// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4zTVb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
const container = document.getElementById("root");
if (!container) throw new Error("No root element found");
const root = (0, _client.createRoot)(container);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}));

},{"react/jsx-runtime":"gaGEj","react-dom/client":"5ccwt","./App":"dXcTy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"dXcTy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _dappKitReact = require("@vechain/dapp-kit-react");
var _reactQuery = require("@tanstack/react-query");
var _config = require("~/config");
var _reactHelmet = require("react-helmet");
var _layout = require("./Layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _captcha = require("./Captcha");
var _captchaDefault = parcelHelpers.interopDefault(_captcha);
// define wallet connect options only in case a project id has been provided
const walletConnectOptions = !(0, _config.WALLET_CONNECT_PROJECT_ID) ? undefined : {
    projectId: (0, _config.WALLET_CONNECT_PROJECT_ID),
    metadata: {
        name: (0, _config.APP_TITLE),
        description: (0, _config.APP_DESCRIPTION),
        url: window.location.origin,
        icons: (0, _config.APP_ICONS)
    }
};
// query client for react-query
const queryClient = new (0, _reactQuery.QueryClient)();
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Providers, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmet.Helmet), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                        children: (0, _config.APP_TITLE)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layoutDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _captchaDefault.default), {})
            })
        ]
    });
}
function Providers({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
        client: queryClient,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappKitReact.DAppKitProvider), {
            // the network & node to connect to
            nodeUrl: (0, _config.NODE_URL),
            genesis: (0, _config.NETWORK),
            // remember last connected address on page reload
            usePersistence: true,
            // optionally enable walletConnect, which will be used for mobile wallets
            walletConnectOptions: walletConnectOptions,
            children: children
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@vechain/dapp-kit-react":"dvX2y","@tanstack/react-query":"2gEtt","~/config":"r2Xd0","react-helmet":"5cEyM","./Layout":"dxwDS","./Captcha":"6zMet","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvX2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAppKitProvider", ()=>X);
parcelHelpers.export(exports, "WalletButton", ()=>et);
parcelHelpers.export(exports, "useConnex", ()=>Y);
parcelHelpers.export(exports, "useWallet", ()=>Z);
parcelHelpers.export(exports, "useWalletModal", ()=>_);
var _react = require("react");
var _dappKitUi = require("@vechain/dapp-kit-ui");
var _utils = require("valtio/vanilla/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@lit/react");
var r = (0, _react.createContext)(void 0), X = ({ children: e, nodeUrl: u, genesis: p, walletConnectOptions: d, usePersistence: m = !1, logLevel: x, requireCertificate: C, themeMode: f, themeVariables: w, i18n: v, language: b, modalParent: h, onSourceClick: A, connectionCertificate: D })=>{
    let t = (0, _react.useMemo)(()=>(0, _dappKitUi.DAppKitUI).configure({
            nodeUrl: u,
            genesis: p,
            walletConnectOptions: d,
            usePersistence: m,
            logLevel: x,
            requireCertificate: C,
            themeVariables: w,
            themeMode: f,
            i18n: v,
            language: b,
            modalParent: h,
            onSourceClick: A,
            connectionCertificate: D
        }), [
        u,
        p,
        d,
        m,
        x,
        C,
        w,
        f,
        v,
        b,
        h,
        A,
        D
    ]), [K, k] = (0, _react.useState)(t.wallet.state.address), [S, y] = (0, _react.useState)(t.wallet.state.source), [W, B] = (0, _react.useState)(t.wallet.state.connectionCertificate);
    (0, _react.useEffect)(()=>{
        let c = (0, _utils.subscribeKey)(t.wallet.state, "address", (o)=>{
            k(o);
        }), T = (0, _utils.subscribeKey)(t.wallet.state, "source", (o)=>{
            y(o);
        }), F = (0, _utils.subscribeKey)(t.wallet.state, "connectionCertificate", (o)=>{
            B(o);
        });
        return ()=>{
            c(), T(), F();
        };
    }, [
        t.wallet.state
    ]);
    let P = (0, _react.useCallback)(()=>{
        (0, _dappKitUi.DAppKitUI).modal.open();
    }, []), E = (0, _react.useCallback)(()=>{
        (0, _dappKitUi.DAppKitUI).modal.close();
    }, []), M = (0, _react.useCallback)((c)=>(0, _dappKitUi.DAppKitUI).modal.onConnectionStatusChange(c), []), g = (0, _react.useMemo)(()=>({
            connex: {
                thor: t.thor,
                vendor: t.vendor
            },
            wallet: {
                setSource: t.wallet.setSource,
                disconnect: t.wallet.disconnect,
                connect: t.wallet.connect,
                availableWallets: t.wallet.state.availableSources,
                account: K,
                source: S,
                connectionCertificate: W
            },
            modal: {
                open: P,
                close: E,
                onConnectionStatusChange: M
            }
        }), [
        t,
        K,
        S,
        E,
        P,
        M,
        W
    ]);
    return (0, _jsxRuntime.jsx)(r.Provider, {
        value: g,
        children: e
    });
}, Y = ()=>{
    let e = (0, _react.useContext)(r);
    if (!e) throw new Error('"useConnex" must be used within a ConnexProvider');
    return e.connex;
}, Z = ()=>{
    let e = (0, _react.useContext)(r);
    if (!e) throw new Error('"useWallet" must be used within a ConnexProvider');
    return e.wallet;
}, _ = ()=>{
    let e = (0, _react.useContext)(r);
    if (!e) throw new Error('"useWalletModal" must be used within a ConnexProvider');
    return e.modal;
};
var et = (0, _react1.createComponent)({
    tagName: "vdk-button",
    elementClass: (0, _dappKitUi.Button),
    react: (0, _reactDefault.default)
});

},{"react":"6uln9","@vechain/dapp-kit-ui":"4g7cn","valtio/vanilla/utils":"43WO7","react/jsx-runtime":"gaGEj","@lit/react":"iJjIx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4g7cn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANDROID_STORE_URL", ()=>EA);
parcelHelpers.export(exports, "AddressButton", ()=>O);
parcelHelpers.export(exports, "AddressModal", ()=>C);
parcelHelpers.export(exports, "BaseModal", ()=>M);
parcelHelpers.export(exports, "Breakpoint", ()=>CA);
parcelHelpers.export(exports, "Button", ()=>I);
parcelHelpers.export(exports, "Colors", ()=>o);
parcelHelpers.export(exports, "ConnectButton", ()=>Q);
parcelHelpers.export(exports, "ConnectModal", ()=>X);
parcelHelpers.export(exports, "ConnectModalManager", ()=>J);
parcelHelpers.export(exports, "CustomWalletConnectModal", ()=>rA);
parcelHelpers.export(exports, "DAppKitUI", ()=>g);
parcelHelpers.export(exports, "Font", ()=>c);
parcelHelpers.export(exports, "Fonts", ()=>wA);
parcelHelpers.export(exports, "IOS_STORE_URL", ()=>zA);
parcelHelpers.export(exports, "Inter", ()=>oo);
parcelHelpers.export(exports, "Modal", ()=>P);
parcelHelpers.export(exports, "QrCodeUtil", ()=>OA);
parcelHelpers.export(exports, "SignConnectionCertificate", ()=>m);
parcelHelpers.export(exports, "SourceCard", ()=>h);
parcelHelpers.export(exports, "VEWORLD_WEBSITE", ()=>VA);
parcelHelpers.export(exports, "WalletConnectQrCode", ()=>p);
parcelHelpers.export(exports, "WalletSources", ()=>DA);
parcelHelpers.export(exports, "addResizeListeners", ()=>xt);
parcelHelpers.export(exports, "createModalIfNotPresent", ()=>GA);
parcelHelpers.export(exports, "defaultI18n", ()=>l);
parcelHelpers.export(exports, "dispatchCustomEvent", ()=>u);
parcelHelpers.export(exports, "friendlyAddress", ()=>AA);
parcelHelpers.export(exports, "getPicassoImage", ()=>K);
parcelHelpers.export(exports, "initButton", ()=>Pe);
parcelHelpers.export(exports, "initModal", ()=>Me);
parcelHelpers.export(exports, "initModalAndButton", ()=>YA);
parcelHelpers.export(exports, "initStyles", ()=>Oe);
parcelHelpers.export(exports, "isAndroid", ()=>xA);
parcelHelpers.export(exports, "isMobile", ()=>MA);
parcelHelpers.export(exports, "modalZIndex", ()=>tA);
parcelHelpers.export(exports, "subscribeToCustomEvent", ()=>w);
parcelHelpers.export(exports, "useTranslate", ()=>y);
var _dappKit = require("@vechain/dapp-kit");
var _utils = require("valtio/vanilla/utils");
var _lit = require("lit");
var _qrcode = require("qrcode");
var _qrcodeDefault = parcelHelpers.interopDefault(_qrcode);
var _picasso = require("@vechain/picasso");
var _events = require("events");
var _decoratorsJs = require("lit/decorators.js");
var Buffer = require("82f674c5760b0c63").Buffer;
var be = Object.defineProperty;
var qe = Object.getOwnPropertyDescriptor;
var e = (t, r, A, n)=>{
    for(var v = n > 1 ? void 0 : n ? qe(r, A) : r, s = t.length - 1, i; s >= 0; s--)(i = t[s]) && (v = (n ? i(r, A, v) : i(v)) || v);
    return n && v && be(r, A, v), v;
};
var pe = .1, IA = 2.5, H = 7;
function XA(t, r, A) {
    return t === r ? !1 : (t - r < 0 ? r - t : t - r) <= A + pe;
}
function me(t, r) {
    let A = Array.prototype.slice.call((0, _qrcodeDefault.default).create(t, {
        errorCorrectionLevel: r
    }).modules.data, 0), n = Math.sqrt(A.length);
    return A.reduce((v, s, i)=>(i % n === 0 ? v.push([
            s
        ]) : v[v.length - 1].push(s)) && v, []);
}
var OA = {
    generate ({ uri: t, size: r, logoSize: A, dotColor: n, edgeColor: v }) {
        let s = [], i = me(t, "Q"), d = r / i.length, _ = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        _.forEach(({ x: B, y: f })=>{
            let D = (i.length - H) * d * B, a = (i.length - H) * d * f, L = .45;
            for(let F = 0; F < _.length; F += 1){
                let V = d * (H - F * 2);
                s.push((0, _lit.svg)`
            <rect
              fill=${F % 2 === 0 ? n : v}
              height=${V}
              rx=${V * L}
              ry=${V * L}
              width=${V}
              x=${D + d * F}
              y=${a + d * F}
            />
          `);
            }
        });
        let pA = Math.floor((A + 25) / d), mA = i.length / 2 - pA / 2, FA = i.length / 2 + pA / 2 - 1, yA = [];
        i.forEach((B, f)=>{
            B.forEach((D, a)=>{
                if (i[f][a] && !(f < H && a < H || f > i.length - (H + 1) && a < H || f < H && a > i.length - (H + 1)) && !(f > mA && f < FA && a > mA && a < FA)) {
                    let L = f * d + d / 2, F = a * d + d / 2;
                    yA.push([
                        L,
                        F
                    ]);
                }
            });
        });
        let Z = {};
        return yA.forEach(([B, f])=>{
            Z[B] ? Z[B].push(f) : Z[B] = [
                f
            ];
        }), Object.entries(Z).map(([B, f])=>{
            let D = f.filter((a)=>f.every((L)=>!XA(a, L, d)));
            return [
                Number(B),
                D
            ];
        }).forEach(([B, f])=>{
            f.forEach((D)=>{
                s.push((0, _lit.svg)`<circle cx=${B} cy=${D} fill=${n} r=${d / IA} />`);
            });
        }), Object.entries(Z).filter(([B, f])=>f.length > 1).map(([B, f])=>{
            let D = f.filter((a)=>f.some((L)=>XA(a, L, d)));
            return [
                Number(B),
                D
            ];
        }).map(([B, f])=>{
            f.sort((a, L)=>a < L ? -1 : 1);
            let D = [];
            for (let a of f){
                let L = D.find((F)=>F.some((V)=>XA(a, V, d)));
                L ? L.push(a) : D.push([
                    a
                ]);
            }
            return [
                B,
                D.map((a)=>[
                        a[0],
                        a[a.length - 1]
                    ])
            ];
        }).forEach(([B, f])=>{
            f.forEach(([D, a])=>{
                s.push((0, _lit.svg)`
              <line
                x1=${B}
                x2=${B}
                y1=${D}
                y2=${a}
                stroke=${n}
                stroke-width=${d / (IA / 2)}
                stroke-linecap="round"
              />
            `);
            });
        }), s;
    }
};
var xt = (t)=>{
    window.addEventListener("load", t, !1), window.addEventListener("resize", t, !1);
};
var u = (t, r)=>{
    (0, _dappKit.DAppKitLogger).debug("dispatchCustomEvent", t, r);
    let A = new CustomEvent(t, {
        detail: r
    });
    dispatchEvent(A);
}, w = (t, r)=>{
    (0, _dappKit.DAppKitLogger).debug("subscribeToCustomEvent", t);
    let A = (n)=>{
        r?.(n.detail);
    };
    return addEventListener(t, A), ()=>{
        removeEventListener(t, A);
    };
};
var MA = ()=>{
    let t = navigator.userAgent || navigator.vendor || window.opera;
    return !!(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4)));
}, xA = ()=>{
    let t = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(t);
};
var y = (t, r)=>(A)=>t?.[r]?.[A] || t?.en?.[A] || A;
var K = (t, r = !1)=>{
    let A = (0, _picasso.picasso)(t.toLowerCase());
    return r ? `data:image/svg+xml;base64,${Buffer.from(A, "utf8").toString("base64")}` : `data:image/svg+xml;utf8,${A}`;
}, AA = (t, r = 6, A = 4)=>{
    let n = t.substring(0, r), v = t.substring(t.length - A);
    return `${n}\u2022\u2022\u2022\u2022${v}`;
};
var o = {
    WalletConnectBlue: (0, _lit.css)`#3496ff`,
    Dark: {
        Primary: (0, _lit.css)`#404040`,
        PrimaryHover: (0, _lit.css)`#454545`,
        PrimaryActive: (0, _lit.css)`#4a4a4a`,
        Secondary: (0, _lit.css)`#2a2a2a`,
        Tertiary: (0, _lit.css)`#ffffff`,
        Quaternary: (0, _lit.css)`#888888`
    },
    Light: {
        Primary: (0, _lit.css)`#f2f2f2`,
        PrimaryHover: (0, _lit.css)`#eeeeee`,
        PrimaryActive: (0, _lit.css)`#eaeaea`,
        Secondary: (0, _lit.css)`#ffffff`,
        Tertiary: (0, _lit.css)`#2a2a2a`,
        Quaternary: (0, _lit.css)`#747474`
    }
};
var HA = `data:image/png;base64,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
`;
var WA = "data:image/png;base64,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";
var hA = `data:image/png;base64,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
`;
var eA = "data:image/png;base64,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";
var DA = {
    "wallet-connect": {
        id: "wallet-connect",
        name: "Wallet Connect",
        logo: hA
    },
    veworld: {
        id: "veworld",
        name: "VeWorld",
        logo: eA
    },
    sync: {
        id: "sync",
        name: "Sync",
        logo: HA
    },
    sync2: {
        id: "sync2",
        name: "Sync 2",
        logo: WA
    }
};
var CA = {
    Mobile: 500,
    Tablet: 800
};
var zA = "https://apps.apple.com/it/app/veworld/id6446854569", EA = "https://play.google.com/store/apps/details?id=org.vechain.veworld.app";
var oo = (0, _lit.css)`'Inter', sans-serif`, c = {
    Family: (0, _lit.css)`'Inter', sans-serif`,
    Size: {
        Medium: (0, _lit.css)`14px`,
        Large: (0, _lit.css)`18px`
    },
    Weight: {
        Medium: (0, _lit.css)`500`
    }
};
var l = {
    en: {
        "connect-wallet": "Connect Wallet",
        "copy-to-clipboard": "Copy to Clipboard",
        connected: "Connected",
        disconnect: "Disconnect",
        "opening-veworld": "Opening VeWorld...",
        "get-veworld": "Get VeWorld",
        "sign-connection-certificate-button": "Sign Certificate",
        "sign-connection-certificate-description": "Proof address is required, please sign a certificate to continue",
        "waiting-signature": "Waiting for signature..."
    },
    it: {
        "connect-wallet": "Connetti il Wallet",
        "copy-to-clipboard": "Copia",
        connected: "Connesso",
        disconnect: "Disconnetti",
        "opening-veworld": "Apertura di VeWorld...",
        "get-veworld": "Ottieni VeWorld",
        "sign-connection-certificate-button": "Firma Certificato",
        "sign-connection-certificate-description": "\xc8 richiesta una firma di certificato per connettersi al wallet.",
        "waiting-signature": "Attendo firma..."
    },
    fr: {
        "connect-wallet": "Connecter le portefeuille",
        "copy-to-clipboard": "Copier dans le presse-papiers",
        connected: "Connect\xe9",
        disconnect: "D\xe9connecter",
        "opening-veworld": "Ouverture de VeWorld...",
        "get-veworld": "Obtenir VeWorld",
        "sign-connection-certificate-description": "Une signature de certificat est requise pour se connecter au portefeuille.",
        "sign-connection-certificate-button": "Signer le certificat",
        "waiting-signature": "En attente de la signature..."
    },
    es: {
        "connect-wallet": "Conectar billetera",
        "copy-to-clipboard": "Copiar al portapapeles",
        connected: "Conectado",
        disconnect: "Desconectar",
        "opening-veworld": "Abriendo VeWorld...",
        "get-veworld": "Obtener VeWorld",
        "sign-connection-certificate-description": "Se requiere una firma de certificado para conectarse a la billetera.",
        "sign-connection-certificate-button": "Firmar certificado",
        "waiting-signature": "Esperando firma..."
    },
    de: {
        "connect-wallet": "Wallet verbinden",
        "copy-to-clipboard": "In Zwischenablage kopieren",
        connected: "Verbunden",
        disconnect: "Trennen",
        "opening-veworld": "VeWorld wird ge\xf6ffnet...",
        "get-veworld": "VeWorld erhalten",
        "sign-connection-certificate-description": "Eine Zertifikatssignatur ist erforderlich, um eine Verbindung zur Brieftasche herzustellen.",
        "sign-connection-certificate-button": "Zertifikat signieren",
        "waiting-signature": "Warte auf Signatur..."
    },
    zh: {
        "connect-wallet": "\u8FDE\u63A5\u94B1\u5305",
        "copy-to-clipboard": "\u590D\u5236\u5230\u526A\u8D34\u677F",
        connected: "\u5DF2\u8FDE\u63A5",
        disconnect: "\u65AD\u5F00\u8FDE\u63A5",
        "opening-veworld": "\u6B63\u5728\u6253\u5F00 VeWorld...",
        "get-veworld": "\u83B7\u53D6 VeWorld",
        "sign-connection-certificate-description": "\u8FDE\u63A5\u94B1\u5305\u9700\u8981\u7B7E\u540D\u8BC1\u4E66\u3002",
        "sign-connection-certificate-button": "\u7B7E\u540D\u8BC1\u4E66",
        "waiting-signature": "\u7B49\u5F85\u7B7E\u540D..."
    },
    ja: {
        "connect-wallet": "\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A",
        "copy-to-clipboard": "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC",
        connected: "\u63A5\u7D9A\u3055\u308C\u307E\u3057\u305F",
        disconnect: "\u5207\u65AD\u3059\u308B",
        "opening-veworld": "VeWorld \u3092\u958B\u3044\u3066\u3044\u307E\u3059...",
        "get-veworld": "VeWorld \u3092\u53D6\u5F97",
        "sign-connection-certificate-description": "\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u63A5\u7D9A\u3059\u308B\u306B\u306F\u8A3C\u660E\u66F8\u306E\u7F72\u540D\u304C\u5FC5\u8981\u3067\u3059\u3002",
        "sign-connection-certificate-button": "\u8A3C\u660E\u66F8\u306B\u7F72\u540D",
        "waiting-signature": "\u7F72\u540D\u3092\u5F85\u3063\u3066\u3044\u307E\u3059..."
    },
    ru: {
        "connect-wallet": "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        "copy-to-clipboard": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
        connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        disconnect: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
        "opening-veworld": "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 VeWorld...",
        "get-veworld": "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C VeWorld",
        "sign-connection-certificate-description": "\u0414\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u043A \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430.",
        "sign-connection-certificate-button": "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442",
        "waiting-signature": "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0438..."
    }
};
var tA = 100;
var VA = "https://www.veworld.com/discover/browser/ul/";
var ye = ()=>document.querySelector("vdk-modal"), GA = (t)=>{
    let r = ye();
    if (r) return r;
    let A = document.createElement("vdk-modal");
    return (t?.modalParent ?? document.body).appendChild(A), A;
}, Ie = {
    "--vdk-color-dark-primary": o.Dark.Primary.toString(),
    "--vdk-color-dark-primary-hover": o.Dark.PrimaryHover.toString(),
    "--vdk-color-dark-primary-active": o.Dark.PrimaryActive.toString(),
    "--vdk-color-dark-secondary": o.Dark.Secondary.toString(),
    "--vdk-color-dark-tertiary": o.Dark.Tertiary.toString(),
    "--vdk-color-dark-quaternary": o.Dark.Quaternary.toString(),
    "--vdk-color-light-primary": o.Light.Primary.toString(),
    "--vdk-color-light-primary-hover": o.Light.PrimaryHover.toString(),
    "--vdk-color-light-primary-active": o.Light.PrimaryActive.toString(),
    "--vdk-color-light-secondary": o.Light.Secondary.toString(),
    "--vdk-color-light-tertiary": o.Light.Tertiary.toString(),
    "--vdk-color-light-quaternary": o.Light.Quaternary.toString(),
    "--vdk-color-walletconnectblue": o.WalletConnectBlue.toString(),
    "--vdk-font-family": c.Family.toString(),
    "--vdk-font-size-medium": c.Size.Medium.toString(),
    "--vdk-font-size-large": c.Size.Large.toString(),
    "--vdk-font-weight-medium": c.Weight.Medium.toString(),
    "--vdk-modal-z-index": 100..toString()
}, Oe = (t)=>{
    let r = document.querySelector(":root");
    if (r) for (let [A, n] of Object.entries({
        ...Ie,
        ...t
    }))r.style.setProperty(A, n);
}, jA = (t)=>({
        mode: t.themeMode ?? "LIGHT",
        i18n: t.i18n ? {
            ...l,
            ...t.i18n
        } : l,
        language: t.language ?? "en"
    }), Pe = (t)=>{
    let r = document.querySelectorAll("vdk-button"), A = jA(t);
    r.forEach((n)=>{
        for (let [v, s] of Object.entries(A))s && (n[v] = s);
    });
}, Me = (t)=>{
    let r = document.querySelector("vdk-modal"), A = jA(t);
    if (r) {
        for (let [n, v] of Object.entries(A))v && (r[n] = v);
        t.onSourceClick && (r.onSourceClick = t.onSourceClick);
    }
}, YA = (t)=>{
    t.themeVariables && Oe(t.themeVariables), Pe(t), Me(t);
};
var z = class z {
    constructor(r, A){
        this.walletManager = r;
        GA(A);
    }
    static getInstance(r, A) {
        return z.instance || (z.instance = new z(r, A)), z.instance;
    }
    open() {
        (0, _dappKit.DAppKitLogger).debug("ConnectModalManager", "opening the modal"), u("vdk-open-wallet-modal");
    }
    close() {
        (0, _dappKit.DAppKitLogger).debug("ConnectModalManager", "closing the modal"), u("vdk-close-wallet-modal");
    }
    closeWalletConnect() {
        (0, _dappKit.DAppKitLogger).debug("ConnectModalManager", "closing wallet connect"), u("vdk-close-wc-qrcode");
    }
    closeConnectionCertificateRequest() {
        (0, _dappKit.DAppKitLogger).debug("ConnectModalManager", "closing connection certificate request"), u("vdk-close-connection-certificate-request");
    }
    onConnectionStatusChange(r) {
        return (0, _utils.subscribeKey)(this.walletManager.state, "address", (A)=>{
            r(A);
        });
    }
    onWalletSelected(r) {
        return (0, _utils.subscribeKey)(this.walletManager.state, "source", (A)=>{
            r(A);
        });
    }
};
z.instance = null;
var J = z;
var LA = "vdk-modal-state-change", E = class E {
    constructor(){
        this.eventEmitter = new (0, _events.EventEmitter);
        w("vdk-close-wc-qrcode", ()=>{
            this.updateModalState({
                open: !1
            });
        }), w("vdk-open-wc-qrcode", ()=>{
            this.updateModalState({
                open: !0
            });
        });
    }
    static getInstance() {
        return E.instance || (E.instance = new E), E.instance;
    }
    openModal(r) {
        return (0, _dappKit.DAppKitLogger).debug("CustomWalletConnectModal", "opening the wc modal"), u("vdk-open-wc-qrcode", r), Promise.resolve();
    }
    closeModal() {
        (0, _dappKit.DAppKitLogger).debug("CustomWalletConnectModal", "closing the modal"), u("vdk-close-wc-qrcode");
    }
    askForConnectionCertificate() {
        (0, _dappKit.DAppKitLogger).debug("CustomWalletConnectModal", "ask for connection certificate"), u("vdk-close-wc-qrcode"), u("vdk-request-connection-certificate");
    }
    onConnectionCertificateSigned() {
        (0, _dappKit.DAppKitLogger).debug("CustomWalletConnectModal", "connection certificate signed"), u("vdk-close-wallet-modal"), u("vdk-close-wc-qrcode"), u("vdk-close-connection-certificate-request");
    }
    subscribeModal(r) {
        return (0, _dappKit.DAppKitLogger).debug("CustomWalletConnectModal", "subscribing to modal state"), this.eventEmitter.on(LA, r), ()=>{
            this.eventEmitter.off(LA, r);
        };
    }
    updateModalState(r) {
        this.eventEmitter.emit(LA, r);
    }
};
E.instance = null;
var rA = E;
var nA = null, bA = null, UA = !1, g = {
    configure (t) {
        return t.walletConnectOptions && !t.walletConnectOptions.modal && (t.walletConnectOptions.modal = rA.getInstance()), bA = t, nA = new (0, _dappKit.DAppKit)(t), J.getInstance(this.wallet, {
            modalParent: t.modalParent
        }), YA(t), u("vdk-dapp-kit-configured"), UA = !0, nA;
    },
    get initialized () {
        return UA;
    },
    get thor () {
        return this.get().thor;
    },
    get vendor () {
        return this.get().vendor;
    },
    get wallet () {
        return this.get().wallet;
    },
    get configuration () {
        return bA;
    },
    get modal () {
        return J.getInstance(this.wallet, {
            modalParent: bA?.modalParent
        });
    },
    get () {
        if (!nA) throw console.error("\uD83D\uDEA8\uD83D\uDEA8\uD83D\uDEA8 DAppKitUI not configured \uD83D\uDEA8\uD83D\uDEA8\uD83D\uDEA8"), new Error("DAppKitUI not configured");
        return nA;
    }
};
var kA, I = class extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.address = "";
        this.disabled = !1;
        this.mobile = !1;
        g.initialized && this.configureButtonUI();
    }
    connectedCallback() {
        super.connectedCallback(), g.initialized && this.initAddressListener(), kA = w("vdk-dapp-kit-configured", ()=>{
            this.setAddressFromState(), this.initAddressListener();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), kA?.();
    }
    setAddressFromState() {
        this.address = g.wallet.state.address ?? "", this.requestUpdate();
    }
    configureButtonUI() {
        this.mode = g.configuration?.themeMode ?? "LIGHT", this.i18n = g.configuration?.i18n ?? l, this.language = g.configuration?.language ?? "en", this.address = g.wallet.state.address ?? "", this.requestUpdate();
    }
    initAddressListener() {
        g.wallet.subscribeToKey("address", (A)=>{
            this.address = A ?? "", this.requestUpdate();
        });
    }
    render() {
        return (0, _lit.html)`
            ${this.address ? (0, _lit.html)`<vdk-address-button
                      .mode=${this.mode}
                      .address=${this.address}
                      .disabled=${this.disabled}
                      .mobile=${this.mobile}
                  ></vdk-address-button>` : (0, _lit.html)`<vdk-connect-button
                      .mode=${this.mode}
                      .i18n=${this.i18n}
                      .language=${this.language}
                      .disabled=${this.disabled}
                      .mobile=${this.mobile}
                  ></vdk-connect-button>`}
        `;
    }
};
e([
    (0, _decoratorsJs.property)()
], I.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], I.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], I.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], I.prototype, "address", 2), e([
    (0, _decoratorsJs.property)()
], I.prototype, "disabled", 2), e([
    (0, _decoratorsJs.property)()
], I.prototype, "mobile", 2), I = e([
    (0, _decoratorsJs.customElement)("vdk-button")
], I);
var q = (0, _lit.css)`
    button {
        font-family: var(--vdk-font-family, ${c.Family});
        font-size: var(--vdk-font-size-medium, ${c.Size.Medium});
        font-weight: var(--vdk-font-weight-medium, ${c.Weight.Medium});
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border: none;
        border-radius: 12px;
        padding: 12px;
        width: 100%;
        gap: 10px;
    }

    button.LIGHT {
        background: var(--vdk-color-light-primary, ${o.Light.Primary});
        color: var(--vdk-color-light-tertiary, ${o.Light.Tertiary});
    }
    button.LIGHT:hover:not(:disabled) {
        background: var(
            --vdk-color-light-primary-hover,
            ${o.Light.PrimaryHover}
        );
    }
    button.LIGHT:active:not(:disabled) {
        background: var(
            --vdk-color-light-primary-active,
            ${o.Light.PrimaryActive}
        );
    }
    button.LIGHT:disabled {
        opacity: 0.8;
    }

    button.DARK {
        background: var(--vdk-color-dark-primary, ${o.Dark.Primary});
        color: var(--vdk-color-dark-tertiary, ${o.Dark.Tertiary});
    }
    button.DARK:hover:not(:disabled) {
        background: var(
            --vdk-color-dark-primary-hover,
            ${o.Dark.PrimaryHover}
        );
    }
    button.DARK:active:not(:disabled) {
        background: var(
            --vdk-color-dark-primary-active,
            ${o.Dark.PrimaryActive}
        );
    }

    button.DARK:disabled {
        opacity: 0.8;
    }
`, gA = (0, _lit.css)`
    .icon-button {
        cursor: pointer;
        width: 25px;
        height: 25px;
        padding: 5px;
        border-radius: 50%;
    }

    .icon-button.LIGHT:hover {
        background: var(
            --vdk-color-light-primary,
            ${o.Light.PrimaryHover}
        );
    }

    .icon-button.DARK:hover {
        background: var(--vdk-color-dark-primary, ${o.Dark.PrimaryHover});
    }

    .icon-button.LIGHT:active {
        background: var(
            --vdk-color-light-primary,
            ${o.Light.PrimaryActive}
        );
    }

    .icon-button.DARK:active {
        background: var(--vdk-color-dark-primary, ${o.Dark.PrimaryActive});
    }

    button:disabled {
        opacity: 0.8;
    }
`;
var KA = (0, _lit.svg)`
      <path
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
    `, cA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${o.Light.Quaternary}
    >
        ${KA}
    </svg>
`, vA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${o.Dark.Quaternary}
    >
        ${KA}
    </svg>
`;
var JA = (0, _lit.svg)`
      <path
        d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
    `, SA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${o.Light.Quaternary}
    >
        ${JA}
    </svg>
`, $A = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${o.Dark.Quaternary}
    >
        ${JA}
    </svg>
`;
var Ae = (0, _lit.svg)`
      <path d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `, fA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke=${o.Light.Quaternary}
        fill="#00000000"
    >
        ${Ae}
    </svg>
`, iA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke=${o.Dark.Quaternary}
        fill="#00000000"
    >
        ${Ae}
    </svg>
`;
var aA = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill=${o.WalletConnectBlue}
    >
        <path
            d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
        />
    </svg>
`;
var te = (0, _lit.svg)`
    <path
        d="M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z"
    />
`, oe = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        fill=${o.Light.Quaternary}
    >
        ${te}
    </svg>
`, re = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 15"
        fill=${o.Dark.Quaternary}
    >
        ${te}
    </svg>
`;
var ne = (0, _lit.html)`
    <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="background: ${o.WalletConnectBlue};"
    >
        <path
            d="M9.58818 11.8556C13.1293 8.31442 18.8706 8.31442 22.4117 11.8556L22.8379 12.2818C23.015 12.4588 23.015 12.7459 22.8379 12.9229L21.3801 14.3808C21.2915 14.4693 21.148 14.4693 21.0595 14.3808L20.473 13.7943C18.0026 11.3239 13.9973 11.3239 11.5269 13.7943L10.8989 14.4223C10.8104 14.5109 10.6668 14.5109 10.5783 14.4223L9.12041 12.9645C8.94336 12.7875 8.94336 12.5004 9.12041 12.3234L9.58818 11.8556ZM25.4268 14.8706L26.7243 16.1682C26.9013 16.3452 26.9013 16.6323 26.7243 16.8093L20.8737 22.6599C20.6966 22.8371 20.4096 22.8371 20.2325 22.6599L16.0802 18.5076C16.0359 18.4634 15.9641 18.4634 15.9199 18.5076L11.7675 22.6599C11.5905 22.8371 11.3034 22.8371 11.1264 22.66C11.1264 22.66 11.1264 22.6599 11.1264 22.6599L5.27561 16.8092C5.09856 16.6322 5.09856 16.3451 5.27561 16.168L6.57313 14.8706C6.75019 14.6934 7.03726 14.6934 7.21431 14.8706L11.3668 19.023C11.411 19.0672 11.4828 19.0672 11.5271 19.023L15.6793 14.8706C15.8563 14.6934 16.1434 14.6934 16.3205 14.8706L20.473 19.023C20.5172 19.0672 20.589 19.0672 20.6332 19.023L24.7856 14.8706C24.9627 14.6935 25.2498 14.6935 25.4268 14.8706Z"
            fill="white"
        ></path>
    </svg>
`;
var ce = (0, _lit.svg)`
      <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
    `, ve = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        stroke=${o.Light.Tertiary}
        fill=${o.Light.Tertiary}
    >
        ${ce}
    </svg>
`, fe = (0, _lit.html)`
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        stroke=${o.Dark.Tertiary}
        fill=${o.Dark.Tertiary}
    >
        ${ce}
    </svg>
`;
var Q = class extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.handleOpen = ()=>{
            g.wallet.disconnect(), g.modal.open();
        };
        this.disabled = !1;
        this.mobile = !1;
    }
    render() {
        if (this.mobile) {
            let n = this.mode === "LIGHT" ? ve : fe;
            return (0, _lit.html)` <vdk-fonts></vdk-fonts>
                <button
                    class="${this.mode} mobile"
                    @click=${this.handleOpen}
                    ?disabled=${this.disabled}
                >
                    <div class="icon">${n}</div>
                </button>`;
        }
        let A = y(this.i18n, this.language);
        return (0, _lit.html)`
            <vdk-fonts></vdk-fonts>
            <button
                class="${this.mode}"
                @click=${this.handleOpen}
                ?disabled=${this.disabled}
            >
                ${A("connect-wallet")}
            </button>
        `;
    }
};
Q.styles = [
    q,
    (0, _lit.css)`
            button {
                width: auto;
            }
            button.mobile {
                height: 41px;
                width: 41px;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .icon {
                padding-top: 4px;
                width: 18px;
                height: 18px;
            }
        `
], e([
    (0, _decoratorsJs.property)()
], Q.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], Q.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], Q.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], Q.prototype, "handleOpen", 2), e([
    (0, _decoratorsJs.property)()
], Q.prototype, "disabled", 2), e([
    (0, _decoratorsJs.property)()
], Q.prototype, "mobile", 2), Q = e([
    (0, _decoratorsJs.customElement)("vdk-connect-button")
], Q);
var O = class extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.mode = "LIGHT";
        this.handleOpen = ()=>{
            g.modal.open();
        };
        this.disabled = !1;
        this.mobile = !1;
    }
    render() {
        return this.mobile ? (0, _lit.html)` <vdk-fonts></vdk-fonts>
                <button
                    class="wallet-button ${this.mode} mobile"
                    @click=${this.handleOpen}
                    ?disabled=${this.disabled}
                >
                    <img
                        class="address-icon mobile"
                        src=${K(this.address ?? "")}
                    />
                </button>` : (0, _lit.html)` <vdk-fonts></vdk-fonts>
            <button
                class="wallet-button ${this.mode}"
                @click=${this.handleOpen}
                ?disabled=${this.disabled}
            >
                <img
                    class="address-icon"
                    src=${K(this.address ?? "")}
                />
                <span class="wallet-address"
                    >${AA(this.address ?? "")}</span
                >
            </button>`;
    }
};
O.styles = [
    q,
    (0, _lit.css)`
            button {
                padding: 9px 12px;
                width: auto;
                gap: 4px;
            }

            button.mobile {
                padding: 0px;
            }

            button.mobile:hover {
                opacity: 0.9;
            }

            /* Style for the wallet address */

            .wallet-address {
                font-size: var(--vdk-font-size-medium, ${c.Size.Medium});
                margin-left: 8px;
                font-family: var(--vdk-font-family, ${c.Family});
            }

            .address-icon {
                width: 23px;
                height: 23px;
                border-radius: 50%;
            }

            .address-icon.mobile {
                width: 41px;
                height: 41px;
                border-radius: 12px;
            }
        `
], e([
    (0, _decoratorsJs.property)()
], O.prototype, "address", 2), e([
    (0, _decoratorsJs.property)()
], O.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], O.prototype, "handleOpen", 2), e([
    (0, _decoratorsJs.property)()
], O.prototype, "disabled", 2), e([
    (0, _decoratorsJs.property)()
], O.prototype, "mobile", 2), O = e([
    (0, _decoratorsJs.customElement)("vdk-address-button")
], O);
var se, P = class extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.address = g.wallet.state.address ?? "";
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.onDisconnectClick = ()=>{
            g.wallet.disconnect();
        };
        g.initialized && this.setAddressFromState();
    }
    connectedCallback() {
        super.connectedCallback(), g.initialized && this.initAddressListener(), se = w("vdk-dapp-kit-configured", ()=>{
            this.setAddressFromState(), this.initAddressListener();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), se?.();
    }
    setAddressFromState() {
        this.address = g.wallet.state.address ?? "", this.requestUpdate();
    }
    initAddressListener() {
        g.wallet.subscribeToKey("address", (A)=>{
            this.address = A ?? "", this.requestUpdate();
        });
    }
    render() {
        return g.initialized ? (0, _lit.html)`
            <div>
                ${this.address ? (0, _lit.html)` <vdk-address-modal
                          .mode=${this.mode}
                          .i18n=${this.i18n}
                          .language=${this.language}
                          .address=${this.address}
                          .onDisconnectClick=${this.onDisconnectClick}
                      ></vdk-address-modal>` : (0, _lit.html)` <vdk-connect-modal
                          .mode=${this.mode}
                          .i18n=${this.i18n}
                          .language=${this.language}
                          .onSourceClick=${this.onSourceClick || (0, _lit.nothing)}
                      ></vdk-connect-modal>`}
            </div>
        ` : (0, _lit.html)``;
    }
};
e([
    (0, _decoratorsJs.property)()
], P.prototype, "address", 2), e([
    (0, _decoratorsJs.property)()
], P.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], P.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], P.prototype, "language", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], P.prototype, "onSourceClick", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], P.prototype, "onDisconnectClick", 2), P = e([
    (0, _decoratorsJs.customElement)("vdk-modal")
], P);
var M = class extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.open = !1;
        this.mode = "LIGHT";
        this.observer = new ResizeObserver(()=>{
            this.modalHeight = this.modalSubContainer?.clientHeight ?? 0;
        });
        this.onClose = ()=>null;
        this.stopPropagation = (A)=>{
            A.stopPropagation();
        };
    }
    willUpdate(A) {
        if (A.has("open")) {
            if (!this.modalSubContainer) return;
            this.open ? (this.modalHeight = this.modalSubContainer.clientHeight, this.observer.observe(this.modalSubContainer)) : (this.modalHeight = 0, this.observer.unobserve(this.modalSubContainer));
        }
    }
    render() {
        return (0, _lit.html)`
            <div
                class="modal-container ${this.open ? "" : "hidden"}"
                @click=${this.onClose}
            >
                <div
                    class="modal ${this.mode}"
                    @click=${this.stopPropagation}
                    style="height: ${this.modalHeight ? `${this.modalHeight}px` : "auto"}"
                >
                    <div class="modal-sub-container">
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
};
M.styles = (0, _lit.css)`
        .modal-container {
            display: flex;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            opacity: 1;
            transition: opacity 0.1s ease-in-out;
            z-index: var(--vdk-modal-z-index, ${100});
        }

        .modal-container.hidden {
            opacity: 0;
            pointer-events: none;
        }

        .modal {
            position: absolute;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            transition: height 0.1s ease-in-out, transform 0.2s ease-in-out;
            overflow: hidden;
        }

        .modal-container.hidden .modal {
            transform: scale(0.97);
        }

        .modal.LIGHT {
            background: var(
                --vdk-color-light-secondary,
                ${o.Light.Secondary}
            );
            color: var(--vdk-color-light-tertiary, ${o.Light.Tertiary});
        }

        .modal.DARK {
            background: var(
                --vdk-color-dark-secondary,
                ${o.Dark.Secondary}
            );
            color: var(--vdk-color-dark-tertiary, ${o.Dark.Tertiary});
        }

        @media (max-width: ${CA.Mobile}px) {
            .modal {
                width: 100%;
                border-top-left-radius: 16px;
                border-top-right-radius: 16px;
                bottom: 0;
                left: 0;
                right: 0;
            }
        }

        @media (min-width: ${CA.Mobile}px) {
            .modal-container {
                align-items: center;
                justify-content: center;
            }
            .modal {
                width: 350px;
                border-radius: 16px;
            }
        }
    `, e([
    (0, _decoratorsJs.query)(".modal-sub-container")
], M.prototype, "modalSubContainer", 2), e([
    (0, _decoratorsJs.property)()
], M.prototype, "modalHeight", 2), e([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], M.prototype, "open", 2), e([
    (0, _decoratorsJs.property)()
], M.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], M.prototype, "onClose", 2), M = e([
    (0, _decoratorsJs.customElement)("vdk-base-modal")
], M);
var de, Be, le, we, ue, Xe, X = class extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.onSourceClick = (A)=>{
            if (A) {
                if (A.id === "veworld" && !window.vechain) {
                    window.open(`${VA}${encodeURIComponent(location.href)}`, "_self");
                    return;
                }
                A.id !== "wallet-connect" && (this.setWaitingForTheSignature(!0), this.requestForConnectionCertificate = !0), this.wallet.setSource(A.id), this.wallet.connect().then(()=>{
                    this.requestUpdate();
                }).catch((n)=>{
                    (0, _dappKit.DAppKitLogger).error("Connection Attempt", "error trying to connect", n);
                });
            }
        };
        this.onClose = ()=>(0, _lit.nothing);
        this.open = !1;
        this.openingVeWorld = !1;
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.requestForConnectionCertificate = !1;
        this.waitingForTheSignature = !1;
        this.setWaitingForTheSignature = (A)=>{
            this.waitingForTheSignature = A;
        };
        this.handleBack = ()=>{
            g.modal.closeWalletConnect();
        };
        this.handleClose = ()=>{
            g.modal.close(), this.walletConnectQRcode && setTimeout(()=>{
                this.handleBack(), this.wallet.disconnect();
            }, 500), this.requestForConnectionCertificate && setTimeout(()=>{
                g.modal.closeConnectionCertificateRequest(), this.wallet.disconnect();
            }, 500), this.onClose();
        };
        de = w("vdk-open-wc-qrcode", (A)=>{
            MA() && (this.openingVeWorld = !0, window.open(`veworld://app.veworld?uri=${encodeURIComponent(A.uri)}`, "_self")), this.open = !0, this.walletConnectQRcode = A.uri;
        }), Be = w("vdk-close-wc-qrcode", ()=>{
            this.walletConnectQRcode = void 0, this.openingVeWorld = !1;
        }), le = w("vdk-open-wallet-modal", ()=>{
            window.vechain?.isInAppBrowser ? this.onSourceClick(DA.veworld) : this.open = !0;
        }), we = w("vdk-close-wallet-modal", ()=>{
            this.open = !1;
        }), ue = w("vdk-request-connection-certificate", ()=>{
            this.requestForConnectionCertificate = !0;
        }), Xe = w("vdk-close-connection-certificate-request", ()=>{
            this.requestForConnectionCertificate = !1;
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), de?.(), Be?.(), le?.(), we?.(), ue?.(), Xe?.();
    }
    get availableSources() {
        return g.wallet.state.availableSources.map((A)=>DA[A]);
    }
    get wallet() {
        return g.wallet;
    }
    renderContent() {
        return this.requestForConnectionCertificate ? (0, _lit.html)`<vdk-sign-connection-certificate
                .mode=${this.mode}
                .i18n=${this.i18n}
                .language=${this.language}
                .waitingForTheSignature=${this.waitingForTheSignature}
                .setWaitingForTheSignature=${this.setWaitingForTheSignature}
            ></vdk-sign-connection-certificate>` : this.walletConnectQRcode ? (0, _lit.html)` <vdk-wallet-connect-qrcode
                .openingVeWorld=${this.openingVeWorld}
                .mode=${this.mode}
                .i18n=${this.i18n}
                .language=${this.language}
                .walletConnectQRcode=${this.walletConnectQRcode}
            ></vdk-wallet-connect-qrcode>` : this.availableSources.map((A)=>(0, _lit.html)` <vdk-source-card
                    .source=${A}
                    .mode=${this.mode}
                    .onClick=${this.onSourceClick}
                ></vdk-source-card>`);
    }
    render() {
        let A = y(this.i18n, this.language);
        return (0, _lit.html)`
            <vdk-fonts></vdk-fonts>
            <vdk-base-modal
                .open=${this.open}
                .onClose=${this.handleClose}
                .mode=${this.mode}
            >
                <div class="modal-container">
                    <div class="modal-header">
                        ${this.walletConnectQRcode ? (0, _lit.html)` <div
                                  class="icon-button ${this.mode}"
                                  @click=${this.handleBack}
                              >
                                  ${this.mode === "LIGHT" ? SA : $A}
                              </div>` : (0, _lit.html)` <div class="icon-button"></div>`}
                        <div>${A("connect-wallet")}</div>
                        <div
                            class="icon-button ${this.mode}"
                            @click=${this.handleClose}
                        >
                            ${this.mode === "LIGHT" ? cA : vA}
                        </div>
                    </div>
                    <div class="modal-body">${this.renderContent()}</div>
                </div>
            </vdk-base-modal>
        `;
    }
};
X.styles = [
    gA,
    (0, _lit.css)`
            .modal-container {
                padding: 20px;
            }

            .modal-header {
                font-family: var(--vdk-font-family, ${c.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${c.Weight.Medium}
                );
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 10px;
            }

            .modal-body {
                flex-direction: column;
            }
        `
], e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], X.prototype, "onSourceClick", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], X.prototype, "onClose", 2), e([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], X.prototype, "open", 2), e([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], X.prototype, "openingVeWorld", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "walletConnectQRcode", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "requestForConnectionCertificate", 2), e([
    (0, _decoratorsJs.property)()
], X.prototype, "waitingForTheSignature", 2), X = e([
    (0, _decoratorsJs.customElement)("vdk-connect-modal")
], X);
var h = class extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.onClick = void 0;
        this.mode = "LIGHT";
        this.source = void 0;
    }
    get wallet() {
        return g.wallet;
    }
    handleSourceClick() {
        this.onClick?.(this.source);
    }
    render() {
        return (0, _lit.html)`
            <button
                class="card ${this.mode}"
                @click=${()=>this.handleSourceClick()}
            >
                <div>${this.source?.name}</div>
                <img src=${this.source?.logo} />
            </button>
        `;
    }
};
h.styles = [
    q,
    (0, _lit.css)`
            button {
                padding: 16px;
                flex: 1;
                margin: 8px 0;
                justify-content: space-between;
                font-size: var(--vdk-font-size-medium, ${c.Size.Medium});
            }

            img {
                width: 32px;
                height: 32px;
                object-fit: contain;
            }
        `
], e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], h.prototype, "onClick", 2), e([
    (0, _decoratorsJs.property)()
], h.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], h.prototype, "source", 2), h = e([
    (0, _decoratorsJs.customElement)("vdk-source-card")
], h);
var k = 280, p = class extends (0, _lit.LitElement) {
    constructor(){
        super(...arguments);
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.showCopiedIcon = !1;
        this.openingVeWorld = !1;
        this.onCopy = async ()=>{
            await navigator.clipboard.writeText(this.walletConnectQRcode || ""), this.showCopiedIcon = !0, setTimeout(()=>{
                this.showCopiedIcon = !1;
            }, 1e3);
        };
        this.getVeWorld = ()=>{
            xA() ? window.open(EA, "_self") : window.open(zA, "_self");
        };
    }
    render() {
        let A = y(this.i18n, this.language), n = this.mode === "LIGHT" ? fA : iA;
        return this.showCopiedIcon && (n = aA), (0, _lit.html)`
            <div class="qrcode-body">
                <div class="qrcode-container ${this.mode}">
                    ${this.openingVeWorld ? this.svgLoaderTemplate() : (0, _lit.nothing)}
                    ${this.svgWCQrCode(this.walletConnectQRcode)}
                    <div class="wc-icon">${ne}</div>
                </div>
                ${this.openingVeWorld ? (0, _lit.html)`<div class="openingVeWorldText">
                          ${A("opening-veworld")}
                      </div>` : (0, _lit.nothing)}
                ${this.openingVeWorld ? (0, _lit.html)`<button
                          class="${this.mode}"
                          @click=${this.getVeWorld}
                      >
                          <img class="veworld-icon" src=${eA} />
                          ${A("get-veworld")}
                      </button>` : (0, _lit.nothing)}
                <div class="separator">
                    <div class="line ${this.mode}"></div>
                    <div class="or ${this.mode}">or</div>
                    <div class="line ${this.mode}"></div>
                </div>
                <button class="${this.mode}" @click=${this.onCopy}>
                    <div class="icon">${n}</div>
                    ${A("copy-to-clipboard")}
                </button>
            </div>
        `;
    }
    svgLoaderTemplate() {
        let s = "8", i = 0;
        s.includes("%") ? i = 0.88 * parseInt(s, 10) : i = parseInt(s, 10), i *= 1.17;
        let d = 317 - i * 1.57, _ = 425 - i * 1.8;
        return (0, _lit.html)`
            <svg
                class="loader"
                viewBox="0 0 110 110"
                width=${k + 50}
                height=${k + 50}
            >
                <rect
                    id="wcm-loader"
                    x="2"
                    y="2"
                    width="106"
                    height="106"
                    rx=${i}
                ></rect>
                <use
                    xlink:href="#wcm-loader"
                    stroke-dasharray="106 ${d}"
                    stroke-dashoffset=${_}
                ></use>
            </svg>
        `;
    }
    svgWCQrCode(A) {
        return A ? (0, _lit.svg)`
            <svg height=${k} width=${k}>
                ${OA.generate({
            uri: A,
            size: k,
            logoSize: k / 4,
            dotColor: this.mode === "LIGHT" ? o.Light.Tertiary.toString() : o.Dark.Tertiary.toString(),
            edgeColor: this.mode === "LIGHT" ? o.Light.Secondary.toString() : o.Dark.Secondary.toString()
        })}
            </svg>
            ` : (0, _lit.nothing);
    }
};
p.styles = [
    q,
    (0, _lit.css)`
            .qrcode-body {
                flex-direction: column;
                align-items: stretch;
                justify-content: center;
                display: flex;
            }

            .qrcode-container {
                position: relative;
                margin: 20px auto 0 auto;
                width: 280px;
                padding: 10px;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid;
            }

            .qrcode-container.LIGHT {
                border-color: var(
                    --vdk-color-light-quaternary,
                    ${o.Light.Quaternary}
                );
            }

            .qrcode-container.DARK {
                border-color: var(
                    --vdk-color-dark-quaternary,
                    ${o.Dark.Quaternary}
                );
            }

            div.wc-icon {
                border-radius: 12px;
                overflow: hidden;
                position: absolute;
                width: 68px;
                height: 68px;
                object-fit: contain;
            }

            .separator {
                display: flex;
                align-items: center;
                padding: 20px 0px;
            }

            .line {
                display: flex;
                flex-grow: 1;
                height: 1px;
            }

            .line.LIGHT {
                background: var(
                    --vdk-color-light-quaternary,
                    ${o.Light.Quaternary}
                );
            }

            .line.DARK {
                background: var(
                    --vdk-color-dark-quaternary,
                    ${o.Dark.Quaternary}
                );
            }

            .or {
                font-family: var(--vdk-font-family, ${c.Family});
                font-size: var(--vdk-font-size-medium, ${c.Size.Medium});
                padding: 0 12px;
            }

            .or.LIGHT {
                color: var(
                    --vdk-color-light-quaternary,
                    ${o.Light.Quaternary}
                );
            }

            .or.DARK {
                color: var(
                    --vdk-color-dark-quaternary,
                    ${o.Dark.Quaternary}
                );
            }

            .icon {
                width: 20px;
                height: 20px;
            }

            .veworld-icon {
                width: 20px;
                height: 20px;
                border-radius: 5px;
            }

            @keyframes loading {
                to {
                    stroke-dashoffset: 0px;
                }
            }

            use {
                stroke: var(
                    --vdk-color-walletconnectblue,
                    ${o.WalletConnectBlue}
                );
                animation: loading 1s linear infinite;
            }

            svg.loader {
                position: absolute;
                fill: none;
                stroke: transparent;
                stroke-linecap: round;
                stroke-width: 1px;
                top: 10;
                left: 10;
            }

            .openingVeWorldText {
                text-align: center;
                font-family: var(--vdk-font-family, ${c.Family});
                font-size: var(--vdk-font-size-medium, ${c.Size.Medium});
                padding: 20px 0;
                color: var(
                    --vdk-color-walletconnectblue,
                    ${o.WalletConnectBlue}
                );
            }
        `
], e([
    (0, _decoratorsJs.property)()
], p.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], p.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], p.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], p.prototype, "walletConnectQRcode", 2), e([
    (0, _decoratorsJs.property)()
], p.prototype, "showCopiedIcon", 2), e([
    (0, _decoratorsJs.property)()
], p.prototype, "openingVeWorld", 2), p = e([
    (0, _decoratorsJs.customElement)("vdk-wallet-connect-qrcode")
], p);
var m = class extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.waitingForTheSignature = !1;
        this.setWaitingForTheSignature = ()=>{};
        this.submitButtonWidth = 0;
        this.setSubmitButtonWidth = ()=>{
            let A = document.querySelector("vdk-modal")?.shadowRoot?.querySelector("vdk-connect-modal")?.shadowRoot?.querySelector("div")?.clientWidth ?? 0;
            this.submitButtonWidth = A ? A - 40 : 0;
        };
        this.handleSignCertificate = async ()=>{
            this.setWaitingForTheSignature(!0), await g.wallet.signConnectionCertificate();
        };
        this.setSubmitButtonWidth(), addEventListener("resize", this.setSubmitButtonWidth);
    }
    svgLoaderTemplate() {
        let n = this.submitButtonWidth - 2, v = 41, s = (n + v) * 2, i = n / 2, d = s - i;
        return (0, _lit.html)`
            <svg
                class="loader"
                viewBox="0 0 ${this.submitButtonWidth} ${v}"
                width=${this.submitButtonWidth}
                height=${v}
            >
                <rect
                    id="sign-connection-loader"
                    x="1"
                    y="1"
                    width=${n}
                    height=${v - 2}
                    rx="12px"
                ></rect>
                <use
                    xlink:href="#sign-connection-loader"
                    stroke-dasharray="${i} ${d}"
                    stroke-dashoffset=${s}
                ></use>
            </svg>
        `;
    }
    render() {
        let A = y(this.i18n, this.language);
        return (0, _lit.html)`
            <div>
                <div class="signCertificateText">
                    ${A("sign-connection-certificate-description")}
                </div>
                ${this.waitingForTheSignature ? this.svgLoaderTemplate() : (0, _lit.nothing)}
                <button
                    class="${this.mode}"
                    @click=${this.handleSignCertificate}
                    .disabled=${this.waitingForTheSignature}
                >
                    ${this.waitingForTheSignature ? A("waiting-signature") : A("sign-connection-certificate-button")}
                </button>
            </div>
        `;
    }
};
m.styles = [
    q,
    (0, _lit.css)`
            .signCertificateText {
                margin: 20px;
                text-align: center;
            }

            @keyframes loading {
                to {
                    stroke-dashoffset: 0px;
                }
            }

            use {
                stroke: var(
                    --vdk-color-walletconnectblue,
                    ${o.WalletConnectBlue}
                );
                animation: loading 1s linear infinite;
            }

            svg.loader {
                position: absolute;
                fill: none;
                stroke: transparent;
                stroke-linecap: round;
                stroke-width: 1px;
                top: 10;
                left: 10;
                z-index: 1;
            }
        `
], e([
    (0, _decoratorsJs.property)()
], m.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], m.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], m.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], m.prototype, "waitingForTheSignature", 2), e([
    (0, _decoratorsJs.property)()
], m.prototype, "setWaitingForTheSignature", 2), e([
    (0, _decoratorsJs.property)()
], m.prototype, "submitButtonWidth", 2), m = e([
    (0, _decoratorsJs.customElement)("vdk-sign-connection-certificate")
], m);
var Ce, Le, C = class extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.open = !1;
        this.address = "";
        this.onDisconnectClick = void 0;
        this.mode = "LIGHT";
        this.i18n = l;
        this.language = "en";
        this.walletConnectQRcode = void 0;
        this.showCopiedIcon = !1;
        this.onClose = ()=>(0, _lit.nothing);
        this.onCopy = async ()=>{
            await navigator.clipboard.writeText(this.address), this.showCopiedIcon = !0, setTimeout(()=>{
                this.showCopiedIcon = !1;
            }, 1e3);
        };
        this.handleClose = ()=>{
            g.modal.close(), this.onClose();
        };
        Ce = w("vdk-open-wallet-modal", ()=>{
            this.open = !0;
        }), Le = w("vdk-close-wallet-modal", ()=>{
            this.open = !1;
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), Ce?.(), Le?.();
    }
    render() {
        let A = y(this.i18n, this.language), n = this.mode === "LIGHT" ? fA : iA;
        return this.showCopiedIcon && (n = aA), (0, _lit.html)`
        <vdk-fonts></vdk-fonts>
        <vdk-base-modal
                .open=${this.open}
                .onClose=${this.handleClose}
                .mode=${this.mode}
        >
            <div class="modal-container">
                <div class="modal-header">
                    <div class="icon-button"></div>
                    <div class="title">${A("connected")}</div>
                    <div
                            class="icon-button ${this.mode}"
                            @click=${this.handleClose}
                    >
                        ${this.mode === "LIGHT" ? cA : vA}
                    </div>
                </div>
                <div class="modal-body">
                    <img
                            class="address-icon"
                            src=${K(this.address)}
                    />
                    <span class="address">
                            ${AA(this.address)}
                            <div class="copy-icon" @click=${this.onCopy}>${n}</div>
                        </span>

                </div>
                <div class="modal-footer">
                    <button
                            class="${this.mode}"
                            @click=${this.onDisconnectClick}
                    >
                        <div class="disconnect-icon ${this.mode}">
                            ${this.mode === "LIGHT" ? oe : re}
                        </div>
                        ${A("disconnect")}
                    </button>
                </div>
        </vdk-base-modal>
    `;
    }
};
C.styles = [
    q,
    gA,
    (0, _lit.css)`
            .modal-container {
                display: flex;
                flex-direction: column;
                gap: 15px;
                padding: 20px;
                transition: width 5s, height 4s;
                font-family: var(--vdk-font-family, ${c.Family});
            }

            .modal-header {
                font-family: var(--vdk-font-family, ${c.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${c.Weight.Medium}
                );
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 20px;
            }

            .modal-body {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 40px;
                transition: width 2s, height 4s;
            }

            .modal-footer {
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 20px;
                font-family: var(--vdk-font-family, ${c.Family});
            }

            .address-icon {
                width: 30%;
                margin-right: 4px;
                border-radius: 50%;
            }

            .disconnect-icon {
                width: 18px;
                height: 18px;
            }

            .title {
                font-family: var(--vdk-font-family, ${c.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${c.Weight.Medium}
                );
            }

            .address {
                font-size: var(--vdk-font-size-large, ${c.Size.Large});
                font-family: var(--vdk-font-family, ${c.Family});
                font-weight: var(
                    --vdk-font-weight-medium,
                    ${c.Weight.Medium}
                );
                display: flex;
                flex-direction: row;
                justify-content: center;
            }

            .copy-icon {
                cursor: pointer;
                width: 20px;
                height: 20px;
                margin-left: 10px;
            }
        `
], e([
    (0, _decoratorsJs.property)({
        type: Boolean
    })
], C.prototype, "open", 2), e([
    (0, _decoratorsJs.property)({
        type: String
    })
], C.prototype, "address", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], C.prototype, "onDisconnectClick", 2), e([
    (0, _decoratorsJs.property)()
], C.prototype, "mode", 2), e([
    (0, _decoratorsJs.property)()
], C.prototype, "i18n", 2), e([
    (0, _decoratorsJs.property)()
], C.prototype, "language", 2), e([
    (0, _decoratorsJs.property)()
], C.prototype, "walletConnectQRcode", 2), e([
    (0, _decoratorsJs.property)()
], C.prototype, "showCopiedIcon", 2), e([
    (0, _decoratorsJs.property)({
        type: Function
    })
], C.prototype, "onClose", 2), C = e([
    (0, _decoratorsJs.customElement)("vdk-address-modal")
], C);
var wA = class extends (0, _lit.LitElement) {
    render() {
        return (0, _lit.html)`
            <style>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;700&display=swap" rel="stylesheet" />
            </style>
        `;
    }
};
wA = e([
    (0, _decoratorsJs.customElement)("vdk-fonts")
], wA);

},{"82f674c5760b0c63":"l5Twm","@vechain/dapp-kit":"7VuTl","valtio/vanilla/utils":"43WO7","lit":"aCmte","qrcode":"g0s0G","@vechain/picasso":"1DbR4","events":"fqTtD","lit/decorators.js":"kQrIl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"7VuTl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CertificateBasedWallet", ()=>C);
parcelHelpers.export(exports, "DAppKit", ()=>Q);
parcelHelpers.export(exports, "DAppKitLogger", ()=>i);
parcelHelpers.export(exports, "DEFAULT_CONNECT_CERT_MESSAGE", ()=>T);
parcelHelpers.export(exports, "DefaultMethods", ()=>V);
parcelHelpers.export(exports, "Storage", ()=>u);
parcelHelpers.export(exports, "WCWallet", ()=>W);
parcelHelpers.export(exports, "WalletManager", ()=>E);
parcelHelpers.export(exports, "WalletMapping", ()=>F);
parcelHelpers.export(exports, "WalletSources", ()=>N);
parcelHelpers.export(exports, "convertVendorToSigner", ()=>O);
parcelHelpers.export(exports, "createWallet", ()=>Y);
parcelHelpers.export(exports, "createWcClient", ()=>G);
parcelHelpers.export(exports, "createWcModal", ()=>z);
parcelHelpers.export(exports, "createWcSigner", ()=>J);
parcelHelpers.export(exports, "genesisBlocks", ()=>x);
parcelHelpers.export(exports, "normalizeGenesisBlock", ()=>U);
parcelHelpers.export(exports, "normalizeGenesisId", ()=>K);
var _indexJs = require("@vechain/connex-driver/dist/index.js");
var _connexFramework = require("@vechain/connex-framework");
var _thorDevkit = require("thor-devkit");
var _vanilla = require("valtio/vanilla");
var _utils = require("valtio/vanilla/utils");
var _connex = require("@vechain/connex");
var _signClient = require("@walletconnect/sign-client");
var _modal = require("@walletconnect/modal");
var _utils1 = require("@walletconnect/utils");
var m = {
    NONE: 0,
    ERROR: 1,
    WARN: 2,
    INFO: 3,
    DEBUG: 4
}, h = m.NONE, i = {
    configure (n) {
        h = m[n];
    },
    debug (n, e, ...t) {
        h >= m.DEBUG && console.log(`[${n}] (${e})`, ...t);
    },
    info (n, e, ...t) {
        h >= m.INFO && console.info(`[${n}] (${e})`, ...t);
    },
    warn (n, e, ...t) {
        h >= m.WARN && console.warn(`[${n}] (${e})`, ...t);
    },
    error (n, e, ...t) {
        h >= m.ERROR && console.error(`[${n}] (${e})`, ...t);
    }
};
var O = (n)=>({
        signTx: (e, t)=>{
            let o = n.sign("tx", e);
            return t.gas && o.gas(t.gas), t.signer && o.signer(t.signer), t.dependsOn && o.dependsOn(t.dependsOn), t.link && o.link(t.link), t.comment && o.comment(t.comment), t.delegator && o.delegate(t.delegator.url, t.delegator.signer), t.onAccepted && o.accepted(t.onAccepted), i.debug("vendor", "signTx", {
                messages: e.length,
                options: t
            }), o.request();
        },
        signCert: (e, t)=>{
            let o = n.sign("cert", e);
            return t.signer && o.signer(t.signer), t.link && o.link(t.link), t.onAccepted && o.accepted(t.onAccepted), i.debug("vendor", "signCert", {
                message: e,
                options: t
            }), o.request();
        }
    });
var M = "dappkit@vechain", k = `${M}/source`, A = `${M}/account`, D = `${M}/connectionCertificate`, ne = (n)=>{
    i.debug("LocalStorage", "setSource", n), n ? localStorage.setItem(k, n) : localStorage.removeItem(k);
}, oe = (n)=>{
    i.debug("LocalStorage", "setAccount", n), n ? localStorage.setItem(A, n) : localStorage.removeItem(A);
}, re = (n)=>{
    i.debug("LocalStorage", "setConnectionCertificate", n), n ? localStorage.setItem(D, JSON.stringify(n)) : localStorage.removeItem(D);
}, se = ()=>{
    let n = localStorage.getItem(k);
    return n || null;
}, ie = ()=>{
    let n = localStorage.getItem(A);
    return n || null;
}, ce = ()=>{
    let n = localStorage.getItem(D);
    return n ? JSON.parse(n) : null;
}, u = {
    setAccount: oe,
    setSource: ne,
    setConnectionCertificate: re,
    getAccount: ie,
    getSource: se,
    getConnectionCertificate: ce
};
var T = {
    purpose: "identification",
    payload: {
        type: "text",
        content: `The following dApp would like to see your public address: ${typeof window < "u" ? window.origin : ""}`
    }
};
var x = {
    main: {
        number: 0,
        id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
        size: 170,
        parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
        timestamp: 1530316800,
        gasLimit: 1e7,
        beneficiary: "0x0000000000000000000000000000000000000000",
        gasUsed: 0,
        totalScore: 0,
        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        txsFeatures: 0,
        stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        signer: "0x0000000000000000000000000000000000000000",
        isTrunk: !0,
        transactions: []
    },
    test: {
        number: 0,
        id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
        size: 170,
        parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
        timestamp: 1530014400,
        gasLimit: 1e7,
        beneficiary: "0x0000000000000000000000000000000000000000",
        gasUsed: 0,
        totalScore: 0,
        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        txsFeatures: 0,
        stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
        signer: "0x0000000000000000000000000000000000000000",
        isTrunk: !0,
        transactions: []
    }
};
var L = {
    requiresCertificate: !0
}, F = {
    "wallet-connect": {
        requiresCertificate: !1
    },
    veworld: L,
    sync2: L,
    sync: L
}, N = Object.keys(F);
Object.freeze(F);
Object.freeze(N);
var V = ((t)=>(t.RequestTransaction = "thor_sendTransaction", t.SignCertificate = "thor_signCertificate", t))(V || {});
var K = (n)=>n ? n === "main" || n === "test" ? x[n].id : n.id : x.main.id, U = (n)=>n ? n === "main" || n === "test" ? x[n] : n : x.main;
var C = class {
    constructor(e, t){
        this.wallet = e;
        this.connectionCertificateData = t;
        this.connect = async ()=>{
            let e = this.connectionCertificateData?.message || T, t = this.connectionCertificateData?.options || {}, { annex: { domain: o, signer: c, timestamp: r }, signature: l } = await this.signCert(e, t), p = {
                ...e,
                signature: l,
                signer: c,
                domain: o,
                timestamp: r
            };
            try {
                return _thorDevkit.Certificate.verify(p), {
                    account: c,
                    verified: !0,
                    connectionCertificate: p
                };
            } catch  {
                return {
                    account: c,
                    verified: !1
                };
            }
        };
        this.signCert = (e, t)=>this.wallet.signCert(e, t);
        this.signTx = (e, t)=>this.wallet.signTx(e, t);
        this.disconnect = async ()=>this.wallet.disconnect?.();
    }
};
var W = class {
    constructor(e){
        this.signer = e;
        this.connect = async ()=>({
                account: await this.signer.connect(),
                verified: !1
            });
        this.signCert = (e, t)=>this.signer.signCert(e, t);
        this.signTx = (e, t)=>this.signer.signTx(e, t);
        this.disconnect = ()=>this.signer.disconnect();
    }
};
var q = {}, G = ({ projectId: n, metadata: e })=>{
    let t = q[n];
    if (t) return t;
    let o = (0, _signClient.SignClient).init({
        projectId: n,
        metadata: e
    }), c = {
        get: async ()=>{
            try {
                return await o;
            } catch  {
                throw new Error("Failed to initialise the wallet connect sign client");
            }
        }
    };
    return q[n] = c, c;
};
var B = {}, de = [
    "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
    "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127"
], pe = de.map((n)=>`vechain:${n.slice(-32)}`), z = (n)=>{
    let e = B[n];
    if (e) return e;
    let t = new (0, _modal.WalletConnectModal)({
        projectId: n,
        explorerRecommendedWalletIds: "NONE",
        mobileWallets: [
            {
                name: "VeWorld",
                id: "veworld-mobile",
                links: {
                    native: "veworld://org.vechain.veworld.app/",
                    universal: "https://veworld.com"
                }
            }
        ],
        chains: pe,
        themeVariables: {
            "--wcm-z-index": "99999999"
        },
        walletImages: {
            "veworld-mobile": "https://www.veworld.net/assets/logo/logo.svg"
        }
    });
    return B[n] = t, t;
};
var J = ({ genesisId: n, wcClient: e, web3Modal: t, onDisconnected: o })=>{
    let c = `vechain:${n.slice(-32)}`, r;
    e.get().then((s)=>{
        l(s), p(s);
    }).catch(()=>{
        throw new Error("Failed to get the wallet connect sign client");
    });
    let l = (s)=>{
        s.on("session_update", ({ topic: a, params: d })=>{
            i.debug("wallet connect signer", "session_update", {
                topic: a,
                params: d
            });
            let { namespaces: f } = d;
            r = {
                ...s.session.get(a),
                namespaces: f
            };
        }), s.on("session_delete", ()=>{
            o(), _().catch(()=>{
                throw new Error("Failed to disconnect");
            });
        });
    }, p = (s)=>{
        if (typeof r < "u") return;
        i.debug("wallet connect signer", "restore session");
        let a = s.session.keys;
        for (let d of a){
            let f = s.session.get(d), b = f.namespaces.vechain.accounts;
            for (let y of b)if (y.split(":")[1] === n.slice(-32)) {
                r = f;
                return;
            }
        }
    }, w = (s)=>{
        if (!r) return;
        i.debug("wallet connect signer", "validate session");
        let a = r.namespaces.vechain.accounts[0], d = a.split(":")[2], f = a.split(":")[1];
        if (f === n.slice(-32) && !(s && s.toLowerCase() !== d.toLowerCase())) return {
            address: d,
            networkIdentifier: f,
            topic: r.topic
        };
    }, v = async ()=>{
        i.debug("wallet connect signer", "connect");
        let s = await e.get(), a = {
            methods: Object.values(V),
            chains: [
                c
            ],
            events: []
        };
        try {
            let d = {
                vechain: a
            }, f = await s.connect({
                requiredNamespaces: d
            });
            return f.uri && await t.openModal({
                uri: f.uri
            }), await new Promise((b, y)=>{
                let I = t.subscribeModal((g)=>{
                    g.open || (y(new Error("User closed modal while connecting")), I());
                });
                f.approval().then((g)=>{
                    r = g, I(), b(g);
                }).catch((g)=>{
                    t.closeModal(), y(g);
                });
            });
        } catch  {
            throw new Error("wc connect failed");
        }
    }, R = async (s)=>{
        let a = w(s);
        return a ? a.topic : (await v()).topic;
    }, S = async (s, a)=>{
        let d = await R(a);
        return (await e.get()).request({
            topic: d,
            chainId: c,
            request: s
        });
    }, ee = async (s, a)=>S({
            method: "thor_sendTransaction",
            params: [
                {
                    message: s,
                    options: a
                }
            ]
        }), te = async (s, a)=>S({
            method: "thor_signCertificate",
            params: [
                {
                    message: s,
                    options: a
                }
            ]
        }), _ = async ()=>{
        if (!r) return;
        let s = r.topic;
        r = void 0;
        let a = await e.get();
        try {
            await a.disconnect({
                topic: s,
                reason: (0, _utils1.getSdkError)("USER_DISCONNECTED")
            });
        } catch  {
            throw new Error("SignClient.disconnect failed");
        }
    };
    return {
        signTx: ee,
        signCert: te,
        disconnect: _,
        genesisId: n,
        connect: async ()=>{
            r || (r = await v());
            let s = r.namespaces.vechain;
            if (!s) throw new Error("Failed to create a vechain session with wallet connect");
            let a = s.accounts[0];
            try {
                return a.split(":")[2];
            } catch  {
                throw new Error("Failed to get account from session");
            }
        }
    };
};
var Y = ({ source: n, genesis: e, walletConnectOptions: t, onDisconnected: o, connectionCertificate: c })=>{
    let r = K(e);
    switch(i.debug("createWallet", n), n){
        case "sync":
            {
                if (!window.connex) throw new Error("User is not in a Sync wallet");
                let l = new _connex.Connex.Vendor(r, "sync");
                return new C(O(l), c);
            }
        case "sync2":
            {
                let l = new _connex.Connex.Vendor(r, "sync2");
                return new C(O(l), c);
            }
        case "veworld":
            {
                if (!window.vechain) throw new Error("VeWorld Extension is not installed");
                let l = window.vechain.newConnexSigner(r);
                return new C(l, c);
            }
        case "wallet-connect":
            {
                if (!t) throw new Error("WalletConnect options are not provided");
                let { projectId: l, metadata: p, modal: w } = t, v = G({
                    projectId: l,
                    metadata: p
                }), R = w ?? z(l), S = J({
                    genesisId: r,
                    wcClient: v,
                    web3Modal: R,
                    onDisconnected: o
                });
                return new W(S);
            }
    }
};
var E = class {
    constructor(e){
        this.options = e;
        this.wallets = {};
        this.signConnectionCertificate = async ()=>{
            let e = this.options.connectionCertificate?.message || T, t = this.options.connectionCertificate?.options || {}, { annex: { domain: o, signer: c, timestamp: r }, signature: l } = await this.wallet.signCert(e, t), p = {
                ...e,
                signature: l,
                signer: c,
                domain: o,
                timestamp: r
            };
            try {
                return _thorDevkit.Certificate.verify(p), this.state.address = c, this.state.connectionCertificate = p, {
                    account: c,
                    verified: !0,
                    connectionCertificate: p
                };
            } catch  {
                return {
                    account: c,
                    verified: !1
                };
            } finally{
                this.options.walletConnectOptions?.modal?.onConnectionCertificateSigned?.();
            }
        };
        this.connect = ()=>this.wallet.connect().then((e)=>(this.state.source === "wallet-connect" && this.options.requireCertificate && this.options.walletConnectOptions?.modal?.askForConnectionCertificate ? this.options.walletConnectOptions.modal.askForConnectionCertificate() : (this.state.address = e.account, this.state.connectionCertificate = e.connectionCertificate ?? null), e)).catch((e)=>{
                throw i.error("WalletManager", "connect", e), e;
            });
        this.disconnect = (e = !1)=>{
            if (!this.state.source) {
                this.state.source = null, this.state.address = null, this.state.connectionCertificate = null;
                return;
            }
            i.debug("WalletManager", "disconnect", "current source", this.state.source);
            let t = this.wallets[this.state.source];
            if (t && !e && t.disconnect) {
                let o = t.disconnect();
                o instanceof Promise && o.catch((c)=>{
                    i.error("WalletManager", "disconnect", c);
                });
            }
            this.state.source = null, this.state.address = null, this.state.connectionCertificate = null;
        };
        this.signTx = (e, t)=>this.wallet.signTx(e, t).then((o)=>(this.state.address = o.signer, o)).catch((o)=>{
                throw i.error("WalletManager", "signTx", o), o;
            });
        this.signCert = (e, t)=>this.wallet.signCert(e, t).then((o)=>(this.state.address = o.annex.signer, o)).catch((o)=>{
                throw i.error("WalletManager", "signCert", o), o;
            });
        this.setSource = (e)=>{
            if (this.state.source !== e) {
                if (this.state.source && this.state.source !== e && this.disconnect(), e === "wallet-connect" && !this.options.walletConnectOptions) throw new Error("WalletConnect options are not provided");
                if (e === "veworld" && !window.vechain) throw new Error("VeWorld Extension is not installed");
                if (e === "sync" && !window.connex) throw new Error("User is not in a Sync wallet");
                i.debug("WalletManager", "setSource", e), this.disconnect(), this.state.source = e;
            }
        };
        this.subscribe = (e)=>(0, _vanilla.subscribe)(this.state, ()=>{
                e(this.state);
            });
        this.subscribeToKey = (e, t)=>(0, _utils.subscribeKey)(this.state, e, (o)=>{
                t(o);
            });
        this.initState = (e)=>{
            let t = this.getAvailableSources();
            if (!e) return (0, _vanilla.proxy)({
                source: null,
                address: null,
                availableSources: t,
                connectionCertificate: null
            });
            let o = u.getAccount(), c = u.getSource(), r = u.getConnectionCertificate();
            return (0, _vanilla.proxy)({
                source: c,
                address: o,
                availableSources: t,
                connectionCertificate: r
            });
        };
        this.initPersistence = (e)=>{
            e && (this.subscribeToKey("address", u.setAccount), this.subscribeToKey("source", u.setSource), this.subscribeToKey("connectionCertificate", u.setConnectionCertificate));
        };
        this.getAvailableSources = ()=>{
            let e = [];
            return e.push("veworld"), this.options.walletConnectOptions && e.push("wallet-connect"), e.push("sync2"), window.connex && e.push("sync"), e;
        };
        this.setFirstDetectedSource = ()=>{
            window.vechain ? this.setSource("veworld") : this.options.walletConnectOptions ? this.setSource("wallet-connect") : window.connex ? this.setSource("sync") : this.setSource("sync2");
        };
        this.state = this.initState(e.usePersistence ?? !1), this.initPersistence(e.usePersistence ?? !1), i.debug("WalletManager", "constructor", this.state), window.vechain?.isInAppBrowser === !0 ? this.setSource("veworld") : e.useFirstDetectedSource && this.setFirstDetectedSource();
    }
    get wallet() {
        let e = this.state.source;
        if (i.debug("WalletManager", "get wallet", "current source", e), !e) throw new Error("No wallet has been selected");
        let t = this.wallets[e];
        if (!t) {
            if (!N.includes(e)) throw new Error(`No wallet found for: ${e}`);
            i.debug("WalletManager", "get wallet", "creating a new wallet", e);
            let o = {
                ...this.options,
                source: e,
                onDisconnected: ()=>this.disconnect(!0)
            };
            t = Y(o), this.wallets[e] = t;
        }
        return t;
    }
};
var H = {}, he = (n, e)=>{
    let t = _thorDevkit.blake2b256(JSON.stringify({
        node: n,
        genesis: e
    })).toString("hex"), o = H[t];
    return o || (o = new (0, _indexJs.DriverNoVendor)(new (0, _indexJs.SimpleNet)(n), e), H[t] = o), o;
}, Q = class {
    constructor(e){
        e.logLevel && (i.configure(e.logLevel), i.debug("DAppKit", "constructor", e));
        let { nodeUrl: t, genesis: o } = e, c = U(o), r = he(t, c), l = new E(e);
        r.signTx = l.signTx.bind(l), r.signCert = l.signCert.bind(l);
        let p = new (0, _connexFramework.Framework)(r);
        this.thor = p.thor, this.vendor = p.vendor, this.wallet = l;
    }
};

},{"@vechain/connex-driver/dist/index.js":"6B1zP","@vechain/connex-framework":"irTjk","thor-devkit":"iIWuY","valtio/vanilla":"5XTXh","valtio/vanilla/utils":"43WO7","@vechain/connex":"fr5nz","@walletconnect/sign-client":"h0I6K","@walletconnect/modal":"h8eAN","@walletconnect/utils":"jCZRI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6B1zP":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9e893f44b4d291db"), exports);
__exportStar(require("1853fb8907f46e2b"), exports);
__exportStar(require("3eab653b64ffc03f"), exports);
__exportStar(require("6d027bcc3eb48cf4"), exports);
__exportStar(require("60a9964ea8359873"), exports);

},{"9e893f44b4d291db":"9sH58","1853fb8907f46e2b":"dJ9no","3eab653b64ffc03f":"aFL01","6d027bcc3eb48cf4":"xm3Bj","60a9964ea8359873":"dJziO"}],"9sH58":[function(require,module,exports) {
var Buffer = require("ca2550804f05ac52").Buffer;
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Driver = void 0;
const driver_no_vendor_1 = require("55fa4c7b9ca4b379");
const thor_devkit_1 = require("e9c8ac80ee8bcc57");
const crypto_1 = require("b7438301528ee981");
/** class fully implements DriverInterface */ class Driver extends driver_no_vendor_1.DriverNoVendor {
    constructor(net, genesis, initialHead, wallet){
        super(net, genesis, initialHead);
        this.wallet = wallet;
        /** params for tx construction */ this.txParams = {
            expiration: 18,
            gasPriceCoef: 0
        };
    }
    /**
     * create driver instance
     * it will fetch config(genesis, head) via net as construction params
     * @param net
     * @param wallet
     */ static connect(net, wallet) {
        return __awaiter(this, void 0, void 0, function*() {
            const genesis = yield net.http("GET", "blocks/0");
            const best = yield net.http("GET", "blocks/best", {
                validateResponseHeader: (headers)=>{
                    const xgid = headers["x-genesis-id"];
                    if (xgid && xgid !== genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
                }
            });
            return new Driver(net, genesis, {
                id: best.id,
                number: best.number,
                timestamp: best.timestamp,
                parentID: best.parentID,
                txsFeatures: best.txsFeatures,
                gasLimit: best.gasLimit
            }, wallet);
        });
    }
    signTx(msg, options) {
        return __awaiter(this, void 0, void 0, function*() {
            options.onAccepted && options.onAccepted();
            const key = this.findKey(options.signer);
            const clauses = msg.map((c)=>({
                    to: c.to ? c.to.toLowerCase() : null,
                    value: c.value.toString().toLowerCase(),
                    data: (c.data || "0x").toLowerCase()
                }));
            const gas = options.gas || (yield this.estimateGas(clauses, key.address));
            const txBody = {
                chainTag: Number.parseInt(this.genesis.id.slice(-2), 16),
                blockRef: this.head.id.slice(0, 18),
                expiration: this.txParams.expiration,
                clauses,
                gasPriceCoef: this.txParams.gasPriceCoef,
                gas,
                dependsOn: options.dependsOn || null,
                nonce: "0x" + crypto_1.randomBytes(8).toString("hex")
            };
            let tx;
            if (options.delegator) {
                const delegatedTx = new thor_devkit_1.Transaction(Object.assign(Object.assign({}, txBody), {
                    reserved: {
                        features: 1 /* vip191 */ 
                    }
                }));
                const originSig = yield key.sign(delegatedTx.signingHash());
                const unsigned = {
                    raw: "0x" + delegatedTx.encode().toString("hex"),
                    origin: key.address
                };
                try {
                    const result = yield this.net.http("POST", options.delegator.url, {
                        body: unsigned
                    });
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    delegatedTx.signature = Buffer.concat([
                        originSig,
                        Buffer.from(result.signature.slice(2), "hex")
                    ]);
                    tx = delegatedTx;
                } catch (err) {
                    // tslint:disable-next-line: no-console
                    console.warn("tx delegation error: ", err);
                // fallback to non-vip191 tx
                }
            }
            if (!tx) {
                tx = new thor_devkit_1.Transaction(txBody);
                tx.signature = yield key.sign(tx.signingHash());
            }
            const raw = "0x" + tx.encode().toString("hex");
            if (this.onTxCommit) this.onTxCommit({
                id: tx.id,
                raw,
                resend: ()=>__awaiter(this, void 0, void 0, function*() {
                        yield this.sendTx(raw);
                    })
            });
            yield this.sendTx(raw);
            return {
                txid: tx.id,
                signer: key.address
            };
        });
    }
    signCert(msg, options) {
        return __awaiter(this, void 0, void 0, function*() {
            options.onAccepted && options.onAccepted();
            const key = this.findKey(options.signer);
            const annex = {
                domain: "localhost",
                timestamp: this.head.timestamp,
                signer: key.address
            };
            const unsigned = thor_devkit_1.Certificate.encode(Object.assign(Object.assign({}, msg), annex));
            const signature = yield key.sign(thor_devkit_1.blake2b256(unsigned));
            return {
                annex,
                signature: "0x" + signature.toString("hex")
            };
        });
    }
    findKey(addr) {
        if (this.wallet) {
            const keys = this.wallet.list;
            const key = addr ? keys.find((k)=>k.address === addr) : keys[0];
            if (key) return key;
        }
        throw new Error("empty wallet");
    }
    sendTx(raw) {
        return this.httpPost("transactions", {
            raw
        });
    }
    estimateGas(clauses, caller) {
        return __awaiter(this, void 0, void 0, function*() {
            const outputs = yield this.explain({
                clauses,
                caller
            }, this.head.id);
            const execGas = outputs.reduce((sum, out)=>sum + out.gasUsed, 0);
            const intrinsicGas = thor_devkit_1.Transaction.intrinsicGas(clauses);
            return intrinsicGas + (execGas ? execGas + 15000 : 0);
        });
    }
}
exports.Driver = Driver;

},{"ca2550804f05ac52":"l5Twm","55fa4c7b9ca4b379":"dJ9no","e9c8ac80ee8bcc57":"iIWuY","b7438301528ee981":"9rmFv"}],"dJ9no":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DriverNoVendor = void 0;
const promint_1 = require("a5d0f082dcf7f328");
const cache_1 = require("623f6074b779ad7a");
const thor_devkit_1 = require("c59ddd4e30ed435c");
const common_1 = require("d56561a957b0edbc");
/** class implements Connex.Driver leaves out Vendor related methods */ class DriverNoVendor {
    constructor(net, genesis, initialHead){
        this.net = net;
        this.genesis = genesis;
        this.headResolvers = [];
        this.int = new promint_1.PromInt();
        this.cache = new cache_1.Cache();
        // to merge concurrent identical remote requests
        this.pendingRequests = {};
        if (initialHead) this.head = initialHead;
        else this.head = {
            id: genesis.id,
            number: genesis.number,
            timestamp: genesis.timestamp,
            parentID: genesis.parentID,
            txsFeatures: genesis.txsFeatures,
            gasLimit: genesis.gasLimit
        };
        this.headTrackerLoop();
    }
    // close the driver to prevent mem leak
    close() {
        this.int.interrupt();
    }
    // implementations
    pollHead() {
        return this.int.wrap(new Promise((resolve)=>{
            this.headResolvers.push(()=>resolve(this.head));
        }));
    }
    getBlock(revision) {
        return this.cache.getBlock(revision, ()=>this.httpGet(`blocks/${revision}`));
    }
    getTransaction(id, allowPending) {
        return this.cache.getTx(id, ()=>{
            const query = {
                head: this.head.id
            };
            if (allowPending) query.pending = "true";
            return this.httpGet(`transactions/${id}`, query);
        });
    }
    getReceipt(id) {
        return this.cache.getReceipt(id, ()=>this.httpGet(`transactions/${id}/receipt`, {
                head: this.head.id
            }));
    }
    getAccount(addr, revision) {
        return this.cache.getAccount(addr, revision, ()=>this.httpGet(`accounts/${addr}`, {
                revision
            }));
    }
    getCode(addr, revision) {
        return this.cache.getTied(`code-${addr}`, revision, ()=>this.httpGet(`accounts/${addr}/code`, {
                revision
            }));
    }
    getStorage(addr, key, revision) {
        return this.cache.getTied(`storage-${addr}-${key}`, revision, ()=>this.httpGet(`accounts/${addr}/storage/${key}`, {
                revision
            }));
    }
    explain(arg, revision, cacheHints) {
        const cacheKey = `explain-${thor_devkit_1.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, revision, ()=>this.httpPost("accounts/*", arg, {
                revision
            }), cacheHints);
    }
    filterEventLogs(arg, cacheHints) {
        const cacheKey = `event-${thor_devkit_1.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/event", arg), cacheHints);
    }
    filterTransferLogs(arg, cacheHints) {
        const cacheKey = `transfer-${thor_devkit_1.blake2b256(JSON.stringify(arg)).toString("hex")}`;
        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/transfer", arg), cacheHints);
    }
    signTx(msg, options) {
        throw new Error("signer not implemented");
    }
    signCert(msg, options) {
        throw new Error("signer not implemented");
    }
    //////
    mergeRequest(req, ...keyParts) {
        const key = JSON.stringify(keyParts);
        const pending = this.pendingRequests[key];
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        if (pending) return pending;
        return this.pendingRequests[key] = (()=>__awaiter(this, void 0, void 0, function*() {
                try {
                    return yield req();
                } finally{
                    delete this.pendingRequests[key];
                }
            }))();
    }
    httpGet(path, query) {
        return this.mergeRequest(()=>{
            return this.net.http("GET", path, {
                query,
                validateResponseHeader: this.headerValidator
            });
        }, path, query || "");
    }
    httpPost(path, body, query) {
        return this.mergeRequest(()=>{
            return this.net.http("POST", path, {
                query,
                body,
                validateResponseHeader: this.headerValidator
            });
        }, path, query || "", body || "");
    }
    get headerValidator() {
        return (headers)=>{
            const xgid = headers["x-genesis-id"];
            if (xgid && xgid !== this.genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
        };
    }
    emitNewHead() {
        const resolvers = this.headResolvers;
        this.headResolvers = [];
        resolvers.forEach((r)=>r());
    }
    headTrackerLoop() {
        return __awaiter(this, void 0, void 0, function*() {
            for(;;){
                let attemptWs = false;
                try {
                    const best = yield this.int.wrap(this.httpGet("blocks/best"));
                    if (best.id !== this.head.id && best.number >= this.head.number) {
                        this.head = {
                            id: best.id,
                            number: best.number,
                            timestamp: best.timestamp,
                            parentID: best.parentID,
                            txsFeatures: best.txsFeatures,
                            gasLimit: best.gasLimit
                        };
                        this.cache.handleNewBlock(this.head, undefined, best);
                        this.emitNewHead();
                        if (Date.now() - this.head.timestamp * 1000 < 60000) // nearly synced
                        attemptWs = true;
                    }
                } catch (err) {
                    if (err instanceof promint_1.InterruptedError) break;
                }
                if (attemptWs) try {
                    yield this.trackWs();
                } catch (err) {
                    if (err instanceof promint_1.InterruptedError) break;
                }
                try {
                    yield this.int.wrap(common_1.sleep(8000));
                } catch (_a) {
                    break;
                }
            }
        });
    }
    trackWs() {
        return __awaiter(this, void 0, void 0, function*() {
            const wsPath = `subscriptions/beat2?pos=${this.head.parentID}`;
            const wsr = this.net.openWebSocketReader(wsPath);
            try {
                for(;;){
                    const data = yield this.int.wrap(wsr.read());
                    const beat = JSON.parse(data);
                    if (!beat.obsolete && beat.id !== this.head.id && beat.number >= this.head.number) {
                        this.head = {
                            id: beat.id,
                            number: beat.number,
                            timestamp: beat.timestamp,
                            parentID: beat.parentID,
                            txsFeatures: beat.txsFeatures,
                            gasLimit: beat.gasLimit
                        };
                        this.cache.handleNewBlock(this.head, {
                            k: beat.k,
                            bits: beat.bloom
                        });
                        this.emitNewHead();
                    }
                }
            } finally{
                wsr.close();
            }
        });
    }
}
exports.DriverNoVendor = DriverNoVendor;

},{"a5d0f082dcf7f328":"ekS6f","623f6074b779ad7a":"jBmFw","c59ddd4e30ed435c":"iIWuY","d56561a957b0edbc":"bK13X"}],"ekS6f":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InterruptedError = exports.PromInt = void 0;
/** class to make promise interruptable */ class PromInt {
    constructor(){
        this.rejectors = new Set();
    }
    /**
     * interrupt all wrapped promises
     */ interrupt() {
        const rejectors = this.rejectors;
        this.rejectors = new Set();
        rejectors.forEach((r)=>r(new InterruptedError()));
    }
    /**
     * wrap the promise
     * @param p the given promise
     * @returns the wrapped promise which will raise InterruptedError on interruption
     */ wrap(p) {
        return new Promise((resolve, reject)=>{
            const rejectors = this.rejectors;
            rejectors.add(reject);
            p.then(resolve).catch(reject).then(()=>rejectors.delete(reject));
        });
    }
}
exports.PromInt = PromInt;
class InterruptedError extends Error {
    constructor(){
        super("promise interrupted");
    }
}
exports.InterruptedError = InterruptedError;
InterruptedError.prototype.name = "InterruptedError";

},{}],"jBmFw":[function(require,module,exports) {
var Buffer = require("3d9d9aa8c703576e").Buffer;
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cache = void 0;
const LRU = require("4de78e82b803e4e");
const bignumber_js_1 = require("2794c1afe3eca73c");
const bloom_1 = require("5cc29b9edc43c71c");
const WINDOW_LEN = 12;
class Cache {
    constructor(){
        this.irreversible = {
            blocks: new LRU(256),
            txs: new LRU(512),
            receipts: new LRU(512)
        };
        this.window = [];
    }
    handleNewBlock(head, bloom, block) {
        while(this.window.length > 0){
            const top = this.window[this.window.length - 1];
            if (top.id === head.id) return;
            if (top.id === head.parentID) break;
            this.window.pop();
        }
        this.window.push(Object.assign(Object.assign({}, head), {
            bloom: bloom ? bloom_1.newFilter(Buffer.from(bloom.bits.slice(2), "hex"), bloom.k) : undefined,
            block,
            accounts: new Map(),
            txs: new Map(),
            receipts: new Map(),
            tied: new Map()
        }));
        // shift out old slots and move cached items into frozen cache
        while(this.window.length > WINDOW_LEN){
            const bottom = this.window.shift();
            bottom.txs.forEach((v, k)=>this.irreversible.txs.set(k, v));
            bottom.receipts.forEach((v, k)=>this.irreversible.receipts.set(k, v));
            if (bottom.block) {
                this.irreversible.blocks.set(bottom.block.id, bottom.block);
                this.irreversible.blocks.set(bottom.block.number, bottom.block);
            }
        }
    }
    getBlock(revision, fetch) {
        return __awaiter(this, void 0, void 0, function*() {
            let block = this.irreversible.blocks.get(revision) || null;
            if (block) return block;
            const { slot } = this.findSlot(revision);
            if (slot && slot.block) return slot.block;
            block = yield fetch();
            if (block) {
                if (slot && slot.id === block.id) slot.block = block;
                if (this.isIrreversible(block.number)) {
                    this.irreversible.blocks.set(block.id, block);
                    if (block.isTrunk) this.irreversible.blocks.set(block.number, block);
                }
            }
            return block;
        });
    }
    getTx(txid, fetch) {
        return __awaiter(this, void 0, void 0, function*() {
            let tx = this.irreversible.txs.get(txid) || null;
            if (tx) return tx;
            for (const slot of this.window){
                tx = slot.txs.get(txid) || null;
                if (tx) return tx;
            }
            tx = yield fetch();
            if (tx && tx.meta) {
                const { slot } = this.findSlot(tx.meta.blockID);
                if (slot) slot.txs.set(txid, tx);
                if (this.isIrreversible(tx.meta.blockNumber)) this.irreversible.txs.set(txid, tx);
            }
            return tx;
        });
    }
    getReceipt(txid, fetch) {
        return __awaiter(this, void 0, void 0, function*() {
            let receipt = this.irreversible.receipts.get(txid) || null;
            if (receipt) return receipt;
            for (const slot of this.window){
                receipt = slot.receipts.get(txid) || null;
                if (receipt) return receipt;
            }
            receipt = yield fetch();
            if (receipt) {
                const { slot } = this.findSlot(receipt.meta.blockID);
                if (slot) slot.receipts.set(txid, receipt);
                if (this.isIrreversible(receipt.meta.blockNumber)) this.irreversible.receipts.set(txid, receipt);
            }
            return receipt;
        });
    }
    getAccount(addr, revision, fetch) {
        return __awaiter(this, void 0, void 0, function*() {
            const found = this.findSlot(revision);
            for(let i = found.index; i >= 0; i--){
                const slot = this.window[i];
                const acc = slot.accounts.get(addr);
                if (acc) {
                    if (i !== found.index) found.slot.accounts.set(addr, acc);
                    return acc.snapshot(found.slot.timestamp);
                }
                if (!slot.bloom || testBytesHex(slot.bloom, addr)) break;
            }
            const accObj = yield fetch();
            if (found.slot) found.slot.accounts.set(addr, new Account(accObj, found.slot.timestamp));
            return accObj;
        });
    }
    /**
     * get cached entry which is tied to a batch of addresses
     * @param key the cache key
     * @param revision block id where cache bound to
     * @param fetch to fetch value when cache missing
     * @param hints array of tied addresses, as the gist to invalidate cache key. undefined means the key is always
     * invalidated on different revision.
     */ getTied(key, revision, fetch, hints) {
        return __awaiter(this, void 0, void 0, function*() {
            const found = this.findSlot(revision);
            for(let i = found.index; i >= 0; i--){
                const slot = this.window[i];
                const v = slot.tied.get(key);
                if (v) {
                    if (i !== found.index) found.slot.tied.set(key, v);
                    return v;
                }
                if (!slot.bloom || !hints) break;
                // if hints.length === 0, never invalidate cache
                if (hints.some((t)=>testBytesHex(slot.bloom, t))) break;
            }
            const value = yield fetch();
            if (found.slot) found.slot.tied.set(key, value);
            return value;
        });
    }
    findSlot(revision) {
        const index = this.window.findIndex((s)=>s.id === revision || s.number === revision);
        if (index >= 0) return {
            slot: this.window[index],
            index
        };
        return {
            index
        };
    }
    isIrreversible(n) {
        if (this.window.length > 0) return n < this.window[this.window.length - 1].number - WINDOW_LEN;
        return false;
    }
}
exports.Cache = Cache;
function testBytesHex(filter, hex) {
    let buf = Buffer.from(hex.slice(2), "hex");
    const nzIndex = buf.findIndex((v)=>v !== 0);
    if (nzIndex < 0) buf = Buffer.alloc(0);
    else buf = buf.slice(nzIndex);
    return filter.contains(buf);
}
const ENERGY_GROWTH_RATE = 5000000000;
class Account {
    constructor(obj, initTimestamp){
        this.obj = obj;
        this.initTimestamp = initTimestamp;
    }
    snapshot(timestamp) {
        return Object.assign(Object.assign({}, this.obj), {
            energy: this.energyAt(timestamp)
        });
    }
    energyAt(timestamp) {
        if (timestamp < this.initTimestamp) return this.obj.energy;
        return "0x" + new bignumber_js_1.default(this.obj.balance).times(timestamp - this.initTimestamp).times(ENERGY_GROWTH_RATE).dividedToIntegerBy(1e18).plus(this.obj.energy).toString(16);
    }
}

},{"3d9d9aa8c703576e":"l5Twm","4de78e82b803e4e":"2xyKn","2794c1afe3eca73c":"2fTAY","5cc29b9edc43c71c":"4FhvH"}],"2xyKn":[function(require,module,exports) {
"use strict";
// A linked list to keep track of recently-used-ness
const Yallist = require("387339c7612f9969");
const MAX = Symbol("max");
const LENGTH = Symbol("length");
const LENGTH_CALCULATOR = Symbol("lengthCalculator");
const ALLOW_STALE = Symbol("allowStale");
const MAX_AGE = Symbol("maxAge");
const DISPOSE = Symbol("dispose");
const NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const LRU_LIST = Symbol("lruList");
const CACHE = Symbol("cache");
const UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[MAX] = options.max || Infinity;
        const lc = options.length || naiveLength;
        this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
        this[ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[MAX_AGE] = options.maxAge || 0;
        this[DISPOSE] = options.dispose;
        this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[MAX] = mL || Infinity;
        trim(this);
    }
    get max() {
        return this[MAX];
    }
    set allowStale(allowStale) {
        this[ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[MAX_AGE] = mA;
        trim(this);
    }
    get maxAge() {
        return this[MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = naiveLength;
        if (lC !== this[LENGTH_CALCULATOR]) {
            this[LENGTH_CALCULATOR] = lC;
            this[LENGTH] = 0;
            this[LRU_LIST].forEach((hit)=>{
                hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
                this[LENGTH] += hit.length;
            });
        }
        trim(this);
    }
    get lengthCalculator() {
        return this[LENGTH_CALCULATOR];
    }
    get length() {
        return this[LENGTH];
    }
    get itemCount() {
        return this[LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[LRU_LIST].head; walker !== null;){
            const next = walker.next;
            forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) this[LRU_LIST].forEach((hit)=>this[DISPOSE](hit.key, hit.value));
        this[CACHE] = new Map() // hash of items by key
        ;
        this[LRU_LIST] = new Yallist() // list of items in order of use recency
        ;
        this[LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[LRU_LIST].map((hit)=>isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[LENGTH_CALCULATOR](value, key);
        if (this[CACHE].has(key)) {
            if (len > this[MAX]) {
                del(this, this[CACHE].get(key));
                return false;
            }
            const node = this[CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[DISPOSE]) {
                if (!this[NO_DISPOSE_ON_SET]) this[DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            trim(this);
            return true;
        }
        const hit = new Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[MAX]) {
            if (this[DISPOSE]) this[DISPOSE](key, value);
            return false;
        }
        this[LENGTH] += hit.length;
        this[LRU_LIST].unshift(hit);
        this[CACHE].set(key, this[LRU_LIST].head);
        trim(this);
        return true;
    }
    has(key) {
        if (!this[CACHE].has(key)) return false;
        const hit = this[CACHE].get(key).value;
        return !isStale(this, hit);
    }
    get(key) {
        return get(this, key, true);
    }
    peek(key) {
        return get(this, key, false);
    }
    pop() {
        const node = this[LRU_LIST].tail;
        if (!node) return null;
        del(this, node);
        return node.value;
    }
    del(key) {
        del(this, this[CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[CACHE].forEach((value, key)=>get(this, key, false));
    }
}
const get = (self, key, doUse)=>{
    const node = self[CACHE].get(key);
    if (node) {
        const hit = node.value;
        if (isStale(self, hit)) {
            del(self, node);
            if (!self[ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[MAX_AGE] && diff > self[MAX_AGE];
};
const trim = (self)=>{
    if (self[LENGTH] > self[MAX]) for(let walker = self[LRU_LIST].tail; self[LENGTH] > self[MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        del(self, walker);
        walker = prev;
    }
};
const del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[DISPOSE]) self[DISPOSE](hit.key, hit.value);
        self[LENGTH] -= hit.length;
        self[CACHE].delete(hit.key);
        self[LRU_LIST].removeNode(node);
    }
};
class Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if (isStale(self, hit)) {
        del(self, node);
        if (!self[ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = LRUCache;

},{"387339c7612f9969":"8Prwf"}],"8Prwf":[function(require,module,exports) {
"use strict";
module.exports = Yallist;
Yallist.Node = Node;
Yallist.create = Yallist;
function Yallist(list) {
    var self = this;
    if (!(self instanceof Yallist)) self = new Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)push(this, arguments[i]);
    return this.length;
};
Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)unshift(this, arguments[i]);
    return this.length;
};
Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
Yallist.prototype.splice = function(start, deleteCount /*, ...nodes */ ) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 2; i < arguments.length; i++)walker = insert(this, walker, arguments[i]);
    return ret;
};
Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function insert(self, node, value) {
    var inserted = node === self.head ? new Node(value, null, node, self) : new Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function push(self, item) {
    self.tail = new Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function unshift(self, item) {
    self.head = new Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function Node(value, prev, next, list) {
    if (!(this instanceof Node)) return new Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}
try {
    // add if support for Symbol.iterator is present
    require("4904b6f58d7ea8ff")(Yallist);
} catch (er) {}

},{"4904b6f58d7ea8ff":"9BjFw"}],"9BjFw":[function(require,module,exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

},{}],"2fTAY":[function(require,module,exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            decimalSeparator: ".",
            groupSeparator: ",",
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            fractionGroupSize: 0
        }, // The alphabet used for base conversion.
        // It must be at least 2 characters long, with no '.' or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor usage without new.
            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
            // '[BigNumber Error] Constructor call without new: {n}'
            //throw Error(bignumberError + ' Constructor call without new: ' + n);
            return new BigNumber(n, b);
            if (b == null) {
                // Duplicate.
                if (n instanceof BigNumber) {
                    x.s = n.s;
                    x.e = n.e;
                    x.c = (n = n.c) ? n.slice() : n;
                    return;
                }
                isNum = typeof n == "number";
                if (isNum && n * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                    // Faster path for integers.
                    if (n === ~~n) {
                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                        x.e = e;
                        x.c = [
                            n
                        ];
                        return;
                    }
                    str = n + "";
                } else {
                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                str = n + "";
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10) {
                    x = new BigNumber(n instanceof BigNumber ? n : str);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                isNum = typeof n == "number";
                if (isNum) {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                    // Prevent later check for length on converted number.
                    isNum = false;
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, n + "", isNum, b);
                }
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            str = str.slice(i, ++len);
            if (str) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                e = e - i - 1;
                // Overflow?
                if (e > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE;
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        str = str.slice(i);
                        i = LOG_BASE - str.length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (isArray(v)) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if only one character, or contains '.' or a repeated character.
                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                        else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
            return v instanceof BigNumber || v && v._isBigNumber === true || false;
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var m, n, i = 0;
            if (isArray(args[0])) args = args[0];
            m = new BigNumber(args[0]);
            for(; ++i < args.length;){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) {
                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                    x.c = x.e = null;
                } else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.c = x.e = x.s = null;
                }
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                nIsOdd = isOdd(n);
            } else nIsOdd = n % 2;
            if (nIsNeg) n.s = 1;
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (nIsBig) {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (!n.c[0]) break;
                    nIsBig = n.e > 14;
                    nIsOdd = isOdd(n);
                } else {
                    n = mathfloor(n / 2);
                    if (!n) break;
                    nIsOdd = n % 2;
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+x);
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "1e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
            var str = this.toFixed(dp, rm);
            if (this.c) {
                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
            }
            return str;
        };
        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
            }
            if (!xc) return x.toString();
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e *= 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1.toString(),
                d1.toString()
            ] : [
                n0.toString(),
                d0.toString()
            ];
            MAX_EXP = exp;
            return arr;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +this;
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                str = coeffToString(n.c);
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            var str, n = this, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
    }
    function isArray(obj) {
        return Object.prototype.toString.call(obj) == "[object Array]";
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(this);

},{}],"4FhvH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newFilter = void 0;
const thor_devkit_1 = require("815aa08f2330fda5");
function newFilter(bits, k) {
    const nBits = bits.length * 8;
    return {
        contains (key) {
            let hash = thor_devkit_1.blake2b256(key).readUInt32BE(0);
            const delta = hash >>> 17 | hash << 15 >>> 0;
            for(let i = 0; i < k; i++){
                const bitPos = hash % nBits;
                const index = bitPos >>> 3;
                const bit = 1 << bitPos % 8;
                if (!(bits[index] & bit)) return false;
                hash = hash + delta >>> 0;
            }
            return true;
        }
    };
}
exports.newFilter = newFilter; // // test vector
 // const bits = Buffer.from('63b2a4758c74e246c818e080b870437f5327a15cf81172512d98e61c54361a851ba8f108420e6b2b74a4196fb8e7bfe2b96c985e49abddb21c0600063997c93edb7c54921551600bcfc80fb62bfcd045c030b328eb8b5498e06dce610d22e901201226226441b8da094141526e0e58f5baf53064d63d598a4024bf68e0', 'hex')
 // const f = newFilter(bits, 6)
 // for (let i = 0; i < 100; i++) {
 //     if (!f.contains(Buffer.from(i + ''))) {
 //         throw new Error('should return true')
 //     }
 // }

},{"815aa08f2330fda5":"iIWuY"}],"iIWuY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _abi = require("./abi");
parcelHelpers.exportAll(_abi, exports);
var _transaction = require("./transaction");
parcelHelpers.exportAll(_transaction, exports);
var _rlp = require("./rlp");
parcelHelpers.exportAll(_rlp, exports);
var _bloom = require("./bloom");
parcelHelpers.exportAll(_bloom, exports);
var _certificate = require("./certificate");
parcelHelpers.exportAll(_certificate, exports);
var _address = require("./address");
parcelHelpers.exportAll(_address, exports);
// crypto
var _blake2B = require("./blake2b");
parcelHelpers.exportAll(_blake2B, exports);
var _secp256K1 = require("./secp256k1");
parcelHelpers.exportAll(_secp256K1, exports);
var _keccak = require("./keccak");
parcelHelpers.exportAll(_keccak, exports);
var _keystore = require("./keystore");
parcelHelpers.exportAll(_keystore, exports);
var _mnemonic = require("./mnemonic");
parcelHelpers.exportAll(_mnemonic, exports);
var _hdnode = require("./hdnode");
parcelHelpers.exportAll(_hdnode, exports);

},{"./abi":"ghglf","./transaction":"hRsQk","./rlp":"eunoT","./bloom":"eMf8V","./certificate":"870oY","./address":"aT2rv","./blake2b":"iUeyt","./secp256k1":"7vgw0","./keccak":"9LyYR","./keystore":"9hEAv","./mnemonic":"etwN5","./hdnode":"eDGtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghglf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abi", ()=>abi);
var _abiCoder = require("@vechain/ethers/utils/abi-coder");
var _keccak = require("./keccak");
var Buffer = require("7f1b504b48c6abbd").Buffer;
class Coder extends (0, _abiCoder.AbiCoder) {
    constructor(){
        super((type, value)=>{
            if (type.match(/^u?int/) && !Array.isArray(value) && typeof value !== "object" || value._ethersType === "BigNumber") return value.toString();
            return value;
        });
    }
    encode(types, values) {
        try {
            return super.encode(types, values);
        } catch (err) {
            if (err.reason) throw new Error(err.reason);
            throw err;
        }
    }
    decode(types, data) {
        try {
            return super.decode(types, data);
        } catch (err) {
            if (err.reason) throw new Error(err.reason);
            throw err;
        }
    }
}
const coder = new Coder();
function formatSignature(fragment) {
    try {
        return (0, _abiCoder.formatSignature)(fragment).replace(/\(tuple\(/g, "((").replace(/\,tuple\(/g, ",(");
    } catch (err) {
        if (err.reason) throw new Error(err.reason);
        throw err;
    }
}
var abi;
(function(abi) {
    /**
     * encode single parameter
     * @param type type of the parameter
     * @param value value of the parameter
     * @returns encoded value in hex string
     */ function encodeParameter(type, value) {
        return coder.encode([
            type
        ], [
            value
        ]);
    }
    abi.encodeParameter = encodeParameter;
    /**
     * decode single parameter
     * @param type type of the parameter
     * @param data encoded parameter in hex string
     * @returns decoded value
     */ function decodeParameter(type, data) {
        return coder.decode([
            type
        ], data)[0];
    }
    abi.decodeParameter = decodeParameter;
    /**
     * encode a group of parameters
     * @param types type array
     * @param values value array
     * @returns encoded values in hex string
     */ function encodeParameters(types, values) {
        return coder.encode(types, values);
    }
    abi.encodeParameters = encodeParameters;
    /**
     * decode a group of parameters
     * @param types type array
     * @param data encoded values in hex string
     * @returns decoded object
     */ function decodeParameters(types, data) {
        const result = coder.decode(types, data);
        const decoded = {};
        types.forEach((t, i)=>{
            decoded[i] = result[i];
            if (t.name) decoded[t.name] = result[i];
        });
        return decoded;
    }
    abi.decodeParameters = decodeParameters;
    /** for contract function */ class Function {
        /**
         * create a function object
         * @param definition abi definition of the function
         */ constructor(definition){
            this.definition = definition;
            this.canonicalName = formatSignature(definition);
            this.signature = "0x" + (0, _keccak.keccak256)(this.canonicalName).slice(0, 4).toString("hex");
        }
        /**
         * encode input parameters into call data
         * @param args arguments for the function
         */ encode(...args) {
            return this.signature + encodeParameters(this.definition.inputs, args).slice(2);
        }
        /**
         * decode output data
         * @param outputData output data to decode
         */ decode(outputData) {
            return decodeParameters(this.definition.outputs, outputData);
        }
    }
    abi.Function = Function;
    /** for contract event */ class Event {
        /** for contract event */ constructor(definition){
            this.definition = definition;
            this.canonicalName = formatSignature(definition);
            this.signature = "0x" + (0, _keccak.keccak256)(this.canonicalName).toString("hex");
        }
        /**
         * encode an object of indexed keys into topics.
         * @param indexed an object contains indexed keys
         */ encode(indexed) {
            const topics = [];
            if (!this.definition.anonymous) topics.push(this.signature);
            for (const input of this.definition.inputs){
                if (!input.indexed) continue;
                const value = indexed[input.name];
                if (value === undefined || value === null) topics.push(null);
                else {
                    let topic;
                    // https://docs.soliditylang.org/en/v0.8.11/abi-spec.html#encoding-of-indexed-event-parameters
                    if (isValueType(input.type)) topic = encodeParameter(input.type, value);
                    else {
                        if (input.type === "string") topic = "0x" + (0, _keccak.keccak256)(value).toString("hex");
                        else if (typeof value === "string" && /^0x[0-9a-f]+$/i.test(value) && value.length % 2 === 0) // value is encoded
                        topic = "0x" + (0, _keccak.keccak256)(Buffer.from(value.slice(2), "hex")).toString("hex");
                        else throw new Error(`event.encode: invalid ${input.type} value`);
                    }
                    topics.push(topic);
                }
            }
            return topics;
        }
        /**
         * decode event log
         * @param data data in event output
         * @param topics topics in event
         */ decode(data, topics) {
            if (!this.definition.anonymous) topics = topics.slice(1);
            if (this.definition.inputs.filter((t)=>t.indexed).length !== topics.length) throw new Error("invalid topics count");
            const decodedNonIndexed = coder.decode(this.definition.inputs.filter((t)=>!t.indexed), data);
            const decoded = {};
            this.definition.inputs.forEach((t, i)=>{
                if (t.indexed) {
                    const topic = topics.shift();
                    decoded[i] = isValueType(t.type) ? decodeParameter(t.type, topic) : topic;
                } else decoded[i] = decodedNonIndexed.shift();
                if (t.name) decoded[t.name] = decoded[i];
            });
            return decoded;
        }
    }
    abi.Event = Event;
    function isValueType(type) {
        return type === "address" || type === "bool" || /^(u?int)([0-9]*)$/.test(type) || /^bytes([0-9]+)$/.test(type);
    }
})(abi || (abi = {}));

},{"7f1b504b48c6abbd":"l5Twm","@vechain/ethers/utils/abi-coder":"cIFes","./keccak":"9LyYR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cIFes":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
// See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
var constants_1 = require("112150acf194fb49");
var errors = __importStar(require("80fc9a0766c65078"));
var address_1 = require("991646637eabc8cf");
var bignumber_1 = require("8c5bece05f5a985");
var bytes_1 = require("fe53351f3408b6a8");
var utf8_1 = require("b0d7108503806e5b");
var properties_1 = require("95240faf46789f0c");
///////////////////////////////
var paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
var paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
var paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
exports.defaultCoerceFunc = function(type, value) {
    var match = type.match(paramTypeNumber);
    if (match && parseInt(match[2]) <= 48) return value.toNumber();
    return value;
};
///////////////////////////////////
// Parsing for Solidity Signatures
var regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
var regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
function verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    return type;
}
function parseParam(param, allowIndexed) {
    var originalParam = param;
    function throwError(i) {
        throw new Error('unexpected character "' + originalParam[i] + '" at position ' + i + ' in "' + originalParam + '"');
    }
    param = param.replace(/\s/g, " ");
    var parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    var node = parent;
    for(var i = 0; i < param.length; i++){
        var c = param[i];
        switch(c){
            case "(":
                if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = verifyType(node.type);
                node.components = [
                    {
                        type: "",
                        name: "",
                        parent: node,
                        state: {
                            allowType: true
                        }
                    }
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (allowIndexed && node.name === "indexed") {
                    node.indexed = true;
                    node.name = "";
                }
                node.type = verifyType(node.type);
                var child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (allowIndexed && node.name === "indexed") {
                    node.indexed = true;
                    node.name = "";
                }
                node.type = verifyType(node.type);
                var sibling = {
                    type: "",
                    name: "",
                    parent: node.parent,
                    state: {
                        allowType: true
                    }
                };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (allowIndexed && node.name === "indexed") {
                            node.indexed = true;
                            node.name = "";
                        } else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) throw new Error("unexpected eof");
    delete parent.state;
    if (allowIndexed && node.name === "indexed") {
        node.indexed = true;
        node.name = "";
    }
    parent.type = verifyType(parent.type);
    return parent;
}
// @TODO: Better return type
function parseSignatureEvent(fragment) {
    var abi = {
        anonymous: false,
        inputs: [],
        name: "",
        type: "event"
    };
    var match = fragment.match(regexParen);
    if (!match) throw new Error("invalid event: " + fragment);
    abi.name = match[1].trim();
    splitNesting(match[2]).forEach(function(param) {
        param = parseParam(param, true);
        param.indexed = !!param.indexed;
        abi.inputs.push(param);
    });
    match[3].split(" ").forEach(function(modifier) {
        switch(modifier){
            case "anonymous":
                abi.anonymous = true;
                break;
            case "":
                break;
            default:
                errors.info("unknown modifier: " + modifier);
        }
    });
    if (abi.name && !abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + abi.name + '"');
    return abi;
}
function parseSignatureFunction(fragment) {
    var abi = {
        constant: false,
        gas: null,
        inputs: [],
        name: "",
        outputs: [],
        payable: false,
        stateMutability: null,
        type: "function"
    };
    var comps = fragment.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) throw new Error("invalid signature");
        if (!comps[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
        abi.gas = bignumber_1.bigNumberify(comps[1]);
        fragment = comps[0];
    }
    comps = fragment.split(" returns ");
    var left = comps[0].match(regexParen);
    if (!left) throw new Error("invalid signature");
    abi.name = left[1].trim();
    if (!abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + left[1] + '"');
    splitNesting(left[2]).forEach(function(param) {
        abi.inputs.push(parseParam(param));
    });
    left[3].split(" ").forEach(function(modifier) {
        switch(modifier){
            case "constant":
                abi.constant = true;
                break;
            case "payable":
                abi.payable = true;
                abi.stateMutability = "payable";
                break;
            case "pure":
                abi.constant = true;
                abi.stateMutability = "pure";
                break;
            case "view":
                abi.constant = true;
                abi.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                errors.info("unknown modifier: " + modifier);
        }
    });
    // We have outputs
    if (comps.length > 1) {
        var right = comps[1].match(regexParen);
        if (right[1].trim() != "" || right[3].trim() != "") throw new Error("unexpected tokens");
        splitNesting(right[2]).forEach(function(param) {
            abi.outputs.push(parseParam(param));
        });
    }
    if (abi.name === "constructor") {
        abi.type = "constructor";
        if (abi.outputs.length) throw new Error("constructor may not have outputs");
        delete abi.name;
        delete abi.outputs;
    }
    return abi;
}
function parseParamType(type) {
    return parseParam(type, true);
}
exports.parseParamType = parseParamType;
// @TODO: Allow a second boolean to expose names
function formatParamType(paramType) {
    return getParamCoder(exports.defaultCoerceFunc, paramType).type;
}
exports.formatParamType = formatParamType;
// @TODO: Allow a second boolean to expose names and modifiers
function formatSignature(fragment) {
    return fragment.name + "(" + fragment.inputs.map(function(i) {
        return formatParamType(i);
    }).join(",") + ")";
}
exports.formatSignature = formatSignature;
function parseSignature(fragment) {
    if (typeof fragment === "string") {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        fragment = fragment.replace(/\s/g, " ");
        fragment = fragment.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        fragment = fragment.trim();
        if (fragment.substring(0, 6) === "event ") return parseSignatureEvent(fragment.substring(6).trim());
        else {
            if (fragment.substring(0, 9) === "function ") fragment = fragment.substring(9);
            return parseSignatureFunction(fragment.trim());
        }
    }
    throw new Error("unknown signature");
}
exports.parseSignature = parseSignature;
var Coder = /** @class */ function() {
    function Coder(coerceFunc, name1, type, localName, dynamic) {
        this.coerceFunc = coerceFunc;
        this.name = name1;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    return Coder;
}();
// Clones the functionality of an existing Coder, but without a localName
var CoderAnonymous = /** @class */ function(_super) {
    __extends(CoderAnonymous, _super);
    function CoderAnonymous(coder) {
        var _this = _super.call(this, coder.coerceFunc, coder.name, coder.type, undefined, coder.dynamic) || this;
        properties_1.defineReadOnly(_this, "coder", coder);
        return _this;
    }
    CoderAnonymous.prototype.encode = function(value) {
        return this.coder.encode(value);
    };
    CoderAnonymous.prototype.decode = function(data, offset) {
        return this.coder.decode(data, offset);
    };
    return CoderAnonymous;
}(Coder);
var CoderNull = /** @class */ function(_super) {
    __extends(CoderNull, _super);
    function CoderNull(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "null", "", localName, false) || this;
    }
    CoderNull.prototype.encode = function(value) {
        return bytes_1.arrayify([]);
    };
    CoderNull.prototype.decode = function(data, offset) {
        if (offset > data.length) throw new Error("invalid null");
        return {
            consumed: 0,
            value: this.coerceFunc("null", undefined)
        };
    };
    return CoderNull;
}(Coder);
var CoderNumber = /** @class */ function(_super) {
    __extends(CoderNumber, _super);
    function CoderNumber(coerceFunc, size, signed, localName) {
        var _this = this;
        var name1 = (signed ? "int" : "uint") + size * 8;
        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
        _this.size = size;
        _this.signed = signed;
        return _this;
    }
    CoderNumber.prototype.encode = function(value) {
        try {
            var v = bignumber_1.bigNumberify(value);
            if (this.signed) {
                var bounds = constants_1.MaxUint256.maskn(this.size * 8 - 1);
                if (v.gt(bounds)) throw new Error("out-of-bounds");
                bounds = bounds.add(constants_1.One).mul(constants_1.NegativeOne);
                if (v.lt(bounds)) throw new Error("out-of-bounds");
            } else if (v.lt(constants_1.Zero) || v.gt(constants_1.MaxUint256.maskn(this.size * 8))) throw new Error("out-of-bounds");
            v = v.toTwos(this.size * 8).maskn(this.size * 8);
            if (this.signed) v = v.fromTwos(this.size * 8).toTwos(256);
            return bytes_1.padZeros(bytes_1.arrayify(v), 32);
        } catch (error) {
            errors.throwError("invalid number value", errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: this.name,
                value: value
            });
        }
        return null;
    };
    CoderNumber.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) errors.throwError("insufficient data for " + this.name + " type", errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: bytes_1.hexlify(data.slice(offset, offset + 32))
        });
        var junkLength = 32 - this.size;
        var value = bignumber_1.bigNumberify(data.slice(offset + junkLength, offset + 32));
        if (this.signed) value = value.fromTwos(this.size * 8);
        else value = value.maskn(this.size * 8);
        return {
            consumed: 32,
            value: this.coerceFunc(this.name, value)
        };
    };
    return CoderNumber;
}(Coder);
var uint256Coder = new CoderNumber(function(type, value) {
    return value;
}, 32, false, "none");
var CoderBoolean = /** @class */ function(_super) {
    __extends(CoderBoolean, _super);
    function CoderBoolean(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "bool", "bool", localName, false) || this;
    }
    CoderBoolean.prototype.encode = function(value) {
        return uint256Coder.encode(!!value ? 1 : 0);
    };
    CoderBoolean.prototype.decode = function(data, offset) {
        try {
            var result = uint256Coder.decode(data, offset);
        } catch (error) {
            if (error.reason === "insufficient data for uint256 type") errors.throwError("insufficient data for boolean type", errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "boolean",
                value: error.value
            });
            throw error;
        }
        return {
            consumed: result.consumed,
            value: this.coerceFunc("bool", !result.value.isZero())
        };
    };
    return CoderBoolean;
}(Coder);
var CoderFixedBytes = /** @class */ function(_super) {
    __extends(CoderFixedBytes, _super);
    function CoderFixedBytes(coerceFunc, length, localName) {
        var _this = this;
        var name1 = "bytes" + length;
        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
        _this.length = length;
        return _this;
    }
    CoderFixedBytes.prototype.encode = function(value) {
        var result = new Uint8Array(32);
        try {
            var data = bytes_1.arrayify(value);
            if (data.length !== this.length) throw new Error("incorrect data length");
            result.set(data);
        } catch (error) {
            errors.throwError("invalid " + this.name + " value", errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: this.name,
                value: error.value || value
            });
        }
        return result;
    };
    CoderFixedBytes.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) errors.throwError("insufficient data for " + name + " type", errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: bytes_1.hexlify(data.slice(offset, offset + 32))
        });
        return {
            consumed: 32,
            value: this.coerceFunc(this.name, bytes_1.hexlify(data.slice(offset, offset + this.length)))
        };
    };
    return CoderFixedBytes;
}(Coder);
var CoderAddress = /** @class */ function(_super) {
    __extends(CoderAddress, _super);
    function CoderAddress(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "address", "address", localName, false) || this;
    }
    CoderAddress.prototype.encode = function(value) {
        var result = new Uint8Array(32);
        try {
            result.set(bytes_1.arrayify(address_1.getAddress(value, false)), 12);
        } catch (error) {
            errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "address",
                value: value
            });
        }
        return result;
    };
    CoderAddress.prototype.decode = function(data, offset) {
        if (data.length < offset + 32) errors.throwError("insufficuent data for address type", errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "address",
            value: bytes_1.hexlify(data.slice(offset, offset + 32))
        });
        return {
            consumed: 32,
            value: this.coerceFunc("address", address_1.getAddress(bytes_1.hexlify(data.slice(offset + 12, offset + 32)), false))
        };
    };
    return CoderAddress;
}(Coder);
function _encodeDynamicBytes(value) {
    var dataLength = 32 * Math.ceil(value.length / 32);
    var padding = new Uint8Array(dataLength - value.length);
    return bytes_1.concat([
        uint256Coder.encode(value.length),
        value,
        padding
    ]);
}
function _decodeDynamicBytes(data, offset, localName) {
    if (data.length < offset + 32) errors.throwError("insufficient data for dynamicBytes length", errors.INVALID_ARGUMENT, {
        arg: localName,
        coderType: "dynamicBytes",
        value: bytes_1.hexlify(data.slice(offset, offset + 32))
    });
    var length = uint256Coder.decode(data, offset).value;
    try {
        length = length.toNumber();
    } catch (error) {
        errors.throwError("dynamic bytes count too large", errors.INVALID_ARGUMENT, {
            arg: localName,
            coderType: "dynamicBytes",
            value: length.toString()
        });
    }
    if (data.length < offset + 32 + length) errors.throwError("insufficient data for dynamicBytes type", errors.INVALID_ARGUMENT, {
        arg: localName,
        coderType: "dynamicBytes",
        value: bytes_1.hexlify(data.slice(offset, offset + 32 + length))
    });
    return {
        consumed: 32 + 32 * Math.ceil(length / 32),
        value: data.slice(offset + 32, offset + 32 + length)
    };
}
var CoderDynamicBytes = /** @class */ function(_super) {
    __extends(CoderDynamicBytes, _super);
    function CoderDynamicBytes(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "bytes", "bytes", localName, true) || this;
    }
    CoderDynamicBytes.prototype.encode = function(value) {
        try {
            return _encodeDynamicBytes(bytes_1.arrayify(value));
        } catch (error) {
            errors.throwError("invalid bytes value", errors.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "bytes",
                value: error.value
            });
        }
        return null;
    };
    CoderDynamicBytes.prototype.decode = function(data, offset) {
        var result = _decodeDynamicBytes(data, offset, this.localName);
        result.value = this.coerceFunc("bytes", bytes_1.hexlify(result.value));
        return result;
    };
    return CoderDynamicBytes;
}(Coder);
var CoderString = /** @class */ function(_super) {
    __extends(CoderString, _super);
    function CoderString(coerceFunc, localName) {
        return _super.call(this, coerceFunc, "string", "string", localName, true) || this;
    }
    CoderString.prototype.encode = function(value) {
        if (typeof value !== "string") errors.throwError("invalid string value", errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "string",
            value: value
        });
        return _encodeDynamicBytes(utf8_1.toUtf8Bytes(value));
    };
    CoderString.prototype.decode = function(data, offset) {
        var result = _decodeDynamicBytes(data, offset, this.localName);
        result.value = this.coerceFunc("string", utf8_1.toUtf8String(result.value));
        return result;
    };
    return CoderString;
}(Coder);
function alignSize(size) {
    return 32 * Math.ceil(size / 32);
}
function pack(coders, values) {
    if (Array.isArray(values)) ;
    else if (values && typeof values === "object") {
        var arrayValues = [];
        coders.forEach(function(coder) {
            arrayValues.push(values[coder.localName]);
        });
        values = arrayValues;
    } else errors.throwError("invalid tuple value", errors.INVALID_ARGUMENT, {
        coderType: "tuple",
        value: values
    });
    if (coders.length !== values.length) errors.throwError("types/value length mismatch", errors.INVALID_ARGUMENT, {
        coderType: "tuple",
        value: values
    });
    var parts = [];
    coders.forEach(function(coder, index) {
        parts.push({
            dynamic: coder.dynamic,
            value: coder.encode(values[index])
        });
    });
    var staticSize = 0, dynamicSize = 0;
    parts.forEach(function(part) {
        if (part.dynamic) {
            staticSize += 32;
            dynamicSize += alignSize(part.value.length);
        } else staticSize += alignSize(part.value.length);
    });
    var offset = 0, dynamicOffset = staticSize;
    var data = new Uint8Array(staticSize + dynamicSize);
    parts.forEach(function(part) {
        if (part.dynamic) {
            //uint256Coder.encode(dynamicOffset).copy(data, offset);
            data.set(uint256Coder.encode(dynamicOffset), offset);
            offset += 32;
            //part.value.copy(data, dynamicOffset);  @TODO
            data.set(part.value, dynamicOffset);
            dynamicOffset += alignSize(part.value.length);
        } else {
            //part.value.copy(data, offset);  @TODO
            data.set(part.value, offset);
            offset += alignSize(part.value.length);
        }
    });
    return data;
}
function unpack(coders, data, offset) {
    var baseOffset = offset;
    var consumed = 0;
    var value = [];
    coders.forEach(function(coder) {
        if (coder.dynamic) {
            var dynamicOffset = uint256Coder.decode(data, offset);
            var result = coder.decode(data, baseOffset + dynamicOffset.value.toNumber());
            // The dynamic part is leap-frogged somewhere else; doesn't count towards size
            result.consumed = dynamicOffset.consumed;
        } else var result = coder.decode(data, offset);
        if (result.value != undefined) value.push(result.value);
        offset += result.consumed;
        consumed += result.consumed;
    });
    coders.forEach(function(coder, index) {
        var name1 = coder.localName;
        if (!name1) return;
        if (name1 === "length") name1 = "_length";
        if (value[name1] != null) return;
        value[name1] = value[index];
    });
    return {
        value: value,
        consumed: consumed
    };
}
var CoderArray = /** @class */ function(_super) {
    __extends(CoderArray, _super);
    function CoderArray(coerceFunc, coder, length, localName) {
        var _this = this;
        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        var dynamic = length === -1 || coder.dynamic;
        _this = _super.call(this, coerceFunc, "array", type, localName, dynamic) || this;
        _this.coder = coder;
        _this.length = length;
        return _this;
    }
    CoderArray.prototype.encode = function(value) {
        if (!Array.isArray(value)) errors.throwError("expected array value", errors.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "array",
            value: value
        });
        var count = this.length;
        var result = new Uint8Array(0);
        if (count === -1) {
            count = value.length;
            result = uint256Coder.encode(count);
        }
        errors.checkArgumentCount(count, value.length, " in coder array" + (this.localName ? " " + this.localName : ""));
        var coders = [];
        for(var i = 0; i < value.length; i++)coders.push(this.coder);
        return bytes_1.concat([
            result,
            pack(coders, value)
        ]);
    };
    CoderArray.prototype.decode = function(data, offset) {
        // @TODO:
        //if (data.length < offset + length * 32) { throw new Error('invalid array'); }
        var consumed = 0;
        var count = this.length;
        if (count === -1) {
            try {
                var decodedLength = uint256Coder.decode(data, offset);
            } catch (error) {
                errors.throwError("insufficient data for dynamic array length", errors.INVALID_ARGUMENT, {
                    arg: this.localName,
                    coderType: "array",
                    value: error.value
                });
            }
            try {
                count = decodedLength.value.toNumber();
            } catch (error) {
                errors.throwError("array count too large", errors.INVALID_ARGUMENT, {
                    arg: this.localName,
                    coderType: "array",
                    value: decodedLength.value.toString()
                });
            }
            consumed += decodedLength.consumed;
            offset += decodedLength.consumed;
        }
        var coders = [];
        for(var i = 0; i < count; i++)coders.push(new CoderAnonymous(this.coder));
        var result = unpack(coders, data, offset);
        result.consumed += consumed;
        result.value = this.coerceFunc(this.type, result.value);
        return result;
    };
    return CoderArray;
}(Coder);
var CoderTuple = /** @class */ function(_super) {
    __extends(CoderTuple, _super);
    function CoderTuple(coerceFunc, coders, localName) {
        var _this = this;
        var dynamic = false;
        var types = [];
        coders.forEach(function(coder) {
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        var type = "tuple(" + types.join(",") + ")";
        _this = _super.call(this, coerceFunc, "tuple", type, localName, dynamic) || this;
        _this.coders = coders;
        return _this;
    }
    CoderTuple.prototype.encode = function(value) {
        return pack(this.coders, value);
    };
    CoderTuple.prototype.decode = function(data, offset) {
        var result = unpack(this.coders, data, offset);
        result.value = this.coerceFunc(this.type, result.value);
        return result;
    };
    return CoderTuple;
}(Coder);
/*
function getTypes(coders) {
    var type = coderTuple(coders).type;
    return type.substring(6, type.length - 1);
}
*/ function splitNesting(value) {
    value = value.trim();
    var result = [];
    var accum = "";
    var depth = 0;
    for(var offset = 0; offset < value.length; offset++){
        var c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) throw new Error("unbalanced parenthsis");
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}
// @TODO: Is there a way to return "class"?
var paramTypeSimple = {
    address: CoderAddress,
    bool: CoderBoolean,
    string: CoderString,
    bytes: CoderDynamicBytes
};
function getTupleParamCoder(coerceFunc, components, localName) {
    if (!components) components = [];
    var coders = [];
    components.forEach(function(component) {
        coders.push(getParamCoder(coerceFunc, component));
    });
    return new CoderTuple(coerceFunc, coders, localName);
}
function getParamCoder(coerceFunc, param) {
    var coder = paramTypeSimple[param.type];
    if (coder) return new coder(coerceFunc, param.name);
    var match = param.type.match(paramTypeNumber);
    if (match) {
        var size = parseInt(match[2] || "256");
        if (size === 0 || size > 256 || size % 8 !== 0) errors.throwError("invalid " + match[1] + " bit length", errors.INVALID_ARGUMENT, {
            arg: "param",
            value: param
        });
        return new CoderNumber(coerceFunc, size / 8, match[1] === "int", param.name);
    }
    var match = param.type.match(paramTypeBytes);
    if (match) {
        var size = parseInt(match[1]);
        if (size === 0 || size > 32) errors.throwError("invalid bytes length", errors.INVALID_ARGUMENT, {
            arg: "param",
            value: param
        });
        return new CoderFixedBytes(coerceFunc, size, param.name);
    }
    var match = param.type.match(paramTypeArray);
    if (match) {
        var size = parseInt(match[2] || "-1");
        param = properties_1.shallowCopy(param);
        param.type = match[1];
        param = properties_1.deepCopy(param);
        return new CoderArray(coerceFunc, getParamCoder(coerceFunc, param), size, param.name);
    }
    if (param.type.substring(0, 5) === "tuple") return getTupleParamCoder(coerceFunc, param.components, param.name);
    if (param.type === "") return new CoderNull(coerceFunc, param.name);
    errors.throwError("invalid type", errors.INVALID_ARGUMENT, {
        arg: "type",
        value: param.type
    });
    return null;
}
var AbiCoder = /** @class */ function() {
    function AbiCoder(coerceFunc) {
        errors.checkNew(this, AbiCoder);
        if (!coerceFunc) coerceFunc = exports.defaultCoerceFunc;
        properties_1.defineReadOnly(this, "coerceFunc", coerceFunc);
    }
    AbiCoder.prototype.encode = function(types, values) {
        if (types.length !== values.length) errors.throwError("types/values length mismatch", errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        var coders = [];
        types.forEach(function(type) {
            // Convert types to type objects
            //   - "uint foo" => { type: "uint", name: "foo" }
            //   - "tuple(uint, uint)" => { type: "tuple", components: [ { type: "uint" }, { type: "uint" }, ] }
            var typeObject = null;
            if (typeof type === "string") typeObject = parseParam(type);
            else typeObject = type;
            coders.push(getParamCoder(this.coerceFunc, typeObject));
        }, this);
        return bytes_1.hexlify(new CoderTuple(this.coerceFunc, coders, "_").encode(values));
    };
    AbiCoder.prototype.decode = function(types, data) {
        var coders = [];
        types.forEach(function(type) {
            // See encode for details
            var typeObject = null;
            if (typeof type === "string") typeObject = parseParam(type);
            else typeObject = properties_1.deepCopy(type);
            coders.push(getParamCoder(this.coerceFunc, typeObject));
        }, this);
        return new CoderTuple(this.coerceFunc, coders, "_").decode(bytes_1.arrayify(data), 0).value;
    };
    return AbiCoder;
}();
exports.AbiCoder = AbiCoder;
exports.defaultAbiCoder = new AbiCoder();

},{"112150acf194fb49":"aUeOF","80fc9a0766c65078":"ljnPX","991646637eabc8cf":"73HJd","8c5bece05f5a985":"8K78M","fe53351f3408b6a8":"71FSg","b0d7108503806e5b":"IsaAt","95240faf46789f0c":"f68LV"}],"aUeOF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bignumber_1 = require("383e20cb66e2155f");
var AddressZero = "0x0000000000000000000000000000000000000000";
exports.AddressZero = AddressZero;
var HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
exports.HashZero = HashZero;
// NFKD (decomposed)
//const EtherSymbol = '\uD835\uDF63';
// NFKC (composed)
var EtherSymbol = "\u039E";
exports.EtherSymbol = EtherSymbol;
var NegativeOne = bignumber_1.bigNumberify(-1);
exports.NegativeOne = NegativeOne;
var Zero = bignumber_1.bigNumberify(0);
exports.Zero = Zero;
var One = bignumber_1.bigNumberify(1);
exports.One = One;
var Two = bignumber_1.bigNumberify(2);
exports.Two = Two;
var WeiPerEther = bignumber_1.bigNumberify("1000000000000000000");
exports.WeiPerEther = WeiPerEther;
var MaxUint256 = bignumber_1.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
exports.MaxUint256 = MaxUint256;

},{"383e20cb66e2155f":"8K78M"}],"8K78M":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardles.
 *
 */ var bn_js_1 = __importDefault(require("2853447d8d6592fe"));
var bytes_1 = require("b3d2c1cb52c262e0");
var properties_1 = require("ac9e71bff646da39");
var errors = __importStar(require("9f9599db983c2aa3"));
var BN_1 = new bn_js_1.default.BN(-1);
function toHex(bn) {
    var value = bn.toString(16);
    if (value[0] === "-") {
        if (value.length % 2 === 0) return "-0x0" + value.substring(1);
        return "-0x" + value.substring(1);
    }
    if (value.length % 2 === 1) return "0x0" + value;
    return "0x" + value;
}
function toBN(value) {
    return _bnify(bigNumberify(value));
}
function toBigNumber(bn) {
    return new BigNumber(toHex(bn));
}
function _bnify(value) {
    var hex = value._hex;
    if (hex[0] === "-") return new bn_js_1.default.BN(hex.substring(3), 16).mul(BN_1);
    return new bn_js_1.default.BN(hex.substring(2), 16);
}
var BigNumber = /** @class */ function() {
    function BigNumber(value) {
        errors.checkNew(this, BigNumber);
        properties_1.setType(this, "BigNumber");
        if (typeof value === "string") {
            if (bytes_1.isHexString(value)) {
                if (value == "0x") value = "0x0";
                properties_1.defineReadOnly(this, "_hex", value);
            } else if (value[0] === "-" && bytes_1.isHexString(value.substring(1))) properties_1.defineReadOnly(this, "_hex", value);
            else if (value.match(/^-?[0-9]*$/)) {
                if (value == "") value = "0";
                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
            } else errors.throwError("invalid BigNumber string value", errors.INVALID_ARGUMENT, {
                arg: "value",
                value: value
            });
        } else if (typeof value === "number") {
            if (parseInt(String(value)) !== value) errors.throwError("underflow", errors.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "underflow",
                value: value,
                outputValue: parseInt(String(value))
            });
            try {
                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
            } catch (error) {
                errors.throwError("overflow", errors.NUMERIC_FAULT, {
                    operation: "setValue",
                    fault: "overflow",
                    details: error.message
                });
            }
        } else if (value instanceof BigNumber) properties_1.defineReadOnly(this, "_hex", value._hex);
        else if (value.toHexString) properties_1.defineReadOnly(this, "_hex", toHex(toBN(value.toHexString())));
        else if (value._hex && bytes_1.isHexString(value._hex)) properties_1.defineReadOnly(this, "_hex", value._hex);
        else if (bytes_1.isArrayish(value)) properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(bytes_1.hexlify(value).substring(2), 16)));
        else errors.throwError("invalid BigNumber value", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
    }
    BigNumber.prototype.fromTwos = function(value) {
        return toBigNumber(_bnify(this).fromTwos(value));
    };
    BigNumber.prototype.toTwos = function(value) {
        return toBigNumber(_bnify(this).toTwos(value));
    };
    BigNumber.prototype.abs = function() {
        if (this._hex[0] === "-") return toBigNumber(_bnify(this).mul(BN_1));
        return this;
    };
    BigNumber.prototype.add = function(other) {
        return toBigNumber(_bnify(this).add(toBN(other)));
    };
    BigNumber.prototype.sub = function(other) {
        return toBigNumber(_bnify(this).sub(toBN(other)));
    };
    BigNumber.prototype.div = function(other) {
        var o = bigNumberify(other);
        if (o.isZero()) errors.throwError("division by zero", errors.NUMERIC_FAULT, {
            operation: "divide",
            fault: "division by zero"
        });
        return toBigNumber(_bnify(this).div(toBN(other)));
    };
    BigNumber.prototype.mul = function(other) {
        return toBigNumber(_bnify(this).mul(toBN(other)));
    };
    BigNumber.prototype.mod = function(other) {
        return toBigNumber(_bnify(this).mod(toBN(other)));
    };
    BigNumber.prototype.pow = function(other) {
        return toBigNumber(_bnify(this).pow(toBN(other)));
    };
    BigNumber.prototype.maskn = function(value) {
        return toBigNumber(_bnify(this).maskn(value));
    };
    BigNumber.prototype.eq = function(other) {
        return _bnify(this).eq(toBN(other));
    };
    BigNumber.prototype.lt = function(other) {
        return _bnify(this).lt(toBN(other));
    };
    BigNumber.prototype.lte = function(other) {
        return _bnify(this).lte(toBN(other));
    };
    BigNumber.prototype.gt = function(other) {
        return _bnify(this).gt(toBN(other));
    };
    BigNumber.prototype.gte = function(other) {
        return _bnify(this).gte(toBN(other));
    };
    BigNumber.prototype.isZero = function() {
        return _bnify(this).isZero();
    };
    BigNumber.prototype.toNumber = function() {
        try {
            return _bnify(this).toNumber();
        } catch (error) {
            errors.throwError("overflow", errors.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "overflow",
                details: error.message
            });
        }
        return null;
    };
    BigNumber.prototype.toString = function() {
        return _bnify(this).toString(10);
    };
    BigNumber.prototype.toHexString = function() {
        return this._hex;
    };
    BigNumber.isBigNumber = function(value) {
        return properties_1.isType(value, "BigNumber");
    };
    return BigNumber;
}();
exports.BigNumber = BigNumber;
function bigNumberify(value) {
    if (BigNumber.isBigNumber(value)) return value;
    return new BigNumber(value);
}
exports.bigNumberify = bigNumberify;

},{"2853447d8d6592fe":"6B2Jb","b3d2c1cb52c262e0":"71FSg","ac9e71bff646da39":"f68LV","9f9599db983c2aa3":"ljnPX"}],"6B2Jb":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("f2e43379f32b5f4").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"f2e43379f32b5f4":"13Pcp"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"71FSg":[function(require,module,exports) {
"use strict";
/**
 *  Conversion Utilities
 *
 */ var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var errors = __importStar(require("aa8b49dc670afbe6"));
///////////////////////////////
function isHexable(value) {
    return !!value.toHexString;
}
exports.isHexable = isHexable;
function addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        var args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isArrayish(value) {
    if (!value || parseInt(String(value.length)) != value.length || typeof value === "string") return false;
    for(var i = 0; i < value.length; i++){
        var v = value[i];
        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
    }
    return true;
}
exports.isArrayish = isArrayish;
function arrayify(value) {
    if (value == null) errors.throwError("cannot convert null value to array", errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    if (isHexable(value)) value = value.toHexString();
    if (typeof value === "string") {
        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        value = value.substring(2);
        if (value.length % 2) value = "0" + value;
        var result = [];
        for(var i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
        return addSlice(new Uint8Array(result));
    }
    if (isArrayish(value)) return addSlice(new Uint8Array(value));
    errors.throwError("invalid arrayify value", null, {
        arg: "value",
        value: value,
        type: typeof value
    });
    return null;
}
exports.arrayify = arrayify;
function concat(objects) {
    var arrays = [];
    var length = 0;
    for(var i = 0; i < objects.length; i++){
        var object = arrayify(objects[i]);
        arrays.push(object);
        length += object.length;
    }
    var result = new Uint8Array(length);
    var offset = 0;
    for(var i = 0; i < arrays.length; i++){
        result.set(arrays[i], offset);
        offset += arrays[i].length;
    }
    return addSlice(result);
}
exports.concat = concat;
function stripZeros(value) {
    var result = arrayify(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    var start = 0;
    while(result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
exports.stripZeros = stripZeros;
function padZeros(value, length) {
    value = arrayify(value);
    if (length < value.length) throw new Error("cannot pad");
    var result = new Uint8Array(length);
    result.set(value, length - value.length);
    return addSlice(result);
}
exports.padZeros = padZeros;
function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
exports.isHexString = isHexString;
var HexCharacters = "0123456789abcdef";
function hexlify(value) {
    if (isHexable(value)) return value.toHexString();
    if (typeof value === "number") {
        if (value < 0) errors.throwError("cannot hexlify negative value", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        // @TODO: Roll this into the above error as a numeric fault (overflow); next version, not backward compatible
        // We can about (value == MAX_INT) to as well, since that may indicate we underflowed already
        if (value >= 9007199254740991) errors.throwError("out-of-range", errors.NUMERIC_FAULT, {
            operartion: "hexlify",
            fault: "out-of-safe-range"
        });
        var hex = "";
        while(value){
            hex = HexCharacters[value & 0x0f] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "string") {
        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
            arg: "value",
            value: value
        });
        if (value.length % 2) value = "0x0" + value.substring(2);
        return value;
    }
    if (isArrayish(value)) {
        var result = [];
        for(var i = 0; i < value.length; i++){
            var v = value[i];
            result.push(HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f]);
        }
        return "0x" + result.join("");
    }
    errors.throwError("invalid hexlify value", null, {
        arg: "value",
        value: value
    });
    return "never";
}
exports.hexlify = hexlify;
function hexDataLength(data) {
    if (!isHexString(data) || data.length % 2 !== 0) return null;
    return (data.length - 2) / 2;
}
exports.hexDataLength = hexDataLength;
function hexDataSlice(data, offset, endOffset) {
    if (!isHexString(data)) errors.throwError("invalid hex data", errors.INVALID_ARGUMENT, {
        arg: "value",
        value: data
    });
    if (data.length % 2 !== 0) errors.throwError("hex data length must be even", errors.INVALID_ARGUMENT, {
        arg: "value",
        value: data
    });
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
exports.hexDataSlice = hexDataSlice;
function hexStripZeros(value) {
    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    while(value.length > 3 && value.substring(0, 3) === "0x0")value = "0x" + value.substring(3);
    return value;
}
exports.hexStripZeros = hexStripZeros;
function hexZeroPad(value, length) {
    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
        arg: "value",
        value: value
    });
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
exports.hexZeroPad = hexZeroPad;
function isSignature(value) {
    return value && value.r != null && value.s != null;
}
function splitSignature(signature) {
    var v = 0;
    var r = "0x", s = "0x";
    if (isSignature(signature)) {
        if (signature.v == null && signature.recoveryParam == null) errors.throwError("at least on of recoveryParam or v must be specified", errors.INVALID_ARGUMENT, {
            argument: "signature",
            value: signature
        });
        r = hexZeroPad(signature.r, 32);
        s = hexZeroPad(signature.s, 32);
        v = signature.v;
        if (typeof v === "string") v = parseInt(v, 16);
        var recoveryParam = signature.recoveryParam;
        if (recoveryParam == null && signature.v != null) recoveryParam = 1 - v % 2;
        v = 27 + recoveryParam;
    } else {
        var bytes = arrayify(signature);
        if (bytes.length !== 65) throw new Error("invalid signature");
        r = hexlify(bytes.slice(0, 32));
        s = hexlify(bytes.slice(32, 64));
        v = bytes[64];
        if (v !== 27 && v !== 28) v = 27 + v % 2;
    }
    return {
        r: r,
        s: s,
        recoveryParam: v - 27,
        v: v
    };
}
exports.splitSignature = splitSignature;
function joinSignature(signature) {
    signature = splitSignature(signature);
    return hexlify(concat([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}
exports.joinSignature = joinSignature;

},{"aa8b49dc670afbe6":"ljnPX"}],"ljnPX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _version_1 = require("e9e573e117ca381f");
// Unknown Error
exports.UNKNOWN_ERROR = "UNKNOWN_ERROR";
// Not implemented
exports.NOT_IMPLEMENTED = "NOT_IMPLEMENTED";
// Missing new operator to an object
//  - name: The name of the class
exports.MISSING_NEW = "MISSING_NEW";
// Call exception
//  - transaction: the transaction
//  - address?: the contract address
//  - args?: The arguments passed into the function
//  - method?: The Solidity method signature
//  - errorSignature?: The EIP848 error signature
//  - errorArgs?: The EIP848 error parameters
//  - reason: The reason (only for EIP848 "Error(string)")
exports.CALL_EXCEPTION = "CALL_EXCEPTION";
// Invalid argument (e.g. value is incompatible with type) to a function:
//   - argument: The argument name that was invalid
//   - value: The value of the argument
exports.INVALID_ARGUMENT = "INVALID_ARGUMENT";
// Missing argument to a function:
//   - count: The number of arguments received
//   - expectedCount: The number of arguments expected
exports.MISSING_ARGUMENT = "MISSING_ARGUMENT";
// Too many arguments
//   - count: The number of arguments received
//   - expectedCount: The number of arguments expected
exports.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT";
// Numeric Fault
//   - operation: the operation being executed
//   - fault: the reason this faulted
exports.NUMERIC_FAULT = "NUMERIC_FAULT";
// Insufficien funds (< value + gasLimit * gasPrice)
//   - transaction: the transaction attempted
exports.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS";
// Nonce has already been used
//   - transaction: the transaction attempted
exports.NONCE_EXPIRED = "NONCE_EXPIRED";
// The replacement fee for the transaction is too low
//   - transaction: the transaction attempted
exports.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
// Unsupported operation
//   - operation
exports.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION";
var _permanentCensorErrors = false;
var _censorErrors = false;
// @TODO: Enum
function throwError(message, code, params) {
    if (_censorErrors) throw new Error("unknown error");
    if (!code) code = exports.UNKNOWN_ERROR;
    if (!params) params = {};
    var messageDetails = [];
    Object.keys(params).forEach(function(key) {
        try {
            messageDetails.push(key + "=" + JSON.stringify(params[key]));
        } catch (error) {
            messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
        }
    });
    messageDetails.push("version=" + _version_1.version);
    var reason = message;
    if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
    // @TODO: Any??
    var error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function(key) {
        error[key] = params[key];
    });
    throw error;
}
exports.throwError = throwError;
function checkNew(self, kind) {
    if (!(self instanceof kind)) throwError("missing new", exports.MISSING_NEW, {
        name: kind.name
    });
}
exports.checkNew = checkNew;
function checkArgumentCount(count, expectedCount, suffix) {
    if (!suffix) suffix = "";
    if (count < expectedCount) throwError("missing argument" + suffix, exports.MISSING_ARGUMENT, {
        count: count,
        expectedCount: expectedCount
    });
    if (count > expectedCount) throwError("too many arguments" + suffix, exports.UNEXPECTED_ARGUMENT, {
        count: count,
        expectedCount: expectedCount
    });
}
exports.checkArgumentCount = checkArgumentCount;
function setCensorship(censorship, permanent) {
    if (_permanentCensorErrors) throwError("error censorship permanent", exports.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
    });
    _censorErrors = !!censorship;
    _permanentCensorErrors = !!permanent;
}
exports.setCensorship = setCensorship;
function checkNormalize() {
    try {
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach(function(form) {
            try {
                "test".normalize(form);
            } catch (error) {
                throw new Error("missing " + form);
            }
        });
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        throwError("platform missing String.prototype.normalize", exports.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: error.message
        });
    }
}
exports.checkNormalize = checkNormalize;
var LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warn: 3,
    error: 4,
    off: 5
};
var LogLevel = LogLevels["default"];
function setLogLevel(logLevel) {
    var level = LogLevels[logLevel];
    if (level == null) {
        warn("invliad log level - " + logLevel);
        return;
    }
    LogLevel = level;
}
exports.setLogLevel = setLogLevel;
function log(logLevel, args) {
    if (LogLevel > LogLevels[logLevel]) return;
    console.log.apply(console, args);
}
function warn() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    log("warn", args);
}
exports.warn = warn;
function info() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    log("info", args);
}
exports.info = info;

},{"e9e573e117ca381f":"9Ctzj"}],"9Ctzj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = "4.0.27-5";

},{}],"f68LV":[function(require,module,exports) {
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var errors = __importStar(require("fe2dcf32286582e"));
function defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
exports.defineReadOnly = defineReadOnly;
// There are some issues with instanceof with npm link, so we use this
// to ensure types are what we expect.
function setType(object, type) {
    Object.defineProperty(object, "_ethersType", {
        configurable: false,
        value: type,
        writable: false
    });
}
exports.setType = setType;
function isType(object, type) {
    return object && object._ethersType === type;
}
exports.isType = isType;
function resolveProperties(object) {
    var result = {};
    var promises = [];
    Object.keys(object).forEach(function(key) {
        var value = object[key];
        if (value instanceof Promise) promises.push(value.then(function(value) {
            result[key] = value;
            return null;
        }));
        else result[key] = value;
    });
    return Promise.all(promises).then(function() {
        return result;
    });
}
exports.resolveProperties = resolveProperties;
function checkProperties(object, properties) {
    if (!object || typeof object !== "object") errors.throwError("invalid object", errors.INVALID_ARGUMENT, {
        argument: "object",
        value: object
    });
    Object.keys(object).forEach(function(key) {
        if (!properties[key]) errors.throwError("invalid object key - " + key, errors.INVALID_ARGUMENT, {
            argument: "transaction",
            value: object,
            key: key
        });
    });
}
exports.checkProperties = checkProperties;
function shallowCopy(object) {
    var result = {};
    for(var key in object)result[key] = object[key];
    return result;
}
exports.shallowCopy = shallowCopy;
var opaque = {
    boolean: true,
    number: true,
    string: true
};
function deepCopy(object, frozen) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof object]) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) {
        var result = object.map(function(item) {
            return deepCopy(item, frozen);
        });
        if (frozen) Object.freeze(result);
        return result;
    }
    if (typeof object === "object") {
        // Some internal objects, which are already immutable
        if (isType(object, "BigNumber")) return object;
        if (isType(object, "Description")) return object;
        if (isType(object, "Indexed")) return object;
        var result = {};
        for(var key in object){
            var value = object[key];
            if (value === undefined) continue;
            defineReadOnly(result, key, deepCopy(value, frozen));
        }
        if (frozen) Object.freeze(result);
        return result;
    }
    // The function type is also immutable, so safe to copy by assignment
    if (typeof object === "function") return object;
    throw new Error("Cannot deepCopy " + typeof object);
}
exports.deepCopy = deepCopy;
// See: https://github.com/isaacs/inherits/blob/master/inherits_browser.js
function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
function inheritable(parent) {
    return function(child) {
        inherits(child, parent);
        defineReadOnly(child, "inherits", inheritable(child));
    };
}
exports.inheritable = inheritable;

},{"fe2dcf32286582e":"ljnPX"}],"73HJd":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
// We use this for base 36 maths
var bn_js_1 = __importDefault(require("82961a1f57f0ca75"));
var bytes_1 = require("1b6fe8d3529185f8");
var keccak256_1 = require("9844576b241f91e");
var rlp_1 = require("7c4250c7548b2798");
var errors = require("f24e52db12af3d7f");
///////////////////////////////
function getChecksumAddress(address) {
    if (typeof address !== "string" || !address.match(/^0x[0-9A-Fa-f]{40}$/)) errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    address = address.toLowerCase();
    var chars = address.substring(2).split("");
    var hashed = new Uint8Array(40);
    for(var i_1 = 0; i_1 < 40; i_1++)hashed[i_1] = chars[i_1].charCodeAt(0);
    hashed = bytes_1.arrayify(keccak256_1.keccak256(hashed));
    for(var i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
var MAX_SAFE_INTEGER = 0x1fffffffffffff;
function log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
var ibanLookup = {};
for(var i = 0; i < 10; i++)ibanLookup[String(i)] = String(i);
for(var i = 0; i < 26; i++)ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
var safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    var expanded = "";
    address.split("").forEach(function(c) {
        expanded += ibanLookup[c];
    });
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= safeDigits){
        var block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    var checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function getAddress(address, checksum) {
    if (checksum === void 0) checksum = true;
    var result = null;
    if (typeof address !== "string") errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        if (checksum) {
            result = getChecksumAddress(address);
            // It is a checksummed address with a bad checksum
            if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) errors.throwError("bad address checksum", errors.INVALID_ARGUMENT, {
                arg: "address",
                value: address
            });
        } else result = address;
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum(address)) errors.throwError("bad icap checksum", errors.INVALID_ARGUMENT, {
            arg: "address",
            value: address
        });
        result = new bn_js_1.default.BN(address.substring(4), 36).toString(16);
        while(result.length < 40)result = "0" + result;
        result = checksum ? getChecksumAddress("0x" + result) : "0x" + result;
    } else errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
        arg: "address",
        value: address
    });
    return result;
}
exports.getAddress = getAddress;
function getIcapAddress(address) {
    var base36 = new bn_js_1.default.BN(getAddress(address).substring(2), 16).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + ibanChecksum("XE00" + base36) + base36;
}
exports.getIcapAddress = getIcapAddress;
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
function getContractAddress(transaction) {
    if (!transaction.from) throw new Error("missing from address");
    var nonce = transaction.nonce;
    return getAddress("0x" + keccak256_1.keccak256(rlp_1.encode([
        getAddress(transaction.from),
        bytes_1.stripZeros(bytes_1.hexlify(nonce))
    ])).substring(26));
}
exports.getContractAddress = getContractAddress;

},{"82961a1f57f0ca75":"6B2Jb","1b6fe8d3529185f8":"71FSg","9844576b241f91e":"g4rCo","7c4250c7548b2798":"a0JNu","f24e52db12af3d7f":"ljnPX"}],"g4rCo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var sha3 = require("f34b895e74a1c245");
var bytes_1 = require("d712941e1e8a927c");
function keccak256(data) {
    return "0x" + sha3.keccak_256(bytes_1.arrayify(data));
}
exports.keccak256 = keccak256;

},{"f34b895e74a1c245":"hqGBR","d712941e1e8a927c":"71FSg"}],"hqGBR":[function(require,module,exports) {
var process = require("5defb539e98cbde3");
var global = arguments[3];
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var root = typeof window === "object" ? window : {};
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array"
    ];
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(bits, padding, type);
        }
        return method;
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createShakeOutputMethod(bits, padding, type);
        }
        return method;
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        var notString = typeof message !== "string";
        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.finalize = function() {
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            if (extraBytes > 0) array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
})();

},{"5defb539e98cbde3":"5QIF0"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"a0JNu":[function(require,module,exports) {
"use strict";
//See: https://github.com/ethereum/wiki/wiki/RLP
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes_1 = require("1a614417e0c4bf6a");
function arrayifyInteger(value) {
    var result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function unarrayifyInteger(data, offset, length) {
    var result = 0;
    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        var payload = [];
        object.forEach(function(child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        var length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    var data = Array.prototype.slice.call(bytes_1.arrayify(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    var length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function encode(object) {
    return bytes_1.hexlify(_encode(object));
}
exports.encode = encode;
function _decodeChildren(data, offset, childOffset, length) {
    var result = [];
    while(childOffset < offset + 1 + length){
        var decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) throw new Error("invalid rlp");
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    if (data.length === 0) throw new Error("invalid rlp data");
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        var lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) throw new Error("too short");
        var length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) throw new Error("to short");
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        var length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) throw new Error("invalid rlp data");
        return _decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        var lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) throw new Error("invalid rlp data");
        var length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) throw new Error("invalid rlp data");
        var result = bytes_1.hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        var length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) throw new Error("invlaid rlp data");
        var result = bytes_1.hexlify(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: bytes_1.hexlify(data[offset])
    };
}
function decode(data) {
    var bytes = bytes_1.arrayify(data);
    var decoded = _decode(bytes, 0);
    if (decoded.consumed !== bytes.length) throw new Error("invalid rlp data");
    return decoded.result;
}
exports.decode = decode;

},{"1a614417e0c4bf6a":"71FSg"}],"IsaAt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var constants_1 = require("a09a72bca93cc7eb");
var errors_1 = require("a948c3e4024791a5");
var bytes_1 = require("dd9b3d044837fdaf");
///////////////////////////////
var UnicodeNormalizationForm;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})(UnicodeNormalizationForm = exports.UnicodeNormalizationForm || (exports.UnicodeNormalizationForm = {}));
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function toUtf8Bytes(str, form) {
    if (form === void 0) form = UnicodeNormalizationForm.current;
    if (form != UnicodeNormalizationForm.current) {
        errors_1.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(c >> 18 | 0xf0);
            result.push(c >> 12 & 0x3f | 0x80);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return bytes_1.arrayify(result);
}
exports.toUtf8Bytes = toUtf8Bytes;
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function toUtf8String(bytes, ignoreErrors) {
    bytes = bytes_1.arrayify(bytes);
    var result = "";
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result += String.fromCharCode(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if (!ignoreErrors) {
                if ((c & 0xc0) === 0x80) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                throw new Error("invalid utf8 byte sequence; invalid prefix");
            }
            continue;
        }
        // Do we have enough bytes in our data?
        if (i + extraLength > bytes.length) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; too short");
            // If there is an invalid unprocessed byte, skip continuation bytes
            for(; i < bytes.length; i++){
                if (bytes[i] >> 6 !== 0x02) break;
            }
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        if (res === null) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
            continue;
        }
        // Check for overlong seuences (more bytes than needed)
        if (res <= overlongMask) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; overlong");
            continue;
        }
        // Maximum code point
        if (res > 0x10ffff) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; out-of-range");
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
            continue;
        }
        if (res <= 0xffff) {
            result += String.fromCharCode(res);
            continue;
        }
        res -= 0x10000;
        result += String.fromCharCode((res >> 10 & 0x3ff) + 0xd800, (res & 0x3ff) + 0xdc00);
    }
    return result;
}
exports.toUtf8String = toUtf8String;
function formatBytes32String(text) {
    // Get the bytes
    var bytes = toUtf8Bytes(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return bytes_1.hexlify(bytes_1.concat([
        bytes,
        constants_1.HashZero
    ]).slice(0, 32));
}
exports.formatBytes32String = formatBytes32String;
function parseBytes32String(bytes) {
    var data = bytes_1.arrayify(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 sdtring - no null terminator");
    // Find the null termination
    var length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return toUtf8String(data.slice(0, length));
}
exports.parseBytes32String = parseBytes32String;

},{"a09a72bca93cc7eb":"aUeOF","a948c3e4024791a5":"ljnPX","dd9b3d044837fdaf":"71FSg"}],"9LyYR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * computes keccak256 hash of given data
 * @param data one or more Buffer | string
 */ parcelHelpers.export(exports, "keccak256", ()=>keccak256);
var _jsSha3 = require("js-sha3");
var Buffer = require("3ce2eadddf187361").Buffer;
function keccak256(...data) {
    const h = (0, _jsSha3.keccak_256).create();
    data.forEach((d)=>{
        if (Buffer.isBuffer(d)) h.update(d);
        else h.update(Buffer.from(d, "utf8"));
    });
    return Buffer.from(h.digest());
}

},{"3ce2eadddf187361":"l5Twm","js-sha3":"hqGBR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"hRsQk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Transaction class defines VeChainThor's multi-clause transaction */ parcelHelpers.export(exports, "Transaction", ()=>Transaction);
var _address = require("./address");
var _blake2B = require("./blake2b");
var _rlp = require("./rlp");
var _secp256K1 = require("./secp256k1");
var Buffer = require("4fd4672cbe1dd13").Buffer;
class Transaction {
    /**
     * construct a transaction object with given body
     * @param body body of tx
     */ constructor(body){
        this.body = Object.assign({}, body);
    }
    /** decode from Buffer to transaction
     * @param raw encoded buffer
     * @param unsigned to indicator if the encoded buffer contains signature
     */ static decode(raw, unsigned) {
        let body;
        let signature;
        if (unsigned) body = unsignedTxRLP.decode(raw);
        else {
            const decoded = txRLP.decode(raw);
            signature = decoded.signature;
            delete decoded.signature;
            body = decoded;
        }
        const reserved = body.reserved;
        if (reserved.length > 0) {
            if (reserved[reserved.length - 1].length === 0) throw new Error("invalid reserved fields: not trimmed");
            const features = featuresKind.buffer(reserved[0], "reserved.features").decode();
            body.reserved = {
                features
            };
            if (reserved.length > 1) body.reserved.unused = reserved.slice(1);
        } else delete body.reserved;
        const tx = new Transaction(body);
        if (signature) tx.signature = signature;
        return tx;
    }
    /**
     * returns transaction ID
     * null returned if something wrong (e.g. invalid signature)
     */ get id() {
        if (!this._signatureValid) return null;
        try {
            const signingHash = this.signingHash();
            const pubKey = (0, _secp256K1.secp256k1).recover(signingHash, this.signature.slice(0, 65));
            const origin = (0, _address.address).fromPublicKey(pubKey);
            return "0x" + (0, _blake2B.blake2b256)(signingHash, Buffer.from(origin.slice(2), "hex")).toString("hex");
        } catch (_a) {
            return null;
        }
    }
    /**
     * compute signing hashes.
     * It returns tx hash for origin or delegator depends on param `delegateFor`.
     * @param delegateFor address of intended tx origin. If set, the returned hash is for delegator to sign.
     */ signingHash(delegateFor) {
        const reserved = this._encodeReserved();
        const buf = unsignedTxRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved
        }));
        const hash = (0, _blake2B.blake2b256)(buf);
        if (delegateFor) {
            if (!/^0x[0-9a-f]{40}$/i.test(delegateFor)) throw new Error("delegateFor expected address");
            return (0, _blake2B.blake2b256)(hash, Buffer.from(delegateFor.slice(2), "hex"));
        }
        return hash;
    }
    /** returns tx origin. null returned if no signature or not incorrectly signed */ get origin() {
        if (!this._signatureValid) return null;
        try {
            const signingHash = this.signingHash();
            const pubKey = (0, _secp256K1.secp256k1).recover(signingHash, this.signature.slice(0, 65));
            return (0, _address.address).fromPublicKey(pubKey);
        } catch (_a) {
            return null;
        }
    }
    /** returns tx delegator. null returned if no signature or not incorrectly signed */ get delegator() {
        if (!this.delegated) return null;
        if (!this._signatureValid) return null;
        const origin = this.origin;
        if (!origin) return null;
        try {
            const signingHash = this.signingHash(origin);
            const pubKey = (0, _secp256K1.secp256k1).recover(signingHash, this.signature.slice(65));
            return (0, _address.address).fromPublicKey(pubKey);
        } catch (_a) {
            return null;
        }
    }
    /** returns whether delegated. see https://github.com/vechain/VIPs/blob/master/vips/VIP-191.md */ get delegated() {
        // tslint:disable-next-line:no-bitwise
        return (((this.body.reserved || {}).features || 0) & Transaction.DELEGATED_MASK) === Transaction.DELEGATED_MASK;
    }
    /** returns intrinsic gas it takes */ get intrinsicGas() {
        return Transaction.intrinsicGas(this.body.clauses);
    }
    /** encode into Buffer */ encode() {
        const reserved = this._encodeReserved();
        if (this.signature) return txRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved,
            signature: this.signature
        }));
        return unsignedTxRLP.encode(Object.assign(Object.assign({}, this.body), {
            reserved
        }));
    }
    _encodeReserved() {
        const reserved = this.body.reserved || {};
        const list = [
            featuresKind.data(reserved.features || 0, "reserved.features").encode(),
            ...reserved.unused || []
        ];
        // trim
        while(list.length > 0){
            if (list[list.length - 1].length === 0) list.pop();
            else break;
        }
        return list;
    }
    get _signatureValid() {
        const expectedSigLen = this.delegated ? 130 : 65;
        return this.signature ? this.signature.length === expectedSigLen : false;
    }
}
Transaction.DELEGATED_MASK = 1;
(function(Transaction) {
    /**
     * calculates intrinsic gas that a tx costs with the given clauses.
     * @param clauses
     */ function intrinsicGas(clauses) {
        const txGas = 5000;
        const clauseGas = 16000;
        const clauseGasContractCreation = 48000;
        if (clauses.length === 0) return txGas + clauseGas;
        return clauses.reduce((sum, c)=>{
            if (c.to) sum += clauseGas;
            else sum += clauseGasContractCreation;
            sum += dataGas(c.data);
            return sum;
        }, txGas);
    }
    Transaction.intrinsicGas = intrinsicGas;
    function dataGas(data) {
        const zgas = 4;
        const nzgas = 68;
        let sum = 0;
        for(let i = 2; i < data.length; i += 2)if (data.substr(i, 2) === "00") sum += zgas;
        else sum += nzgas;
        return sum;
    }
})(Transaction || (Transaction = {}));
const unsignedTxRLP = new (0, _rlp.RLP)({
    name: "tx",
    kind: [
        {
            name: "chainTag",
            kind: new (0, _rlp.RLP).NumericKind(1)
        },
        {
            name: "blockRef",
            kind: new (0, _rlp.RLP).CompactFixedBlobKind(8)
        },
        {
            name: "expiration",
            kind: new (0, _rlp.RLP).NumericKind(4)
        },
        {
            name: "clauses",
            kind: {
                item: [
                    {
                        name: "to",
                        kind: new (0, _rlp.RLP).NullableFixedBlobKind(20)
                    },
                    {
                        name: "value",
                        kind: new (0, _rlp.RLP).NumericKind(32)
                    },
                    {
                        name: "data",
                        kind: new (0, _rlp.RLP).BlobKind()
                    }
                ]
            }
        },
        {
            name: "gasPriceCoef",
            kind: new (0, _rlp.RLP).NumericKind(1)
        },
        {
            name: "gas",
            kind: new (0, _rlp.RLP).NumericKind(8)
        },
        {
            name: "dependsOn",
            kind: new (0, _rlp.RLP).NullableFixedBlobKind(32)
        },
        {
            name: "nonce",
            kind: new (0, _rlp.RLP).NumericKind(8)
        },
        {
            name: "reserved",
            kind: {
                item: new (0, _rlp.RLP).BufferKind()
            }
        }
    ]
});
const txRLP = new (0, _rlp.RLP)({
    name: "tx",
    kind: [
        ...unsignedTxRLP.profile.kind,
        {
            name: "signature",
            kind: new (0, _rlp.RLP).BufferKind()
        }
    ]
});
const featuresKind = new (0, _rlp.RLP).NumericKind(4);

},{"4fd4672cbe1dd13":"l5Twm","./address":"aT2rv","./blake2b":"iUeyt","./rlp":"eunoT","./secp256k1":"7vgw0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aT2rv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "address", ()=>address);
var _keccak = require("./keccak");
var address;
(function(address) {
    /**
     * derive Address from public key, note that the public key is uncompressed
     * @param pub the public key
     */ function fromPublicKey(pub) {
        return "0x" + (0, _keccak.keccak256)(pub.slice(1)).slice(12).toString("hex");
    }
    address.fromPublicKey = fromPublicKey;
    /**
     * to check if a value presents an address
     * @param v the value to be checked
     */ function test(v) {
        return typeof v === "string" && /^0x[0-9a-f]{40}$/i.test(v);
    }
    address.test = test;
    /**
     * encode the address to checksumed address that is compatible with eip-55
     * @param address input address
     */ function toChecksumed(addr) {
        if (!test(addr)) throw new Error("invalid address");
        addr = addr.slice(2).toLowerCase();
        const hash = (0, _keccak.keccak256)(addr);
        let checksumed = "0x";
        for(let i = 0; i < addr.length; i++){
            // tslint:disable-next-line:no-bitwise
            let byte = hash[i >> 1];
            if (i % 2 === 0) // tslint:disable-next-line:no-bitwise
            byte >>= 4;
            if (byte % 16 >= 8) checksumed += addr[i].toUpperCase();
            else checksumed += addr[i];
        }
        return checksumed;
    }
    address.toChecksumed = toChecksumed;
})(address || (address = {}));

},{"./keccak":"9LyYR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iUeyt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */ parcelHelpers.export(exports, "blake2b256", ()=>blake2b256);
var Buffer = require("8ffbf466f54a52ab").Buffer;
const blake = require("8c46cbf423be9eb0");
function blake2b256(...data) {
    const ctx = blake.blake2bInit(32, null);
    data.forEach((d)=>{
        if (Buffer.isBuffer(d)) blake.blake2bUpdate(ctx, d);
        else blake.blake2bUpdate(ctx, Buffer.from(d, "utf8"));
    });
    return Buffer.from(blake.blake2bFinal(ctx));
}

},{"8ffbf466f54a52ab":"l5Twm","8c46cbf423be9eb0":"2xufO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2xufO":[function(require,module,exports) {
const b2b = require("2af72e15913aa368");
const b2s = require("44694e62d4382597");
module.exports = {
    blake2b: b2b.blake2b,
    blake2bHex: b2b.blake2bHex,
    blake2bInit: b2b.blake2bInit,
    blake2bUpdate: b2b.blake2bUpdate,
    blake2bFinal: b2b.blake2bFinal,
    blake2s: b2s.blake2s,
    blake2sHex: b2s.blake2sHex,
    blake2sInit: b2s.blake2sInit,
    blake2sUpdate: b2s.blake2sUpdate,
    blake2sFinal: b2s.blake2sFinal
};

},{"2af72e15913aa368":"7XezI","44694e62d4382597":"6NRvo"}],"7XezI":[function(require,module,exports) {
// Blake2B in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch
const util = require("8c8e45fc3077d415");
// 64-bit unsigned addition
// Sets v[a,a+1] += v[b,b+1]
// v should be a Uint32Array
function ADD64AA(v, a, b) {
    const o0 = v[a] + v[b];
    let o1 = v[a + 1] + v[b + 1];
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// 64-bit unsigned addition
// Sets v[a,a+1] += b
// b0 is the low 32 bits of b, b1 represents the high 32 bits
function ADD64AC(v, a, b0, b1) {
    let o0 = v[a] + b0;
    if (b0 < 0) o0 += 0x100000000;
    let o1 = v[a + 1] + b1;
    if (o0 >= 0x100000000) o1++;
    v[a] = o0;
    v[a + 1] = o1;
}
// Little-endian byte access
function B2B_GET32(arr, i) {
    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
}
// G Mixing function
// The ROTRs are inlined for speed
function B2B_G(a, b, c, d, ix, iy) {
    const x0 = m[ix];
    const x1 = m[ix + 1];
    const y0 = m[iy];
    const y1 = m[iy + 1];
    ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
    ;
    ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
    ;
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
    let xor0 = v[d] ^ v[a];
    let xor1 = v[d + 1] ^ v[a + 1];
    v[d] = xor1;
    v[d + 1] = xor0;
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = xor0 >>> 24 ^ xor1 << 8;
    v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
    ADD64AA(v, a, b);
    ADD64AC(v, a, y0, y1);
    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
    xor0 = v[d] ^ v[a];
    xor1 = v[d + 1] ^ v[a + 1];
    v[d] = xor0 >>> 16 ^ xor1 << 16;
    v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
    ADD64AA(v, c, d);
    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
    xor0 = v[b] ^ v[c];
    xor1 = v[b + 1] ^ v[c + 1];
    v[b] = xor1 >>> 31 ^ xor0 << 1;
    v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
}
// Initialization Vector
const BLAKE2B_IV32 = new Uint32Array([
    0xf3bcc908,
    0x6a09e667,
    0x84caa73b,
    0xbb67ae85,
    0xfe94f82b,
    0x3c6ef372,
    0x5f1d36f1,
    0xa54ff53a,
    0xade682d1,
    0x510e527f,
    0x2b3e6c1f,
    0x9b05688c,
    0xfb41bd6b,
    0x1f83d9ab,
    0x137e2179,
    0x5be0cd19
]);
const SIGMA8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3
];
// These are offsets into a uint64 buffer.
// Multiply them all by 2 to make them offsets into a uint32 buffer,
// because this is Javascript and we don't have uint64s
const SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
    return x * 2;
}));
// Compression function. 'last' flag indicates last block.
// Note we're representing 16 uint64s as 32 uint32s
const v = new Uint32Array(32);
const m = new Uint32Array(32);
function blake2bCompress(ctx, last) {
    let i = 0;
    // init work variables
    for(i = 0; i < 16; i++){
        v[i] = ctx.h[i];
        v[i + 16] = BLAKE2B_IV32[i];
    }
    // low 64 bits of offset
    v[24] = v[24] ^ ctx.t;
    v[25] = v[25] ^ ctx.t / 0x100000000;
    // high 64 bits not supported, offset may not be higher than 2**53-1
    // last block flag set ?
    if (last) {
        v[28] = ~v[28];
        v[29] = ~v[29];
    }
    // get little-endian words
    for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
    // twelve rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 64)
    for(i = 0; i < 12; i++){
        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
    }
    // util.debugPrint('   (i=12) v[16]', v, 64)
    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
// util.debugPrint('h[8]', ctx.h, 64)
}
// reusable parameterBlock
const parameterBlock = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0 // 60: personal
]);
// Creates a BLAKE2b hashing context
// Requires an output length between 1 and 64 bytes
// Takes an optional Uint8Array key
// Takes an optinal Uint8Array salt
// Takes an optinal Uint8Array personal
function blake2bInit(outlen, key, salt, personal) {
    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
    if (salt && salt.length !== 16) throw new Error("Illegal salt, expected Uint8Array with length is 16");
    if (personal && personal.length !== 16) throw new Error("Illegal personal, expected Uint8Array with length is 16");
    // state, 'param block'
    const ctx = {
        b: new Uint8Array(128),
        h: new Uint32Array(16),
        t: 0,
        c: 0,
        outlen: outlen // output length in bytes
    };
    // initialize parameterBlock before usage
    parameterBlock.fill(0);
    parameterBlock[0] = outlen;
    if (key) parameterBlock[1] = key.length;
    parameterBlock[2] = 1 // fanout
    ;
    parameterBlock[3] = 1 // depth
    ;
    if (salt) parameterBlock.set(salt, 32);
    if (personal) parameterBlock.set(personal, 48);
    // initialize hash state
    for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameterBlock, i * 4);
    // key the hash, if applicable
    if (key) {
        blake2bUpdate(ctx, key);
        // at the end
        ctx.c = 128;
    }
    return ctx;
}
// Updates a BLAKE2b streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2bUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 128) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            blake2bCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2b streaming hash
// Returns a Uint8Array containing the message digest
function blake2bFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 128)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    blake2bCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
    return out;
}
// Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function blake2b(input, key, outlen, salt, personal) {
    // preprocess inputs
    outlen = outlen || 64;
    input = util.normalizeInput(input);
    if (salt) salt = util.normalizeInput(salt);
    if (personal) personal = util.normalizeInput(personal);
    // do the math
    const ctx = blake2bInit(outlen, key, salt, personal);
    blake2bUpdate(ctx, input);
    return blake2bFinal(ctx);
}
// Computes the BLAKE2B hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 64 bytes
// - outlen - optional output length in bytes, default 64
// - salt - optional salt bytes, string, Buffer or Uint8Array
// - personal - optional personal bytes, string, Buffer or Uint8Array
function blake2bHex(input, key, outlen, salt, personal) {
    const output = blake2b(input, key, outlen, salt, personal);
    return util.toHex(output);
}
module.exports = {
    blake2b: blake2b,
    blake2bHex: blake2bHex,
    blake2bInit: blake2bInit,
    blake2bUpdate: blake2bUpdate,
    blake2bFinal: blake2bFinal
};

},{"8c8e45fc3077d415":"esOxZ"}],"esOxZ":[function(require,module,exports) {
const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
// For convenience, let people hash a string, not just a Uint8Array
function normalizeInput(input) {
    let ret;
    if (input instanceof Uint8Array) ret = input;
    else if (typeof input === "string") {
        const encoder = new TextEncoder();
        ret = encoder.encode(input);
    } else throw new Error(ERROR_MSG_INPUT);
    return ret;
}
// Converts a Uint8Array to a hexadecimal string
// For example, toHex([255, 0, 255]) returns "ff00ff"
function toHex(bytes) {
    return Array.prototype.map.call(bytes, function(n) {
        return (n < 16 ? "0" : "") + n.toString(16);
    }).join("");
}
// Converts any value in [0...2^32-1] to an 8-character hex string
function uint32ToHex(val) {
    return (0x100000000 + val).toString(16).substring(1);
}
// For debugging: prints out hash state in the same format as the RFC
// sample computation exactly, so that you can diff
function debugPrint(label, arr, size) {
    let msg = "\n" + label + " = ";
    for(let i = 0; i < arr.length; i += 2){
        if (size === 32) {
            msg += uint32ToHex(arr[i]).toUpperCase();
            msg += " ";
            msg += uint32ToHex(arr[i + 1]).toUpperCase();
        } else if (size === 64) {
            msg += uint32ToHex(arr[i + 1]).toUpperCase();
            msg += uint32ToHex(arr[i]).toUpperCase();
        } else throw new Error("Invalid size " + size);
        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
        else if (i < arr.length - 2) msg += " ";
    }
    console.log(msg);
}
// For performance testing: generates N bytes of input, hashes M times
// Measures and prints MB/second hash performance each time
function testSpeed(hashFn, N, M) {
    let startMs = new Date().getTime();
    const input = new Uint8Array(N);
    for(let i = 0; i < N; i++)input[i] = i % 256;
    const genMs = new Date().getTime();
    console.log("Generated random input in " + (genMs - startMs) + "ms");
    startMs = genMs;
    for(let i = 0; i < M; i++){
        const hashHex = hashFn(input);
        const hashMs = new Date().getTime();
        const ms = hashMs - startMs;
        startMs = hashMs;
        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
    }
}
module.exports = {
    normalizeInput: normalizeInput,
    toHex: toHex,
    debugPrint: debugPrint,
    testSpeed: testSpeed
};

},{}],"6NRvo":[function(require,module,exports) {
// BLAKE2s hash function in pure Javascript
// Adapted from the reference implementation in RFC7693
// Ported to Javascript by DC - https://github.com/dcposch
const util = require("8862b00f5e215bfb");
// Little-endian byte access.
// Expects a Uint8Array and an index
// Returns the little-endian uint32 at v[i..i+3]
function B2S_GET32(v, i) {
    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
}
// Mixing function G.
function B2S_G(a, b, c, d, x, y) {
    v[a] = v[a] + v[b] + x;
    v[d] = ROTR32(v[d] ^ v[a], 16);
    v[c] = v[c] + v[d];
    v[b] = ROTR32(v[b] ^ v[c], 12);
    v[a] = v[a] + v[b] + y;
    v[d] = ROTR32(v[d] ^ v[a], 8);
    v[c] = v[c] + v[d];
    v[b] = ROTR32(v[b] ^ v[c], 7);
}
// 32-bit right rotation
// x should be a uint32
// y must be between 1 and 31, inclusive
function ROTR32(x, y) {
    return x >>> y ^ x << 32 - y;
}
// Initialization Vector.
const BLAKE2S_IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const SIGMA = new Uint8Array([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    14,
    10,
    4,
    8,
    9,
    15,
    13,
    6,
    1,
    12,
    0,
    2,
    11,
    7,
    5,
    3,
    11,
    8,
    12,
    0,
    5,
    2,
    15,
    13,
    10,
    14,
    3,
    6,
    7,
    1,
    9,
    4,
    7,
    9,
    3,
    1,
    13,
    12,
    11,
    14,
    2,
    6,
    5,
    10,
    4,
    0,
    15,
    8,
    9,
    0,
    5,
    7,
    2,
    4,
    10,
    15,
    14,
    1,
    11,
    12,
    6,
    8,
    3,
    13,
    2,
    12,
    6,
    10,
    0,
    11,
    8,
    3,
    4,
    13,
    7,
    5,
    15,
    14,
    1,
    9,
    12,
    5,
    1,
    15,
    14,
    13,
    4,
    10,
    0,
    7,
    6,
    3,
    9,
    2,
    8,
    11,
    13,
    11,
    7,
    14,
    12,
    1,
    3,
    9,
    5,
    0,
    15,
    4,
    8,
    6,
    2,
    10,
    6,
    15,
    14,
    9,
    11,
    3,
    0,
    8,
    12,
    2,
    13,
    7,
    1,
    4,
    10,
    5,
    10,
    2,
    8,
    4,
    7,
    6,
    1,
    5,
    15,
    11,
    9,
    14,
    3,
    12,
    13,
    0
]);
// Compression function. "last" flag indicates last block
const v = new Uint32Array(16);
const m = new Uint32Array(16);
function blake2sCompress(ctx, last) {
    let i = 0;
    for(i = 0; i < 8; i++){
        // init work variables
        v[i] = ctx.h[i];
        v[i + 8] = BLAKE2S_IV[i];
    }
    v[12] ^= ctx.t // low 32 bits of offset
    ;
    v[13] ^= ctx.t / 0x100000000 // high 32 bits
    ;
    if (last) // last block flag set ?
    v[14] = ~v[14];
    for(i = 0; i < 16; i++)// get little-endian words
    m[i] = B2S_GET32(ctx.b, 4 * i);
    // ten rounds of mixing
    // uncomment the DebugPrint calls to log the computation
    // and match the RFC sample documentation
    // util.debugPrint('          m[16]', m, 32)
    for(i = 0; i < 10; i++){
        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
        B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]]);
        B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]]);
        B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]]);
        B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]]);
        B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]]);
        B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]]);
        B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]]);
        B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]]);
    }
    // util.debugPrint('   (i=10) v[16]', v, 32)
    for(i = 0; i < 8; i++)ctx.h[i] ^= v[i] ^ v[i + 8];
// util.debugPrint('h[8]', ctx.h, 32)
}
// Creates a BLAKE2s hashing context
// Requires an output length between 1 and 32 bytes
// Takes an optional Uint8Array key
function blake2sInit(outlen, key) {
    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
    const keylen = key ? key.length : 0;
    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
    const ctx = {
        h: new Uint32Array(BLAKE2S_IV),
        b: new Uint8Array(64),
        c: 0,
        t: 0,
        outlen: outlen // output length in bytes
    };
    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
    if (keylen > 0) {
        blake2sUpdate(ctx, key);
        ctx.c = 64 // at the end
        ;
    }
    return ctx;
}
// Updates a BLAKE2s streaming hash
// Requires hash context and Uint8Array (byte array)
function blake2sUpdate(ctx, input) {
    for(let i = 0; i < input.length; i++){
        if (ctx.c === 64) {
            // buffer full ?
            ctx.t += ctx.c // add counters
            ;
            blake2sCompress(ctx, false) // compress (not last)
            ;
            ctx.c = 0 // counter to zero
            ;
        }
        ctx.b[ctx.c++] = input[i];
    }
}
// Completes a BLAKE2s streaming hash
// Returns a Uint8Array containing the message digest
function blake2sFinal(ctx) {
    ctx.t += ctx.c // mark last block offset
    ;
    while(ctx.c < 64)// fill up with zeros
    ctx.b[ctx.c++] = 0;
    blake2sCompress(ctx, true) // final block flag = 1
    ;
    // little endian convert and store
    const out = new Uint8Array(ctx.outlen);
    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
    return out;
}
// Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
//
// Returns a n-byte Uint8Array
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function blake2s(input, key, outlen) {
    // preprocess inputs
    outlen = outlen || 32;
    input = util.normalizeInput(input);
    // do the math
    const ctx = blake2sInit(outlen, key);
    blake2sUpdate(ctx, input);
    return blake2sFinal(ctx);
}
// Computes the BLAKE2S hash of a string or byte array
//
// Returns an n-byte hash in hex, all lowercase
//
// Parameters:
// - input - the input bytes, as a string, Buffer, or Uint8Array
// - key - optional key Uint8Array, up to 32 bytes
// - outlen - optional output length in bytes, default 64
function blake2sHex(input, key, outlen) {
    const output = blake2s(input, key, outlen);
    return util.toHex(output);
}
module.exports = {
    blake2s: blake2s,
    blake2sHex: blake2sHex,
    blake2sInit: blake2sInit,
    blake2sUpdate: blake2sUpdate,
    blake2sFinal: blake2sFinal
};

},{"8862b00f5e215bfb":"esOxZ"}],"eunoT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RLP", ()=>RLP);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _rlp = require("rlp");
var Buffer = require("51f24aa65141376c").Buffer;
class RLP {
    constructor(profile){
        this.profile = profile;
    }
    /**
     * encode data according to profile
     * @param data the structured data to be encoded
     */ encode(data) {
        const packed = pack(data, this.profile, "");
        return _rlp.encode(packed);
    }
    /**
     * decode buffer according to profile
     * @param buf rlp encoded data
     */ decode(buf) {
        const packed = _rlp.decode(buf);
        return unpack(packed, this.profile, "");
    }
}
(function(RLP) {
    /** base class of scalar kind */ class ScalarKind {
    }
    RLP.ScalarKind = ScalarKind;
    /** a buffer kind to keep buffer type */ class BufferKind extends ScalarKind {
        data(data, ctx) {
            assert(Buffer.isBuffer(data), ctx, "expected buffer");
            return {
                encode () {
                    return data;
                }
            };
        }
        buffer(buf, ctx) {
            return {
                decode () {
                    return buf;
                }
            };
        }
    }
    RLP.BufferKind = BufferKind;
    /** a scalar kind to presents number */ class NumericKind extends ScalarKind {
        /**
         * create a numeric kind
         * @param maxBytes up limit of data in bytes
         */ constructor(maxBytes){
            super();
            this.maxBytes = maxBytes;
        }
        data(data, ctx) {
            assert(typeof data === "string" || typeof data === "number", ctx, "expected string or number");
            if (typeof data === "string") {
                const isHex = isHexString(data);
                const isDec = isDecString(data);
                assert(isHex || isDec, ctx, "expected non-negative integer in hex or dec string");
                if (isHex) assert(data.length > 2, ctx, "expected valid hex string");
            } else assert(Number.isSafeInteger(data) && data >= 0, ctx, "expected non-negative safe integer");
            const bn = new (0, _bignumberJsDefault.default)(data);
            if (bn.isZero()) return {
                encode () {
                    return Buffer.alloc(0);
                }
            };
            let hex = bn.toString(16);
            if (hex.length % 2 !== 0) hex = "0" + hex;
            assert(this.maxBytes ? hex.length <= this.maxBytes * 2 : true, ctx, `expected number in ${this.maxBytes} bytes`);
            return {
                encode () {
                    return Buffer.from(hex, "hex");
                }
            };
        }
        buffer(buf, ctx) {
            assert(this.maxBytes ? buf.length <= this.maxBytes : true, ctx, `expected less than ${this.maxBytes} bytes`);
            assert(buf.length === 0 || buf[0] !== 0, ctx, `expected canonical integer (no leading zero bytes)`);
            return {
                decode () {
                    if (buf.length === 0) return 0;
                    const bn = new (0, _bignumberJsDefault.default)(buf.toString("hex"), 16);
                    const num = bn.toNumber();
                    return Number.isSafeInteger(num) ? num : "0x" + bn.toString(16);
                }
            };
        }
    }
    RLP.NumericKind = NumericKind;
    /** a scalar kind to present blob */ class BlobKind extends ScalarKind {
        data(data, ctx) {
            assert(isHexString(data), ctx, "expected hex string");
            assert(data.length % 2 === 0, ctx, "expected even length hex");
            return {
                encode () {
                    return Buffer.from(data.slice(2), "hex");
                }
            };
        }
        buffer(buf, ctx) {
            return {
                decode () {
                    return "0x" + buf.toString("hex");
                }
            };
        }
    }
    RLP.BlobKind = BlobKind;
    /** fixed length blob */ class FixedBlobKind extends BlobKind {
        constructor(bytes){
            super();
            this.bytes = bytes;
        }
        data(data, ctx) {
            const encoder = super.data(data, ctx);
            assert(data.length === this.bytes * 2 + 2, ctx, `expected hex string presents ${this.bytes} bytes`);
            return encoder;
        }
        buffer(buf, ctx) {
            const decoder = super.buffer(buf, ctx);
            assert(buf.length === this.bytes, ctx, `expected ${this.bytes} bytes`);
            return decoder;
        }
    }
    RLP.FixedBlobKind = FixedBlobKind;
    /** fixed length blob allowing null */ class NullableFixedBlobKind extends FixedBlobKind {
        data(data, ctx) {
            if (!data) return {
                encode () {
                    return Buffer.alloc(0);
                }
            };
            return super.data(data, ctx);
        }
        buffer(buf, ctx) {
            if (buf.length === 0) return {
                decode () {
                    return null;
                }
            };
            return super.buffer(buf, ctx);
        }
    }
    RLP.NullableFixedBlobKind = NullableFixedBlobKind;
    /** fixed length blob kind that will remove leading zero on encoding and pad zero on decoding */ class CompactFixedBlobKind extends FixedBlobKind {
        data(data, ctx) {
            const buf = super.data(data, ctx).encode();
            return {
                encode () {
                    const nzIndex = buf.findIndex((v)=>v !== 0);
                    if (nzIndex >= 0) return buf.slice(nzIndex);
                    return Buffer.alloc(0);
                }
            };
        }
        buffer(buf, ctx) {
            assert(buf.length <= this.bytes, ctx, `expected less than ${this.bytes} bytes`);
            assert(buf.length === 0 || buf[0] !== 0, ctx, `expected no leading zero bytes`);
            const bytes = this.bytes;
            return {
                decode () {
                    const zeros = "0".repeat((bytes - buf.length) * 2);
                    return "0x" + zeros + buf.toString("hex");
                }
            };
        }
    }
    RLP.CompactFixedBlobKind = CompactFixedBlobKind;
})(RLP || (RLP = {}));
function pack(obj, profile, ctx) {
    ctx = ctx ? ctx + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof RLP.ScalarKind) return kind.data(obj, ctx).encode();
    if (Array.isArray(kind)) return kind.map((k)=>pack(obj[k.name], k, ctx));
    assert(Array.isArray(obj), ctx, "expected array");
    const item = kind.item;
    return obj.map((part, i)=>pack(part, {
            name: "#" + i,
            kind: item
        }, ctx));
}
function unpack(packed, profile, ctx) {
    ctx = ctx ? ctx + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof RLP.ScalarKind) {
        assert(Buffer.isBuffer(packed), ctx, "expected Buffer");
        return kind.buffer(packed, ctx).decode();
    }
    if (Array.isArray(kind)) {
        assert(Array.isArray(packed), ctx, "expected array");
        const parts = packed;
        assert(parts.length === kind.length, ctx, `expected ${kind.length} items, but got ${parts.length}`);
        return kind.reduce((o, p, i)=>{
            o[p.name] = unpack(parts[i], p, ctx);
            return o;
        }, {});
    }
    assert(Array.isArray(packed), ctx, "expected array");
    const item = kind.item;
    return packed.map((part, i)=>unpack(part, {
            name: "#" + i,
            kind: item
        }, ctx));
}
function assert(cond, ctx, msg) {
    if (!cond) throw new RLPError(`${ctx}: ${msg}`);
}
function isHexString(str) {
    return /^0x[0-9a-f]*$/i.test(str);
}
function isDecString(str) {
    return /^[0-9]+$/.test(str);
}
class RLPError extends Error {
    constructor(msg){
        super(msg);
        this.name = RLPError.name;
    }
}

},{"51f24aa65141376c":"l5Twm","bignumber.js":"2fTAY","rlp":"iee6k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iee6k":[function(require,module,exports) {
var Buffer = require("c4f3522d609e2bb4").Buffer;
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLength = exports.decode = exports.encode = void 0;
var bn_js_1 = __importDefault(require("f2de64fac014d334"));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push(encode(input[i]));
        var buf = Buffer.concat(output);
        return Buffer.concat([
            encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : Buffer.concat([
            encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
exports.encode = encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function safeParseInt(v, base) {
    if (v[0] === "0" && v[1] === "0") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function encodeLength(len, offset) {
    if (len < 56) return Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = intToHex(offset + 55 + lLength);
        return Buffer.from(firstByte + hexLength, "hex");
    }
}
function decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return Buffer.from([]);
    var inputBuffer = toBuffer(input);
    var decoded = _decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
exports.decode = decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function getLength(input) {
    if (!input || input.length === 0) return Buffer.from([]);
    var inputBuffer = toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length_1 = safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length_1;
    }
}
exports.getLength = getLength;
/** Decode an input with RLP */ function _decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function intToBuffer(integer) {
    var hex = intToHex(integer);
    return Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function toBuffer(v) {
    if (!Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if (isHexPrefixed(v)) return Buffer.from(padToEven(stripHexPrefix(v)), "hex");
            else return Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return Buffer.from([]);
            else return intToBuffer(v);
        } else if (v === null || v === undefined) return Buffer.from([]);
        else if (v instanceof Uint8Array) return Buffer.from(v);
        else if (bn_js_1.default.isBN(v)) // converts a BN to a Buffer
        return Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

},{"c4f3522d609e2bb4":"l5Twm","f2de64fac014d334":"x4ItY"}],"x4ItY":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"13Pcp"}],"7vgw0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "secp256k1", ()=>secp256k1);
var _crypto = require("crypto");
var _elliptic = require("elliptic");
var Buffer = require("840caf60429d9284").Buffer;
const curve = new (0, _elliptic.ec)("secp256k1");
const N = Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const ZERO = Buffer.alloc(32, 0);
function isValidPrivateKey(key) {
    return Buffer.isBuffer(key) && key.length === 32 && !key.equals(ZERO) && key.compare(N) < 0;
}
function isValidMessageHash(hash) {
    return Buffer.isBuffer(hash) && hash.length === 32;
}
var secp256k1;
(function(secp256k1) {
    /**
     * generate private key
     * @param rng the optional random number generator, which exactly generates 32 random bytes
     */ function generatePrivateKey(rng) {
        rng = rng || (()=>(0, _crypto.randomBytes)(32));
        for(;;){
            const privKey = rng();
            if (isValidPrivateKey(privKey)) return privKey;
        }
    }
    secp256k1.generatePrivateKey = generatePrivateKey;
    /**
     * derive public key(uncompressed) from private key
     * @param privKey the private key
     */ function derivePublicKey(privKey) {
        if (!isValidPrivateKey(privKey)) throw new Error("invalid private key");
        const keyPair = curve.keyFromPrivate(privKey);
        return Buffer.from(keyPair.getPublic().encode("array", false));
    }
    secp256k1.derivePublicKey = derivePublicKey;
    /**
     * sign a message using elliptic curve algorithm on the curve secp256k1
     * @param msgHash hash of message
     * @param privKey serialized private key
     */ function sign(msgHash, privKey) {
        if (!isValidMessageHash(msgHash)) throw new Error("invalid message hash");
        if (!isValidPrivateKey(privKey)) throw new Error("invalid private key");
        const keyPair = curve.keyFromPrivate(privKey);
        const sig = keyPair.sign(msgHash, {
            canonical: true
        });
        const r = Buffer.from(sig.r.toArray("be", 32));
        const s = Buffer.from(sig.s.toArray("be", 32));
        return Buffer.concat([
            r,
            s,
            Buffer.from([
                sig.recoveryParam
            ])
        ]);
    }
    secp256k1.sign = sign;
    /**
     * recovery signature to public key
     * @param msgHash hash of message
     * @param sig signature
     */ function recover(msgHash, sig) {
        if (!isValidMessageHash(msgHash)) throw new Error("invalid message hash");
        if (!Buffer.isBuffer(sig) || sig.length !== 65) throw new Error("invalid signature");
        const recovery = sig[64];
        if (recovery !== 0 && recovery !== 1) throw new Error("invalid signature recovery");
        const r = sig.slice(0, 32);
        const s = sig.slice(32, 64);
        return Buffer.from(curve.recoverPubKey(msgHash, {
            r,
            s
        }, recovery).encode("array", false));
    }
    secp256k1.recover = recover;
})(secp256k1 || (secp256k1 = {}));

},{"840caf60429d9284":"l5Twm","crypto":"9rmFv","elliptic":"e8UEU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rmFv":[function(require,module,exports) {
"use strict";
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require("9f84b01a6f751e2b");
exports.createHash = exports.Hash = require("6215218888164bf3");
exports.createHmac = exports.Hmac = require("41dc42cb22bbf5f8");
var algos = require("acce2639fd57a8ee");
var algoKeys = Object.keys(algos);
var hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat(algoKeys);
exports.getHashes = function() {
    return hashes;
};
var p = require("b26231bc996405c3");
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;
var aes = require("cd296f7efacbf3dd");
exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;
var dh = require("f35f6f689077fd07");
exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;
var sign = require("e955328ff9b7dd32");
exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;
exports.createECDH = require("84e3bfaa4f6c843e");
var publicEncrypt = require("eeb59405cf029b93");
exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;
// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })
var rf = require("327f527258516f60");
exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;
exports.createCredentials = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
exports.constants = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

},{"9f84b01a6f751e2b":"c6z4K","6215218888164bf3":"iwHvk","41dc42cb22bbf5f8":"7xH2B","acce2639fd57a8ee":"bp2SQ","b26231bc996405c3":"aqGHG","cd296f7efacbf3dd":"eoEgH","f35f6f689077fd07":"lqXbp","e955328ff9b7dd32":"9AaKM","84e3bfaa4f6c843e":"4A8Bn","eeb59405cf029b93":"4jHVG","327f527258516f60":"dpgow"}],"c6z4K":[function(require,module,exports) {
var global = arguments[3];
var process = require("9f5c61be6bd9c67a");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295;
function oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}
var Buffer = require("caff9346743c214e").Buffer;
var crypto = global.crypto || global.msCrypto;
if (crypto && crypto.getRandomValues) module.exports = randomBytes;
else module.exports = oldBrowser;
function randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
        else crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return process.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

},{"9f5c61be6bd9c67a":"5QIF0","caff9346743c214e":"6hBQU"}],"6hBQU":[function(require,module,exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"l5Twm"}],"iwHvk":[function(require,module,exports) {
"use strict";
var inherits = require("45ce174cec337471");
var MD5 = require("4170b0039f3b4aab");
var RIPEMD160 = require("efcc6ede1fda4d98");
var sha = require("65b1a51ddac82548");
var Base = require("ac5a46c0f3b4d769");
function Hash(hash) {
    Base.call(this, "digest");
    this._hash = hash;
}
inherits(Hash, Base);
Hash.prototype._update = function(data) {
    this._hash.update(data);
};
Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new MD5();
    if (alg === "rmd160" || alg === "ripemd160") return new RIPEMD160();
    return new Hash(sha(alg));
};

},{"45ce174cec337471":"8LxVj","4170b0039f3b4aab":"i9uFm","efcc6ede1fda4d98":"iRD8I","65b1a51ddac82548":"7ZUZ8","ac5a46c0f3b4d769":"7VZSW"}],"8LxVj":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"i9uFm":[function(require,module,exports) {
"use strict";
var inherits = require("634114d48656c754");
var HashBase = require("4b170874b4cb8d4e");
var Buffer = require("72d4e45c6a42a2da").Buffer;
var ARRAY16 = new Array(16);
function MD5() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
inherits(MD5, HashBase);
MD5.prototype._update = function() {
    var M = ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fnF(a, b, c, d, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function fnG(a, b, c, d, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function fnH(a, b, c, d, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function fnI(a, b, c, d, m, k, s) {
    return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = MD5;

},{"634114d48656c754":"8LxVj","4b170874b4cb8d4e":"bkj8g","72d4e45c6a42a2da":"6hBQU"}],"bkj8g":[function(require,module,exports) {
"use strict";
var Buffer = require("27eaec8a721206a5").Buffer;
var Transform = require("c9c4fcebe200e6bf").Transform;
var inherits = require("91e9fa68d440541e");
function throwIfNotStringOrBuffer(val, prefix) {
    if (!Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function HashBase(blockSize) {
    Transform.call(this);
    this._block = Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
inherits(HashBase, Transform);
HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype.update = function(data, encoding) {
    throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = HashBase;

},{"27eaec8a721206a5":"6hBQU","c9c4fcebe200e6bf":"gHHLM","91e9fa68d440541e":"8LxVj"}],"gHHLM":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"fqTtD","4a6ee9586f51c38d":"8LxVj","e6206e1f4d20abc7":"cKiEz","a3f1405f37e1dfb1":"1l9D3","6691a72c5fc222fd":"jXYL7","43a905ce7ec6ac9e":"fyAZh","dd715550d7783885":"3kmEt","d90a3520974ec96e":"YQEqF","eb2779cfd287c5c9":"3jCgz"}],"fqTtD":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"cKiEz":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("896ff8d56553f7a");
"use strict";
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("16782d660ac22e0c").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("9a34f23fa53f83f7");
/*</replacement>*/ var Buffer = require("fb95ecaa88342eae").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("a4a723b7297c7152");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("7a14cc1689b8c63e");
var destroyImpl = require("efa8155386cc4283");
var _require = require("994c984d08c7bbf2"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("8de60461b822641b").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("19affa8ce41f090d")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("830c56f840811f05");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7451b8c4bf72370");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"896ff8d56553f7a":"5QIF0","16782d660ac22e0c":"fqTtD","9a34f23fa53f83f7":"9k4qR","fb95ecaa88342eae":"l5Twm","a4a723b7297c7152":"13Pcp","7a14cc1689b8c63e":"XxY4N","efa8155386cc4283":"jRCu7","994c984d08c7bbf2":"e5vN8","8de60461b822641b":"64341","19affa8ce41f090d":"8LxVj","f1c95f846e94e4eb":"jXYL7","6392acd10886f115":"dr7zb","830c56f840811f05":"3TcjU","7451b8c4bf72370":"39HiC"}],"9k4qR":[function(require,module,exports) {
module.exports = require("ed88fc9aa73f911").EventEmitter;

},{"ed88fc9aa73f911":"fqTtD"}],"XxY4N":[function(require,module,exports) {
"use strict";
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("59f5d0111b7fa075"), Buffer = _require.Buffer;
var _require2 = require("eef6a677577349b8"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"59f5d0111b7fa075":"l5Twm","eef6a677577349b8":"13Pcp"}],"jRCu7":[function(require,module,exports) {
var process = require("4284522496af5dfb");
"use strict";
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"4284522496af5dfb":"5QIF0"}],"e5vN8":[function(require,module,exports) {
"use strict";
var ERR_INVALID_OPT_VALUE = require("4e508d569e2117ef").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4e508d569e2117ef":"64341"}],"64341":[function(require,module,exports) {
"use strict";
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
module.exports.codes = codes;

},{}],"jXYL7":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("2ab1115635c50a9f");
"use strict";
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("68a7582259cd5865");
var Writable = require("93d042f8bb80078e");
require("aa7b11ba5bf4defc")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"2ab1115635c50a9f":"5QIF0","68a7582259cd5865":"cKiEz","93d042f8bb80078e":"1l9D3","aa7b11ba5bf4defc":"8LxVj"}],"1l9D3":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("f05a2a5a09d4d8b0");
"use strict";
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("dc51171b07b54af1")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("44a3cc22ec64fcd3");
/*</replacement>*/ var Buffer = require("de8f7fb7ccda8086").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("acf48fb5d9dc6204");
var _require = require("9d146cd974da0f53"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("3c574b8881abcf86").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("10dad555ffe77dde")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"f05a2a5a09d4d8b0":"5QIF0","dc51171b07b54af1":"3YafI","44a3cc22ec64fcd3":"9k4qR","de8f7fb7ccda8086":"l5Twm","acf48fb5d9dc6204":"jRCu7","9d146cd974da0f53":"e5vN8","3c574b8881abcf86":"64341","10dad555ffe77dde":"8LxVj","c5e7171d6f58d3c0":"jXYL7"}],"3YafI":[function(require,module,exports) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

},{}],"dr7zb":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"2a29807c689a070a":"6hBQU"}],"3TcjU":[function(require,module,exports) {
var process = require("96b869862a96261a");
"use strict";
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("745a3cd8f6469ed5");
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"96b869862a96261a":"5QIF0","745a3cd8f6469ed5":"YQEqF"}],"YQEqF":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var ERR_STREAM_PREMATURE_CLOSE = require("d35458f585bdd360").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos(stream, opts, callback) {
    if (typeof opts === "function") return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = eos;

},{"d35458f585bdd360":"64341"}],"39HiC":[function(require,module,exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

},{}],"fyAZh":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var _require$codes = require("baab47252aa06434").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("db11ebf938e536ed");
require("82049677fa603d40")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"baab47252aa06434":"64341","db11ebf938e536ed":"jXYL7","82049677fa603d40":"8LxVj"}],"3kmEt":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("7ab21291895ec3d2");
require("f24ec1883eef5e9b")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"7ab21291895ec3d2":"fyAZh","f24ec1883eef5e9b":"8LxVj"}],"3jCgz":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("6ba21bd580ac7d57").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = require("dd7fd89dd81b8674");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"6ba21bd580ac7d57":"64341","dd7fd89dd81b8674":"YQEqF"}],"iRD8I":[function(require,module,exports) {
"use strict";
var Buffer = require("c813c8075bcf823e").Buffer;
var inherits = require("84928993e7c3934b");
var HashBase = require("4b3519823770a56d");
var ARRAY16 = new Array(16);
var zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function RIPEMD160() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
inherits(RIPEMD160, HashBase);
RIPEMD160.prototype._update = function() {
    var words = ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
            tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
        } else if (i < 32) {
            tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
            tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
        } else if (i < 48) {
            tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
            tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
        } else if (i < 64) {
            tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
            tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
        } else {
            tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
            tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
        }
        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fn1(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function fn2(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function fn3(a, b, c, d, e, m, k, s) {
    return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function fn4(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function fn5(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = RIPEMD160;

},{"c813c8075bcf823e":"l5Twm","84928993e7c3934b":"8LxVj","4b3519823770a56d":"bkj8g"}],"7ZUZ8":[function(require,module,exports) {
var exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};
exports.sha = require("54c9313943368ce2");
exports.sha1 = require("6e6f42e0b6fe29ef");
exports.sha224 = require("cefe70c6f9f68940");
exports.sha256 = require("3b4e2aa73bc3fef5");
exports.sha384 = require("be7da8b8e5a0fd78");
exports.sha512 = require("25610a4ba83316a4");

},{"54c9313943368ce2":"dg5QZ","6e6f42e0b6fe29ef":"dR4ik","cefe70c6f9f68940":"6FRTV","3b4e2aa73bc3fef5":"dDAtH","be7da8b8e5a0fd78":"fRcHf","25610a4ba83316a4":"fJVVX"}],"dg5QZ":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ var inherits = require("55404b425acd1c6f");
var Hash = require("457bc9c7737d761f");
var Buffer = require("44759e57eb2992a").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha, Hash);
Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha;

},{"55404b425acd1c6f":"8LxVj","457bc9c7737d761f":"abN2o","44759e57eb2992a":"6hBQU"}],"abN2o":[function(require,module,exports) {
var Buffer = require("fe67468afd3c1b91").Buffer;
// prototype class for hash functions
function Hash(blockSize, finalSize) {
    this._block = Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = Hash;

},{"fe67468afd3c1b91":"6hBQU"}],"dR4ik":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ var inherits = require("bf0dcaa2121c06d3");
var Hash = require("788f05b1f9753762");
var Buffer = require("ee7c2a3e649d259f").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha1() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha1, Hash);
Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl1(num) {
    return num << 1 | num >>> 31;
}
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha1.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha1;

},{"bf0dcaa2121c06d3":"8LxVj","788f05b1f9753762":"abN2o","ee7c2a3e649d259f":"6hBQU"}],"6FRTV":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("1759318dd61b32af");
var Sha256 = require("5a24a8ff4dc414f6");
var Hash = require("377596dd27739a66");
var Buffer = require("381289f917f16a20").Buffer;
var W = new Array(64);
function Sha224() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha224, Sha256);
Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
Sha224.prototype._hash = function() {
    var H = Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = Sha224;

},{"1759318dd61b32af":"8LxVj","5a24a8ff4dc414f6":"dDAtH","377596dd27739a66":"abN2o","381289f917f16a20":"6hBQU"}],"dDAtH":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("682a6716eeab42dd");
var Hash = require("f062bd789841a9ce");
var Buffer = require("1d47643a8adb8c1b").Buffer;
var K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var W = new Array(64);
function Sha256() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha256, Hash);
Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
        var T2 = sigma0(a) + maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
Sha256.prototype._hash = function() {
    var H = Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = Sha256;

},{"682a6716eeab42dd":"8LxVj","f062bd789841a9ce":"abN2o","1d47643a8adb8c1b":"6hBQU"}],"fRcHf":[function(require,module,exports) {
var inherits = require("2a5cbb73fedd61b");
var SHA512 = require("fdb4d0946b31cdb5");
var Hash = require("50aa04d4bd2df0e1");
var Buffer = require("3d3bcc84ec383b74").Buffer;
var W = new Array(160);
function Sha384() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha384, SHA512);
Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
Sha384.prototype._hash = function() {
    var H = Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = Sha384;

},{"2a5cbb73fedd61b":"8LxVj","fdb4d0946b31cdb5":"fJVVX","50aa04d4bd2df0e1":"abN2o","3d3bcc84ec383b74":"6hBQU"}],"fJVVX":[function(require,module,exports) {
var inherits = require("8d87c82d5ce5743");
var Hash = require("27d0146c4419ba93");
var Buffer = require("602d9c7256ca6bf7").Buffer;
var K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var W = new Array(160);
function Sha512() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha512, Hash);
Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = Gamma0(xh, xl);
        var gamma0l = Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = Gamma1(xh, xl);
        var gamma1l = Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = maj(ah, bh, ch);
        var majl = maj(al, bl, cl);
        var sigma0h = sigma0(ah, al);
        var sigma0l = sigma0(al, ah);
        var sigma1h = sigma1(eh, el);
        var sigma1l = sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = K[j];
        var Kil = K[j + 1];
        var chh = Ch(eh, fh, gh);
        var chl = Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
};
Sha512.prototype._hash = function() {
    var H = Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = Sha512;

},{"8d87c82d5ce5743":"8LxVj","27d0146c4419ba93":"abN2o","602d9c7256ca6bf7":"6hBQU"}],"7VZSW":[function(require,module,exports) {
var Buffer = require("631f7eb12d35b579").Buffer;
var Transform = require("5b378a2a05398c5").Transform;
var StringDecoder = require("d42da7de127e1c4b").StringDecoder;
var inherits = require("7a0f2f27fe0a389b");
function CipherBase(hashMode) {
    Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
inherits(CipherBase, Transform);
CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
CipherBase.prototype.setAutoPadding = function() {};
CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = CipherBase;

},{"631f7eb12d35b579":"6hBQU","5b378a2a05398c5":"gHHLM","d42da7de127e1c4b":"dr7zb","7a0f2f27fe0a389b":"8LxVj"}],"7xH2B":[function(require,module,exports) {
"use strict";
var inherits = require("6a73c7c8ca6b61fa");
var Legacy = require("e1b443c27c833bc0");
var Base = require("7571755cc57fd60e");
var Buffer = require("b8ba1339feab1938").Buffer;
var md5 = require("c00fb3fd28cadeb2");
var RIPEMD160 = require("b7f8eae556813ec1");
var sha = require("40c5a912778271f7");
var ZEROS = Buffer.alloc(128);
function Hmac(alg, key) {
    Base.call(this, "digest");
    if (typeof key === "string") key = Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new RIPEMD160() : sha(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new RIPEMD160() : sha(alg);
    this._hash.update(ipad);
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new RIPEMD160() : sha(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new Hmac("rmd160", key);
    if (alg === "md5") return new Legacy(md5, key);
    return new Hmac(alg, key);
};

},{"6a73c7c8ca6b61fa":"8LxVj","e1b443c27c833bc0":"aDf1q","7571755cc57fd60e":"7VZSW","b8ba1339feab1938":"6hBQU","c00fb3fd28cadeb2":"aXxZy","b7f8eae556813ec1":"iRD8I","40c5a912778271f7":"7ZUZ8"}],"aDf1q":[function(require,module,exports) {
"use strict";
var inherits = require("2baf2864ece10f11");
var Buffer = require("c7fb5e22d675c53c").Buffer;
var Base = require("8fdec7d6b96329ea");
var ZEROS = Buffer.alloc(128);
var blocksize = 64;
function Hmac(alg, key) {
    Base.call(this, "digest");
    if (typeof key === "string") key = Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) key = alg(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = this._ipad = Buffer.allocUnsafe(blocksize);
    var opad = this._opad = Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
inherits(Hmac, Base);
Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
Hmac.prototype._final = function() {
    var h = this._alg(Buffer.concat(this._hash));
    return this._alg(Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = Hmac;

},{"2baf2864ece10f11":"8LxVj","c7fb5e22d675c53c":"6hBQU","8fdec7d6b96329ea":"7VZSW"}],"aXxZy":[function(require,module,exports) {
var MD5 = require("f07cc93582c49804");
module.exports = function(buffer) {
    return new MD5().update(buffer).digest();
};

},{"f07cc93582c49804":"i9uFm"}],"bp2SQ":[function(require,module,exports) {
"use strict";
module.exports = require("b6a65ebe2480cb5a");

},{"b6a65ebe2480cb5a":"eT3Fy"}],"eT3Fy":[function(require,module,exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

},{}],"aqGHG":[function(require,module,exports) {
exports.pbkdf2 = require("50310b85983e4f32");
exports.pbkdf2Sync = require("5f7b0df9c2ef196d");

},{"50310b85983e4f32":"8Mzns","5f7b0df9c2ef196d":"fInsE"}],"8Mzns":[function(require,module,exports) {
var global = arguments[3];
var Buffer = require("a1f6b66eddae53e0").Buffer;
var checkParameters = require("a915fb954a5b62ac");
var defaultEncoding = require("76b8747fb257c65c");
var sync = require("f6f43e3eaadd9ae9");
var toBuffer = require("d12cab846fc3f945");
var ZERO_BUF;
var subtle = global.crypto && global.crypto.subtle;
var toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var checks = [];
function checkNative(algo) {
    if (global.process && !global.process.browser) return Promise.resolve(false);
    if (!subtle || !subtle.importKey || !subtle.deriveBits) return Promise.resolve(false);
    if (checks[algo] !== undefined) return checks[algo];
    ZERO_BUF = ZERO_BUF || Buffer.alloc(8);
    var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    checks[algo] = prom;
    return prom;
}
var nextTick;
function getNextTick() {
    if (nextTick) return nextTick;
    if (global.process && global.process.nextTick) nextTick = global.process.nextTick;
    else if (global.queueMicrotask) nextTick = global.queueMicrotask;
    else if (global.setImmediate) nextTick = global.setImmediate;
    else nextTick = global.setTimeout;
    return nextTick;
}
function browserPbkdf2(password, salt, iterations, length, algo) {
    return subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return Buffer.from(res);
    });
}
function resolvePromise(promise, callback) {
    promise.then(function(out) {
        getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = toBrowser[digest.toLowerCase()];
    if (!algo || typeof global.Promise !== "function") {
        getNextTick()(function() {
            var out;
            try {
                out = sync(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, "Password");
    salt = toBuffer(salt, defaultEncoding, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    resolvePromise(checkNative(algo).then(function(resp) {
        if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo);
        return sync(password, salt, iterations, keylen, digest);
    }), callback);
};

},{"a1f6b66eddae53e0":"6hBQU","a915fb954a5b62ac":"3LMRh","76b8747fb257c65c":"5rG5o","f6f43e3eaadd9ae9":"fInsE","d12cab846fc3f945":"fuYwM"}],"3LMRh":[function(require,module,exports) {
var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

},{}],"5rG5o":[function(require,module,exports) {
var global = arguments[3];
var process = require("6b9fe6b7a0bbf941");
var defaultEncoding;
/* istanbul ignore next */ if (global.process && global.process.browser) defaultEncoding = "utf-8";
else if (global.process && global.process.version) {
    var pVersionMajor = parseInt(process.version.split(".")[0].slice(1), 10);
    defaultEncoding = pVersionMajor >= 6 ? "utf-8" : "binary";
} else defaultEncoding = "utf-8";
module.exports = defaultEncoding;

},{"6b9fe6b7a0bbf941":"5QIF0"}],"fInsE":[function(require,module,exports) {
var md5 = require("1e04e1c2d51cd13d");
var RIPEMD160 = require("42015ac33af139f8");
var sha = require("a7eb8e83614997ca");
var Buffer = require("290c92d9373f664d").Buffer;
var checkParameters = require("1b04775c4713da3d");
var defaultEncoding = require("b290a762e8475e9f");
var toBuffer = require("82c0eccfe5526b2c");
var ZEROS = Buffer.alloc(128);
var sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function Hmac(alg, key, saltLen) {
    var hash = getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = Buffer.concat([
        key,
        ZEROS
    ], blocksize);
    var ipad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    var opad = Buffer.allocUnsafe(blocksize + sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = sizes[alg];
}
Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function getDigest(alg) {
    function shaFunc(data) {
        return sha(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new RIPEMD160().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return md5;
    return shaFunc;
}
function pbkdf2(password, salt, iterations, keylen, digest) {
    checkParameters(iterations, keylen);
    password = toBuffer(password, defaultEncoding, "Password");
    salt = toBuffer(salt, defaultEncoding, "Salt");
    digest = digest || "sha1";
    var hmac = new Hmac(digest, password, salt.length);
    var DK = Buffer.allocUnsafe(keylen);
    var block1 = Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = pbkdf2;

},{"1e04e1c2d51cd13d":"aXxZy","42015ac33af139f8":"iRD8I","a7eb8e83614997ca":"7ZUZ8","290c92d9373f664d":"6hBQU","1b04775c4713da3d":"3LMRh","b290a762e8475e9f":"5rG5o","82c0eccfe5526b2c":"fuYwM"}],"fuYwM":[function(require,module,exports) {
var Buffer = require("cc6579c2e1506b6d").Buffer;
module.exports = function(thing, encoding, name) {
    if (Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

},{"cc6579c2e1506b6d":"6hBQU"}],"eoEgH":[function(require,module,exports) {
var DES = require("9fddd06e02c9f65f");
var aes = require("c080e0e074a10616");
var aesModes = require("deca4106fa6cf801");
var desModes = require("7141e0762da15af0");
var ebtk = require("ca278cb2f2d32ea3");
function createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, keyLen, ivLen);
    return createCipheriv(suite, keys.key, keys.iv);
}
function createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if (aesModes[suite]) {
        keyLen = aesModes[suite].key;
        ivLen = aesModes[suite].iv;
    } else if (desModes[suite]) {
        keyLen = desModes[suite].key * 8;
        ivLen = desModes[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, keyLen, ivLen);
    return createDecipheriv(suite, keys.key, keys.iv);
}
function createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createCipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv);
    if (desModes[suite]) return new DES({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function getCiphers() {
    return Object.keys(desModes).concat(aes.getCiphers());
}
exports.createCipher = exports.Cipher = createCipher;
exports.createCipheriv = exports.Cipheriv = createCipheriv;
exports.createDecipher = exports.Decipher = createDecipher;
exports.createDecipheriv = exports.Decipheriv = createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"9fddd06e02c9f65f":"8PYCN","c080e0e074a10616":"kfyVF","deca4106fa6cf801":"5Xdi3","7141e0762da15af0":"2UhGP","ca278cb2f2d32ea3":"1bdUb"}],"8PYCN":[function(require,module,exports) {
var CipherBase = require("4df025afd5a20f9f");
var des = require("8ea0942e2f125a3");
var inherits = require("8a7d640fedcdd788");
var Buffer = require("c9c674d2a2a092c4").Buffer;
var modes = {
    "des-ede3-cbc": des.CBC.instantiate(des.EDE),
    "des-ede3": des.EDE,
    "des-ede-cbc": des.CBC.instantiate(des.EDE),
    "des-ede": des.EDE,
    "des-cbc": des.CBC.instantiate(des.DES),
    "des-ecb": des.DES
};
modes.des = modes["des-cbc"];
modes.des3 = modes["des-ede3-cbc"];
module.exports = DES;
inherits(DES, CipherBase);
function DES(opts) {
    CipherBase.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!Buffer.isBuffer(key)) key = Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!Buffer.isBuffer(iv)) iv = Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
DES.prototype._update = function(data) {
    return Buffer.from(this._des.update(data));
};
DES.prototype._final = function() {
    return Buffer.from(this._des.final());
};

},{"4df025afd5a20f9f":"7VZSW","8ea0942e2f125a3":"3HhGU","8a7d640fedcdd788":"8LxVj","c9c674d2a2a092c4":"6hBQU"}],"3HhGU":[function(require,module,exports) {
"use strict";
exports.utils = require("c56851640eb0e265");
exports.Cipher = require("22f0b7ac3b9c9316");
exports.DES = require("d0445787359f92a0");
exports.CBC = require("203ada8fdbbff440");
exports.EDE = require("736756ddbc573f7");

},{"c56851640eb0e265":"fXS2z","22f0b7ac3b9c9316":"h7GSw","d0445787359f92a0":"kUYdd","203ada8fdbbff440":"bVXu0","736756ddbc573f7":"7j8TY"}],"fXS2z":[function(require,module,exports) {
"use strict";
exports.readUInt32BE = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
exports.ip = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.rip = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.pc1 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.r28shl = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
exports.pc2 = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> pc2table[i] & 0x1;
    }
    for(var i = len; i < pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
exports.expand = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
exports.substitute = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
exports.permute = function permute(num) {
    var out = 0;
    for(var i = 0; i < permuteTable.length; i++){
        out <<= 1;
        out |= num >>> permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
exports.padSplit = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

},{}],"h7GSw":[function(require,module,exports) {
"use strict";
var assert = require("85cfb697294fd1d8");
function Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = Cipher;
Cipher.prototype._init = function _init() {
// Might be overrided
};
Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    assert.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

},{"85cfb697294fd1d8":"cKbUa"}],"cKbUa":[function(require,module,exports) {
module.exports = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

},{}],"kUYdd":[function(require,module,exports) {
"use strict";
var assert = require("2e43e10aa2de50ed");
var inherits = require("551480b8aa09d318");
var utils = require("b6dc5b7926f5a82f");
var Cipher = require("38547d2f1967e2cd");
function DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function DES(options) {
    Cipher.call(this, options);
    var state = new DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;
DES.create = function create(options) {
    return new DES(options);
};
var shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    assert.equal(key.length, this.blockSize, "Invalid key length");
    var kL = utils.readUInt32BE(key, 0);
    var kR = utils.readUInt32BE(key, 4);
    utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = shiftTable[i >>> 1];
        kL = utils.r28shl(kL, shift);
        kR = utils.r28shl(kR, shift);
        utils.pc2(kL, kR, state.keys, i);
    }
};
DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = utils.readUInt32BE(inp, inOff);
    var r = utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    utils.writeUInt32BE(out, l, outOff);
    utils.writeUInt32BE(out, r, outOff + 4);
};
DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)assert.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    utils.rip(r, l, out, off);
};
DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = utils.substitute(keyL, keyR);
        var f = utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    utils.rip(l, r, out, off);
};

},{"2e43e10aa2de50ed":"cKbUa","551480b8aa09d318":"8LxVj","b6dc5b7926f5a82f":"fXS2z","38547d2f1967e2cd":"h7GSw"}],"bVXu0":[function(require,module,exports) {
"use strict";
var assert = require("63ac301527fc117b");
var inherits = require("7d48f4d3d39d3b86");
var proto = {};
function CBCState(iv) {
    assert.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    inherits(CBC, Base);
    var keys = Object.keys(proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
exports.instantiate = instantiate;
proto._cbcInit = function _cbcInit() {
    var state = new CBCState(this.options.iv);
    this._cbcState = state;
};
proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

},{"63ac301527fc117b":"cKbUa","7d48f4d3d39d3b86":"8LxVj"}],"7j8TY":[function(require,module,exports) {
"use strict";
var assert = require("d5bfc55b5aa12c8d");
var inherits = require("39ce41101e752862");
var Cipher = require("ba2db61b5607fad4");
var DES = require("f13080dd5389ba87");
function EDEState(type, key) {
    assert.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        DES.create({
            type: "encrypt",
            key: k1
        }),
        DES.create({
            type: "decrypt",
            key: k2
        }),
        DES.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        DES.create({
            type: "decrypt",
            key: k3
        }),
        DES.create({
            type: "encrypt",
            key: k2
        }),
        DES.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function EDE(options) {
    Cipher.call(this, options);
    var state = new EDEState(this.type, this.options.key);
    this._edeState = state;
}
inherits(EDE, Cipher);
module.exports = EDE;
EDE.create = function create(options) {
    return new EDE(options);
};
EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;

},{"d5bfc55b5aa12c8d":"cKbUa","39ce41101e752862":"8LxVj","ba2db61b5607fad4":"h7GSw","f13080dd5389ba87":"kUYdd"}],"kfyVF":[function(require,module,exports) {
var ciphers = require("852cf53431a1f811");
var deciphers = require("cf65999dbb4c5e15");
var modes = require("deceb76ffb34f58f");
function getCiphers() {
    return Object.keys(modes);
}
exports.createCipher = exports.Cipher = ciphers.createCipher;
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv;
exports.createDecipher = exports.Decipher = deciphers.createDecipher;
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv;
exports.listCiphers = exports.getCiphers = getCiphers;

},{"852cf53431a1f811":"77BxS","cf65999dbb4c5e15":"TiWWJ","deceb76ffb34f58f":"3N6sl"}],"77BxS":[function(require,module,exports) {
var MODES = require("634015cf40a677fe");
var AuthCipher = require("ca7c032525082be8");
var Buffer = require("2bd35013f47d4062").Buffer;
var StreamCipher = require("2b03aae3a1335af6");
var Transform = require("138a78277ccfd16f");
var aes = require("cc8a1e2b2934f08f");
var ebtk = require("b149eab8b94068d4");
var inherits = require("ebc328fc178264d2");
function Cipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Cipher, Transform);
Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
var PADDING = Buffer.alloc(16, 0x10);
Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals(PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function createCipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new StreamCipher(config.module, password, iv);
    else if (config.type === "auth") return new AuthCipher(config.module, password, iv);
    return new Cipher(config.module, password, iv);
}
function createCipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, config.key, config.iv);
    return createCipheriv(suite, keys.key, keys.iv);
}
exports.createCipheriv = createCipheriv;
exports.createCipher = createCipher;

},{"634015cf40a677fe":"5Xdi3","ca7c032525082be8":"f9UFM","2bd35013f47d4062":"6hBQU","2b03aae3a1335af6":"dpWV9","138a78277ccfd16f":"7VZSW","cc8a1e2b2934f08f":"ig7sU","b149eab8b94068d4":"1bdUb","ebc328fc178264d2":"8LxVj"}],"5Xdi3":[function(require,module,exports) {
var modeModules = {
    ECB: require("c49ddaf3154fac1e"),
    CBC: require("7c781e2d9206f623"),
    CFB: require("12dfbd130b5827a1"),
    CFB8: require("ae02434166690767"),
    CFB1: require("15ddc45cf76ec123"),
    OFB: require("62e3e290f0879f98"),
    CTR: require("1e6578fa70b860a7"),
    GCM: require("1e6578fa70b860a7")
};
var modes = require("b313067770c9aed2");
for(var key in modes)modes[key].module = modeModules[modes[key].mode];
module.exports = modes;

},{"c49ddaf3154fac1e":"3gVOm","7c781e2d9206f623":"dymJ2","12dfbd130b5827a1":"jA8fi","ae02434166690767":"gg4Yp","15ddc45cf76ec123":"8RbVo","62e3e290f0879f98":"ipVmA","1e6578fa70b860a7":"guWve","b313067770c9aed2":"3N6sl"}],"3gVOm":[function(require,module,exports) {
exports.encrypt = function(self, block) {
    return self._cipher.encryptBlock(block);
};
exports.decrypt = function(self, block) {
    return self._cipher.decryptBlock(block);
};

},{}],"dymJ2":[function(require,module,exports) {
var xor = require("587e692127ea2c31");
exports.encrypt = function(self, block) {
    var data = xor(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
exports.decrypt = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return xor(out, pad);
};

},{"587e692127ea2c31":"5ceZM"}],"5ceZM":[function(require,module,exports) {
var Buffer = require("ccae1b11eb3a9ec8").Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

},{"ccae1b11eb3a9ec8":"l5Twm"}],"jA8fi":[function(require,module,exports) {
var Buffer = require("7747ec7a535c746a").Buffer;
var xor = require("fe4415d84c8f2a05");
function encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = xor(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
exports.encrypt = function(self, data, decrypt) {
    var out = Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = Buffer.concat([
                out,
                encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = Buffer.concat([
                out,
                encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

},{"7747ec7a535c746a":"6hBQU","fe4415d84c8f2a05":"5ceZM"}],"gg4Yp":[function(require,module,exports) {
var Buffer = require("36c8b61b54eac90b").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = Buffer.concat([
        self._prev.slice(1),
        Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"36c8b61b54eac90b":"6hBQU"}],"8RbVo":[function(require,module,exports) {
var Buffer = require("5eb46e1eefd15734").Buffer;
function encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = Buffer.allocUnsafe(buffer.length);
    buffer = Buffer.concat([
        buffer,
        Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
exports.encrypt = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = encryptByte(self, chunk[i], decrypt);
    return out;
};

},{"5eb46e1eefd15734":"6hBQU"}],"ipVmA":[function(require,module,exports) {
var Buffer = require("b3ff65e516d49ef1").Buffer;
var xor = require("7f0c2ff10cf58835");
function getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
exports.encrypt = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = Buffer.concat([
        self._cache,
        getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"b3ff65e516d49ef1":"l5Twm","7f0c2ff10cf58835":"5ceZM"}],"guWve":[function(require,module,exports) {
var xor = require("9e40d7dfdb715c7");
var Buffer = require("53cb1eb6f102a1c9").Buffer;
var incr32 = require("57780b841d591d93");
function getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    incr32(self._prev);
    return out;
}
var blockSize = 16;
exports.encrypt = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / blockSize);
    var start = self._cache.length;
    self._cache = Buffer.concat([
        self._cache,
        Buffer.allocUnsafe(chunkNum * blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = getBlock(self);
        var offset = start + i * blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return xor(chunk, pad);
};

},{"9e40d7dfdb715c7":"5ceZM","53cb1eb6f102a1c9":"6hBQU","57780b841d591d93":"kT2Ms"}],"kT2Ms":[function(require,module,exports) {
function incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = incr32;

},{}],"3N6sl":[function(require,module,exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

},{}],"f9UFM":[function(require,module,exports) {
var aes = require("b0edcf3ce18ae4ef");
var Buffer = require("2c8f7ba691c38788").Buffer;
var Transform = require("1432783a1879aa01");
var inherits = require("60e0d0bfceaaf739");
var GHASH = require("f76de0f4100ad13f");
var xor = require("a9c82903acf3978e");
var incr32 = require("4e429278132497a7");
function xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return Buffer.concat([
            iv,
            Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new GHASH(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update(Buffer.alloc(toPad, 0));
    }
    ghash.update(Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = Buffer.from(self._finID);
    incr32(out);
    return out;
}
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    var h = Buffer.alloc(4, 0);
    this._cipher = new aes.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new GHASH(ck);
    iv = calcIv(this, iv, ck);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = StreamCipher;

},{"b0edcf3ce18ae4ef":"ig7sU","2c8f7ba691c38788":"6hBQU","1432783a1879aa01":"7VZSW","60e0d0bfceaaf739":"8LxVj","f76de0f4100ad13f":"h80xv","a9c82903acf3978e":"5ceZM","4e429278132497a7":"kT2Ms"}],"ig7sU":[function(require,module,exports) {
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var Buffer = require("9c4f04f75f375be").Buffer;
function asUInt32Array(buf) {
    if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function AES(key) {
    this._key = asUInt32Array(key);
    this._reset();
}
AES.blockSize = 16;
AES.keySize = 32;
AES.prototype.blockSize = AES.blockSize;
AES.prototype.keySize = AES.keySize;
AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
            t ^= RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = G.SBOX[t >>> 24] << 24 | G.SBOX[t >>> 16 & 0xff] << 16 | G.SBOX[t >>> 8 & 0xff] << 8 | G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[tt >>> 16 & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[tt >>> 8 & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
AES.prototype.encryptBlockRaw = function(M) {
    M = asUInt32Array(M);
    return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds);
};
AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
AES.prototype.decryptBlock = function(M) {
    M = asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds);
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
AES.prototype.scrub = function() {
    scrubVec(this._keySchedule);
    scrubVec(this._invKeySchedule);
    scrubVec(this._key);
};
module.exports.AES = AES;

},{"9c4f04f75f375be":"6hBQU"}],"h80xv":[function(require,module,exports) {
var Buffer = require("815beeecbe039d1a").Buffer;
var ZEROES = Buffer.alloc(16, 0);
function toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function fromArray(out) {
    var buf = Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function GHASH(key) {
    this.h = key;
    this.state = Buffer.alloc(16, 0);
    this.cache = Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
GHASH.prototype._multiply = function() {
    var Vi = toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = fromArray(Zi);
};
GHASH.prototype.update = function(buf) {
    this.cache = Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash(Buffer.concat([
        this.cache,
        ZEROES
    ], 16));
    this.ghash(fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = GHASH;

},{"815beeecbe039d1a":"6hBQU"}],"dpWV9":[function(require,module,exports) {
var aes = require("499d62308d7dac40");
var Buffer = require("bc4a1f7113303d58").Buffer;
var Transform = require("e701745abb80bc49");
var inherits = require("3765f10ec3d7a831");
function StreamCipher(mode, key, iv, decrypt) {
    Transform.call(this);
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._cache = Buffer.allocUnsafe(0);
    this._secCache = Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
inherits(StreamCipher, Transform);
StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = StreamCipher;

},{"499d62308d7dac40":"ig7sU","bc4a1f7113303d58":"6hBQU","e701745abb80bc49":"7VZSW","3765f10ec3d7a831":"8LxVj"}],"1bdUb":[function(require,module,exports) {
var Buffer = require("adb33291e0f9c65a").Buffer;
var MD5 = require("15f984dc9e3797d9");
/* eslint-disable camelcase */ function EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!Buffer.isBuffer(password)) password = Buffer.from(password, "binary");
    if (salt) {
        if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = Buffer.alloc(keyLen);
    var iv = Buffer.alloc(ivLen || 0);
    var tmp = Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new MD5();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = EVP_BytesToKey;

},{"adb33291e0f9c65a":"6hBQU","15f984dc9e3797d9":"i9uFm"}],"TiWWJ":[function(require,module,exports) {
var AuthCipher = require("2f5914bdcee0aab2");
var Buffer = require("2eedc5cbfd1eafeb").Buffer;
var MODES = require("2b861a45e2a2d1fe");
var StreamCipher = require("54b6d333d74ae9c8");
var Transform = require("4b438dd1327af64e");
var aes = require("928aea47daff81dc");
var ebtk = require("25542df8da1646fe");
var inherits = require("153b885d89d2089e");
function Decipher(mode, key, iv) {
    Transform.call(this);
    this._cache = new Splitter();
    this._last = void 0;
    this._cipher = new aes.AES(key);
    this._prev = Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
inherits(Decipher, Transform);
Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return Buffer.concat(out);
};
Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function Splitter() {
    this.cache = Buffer.allocUnsafe(0);
}
Splitter.prototype.add = function(data) {
    this.cache = Buffer.concat([
        this.cache,
        data
    ]);
};
Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function createDecipheriv(suite, password, iv) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new StreamCipher(config.module, password, iv, true);
    else if (config.type === "auth") return new AuthCipher(config.module, password, iv, true);
    return new Decipher(config.module, password, iv);
}
function createDecipher(suite, password) {
    var config = MODES[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = ebtk(password, false, config.key, config.iv);
    return createDecipheriv(suite, keys.key, keys.iv);
}
exports.createDecipher = createDecipher;
exports.createDecipheriv = createDecipheriv;

},{"2f5914bdcee0aab2":"f9UFM","2eedc5cbfd1eafeb":"6hBQU","2b861a45e2a2d1fe":"5Xdi3","54b6d333d74ae9c8":"dpWV9","4b438dd1327af64e":"7VZSW","928aea47daff81dc":"ig7sU","25542df8da1646fe":"1bdUb","153b885d89d2089e":"8LxVj"}],"2UhGP":[function(require,module,exports) {
exports["des-ecb"] = {
    key: 8,
    iv: 0
};
exports["des-cbc"] = exports.des = {
    key: 8,
    iv: 8
};
exports["des-ede3-cbc"] = exports.des3 = {
    key: 24,
    iv: 8
};
exports["des-ede3"] = {
    key: 24,
    iv: 0
};
exports["des-ede-cbc"] = {
    key: 16,
    iv: 8
};
exports["des-ede"] = {
    key: 16,
    iv: 0
};

},{}],"lqXbp":[function(require,module,exports) {
var Buffer = require("55a084ce1a29baa3").Buffer;
var generatePrime = require("5ed99cf028c947ad");
var primes = require("8da23ed5d7edf952");
var DH = require("981b8db942febaf3");
function getDiffieHellman(mod) {
    var prime = new Buffer(primes[mod].prime, "hex");
    var gen = new Buffer(primes[mod].gen, "hex");
    return new DH(prime, gen);
}
var ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function createDiffieHellman(prime, enc, generator, genc) {
    if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) return createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new Buffer([
        2
    ]);
    if (!Buffer.isBuffer(generator)) generator = new Buffer(generator, genc);
    if (typeof prime === "number") return new DH(generatePrime(prime, generator), generator, true);
    if (!Buffer.isBuffer(prime)) prime = new Buffer(prime, enc);
    return new DH(prime, generator, true);
}
exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman;
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman;

},{"55a084ce1a29baa3":"l5Twm","5ed99cf028c947ad":"qxbJR","8da23ed5d7edf952":"8ef5Z","981b8db942febaf3":"2I8Rm"}],"qxbJR":[function(require,module,exports) {
var randomBytes = require("e11b752ebf414e01");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = require("6139735ee181267b");
var TWENTYFOUR = new BN(24);
var MillerRabin = require("7b3f73f9ab7b2b6a");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;
function _getPrimes() {
    if (primes !== null) return primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    primes = res;
    return res;
}
function simpleSieve(p) {
    var primes = _getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function fermatTest(p) {
    var red = BN.mont(p);
    return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new BN([
            0x8c,
            0x7b
        ]);
        else return new BN([
            0x8c,
            0x27
        ]);
    }
    gen = new BN(gen);
    var num, n2;
    while(true){
        num = new BN(randomBytes(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd(ONE);
        if (!num.testn(1)) num.iadd(TWO);
        if (!gen.cmp(TWO)) while(num.mod(TWENTYFOUR).cmp(ELEVEN))num.iadd(FOUR);
        else if (!gen.cmp(FIVE)) while(num.mod(TEN).cmp(THREE))num.iadd(FOUR);
        n2 = num.shrn(1);
        if (simpleSieve(n2) && simpleSieve(num) && fermatTest(n2) && fermatTest(num) && millerRabin.test(n2) && millerRabin.test(num)) return num;
    }
}

},{"e11b752ebf414e01":"c6z4K","6139735ee181267b":"4EiPO","7b3f73f9ab7b2b6a":"gMHDm"}],"4EiPO":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("a4b3a214327293bc").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"a4b3a214327293bc":"13Pcp"}],"gMHDm":[function(require,module,exports) {
var bn = require("31d279a7646d17e9");
var brorand = require("1ed277e13aa258c6");
function MillerRabin(rand) {
    this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;
MillerRabin.create = function create(rand) {
    return new MillerRabin(rand);
};
MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new bn(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = bn.mont(n);
    var rone = new bn(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new bn(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

},{"31d279a7646d17e9":"iaRkH","1ed277e13aa258c6":"dzcfb"}],"iaRkH":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1a01f12e7676c433").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1a01f12e7676c433":"13Pcp"}],"dzcfb":[function(require,module,exports) {
var r;
module.exports = function rand(len) {
    if (!r) r = new Rand(null);
    return r.generate(len);
};
function Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = Rand;
Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};
if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var crypto = require("e8ad0674730919a8");
    if (typeof crypto.randomBytes !== "function") throw new Error("Not supported");
    Rand.prototype._rand = function _rand(n) {
        return crypto.randomBytes(n);
    };
} catch (e) {}

},{"e8ad0674730919a8":"13Pcp"}],"8ef5Z":[function(require,module,exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

},{}],"2I8Rm":[function(require,module,exports) {
var Buffer = require("18c258c24cda4205").Buffer;
var BN = require("6cfaed55db270425");
var MillerRabin = require("8bc0d9823ee74460");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = require("dd39d03f4b3404fc");
var randomBytes = require("e2757e55299a3ebc");
module.exports = DH;
function setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this._pub = new BN(pub);
    return this;
}
function setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    this._priv = new BN(priv);
    return this;
}
var primeCache = {};
function checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in primeCache) return primeCache[hex];
    var error = 0;
    if (prime.isEven() || !primes.simpleSieve || !primes.fermatTest(prime) || !millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        primeCache[hex] = error;
        return error;
    }
    if (!millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod(TEN);
            if (rem.cmp(THREE) && rem.cmp(SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    primeCache[hex] = error;
    return error;
}
function DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new BN(prime);
    this._prime = BN.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = setPublicKey;
        this.setPrivateKey = setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty(DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new BN(randomBytes(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
DH.prototype.computeSecret = function(other) {
    other = new BN(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new Buffer(prime.length - out.length);
        front.fill(0);
        out = Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
DH.prototype.getPublicKey = function getPublicKey(enc) {
    return formatReturnValue(this._pub, enc);
};
DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return formatReturnValue(this._priv, enc);
};
DH.prototype.getPrime = function(enc) {
    return formatReturnValue(this.__prime, enc);
};
DH.prototype.getGenerator = function(enc) {
    return formatReturnValue(this._gen, enc);
};
DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(gen)) gen = new Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new BN(gen);
    return this;
};
function formatReturnValue(bn, enc) {
    var buf = new Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"18c258c24cda4205":"l5Twm","6cfaed55db270425":"4EiPO","8bc0d9823ee74460":"gMHDm","dd39d03f4b3404fc":"qxbJR","e2757e55299a3ebc":"c6z4K"}],"9AaKM":[function(require,module,exports) {
"use strict";
var Buffer = require("9c72b70d69889676").Buffer;
var createHash = require("efe64c48bedfa38e");
var stream = require("6a5343e9b2081ca8");
var inherits = require("f95e32eac8325984");
var sign = require("6e9f6edb752a2c10");
var verify = require("c2f6e4379d1db430");
var algorithms = require("2d93707c75adaee");
Object.keys(algorithms).forEach(function(key) {
    algorithms[key].id = Buffer.from(algorithms[key].id, "hex");
    algorithms[key.toLowerCase()] = algorithms[key];
});
function Sign(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Sign, stream.Writable);
Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? Buffer.from(data, enc) : data);
    return this;
};
Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = sign(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function Verify(algorithm) {
    stream.Writable.call(this);
    var data = algorithms[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = createHash(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
inherits(Verify, stream.Writable);
Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? Buffer.from(data, enc) : data);
    return this;
};
Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return verify(sigBuffer, hash, key, this._signType, this._tag);
};
function createSign(algorithm) {
    return new Sign(algorithm);
}
function createVerify(algorithm) {
    return new Verify(algorithm);
}
module.exports = {
    Sign: createSign,
    Verify: createVerify,
    createSign: createSign,
    createVerify: createVerify
};

},{"9c72b70d69889676":"6hBQU","efe64c48bedfa38e":"iwHvk","6a5343e9b2081ca8":"5ZXEz","f95e32eac8325984":"8LxVj","6e9f6edb752a2c10":"hgwxo","c2f6e4379d1db430":"k3ZfA","2d93707c75adaee":"eT3Fy"}],"5ZXEz":[function(require,module,exports) {
exports = module.exports = require("392bf23263928896");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("b3e7e17c8992e180");
exports.Duplex = require("13e76ab91fcbc4e9");
exports.Transform = require("e63a48f5df979c3f");
exports.PassThrough = require("ef010675ea82302");

},{"392bf23263928896":"1JXpG","b3e7e17c8992e180":"9lAVw","13e76ab91fcbc4e9":"edeRU","e63a48f5df979c3f":"bIiom","ef010675ea82302":"lYEOa"}],"1JXpG":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("acdc8d728eafc3c");
"use strict";
/*<replacement>*/ var pna = require("26c9194cf303b569");
/*</replacement>*/ module.exports = Readable;
/*<replacement>*/ var isArray = require("f0ff2feb5ac2ea96");
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("7baf8ed26f8124bf").EventEmitter;
var EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("dafc1b6fa55a5131");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("438bde9908b6c1de").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ /*<replacement>*/ var util = Object.create(require("548a9f63e24b6c89"));
util.inherits = require("30014b4398bf8f8f");
/*</replacement>*/ /*<replacement>*/ var debugUtil = require("4c92d286379dd843");
var debug = void 0;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function() {};
/*</replacement>*/ var BufferList = require("606856df3001c587");
var destroyImpl = require("6fe23f38e6cfc872");
var StringDecoder;
util.inherits(Readable, Stream);
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream) {
    Duplex = Duplex || require("bc3aa255fbc67c9c");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("c197c900df82ce95").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("bc3aa255fbc67c9c");
    if (!(this instanceof Readable)) return new Readable(options);
    this._readableState = new ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return needMoreData(state);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("c197c900df82ce95").StringDecoder;
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) pna.nextTick(emitReadable_, stream);
        else emitReadable_(stream);
    }
}
function emitReadable_(stream) {
    debug("emit readable");
    stream.emit("readable");
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        pna.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) pna.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) pna.nextTick(nReadingNextTick, this);
            else if (state.length) emitReadable(this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        state.flowing = true;
        resume(this, state);
    }
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        pna.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    if (!state.reading) {
        debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        pna.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"acdc8d728eafc3c":"5QIF0","26c9194cf303b569":"3FsOo","f0ff2feb5ac2ea96":"grrgb","7baf8ed26f8124bf":"fqTtD","dafc1b6fa55a5131":"bFZFl","438bde9908b6c1de":"dK7yc","548a9f63e24b6c89":"htPre","30014b4398bf8f8f":"8LxVj","4c92d286379dd843":"13Pcp","606856df3001c587":"2GLCH","6fe23f38e6cfc872":"4BMvQ","bc3aa255fbc67c9c":"edeRU","c197c900df82ce95":"c5r4W"}],"3FsOo":[function(require,module,exports) {
var process = require("36724de317ab1d63");
"use strict";
if (typeof process === "undefined" || !process.version || process.version.indexOf("v0.") === 0 || process.version.indexOf("v1.") === 0 && process.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: nextTick
};
else module.exports = process;
function nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return process.nextTick(fn);
        case 2:
            return process.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return process.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return process.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return process.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

},{"36724de317ab1d63":"5QIF0"}],"grrgb":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"bFZFl":[function(require,module,exports) {
module.exports = require("bfecde69246b8387").EventEmitter;

},{"bfecde69246b8387":"fqTtD"}],"dK7yc":[function(require,module,exports) {
/* eslint-disable node/no-deprecated-api */ var buffer = require("c820c533cb2bf72b");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"c820c533cb2bf72b":"l5Twm"}],"htPre":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return objectToString(arg) === "[object Array]";
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
function isError(e) {
    return objectToString(e) === "[object Error]" || e instanceof Error;
}
exports.isError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("552a2cbe55fe12b9").Buffer.isBuffer;
function objectToString(o) {
    return Object.prototype.toString.call(o);
}

},{"552a2cbe55fe12b9":"l5Twm"}],"2GLCH":[function(require,module,exports) {
"use strict";
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var Buffer = require("bb3411b2f31d2ce8").Buffer;
var util = require("42054142ae757f87");
function copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return Buffer.alloc(0);
        var ret = Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if (util && util.inspect && util.inspect.custom) module.exports.prototype[util.inspect.custom] = function() {
    var obj = util.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

},{"bb3411b2f31d2ce8":"dK7yc","42054142ae757f87":"13Pcp"}],"4BMvQ":[function(require,module,exports) {
"use strict";
/*<replacement>*/ var pna = require("e50943071015c04b");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) pna.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) pna.nextTick(emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                pna.nextTick(emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy
};

},{"e50943071015c04b":"3FsOo"}],"edeRU":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";
/*<replacement>*/ var pna = require("c94fdf0143e48da8");
/*</replacement>*/ /*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
/*<replacement>*/ var util = Object.create(require("ff0b45ab1837c906"));
util.inherits = require("e57c79c5df54e9fc");
/*</replacement>*/ var Readable = require("cfff40011760149c");
var Writable = require("68203b9ff124688b");
util.inherits(Duplex, Readable);
// avoid scope creep, the keys array can then be collected
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", onend);
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    pna.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    pna.nextTick(cb, err);
};

},{"c94fdf0143e48da8":"3FsOo","ff0b45ab1837c906":"htPre","e57c79c5df54e9fc":"8LxVj","cfff40011760149c":"1JXpG","68203b9ff124688b":"9lAVw"}],"9lAVw":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
"use strict";
/*<replacement>*/ var pna = require("7e686eccf74ab4e6");
/*</replacement>*/ module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var asyncWrite = (0, pna.nextTick);
/*</replacement>*/ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var util = Object.create(require("dd076da3559409cf"));
util.inherits = require("2fb147f74ec047eb");
/*</replacement>*/ /*<replacement>*/ var internalUtil = {
    deprecate: require("11c37a95821e648")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("b40e70df911a72c6");
/*</replacement>*/ /*<replacement>*/ var Buffer = require("c2fb7c9e9719dbe7").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/ var destroyImpl = require("1eb3dbe751a6248a");
util.inherits(Writable, Stream);
function nop() {}
function WritableState(options, stream) {
    Duplex = Duplex || require("16a38fd16351fed3");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("16a38fd16351fed3");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) return new Writable(options);
    this._writableState = new WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    pna.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        pna.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ended) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        pna.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        pna.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) /*<replacement>*/ asyncWrite(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
};
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            pna.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) pna.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

},{"7e686eccf74ab4e6":"3FsOo","dd076da3559409cf":"htPre","2fb147f74ec047eb":"8LxVj","11c37a95821e648":"3YafI","b40e70df911a72c6":"bFZFl","c2fb7c9e9719dbe7":"dK7yc","1eb3dbe751a6248a":"4BMvQ","16a38fd16351fed3":"edeRU"}],"c5r4W":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("5caf6e4647a8dd1f").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"5caf6e4647a8dd1f":"eOuPb"}],"eOuPb":[function(require,module,exports) {
/* eslint-disable node/no-deprecated-api */ var buffer = require("35dacd25b906a5c3");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"35dacd25b906a5c3":"l5Twm"}],"bIiom":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var Duplex = require("1617c45a2a1b28cf");
/*<replacement>*/ var util = Object.create(require("bccac3b6bc45030c"));
util.inherits = require("6f7856677d29791c");
/*</replacement>*/ util.inherits(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

},{"1617c45a2a1b28cf":"edeRU","bccac3b6bc45030c":"htPre","6f7856677d29791c":"8LxVj"}],"lYEOa":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("6c6a36bb2f4f7153");
/*<replacement>*/ var util = Object.create(require("665ff71a2d0161c8"));
util.inherits = require("5eded30f0d955323");
/*</replacement>*/ util.inherits(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"6c6a36bb2f4f7153":"bIiom","665ff71a2d0161c8":"htPre","5eded30f0d955323":"8LxVj"}],"hgwxo":[function(require,module,exports) {
"use strict";
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("6ae1d89b9934a98d").Buffer;
var createHmac = require("a8da94153ecfc34b");
var crt = require("51cccb2c4d98daac");
var EC = require("94cc3a287d70a03d").ec;
var BN = require("e83ac2526d8afeba");
var parseKeys = require("892f1603b4523d84");
var curves = require("d22eecc2600c2d97");
var RSA_PKCS1_PADDING = 1;
function sign(hash, key, hashType, signType, tag) {
    var priv = parseKeys(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = crt(pad, priv);
    return out;
}
function ecSign(hash, priv) {
    var curveId = curves[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return Buffer.from(out.toDER());
}
function dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new BN(0);
    var k;
    var H = bits2int(hash, q).mod(q);
    var s = false;
    var kv = getKey(x, q, hash, algo);
    while(s === false){
        k = makeKey(q, kv, algo);
        r = makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new BN(0);
        }
    }
    return toDER(r, s);
}
function toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return Buffer.from(res);
}
function getKey(x, q, hash, algo) {
    x = Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - x.length);
        x = Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = bits2octets(hash, q);
    var v = Buffer.alloc(hlen);
    v.fill(1);
    var k = Buffer.alloc(hlen);
    k = createHmac(algo, k).update(v).update(Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    k = createHmac(algo, k).update(v).update(Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = createHmac(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function bits2int(obits, q) {
    var bits = new BN(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function bits2octets(bits, q) {
    bits = bits2int(bits, q);
    bits = bits.mod(q);
    var out = Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = Buffer.alloc(q.byteLength() - out.length);
        out = Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = createHmac(algo, kv.k).update(kv.v).digest();
            t = Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = bits2int(t, q);
        kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([
            0
        ])).digest();
        kv.v = createHmac(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function makeR(g, k, p, q) {
    return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;

},{"6ae1d89b9934a98d":"6hBQU","a8da94153ecfc34b":"7xH2B","51cccb2c4d98daac":"8SmjR","94cc3a287d70a03d":"fsa07","e83ac2526d8afeba":"x4ItY","892f1603b4523d84":"kha3d","d22eecc2600c2d97":"47Mq1"}],"8SmjR":[function(require,module,exports) {
var Buffer = require("a54d4e6dcf549cd6").Buffer;
var BN = require("5d911a7c773081c");
var randomBytes = require("cfe4d67488897360");
function blind(priv) {
    var r = getr(priv);
    var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new BN(randomBytes(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function crt(msg, priv) {
    var blinds = blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed(BN.mont(priv.prime1));
    var c2 = blinded.toRed(BN.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, "be", len);
}
crt.getr = getr;
module.exports = crt;

},{"a54d4e6dcf549cd6":"l5Twm","5d911a7c773081c":"x4ItY","cfe4d67488897360":"c6z4K"}],"fsa07":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("2a438d9f80ccc729").version;
elliptic.utils = require("11dc1cc2c8ec1046");
elliptic.rand = require("465a97970e1e7635");
elliptic.curve = require("2d87f6e20849863a");
elliptic.curves = require("5f656c8e30f15f72");
// Protocols
elliptic.ec = require("a08ba2c08f481c70");
elliptic.eddsa = require("82168ebad05dc21e");

},{"2a438d9f80ccc729":"1Rfs7","11dc1cc2c8ec1046":"bScf2","465a97970e1e7635":"dzcfb","2d87f6e20849863a":"TDt5K","5f656c8e30f15f72":"8mXon","a08ba2c08f481c70":"18apA","82168ebad05dc21e":"djsJE"}],"1Rfs7":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"bScf2":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("c8de895fc166a226");
var minAssert = require("299f4897766ebbc1");
var minUtils = require("298ef03d30e5aac");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"c8de895fc166a226":"f1Jsj","299f4897766ebbc1":"cKbUa","298ef03d30e5aac":"1KIes"}],"f1Jsj":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("b9733830054e0aa9").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"b9733830054e0aa9":"13Pcp"}],"1KIes":[function(require,module,exports) {
"use strict";
var utils = exports;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
utils.toArray = toArray;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
utils.zero2 = zero2;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
utils.toHex = toHex;
utils.encode = function encode(arr, enc) {
    if (enc === "hex") return toHex(arr);
    else return arr;
};

},{}],"TDt5K":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("5861308862489ae6");
curve.short = require("d783eaed5378c550");
curve.mont = require("9ab0eb6020e565d4");
curve.edwards = require("e288cebb6c42e4ae");

},{"5861308862489ae6":"l8X2h","d783eaed5378c550":"2hHmS","9ab0eb6020e565d4":"lCiEg","e288cebb6c42e4ae":"iNPCu"}],"l8X2h":[function(require,module,exports) {
"use strict";
var BN = require("1a09a4ba257ba7ab");
var utils = require("5428e0a2ad594ef4");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"1a09a4ba257ba7ab":"f1Jsj","5428e0a2ad594ef4":"bScf2"}],"2hHmS":[function(require,module,exports) {
"use strict";
var utils = require("c4b5844351271000");
var BN = require("c77af587b504c80f");
var inherits = require("7523cd1d14445538");
var Base = require("1935bd9279880978");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"c4b5844351271000":"bScf2","c77af587b504c80f":"f1Jsj","7523cd1d14445538":"8LxVj","1935bd9279880978":"l8X2h"}],"lCiEg":[function(require,module,exports) {
"use strict";
var BN = require("fd96c1c8c8f9ea6d");
var inherits = require("a32e13b85cdf84eb");
var Base = require("b62d59dafdba3e20");
var utils = require("d2b62737ac9fe936");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"fd96c1c8c8f9ea6d":"f1Jsj","a32e13b85cdf84eb":"8LxVj","b62d59dafdba3e20":"l8X2h","d2b62737ac9fe936":"bScf2"}],"iNPCu":[function(require,module,exports) {
"use strict";
var utils = require("5efc345035c646bb");
var BN = require("d4ec0564d5f7f877");
var inherits = require("d620d726e89b0ede");
var Base = require("92fb2867c8d24c1e");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"5efc345035c646bb":"bScf2","d4ec0564d5f7f877":"f1Jsj","d620d726e89b0ede":"8LxVj","92fb2867c8d24c1e":"l8X2h"}],"8mXon":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("c93b9821af880fe2");
var curve = require("d92e038aede152a5");
var utils = require("9d28f7052861ee84");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("69142e49088ac241");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"c93b9821af880fe2":"dElqS","d92e038aede152a5":"TDt5K","9d28f7052861ee84":"bScf2","69142e49088ac241":"hBEMm"}],"dElqS":[function(require,module,exports) {
var hash = exports;
hash.utils = require("38593959f18bd562");
hash.common = require("31a457752237e8ad");
hash.sha = require("3e37816d2a2fd68d");
hash.ripemd = require("ce5a13b5bd10f171");
hash.hmac = require("c32fbac97a361580");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"38593959f18bd562":"gaAPT","31a457752237e8ad":"1z68J","3e37816d2a2fd68d":"ckm08","ce5a13b5bd10f171":"jxx9f","c32fbac97a361580":"fbLYV"}],"gaAPT":[function(require,module,exports) {
"use strict";
var assert = require("6002b0feade022a4");
var inherits = require("d4826c9d0ff1b1f");
exports.inherits = inherits;
function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if (isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"6002b0feade022a4":"cKbUa","d4826c9d0ff1b1f":"8LxVj"}],"1z68J":[function(require,module,exports) {
"use strict";
var utils = require("e9291abdfb47ee4f");
var assert = require("ea8841b701712638");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"e9291abdfb47ee4f":"gaAPT","ea8841b701712638":"cKbUa"}],"ckm08":[function(require,module,exports) {
"use strict";
exports.sha1 = require("3835379564860fd7");
exports.sha224 = require("bb9f72f042233648");
exports.sha256 = require("20a3b0fa42e37dfe");
exports.sha384 = require("ad4827efa7d953c2");
exports.sha512 = require("301292595a944c1d");

},{"3835379564860fd7":"h9TRQ","bb9f72f042233648":"4rHQO","20a3b0fa42e37dfe":"dM6zL","ad4827efa7d953c2":"2OiZQ","301292595a944c1d":"gqcqX"}],"h9TRQ":[function(require,module,exports) {
"use strict";
var utils = require("b75f3c1442bf9100");
var common = require("a29e68029e4c48f8");
var shaCommon = require("1be62f90a237cba5");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"b75f3c1442bf9100":"gaAPT","a29e68029e4c48f8":"1z68J","1be62f90a237cba5":"gx3FZ"}],"gx3FZ":[function(require,module,exports) {
"use strict";
var utils = require("f0fb61f828bacd0f");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"f0fb61f828bacd0f":"gaAPT"}],"4rHQO":[function(require,module,exports) {
"use strict";
var utils = require("fe5acd040463c159");
var SHA256 = require("fa3503eda3738d05");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
    else return utils.split32(this.h.slice(0, 7), "big");
};

},{"fe5acd040463c159":"gaAPT","fa3503eda3738d05":"dM6zL"}],"dM6zL":[function(require,module,exports) {
"use strict";
var utils = require("32ad3e510bd41f2a");
var common = require("469ad88ad505772a");
var shaCommon = require("fffa7d1ddf1f0b43");
var assert = require("126369f57b5225ed");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"32ad3e510bd41f2a":"gaAPT","469ad88ad505772a":"1z68J","fffa7d1ddf1f0b43":"gx3FZ","126369f57b5225ed":"cKbUa"}],"2OiZQ":[function(require,module,exports) {
"use strict";
var utils = require("a696ee34c45713da");
var SHA512 = require("fff95253fdaa49ea");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
    else return utils.split32(this.h.slice(0, 12), "big");
};

},{"a696ee34c45713da":"gaAPT","fff95253fdaa49ea":"gqcqX"}],"gqcqX":[function(require,module,exports) {
"use strict";
var utils = require("7753b1fa702fbb54");
var common = require("81b6970d75627ce1");
var assert = require("f660976cede694e2");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"7753b1fa702fbb54":"gaAPT","81b6970d75627ce1":"1z68J","f660976cede694e2":"cKbUa"}],"jxx9f":[function(require,module,exports) {
"use strict";
var utils = require("36495272d446418f");
var common = require("ad8cf0490e28e8d7");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "little");
    else return utils.split32(this.h, "little");
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"36495272d446418f":"gaAPT","ad8cf0490e28e8d7":"1z68J"}],"fbLYV":[function(require,module,exports) {
"use strict";
var utils = require("596c08b6835a6e2d");
var assert = require("be527907d4f06808");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"596c08b6835a6e2d":"gaAPT","be527907d4f06808":"cKbUa"}],"hBEMm":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"18apA":[function(require,module,exports) {
"use strict";
var BN = require("ee63e3b3a497d36f");
var HmacDRBG = require("2d077ace592816e9");
var utils = require("64b396c866f9458c");
var curves = require("45c85142bdbe6bb");
var rand = require("664c47e29480ec15");
var assert = utils.assert;
var KeyPair = require("1037090aed6fe722");
var Signature = require("c324c6568a16eb35");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"ee63e3b3a497d36f":"f1Jsj","2d077ace592816e9":"alGiF","64b396c866f9458c":"bScf2","45c85142bdbe6bb":"8mXon","664c47e29480ec15":"dzcfb","1037090aed6fe722":"9jHYg","c324c6568a16eb35":"4SOzU"}],"alGiF":[function(require,module,exports) {
"use strict";
var hash = require("629972fec592198f");
var utils = require("c20531edfb274a2c");
var assert = require("43ff1863ab3fce20");
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = utils.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = utils.toArray(options.pers, options.persEnc || "hex");
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new hash.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils.toArray(entropy, entropyEnc);
    add = utils.toArray(add, addEnc);
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils.encode(res, enc);
};

},{"629972fec592198f":"dElqS","c20531edfb274a2c":"1KIes","43ff1863ab3fce20":"cKbUa"}],"9jHYg":[function(require,module,exports) {
"use strict";
var BN = require("590f885cd6c9c0ee");
var utils = require("c5e5492c7f8a75a5");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"590f885cd6c9c0ee":"f1Jsj","c5e5492c7f8a75a5":"bScf2"}],"4SOzU":[function(require,module,exports) {
"use strict";
var BN = require("d9a236fe93a1d25d");
var utils = require("ea141aa3fe092449");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"d9a236fe93a1d25d":"f1Jsj","ea141aa3fe092449":"bScf2"}],"djsJE":[function(require,module,exports) {
"use strict";
var hash = require("24028bd62cb870f3");
var curves = require("b76f439da91f44c3");
var utils = require("152d1e4c449cc9e4");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("a58cdb34cacac97e");
var Signature = require("15d048aac701be19");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"24028bd62cb870f3":"dElqS","b76f439da91f44c3":"8mXon","152d1e4c449cc9e4":"bScf2","a58cdb34cacac97e":"i8SpN","15d048aac701be19":"aqgKn"}],"i8SpN":[function(require,module,exports) {
"use strict";
var utils = require("117d14292cbb78b8");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"117d14292cbb78b8":"bScf2"}],"aqgKn":[function(require,module,exports) {
"use strict";
var BN = require("1838203efc58f135");
var utils = require("8921fa44362725dd");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"1838203efc58f135":"f1Jsj","8921fa44362725dd":"bScf2"}],"kha3d":[function(require,module,exports) {
"use strict";
var asn1 = require("a33d2f68b0ffe26d");
var aesid = require("c39bbd52d12adb70");
var fixProc = require("7247fe0465255c67");
var ciphers = require("ea725b5eadc96106");
var compat = require("aa2a622927353f9f");
var Buffer = require("11d61e4bc73f5fdc").Buffer;
function decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = aesid[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = compat.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = ciphers.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return Buffer.concat(out);
}
function parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = Buffer.from(buffer);
    var stripped = fixProc(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = asn1.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = asn1.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = asn1.EncryptedPrivateKey.decode(data, "der");
            data = decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = asn1.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return asn1.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return asn1.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: asn1.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = asn1.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
parseKeys.signature = asn1.signature;
module.exports = parseKeys;

},{"a33d2f68b0ffe26d":"5sBTY","c39bbd52d12adb70":"i2Ytl","7247fe0465255c67":"68ze8","ea725b5eadc96106":"kfyVF","aa2a622927353f9f":"aqGHG","11d61e4bc73f5fdc":"6hBQU"}],"5sBTY":[function(require,module,exports) {
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
"use strict";
var asn1 = require("821e6411e0aeb10a");
exports.certificate = require("6bb4fbbd6e2d2384");
var RSAPrivateKey = asn1.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
exports.RSAPrivateKey = RSAPrivateKey;
var RSAPublicKey = asn1.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
exports.RSAPublicKey = RSAPublicKey;
var AlgorithmIdentifier = asn1.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var PublicKey = asn1.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
exports.PublicKey = PublicKey;
var PrivateKeyInfo = asn1.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;
var DSAPrivateKey = asn1.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
exports.DSAPrivateKey = DSAPrivateKey;
exports.DSAparam = asn1.define("DSAparam", function() {
    this["int"]();
});
var ECParameters = asn1.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var ECPrivateKey = asn1.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
exports.ECPrivateKey = ECPrivateKey;
exports.signature = asn1.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

},{"821e6411e0aeb10a":"g4cJU","6bb4fbbd6e2d2384":"3vEad"}],"g4cJU":[function(require,module,exports) {
var asn1 = exports;
asn1.bignum = require("b4f67f473458f037");
asn1.define = require("3a96ab8454f69498").define;
asn1.base = require("82a96f1d67e1a13d");
asn1.constants = require("f666a445bd64a777");
asn1.decoders = require("e200f1dc591d286b");
asn1.encoders = require("5ea4ddb7d1e6fcb9");

},{"b4f67f473458f037":"cMGtA","3a96ab8454f69498":"g59rL","82a96f1d67e1a13d":"aZUCg","f666a445bd64a777":"hnAYr","e200f1dc591d286b":"e4XAX","5ea4ddb7d1e6fcb9":"a4zEQ"}],"cMGtA":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("7f1ee543ef73731a").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"7f1ee543ef73731a":"13Pcp"}],"g59rL":[function(require,module,exports) {
var asn1 = require("ab532762dbbdc666");
var inherits = require("64c493c8ea32f1a7");
var api = exports;
api.define = function define(name, body) {
    return new Entity(name, body);
};
function Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = require("62c08f34eab7465f").runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    inherits(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
    return this.decoders[enc];
};
Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
    return this.encoders[enc];
};
Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

},{"ab532762dbbdc666":"g4cJU","64c493c8ea32f1a7":"8LxVj","62c08f34eab7465f":"7YpEc"}],"7YpEc":[function(require,module,exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

},{}],"aZUCg":[function(require,module,exports) {
var base = exports;
base.Reporter = require("59a43dc644aa14a1").Reporter;
base.DecoderBuffer = require("bb5e01939a3ed5de").DecoderBuffer;
base.EncoderBuffer = require("bb5e01939a3ed5de").EncoderBuffer;
base.Node = require("97802675bd1acef");

},{"59a43dc644aa14a1":"6oBP5","bb5e01939a3ed5de":"9Irxv","97802675bd1acef":"dedTn"}],"6oBP5":[function(require,module,exports) {
var inherits = require("cca99c6acf69321b");
function Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
exports.Reporter = Reporter;
Reporter.prototype.isError = function isError(obj) {
    return obj instanceof ReporterError;
};
Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof ReporterError;
    if (inherited) err = msg;
    else err = new ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
inherits(ReporterError, Error);
ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

},{"cca99c6acf69321b":"8LxVj"}],"9Irxv":[function(require,module,exports) {
var inherits = require("ff35534ecc380ed3");
var Reporter = require("5e377fc82488d72a").Reporter;
var Buffer = require("e61f132f215e12f9").Buffer;
function DecoderBuffer(base, options) {
    Reporter.call(this, options);
    if (!Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;
DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: Reporter.prototype.save.call(this)
    };
};
DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof EncoderBuffer)) item = new EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = Buffer.byteLength(value);
    } else if (Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
exports.EncoderBuffer = EncoderBuffer;
EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if (Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

},{"ff35534ecc380ed3":"8LxVj","5e377fc82488d72a":"aZUCg","e61f132f215e12f9":"l5Twm"}],"dedTn":[function(require,module,exports) {
var Reporter = require("b93dc035fd1a2dd2").Reporter;
var EncoderBuffer = require("b93dc035fd1a2dd2").EncoderBuffer;
var DecoderBuffer = require("b93dc035fd1a2dd2").DecoderBuffer;
var assert = require("1bf7ce79b1c01d8b");
// Supported tags
var tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat(tags);
// Overrided methods list
var overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = Node;
var stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
Node.prototype._init = function init(body) {
    var state = this._baseState;
    assert(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    assert.equal(state.children.length, 1, "Root node can have only one child");
};
Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        assert(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        assert(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
overrided.forEach(function(method) {
    Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
tags.forEach(function(tag) {
    Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        assert(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
Node.prototype.use = function use(item) {
    assert(item);
    var state = this._baseState;
    assert(state.use === null);
    state.use = item;
    return this;
};
Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
Node.prototype.def = function def(val) {
    var state = this._baseState;
    assert(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    assert(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    assert(state.key === null);
    state.key = newKey;
    return this;
};
Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    assert(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    assert(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    assert(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new EncoderBuffer(data, this.reporter);
};
Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) assert(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

},{"b93dc035fd1a2dd2":"aZUCg","1bf7ce79b1c01d8b":"cKbUa"}],"hnAYr":[function(require,module,exports) {
var constants = exports;
// Helper
constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};
constants.der = require("cd34b6c5ba00554c");

},{"cd34b6c5ba00554c":"cQM1Z"}],"cQM1Z":[function(require,module,exports) {
var constants = require("c9de207563729b47");
exports.tagClass = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
exports.tagClassByName = constants._reverse(exports.tagClass);
exports.tag = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
exports.tagByName = constants._reverse(exports.tag);

},{"c9de207563729b47":"hnAYr"}],"e4XAX":[function(require,module,exports) {
var decoders = exports;
decoders.der = require("abb46f93da4a6a9");
decoders.pem = require("f1e062afeaaaac02");

},{"abb46f93da4a6a9":"4DKCt","f1e062afeaaaac02":"2v0Ly"}],"4DKCt":[function(require,module,exports) {
var inherits = require("7c238308bb002386");
var asn1 = require("2acbc866baed26c6");
var base = asn1.base;
var bignum = asn1.bignum;
// Import DER constants
var der = asn1.constants.der;
function DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DERDecoder;
DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof base.DecoderBuffer)) data = new base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, "der", parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

},{"7c238308bb002386":"8LxVj","2acbc866baed26c6":"g4cJU"}],"2v0Ly":[function(require,module,exports) {
var inherits = require("c2d50a9d5a6f334a");
var Buffer = require("883f76082a59dd03").Buffer;
var DERDecoder = require("dc9bd6cca8dafd6");
function PEMDecoder(entity) {
    DERDecoder.call(this, entity);
    this.enc = "pem";
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;
PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new Buffer(base64, "base64");
    return DERDecoder.prototype.decode.call(this, input, options);
};

},{"c2d50a9d5a6f334a":"8LxVj","883f76082a59dd03":"l5Twm","dc9bd6cca8dafd6":"4DKCt"}],"a4zEQ":[function(require,module,exports) {
var encoders = exports;
encoders.der = require("6153180e09514e51");
encoders.pem = require("babaf0c4b3d9210a");

},{"6153180e09514e51":"fbXaV","babaf0c4b3d9210a":"lHowv"}],"fbXaV":[function(require,module,exports) {
var inherits = require("94789e1422bf21a1");
var Buffer = require("41574641d7de4531").Buffer;
var asn1 = require("9d8c942bce7973a8");
var base = asn1.base;
// Import DER constants
var der = asn1.constants.der;
function DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new DERNode();
    this.tree._init(entity.body);
}
module.exports = DEREncoder;
DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function DERNode(parent) {
    base.Node.call(this, "der", parent);
}
inherits(DERNode, base.Node);
DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        two(date.getFullYear()),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        two(date.getFullYear() % 100),
        two(date.getUTCMonth() + 1),
        two(date.getUTCDate()),
        two(date.getUTCHours()),
        two(date.getUTCMinutes()),
        two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new Buffer(numArray);
    }
    if (Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new Buffer(out));
};
DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if (der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= der.tagClassByName[cls || "universal"] << 6;
    return res;
}

},{"94789e1422bf21a1":"8LxVj","41574641d7de4531":"l5Twm","9d8c942bce7973a8":"g4cJU"}],"lHowv":[function(require,module,exports) {
var inherits = require("bc3c7930ded74eee");
var DEREncoder = require("cf885a4234262436");
function PEMEncoder(entity) {
    DEREncoder.call(this, entity);
    this.enc = "pem";
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;
PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = DEREncoder.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

},{"bc3c7930ded74eee":"8LxVj","cf885a4234262436":"fbXaV"}],"3vEad":[function(require,module,exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";
var asn = require("373dc11d39ac511a");
var Time = asn.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var AttributeTypeValue = asn.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var AlgorithmIdentifier = asn.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var SubjectPublicKeyInfo = asn.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use(AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var RelativeDistinguishedName = asn.define("RelativeDistinguishedName", function() {
    this.setof(AttributeTypeValue);
});
var RDNSequence = asn.define("RDNSequence", function() {
    this.seqof(RelativeDistinguishedName);
});
var Name = asn.define("Name", function() {
    this.choice({
        rdnSequence: this.use(RDNSequence)
    });
});
var Validity = asn.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use(Time), this.key("notAfter").use(Time));
});
var Extension = asn.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var TBSCertificate = asn.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use(AlgorithmIdentifier), this.key("issuer").use(Name), this.key("validity").use(Validity), this.key("subject").use(Name), this.key("subjectPublicKeyInfo").use(SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(Extension).optional());
});
var X509Certificate = asn.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use(TBSCertificate), this.key("signatureAlgorithm").use(AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = X509Certificate;

},{"373dc11d39ac511a":"g4cJU"}],"i2Ytl":[function(require,module,exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

},{}],"68ze8":[function(require,module,exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = require("482ca5fecee84bd1");
var ciphers = require("5e77b1b6b79a5d20");
var Buffer = require("fcf1038e6a690508").Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match(findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match(fullRegex);
        decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = Buffer.from(match[2], "hex");
        var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = Buffer.concat(out);
    }
    var tag = key.match(startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

},{"482ca5fecee84bd1":"1bdUb","5e77b1b6b79a5d20":"kfyVF","fcf1038e6a690508":"6hBQU"}],"47Mq1":[function(require,module,exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

},{}],"k3ZfA":[function(require,module,exports) {
"use strict";
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = require("c893e8283afd176a").Buffer;
var BN = require("18576d045784617e");
var EC = require("9429de8047bf329a").ec;
var parseKeys = require("88de5f3d7e6f8c00");
var curves = require("69d69f2e18a199ce");
function verify(sig, hash, key, signType, tag) {
    var pub = parseKeys(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = Buffer.from(pad);
    var red = BN.mont(pub.modulus);
    sig = new BN(sig).toRed(red);
    sig = sig.redPow(new BN(pub.publicExponent));
    sig = Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function ecVerify(sig, hash, pub) {
    var curveId = curves[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = parseKeys.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    checkValue(s, q);
    checkValue(r, q);
    var montp = BN.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new BN(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = verify;

},{"c893e8283afd176a":"6hBQU","18576d045784617e":"x4ItY","9429de8047bf329a":"fsa07","88de5f3d7e6f8c00":"kha3d","69d69f2e18a199ce":"47Mq1"}],"4A8Bn":[function(require,module,exports) {
var Buffer = require("59d8fd0d64d5aa42").Buffer;
var elliptic = require("a6b1ec3b8e72335c");
var BN = require("8c5a992927812eef");
module.exports = function createECDH(curve) {
    return new ECDH(curve);
};
var aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
aliases.p224 = aliases.secp224r1;
aliases.p256 = aliases.secp256r1 = aliases.prime256v1;
aliases.p192 = aliases.secp192r1 = aliases.prime192v1;
aliases.p384 = aliases.secp384r1;
aliases.p521 = aliases.secp521r1;
function ECDH(curve) {
    this.curveType = aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!Buffer.isBuffer(other)) other = new Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return formatReturnValue(out, enc, this.curveType.byteLength);
};
ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return formatReturnValue(key, enc);
};
ECDH.prototype.getPrivateKey = function(enc) {
    return formatReturnValue(this.keys.getPrivate(), enc);
};
ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(pub)) pub = new Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!Buffer.isBuffer(priv)) priv = new Buffer(priv, enc);
    var _priv = new BN(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new Buffer(len - buf.length);
        zeros.fill(0);
        buf = Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

},{"59d8fd0d64d5aa42":"l5Twm","a6b1ec3b8e72335c":"e8UEU","8c5a992927812eef":"e4Pkj"}],"e8UEU":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("e6672bc3ba1c9961").version;
elliptic.utils = require("5bc72f89931ad0f5");
elliptic.rand = require("7f90d752a36f35cf");
elliptic.curve = require("d11da69c91421223");
elliptic.curves = require("6845bad4ed92c3e4");
// Protocols
elliptic.ec = require("b5f2e1f615acc4b");
elliptic.eddsa = require("79ae761761517980");

},{"e6672bc3ba1c9961":"3u0Xw","5bc72f89931ad0f5":"7PLUP","7f90d752a36f35cf":"dzcfb","d11da69c91421223":"3ZY1v","6845bad4ed92c3e4":"ab7Cj","b5f2e1f615acc4b":"6GXut","79ae761761517980":"7YIGW"}],"3u0Xw":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"7PLUP":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("f4cbcf6f6eb25ca0");
var minAssert = require("d8ee30463f95a0fd");
var minUtils = require("997429d6bbd82d59");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"f4cbcf6f6eb25ca0":"kRh32","d8ee30463f95a0fd":"cKbUa","997429d6bbd82d59":"1KIes"}],"kRh32":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1cf9b8cfa268aab5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1cf9b8cfa268aab5":"13Pcp"}],"3ZY1v":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("59d486bd2037506a");
curve.short = require("eb37617ef6927580");
curve.mont = require("be9c662572da2183");
curve.edwards = require("60763dd06fe64e8d");

},{"59d486bd2037506a":"49Ytv","eb37617ef6927580":"kMHPS","be9c662572da2183":"24Z2p","60763dd06fe64e8d":"4i3b7"}],"49Ytv":[function(require,module,exports) {
"use strict";
var BN = require("70865a568c61cc60");
var utils = require("fb5111a3810a8235");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"70865a568c61cc60":"kRh32","fb5111a3810a8235":"7PLUP"}],"kMHPS":[function(require,module,exports) {
"use strict";
var utils = require("89f794ef417dc31c");
var BN = require("c314b0ac30b69c4a");
var inherits = require("6ac4d7c73f24ab9c");
var Base = require("6e622edb7498c94");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"89f794ef417dc31c":"7PLUP","c314b0ac30b69c4a":"kRh32","6ac4d7c73f24ab9c":"8LxVj","6e622edb7498c94":"49Ytv"}],"24Z2p":[function(require,module,exports) {
"use strict";
var BN = require("ebdf19f04f3ed250");
var inherits = require("cb5bb4841a749f68");
var Base = require("51280941230b3f98");
var utils = require("ea7949a80be00261");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"ebdf19f04f3ed250":"kRh32","cb5bb4841a749f68":"8LxVj","51280941230b3f98":"49Ytv","ea7949a80be00261":"7PLUP"}],"4i3b7":[function(require,module,exports) {
"use strict";
var utils = require("7bd66a4710450b08");
var BN = require("ccef46dcf03d45c6");
var inherits = require("19937272cbe23c92");
var Base = require("108c8ead5f54502b");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"7bd66a4710450b08":"7PLUP","ccef46dcf03d45c6":"kRh32","19937272cbe23c92":"8LxVj","108c8ead5f54502b":"49Ytv"}],"ab7Cj":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("1c9db357c0845afa");
var curve = require("47ec78745540f875");
var utils = require("e30b16e4a47a5405");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("9eada5f7049e7dfd");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"1c9db357c0845afa":"dElqS","47ec78745540f875":"3ZY1v","e30b16e4a47a5405":"7PLUP","9eada5f7049e7dfd":"iM2eR"}],"iM2eR":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"6GXut":[function(require,module,exports) {
"use strict";
var BN = require("2e69183faf5285a1");
var HmacDRBG = require("b0cb641292e4911d");
var utils = require("eab3e45147b180ba");
var curves = require("a5ce61d26ce01c4c");
var rand = require("f6342f89ac472937");
var assert = utils.assert;
var KeyPair = require("eb5ba559e423f6e9");
var Signature = require("7c5e2c76c574ce41");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"2e69183faf5285a1":"kRh32","b0cb641292e4911d":"alGiF","eab3e45147b180ba":"7PLUP","a5ce61d26ce01c4c":"ab7Cj","f6342f89ac472937":"dzcfb","eb5ba559e423f6e9":"jG59z","7c5e2c76c574ce41":"59s4p"}],"jG59z":[function(require,module,exports) {
"use strict";
var BN = require("55cc33a33cda153d");
var utils = require("bda8b1ff480a7f3");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"55cc33a33cda153d":"kRh32","bda8b1ff480a7f3":"7PLUP"}],"59s4p":[function(require,module,exports) {
"use strict";
var BN = require("a7ae8f0fe39990e7");
var utils = require("5df7da4811374387");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"a7ae8f0fe39990e7":"kRh32","5df7da4811374387":"7PLUP"}],"7YIGW":[function(require,module,exports) {
"use strict";
var hash = require("50f9bfa8a484d5d8");
var curves = require("68956d27442d6321");
var utils = require("99ec52641eff141d");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("2ad2982d76b37f15");
var Signature = require("76c25a1d63d10c1b");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"50f9bfa8a484d5d8":"dElqS","68956d27442d6321":"ab7Cj","99ec52641eff141d":"7PLUP","2ad2982d76b37f15":"grnAU","76c25a1d63d10c1b":"9awGI"}],"grnAU":[function(require,module,exports) {
"use strict";
var utils = require("387ffb9c0bf065ab");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"387ffb9c0bf065ab":"7PLUP"}],"9awGI":[function(require,module,exports) {
"use strict";
var BN = require("696e2c87f819d166");
var utils = require("51b94bcac1dcb2b2");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"696e2c87f819d166":"kRh32","51b94bcac1dcb2b2":"7PLUP"}],"e4Pkj":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1b9e2dcc2d1e58c5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1b9e2dcc2d1e58c5":"13Pcp"}],"4jHVG":[function(require,module,exports) {
exports.publicEncrypt = require("d84cba4f52311cc8");
exports.privateDecrypt = require("f9c6d8fbe09b61c");
exports.privateEncrypt = function privateEncrypt(key, buf) {
    return exports.publicEncrypt(key, buf, true);
};
exports.publicDecrypt = function publicDecrypt(key, buf) {
    return exports.privateDecrypt(key, buf, true);
};

},{"d84cba4f52311cc8":"6bigX","f9c6d8fbe09b61c":"aD1aF"}],"6bigX":[function(require,module,exports) {
var parseKeys = require("ca2697dbde558d1");
var randomBytes = require("4704ad09aa96a56b");
var createHash = require("b8a92fd1d9e43252");
var mgf = require("469be15a31031bba");
var xor = require("f9f3694c0f7388b6");
var BN = require("cb7a38ec1a0039d7");
var withPublic = require("969e1e2dd90e2fbe");
var crt = require("9022efe01867a612");
var Buffer = require("d610bb618706f42f").Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = oaep(key, msg);
    else if (padding === 1) paddedMsg = pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new BN(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return crt(paddedMsg, key);
    else return withPublic(paddedMsg, key);
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = createHash("sha1").update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = randomBytes(hLen);
    var maskedDb = xor(Buffer.concat([
        iHash,
        ps,
        Buffer.alloc(1, 1),
        msg
    ], dblen), mgf(seed, dblen));
    var maskedSeed = xor(seed, mgf(maskedDb, hLen));
    return new BN(Buffer.concat([
        Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = Buffer.alloc(k - mLen - 3, 0xff);
    else ps = nonZero(k - mLen - 3);
    return new BN(Buffer.concat([
        Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        Buffer.alloc(1),
        msg
    ], k));
}
function nonZero(len) {
    var out = Buffer.allocUnsafe(len);
    var i = 0;
    var cache = randomBytes(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = randomBytes(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

},{"ca2697dbde558d1":"kha3d","4704ad09aa96a56b":"c6z4K","b8a92fd1d9e43252":"iwHvk","469be15a31031bba":"ftwgE","f9f3694c0f7388b6":"kquW3","cb7a38ec1a0039d7":"lQ4WC","969e1e2dd90e2fbe":"6sdP3","9022efe01867a612":"8SmjR","d610bb618706f42f":"6hBQU"}],"ftwgE":[function(require,module,exports) {
var createHash = require("b36bb21196daa39");
var Buffer = require("cfa1ea60eac1ebfa").Buffer;
module.exports = function(seed, len) {
    var t = Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = i2ops(i++);
        t = Buffer.concat([
            t,
            createHash("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function i2ops(c) {
    var out = Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

},{"b36bb21196daa39":"iwHvk","cfa1ea60eac1ebfa":"6hBQU"}],"kquW3":[function(require,module,exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

},{}],"lQ4WC":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("64c9d23ade4c9eaa").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"64c9d23ade4c9eaa":"13Pcp"}],"6sdP3":[function(require,module,exports) {
var BN = require("94162e508c4195c3");
var Buffer = require("1bab2adfd8072b94").Buffer;
function withPublic(paddedMsg, key) {
    return Buffer.from(paddedMsg.toRed(BN.mont(key.modulus)).redPow(new BN(key.publicExponent)).fromRed().toArray());
}
module.exports = withPublic;

},{"94162e508c4195c3":"lQ4WC","1bab2adfd8072b94":"6hBQU"}],"aD1aF":[function(require,module,exports) {
var parseKeys = require("6c46b1d8bb7eae7b");
var mgf = require("9e51003323ea065d");
var xor = require("637b57d34a8dda25");
var BN = require("3927561f39566b29");
var crt = require("521cbc4ce6042d5b");
var createHash = require("95282d7c0e66f364");
var withPublic = require("1bc2f92e3c398dbe");
var Buffer = require("802d086fb6d63368").Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = parseKeys(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = withPublic(new BN(enc), key);
    else msg = crt(enc, key);
    var zBuffer = Buffer.alloc(k - msg.length);
    msg = Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return oaep(key, msg);
    else if (padding === 1) return pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = createHash("sha1").update(Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = xor(maskedSeed, mgf(maskedDb, hLen));
    var db = xor(maskedDb, mgf(seed, k - hLen - 1));
    if (compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function compare(a, b) {
    a = Buffer.from(a);
    b = Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

},{"6c46b1d8bb7eae7b":"kha3d","9e51003323ea065d":"ftwgE","637b57d34a8dda25":"kquW3","3927561f39566b29":"lQ4WC","521cbc4ce6042d5b":"8SmjR","95282d7c0e66f364":"iwHvk","1bc2f92e3c398dbe":"6sdP3","802d086fb6d63368":"6hBQU"}],"dpgow":[function(require,module,exports) {
var global = arguments[3];
var process = require("e52c82591caff1d7");
"use strict";
function oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}
var safeBuffer = require("954d667c0302f12c");
var randombytes = require("7041a0e993c249ef");
var Buffer = safeBuffer.Buffer;
var kBufferMaxLength = safeBuffer.kMaxLength;
var crypto = global.crypto || global.msCrypto;
var kMaxUint32 = Math.pow(2, 32) - 1;
function assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > kBufferMaxLength) throw new RangeError("buffer too small");
}
if (crypto && crypto.getRandomValues || false) {
    exports.randomFill = randomFill;
    exports.randomFillSync = randomFillSync;
} else {
    exports.randomFill = oldBrowser;
    exports.randomFillSync = oldBrowser;
}
function randomFill(buf, offset, size, cb) {
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    assertOffset(offset, buf.length);
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size, cb);
}
function actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    crypto.getRandomValues(uint);
    if (cb) {
        process.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        randombytes(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = randombytes(size);
    bytes.copy(buf, offset);
    return buf;
}
function randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    assertSize(size, offset, buf.length);
    return actualFill(buf, offset, size);
}

},{"e52c82591caff1d7":"5QIF0","954d667c0302f12c":"6hBQU","7041a0e993c249ef":"c6z4K"}],"eMf8V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 2048 bits Bloom filter
 */ parcelHelpers.export(exports, "Bloom", ()=>Bloom);
var _blake2B = require("./blake2b");
var Buffer = require("5e2273d46e78b8e5").Buffer;
class Bloom {
    /**
     * new bloom filter instance
     * @param k number of hash functions
     * @param bits leave it out to construct an empty one
     */ constructor(k, bits){
        if (bits) this.bits = bits;
        else this.bits = Buffer.alloc(Bloom.BITS_LENGTH / 8);
        this.k = k;
    }
    /** estimate k(number of hash functions) according to item count */ static estimateK(itemCount) {
        const k = Math.round(this.BITS_LENGTH / itemCount * Math.LN2);
        return Math.max(Math.min(k, this.MAX_K), 1);
    }
    /**
     * add item
     * @param item
     */ add(item) {
        this.distribute(item, (index, bit)=>{
            // tslint:disable-next-line:no-bitwise
            this.bits[index] |= bit;
            return true;
        });
    }
    /**
     * test if an item contained. (false positive)
     * @param item
     */ test(item) {
        return this.distribute(item, (index, bit)=>{
            // tslint:disable-next-line:no-bitwise
            return (this.bits[index] & bit) === bit;
        });
    }
    distribute(item, cb) {
        const hash = (0, _blake2B.blake2b256)(item);
        for(let i = 0; i < this.k; i++){
            // tslint:disable-next-line:no-bitwise
            const d = (hash[i * 2 + 1] + (hash[i * 2] << 8)) % Bloom.BITS_LENGTH;
            // tslint:disable-next-line:no-bitwise
            const bit = 1 << d % 8;
            if (!cb(Math.floor(d / 8), bit)) return false;
        }
        return true;
    }
}
/** number of hash functions */ Bloom.MAX_K = 16;
/** bit length */ Bloom.BITS_LENGTH = 2048;

},{"5e2273d46e78b8e5":"l5Twm","./blake2b":"iUeyt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"870oY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Certificate", ()=>Certificate);
var _address = require("./address");
var _blake2B = require("./blake2b");
var _secp256K1 = require("./secp256k1");
var Buffer = require("e53e22214c6ad0eb").Buffer;
const fastJsonStableStringify = require("c2938d8544564fb2");
var Certificate;
(function(Certificate) {
    function safeToLowerCase(str) {
        return typeof str === "string" ? str.toLowerCase() : str;
    }
    /**
     * deterministically encode cert into JSON
     * @param cert cert object
     */ function encode(cert) {
        return fastJsonStableStringify(Object.assign(Object.assign({}, cert), {
            signer: safeToLowerCase(cert.signer),
            signature: cert.signature ? safeToLowerCase(cert.signature) : cert.signature
        }));
    }
    Certificate.encode = encode;
    /**
     * verify the cert
     * @param cert cert object with signature
     */ function verify(cert) {
        if (!cert.signature) throw new Error("signature missing");
        const signature = cert.signature;
        if (!/^0x[0-9a-f]+$/i.test(signature) || signature.length % 2 !== 0) throw new Error("invalid signature");
        const encoded = encode(Object.assign(Object.assign({}, cert), {
            signature: undefined
        }));
        const signingHash = (0, _blake2B.blake2b256)(encoded);
        const pubKey = (0, _secp256K1.secp256k1).recover(signingHash, Buffer.from(signature.slice(2), "hex"));
        if ((0, _address.address).fromPublicKey(pubKey) !== safeToLowerCase(cert.signer)) throw new Error("signature does not match with signer");
    }
    Certificate.verify = verify;
})(Certificate || (Certificate = {}));

},{"e53e22214c6ad0eb":"l5Twm","./address":"aT2rv","./blake2b":"iUeyt","./secp256k1":"7vgw0","c2938d8544564fb2":"58Wk9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58Wk9":[function(require,module,exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

},{}],"9hEAv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keystore", ()=>Keystore);
var _secretStorage = require("@vechain/ethers/utils/secret-storage");
var Buffer = require("cb75fb806a5349da").Buffer;
var Keystore;
(function(Keystore) {
    /**
     * encrypt private key to keystore with given password
     * @param privateKey the private key to be encrypted
     * @param password password to encrypt the private key
     */ function encrypt(privateKey, password) {
        return _secretStorage.encrypt("0x" + privateKey.toString("hex"), password, {
            scrypt: {
                N: 131072,
                p: 1,
                r: 8
            }
        }).then((str)=>normalize(JSON.parse(str)));
    }
    Keystore.encrypt = encrypt;
    /**
     * decrypt private key from keystore
     * an error thrown if not well formed
     * @param ks the keystore
     * @param password password to decrypt keystore
     */ function decrypt(ks, password) {
        return _secretStorage.decrypt(JSON.stringify(ks), password).then((sk)=>Buffer.from(sk.privateKey.slice(2), "hex"));
    }
    Keystore.decrypt = decrypt;
    /**
     * roughly check whether keystore is well formed
     * @param ks the keystore
     */ function wellFormed(ks) {
        try {
            validate(normalize(ks));
            return true;
        } catch (_a) {
            return false;
        }
    }
    Keystore.wellFormed = wellFormed;
    /** normalize keystore. e.g. lower case keys */ function normalize(obj) {
        const lowerKey = (o)=>{
            return Object.keys(o).reduce((converted, k)=>{
                let v = o[k];
                if (typeof v === "object") v = lowerKey(v);
                converted[k.toLowerCase()] = v;
                return converted;
            }, {});
        };
        return lowerKey(obj);
    }
    function validate(ks) {
        if (ks.version !== 1 && ks.version !== 3) throw new Error("unsupported version");
        if (!/^[0-9a-f]{40}$/i.test(ks.address)) throw new Error("invalid address");
        if (!/^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/i.test(ks.id)) throw new Error("invalid id");
        if (typeof ks.crypto !== "object") throw new Error("invalid crypto");
        return ks;
    }
})(Keystore || (Keystore = {}));

},{"cb75fb806a5349da":"l5Twm","@vechain/ethers/utils/secret-storage":"9710T","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9710T":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var aes_js_1 = __importDefault(require("b791209189071980"));
var scrypt_js_1 = __importDefault(require("f3c58f4d42c9bdb"));
var uuid_1 = __importDefault(require("cd5dfa87203e16bf"));
var signing_key_1 = require("1f84c68043437f96");
var HDNode = __importStar(require("ccc5e140787b954e"));
var address_1 = require("fc1013c750c889ee");
var bytes_1 = require("fdb363749c5d499e");
var pbkdf2_1 = require("754df9c928d9c8f7");
var keccak256_1 = require("ee1db42f5c27eab4");
var utf8_1 = require("3c0c5898631def87");
var random_bytes_1 = require("8a3051dc8bfb0a1d");
function looseArrayify(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return bytes_1.arrayify(hexString);
}
function zpad(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function getPassword(password) {
    if (typeof password === "string") return utf8_1.toUtf8Bytes(password, utf8_1.UnicodeNormalizationForm.NFKC);
    return bytes_1.arrayify(password);
}
// Search an Object and its children recursively, caselessly.
function searchPath(object, path) {
    var currentChild = object;
    var comps = path.toLowerCase().split("/");
    for(var i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        var matchingChild = null;
        for(var key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
// @TODO: Make a type for string or arrayish
// See: https://github.com/ethereum/pyethsaletool
function decryptCrowdsale(json, password) {
    var data = JSON.parse(json);
    password = getPassword(password);
    // Ethereum Address
    var ethaddr = address_1.getAddress(searchPath(data, "ethaddr"));
    // Encrypted Seed
    var encseed = looseArrayify(searchPath(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) throw new Error("invalid encseed");
    var key = pbkdf2_1.pbkdf2(password, password, 2000, 32, "sha256").slice(0, 16);
    var iv = encseed.slice(0, 16);
    var encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    var aesCbc = new aes_js_1.default.ModeOfOperation.cbc(key, iv);
    var seed = bytes_1.arrayify(aesCbc.decrypt(encryptedSeed));
    seed = aes_js_1.default.padding.pkcs7.strip(seed);
    // This wallet format is weird... Convert the binary encoded hex to a string.
    var seedHex = "";
    for(var i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    var seedHexBytes = utf8_1.toUtf8Bytes(seedHex);
    var signingKey = new signing_key_1.SigningKey(keccak256_1.keccak256(seedHexBytes));
    if (signingKey.address !== ethaddr) throw new Error("corrupt crowdsale wallet");
    return signingKey;
}
exports.decryptCrowdsale = decryptCrowdsale;
//@TODO: string or arrayish
function decrypt(json, password, progressCallback) {
    var data = JSON.parse(json);
    var passwordBytes = getPassword(password);
    var decrypt = function(key, ciphertext) {
        var cipher = searchPath(data, "crypto/cipher");
        if (cipher === "aes-128-ctr") {
            var iv = looseArrayify(searchPath(data, "crypto/cipherparams/iv"));
            var counter = new aes_js_1.default.Counter(iv);
            var aesCtr = new aes_js_1.default.ModeOfOperation.ctr(key, counter);
            return bytes_1.arrayify(aesCtr.decrypt(ciphertext));
        }
        return null;
    };
    var computeMAC = function(derivedHalf, ciphertext) {
        return keccak256_1.keccak256(bytes_1.concat([
            derivedHalf,
            ciphertext
        ]));
    };
    var getSigningKey = function(key, reject) {
        var ciphertext = looseArrayify(searchPath(data, "crypto/ciphertext"));
        var computedMAC = bytes_1.hexlify(computeMAC(key.slice(16, 32), ciphertext)).substring(2);
        if (computedMAC !== searchPath(data, "crypto/mac").toLowerCase()) {
            reject(new Error("invalid password"));
            return null;
        }
        var privateKey = decrypt(key.slice(0, 16), ciphertext);
        var mnemonicKey = key.slice(32, 64);
        if (!privateKey) {
            reject(new Error("unsupported cipher"));
            return null;
        }
        var signingKey = new signing_key_1.SigningKey(privateKey);
        if (signingKey.address !== address_1.getAddress(data.address)) {
            reject(new Error("address mismatch"));
            return null;
        }
        // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
        if (searchPath(data, "x-ethers/version") === "0.1") {
            var mnemonicCiphertext = looseArrayify(searchPath(data, "x-ethers/mnemonicCiphertext"));
            var mnemonicIv = looseArrayify(searchPath(data, "x-ethers/mnemonicCounter"));
            var mnemonicCounter = new aes_js_1.default.Counter(mnemonicIv);
            var mnemonicAesCtr = new aes_js_1.default.ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            var path = searchPath(data, "x-ethers/path") || HDNode.defaultPath;
            var entropy = bytes_1.arrayify(mnemonicAesCtr.decrypt(mnemonicCiphertext));
            var mnemonic = HDNode.entropyToMnemonic(entropy);
            var node = HDNode.fromMnemonic(mnemonic).derivePath(path);
            if (node.privateKey != bytes_1.hexlify(privateKey)) {
                reject(new Error("mnemonic mismatch"));
                return null;
            }
            signingKey = new signing_key_1.SigningKey(node);
        }
        return signingKey;
    };
    return new Promise(function(resolve, reject) {
        var kdf = searchPath(data, "crypto/kdf");
        if (kdf && typeof kdf === "string") {
            if (kdf.toLowerCase() === "scrypt") {
                var salt = looseArrayify(searchPath(data, "crypto/kdfparams/salt"));
                var N = parseInt(searchPath(data, "crypto/kdfparams/n"));
                var r = parseInt(searchPath(data, "crypto/kdfparams/r"));
                var p = parseInt(searchPath(data, "crypto/kdfparams/p"));
                if (!N || !r || !p) {
                    reject(new Error("unsupported key-derivation function parameters"));
                    return;
                }
                // Make sure N is a power of 2
                if ((N & N - 1) !== 0) {
                    reject(new Error("unsupported key-derivation function parameter value for N"));
                    return;
                }
                var dkLen = parseInt(searchPath(data, "crypto/kdfparams/dklen"));
                if (dkLen !== 32) {
                    reject(new Error("unsupported key-derivation derived-key length"));
                    return;
                }
                if (progressCallback) progressCallback(0);
                scrypt_js_1.default(passwordBytes, salt, N, r, p, 64, function(error, progress, key) {
                    if (error) {
                        error.progress = progress;
                        reject(error);
                    } else if (key) {
                        key = bytes_1.arrayify(key);
                        var signingKey = getSigningKey(key, reject);
                        if (!signingKey) return;
                        if (progressCallback) progressCallback(1);
                        resolve(signingKey);
                    } else if (progressCallback) return progressCallback(progress);
                });
            } else if (kdf.toLowerCase() === "pbkdf2") {
                var salt = looseArrayify(searchPath(data, "crypto/kdfparams/salt"));
                var prfFunc = null;
                var prf = searchPath(data, "crypto/kdfparams/prf");
                if (prf === "hmac-sha256") prfFunc = "sha256";
                else if (prf === "hmac-sha512") prfFunc = "sha512";
                else {
                    reject(new Error("unsupported prf"));
                    return;
                }
                var c = parseInt(searchPath(data, "crypto/kdfparams/c"));
                var dkLen = parseInt(searchPath(data, "crypto/kdfparams/dklen"));
                if (dkLen !== 32) {
                    reject(new Error("unsupported key-derivation derived-key length"));
                    return;
                }
                var key = pbkdf2_1.pbkdf2(passwordBytes, salt, c, dkLen, prfFunc);
                var signingKey = getSigningKey(key, reject);
                if (!signingKey) return;
                resolve(signingKey);
            } else reject(new Error("unsupported key-derivation function"));
        } else reject(new Error("unsupported key-derivation function"));
    });
}
exports.decrypt = decrypt;
function encrypt(privateKey, password, options, progressCallback) {
    // the options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    // Check the private key
    var privateKeyBytes = null;
    if (signing_key_1.SigningKey.isSigningKey(privateKey)) privateKeyBytes = bytes_1.arrayify(privateKey.privateKey);
    else privateKeyBytes = bytes_1.arrayify(privateKey);
    if (privateKeyBytes.length !== 32) throw new Error("invalid private key");
    var passwordBytes = getPassword(password);
    var entropy = null;
    if (options.entropy) entropy = bytes_1.arrayify(options.entropy);
    if (options.mnemonic) {
        if (entropy) {
            if (HDNode.entropyToMnemonic(entropy) !== options.mnemonic) throw new Error("entropy and mnemonic mismatch");
        } else entropy = bytes_1.arrayify(HDNode.mnemonicToEntropy(options.mnemonic));
    }
    var path = options.path;
    if (entropy && !path) path = HDNode.defaultPath;
    var client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    var salt = null;
    if (options.salt) salt = bytes_1.arrayify(options.salt);
    else salt = random_bytes_1.randomBytes(32);
    // Override initialization vector
    var iv = null;
    if (options.iv) {
        iv = bytes_1.arrayify(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = random_bytes_1.randomBytes(16);
    // Override the uuid
    var uuidRandom = null;
    if (options.uuid) {
        uuidRandom = bytes_1.arrayify(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = random_bytes_1.randomBytes(16);
    // Override the scrypt password-based key derivation function parameters
    var N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    return new Promise(function(resolve, reject) {
        if (progressCallback) progressCallback(0);
        // We take 64 bytes:
        //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
        //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
        scrypt_js_1.default(passwordBytes, salt, N, r, p, 64, function(error, progress, key) {
            if (error) {
                error.progress = progress;
                reject(error);
            } else if (key) {
                key = bytes_1.arrayify(key);
                // This will be used to encrypt the wallet (as per Web3 secret storage)
                var derivedKey = key.slice(0, 16);
                var macPrefix = key.slice(16, 32);
                // This will be used to encrypt the mnemonic phrase (if any)
                var mnemonicKey = key.slice(32, 64);
                // Get the address for this private key
                var address = new signing_key_1.SigningKey(privateKeyBytes).address;
                // Encrypt the private key
                var counter = new aes_js_1.default.Counter(iv);
                var aesCtr = new aes_js_1.default.ModeOfOperation.ctr(derivedKey, counter);
                var ciphertext = bytes_1.arrayify(aesCtr.encrypt(privateKeyBytes));
                // Compute the message authentication code, used to check the password
                var mac = keccak256_1.keccak256(bytes_1.concat([
                    macPrefix,
                    ciphertext
                ]));
                // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
                var data = {
                    address: address.substring(2).toLowerCase(),
                    id: uuid_1.default.v4({
                        random: uuidRandom
                    }),
                    version: 3,
                    Crypto: {
                        cipher: "aes-128-ctr",
                        cipherparams: {
                            iv: bytes_1.hexlify(iv).substring(2)
                        },
                        ciphertext: bytes_1.hexlify(ciphertext).substring(2),
                        kdf: "scrypt",
                        kdfparams: {
                            salt: bytes_1.hexlify(salt).substring(2),
                            n: N,
                            dklen: 32,
                            p: p,
                            r: r
                        },
                        mac: mac.substring(2)
                    }
                };
                // If we have a mnemonic, encrypt it into the JSON wallet
                if (entropy) {
                    var mnemonicIv = random_bytes_1.randomBytes(16);
                    var mnemonicCounter = new aes_js_1.default.Counter(mnemonicIv);
                    var mnemonicAesCtr = new aes_js_1.default.ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
                    var mnemonicCiphertext = bytes_1.arrayify(mnemonicAesCtr.encrypt(entropy));
                    var now = new Date();
                    var timestamp = now.getUTCFullYear() + "-" + zpad(now.getUTCMonth() + 1, 2) + "-" + zpad(now.getUTCDate(), 2) + "T" + zpad(now.getUTCHours(), 2) + "-" + zpad(now.getUTCMinutes(), 2) + "-" + zpad(now.getUTCSeconds(), 2) + ".0Z";
                    data["x-ethers"] = {
                        client: client,
                        gethFilename: "UTC--" + timestamp + "--" + data.address,
                        mnemonicCounter: bytes_1.hexlify(mnemonicIv).substring(2),
                        mnemonicCiphertext: bytes_1.hexlify(mnemonicCiphertext).substring(2),
                        path: path,
                        version: "0.1"
                    };
                }
                if (progressCallback) progressCallback(1);
                resolve(JSON.stringify(data));
            } else if (progressCallback) return progressCallback(progress);
        });
    });
}
exports.encrypt = encrypt;

},{"b791209189071980":"jMrbO","f3c58f4d42c9bdb":"iLUnG","cd5dfa87203e16bf":"acURd","1f84c68043437f96":"iQQYy","ccc5e140787b954e":"9KSDI","fc1013c750c889ee":"73HJd","fdb363749c5d499e":"71FSg","754df9c928d9c8f7":"fkPrj","ee1db42f5c27eab4":"g4rCo","3c0c5898631def87":"IsaAt","8a3051dc8bfb0a1d":"6GSe1"}],"jMrbO":[function(require,module,exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(this);

},{}],"iLUnG":[function(require,module,exports) {
"use strict";
(function(root) {
    var MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        var K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ];
        var h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        var h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        var w = new Array(64);
        function blocks(p) {
            var off = 0, len = p.length;
            while(len >= 64){
                var a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        var i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        var i;
        var innerLen = 64 + salt.length + 4;
        var inner = new Array(innerLen);
        var outerKey = new Array(64);
        var dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(var i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        var i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(var i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(var i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(var i = 0; i < o.length; i++){
            if (typeof o[i] !== "number") return false;
            var v = parseInt(o[i]);
            if (v != o[i] || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        var intValue = parseInt(value);
        if (value != intValue) throw new Error("invalid " + name);
        return intValue;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function scrypt(password, salt, N, r, p, dkLen, callback) {
        if (!callback) throw new Error("missing callback");
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        var b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        var B = new Uint32Array(p * 32 * r);
        for(var i = 0; i < B.length; i++){
            var j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        var XY = new Uint32Array(64 * r);
        var V = new Uint32Array(32 * r * N);
        var Yi = 32 * r;
        // scratch space
        var x = new Uint32Array(16); // salsa20_8
        var _X = new Uint32Array(16); // blockmix_salsa8
        var totalOps = p * N * 2;
        var currentOp = 0;
        var lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        var stop = false;
        // State information
        var state = 0;
        var i0 = 0, i1;
        var Bi;
        // How many blockmix_salsa8 can we do per step?
        var limit = parseInt(1000 / r);
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        var nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        var incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    var steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    var percent10 = parseInt(1000 * currentOp / totalOps);
                    if (percent10 !== lastPercent10) {
                        stop = callback(null, currentOp / totalOps);
                        if (stop) break;
                        lastPercent10 = percent10;
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    var steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(var i = 0; i < steps; i++){
                        var offset = (2 * r - 1) * 16; // ROMix - 7
                        var j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    var percent10 = parseInt(1000 * currentOp / totalOps);
                    if (percent10 !== lastPercent10) {
                        stop = callback(null, currentOp / totalOps);
                        if (stop) break;
                        lastPercent10 = percent10;
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(var i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    var derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Done; don't break (which would reschedule)
                    return callback(null, 1.0, derivedKey);
            }
            // Schedule the next steps
            nextTick(incrementalSMix);
        };
        // Bootstrap the incremental smix
        incrementalSMix();
    }
    // node.js
    if (typeof exports !== "undefined") module.exports = scrypt;
    else if (typeof define === "function" && define.amd) define(scrypt);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = scrypt;
    }
})(this);

},{}],"acURd":[function(require,module,exports) {
//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php
// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = require("d9a9dfa7fc160680");
// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for(var i = 0; i < 256; i++){
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
}
// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
    var i = buf && offset || 0, ii = 0;
    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
        if (ii < 16) buf[i + ii++] = _hexToByte[oct];
    });
    // Zero out remaining bytes if string was short
    while(ii < 16)buf[i + ii++] = 0;
    return buf;
}
// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
// random #'s we need to init node and clockseq
var _seedBytes = _rng();
// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1],
    _seedBytes[2],
    _seedBytes[3],
    _seedBytes[4],
    _seedBytes[5]
];
// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;
// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    var node = options.node || _nodeId;
    for(var n = 0; n < 6; n++)b[i + n] = node[n];
    return buf ? buf : unparse(b);
}
// **`v4()` - Generate random UUID**
// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options == "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || _rng)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ii++)buf[i + ii] = rnds[ii];
    return buf || unparse(rnds);
}
// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;
module.exports = uuid;

},{"d9a9dfa7fc160680":"5NyYg"}],"5NyYg":[function(require,module,exports) {
var global = arguments[3];
var rng;
if (global.crypto && crypto.getRandomValues) {
    // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
    // Moderately fast, high quality
    var _rnds8 = new Uint8Array(16);
    rng = function whatwgRNG() {
        crypto.getRandomValues(_rnds8);
        return _rnds8;
    };
}
if (!rng) {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var _rnds = new Array(16);
    rng = function() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return _rnds;
    };
}
module.exports = rng;

},{}],"iQQYy":[function(require,module,exports) {
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 *  SigningKey
 *
 *
 */ var hdnode_1 = require("a17798e52a8cc2b2");
var bytes_1 = require("217cabd3c1e046b6");
var properties_1 = require("4a33d61034c06ea8");
var secp256k1_1 = require("f8b2066fd723a8b");
var errors = __importStar(require("a3877897d06e11b4"));
///////////////////////////////
var SigningKey = /** @class */ function() {
    function SigningKey(privateKey) {
        errors.checkNew(this, SigningKey);
        var privateKeyBytes = null;
        if (hdnode_1.HDNode.isHDNode(privateKey)) {
            properties_1.defineReadOnly(this, "mnemonic", privateKey.mnemonic);
            properties_1.defineReadOnly(this, "path", privateKey.path);
            privateKeyBytes = bytes_1.arrayify(privateKey.privateKey);
        } else {
            // A lot of common tools do not prefix private keys with a 0x
            if (typeof privateKey === "string" && privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
            privateKeyBytes = bytes_1.arrayify(privateKey);
        }
        try {
            if (privateKeyBytes.length !== 32) errors.throwError("exactly 32 bytes required", errors.INVALID_ARGUMENT, {
                arg: "privateKey",
                value: "[REDACTED]"
            });
        } catch (error) {
            var params = {
                arg: "privateKey",
                reason: error.reason,
                value: "[REDACTED]"
            };
            if (error.value) {
                if (typeof error.value.length === "number") params.length = error.value.length;
                params.type = typeof error.value;
            }
            errors.throwError("invalid private key", error.code, params);
        }
        properties_1.defineReadOnly(this, "privateKey", bytes_1.hexlify(privateKeyBytes));
        properties_1.defineReadOnly(this, "keyPair", new secp256k1_1.KeyPair(privateKeyBytes));
        properties_1.defineReadOnly(this, "publicKey", this.keyPair.publicKey);
        properties_1.defineReadOnly(this, "address", secp256k1_1.computeAddress(this.keyPair.publicKey));
        properties_1.setType(this, "SigningKey");
    }
    SigningKey.prototype.signDigest = function(digest) {
        return this.keyPair.sign(digest);
    };
    SigningKey.prototype.computeSharedSecret = function(key) {
        return this.keyPair.computeSharedSecret(bytes_1.arrayify(key));
    };
    SigningKey.isSigningKey = function(value) {
        return properties_1.isType(value, "SigningKey");
    };
    return SigningKey;
}();
exports.SigningKey = SigningKey;

},{"a17798e52a8cc2b2":"9KSDI","217cabd3c1e046b6":"71FSg","4a33d61034c06ea8":"f68LV","f8b2066fd723a8b":"jYC5E","a3877897d06e11b4":"ljnPX"}],"9KSDI":[function(require,module,exports) {
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
// See: https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
// See: https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki
var errors = __importStar(require("ccbcf52df1056d0f"));
// The English language word list.
// For additional word lists, please see /src.tc/wordlists/
var lang_en_1 = require("25d382cc44ccaaaf");
// Automatically register English?
//import { register } from '../wordlists/wordlist';
//register(langEn);
var basex_1 = require("842e207a0cc83f02");
var bytes_1 = require("7a8d51e59a344d7");
var bignumber_1 = require("a754c83d0c43120f");
var utf8_1 = require("be93428a8aed7cba");
var pbkdf2_1 = require("faffd088d5c461c4");
var hmac_1 = require("def7a8dcbd243566");
var properties_1 = require("f69d5f0ee05e7b40");
var secp256k1_1 = require("8e5b0aabd338b6ce");
var sha2_1 = require("c4024bfbe0bb355");
var N = bignumber_1.bigNumberify("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
var MasterSecret = utf8_1.toUtf8Bytes("Bitcoin seed");
var HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function getLowerMask(bits) {
    return (1 << bits) - 1;
}
function bytes32(value) {
    return bytes_1.hexZeroPad(bytes_1.hexlify(value), 32);
}
function base58check(data) {
    var checksum = bytes_1.hexDataSlice(sha2_1.sha256(sha2_1.sha256(data)), 0, 4);
    return basex_1.Base58.encode(bytes_1.concat([
        data,
        checksum
    ]));
}
var _constructorGuard = {};
exports.defaultPath = "m/44'/60'/0'/0/0";
var HDNode = /** @class */ function() {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ function HDNode(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonic, path) {
        errors.checkNew(this, HDNode);
        if (constructorGuard !== _constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            var keyPair = new secp256k1_1.KeyPair(privateKey);
            properties_1.defineReadOnly(this, "privateKey", keyPair.privateKey);
            properties_1.defineReadOnly(this, "publicKey", keyPair.compressedPublicKey);
        } else {
            properties_1.defineReadOnly(this, "privateKey", null);
            properties_1.defineReadOnly(this, "publicKey", bytes_1.hexlify(publicKey));
        }
        properties_1.defineReadOnly(this, "parentFingerprint", parentFingerprint);
        properties_1.defineReadOnly(this, "fingerprint", bytes_1.hexDataSlice(sha2_1.ripemd160(sha2_1.sha256(this.publicKey)), 0, 4));
        properties_1.defineReadOnly(this, "address", secp256k1_1.computeAddress(this.publicKey));
        properties_1.defineReadOnly(this, "chainCode", chainCode);
        properties_1.defineReadOnly(this, "index", index);
        properties_1.defineReadOnly(this, "depth", depth);
        properties_1.defineReadOnly(this, "mnemonic", mnemonic);
        properties_1.defineReadOnly(this, "path", path);
        properties_1.setType(this, "HDNode");
    }
    Object.defineProperty(HDNode.prototype, "extendedKey", {
        get: function() {
            // We only support the mainnet values for now, but if anyone needs
            // testnet values, let me know. I believe current senitment is that
            // we should always use mainnet, and use BIP-44 to derive the network
            //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
            //   - Testnet: public=0x043587CF, private=0x04358394
            if (this.depth >= 256) throw new Error("Depth too large!");
            return base58check(bytes_1.concat([
                this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
                bytes_1.hexlify(this.depth),
                this.parentFingerprint,
                bytes_1.hexZeroPad(bytes_1.hexlify(this.index), 4),
                this.chainCode,
                this.privateKey != null ? bytes_1.concat([
                    "0x00",
                    this.privateKey
                ]) : this.publicKey
            ]));
        },
        enumerable: true,
        configurable: true
    });
    HDNode.prototype.neuter = function() {
        return new HDNode(_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, null, this.path);
    };
    HDNode.prototype._derive = function(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        var path = this.path;
        if (path) path += "/" + (index & ~HardenedBit);
        var data = new Uint8Array(37);
        if (index & HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set(bytes_1.arrayify(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set(bytes_1.arrayify(this.publicKey));
        // Data += ser_32(i)
        for(var i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        var I = hmac_1.computeHmac(hmac_1.SupportedAlgorithms.sha512, this.chainCode, data);
        var IL = I.slice(0, 32);
        var IR = I.slice(32);
        // The private key
        var ki = null;
        // The public key
        var Ki = null;
        if (this.privateKey) ki = bytes32(bignumber_1.bigNumberify(IL).add(this.privateKey).mod(N));
        else {
            var ek = new secp256k1_1.KeyPair(bytes_1.hexlify(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        return new HDNode(_constructorGuard, ki, Ki, this.fingerprint, bytes32(IR), index, this.depth + 1, this.mnemonic, path);
    };
    HDNode.prototype.derivePath = function(path) {
        var components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        var result = this;
        for(var i = 0; i < components.length; i++){
            var component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                var index = parseInt(component.substring(0, component.length - 1));
                if (index >= HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                var index = parseInt(component);
                if (index >= HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invlaid path component - " + component);
        }
        return result;
    };
    HDNode.isHDNode = function(value) {
        return properties_1.isType(value, "HDNode");
    };
    return HDNode;
}();
exports.HDNode = HDNode;
function fromExtendedKey(extendedKey) {
    var bytes = basex_1.Base58.decode(extendedKey);
    if (bytes.length !== 82 || base58check(bytes.slice(0, 78)) !== extendedKey) errors.throwError("invalid extended key", errors.INVALID_ARGUMENT, {
        argument: "extendedKey",
        value: "[REDACTED]"
    });
    var depth = bytes[4];
    var parentFingerprint = bytes_1.hexlify(bytes.slice(5, 9));
    var index = parseInt(bytes_1.hexlify(bytes.slice(9, 13)).substring(2), 16);
    var chainCode = bytes_1.hexlify(bytes.slice(13, 45));
    var key = bytes.slice(45, 78);
    switch(bytes_1.hexlify(bytes.slice(0, 4))){
        // Public Key
        case "0x0488b21e":
        case "0x043587cf":
            return new HDNode(_constructorGuard, null, bytes_1.hexlify(key), parentFingerprint, chainCode, index, depth, null, null);
        // Private Key
        case "0x0488ade4":
        case "0x04358394 ":
            if (key[0] !== 0) break;
            return new HDNode(_constructorGuard, bytes_1.hexlify(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null, null);
    }
    return errors.throwError("invalid extended key", errors.INVALID_ARGUMENT, {
        argument: "extendedKey",
        value: "[REDACTED]"
    });
}
exports.fromExtendedKey = fromExtendedKey;
function _fromSeed(seed, mnemonic) {
    var seedArray = bytes_1.arrayify(seed);
    if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
    var I = bytes_1.arrayify(hmac_1.computeHmac(hmac_1.SupportedAlgorithms.sha512, MasterSecret, seedArray));
    return new HDNode(_constructorGuard, bytes32(I.slice(0, 32)), null, "0x00000000", bytes32(I.slice(32)), 0, 0, mnemonic, "m");
}
function fromMnemonic(mnemonic, wordlist, password) {
    // Check that the checksum s valid (will throw an error)
    mnemonicToEntropy(mnemonic, wordlist);
    return _fromSeed(mnemonicToSeed(mnemonic, password), mnemonic);
}
exports.fromMnemonic = fromMnemonic;
function fromSeed(seed) {
    return _fromSeed(seed, null);
}
exports.fromSeed = fromSeed;
function mnemonicToSeed(mnemonic, password) {
    if (!password) password = "";
    var salt = utf8_1.toUtf8Bytes("mnemonic" + password, utf8_1.UnicodeNormalizationForm.NFKD);
    return bytes_1.hexlify(pbkdf2_1.pbkdf2(utf8_1.toUtf8Bytes(mnemonic, utf8_1.UnicodeNormalizationForm.NFKD), salt, 2048, 64, "sha512"));
}
exports.mnemonicToSeed = mnemonicToSeed;
function mnemonicToEntropy(mnemonic, wordlist) {
    if (!wordlist) wordlist = lang_en_1.langEn;
    errors.checkNormalize();
    var words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    var entropy = bytes_1.arrayify(new Uint8Array(Math.ceil(11 * words.length / 8)));
    var offset = 0;
    for(var i = 0; i < words.length; i++){
        var index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(var bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    var entropyBits = 32 * words.length / 3;
    var checksumBits = words.length / 3;
    var checksumMask = getUpperMask(checksumBits);
    var checksum = bytes_1.arrayify(sha2_1.sha256(entropy.slice(0, entropyBits / 8)))[0];
    checksum &= checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return bytes_1.hexlify(entropy.slice(0, entropyBits / 8));
}
exports.mnemonicToEntropy = mnemonicToEntropy;
function entropyToMnemonic(entropy, wordlist) {
    entropy = bytes_1.arrayify(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    var indices = [
        0
    ];
    var remainingBits = 11;
    for(var i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    var checksum = bytes_1.arrayify(sha2_1.sha256(entropy))[0];
    var checksumBits = entropy.length / 4;
    checksum &= getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    if (!wordlist) wordlist = lang_en_1.langEn;
    return wordlist.join(indices.map(function(index) {
        return wordlist.getWord(index);
    }));
}
exports.entropyToMnemonic = entropyToMnemonic;
function isValidMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
exports.isValidMnemonic = isValidMnemonic;

},{"ccbcf52df1056d0f":"ljnPX","25d382cc44ccaaaf":"2hA9M","842e207a0cc83f02":"2PZA7","7a8d51e59a344d7":"71FSg","a754c83d0c43120f":"8K78M","be93428a8aed7cba":"IsaAt","faffd088d5c461c4":"fkPrj","def7a8dcbd243566":"iYhCn","f69d5f0ee05e7b40":"f68LV","8e5b0aabd338b6ce":"jYC5E","c4024bfbe0bb355":"53Rub"}],"2hA9M":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
var wordlist_1 = require("d2abd3793f4602b");
var words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
var wordlist = null;
function loadWords(lang) {
    if (wordlist != null) return;
    wordlist = words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    if (wordlist_1.check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
var LangEn = /** @class */ function(_super) {
    __extends(LangEn, _super);
    function LangEn() {
        return _super.call(this, "en") || this;
    }
    LangEn.prototype.getWord = function(index) {
        loadWords(this);
        return wordlist[index];
    };
    LangEn.prototype.getWordIndex = function(word) {
        loadWords(this);
        return wordlist.indexOf(word);
    };
    return LangEn;
}(wordlist_1.Wordlist);
var langEn = new LangEn();
exports.langEn = langEn;
wordlist_1.register(langEn);

},{"d2abd3793f4602b":"kBXMn"}],"kBXMn":[function(require,module,exports) {
var global = arguments[3];
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// This gets overriddenby gulp during bip39-XX
var exportWordlist = false;
var hash_1 = require("66596b47a8b31218");
var properties_1 = require("8d18f7929efbc317");
function check(wordlist) {
    var words = [];
    for(var i = 0; i < 2048; i++){
        var word = wordlist.getWord(i);
        if (i !== wordlist.getWordIndex(word)) return "0x";
        words.push(word);
    }
    return hash_1.id(words.join("\n") + "\n");
}
exports.check = check;
var Wordlist = /** @class */ function() {
    function Wordlist(locale) {
        properties_1.defineReadOnly(this, "locale", locale);
    }
    // Subclasses may override this
    Wordlist.prototype.split = function(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    };
    // Subclasses may override this
    Wordlist.prototype.join = function(words) {
        return words.join(" ");
    };
    return Wordlist;
}();
exports.Wordlist = Wordlist;
function register(lang, name) {
    if (!name) name = lang.locale;
    if (exportWordlist) {
        var g = global;
        if (!g.wordlists) properties_1.defineReadOnly(g, "wordlists", {});
        if (!g.wordlists[name]) properties_1.defineReadOnly(g.wordlists, name, lang);
        if (g.ethers && g.ethers.wordlists) {
            if (!g.ethers.wordlists[name]) properties_1.defineReadOnly(g.ethers.wordlists, name, lang);
        }
    }
}
exports.register = register;

},{"66596b47a8b31218":"9k2eV","8d18f7929efbc317":"f68LV"}],"9k2eV":[function(require,module,exports) {
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var errors = __importStar(require("55ffbd0179e86417"));
var bytes_1 = require("accb4b524eee0a8e");
var utf8_1 = require("9286c4bcb32e3b94");
var keccak256_1 = require("80ecb6035c85b880");
///////////////////////////////
var Zeros = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
var Partition = new RegExp("^((.*)\\.)?([^.]+)$");
var UseSTD3ASCIIRules = new RegExp("^[a-z0-9.-]*$");
function namehash(name) {
    if (typeof name !== "string") errors.throwError("invalid address - " + String(name), errors.INVALID_ARGUMENT, {
        argument: "name",
        value: name
    });
    name = name.toLowerCase();
    // Supporting the full UTF-8 space requires additional (and large)
    // libraries, so for now we simply do not support them.
    // It should be fairly easy in the future to support systems with
    // String.normalize, but that is future work.
    if (!name.match(UseSTD3ASCIIRules)) errors.throwError("contains invalid UseSTD3ASCIIRules characters", errors.INVALID_ARGUMENT, {
        argument: "name",
        value: name
    });
    var result = Zeros;
    while(name.length){
        var partition = name.match(Partition);
        var label = utf8_1.toUtf8Bytes(partition[3]);
        result = keccak256_1.keccak256(bytes_1.concat([
            result,
            keccak256_1.keccak256(label)
        ]));
        name = partition[2] || "";
    }
    return bytes_1.hexlify(result);
}
exports.namehash = namehash;
function id(text) {
    return keccak256_1.keccak256(utf8_1.toUtf8Bytes(text));
}
exports.id = id;
function hashMessage(message) {
    return keccak256_1.keccak256(bytes_1.concat([
        utf8_1.toUtf8Bytes("\x19Ethereum Signed Message:\n"),
        utf8_1.toUtf8Bytes(String(message.length)),
        typeof message === "string" ? utf8_1.toUtf8Bytes(message) : message
    ]));
}
exports.hashMessage = hashMessage;

},{"55ffbd0179e86417":"ljnPX","accb4b524eee0a8e":"71FSg","9286c4bcb32e3b94":"IsaAt","80ecb6035c85b880":"g4rCo"}],"2PZA7":[function(require,module,exports) {
"use strict";
/**
 * var basex = require('base-x');
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes_1 = require("365e997289c5b10c");
var properties_1 = require("611a260ba75be05e");
var BaseX = /** @class */ function() {
    function BaseX(alphabet) {
        properties_1.defineReadOnly(this, "alphabet", alphabet);
        properties_1.defineReadOnly(this, "base", alphabet.length);
        properties_1.defineReadOnly(this, "_alphabetMap", {});
        properties_1.defineReadOnly(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(var i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    BaseX.prototype.encode = function(value) {
        var source = bytes_1.arrayify(value);
        if (source.length === 0) return "";
        var digits = [
            0
        ];
        for(var i = 0; i < source.length; ++i){
            var carry = source[i];
            for(var j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        var string = "";
        // deal with leading zeros
        for(var k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(var q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    };
    BaseX.prototype.decode = function(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        var bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(var i = 0; i < value.length; i++){
            var byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            var carry = byte;
            for(var j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(var k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return bytes_1.arrayify(new Uint8Array(bytes.reverse()));
    };
    return BaseX;
}();
exports.BaseX = BaseX;
var Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567");
exports.Base32 = Base32;
var Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
exports.Base58 = Base58; //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

},{"365e997289c5b10c":"71FSg","611a260ba75be05e":"f68LV"}],"fkPrj":[function(require,module,exports) {
var Buffer = require("e6d710228362650e").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var crypto_1 = require("d9fde0264f9ff593");
var bytes_1 = require("a19660122b7e8f0d");
function bufferify(value) {
    return Buffer.from(bytes_1.arrayify(value));
}
function pbkdf2(password, salt, iterations, keylen, hashAlgorithm) {
    return bytes_1.arrayify(crypto_1.pbkdf2Sync(bufferify(password), bufferify(salt), iterations, keylen, hashAlgorithm));
}
exports.pbkdf2 = pbkdf2;

},{"e6d710228362650e":"l5Twm","d9fde0264f9ff593":"9rmFv","a19660122b7e8f0d":"71FSg"}],"iYhCn":[function(require,module,exports) {
var Buffer = require("ba720ddc91c73bd2").Buffer;
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var crypto_1 = require("f377c0b644a1060");
var bytes_1 = require("717bf679b803a48b");
var errors = __importStar(require("15c4096509c8d506"));
var SupportedAlgorithms;
(function(SupportedAlgorithms) {
    SupportedAlgorithms["sha256"] = "sha256";
    SupportedAlgorithms["sha512"] = "sha512";
})(SupportedAlgorithms = exports.SupportedAlgorithms || (exports.SupportedAlgorithms = {}));
function computeHmac(algorithm, key, data) {
    if (!SupportedAlgorithms[algorithm]) errors.throwError("unsupported algorithm " + algorithm, errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return bytes_1.arrayify(crypto_1.createHmac(algorithm, Buffer.from(bytes_1.arrayify(key))).update(Buffer.from(bytes_1.arrayify(data))).digest());
}
exports.computeHmac = computeHmac;

},{"ba720ddc91c73bd2":"l5Twm","f377c0b644a1060":"9rmFv","717bf679b803a48b":"71FSg","15c4096509c8d506":"ljnPX"}],"jYC5E":[function(require,module,exports) {
"use strict";
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var elliptic_1 = require("2495e254c70a31df");
var address_1 = require("cd60bb70e79b73c4");
var bytes_1 = require("8ede1754323324ad");
var hash_1 = require("c40663a0b2c5c924");
var keccak256_1 = require("3e503e5ad206d391");
var properties_1 = require("7a283c4ed2a337f2");
var errors = __importStar(require("ea989855b19cdab"));
///////////////////////////////
var _curve = null;
function getCurve() {
    if (!_curve) _curve = new elliptic_1.ec("secp256k1");
    return _curve;
}
var KeyPair = /** @class */ function() {
    function KeyPair(privateKey) {
        var keyPair = getCurve().keyFromPrivate(bytes_1.arrayify(privateKey));
        properties_1.defineReadOnly(this, "privateKey", bytes_1.hexlify(keyPair.priv.toArray("be", 32)));
        properties_1.defineReadOnly(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        properties_1.defineReadOnly(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        properties_1.defineReadOnly(this, "publicKeyBytes", keyPair.getPublic().encode(null, true));
    }
    KeyPair.prototype.sign = function(digest) {
        var keyPair = getCurve().keyFromPrivate(bytes_1.arrayify(this.privateKey));
        var signature = keyPair.sign(bytes_1.arrayify(digest), {
            canonical: true
        });
        return {
            recoveryParam: signature.recoveryParam,
            r: bytes_1.hexZeroPad("0x" + signature.r.toString(16), 32),
            s: bytes_1.hexZeroPad("0x" + signature.s.toString(16), 32),
            v: 27 + signature.recoveryParam
        };
    };
    KeyPair.prototype.computeSharedSecret = function(otherKey) {
        var keyPair = getCurve().keyFromPrivate(bytes_1.arrayify(this.privateKey));
        var otherKeyPair = getCurve().keyFromPublic(bytes_1.arrayify(computePublicKey(otherKey)));
        return bytes_1.hexZeroPad("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    };
    KeyPair.prototype._addPoint = function(other) {
        var p0 = getCurve().keyFromPublic(bytes_1.arrayify(this.publicKey));
        var p1 = getCurve().keyFromPublic(bytes_1.arrayify(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    };
    return KeyPair;
}();
exports.KeyPair = KeyPair;
function computePublicKey(key, compressed) {
    var bytes = bytes_1.arrayify(key);
    if (bytes.length === 32) {
        var keyPair = new KeyPair(bytes);
        if (compressed) return keyPair.compressedPublicKey;
        return keyPair.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return bytes_1.hexlify(bytes);
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return bytes_1.hexlify(bytes);
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    errors.throwError("invalid public or private key", errors.INVALID_ARGUMENT, {
        arg: "key",
        value: "[REDACTED]"
    });
    return null;
}
exports.computePublicKey = computePublicKey;
function computeAddress(key) {
    // Strip off the leading "0x04"
    var publicKey = "0x" + computePublicKey(key).slice(4);
    return address_1.getAddress("0x" + keccak256_1.keccak256(publicKey).substring(26));
}
exports.computeAddress = computeAddress;
function recoverPublicKey(digest, signature) {
    var sig = bytes_1.splitSignature(signature);
    var rs = {
        r: bytes_1.arrayify(sig.r),
        s: bytes_1.arrayify(sig.s)
    };
    return "0x" + getCurve().recoverPubKey(bytes_1.arrayify(digest), rs, sig.recoveryParam).encode("hex", false);
}
exports.recoverPublicKey = recoverPublicKey;
function recoverAddress(digest, signature) {
    return computeAddress(recoverPublicKey(bytes_1.arrayify(digest), signature));
}
exports.recoverAddress = recoverAddress;
function verifyMessage(message, signature) {
    return recoverAddress(hash_1.hashMessage(message), signature);
}
exports.verifyMessage = verifyMessage;

},{"2495e254c70a31df":"e8UEU","cd60bb70e79b73c4":"73HJd","8ede1754323324ad":"71FSg","c40663a0b2c5c924":"9k2eV","3e503e5ad206d391":"g4rCo","7a283c4ed2a337f2":"f68LV","ea989855b19cdab":"ljnPX"}],"53Rub":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var hash_js_1 = __importDefault(require("3a8ad0152918d2d"));
var bytes_1 = require("9a6f79c4777662f");
function ripemd160(data) {
    return "0x" + hash_js_1.default.ripemd160().update(bytes_1.arrayify(data)).digest("hex");
}
exports.ripemd160 = ripemd160;
function sha256(data) {
    return "0x" + hash_js_1.default.sha256().update(bytes_1.arrayify(data)).digest("hex");
}
exports.sha256 = sha256;
function sha512(data) {
    return "0x" + hash_js_1.default.sha512().update(bytes_1.arrayify(data)).digest("hex");
}
exports.sha512 = sha512;

},{"3a8ad0152918d2d":"ky4Km","9a6f79c4777662f":"71FSg"}],"ky4Km":[function(require,module,exports) {
var hash = exports;
hash.utils = require("c873f1c67065c0da");
hash.common = require("c35870c26520dd9a");
hash.sha = require("be076af41df5aa9c");
hash.ripemd = require("75d89280852a68b6");
hash.hmac = require("a04e5f9e7ddda45a");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"c873f1c67065c0da":"1F40f","c35870c26520dd9a":"84Ocf","be076af41df5aa9c":"kLkhd","75d89280852a68b6":"iWjQQ","a04e5f9e7ddda45a":"aVZAO"}],"1F40f":[function(require,module,exports) {
"use strict";
var assert = require("bc41f8372ac69739");
var inherits = require("92ad4fe2efeeac08");
exports.inherits = inherits;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"bc41f8372ac69739":"cKbUa","92ad4fe2efeeac08":"8LxVj"}],"84Ocf":[function(require,module,exports) {
"use strict";
var utils = require("5eb5f105eb7634f2");
var assert = require("81125b3339dc18ed");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"5eb5f105eb7634f2":"1F40f","81125b3339dc18ed":"cKbUa"}],"kLkhd":[function(require,module,exports) {
"use strict";
exports.sha1 = require("7414712c0e1d0b58");
exports.sha224 = require("6f0e1be062c5520c");
exports.sha256 = require("4ba173c3047f67");
exports.sha384 = require("5ea64f0b0e65ecf");
exports.sha512 = require("7b85b3f2c7071a07");

},{"7414712c0e1d0b58":"2pIwg","6f0e1be062c5520c":"l7cuC","4ba173c3047f67":"9oTXF","5ea64f0b0e65ecf":"buf1t","7b85b3f2c7071a07":"aiLrz"}],"2pIwg":[function(require,module,exports) {
"use strict";
var utils = require("44a22a87a3693483");
var common = require("e63090fe4419a568");
var shaCommon = require("2f85032d4adccdfb");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"44a22a87a3693483":"1F40f","e63090fe4419a568":"84Ocf","2f85032d4adccdfb":"kgJsG"}],"kgJsG":[function(require,module,exports) {
"use strict";
var utils = require("9f9f37fe881e4c28");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"9f9f37fe881e4c28":"1F40f"}],"l7cuC":[function(require,module,exports) {
"use strict";
var utils = require("522cd89fa0feaa96");
var SHA256 = require("d2a85452bc858393");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
    else return utils.split32(this.h.slice(0, 7), "big");
};

},{"522cd89fa0feaa96":"1F40f","d2a85452bc858393":"9oTXF"}],"9oTXF":[function(require,module,exports) {
"use strict";
var utils = require("e01eeff34b290956");
var common = require("776b5393d8865889");
var shaCommon = require("94cb92ef633baa98");
var assert = require("674e6be558847c87");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"e01eeff34b290956":"1F40f","776b5393d8865889":"84Ocf","94cb92ef633baa98":"kgJsG","674e6be558847c87":"cKbUa"}],"buf1t":[function(require,module,exports) {
"use strict";
var utils = require("d5f667dab85f1ab1");
var SHA512 = require("b1e86e39494d39d9");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
    else return utils.split32(this.h.slice(0, 12), "big");
};

},{"d5f667dab85f1ab1":"1F40f","b1e86e39494d39d9":"aiLrz"}],"aiLrz":[function(require,module,exports) {
"use strict";
var utils = require("61a47830d8365c8c");
var common = require("43865005bd6d1caa");
var assert = require("a9b1277733d0b93a");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"61a47830d8365c8c":"1F40f","43865005bd6d1caa":"84Ocf","a9b1277733d0b93a":"cKbUa"}],"iWjQQ":[function(require,module,exports) {
"use strict";
var utils = require("d04e96bb68c50e47");
var common = require("8d669f8c2ecf9202");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "little");
    else return utils.split32(this.h, "little");
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"d04e96bb68c50e47":"1F40f","8d669f8c2ecf9202":"84Ocf"}],"aVZAO":[function(require,module,exports) {
"use strict";
var utils = require("36d13d1ea4e41c7d");
var assert = require("fa286601cba08637");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"36d13d1ea4e41c7d":"1F40f","fa286601cba08637":"cKbUa"}],"6GSe1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes_1 = require("bf4c0e71bf7d72d9");
var crypto_1 = require("cd4e2a246352ec35");
function randomBytes(length) {
    return bytes_1.arrayify(crypto_1.randomBytes(length));
}
exports.randomBytes = randomBytes;

},{"bf4c0e71bf7d72d9":"71FSg","cd4e2a246352ec35":"9rmFv"}],"etwN5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mnemonic", ()=>mnemonic);
var _hdnode = require("@vechain/ethers/utils/hdnode");
var _crypto = require("crypto");
var _hdnode1 = require("./hdnode");
var mnemonic;
(function(mnemonic) {
    /**
     * generate BIP39 mnemonic words
     * @param rng the optional random number generator, which generates 16~32 (step 4) random bytes.
     * Every 4 bytes produce 3 words.
     */ function generate(rng) {
        rng = rng || (()=>(0, _crypto.randomBytes)(16));
        return _hdnode.entropyToMnemonic(rng()).split(" ");
    }
    mnemonic.generate = generate;
    /**
     * check if the given mnemonic words have valid checksum
     * @param words mnemonic words
     */ function validate(words) {
        return _hdnode.isValidMnemonic(words.join(" "));
    }
    mnemonic.validate = validate;
    /**
     * derive private key at index 0 from mnemonic words according to BIP32.
     * the derivation path is defined at https://github.com/satoshilabs/slips/blob/master/slip-0044.md
     */ function derivePrivateKey(words) {
        return (0, _hdnode1.HDNode).fromMnemonic(words).derive(0).privateKey;
    }
    mnemonic.derivePrivateKey = derivePrivateKey;
})(mnemonic || (mnemonic = {}));

},{"@vechain/ethers/utils/hdnode":"9KSDI","crypto":"9rmFv","./hdnode":"eDGtf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDGtf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HDNode", ()=>HDNode);
var _basex = require("@vechain/ethers/utils/basex");
var _hdnode = require("@vechain/ethers/utils/hdnode");
var _crypto = require("crypto");
var _elliptic = require("elliptic");
var _address = require("./address");
var Buffer = require("916d121c50b5ea8e").Buffer;
// see https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const VET_DERIVATION_PATH = `m/44'/818'/0'/0`;
const xpubPrefix = Buffer.from("0488b21e000000000000000000", "hex");
const xprivPrefix = Buffer.from("0488ade4000000000000000000", "hex");
const curve = new (0, _elliptic.ec)("secp256k1");
var HDNode;
(function(HDNode) {
    /** create node from mnemonic words */ function fromMnemonic(words) {
        // normalize words to lowercase
        const joinedWords = words.join(" ").toLowerCase();
        const node = _hdnode.fromMnemonic(joinedWords).derivePath(VET_DERIVATION_PATH);
        return createHDNode(node);
    }
    HDNode.fromMnemonic = fromMnemonic;
    /**
     * create node from xpub
     * @param pub public key
     * @param chainCode chain code
     */ function fromPublicKey(pub, chainCode) {
        const compressed = curve.keyFromPublic(pub).getPublic(true, "array");
        const key = Buffer.concat([
            xpubPrefix,
            chainCode,
            Buffer.from(compressed)
        ]);
        const checksum = sha256(sha256(key)).slice(0, 4);
        const node = _hdnode.fromExtendedKey((0, _basex.Base58).encode(Buffer.concat([
            key,
            checksum
        ])));
        return createHDNode(node);
    }
    HDNode.fromPublicKey = fromPublicKey;
    /**
     * create node from xpriv
     * @param priv private key
     * @param chainCode chain code
     */ function fromPrivateKey(priv, chainCode) {
        const key = Buffer.concat([
            xprivPrefix,
            chainCode,
            Buffer.from([
                0
            ]),
            priv
        ]);
        const checksum = sha256(sha256(key)).slice(0, 4);
        const node = _hdnode.fromExtendedKey((0, _basex.Base58).encode(Buffer.concat([
            key,
            checksum
        ])));
        return createHDNode(node);
    }
    HDNode.fromPrivateKey = fromPrivateKey;
    function createHDNode(ethersNode) {
        const pub = Buffer.from(curve.keyFromPublic(ethersNode.publicKey.slice(2), "hex").getPublic(false, "array"));
        const priv = ethersNode.privateKey ? Buffer.from(ethersNode.privateKey.slice(2), "hex") : null;
        const cc = Buffer.from(ethersNode.chainCode.slice(2), "hex");
        const addr = (0, _address.address).fromPublicKey(pub);
        return {
            get publicKey () {
                return pub;
            },
            get privateKey () {
                return priv;
            },
            get chainCode () {
                return cc;
            },
            get address () {
                return addr;
            },
            derive (index) {
                return createHDNode(ethersNode.derivePath("" + index));
            }
        };
    }
    function sha256(data) {
        return (0, _crypto.createHash)("sha256").update(data).digest();
    }
})(HDNode || (HDNode = {}));

},{"916d121c50b5ea8e":"l5Twm","@vechain/ethers/utils/basex":"2PZA7","@vechain/ethers/utils/hdnode":"9KSDI","crypto":"9rmFv","elliptic":"e8UEU","./address":"aT2rv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bK13X":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sleep = void 0;
function sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
exports.sleep = sleep;

},{}],"aFL01":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"xm3Bj":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimpleNet = void 0;
const axios_1 = require("2c23ac0c58723482");
const simple_websocket_reader_1 = require("df396383b635ab3f");
const url_1 = require("cfa3c1fd0adbdf9b");
const http_1 = require("f991c8d32152a22a");
const https_1 = require("ede7eb59f58e2550");
/** class simply implements Net interface */ class SimpleNet {
    constructor(baseURL, timeout = 30000, wsTimeout = 30000){
        this.baseURL = baseURL;
        this.wsTimeout = wsTimeout;
        this.axios = axios_1.default.create({
            httpAgent: new http_1.Agent({
                keepAlive: true
            }),
            httpsAgent: new https_1.Agent({
                keepAlive: true
            }),
            baseURL,
            timeout
        });
    }
    http(method, path, params) {
        return __awaiter(this, void 0, void 0, function*() {
            params = params || {};
            try {
                const resp = yield this.axios.request({
                    method,
                    url: path,
                    data: params.body,
                    headers: params.headers,
                    params: params.query
                });
                if (params.validateResponseHeader) params.validateResponseHeader(resp.headers);
                return resp.data;
            } catch (err) {
                if (err.isAxiosError) throw convertError(err);
                throw new Error(`${method} ${url_1.resolve(this.baseURL, path)}: ${err.message}`);
            }
        });
    }
    openWebSocketReader(path) {
        const url = url_1.resolve(this.baseURL, path).replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
        return new simple_websocket_reader_1.SimpleWebSocketReader(url, this.wsTimeout);
    }
}
exports.SimpleNet = SimpleNet;
function convertError(err) {
    if (err.response) {
        const resp = err.response;
        if (typeof resp.data === "string") {
            let text = resp.data.trim();
            if (text.length > 50) text = text.slice(0, 50) + "...";
            return new Error(`${resp.status} ${err.config.method} ${err.config.url}: ${text}`);
        } else return new Error(`${resp.status} ${err.config.method} ${err.config.url}`);
    } else return new Error(`${err.config.method} ${err.config.url}: ${err.message}`);
}

},{"2c23ac0c58723482":"gqqlV","df396383b635ab3f":"ioHF1","cfa3c1fd0adbdf9b":"280SV","f991c8d32152a22a":"biwe9","ede7eb59f58e2550":"h9uDr"}],"gqqlV":[function(require,module,exports) {
module.exports = require("9f37cef8b0e13afc");

},{"9f37cef8b0e13afc":"bpQHr"}],"bpQHr":[function(require,module,exports) {
"use strict";
var utils = require("1137fef34918bf53");
var bind = require("ce63a8247a300202");
var Axios = require("c14c66f4c3ec48a2");
var mergeConfig = require("345f9ec0ee8efc80");
var defaults = require("27bdb15d131780c5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);
    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);
    // Copy context to instance
    utils.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var axios = createInstance(defaults);
// Expose Axios class to allow class inheritance
axios.Axios = Axios;
// Factory for creating new instances
axios.create = function create(instanceConfig) {
    return createInstance(mergeConfig(axios.defaults, instanceConfig));
};
// Expose Cancel & CancelToken
axios.Cancel = require("ae1da7645e57ebca");
axios.CancelToken = require("853fec7db7d524b4");
axios.isCancel = require("322a636c3e2325e1");
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = require("75c7c70e55d88256");
// Expose isAxiosError
axios.isAxiosError = require("543a1da09311ae9b");
module.exports = axios;
// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"1137fef34918bf53":"j4U5Z","ce63a8247a300202":"lsHw8","c14c66f4c3ec48a2":"gSzLM","345f9ec0ee8efc80":"hBFgb","27bdb15d131780c5":"2sPgx","ae1da7645e57ebca":"aM0uf","853fec7db7d524b4":"d4MXP","322a636c3e2325e1":"kQA2M","75c7c70e55d88256":"jQT5B","543a1da09311ae9b":"2EXuU"}],"j4U5Z":[function(require,module,exports) {
"use strict";
var bind = require("a7c7b4094caa86ac");
// utils is a library of generic helper functions non-specific to axios
var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
    return toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function isArrayBuffer(val) {
    return toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
    if (toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function isDate(val) {
    return toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function isFile(val) {
    return toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function isBlob(val) {
    return toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
    return toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
    var result = {};
    function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
        else if (isPlainObject(val)) result[key] = merge({}, val);
        else if (isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = bind(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
};

},{"a7c7b4094caa86ac":"lsHw8"}],"lsHw8":[function(require,module,exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

},{}],"gSzLM":[function(require,module,exports) {
"use strict";
var utils = require("2cd2d0baba832579");
var buildURL = require("945ebba9256ed84f");
var InterceptorManager = require("fc2d71ae77ba798e");
var dispatchRequest = require("77b4f57f4d663a9b");
var mergeConfig = require("5db81a4f62f8927d");
var validator = require("d0f5147a00cee7c5");
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = mergeConfig(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
        forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
        clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
utils.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
utils.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, data, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = Axios;

},{"2cd2d0baba832579":"j4U5Z","945ebba9256ed84f":"hOGC1","fc2d71ae77ba798e":"g8bpG","77b4f57f4d663a9b":"98TLw","5db81a4f62f8927d":"hBFgb","d0f5147a00cee7c5":"ky4Bn"}],"hOGC1":[function(require,module,exports) {
"use strict";
var utils = require("d198994ea2a45305");
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if (utils.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) v = v.toISOString();
                else if (utils.isObject(v)) v = JSON.stringify(v);
                parts.push(encode(key) + "=" + encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

},{"d198994ea2a45305":"j4U5Z"}],"g8bpG":[function(require,module,exports) {
"use strict";
var utils = require("982be9ba543c1801");
function InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = InterceptorManager;

},{"982be9ba543c1801":"j4U5Z"}],"98TLw":[function(require,module,exports) {
"use strict";
var utils = require("dccb83262660ba2a");
var transformData = require("670a836c9c5a1abe");
var isCancel = require("9b938a75c8452b2f");
var defaults = require("293260d2186f65fb");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = transformData.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    utils.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

},{"dccb83262660ba2a":"j4U5Z","670a836c9c5a1abe":"74rSt","9b938a75c8452b2f":"kQA2M","293260d2186f65fb":"2sPgx"}],"74rSt":[function(require,module,exports) {
"use strict";
var utils = require("506225f7f22ee5b3");
var defaults = require("5f8f7bd977372ccb");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || defaults;
    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

},{"506225f7f22ee5b3":"j4U5Z","5f8f7bd977372ccb":"2sPgx"}],"2sPgx":[function(require,module,exports) {
var process = require("1ad3e53325021694");
"use strict";
var utils = require("46f17d5a961ed1b0");
var normalizeHeaderName = require("cc6d63c7870abf00");
var enhanceError = require("381f0945c152ddd3");
var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
    if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}
function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = require("f5547462a34fd4c6");
    else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") // For node use HTTP adapter
    adapter = require("1a73616b0da0ef06");
    return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
    if (utils.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return utils.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            normalizeHeaderName(headers, "Accept");
            normalizeHeaderName(headers, "Content-Type");
            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
            if (utils.isArrayBufferView(data)) return data.buffer;
            if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                setContentTypeIfUnset(headers, "application/json");
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw enhanceError(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
utils.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
});
utils.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

},{"1ad3e53325021694":"5QIF0","46f17d5a961ed1b0":"j4U5Z","cc6d63c7870abf00":"drGT9","381f0945c152ddd3":"klxZS","f5547462a34fd4c6":"hVrwR","1a73616b0da0ef06":"hVrwR"}],"drGT9":[function(require,module,exports) {
"use strict";
var utils = require("5f8afca0889a63e1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

},{"5f8afca0889a63e1":"j4U5Z"}],"klxZS":[function(require,module,exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

},{}],"hVrwR":[function(require,module,exports) {
"use strict";
var utils = require("2bb8b5f6db10dd6d");
var settle = require("a7b983c12bb9f77f");
var cookies = require("19bdb320f45f036e");
var buildURL = require("568f70ee55491398");
var buildFullPath = require("a1fd5a6807469b6d");
var parseHeaders = require("f197d20bdfdcd5a4");
var isURLSameOrigin = require("32737c301de74bf5");
var createError = require("df24397a62f10f34");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if (utils.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            settle(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(createError("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

},{"2bb8b5f6db10dd6d":"j4U5Z","a7b983c12bb9f77f":"jaZcJ","19bdb320f45f036e":"eD59s","568f70ee55491398":"hOGC1","a1fd5a6807469b6d":"6MlRA","f197d20bdfdcd5a4":"g7ZuC","32737c301de74bf5":"3QStk","df24397a62f10f34":"9Cxv7"}],"jaZcJ":[function(require,module,exports) {
"use strict";
var createError = require("72d296795d733aeb");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(createError("Request failed with status code " + response.status, response.config, null, response.request, response));
};

},{"72d296795d733aeb":"9Cxv7"}],"9Cxv7":[function(require,module,exports) {
"use strict";
var enhanceError = require("ff529806947600d1");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError(error, config, code, request, response);
};

},{"ff529806947600d1":"klxZS"}],"eD59s":[function(require,module,exports) {
"use strict";
var utils = require("c987331427b8b2ad");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if (utils.isString(path)) cookie.push("path=" + path);
            if (utils.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

},{"c987331427b8b2ad":"j4U5Z"}],"6MlRA":[function(require,module,exports) {
"use strict";
var isAbsoluteURL = require("5ff0e8c05aa13380");
var combineURLs = require("e1ac36eef7d02fa4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
    return requestedURL;
};

},{"5ff0e8c05aa13380":"02G4G","e1ac36eef7d02fa4":"6BOaY"}],"02G4G":[function(require,module,exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],"6BOaY":[function(require,module,exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

},{}],"g7ZuC":[function(require,module,exports) {
"use strict";
var utils = require("5802dc5113a634d0");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

},{"5802dc5113a634d0":"j4U5Z"}],"3QStk":[function(require,module,exports) {
"use strict";
var utils = require("c8f79893fd676b4c");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"c8f79893fd676b4c":"j4U5Z"}],"kQA2M":[function(require,module,exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

},{}],"hBFgb":[function(require,module,exports) {
"use strict";
var utils = require("99adbff39af8f677");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
        else if (utils.isPlainObject(source)) return utils.merge({}, source);
        else if (utils.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    utils.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    utils.forEach(otherKeys, mergeDeepProperties);
    return config;
};

},{"99adbff39af8f677":"j4U5Z"}],"ky4Bn":[function(require,module,exports) {
"use strict";
var pkg = require("3c22590bc411b699");
var validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: isOlderVersion,
    assertOptions: assertOptions,
    validators: validators
};

},{"3c22590bc411b699":"1eZdx"}],"1eZdx":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

},{}],"aM0uf":[function(require,module,exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function Cancel(message) {
    this.message = message;
}
Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel.prototype.__CANCEL__ = true;
module.exports = Cancel;

},{}],"d4MXP":[function(require,module,exports) {
"use strict";
var Cancel = require("69a8f59e5e2b033");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = CancelToken;

},{"69a8f59e5e2b033":"aM0uf"}],"jQT5B":[function(require,module,exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

},{}],"2EXuU":[function(require,module,exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

},{}],"ioHF1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimpleWebSocketReader = void 0;
const WebSocket = require("d631a05e77f7ae9b");
class SimpleWebSocketReader {
    constructor(url, timeout = 30000){
        this.timeout = timeout;
        this.callbacks = [];
        this.ws = new WebSocket(url);
        this.ws.onmessage = (ev)=>{
            try {
                const cbs = this.callbacks;
                this.callbacks = [];
                cbs.forEach((cb)=>cb(ev.data));
            } catch (err) {
                this.setError(err);
                this.ws.close();
            }
        };
        this.ws.onerror = (ev)=>{
            this.setError(ev.error);
            this.ws.close();
        };
        this.ws.onclose = ()=>{
            this.setError(new Error("closed"));
        };
    }
    read() {
        return new Promise((resolve, reject)=>{
            if (this.error) return reject(this.error);
            const timer = setTimeout(()=>{
                reject(new Error("ws read timeout"));
            }, this.timeout);
            this.callbacks.push((data, err)=>{
                clearTimeout(timer);
                if (err) return reject(err);
                resolve(data);
            });
        });
    }
    close() {
        this.ws.close();
    }
    setError(err) {
        if (!this.error) {
            this.error = err;
            const cbs = this.callbacks;
            this.callbacks = [];
            cbs.forEach((cb)=>cb(null, err));
        }
    }
}
exports.SimpleWebSocketReader = SimpleWebSocketReader;

},{"d631a05e77f7ae9b":"jo9DE"}],"jo9DE":[function(require,module,exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var global = arguments[3];
var ws = null;
if (typeof WebSocket !== "undefined") ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") ws = MozWebSocket;
else if (typeof global !== "undefined") ws = global.WebSocket || global.MozWebSocket;
else if (typeof window !== "undefined") ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") ws = self.WebSocket || self.MozWebSocket;
module.exports = ws;

},{}],"280SV":[function(require,module,exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";
var punycode = require("6aa635927f16f681");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
}, querystring = require("6724c84b9b69726b");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = querystring.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

},{"6aa635927f16f681":"8ORYx","6724c84b9b69726b":"3KnnP"}],"8ORYx":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"3KnnP":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"c65e4","7ffa4249597bf32b":"4TH1Q","454df9476704f887":"4FjOV"}],"c65e4":[function(require,module,exports) {
"use strict";
var getSideChannel = require("6246bbb805756d41");
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats["default"];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = formats["default"];
    if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

},{"6246bbb805756d41":"kTEaB","44263cc7b702ebf":"3YhBn","929f8531a94a537c":"4FjOV"}],"kTEaB":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("7911ec51a2dc9f3e");
var callBound = require("125062ab9035288f");
var inspect = require("9f4f5a92d8c6543");
var $TypeError = require("1d3f7a3f029b095e");
var $WeakMap = GetIntrinsic("%WeakMap%", true);
var $Map = GetIntrinsic("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var listGet = function(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var listHas = function(objects, key) {
    return !!listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapGet($wm, key);
            } else if ($Map) {
                if ($m) return $mapGet($m, key);
            } else {
                if ($o) return listGet($o, key);
            }
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapHas($wm, key);
            } else if ($Map) {
                if ($m) return $mapHas($m, key);
            } else {
                if ($o) return listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if ($Map) {
                if (!$m) $m = new $Map();
                $mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                listSet($o, key, value);
            }
        }
    };
    return channel;
};

},{"7911ec51a2dc9f3e":"igBhj","125062ab9035288f":"eK6wT","9f4f5a92d8c6543":"87sBP","1d3f7a3f029b095e":"8YLfd"}],"igBhj":[function(require,module,exports) {
"use strict";
var undefined1;
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    "%EvalError%": $EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"ff34c740859aa28e":"5DjZP","349515b7ea9b6cef":"ilptm","9da01653b2dd9abf":"dIEDM","68586abd6b0136da":"fEjTP","662263fdbc077fc8":"5eMyt","abdfc34e5f6bb86":"8YLfd","daca1f932429e03e":"0AO4W","1f00f712d594ccf":"7Qiml","23730654306aa64c":"bIcqy","7c5e688e48cd07b0":"42Rnv","af36d49b4b8c6c7c":"b31Xs"}],"5DjZP":[function(require,module,exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

},{}],"ilptm":[function(require,module,exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"dIEDM":[function(require,module,exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"fEjTP":[function(require,module,exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"5eMyt":[function(require,module,exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"8YLfd":[function(require,module,exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"0AO4W":[function(require,module,exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"7Qiml":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"8apFc"}],"8apFc":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"bIcqy":[function(require,module,exports) {
"use strict";
var test = {
    __proto__: null,
    foo: {}
};
var $Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: test
    }).foo === test.foo && !(test instanceof $Object);
};

},{}],"42Rnv":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"g2Nry"}],"g2Nry":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"b31Xs":[function(require,module,exports) {
"use strict";
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"42Rnv"}],"eK6wT":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"igBhj","266fc50410cfc4a":"8iKie"}],"8iKie":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var setFunctionLength = require("f4b53071c102d4e");
var $TypeError = require("761613670c43be80");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $defineProperty = require("3426ee59b177cf96");
var $max = GetIntrinsic("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"42Rnv","68d2ad3775278f43":"igBhj","f4b53071c102d4e":"3pGTz","761613670c43be80":"8YLfd","3426ee59b177cf96":"fFPki"}],"3pGTz":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"igBhj","37dd1486f0f556ef":"1VH5F","6a9d2b46085df706":"h7wkG","2d412b0f532d1834":"bOKb6","4352c534d27fe477":"8YLfd"}],"1VH5F":[function(require,module,exports) {
"use strict";
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

},{"f17fd23367965521":"fFPki","50f12088ee0f6bb":"5eMyt","45c79de2b2f9c949":"8YLfd","3f9bd39335781ec7":"bOKb6"}],"fFPki":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8e0b8e4026aaf38a");
/** @type {import('.')} */ var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{"8e0b8e4026aaf38a":"igBhj"}],"bOKb6":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"igBhj"}],"h7wkG":[function(require,module,exports) {
"use strict";
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"fFPki"}],"87sBP":[function(require,module,exports) {
var global = arguments[3];
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
        return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
    if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
    if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === global) return "{ [object globalThis] }";
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
        return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
}
function isArray(obj) {
    return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== "object") return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return "Object(" + str + ")";
}
function weakCollectionOf(type) {
    return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"13Pcp"}],"3YhBn":[function(require,module,exports) {
"use strict";
var formats = require("7adf3674f81a2c87");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if (isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
    return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"7adf3674f81a2c87":"4FjOV"}],"4FjOV":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"4TH1Q":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: true,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) charset = "utf-8";
            else if (parts[i] === isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = isArray(val) ? [
            val
        ] : val;
        var existing = has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = utils.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"3YhBn"}],"biwe9":[function(require,module,exports) {
var global = arguments[3];
var ClientRequest = require("83d28c734ca853c7");
var response = require("48c6aa21794e4a2c");
var extend = require("cc32961fe07c8fa5");
var statusCodes = require("381164753d333ab6");
var url = require("6039c69b7d2da501");
var http = exports;
http.request = function(opts, cb) {
    if (typeof opts === "string") opts = url.parse(opts);
    else opts = extend(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new ClientRequest(opts);
    if (cb) req.on("response", cb);
    return req;
};
http.get = function get(opts, cb) {
    var req = http.request(opts, cb);
    req.end();
    return req;
};
http.ClientRequest = ClientRequest;
http.IncomingMessage = response.IncomingMessage;
http.Agent = function() {};
http.Agent.defaultMaxSockets = 4;
http.globalAgent = new http.Agent();
http.STATUS_CODES = statusCodes;
http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

},{"83d28c734ca853c7":"3MspK","48c6aa21794e4a2c":"288qE","cc32961fe07c8fa5":"7rqcZ","381164753d333ab6":"fHu7L","6039c69b7d2da501":"280SV"}],"3MspK":[function(require,module,exports) {
var Buffer = require("171a808a93d7935a").Buffer;
var global = arguments[3];
var process = require("a9ea3f73cd8e4ec0");
var capability = require("47a5b3351a25523b");
var inherits = require("33d332b21b1041");
var response = require("90881d49dd53d428");
var stream = require("c817ce87e1330fb2");
var IncomingMessage = response.IncomingMessage;
var rStates = response.readyStates;
function decideMode(preferBinary, useFetch) {
    if (capability.fetch && useFetch) return "fetch";
    else if (capability.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if (capability.msstream) return "ms-stream";
    else if (capability.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var ClientRequest = module.exports = function(opts) {
    var self = this;
    stream.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !capability.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !capability.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
inherits(ClientRequest, stream.Writable);
ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if (unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if (capability.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case rStates.LOADING:
                case rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    stream.Writable.prototype.end.call(self, data, encoding, cb);
};
ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
ClientRequest.prototype.flushHeaders = function() {};
ClientRequest.prototype.setNoDelay = function() {};
ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

},{"171a808a93d7935a":"l5Twm","a9ea3f73cd8e4ec0":"5QIF0","47a5b3351a25523b":"kHzFH","33d332b21b1041":"8LxVj","90881d49dd53d428":"288qE","c817ce87e1330fb2":"k5khq"}],"kHzFH":[function(require,module,exports) {
var global = arguments[3];
exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream);
exports.writableStream = isFunction(global.WritableStream);
exports.abortController = isFunction(global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr;
function getXHR() {
    // Cache the xhr value
    if (xhr !== undefined) return xhr;
    if (global.XMLHttpRequest) {
        xhr = new global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            xhr.open("GET", global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            xhr = null;
        }
    } else // Service workers don't have XHR
    xhr = null;
    return xhr;
}
function checkTypeSupport(type) {
    var xhr = getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport("arraybuffer");
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport("ms-stream");
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport("moz-chunked-arraybuffer");
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false);
function isFunction(value) {
    return typeof value === "function";
}
xhr = null // Help gc
;

},{}],"288qE":[function(require,module,exports) {
var process = require("d1269065c33ee7fe");
var Buffer = require("77d4ce6cf763caca").Buffer;
var global = arguments[3];
var capability = require("7dcf7aadbb533bfb");
var inherits = require("57b1383434ef92a1");
var stream = require("fa2873d490014c0a");
var rStates = exports.readyStates = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var IncomingMessage = exports.IncomingMessage = function(xhr, response, mode, resetTimers) {
    var self = this;
    stream.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        process.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if (capability.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push(Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push(Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!capability.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
inherits(IncomingMessage, stream.Readable);
IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING || !response) break;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING) break;
            var reader = new global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

},{"d1269065c33ee7fe":"5QIF0","77d4ce6cf763caca":"l5Twm","7dcf7aadbb533bfb":"kHzFH","57b1383434ef92a1":"8LxVj","fa2873d490014c0a":"k5khq"}],"k5khq":[function(require,module,exports) {
exports = module.exports = require("68bb3bdae87803ec");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("74167f79b688eaf7");
exports.Duplex = require("84600f6783428a47");
exports.Transform = require("23bee5f697448a0");
exports.PassThrough = require("e0ec4b8e438dbbd");
exports.finished = require("6cc0f9af7147cdbc");
exports.pipeline = require("f90db22d01d3c3d1");

},{"68bb3bdae87803ec":"cKiEz","74167f79b688eaf7":"1l9D3","84600f6783428a47":"jXYL7","23bee5f697448a0":"fyAZh","e0ec4b8e438dbbd":"3kmEt","6cc0f9af7147cdbc":"YQEqF","f90db22d01d3c3d1":"3jCgz"}],"7rqcZ":[function(require,module,exports) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"fHu7L":[function(require,module,exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

},{}],"h9uDr":[function(require,module,exports) {
var http = require("c0383d0f5be55d6b");
var url = require("23c94c23cc2fc416");
var https = module.exports;
for(var key in http)if (http.hasOwnProperty(key)) https[key] = http[key];
https.request = function(params, cb) {
    params = validateParams(params);
    return http.request.call(this, params, cb);
};
https.get = function(params, cb) {
    params = validateParams(params);
    return http.get.call(this, params, cb);
};
function validateParams(params) {
    if (typeof params === "string") params = url.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

},{"c0383d0f5be55d6b":"biwe9","23c94c23cc2fc416":"280SV"}],"dJziO":[function(require,module,exports) {
var Buffer = require("69fdb0b234b20a8b").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimpleWallet = void 0;
const thor_devkit_1 = require("ae2e9913009e619");
/** class simply implements Wallet interface */ class SimpleWallet {
    constructor(){
        this.keys = [];
    }
    get list() {
        return this.keys.map((k)=>{
            return {
                address: k.address,
                sign (msgHash) {
                    return Promise.resolve(thor_devkit_1.secp256k1.sign(msgHash, k.privateKey));
                }
            };
        });
    }
    /**
     * import private key
     * @param privateKey hex string presented private key
     * @returns address derived from the private key
     */ import(privateKey) {
        if (privateKey.startsWith("0x")) privateKey = privateKey.slice(2);
        if (!/^[0-9a-f]{64}$/i.test(privateKey)) throw new Error("invalid private key");
        const buf = Buffer.from(privateKey, "hex");
        const addr = thor_devkit_1.address.fromPublicKey(thor_devkit_1.secp256k1.derivePublicKey(buf));
        this.keys.push({
            address: addr,
            privateKey: buf
        });
        return addr;
    }
    /**
     * remove corresponding key by given address
     * @param addr address
     * @returns true if found and removed, false otherwise
     */ remove(addr) {
        const i = this.keys.findIndex((k)=>k.address === addr.toLowerCase());
        if (i >= 0) {
            this.keys.splice(i, 1);
            return true;
        }
        return false;
    }
}
exports.SimpleWallet = SimpleWallet;

},{"69fdb0b234b20a8b":"l5Twm","ae2e9913009e619":"iIWuY"}],"irTjk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Class implements Connex interface
 */ parcelHelpers.export(exports, "Framework", ()=>Framework);
parcelHelpers.export(exports, "newVendor", ()=>(0, _vendor.newVendor));
var _thor = require("./thor");
var _vendor = require("./vendor");
var _driverGuard = require("./driver-guard");
class Framework {
    /**
     * constructor
     * @param driver the driver instance
     */ constructor(driver){
        this.thor = (0, _thor.newThor)(driver);
        this.vendor = (0, _vendor.newVendor)(driver);
    }
    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */ static guardDriver(driver, errorHandler) {
        return (0, _driverGuard.newDriverGuard)(driver, errorHandler);
    }
}

},{"./thor":"3begD","./vendor":"chNuL","./driver-guard":"iwXmN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3begD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newThor", ()=>newThor);
var _accountVisitor = require("./account-visitor");
var _blockVisitor = require("./block-visitor");
var _txVisitor = require("./tx-visitor");
var _filter = require("./filter");
var _headTracker = require("./head-tracker");
var _explainer = require("./explainer");
var _rules = require("./rules");
var _validatorTs = require("validator-ts");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function newThor(driver) {
    const headTracker = (0, _headTracker.newHeadTracker)(driver);
    const readyDriver = (()=>__awaiter(this, void 0, void 0, function*() {
            if (headTracker.head.number > 0) return driver;
            yield headTracker.ticker().next();
            return driver;
        }))();
    const genesis = JSON.parse(JSON.stringify(driver.genesis));
    return {
        get genesis () {
            return genesis;
        },
        get status () {
            return {
                head: headTracker.head,
                progress: headTracker.progress,
                finalized: headTracker.finalized
            };
        },
        ticker: ()=>headTracker.ticker(),
        account: (addr)=>{
            addr = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return (0, _accountVisitor.newAccountVisitor)(readyDriver, addr);
        },
        block: (revision)=>{
            if (typeof revision === "undefined") revision = driver.head.id;
            else _rules.ensure(typeof revision === "string" ? _rules.isHexBytes(revision, 32) : _rules.isUInt(revision, 32), "arg0: expected bytes32 or unsigned 32-bit integer");
            return (0, _blockVisitor.newBlockVisitor)(driver, typeof revision === "string" ? revision.toLowerCase() : revision);
        },
        transaction: (id)=>{
            id = _rules.test(id, _rules.bytes32, "arg0").toLowerCase();
            return (0, _txVisitor.newTxVisitor)(readyDriver, id);
        },
        filter: (kind, criteria)=>{
            _rules.ensure(kind === "event" || kind === "transfer", `arg0: expected 'event' or 'transfer'`);
            if (kind === "event") {
                _rules.test(criteria, [
                    eventCriteriaScheme
                ], "arg1");
                return (0, _filter.newFilter)(readyDriver, "event", criteria.map((c)=>{
                    return {
                        address: c.address ? c.address.toLowerCase() : undefined,
                        topic0: c.topic0 ? c.topic0.toLowerCase() : undefined,
                        topic1: c.topic1 ? c.topic1.toLowerCase() : undefined,
                        topic2: c.topic2 ? c.topic2.toLowerCase() : undefined,
                        topic3: c.topic3 ? c.topic3.toLowerCase() : undefined,
                        topic4: c.topic4 ? c.topic4.toLowerCase() : undefined
                    };
                }));
            } else {
                _rules.test(criteria, [
                    transferCriteriaScheme
                ], "arg1");
                return (0, _filter.newFilter)(readyDriver, "transfer", criteria.map((c)=>{
                    return {
                        txOrigin: c.txOrigin ? c.txOrigin.toLowerCase() : undefined,
                        sender: c.sender ? c.sender.toLowerCase() : undefined,
                        recipient: c.recipient ? c.recipient.toLowerCase() : undefined
                    };
                }));
            }
        },
        explain: (clauses)=>{
            _rules.test(clauses, [
                clauseScheme
            ], "arg0");
            return (0, _explainer.newExplainer)(readyDriver, clauses);
        }
    };
}
const clauseScheme = {
    to: _validatorTs.nullable(_rules.address),
    value: _rules.bigInt,
    data: _validatorTs.optional(_rules.bytes)
};
const eventCriteriaScheme = {
    address: _validatorTs.optional(_rules.address),
    topic0: _validatorTs.optional(_rules.bytes32),
    topic1: _validatorTs.optional(_rules.bytes32),
    topic2: _validatorTs.optional(_rules.bytes32),
    topic3: _validatorTs.optional(_rules.bytes32),
    topic4: _validatorTs.optional(_rules.bytes32)
};
const transferCriteriaScheme = {
    sender: _validatorTs.optional(_rules.address),
    recipient: _validatorTs.optional(_rules.address),
    txOrigin: _validatorTs.optional(_rules.address)
};

},{"./account-visitor":"k5Z29","./block-visitor":"76yuh","./tx-visitor":"kcuN7","./filter":"by5Qn","./head-tracker":"VSM5w","./explainer":"iYbji","./rules":"9mlXk","validator-ts":"9VJaG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5Z29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newAccountVisitor", ()=>newAccountVisitor);
var _thorDevkit = require("thor-devkit");
var _revertReason = require("./revert-reason");
var _filter = require("./filter");
var _vendor = require("./vendor");
var _rules = require("./rules");
function newAccountVisitor(readyDriver, addr) {
    return {
        get address () {
            return addr;
        },
        get: ()=>{
            return readyDriver.then((d)=>d.getAccount(addr, d.head.id));
        },
        getCode: ()=>{
            return readyDriver.then((d)=>d.getCode(addr, d.head.id));
        },
        getStorage: (key)=>{
            key = _rules.test(key, _rules.bytes32, "arg0").toLowerCase();
            return readyDriver.then((d)=>d.getStorage(addr, key, d.head.id));
        },
        method: (jsonABI)=>{
            let coder;
            try {
                coder = new (0, _thorDevkit.abi).Function(JSON.parse(JSON.stringify(jsonABI)));
            } catch (err) {
                throw new _rules.BadParameter(`arg0: expected valid ABI (${err.message})`);
            }
            return newMethod(readyDriver, addr, coder);
        },
        event: (jsonABI)=>{
            let coder;
            try {
                coder = new (0, _thorDevkit.abi).Event(JSON.parse(JSON.stringify(jsonABI)));
            } catch (err) {
                throw new _rules.BadParameter(`arg0: expected valid ABI (${err.message})`);
            }
            return newEvent(readyDriver, addr, coder);
        }
    };
}
function newMethod(readyDriver, addr, coder) {
    let value = 0;
    const opts = {};
    let cacheHints;
    return {
        value (val) {
            value = _rules.test(val, _rules.bigInt, "arg0");
            return this;
        },
        caller (addr) {
            opts.caller = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = _rules.test(gas, _rules.uint64, "arg0");
            return this;
        },
        gasPrice (gp) {
            opts.gasPrice = _rules.test(gp, _rules.bigInt, "arg0").toString().toLowerCase();
            return this;
        },
        gasPayer (addr) {
            opts.gasPayer = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        cache (hints) {
            cacheHints = _rules.test(hints, [
                _rules.address
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        asClause: (...args)=>{
            const inputsLen = (coder.definition.inputs || []).length;
            _rules.ensure(inputsLen === args.length, `args count expected ${inputsLen}`);
            try {
                const data = coder.encode(...args);
                return {
                    to: addr,
                    value: value.toString().toLowerCase(),
                    data
                };
            } catch (err) {
                throw new _rules.BadParameter(`args can not be encoded (${err.message})`);
            }
        },
        call (...args) {
            const clause = this.asClause(...args);
            return readyDriver.then((d)=>d.explain(Object.assign({
                    clauses: [
                        clause
                    ]
                }, opts), d.head.id, cacheHints)).then((outputs)=>outputs[0]).then((output)=>{
                if (output.reverted) {
                    const revertReason = (0, _revertReason.decodeRevertReason)(output.data);
                    return Object.assign(Object.assign({}, output), {
                        revertReason,
                        decoded: {}
                    });
                } else {
                    const decoded = coder.decode(output.data);
                    return Object.assign(Object.assign({}, output), {
                        decoded
                    });
                }
            });
        },
        transact (...args) {
            const clause = this.asClause(...args);
            return (0, _vendor.newTxSigningService)(readyDriver, [
                Object.assign(Object.assign({}, clause), {
                    abi: coder.definition
                })
            ]);
        }
    };
}
function newEvent(readyDriver, addr, coder) {
    const encode = (indexed)=>{
        const topics = coder.encode(indexed);
        return {
            address: addr,
            topic0: topics[0] || undefined,
            topic1: topics[1] || undefined,
            topic2: topics[2] || undefined,
            topic3: topics[3] || undefined,
            topic4: topics[4] || undefined
        };
    };
    return {
        asCriteria: (indexed)=>{
            try {
                return encode(indexed);
            } catch (err) {
                throw new _rules.BadParameter(`arg0: can not be encoded (${err.message})`);
            }
        },
        filter: (indexed)=>{
            _rules.test(indexed, [
                {}
            ], "arg0");
            if (indexed.length === 0) indexed = [
                {}
            ];
            const criteria = indexed.map((o, i)=>{
                try {
                    return encode(o);
                } catch (err) {
                    throw new _rules.BadParameter(`arg0.#${i}: can not be encoded (${err.message})`);
                }
            });
            const filter = (0, _filter.newFilter)(readyDriver, "event", criteria);
            return {
                range (range) {
                    filter.range(range);
                    return this;
                },
                order (order) {
                    filter.order(order);
                    return this;
                },
                cache (hints) {
                    filter.cache(hints);
                    return this;
                },
                apply (offset, limit) {
                    return filter.apply(offset, limit).then((events)=>events.map((event)=>{
                            const decoded = coder.decode(event.data, event.topics);
                            return Object.assign(Object.assign({}, event), {
                                decoded
                            });
                        }));
                }
            };
        }
    };
}

},{"thor-devkit":"iIWuY","./revert-reason":"23S5u","./filter":"by5Qn","./vendor":"chNuL","./rules":"9mlXk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"23S5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeRevertReason", ()=>decodeRevertReason);
var _thorDevkit = require("thor-devkit");
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#error-handling-assert-require-revert-and-exceptions
// builtin errors in solidity, Error(string) and Panic(uint256)
const errorSelector = "0x" + (0, _thorDevkit.keccak256)("Error(string)").toString("hex").slice(0, 8);
const panicSelector = "0x" + (0, _thorDevkit.keccak256)("Panic(uint256)").toString("hex").slice(0, 8);
function decodeRevertReason(data) {
    try {
        if (data.startsWith(errorSelector)) return (0, _thorDevkit.abi).decodeParameter("string", "0x" + data.slice(errorSelector.length));
        else if (data.startsWith(panicSelector)) {
            const decoded = (0, _thorDevkit.abi).decodeParameter("uint256", "0x" + data.slice(panicSelector.length));
            return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
        }
        return "";
    } catch (_a) {
        return "";
    }
}

},{"thor-devkit":"iIWuY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"by5Qn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newFilter", ()=>newFilter);
var _rules = require("./rules");
const MAX_LIMIT = 256;
function newFilter(readyDriver, kind, criteria) {
    const filterBody = {
        range: {
            unit: "block",
            from: 0,
            to: Math.pow(2, 32) - 1
        },
        options: {
            offset: 0,
            limit: 10
        },
        criteriaSet: criteria,
        order: "asc"
    };
    let cacheHints;
    return {
        range (range) {
            _rules.test(range, {
                unit: (v)=>v === "block" || v === "time" ? "" : `expected 'block' or 'time'`,
                from: _rules.uint64,
                to: _rules.uint64
            }, "arg0");
            _rules.ensure(range.from <= range.to, "arg0.from: expected <= arg0.to");
            filterBody.range = Object.assign({}, range);
            return this;
        },
        order (order) {
            _rules.ensure(order === "asc" || order === "desc", `arg0: expected 'asc' or 'desc'`);
            filterBody.order = order;
            return this;
        },
        cache (hints) {
            cacheHints = _rules.test(hints, [
                _rules.address
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        apply (offset, limit) {
            _rules.test(offset, _rules.uint64, "arg0");
            _rules.ensure(limit >= 0 && limit <= MAX_LIMIT && Number.isInteger(limit), `arg1: expected unsigned integer <= ${MAX_LIMIT}`);
            filterBody.options.offset = offset;
            filterBody.options.limit = limit;
            if (kind === "transfer") return readyDriver.then((d)=>d.filterTransferLogs(filterBody, cacheHints));
            else return readyDriver.then((d)=>d.filterEventLogs(filterBody, cacheHints));
        }
    };
}

},{"./rules":"9mlXk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mlXk":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDecString", ()=>isDecString);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "isHexBytes", ()=>isHexBytes);
parcelHelpers.export(exports, "isUInt", ()=>isUInt);
parcelHelpers.export(exports, "isBigInt", ()=>isBigInt);
parcelHelpers.export(exports, "BadParameter", ()=>BadParameter);
parcelHelpers.export(exports, "ensure", ()=>ensure);
parcelHelpers.export(exports, "test", ()=>test);
// rules
parcelHelpers.export(exports, "bytes", ()=>bytes);
parcelHelpers.export(exports, "bytes8", ()=>bytes8);
parcelHelpers.export(exports, "bytes32", ()=>bytes32);
parcelHelpers.export(exports, "uint8", ()=>uint8);
parcelHelpers.export(exports, "uint32", ()=>uint32);
parcelHelpers.export(exports, "uint64", ()=>uint64);
parcelHelpers.export(exports, "bool", ()=>bool);
parcelHelpers.export(exports, "bigInt", ()=>bigInt);
parcelHelpers.export(exports, "hexString", ()=>hexString);
parcelHelpers.export(exports, "address", ()=>address);
parcelHelpers.export(exports, "string", ()=>string);
var _validatorTs = require("validator-ts");
function isDecString(val) {
    return typeof val === "string" && /^[0-9]+$/.test(val);
}
function isHexString(val) {
    return typeof val === "string" && /^0x[0-9a-f]+$/i.test(val);
}
function isHexBytes(val, n) {
    if (typeof val !== "string" || !/^0x[0-9a-f]*$/i.test(val)) return false;
    return n ? val.length === n * 2 + 2 : val.length % 2 === 0;
}
function isUInt(val, bit) {
    if (val < 0 || !Number.isInteger(val)) return false;
    return bit ? val < Math.pow(2, bit) : true;
}
function isBigInt(v) {
    return typeof v === "string" ? isDecString(v) || isHexString(v) : isUInt(v, 0);
}
class BadParameter extends Error {
    constructor(msg){
        super(msg);
    }
}
BadParameter.prototype.name = "BadParameter";
function ensure(b, msg) {
    if (!b) throw new BadParameter(msg);
}
function test(value, scheme, context) {
    try {
        return _validatorTs.validate(value, scheme, context);
    } catch (err) {
        if (err instanceof _validatorTs.ValidationError) throw new BadParameter(err.message);
        throw err;
    }
}
function bytes(v) {
    return isHexBytes(v) ? "" : "expected bytes in hex string";
}
function bytes8(v) {
    return isHexBytes(v, 8) ? "" : "expected bytes8";
}
function bytes32(v) {
    return isHexBytes(v, 32) ? "" : "expected bytes32";
}
function uint8(v) {
    return isUInt(v, 8) ? "" : "expected 8-bit unsigned integer";
}
function uint32(v) {
    return isUInt(v, 32) ? "" : "expected 32-bit unsigned integer";
}
function uint64(v) {
    return isUInt(v, 64) ? "" : "expected 64-bit unsigned integer";
}
function bool(v) {
    return typeof v === "boolean" ? "" : "expected boolean";
}
function bigInt(v) {
    return isBigInt(v) ? "" : "expected unsigned integer in number or string";
}
function hexString(v) {
    return isHexString(v) ? "" : "expected integer in hex string";
}
function address(v) {
    return isHexBytes(v, 20) ? "" : "expected address";
}
function string(v) {
    return typeof v === "string" ? "" : "expected string";
}

},{"validator-ts":"9VJaG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VJaG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * convert the given Scheme into a Rule that allows undefined value
 * @param scheme the scheme
 */ function optional(scheme) {
    return (value, context)=>{
        if (value !== undefined) validate(value, scheme, context);
        return "";
    };
}
exports.optional = optional;
/**
 * convert the given Scheme into a Rule that allows null value
 * @param scheme the scheme
 */ function nullable(scheme) {
    return (value, context)=>{
        if (value !== null) validate(value, scheme, context);
        return "";
    };
}
exports.nullable = nullable;
/** Validator class */ class Validator {
    constructor(scheme){
        this.scheme = scheme;
    }
    test(value, context) {
        return validate(value, this.scheme, context);
    }
}
exports.Validator = Validator;
/** Error class describes validation error */ class ValidationError extends Error {
    constructor(rawMessage, context){
        super(context ? `${context}: ${rawMessage}` : rawMessage);
        this.rawMessage = rawMessage;
        this.context = context;
    }
}
exports.ValidationError = ValidationError;
ValidationError.prototype.name = "ValidationError";
/**
 * direct function to validate value without construct Validator object
 * @param value value to be validated
 * @param scheme scheme
 * @param context context string appears in error object
 */ function validate(value, scheme, context) {
    if (Array.isArray(scheme)) {
        if (!Array.isArray(value)) throw new ValidationError("expected array", context || "");
        value.forEach((el, i)=>validate(el, scheme[0], context ? `${context}.#${i}` : `#${i}`));
    } else if (scheme instanceof Function) {
        const errMsg = scheme(value, context);
        if (errMsg) throw new ValidationError(errMsg, context || "");
    } else {
        if (!(value instanceof Object)) throw new ValidationError("expected object", context || "");
        for(const key in scheme)if (scheme.hasOwnProperty(key)) validate(value[key], scheme[key], context ? `${context}.${key}` : key);
    }
    return value;
}
exports.validate = validate;

},{}],"chNuL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newVendor", ()=>newVendor);
parcelHelpers.export(exports, "newTxSigningService", ()=>newTxSigningService);
var _rules = require("./rules");
var _validatorTs = require("validator-ts");
var _thorDevkit = require("thor-devkit");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function newVendor(driver) {
    return {
        sign: (kind, msg)=>{
            if (kind === "tx") {
                _rules.test(msg, [
                    clauseScheme
                ], "arg1");
                return newTxSigningService(Promise.resolve(driver), msg);
            } else if (kind === "cert") {
                _rules.test(msg, {
                    purpose: (v)=>v === "agreement" || v === "identification" ? "" : `expected 'agreement' or 'identification'`,
                    payload: {
                        type: (v)=>v === "text" ? "" : `expected 'text'`,
                        content: _rules.string
                    }
                }, "arg1");
                return newCertSigningService(Promise.resolve(driver), msg);
            } else throw new _rules.BadParameter(`arg0: expected 'tx' or 'cert'`);
        }
    };
}
function newTxSigningService(readyDriver, msg) {
    const opts = {};
    return {
        signer (addr) {
            opts.signer = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = _rules.test(gas, _rules.uint64, "arg0");
            return this;
        },
        dependsOn (txid) {
            opts.dependsOn = _rules.test(txid, _rules.bytes32, "arg0").toLowerCase();
            return this;
        },
        link (url) {
            opts.link = _rules.test(url, _rules.string, "arg0");
            return this;
        },
        comment (text) {
            opts.comment = _rules.test(text, _rules.string, "arg0");
            return this;
        },
        delegate (url, signer) {
            _rules.ensure(typeof url === "string", `arg0: expected url string`);
            _rules.test(signer, _validatorTs.optional(_rules.address), "arg1");
            opts.delegator = {
                url,
                signer: signer && signer.toLowerCase()
            };
            return this;
        },
        accepted (cb) {
            _rules.ensure(typeof cb === "function", "arg0: expected function");
            opts.onAccepted = cb;
            return this;
        },
        request () {
            const transformedMsg = msg.map((c)=>Object.assign(Object.assign({}, c), {
                    value: new (0, _bignumberJsDefault.default)(c.value).toString(10)
                }));
            return (()=>__awaiter(this, void 0, void 0, function*() {
                    try {
                        const driver = yield readyDriver;
                        return yield driver.signTx(transformedMsg, opts);
                    } catch (err) {
                        throw new Rejected(err.message);
                    }
                }))();
        }
    };
}
function newCertSigningService(readyDriver, msg) {
    const opts = {};
    return {
        signer (addr) {
            opts.signer = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        link (url) {
            opts.link = _rules.test(url, _rules.string, "arg0");
            return this;
        },
        accepted (cb) {
            _rules.ensure(typeof cb === "function", "arg0: expected function");
            opts.onAccepted = cb;
            return this;
        },
        request () {
            return (()=>__awaiter(this, void 0, void 0, function*() {
                    try {
                        const driver = yield readyDriver;
                        return yield driver.signCert(msg, opts);
                    } catch (err) {
                        throw new Rejected(err.message);
                    }
                }))();
        }
    };
}
class Rejected extends Error {
    constructor(msg){
        super(msg);
    }
}
Rejected.prototype.name = "Rejected";
const clauseScheme = {
    to: _validatorTs.nullable(_rules.address),
    value: _rules.bigInt,
    data: _validatorTs.optional(_rules.bytes),
    comment: _validatorTs.optional(_rules.string),
    abi: _validatorTs.optional((v)=>{
        if (!(v instanceof Object)) return "expected object";
        try {
            new (0, _thorDevkit.abi).Function(v).signature;
            return "";
        } catch (err) {
            return `expected valid ABI (${err.message})`;
        }
    })
};

},{"./rules":"9mlXk","validator-ts":"9VJaG","thor-devkit":"iIWuY","bignumber.js":"2fTAY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"76yuh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newBlockVisitor", ()=>newBlockVisitor);
function newBlockVisitor(driver, revision) {
    return {
        get revision () {
            return revision;
        },
        get: ()=>driver.getBlock(revision)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcuN7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newTxVisitor", ()=>newTxVisitor);
function newTxVisitor(readyDriver, id) {
    let allowPending = false;
    return {
        get id () {
            return id;
        },
        allowPending () {
            allowPending = true;
            return this;
        },
        get: ()=>readyDriver.then((d)=>d.getTransaction(id, allowPending)),
        getReceipt: ()=>readyDriver.then((d)=>d.getReceipt(id))
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"VSM5w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newHeadTracker", ()=>newHeadTracker);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const checkpointInterval = 180;
function newHeadTracker(driver) {
    let head = Object.assign({}, driver.head);
    let finalized = driver.genesis.id;
    let resolvers = [];
    (()=>__awaiter(this, void 0, void 0, function*() {
            for(;;)try {
                const newHead = yield driver.pollHead();
                if (newHead.id !== head.id && newHead.number >= head.number) {
                    if (head.number === 0 || (newHead.number + 1) % checkpointInterval === 0) try {
                        const finalizedBlk = yield driver.getBlock("finalized");
                        if (finalizedBlk && finalizedBlk.id != finalized) finalized = finalizedBlk.id;
                    } catch (_a) {}
                    head = Object.assign({}, newHead);
                    const resolversCopy = resolvers;
                    resolvers = [];
                    resolversCopy.forEach((r)=>r(newHead));
                } else yield new Promise((resolve)=>setTimeout(resolve, 1000));
            } catch (_b) {
                break;
            }
        }))();
    const genesisTs = driver.genesis.timestamp;
    return {
        get head () {
            return head;
        },
        get progress () {
            const nowTsMs = Date.now();
            const headTsMs = head.timestamp * 1000;
            if (nowTsMs - headTsMs < 30000) return 1;
            const genesisTsMs = genesisTs * 1000;
            const p = (headTsMs - genesisTsMs) / (nowTsMs - genesisTsMs);
            return p < 0 ? NaN : p;
        },
        get finalized () {
            return finalized;
        },
        ticker: ()=>{
            let lastHeadId = head.id;
            return {
                next: ()=>{
                    return new Promise((resolve)=>{
                        if (lastHeadId !== head.id) return resolve(Object.assign({}, head));
                        resolvers.push((newHead)=>{
                            resolve(Object.assign({}, newHead));
                        });
                    }).then((h)=>{
                        lastHeadId = h.id;
                        return h;
                    });
                }
            };
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYbji":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newExplainer", ()=>newExplainer);
var _revertReason = require("./revert-reason");
var _rules = require("./rules");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
function newExplainer(readyDriver, clauses) {
    const opts = {};
    let cacheHints;
    return {
        caller (addr) {
            opts.caller = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        gas (gas) {
            opts.gas = _rules.test(gas, _rules.uint64, "arg0");
            return this;
        },
        gasPrice (gp) {
            opts.gasPrice = _rules.test(gp, _rules.bigInt, "arg0").toString().toLowerCase();
            return this;
        },
        gasPayer (addr) {
            opts.gasPayer = _rules.test(addr, _rules.address, "arg0").toLowerCase();
            return this;
        },
        cache (hints) {
            cacheHints = _rules.test(hints, [
                _rules.address
            ], "arg0").map((t)=>t.toLowerCase());
            return this;
        },
        execute () {
            const transformedClauses = clauses.map((c)=>{
                return {
                    to: c.to ? c.to.toLowerCase() : null,
                    value: new (0, _bignumberJsDefault.default)(c.value).toString(10),
                    data: (c.data || "0x").toLowerCase()
                };
            });
            return readyDriver.then((d)=>d.explain(Object.assign({
                    clauses: transformedClauses
                }, opts), d.head.id, cacheHints)).then((outputs)=>{
                return outputs.map((o)=>{
                    if (o.reverted) {
                        const revertReason = (0, _revertReason.decodeRevertReason)(o.data);
                        return Object.assign(Object.assign({}, o), {
                            revertReason
                        });
                    }
                    return o;
                });
            });
        }
    };
}

},{"./revert-reason":"23S5u","./rules":"9mlXk","bignumber.js":"2fTAY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iwXmN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newDriverGuard", ()=>newDriverGuard);
var _validatorTs = require("validator-ts");
var _rules = require("./rules");
function newDriverGuard(driver, errHandler) {
    const test = (obj, scheme, path)=>{
        try {
            _validatorTs.validate(obj, scheme, path);
        } catch (err) {
            if (errHandler) errHandler(err);
            else // tslint:disable-next-line:no-console
            console.warn(`Connex-Driver[MALFORMED RESPONSE]: ${err.message}`);
        }
        return obj;
    };
    const genesis = test(driver.genesis, blockScheme, "genesis");
    return {
        genesis,
        get head () {
            return test(driver.head, headScheme, "head");
        },
        pollHead () {
            return driver.pollHead().then((h)=>test(h, headScheme, "getHead()"));
        },
        getBlock (revision) {
            return driver.getBlock(revision).then((b)=>b ? test(b, blockScheme, "getBlock()") : b);
        },
        getTransaction (id, allowPending) {
            return driver.getTransaction(id, allowPending).then((tx)=>tx ? test(tx, txScheme, "getTransaction()") : tx);
        },
        getReceipt (id) {
            return driver.getReceipt(id).then((r)=>r ? test(r, receiptScheme, "getReceipt()") : r);
        },
        getAccount (addr, revision) {
            return driver.getAccount(addr, revision).then((a)=>test(a, {
                    balance: _rules.hexString,
                    energy: _rules.hexString,
                    hasCode: _rules.bool
                }, "getAccount()"));
        },
        getCode (addr, revision) {
            return driver.getCode(addr, revision).then((c)=>test(c, {
                    code: _rules.bytes
                }, "getCode()"));
        },
        getStorage (addr, key, revision) {
            return driver.getStorage(addr, key, revision).then((s)=>test(s, {
                    value: _rules.bytes32
                }, "getStorage()"));
        },
        explain (arg, revision) {
            return driver.explain(arg, revision).then((r)=>test(r, [
                    vmOutputScheme
                ], "explain()"));
        },
        filterEventLogs (arg) {
            return driver.filterEventLogs(arg).then((r)=>test(r, [
                    eventWithMetaScheme
                ], "filterEventLogs()"));
        },
        filterTransferLogs (arg) {
            return driver.filterTransferLogs(arg).then((r)=>test(r, [
                    transferWithMetaScheme
                ], "filterTransferLogs()"));
        },
        signTx (msg, options) {
            return driver.signTx(msg, options).then((r)=>test(r, {
                    txid: _rules.bytes32,
                    signer: _rules.address
                }, "signTx()"));
        },
        signCert (msg, options) {
            return driver.signCert(msg, options).then((r)=>test(r, {
                    annex: {
                        domain: _rules.string,
                        timestamp: _rules.uint64,
                        signer: _rules.address
                    },
                    signature: (v)=>_rules.isHexBytes(v, 65) ? "" : "expected 65 bytes"
                }, "signCert()"));
        }
    };
}
const headScheme = {
    id: _rules.bytes32,
    number: _rules.uint32,
    timestamp: _rules.uint64,
    parentID: _rules.bytes32,
    txsFeatures: _validatorTs.optional(_rules.uint32),
    gasLimit: _rules.uint64
};
const blockScheme = {
    id: _rules.bytes32,
    number: _rules.uint32,
    size: _rules.uint32,
    parentID: _rules.bytes32,
    timestamp: _rules.uint64,
    gasLimit: _rules.uint64,
    beneficiary: _rules.address,
    gasUsed: _rules.uint64,
    totalScore: _rules.uint64,
    txsRoot: _rules.bytes32,
    txsFeatures: _validatorTs.optional(_rules.uint32),
    stateRoot: _rules.bytes32,
    receiptsRoot: _rules.bytes32,
    signer: _rules.address,
    com: _validatorTs.optional(_rules.bool),
    isFinalized: _validatorTs.optional(_rules.bool),
    isTrunk: _rules.bool,
    transactions: [
        _rules.bytes32
    ]
};
const txScheme = {
    id: _rules.bytes32,
    chainTag: _rules.uint8,
    blockRef: _rules.bytes8,
    expiration: _rules.uint32,
    gasPriceCoef: _rules.uint8,
    gas: _rules.uint64,
    origin: _rules.address,
    delegator: _validatorTs.nullable(_validatorTs.optional(_rules.address)),
    nonce: _rules.hexString,
    dependsOn: _validatorTs.nullable(_rules.bytes32),
    size: _rules.uint32,
    clauses: [
        {
            to: _validatorTs.nullable(_rules.address),
            value: _rules.hexString,
            data: _rules.bytes
        }
    ],
    meta: _validatorTs.nullable({
        blockID: _rules.bytes32,
        blockNumber: _rules.uint32,
        blockTimestamp: _rules.uint64
    })
};
const logMetaScheme = {
    blockID: _rules.bytes32,
    blockNumber: _rules.uint32,
    blockTimestamp: _rules.uint64,
    txID: _rules.bytes32,
    txOrigin: _rules.address,
    clauseIndex: _rules.uint32
};
const eventScheme = {
    address: _rules.address,
    topics: [
        _rules.bytes32
    ],
    data: _rules.bytes
};
const eventWithMetaScheme = Object.assign(Object.assign({}, eventScheme), {
    meta: logMetaScheme
});
const transferScheme = {
    sender: _rules.address,
    recipient: _rules.address,
    amount: _rules.hexString
};
const transferWithMetaScheme = Object.assign(Object.assign({}, transferScheme), {
    meta: logMetaScheme
});
const receiptScheme = {
    gasUsed: _rules.uint64,
    gasPayer: _rules.address,
    paid: _rules.hexString,
    reward: _rules.hexString,
    reverted: _rules.bool,
    outputs: [
        {
            contractAddress: _validatorTs.nullable(_rules.address),
            events: [
                eventScheme
            ],
            transfers: [
                transferScheme
            ]
        }
    ],
    meta: {
        blockID: _rules.bytes32,
        blockNumber: _rules.uint32,
        blockTimestamp: _rules.uint64,
        txID: _rules.bytes32,
        txOrigin: _rules.address
    }
};
const vmOutputScheme = {
    data: _rules.bytes,
    vmError: _rules.string,
    gasUsed: _rules.uint64,
    reverted: _rules.bool,
    revertReason: ()=>"",
    events: [
        {
            address: _rules.address,
            topics: [
                _rules.bytes32
            ],
            data: _rules.bytes
        }
    ],
    transfers: [
        {
            sender: _rules.address,
            recipient: _rules.address,
            amount: _rules.hexString
        }
    ]
};

},{"validator-ts":"9VJaG","./rules":"9mlXk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XTXh":[function(require,module,exports) {
"use strict";
var proxyCompare = require("d4fb8480fa3c5685");
var isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var proxyStateMap = new WeakMap();
var refSet = new WeakSet();
var buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return isObject(x) && !refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        proxyCompare.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if (refSet.has(value)) proxyCompare.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if (proxyStateMap.has(value)) {
                var _ref = proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
                removePropListener(prop);
                if (isObject(value)) value = proxyCompare.getUntracked(value) || value;
                var nextValue = value;
                if (value instanceof Promise) value.then(function(v) {
                    value.status = "fulfilled";
                    value.value = v;
                    notifyUpdate([
                        "resolve",
                        [
                            prop
                        ],
                        v
                    ]);
                }).catch(function(e) {
                    value.status = "rejected";
                    value.reason = e;
                    notifyUpdate([
                        "reject",
                        [
                            prop
                        ],
                        e
                    ]);
                });
                else {
                    if (!proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                    var childProxyState = !refSet.has(nextValue) && proxyStateMap.get(nextValue);
                    if (childProxyState) addPropListener(prop, childProxyState);
                }
                Reflect.set(target, prop, nextValue, receiver);
                notifyUpdate([
                    "set",
                    [
                        prop
                    ],
                    value,
                    prevValue
                ]);
                return true;
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        proxyStateMap,
        refSet,
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var _buildProxyFunction = buildProxyFunction(), defaultProxyFunction = _buildProxyFunction[0];
function proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return defaultProxyFunction(initialObject);
}
function getVersion(proxyObject) {
    var proxyState = proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = proxyStateMap.get(proxyObject);
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function snapshot(proxyObject, handlePromise) {
    var proxyState = proxyStateMap.get(proxyObject);
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function ref(obj) {
    refSet.add(obj);
    return obj;
}
var unstable_buildProxyFunction = buildProxyFunction;
exports.getVersion = getVersion;
exports.proxy = proxy;
exports.ref = ref;
exports.snapshot = snapshot;
exports.subscribe = subscribe;
exports.unstable_buildProxyFunction = unstable_buildProxyFunction;

},{"d4fb8480fa3c5685":"aKyLc"}],"aKyLc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "affectedToPathList", ()=>w);
parcelHelpers.export(exports, "createProxy", ()=>a);
parcelHelpers.export(exports, "getUntracked", ()=>y);
parcelHelpers.export(exports, "isChanged", ()=>p);
parcelHelpers.export(exports, "markToTrack", ()=>h);
parcelHelpers.export(exports, "replaceNewProxy", ()=>O);
parcelHelpers.export(exports, "trackMemo", ()=>g);
const e = Symbol(), t = Symbol(), r = "a", n = "w";
let o = (e, t)=>new Proxy(e, t);
const s = Object.getPrototypeOf, c = new WeakMap, l = (e)=>e && (c.has(e) ? c.get(e) : s(e) === Object.prototype || s(e) === Array.prototype), f = (e)=>"object" == typeof e && null !== e, i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create(s(e), t);
}, u = (e)=>e[t] || e, a = (s, c, f, p)=>{
    if (!l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[r].get(o);
                if (s || (s = {}, c[r].set(o, s)), e === n) s[n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === t ? o : (f("k", n), a(Reflect.get(e, n), c[r], c.c, c.t)),
            has: (t, n)=>n === e ? (l = !0, c[r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f(n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = o(h || y, w[0]), f && f.set(y, w)), w[1][r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, p = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!f(e) || !f(t)) return !0;
    const s = r.get(u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = p(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, g = (t)=>!!l(t) && e in t, y = (e)=>l(e) && e[t] || null, h = (e, t = !0)=>{
    c.set(e, t);
}, w = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        f(e) && s.add(e);
        const i = f(e) && t.get(u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, O = (e)=>{
    o = e;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43WO7":[function(require,module,exports) {
"use strict";
var vanilla = require("5f72634c2334d160");
function subscribeKey(proxyObject, key, callback, notifyInSync) {
    var prevValue = proxyObject[key];
    return vanilla.subscribe(proxyObject, function() {
        var nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
var currentCleanups;
function watch(callback, options) {
    var alive = true;
    var cleanups = new Set();
    var subscriptions = new Map();
    var cleanup = function cleanup() {
        if (alive) {
            alive = false;
            cleanups.forEach(function(clean) {
                return clean();
            });
            cleanups.clear();
            subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            subscriptions.clear();
        }
    };
    var revalidate = function revalidate() {
        if (!alive) return;
        cleanups.forEach(function(clean) {
            return clean();
        });
        cleanups.clear();
        var proxiesToSubscribe = new Set();
        var parent = currentCleanups;
        currentCleanups = cleanups;
        try {
            var cleanupReturn = callback(function(proxyObject) {
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            currentCleanups = parent;
        }
        subscriptions.forEach(function(unsubscribe, proxyObject) {
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach(function(proxyObject) {
            var unsubscribe = vanilla.subscribe(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if (currentCleanups) currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
function _defineAccessor(type, obj, key, fn) {
    var desc = {
        configurable: !0,
        enumerable: !0
    };
    return desc[type] = fn, Object.defineProperty(obj, key, desc);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _excluded = [
    "enabled",
    "name"
];
var DEVTOOLS = Symbol();
function devtools(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    var _ref = options || {}, enabled = _ref.enabled, _ref$name = _ref.name, name = _ref$name === void 0 ? "" : _ref$name, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var extension;
    try {
        extension = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (_unused) {}
    if (!extension) return;
    var isTimeTraveling = false;
    var devtools = extension.connect(_extends({
        name: name
    }, rest));
    var unsub1 = vanilla.subscribe(proxyObject, function(ops) {
        var action = ops.filter(function(_ref2) {
            _ref2[0];
            var path = _ref2[1];
            return path[0] !== DEVTOOLS;
        }).map(function(_ref3) {
            var op = _ref3[0], path = _ref3[1];
            return op + ":" + path.map(String).join(".");
        }).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            var snapWithoutDevtools = Object.assign({}, vanilla.snapshot(proxyObject));
            delete snapWithoutDevtools[DEVTOOLS];
            devtools.send({
                type: action,
                updatedAt: new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    var unsub2 = devtools.subscribe(function(message) {
        var _message$payload3, _message$payload4;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            var _message$payload, _message$payload2;
            if (((_message$payload = message.payload) == null ? void 0 : _message$payload.type) === "JUMP_TO_ACTION" || ((_message$payload2 = message.payload) == null ? void 0 : _message$payload2.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                var state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_message$payload3 = message.payload) == null ? void 0 : _message$payload3.type) === "COMMIT") devtools.init(vanilla.snapshot(proxyObject));
        else if (message.type === "DISPATCH" && ((_message$payload4 = message.payload) == null ? void 0 : _message$payload4.type) === "IMPORT_STATE") {
            var _message$payload$next, _message$payload$next2;
            var actions = (_message$payload$next = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next.actionsById;
            var computedStates = ((_message$payload$next2 = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next2.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(function(_ref4, index) {
                var state = _ref4.state;
                var action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools.init(vanilla.snapshot(proxyObject));
                else devtools.send(action, vanilla.snapshot(proxyObject));
            });
        }
    });
    devtools.init(vanilla.snapshot(proxyObject));
    return function() {
        unsub1();
        unsub2 == null || unsub2();
    };
}
var sourceObjectMap = new WeakMap();
var derivedObjectMap = new WeakMap();
var markPending = function markPending(sourceObject, callback) {
    var sourceObjectEntry = sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
var checkPending = function checkPending(sourceObject, callback) {
    var sourceObjectEntry = sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry != null && sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
var unmarkPending = function unmarkPending(sourceObject) {
    var sourceObjectEntry = sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach(function(callback) {
                return callback();
            });
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach(function(subscription) {
            var derivedObject = subscription.d;
            if (sourceObject !== derivedObject) unmarkPending(derivedObject);
        });
    }
};
var addSubscription = function addSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            new Set()
        ];
        derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    var sourceObjectEntry = sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        var _subscriptions = new Set();
        var _unsubscribe = vanilla.subscribe(sourceObject, function(ops) {
            _subscriptions.forEach(function(subscription) {
                var derivedObject = subscription.d, callback = subscription.c, notifyInSync = subscription.n, ignoreKeys = subscription.i;
                if (sourceObject === derivedObject && ops.every(function(op) {
                    return op[1].length === 1 && ignoreKeys.includes(op[1][0]);
                })) return;
                if (subscription.p) return;
                markPending(sourceObject, callback);
                if (notifyInSync) unmarkPending(sourceObject);
                else subscription.p = Promise.resolve().then(function() {
                    delete subscription.p;
                    unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            _subscriptions,
            _unsubscribe,
            0,
            new Set()
        ];
        sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
var removeSubscription = function removeSubscription(subscription) {
    var sourceObject = subscription.s, derivedObject = subscription.d;
    var derivedObjectEntry = derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) derivedObjectMap.delete(derivedObject);
    var sourceObjectEntry = sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        var _subscriptions2 = sourceObjectEntry[0], _unsubscribe2 = sourceObjectEntry[1];
        _subscriptions2.delete(subscription);
        if (!_subscriptions2.size) {
            _unsubscribe2();
            sourceObjectMap.delete(sourceObject);
        }
    }
};
var listSubscriptions = function listSubscriptions(derivedObject) {
    var derivedObjectEntry = derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
var unstable_deriveSubscriptions = {
    add: addSubscription,
    remove: removeSubscription,
    list: listSubscriptions
};
function derive(derivedFns, options) {
    var proxyObject = (options == null ? void 0 : options.proxy) || vanilla.proxy({});
    var notifyInSync = !!(options != null && options.sync);
    var derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        var fn = derivedFns[key];
        var lastDependencies = null;
        var evaluate = function evaluate() {
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(function(_ref) {
                    var p = _ref[0];
                    return checkPending(p, evaluate);
                }).some(function(isPending) {
                    return isPending;
                })) return;
                if (Array.from(lastDependencies).every(function(_ref2) {
                    var p = _ref2[0], entry = _ref2[1];
                    return vanilla.getVersion(p) === entry.v;
                })) return;
            }
            var dependencies = new Map();
            var get = function get(p) {
                dependencies.set(p, {
                    v: vanilla.getVersion(p)
                });
                return p;
            };
            var value = fn(get);
            var subscribeToDependencies = function subscribeToDependencies() {
                var _lastDependencies2;
                dependencies.forEach(function(entry, p) {
                    var _lastDependencies;
                    var lastSubscription = (_lastDependencies = lastDependencies) == null || (_lastDependencies = _lastDependencies.get(p)) == null ? void 0 : _lastDependencies.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        var subscription = {
                            s: p,
                            d: proxyObject,
                            k: key,
                            c: evaluate,
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                (_lastDependencies2 = lastDependencies) == null || _lastDependencies2.forEach(function(entry, p) {
                    if (!dependencies.has(p) && entry.s) removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function underive(proxyObject, options) {
    var keysToDelete = options != null && options.delete ? new Set() : null;
    listSubscriptions(proxyObject).forEach(function(subscription) {
        var key = subscription.k;
        if (!(options != null && options.keys) || options.keys.includes(key)) {
            removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach(function(key) {
        delete proxyObject[key];
    });
}
function addComputed_DEPRECATED(proxyObject, computedFns_FAKE, targetObject) {
    if (targetObject === void 0) targetObject = proxyObject;
    var derivedFns = {};
    Object.keys(computedFns_FAKE).forEach(function(key) {
        derivedFns[key] = function(get) {
            return computedFns_FAKE[key](get(proxyObject));
        };
    });
    return derive(derivedFns, {
        proxy: targetObject
    });
}
function proxyWithComputed_DEPRECATED(initialObject, computedFns) {
    Object.keys(computedFns).forEach(function(key) {
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        var computedFn = computedFns[key];
        var _ref = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn, get = _ref.get, set = _ref.set;
        var desc = {};
        desc.get = function() {
            return get(vanilla.snapshot(proxyObject));
        };
        if (set) desc.set = function(newValue) {
            return set(proxyObject, newValue);
        };
        Object.defineProperty(initialObject, key, desc);
    });
    var proxyObject = vanilla.proxy(initialObject);
    return proxyObject;
}
var isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var refSet;
var deepClone = function deepClone(obj) {
    if (!refSet) refSet = vanilla.unstable_buildProxyFunction()[2];
    if (!isObject(obj) || refSet.has(obj)) return obj;
    var baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach(function(key) {
        baseObject[key] = deepClone(obj[key]);
    });
    return baseObject;
};
function proxyWithHistory(initialValue, skipSubscribe) {
    if (skipSubscribe === void 0) skipSubscribe = false;
    var proxyObject = vanilla.proxy({
        value: initialValue,
        history: vanilla.ref({
            wip: undefined,
            snapshots: [],
            index: -1
        }),
        clone: deepClone,
        canUndo: function canUndo() {
            return proxyObject.history.index > 0;
        },
        undo: function undo() {
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: function canRedo() {
            return proxyObject.history.index < proxyObject.history.snapshots.length - 1;
        },
        redo: function redo() {
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: function saveHistory() {
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push(vanilla.snapshot(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: function subscribe() {
            return vanilla.subscribe(proxyObject, function(ops) {
                if (ops.every(function(op) {
                    return op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip);
                })) proxyObject.saveHistory();
            });
        }
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function proxySet(initialValues) {
    var _proxy;
    var set = vanilla.proxy((_proxy = {
        data: Array.from(new Set(initialValues)),
        has: function has(value) {
            return this.data.indexOf(value) !== -1;
        },
        add: function add(value) {
            var hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf(vanilla.proxy(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete: function _delete(value) {
            var index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(value) {
                cb(value, value, _this);
            });
        }
    }, _defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Set";
    }), _proxy.toJSON = function toJSON() {
        return new Set(this.data);
    }, _proxy[Symbol.iterator] = function() {
        return this.data[Symbol.iterator]();
    }, _proxy.values = function values() {
        return this.data.values();
    }, _proxy.keys = function keys() {
        return this.data.values();
    }, _proxy.entries = function entries() {
        return new Set(this.data).entries();
    }, _proxy));
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function proxyMap(entries) {
    var _proxy;
    var map = vanilla.proxy((_proxy = {
        data: Array.from(entries || []),
        has: function has(key) {
            return this.data.some(function(p) {
                return p[0] === key;
            });
        },
        set: function set(key, value) {
            var record = this.data.find(function(p) {
                return p[0] === key;
            });
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get: function get(key) {
            var _this$data$find;
            return (_this$data$find = this.data.find(function(p) {
                return p[0] === key;
            })) == null ? void 0 : _this$data$find[1];
        },
        delete: function _delete(key) {
            var index = this.data.findIndex(function(p) {
                return p[0] === key;
            });
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear: function clear() {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON: function toJSON() {
            return new Map(this.data);
        },
        forEach: function forEach(cb) {
            var _this = this;
            this.data.forEach(function(p) {
                cb(p[1], p[0], _this);
            });
        },
        keys: function keys() {
            return this.data.map(function(p) {
                return p[0];
            }).values();
        },
        values: function values() {
            return this.data.map(function(p) {
                return p[1];
            }).values();
        },
        entries: function entries() {
            return new Map(this.data).entries();
        }
    }, _defineAccessor("get", _proxy, Symbol.toStringTag, function() {
        return "Map";
    }), _proxy[Symbol.iterator] = function() {
        return this.entries();
    }, _proxy));
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}
exports.addComputed = addComputed_DEPRECATED;
exports.derive = derive;
exports.devtools = devtools;
exports.proxyMap = proxyMap;
exports.proxySet = proxySet;
exports.proxyWithComputed = proxyWithComputed_DEPRECATED;
exports.proxyWithHistory = proxyWithHistory;
exports.subscribeKey = subscribeKey;
exports.underive = underive;
exports.unstable_deriveSubscriptions = unstable_deriveSubscriptions;
exports.watch = watch;

},{"5f72634c2334d160":"5XTXh"}],"fr5nz":[function(require,module,exports) {
var process = require("6afa0553e9bd9d1f");
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(self, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ 280: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "Connex": ()=>/* binding */ ConnexClass,
                    "default": ()=>/* binding */ esm
                });
                // EXTERNAL MODULE: ../framework/node_modules/@vechain/ethers/utils/abi-coder.js
                var abi_coder = __webpack_require__(2046);
                // EXTERNAL MODULE: ../framework/node_modules/js-sha3/src/sha3.js
                var sha3 = __webpack_require__(747);
                // CONCATENATED MODULE: ../framework/node_modules/thor-devkit/esm/keccak.js
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                /**
 * computes keccak256 hash of given data
 * @param data one or more Buffer | string
 */ function keccak256(...data) {
                    const h = sha3.keccak_256.create();
                    data.forEach((d)=>{
                        if (Buffer.isBuffer(d)) h.update(d);
                        else h.update(Buffer.from(d, "utf8"));
                    });
                    return Buffer.from(h.digest());
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2VjY2FrLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2tlY2Nhay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBQ3BDOzs7R0FHRztBQUNILE1BQU0sVUFBVSxTQUFTLENBQUMsR0FBRyxJQUE0QjtJQUNyRCxNQUFNLENBQUMsR0FBRyxVQUFVLENBQUMsTUFBTSxFQUFFLENBQUE7SUFDN0IsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFBO1NBQ2Q7YUFBTTtZQUNILENBQUMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuQztJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFBO0FBQ2xDLENBQUMifQ==
                // CONCATENATED MODULE: ../framework/node_modules/thor-devkit/esm/abi.js
                /* provided dependency */ var abi_Buffer = __webpack_require__(8764)["Buffer"];
                class Coder extends abi_coder.AbiCoder {
                    constructor(){
                        super((type, value)=>{
                            if (type.match(/^u?int/) && !Array.isArray(value) && typeof value !== "object" || value._ethersType === "BigNumber") return value.toString();
                            return value;
                        });
                    }
                    encode(types, values) {
                        try {
                            return super.encode(types, values);
                        } catch (err) {
                            if (err.reason) throw new Error(err.reason);
                            throw err;
                        }
                    }
                    decode(types, data) {
                        try {
                            return super.decode(types, data);
                        } catch (err) {
                            if (err.reason) throw new Error(err.reason);
                            throw err;
                        }
                    }
                }
                const coder = new Coder();
                function formatSignature(fragment) {
                    try {
                        return (0, abi_coder.formatSignature)(fragment).replace(/\(tuple\(/g, "((").replace(/\,tuple\(/g, ",(");
                    } catch (err) {
                        if (err.reason) throw new Error(err.reason);
                        throw err;
                    }
                }
                /** encode/decode parameters of contract function call, event log, according to ABI JSON */ var abi;
                (function(abi) {
                    /**
     * encode single parameter
     * @param type type of the parameter
     * @param value value of the parameter
     * @returns encoded value in hex string
     */ function encodeParameter(type, value) {
                        return coder.encode([
                            type
                        ], [
                            value
                        ]);
                    }
                    abi.encodeParameter = encodeParameter;
                    /**
     * decode single parameter
     * @param type type of the parameter
     * @param data encoded parameter in hex string
     * @returns decoded value
     */ function decodeParameter(type, data) {
                        return coder.decode([
                            type
                        ], data)[0];
                    }
                    abi.decodeParameter = decodeParameter;
                    /**
     * encode a group of parameters
     * @param types type array
     * @param values value array
     * @returns encoded values in hex string
     */ function encodeParameters(types, values) {
                        return coder.encode(types, values);
                    }
                    abi.encodeParameters = encodeParameters;
                    /**
     * decode a group of parameters
     * @param types type array
     * @param data encoded values in hex string
     * @returns decoded object
     */ function decodeParameters(types, data) {
                        const result = coder.decode(types, data);
                        const decoded = {};
                        types.forEach((t, i)=>{
                            decoded[i] = result[i];
                            if (t.name) decoded[t.name] = result[i];
                        });
                        return decoded;
                    }
                    abi.decodeParameters = decodeParameters;
                    /** for contract function */ class Function1 {
                        /**
         * create a function object
         * @param definition abi definition of the function
         */ constructor(definition){
                            this.definition = definition;
                            this.canonicalName = formatSignature(definition);
                            this.signature = "0x" + keccak256(this.canonicalName).slice(0, 4).toString("hex");
                        }
                        /**
         * encode input parameters into call data
         * @param args arguments for the function
         */ encode(...args) {
                            return this.signature + encodeParameters(this.definition.inputs, args).slice(2);
                        }
                        /**
         * decode output data
         * @param outputData output data to decode
         */ decode(outputData) {
                            return decodeParameters(this.definition.outputs, outputData);
                        }
                    }
                    abi.Function = Function1;
                    /** for contract event */ class Event {
                        /** for contract event */ constructor(definition){
                            this.definition = definition;
                            this.canonicalName = formatSignature(definition);
                            this.signature = "0x" + keccak256(this.canonicalName).toString("hex");
                        }
                        /**
         * encode an object of indexed keys into topics.
         * @param indexed an object contains indexed keys
         */ encode(indexed) {
                            const topics = [];
                            if (!this.definition.anonymous) topics.push(this.signature);
                            for (const input of this.definition.inputs){
                                if (!input.indexed) continue;
                                const value = indexed[input.name];
                                if (value === undefined || value === null) topics.push(null);
                                else {
                                    let topic;
                                    // https://docs.soliditylang.org/en/v0.8.11/abi-spec.html#encoding-of-indexed-event-parameters
                                    if (isValueType(input.type)) topic = encodeParameter(input.type, value);
                                    else {
                                        if (input.type === "string") topic = "0x" + keccak256(value).toString("hex");
                                        else if (typeof value === "string" && /^0x[0-9a-f]+$/i.test(value) && value.length % 2 === 0) // value is encoded
                                        topic = "0x" + keccak256(abi_Buffer.from(value.slice(2), "hex")).toString("hex");
                                        else throw new Error(`event.encode: invalid ${input.type} value`);
                                    }
                                    topics.push(topic);
                                }
                            }
                            return topics;
                        }
                        /**
         * decode event log
         * @param data data in event output
         * @param topics topics in event
         */ decode(data, topics) {
                            if (!this.definition.anonymous) topics = topics.slice(1);
                            if (this.definition.inputs.filter((t)=>t.indexed).length !== topics.length) throw new Error("invalid topics count");
                            const decodedNonIndexed = coder.decode(this.definition.inputs.filter((t)=>!t.indexed), data);
                            const decoded = {};
                            this.definition.inputs.forEach((t, i)=>{
                                if (t.indexed) {
                                    const topic = topics.shift();
                                    decoded[i] = isValueType(t.type) ? decodeParameter(t.type, topic) : topic;
                                } else decoded[i] = decodedNonIndexed.shift();
                                if (t.name) decoded[t.name] = decoded[i];
                            });
                            return decoded;
                        }
                    }
                    abi.Event = Event;
                    function isValueType(type) {
                        return type === "address" || type === "bool" || /^(u?int)([0-9]*)$/.test(type) || /^bytes([0-9]+)$/.test(type);
                    }
                })(abi || (abi = {}));
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/revert-reason.js
                // https://docs.soliditylang.org/en/v0.8.16/control-structures.html#error-handling-assert-require-revert-and-exceptions
                // builtin errors in solidity, Error(string) and Panic(uint256)
                const errorSelector = "0x" + keccak256("Error(string)").toString("hex").slice(0, 8);
                const panicSelector = "0x" + keccak256("Panic(uint256)").toString("hex").slice(0, 8);
                function decodeRevertReason(data) {
                    try {
                        if (data.startsWith(errorSelector)) return abi.decodeParameter("string", "0x" + data.slice(errorSelector.length));
                        else if (data.startsWith(panicSelector)) {
                            const decoded = abi.decodeParameter("uint256", "0x" + data.slice(panicSelector.length));
                            return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
                        }
                        return "";
                    } catch (_a) {
                        return "";
                    }
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2ZXJ0LXJlYXNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXZlcnQtcmVhc29uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBRTVDLHVIQUF1SDtBQUN2SCwrREFBK0Q7QUFFL0QsTUFBTSxhQUFhLEdBQUcsSUFBSSxHQUFHLFNBQVMsQ0FBQyxlQUFlLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtBQUNuRixNQUFNLGFBQWEsR0FBRyxJQUFJLEdBQUcsU0FBUyxDQUFDLGdCQUFnQixDQUFDLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUE7QUFFcEYsTUFBTSxVQUFVLGtCQUFrQixDQUFDLElBQVk7SUFDM0MsSUFBSTtRQUNBLElBQUksSUFBSSxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsRUFBRTtZQUNoQyxPQUFPLEdBQUcsQ0FBQyxlQUFlLENBQUMsUUFBUSxFQUFFLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBVyxDQUFBO1NBQzFGO2FBQU0sSUFBSSxJQUFJLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxFQUFFO1lBQ3ZDLE1BQU0sT0FBTyxHQUFHLEdBQUcsQ0FBQyxlQUFlLENBQUMsU0FBUyxFQUFFLElBQUksR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBVyxDQUFBO1lBQ2pHLE9BQU8sV0FBVyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLEVBQUUsR0FBRyxDQUFDLEdBQUcsQ0FBQTtTQUN2RTtRQUNELE9BQU8sRUFBRSxDQUFBO0tBQ1o7SUFBQyxXQUFNO1FBQ0osT0FBTyxFQUFFLENBQUE7S0FDWjtBQUNMLENBQUMifQ==
                // EXTERNAL MODULE: ../framework/node_modules/validator-ts/dist/index.js
                var dist = __webpack_require__(6462);
                // CONCATENATED MODULE: ../framework/esm/rules.js
                /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ function isDecString(val) {
                    return typeof val === "string" && /^[0-9]+$/.test(val);
                }
                function isHexString(val) {
                    return typeof val === "string" && /^0x[0-9a-f]+$/i.test(val);
                }
                function isHexBytes(val, n) {
                    if (typeof val !== "string" || !/^0x[0-9a-f]*$/i.test(val)) return false;
                    return n ? val.length === n * 2 + 2 : val.length % 2 === 0;
                }
                function isUInt(val, bit) {
                    if (val < 0 || !Number.isInteger(val)) return false;
                    return bit ? val < Math.pow(2, bit) : true;
                }
                function isBigInt(v) {
                    return typeof v === "string" ? isDecString(v) || isHexString(v) : isUInt(v, 0);
                }
                class BadParameter extends Error {
                    constructor(msg){
                        super(msg);
                    }
                }
                BadParameter.prototype.name = "BadParameter";
                function ensure(b, msg) {
                    if (!b) throw new BadParameter(msg);
                }
                function test(value, scheme, context) {
                    try {
                        return dist /* validate */ .Gu(value, scheme, context);
                    } catch (err) {
                        if (err instanceof dist /* ValidationError */ .p8) throw new BadParameter(err.message);
                        throw err;
                    }
                }
                // rules
                function bytes(v) {
                    return isHexBytes(v) ? "" : "expected bytes in hex string";
                }
                function bytes8(v) {
                    return isHexBytes(v, 8) ? "" : "expected bytes8";
                }
                function bytes32(v) {
                    return isHexBytes(v, 32) ? "" : "expected bytes32";
                }
                function uint8(v) {
                    return isUInt(v, 8) ? "" : "expected 8-bit unsigned integer";
                }
                function uint32(v) {
                    return isUInt(v, 32) ? "" : "expected 32-bit unsigned integer";
                }
                function uint64(v) {
                    return isUInt(v, 64) ? "" : "expected 64-bit unsigned integer";
                }
                function bool(v) {
                    return typeof v === "boolean" ? "" : "expected boolean";
                }
                function bigInt(v) {
                    return isBigInt(v) ? "" : "expected unsigned integer in number or string";
                }
                function hexString(v) {
                    return isHexString(v) ? "" : "expected integer in hex string";
                }
                function address(v) {
                    return isHexBytes(v, 20) ? "" : "expected address";
                }
                function string(v) {
                    return typeof v === "string" ? "" : "expected string";
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/filter.js
                const MAX_LIMIT = 256;
                function newFilter(readyDriver, kind, criteria) {
                    const filterBody = {
                        range: {
                            unit: "block",
                            from: 0,
                            to: Math.pow(2, 32) - 1
                        },
                        options: {
                            offset: 0,
                            limit: 10
                        },
                        criteriaSet: criteria,
                        order: "asc"
                    };
                    let cacheHints;
                    return {
                        range (range) {
                            test(range, {
                                unit: (v)=>v === "block" || v === "time" ? "" : `expected 'block' or 'time'`,
                                from: uint64,
                                to: uint64
                            }, "arg0");
                            ensure(range.from <= range.to, "arg0.from: expected <= arg0.to");
                            filterBody.range = Object.assign({}, range);
                            return this;
                        },
                        order (order) {
                            ensure(order === "asc" || order === "desc", `arg0: expected 'asc' or 'desc'`);
                            filterBody.order = order;
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        apply (offset, limit) {
                            test(offset, uint64, "arg0");
                            ensure(limit >= 0 && limit <= MAX_LIMIT && Number.isInteger(limit), `arg1: expected unsigned integer <= ${MAX_LIMIT}`);
                            filterBody.options.offset = offset;
                            filterBody.options.limit = limit;
                            if (kind === "transfer") return readyDriver.then((d)=>d.filterTransferLogs(filterBody, cacheHints));
                            else return readyDriver.then((d)=>d.filterEventLogs(filterBody, cacheHints));
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // EXTERNAL MODULE: ../framework/node_modules/bignumber.js/bignumber.js
                var bignumber = __webpack_require__(634);
                var bignumber_default = /*#__PURE__*/ __webpack_require__.n(bignumber);
                // CONCATENATED MODULE: ../framework/esm/vendor.js
                var __awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function newVendor(driver) {
                    return {
                        sign: (kind, msg)=>{
                            if (kind === "tx") {
                                test(msg, [
                                    clauseScheme
                                ], "arg1");
                                return newTxSigningService(Promise.resolve(driver), msg);
                            } else if (kind === "cert") {
                                test(msg, {
                                    purpose: (v)=>v === "agreement" || v === "identification" ? "" : `expected 'agreement' or 'identification'`,
                                    payload: {
                                        type: (v)=>v === "text" ? "" : `expected 'text'`,
                                        content: string
                                    }
                                }, "arg1");
                                return newCertSigningService(Promise.resolve(driver), msg);
                            } else throw new BadParameter(`arg0: expected 'tx' or 'cert'`);
                        }
                    };
                }
                function newTxSigningService(readyDriver, msg) {
                    const opts = {};
                    return {
                        signer (addr) {
                            opts.signer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        dependsOn (txid) {
                            opts.dependsOn = test(txid, bytes32, "arg0").toLowerCase();
                            return this;
                        },
                        link (url) {
                            opts.link = test(url, string, "arg0");
                            return this;
                        },
                        comment (text) {
                            opts.comment = test(text, string, "arg0");
                            return this;
                        },
                        delegate (url, signer) {
                            ensure(typeof url === "string", `arg0: expected url string`);
                            test(signer, dist /* optional */ .jt(address), "arg1");
                            opts.delegator = {
                                url,
                                signer: signer && signer.toLowerCase()
                            };
                            return this;
                        },
                        accepted (cb) {
                            ensure(typeof cb === "function", "arg0: expected function");
                            opts.onAccepted = cb;
                            return this;
                        },
                        request () {
                            const transformedMsg = msg.map((c)=>Object.assign(Object.assign({}, c), {
                                    value: new (bignumber_default())(c.value).toString(10)
                                }));
                            return (()=>__awaiter(this, void 0, void 0, function*() {
                                    try {
                                        const driver = yield readyDriver;
                                        return yield driver.signTx(transformedMsg, opts);
                                    } catch (err) {
                                        throw new Rejected(err.message);
                                    }
                                }))();
                        }
                    };
                }
                function newCertSigningService(readyDriver, msg) {
                    const opts = {};
                    return {
                        signer (addr) {
                            opts.signer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        link (url) {
                            opts.link = test(url, string, "arg0");
                            return this;
                        },
                        accepted (cb) {
                            ensure(typeof cb === "function", "arg0: expected function");
                            opts.onAccepted = cb;
                            return this;
                        },
                        request () {
                            return (()=>__awaiter(this, void 0, void 0, function*() {
                                    try {
                                        const driver = yield readyDriver;
                                        return yield driver.signCert(msg, opts);
                                    } catch (err) {
                                        throw new Rejected(err.message);
                                    }
                                }))();
                        }
                    };
                }
                class Rejected extends Error {
                    constructor(msg){
                        super(msg);
                    }
                }
                Rejected.prototype.name = "Rejected";
                const clauseScheme = {
                    to: dist /* nullable */ .AG(address),
                    value: bigInt,
                    data: dist /* optional */ .jt(bytes),
                    comment: dist /* optional */ .jt(string),
                    abi: dist /* optional */ .jt((v)=>{
                        if (!(v instanceof Object)) return "expected object";
                        try {
                            new abi.Function(v).signature;
                            return "";
                        } catch (err) {
                            return `expected valid ABI (${err.message})`;
                        }
                    })
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/account-visitor.js
                function newAccountVisitor(readyDriver, addr) {
                    return {
                        get address () {
                            return addr;
                        },
                        get: ()=>{
                            return readyDriver.then((d)=>d.getAccount(addr, d.head.id));
                        },
                        getCode: ()=>{
                            return readyDriver.then((d)=>d.getCode(addr, d.head.id));
                        },
                        getStorage: (key)=>{
                            key = test(key, bytes32, "arg0").toLowerCase();
                            return readyDriver.then((d)=>d.getStorage(addr, key, d.head.id));
                        },
                        method: (jsonABI)=>{
                            let coder;
                            try {
                                coder = new abi.Function(JSON.parse(JSON.stringify(jsonABI)));
                            } catch (err) {
                                throw new BadParameter(`arg0: expected valid ABI (${err.message})`);
                            }
                            return newMethod(readyDriver, addr, coder);
                        },
                        event: (jsonABI)=>{
                            let coder;
                            try {
                                coder = new abi.Event(JSON.parse(JSON.stringify(jsonABI)));
                            } catch (err) {
                                throw new BadParameter(`arg0: expected valid ABI (${err.message})`);
                            }
                            return newEvent(readyDriver, addr, coder);
                        }
                    };
                }
                function newMethod(readyDriver, addr, coder) {
                    let value = 0;
                    const opts = {};
                    let cacheHints;
                    return {
                        value (val) {
                            value = test(val, bigInt, "arg0");
                            return this;
                        },
                        caller (addr) {
                            opts.caller = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        gasPrice (gp) {
                            opts.gasPrice = test(gp, bigInt, "arg0").toString().toLowerCase();
                            return this;
                        },
                        gasPayer (addr) {
                            opts.gasPayer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        asClause: (...args)=>{
                            const inputsLen = (coder.definition.inputs || []).length;
                            ensure(inputsLen === args.length, `args count expected ${inputsLen}`);
                            try {
                                const data = coder.encode(...args);
                                return {
                                    to: addr,
                                    value: value.toString().toLowerCase(),
                                    data
                                };
                            } catch (err) {
                                throw new BadParameter(`args can not be encoded (${err.message})`);
                            }
                        },
                        call (...args) {
                            const clause = this.asClause(...args);
                            return readyDriver.then((d)=>d.explain(Object.assign({
                                    clauses: [
                                        clause
                                    ]
                                }, opts), d.head.id, cacheHints)).then((outputs)=>outputs[0]).then((output)=>{
                                if (output.reverted) {
                                    const revertReason = decodeRevertReason(output.data);
                                    return Object.assign(Object.assign({}, output), {
                                        revertReason,
                                        decoded: {}
                                    });
                                } else {
                                    const decoded = coder.decode(output.data);
                                    return Object.assign(Object.assign({}, output), {
                                        decoded
                                    });
                                }
                            });
                        },
                        transact (...args) {
                            const clause = this.asClause(...args);
                            return newTxSigningService(readyDriver, [
                                Object.assign(Object.assign({}, clause), {
                                    abi: coder.definition
                                })
                            ]);
                        }
                    };
                }
                function newEvent(readyDriver, addr, coder) {
                    const encode = (indexed)=>{
                        const topics = coder.encode(indexed);
                        return {
                            address: addr,
                            topic0: topics[0] || undefined,
                            topic1: topics[1] || undefined,
                            topic2: topics[2] || undefined,
                            topic3: topics[3] || undefined,
                            topic4: topics[4] || undefined
                        };
                    };
                    return {
                        asCriteria: (indexed)=>{
                            try {
                                return encode(indexed);
                            } catch (err) {
                                throw new BadParameter(`arg0: can not be encoded (${err.message})`);
                            }
                        },
                        filter: (indexed)=>{
                            test(indexed, [
                                {}
                            ], "arg0");
                            if (indexed.length === 0) indexed = [
                                {}
                            ];
                            const criteria = indexed.map((o, i)=>{
                                try {
                                    return encode(o);
                                } catch (err) {
                                    throw new BadParameter(`arg0.#${i}: can not be encoded (${err.message})`);
                                }
                            });
                            const filter = newFilter(readyDriver, "event", criteria);
                            return {
                                range (range) {
                                    filter.range(range);
                                    return this;
                                },
                                order (order) {
                                    filter.order(order);
                                    return this;
                                },
                                cache (hints) {
                                    filter.cache(hints);
                                    return this;
                                },
                                apply (offset, limit) {
                                    return filter.apply(offset, limit).then((events)=>events.map((event)=>{
                                            const decoded = coder.decode(event.data, event.topics);
                                            return Object.assign(Object.assign({}, event), {
                                                decoded
                                            });
                                        }));
                                }
                            };
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/block-visitor.js
                function newBlockVisitor(driver, revision) {
                    return {
                        get revision () {
                            return revision;
                        },
                        get: ()=>driver.getBlock(revision)
                    };
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvY2stdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibG9jay12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxlQUFlLENBQzNCLE1BQXFCLEVBQ3JCLFFBQXlCO0lBR3pCLE9BQU87UUFDSCxJQUFJLFFBQVEsS0FBSyxPQUFPLFFBQVEsQ0FBQSxDQUFDLENBQUM7UUFDbEMsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO0tBQ3ZDLENBQUE7QUFDTCxDQUFDIn0=
                // CONCATENATED MODULE: ../framework/esm/tx-visitor.js
                function newTxVisitor(readyDriver, id) {
                    let allowPending = false;
                    return {
                        get id () {
                            return id;
                        },
                        allowPending () {
                            allowPending = true;
                            return this;
                        },
                        get: ()=>readyDriver.then((d)=>d.getTransaction(id, allowPending)),
                        getReceipt: ()=>readyDriver.then((d)=>d.getReceipt(id))
                    };
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHgtdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy90eC12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sVUFBVSxZQUFZLENBQ3hCLFdBQW1DLEVBQ25DLEVBQVU7SUFFVixJQUFJLFlBQVksR0FBRyxLQUFLLENBQUE7SUFDeEIsT0FBTztRQUNILElBQUksRUFBRTtZQUNGLE9BQU8sRUFBRSxDQUFBO1FBQ2IsQ0FBQztRQUNELFlBQVk7WUFDUixZQUFZLEdBQUcsSUFBSSxDQUFBO1lBQ25CLE9BQU8sSUFBSSxDQUFBO1FBQ2YsQ0FBQztRQUNELEdBQUcsRUFBRSxHQUFHLEVBQUUsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxFQUFFLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFDcEUsVUFBVSxFQUFFLEdBQUcsRUFBRSxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0tBQzVELENBQUE7QUFDTCxDQUFDIn0=
                // CONCATENATED MODULE: ../framework/esm/head-tracker.js
                var head_tracker_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                const checkpointInterval = 180;
                function newHeadTracker(driver) {
                    let head = Object.assign({}, driver.head);
                    let finalized = driver.genesis.id;
                    let resolvers = [];
                    (()=>head_tracker_awaiter(this, void 0, void 0, function*() {
                            for(;;)try {
                                const newHead = yield driver.pollHead();
                                if (newHead.id !== head.id && newHead.number >= head.number) {
                                    if (head.number === 0 || (newHead.number + 1) % checkpointInterval === 0) try {
                                        const finalizedBlk = yield driver.getBlock("finalized");
                                        if (finalizedBlk && finalizedBlk.id != finalized) finalized = finalizedBlk.id;
                                    } catch (_a) {}
                                    head = Object.assign({}, newHead);
                                    const resolversCopy = resolvers;
                                    resolvers = [];
                                    resolversCopy.forEach((r)=>r(newHead));
                                } else yield new Promise((resolve)=>setTimeout(resolve, 1000));
                            } catch (_b) {
                                break;
                            }
                        }))();
                    const genesisTs = driver.genesis.timestamp;
                    return {
                        get head () {
                            return head;
                        },
                        get progress () {
                            const nowTsMs = Date.now();
                            const headTsMs = head.timestamp * 1000;
                            if (nowTsMs - headTsMs < 30000) return 1;
                            const genesisTsMs = genesisTs * 1000;
                            const p = (headTsMs - genesisTsMs) / (nowTsMs - genesisTsMs);
                            return p < 0 ? NaN : p;
                        },
                        get finalized () {
                            return finalized;
                        },
                        ticker: ()=>{
                            let lastHeadId = head.id;
                            return {
                                next: ()=>{
                                    return new Promise((resolve)=>{
                                        if (lastHeadId !== head.id) return resolve(Object.assign({}, head));
                                        resolvers.push((newHead)=>{
                                            resolve(Object.assign({}, newHead));
                                        });
                                    }).then((h)=>{
                                        lastHeadId = h.id;
                                        return h;
                                    });
                                }
                            };
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/explainer.js
                function newExplainer(readyDriver, clauses) {
                    const opts = {};
                    let cacheHints;
                    return {
                        caller (addr) {
                            opts.caller = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        gas (gas) {
                            opts.gas = test(gas, uint64, "arg0");
                            return this;
                        },
                        gasPrice (gp) {
                            opts.gasPrice = test(gp, bigInt, "arg0").toString().toLowerCase();
                            return this;
                        },
                        gasPayer (addr) {
                            opts.gasPayer = test(addr, address, "arg0").toLowerCase();
                            return this;
                        },
                        cache (hints) {
                            cacheHints = test(hints, [
                                address
                            ], "arg0").map((t)=>t.toLowerCase());
                            return this;
                        },
                        execute () {
                            const transformedClauses = clauses.map((c)=>{
                                return {
                                    to: c.to ? c.to.toLowerCase() : null,
                                    value: new (bignumber_default())(c.value).toString(10),
                                    data: (c.data || "0x").toLowerCase()
                                };
                            });
                            return readyDriver.then((d)=>d.explain(Object.assign({
                                    clauses: transformedClauses
                                }, opts), d.head.id, cacheHints)).then((outputs)=>{
                                return outputs.map((o)=>{
                                    if (o.reverted) {
                                        const revertReason = decodeRevertReason(o.data);
                                        return Object.assign(Object.assign({}, o), {
                                            revertReason
                                        });
                                    }
                                    return o;
                                });
                            });
                        }
                    };
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwbGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2V4cGxhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQTtBQUNwRCxPQUFPLEtBQUssQ0FBQyxNQUFNLFNBQVMsQ0FBQTtBQUM1QixPQUFPLFNBQVMsTUFBTSxjQUFjLENBQUE7QUFFcEMsTUFBTSxVQUFVLFlBQVksQ0FBQyxXQUFtQyxFQUFFLE9BQTJCO0lBQ3pGLE1BQU0sSUFBSSxHQUtOLEVBQUUsQ0FBQTtJQUNOLElBQUksVUFBZ0MsQ0FBQTtJQUVwQyxPQUFPO1FBQ0gsTUFBTSxDQUFDLElBQUk7WUFDUCxJQUFJLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7WUFDM0QsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsR0FBRyxDQUFDLEdBQUc7WUFDSCxJQUFJLENBQUMsR0FBRyxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUE7WUFDeEMsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsUUFBUSxDQUFDLEVBQUU7WUFDUCxJQUFJLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUMsV0FBVyxFQUFFLENBQUE7WUFDckUsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsUUFBUSxDQUFDLElBQUk7WUFDVCxJQUFJLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7WUFDN0QsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsS0FBSyxDQUFDLEtBQUs7WUFDUCxVQUFVLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUE7WUFDekUsT0FBTyxJQUFJLENBQUE7UUFDZixDQUFDO1FBQ0QsT0FBTztZQUNILE1BQU0sa0JBQWtCLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRTtnQkFDdkMsT0FBTztvQkFDSCxFQUFFLEVBQUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSTtvQkFDcEMsS0FBSyxFQUFFLElBQUksU0FBUyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDO29CQUMxQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxDQUFDLFdBQVcsRUFBRTtpQkFDdkMsQ0FBQTtZQUNMLENBQUMsQ0FBQyxDQUFBO1lBRUYsT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLE9BQU8saUJBRTlCLE9BQU8sRUFBRSxrQkFBa0IsSUFDeEIsSUFBSSxHQUVYLENBQUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxFQUFFLFVBQVUsQ0FBQyxDQUFDO2lCQUN0QixJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ1osT0FBTyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFO29CQUNuQixJQUFJLENBQUMsQ0FBQyxRQUFRLEVBQUU7d0JBQ1osTUFBTSxZQUFZLEdBQUcsa0JBQWtCLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFBO3dCQUMvQyx1Q0FBWSxDQUFDLEtBQUUsWUFBWSxJQUFFO3FCQUNoQztvQkFDRCxPQUFPLENBQUMsQ0FBQTtnQkFDWixDQUFDLENBQUMsQ0FBQTtZQUNOLENBQUMsQ0FBQyxDQUFBO1FBQ1YsQ0FBQztLQUNKLENBQUE7QUFDTCxDQUFDIn0=
                // CONCATENATED MODULE: ../framework/esm/thor.js
                var thor_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                function newThor(driver) {
                    const headTracker = newHeadTracker(driver);
                    const readyDriver = (()=>thor_awaiter(this, void 0, void 0, function*() {
                            if (headTracker.head.number > 0) return driver;
                            yield headTracker.ticker().next();
                            return driver;
                        }))();
                    const genesis = JSON.parse(JSON.stringify(driver.genesis));
                    return {
                        get genesis () {
                            return genesis;
                        },
                        get status () {
                            return {
                                head: headTracker.head,
                                progress: headTracker.progress,
                                finalized: headTracker.finalized
                            };
                        },
                        ticker: ()=>headTracker.ticker(),
                        account: (addr)=>{
                            addr = test(addr, address, "arg0").toLowerCase();
                            return newAccountVisitor(readyDriver, addr);
                        },
                        block: (revision)=>{
                            if (typeof revision === "undefined") revision = driver.head.id;
                            else ensure(typeof revision === "string" ? isHexBytes(revision, 32) : isUInt(revision, 32), "arg0: expected bytes32 or unsigned 32-bit integer");
                            return newBlockVisitor(driver, typeof revision === "string" ? revision.toLowerCase() : revision);
                        },
                        transaction: (id)=>{
                            id = test(id, bytes32, "arg0").toLowerCase();
                            return newTxVisitor(readyDriver, id);
                        },
                        filter: (kind, criteria)=>{
                            ensure(kind === "event" || kind === "transfer", `arg0: expected 'event' or 'transfer'`);
                            if (kind === "event") {
                                test(criteria, [
                                    eventCriteriaScheme
                                ], "arg1");
                                return newFilter(readyDriver, "event", criteria.map((c)=>{
                                    return {
                                        address: c.address ? c.address.toLowerCase() : undefined,
                                        topic0: c.topic0 ? c.topic0.toLowerCase() : undefined,
                                        topic1: c.topic1 ? c.topic1.toLowerCase() : undefined,
                                        topic2: c.topic2 ? c.topic2.toLowerCase() : undefined,
                                        topic3: c.topic3 ? c.topic3.toLowerCase() : undefined,
                                        topic4: c.topic4 ? c.topic4.toLowerCase() : undefined
                                    };
                                }));
                            } else {
                                test(criteria, [
                                    transferCriteriaScheme
                                ], "arg1");
                                return newFilter(readyDriver, "transfer", criteria.map((c)=>{
                                    return {
                                        txOrigin: c.txOrigin ? c.txOrigin.toLowerCase() : undefined,
                                        sender: c.sender ? c.sender.toLowerCase() : undefined,
                                        recipient: c.recipient ? c.recipient.toLowerCase() : undefined
                                    };
                                }));
                            }
                        },
                        explain: (clauses)=>{
                            test(clauses, [
                                thor_clauseScheme
                            ], "arg0");
                            return newExplainer(readyDriver, clauses);
                        }
                    };
                }
                const thor_clauseScheme = {
                    to: dist /* nullable */ .AG(address),
                    value: bigInt,
                    data: dist /* optional */ .jt(bytes)
                };
                const eventCriteriaScheme = {
                    address: dist /* optional */ .jt(address),
                    topic0: dist /* optional */ .jt(bytes32),
                    topic1: dist /* optional */ .jt(bytes32),
                    topic2: dist /* optional */ .jt(bytes32),
                    topic3: dist /* optional */ .jt(bytes32),
                    topic4: dist /* optional */ .jt(bytes32)
                };
                const transferCriteriaScheme = {
                    sender: dist /* optional */ .jt(address),
                    recipient: dist /* optional */ .jt(address),
                    txOrigin: dist /* optional */ .jt(address)
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/driver-guard.js
                function newDriverGuard(driver, errHandler) {
                    const test = (obj, scheme, path)=>{
                        try {
                            dist /* validate */ .Gu(obj, scheme, path);
                        } catch (err) {
                            if (errHandler) errHandler(err);
                            else // tslint:disable-next-line:no-console
                            console.warn(`Connex-Driver[MALFORMED RESPONSE]: ${err.message}`);
                        }
                        return obj;
                    };
                    const genesis = test(driver.genesis, blockScheme, "genesis");
                    return {
                        genesis,
                        get head () {
                            return test(driver.head, headScheme, "head");
                        },
                        pollHead () {
                            return driver.pollHead().then((h)=>test(h, headScheme, "getHead()"));
                        },
                        getBlock (revision) {
                            return driver.getBlock(revision).then((b)=>b ? test(b, blockScheme, "getBlock()") : b);
                        },
                        getTransaction (id, allowPending) {
                            return driver.getTransaction(id, allowPending).then((tx)=>tx ? test(tx, txScheme, "getTransaction()") : tx);
                        },
                        getReceipt (id) {
                            return driver.getReceipt(id).then((r)=>r ? test(r, receiptScheme, "getReceipt()") : r);
                        },
                        getAccount (addr, revision) {
                            return driver.getAccount(addr, revision).then((a)=>test(a, {
                                    balance: hexString,
                                    energy: hexString,
                                    hasCode: bool
                                }, "getAccount()"));
                        },
                        getCode (addr, revision) {
                            return driver.getCode(addr, revision).then((c)=>test(c, {
                                    code: bytes
                                }, "getCode()"));
                        },
                        getStorage (addr, key, revision) {
                            return driver.getStorage(addr, key, revision).then((s)=>test(s, {
                                    value: bytes32
                                }, "getStorage()"));
                        },
                        explain (arg, revision) {
                            return driver.explain(arg, revision).then((r)=>test(r, [
                                    vmOutputScheme
                                ], "explain()"));
                        },
                        filterEventLogs (arg) {
                            return driver.filterEventLogs(arg).then((r)=>test(r, [
                                    eventWithMetaScheme
                                ], "filterEventLogs()"));
                        },
                        filterTransferLogs (arg) {
                            return driver.filterTransferLogs(arg).then((r)=>test(r, [
                                    transferWithMetaScheme
                                ], "filterTransferLogs()"));
                        },
                        signTx (msg, options) {
                            return driver.signTx(msg, options).then((r)=>test(r, {
                                    txid: bytes32,
                                    signer: address
                                }, "signTx()"));
                        },
                        signCert (msg, options) {
                            return driver.signCert(msg, options).then((r)=>test(r, {
                                    annex: {
                                        domain: string,
                                        timestamp: uint64,
                                        signer: address
                                    },
                                    signature: (v)=>isHexBytes(v, 65) ? "" : "expected 65 bytes"
                                }, "signCert()"));
                        }
                    };
                }
                const headScheme = {
                    id: bytes32,
                    number: uint32,
                    timestamp: uint64,
                    parentID: bytes32,
                    txsFeatures: dist /* optional */ .jt(uint32),
                    gasLimit: uint64
                };
                const blockScheme = {
                    id: bytes32,
                    number: uint32,
                    size: uint32,
                    parentID: bytes32,
                    timestamp: uint64,
                    gasLimit: uint64,
                    beneficiary: address,
                    gasUsed: uint64,
                    totalScore: uint64,
                    txsRoot: bytes32,
                    txsFeatures: dist /* optional */ .jt(uint32),
                    stateRoot: bytes32,
                    receiptsRoot: bytes32,
                    signer: address,
                    com: dist /* optional */ .jt(bool),
                    isFinalized: dist /* optional */ .jt(bool),
                    isTrunk: bool,
                    transactions: [
                        bytes32
                    ]
                };
                const txScheme = {
                    id: bytes32,
                    chainTag: uint8,
                    blockRef: bytes8,
                    expiration: uint32,
                    gasPriceCoef: uint8,
                    gas: uint64,
                    origin: address,
                    delegator: dist /* nullable */ .AG(dist /* optional */ .jt(address)),
                    nonce: hexString,
                    dependsOn: dist /* nullable */ .AG(bytes32),
                    size: uint32,
                    clauses: [
                        {
                            to: dist /* nullable */ .AG(address),
                            value: hexString,
                            data: bytes
                        }
                    ],
                    meta: dist /* nullable */ .AG({
                        blockID: bytes32,
                        blockNumber: uint32,
                        blockTimestamp: uint64
                    })
                };
                const logMetaScheme = {
                    blockID: bytes32,
                    blockNumber: uint32,
                    blockTimestamp: uint64,
                    txID: bytes32,
                    txOrigin: address,
                    clauseIndex: uint32
                };
                const eventScheme = {
                    address: address,
                    topics: [
                        bytes32
                    ],
                    data: bytes
                };
                const eventWithMetaScheme = Object.assign(Object.assign({}, eventScheme), {
                    meta: logMetaScheme
                });
                const transferScheme = {
                    sender: address,
                    recipient: address,
                    amount: hexString
                };
                const transferWithMetaScheme = Object.assign(Object.assign({}, transferScheme), {
                    meta: logMetaScheme
                });
                const receiptScheme = {
                    gasUsed: uint64,
                    gasPayer: address,
                    paid: hexString,
                    reward: hexString,
                    reverted: bool,
                    outputs: [
                        {
                            contractAddress: dist /* nullable */ .AG(address),
                            events: [
                                eventScheme
                            ],
                            transfers: [
                                transferScheme
                            ]
                        }
                    ],
                    meta: {
                        blockID: bytes32,
                        blockNumber: uint32,
                        blockTimestamp: uint64,
                        txID: bytes32,
                        txOrigin: address
                    }
                };
                const vmOutputScheme = {
                    data: bytes,
                    vmError: string,
                    gasUsed: uint64,
                    reverted: bool,
                    revertReason: ()=>"",
                    events: [
                        {
                            address: address,
                            topics: [
                                bytes32
                            ],
                            data: bytes
                        }
                    ],
                    transfers: [
                        {
                            sender: address,
                            recipient: address,
                            amount: hexString
                        }
                    ]
                };
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../framework/esm/index.js
                /**
 * Class implements Connex interface
 */ class Framework {
                    /**
     * constructor
     * @param driver the driver instance
     */ constructor(driver){
                        this.thor = newThor(driver);
                        this.vendor = newVendor(driver);
                    }
                    /**
     * create a wrapper for driver, to validate responses. it should be helpful to make sure driver is properly
     * implemented in development stage.
     * @param driver the driver to be wrapped
     * @param errorHandler optional error handler. If omitted, error message will be printed via console.warn.
     */ static guardDriver(driver, errorHandler) {
                        return newDriverGuard(driver, errorHandler);
                    }
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFFBQVEsQ0FBQTtBQUNoQyxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ3BDLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUUvQzs7R0FFRztBQUNILE1BQU0sT0FBTyxTQUFTO0lBaUJsQjs7O09BR0c7SUFDSCxZQUFZLE1BQXFCO1FBQzdCLElBQUksQ0FBQyxJQUFJLEdBQUcsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQzNCLElBQUksQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ25DLENBQUM7SUF2QkQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsV0FBVyxDQUNyQixNQUFxQixFQUNyQixZQUFtQztRQUVuQyxPQUFPLGNBQWMsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDLENBQUE7SUFDL0MsQ0FBQztDQWFKO0FBRUQsT0FBTyxFQUFFLFNBQVMsRUFBRSxDQUFBIn0=
                // CONCATENATED MODULE: ./esm/config.js
                const genesisBlocks = {
                    main: {
                        number: 0,
                        id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
                        size: 170,
                        parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
                        timestamp: 1530316800,
                        gasLimit: 10000000,
                        beneficiary: "0x0000000000000000000000000000000000000000",
                        gasUsed: 0,
                        totalScore: 0,
                        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        txsFeatures: 0,
                        stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
                        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        signer: "0x0000000000000000000000000000000000000000",
                        isTrunk: true,
                        transactions: []
                    },
                    test: {
                        number: 0,
                        id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
                        size: 170,
                        parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
                        timestamp: 1530014400,
                        gasLimit: 10000000,
                        beneficiary: "0x0000000000000000000000000000000000000000",
                        gasUsed: 0,
                        totalScore: 0,
                        txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        txsFeatures: 0,
                        stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
                        receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
                        signer: "0x0000000000000000000000000000000000000000",
                        isTrunk: true,
                        transactions: []
                    }
                };
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUc7SUFDekIsSUFBSSxFQUFFO1FBQ0YsTUFBTSxFQUFFLENBQUM7UUFDVCxFQUFFLEVBQUUsb0VBQW9FO1FBQ3hFLElBQUksRUFBRSxHQUFHO1FBQ1QsUUFBUSxFQUFFLG9FQUFvRTtRQUM5RSxTQUFTLEVBQUUsVUFBVTtRQUNyQixRQUFRLEVBQUUsUUFBUTtRQUNsQixXQUFXLEVBQUUsNENBQTRDO1FBQ3pELE9BQU8sRUFBRSxDQUFDO1FBQ1YsVUFBVSxFQUFFLENBQUM7UUFDYixPQUFPLEVBQUUsb0VBQW9FO1FBQzdFLFdBQVcsRUFBRSxDQUFDO1FBQ2QsU0FBUyxFQUFFLG9FQUFvRTtRQUMvRSxZQUFZLEVBQUUsb0VBQW9FO1FBQ2xGLE1BQU0sRUFBRSw0Q0FBNEM7UUFDcEQsT0FBTyxFQUFFLElBQUk7UUFDYixZQUFZLEVBQUUsRUFBRTtLQUNuQjtJQUNELElBQUksRUFBRTtRQUNGLE1BQU0sRUFBRSxDQUFDO1FBQ1QsRUFBRSxFQUFFLG9FQUFvRTtRQUN4RSxJQUFJLEVBQUUsR0FBRztRQUNULFFBQVEsRUFBRSxvRUFBb0U7UUFDOUUsU0FBUyxFQUFFLFVBQVU7UUFDckIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsV0FBVyxFQUFFLDRDQUE0QztRQUN6RCxPQUFPLEVBQUUsQ0FBQztRQUNWLFVBQVUsRUFBRSxDQUFDO1FBQ2IsT0FBTyxFQUFFLG9FQUFvRTtRQUM3RSxXQUFXLEVBQUUsQ0FBQztRQUNkLFNBQVMsRUFBRSxvRUFBb0U7UUFDL0UsWUFBWSxFQUFFLG9FQUFvRTtRQUNsRixNQUFNLEVBQUUsNENBQTRDO1FBQ3BELE9BQU8sRUFBRSxJQUFJO1FBQ2IsWUFBWSxFQUFFLEVBQUU7S0FDbkI7Q0FDSixDQUFBIn0=
                // CONCATENATED MODULE: ../driver/esm/promint.js
                /** class to make promise interruptable */ class PromInt {
                    constructor(){
                        this.rejectors = new Set();
                    }
                    /**
     * interrupt all wrapped promises
     */ interrupt() {
                        const rejectors = this.rejectors;
                        this.rejectors = new Set();
                        rejectors.forEach((r)=>r(new InterruptedError()));
                    }
                    /**
     * wrap the promise
     * @param p the given promise
     * @returns the wrapped promise which will raise InterruptedError on interruption
     */ wrap(p) {
                        return new Promise((resolve, reject)=>{
                            const rejectors = this.rejectors;
                            rejectors.add(reject);
                            p.then(resolve).catch(reject).then(()=>rejectors.delete(reject));
                        });
                    }
                }
                class InterruptedError extends Error {
                    constructor(){
                        super("promise interrupted");
                    }
                }
                InterruptedError.prototype.name = "InterruptedError";
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbWludC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wcm9taW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLDBDQUEwQztBQUMxQyxNQUFNLE9BQU8sT0FBTztJQUFwQjtRQUNZLGNBQVMsR0FBRyxJQUFJLEdBQUcsRUFBd0IsQ0FBQTtJQTJCdkQsQ0FBQztJQXpCRzs7T0FFRztJQUNJLFNBQVM7UUFDWixNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFBO1FBQ2hDLElBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxHQUFHLEVBQUUsQ0FBQTtRQUUxQixTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksZ0JBQWdCLEVBQUUsQ0FBQyxDQUFDLENBQUE7SUFDckQsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxJQUFJLENBQUksQ0FBYTtRQUN4QixPQUFPLElBQUksT0FBTyxDQUFJLENBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO1lBQ3RDLE1BQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUE7WUFDaEMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtZQUVyQixLQUFLLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDO2lCQUNmLEtBQUssQ0FBQyxNQUFNLENBQUM7aUJBQ2IsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQTtRQUM3QyxDQUFDLENBQUMsQ0FBQTtJQUNOLENBQUM7Q0FDSjtBQUVELE1BQU0sT0FBTyxnQkFBaUIsU0FBUSxLQUFLO0lBQ3ZDO1FBQ0ksS0FBSyxDQUFDLHFCQUFxQixDQUFDLENBQUE7SUFDaEMsQ0FBQztDQUNKO0FBRUQsZ0JBQWdCLENBQUMsU0FBUyxDQUFDLElBQUksR0FBRyxrQkFBa0IsQ0FBQSJ9
                // EXTERNAL MODULE: ../driver/node_modules/lru-cache/index.js
                var lru_cache = __webpack_require__(9992);
                // EXTERNAL MODULE: ../driver/node_modules/bignumber.js/bignumber.js
                var bignumber_js_bignumber = __webpack_require__(4491);
                var bignumber_js_bignumber_default = /*#__PURE__*/ __webpack_require__.n(bignumber_js_bignumber);
                // CONCATENATED MODULE: ../driver/node_modules/thor-devkit/esm/blake2b.js
                /* provided dependency */ var blake2b_Buffer = __webpack_require__(8764)["Buffer"];
                const blake = __webpack_require__(1161);
                /**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */ function blake2b256(...data) {
                    const ctx = blake.blake2bInit(32, null);
                    data.forEach((d)=>{
                        if (blake2b_Buffer.isBuffer(d)) blake.blake2bUpdate(ctx, d);
                        else blake.blake2bUpdate(ctx, blake2b_Buffer.from(d, "utf8"));
                    });
                    return blake2b_Buffer.from(blake.blake2bFinal(ctx));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxha2UyYi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibGFrZTJiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQTtBQUVoQzs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUFDLEdBQUcsSUFBNEI7SUFDdEQsTUFBTSxHQUFHLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixLQUFLLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUM5QjthQUFNO1lBQ0gsS0FBSyxDQUFDLGFBQWEsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuRDtJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUMvQyxDQUFDIn0=
                // CONCATENATED MODULE: ../driver/esm/bloom.js
                function bloom_newFilter(bits, k) {
                    const nBits = bits.length * 8;
                    return {
                        contains (key) {
                            let hash = blake2b256(key).readUInt32BE(0);
                            const delta = hash >>> 17 | hash << 15 >>> 0;
                            for(let i = 0; i < k; i++){
                                const bitPos = hash % nBits;
                                const index = bitPos >>> 3;
                                const bit = 1 << bitPos % 8;
                                if (!(bits[index] & bit)) return false;
                                hash = hash + delta >>> 0;
                            }
                            return true;
                        }
                    };
                }
                // // test vector
                // const bits = Buffer.from('63b2a4758c74e246c818e080b870437f5327a15cf81172512d98e61c54361a851ba8f108420e6b2b74a4196fb8e7bfe2b96c985e49abddb21c0600063997c93edb7c54921551600bcfc80fb62bfcd045c030b328eb8b5498e06dce610d22e901201226226441b8da094141526e0e58f5baf53064d63d598a4024bf68e0', 'hex')
                // const f = newFilter(bits, 6)
                // for (let i = 0; i < 100; i++) {
                //     if (!f.contains(Buffer.from(i + ''))) {
                //         throw new Error('should return true')
                //     }
                // }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvb20uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYmxvb20udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUV4QyxNQUFNLFVBQVUsU0FBUyxDQUFDLElBQVksRUFBRSxDQUFTO0lBQzdDLE1BQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFBO0lBQzdCLE9BQU87UUFDSCxRQUFRLENBQUMsR0FBVztZQUNoQixJQUFJLElBQUksR0FBRyxVQUFVLENBQUMsR0FBRyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFBO1lBQzFDLE1BQU0sS0FBSyxHQUFHLENBQUMsSUFBSSxLQUFLLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQTtZQUNoRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsRUFBRSxFQUFFO2dCQUN4QixNQUFNLE1BQU0sR0FBRyxJQUFJLEdBQUcsS0FBSyxDQUFBO2dCQUMzQixNQUFNLEtBQUssR0FBRyxNQUFNLEtBQUssQ0FBQyxDQUFBO2dCQUMxQixNQUFNLEdBQUcsR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDLENBQUE7Z0JBQzdCLElBQUksQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxHQUFHLENBQUMsRUFBRTtvQkFDdEIsT0FBTyxLQUFLLENBQUE7aUJBQ2Y7Z0JBQ0QsSUFBSSxHQUFHLENBQUMsSUFBSSxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQTthQUM5QjtZQUNELE9BQU8sSUFBSSxDQUFBO1FBQ2YsQ0FBQztLQUNKLENBQUE7QUFDTCxDQUFDO0FBQ0QsaUJBQWlCO0FBQ2pCLGdTQUFnUztBQUNoUywrQkFBK0I7QUFDL0Isa0NBQWtDO0FBQ2xDLDhDQUE4QztBQUM5QyxnREFBZ0Q7QUFDaEQsUUFBUTtBQUNSLElBQUkifQ==
                // CONCATENATED MODULE: ../driver/esm/cache.js
                /* provided dependency */ var cache_Buffer = __webpack_require__(8764)["Buffer"];
                var cache_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const WINDOW_LEN = 12;
                class Cache {
                    constructor(){
                        this.irreversible = {
                            blocks: new lru_cache(256),
                            txs: new lru_cache(512),
                            receipts: new lru_cache(512)
                        };
                        this.window = [];
                    }
                    handleNewBlock(head, bloom, block) {
                        while(this.window.length > 0){
                            const top = this.window[this.window.length - 1];
                            if (top.id === head.id) return;
                            if (top.id === head.parentID) break;
                            this.window.pop();
                        }
                        this.window.push(Object.assign(Object.assign({}, head), {
                            bloom: bloom ? bloom_newFilter(cache_Buffer.from(bloom.bits.slice(2), "hex"), bloom.k) : undefined,
                            block,
                            accounts: new Map(),
                            txs: new Map(),
                            receipts: new Map(),
                            tied: new Map()
                        }));
                        // shift out old slots and move cached items into frozen cache
                        while(this.window.length > WINDOW_LEN){
                            const bottom = this.window.shift();
                            bottom.txs.forEach((v, k)=>this.irreversible.txs.set(k, v));
                            bottom.receipts.forEach((v, k)=>this.irreversible.receipts.set(k, v));
                            if (bottom.block) {
                                this.irreversible.blocks.set(bottom.block.id, bottom.block);
                                this.irreversible.blocks.set(bottom.block.number, bottom.block);
                            }
                        }
                    }
                    getBlock(revision, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let block = this.irreversible.blocks.get(revision) || null;
                            if (block) return block;
                            const { slot } = this.findSlot(revision);
                            if (slot && slot.block) return slot.block;
                            block = yield fetch1();
                            if (block) {
                                if (slot && slot.id === block.id) slot.block = block;
                                if (this.isIrreversible(block.number)) {
                                    this.irreversible.blocks.set(block.id, block);
                                    if (block.isTrunk) this.irreversible.blocks.set(block.number, block);
                                }
                            }
                            return block;
                        });
                    }
                    getTx(txid, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let tx = this.irreversible.txs.get(txid) || null;
                            if (tx) return tx;
                            for (const slot of this.window){
                                tx = slot.txs.get(txid) || null;
                                if (tx) return tx;
                            }
                            tx = yield fetch1();
                            if (tx && tx.meta) {
                                const { slot } = this.findSlot(tx.meta.blockID);
                                if (slot) slot.txs.set(txid, tx);
                                if (this.isIrreversible(tx.meta.blockNumber)) this.irreversible.txs.set(txid, tx);
                            }
                            return tx;
                        });
                    }
                    getReceipt(txid, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            let receipt = this.irreversible.receipts.get(txid) || null;
                            if (receipt) return receipt;
                            for (const slot of this.window){
                                receipt = slot.receipts.get(txid) || null;
                                if (receipt) return receipt;
                            }
                            receipt = yield fetch1();
                            if (receipt) {
                                const { slot } = this.findSlot(receipt.meta.blockID);
                                if (slot) slot.receipts.set(txid, receipt);
                                if (this.isIrreversible(receipt.meta.blockNumber)) this.irreversible.receipts.set(txid, receipt);
                            }
                            return receipt;
                        });
                    }
                    getAccount(addr, revision, fetch1) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            const found = this.findSlot(revision);
                            for(let i = found.index; i >= 0; i--){
                                const slot = this.window[i];
                                const acc = slot.accounts.get(addr);
                                if (acc) {
                                    if (i !== found.index) found.slot.accounts.set(addr, acc);
                                    return acc.snapshot(found.slot.timestamp);
                                }
                                if (!slot.bloom || testBytesHex(slot.bloom, addr)) break;
                            }
                            const accObj = yield fetch1();
                            if (found.slot) found.slot.accounts.set(addr, new Account(accObj, found.slot.timestamp));
                            return accObj;
                        });
                    }
                    /**
     * get cached entry which is tied to a batch of addresses
     * @param key the cache key
     * @param revision block id where cache bound to
     * @param fetch to fetch value when cache missing
     * @param hints array of tied addresses, as the gist to invalidate cache key. undefined means the key is always
     * invalidated on different revision.
     */ getTied(key, revision, fetch1, hints) {
                        return cache_awaiter(this, void 0, void 0, function*() {
                            const found = this.findSlot(revision);
                            for(let i = found.index; i >= 0; i--){
                                const slot = this.window[i];
                                const v = slot.tied.get(key);
                                if (v) {
                                    if (i !== found.index) found.slot.tied.set(key, v);
                                    return v;
                                }
                                if (!slot.bloom || !hints) break;
                                // if hints.length === 0, never invalidate cache
                                if (hints.some((t)=>testBytesHex(slot.bloom, t))) break;
                            }
                            const value = yield fetch1();
                            if (found.slot) found.slot.tied.set(key, value);
                            return value;
                        });
                    }
                    findSlot(revision) {
                        const index = this.window.findIndex((s)=>s.id === revision || s.number === revision);
                        if (index >= 0) return {
                            slot: this.window[index],
                            index
                        };
                        return {
                            index
                        };
                    }
                    isIrreversible(n) {
                        if (this.window.length > 0) return n < this.window[this.window.length - 1].number - WINDOW_LEN;
                        return false;
                    }
                }
                function testBytesHex(filter, hex) {
                    let buf = cache_Buffer.from(hex.slice(2), "hex");
                    const nzIndex = buf.findIndex((v)=>v !== 0);
                    if (nzIndex < 0) buf = cache_Buffer.alloc(0);
                    else buf = buf.slice(nzIndex);
                    return filter.contains(buf);
                }
                const ENERGY_GROWTH_RATE = 5000000000;
                class Account {
                    constructor(obj, initTimestamp){
                        this.obj = obj;
                        this.initTimestamp = initTimestamp;
                    }
                    snapshot(timestamp) {
                        return Object.assign(Object.assign({}, this.obj), {
                            energy: this.energyAt(timestamp)
                        });
                    }
                    energyAt(timestamp) {
                        if (timestamp < this.initTimestamp) return this.obj.energy;
                        return "0x" + new (bignumber_js_bignumber_default())(this.obj.balance).times(timestamp - this.initTimestamp).times(ENERGY_GROWTH_RATE).dividedToIntegerBy(1e18).plus(this.obj.energy).toString(16);
                    }
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ../driver/esm/common.js
                function sleep(ms) {
                    return new Promise((resolve)=>setTimeout(resolve, ms));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLFVBQVUsS0FBSyxDQUFDLEVBQVU7SUFDNUIsT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLFVBQVUsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQTtBQUMxRCxDQUFDIn0=
                // CONCATENATED MODULE: ../driver/esm/driver-no-vendor.js
                var driver_no_vendor_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** class implements Connex.Driver leaves out Vendor related methods */ class DriverNoVendor {
                    constructor(net, genesis, initialHead){
                        this.net = net;
                        this.genesis = genesis;
                        this.headResolvers = [];
                        this.int = new PromInt();
                        this.cache = new Cache();
                        // to merge concurrent identical remote requests
                        this.pendingRequests = {};
                        if (initialHead) this.head = initialHead;
                        else this.head = {
                            id: genesis.id,
                            number: genesis.number,
                            timestamp: genesis.timestamp,
                            parentID: genesis.parentID,
                            txsFeatures: genesis.txsFeatures,
                            gasLimit: genesis.gasLimit
                        };
                        this.headTrackerLoop();
                    }
                    // close the driver to prevent mem leak
                    close() {
                        this.int.interrupt();
                    }
                    // implementations
                    pollHead() {
                        return this.int.wrap(new Promise((resolve)=>{
                            this.headResolvers.push(()=>resolve(this.head));
                        }));
                    }
                    getBlock(revision) {
                        return this.cache.getBlock(revision, ()=>this.httpGet(`blocks/${revision}`));
                    }
                    getTransaction(id, allowPending) {
                        return this.cache.getTx(id, ()=>{
                            const query = {
                                head: this.head.id
                            };
                            if (allowPending) query.pending = "true";
                            return this.httpGet(`transactions/${id}`, query);
                        });
                    }
                    getReceipt(id) {
                        return this.cache.getReceipt(id, ()=>this.httpGet(`transactions/${id}/receipt`, {
                                head: this.head.id
                            }));
                    }
                    getAccount(addr, revision) {
                        return this.cache.getAccount(addr, revision, ()=>this.httpGet(`accounts/${addr}`, {
                                revision
                            }));
                    }
                    getCode(addr, revision) {
                        return this.cache.getTied(`code-${addr}`, revision, ()=>this.httpGet(`accounts/${addr}/code`, {
                                revision
                            }));
                    }
                    getStorage(addr, key, revision) {
                        return this.cache.getTied(`storage-${addr}-${key}`, revision, ()=>this.httpGet(`accounts/${addr}/storage/${key}`, {
                                revision
                            }));
                    }
                    explain(arg, revision, cacheHints) {
                        const cacheKey = `explain-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, revision, ()=>this.httpPost("accounts/*", arg, {
                                revision
                            }), cacheHints);
                    }
                    filterEventLogs(arg, cacheHints) {
                        const cacheKey = `event-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/event", arg), cacheHints);
                    }
                    filterTransferLogs(arg, cacheHints) {
                        const cacheKey = `transfer-${blake2b256(JSON.stringify(arg)).toString("hex")}`;
                        return this.cache.getTied(cacheKey, this.head.id, ()=>this.httpPost("logs/transfer", arg), cacheHints);
                    }
                    signTx(msg, options) {
                        throw new Error("signer not implemented");
                    }
                    signCert(msg, options) {
                        throw new Error("signer not implemented");
                    }
                    //////
                    mergeRequest(req, ...keyParts) {
                        const key = JSON.stringify(keyParts);
                        const pending = this.pendingRequests[key];
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        if (pending) return pending;
                        return this.pendingRequests[key] = (()=>driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                                try {
                                    return yield req();
                                } finally{
                                    delete this.pendingRequests[key];
                                }
                            }))();
                    }
                    httpGet(path, query) {
                        return this.mergeRequest(()=>{
                            return this.net.http("GET", path, {
                                query,
                                validateResponseHeader: this.headerValidator
                            });
                        }, path, query || "");
                    }
                    httpPost(path, body, query) {
                        return this.mergeRequest(()=>{
                            return this.net.http("POST", path, {
                                query,
                                body,
                                validateResponseHeader: this.headerValidator
                            });
                        }, path, query || "", body || "");
                    }
                    get headerValidator() {
                        return (headers)=>{
                            const xgid = headers["x-genesis-id"];
                            if (xgid && xgid !== this.genesis.id) throw new Error(`responded 'x-genesis-id' not matched`);
                        };
                    }
                    emitNewHead() {
                        const resolvers = this.headResolvers;
                        this.headResolvers = [];
                        resolvers.forEach((r)=>r());
                    }
                    headTrackerLoop() {
                        return driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                            for(;;){
                                let attemptWs = false;
                                try {
                                    const best = yield this.int.wrap(this.httpGet("blocks/best"));
                                    if (best.id !== this.head.id && best.number >= this.head.number) {
                                        this.head = {
                                            id: best.id,
                                            number: best.number,
                                            timestamp: best.timestamp,
                                            parentID: best.parentID,
                                            txsFeatures: best.txsFeatures,
                                            gasLimit: best.gasLimit
                                        };
                                        this.cache.handleNewBlock(this.head, undefined, best);
                                        this.emitNewHead();
                                        if (Date.now() - this.head.timestamp * 1000 < 60000) // nearly synced
                                        attemptWs = true;
                                    }
                                } catch (err) {
                                    if (err instanceof InterruptedError) break;
                                }
                                if (attemptWs) try {
                                    yield this.trackWs();
                                } catch (err) {
                                    if (err instanceof InterruptedError) break;
                                }
                                try {
                                    yield this.int.wrap(sleep(8000));
                                } catch (_a) {
                                    break;
                                }
                            }
                        });
                    }
                    trackWs() {
                        return driver_no_vendor_awaiter(this, void 0, void 0, function*() {
                            const wsPath = `subscriptions/beat2?pos=${this.head.parentID}`;
                            const wsr = this.net.openWebSocketReader(wsPath);
                            try {
                                for(;;){
                                    const data = yield this.int.wrap(wsr.read());
                                    const beat = JSON.parse(data);
                                    if (!beat.obsolete && beat.id !== this.head.id && beat.number >= this.head.number) {
                                        this.head = {
                                            id: beat.id,
                                            number: beat.number,
                                            timestamp: beat.timestamp,
                                            parentID: beat.parentID,
                                            txsFeatures: beat.txsFeatures,
                                            gasLimit: beat.gasLimit
                                        };
                                        this.cache.handleNewBlock(this.head, {
                                            k: beat.k,
                                            bits: beat.bloom
                                        });
                                        this.emitNewHead();
                                    }
                                }
                            } finally{
                                wsr.close();
                            }
                        });
                    }
                }
                //# sourceMappingURL=data:application/json;base64,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
                // EXTERNAL MODULE: ../driver/node_modules/axios/index.js
                var axios = __webpack_require__(8416);
                var axios_default = /*#__PURE__*/ __webpack_require__.n(axios);
                // EXTERNAL MODULE: ../driver/node_modules/isomorphic-ws/browser.js
                var browser = __webpack_require__(9347);
                // CONCATENATED MODULE: ../driver/esm/simple-websocket-reader.js
                class SimpleWebSocketReader {
                    constructor(url, timeout = 30000){
                        this.timeout = timeout;
                        this.callbacks = [];
                        this.ws = new browser(url);
                        this.ws.onmessage = (ev)=>{
                            try {
                                const cbs = this.callbacks;
                                this.callbacks = [];
                                cbs.forEach((cb)=>cb(ev.data));
                            } catch (err) {
                                this.setError(err);
                                this.ws.close();
                            }
                        };
                        this.ws.onerror = (ev)=>{
                            this.setError(ev.error);
                            this.ws.close();
                        };
                        this.ws.onclose = ()=>{
                            this.setError(new Error("closed"));
                        };
                    }
                    read() {
                        return new Promise((resolve, reject)=>{
                            if (this.error) return reject(this.error);
                            const timer = setTimeout(()=>{
                                reject(new Error("ws read timeout"));
                            }, this.timeout);
                            this.callbacks.push((data, err)=>{
                                clearTimeout(timer);
                                if (err) return reject(err);
                                resolve(data);
                            });
                        });
                    }
                    close() {
                        this.ws.close();
                    }
                    setError(err) {
                        if (!this.error) {
                            this.error = err;
                            const cbs = this.callbacks;
                            this.callbacks = [];
                            cbs.forEach((cb)=>cb(null, err));
                        }
                    }
                }
                //# sourceMappingURL=data:application/json;base64,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
                // EXTERNAL MODULE: ./node_modules/url/url.js
                var url_url = __webpack_require__(8575);
                // CONCATENATED MODULE: ./dummy-http-agent.js
                class Agent {
                    constructor(){
                        return undefined;
                    }
                }
                // CONCATENATED MODULE: ../driver/esm/simple-net.js
                var simple_net_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /** class simply implements Net interface */ class SimpleNet {
                    constructor(baseURL, timeout = 30000, wsTimeout = 30000){
                        this.baseURL = baseURL;
                        this.wsTimeout = wsTimeout;
                        this.axios = axios_default().create({
                            httpAgent: new Agent({
                                keepAlive: true
                            }),
                            httpsAgent: new Agent({
                                keepAlive: true
                            }),
                            baseURL,
                            timeout
                        });
                    }
                    http(method, path, params) {
                        return simple_net_awaiter(this, void 0, void 0, function*() {
                            params = params || {};
                            try {
                                const resp = yield this.axios.request({
                                    method,
                                    url: path,
                                    data: params.body,
                                    headers: params.headers,
                                    params: params.query
                                });
                                if (params.validateResponseHeader) params.validateResponseHeader(resp.headers);
                                return resp.data;
                            } catch (err) {
                                if (err.isAxiosError) throw convertError(err);
                                throw new Error(`${method} ${(0, url_url /* resolve */ .DB)(this.baseURL, path)}: ${err.message}`);
                            }
                        });
                    }
                    openWebSocketReader(path) {
                        const url = (0, url_url /* resolve */ .DB)(this.baseURL, path).replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
                        return new SimpleWebSocketReader(url, this.wsTimeout);
                    }
                }
                function convertError(err) {
                    if (err.response) {
                        const resp = err.response;
                        if (typeof resp.data === "string") {
                            let text = resp.data.trim();
                            if (text.length > 50) text = text.slice(0, 50) + "...";
                            return new Error(`${resp.status} ${err.config.method} ${err.config.url}: ${text}`);
                        } else return new Error(`${resp.status} ${err.config.method} ${err.config.url}`);
                    } else return new Error(`${err.config.method} ${err.config.url}: ${err.message}`);
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./node_modules/thor-devkit/esm/blake2b.js
                /* provided dependency */ var esm_blake2b_Buffer = __webpack_require__(8764)["Buffer"];
                const blake2b_blake = __webpack_require__(1191);
                /**
 * computes blake2b 256bit hash of given data
 * @param data one or more Buffer | string
 */ function blake2b_blake2b256(...data) {
                    const ctx = blake2b_blake.blake2bInit(32, null);
                    data.forEach((d)=>{
                        if (esm_blake2b_Buffer.isBuffer(d)) blake2b_blake.blake2bUpdate(ctx, d);
                        else blake2b_blake.blake2bUpdate(ctx, esm_blake2b_Buffer.from(d, "utf8"));
                    });
                    return esm_blake2b_Buffer.from(blake2b_blake.blake2bFinal(ctx));
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxha2UyYi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibGFrZTJiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQTtBQUVoQzs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUFDLEdBQUcsSUFBNEI7SUFDdEQsTUFBTSxHQUFHLEdBQUcsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLEVBQUUsSUFBSSxDQUFDLENBQUE7SUFDdkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUNiLElBQUksTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNwQixLQUFLLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUM5QjthQUFNO1lBQ0gsS0FBSyxDQUFDLGFBQWEsQ0FBQyxHQUFHLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtTQUNuRDtJQUNMLENBQUMsQ0FBQyxDQUFBO0lBQ0YsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxZQUFZLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUMvQyxDQUFDIn0=
                // CONCATENATED MODULE: ./esm/driver.js
                var driver_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                /* eslint-disable @typescript-eslint/no-unused-vars */ /** the LazyDriver implements vendor methods at construction but allows attaching NoVendorDriver later to be a full one*/ class LazyDriver {
                    constructor(signer){
                        this.signer = signer;
                        this._driver = null;
                    }
                    get noVendor() {
                        if (!this._driver) throw new Error("thor driver is not ready");
                        return this._driver;
                    }
                    setNoVendor(driver) {
                        this._driver = driver;
                    }
                    get genesis() {
                        return this.noVendor.genesis;
                    }
                    get head() {
                        return this.noVendor.head;
                    }
                    pollHead() {
                        return this.noVendor.pollHead();
                    }
                    getBlock(revision) {
                        return this.noVendor.getBlock(revision);
                    }
                    getTransaction(id, allowPending) {
                        return this.noVendor.getTransaction(id, allowPending);
                    }
                    getReceipt(id) {
                        return this.noVendor.getReceipt(id);
                    }
                    getAccount(addr, revision) {
                        return this.noVendor.getAccount(addr, revision);
                    }
                    getCode(addr, revision) {
                        return this.noVendor.getCode(addr, revision);
                    }
                    getStorage(addr, key, revision) {
                        return this.noVendor.getStorage(addr, key, revision);
                    }
                    explain(arg, revision, cacheHints) {
                        return this.noVendor.explain(arg, revision, cacheHints);
                    }
                    filterEventLogs(arg) {
                        return this.noVendor.filterEventLogs(arg);
                    }
                    filterTransferLogs(arg) {
                        return this.noVendor.filterTransferLogs(arg);
                    }
                    signTx(msg, options) {
                        return driver_awaiter(this, void 0, void 0, function*() {
                            return this.signer.then((b)=>b.signTx(msg, options));
                        });
                    }
                    signCert(msg, options) {
                        return driver_awaiter(this, void 0, void 0, function*() {
                            return this.signer.then((b)=>b.signCert(msg, options));
                        });
                    }
                }
                const cache = {};
                /**
 * create a no vendor driver
 * @param node the url of thor node
 * @param genesis the enforced genesis block
 */ function createNoVendor(node, genesis) {
                    const key = blake2b_blake2b256(JSON.stringify({
                        node,
                        genesis
                    })).toString("hex");
                    let driver = cache[key];
                    if (!driver) cache[key] = driver = new DriverNoVendor(new SimpleNet(node), genesis);
                    return driver;
                }
                /**
 * create a full driver
 * @param node the url of thor node
 * @param genesis the enforced genesis block
 * @param newSigner a function to create signer
 */ function createFull(node, genesis, newSigner) {
                    const driver = new LazyDriver(newSigner(genesis.id));
                    driver.setNoVendor(createNoVendor(node, genesis));
                    return driver;
                }
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./esm/script-loader.js
                // maps src to library promise
                const script_loader_cache = {};
                function loadLibrary(src, libName) {
                    let lib = script_loader_cache[src];
                    if (!lib) {
                        const script = document.createElement("script");
                        script_loader_cache[src] = lib = new Promise((resolve, reject)=>{
                            script.onload = ()=>resolve(window[libName]);
                            script.onerror = (err)=>reject(new Error(err.toString()));
                        });
                        script.src = src;
                        document.body.appendChild(script);
                    }
                    return lib;
                }
                //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NyaXB0LWxvYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zY3JpcHQtbG9hZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLDhCQUE4QjtBQUM5QixNQUFNLEtBQUssR0FBcUMsRUFBRSxDQUFBO0FBRWxELE1BQU0sVUFBVSxXQUFXLENBQUksR0FBVyxFQUFFLE9BQWU7SUFDdkQsSUFBSSxHQUFHLEdBQUcsS0FBSyxDQUFDLEdBQUcsQ0FBMkIsQ0FBQTtJQUM5QyxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ04sTUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUMvQyxLQUFLLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxHQUFHLElBQUksT0FBTyxDQUFDLENBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO1lBQy9DLE1BQU0sQ0FBQyxNQUFNLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFFLE1BQWdCLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQTtZQUN6RCxNQUFNLENBQUMsT0FBTyxHQUFHLEdBQUcsQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLElBQUksS0FBSyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDLENBQUE7UUFDN0QsQ0FBQyxDQUFDLENBQUE7UUFDRixNQUFNLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQTtRQUNoQixRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtLQUNwQztJQUNELE9BQU8sR0FBRyxDQUFBO0FBQ2QsQ0FBQyJ9
                // EXTERNAL MODULE: ./node_modules/randombytes/browser.js
                var randombytes_browser = __webpack_require__(1798);
                var randombytes_browser_default = /*#__PURE__*/ __webpack_require__.n(randombytes_browser);
                // CONCATENATED MODULE: ./esm/signer.js
                var signer_awaiter = function(thisArg, _arguments, P, generator) {
                    function adopt(value) {
                        return value instanceof P ? value : new P(function(resolve) {
                            resolve(value);
                        });
                    }
                    return new (P || (P = Promise))(function(resolve, reject) {
                        function fulfilled(value) {
                            try {
                                step(generator.next(value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function rejected(value) {
                            try {
                                step(generator["throw"](value));
                            } catch (e) {
                                reject(e);
                            }
                        }
                        function step(result) {
                            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                        }
                        step((generator = generator.apply(thisArg, _arguments || [])).next());
                    });
                };
                const BUDDY_SRC = "https://unpkg.com/@vechain/connex-wallet-buddy@0.1";
                const BUDDY_LIB_NAME = "ConnexWalletBuddy";
                const createSync2 = (genesisId)=>signer_awaiter(void 0, void 0, void 0, function*() {
                        return loadLibrary(BUDDY_SRC, BUDDY_LIB_NAME).then((lib)=>lib.create(genesisId, ()=>randombytes_browser_default()(16).toString("hex"), (val)=>blake2b_blake2b256(val).toString("hex")));
                    });
                const createSync = (genesisId)=>signer_awaiter(void 0, void 0, void 0, function*() {
                        const v1 = window.connex.vendor;
                        return Promise.resolve({
                            signTx: (msg, options)=>{
                                const s1 = v1.sign("tx");
                                options.signer && s1.signer(options.signer);
                                options.gas && s1.gas(options.gas);
                                options.dependsOn && s1.dependsOn(options.dependsOn);
                                options.link && s1.link(options.link);
                                options.comment && s1.link(options.comment);
                                if (options.delegator) {
                                    const url = options.delegator.url;
                                    s1.delegate((unsignedTx)=>signer_awaiter(void 0, void 0, void 0, function*() {
                                            const res = yield fetch(url, {
                                                method: "POST",
                                                body: JSON.stringify(unsignedTx),
                                                headers: {
                                                    "Content-Type": "application/json"
                                                }
                                            });
                                            return res.json();
                                        }));
                                }
                                options.onAccepted && options.onAccepted();
                                return s1.request(msg);
                            },
                            signCert: (msg, options)=>{
                                const s1 = v1.sign("cert");
                                options.signer && s1.signer(options.signer);
                                options.link && s1.link(options.link);
                                options.onAccepted && options.onAccepted();
                                return s1.request(msg);
                            }
                        });
                    });
                //# sourceMappingURL=data:application/json;base64,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
                // CONCATENATED MODULE: ./esm/index.js
                /** convert options.network to Connex.Thor.Block */ function normalizeNetwork(n) {
                    n = n || "main";
                    if (typeof n === "string") {
                        const gb = genesisBlocks[n];
                        if (!gb) throw new Error("invalid network");
                        return gb;
                    } else return n;
                }
                /** convert network name to genesis id */ function normalizeGenesisId(id) {
                    id = id || "main";
                    if (/^0x[0-9a-f]{64}$/.test(id)) return id;
                    const gb = genesisBlocks[id];
                    if (gb) return gb.id;
                    throw new Error("invalid genesis id");
                }
                /** convert options.signer to a signer creation function */ function normalizeSigner(genesisId, signer) {
                    switch(signer.toLocaleLowerCase()){
                        case "sync":
                            if (!window.connex) throw new Error("Sync not found");
                            if (window.connex.thor.genesis.id !== genesisId) throw new Error("Network mismatch");
                            return createSync;
                        case "sync2":
                            return createSync2;
                        default:
                            throw new Error("unsupported signer");
                    }
                }
                /** Thor class which can work stand alone to provide reading-services only */ class ThorClass {
                    constructor(opts){
                        const genesis = normalizeNetwork(opts.network);
                        const driver = createNoVendor(opts.node, genesis);
                        const framework = new Framework(driver);
                        return {
                            get genesis () {
                                return framework.thor.genesis;
                            },
                            get status () {
                                return framework.thor.status;
                            },
                            get ticker () {
                                return framework.thor.ticker.bind(framework.thor);
                            },
                            get account () {
                                return framework.thor.account.bind(framework.thor);
                            },
                            get block () {
                                return framework.thor.block.bind(framework.thor);
                            },
                            get transaction () {
                                return framework.thor.transaction.bind(framework.thor);
                            },
                            get filter () {
                                return framework.thor.filter.bind(framework.thor);
                            },
                            get explain () {
                                return framework.thor.explain.bind(framework.thor);
                            }
                        };
                    }
                }
                /** Vendor class which can work standalone to provides signing-services only */ class VendorClass {
                    constructor(genesisId, signer = "sync2"){
                        genesisId = normalizeGenesisId(genesisId);
                        const newSigner = normalizeSigner(genesisId, signer);
                        const driver = new LazyDriver(newSigner(genesisId));
                        const vendor = newVendor(driver);
                        return {
                            get sign () {
                                return vendor.sign.bind(vendor);
                            }
                        };
                    }
                }
                /** Connex class */ class ConnexClass {
                    constructor(opts){
                        var _a;
                        const genesis = normalizeNetwork(opts.network);
                        const newSigner = normalizeSigner(genesis.id, (_a = opts.signer) !== null && _a !== void 0 ? _a : "sync2");
                        const driver = createFull(opts.node, genesis, newSigner);
                        const framework = new Framework(driver);
                        return {
                            get thor () {
                                return framework.thor;
                            },
                            get vendor () {
                                return framework.vendor;
                            }
                        };
                    }
                }
                ConnexClass.Thor = ThorClass;
                ConnexClass.Vendor = VendorClass;
                /* harmony default export */ const esm = ConnexClass;
            //# sourceMappingURL=data:application/json;base64,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
            /***/ },
            /***/ 9742: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                exports.byteLength = byteLength;
                exports.toByteArray = toByteArray;
                exports.fromByteArray = fromByteArray;
                var lookup = [];
                var revLookup = [];
                var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
                var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                for(var i = 0, len = code.length; i < len; ++i){
                    lookup[i] = code[i];
                    revLookup[code.charCodeAt(i)] = i;
                }
                // Support decoding URL-safe base64 strings, as Node.js does.
                // See: https://en.wikipedia.org/wiki/Base64#URL_applications
                revLookup["-".charCodeAt(0)] = 62;
                revLookup["_".charCodeAt(0)] = 63;
                function getLens(b64) {
                    var len = b64.length;
                    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    // Trim off extra bytes after placeholder bytes are found
                    // See: https://github.com/beatgammit/base64-js/issues/42
                    var validLen = b64.indexOf("=");
                    if (validLen === -1) validLen = len;
                    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
                    return [
                        validLen,
                        placeHoldersLen
                    ];
                }
                // base64 is 4/3 + up to two characters of the original data
                function byteLength(b64) {
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function _byteLength(b64, validLen, placeHoldersLen) {
                    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
                }
                function toByteArray(b64) {
                    var tmp;
                    var lens = getLens(b64);
                    var validLen = lens[0];
                    var placeHoldersLen = lens[1];
                    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
                    var curByte = 0;
                    // if there are placeholders, only get up to the last complete 4 chars
                    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
                    var i;
                    for(i = 0; i < len; i += 4){
                        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
                        arr[curByte++] = tmp >> 16 & 0xFF;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 2) {
                        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    if (placeHoldersLen === 1) {
                        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
                        arr[curByte++] = tmp >> 8 & 0xFF;
                        arr[curByte++] = tmp & 0xFF;
                    }
                    return arr;
                }
                function tripletToBase64(num) {
                    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
                }
                function encodeChunk(uint8, start, end) {
                    var tmp;
                    var output = [];
                    for(var i = start; i < end; i += 3){
                        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
                        output.push(tripletToBase64(tmp));
                    }
                    return output.join("");
                }
                function fromByteArray(uint8) {
                    var tmp;
                    var len = uint8.length;
                    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
                    ;
                    var parts = [];
                    var maxChunkLength = 16383 // must be multiple of 3
                    ;
                    // go through the array every three bytes, we'll deal with trailing stuff later
                    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
                    // pad the end with zeros, but make sure to not forget the extra bytes
                    if (extraBytes === 1) {
                        tmp = uint8[len - 1];
                        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
                    } else if (extraBytes === 2) {
                        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
                    }
                    return parts.join("");
                }
            /***/ },
            /***/ 8442: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // Blake2B in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(9488);
                // 64-bit unsigned addition
                // Sets v[a,a+1] += v[b,b+1]
                // v should be a Uint32Array
                function ADD64AA(v, a, b) {
                    const o0 = v[a] + v[b];
                    let o1 = v[a + 1] + v[b + 1];
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // 64-bit unsigned addition
                // Sets v[a,a+1] += b
                // b0 is the low 32 bits of b, b1 represents the high 32 bits
                function ADD64AC(v, a, b0, b1) {
                    let o0 = v[a] + b0;
                    if (b0 < 0) o0 += 0x100000000;
                    let o1 = v[a + 1] + b1;
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // Little-endian byte access
                function B2B_GET32(arr, i) {
                    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
                }
                // G Mixing function
                // The ROTRs are inlined for speed
                function B2B_G(a, b, c, d, ix, iy) {
                    const x0 = m[ix];
                    const x1 = m[ix + 1];
                    const y0 = m[iy];
                    const y1 = m[iy + 1];
                    ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
                    ;
                    ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
                    ;
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
                    let xor0 = v[d] ^ v[a];
                    let xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor1;
                    v[d + 1] = xor0;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor0 >>> 24 ^ xor1 << 8;
                    v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
                    ADD64AA(v, a, b);
                    ADD64AC(v, a, y0, y1);
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
                    xor0 = v[d] ^ v[a];
                    xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor0 >>> 16 ^ xor1 << 16;
                    v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor1 >>> 31 ^ xor0 << 1;
                    v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
                }
                // Initialization Vector
                const BLAKE2B_IV32 = new Uint32Array([
                    0xf3bcc908,
                    0x6a09e667,
                    0x84caa73b,
                    0xbb67ae85,
                    0xfe94f82b,
                    0x3c6ef372,
                    0x5f1d36f1,
                    0xa54ff53a,
                    0xade682d1,
                    0x510e527f,
                    0x2b3e6c1f,
                    0x9b05688c,
                    0xfb41bd6b,
                    0x1f83d9ab,
                    0x137e2179,
                    0x5be0cd19
                ]);
                const SIGMA8 = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ];
                // These are offsets into a uint64 buffer.
                // Multiply them all by 2 to make them offsets into a uint32 buffer,
                // because this is Javascript and we don't have uint64s
                const SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
                    return x * 2;
                }));
                // Compression function. 'last' flag indicates last block.
                // Note we're representing 16 uint64s as 32 uint32s
                const v = new Uint32Array(32);
                const m = new Uint32Array(32);
                function blake2bCompress(ctx, last) {
                    let i = 0;
                    // init work variables
                    for(i = 0; i < 16; i++){
                        v[i] = ctx.h[i];
                        v[i + 16] = BLAKE2B_IV32[i];
                    }
                    // low 64 bits of offset
                    v[24] = v[24] ^ ctx.t;
                    v[25] = v[25] ^ ctx.t / 0x100000000;
                    // high 64 bits not supported, offset may not be higher than 2**53-1
                    // last block flag set ?
                    if (last) {
                        v[28] = ~v[28];
                        v[29] = ~v[29];
                    }
                    // get little-endian words
                    for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
                    // twelve rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 64)
                    for(i = 0; i < 12; i++){
                        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
                        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
                    }
                    // util.debugPrint('   (i=12) v[16]', v, 64)
                    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
                // util.debugPrint('h[8]', ctx.h, 64)
                }
                // Creates a BLAKE2b hashing context
                // Requires an output length between 1 and 64 bytes
                // Takes an optional Uint8Array key
                function blake2bInit(outlen, key) {
                    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
                    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
                    // state, 'param block'
                    const ctx = {
                        b: new Uint8Array(128),
                        h: new Uint32Array(16),
                        t: 0,
                        c: 0,
                        outlen: outlen // output length in bytes
                    };
                    // initialize hash state
                    for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i];
                    const keylen = key ? key.length : 0;
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    // key the hash, if applicable
                    if (key) {
                        blake2bUpdate(ctx, key);
                        // at the end
                        ctx.c = 128;
                    }
                    return ctx;
                }
                // Updates a BLAKE2b streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2bUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 128) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2bCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2b streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2bFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 128)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2bCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
                    return out;
                }
                // Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2b(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 64;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2bInit(outlen, key);
                    blake2bUpdate(ctx, input);
                    return blake2bFinal(ctx);
                }
                // Computes the BLAKE2B hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2bHex(input, key, outlen) {
                    const output = blake2b(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2b: blake2b,
                    blake2bHex: blake2bHex,
                    blake2bInit: blake2bInit,
                    blake2bUpdate: blake2bUpdate,
                    blake2bFinal: blake2bFinal
                };
            /***/ },
            /***/ 5297: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // BLAKE2s hash function in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(9488);
                // Little-endian byte access.
                // Expects a Uint8Array and an index
                // Returns the little-endian uint32 at v[i..i+3]
                function B2S_GET32(v, i) {
                    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
                }
                // Mixing function G.
                function B2S_G(a, b, c, d, x, y) {
                    v[a] = v[a] + v[b] + x;
                    v[d] = ROTR32(v[d] ^ v[a], 16);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 12);
                    v[a] = v[a] + v[b] + y;
                    v[d] = ROTR32(v[d] ^ v[a], 8);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 7);
                }
                // 32-bit right rotation
                // x should be a uint32
                // y must be between 1 and 31, inclusive
                function ROTR32(x, y) {
                    return x >>> y ^ x << 32 - y;
                }
                // Initialization Vector.
                const BLAKE2S_IV = new Uint32Array([
                    0x6a09e667,
                    0xbb67ae85,
                    0x3c6ef372,
                    0xa54ff53a,
                    0x510e527f,
                    0x9b05688c,
                    0x1f83d9ab,
                    0x5be0cd19
                ]);
                const SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0
                ]);
                // Compression function. "last" flag indicates last block
                const v = new Uint32Array(16);
                const m = new Uint32Array(16);
                function blake2sCompress(ctx, last) {
                    let i = 0;
                    for(i = 0; i < 8; i++){
                        // init work variables
                        v[i] = ctx.h[i];
                        v[i + 8] = BLAKE2S_IV[i];
                    }
                    v[12] ^= ctx.t // low 32 bits of offset
                    ;
                    v[13] ^= ctx.t / 0x100000000 // high 32 bits
                    ;
                    if (last) // last block flag set ?
                    v[14] = ~v[14];
                    for(i = 0; i < 16; i++)// get little-endian words
                    m[i] = B2S_GET32(ctx.b, 4 * i);
                    // ten rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 32)
                    for(i = 0; i < 10; i++){
                        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
                        B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]]);
                        B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]]);
                        B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]]);
                        B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]]);
                        B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]]);
                        B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]]);
                        B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]]);
                        B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]]);
                    }
                    // util.debugPrint('   (i=10) v[16]', v, 32)
                    for(i = 0; i < 8; i++)ctx.h[i] ^= v[i] ^ v[i + 8];
                // util.debugPrint('h[8]', ctx.h, 32)
                }
                // Creates a BLAKE2s hashing context
                // Requires an output length between 1 and 32 bytes
                // Takes an optional Uint8Array key
                function blake2sInit(outlen, key) {
                    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
                    const keylen = key ? key.length : 0;
                    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
                    const ctx = {
                        h: new Uint32Array(BLAKE2S_IV),
                        b: new Uint8Array(64),
                        c: 0,
                        t: 0,
                        outlen: outlen // output length in bytes
                    };
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    if (keylen > 0) {
                        blake2sUpdate(ctx, key);
                        ctx.c = 64 // at the end
                        ;
                    }
                    return ctx;
                }
                // Updates a BLAKE2s streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2sUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 64) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2sCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2s streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2sFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 64)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2sCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
                    return out;
                }
                // Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2s(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 32;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2sInit(outlen, key);
                    blake2sUpdate(ctx, input);
                    return blake2sFinal(ctx);
                }
                // Computes the BLAKE2S hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2sHex(input, key, outlen) {
                    const output = blake2s(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2s: blake2s,
                    blake2sHex: blake2sHex,
                    blake2sInit: blake2sInit,
                    blake2sUpdate: blake2sUpdate,
                    blake2sFinal: blake2sFinal
                };
            /***/ },
            /***/ 1191: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                const b2b = __webpack_require__(8442);
                const b2s = __webpack_require__(5297);
                module1.exports = {
                    blake2b: b2b.blake2b,
                    blake2bHex: b2b.blake2bHex,
                    blake2bInit: b2b.blake2bInit,
                    blake2bUpdate: b2b.blake2bUpdate,
                    blake2bFinal: b2b.blake2bFinal,
                    blake2s: b2s.blake2s,
                    blake2sHex: b2s.blake2sHex,
                    blake2sInit: b2s.blake2sInit,
                    blake2sUpdate: b2s.blake2sUpdate,
                    blake2sFinal: b2s.blake2sFinal
                };
            /***/ },
            /***/ 9488: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
                // For convenience, let people hash a string, not just a Uint8Array
                function normalizeInput(input) {
                    let ret;
                    if (input instanceof Uint8Array) ret = input;
                    else if (input instanceof Buffer) ret = new Uint8Array(input);
                    else if (typeof input === "string") ret = new Uint8Array(Buffer.from(input, "utf8"));
                    else throw new Error(ERROR_MSG_INPUT);
                    return ret;
                }
                // Converts a Uint8Array to a hexadecimal string
                // For example, toHex([255, 0, 255]) returns "ff00ff"
                function toHex(bytes) {
                    return Array.prototype.map.call(bytes, function(n) {
                        return (n < 16 ? "0" : "") + n.toString(16);
                    }).join("");
                }
                // Converts any value in [0...2^32-1] to an 8-character hex string
                function uint32ToHex(val) {
                    return (0x100000000 + val).toString(16).substring(1);
                }
                // For debugging: prints out hash state in the same format as the RFC
                // sample computation exactly, so that you can diff
                function debugPrint(label, arr, size) {
                    let msg = "\n" + label + " = ";
                    for(let i = 0; i < arr.length; i += 2){
                        if (size === 32) {
                            msg += uint32ToHex(arr[i]).toUpperCase();
                            msg += " ";
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                        } else if (size === 64) {
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                            msg += uint32ToHex(arr[i]).toUpperCase();
                        } else throw new Error("Invalid size " + size);
                        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
                        else if (i < arr.length - 2) msg += " ";
                    }
                    console.log(msg);
                }
                // For performance testing: generates N bytes of input, hashes M times
                // Measures and prints MB/second hash performance each time
                function testSpeed(hashFn, N, M) {
                    let startMs = new Date().getTime();
                    const input = new Uint8Array(N);
                    for(let i = 0; i < N; i++)input[i] = i % 256;
                    const genMs = new Date().getTime();
                    console.log("Generated random input in " + (genMs - startMs) + "ms");
                    startMs = genMs;
                    for(let i = 0; i < M; i++){
                        const hashHex = hashFn(input);
                        const hashMs = new Date().getTime();
                        const ms = hashMs - startMs;
                        startMs = hashMs;
                        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
                        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
                    }
                }
                module1.exports = {
                    normalizeInput: normalizeInput,
                    toHex: toHex,
                    debugPrint: debugPrint,
                    testSpeed: testSpeed
                };
            /***/ },
            /***/ 8764: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var base64 = __webpack_require__(9742);
                var ieee754 = __webpack_require__(645);
                var customInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
                exports.Buffer = Buffer;
                exports.SlowBuffer = SlowBuffer;
                exports.INSPECT_MAX_BYTES = 50;
                var K_MAX_LENGTH = 0x7fffffff;
                exports.kMaxLength = K_MAX_LENGTH;
                /**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
                if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                function typedArraySupport() {
                    // Can typed array instances can be augmented?
                    try {
                        var arr = new Uint8Array(1);
                        var proto = {
                            foo: function() {
                                return 42;
                            }
                        };
                        Object.setPrototypeOf(proto, Uint8Array.prototype);
                        Object.setPrototypeOf(arr, proto);
                        return arr.foo() === 42;
                    } catch (e) {
                        return false;
                    }
                }
                Object.defineProperty(Buffer.prototype, "parent", {
                    enumerable: true,
                    get: function() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.buffer;
                    }
                });
                Object.defineProperty(Buffer.prototype, "offset", {
                    enumerable: true,
                    get: function() {
                        if (!Buffer.isBuffer(this)) return undefined;
                        return this.byteOffset;
                    }
                });
                function createBuffer(length) {
                    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
                    // Return an augmented `Uint8Array` instance
                    var buf = new Uint8Array(length);
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                /**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
                    // Common case.
                    if (typeof arg === "number") {
                        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                        return allocUnsafe(arg);
                    }
                    return from(arg, encodingOrOffset, length);
                }
                Buffer.poolSize = 8192 // not used by this implementation
                ;
                function from(value, encodingOrOffset, length) {
                    if (typeof value === "string") return fromString(value, encodingOrOffset);
                    if (ArrayBuffer.isView(value)) return fromArrayLike(value);
                    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
                    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                    var valueOf = value.valueOf && value.valueOf();
                    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
                    var b = fromObject(value);
                    if (b) return b;
                    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
                    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
                }
                /**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
                    return from(value, encodingOrOffset, length);
                };
                // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                // https://github.com/feross/buffer/pull/148
                Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                Object.setPrototypeOf(Buffer, Uint8Array);
                function assertSize(size) {
                    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
                    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
                }
                function alloc(size, fill, encoding) {
                    assertSize(size);
                    if (size <= 0) return createBuffer(size);
                    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
                    // prevents accidentally sending in a number that would
                    // be interpretted as a start offset.
                    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
                    return createBuffer(size);
                }
                /**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
                    return alloc(size, fill, encoding);
                };
                function allocUnsafe(size) {
                    assertSize(size);
                    return createBuffer(size < 0 ? 0 : checked(size) | 0);
                }
                /**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
                    return allocUnsafe(size);
                };
                /**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
                    return allocUnsafe(size);
                };
                function fromString(string, encoding) {
                    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
                    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                    var length = byteLength(string, encoding) | 0;
                    var buf = createBuffer(length);
                    var actual = buf.write(string, encoding);
                    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
                    // cause everything after the first invalid character to be ignored. (e.g.
                    // 'abxxcd' will be treated as 'ab')
                    buf = buf.slice(0, actual);
                    return buf;
                }
                function fromArrayLike(array) {
                    var length = array.length < 0 ? 0 : checked(array.length) | 0;
                    var buf = createBuffer(length);
                    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
                    return buf;
                }
                function fromArrayBuffer(array, byteOffset, length) {
                    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
                    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
                    var buf;
                    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
                    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
                    else buf = new Uint8Array(array, byteOffset, length);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(buf, Buffer.prototype);
                    return buf;
                }
                function fromObject(obj) {
                    if (Buffer.isBuffer(obj)) {
                        var len = checked(obj.length) | 0;
                        var buf = createBuffer(len);
                        if (buf.length === 0) return buf;
                        obj.copy(buf, 0, 0, len);
                        return buf;
                    }
                    if (obj.length !== undefined) {
                        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
                        return fromArrayLike(obj);
                    }
                    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
                }
                function checked(length) {
                    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                    // length is NaN (which is otherwise coerced to zero.)
                    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
                    return length | 0;
                }
                function SlowBuffer(length) {
                    if (+length != length) length = 0;
                    return Buffer.alloc(+length);
                }
                Buffer.isBuffer = function isBuffer(b) {
                    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
                    ;
                };
                Buffer.compare = function compare(a, b) {
                    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
                    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
                    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                    if (a === b) return 0;
                    var x = a.length;
                    var y = b.length;
                    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
                        x = a[i];
                        y = b[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                Buffer.isEncoding = function isEncoding(encoding) {
                    switch(String(encoding).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return true;
                        default:
                            return false;
                    }
                };
                Buffer.concat = function concat(list, length) {
                    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (list.length === 0) return Buffer.alloc(0);
                    var i;
                    if (length === undefined) {
                        length = 0;
                        for(i = 0; i < list.length; ++i)length += list[i].length;
                    }
                    var buffer = Buffer.allocUnsafe(length);
                    var pos = 0;
                    for(i = 0; i < list.length; ++i){
                        var buf = list[i];
                        if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
                        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
                        buf.copy(buffer, pos);
                        pos += buf.length;
                    }
                    return buffer;
                };
                function byteLength(string, encoding) {
                    if (Buffer.isBuffer(string)) return string.length;
                    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
                    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
                    var len = string.length;
                    var mustMatch = arguments.length > 2 && arguments[2] === true;
                    if (!mustMatch && len === 0) return 0;
                    // Use a for loop to avoid recursion
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return len;
                        case "utf8":
                        case "utf-8":
                            return utf8ToBytes(string).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return len * 2;
                        case "hex":
                            return len >>> 1;
                        case "base64":
                            return base64ToBytes(string).length;
                        default:
                            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                            ;
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                }
                Buffer.byteLength = byteLength;
                function slowToString(encoding, start, end) {
                    var loweredCase = false;
                    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                    // property of a typed array.
                    // This behaves neither like String nor Uint8Array in that we set start/end
                    // to their upper/lower bounds if the value passed is out of range.
                    // undefined is handled specially as per ECMA-262 6th Edition,
                    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                    if (start === undefined || start < 0) start = 0;
                    // Return early if start > this.length. Done here to prevent potential uint32
                    // coercion fail below.
                    if (start > this.length) return "";
                    if (end === undefined || end > this.length) end = this.length;
                    if (end <= 0) return "";
                    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
                    end >>>= 0;
                    start >>>= 0;
                    if (end <= start) return "";
                    if (!encoding) encoding = "utf8";
                    while(true)switch(encoding){
                        case "hex":
                            return hexSlice(this, start, end);
                        case "utf8":
                        case "utf-8":
                            return utf8Slice(this, start, end);
                        case "ascii":
                            return asciiSlice(this, start, end);
                        case "latin1":
                        case "binary":
                            return latin1Slice(this, start, end);
                        case "base64":
                            return base64Slice(this, start, end);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return utf16leSlice(this, start, end);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = (encoding + "").toLowerCase();
                            loweredCase = true;
                    }
                }
                // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                // reliably in a browserify context because there could be multiple different
                // copies of the 'buffer' package in use. This method works even for Buffer
                // instances that were created from another copy of the `buffer` package.
                // See: https://github.com/feross/buffer/issues/154
                Buffer.prototype._isBuffer = true;
                function swap(b, n, m) {
                    var i = b[n];
                    b[n] = b[m];
                    b[m] = i;
                }
                Buffer.prototype.swap16 = function swap16() {
                    var len = this.length;
                    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
                    return this;
                };
                Buffer.prototype.swap32 = function swap32() {
                    var len = this.length;
                    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var i = 0; i < len; i += 4){
                        swap(this, i, i + 3);
                        swap(this, i + 1, i + 2);
                    }
                    return this;
                };
                Buffer.prototype.swap64 = function swap64() {
                    var len = this.length;
                    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var i = 0; i < len; i += 8){
                        swap(this, i, i + 7);
                        swap(this, i + 1, i + 6);
                        swap(this, i + 2, i + 5);
                        swap(this, i + 3, i + 4);
                    }
                    return this;
                };
                Buffer.prototype.toString = function toString() {
                    var length = this.length;
                    if (length === 0) return "";
                    if (arguments.length === 0) return utf8Slice(this, 0, length);
                    return slowToString.apply(this, arguments);
                };
                Buffer.prototype.toLocaleString = Buffer.prototype.toString;
                Buffer.prototype.equals = function equals(b) {
                    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
                    if (this === b) return true;
                    return Buffer.compare(this, b) === 0;
                };
                Buffer.prototype.inspect = function inspect() {
                    var str = "";
                    var max = exports.INSPECT_MAX_BYTES;
                    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
                    if (this.length > max) str += " ... ";
                    return "<Buffer " + str + ">";
                };
                if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
                Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
                    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
                    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
                    if (start === undefined) start = 0;
                    if (end === undefined) end = target ? target.length : 0;
                    if (thisStart === undefined) thisStart = 0;
                    if (thisEnd === undefined) thisEnd = this.length;
                    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
                    if (thisStart >= thisEnd && start >= end) return 0;
                    if (thisStart >= thisEnd) return -1;
                    if (start >= end) return 1;
                    start >>>= 0;
                    end >>>= 0;
                    thisStart >>>= 0;
                    thisEnd >>>= 0;
                    if (this === target) return 0;
                    var x = thisEnd - thisStart;
                    var y = end - start;
                    var len = Math.min(x, y);
                    var thisCopy = this.slice(thisStart, thisEnd);
                    var targetCopy = target.slice(start, end);
                    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
                        x = thisCopy[i];
                        y = targetCopy[i];
                        break;
                    }
                    if (x < y) return -1;
                    if (y < x) return 1;
                    return 0;
                };
                // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                //
                // Arguments:
                // - buffer - a Buffer to search
                // - val - a string, Buffer, or number
                // - byteOffset - an index into `buffer`; will be clamped to an int32
                // - encoding - an optional encoding, relevant is val is a string
                // - dir - true for indexOf, false for lastIndexOf
                function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
                    // Empty buffer means no match
                    if (buffer.length === 0) return -1;
                    // Normalize byteOffset
                    if (typeof byteOffset === "string") {
                        encoding = byteOffset;
                        byteOffset = 0;
                    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
                    else if (byteOffset < -2147483648) byteOffset = -2147483648;
                    byteOffset = +byteOffset // Coerce to Number.
                    ;
                    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                    byteOffset = dir ? 0 : buffer.length - 1;
                    // Normalize byteOffset: negative offsets start from the end of the buffer
                    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                    if (byteOffset >= buffer.length) {
                        if (dir) return -1;
                        else byteOffset = buffer.length - 1;
                    } else if (byteOffset < 0) {
                        if (dir) byteOffset = 0;
                        else return -1;
                    }
                    // Normalize val
                    if (typeof val === "string") val = Buffer.from(val, encoding);
                    // Finally, search either indexOf (if dir is true) or lastIndexOf
                    if (Buffer.isBuffer(val)) {
                        // Special case: looking for empty string/buffer always fails
                        if (val.length === 0) return -1;
                        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                    } else if (typeof val === "number") {
                        val = val & 0xFF // Search for a byte value [0-255]
                        ;
                        if (typeof Uint8Array.prototype.indexOf === "function") {
                            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
                        }
                        return arrayIndexOf(buffer, [
                            val
                        ], byteOffset, encoding, dir);
                    }
                    throw new TypeError("val must be string, number or Buffer");
                }
                function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                    var indexSize = 1;
                    var arrLength = arr.length;
                    var valLength = val.length;
                    if (encoding !== undefined) {
                        encoding = String(encoding).toLowerCase();
                        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                            if (arr.length < 2 || val.length < 2) return -1;
                            indexSize = 2;
                            arrLength /= 2;
                            valLength /= 2;
                            byteOffset /= 2;
                        }
                    }
                    function read(buf, i) {
                        if (indexSize === 1) return buf[i];
                        else return buf.readUInt16BE(i * indexSize);
                    }
                    var i;
                    if (dir) {
                        var foundIndex = -1;
                        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                            if (foundIndex === -1) foundIndex = i;
                            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
                        } else {
                            if (foundIndex !== -1) i -= i - foundIndex;
                            foundIndex = -1;
                        }
                    } else {
                        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
                        for(i = byteOffset; i >= 0; i--){
                            var found = true;
                            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                                found = false;
                                break;
                            }
                            if (found) return i;
                        }
                    }
                    return -1;
                }
                Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
                    return this.indexOf(val, byteOffset, encoding) !== -1;
                };
                Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
                };
                Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
                    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
                };
                function hexWrite(buf, string, offset, length) {
                    offset = Number(offset) || 0;
                    var remaining = buf.length - offset;
                    if (!length) length = remaining;
                    else {
                        length = Number(length);
                        if (length > remaining) length = remaining;
                    }
                    var strLen = string.length;
                    if (length > strLen / 2) length = strLen / 2;
                    for(var i = 0; i < length; ++i){
                        var parsed = parseInt(string.substr(i * 2, 2), 16);
                        if (numberIsNaN(parsed)) return i;
                        buf[offset + i] = parsed;
                    }
                    return i;
                }
                function utf8Write(buf, string, offset, length) {
                    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
                }
                function asciiWrite(buf, string, offset, length) {
                    return blitBuffer(asciiToBytes(string), buf, offset, length);
                }
                function latin1Write(buf, string, offset, length) {
                    return asciiWrite(buf, string, offset, length);
                }
                function base64Write(buf, string, offset, length) {
                    return blitBuffer(base64ToBytes(string), buf, offset, length);
                }
                function ucs2Write(buf, string, offset, length) {
                    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
                }
                Buffer.prototype.write = function write(string, offset, length, encoding) {
                    // Buffer#write(string)
                    if (offset === undefined) {
                        encoding = "utf8";
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, encoding)
                    } else if (length === undefined && typeof offset === "string") {
                        encoding = offset;
                        length = this.length;
                        offset = 0;
                    // Buffer#write(string, offset[, length][, encoding])
                    } else if (isFinite(offset)) {
                        offset = offset >>> 0;
                        if (isFinite(length)) {
                            length = length >>> 0;
                            if (encoding === undefined) encoding = "utf8";
                        } else {
                            encoding = length;
                            length = undefined;
                        }
                    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                    var remaining = this.length - offset;
                    if (length === undefined || length > remaining) length = remaining;
                    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    if (!encoding) encoding = "utf8";
                    var loweredCase = false;
                    for(;;)switch(encoding){
                        case "hex":
                            return hexWrite(this, string, offset, length);
                        case "utf8":
                        case "utf-8":
                            return utf8Write(this, string, offset, length);
                        case "ascii":
                            return asciiWrite(this, string, offset, length);
                        case "latin1":
                        case "binary":
                            return latin1Write(this, string, offset, length);
                        case "base64":
                            // Warning: maxLength not taken into account in base64Write
                            return base64Write(this, string, offset, length);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return ucs2Write(this, string, offset, length);
                        default:
                            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                            encoding = ("" + encoding).toLowerCase();
                            loweredCase = true;
                    }
                };
                Buffer.prototype.toJSON = function toJSON() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                function base64Slice(buf, start, end) {
                    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
                    else return base64.fromByteArray(buf.slice(start, end));
                }
                function utf8Slice(buf, start, end) {
                    end = Math.min(buf.length, end);
                    var res = [];
                    var i = start;
                    while(i < end){
                        var firstByte = buf[i];
                        var codePoint = null;
                        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
                        if (i + bytesPerSequence <= end) {
                            var secondByte, thirdByte, fourthByte, tempCodePoint;
                            switch(bytesPerSequence){
                                case 1:
                                    if (firstByte < 0x80) codePoint = firstByte;
                                    break;
                                case 2:
                                    secondByte = buf[i + 1];
                                    if ((secondByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 3:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                                    }
                                    break;
                                case 4:
                                    secondByte = buf[i + 1];
                                    thirdByte = buf[i + 2];
                                    fourthByte = buf[i + 3];
                                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                                    }
                            }
                        }
                        if (codePoint === null) {
                            // we did not generate a valid codePoint so insert a
                            // replacement char (U+FFFD) and advance only 1 byte
                            codePoint = 0xFFFD;
                            bytesPerSequence = 1;
                        } else if (codePoint > 0xFFFF) {
                            // encode to utf16 (surrogate pair dance)
                            codePoint -= 0x10000;
                            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                            codePoint = 0xDC00 | codePoint & 0x3FF;
                        }
                        res.push(codePoint);
                        i += bytesPerSequence;
                    }
                    return decodeCodePointsArray(res);
                }
                // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                // the lowest limit is Chrome, with 0x10000 args.
                // We go 1 magnitude less, for safety
                var MAX_ARGUMENTS_LENGTH = 0x1000;
                function decodeCodePointsArray(codePoints) {
                    var len = codePoints.length;
                    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
                    ;
                    // Decode in chunks to avoid "call stack size exceeded".
                    var res = "";
                    var i = 0;
                    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
                    return res;
                }
                function asciiSlice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
                    return ret;
                }
                function latin1Slice(buf, start, end) {
                    var ret = "";
                    end = Math.min(buf.length, end);
                    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
                    return ret;
                }
                function hexSlice(buf, start, end) {
                    var len = buf.length;
                    if (!start || start < 0) start = 0;
                    if (!end || end < 0 || end > len) end = len;
                    var out = "";
                    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
                    return out;
                }
                function utf16leSlice(buf, start, end) {
                    var bytes = buf.slice(start, end);
                    var res = "";
                    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                    return res;
                }
                Buffer.prototype.slice = function slice(start, end) {
                    var len = this.length;
                    start = ~~start;
                    end = end === undefined ? len : ~~end;
                    if (start < 0) {
                        start += len;
                        if (start < 0) start = 0;
                    } else if (start > len) start = len;
                    if (end < 0) {
                        end += len;
                        if (end < 0) end = 0;
                    } else if (end > len) end = len;
                    if (end < start) end = start;
                    var newBuf = this.subarray(start, end);
                    // Return an augmented `Uint8Array` instance
                    Object.setPrototypeOf(newBuf, Buffer.prototype);
                    return newBuf;
                };
                /*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
                    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
                    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
                }
                Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    return val;
                };
                Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset + --byteLength];
                    var mul = 1;
                    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
                    return val;
                };
                Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    return this[offset];
                };
                Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] | this[offset + 1] << 8;
                };
                Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] << 8 | this[offset + 1];
                };
                Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
                };
                Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
                };
                Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
                    var i = byteLength;
                    var mul = 1;
                    var val = this[offset + --i];
                    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
                    mul *= 0x80;
                    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
                    return val;
                };
                Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    if (!(this[offset] & 0x80)) return this[offset];
                    return (0xff - this[offset] + 1) * -1;
                };
                Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset] | this[offset + 1] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    var val = this[offset + 1] | this[offset] << 8;
                    return val & 0x8000 ? val | 0xFFFF0000 : val;
                };
                Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
                };
                Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
                };
                Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, true, 23, 4);
                };
                Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
                    return ieee754.read(this, offset, false, 23, 4);
                };
                Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, true, 52, 8);
                };
                Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 8, this.length);
                    return ieee754.read(this, offset, false, 52, 8);
                };
                function checkInt(buf, value, offset, ext, max, min) {
                    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                }
                Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var mul = 1;
                    var i = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                        checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
                    return offset + byteLength;
                };
                Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset + 3] = value >>> 24;
                    this[offset + 2] = value >>> 16;
                    this[offset + 1] = value >>> 8;
                    this[offset] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = 0;
                    var mul = 1;
                    var sub = 0;
                    this[offset] = value & 0xFF;
                    while(++i < byteLength && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) {
                        var limit = Math.pow(2, 8 * byteLength - 1);
                        checkInt(this, value, offset, byteLength, limit - 1, -limit);
                    }
                    var i = byteLength - 1;
                    var mul = 1;
                    var sub = 0;
                    this[offset + i] = value & 0xFF;
                    while(--i >= 0 && (mul *= 0x100)){
                        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
                        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
                    }
                    return offset + byteLength;
                };
                Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
                    if (value < 0) value = 0xff + value + 1;
                    this[offset] = value & 0xff;
                    return offset + 1;
                };
                Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                };
                Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                };
                Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    this[offset + 2] = value >>> 16;
                    this[offset + 3] = value >>> 24;
                    return offset + 4;
                };
                Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
                    if (value < 0) value = 0xffffffff + value + 1;
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                };
                function checkIEEE754(buf, value, offset, ext, max, min) {
                    if (offset + ext > buf.length) throw new RangeError("Index out of range");
                    if (offset < 0) throw new RangeError("Index out of range");
                }
                function writeFloat(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 23, 4);
                    return offset + 4;
                }
                Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
                    return writeFloat(this, value, offset, false, noAssert);
                };
                function writeDouble(buf, value, offset, littleEndian, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
                    ieee754.write(buf, value, offset, littleEndian, 52, 8);
                    return offset + 8;
                }
                Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, true, noAssert);
                };
                Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
                    return writeDouble(this, value, offset, false, noAssert);
                };
                // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                Buffer.prototype.copy = function copy(target, targetStart, start, end) {
                    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
                    if (!start) start = 0;
                    if (!end && end !== 0) end = this.length;
                    if (targetStart >= target.length) targetStart = target.length;
                    if (!targetStart) targetStart = 0;
                    if (end > 0 && end < start) end = start;
                    // Copy 0 bytes; we're done
                    if (end === start) return 0;
                    if (target.length === 0 || this.length === 0) return 0;
                    // Fatal error conditions
                    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
                    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
                    if (end < 0) throw new RangeError("sourceEnd out of bounds");
                    // Are we oob?
                    if (end > this.length) end = this.length;
                    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
                    var len = end - start;
                    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
                    this.copyWithin(targetStart, start, end);
                    else if (this === target && start < targetStart && targetStart < end) // descending copy from end
                    for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
                    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
                    return len;
                };
                // Usage:
                //    buffer.fill(number[, offset[, end]])
                //    buffer.fill(buffer[, offset[, end]])
                //    buffer.fill(string[, offset[, end]][, encoding])
                Buffer.prototype.fill = function fill(val, start, end, encoding) {
                    // Handle string cases:
                    if (typeof val === "string") {
                        if (typeof start === "string") {
                            encoding = start;
                            start = 0;
                            end = this.length;
                        } else if (typeof end === "string") {
                            encoding = end;
                            end = this.length;
                        }
                        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
                        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
                        if (val.length === 1) {
                            var code = val.charCodeAt(0);
                            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                            val = code;
                        }
                    } else if (typeof val === "number") val = val & 255;
                    else if (typeof val === "boolean") val = Number(val);
                    // Invalid ranges are not set to a default, so can range check early.
                    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
                    if (end <= start) return this;
                    start = start >>> 0;
                    end = end === undefined ? this.length : end >>> 0;
                    if (!val) val = 0;
                    var i;
                    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
                    else {
                        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
                        var len = bytes.length;
                        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
                        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
                    }
                    return this;
                };
                // HELPER FUNCTIONS
                // ================
                var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
                function base64clean(str) {
                    // Node takes equal signs as end of the Base64 encoding
                    str = str.split("=")[0];
                    // Node strips out invalid characters like \n and \t from the string, base64-js does not
                    str = str.trim().replace(INVALID_BASE64_RE, "");
                    // Node converts strings with length < 2 to ''
                    if (str.length < 2) return "";
                    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                    while(str.length % 4 !== 0)str = str + "=";
                    return str;
                }
                function utf8ToBytes(string, units) {
                    units = units || Infinity;
                    var codePoint;
                    var length = string.length;
                    var leadSurrogate = null;
                    var bytes = [];
                    for(var i = 0; i < length; ++i){
                        codePoint = string.charCodeAt(i);
                        // is surrogate component
                        if (codePoint > 0xD7FF && codePoint < 0xE000) {
                            // last char was a lead
                            if (!leadSurrogate) {
                                // no lead yet
                                if (codePoint > 0xDBFF) {
                                    // unexpected trail
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                } else if (i + 1 === length) {
                                    // unpaired lead
                                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                    continue;
                                }
                                // valid lead
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // 2 leads in a row
                            if (codePoint < 0xDC00) {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                leadSurrogate = codePoint;
                                continue;
                            }
                            // valid surrogate pair
                            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
                        } else if (leadSurrogate) // valid bmp char, but last char was a lead
                        {
                            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        }
                        leadSurrogate = null;
                        // encode utf8
                        if (codePoint < 0x80) {
                            if ((units -= 1) < 0) break;
                            bytes.push(codePoint);
                        } else if (codePoint < 0x800) {
                            if ((units -= 2) < 0) break;
                            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x10000) {
                            if ((units -= 3) < 0) break;
                            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else if (codePoint < 0x110000) {
                            if ((units -= 4) < 0) break;
                            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                        } else throw new Error("Invalid code point");
                    }
                    return bytes;
                }
                function asciiToBytes(str) {
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
                    byteArray.push(str.charCodeAt(i) & 0xFF);
                    return byteArray;
                }
                function utf16leToBytes(str, units) {
                    var c, hi, lo;
                    var byteArray = [];
                    for(var i = 0; i < str.length; ++i){
                        if ((units -= 2) < 0) break;
                        c = str.charCodeAt(i);
                        hi = c >> 8;
                        lo = c % 256;
                        byteArray.push(lo);
                        byteArray.push(hi);
                    }
                    return byteArray;
                }
                function base64ToBytes(str) {
                    return base64.toByteArray(base64clean(str));
                }
                function blitBuffer(src, dst, offset, length) {
                    for(var i = 0; i < length; ++i){
                        if (i + offset >= dst.length || i >= src.length) break;
                        dst[i + offset] = src[i];
                    }
                    return i;
                }
                // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                // the `instanceof` check but they should be treated as of that type.
                // See: https://github.com/feross/buffer/issues/166
                function isInstance(obj, type) {
                    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
                }
                function numberIsNaN(obj) {
                    // For IE11 support
                    return obj !== obj // eslint-disable-line no-self-compare
                    ;
                }
                // Create lookup table for `toString('hex')`
                // See: https://github.com/feross/buffer/issues/219
                var hexSliceLookupTable = function() {
                    var alphabet = "0123456789abcdef";
                    var table = new Array(256);
                    for(var i = 0; i < 16; ++i){
                        var i16 = i * 16;
                        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
                    }
                    return table;
                }();
            /***/ },
            /***/ 645: /***/ (__unused_webpack_module, exports)=>{
                exports.read = function(buffer, offset, isLE, mLen, nBytes) {
                    var e, m;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var nBits = -7;
                    var i = isLE ? nBytes - 1 : 0;
                    var d = isLE ? -1 : 1;
                    var s = buffer[offset + i];
                    i += d;
                    e = s & (1 << -nBits) - 1;
                    s >>= -nBits;
                    nBits += eLen;
                    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
                    m = e & (1 << -nBits) - 1;
                    e >>= -nBits;
                    nBits += mLen;
                    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
                    if (e === 0) e = 1 - eBias;
                    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
                    else {
                        m = m + Math.pow(2, mLen);
                        e = e - eBias;
                    }
                    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
                };
                exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
                    var e, m, c;
                    var eLen = nBytes * 8 - mLen - 1;
                    var eMax = (1 << eLen) - 1;
                    var eBias = eMax >> 1;
                    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
                    var i = isLE ? 0 : nBytes - 1;
                    var d = isLE ? 1 : -1;
                    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                    value = Math.abs(value);
                    if (isNaN(value) || value === Infinity) {
                        m = isNaN(value) ? 1 : 0;
                        e = eMax;
                    } else {
                        e = Math.floor(Math.log(value) / Math.LN2);
                        if (value * (c = Math.pow(2, -e)) < 1) {
                            e--;
                            c *= 2;
                        }
                        if (e + eBias >= 1) value += rt / c;
                        else value += rt * Math.pow(2, 1 - eBias);
                        if (value * c >= 2) {
                            e++;
                            c /= 2;
                        }
                        if (e + eBias >= eMax) {
                            m = 0;
                            e = eMax;
                        } else if (e + eBias >= 1) {
                            m = (value * c - 1) * Math.pow(2, mLen);
                            e = e + eBias;
                        } else {
                            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                            e = 0;
                        }
                    }
                    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
                    e = e << mLen | m;
                    eLen += mLen;
                    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
                    buffer[offset + i - d] |= s * 128;
                };
            /***/ },
            /***/ 2587: /***/ (module1)=>{
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                // If obj.hasOwnProperty has been overridden, then calling
                // obj.hasOwnProperty(prop) will break.
                // See: https://github.com/joyent/node/issues/1707
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                module1.exports = function(qs, sep, eq, options) {
                    sep = sep || "&";
                    eq = eq || "=";
                    var obj = {};
                    if (typeof qs !== "string" || qs.length === 0) return obj;
                    var regexp = /\+/g;
                    qs = qs.split(sep);
                    var maxKeys = 1000;
                    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
                    var len = qs.length;
                    // maxKeys <= 0 means that we should not limit keys count
                    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                    for(var i = 0; i < len; ++i){
                        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
                        if (idx >= 0) {
                            kstr = x.substr(0, idx);
                            vstr = x.substr(idx + 1);
                        } else {
                            kstr = x;
                            vstr = "";
                        }
                        k = decodeURIComponent(kstr);
                        v = decodeURIComponent(vstr);
                        if (!hasOwnProperty(obj, k)) obj[k] = v;
                        else if (Array.isArray(obj[k])) obj[k].push(v);
                        else obj[k] = [
                            obj[k],
                            v
                        ];
                    }
                    return obj;
                };
            /***/ },
            /***/ 2361: /***/ (module1)=>{
                "use strict";
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var stringifyPrimitive = function(v) {
                    switch(typeof v){
                        case "string":
                            return v;
                        case "boolean":
                            return v ? "true" : "false";
                        case "number":
                            return isFinite(v) ? v : "";
                        default:
                            return "";
                    }
                };
                module1.exports = function(obj, sep, eq, name1) {
                    sep = sep || "&";
                    eq = eq || "=";
                    if (obj === null) obj = undefined;
                    if (typeof obj === "object") return Object.keys(obj).map(function(k) {
                        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                        if (Array.isArray(obj[k])) return obj[k].map(function(v) {
                            return ks + encodeURIComponent(stringifyPrimitive(v));
                        }).join(sep);
                        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                    }).join(sep);
                    if (!name1) return "";
                    return encodeURIComponent(stringifyPrimitive(name1)) + eq + encodeURIComponent(stringifyPrimitive(obj));
                };
            /***/ },
            /***/ 7673: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                exports.decode = exports.parse = __webpack_require__(2587);
                exports.encode = exports.stringify = __webpack_require__(2361);
            /***/ },
            /***/ 1798: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                // limit of Crypto.getRandomValues()
                // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
                var MAX_BYTES = 65536;
                // Node supports requesting up to this number of bytes
                // https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
                var MAX_UINT32 = 4294967295;
                function oldBrowser() {
                    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                }
                var Buffer = __webpack_require__(9509).Buffer;
                var crypto1 = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto;
                if (crypto1 && crypto1.getRandomValues) module1.exports = randomBytes;
                else module1.exports = oldBrowser;
                function randomBytes(size, cb) {
                    // phantomjs needs to throw
                    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
                    var bytes = Buffer.allocUnsafe(size);
                    if (size > 0) {
                        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
                        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
                        // the buffer so we don't have to here
                        crypto1.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
                        else crypto1.getRandomValues(bytes);
                    }
                    if (typeof cb === "function") return process.nextTick(function() {
                        cb(null, bytes);
                    });
                    return bytes;
                }
            /***/ },
            /***/ 9509: /***/ (module1, exports, __webpack_require__)=>{
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = __webpack_require__(8764);
                var Buffer = buffer.Buffer;
                // alternative to using Object.keys for old browsers
                function copyProps(src, dst) {
                    for(var key in src)dst[key] = src[key];
                }
                if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module1.exports = buffer;
                else {
                    // Copy properties from require('buffer')
                    copyProps(buffer, exports);
                    exports.Buffer = SafeBuffer;
                }
                function SafeBuffer(arg, encodingOrOffset, length) {
                    return Buffer(arg, encodingOrOffset, length);
                }
                SafeBuffer.prototype = Object.create(Buffer.prototype);
                // Copy static methods from Buffer
                copyProps(Buffer, SafeBuffer);
                SafeBuffer.from = function(arg, encodingOrOffset, length) {
                    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
                    return Buffer(arg, encodingOrOffset, length);
                };
                SafeBuffer.alloc = function(size, fill, encoding) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    var buf = Buffer(size);
                    if (fill !== undefined) {
                        if (typeof encoding === "string") buf.fill(fill, encoding);
                        else buf.fill(fill);
                    } else buf.fill(0);
                    return buf;
                };
                SafeBuffer.allocUnsafe = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return Buffer(size);
                };
                SafeBuffer.allocUnsafeSlow = function(size) {
                    if (typeof size !== "number") throw new TypeError("Argument must be a number");
                    return buffer.SlowBuffer(size);
                };
            /***/ },
            /***/ 2511: /***/ function(module1, exports, __webpack_require__) {
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                var __WEBPACK_AMD_DEFINE_RESULT__; /*! https://mths.be/punycode v1.3.2 by @mathias */ 
                (function(root) {
                    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
                    var freeModule = module1 && !module1.nodeType && module1;
                    var freeGlobal = typeof __webpack_require__.g == "object" && __webpack_require__.g;
                    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
                    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
                        "overflow": "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
                    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
                        throw RangeError(errors[type]);
                    }
                    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
                        var length = array.length;
                        var result = [];
                        while(length--)result[length] = fn(array[length]);
                        return result;
                    }
                    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
                        var parts = string.split("@");
                        var result = "";
                        if (parts.length > 1) {
                            // In email addresses, only the domain name should be punycoded. Leave
                            // the local part (i.e. everything up to `@`) intact.
                            result = parts[0] + "@";
                            string = parts[1];
                        }
                        // Avoid `split(regex)` for IE8 compatibility. See #17.
                        string = string.replace(regexSeparators, ".");
                        var labels = string.split(".");
                        var encoded = map(labels, fn).join(".");
                        return result + encoded;
                    }
                    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
                        var output = [], counter = 0, length = string.length, value, extra;
                        while(counter < length){
                            value = string.charCodeAt(counter++);
                            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                // high surrogate, and there is a next character
                                extra = string.charCodeAt(counter++);
                                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                else {
                                    // unmatched surrogate; only append this code unit, in case the next
                                    // code unit is the high surrogate of a surrogate pair
                                    output.push(value);
                                    counter--;
                                }
                            } else output.push(value);
                        }
                        return output;
                    }
                    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
                        return map(array, function(value) {
                            var output = "";
                            if (value > 0xFFFF) {
                                value -= 0x10000;
                                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                value = 0xDC00 | value & 0x3FF;
                            }
                            output += stringFromCharCode(value);
                            return output;
                        }).join("");
                    }
                    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
                        if (codePoint - 48 < 10) return codePoint - 22;
                        if (codePoint - 65 < 26) return codePoint - 65;
                        if (codePoint - 97 < 26) return codePoint - 97;
                        return base;
                    }
                    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
                        //  0..25 map to ASCII a..z or A..Z
                        // 26..35 map to ASCII 0..9
                        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                    }
                    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
                        var k = 0;
                        delta = firstTime ? floor(delta / damp) : delta >> 1;
                        delta += floor(delta / numPoints);
                        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                    }
                    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
                        // Don't use UCS-2
                        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
                        // Handle the basic code points: let `basic` be the number of input code
                        // points before the last delimiter, or `0` if there is none, then copy
                        // the first basic code points to the output.
                        basic = input.lastIndexOf(delimiter);
                        if (basic < 0) basic = 0;
                        for(j = 0; j < basic; ++j){
                            // if it's not a basic code point
                            if (input.charCodeAt(j) >= 0x80) error("not-basic");
                            output.push(input.charCodeAt(j));
                        }
                        // Main decoding loop: start just after the last delimiter if any basic code
                        // points were copied; start at the beginning otherwise.
                        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                            // `index` is the index of the next character to be consumed.
                            // Decode a generalized variable-length integer into `delta`,
                            // which gets added to `i`. The overflow checking is easier
                            // if we increase `i` as we go, then subtract off its starting
                            // value at the end to obtain `delta`.
                            for(oldi = i, w = 1, k = base;; k += base){
                                if (index >= inputLength) error("invalid-input");
                                digit = basicToDigit(input.charCodeAt(index++));
                                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                                i += digit * w;
                                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                if (digit < t) break;
                                baseMinusT = base - t;
                                if (w > floor(maxInt / baseMinusT)) error("overflow");
                                w *= baseMinusT;
                            }
                            out = output.length + 1;
                            bias = adapt(i - oldi, out, oldi == 0);
                            // `i` was supposed to wrap around from `out` to `0`,
                            // incrementing `n` each time, so we'll fix that now:
                            if (floor(i / out) > maxInt - n) error("overflow");
                            n += floor(i / out);
                            i %= out;
                            // Insert `n` at position `i` of the output
                            output.splice(i++, 0, n);
                        }
                        return ucs2encode(output);
                    }
                    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
                        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
                        // Convert the input in UCS-2 to Unicode
                        input = ucs2decode(input);
                        // Cache the length
                        inputLength = input.length;
                        // Initialize the state
                        n = initialN;
                        delta = 0;
                        bias = initialBias;
                        // Handle the basic code points
                        for(j = 0; j < inputLength; ++j){
                            currentValue = input[j];
                            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                        }
                        handledCPCount = basicLength = output.length;
                        // `handledCPCount` is the number of code points that have been handled;
                        // `basicLength` is the number of basic code points.
                        // Finish the basic string - if it is not empty - with a delimiter
                        if (basicLength) output.push(delimiter);
                        // Main encoding loop:
                        while(handledCPCount < inputLength){
                            // All non-basic code points < n have been handled already. Find the next
                            // larger one:
                            for(m = maxInt, j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue >= n && currentValue < m) m = currentValue;
                            }
                            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                            // but guard against overflow
                            handledCPCountPlusOne = handledCPCount + 1;
                            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
                            delta += (m - n) * handledCPCountPlusOne;
                            n = m;
                            for(j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue < n && ++delta > maxInt) error("overflow");
                                if (currentValue == n) {
                                    // Represent delta as a generalized variable-length integer
                                    for(q = delta, k = base;; k += base){
                                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                        if (q < t) break;
                                        qMinusT = q - t;
                                        baseMinusT = base - t;
                                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                        q = floor(qMinusT / baseMinusT);
                                    }
                                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                    delta = 0;
                                    ++handledCPCount;
                                }
                            }
                            ++delta;
                            ++n;
                        }
                        return output.join("");
                    }
                    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
                        return mapDomain(input, function(string) {
                            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                        });
                    }
                    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
                        return mapDomain(input, function(string) {
                            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
                        });
                    }
                    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
                        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
                        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
                            "decode": ucs2decode,
                            "encode": ucs2encode
                        },
                        "decode": decode,
                        "encode": encode,
                        "toASCII": toASCII,
                        "toUnicode": toUnicode
                    };
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return punycode;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 8575: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                var __webpack_unused_export__;
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var punycode = __webpack_require__(2511);
                var util = __webpack_require__(2502);
                __webpack_unused_export__ = urlParse;
                exports.DB = urlResolve;
                __webpack_unused_export__ = urlResolveObject;
                __webpack_unused_export__ = urlFormat;
                __webpack_unused_export__ = Url;
                function Url() {
                    this.protocol = null;
                    this.slashes = null;
                    this.auth = null;
                    this.host = null;
                    this.port = null;
                    this.hostname = null;
                    this.hash = null;
                    this.search = null;
                    this.query = null;
                    this.pathname = null;
                    this.path = null;
                    this.href = null;
                }
                // Reference: RFC 3986, RFC 1808, RFC 2396
                // define these here so at least they only have to be
                // compiled once on the first module load.
                var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
                simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
                // We actually just auto-escape these.
                delims = [
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "	"
                ], // RFC 2396: characters not allowed for various reasons.
                unwise = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
                autoEscape = [
                    "'"
                ].concat(unwise), // Characters that are never ever allowed in a hostname.
                // Note that any invalid chars are also handled, but these
                // are the ones that are *expected* to be seen, so we fast-path
                // them.
                nonHostChars = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(autoEscape), hostEndingChars = [
                    "/",
                    "?",
                    "#"
                ], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
                unsafeProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that never have a hostname.
                hostlessProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that always contain a // bit.
                slashedProtocol = {
                    "http": true,
                    "https": true,
                    "ftp": true,
                    "gopher": true,
                    "file": true,
                    "http:": true,
                    "https:": true,
                    "ftp:": true,
                    "gopher:": true,
                    "file:": true
                }, querystring = __webpack_require__(7673);
                function urlParse(url, parseQueryString, slashesDenoteHost) {
                    if (url && util.isObject(url) && url instanceof Url) return url;
                    var u = new Url;
                    u.parse(url, parseQueryString, slashesDenoteHost);
                    return u;
                }
                Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                    if (!util.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                    // Copy chrome, IE, opera backslash-handling behavior.
                    // Back slashes before the query string get converted to forward slashes
                    // See: https://code.google.com/p/chromium/issues/detail?id=25916
                    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
                    uSplit[0] = uSplit[0].replace(slashRegex, "/");
                    url = uSplit.join(splitter);
                    var rest = url;
                    // trim before proceeding.
                    // This is to support parse stuff like "  http://foo.com  \n"
                    rest = rest.trim();
                    if (!slashesDenoteHost && url.split("#").length === 1) {
                        // Try fast path regexp
                        var simplePath = simplePathPattern.exec(rest);
                        if (simplePath) {
                            this.path = rest;
                            this.href = rest;
                            this.pathname = simplePath[1];
                            if (simplePath[2]) {
                                this.search = simplePath[2];
                                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                                else this.query = this.search.substr(1);
                            } else if (parseQueryString) {
                                this.search = "";
                                this.query = {};
                            }
                            return this;
                        }
                    }
                    var proto = protocolPattern.exec(rest);
                    if (proto) {
                        proto = proto[0];
                        var lowerProto = proto.toLowerCase();
                        this.protocol = lowerProto;
                        rest = rest.substr(proto.length);
                    }
                    // figure out if it's got a host
                    // user@server is *always* interpreted as a hostname, and url
                    // resolution will treat //foo/bar as host=foo,path=bar because that's
                    // how the browser resolves relative URLs.
                    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                        var slashes = rest.substr(0, 2) === "//";
                        if (slashes && !(proto && hostlessProtocol[proto])) {
                            rest = rest.substr(2);
                            this.slashes = true;
                        }
                    }
                    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                        // there's a hostname.
                        // the first instance of /, ?, ;, or # ends the host.
                        //
                        // If there is an @ in the hostname, then non-host chars *are* allowed
                        // to the left of the last @ sign, unless some host-ending character
                        // comes *before* the @-sign.
                        // URLs are obnoxious.
                        //
                        // ex:
                        // http://a@b@c/ => user:a@b host:c
                        // http://a@b?@c => user:a host:c path:/?@c
                        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
                        // Review our test case against browsers more comprehensively.
                        // find the first instance of any hostEndingChars
                        var hostEnd = -1;
                        for(var i = 0; i < hostEndingChars.length; i++){
                            var hec = rest.indexOf(hostEndingChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // at this point, either we have an explicit point where the
                        // auth portion cannot go past, or the last @ char is the decider.
                        var auth, atSign;
                        if (hostEnd === -1) // atSign can be anywhere.
                        atSign = rest.lastIndexOf("@");
                        else // atSign must be in auth portion.
                        // http://a@b/c@d => host:b auth:a path:/c@d
                        atSign = rest.lastIndexOf("@", hostEnd);
                        // Now we have a portion which is definitely the auth.
                        // Pull that off.
                        if (atSign !== -1) {
                            auth = rest.slice(0, atSign);
                            rest = rest.slice(atSign + 1);
                            this.auth = decodeURIComponent(auth);
                        }
                        // the host is the remaining to the left of the first non-host char
                        hostEnd = -1;
                        for(var i = 0; i < nonHostChars.length; i++){
                            var hec = rest.indexOf(nonHostChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // if we still have not hit it, then the entire thing is a host.
                        if (hostEnd === -1) hostEnd = rest.length;
                        this.host = rest.slice(0, hostEnd);
                        rest = rest.slice(hostEnd);
                        // pull out port.
                        this.parseHost();
                        // we've indicated that there is a hostname,
                        // so even if it's empty, it has to be present.
                        this.hostname = this.hostname || "";
                        // if hostname begins with [ and ends with ]
                        // assume that it's an IPv6 address.
                        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
                        // validate a little.
                        if (!ipv6Hostname) {
                            var hostparts = this.hostname.split(/\./);
                            for(var i = 0, l = hostparts.length; i < l; i++){
                                var part = hostparts[i];
                                if (!part) continue;
                                if (!part.match(hostnamePartPattern)) {
                                    var newpart = "";
                                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                                    // we need this to make sure size of hostname is not
                                    // broken by replacing non-ASCII by nothing
                                    newpart += "x";
                                    else newpart += part[j];
                                    // we test again with ASCII char only
                                    if (!newpart.match(hostnamePartPattern)) {
                                        var validParts = hostparts.slice(0, i);
                                        var notHost = hostparts.slice(i + 1);
                                        var bit = part.match(hostnamePartStart);
                                        if (bit) {
                                            validParts.push(bit[1]);
                                            notHost.unshift(bit[2]);
                                        }
                                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                                        this.hostname = validParts.join(".");
                                        break;
                                    }
                                }
                            }
                        }
                        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
                        else // hostnames are always lower case.
                        this.hostname = this.hostname.toLowerCase();
                        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
                        // It only converts parts of the domain name that
                        // have non-ASCII characters, i.e. it doesn't matter if
                        // you call it with a domain that already is ASCII-only.
                        this.hostname = punycode.toASCII(this.hostname);
                        var p = this.port ? ":" + this.port : "";
                        var h = this.hostname || "";
                        this.host = h + p;
                        this.href += this.host;
                        // strip [ and ] from the hostname
                        // the host field still retains them, though
                        if (ipv6Hostname) {
                            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                            if (rest[0] !== "/") rest = "/" + rest;
                        }
                    }
                    // now rest is set to the post-host stuff.
                    // chop off any delim chars.
                    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
                    // escaped, even if encodeURIComponent doesn't think they
                    // need to be.
                    for(var i = 0, l = autoEscape.length; i < l; i++){
                        var ae = autoEscape[i];
                        if (rest.indexOf(ae) === -1) continue;
                        var esc = encodeURIComponent(ae);
                        if (esc === ae) esc = escape(ae);
                        rest = rest.split(ae).join(esc);
                    }
                    // chop off from the tail first.
                    var hash = rest.indexOf("#");
                    if (hash !== -1) {
                        // got a fragment string.
                        this.hash = rest.substr(hash);
                        rest = rest.slice(0, hash);
                    }
                    var qm = rest.indexOf("?");
                    if (qm !== -1) {
                        this.search = rest.substr(qm);
                        this.query = rest.substr(qm + 1);
                        if (parseQueryString) this.query = querystring.parse(this.query);
                        rest = rest.slice(0, qm);
                    } else if (parseQueryString) {
                        // no query string, but parseQueryString still requested
                        this.search = "";
                        this.query = {};
                    }
                    if (rest) this.pathname = rest;
                    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
                    //to support http.request
                    if (this.pathname || this.search) {
                        var p = this.pathname || "";
                        var s = this.search || "";
                        this.path = p + s;
                    }
                    // finally, reconstruct the href based on what has been validated.
                    this.href = this.format();
                    return this;
                };
                // format a parsed object into a url string
                function urlFormat(obj) {
                    // ensure it's an object, and not a string url.
                    // If it's an obj, this is a no-op.
                    // this way, you can call url_format() on strings
                    // to clean up potentially wonky urls.
                    if (util.isString(obj)) obj = urlParse(obj);
                    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                    return obj.format();
                }
                Url.prototype.format = function() {
                    var auth = this.auth || "";
                    if (auth) {
                        auth = encodeURIComponent(auth);
                        auth = auth.replace(/%3A/i, ":");
                        auth += "@";
                    }
                    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
                    if (this.host) host = auth + this.host;
                    else if (this.hostname) {
                        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
                        if (this.port) host += ":" + this.port;
                    }
                    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                    var search = this.search || query && "?" + query || "";
                    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
                    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                    // unless they had them to begin with.
                    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                        host = "//" + (host || "");
                        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
                    } else if (!host) host = "";
                    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
                    if (search && search.charAt(0) !== "?") search = "?" + search;
                    pathname = pathname.replace(/[?#]/g, function(match) {
                        return encodeURIComponent(match);
                    });
                    search = search.replace("#", "%23");
                    return protocol + host + pathname + search + hash;
                };
                function urlResolve(source, relative) {
                    return urlParse(source, false, true).resolve(relative);
                }
                Url.prototype.resolve = function(relative) {
                    return this.resolveObject(urlParse(relative, false, true)).format();
                };
                function urlResolveObject(source, relative) {
                    if (!source) return relative;
                    return urlParse(source, false, true).resolveObject(relative);
                }
                Url.prototype.resolveObject = function(relative) {
                    if (util.isString(relative)) {
                        var rel = new Url();
                        rel.parse(relative, false, true);
                        relative = rel;
                    }
                    var result = new Url();
                    var tkeys = Object.keys(this);
                    for(var tk = 0; tk < tkeys.length; tk++){
                        var tkey = tkeys[tk];
                        result[tkey] = this[tkey];
                    }
                    // hash is always overridden, no matter what.
                    // even href="" will remove it.
                    result.hash = relative.hash;
                    // if the relative url is empty, then there's nothing left to do here.
                    if (relative.href === "") {
                        result.href = result.format();
                        return result;
                    }
                    // hrefs like //foo/bar always cut to the protocol.
                    if (relative.slashes && !relative.protocol) {
                        // take everything except the protocol from relative
                        var rkeys = Object.keys(relative);
                        for(var rk = 0; rk < rkeys.length; rk++){
                            var rkey = rkeys[rk];
                            if (rkey !== "protocol") result[rkey] = relative[rkey];
                        }
                        //urlParse appends trailing / to urls like http://www.example.com
                        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
                        result.href = result.format();
                        return result;
                    }
                    if (relative.protocol && relative.protocol !== result.protocol) {
                        // if it's a known url protocol, then changing
                        // the protocol does weird things
                        // first, if it's not file:, then we MUST have a host,
                        // and if there was a path
                        // to begin with, then we MUST have a path.
                        // if it is file:, then the host is dropped,
                        // because that's known to be hostless.
                        // anything else is assumed to be absolute.
                        if (!slashedProtocol[relative.protocol]) {
                            var keys = Object.keys(relative);
                            for(var v = 0; v < keys.length; v++){
                                var k = keys[v];
                                result[k] = relative[k];
                            }
                            result.href = result.format();
                            return result;
                        }
                        result.protocol = relative.protocol;
                        if (!relative.host && !hostlessProtocol[relative.protocol]) {
                            var relPath = (relative.pathname || "").split("/");
                            while(relPath.length && !(relative.host = relPath.shift()));
                            if (!relative.host) relative.host = "";
                            if (!relative.hostname) relative.hostname = "";
                            if (relPath[0] !== "") relPath.unshift("");
                            if (relPath.length < 2) relPath.unshift("");
                            result.pathname = relPath.join("/");
                        } else result.pathname = relative.pathname;
                        result.search = relative.search;
                        result.query = relative.query;
                        result.host = relative.host || "";
                        result.auth = relative.auth;
                        result.hostname = relative.hostname || relative.host;
                        result.port = relative.port;
                        // to support http.request
                        if (result.pathname || result.search) {
                            var p = result.pathname || "";
                            var s = result.search || "";
                            result.path = p + s;
                        }
                        result.slashes = result.slashes || relative.slashes;
                        result.href = result.format();
                        return result;
                    }
                    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                    // if the url is a non-slashed url, then relative
                    // links like ../.. should be able
                    // to crawl up to the hostname, as well.  This is strange.
                    // result.protocol has already been set by now.
                    // Later on, put the first path part into the host field.
                    if (psychotic) {
                        result.hostname = "";
                        result.port = null;
                        if (result.host) {
                            if (srcPath[0] === "") srcPath[0] = result.host;
                            else srcPath.unshift(result.host);
                        }
                        result.host = "";
                        if (relative.protocol) {
                            relative.hostname = null;
                            relative.port = null;
                            if (relative.host) {
                                if (relPath[0] === "") relPath[0] = relative.host;
                                else relPath.unshift(relative.host);
                            }
                            relative.host = null;
                        }
                        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
                    }
                    if (isRelAbs) {
                        // it's absolute.
                        result.host = relative.host || relative.host === "" ? relative.host : result.host;
                        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
                        result.search = relative.search;
                        result.query = relative.query;
                        srcPath = relPath;
                    // fall through to the dot-handling below.
                    } else if (relPath.length) {
                        // it's relative
                        // throw away the existing file, and take the new path instead.
                        if (!srcPath) srcPath = [];
                        srcPath.pop();
                        srcPath = srcPath.concat(relPath);
                        result.search = relative.search;
                        result.query = relative.query;
                    } else if (!util.isNullOrUndefined(relative.search)) {
                        // just pull out the search.
                        // like href='?foo'.
                        // Put this after the other two cases because it simplifies the booleans
                        if (psychotic) {
                            result.hostname = result.host = srcPath.shift();
                            //occationaly the auth can get stuck only in host
                            //this especially happens in cases like
                            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                            if (authInHost) {
                                result.auth = authInHost.shift();
                                result.host = result.hostname = authInHost.shift();
                            }
                        }
                        result.search = relative.search;
                        result.query = relative.query;
                        //to support http.request
                        if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                        result.href = result.format();
                        return result;
                    }
                    if (!srcPath.length) {
                        // no path at all.  easy.
                        // we've already handled the other stuff above.
                        result.pathname = null;
                        //to support http.request
                        if (result.search) result.path = "/" + result.search;
                        else result.path = null;
                        result.href = result.format();
                        return result;
                    }
                    // if a url ENDs in . or .., then it must get a trailing slash.
                    // however, if it ends in anything else non-slashy,
                    // then it must NOT get a trailing slash.
                    var last = srcPath.slice(-1)[0];
                    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
                    // strip single dots, resolve double dots to parent dir
                    // if the path tries to go above the root, `up` ends up > 0
                    var up = 0;
                    for(var i = srcPath.length; i >= 0; i--){
                        last = srcPath[i];
                        if (last === ".") srcPath.splice(i, 1);
                        else if (last === "..") {
                            srcPath.splice(i, 1);
                            up++;
                        } else if (up) {
                            srcPath.splice(i, 1);
                            up--;
                        }
                    }
                    // if the path is allowed to go above the root, restore leading ..s
                    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
                    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
                    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
                    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
                    // put the host back
                    if (psychotic) {
                        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
                        //occationaly the auth can get stuck only in host
                        //this especially happens in cases like
                        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.host = result.hostname = authInHost.shift();
                        }
                    }
                    mustEndAbs = mustEndAbs || result.host && srcPath.length;
                    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
                    if (!srcPath.length) {
                        result.pathname = null;
                        result.path = null;
                    } else result.pathname = srcPath.join("/");
                    //to support request.http
                    if (!util.isNull(result.pathname) || !util.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                    result.auth = relative.auth || result.auth;
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                };
                Url.prototype.parseHost = function() {
                    var host = this.host;
                    var port = portPattern.exec(host);
                    if (port) {
                        port = port[0];
                        if (port !== ":") this.port = port.substr(1);
                        host = host.substr(0, host.length - port.length);
                    }
                    if (host) this.hostname = host;
                };
            /***/ },
            /***/ 2502: /***/ (module1)=>{
                "use strict";
                module1.exports = {
                    isString: function(arg) {
                        return typeof arg === "string";
                    },
                    isObject: function(arg) {
                        return typeof arg === "object" && arg !== null;
                    },
                    isNull: function(arg) {
                        return arg === null;
                    },
                    isNullOrUndefined: function(arg) {
                        return arg == null;
                    }
                };
            /***/ },
            /***/ 8416: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                module1.exports = __webpack_require__(41);
            /***/ },
            /***/ 6347: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var settle = __webpack_require__(8762);
                var cookies = __webpack_require__(6164);
                var buildURL = __webpack_require__(51);
                var buildFullPath = __webpack_require__(6672);
                var parseHeaders = __webpack_require__(9942);
                var isURLSameOrigin = __webpack_require__(3789);
                var createError = __webpack_require__(2604);
                module1.exports = function xhrAdapter(config) {
                    return new Promise(function dispatchXhrRequest(resolve, reject) {
                        var requestData = config.data;
                        var requestHeaders = config.headers;
                        if (utils.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
                        var request = new XMLHttpRequest();
                        // HTTP basic authentication
                        if (config.auth) {
                            var username = config.auth.username || "";
                            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
                            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
                        }
                        var fullPath = buildFullPath(config.baseURL, config.url);
                        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
                        // Set the request timeout in MS
                        request.timeout = config.timeout;
                        // Listen for ready state
                        request.onreadystatechange = function handleLoad() {
                            if (!request || request.readyState !== 4) return;
                            // The request errored out and we didn't get a response, this will be
                            // handled by onerror instead
                            // With one exception: request that using file: protocol, most browsers
                            // will return status as 0 even though it's a successful request
                            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
                            // Prepare the response
                            var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
                            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
                            var response = {
                                data: responseData,
                                status: request.status,
                                statusText: request.statusText,
                                headers: responseHeaders,
                                config: config,
                                request: request
                            };
                            settle(resolve, reject, response);
                            // Clean up request
                            request = null;
                        };
                        // Handle browser request cancellation (as opposed to a manual cancellation)
                        request.onabort = function handleAbort() {
                            if (!request) return;
                            reject(createError("Request aborted", config, "ECONNABORTED", request));
                            // Clean up request
                            request = null;
                        };
                        // Handle low level network errors
                        request.onerror = function handleError() {
                            // Real errors are hidden from us by the browser
                            // onerror should only fire if it's a network error
                            reject(createError("Network Error", config, null, request));
                            // Clean up request
                            request = null;
                        };
                        // Handle timeout
                        request.ontimeout = function handleTimeout() {
                            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
                            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
                            reject(createError(timeoutErrorMessage, config, "ECONNABORTED", request));
                            // Clean up request
                            request = null;
                        };
                        // Add xsrf header
                        // This is only done if running in a standard browser environment.
                        // Specifically not if we're in a web worker, or react-native.
                        if (utils.isStandardBrowserEnv()) {
                            // Add xsrf header
                            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
                            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
                        }
                        // Add headers to the request
                        if ("setRequestHeader" in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
                            delete requestHeaders[key];
                            else // Otherwise add header to the request
                            request.setRequestHeader(key, val);
                        });
                        // Add withCredentials to request if needed
                        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
                        // Add responseType to request if needed
                        if (config.responseType) try {
                            request.responseType = config.responseType;
                        } catch (e) {
                            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
                            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
                            if (config.responseType !== "json") throw e;
                        }
                        // Handle progress if needed
                        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
                        // Not all browsers support upload events
                        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
                        if (config.cancelToken) // Handle cancellation
                        config.cancelToken.promise.then(function onCanceled(cancel) {
                            if (!request) return;
                            request.abort();
                            reject(cancel);
                            // Clean up request
                            request = null;
                        });
                        if (!requestData) requestData = null;
                        // Send the request
                        request.send(requestData);
                    });
                };
            /***/ },
            /***/ 41: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var bind = __webpack_require__(1330);
                var Axios = __webpack_require__(2819);
                var mergeConfig = __webpack_require__(7711);
                var defaults = __webpack_require__(6450);
                /**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
                    var context = new Axios(defaultConfig);
                    var instance = bind(Axios.prototype.request, context);
                    // Copy axios.prototype to instance
                    utils.extend(instance, Axios.prototype, context);
                    // Copy context to instance
                    utils.extend(instance, context);
                    return instance;
                }
                // Create the default instance to be exported
                var axios = createInstance(defaults);
                // Expose Axios class to allow class inheritance
                axios.Axios = Axios;
                // Factory for creating new instances
                axios.create = function create(instanceConfig) {
                    return createInstance(mergeConfig(axios.defaults, instanceConfig));
                };
                // Expose Cancel & CancelToken
                axios.Cancel = __webpack_require__(7623);
                axios.CancelToken = __webpack_require__(3803);
                axios.isCancel = __webpack_require__(9328);
                // Expose all/spread
                axios.all = function all(promises) {
                    return Promise.all(promises);
                };
                axios.spread = __webpack_require__(348);
                // Expose isAxiosError
                axios.isAxiosError = __webpack_require__(839);
                module1.exports = axios;
                // Allow use of default import syntax in TypeScript
                module1.exports.default = axios;
            /***/ },
            /***/ 7623: /***/ (module1)=>{
                "use strict";
                /**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function Cancel(message) {
                    this.message = message;
                }
                Cancel.prototype.toString = function toString() {
                    return "Cancel" + (this.message ? ": " + this.message : "");
                };
                Cancel.prototype.__CANCEL__ = true;
                module1.exports = Cancel;
            /***/ },
            /***/ 3803: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var Cancel = __webpack_require__(7623);
                /**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
                    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
                    var resolvePromise;
                    this.promise = new Promise(function promiseExecutor(resolve) {
                        resolvePromise = resolve;
                    });
                    var token = this;
                    executor(function cancel(message) {
                        if (token.reason) // Cancellation has already been requested
                        return;
                        token.reason = new Cancel(message);
                        resolvePromise(token.reason);
                    });
                }
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                    if (this.reason) throw this.reason;
                };
                /**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
                    var cancel;
                    var token = new CancelToken(function executor(c) {
                        cancel = c;
                    });
                    return {
                        token: token,
                        cancel: cancel
                    };
                };
                module1.exports = CancelToken;
            /***/ },
            /***/ 9328: /***/ (module1)=>{
                "use strict";
                module1.exports = function isCancel(value) {
                    return !!(value && value.__CANCEL__);
                };
            /***/ },
            /***/ 2819: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var buildURL = __webpack_require__(51);
                var InterceptorManager = __webpack_require__(3973);
                var dispatchRequest = __webpack_require__(1639);
                var mergeConfig = __webpack_require__(7711);
                /**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
                    this.defaults = instanceConfig;
                    this.interceptors = {
                        request: new InterceptorManager(),
                        response: new InterceptorManager()
                    };
                }
                /**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(config) {
                    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                    if (typeof config === "string") {
                        config = arguments[1] || {};
                        config.url = arguments[0];
                    } else config = config || {};
                    config = mergeConfig(this.defaults, config);
                    // Set config.method
                    if (config.method) config.method = config.method.toLowerCase();
                    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
                    else config.method = "get";
                    // Hook up interceptors middleware
                    var chain = [
                        dispatchRequest,
                        undefined
                    ];
                    var promise = Promise.resolve(config);
                    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                        chain.unshift(interceptor.fulfilled, interceptor.rejected);
                    });
                    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                        chain.push(interceptor.fulfilled, interceptor.rejected);
                    });
                    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
                    return promise;
                };
                Axios.prototype.getUri = function getUri(config) {
                    config = mergeConfig(this.defaults, config);
                    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
                };
                // Provide aliases for supported request methods
                utils.forEach([
                    "delete",
                    "get",
                    "head",
                    "options"
                ], function forEachMethodNoData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: (config || {}).data
                        }));
                    };
                });
                utils.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    /*eslint func-names:0*/ Axios.prototype[method] = function(url, data, config) {
                        return this.request(mergeConfig(config || {}, {
                            method: method,
                            url: url,
                            data: data
                        }));
                    };
                });
                module1.exports = Axios;
            /***/ },
            /***/ 3973: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                function InterceptorManager() {
                    this.handlers = [];
                }
                /**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected) {
                    this.handlers.push({
                        fulfilled: fulfilled,
                        rejected: rejected
                    });
                    return this.handlers.length - 1;
                };
                /**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
                    if (this.handlers[id]) this.handlers[id] = null;
                };
                /**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
                    utils.forEach(this.handlers, function forEachHandler(h) {
                        if (h !== null) fn(h);
                    });
                };
                module1.exports = InterceptorManager;
            /***/ },
            /***/ 6672: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var isAbsoluteURL = __webpack_require__(1275);
                var combineURLs = __webpack_require__(2345);
                /**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module1.exports = function buildFullPath(baseURL, requestedURL) {
                    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
                    return requestedURL;
                };
            /***/ },
            /***/ 2604: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var enhanceError = __webpack_require__(5898);
                /**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module1.exports = function createError(message, config, code, request, response) {
                    var error = new Error(message);
                    return enhanceError(error, config, code, request, response);
                };
            /***/ },
            /***/ 1639: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var transformData = __webpack_require__(2244);
                var isCancel = __webpack_require__(9328);
                var defaults = __webpack_require__(6450);
                /**
 * Throws a `Cancel` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
                    if (config.cancelToken) config.cancelToken.throwIfRequested();
                }
                /**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module1.exports = function dispatchRequest(config) {
                    throwIfCancellationRequested(config);
                    // Ensure headers exist
                    config.headers = config.headers || {};
                    // Transform request data
                    config.data = transformData(config.data, config.headers, config.transformRequest);
                    // Flatten headers
                    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
                    utils.forEach([
                        "delete",
                        "get",
                        "head",
                        "post",
                        "put",
                        "patch",
                        "common"
                    ], function cleanHeaderConfig(method) {
                        delete config.headers[method];
                    });
                    var adapter = config.adapter || defaults.adapter;
                    return adapter(config).then(function onAdapterResolution(response) {
                        throwIfCancellationRequested(config);
                        // Transform response data
                        response.data = transformData(response.data, response.headers, config.transformResponse);
                        return response;
                    }, function onAdapterRejection(reason) {
                        if (!isCancel(reason)) {
                            throwIfCancellationRequested(config);
                            // Transform response data
                            if (reason && reason.response) reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
                        }
                        return Promise.reject(reason);
                    });
                };
            /***/ },
            /***/ 5898: /***/ (module1)=>{
                "use strict";
                /**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module1.exports = function enhanceError(error, config, code, request, response) {
                    error.config = config;
                    if (code) error.code = code;
                    error.request = request;
                    error.response = response;
                    error.isAxiosError = true;
                    error.toJSON = function toJSON() {
                        return {
                            // Standard
                            message: this.message,
                            name: this.name,
                            // Microsoft
                            description: this.description,
                            number: this.number,
                            // Mozilla
                            fileName: this.fileName,
                            lineNumber: this.lineNumber,
                            columnNumber: this.columnNumber,
                            stack: this.stack,
                            // Axios
                            config: this.config,
                            code: this.code
                        };
                    };
                    return error;
                };
            /***/ },
            /***/ 7711: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                /**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module1.exports = function mergeConfig(config1, config2) {
                    // eslint-disable-next-line no-param-reassign
                    config2 = config2 || {};
                    var config = {};
                    var valueFromConfig2Keys = [
                        "url",
                        "method",
                        "data"
                    ];
                    var mergeDeepPropertiesKeys = [
                        "headers",
                        "auth",
                        "proxy",
                        "params"
                    ];
                    var defaultToConfig2Keys = [
                        "baseURL",
                        "transformRequest",
                        "transformResponse",
                        "paramsSerializer",
                        "timeout",
                        "timeoutMessage",
                        "withCredentials",
                        "adapter",
                        "responseType",
                        "xsrfCookieName",
                        "xsrfHeaderName",
                        "onUploadProgress",
                        "onDownloadProgress",
                        "decompress",
                        "maxContentLength",
                        "maxBodyLength",
                        "maxRedirects",
                        "transport",
                        "httpAgent",
                        "httpsAgent",
                        "cancelToken",
                        "socketPath",
                        "responseEncoding"
                    ];
                    var directMergeKeys = [
                        "validateStatus"
                    ];
                    function getMergedValue(target, source) {
                        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
                        else if (utils.isPlainObject(source)) return utils.merge({}, source);
                        else if (utils.isArray(source)) return source.slice();
                        return source;
                    }
                    function mergeDeepProperties(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
                        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                    }
                    utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                    });
                    utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
                    utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
                        if (!utils.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
                        else if (!utils.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
                    });
                    utils.forEach(directMergeKeys, function merge(prop) {
                        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
                        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
                    });
                    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
                    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
                        return axiosKeys.indexOf(key) === -1;
                    });
                    utils.forEach(otherKeys, mergeDeepProperties);
                    return config;
                };
            /***/ },
            /***/ 8762: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var createError = __webpack_require__(2604);
                /**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module1.exports = function settle(resolve, reject, response) {
                    var validateStatus = response.config.validateStatus;
                    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
                    else reject(createError("Request failed with status code " + response.status, response.config, null, response.request, response));
                };
            /***/ },
            /***/ 2244: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                /**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module1.exports = function transformData(data, headers, fns) {
                    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
                        data = fn(data, headers);
                    });
                    return data;
                };
            /***/ },
            /***/ 6450: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                var normalizeHeaderName = __webpack_require__(2854);
                var DEFAULT_CONTENT_TYPE = {
                    "Content-Type": "application/x-www-form-urlencoded"
                };
                function setContentTypeIfUnset(headers, value) {
                    if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
                }
                function getDefaultAdapter() {
                    var adapter;
                    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
                    adapter = __webpack_require__(6347);
                    else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") // For node use HTTP adapter
                    adapter = __webpack_require__(6347);
                    return adapter;
                }
                var defaults = {
                    adapter: getDefaultAdapter(),
                    transformRequest: [
                        function transformRequest(data, headers) {
                            normalizeHeaderName(headers, "Accept");
                            normalizeHeaderName(headers, "Content-Type");
                            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
                            if (utils.isArrayBufferView(data)) return data.buffer;
                            if (utils.isURLSearchParams(data)) {
                                setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                                return data.toString();
                            }
                            if (utils.isObject(data)) {
                                setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                                return JSON.stringify(data);
                            }
                            return data;
                        }
                    ],
                    transformResponse: [
                        function transformResponse(data) {
                            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                                data = JSON.parse(data);
                            } catch (e) {}
                            return data;
                        }
                    ],
                    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
                    xsrfCookieName: "XSRF-TOKEN",
                    xsrfHeaderName: "X-XSRF-TOKEN",
                    maxContentLength: -1,
                    maxBodyLength: -1,
                    validateStatus: function validateStatus(status) {
                        return status >= 200 && status < 300;
                    }
                };
                defaults.headers = {
                    common: {
                        "Accept": "application/json, text/plain, */*"
                    }
                };
                utils.forEach([
                    "delete",
                    "get",
                    "head"
                ], function forEachMethodNoData(method) {
                    defaults.headers[method] = {};
                });
                utils.forEach([
                    "post",
                    "put",
                    "patch"
                ], function forEachMethodWithData(method) {
                    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
                });
                module1.exports = defaults;
            /***/ },
            /***/ 1330: /***/ (module1)=>{
                "use strict";
                module1.exports = function bind(fn, thisArg) {
                    return function wrap() {
                        var args = new Array(arguments.length);
                        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
                        return fn.apply(thisArg, args);
                    };
                };
            /***/ },
            /***/ 51: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                function encode(val) {
                    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                }
                /**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module1.exports = function buildURL(url, params, paramsSerializer) {
                    /*eslint no-param-reassign:0*/ if (!params) return url;
                    var serializedParams;
                    if (paramsSerializer) serializedParams = paramsSerializer(params);
                    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
                    else {
                        var parts = [];
                        utils.forEach(params, function serialize(val, key) {
                            if (val === null || typeof val === "undefined") return;
                            if (utils.isArray(val)) key = key + "[]";
                            else val = [
                                val
                            ];
                            utils.forEach(val, function parseValue(v) {
                                if (utils.isDate(v)) v = v.toISOString();
                                else if (utils.isObject(v)) v = JSON.stringify(v);
                                parts.push(encode(key) + "=" + encode(v));
                            });
                        });
                        serializedParams = parts.join("&");
                    }
                    if (serializedParams) {
                        var hashmarkIndex = url.indexOf("#");
                        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
                        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
                    }
                    return url;
                };
            /***/ },
            /***/ 2345: /***/ (module1)=>{
                "use strict";
                /**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module1.exports = function combineURLs(baseURL, relativeURL) {
                    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
                };
            /***/ },
            /***/ 6164: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
                function standardBrowserEnv() {
                    return {
                        write: function write(name1, value, expires, path, domain, secure) {
                            var cookie = [];
                            cookie.push(name1 + "=" + encodeURIComponent(value));
                            if (utils.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
                            if (utils.isString(path)) cookie.push("path=" + path);
                            if (utils.isString(domain)) cookie.push("domain=" + domain);
                            if (secure === true) cookie.push("secure");
                            document.cookie = cookie.join("; ");
                        },
                        read: function read(name1) {
                            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name1 + ")=([^;]*)"));
                            return match ? decodeURIComponent(match[3]) : null;
                        },
                        remove: function remove(name1) {
                            this.write(name1, "", Date.now() - 86400000);
                        }
                    };
                }() : // Non standard browser env (web workers, react-native) lack needed support.
                function nonStandardBrowserEnv() {
                    return {
                        write: function write() {},
                        read: function read() {
                            return null;
                        },
                        remove: function remove() {}
                    };
                }();
            /***/ },
            /***/ 1275: /***/ (module1)=>{
                "use strict";
                /**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module1.exports = function isAbsoluteURL(url) {
                    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
                    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
                    // by any combination of letters, digits, plus, period, or hyphen.
                    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
                };
            /***/ },
            /***/ 839: /***/ (module1)=>{
                "use strict";
                /**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module1.exports = function isAxiosError(payload) {
                    return typeof payload === "object" && payload.isAxiosError === true;
                };
            /***/ },
            /***/ 3789: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
                // whether the request URL is of the same origin as current location.
                function standardBrowserEnv() {
                    var msie = /(msie|trident)/i.test(navigator.userAgent);
                    var urlParsingNode = document.createElement("a");
                    var originURL;
                    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
                        var href = url;
                        if (msie) {
                            // IE needs attribute set twice to normalize properties
                            urlParsingNode.setAttribute("href", href);
                            href = urlParsingNode.href;
                        }
                        urlParsingNode.setAttribute("href", href);
                        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
                        return {
                            href: urlParsingNode.href,
                            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
                            host: urlParsingNode.host,
                            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
                            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
                            hostname: urlParsingNode.hostname,
                            port: urlParsingNode.port,
                            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
                        };
                    }
                    originURL = resolveURL(window.location.href);
                    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
                        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                    };
                }() : // Non standard browser envs (web workers, react-native) lack needed support.
                function nonStandardBrowserEnv() {
                    return function isURLSameOrigin() {
                        return true;
                    };
                }();
            /***/ },
            /***/ 2854: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                module1.exports = function normalizeHeaderName(headers, normalizedName) {
                    utils.forEach(headers, function processHeader(value, name1) {
                        if (name1 !== normalizedName && name1.toUpperCase() === normalizedName.toUpperCase()) {
                            headers[normalizedName] = value;
                            delete headers[name1];
                        }
                    });
                };
            /***/ },
            /***/ 9942: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var utils = __webpack_require__(9053);
                // Headers whose duplicates are ignored by node
                // c.f. https://nodejs.org/api/http.html#http_message_headers
                var ignoreDuplicateOf = [
                    "age",
                    "authorization",
                    "content-length",
                    "content-type",
                    "etag",
                    "expires",
                    "from",
                    "host",
                    "if-modified-since",
                    "if-unmodified-since",
                    "last-modified",
                    "location",
                    "max-forwards",
                    "proxy-authorization",
                    "referer",
                    "retry-after",
                    "user-agent"
                ];
                /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module1.exports = function parseHeaders(headers) {
                    var parsed = {};
                    var key;
                    var val;
                    var i;
                    if (!headers) return parsed;
                    utils.forEach(headers.split("\n"), function parser(line) {
                        i = line.indexOf(":");
                        key = utils.trim(line.substr(0, i)).toLowerCase();
                        val = utils.trim(line.substr(i + 1));
                        if (key) {
                            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
                            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                                val
                            ]);
                            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
                        }
                    });
                    return parsed;
                };
            /***/ },
            /***/ 348: /***/ (module1)=>{
                "use strict";
                /**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module1.exports = function spread(callback) {
                    return function wrap(arr) {
                        return callback.apply(null, arr);
                    };
                };
            /***/ },
            /***/ 9053: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                var bind = __webpack_require__(1330);
                /*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
                var toString = Object.prototype.toString;
                /**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
                    return toString.call(val) === "[object Array]";
                }
                /**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
                    return typeof val === "undefined";
                }
                /**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
                    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
                }
                /**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function isArrayBuffer(val) {
                    return toString.call(val) === "[object ArrayBuffer]";
                }
                /**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(val) {
                    return typeof FormData !== "undefined" && val instanceof FormData;
                }
                /**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
                    var result;
                    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
                    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
                    return result;
                }
                /**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
                    return typeof val === "string";
                }
                /**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
                    return typeof val === "number";
                }
                /**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
                    return val !== null && typeof val === "object";
                }
                /**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
                    if (toString.call(val) !== "[object Object]") return false;
                    var prototype = Object.getPrototypeOf(val);
                    return prototype === null || prototype === Object.prototype;
                }
                /**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function isDate(val) {
                    return toString.call(val) === "[object Date]";
                }
                /**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function isFile(val) {
                    return toString.call(val) === "[object File]";
                }
                /**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function isBlob(val) {
                    return toString.call(val) === "[object Blob]";
                }
                /**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
                    return toString.call(val) === "[object Function]";
                }
                /**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
                    return isObject(val) && isFunction(val.pipe);
                }
                /**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function isURLSearchParams(val) {
                    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
                }
                /**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
                    return str.replace(/^\s*/, "").replace(/\s*$/, "");
                }
                /**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
                    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
                    return typeof window !== "undefined" && typeof document !== "undefined";
                }
                /**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
                    // Don't bother if no value provided
                    if (obj === null || typeof obj === "undefined") return;
                    // Force an array if not already something iterable
                    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
                        obj
                    ];
                    if (isArray(obj)) // Iterate over array values
                    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
                    else {
                        // Iterate over object keys
                        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
                    }
                }
                /**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
                    var result = {};
                    function assignValue(val, key) {
                        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
                        else if (isPlainObject(val)) result[key] = merge({}, val);
                        else if (isArray(val)) result[key] = val.slice();
                        else result[key] = val;
                    }
                    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
                    return result;
                }
                /**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
                    forEach(b, function assignValue(val, key) {
                        if (thisArg && typeof val === "function") a[key] = bind(val, thisArg);
                        else a[key] = val;
                    });
                    return a;
                }
                /**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
                    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
                    return content;
                }
                module1.exports = {
                    isArray: isArray,
                    isArrayBuffer: isArrayBuffer,
                    isBuffer: isBuffer,
                    isFormData: isFormData,
                    isArrayBufferView: isArrayBufferView,
                    isString: isString,
                    isNumber: isNumber,
                    isObject: isObject,
                    isPlainObject: isPlainObject,
                    isUndefined: isUndefined,
                    isDate: isDate,
                    isFile: isFile,
                    isBlob: isBlob,
                    isFunction: isFunction,
                    isStream: isStream,
                    isURLSearchParams: isURLSearchParams,
                    isStandardBrowserEnv: isStandardBrowserEnv,
                    forEach: forEach,
                    merge: merge,
                    extend: extend,
                    trim: trim,
                    stripBOM: stripBOM
                };
            /***/ },
            /***/ 4491: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_RESULT__;
                (function(globalObject) {
                    "use strict";
                    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
                    POWS_TEN = [
                        1,
                        10,
                        100,
                        1e3,
                        1e4,
                        1e5,
                        1e6,
                        1e7,
                        1e8,
                        1e9,
                        1e10,
                        1e11,
                        1e12,
                        1e13
                    ], SQRT_BASE = 1e7, // EDITABLE
                    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
                    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
                    MAX = 1E9; // 0 to MAX_INT32
                    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
                        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
                            constructor: BigNumber,
                            toString: null,
                            valueOf: null
                        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
                        // The default values below must be integers within the inclusive ranges stated.
                        // The values can also be changed at run-time using BigNumber.set.
                        // The maximum number of decimal places for operations involving division.
                        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
                        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
                        // UP         0 Away from zero.
                        // DOWN       1 Towards zero.
                        // CEIL       2 Towards +Infinity.
                        // FLOOR      3 Towards -Infinity.
                        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
                        // The exponent value at and beneath which toString returns exponential notation.
                        // Number type: -7
                        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
                        // Number type: 21
                        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
                        // The minimum exponent value, beneath which underflow to zero occurs.
                        // Number type: -324  (5e-324)
                        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
                        // Number type:  308  (1.7976931348623157e+308)
                        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
                        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
                        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
                        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                        // The remainder (r) is calculated as: r = a - n * q.
                        //
                        // UP        0 The remainder is positive if the dividend is negative, else is negative.
                        // DOWN      1 The remainder has the same sign as the dividend.
                        //             This modulo mode is commonly known as 'truncated division' and is
                        //             equivalent to (a % n) in JavaScript.
                        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
                        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
                        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
                        //             The remainder is always positive.
                        //
                        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
                        // modes are commonly used for the modulus operation.
                        // Although the other rounding modes can also be used, they may not give useful results.
                        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
                        // If POW_PRECISION is 0, there will be unlimited significant digits.
                        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
                        FORMAT = {
                            decimalSeparator: ".",
                            groupSeparator: ",",
                            groupSize: 3,
                            secondaryGroupSize: 0,
                            fractionGroupSeparator: "\xa0",
                            fractionGroupSize: 0
                        }, // The alphabet used for base conversion.
                        // It must be at least 2 characters long, with no '.' or repeated character.
                        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
                        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
                        //------------------------------------------------------------------------------------------
                        // CONSTRUCTOR
                        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
                            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
                            // Enable constructor usage without new.
                            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
                            // '[BigNumber Error] Constructor call without new: {n}'
                            //throw Error(bignumberError + ' Constructor call without new: ' + n);
                            return new BigNumber(n, b);
                            if (b == null) {
                                // Duplicate.
                                if (n instanceof BigNumber) {
                                    x.s = n.s;
                                    x.e = n.e;
                                    x.c = (n = n.c) ? n.slice() : n;
                                    return;
                                }
                                isNum = typeof n == "number";
                                if (isNum && n * 0 == 0) {
                                    // Use `1 / n` to handle minus zero also.
                                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                                    // Faster path for integers.
                                    if (n === ~~n) {
                                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                                        x.e = e;
                                        x.c = [
                                            n
                                        ];
                                        return;
                                    }
                                    str = n + "";
                                } else {
                                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                                }
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                // Exponential form?
                                if ((i = str.search(/e/i)) > 0) {
                                    // Determine exponent.
                                    if (e < 0) e = i;
                                    e += +str.slice(i + 1);
                                    str = str.substring(0, i);
                                } else if (e < 0) // Integer.
                                e = str.length;
                            } else {
                                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                                intCheck(b, 2, ALPHABET.length, "Base");
                                str = n + "";
                                // Allow exponential notation to be used with base 10 argument, while
                                // also rounding to DECIMAL_PLACES as with other bases.
                                if (b == 10) {
                                    x = new BigNumber(n instanceof BigNumber ? n : str);
                                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                                }
                                isNum = typeof n == "number";
                                if (isNum) {
                                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                                    // Prevent later check for length on converted number.
                                    isNum = false;
                                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                                alphabet = ALPHABET.slice(0, b);
                                e = i = 0;
                                // Check that str is a valid base b number.
                                // Don't use RegExp so alphabet can contain special characters.
                                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                                    if (c == ".") // If '.' is not the first character and it has not be found before.
                                    {
                                        if (i > e) {
                                            e = len;
                                            continue;
                                        }
                                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                                    {
                                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                                            caseChanged = true;
                                            i = -1;
                                            e = 0;
                                            continue;
                                        }
                                    }
                                    return parseNumeric(x, n + "", isNum, b);
                                }
                                str = convertBase(str, b, 10, x.s);
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                else e = str.length;
                            }
                            // Determine leading zeros.
                            for(i = 0; str.charCodeAt(i) === 48; i++);
                            // Determine trailing zeros.
                            for(len = str.length; str.charCodeAt(--len) === 48;);
                            str = str.slice(i, ++len);
                            if (str) {
                                len -= i;
                                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                                e = e - i - 1;
                                // Overflow?
                                if (e > MAX_EXP) // Infinity.
                                x.c = x.e = null;
                                else if (e < MIN_EXP) // Zero.
                                x.c = [
                                    x.e = 0
                                ];
                                else {
                                    x.e = e;
                                    x.c = [];
                                    // Transform base
                                    // e is the base 10 exponent.
                                    // i is where to slice str to get the first element of the coefficient array.
                                    i = (e + 1) % LOG_BASE;
                                    if (e < 0) i += LOG_BASE;
                                    if (i < len) {
                                        if (i) x.c.push(+str.slice(0, i));
                                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                                        str = str.slice(i);
                                        i = LOG_BASE - str.length;
                                    } else i -= len;
                                    for(; i--; str += "0");
                                    x.c.push(+str);
                                }
                            } else // Zero.
                            x.c = [
                                x.e = 0
                            ];
                        }
                        // CONSTRUCTOR PROPERTIES
                        BigNumber.clone = clone;
                        BigNumber.ROUND_UP = 0;
                        BigNumber.ROUND_DOWN = 1;
                        BigNumber.ROUND_CEIL = 2;
                        BigNumber.ROUND_FLOOR = 3;
                        BigNumber.ROUND_HALF_UP = 4;
                        BigNumber.ROUND_HALF_DOWN = 5;
                        BigNumber.ROUND_HALF_EVEN = 6;
                        BigNumber.ROUND_HALF_CEIL = 7;
                        BigNumber.ROUND_HALF_FLOOR = 8;
                        BigNumber.EUCLID = 9;
                        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
                            var p, v;
                            if (obj != null) {
                                if (typeof obj == "object") {
                                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        DECIMAL_PLACES = v;
                                    }
                                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 8, p);
                                        ROUNDING_MODE = v;
                                    }
                                    // EXPONENTIAL_AT {number|number[]}
                                    // Integer, -MAX to MAX inclusive or
                                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, 0, p);
                                            intCheck(v[1], 0, MAX, p);
                                            TO_EXP_NEG = v[0];
                                            TO_EXP_POS = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                                        }
                                    }
                                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                                    if (obj.hasOwnProperty(p = "RANGE")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, -1, p);
                                            intCheck(v[1], 1, MAX, p);
                                            MIN_EXP = v[0];
                                            MAX_EXP = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                                        }
                                    }
                                    // CRYPTO {boolean} true or false.
                                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                                    // '[BigNumber Error] crypto unavailable'
                                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                                        v = obj[p];
                                        if (v === !!v) {
                                            if (v) {
                                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                                else {
                                                    CRYPTO = !v;
                                                    throw Error(bignumberError + "crypto unavailable");
                                                }
                                            } else CRYPTO = v;
                                        } else throw Error(bignumberError + p + " not true or false: " + v);
                                    }
                                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 9, p);
                                        MODULO_MODE = v;
                                    }
                                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        POW_PRECISION = v;
                                    }
                                    // FORMAT {object}
                                    // '[BigNumber Error] FORMAT not an object: {v}'
                                    if (obj.hasOwnProperty(p = "FORMAT")) {
                                        v = obj[p];
                                        if (typeof v == "object") FORMAT = v;
                                        else throw Error(bignumberError + p + " not an object: " + v);
                                    }
                                    // ALPHABET {string}
                                    // '[BigNumber Error] ALPHABET invalid: {v}'
                                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                                        v = obj[p];
                                        // Disallow if only one character, or contains '.' or a repeated character.
                                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                                        else throw Error(bignumberError + p + " invalid: " + v);
                                    }
                                } else // '[BigNumber Error] Object expected: {v}'
                                throw Error(bignumberError + "Object expected: " + obj);
                            }
                            return {
                                DECIMAL_PLACES: DECIMAL_PLACES,
                                ROUNDING_MODE: ROUNDING_MODE,
                                EXPONENTIAL_AT: [
                                    TO_EXP_NEG,
                                    TO_EXP_POS
                                ],
                                RANGE: [
                                    MIN_EXP,
                                    MAX_EXP
                                ],
                                CRYPTO: CRYPTO,
                                MODULO_MODE: MODULO_MODE,
                                POW_PRECISION: POW_PRECISION,
                                FORMAT: FORMAT,
                                ALPHABET: ALPHABET
                            };
                        };
                        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
                            return v instanceof BigNumber || v && v._isBigNumber === true || false;
                        };
                        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
                            return maxOrMin(arguments, P.lt);
                        };
                        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
                            return maxOrMin(arguments, P.gt);
                        };
                        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
                            var pow2_53 = 0x20000000000000;
                            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
                            // Check if Math.random() produces more than 32 bits of randomness.
                            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
                            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
                            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                                return mathfloor(Math.random() * pow2_53);
                            } : function() {
                                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
                            };
                            return function(dp) {
                                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                                if (dp == null) dp = DECIMAL_PLACES;
                                else intCheck(dp, 0, MAX);
                                k = mathceil(dp / LOG_BASE);
                                if (CRYPTO) {
                                    // Browsers supporting crypto.getRandomValues.
                                    if (crypto.getRandomValues) {
                                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                                        for(; i < k;){
                                            // 53 bits:
                                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                                            //                                     11111 11111111 11111111
                                            // 0x20000 is 2^21.
                                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                                            // Rejection sampling:
                                            // 0 <= v < 9007199254740992
                                            // Probability that v >= 9e15, is
                                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                                            if (v >= 9e15) {
                                                b = crypto.getRandomValues(new Uint32Array(2));
                                                a[i] = b[0];
                                                a[i + 1] = b[1];
                                            } else {
                                                // 0 <= v <= 8999999999999999
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 2;
                                            }
                                        }
                                        i = k / 2;
                                    // Node.js supporting crypto.randomBytes.
                                    } else if (crypto.randomBytes) {
                                        // buffer
                                        a = crypto.randomBytes(k *= 7);
                                        for(; i < k;){
                                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                                            // 0 <= v < 9007199254740992
                                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                                            else {
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 7;
                                            }
                                        }
                                        i = k / 7;
                                    } else {
                                        CRYPTO = false;
                                        throw Error(bignumberError + "crypto unavailable");
                                    }
                                }
                                // Use Math.random.
                                if (!CRYPTO) for(; i < k;){
                                    v = random53bitInt();
                                    if (v < 9e15) c[i++] = v % 1e14;
                                }
                                k = c[--i];
                                dp %= LOG_BASE;
                                // Convert trailing digits to zeros according to dp.
                                if (k && dp) {
                                    v = POWS_TEN[LOG_BASE - dp];
                                    c[i] = mathfloor(k / v) * v;
                                }
                                // Remove trailing elements which are zero.
                                for(; c[i] === 0; c.pop(), i--);
                                // Zero?
                                if (i < 0) c = [
                                    e = 0
                                ];
                                else {
                                    // Remove leading elements which are zero and adjust exponent accordingly.
                                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                                    // Count the digits of the first element of c to determine leading zeros, and...
                                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                                    // adjust the exponent accordingly.
                                    if (i < LOG_BASE) e -= LOG_BASE - i;
                                }
                                rand.e = e;
                                rand.c = c;
                                return rand;
                            };
                        }();
                        // PRIVATE FUNCTIONS
                        // Called by BigNumber and BigNumber.prototype.toString.
                        convertBase = function() {
                            var decimal = "0123456789";
                            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                                var j, arr = [
                                    0
                                ], arrL, i = 0, len = str.length;
                                for(; i < len;){
                                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                                    arr[0] += alphabet.indexOf(str.charAt(i++));
                                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                                        if (arr[j + 1] == null) arr[j + 1] = 0;
                                        arr[j + 1] += arr[j] / baseOut | 0;
                                        arr[j] %= baseOut;
                                    }
                                }
                                return arr.reverse();
                            }
                            // Convert a numeric string of baseIn to a numeric string of baseOut.
                            // If the caller is toString, we are converting from base 10 to baseOut.
                            // If the caller is BigNumber, we are converting from baseIn to base 10.
                            return function(str, baseIn, baseOut, sign, callerIsToString) {
                                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                                // Non-integer.
                                if (i >= 0) {
                                    k = POW_PRECISION;
                                    // Unlimited precision.
                                    POW_PRECISION = 0;
                                    str = str.replace(".", "");
                                    y = new BigNumber(baseIn);
                                    x = y.pow(str.length - i);
                                    POW_PRECISION = k;
                                    // Convert str as if an integer, then restore the fraction part by dividing the
                                    // result by its base raised to a power.
                                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                                    y.e = y.c.length;
                                }
                                // Convert the number as integer.
                                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                                e = k = xc.length;
                                // Remove trailing zeros.
                                for(; xc[--k] == 0; xc.pop());
                                // Zero?
                                if (!xc[0]) return alphabet.charAt(0);
                                // Does str represent an integer? If so, no need for the division.
                                if (i < 0) --e;
                                else {
                                    x.c = xc;
                                    x.e = e;
                                    // The sign is needed for correct rounding.
                                    x.s = sign;
                                    x = div(x, y, dp, rm, baseOut);
                                    xc = x.c;
                                    r = x.r;
                                    e = x.e;
                                }
                                // xc now represents str converted to baseOut.
                                // THe index of the rounding digit.
                                d = e + dp + 1;
                                // The rounding digit: the digit to the right of the digit that may be rounded up.
                                i = xc[d];
                                // Look at the rounding digits and mode to determine whether to round up.
                                k = baseOut / 2;
                                r = r || d < 0 || xc[d + 1] != null;
                                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                                // If the index of the rounding digit is not greater than zero, or xc represents
                                // zero, then the result of the base conversion is zero or, if rounding up, a value
                                // such as 0.00001.
                                if (d < 1 || !xc[0]) // 1^-dp or 0
                                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                                else {
                                    // Truncate xc to the required number of decimal places.
                                    xc.length = d;
                                    // Round up?
                                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                                    for(--baseOut; ++xc[--d] > baseOut;){
                                        xc[d] = 0;
                                        if (!d) {
                                            ++e;
                                            xc = [
                                                1
                                            ].concat(xc);
                                        }
                                    }
                                    // Determine trailing zeros.
                                    for(k = xc.length; !xc[--k];);
                                    // E.g. [4, 11, 15] becomes 4bf.
                                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                                    // Add leading zeros, decimal point and trailing zeros as required.
                                    str = toFixedPoint(str, e, alphabet.charAt(0));
                                }
                                // The caller will add the sign.
                                return str;
                            };
                        }();
                        // Perform division in the specified base. Called by div and convertBase.
                        div = function() {
                            // Assume non-zero x and k.
                            function multiply(x, k, base) {
                                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                                for(x = x.slice(); i--;){
                                    xlo = x[i] % SQRT_BASE;
                                    xhi = x[i] / SQRT_BASE | 0;
                                    m = khi * xlo + xhi * klo;
                                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                                    x[i] = temp % base;
                                }
                                if (carry) x = [
                                    carry
                                ].concat(x);
                                return x;
                            }
                            function compare(a, b, aL, bL) {
                                var i, cmp;
                                if (aL != bL) cmp = aL > bL ? 1 : -1;
                                else {
                                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                                        cmp = a[i] > b[i] ? 1 : -1;
                                        break;
                                    }
                                }
                                return cmp;
                            }
                            function subtract(a, b, aL, base) {
                                var i = 0;
                                // Subtract b from a.
                                for(; aL--;){
                                    a[aL] -= i;
                                    i = a[aL] < b[aL] ? 1 : 0;
                                    a[aL] = i * base + a[aL] - b[aL];
                                }
                                // Remove leading zeros.
                                for(; !a[0] && a.length > 1; a.splice(0, 1));
                            }
                            // x: dividend, y: divisor.
                            return function(x, y, dp, rm, base) {
                                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                                // Either NaN, Infinity or 0?
                                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                                q = new BigNumber(s);
                                qc = q.c = [];
                                e = x.e - y.e;
                                s = dp + e + 1;
                                if (!base) {
                                    base = BASE;
                                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                                    s = s / LOG_BASE | 0;
                                }
                                // Result exponent may be one less then the current value of e.
                                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                                for(i = 0; yc[i] == (xc[i] || 0); i++);
                                if (yc[i] > (xc[i] || 0)) e--;
                                if (s < 0) {
                                    qc.push(1);
                                    more = true;
                                } else {
                                    xL = xc.length;
                                    yL = yc.length;
                                    i = 0;
                                    s += 2;
                                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                                    n = mathfloor(base / (yc[0] + 1));
                                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                                    if (n > 1) {
                                        yc = multiply(yc, n, base);
                                        xc = multiply(xc, n, base);
                                        yL = yc.length;
                                        xL = xc.length;
                                    }
                                    xi = yL;
                                    rem = xc.slice(0, yL);
                                    remL = rem.length;
                                    // Add zeros to make remainder as long as divisor.
                                    for(; remL < yL; rem[remL++] = 0);
                                    yz = yc.slice();
                                    yz = [
                                        0
                                    ].concat(yz);
                                    yc0 = yc[0];
                                    if (yc[1] >= base / 2) yc0++;
                                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                                    do {
                                        n = 0;
                                        // Compare divisor and remainder.
                                        cmp = compare(yc, rem, yL, remL);
                                        // If divisor < remainder.
                                        if (cmp < 0) {
                                            // Calculate trial digit, n.
                                            rem0 = rem[0];
                                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                                            // n is how many times the divisor goes into the current remainder.
                                            n = mathfloor(rem0 / yc0);
                                            //  Algorithm:
                                            //  product = divisor multiplied by trial digit (n).
                                            //  Compare product and remainder.
                                            //  If product is greater than remainder:
                                            //    Subtract divisor from product, decrement trial digit.
                                            //  Subtract product from remainder.
                                            //  If product was less than remainder at the last compare:
                                            //    Compare new remainder and divisor.
                                            //    If remainder is greater than divisor:
                                            //      Subtract divisor from remainder, increment trial digit.
                                            if (n > 1) {
                                                // n may be > base only when base is 3.
                                                if (n >= base) n = base - 1;
                                                // product = divisor * trial digit.
                                                prod = multiply(yc, n, base);
                                                prodL = prod.length;
                                                remL = rem.length;
                                                // Compare product and remainder.
                                                // If product > remainder then trial digit n too high.
                                                // n is 1 too high about 5% of the time, and is not known to have
                                                // ever been more than 1 too high.
                                                while(compare(prod, rem, prodL, remL) == 1){
                                                    n--;
                                                    // Subtract divisor from product.
                                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                                    prodL = prod.length;
                                                    cmp = 1;
                                                }
                                            } else {
                                                // n is 0 or 1, cmp is -1.
                                                // If n is 0, there is no need to compare yc and rem again below,
                                                // so change cmp to 1 to avoid it.
                                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                                cmp = n = 1;
                                                // product = divisor
                                                prod = yc.slice();
                                                prodL = prod.length;
                                            }
                                            if (prodL < remL) prod = [
                                                0
                                            ].concat(prod);
                                            // Subtract product from remainder.
                                            subtract(rem, prod, remL, base);
                                            remL = rem.length;
                                            // If product was < remainder.
                                            if (cmp == -1) // Compare divisor and new remainder.
                                            // If divisor < new remainder, subtract divisor from remainder.
                                            // Trial digit n too low.
                                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                            while(compare(yc, rem, yL, remL) < 1){
                                                n++;
                                                // Subtract divisor from remainder.
                                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                                remL = rem.length;
                                            }
                                        } else if (cmp === 0) {
                                            n++;
                                            rem = [
                                                0
                                            ];
                                        } // else cmp === 1 and n will be 0
                                        // Add the next digit, n, to the result array.
                                        qc[i++] = n;
                                        // Update the remainder.
                                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                                        else {
                                            rem = [
                                                xc[xi]
                                            ];
                                            remL = 1;
                                        }
                                    }while ((xi++ < xL || rem[0] != null) && s--);
                                    more = rem[0] != null;
                                    // Leading zero?
                                    if (!qc[0]) qc.splice(0, 1);
                                }
                                if (base == BASE) {
                                    // To calculate q.e, first get the number of digits of qc[0].
                                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                                // Caller is convertBase.
                                } else {
                                    q.e = e;
                                    q.r = +more;
                                }
                                return q;
                            };
                        }();
                        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
                            var c0, e, ne, len, str;
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            if (!n.c) return n.toString();
                            c0 = n.c[0];
                            ne = n.e;
                            if (i == null) {
                                str = coeffToString(n.c);
                                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
                            } else {
                                n = round(new BigNumber(n), i, rm);
                                // n.e may have changed if the value was rounded up.
                                e = n.e;
                                str = coeffToString(n.c);
                                len = str.length;
                                // toPrecision returns exponential notation if the number of significant digits
                                // specified is less than the number of digits necessary to represent the integer
                                // part of the value in fixed-point notation.
                                // Exponential notation.
                                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                                    // Append zeros?
                                    for(; len < i; str += "0", len++);
                                    str = toExponential(str, e);
                                // Fixed-point notation.
                                } else {
                                    i -= ne;
                                    str = toFixedPoint(str, e, "0");
                                    // Append zeros?
                                    if (e + 1 > len) {
                                        if (--i > 0) for(str += "."; i--; str += "0");
                                    } else {
                                        i += e - len;
                                        if (i > 0) {
                                            if (e + 1 == len) str += ".";
                                            for(; i--; str += "0");
                                        }
                                    }
                                }
                            }
                            return n.s < 0 && c0 ? "-" + str : str;
                        }
                        // Handle BigNumber.max and BigNumber.min.
                        function maxOrMin(args, method) {
                            var m, n, i = 0;
                            if (isArray(args[0])) args = args[0];
                            m = new BigNumber(args[0]);
                            for(; ++i < args.length;){
                                n = new BigNumber(args[i]);
                                // If any number is NaN, return NaN.
                                if (!n.s) {
                                    m = n;
                                    break;
                                } else if (method.call(m, n)) m = n;
                            }
                            return m;
                        }
                        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
                            var i = 1, j = c.length;
                            // Remove trailing zeros.
                            for(; !c[--j]; c.pop());
                            // Calculate the base 10 exponent. First get the number of digits of c[0].
                            for(j = c[0]; j >= 10; j /= 10, i++);
                            // Overflow?
                            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
                            n.c = n.e = null;
                            else if (e < MIN_EXP) // Zero.
                            n.c = [
                                n.e = 0
                            ];
                            else {
                                n.e = e;
                                n.c = c;
                            }
                            return n;
                        }
                        // Handle values that fail the validity test in BigNumber.
                        parseNumeric = function() {
                            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
                            return function(x, str, isNum, b) {
                                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                                // No exception on ±Infinity or NaN.
                                if (isInfinityOrNaN.test(s)) {
                                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                                    x.c = x.e = null;
                                } else {
                                    if (!isNum) {
                                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                                        s = s.replace(basePrefix, function(m, p1, p2) {
                                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                                            return !b || b == base ? p1 : m;
                                        });
                                        if (b) {
                                            base = b;
                                            // E.g. '1.' to '1', '.1' to '0.1'
                                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                                        }
                                        if (str != s) return new BigNumber(s, base);
                                    }
                                    // '[BigNumber Error] Not a number: {n}'
                                    // '[BigNumber Error] Not a base {b} number: {n}'
                                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                                    // NaN
                                    x.c = x.e = x.s = null;
                                }
                            };
                        }();
                        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
                            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
                            // if x is not Infinity or NaN...
                            if (xc) {
                                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                                // ni is the index of n within x.c.
                                // d is the number of digits of n.
                                // i is the index of rd within n including leading zeros.
                                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                                out: {
                                    // Get the number of digits of the first element of xc.
                                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                                    i = sd - d;
                                    // If the rounding digit is in the first element of xc...
                                    if (i < 0) {
                                        i += LOG_BASE;
                                        j = sd;
                                        n = xc[ni = 0];
                                        // Get the rounding digit at index j of n.
                                        rd = n / pows10[d - j - 1] % 10 | 0;
                                    } else {
                                        ni = mathceil((i + 1) / LOG_BASE);
                                        if (ni >= xc.length) {
                                            if (r) {
                                                // Needed by sqrt.
                                                for(; xc.length <= ni; xc.push(0));
                                                n = rd = 0;
                                                d = 1;
                                                i %= LOG_BASE;
                                                j = i - LOG_BASE + 1;
                                            } else break out;
                                        } else {
                                            n = k = xc[ni];
                                            // Get the number of digits of n.
                                            for(d = 1; k >= 10; k /= 10, d++);
                                            // Get the index of rd within n.
                                            i %= LOG_BASE;
                                            // Get the index of rd within n, adjusted for leading zeros.
                                            // The number of leading zeros of n is given by LOG_BASE - d.
                                            j = i - LOG_BASE + d;
                                            // Get the rounding digit at index j of n.
                                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                                        }
                                    }
                                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                                    if (sd < 1 || !xc[0]) {
                                        xc.length = 0;
                                        if (r) {
                                            // Convert sd to decimal places.
                                            sd -= x.e + 1;
                                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                                            x.e = -sd || 0;
                                        } else // Zero.
                                        xc[0] = x.e = 0;
                                        return x;
                                    }
                                    // Remove excess digits.
                                    if (i == 0) {
                                        xc.length = ni;
                                        k = 1;
                                        ni--;
                                    } else {
                                        xc.length = ni + 1;
                                        k = pows10[LOG_BASE - i];
                                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                                        // j > 0 means i > number of leading zeros of n.
                                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                                    }
                                    // Round up?
                                    if (r) {
                                        for(;;)// If the digit to be rounded up is in the first element of xc...
                                        if (ni == 0) {
                                            // i will be the length of xc[0] before k is added.
                                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                                            j = xc[0] += k;
                                            for(k = 1; j >= 10; j /= 10, k++);
                                            // if i != k the length has increased.
                                            if (i != k) {
                                                x.e++;
                                                if (xc[0] == BASE) xc[0] = 1;
                                            }
                                            break;
                                        } else {
                                            xc[ni] += k;
                                            if (xc[ni] != BASE) break;
                                            xc[ni--] = 0;
                                            k = 1;
                                        }
                                    }
                                    // Remove trailing zeros.
                                    for(i = xc.length; xc[--i] === 0; xc.pop());
                                }
                                // Overflow? Infinity.
                                if (x.e > MAX_EXP) x.c = x.e = null;
                                else if (x.e < MIN_EXP) x.c = [
                                    x.e = 0
                                ];
                            }
                            return x;
                        }
                        // PROTOTYPE/INSTANCE METHODS
                        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
                            var x = new BigNumber(this);
                            if (x.s < 0) x.s = 1;
                            return x;
                        };
                        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
                            return compare(this, new BigNumber(y, b));
                        };
                        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
                            var c, n, v, x = this;
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), dp + x.e + 1, rm);
                            }
                            if (!(c = x.c)) return null;
                            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
                            // Subtract the number of trailing zeros of the last number.
                            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
                            if (n < 0) n = 0;
                            return n;
                        };
                        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
                            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
                        };
                        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
                            return div(this, new BigNumber(y, b), 0, 1);
                        };
                        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
                            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
                            n = new BigNumber(n);
                            // Allow NaN and ±Infinity, but not other non-integers.
                            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
                            if (m != null) m = new BigNumber(m);
                            // Exponent of MAX_SAFE_INTEGER is 15.
                            nIsBig = n.e > 14;
                            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
                            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                                // The sign of the result of pow when x is negative depends on the evenness of n.
                                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                                return m ? y.mod(m) : y;
                            }
                            nIsNeg = n.s < 0;
                            if (m) {
                                // x % m returns NaN if abs(m) is zero, or m is NaN.
                                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                                if (isModExp) x = x.mod(m);
                            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
                            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
                            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                                // If x is negative and n is odd, k = -0, else k = 0.
                                k = x.s < 0 && isOdd(n) ? -0 : 0;
                                // If x >= 1, k = ±Infinity.
                                if (x.e > -1) k = 1 / k;
                                // If n is negative return ±0, else return ±Infinity.
                                return new BigNumber(nIsNeg ? 1 / k : k);
                            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
                            // equates to truncating significant digits to POW_PRECISION + [28, 41],
                            // i.e. there will be a minimum of 28 guard digits retained.
                            k = mathceil(POW_PRECISION / LOG_BASE + 2);
                            if (nIsBig) {
                                half = new BigNumber(0.5);
                                nIsOdd = isOdd(n);
                            } else nIsOdd = n % 2;
                            if (nIsNeg) n.s = 1;
                            y = new BigNumber(ONE);
                            // Performs 54 loop iterations for n of 9007199254740991.
                            for(;;){
                                if (nIsOdd) {
                                    y = y.times(x);
                                    if (!y.c) break;
                                    if (k) {
                                        if (y.c.length > k) y.c.length = k;
                                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                                }
                                if (nIsBig) {
                                    n = n.times(half);
                                    round(n, n.e + 1, 1);
                                    if (!n.c[0]) break;
                                    nIsBig = n.e > 14;
                                    nIsOdd = isOdd(n);
                                } else {
                                    n = mathfloor(n / 2);
                                    if (!n) break;
                                    nIsOdd = n % 2;
                                }
                                x = x.times(x);
                                if (k) {
                                    if (x.c && x.c.length > k) x.c.length = k;
                                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
                            }
                            if (isModExp) return y;
                            if (nIsNeg) y = ONE.div(y);
                            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
                            var n = new BigNumber(this);
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            return round(n, n.e + 1, rm);
                        };
                        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
                            return compare(this, new BigNumber(y, b)) === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
                            return !!this.c;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
                            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
                        };
                        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
                            return !this.s;
                        };
                        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
                            return this.s < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
                            return this.s > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
                            return !!this.c && this.c[0] == 0;
                        };
                        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
                            var i, j, t, xLTy, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.plus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Either Infinity?
                                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                                // Either zero?
                                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                                ROUNDING_MODE == 3 ? -0 : 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Determine which is the bigger number.
                            if (a = xe - ye) {
                                if (xLTy = a < 0) {
                                    a = -a;
                                    t = xc;
                                } else {
                                    ye = xe;
                                    t = yc;
                                }
                                t.reverse();
                                // Prepend zeros to equalise exponents.
                                for(b = a; b--; t.push(0));
                                t.reverse();
                            } else {
                                // Exponents equal. Check digit by digit.
                                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                                    xLTy = xc[b] < yc[b];
                                    break;
                                }
                            }
                            // x < y? Point xc to the array of the bigger number.
                            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
                            b = (j = yc.length) - (i = xc.length);
                            // Append zeros to xc if shorter.
                            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
                            if (b > 0) for(; b--; xc[i++] = 0);
                            b = BASE - 1;
                            // Subtract yc from xc.
                            for(; j > a;){
                                if (xc[--j] < yc[j]) {
                                    for(i = j; i && !xc[--i]; xc[i] = b);
                                    --xc[i];
                                    xc[j] += BASE;
                                }
                                xc[j] -= yc[j];
                            }
                            // Remove leading zeros and adjust exponent accordingly.
                            for(; xc[0] == 0; xc.splice(0, 1), --ye);
                            // Zero?
                            if (!xc[0]) {
                                // Following IEEE 754 (2008) 6.3,
                                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                                y.c = [
                                    y.e = 0
                                ];
                                return y;
                            }
                            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
                            // for finite x and y.
                            return normalise(y, xc, ye);
                        };
                        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
                            var q, s, x = this;
                            y = new BigNumber(y, b);
                            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
                            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
                            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
                            if (MODULO_MODE == 9) {
                                // Euclidian division: q = sign(y) * floor(x / abs(y))
                                // r = x - qy    where  0 <= r < abs(y)
                                s = y.s;
                                y.s = 1;
                                q = div(x, y, 0, 3);
                                y.s = s;
                                q.s *= s;
                            } else q = div(x, y, 0, MODULO_MODE);
                            y = x.minus(q.times(y));
                            // To match JavaScript %, ensure sign of zero is sign of dividend.
                            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
                            return y;
                        };
                        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
                            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
                            // Either NaN, ±Infinity or ±0?
                            if (!xc || !yc || !xc[0] || !yc[0]) {
                                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                                else {
                                    y.s *= x.s;
                                    // Return ±Infinity if either is ±Infinity.
                                    if (!xc || !yc) y.c = y.e = null;
                                    else {
                                        y.c = [
                                            0
                                        ];
                                        y.e = 0;
                                    }
                                }
                                return y;
                            }
                            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
                            y.s *= x.s;
                            xcL = xc.length;
                            ycL = yc.length;
                            // Ensure xc points to longer array and xcL to its length.
                            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
                            // Initialise the result array with zeros.
                            for(i = xcL + ycL, zc = []; i--; zc.push(0));
                            base = BASE;
                            sqrtBase = SQRT_BASE;
                            for(i = ycL; --i >= 0;){
                                c = 0;
                                ylo = yc[i] % sqrtBase;
                                yhi = yc[i] / sqrtBase | 0;
                                for(k = xcL, j = i + k; j > i;){
                                    xlo = xc[--k] % sqrtBase;
                                    xhi = xc[k] / sqrtBase | 0;
                                    m = yhi * xlo + xhi * ylo;
                                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                                    zc[j--] = xlo % base;
                                }
                                zc[j] = c;
                            }
                            if (c) ++e;
                            else zc.splice(0, 1);
                            return normalise(y, zc, e);
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
                            var x = new BigNumber(this);
                            x.s = -x.s || null;
                            return x;
                        };
                        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
                            var t, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.minus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Return ±Infinity if either ±Infinity.
                                if (!xc || !yc) return new BigNumber(a / 0);
                                // Either zero?
                                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
                            if (a = xe - ye) {
                                if (a > 0) {
                                    ye = xe;
                                    t = yc;
                                } else {
                                    a = -a;
                                    t = xc;
                                }
                                t.reverse();
                                for(; a--; t.push(0));
                                t.reverse();
                            }
                            a = xc.length;
                            b = yc.length;
                            // Point xc to the longer array, and b to the shorter length.
                            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
                            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
                            for(a = 0; b;){
                                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
                            }
                            if (a) {
                                xc = [
                                    a
                                ].concat(xc);
                                ++ye;
                            }
                            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
                            // ye = MAX_EXP + 1 possible
                            return normalise(y, xc, ye);
                        };
                        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
                            var c, n, v, x = this;
                            if (sd != null && sd !== !!sd) {
                                intCheck(sd, 1, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), sd, rm);
                            }
                            if (!(c = x.c)) return null;
                            v = c.length - 1;
                            n = v * LOG_BASE + 1;
                            if (v = c[v]) {
                                // Subtract the number of trailing zeros of the last element.
                                for(; v % 10 == 0; v /= 10, n--);
                                // Add the number of digits of the first element.
                                for(v = c[0]; v >= 10; v /= 10, n++);
                            }
                            if (sd && x.e + 1 > n) n = x.e + 1;
                            return n;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
                            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
                            return this.times("1e" + k);
                        };
                        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
                            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
                            // Negative/NaN/Infinity/zero?
                            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
                            // Initial estimate.
                            s = Math.sqrt(+x);
                            // Math.sqrt underflow/overflow?
                            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
                            if (s == 0 || s == 1 / 0) {
                                n = coeffToString(c);
                                if ((n.length + e) % 2 == 0) n += "0";
                                s = Math.sqrt(n);
                                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                                if (s == 1 / 0) n = "1e" + e;
                                else {
                                    n = s.toExponential();
                                    n = n.slice(0, n.indexOf("e") + 1) + e;
                                }
                                r = new BigNumber(n);
                            } else r = new BigNumber(s + "");
                            // Check for zero.
                            // r could be zero if MIN_EXP is changed after the this value was created.
                            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
                            // coeffToString to throw.
                            if (r.c[0]) {
                                e = r.e;
                                s = e + dp;
                                if (s < 3) s = 0;
                                // Newton-Raphson iteration.
                                for(;;){
                                    t = r;
                                    r = half.times(t.plus(div(x, t, dp, 1)));
                                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                                        // The exponent of r may here be one less than the final result exponent,
                                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                                        // are indexed correctly.
                                        if (r.e < e) --s;
                                        n = n.slice(s - 3, s + 1);
                                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                                        // iteration.
                                        if (n == "9999" || !rep && n == "4999") {
                                            // On the first iteration only, check to see if rounding up gives the
                                            // exact result as the nines may infinitely repeat.
                                            if (!rep) {
                                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                                if (t.times(t).eq(x)) {
                                                    r = t;
                                                    break;
                                                }
                                            }
                                            dp += 4;
                                            s += 4;
                                            rep = 1;
                                        } else {
                                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                                            // result. If not, then there are further digits and m will be truthy.
                                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                                // Truncate to the first rounding digit.
                                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                                m = !r.times(r).eq(x);
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
                        };
                        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp++;
                            }
                            return format(this, dp, rm, 1);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp = dp + this.e + 1;
                            }
                            return format(this, dp, rm);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
                            var str = this.toFixed(dp, rm);
                            if (this.c) {
                                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                                if (g1 > 0 && len > 0) {
                                    i = len % g1 || g1;
                                    intPart = intDigits.substr(0, i);
                                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                                    if (isNeg) intPart = "-" + intPart;
                                }
                                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
                            }
                            return str;
                        };
                        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
                            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
                            if (md != null) {
                                n = new BigNumber(md);
                                // Throw if md is less than one or is not an integer, unless it is Infinity.
                                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
                            }
                            if (!xc) return x.toString();
                            d = new BigNumber(ONE);
                            n1 = d0 = new BigNumber(ONE);
                            d1 = n0 = new BigNumber(ONE);
                            s = coeffToString(xc);
                            // Determine initial denominator.
                            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
                            e = d.e = s.length - x.e - 1;
                            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
                            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
                            exp = MAX_EXP;
                            MAX_EXP = 1 / 0;
                            n = new BigNumber(s);
                            // n0 = d1 = 0
                            n0.c[0] = 0;
                            for(;;){
                                q = div(n, d, 0, 1);
                                d2 = d0.plus(q.times(d1));
                                if (d2.comparedTo(md) == 1) break;
                                d0 = d1;
                                d1 = d2;
                                n1 = n0.plus(q.times(d2 = n1));
                                n0 = d2;
                                d = n.minus(q.times(d2 = d));
                                n = d2;
                            }
                            d2 = div(md.minus(d0), d1, 0, 1);
                            n0 = n0.plus(d2.times(n1));
                            d0 = d0.plus(d2.times(d1));
                            n0.s = n1.s = x.s;
                            e *= 2;
                            // Determine which fraction is closer to x, n0/d0 or n1/d1
                            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                                n1.toString(),
                                d1.toString()
                            ] : [
                                n0.toString(),
                                d0.toString()
                            ];
                            MAX_EXP = exp;
                            return arr;
                        };
                        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
                            return +this;
                        };
                        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
                            if (sd != null) intCheck(sd, 1, MAX);
                            return format(this, sd, rm, 2);
                        };
                        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
                            var str, n = this, s = n.s, e = n.e;
                            // Infinity or NaN?
                            if (e === null) {
                                if (s) {
                                    str = "Infinity";
                                    if (s < 0) str = "-" + str;
                                } else str = "NaN";
                            } else {
                                str = coeffToString(n.c);
                                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                                else {
                                    intCheck(b, 2, ALPHABET.length, "Base");
                                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                                }
                                if (s < 0 && n.c[0]) str = "-" + str;
                            }
                            return str;
                        };
                        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
                            var str, n = this, e = n.e;
                            if (e === null) return n.toString();
                            str = coeffToString(n.c);
                            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                            return n.s < 0 ? "-" + str : str;
                        };
                        P._isBigNumber = true;
                        if (configObject != null) BigNumber.set(configObject);
                        return BigNumber;
                    }
                    // PRIVATE HELPER FUNCTIONS
                    function bitFloor(n) {
                        var i = n | 0;
                        return n > 0 || n === i ? i : i - 1;
                    }
                    // Return a coefficient array as a string of base 10 digits.
                    function coeffToString(a) {
                        var s, z, i = 1, j = a.length, r = a[0] + "";
                        for(; i < j;){
                            s = a[i++] + "";
                            z = LOG_BASE - s.length;
                            for(; z--; s = "0" + s);
                            r += s;
                        }
                        // Determine trailing zeros.
                        for(j = r.length; r.charCodeAt(--j) === 48;);
                        return r.slice(0, j + 1 || 1);
                    }
                    // Compare the value of BigNumbers x and y.
                    function compare(x, y) {
                        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
                        // Either NaN?
                        if (!i || !j) return null;
                        a = xc && !xc[0];
                        b = yc && !yc[0];
                        // Either zero?
                        if (a || b) return a ? b ? 0 : -j : i;
                        // Signs differ?
                        if (i != j) return i;
                        a = i < 0;
                        b = k == l;
                        // Either Infinity?
                        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
                        // Compare exponents.
                        if (!b) return k > l ^ a ? 1 : -1;
                        j = (k = xc.length) < (l = yc.length) ? k : l;
                        // Compare digit by digit.
                        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
                        // Compare lengths.
                        return k == l ? 0 : k > l ^ a ? 1 : -1;
                    }
                    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name1) {
                        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name1 || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
                    }
                    function isArray(obj) {
                        return Object.prototype.toString.call(obj) == "[object Array]";
                    }
                    // Assumes finite n.
                    function isOdd(n) {
                        var k = n.c.length - 1;
                        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
                    }
                    function toExponential(str, e) {
                        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
                    }
                    function toFixedPoint(str, e, z) {
                        var len, zs;
                        // Negative exponent?
                        if (e < 0) {
                            // Prepend zeros.
                            for(zs = z + "."; ++e; zs += z);
                            str = zs + str;
                        // Positive exponent
                        } else {
                            len = str.length;
                            // Append zeros.
                            if (++e > len) {
                                for(zs = z, e -= len; --e; zs += z);
                                str += zs;
                            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                        }
                        return str;
                    }
                    // EXPORT
                    BigNumber = clone();
                    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return BigNumber;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 7318: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // Blake2B in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(1022);
                // 64-bit unsigned addition
                // Sets v[a,a+1] += v[b,b+1]
                // v should be a Uint32Array
                function ADD64AA(v, a, b) {
                    const o0 = v[a] + v[b];
                    let o1 = v[a + 1] + v[b + 1];
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // 64-bit unsigned addition
                // Sets v[a,a+1] += b
                // b0 is the low 32 bits of b, b1 represents the high 32 bits
                function ADD64AC(v, a, b0, b1) {
                    let o0 = v[a] + b0;
                    if (b0 < 0) o0 += 0x100000000;
                    let o1 = v[a + 1] + b1;
                    if (o0 >= 0x100000000) o1++;
                    v[a] = o0;
                    v[a + 1] = o1;
                }
                // Little-endian byte access
                function B2B_GET32(arr, i) {
                    return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
                }
                // G Mixing function
                // The ROTRs are inlined for speed
                function B2B_G(a, b, c, d, ix, iy) {
                    const x0 = m[ix];
                    const x1 = m[ix + 1];
                    const y0 = m[iy];
                    const y1 = m[iy + 1];
                    ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
                    ;
                    ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits
                    ;
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
                    let xor0 = v[d] ^ v[a];
                    let xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor1;
                    v[d + 1] = xor0;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor0 >>> 24 ^ xor1 << 8;
                    v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
                    ADD64AA(v, a, b);
                    ADD64AC(v, a, y0, y1);
                    // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
                    xor0 = v[d] ^ v[a];
                    xor1 = v[d + 1] ^ v[a + 1];
                    v[d] = xor0 >>> 16 ^ xor1 << 16;
                    v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
                    ADD64AA(v, c, d);
                    // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
                    xor0 = v[b] ^ v[c];
                    xor1 = v[b + 1] ^ v[c + 1];
                    v[b] = xor1 >>> 31 ^ xor0 << 1;
                    v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
                }
                // Initialization Vector
                const BLAKE2B_IV32 = new Uint32Array([
                    0xf3bcc908,
                    0x6a09e667,
                    0x84caa73b,
                    0xbb67ae85,
                    0xfe94f82b,
                    0x3c6ef372,
                    0x5f1d36f1,
                    0xa54ff53a,
                    0xade682d1,
                    0x510e527f,
                    0x2b3e6c1f,
                    0x9b05688c,
                    0xfb41bd6b,
                    0x1f83d9ab,
                    0x137e2179,
                    0x5be0cd19
                ]);
                const SIGMA8 = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ];
                // These are offsets into a uint64 buffer.
                // Multiply them all by 2 to make them offsets into a uint32 buffer,
                // because this is Javascript and we don't have uint64s
                const SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
                    return x * 2;
                }));
                // Compression function. 'last' flag indicates last block.
                // Note we're representing 16 uint64s as 32 uint32s
                const v = new Uint32Array(32);
                const m = new Uint32Array(32);
                function blake2bCompress(ctx, last) {
                    let i = 0;
                    // init work variables
                    for(i = 0; i < 16; i++){
                        v[i] = ctx.h[i];
                        v[i + 16] = BLAKE2B_IV32[i];
                    }
                    // low 64 bits of offset
                    v[24] = v[24] ^ ctx.t;
                    v[25] = v[25] ^ ctx.t / 0x100000000;
                    // high 64 bits not supported, offset may not be higher than 2**53-1
                    // last block flag set ?
                    if (last) {
                        v[28] = ~v[28];
                        v[29] = ~v[29];
                    }
                    // get little-endian words
                    for(i = 0; i < 32; i++)m[i] = B2B_GET32(ctx.b, 4 * i);
                    // twelve rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 64)
                    for(i = 0; i < 12; i++){
                        // util.debugPrint('   (i=' + (i < 10 ? ' ' : '') + i + ') v[16]', v, 64)
                        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
                        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
                        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
                        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
                        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
                        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
                        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
                        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
                    }
                    // util.debugPrint('   (i=12) v[16]', v, 64)
                    for(i = 0; i < 16; i++)ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
                // util.debugPrint('h[8]', ctx.h, 64)
                }
                // Creates a BLAKE2b hashing context
                // Requires an output length between 1 and 64 bytes
                // Takes an optional Uint8Array key
                function blake2bInit(outlen, key) {
                    if (outlen === 0 || outlen > 64) throw new Error("Illegal output length, expected 0 < length <= 64");
                    if (key && key.length > 64) throw new Error("Illegal key, expected Uint8Array with 0 < length <= 64");
                    // state, 'param block'
                    const ctx = {
                        b: new Uint8Array(128),
                        h: new Uint32Array(16),
                        t: 0,
                        c: 0,
                        outlen: outlen // output length in bytes
                    };
                    // initialize hash state
                    for(let i = 0; i < 16; i++)ctx.h[i] = BLAKE2B_IV32[i];
                    const keylen = key ? key.length : 0;
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    // key the hash, if applicable
                    if (key) {
                        blake2bUpdate(ctx, key);
                        // at the end
                        ctx.c = 128;
                    }
                    return ctx;
                }
                // Updates a BLAKE2b streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2bUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 128) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2bCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2b streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2bFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 128)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2bCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
                    return out;
                }
                // Computes the BLAKE2B hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2b(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 64;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2bInit(outlen, key);
                    blake2bUpdate(ctx, input);
                    return blake2bFinal(ctx);
                }
                // Computes the BLAKE2B hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 64 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2bHex(input, key, outlen) {
                    const output = blake2b(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2b: blake2b,
                    blake2bHex: blake2bHex,
                    blake2bInit: blake2bInit,
                    blake2bUpdate: blake2bUpdate,
                    blake2bFinal: blake2bFinal
                };
            /***/ },
            /***/ 8855: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // BLAKE2s hash function in pure Javascript
                // Adapted from the reference implementation in RFC7693
                // Ported to Javascript by DC - https://github.com/dcposch
                const util = __webpack_require__(1022);
                // Little-endian byte access.
                // Expects a Uint8Array and an index
                // Returns the little-endian uint32 at v[i..i+3]
                function B2S_GET32(v, i) {
                    return v[i] ^ v[i + 1] << 8 ^ v[i + 2] << 16 ^ v[i + 3] << 24;
                }
                // Mixing function G.
                function B2S_G(a, b, c, d, x, y) {
                    v[a] = v[a] + v[b] + x;
                    v[d] = ROTR32(v[d] ^ v[a], 16);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 12);
                    v[a] = v[a] + v[b] + y;
                    v[d] = ROTR32(v[d] ^ v[a], 8);
                    v[c] = v[c] + v[d];
                    v[b] = ROTR32(v[b] ^ v[c], 7);
                }
                // 32-bit right rotation
                // x should be a uint32
                // y must be between 1 and 31, inclusive
                function ROTR32(x, y) {
                    return x >>> y ^ x << 32 - y;
                }
                // Initialization Vector.
                const BLAKE2S_IV = new Uint32Array([
                    0x6a09e667,
                    0xbb67ae85,
                    0x3c6ef372,
                    0xa54ff53a,
                    0x510e527f,
                    0x9b05688c,
                    0x1f83d9ab,
                    0x5be0cd19
                ]);
                const SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0
                ]);
                // Compression function. "last" flag indicates last block
                const v = new Uint32Array(16);
                const m = new Uint32Array(16);
                function blake2sCompress(ctx, last) {
                    let i = 0;
                    for(i = 0; i < 8; i++){
                        // init work variables
                        v[i] = ctx.h[i];
                        v[i + 8] = BLAKE2S_IV[i];
                    }
                    v[12] ^= ctx.t // low 32 bits of offset
                    ;
                    v[13] ^= ctx.t / 0x100000000 // high 32 bits
                    ;
                    if (last) // last block flag set ?
                    v[14] = ~v[14];
                    for(i = 0; i < 16; i++)// get little-endian words
                    m[i] = B2S_GET32(ctx.b, 4 * i);
                    // ten rounds of mixing
                    // uncomment the DebugPrint calls to log the computation
                    // and match the RFC sample documentation
                    // util.debugPrint('          m[16]', m, 32)
                    for(i = 0; i < 10; i++){
                        // util.debugPrint('   (i=' + i + ')  v[16]', v, 32)
                        B2S_G(0, 4, 8, 12, m[SIGMA[i * 16 + 0]], m[SIGMA[i * 16 + 1]]);
                        B2S_G(1, 5, 9, 13, m[SIGMA[i * 16 + 2]], m[SIGMA[i * 16 + 3]]);
                        B2S_G(2, 6, 10, 14, m[SIGMA[i * 16 + 4]], m[SIGMA[i * 16 + 5]]);
                        B2S_G(3, 7, 11, 15, m[SIGMA[i * 16 + 6]], m[SIGMA[i * 16 + 7]]);
                        B2S_G(0, 5, 10, 15, m[SIGMA[i * 16 + 8]], m[SIGMA[i * 16 + 9]]);
                        B2S_G(1, 6, 11, 12, m[SIGMA[i * 16 + 10]], m[SIGMA[i * 16 + 11]]);
                        B2S_G(2, 7, 8, 13, m[SIGMA[i * 16 + 12]], m[SIGMA[i * 16 + 13]]);
                        B2S_G(3, 4, 9, 14, m[SIGMA[i * 16 + 14]], m[SIGMA[i * 16 + 15]]);
                    }
                    // util.debugPrint('   (i=10) v[16]', v, 32)
                    for(i = 0; i < 8; i++)ctx.h[i] ^= v[i] ^ v[i + 8];
                // util.debugPrint('h[8]', ctx.h, 32)
                }
                // Creates a BLAKE2s hashing context
                // Requires an output length between 1 and 32 bytes
                // Takes an optional Uint8Array key
                function blake2sInit(outlen, key) {
                    if (!(outlen > 0 && outlen <= 32)) throw new Error("Incorrect output length, should be in [1, 32]");
                    const keylen = key ? key.length : 0;
                    if (key && !(keylen > 0 && keylen <= 32)) throw new Error("Incorrect key length, should be in [1, 32]");
                    const ctx = {
                        h: new Uint32Array(BLAKE2S_IV),
                        b: new Uint8Array(64),
                        c: 0,
                        t: 0,
                        outlen: outlen // output length in bytes
                    };
                    ctx.h[0] ^= 0x01010000 ^ keylen << 8 ^ outlen;
                    if (keylen > 0) {
                        blake2sUpdate(ctx, key);
                        ctx.c = 64 // at the end
                        ;
                    }
                    return ctx;
                }
                // Updates a BLAKE2s streaming hash
                // Requires hash context and Uint8Array (byte array)
                function blake2sUpdate(ctx, input) {
                    for(let i = 0; i < input.length; i++){
                        if (ctx.c === 64) {
                            // buffer full ?
                            ctx.t += ctx.c // add counters
                            ;
                            blake2sCompress(ctx, false) // compress (not last)
                            ;
                            ctx.c = 0 // counter to zero
                            ;
                        }
                        ctx.b[ctx.c++] = input[i];
                    }
                }
                // Completes a BLAKE2s streaming hash
                // Returns a Uint8Array containing the message digest
                function blake2sFinal(ctx) {
                    ctx.t += ctx.c // mark last block offset
                    ;
                    while(ctx.c < 64)// fill up with zeros
                    ctx.b[ctx.c++] = 0;
                    blake2sCompress(ctx, true) // final block flag = 1
                    ;
                    // little endian convert and store
                    const out = new Uint8Array(ctx.outlen);
                    for(let i = 0; i < ctx.outlen; i++)out[i] = ctx.h[i >> 2] >> 8 * (i & 3) & 0xff;
                    return out;
                }
                // Computes the BLAKE2S hash of a string or byte array, and returns a Uint8Array
                //
                // Returns a n-byte Uint8Array
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2s(input, key, outlen) {
                    // preprocess inputs
                    outlen = outlen || 32;
                    input = util.normalizeInput(input);
                    // do the math
                    const ctx = blake2sInit(outlen, key);
                    blake2sUpdate(ctx, input);
                    return blake2sFinal(ctx);
                }
                // Computes the BLAKE2S hash of a string or byte array
                //
                // Returns an n-byte hash in hex, all lowercase
                //
                // Parameters:
                // - input - the input bytes, as a string, Buffer, or Uint8Array
                // - key - optional key Uint8Array, up to 32 bytes
                // - outlen - optional output length in bytes, default 64
                function blake2sHex(input, key, outlen) {
                    const output = blake2s(input, key, outlen);
                    return util.toHex(output);
                }
                module1.exports = {
                    blake2s: blake2s,
                    blake2sHex: blake2sHex,
                    blake2sInit: blake2sInit,
                    blake2sUpdate: blake2sUpdate,
                    blake2sFinal: blake2sFinal
                };
            /***/ },
            /***/ 1161: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                const b2b = __webpack_require__(7318);
                const b2s = __webpack_require__(8855);
                module1.exports = {
                    blake2b: b2b.blake2b,
                    blake2bHex: b2b.blake2bHex,
                    blake2bInit: b2b.blake2bInit,
                    blake2bUpdate: b2b.blake2bUpdate,
                    blake2bFinal: b2b.blake2bFinal,
                    blake2s: b2s.blake2s,
                    blake2sHex: b2s.blake2sHex,
                    blake2sInit: b2s.blake2sInit,
                    blake2sUpdate: b2s.blake2sUpdate,
                    blake2sFinal: b2s.blake2sFinal
                };
            /***/ },
            /***/ 1022: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];
                const ERROR_MSG_INPUT = "Input must be an string, Buffer or Uint8Array";
                // For convenience, let people hash a string, not just a Uint8Array
                function normalizeInput(input) {
                    let ret;
                    if (input instanceof Uint8Array) ret = input;
                    else if (input instanceof Buffer) ret = new Uint8Array(input);
                    else if (typeof input === "string") ret = new Uint8Array(Buffer.from(input, "utf8"));
                    else throw new Error(ERROR_MSG_INPUT);
                    return ret;
                }
                // Converts a Uint8Array to a hexadecimal string
                // For example, toHex([255, 0, 255]) returns "ff00ff"
                function toHex(bytes) {
                    return Array.prototype.map.call(bytes, function(n) {
                        return (n < 16 ? "0" : "") + n.toString(16);
                    }).join("");
                }
                // Converts any value in [0...2^32-1] to an 8-character hex string
                function uint32ToHex(val) {
                    return (0x100000000 + val).toString(16).substring(1);
                }
                // For debugging: prints out hash state in the same format as the RFC
                // sample computation exactly, so that you can diff
                function debugPrint(label, arr, size) {
                    let msg = "\n" + label + " = ";
                    for(let i = 0; i < arr.length; i += 2){
                        if (size === 32) {
                            msg += uint32ToHex(arr[i]).toUpperCase();
                            msg += " ";
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                        } else if (size === 64) {
                            msg += uint32ToHex(arr[i + 1]).toUpperCase();
                            msg += uint32ToHex(arr[i]).toUpperCase();
                        } else throw new Error("Invalid size " + size);
                        if (i % 6 === 4) msg += "\n" + new Array(label.length + 4).join(" ");
                        else if (i < arr.length - 2) msg += " ";
                    }
                    console.log(msg);
                }
                // For performance testing: generates N bytes of input, hashes M times
                // Measures and prints MB/second hash performance each time
                function testSpeed(hashFn, N, M) {
                    let startMs = new Date().getTime();
                    const input = new Uint8Array(N);
                    for(let i = 0; i < N; i++)input[i] = i % 256;
                    const genMs = new Date().getTime();
                    console.log("Generated random input in " + (genMs - startMs) + "ms");
                    startMs = genMs;
                    for(let i = 0; i < M; i++){
                        const hashHex = hashFn(input);
                        const hashMs = new Date().getTime();
                        const ms = hashMs - startMs;
                        startMs = hashMs;
                        console.log("Hashed in " + ms + "ms: " + hashHex.substring(0, 20) + "...");
                        console.log(Math.round(N / 1048576 / (ms / 1000) * 100) / 100 + " MB PER SECOND");
                    }
                }
                module1.exports = {
                    normalizeInput: normalizeInput,
                    toHex: toHex,
                    debugPrint: debugPrint,
                    testSpeed: testSpeed
                };
            /***/ },
            /***/ 9347: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                // https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
                var ws = null;
                if (typeof WebSocket !== "undefined") ws = WebSocket;
                else if (typeof MozWebSocket !== "undefined") ws = MozWebSocket;
                else if (typeof __webpack_require__.g !== "undefined") ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket;
                else if (typeof window !== "undefined") ws = window.WebSocket || window.MozWebSocket;
                else if (typeof self !== "undefined") ws = self.WebSocket || self.MozWebSocket;
                module1.exports = ws;
            /***/ },
            /***/ 9992: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                // A linked list to keep track of recently-used-ness
                const Yallist = __webpack_require__(7279);
                const MAX = Symbol("max");
                const LENGTH = Symbol("length");
                const LENGTH_CALCULATOR = Symbol("lengthCalculator");
                const ALLOW_STALE = Symbol("allowStale");
                const MAX_AGE = Symbol("maxAge");
                const DISPOSE = Symbol("dispose");
                const NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
                const LRU_LIST = Symbol("lruList");
                const CACHE = Symbol("cache");
                const UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
                const naiveLength = ()=>1;
                // lruList is a yallist where the head is the youngest
                // item, and the tail is the oldest.  the list contains the Hit
                // objects as the entries.
                // Each Hit object has a reference to its Yallist.Node.  This
                // never changes.
                //
                // cache is a Map (or PseudoMap) that matches the keys to
                // the Yallist.Node object.
                class LRUCache {
                    constructor(options){
                        if (typeof options === "number") options = {
                            max: options
                        };
                        if (!options) options = {};
                        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
                        // Kind of weird to have a default max of Infinity, but oh well.
                        const max = this[MAX] = options.max || Infinity;
                        const lc = options.length || naiveLength;
                        this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
                        this[ALLOW_STALE] = options.stale || false;
                        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
                        this[MAX_AGE] = options.maxAge || 0;
                        this[DISPOSE] = options.dispose;
                        this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
                        this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
                        this.reset();
                    }
                    // resize the cache when the max changes.
                    set max(mL) {
                        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
                        this[MAX] = mL || Infinity;
                        trim(this);
                    }
                    get max() {
                        return this[MAX];
                    }
                    set allowStale(allowStale) {
                        this[ALLOW_STALE] = !!allowStale;
                    }
                    get allowStale() {
                        return this[ALLOW_STALE];
                    }
                    set maxAge(mA) {
                        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
                        this[MAX_AGE] = mA;
                        trim(this);
                    }
                    get maxAge() {
                        return this[MAX_AGE];
                    }
                    // resize the cache when the lengthCalculator changes.
                    set lengthCalculator(lC) {
                        if (typeof lC !== "function") lC = naiveLength;
                        if (lC !== this[LENGTH_CALCULATOR]) {
                            this[LENGTH_CALCULATOR] = lC;
                            this[LENGTH] = 0;
                            this[LRU_LIST].forEach((hit)=>{
                                hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
                                this[LENGTH] += hit.length;
                            });
                        }
                        trim(this);
                    }
                    get lengthCalculator() {
                        return this[LENGTH_CALCULATOR];
                    }
                    get length() {
                        return this[LENGTH];
                    }
                    get itemCount() {
                        return this[LRU_LIST].length;
                    }
                    rforEach(fn, thisp) {
                        thisp = thisp || this;
                        for(let walker = this[LRU_LIST].tail; walker !== null;){
                            const prev = walker.prev;
                            forEachStep(this, fn, walker, thisp);
                            walker = prev;
                        }
                    }
                    forEach(fn, thisp) {
                        thisp = thisp || this;
                        for(let walker = this[LRU_LIST].head; walker !== null;){
                            const next = walker.next;
                            forEachStep(this, fn, walker, thisp);
                            walker = next;
                        }
                    }
                    keys() {
                        return this[LRU_LIST].toArray().map((k)=>k.key);
                    }
                    values() {
                        return this[LRU_LIST].toArray().map((k)=>k.value);
                    }
                    reset() {
                        if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) this[LRU_LIST].forEach((hit)=>this[DISPOSE](hit.key, hit.value));
                        this[CACHE] = new Map() // hash of items by key
                        ;
                        this[LRU_LIST] = new Yallist() // list of items in order of use recency
                        ;
                        this[LENGTH] = 0 // length of items in the list
                        ;
                    }
                    dump() {
                        return this[LRU_LIST].map((hit)=>isStale(this, hit) ? false : {
                                k: hit.key,
                                v: hit.value,
                                e: hit.now + (hit.maxAge || 0)
                            }).toArray().filter((h)=>h);
                    }
                    dumpLru() {
                        return this[LRU_LIST];
                    }
                    set(key, value, maxAge) {
                        maxAge = maxAge || this[MAX_AGE];
                        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
                        const now = maxAge ? Date.now() : 0;
                        const len = this[LENGTH_CALCULATOR](value, key);
                        if (this[CACHE].has(key)) {
                            if (len > this[MAX]) {
                                del(this, this[CACHE].get(key));
                                return false;
                            }
                            const node = this[CACHE].get(key);
                            const item = node.value;
                            // dispose of the old one before overwriting
                            // split out into 2 ifs for better coverage tracking
                            if (this[DISPOSE]) {
                                if (!this[NO_DISPOSE_ON_SET]) this[DISPOSE](key, item.value);
                            }
                            item.now = now;
                            item.maxAge = maxAge;
                            item.value = value;
                            this[LENGTH] += len - item.length;
                            item.length = len;
                            this.get(key);
                            trim(this);
                            return true;
                        }
                        const hit = new Entry(key, value, len, now, maxAge);
                        // oversized objects fall out of cache automatically.
                        if (hit.length > this[MAX]) {
                            if (this[DISPOSE]) this[DISPOSE](key, value);
                            return false;
                        }
                        this[LENGTH] += hit.length;
                        this[LRU_LIST].unshift(hit);
                        this[CACHE].set(key, this[LRU_LIST].head);
                        trim(this);
                        return true;
                    }
                    has(key) {
                        if (!this[CACHE].has(key)) return false;
                        const hit = this[CACHE].get(key).value;
                        return !isStale(this, hit);
                    }
                    get(key) {
                        return get(this, key, true);
                    }
                    peek(key) {
                        return get(this, key, false);
                    }
                    pop() {
                        const node = this[LRU_LIST].tail;
                        if (!node) return null;
                        del(this, node);
                        return node.value;
                    }
                    del(key) {
                        del(this, this[CACHE].get(key));
                    }
                    load(arr) {
                        // reset the cache
                        this.reset();
                        const now = Date.now();
                        // A previous serialized cache has the most recent items first
                        for(let l = arr.length - 1; l >= 0; l--){
                            const hit = arr[l];
                            const expiresAt = hit.e || 0;
                            if (expiresAt === 0) // the item was created without expiration in a non aged cache
                            this.set(hit.k, hit.v);
                            else {
                                const maxAge = expiresAt - now;
                                // dont add already expired items
                                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
                            }
                        }
                    }
                    prune() {
                        this[CACHE].forEach((value, key)=>get(this, key, false));
                    }
                }
                const get = (self1, key, doUse)=>{
                    const node = self1[CACHE].get(key);
                    if (node) {
                        const hit = node.value;
                        if (isStale(self1, hit)) {
                            del(self1, node);
                            if (!self1[ALLOW_STALE]) return undefined;
                        } else if (doUse) {
                            if (self1[UPDATE_AGE_ON_GET]) node.value.now = Date.now();
                            self1[LRU_LIST].unshiftNode(node);
                        }
                        return hit.value;
                    }
                };
                const isStale = (self1, hit)=>{
                    if (!hit || !hit.maxAge && !self1[MAX_AGE]) return false;
                    const diff = Date.now() - hit.now;
                    return hit.maxAge ? diff > hit.maxAge : self1[MAX_AGE] && diff > self1[MAX_AGE];
                };
                const trim = (self1)=>{
                    if (self1[LENGTH] > self1[MAX]) for(let walker = self1[LRU_LIST].tail; self1[LENGTH] > self1[MAX] && walker !== null;){
                        // We know that we're about to delete this one, and also
                        // what the next least recently used key will be, so just
                        // go ahead and set it now.
                        const prev = walker.prev;
                        del(self1, walker);
                        walker = prev;
                    }
                };
                const del = (self1, node)=>{
                    if (node) {
                        const hit = node.value;
                        if (self1[DISPOSE]) self1[DISPOSE](hit.key, hit.value);
                        self1[LENGTH] -= hit.length;
                        self1[CACHE].delete(hit.key);
                        self1[LRU_LIST].removeNode(node);
                    }
                };
                class Entry {
                    constructor(key, value, length, now, maxAge){
                        this.key = key;
                        this.value = value;
                        this.length = length;
                        this.now = now;
                        this.maxAge = maxAge || 0;
                    }
                }
                const forEachStep = (self1, fn, node, thisp)=>{
                    let hit = node.value;
                    if (isStale(self1, hit)) {
                        del(self1, node);
                        if (!self1[ALLOW_STALE]) hit = undefined;
                    }
                    if (hit) fn.call(thisp, hit.value, hit.key, self1);
                };
                module1.exports = LRUCache;
            /***/ },
            /***/ 862: /***/ (module1)=>{
                "use strict";
                module1.exports = function(Yallist) {
                    Yallist.prototype[Symbol.iterator] = function*() {
                        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
                    };
                };
            /***/ },
            /***/ 7279: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                "use strict";
                module1.exports = Yallist;
                Yallist.Node = Node;
                Yallist.create = Yallist;
                function Yallist(list) {
                    var self1 = this;
                    if (!(self1 instanceof Yallist)) self1 = new Yallist();
                    self1.tail = null;
                    self1.head = null;
                    self1.length = 0;
                    if (list && typeof list.forEach === "function") list.forEach(function(item) {
                        self1.push(item);
                    });
                    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self1.push(arguments[i]);
                    return self1;
                }
                Yallist.prototype.removeNode = function(node) {
                    if (node.list !== this) throw new Error("removing node which does not belong to this list");
                    var next = node.next;
                    var prev = node.prev;
                    if (next) next.prev = prev;
                    if (prev) prev.next = next;
                    if (node === this.head) this.head = next;
                    if (node === this.tail) this.tail = prev;
                    node.list.length--;
                    node.next = null;
                    node.prev = null;
                    node.list = null;
                };
                Yallist.prototype.unshiftNode = function(node) {
                    if (node === this.head) return;
                    if (node.list) node.list.removeNode(node);
                    var head = this.head;
                    node.list = this;
                    node.next = head;
                    if (head) head.prev = node;
                    this.head = node;
                    if (!this.tail) this.tail = node;
                    this.length++;
                };
                Yallist.prototype.pushNode = function(node) {
                    if (node === this.tail) return;
                    if (node.list) node.list.removeNode(node);
                    var tail = this.tail;
                    node.list = this;
                    node.prev = tail;
                    if (tail) tail.next = node;
                    this.tail = node;
                    if (!this.head) this.head = node;
                    this.length++;
                };
                Yallist.prototype.push = function() {
                    for(var i = 0, l = arguments.length; i < l; i++)push(this, arguments[i]);
                    return this.length;
                };
                Yallist.prototype.unshift = function() {
                    for(var i = 0, l = arguments.length; i < l; i++)unshift(this, arguments[i]);
                    return this.length;
                };
                Yallist.prototype.pop = function() {
                    if (!this.tail) return undefined;
                    var res = this.tail.value;
                    this.tail = this.tail.prev;
                    if (this.tail) this.tail.next = null;
                    else this.head = null;
                    this.length--;
                    return res;
                };
                Yallist.prototype.shift = function() {
                    if (!this.head) return undefined;
                    var res = this.head.value;
                    this.head = this.head.next;
                    if (this.head) this.head.prev = null;
                    else this.tail = null;
                    this.length--;
                    return res;
                };
                Yallist.prototype.forEach = function(fn, thisp) {
                    thisp = thisp || this;
                    for(var walker = this.head, i = 0; walker !== null; i++){
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.next;
                    }
                };
                Yallist.prototype.forEachReverse = function(fn, thisp) {
                    thisp = thisp || this;
                    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
                        fn.call(thisp, walker.value, i, this);
                        walker = walker.prev;
                    }
                };
                Yallist.prototype.get = function(n) {
                    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
                    walker = walker.next;
                    if (i === n && walker !== null) return walker.value;
                };
                Yallist.prototype.getReverse = function(n) {
                    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
                    walker = walker.prev;
                    if (i === n && walker !== null) return walker.value;
                };
                Yallist.prototype.map = function(fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for(var walker = this.head; walker !== null;){
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.next;
                    }
                    return res;
                };
                Yallist.prototype.mapReverse = function(fn, thisp) {
                    thisp = thisp || this;
                    var res = new Yallist();
                    for(var walker = this.tail; walker !== null;){
                        res.push(fn.call(thisp, walker.value, this));
                        walker = walker.prev;
                    }
                    return res;
                };
                Yallist.prototype.reduce = function(fn, initial) {
                    var acc;
                    var walker = this.head;
                    if (arguments.length > 1) acc = initial;
                    else if (this.head) {
                        walker = this.head.next;
                        acc = this.head.value;
                    } else throw new TypeError("Reduce of empty list with no initial value");
                    for(var i = 0; walker !== null; i++){
                        acc = fn(acc, walker.value, i);
                        walker = walker.next;
                    }
                    return acc;
                };
                Yallist.prototype.reduceReverse = function(fn, initial) {
                    var acc;
                    var walker = this.tail;
                    if (arguments.length > 1) acc = initial;
                    else if (this.tail) {
                        walker = this.tail.prev;
                        acc = this.tail.value;
                    } else throw new TypeError("Reduce of empty list with no initial value");
                    for(var i = this.length - 1; walker !== null; i--){
                        acc = fn(acc, walker.value, i);
                        walker = walker.prev;
                    }
                    return acc;
                };
                Yallist.prototype.toArray = function() {
                    var arr = new Array(this.length);
                    for(var i = 0, walker = this.head; walker !== null; i++){
                        arr[i] = walker.value;
                        walker = walker.next;
                    }
                    return arr;
                };
                Yallist.prototype.toArrayReverse = function() {
                    var arr = new Array(this.length);
                    for(var i = 0, walker = this.tail; walker !== null; i++){
                        arr[i] = walker.value;
                        walker = walker.prev;
                    }
                    return arr;
                };
                Yallist.prototype.slice = function(from, to) {
                    to = to || this.length;
                    if (to < 0) to += this.length;
                    from = from || 0;
                    if (from < 0) from += this.length;
                    var ret = new Yallist();
                    if (to < from || to < 0) return ret;
                    if (from < 0) from = 0;
                    if (to > this.length) to = this.length;
                    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
                    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
                    return ret;
                };
                Yallist.prototype.sliceReverse = function(from, to) {
                    to = to || this.length;
                    if (to < 0) to += this.length;
                    from = from || 0;
                    if (from < 0) from += this.length;
                    var ret = new Yallist();
                    if (to < from || to < 0) return ret;
                    if (from < 0) from = 0;
                    if (to > this.length) to = this.length;
                    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
                    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
                    return ret;
                };
                Yallist.prototype.reverse = function() {
                    var head = this.head;
                    var tail = this.tail;
                    for(var walker = head; walker !== null; walker = walker.prev){
                        var p = walker.prev;
                        walker.prev = walker.next;
                        walker.next = p;
                    }
                    this.head = tail;
                    this.tail = head;
                    return this;
                };
                function push(self1, item) {
                    self1.tail = new Node(item, self1.tail, null, self1);
                    if (!self1.head) self1.head = self1.tail;
                    self1.length++;
                }
                function unshift(self1, item) {
                    self1.head = new Node(item, null, self1.head, self1);
                    if (!self1.tail) self1.tail = self1.head;
                    self1.length++;
                }
                function Node(value, prev, next, list) {
                    if (!(this instanceof Node)) return new Node(value, prev, next, list);
                    this.list = list;
                    this.value = value;
                    if (prev) {
                        prev.next = this;
                        this.prev = prev;
                    } else this.prev = null;
                    if (next) {
                        next.prev = this;
                        this.next = next;
                    } else this.next = null;
                }
                try {
                    // add if support for Symbol.iterator is present
                    __webpack_require__(862)(Yallist);
                } catch (er) {}
            /***/ },
            /***/ 3609: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.version = "4.0.27-5";
            /***/ },
            /***/ 8707: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var bignumber_1 = __webpack_require__(4759);
                var AddressZero = "0x0000000000000000000000000000000000000000";
                exports.AddressZero = AddressZero;
                var HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
                exports.HashZero = HashZero;
                // NFKD (decomposed)
                //const EtherSymbol = '\uD835\uDF63';
                // NFKC (composed)
                var EtherSymbol = "\u039E";
                exports.EtherSymbol = EtherSymbol;
                var NegativeOne = bignumber_1.bigNumberify(-1);
                exports.NegativeOne = NegativeOne;
                var Zero = bignumber_1.bigNumberify(0);
                exports.Zero = Zero;
                var One = bignumber_1.bigNumberify(1);
                exports.One = One;
                var Two = bignumber_1.bigNumberify(2);
                exports.Two = Two;
                var WeiPerEther = bignumber_1.bigNumberify("1000000000000000000");
                exports.WeiPerEther = WeiPerEther;
                var MaxUint256 = bignumber_1.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                exports.MaxUint256 = MaxUint256;
            /***/ },
            /***/ 6459: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _version_1 = __webpack_require__(3609);
                // Unknown Error
                exports.UNKNOWN_ERROR = "UNKNOWN_ERROR";
                // Not implemented
                exports.NOT_IMPLEMENTED = "NOT_IMPLEMENTED";
                // Missing new operator to an object
                //  - name: The name of the class
                exports.MISSING_NEW = "MISSING_NEW";
                // Call exception
                //  - transaction: the transaction
                //  - address?: the contract address
                //  - args?: The arguments passed into the function
                //  - method?: The Solidity method signature
                //  - errorSignature?: The EIP848 error signature
                //  - errorArgs?: The EIP848 error parameters
                //  - reason: The reason (only for EIP848 "Error(string)")
                exports.CALL_EXCEPTION = "CALL_EXCEPTION";
                // Invalid argument (e.g. value is incompatible with type) to a function:
                //   - argument: The argument name that was invalid
                //   - value: The value of the argument
                exports.INVALID_ARGUMENT = "INVALID_ARGUMENT";
                // Missing argument to a function:
                //   - count: The number of arguments received
                //   - expectedCount: The number of arguments expected
                exports.MISSING_ARGUMENT = "MISSING_ARGUMENT";
                // Too many arguments
                //   - count: The number of arguments received
                //   - expectedCount: The number of arguments expected
                exports.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT";
                // Numeric Fault
                //   - operation: the operation being executed
                //   - fault: the reason this faulted
                exports.NUMERIC_FAULT = "NUMERIC_FAULT";
                // Insufficien funds (< value + gasLimit * gasPrice)
                //   - transaction: the transaction attempted
                exports.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS";
                // Nonce has already been used
                //   - transaction: the transaction attempted
                exports.NONCE_EXPIRED = "NONCE_EXPIRED";
                // The replacement fee for the transaction is too low
                //   - transaction: the transaction attempted
                exports.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
                // Unsupported operation
                //   - operation
                exports.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION";
                var _permanentCensorErrors = false;
                var _censorErrors = false;
                // @TODO: Enum
                function throwError(message, code, params) {
                    if (_censorErrors) throw new Error("unknown error");
                    if (!code) code = exports.UNKNOWN_ERROR;
                    if (!params) params = {};
                    var messageDetails = [];
                    Object.keys(params).forEach(function(key) {
                        try {
                            messageDetails.push(key + "=" + JSON.stringify(params[key]));
                        } catch (error) {
                            messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
                        }
                    });
                    messageDetails.push("version=" + _version_1.version);
                    var reason = message;
                    if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
                    // @TODO: Any??
                    var error = new Error(message);
                    error.reason = reason;
                    error.code = code;
                    Object.keys(params).forEach(function(key) {
                        error[key] = params[key];
                    });
                    throw error;
                }
                exports.throwError = throwError;
                function checkNew(self1, kind) {
                    if (!(self1 instanceof kind)) throwError("missing new", exports.MISSING_NEW, {
                        name: kind.name
                    });
                }
                exports.checkNew = checkNew;
                function checkArgumentCount(count, expectedCount, suffix) {
                    if (!suffix) suffix = "";
                    if (count < expectedCount) throwError("missing argument" + suffix, exports.MISSING_ARGUMENT, {
                        count: count,
                        expectedCount: expectedCount
                    });
                    if (count > expectedCount) throwError("too many arguments" + suffix, exports.UNEXPECTED_ARGUMENT, {
                        count: count,
                        expectedCount: expectedCount
                    });
                }
                exports.checkArgumentCount = checkArgumentCount;
                function setCensorship(censorship, permanent) {
                    if (_permanentCensorErrors) throwError("error censorship permanent", exports.UNSUPPORTED_OPERATION, {
                        operation: "setCensorship"
                    });
                    _censorErrors = !!censorship;
                    _permanentCensorErrors = !!permanent;
                }
                exports.setCensorship = setCensorship;
                function checkNormalize() {
                    try {
                        // Make sure all forms of normalization are supported
                        [
                            "NFD",
                            "NFC",
                            "NFKD",
                            "NFKC"
                        ].forEach(function(form) {
                            try {
                                "test".normalize(form);
                            } catch (error) {
                                throw new Error("missing " + form);
                            }
                        });
                        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
                    } catch (error) {
                        throwError("platform missing String.prototype.normalize", exports.UNSUPPORTED_OPERATION, {
                            operation: "String.prototype.normalize",
                            form: error.message
                        });
                    }
                }
                exports.checkNormalize = checkNormalize;
                var LogLevels = {
                    debug: 1,
                    "default": 2,
                    info: 2,
                    warn: 3,
                    error: 4,
                    off: 5
                };
                var LogLevel = LogLevels["default"];
                function setLogLevel(logLevel) {
                    var level = LogLevels[logLevel];
                    if (level == null) {
                        warn("invliad log level - " + logLevel);
                        return;
                    }
                    LogLevel = level;
                }
                exports.setLogLevel = setLogLevel;
                function log(logLevel, args) {
                    if (LogLevel > LogLevels[logLevel]) return;
                    console.log.apply(console, args);
                }
                function warn() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    log("warn", args);
                }
                exports.warn = warn;
                function info() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    log("info", args);
                }
                exports.info = info;
            /***/ },
            /***/ 2046: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __extends = this && this.__extends || function() {
                    var extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return function(d, b) {
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
                var constants_1 = __webpack_require__(8707);
                var errors = __importStar(__webpack_require__(6459));
                var address_1 = __webpack_require__(5638);
                var bignumber_1 = __webpack_require__(4759);
                var bytes_1 = __webpack_require__(8458);
                var utf8_1 = __webpack_require__(1165);
                var properties_1 = __webpack_require__(8184);
                ///////////////////////////////
                var paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
                var paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
                var paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
                exports.defaultCoerceFunc = function(type, value) {
                    var match = type.match(paramTypeNumber);
                    if (match && parseInt(match[2]) <= 48) return value.toNumber();
                    return value;
                };
                ///////////////////////////////////
                // Parsing for Solidity Signatures
                var regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
                var regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
                function verifyType(type) {
                    // These need to be transformed to their full description
                    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
                    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
                    return type;
                }
                function parseParam(param, allowIndexed) {
                    var originalParam = param;
                    function throwError(i) {
                        throw new Error('unexpected character "' + originalParam[i] + '" at position ' + i + ' in "' + originalParam + '"');
                    }
                    param = param.replace(/\s/g, " ");
                    var parent = {
                        type: "",
                        name: "",
                        state: {
                            allowType: true
                        }
                    };
                    var node = parent;
                    for(var i = 0; i < param.length; i++){
                        var c = param[i];
                        switch(c){
                            case "(":
                                if (!node.state.allowParams) throwError(i);
                                node.state.allowType = false;
                                node.type = verifyType(node.type);
                                node.components = [
                                    {
                                        type: "",
                                        name: "",
                                        parent: node,
                                        state: {
                                            allowType: true
                                        }
                                    }
                                ];
                                node = node.components[0];
                                break;
                            case ")":
                                delete node.state;
                                if (allowIndexed && node.name === "indexed") {
                                    node.indexed = true;
                                    node.name = "";
                                }
                                node.type = verifyType(node.type);
                                var child = node;
                                node = node.parent;
                                if (!node) throwError(i);
                                delete child.parent;
                                node.state.allowParams = false;
                                node.state.allowName = true;
                                node.state.allowArray = true;
                                break;
                            case ",":
                                delete node.state;
                                if (allowIndexed && node.name === "indexed") {
                                    node.indexed = true;
                                    node.name = "";
                                }
                                node.type = verifyType(node.type);
                                var sibling = {
                                    type: "",
                                    name: "",
                                    parent: node.parent,
                                    state: {
                                        allowType: true
                                    }
                                };
                                node.parent.components.push(sibling);
                                delete node.parent;
                                node = sibling;
                                break;
                            // Hit a space...
                            case " ":
                                // If reading type, the type is done and may read a param or name
                                if (node.state.allowType) {
                                    if (node.type !== "") {
                                        node.type = verifyType(node.type);
                                        delete node.state.allowType;
                                        node.state.allowName = true;
                                        node.state.allowParams = true;
                                    }
                                }
                                // If reading name, the name is done
                                if (node.state.allowName) {
                                    if (node.name !== "") {
                                        if (allowIndexed && node.name === "indexed") {
                                            node.indexed = true;
                                            node.name = "";
                                        } else node.state.allowName = false;
                                    }
                                }
                                break;
                            case "[":
                                if (!node.state.allowArray) throwError(i);
                                node.type += c;
                                node.state.allowArray = false;
                                node.state.allowName = false;
                                node.state.readArray = true;
                                break;
                            case "]":
                                if (!node.state.readArray) throwError(i);
                                node.type += c;
                                node.state.readArray = false;
                                node.state.allowArray = true;
                                node.state.allowName = true;
                                break;
                            default:
                                if (node.state.allowType) {
                                    node.type += c;
                                    node.state.allowParams = true;
                                    node.state.allowArray = true;
                                } else if (node.state.allowName) {
                                    node.name += c;
                                    delete node.state.allowArray;
                                } else if (node.state.readArray) node.type += c;
                                else throwError(i);
                        }
                    }
                    if (node.parent) throw new Error("unexpected eof");
                    delete parent.state;
                    if (allowIndexed && node.name === "indexed") {
                        node.indexed = true;
                        node.name = "";
                    }
                    parent.type = verifyType(parent.type);
                    return parent;
                }
                // @TODO: Better return type
                function parseSignatureEvent(fragment) {
                    var abi = {
                        anonymous: false,
                        inputs: [],
                        name: "",
                        type: "event"
                    };
                    var match = fragment.match(regexParen);
                    if (!match) throw new Error("invalid event: " + fragment);
                    abi.name = match[1].trim();
                    splitNesting(match[2]).forEach(function(param) {
                        param = parseParam(param, true);
                        param.indexed = !!param.indexed;
                        abi.inputs.push(param);
                    });
                    match[3].split(" ").forEach(function(modifier) {
                        switch(modifier){
                            case "anonymous":
                                abi.anonymous = true;
                                break;
                            case "":
                                break;
                            default:
                                errors.info("unknown modifier: " + modifier);
                        }
                    });
                    if (abi.name && !abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + abi.name + '"');
                    return abi;
                }
                function parseSignatureFunction(fragment) {
                    var abi = {
                        constant: false,
                        gas: null,
                        inputs: [],
                        name: "",
                        outputs: [],
                        payable: false,
                        stateMutability: null,
                        type: "function"
                    };
                    var comps = fragment.split("@");
                    if (comps.length !== 1) {
                        if (comps.length > 2) throw new Error("invalid signature");
                        if (!comps[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
                        abi.gas = bignumber_1.bigNumberify(comps[1]);
                        fragment = comps[0];
                    }
                    comps = fragment.split(" returns ");
                    var left = comps[0].match(regexParen);
                    if (!left) throw new Error("invalid signature");
                    abi.name = left[1].trim();
                    if (!abi.name.match(regexIdentifier)) throw new Error('invalid identifier: "' + left[1] + '"');
                    splitNesting(left[2]).forEach(function(param) {
                        abi.inputs.push(parseParam(param));
                    });
                    left[3].split(" ").forEach(function(modifier) {
                        switch(modifier){
                            case "constant":
                                abi.constant = true;
                                break;
                            case "payable":
                                abi.payable = true;
                                abi.stateMutability = "payable";
                                break;
                            case "pure":
                                abi.constant = true;
                                abi.stateMutability = "pure";
                                break;
                            case "view":
                                abi.constant = true;
                                abi.stateMutability = "view";
                                break;
                            case "external":
                            case "public":
                            case "":
                                break;
                            default:
                                errors.info("unknown modifier: " + modifier);
                        }
                    });
                    // We have outputs
                    if (comps.length > 1) {
                        var right = comps[1].match(regexParen);
                        if (right[1].trim() != "" || right[3].trim() != "") throw new Error("unexpected tokens");
                        splitNesting(right[2]).forEach(function(param) {
                            abi.outputs.push(parseParam(param));
                        });
                    }
                    if (abi.name === "constructor") {
                        abi.type = "constructor";
                        if (abi.outputs.length) throw new Error("constructor may not have outputs");
                        delete abi.name;
                        delete abi.outputs;
                    }
                    return abi;
                }
                function parseParamType(type) {
                    return parseParam(type, true);
                }
                exports.parseParamType = parseParamType;
                // @TODO: Allow a second boolean to expose names
                function formatParamType(paramType) {
                    return getParamCoder(exports.defaultCoerceFunc, paramType).type;
                }
                exports.formatParamType = formatParamType;
                // @TODO: Allow a second boolean to expose names and modifiers
                function formatSignature(fragment) {
                    return fragment.name + "(" + fragment.inputs.map(function(i) {
                        return formatParamType(i);
                    }).join(",") + ")";
                }
                exports.formatSignature = formatSignature;
                function parseSignature(fragment) {
                    if (typeof fragment === "string") {
                        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
                        fragment = fragment.replace(/\s/g, " ");
                        fragment = fragment.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
                        fragment = fragment.trim();
                        if (fragment.substring(0, 6) === "event ") return parseSignatureEvent(fragment.substring(6).trim());
                        else {
                            if (fragment.substring(0, 9) === "function ") fragment = fragment.substring(9);
                            return parseSignatureFunction(fragment.trim());
                        }
                    }
                    throw new Error("unknown signature");
                }
                exports.parseSignature = parseSignature;
                var Coder = /** @class */ function() {
                    function Coder(coerceFunc, name1, type, localName, dynamic) {
                        this.coerceFunc = coerceFunc;
                        this.name = name1;
                        this.type = type;
                        this.localName = localName;
                        this.dynamic = dynamic;
                    }
                    return Coder;
                }();
                // Clones the functionality of an existing Coder, but without a localName
                var CoderAnonymous = /** @class */ function(_super) {
                    __extends(CoderAnonymous, _super);
                    function CoderAnonymous(coder) {
                        var _this = _super.call(this, coder.coerceFunc, coder.name, coder.type, undefined, coder.dynamic) || this;
                        properties_1.defineReadOnly(_this, "coder", coder);
                        return _this;
                    }
                    CoderAnonymous.prototype.encode = function(value) {
                        return this.coder.encode(value);
                    };
                    CoderAnonymous.prototype.decode = function(data, offset) {
                        return this.coder.decode(data, offset);
                    };
                    return CoderAnonymous;
                }(Coder);
                var CoderNull = /** @class */ function(_super) {
                    __extends(CoderNull, _super);
                    function CoderNull(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "null", "", localName, false) || this;
                    }
                    CoderNull.prototype.encode = function(value) {
                        return bytes_1.arrayify([]);
                    };
                    CoderNull.prototype.decode = function(data, offset) {
                        if (offset > data.length) throw new Error("invalid null");
                        return {
                            consumed: 0,
                            value: this.coerceFunc("null", undefined)
                        };
                    };
                    return CoderNull;
                }(Coder);
                var CoderNumber = /** @class */ function(_super) {
                    __extends(CoderNumber, _super);
                    function CoderNumber(coerceFunc, size, signed, localName) {
                        var _this = this;
                        var name1 = (signed ? "int" : "uint") + size * 8;
                        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
                        _this.size = size;
                        _this.signed = signed;
                        return _this;
                    }
                    CoderNumber.prototype.encode = function(value) {
                        try {
                            var v = bignumber_1.bigNumberify(value);
                            if (this.signed) {
                                var bounds = constants_1.MaxUint256.maskn(this.size * 8 - 1);
                                if (v.gt(bounds)) throw new Error("out-of-bounds");
                                bounds = bounds.add(constants_1.One).mul(constants_1.NegativeOne);
                                if (v.lt(bounds)) throw new Error("out-of-bounds");
                            } else if (v.lt(constants_1.Zero) || v.gt(constants_1.MaxUint256.maskn(this.size * 8))) throw new Error("out-of-bounds");
                            v = v.toTwos(this.size * 8).maskn(this.size * 8);
                            if (this.signed) v = v.fromTwos(this.size * 8).toTwos(256);
                            return bytes_1.padZeros(bytes_1.arrayify(v), 32);
                        } catch (error) {
                            errors.throwError("invalid number value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: this.name,
                                value: value
                            });
                        }
                        return null;
                    };
                    CoderNumber.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficient data for " + this.name + " type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: this.name,
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        var junkLength = 32 - this.size;
                        var value = bignumber_1.bigNumberify(data.slice(offset + junkLength, offset + 32));
                        if (this.signed) value = value.fromTwos(this.size * 8);
                        else value = value.maskn(this.size * 8);
                        return {
                            consumed: 32,
                            value: this.coerceFunc(this.name, value)
                        };
                    };
                    return CoderNumber;
                }(Coder);
                var uint256Coder = new CoderNumber(function(type, value) {
                    return value;
                }, 32, false, "none");
                var CoderBoolean = /** @class */ function(_super) {
                    __extends(CoderBoolean, _super);
                    function CoderBoolean(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "bool", "bool", localName, false) || this;
                    }
                    CoderBoolean.prototype.encode = function(value) {
                        return uint256Coder.encode(!!value ? 1 : 0);
                    };
                    CoderBoolean.prototype.decode = function(data, offset) {
                        try {
                            var result = uint256Coder.decode(data, offset);
                        } catch (error) {
                            if (error.reason === "insufficient data for uint256 type") errors.throwError("insufficient data for boolean type", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "boolean",
                                value: error.value
                            });
                            throw error;
                        }
                        return {
                            consumed: result.consumed,
                            value: this.coerceFunc("bool", !result.value.isZero())
                        };
                    };
                    return CoderBoolean;
                }(Coder);
                var CoderFixedBytes = /** @class */ function(_super) {
                    __extends(CoderFixedBytes, _super);
                    function CoderFixedBytes(coerceFunc, length, localName) {
                        var _this = this;
                        var name1 = "bytes" + length;
                        _this = _super.call(this, coerceFunc, name1, name1, localName, false) || this;
                        _this.length = length;
                        return _this;
                    }
                    CoderFixedBytes.prototype.encode = function(value) {
                        var result = new Uint8Array(32);
                        try {
                            var data = bytes_1.arrayify(value);
                            if (data.length !== this.length) throw new Error("incorrect data length");
                            result.set(data);
                        } catch (error) {
                            errors.throwError("invalid " + this.name + " value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: this.name,
                                value: error.value || value
                            });
                        }
                        return result;
                    };
                    CoderFixedBytes.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficient data for " + name + " type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: this.name,
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        return {
                            consumed: 32,
                            value: this.coerceFunc(this.name, bytes_1.hexlify(data.slice(offset, offset + this.length)))
                        };
                    };
                    return CoderFixedBytes;
                }(Coder);
                var CoderAddress = /** @class */ function(_super) {
                    __extends(CoderAddress, _super);
                    function CoderAddress(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "address", "address", localName, false) || this;
                    }
                    CoderAddress.prototype.encode = function(value) {
                        var result = new Uint8Array(32);
                        try {
                            result.set(bytes_1.arrayify(address_1.getAddress(value, false)), 12);
                        } catch (error) {
                            errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "address",
                                value: value
                            });
                        }
                        return result;
                    };
                    CoderAddress.prototype.decode = function(data, offset) {
                        if (data.length < offset + 32) errors.throwError("insufficuent data for address type", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "address",
                            value: bytes_1.hexlify(data.slice(offset, offset + 32))
                        });
                        return {
                            consumed: 32,
                            value: this.coerceFunc("address", address_1.getAddress(bytes_1.hexlify(data.slice(offset + 12, offset + 32)), false))
                        };
                    };
                    return CoderAddress;
                }(Coder);
                function _encodeDynamicBytes(value) {
                    var dataLength = 32 * Math.ceil(value.length / 32);
                    var padding = new Uint8Array(dataLength - value.length);
                    return bytes_1.concat([
                        uint256Coder.encode(value.length),
                        value,
                        padding
                    ]);
                }
                function _decodeDynamicBytes(data, offset, localName) {
                    if (data.length < offset + 32) errors.throwError("insufficient data for dynamicBytes length", errors.INVALID_ARGUMENT, {
                        arg: localName,
                        coderType: "dynamicBytes",
                        value: bytes_1.hexlify(data.slice(offset, offset + 32))
                    });
                    var length = uint256Coder.decode(data, offset).value;
                    try {
                        length = length.toNumber();
                    } catch (error) {
                        errors.throwError("dynamic bytes count too large", errors.INVALID_ARGUMENT, {
                            arg: localName,
                            coderType: "dynamicBytes",
                            value: length.toString()
                        });
                    }
                    if (data.length < offset + 32 + length) errors.throwError("insufficient data for dynamicBytes type", errors.INVALID_ARGUMENT, {
                        arg: localName,
                        coderType: "dynamicBytes",
                        value: bytes_1.hexlify(data.slice(offset, offset + 32 + length))
                    });
                    return {
                        consumed: 32 + 32 * Math.ceil(length / 32),
                        value: data.slice(offset + 32, offset + 32 + length)
                    };
                }
                var CoderDynamicBytes = /** @class */ function(_super) {
                    __extends(CoderDynamicBytes, _super);
                    function CoderDynamicBytes(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "bytes", "bytes", localName, true) || this;
                    }
                    CoderDynamicBytes.prototype.encode = function(value) {
                        try {
                            return _encodeDynamicBytes(bytes_1.arrayify(value));
                        } catch (error) {
                            errors.throwError("invalid bytes value", errors.INVALID_ARGUMENT, {
                                arg: this.localName,
                                coderType: "bytes",
                                value: error.value
                            });
                        }
                        return null;
                    };
                    CoderDynamicBytes.prototype.decode = function(data, offset) {
                        var result = _decodeDynamicBytes(data, offset, this.localName);
                        result.value = this.coerceFunc("bytes", bytes_1.hexlify(result.value));
                        return result;
                    };
                    return CoderDynamicBytes;
                }(Coder);
                var CoderString = /** @class */ function(_super) {
                    __extends(CoderString, _super);
                    function CoderString(coerceFunc, localName) {
                        return _super.call(this, coerceFunc, "string", "string", localName, true) || this;
                    }
                    CoderString.prototype.encode = function(value) {
                        if (typeof value !== "string") errors.throwError("invalid string value", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "string",
                            value: value
                        });
                        return _encodeDynamicBytes(utf8_1.toUtf8Bytes(value));
                    };
                    CoderString.prototype.decode = function(data, offset) {
                        var result = _decodeDynamicBytes(data, offset, this.localName);
                        result.value = this.coerceFunc("string", utf8_1.toUtf8String(result.value));
                        return result;
                    };
                    return CoderString;
                }(Coder);
                function alignSize(size) {
                    return 32 * Math.ceil(size / 32);
                }
                function pack(coders, values) {
                    if (Array.isArray(values)) ;
                    else if (values && typeof values === "object") {
                        var arrayValues = [];
                        coders.forEach(function(coder) {
                            arrayValues.push(values[coder.localName]);
                        });
                        values = arrayValues;
                    } else errors.throwError("invalid tuple value", errors.INVALID_ARGUMENT, {
                        coderType: "tuple",
                        value: values
                    });
                    if (coders.length !== values.length) errors.throwError("types/value length mismatch", errors.INVALID_ARGUMENT, {
                        coderType: "tuple",
                        value: values
                    });
                    var parts = [];
                    coders.forEach(function(coder, index) {
                        parts.push({
                            dynamic: coder.dynamic,
                            value: coder.encode(values[index])
                        });
                    });
                    var staticSize = 0, dynamicSize = 0;
                    parts.forEach(function(part) {
                        if (part.dynamic) {
                            staticSize += 32;
                            dynamicSize += alignSize(part.value.length);
                        } else staticSize += alignSize(part.value.length);
                    });
                    var offset = 0, dynamicOffset = staticSize;
                    var data = new Uint8Array(staticSize + dynamicSize);
                    parts.forEach(function(part) {
                        if (part.dynamic) {
                            //uint256Coder.encode(dynamicOffset).copy(data, offset);
                            data.set(uint256Coder.encode(dynamicOffset), offset);
                            offset += 32;
                            //part.value.copy(data, dynamicOffset);  @TODO
                            data.set(part.value, dynamicOffset);
                            dynamicOffset += alignSize(part.value.length);
                        } else {
                            //part.value.copy(data, offset);  @TODO
                            data.set(part.value, offset);
                            offset += alignSize(part.value.length);
                        }
                    });
                    return data;
                }
                function unpack(coders, data, offset) {
                    var baseOffset = offset;
                    var consumed = 0;
                    var value = [];
                    coders.forEach(function(coder) {
                        if (coder.dynamic) {
                            var dynamicOffset = uint256Coder.decode(data, offset);
                            var result = coder.decode(data, baseOffset + dynamicOffset.value.toNumber());
                            // The dynamic part is leap-frogged somewhere else; doesn't count towards size
                            result.consumed = dynamicOffset.consumed;
                        } else var result = coder.decode(data, offset);
                        if (result.value != undefined) value.push(result.value);
                        offset += result.consumed;
                        consumed += result.consumed;
                    });
                    coders.forEach(function(coder, index) {
                        var name1 = coder.localName;
                        if (!name1) return;
                        if (name1 === "length") name1 = "_length";
                        if (value[name1] != null) return;
                        value[name1] = value[index];
                    });
                    return {
                        value: value,
                        consumed: consumed
                    };
                }
                var CoderArray = /** @class */ function(_super) {
                    __extends(CoderArray, _super);
                    function CoderArray(coerceFunc, coder, length, localName) {
                        var _this = this;
                        var type = coder.type + "[" + (length >= 0 ? length : "") + "]";
                        var dynamic = length === -1 || coder.dynamic;
                        _this = _super.call(this, coerceFunc, "array", type, localName, dynamic) || this;
                        _this.coder = coder;
                        _this.length = length;
                        return _this;
                    }
                    CoderArray.prototype.encode = function(value) {
                        if (!Array.isArray(value)) errors.throwError("expected array value", errors.INVALID_ARGUMENT, {
                            arg: this.localName,
                            coderType: "array",
                            value: value
                        });
                        var count = this.length;
                        var result = new Uint8Array(0);
                        if (count === -1) {
                            count = value.length;
                            result = uint256Coder.encode(count);
                        }
                        errors.checkArgumentCount(count, value.length, " in coder array" + (this.localName ? " " + this.localName : ""));
                        var coders = [];
                        for(var i = 0; i < value.length; i++)coders.push(this.coder);
                        return bytes_1.concat([
                            result,
                            pack(coders, value)
                        ]);
                    };
                    CoderArray.prototype.decode = function(data, offset) {
                        // @TODO:
                        //if (data.length < offset + length * 32) { throw new Error('invalid array'); }
                        var consumed = 0;
                        var count = this.length;
                        if (count === -1) {
                            try {
                                var decodedLength = uint256Coder.decode(data, offset);
                            } catch (error) {
                                errors.throwError("insufficient data for dynamic array length", errors.INVALID_ARGUMENT, {
                                    arg: this.localName,
                                    coderType: "array",
                                    value: error.value
                                });
                            }
                            try {
                                count = decodedLength.value.toNumber();
                            } catch (error) {
                                errors.throwError("array count too large", errors.INVALID_ARGUMENT, {
                                    arg: this.localName,
                                    coderType: "array",
                                    value: decodedLength.value.toString()
                                });
                            }
                            consumed += decodedLength.consumed;
                            offset += decodedLength.consumed;
                        }
                        var coders = [];
                        for(var i = 0; i < count; i++)coders.push(new CoderAnonymous(this.coder));
                        var result = unpack(coders, data, offset);
                        result.consumed += consumed;
                        result.value = this.coerceFunc(this.type, result.value);
                        return result;
                    };
                    return CoderArray;
                }(Coder);
                var CoderTuple = /** @class */ function(_super) {
                    __extends(CoderTuple, _super);
                    function CoderTuple(coerceFunc, coders, localName) {
                        var _this = this;
                        var dynamic = false;
                        var types = [];
                        coders.forEach(function(coder) {
                            if (coder.dynamic) dynamic = true;
                            types.push(coder.type);
                        });
                        var type = "tuple(" + types.join(",") + ")";
                        _this = _super.call(this, coerceFunc, "tuple", type, localName, dynamic) || this;
                        _this.coders = coders;
                        return _this;
                    }
                    CoderTuple.prototype.encode = function(value) {
                        return pack(this.coders, value);
                    };
                    CoderTuple.prototype.decode = function(data, offset) {
                        var result = unpack(this.coders, data, offset);
                        result.value = this.coerceFunc(this.type, result.value);
                        return result;
                    };
                    return CoderTuple;
                }(Coder);
                /*
function getTypes(coders) {
    var type = coderTuple(coders).type;
    return type.substring(6, type.length - 1);
}
*/ function splitNesting(value) {
                    value = value.trim();
                    var result = [];
                    var accum = "";
                    var depth = 0;
                    for(var offset = 0; offset < value.length; offset++){
                        var c = value[offset];
                        if (c === "," && depth === 0) {
                            result.push(accum);
                            accum = "";
                        } else {
                            accum += c;
                            if (c === "(") depth++;
                            else if (c === ")") {
                                depth--;
                                if (depth === -1) throw new Error("unbalanced parenthsis");
                            }
                        }
                    }
                    if (accum) result.push(accum);
                    return result;
                }
                // @TODO: Is there a way to return "class"?
                var paramTypeSimple = {
                    address: CoderAddress,
                    bool: CoderBoolean,
                    string: CoderString,
                    bytes: CoderDynamicBytes
                };
                function getTupleParamCoder(coerceFunc, components, localName) {
                    if (!components) components = [];
                    var coders = [];
                    components.forEach(function(component) {
                        coders.push(getParamCoder(coerceFunc, component));
                    });
                    return new CoderTuple(coerceFunc, coders, localName);
                }
                function getParamCoder(coerceFunc, param) {
                    var coder = paramTypeSimple[param.type];
                    if (coder) return new coder(coerceFunc, param.name);
                    var match = param.type.match(paramTypeNumber);
                    if (match) {
                        var size = parseInt(match[2] || "256");
                        if (size === 0 || size > 256 || size % 8 !== 0) errors.throwError("invalid " + match[1] + " bit length", errors.INVALID_ARGUMENT, {
                            arg: "param",
                            value: param
                        });
                        return new CoderNumber(coerceFunc, size / 8, match[1] === "int", param.name);
                    }
                    var match = param.type.match(paramTypeBytes);
                    if (match) {
                        var size = parseInt(match[1]);
                        if (size === 0 || size > 32) errors.throwError("invalid bytes length", errors.INVALID_ARGUMENT, {
                            arg: "param",
                            value: param
                        });
                        return new CoderFixedBytes(coerceFunc, size, param.name);
                    }
                    var match = param.type.match(paramTypeArray);
                    if (match) {
                        var size = parseInt(match[2] || "-1");
                        param = properties_1.shallowCopy(param);
                        param.type = match[1];
                        param = properties_1.deepCopy(param);
                        return new CoderArray(coerceFunc, getParamCoder(coerceFunc, param), size, param.name);
                    }
                    if (param.type.substring(0, 5) === "tuple") return getTupleParamCoder(coerceFunc, param.components, param.name);
                    if (param.type === "") return new CoderNull(coerceFunc, param.name);
                    errors.throwError("invalid type", errors.INVALID_ARGUMENT, {
                        arg: "type",
                        value: param.type
                    });
                    return null;
                }
                var AbiCoder = /** @class */ function() {
                    function AbiCoder(coerceFunc) {
                        errors.checkNew(this, AbiCoder);
                        if (!coerceFunc) coerceFunc = exports.defaultCoerceFunc;
                        properties_1.defineReadOnly(this, "coerceFunc", coerceFunc);
                    }
                    AbiCoder.prototype.encode = function(types, values) {
                        if (types.length !== values.length) errors.throwError("types/values length mismatch", errors.INVALID_ARGUMENT, {
                            count: {
                                types: types.length,
                                values: values.length
                            },
                            value: {
                                types: types,
                                values: values
                            }
                        });
                        var coders = [];
                        types.forEach(function(type) {
                            // Convert types to type objects
                            //   - "uint foo" => { type: "uint", name: "foo" }
                            //   - "tuple(uint, uint)" => { type: "tuple", components: [ { type: "uint" }, { type: "uint" }, ] }
                            var typeObject = null;
                            if (typeof type === "string") typeObject = parseParam(type);
                            else typeObject = type;
                            coders.push(getParamCoder(this.coerceFunc, typeObject));
                        }, this);
                        return bytes_1.hexlify(new CoderTuple(this.coerceFunc, coders, "_").encode(values));
                    };
                    AbiCoder.prototype.decode = function(types, data) {
                        var coders = [];
                        types.forEach(function(type) {
                            // See encode for details
                            var typeObject = null;
                            if (typeof type === "string") typeObject = parseParam(type);
                            else typeObject = properties_1.deepCopy(type);
                            coders.push(getParamCoder(this.coerceFunc, typeObject));
                        }, this);
                        return new CoderTuple(this.coerceFunc, coders, "_").decode(bytes_1.arrayify(data), 0).value;
                    };
                    return AbiCoder;
                }();
                exports.AbiCoder = AbiCoder;
                exports.defaultAbiCoder = new AbiCoder();
            /***/ },
            /***/ 5638: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                // We use this for base 36 maths
                var bn_js_1 = __importDefault(__webpack_require__(5697));
                var bytes_1 = __webpack_require__(8458);
                var keccak256_1 = __webpack_require__(918);
                var rlp_1 = __webpack_require__(6100);
                var errors = __webpack_require__(6459);
                ///////////////////////////////
                function getChecksumAddress(address) {
                    if (typeof address !== "string" || !address.match(/^0x[0-9A-Fa-f]{40}$/)) errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    address = address.toLowerCase();
                    var chars = address.substring(2).split("");
                    var hashed = new Uint8Array(40);
                    for(var i_1 = 0; i_1 < 40; i_1++)hashed[i_1] = chars[i_1].charCodeAt(0);
                    hashed = bytes_1.arrayify(keccak256_1.keccak256(hashed));
                    for(var i = 0; i < 40; i += 2){
                        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
                        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
                    }
                    return "0x" + chars.join("");
                }
                // Shims for environments that are missing some required constants and functions
                var MAX_SAFE_INTEGER = 0x1fffffffffffff;
                function log10(x) {
                    if (Math.log10) return Math.log10(x);
                    return Math.log(x) / Math.LN10;
                }
                // See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
                // Create lookup table
                var ibanLookup = {};
                for(var i = 0; i < 10; i++)ibanLookup[String(i)] = String(i);
                for(var i = 0; i < 26; i++)ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
                // How many decimal digits can we process? (for 64-bit float, this is 15)
                var safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
                function ibanChecksum(address) {
                    address = address.toUpperCase();
                    address = address.substring(4) + address.substring(0, 2) + "00";
                    var expanded = "";
                    address.split("").forEach(function(c) {
                        expanded += ibanLookup[c];
                    });
                    // Javascript can handle integers safely up to 15 (decimal) digits
                    while(expanded.length >= safeDigits){
                        var block = expanded.substring(0, safeDigits);
                        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
                    }
                    var checksum = String(98 - parseInt(expanded, 10) % 97);
                    while(checksum.length < 2)checksum = "0" + checksum;
                    return checksum;
                }
                function getAddress(address, checksum) {
                    if (checksum === void 0) checksum = true;
                    var result = null;
                    if (typeof address !== "string") errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
                        // Missing the 0x prefix
                        if (address.substring(0, 2) !== "0x") address = "0x" + address;
                        if (checksum) {
                            result = getChecksumAddress(address);
                            // It is a checksummed address with a bad checksum
                            if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) errors.throwError("bad address checksum", errors.INVALID_ARGUMENT, {
                                arg: "address",
                                value: address
                            });
                        } else result = address;
                    // Maybe ICAP? (we only support direct mode)
                    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
                        // It is an ICAP address with a bad checksum
                        if (address.substring(2, 4) !== ibanChecksum(address)) errors.throwError("bad icap checksum", errors.INVALID_ARGUMENT, {
                            arg: "address",
                            value: address
                        });
                        result = new bn_js_1.default.BN(address.substring(4), 36).toString(16);
                        while(result.length < 40)result = "0" + result;
                        result = checksum ? getChecksumAddress("0x" + result) : "0x" + result;
                    } else errors.throwError("invalid address", errors.INVALID_ARGUMENT, {
                        arg: "address",
                        value: address
                    });
                    return result;
                }
                exports.getAddress = getAddress;
                function getIcapAddress(address) {
                    var base36 = new bn_js_1.default.BN(getAddress(address).substring(2), 16).toString(36).toUpperCase();
                    while(base36.length < 30)base36 = "0" + base36;
                    return "XE" + ibanChecksum("XE00" + base36) + base36;
                }
                exports.getIcapAddress = getIcapAddress;
                // http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
                function getContractAddress(transaction) {
                    if (!transaction.from) throw new Error("missing from address");
                    var nonce = transaction.nonce;
                    return getAddress("0x" + keccak256_1.keccak256(rlp_1.encode([
                        getAddress(transaction.from),
                        bytes_1.stripZeros(bytes_1.hexlify(nonce))
                    ])).substring(26));
                }
                exports.getContractAddress = getContractAddress;
            /***/ },
            /***/ 4759: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardles.
 *
 */ var bn_js_1 = __importDefault(__webpack_require__(5697));
                var bytes_1 = __webpack_require__(8458);
                var properties_1 = __webpack_require__(8184);
                var errors = __importStar(__webpack_require__(6459));
                var BN_1 = new bn_js_1.default.BN(-1);
                function toHex(bn) {
                    var value = bn.toString(16);
                    if (value[0] === "-") {
                        if (value.length % 2 === 0) return "-0x0" + value.substring(1);
                        return "-0x" + value.substring(1);
                    }
                    if (value.length % 2 === 1) return "0x0" + value;
                    return "0x" + value;
                }
                function toBN(value) {
                    return _bnify(bigNumberify(value));
                }
                function toBigNumber(bn) {
                    return new BigNumber(toHex(bn));
                }
                function _bnify(value) {
                    var hex = value._hex;
                    if (hex[0] === "-") return new bn_js_1.default.BN(hex.substring(3), 16).mul(BN_1);
                    return new bn_js_1.default.BN(hex.substring(2), 16);
                }
                var BigNumber = /** @class */ function() {
                    function BigNumber(value) {
                        errors.checkNew(this, BigNumber);
                        properties_1.setType(this, "BigNumber");
                        if (typeof value === "string") {
                            if (bytes_1.isHexString(value)) {
                                if (value == "0x") value = "0x0";
                                properties_1.defineReadOnly(this, "_hex", value);
                            } else if (value[0] === "-" && bytes_1.isHexString(value.substring(1))) properties_1.defineReadOnly(this, "_hex", value);
                            else if (value.match(/^-?[0-9]*$/)) {
                                if (value == "") value = "0";
                                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
                            } else errors.throwError("invalid BigNumber string value", errors.INVALID_ARGUMENT, {
                                arg: "value",
                                value: value
                            });
                        } else if (typeof value === "number") {
                            if (parseInt(String(value)) !== value) errors.throwError("underflow", errors.NUMERIC_FAULT, {
                                operation: "setValue",
                                fault: "underflow",
                                value: value,
                                outputValue: parseInt(String(value))
                            });
                            try {
                                properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(value)));
                            } catch (error) {
                                errors.throwError("overflow", errors.NUMERIC_FAULT, {
                                    operation: "setValue",
                                    fault: "overflow",
                                    details: error.message
                                });
                            }
                        } else if (value instanceof BigNumber) properties_1.defineReadOnly(this, "_hex", value._hex);
                        else if (value.toHexString) properties_1.defineReadOnly(this, "_hex", toHex(toBN(value.toHexString())));
                        else if (value._hex && bytes_1.isHexString(value._hex)) properties_1.defineReadOnly(this, "_hex", value._hex);
                        else if (bytes_1.isArrayish(value)) properties_1.defineReadOnly(this, "_hex", toHex(new bn_js_1.default.BN(bytes_1.hexlify(value).substring(2), 16)));
                        else errors.throwError("invalid BigNumber value", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                    }
                    BigNumber.prototype.fromTwos = function(value) {
                        return toBigNumber(_bnify(this).fromTwos(value));
                    };
                    BigNumber.prototype.toTwos = function(value) {
                        return toBigNumber(_bnify(this).toTwos(value));
                    };
                    BigNumber.prototype.abs = function() {
                        if (this._hex[0] === "-") return toBigNumber(_bnify(this).mul(BN_1));
                        return this;
                    };
                    BigNumber.prototype.add = function(other) {
                        return toBigNumber(_bnify(this).add(toBN(other)));
                    };
                    BigNumber.prototype.sub = function(other) {
                        return toBigNumber(_bnify(this).sub(toBN(other)));
                    };
                    BigNumber.prototype.div = function(other) {
                        var o = bigNumberify(other);
                        if (o.isZero()) errors.throwError("division by zero", errors.NUMERIC_FAULT, {
                            operation: "divide",
                            fault: "division by zero"
                        });
                        return toBigNumber(_bnify(this).div(toBN(other)));
                    };
                    BigNumber.prototype.mul = function(other) {
                        return toBigNumber(_bnify(this).mul(toBN(other)));
                    };
                    BigNumber.prototype.mod = function(other) {
                        return toBigNumber(_bnify(this).mod(toBN(other)));
                    };
                    BigNumber.prototype.pow = function(other) {
                        return toBigNumber(_bnify(this).pow(toBN(other)));
                    };
                    BigNumber.prototype.maskn = function(value) {
                        return toBigNumber(_bnify(this).maskn(value));
                    };
                    BigNumber.prototype.eq = function(other) {
                        return _bnify(this).eq(toBN(other));
                    };
                    BigNumber.prototype.lt = function(other) {
                        return _bnify(this).lt(toBN(other));
                    };
                    BigNumber.prototype.lte = function(other) {
                        return _bnify(this).lte(toBN(other));
                    };
                    BigNumber.prototype.gt = function(other) {
                        return _bnify(this).gt(toBN(other));
                    };
                    BigNumber.prototype.gte = function(other) {
                        return _bnify(this).gte(toBN(other));
                    };
                    BigNumber.prototype.isZero = function() {
                        return _bnify(this).isZero();
                    };
                    BigNumber.prototype.toNumber = function() {
                        try {
                            return _bnify(this).toNumber();
                        } catch (error) {
                            errors.throwError("overflow", errors.NUMERIC_FAULT, {
                                operation: "setValue",
                                fault: "overflow",
                                details: error.message
                            });
                        }
                        return null;
                    };
                    BigNumber.prototype.toString = function() {
                        return _bnify(this).toString(10);
                    };
                    BigNumber.prototype.toHexString = function() {
                        return this._hex;
                    };
                    BigNumber.isBigNumber = function(value) {
                        return properties_1.isType(value, "BigNumber");
                    };
                    return BigNumber;
                }();
                exports.BigNumber = BigNumber;
                function bigNumberify(value) {
                    if (BigNumber.isBigNumber(value)) return value;
                    return new BigNumber(value);
                }
                exports.bigNumberify = bigNumberify;
            /***/ },
            /***/ 8458: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /**
 *  Conversion Utilities
 *
 */ var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var errors = __importStar(__webpack_require__(6459));
                ///////////////////////////////
                function isHexable(value) {
                    return !!value.toHexString;
                }
                exports.isHexable = isHexable;
                function addSlice(array) {
                    if (array.slice) return array;
                    array.slice = function() {
                        var args = Array.prototype.slice.call(arguments);
                        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
                    };
                    return array;
                }
                function isArrayish(value) {
                    if (!value || parseInt(String(value.length)) != value.length || typeof value === "string") return false;
                    for(var i = 0; i < value.length; i++){
                        var v = value[i];
                        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
                    }
                    return true;
                }
                exports.isArrayish = isArrayish;
                function arrayify(value) {
                    if (value == null) errors.throwError("cannot convert null value to array", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    if (isHexable(value)) value = value.toHexString();
                    if (typeof value === "string") {
                        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
                        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        value = value.substring(2);
                        if (value.length % 2) value = "0" + value;
                        var result = [];
                        for(var i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
                        return addSlice(new Uint8Array(result));
                    }
                    if (isArrayish(value)) return addSlice(new Uint8Array(value));
                    errors.throwError("invalid arrayify value", null, {
                        arg: "value",
                        value: value,
                        type: typeof value
                    });
                    return null;
                }
                exports.arrayify = arrayify;
                function concat(objects) {
                    var arrays = [];
                    var length = 0;
                    for(var i = 0; i < objects.length; i++){
                        var object = arrayify(objects[i]);
                        arrays.push(object);
                        length += object.length;
                    }
                    var result = new Uint8Array(length);
                    var offset = 0;
                    for(var i = 0; i < arrays.length; i++){
                        result.set(arrays[i], offset);
                        offset += arrays[i].length;
                    }
                    return addSlice(result);
                }
                exports.concat = concat;
                function stripZeros(value) {
                    var result = arrayify(value);
                    if (result.length === 0) return result;
                    // Find the first non-zero entry
                    var start = 0;
                    while(result[start] === 0)start++;
                    // If we started with zeros, strip them
                    if (start) result = result.slice(start);
                    return result;
                }
                exports.stripZeros = stripZeros;
                function padZeros(value, length) {
                    value = arrayify(value);
                    if (length < value.length) throw new Error("cannot pad");
                    var result = new Uint8Array(length);
                    result.set(value, length - value.length);
                    return addSlice(result);
                }
                exports.padZeros = padZeros;
                function isHexString(value, length) {
                    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
                    if (length && value.length !== 2 + 2 * length) return false;
                    return true;
                }
                exports.isHexString = isHexString;
                var HexCharacters = "0123456789abcdef";
                function hexlify(value) {
                    if (isHexable(value)) return value.toHexString();
                    if (typeof value === "number") {
                        if (value < 0) errors.throwError("cannot hexlify negative value", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        // @TODO: Roll this into the above error as a numeric fault (overflow); next version, not backward compatible
                        // We can about (value == MAX_INT) to as well, since that may indicate we underflowed already
                        if (value >= 9007199254740991) errors.throwError("out-of-range", errors.NUMERIC_FAULT, {
                            operartion: "hexlify",
                            fault: "out-of-safe-range"
                        });
                        var hex = "";
                        while(value){
                            hex = HexCharacters[value & 0x0f] + hex;
                            value = Math.floor(value / 16);
                        }
                        if (hex.length) {
                            if (hex.length % 2) hex = "0" + hex;
                            return "0x" + hex;
                        }
                        return "0x00";
                    }
                    if (typeof value === "string") {
                        var match = value.match(/^(0x)?[0-9a-fA-F]*$/);
                        if (!match) errors.throwError("invalid hexidecimal string", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (match[1] !== "0x") errors.throwError("hex string must have 0x prefix", errors.INVALID_ARGUMENT, {
                            arg: "value",
                            value: value
                        });
                        if (value.length % 2) value = "0x0" + value.substring(2);
                        return value;
                    }
                    if (isArrayish(value)) {
                        var result = [];
                        for(var i = 0; i < value.length; i++){
                            var v = value[i];
                            result.push(HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f]);
                        }
                        return "0x" + result.join("");
                    }
                    errors.throwError("invalid hexlify value", null, {
                        arg: "value",
                        value: value
                    });
                    return "never";
                }
                exports.hexlify = hexlify;
                function hexDataLength(data) {
                    if (!isHexString(data) || data.length % 2 !== 0) return null;
                    return (data.length - 2) / 2;
                }
                exports.hexDataLength = hexDataLength;
                function hexDataSlice(data, offset, endOffset) {
                    if (!isHexString(data)) errors.throwError("invalid hex data", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: data
                    });
                    if (data.length % 2 !== 0) errors.throwError("hex data length must be even", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: data
                    });
                    offset = 2 + 2 * offset;
                    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
                    return "0x" + data.substring(offset);
                }
                exports.hexDataSlice = hexDataSlice;
                function hexStripZeros(value) {
                    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    while(value.length > 3 && value.substring(0, 3) === "0x0")value = "0x" + value.substring(3);
                    return value;
                }
                exports.hexStripZeros = hexStripZeros;
                function hexZeroPad(value, length) {
                    if (!isHexString(value)) errors.throwError("invalid hex string", errors.INVALID_ARGUMENT, {
                        arg: "value",
                        value: value
                    });
                    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
                    return value;
                }
                exports.hexZeroPad = hexZeroPad;
                function isSignature(value) {
                    return value && value.r != null && value.s != null;
                }
                function splitSignature(signature) {
                    var v = 0;
                    var r = "0x", s = "0x";
                    if (isSignature(signature)) {
                        if (signature.v == null && signature.recoveryParam == null) errors.throwError("at least on of recoveryParam or v must be specified", errors.INVALID_ARGUMENT, {
                            argument: "signature",
                            value: signature
                        });
                        r = hexZeroPad(signature.r, 32);
                        s = hexZeroPad(signature.s, 32);
                        v = signature.v;
                        if (typeof v === "string") v = parseInt(v, 16);
                        var recoveryParam = signature.recoveryParam;
                        if (recoveryParam == null && signature.v != null) recoveryParam = 1 - v % 2;
                        v = 27 + recoveryParam;
                    } else {
                        var bytes = arrayify(signature);
                        if (bytes.length !== 65) throw new Error("invalid signature");
                        r = hexlify(bytes.slice(0, 32));
                        s = hexlify(bytes.slice(32, 64));
                        v = bytes[64];
                        if (v !== 27 && v !== 28) v = 27 + v % 2;
                    }
                    return {
                        r: r,
                        s: s,
                        recoveryParam: v - 27,
                        v: v
                    };
                }
                exports.splitSignature = splitSignature;
                function joinSignature(signature) {
                    signature = splitSignature(signature);
                    return hexlify(concat([
                        signature.r,
                        signature.s,
                        signature.recoveryParam ? "0x1c" : "0x1b"
                    ]));
                }
                exports.joinSignature = joinSignature;
            /***/ },
            /***/ 918: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var sha3 = __webpack_require__(747);
                var bytes_1 = __webpack_require__(8458);
                function keccak256(data) {
                    return "0x" + sha3.keccak_256(bytes_1.arrayify(data));
                }
                exports.keccak256 = keccak256;
            /***/ },
            /***/ 8184: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var __importStar = this && this.__importStar || function(mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) {
                        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
                    }
                    result["default"] = mod;
                    return result;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var errors = __importStar(__webpack_require__(6459));
                function defineReadOnly(object, name1, value) {
                    Object.defineProperty(object, name1, {
                        enumerable: true,
                        value: value,
                        writable: false
                    });
                }
                exports.defineReadOnly = defineReadOnly;
                // There are some issues with instanceof with npm link, so we use this
                // to ensure types are what we expect.
                function setType(object, type) {
                    Object.defineProperty(object, "_ethersType", {
                        configurable: false,
                        value: type,
                        writable: false
                    });
                }
                exports.setType = setType;
                function isType(object, type) {
                    return object && object._ethersType === type;
                }
                exports.isType = isType;
                function resolveProperties(object) {
                    var result = {};
                    var promises = [];
                    Object.keys(object).forEach(function(key) {
                        var value = object[key];
                        if (value instanceof Promise) promises.push(value.then(function(value) {
                            result[key] = value;
                            return null;
                        }));
                        else result[key] = value;
                    });
                    return Promise.all(promises).then(function() {
                        return result;
                    });
                }
                exports.resolveProperties = resolveProperties;
                function checkProperties(object, properties) {
                    if (!object || typeof object !== "object") errors.throwError("invalid object", errors.INVALID_ARGUMENT, {
                        argument: "object",
                        value: object
                    });
                    Object.keys(object).forEach(function(key) {
                        if (!properties[key]) errors.throwError("invalid object key - " + key, errors.INVALID_ARGUMENT, {
                            argument: "transaction",
                            value: object,
                            key: key
                        });
                    });
                }
                exports.checkProperties = checkProperties;
                function shallowCopy(object) {
                    var result = {};
                    for(var key in object)result[key] = object[key];
                    return result;
                }
                exports.shallowCopy = shallowCopy;
                var opaque = {
                    boolean: true,
                    number: true,
                    string: true
                };
                function deepCopy(object, frozen) {
                    // Opaque objects are not mutable, so safe to copy by assignment
                    if (object === undefined || object === null || opaque[typeof object]) return object;
                    // Arrays are mutable, so we need to create a copy
                    if (Array.isArray(object)) {
                        var result = object.map(function(item) {
                            return deepCopy(item, frozen);
                        });
                        if (frozen) Object.freeze(result);
                        return result;
                    }
                    if (typeof object === "object") {
                        // Some internal objects, which are already immutable
                        if (isType(object, "BigNumber")) return object;
                        if (isType(object, "Description")) return object;
                        if (isType(object, "Indexed")) return object;
                        var result = {};
                        for(var key in object){
                            var value = object[key];
                            if (value === undefined) continue;
                            defineReadOnly(result, key, deepCopy(value, frozen));
                        }
                        if (frozen) Object.freeze(result);
                        return result;
                    }
                    // The function type is also immutable, so safe to copy by assignment
                    if (typeof object === "function") return object;
                    throw new Error("Cannot deepCopy " + typeof object);
                }
                exports.deepCopy = deepCopy;
                // See: https://github.com/isaacs/inherits/blob/master/inherits_browser.js
                function inherits(ctor, superCtor) {
                    ctor.super_ = superCtor;
                    ctor.prototype = Object.create(superCtor.prototype, {
                        constructor: {
                            value: ctor,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                }
                function inheritable(parent) {
                    return function(child) {
                        inherits(child, parent);
                        defineReadOnly(child, "inherits", inheritable(child));
                    };
                }
                exports.inheritable = inheritable;
            /***/ },
            /***/ 6100: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                //See: https://github.com/ethereum/wiki/wiki/RLP
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var bytes_1 = __webpack_require__(8458);
                function arrayifyInteger(value) {
                    var result = [];
                    while(value){
                        result.unshift(value & 0xff);
                        value >>= 8;
                    }
                    return result;
                }
                function unarrayifyInteger(data, offset, length) {
                    var result = 0;
                    for(var i = 0; i < length; i++)result = result * 256 + data[offset + i];
                    return result;
                }
                function _encode(object) {
                    if (Array.isArray(object)) {
                        var payload = [];
                        object.forEach(function(child) {
                            payload = payload.concat(_encode(child));
                        });
                        if (payload.length <= 55) {
                            payload.unshift(0xc0 + payload.length);
                            return payload;
                        }
                        var length = arrayifyInteger(payload.length);
                        length.unshift(0xf7 + length.length);
                        return length.concat(payload);
                    }
                    var data = Array.prototype.slice.call(bytes_1.arrayify(object));
                    if (data.length === 1 && data[0] <= 0x7f) return data;
                    else if (data.length <= 55) {
                        data.unshift(0x80 + data.length);
                        return data;
                    }
                    var length = arrayifyInteger(data.length);
                    length.unshift(0xb7 + length.length);
                    return length.concat(data);
                }
                function encode(object) {
                    return bytes_1.hexlify(_encode(object));
                }
                exports.encode = encode;
                function _decodeChildren(data, offset, childOffset, length) {
                    var result = [];
                    while(childOffset < offset + 1 + length){
                        var decoded = _decode(data, childOffset);
                        result.push(decoded.result);
                        childOffset += decoded.consumed;
                        if (childOffset > offset + 1 + length) throw new Error("invalid rlp");
                    }
                    return {
                        consumed: 1 + length,
                        result: result
                    };
                }
                // returns { consumed: number, result: Object }
                function _decode(data, offset) {
                    if (data.length === 0) throw new Error("invalid rlp data");
                    // Array with extra length prefix
                    if (data[offset] >= 0xf8) {
                        var lengthLength = data[offset] - 0xf7;
                        if (offset + 1 + lengthLength > data.length) throw new Error("too short");
                        var length = unarrayifyInteger(data, offset + 1, lengthLength);
                        if (offset + 1 + lengthLength + length > data.length) throw new Error("to short");
                        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
                    } else if (data[offset] >= 0xc0) {
                        var length = data[offset] - 0xc0;
                        if (offset + 1 + length > data.length) throw new Error("invalid rlp data");
                        return _decodeChildren(data, offset, offset + 1, length);
                    } else if (data[offset] >= 0xb8) {
                        var lengthLength = data[offset] - 0xb7;
                        if (offset + 1 + lengthLength > data.length) throw new Error("invalid rlp data");
                        var length = unarrayifyInteger(data, offset + 1, lengthLength);
                        if (offset + 1 + lengthLength + length > data.length) throw new Error("invalid rlp data");
                        var result = bytes_1.hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
                        return {
                            consumed: 1 + lengthLength + length,
                            result: result
                        };
                    } else if (data[offset] >= 0x80) {
                        var length = data[offset] - 0x80;
                        if (offset + 1 + length > data.length) throw new Error("invlaid rlp data");
                        var result = bytes_1.hexlify(data.slice(offset + 1, offset + 1 + length));
                        return {
                            consumed: 1 + length,
                            result: result
                        };
                    }
                    return {
                        consumed: 1,
                        result: bytes_1.hexlify(data[offset])
                    };
                }
                function decode(data) {
                    var bytes = bytes_1.arrayify(data);
                    var decoded = _decode(bytes, 0);
                    if (decoded.consumed !== bytes.length) throw new Error("invalid rlp data");
                    return decoded.result;
                }
                exports.decode = decode;
            /***/ },
            /***/ 1165: /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(8707);
                var errors_1 = __webpack_require__(6459);
                var bytes_1 = __webpack_require__(8458);
                ///////////////////////////////
                var UnicodeNormalizationForm;
                (function(UnicodeNormalizationForm) {
                    UnicodeNormalizationForm["current"] = "";
                    UnicodeNormalizationForm["NFC"] = "NFC";
                    UnicodeNormalizationForm["NFD"] = "NFD";
                    UnicodeNormalizationForm["NFKC"] = "NFKC";
                    UnicodeNormalizationForm["NFKD"] = "NFKD";
                })(UnicodeNormalizationForm = exports.UnicodeNormalizationForm || (exports.UnicodeNormalizationForm = {}));
                // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
                function toUtf8Bytes(str, form) {
                    if (form === void 0) form = UnicodeNormalizationForm.current;
                    if (form != UnicodeNormalizationForm.current) {
                        errors_1.checkNormalize();
                        str = str.normalize(form);
                    }
                    var result = [];
                    for(var i = 0; i < str.length; i++){
                        var c = str.charCodeAt(i);
                        if (c < 0x80) result.push(c);
                        else if (c < 0x800) {
                            result.push(c >> 6 | 0xc0);
                            result.push(c & 0x3f | 0x80);
                        } else if ((c & 0xfc00) == 0xd800) {
                            i++;
                            var c2 = str.charCodeAt(i);
                            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
                            // Surrogate Pair
                            c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                            result.push(c >> 18 | 0xf0);
                            result.push(c >> 12 & 0x3f | 0x80);
                            result.push(c >> 6 & 0x3f | 0x80);
                            result.push(c & 0x3f | 0x80);
                        } else {
                            result.push(c >> 12 | 0xe0);
                            result.push(c >> 6 & 0x3f | 0x80);
                            result.push(c & 0x3f | 0x80);
                        }
                    }
                    return bytes_1.arrayify(result);
                }
                exports.toUtf8Bytes = toUtf8Bytes;
                // http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
                function toUtf8String(bytes, ignoreErrors) {
                    bytes = bytes_1.arrayify(bytes);
                    var result = "";
                    var i = 0;
                    // Invalid bytes are ignored
                    while(i < bytes.length){
                        var c = bytes[i++];
                        // 0xxx xxxx
                        if (c >> 7 === 0) {
                            result += String.fromCharCode(c);
                            continue;
                        }
                        // Multibyte; how many bytes left for this character?
                        var extraLength = null;
                        var overlongMask = null;
                        // 110x xxxx 10xx xxxx
                        if ((c & 0xe0) === 0xc0) {
                            extraLength = 1;
                            overlongMask = 0x7f;
                        // 1110 xxxx 10xx xxxx 10xx xxxx
                        } else if ((c & 0xf0) === 0xe0) {
                            extraLength = 2;
                            overlongMask = 0x7ff;
                        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
                        } else if ((c & 0xf8) === 0xf0) {
                            extraLength = 3;
                            overlongMask = 0xffff;
                        } else {
                            if (!ignoreErrors) {
                                if ((c & 0xc0) === 0x80) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                                throw new Error("invalid utf8 byte sequence; invalid prefix");
                            }
                            continue;
                        }
                        // Do we have enough bytes in our data?
                        if (i + extraLength > bytes.length) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; too short");
                            // If there is an invalid unprocessed byte, skip continuation bytes
                            for(; i < bytes.length; i++){
                                if (bytes[i] >> 6 !== 0x02) break;
                            }
                            continue;
                        }
                        // Remove the length prefix from the char
                        var res = c & (1 << 8 - extraLength - 1) - 1;
                        for(var j = 0; j < extraLength; j++){
                            var nextChar = bytes[i];
                            // Invalid continuation byte
                            if ((nextChar & 0xc0) != 0x80) {
                                res = null;
                                break;
                            }
                            res = res << 6 | nextChar & 0x3f;
                            i++;
                        }
                        if (res === null) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
                            continue;
                        }
                        // Check for overlong seuences (more bytes than needed)
                        if (res <= overlongMask) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; overlong");
                            continue;
                        }
                        // Maximum code point
                        if (res > 0x10ffff) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; out-of-range");
                            continue;
                        }
                        // Reserved for UTF-16 surrogate halves
                        if (res >= 0xd800 && res <= 0xdfff) {
                            if (!ignoreErrors) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
                            continue;
                        }
                        if (res <= 0xffff) {
                            result += String.fromCharCode(res);
                            continue;
                        }
                        res -= 0x10000;
                        result += String.fromCharCode((res >> 10 & 0x3ff) + 0xd800, (res & 0x3ff) + 0xdc00);
                    }
                    return result;
                }
                exports.toUtf8String = toUtf8String;
                function formatBytes32String(text) {
                    // Get the bytes
                    var bytes = toUtf8Bytes(text);
                    // Check we have room for null-termination
                    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
                    // Zero-pad (implicitly null-terminates)
                    return bytes_1.hexlify(bytes_1.concat([
                        bytes,
                        constants_1.HashZero
                    ]).slice(0, 32));
                }
                exports.formatBytes32String = formatBytes32String;
                function parseBytes32String(bytes) {
                    var data = bytes_1.arrayify(bytes);
                    // Must be 32 bytes with a null-termination
                    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
                    if (data[31] !== 0) throw new Error("invalid bytes32 sdtring - no null terminator");
                    // Find the null termination
                    var length = 31;
                    while(data[length - 1] === 0)length--;
                    // Determine the string value
                    return toUtf8String(data.slice(0, length));
                }
                exports.parseBytes32String = parseBytes32String;
            /***/ },
            /***/ 634: /***/ function(module1, exports, __webpack_require__) {
                var __WEBPACK_AMD_DEFINE_RESULT__;
                (function(globalObject) {
                    "use strict";
                    /*
 *      bignumber.js v7.2.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
                    POWS_TEN = [
                        1,
                        10,
                        100,
                        1e3,
                        1e4,
                        1e5,
                        1e6,
                        1e7,
                        1e8,
                        1e9,
                        1e10,
                        1e11,
                        1e12,
                        1e13
                    ], SQRT_BASE = 1e7, // EDITABLE
                    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
                    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
                    MAX = 1E9; // 0 to MAX_INT32
                    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
                        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
                            constructor: BigNumber,
                            toString: null,
                            valueOf: null
                        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
                        // The default values below must be integers within the inclusive ranges stated.
                        // The values can also be changed at run-time using BigNumber.set.
                        // The maximum number of decimal places for operations involving division.
                        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
                        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
                        // UP         0 Away from zero.
                        // DOWN       1 Towards zero.
                        // CEIL       2 Towards +Infinity.
                        // FLOOR      3 Towards -Infinity.
                        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
                        // The exponent value at and beneath which toString returns exponential notation.
                        // Number type: -7
                        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
                        // Number type: 21
                        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
                        // The minimum exponent value, beneath which underflow to zero occurs.
                        // Number type: -324  (5e-324)
                        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
                        // Number type:  308  (1.7976931348623157e+308)
                        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
                        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
                        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
                        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                        // The remainder (r) is calculated as: r = a - n * q.
                        //
                        // UP        0 The remainder is positive if the dividend is negative, else is negative.
                        // DOWN      1 The remainder has the same sign as the dividend.
                        //             This modulo mode is commonly known as 'truncated division' and is
                        //             equivalent to (a % n) in JavaScript.
                        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
                        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
                        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
                        //             The remainder is always positive.
                        //
                        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
                        // modes are commonly used for the modulus operation.
                        // Although the other rounding modes can also be used, they may not give useful results.
                        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
                        // If POW_PRECISION is 0, there will be unlimited significant digits.
                        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
                        FORMAT = {
                            decimalSeparator: ".",
                            groupSeparator: ",",
                            groupSize: 3,
                            secondaryGroupSize: 0,
                            fractionGroupSeparator: "\xa0",
                            fractionGroupSize: 0
                        }, // The alphabet used for base conversion.
                        // It must be at least 2 characters long, with no '.' or repeated character.
                        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
                        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
                        //------------------------------------------------------------------------------------------
                        // CONSTRUCTOR
                        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * n {number|string|BigNumber} A numeric value.
     * [b] {number} The base of n. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(n, b) {
                            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
                            // Enable constructor usage without new.
                            if (!(x instanceof BigNumber)) // Don't throw on constructor call without new (#81).
                            // '[BigNumber Error] Constructor call without new: {n}'
                            //throw Error(bignumberError + ' Constructor call without new: ' + n);
                            return new BigNumber(n, b);
                            if (b == null) {
                                // Duplicate.
                                if (n instanceof BigNumber) {
                                    x.s = n.s;
                                    x.e = n.e;
                                    x.c = (n = n.c) ? n.slice() : n;
                                    return;
                                }
                                isNum = typeof n == "number";
                                if (isNum && n * 0 == 0) {
                                    // Use `1 / n` to handle minus zero also.
                                    x.s = 1 / n < 0 ? (n = -n, -1) : 1;
                                    // Faster path for integers.
                                    if (n === ~~n) {
                                        for(e = 0, i = n; i >= 10; i /= 10, e++);
                                        x.e = e;
                                        x.c = [
                                            n
                                        ];
                                        return;
                                    }
                                    str = n + "";
                                } else {
                                    if (!isNumeric.test(str = n + "")) return parseNumeric(x, str, isNum);
                                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                                }
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                // Exponential form?
                                if ((i = str.search(/e/i)) > 0) {
                                    // Determine exponent.
                                    if (e < 0) e = i;
                                    e += +str.slice(i + 1);
                                    str = str.substring(0, i);
                                } else if (e < 0) // Integer.
                                e = str.length;
                            } else {
                                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                                intCheck(b, 2, ALPHABET.length, "Base");
                                str = n + "";
                                // Allow exponential notation to be used with base 10 argument, while
                                // also rounding to DECIMAL_PLACES as with other bases.
                                if (b == 10) {
                                    x = new BigNumber(n instanceof BigNumber ? n : str);
                                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                                }
                                isNum = typeof n == "number";
                                if (isNum) {
                                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                                    if (n * 0 != 0) return parseNumeric(x, str, isNum, b);
                                    x.s = 1 / n < 0 ? (str = str.slice(1), -1) : 1;
                                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + n);
                                    // Prevent later check for length on converted number.
                                    isNum = false;
                                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                                alphabet = ALPHABET.slice(0, b);
                                e = i = 0;
                                // Check that str is a valid base b number.
                                // Don't use RegExp so alphabet can contain special characters.
                                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                                    if (c == ".") // If '.' is not the first character and it has not be found before.
                                    {
                                        if (i > e) {
                                            e = len;
                                            continue;
                                        }
                                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                                    {
                                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                                            caseChanged = true;
                                            i = -1;
                                            e = 0;
                                            continue;
                                        }
                                    }
                                    return parseNumeric(x, n + "", isNum, b);
                                }
                                str = convertBase(str, b, 10, x.s);
                                // Decimal point?
                                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                                else e = str.length;
                            }
                            // Determine leading zeros.
                            for(i = 0; str.charCodeAt(i) === 48; i++);
                            // Determine trailing zeros.
                            for(len = str.length; str.charCodeAt(--len) === 48;);
                            str = str.slice(i, ++len);
                            if (str) {
                                len -= i;
                                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                                if (isNum && BigNumber.DEBUG && len > 15 && (n > MAX_SAFE_INTEGER || n !== mathfloor(n))) throw Error(tooManyDigits + x.s * n);
                                e = e - i - 1;
                                // Overflow?
                                if (e > MAX_EXP) // Infinity.
                                x.c = x.e = null;
                                else if (e < MIN_EXP) // Zero.
                                x.c = [
                                    x.e = 0
                                ];
                                else {
                                    x.e = e;
                                    x.c = [];
                                    // Transform base
                                    // e is the base 10 exponent.
                                    // i is where to slice str to get the first element of the coefficient array.
                                    i = (e + 1) % LOG_BASE;
                                    if (e < 0) i += LOG_BASE;
                                    if (i < len) {
                                        if (i) x.c.push(+str.slice(0, i));
                                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                                        str = str.slice(i);
                                        i = LOG_BASE - str.length;
                                    } else i -= len;
                                    for(; i--; str += "0");
                                    x.c.push(+str);
                                }
                            } else // Zero.
                            x.c = [
                                x.e = 0
                            ];
                        }
                        // CONSTRUCTOR PROPERTIES
                        BigNumber.clone = clone;
                        BigNumber.ROUND_UP = 0;
                        BigNumber.ROUND_DOWN = 1;
                        BigNumber.ROUND_CEIL = 2;
                        BigNumber.ROUND_FLOOR = 3;
                        BigNumber.ROUND_HALF_UP = 4;
                        BigNumber.ROUND_HALF_DOWN = 5;
                        BigNumber.ROUND_HALF_EVEN = 6;
                        BigNumber.ROUND_HALF_CEIL = 7;
                        BigNumber.ROUND_HALF_FLOOR = 8;
                        BigNumber.EUCLID = 9;
                        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *      decimalSeparator       {string}
     *      groupSeparator         {string}
     *      groupSize              {number}
     *      secondaryGroupSize     {number}
     *      fractionGroupSeparator {string}
     *      fractionGroupSize      {number}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
                            var p, v;
                            if (obj != null) {
                                if (typeof obj == "object") {
                                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        DECIMAL_PLACES = v;
                                    }
                                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 8, p);
                                        ROUNDING_MODE = v;
                                    }
                                    // EXPONENTIAL_AT {number|number[]}
                                    // Integer, -MAX to MAX inclusive or
                                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, 0, p);
                                            intCheck(v[1], 0, MAX, p);
                                            TO_EXP_NEG = v[0];
                                            TO_EXP_POS = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                                        }
                                    }
                                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                                    if (obj.hasOwnProperty(p = "RANGE")) {
                                        v = obj[p];
                                        if (isArray(v)) {
                                            intCheck(v[0], -MAX, -1, p);
                                            intCheck(v[1], 1, MAX, p);
                                            MIN_EXP = v[0];
                                            MAX_EXP = v[1];
                                        } else {
                                            intCheck(v, -MAX, MAX, p);
                                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                                        }
                                    }
                                    // CRYPTO {boolean} true or false.
                                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                                    // '[BigNumber Error] crypto unavailable'
                                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                                        v = obj[p];
                                        if (v === !!v) {
                                            if (v) {
                                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                                else {
                                                    CRYPTO = !v;
                                                    throw Error(bignumberError + "crypto unavailable");
                                                }
                                            } else CRYPTO = v;
                                        } else throw Error(bignumberError + p + " not true or false: " + v);
                                    }
                                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                                        v = obj[p];
                                        intCheck(v, 0, 9, p);
                                        MODULO_MODE = v;
                                    }
                                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                                        v = obj[p];
                                        intCheck(v, 0, MAX, p);
                                        POW_PRECISION = v;
                                    }
                                    // FORMAT {object}
                                    // '[BigNumber Error] FORMAT not an object: {v}'
                                    if (obj.hasOwnProperty(p = "FORMAT")) {
                                        v = obj[p];
                                        if (typeof v == "object") FORMAT = v;
                                        else throw Error(bignumberError + p + " not an object: " + v);
                                    }
                                    // ALPHABET {string}
                                    // '[BigNumber Error] ALPHABET invalid: {v}'
                                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                                        v = obj[p];
                                        // Disallow if only one character, or contains '.' or a repeated character.
                                        if (typeof v == "string" && !/^.$|\.|(.).*\1/.test(v)) ALPHABET = v;
                                        else throw Error(bignumberError + p + " invalid: " + v);
                                    }
                                } else // '[BigNumber Error] Object expected: {v}'
                                throw Error(bignumberError + "Object expected: " + obj);
                            }
                            return {
                                DECIMAL_PLACES: DECIMAL_PLACES,
                                ROUNDING_MODE: ROUNDING_MODE,
                                EXPONENTIAL_AT: [
                                    TO_EXP_NEG,
                                    TO_EXP_POS
                                ],
                                RANGE: [
                                    MIN_EXP,
                                    MAX_EXP
                                ],
                                CRYPTO: CRYPTO,
                                MODULO_MODE: MODULO_MODE,
                                POW_PRECISION: POW_PRECISION,
                                FORMAT: FORMAT,
                                ALPHABET: ALPHABET
                            };
                        };
                        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * v {any}
     */ BigNumber.isBigNumber = function(v) {
                            return v instanceof BigNumber || v && v._isBigNumber === true || false;
                        };
                        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
                            return maxOrMin(arguments, P.lt);
                        };
                        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
                            return maxOrMin(arguments, P.gt);
                        };
                        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
                            var pow2_53 = 0x20000000000000;
                            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
                            // Check if Math.random() produces more than 32 bits of randomness.
                            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
                            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
                            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                                return mathfloor(Math.random() * pow2_53);
                            } : function() {
                                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
                            };
                            return function(dp) {
                                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                                if (dp == null) dp = DECIMAL_PLACES;
                                else intCheck(dp, 0, MAX);
                                k = mathceil(dp / LOG_BASE);
                                if (CRYPTO) {
                                    // Browsers supporting crypto.getRandomValues.
                                    if (crypto.getRandomValues) {
                                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                                        for(; i < k;){
                                            // 53 bits:
                                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                                            //                                     11111 11111111 11111111
                                            // 0x20000 is 2^21.
                                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                                            // Rejection sampling:
                                            // 0 <= v < 9007199254740992
                                            // Probability that v >= 9e15, is
                                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                                            if (v >= 9e15) {
                                                b = crypto.getRandomValues(new Uint32Array(2));
                                                a[i] = b[0];
                                                a[i + 1] = b[1];
                                            } else {
                                                // 0 <= v <= 8999999999999999
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 2;
                                            }
                                        }
                                        i = k / 2;
                                    // Node.js supporting crypto.randomBytes.
                                    } else if (crypto.randomBytes) {
                                        // buffer
                                        a = crypto.randomBytes(k *= 7);
                                        for(; i < k;){
                                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                                            // 0 <= v < 9007199254740992
                                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                                            else {
                                                // 0 <= (v % 1e14) <= 99999999999999
                                                c.push(v % 1e14);
                                                i += 7;
                                            }
                                        }
                                        i = k / 7;
                                    } else {
                                        CRYPTO = false;
                                        throw Error(bignumberError + "crypto unavailable");
                                    }
                                }
                                // Use Math.random.
                                if (!CRYPTO) for(; i < k;){
                                    v = random53bitInt();
                                    if (v < 9e15) c[i++] = v % 1e14;
                                }
                                k = c[--i];
                                dp %= LOG_BASE;
                                // Convert trailing digits to zeros according to dp.
                                if (k && dp) {
                                    v = POWS_TEN[LOG_BASE - dp];
                                    c[i] = mathfloor(k / v) * v;
                                }
                                // Remove trailing elements which are zero.
                                for(; c[i] === 0; c.pop(), i--);
                                // Zero?
                                if (i < 0) c = [
                                    e = 0
                                ];
                                else {
                                    // Remove leading elements which are zero and adjust exponent accordingly.
                                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                                    // Count the digits of the first element of c to determine leading zeros, and...
                                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                                    // adjust the exponent accordingly.
                                    if (i < LOG_BASE) e -= LOG_BASE - i;
                                }
                                rand.e = e;
                                rand.c = c;
                                return rand;
                            };
                        }();
                        // PRIVATE FUNCTIONS
                        // Called by BigNumber and BigNumber.prototype.toString.
                        convertBase = function() {
                            var decimal = "0123456789";
                            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                                var j, arr = [
                                    0
                                ], arrL, i = 0, len = str.length;
                                for(; i < len;){
                                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                                    arr[0] += alphabet.indexOf(str.charAt(i++));
                                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                                        if (arr[j + 1] == null) arr[j + 1] = 0;
                                        arr[j + 1] += arr[j] / baseOut | 0;
                                        arr[j] %= baseOut;
                                    }
                                }
                                return arr.reverse();
                            }
                            // Convert a numeric string of baseIn to a numeric string of baseOut.
                            // If the caller is toString, we are converting from base 10 to baseOut.
                            // If the caller is BigNumber, we are converting from baseIn to base 10.
                            return function(str, baseIn, baseOut, sign, callerIsToString) {
                                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                                // Non-integer.
                                if (i >= 0) {
                                    k = POW_PRECISION;
                                    // Unlimited precision.
                                    POW_PRECISION = 0;
                                    str = str.replace(".", "");
                                    y = new BigNumber(baseIn);
                                    x = y.pow(str.length - i);
                                    POW_PRECISION = k;
                                    // Convert str as if an integer, then restore the fraction part by dividing the
                                    // result by its base raised to a power.
                                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                                    y.e = y.c.length;
                                }
                                // Convert the number as integer.
                                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                                e = k = xc.length;
                                // Remove trailing zeros.
                                for(; xc[--k] == 0; xc.pop());
                                // Zero?
                                if (!xc[0]) return alphabet.charAt(0);
                                // Does str represent an integer? If so, no need for the division.
                                if (i < 0) --e;
                                else {
                                    x.c = xc;
                                    x.e = e;
                                    // The sign is needed for correct rounding.
                                    x.s = sign;
                                    x = div(x, y, dp, rm, baseOut);
                                    xc = x.c;
                                    r = x.r;
                                    e = x.e;
                                }
                                // xc now represents str converted to baseOut.
                                // THe index of the rounding digit.
                                d = e + dp + 1;
                                // The rounding digit: the digit to the right of the digit that may be rounded up.
                                i = xc[d];
                                // Look at the rounding digits and mode to determine whether to round up.
                                k = baseOut / 2;
                                r = r || d < 0 || xc[d + 1] != null;
                                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                                // If the index of the rounding digit is not greater than zero, or xc represents
                                // zero, then the result of the base conversion is zero or, if rounding up, a value
                                // such as 0.00001.
                                if (d < 1 || !xc[0]) // 1^-dp or 0
                                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                                else {
                                    // Truncate xc to the required number of decimal places.
                                    xc.length = d;
                                    // Round up?
                                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                                    for(--baseOut; ++xc[--d] > baseOut;){
                                        xc[d] = 0;
                                        if (!d) {
                                            ++e;
                                            xc = [
                                                1
                                            ].concat(xc);
                                        }
                                    }
                                    // Determine trailing zeros.
                                    for(k = xc.length; !xc[--k];);
                                    // E.g. [4, 11, 15] becomes 4bf.
                                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                                    // Add leading zeros, decimal point and trailing zeros as required.
                                    str = toFixedPoint(str, e, alphabet.charAt(0));
                                }
                                // The caller will add the sign.
                                return str;
                            };
                        }();
                        // Perform division in the specified base. Called by div and convertBase.
                        div = function() {
                            // Assume non-zero x and k.
                            function multiply(x, k, base) {
                                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                                for(x = x.slice(); i--;){
                                    xlo = x[i] % SQRT_BASE;
                                    xhi = x[i] / SQRT_BASE | 0;
                                    m = khi * xlo + xhi * klo;
                                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                                    x[i] = temp % base;
                                }
                                if (carry) x = [
                                    carry
                                ].concat(x);
                                return x;
                            }
                            function compare(a, b, aL, bL) {
                                var i, cmp;
                                if (aL != bL) cmp = aL > bL ? 1 : -1;
                                else {
                                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                                        cmp = a[i] > b[i] ? 1 : -1;
                                        break;
                                    }
                                }
                                return cmp;
                            }
                            function subtract(a, b, aL, base) {
                                var i = 0;
                                // Subtract b from a.
                                for(; aL--;){
                                    a[aL] -= i;
                                    i = a[aL] < b[aL] ? 1 : 0;
                                    a[aL] = i * base + a[aL] - b[aL];
                                }
                                // Remove leading zeros.
                                for(; !a[0] && a.length > 1; a.splice(0, 1));
                            }
                            // x: dividend, y: divisor.
                            return function(x, y, dp, rm, base) {
                                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                                // Either NaN, Infinity or 0?
                                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                                q = new BigNumber(s);
                                qc = q.c = [];
                                e = x.e - y.e;
                                s = dp + e + 1;
                                if (!base) {
                                    base = BASE;
                                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                                    s = s / LOG_BASE | 0;
                                }
                                // Result exponent may be one less then the current value of e.
                                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                                for(i = 0; yc[i] == (xc[i] || 0); i++);
                                if (yc[i] > (xc[i] || 0)) e--;
                                if (s < 0) {
                                    qc.push(1);
                                    more = true;
                                } else {
                                    xL = xc.length;
                                    yL = yc.length;
                                    i = 0;
                                    s += 2;
                                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                                    n = mathfloor(base / (yc[0] + 1));
                                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                                    if (n > 1) {
                                        yc = multiply(yc, n, base);
                                        xc = multiply(xc, n, base);
                                        yL = yc.length;
                                        xL = xc.length;
                                    }
                                    xi = yL;
                                    rem = xc.slice(0, yL);
                                    remL = rem.length;
                                    // Add zeros to make remainder as long as divisor.
                                    for(; remL < yL; rem[remL++] = 0);
                                    yz = yc.slice();
                                    yz = [
                                        0
                                    ].concat(yz);
                                    yc0 = yc[0];
                                    if (yc[1] >= base / 2) yc0++;
                                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                                    do {
                                        n = 0;
                                        // Compare divisor and remainder.
                                        cmp = compare(yc, rem, yL, remL);
                                        // If divisor < remainder.
                                        if (cmp < 0) {
                                            // Calculate trial digit, n.
                                            rem0 = rem[0];
                                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                                            // n is how many times the divisor goes into the current remainder.
                                            n = mathfloor(rem0 / yc0);
                                            //  Algorithm:
                                            //  product = divisor multiplied by trial digit (n).
                                            //  Compare product and remainder.
                                            //  If product is greater than remainder:
                                            //    Subtract divisor from product, decrement trial digit.
                                            //  Subtract product from remainder.
                                            //  If product was less than remainder at the last compare:
                                            //    Compare new remainder and divisor.
                                            //    If remainder is greater than divisor:
                                            //      Subtract divisor from remainder, increment trial digit.
                                            if (n > 1) {
                                                // n may be > base only when base is 3.
                                                if (n >= base) n = base - 1;
                                                // product = divisor * trial digit.
                                                prod = multiply(yc, n, base);
                                                prodL = prod.length;
                                                remL = rem.length;
                                                // Compare product and remainder.
                                                // If product > remainder then trial digit n too high.
                                                // n is 1 too high about 5% of the time, and is not known to have
                                                // ever been more than 1 too high.
                                                while(compare(prod, rem, prodL, remL) == 1){
                                                    n--;
                                                    // Subtract divisor from product.
                                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                                    prodL = prod.length;
                                                    cmp = 1;
                                                }
                                            } else {
                                                // n is 0 or 1, cmp is -1.
                                                // If n is 0, there is no need to compare yc and rem again below,
                                                // so change cmp to 1 to avoid it.
                                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                                cmp = n = 1;
                                                // product = divisor
                                                prod = yc.slice();
                                                prodL = prod.length;
                                            }
                                            if (prodL < remL) prod = [
                                                0
                                            ].concat(prod);
                                            // Subtract product from remainder.
                                            subtract(rem, prod, remL, base);
                                            remL = rem.length;
                                            // If product was < remainder.
                                            if (cmp == -1) // Compare divisor and new remainder.
                                            // If divisor < new remainder, subtract divisor from remainder.
                                            // Trial digit n too low.
                                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                            while(compare(yc, rem, yL, remL) < 1){
                                                n++;
                                                // Subtract divisor from remainder.
                                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                                remL = rem.length;
                                            }
                                        } else if (cmp === 0) {
                                            n++;
                                            rem = [
                                                0
                                            ];
                                        } // else cmp === 1 and n will be 0
                                        // Add the next digit, n, to the result array.
                                        qc[i++] = n;
                                        // Update the remainder.
                                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                                        else {
                                            rem = [
                                                xc[xi]
                                            ];
                                            remL = 1;
                                        }
                                    }while ((xi++ < xL || rem[0] != null) && s--);
                                    more = rem[0] != null;
                                    // Leading zero?
                                    if (!qc[0]) qc.splice(0, 1);
                                }
                                if (base == BASE) {
                                    // To calculate q.e, first get the number of digits of qc[0].
                                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                                // Caller is convertBase.
                                } else {
                                    q.e = e;
                                    q.r = +more;
                                }
                                return q;
                            };
                        }();
                        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
                            var c0, e, ne, len, str;
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            if (!n.c) return n.toString();
                            c0 = n.c[0];
                            ne = n.e;
                            if (i == null) {
                                str = coeffToString(n.c);
                                str = id == 1 || id == 2 && ne <= TO_EXP_NEG ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
                            } else {
                                n = round(new BigNumber(n), i, rm);
                                // n.e may have changed if the value was rounded up.
                                e = n.e;
                                str = coeffToString(n.c);
                                len = str.length;
                                // toPrecision returns exponential notation if the number of significant digits
                                // specified is less than the number of digits necessary to represent the integer
                                // part of the value in fixed-point notation.
                                // Exponential notation.
                                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                                    // Append zeros?
                                    for(; len < i; str += "0", len++);
                                    str = toExponential(str, e);
                                // Fixed-point notation.
                                } else {
                                    i -= ne;
                                    str = toFixedPoint(str, e, "0");
                                    // Append zeros?
                                    if (e + 1 > len) {
                                        if (--i > 0) for(str += "."; i--; str += "0");
                                    } else {
                                        i += e - len;
                                        if (i > 0) {
                                            if (e + 1 == len) str += ".";
                                            for(; i--; str += "0");
                                        }
                                    }
                                }
                            }
                            return n.s < 0 && c0 ? "-" + str : str;
                        }
                        // Handle BigNumber.max and BigNumber.min.
                        function maxOrMin(args, method) {
                            var m, n, i = 0;
                            if (isArray(args[0])) args = args[0];
                            m = new BigNumber(args[0]);
                            for(; ++i < args.length;){
                                n = new BigNumber(args[i]);
                                // If any number is NaN, return NaN.
                                if (!n.s) {
                                    m = n;
                                    break;
                                } else if (method.call(m, n)) m = n;
                            }
                            return m;
                        }
                        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
                            var i = 1, j = c.length;
                            // Remove trailing zeros.
                            for(; !c[--j]; c.pop());
                            // Calculate the base 10 exponent. First get the number of digits of c[0].
                            for(j = c[0]; j >= 10; j /= 10, i++);
                            // Overflow?
                            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
                            n.c = n.e = null;
                            else if (e < MIN_EXP) // Zero.
                            n.c = [
                                n.e = 0
                            ];
                            else {
                                n.e = e;
                                n.c = c;
                            }
                            return n;
                        }
                        // Handle values that fail the validity test in BigNumber.
                        parseNumeric = function() {
                            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
                            return function(x, str, isNum, b) {
                                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                                // No exception on ±Infinity or NaN.
                                if (isInfinityOrNaN.test(s)) {
                                    x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                                    x.c = x.e = null;
                                } else {
                                    if (!isNum) {
                                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                                        s = s.replace(basePrefix, function(m, p1, p2) {
                                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                                            return !b || b == base ? p1 : m;
                                        });
                                        if (b) {
                                            base = b;
                                            // E.g. '1.' to '1', '.1' to '0.1'
                                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                                        }
                                        if (str != s) return new BigNumber(s, base);
                                    }
                                    // '[BigNumber Error] Not a number: {n}'
                                    // '[BigNumber Error] Not a base {b} number: {n}'
                                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                                    // NaN
                                    x.c = x.e = x.s = null;
                                }
                            };
                        }();
                        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
                            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
                            // if x is not Infinity or NaN...
                            if (xc) {
                                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                                // ni is the index of n within x.c.
                                // d is the number of digits of n.
                                // i is the index of rd within n including leading zeros.
                                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                                out: {
                                    // Get the number of digits of the first element of xc.
                                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                                    i = sd - d;
                                    // If the rounding digit is in the first element of xc...
                                    if (i < 0) {
                                        i += LOG_BASE;
                                        j = sd;
                                        n = xc[ni = 0];
                                        // Get the rounding digit at index j of n.
                                        rd = n / pows10[d - j - 1] % 10 | 0;
                                    } else {
                                        ni = mathceil((i + 1) / LOG_BASE);
                                        if (ni >= xc.length) {
                                            if (r) {
                                                // Needed by sqrt.
                                                for(; xc.length <= ni; xc.push(0));
                                                n = rd = 0;
                                                d = 1;
                                                i %= LOG_BASE;
                                                j = i - LOG_BASE + 1;
                                            } else break out;
                                        } else {
                                            n = k = xc[ni];
                                            // Get the number of digits of n.
                                            for(d = 1; k >= 10; k /= 10, d++);
                                            // Get the index of rd within n.
                                            i %= LOG_BASE;
                                            // Get the index of rd within n, adjusted for leading zeros.
                                            // The number of leading zeros of n is given by LOG_BASE - d.
                                            j = i - LOG_BASE + d;
                                            // Get the rounding digit at index j of n.
                                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                                        }
                                    }
                                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                                    if (sd < 1 || !xc[0]) {
                                        xc.length = 0;
                                        if (r) {
                                            // Convert sd to decimal places.
                                            sd -= x.e + 1;
                                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                                            x.e = -sd || 0;
                                        } else // Zero.
                                        xc[0] = x.e = 0;
                                        return x;
                                    }
                                    // Remove excess digits.
                                    if (i == 0) {
                                        xc.length = ni;
                                        k = 1;
                                        ni--;
                                    } else {
                                        xc.length = ni + 1;
                                        k = pows10[LOG_BASE - i];
                                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                                        // j > 0 means i > number of leading zeros of n.
                                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                                    }
                                    // Round up?
                                    if (r) {
                                        for(;;)// If the digit to be rounded up is in the first element of xc...
                                        if (ni == 0) {
                                            // i will be the length of xc[0] before k is added.
                                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                                            j = xc[0] += k;
                                            for(k = 1; j >= 10; j /= 10, k++);
                                            // if i != k the length has increased.
                                            if (i != k) {
                                                x.e++;
                                                if (xc[0] == BASE) xc[0] = 1;
                                            }
                                            break;
                                        } else {
                                            xc[ni] += k;
                                            if (xc[ni] != BASE) break;
                                            xc[ni--] = 0;
                                            k = 1;
                                        }
                                    }
                                    // Remove trailing zeros.
                                    for(i = xc.length; xc[--i] === 0; xc.pop());
                                }
                                // Overflow? Infinity.
                                if (x.e > MAX_EXP) x.c = x.e = null;
                                else if (x.e < MIN_EXP) x.c = [
                                    x.e = 0
                                ];
                            }
                            return x;
                        }
                        // PROTOTYPE/INSTANCE METHODS
                        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
                            var x = new BigNumber(this);
                            if (x.s < 0) x.s = 1;
                            return x;
                        };
                        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
                            return compare(this, new BigNumber(y, b));
                        };
                        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
                            var c, n, v, x = this;
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), dp + x.e + 1, rm);
                            }
                            if (!(c = x.c)) return null;
                            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
                            // Subtract the number of trailing zeros of the last number.
                            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
                            if (n < 0) n = 0;
                            return n;
                        };
                        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
                            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
                        };
                        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
                            return div(this, new BigNumber(y, b), 0, 1);
                        };
                        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
                            var half, isModExp, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
                            n = new BigNumber(n);
                            // Allow NaN and ±Infinity, but not other non-integers.
                            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + n);
                            if (m != null) m = new BigNumber(m);
                            // Exponent of MAX_SAFE_INTEGER is 15.
                            nIsBig = n.e > 14;
                            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
                            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                                // The sign of the result of pow when x is negative depends on the evenness of n.
                                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                                y = new BigNumber(Math.pow(+x.valueOf(), nIsBig ? 2 - isOdd(n) : +n));
                                return m ? y.mod(m) : y;
                            }
                            nIsNeg = n.s < 0;
                            if (m) {
                                // x % m returns NaN if abs(m) is zero, or m is NaN.
                                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                                if (isModExp) x = x.mod(m);
                            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
                            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
                            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                                // If x is negative and n is odd, k = -0, else k = 0.
                                k = x.s < 0 && isOdd(n) ? -0 : 0;
                                // If x >= 1, k = ±Infinity.
                                if (x.e > -1) k = 1 / k;
                                // If n is negative return ±0, else return ±Infinity.
                                return new BigNumber(nIsNeg ? 1 / k : k);
                            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
                            // equates to truncating significant digits to POW_PRECISION + [28, 41],
                            // i.e. there will be a minimum of 28 guard digits retained.
                            k = mathceil(POW_PRECISION / LOG_BASE + 2);
                            if (nIsBig) {
                                half = new BigNumber(0.5);
                                nIsOdd = isOdd(n);
                            } else nIsOdd = n % 2;
                            if (nIsNeg) n.s = 1;
                            y = new BigNumber(ONE);
                            // Performs 54 loop iterations for n of 9007199254740991.
                            for(;;){
                                if (nIsOdd) {
                                    y = y.times(x);
                                    if (!y.c) break;
                                    if (k) {
                                        if (y.c.length > k) y.c.length = k;
                                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                                }
                                if (nIsBig) {
                                    n = n.times(half);
                                    round(n, n.e + 1, 1);
                                    if (!n.c[0]) break;
                                    nIsBig = n.e > 14;
                                    nIsOdd = isOdd(n);
                                } else {
                                    n = mathfloor(n / 2);
                                    if (!n) break;
                                    nIsOdd = n % 2;
                                }
                                x = x.times(x);
                                if (k) {
                                    if (x.c && x.c.length > k) x.c.length = k;
                                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
                            }
                            if (isModExp) return y;
                            if (nIsNeg) y = ONE.div(y);
                            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
                            var n = new BigNumber(this);
                            if (rm == null) rm = ROUNDING_MODE;
                            else intCheck(rm, 0, 8);
                            return round(n, n.e + 1, rm);
                        };
                        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
                            return compare(this, new BigNumber(y, b)) === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
                            return !!this.c;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
                            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
                        };
                        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
                            return compare(this, new BigNumber(y, b)) < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
                            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
                        };
                        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
                            return !this.s;
                        };
                        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
                            return this.s < 0;
                        };
                        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
                            return this.s > 0;
                        };
                        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
                            return !!this.c && this.c[0] == 0;
                        };
                        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
                            var i, j, t, xLTy, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.plus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Either Infinity?
                                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                                // Either zero?
                                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                                ROUNDING_MODE == 3 ? -0 : 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Determine which is the bigger number.
                            if (a = xe - ye) {
                                if (xLTy = a < 0) {
                                    a = -a;
                                    t = xc;
                                } else {
                                    ye = xe;
                                    t = yc;
                                }
                                t.reverse();
                                // Prepend zeros to equalise exponents.
                                for(b = a; b--; t.push(0));
                                t.reverse();
                            } else {
                                // Exponents equal. Check digit by digit.
                                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                                    xLTy = xc[b] < yc[b];
                                    break;
                                }
                            }
                            // x < y? Point xc to the array of the bigger number.
                            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
                            b = (j = yc.length) - (i = xc.length);
                            // Append zeros to xc if shorter.
                            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
                            if (b > 0) for(; b--; xc[i++] = 0);
                            b = BASE - 1;
                            // Subtract yc from xc.
                            for(; j > a;){
                                if (xc[--j] < yc[j]) {
                                    for(i = j; i && !xc[--i]; xc[i] = b);
                                    --xc[i];
                                    xc[j] += BASE;
                                }
                                xc[j] -= yc[j];
                            }
                            // Remove leading zeros and adjust exponent accordingly.
                            for(; xc[0] == 0; xc.splice(0, 1), --ye);
                            // Zero?
                            if (!xc[0]) {
                                // Following IEEE 754 (2008) 6.3,
                                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                                y.c = [
                                    y.e = 0
                                ];
                                return y;
                            }
                            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
                            // for finite x and y.
                            return normalise(y, xc, ye);
                        };
                        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
                            var q, s, x = this;
                            y = new BigNumber(y, b);
                            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
                            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
                            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
                            if (MODULO_MODE == 9) {
                                // Euclidian division: q = sign(y) * floor(x / abs(y))
                                // r = x - qy    where  0 <= r < abs(y)
                                s = y.s;
                                y.s = 1;
                                q = div(x, y, 0, 3);
                                y.s = s;
                                q.s *= s;
                            } else q = div(x, y, 0, MODULO_MODE);
                            y = x.minus(q.times(y));
                            // To match JavaScript %, ensure sign of zero is sign of dividend.
                            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
                            return y;
                        };
                        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
                            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
                            // Either NaN, ±Infinity or ±0?
                            if (!xc || !yc || !xc[0] || !yc[0]) {
                                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                                else {
                                    y.s *= x.s;
                                    // Return ±Infinity if either is ±Infinity.
                                    if (!xc || !yc) y.c = y.e = null;
                                    else {
                                        y.c = [
                                            0
                                        ];
                                        y.e = 0;
                                    }
                                }
                                return y;
                            }
                            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
                            y.s *= x.s;
                            xcL = xc.length;
                            ycL = yc.length;
                            // Ensure xc points to longer array and xcL to its length.
                            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
                            // Initialise the result array with zeros.
                            for(i = xcL + ycL, zc = []; i--; zc.push(0));
                            base = BASE;
                            sqrtBase = SQRT_BASE;
                            for(i = ycL; --i >= 0;){
                                c = 0;
                                ylo = yc[i] % sqrtBase;
                                yhi = yc[i] / sqrtBase | 0;
                                for(k = xcL, j = i + k; j > i;){
                                    xlo = xc[--k] % sqrtBase;
                                    xhi = xc[k] / sqrtBase | 0;
                                    m = yhi * xlo + xhi * ylo;
                                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                                    zc[j--] = xlo % base;
                                }
                                zc[j] = c;
                            }
                            if (c) ++e;
                            else zc.splice(0, 1);
                            return normalise(y, zc, e);
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
                            var x = new BigNumber(this);
                            x.s = -x.s || null;
                            return x;
                        };
                        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
                            var t, x = this, a = x.s;
                            y = new BigNumber(y, b);
                            b = y.s;
                            // Either NaN?
                            if (!a || !b) return new BigNumber(NaN);
                            // Signs differ?
                            if (a != b) {
                                y.s = -b;
                                return x.minus(y);
                            }
                            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
                            if (!xe || !ye) {
                                // Return ±Infinity if either ±Infinity.
                                if (!xc || !yc) return new BigNumber(a / 0);
                                // Either zero?
                                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
                            }
                            xe = bitFloor(xe);
                            ye = bitFloor(ye);
                            xc = xc.slice();
                            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
                            if (a = xe - ye) {
                                if (a > 0) {
                                    ye = xe;
                                    t = yc;
                                } else {
                                    a = -a;
                                    t = xc;
                                }
                                t.reverse();
                                for(; a--; t.push(0));
                                t.reverse();
                            }
                            a = xc.length;
                            b = yc.length;
                            // Point xc to the longer array, and b to the shorter length.
                            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
                            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
                            for(a = 0; b;){
                                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
                            }
                            if (a) {
                                xc = [
                                    a
                                ].concat(xc);
                                ++ye;
                            }
                            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
                            // ye = MAX_EXP + 1 possible
                            return normalise(y, xc, ye);
                        };
                        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
                            var c, n, v, x = this;
                            if (sd != null && sd !== !!sd) {
                                intCheck(sd, 1, MAX);
                                if (rm == null) rm = ROUNDING_MODE;
                                else intCheck(rm, 0, 8);
                                return round(new BigNumber(x), sd, rm);
                            }
                            if (!(c = x.c)) return null;
                            v = c.length - 1;
                            n = v * LOG_BASE + 1;
                            if (v = c[v]) {
                                // Subtract the number of trailing zeros of the last element.
                                for(; v % 10 == 0; v /= 10, n--);
                                // Add the number of digits of the first element.
                                for(v = c[0]; v >= 10; v /= 10, n++);
                            }
                            if (sd && x.e + 1 > n) n = x.e + 1;
                            return n;
                        };
                        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
                            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
                            return this.times("1e" + k);
                        };
                        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
                            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
                            // Negative/NaN/Infinity/zero?
                            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
                            // Initial estimate.
                            s = Math.sqrt(+x);
                            // Math.sqrt underflow/overflow?
                            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
                            if (s == 0 || s == 1 / 0) {
                                n = coeffToString(c);
                                if ((n.length + e) % 2 == 0) n += "0";
                                s = Math.sqrt(n);
                                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                                if (s == 1 / 0) n = "1e" + e;
                                else {
                                    n = s.toExponential();
                                    n = n.slice(0, n.indexOf("e") + 1) + e;
                                }
                                r = new BigNumber(n);
                            } else r = new BigNumber(s + "");
                            // Check for zero.
                            // r could be zero if MIN_EXP is changed after the this value was created.
                            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
                            // coeffToString to throw.
                            if (r.c[0]) {
                                e = r.e;
                                s = e + dp;
                                if (s < 3) s = 0;
                                // Newton-Raphson iteration.
                                for(;;){
                                    t = r;
                                    r = half.times(t.plus(div(x, t, dp, 1)));
                                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                                        // The exponent of r may here be one less than the final result exponent,
                                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                                        // are indexed correctly.
                                        if (r.e < e) --s;
                                        n = n.slice(s - 3, s + 1);
                                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                                        // iteration.
                                        if (n == "9999" || !rep && n == "4999") {
                                            // On the first iteration only, check to see if rounding up gives the
                                            // exact result as the nines may infinitely repeat.
                                            if (!rep) {
                                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                                if (t.times(t).eq(x)) {
                                                    r = t;
                                                    break;
                                                }
                                            }
                                            dp += 4;
                                            s += 4;
                                            rep = 1;
                                        } else {
                                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                                            // result. If not, then there are further digits and m will be truthy.
                                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                                // Truncate to the first rounding digit.
                                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                                m = !r.times(r).eq(x);
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
                        };
                        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp++;
                            }
                            return format(this, dp, rm, 1);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
                            if (dp != null) {
                                intCheck(dp, 0, MAX);
                                dp = dp + this.e + 1;
                            }
                            return format(this, dp, rm);
                        };
                        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the FORMAT object (see BigNumber.set).
     *
     * FORMAT = {
     *      decimalSeparator : '.',
     *      groupSeparator : ',',
     *      groupSize : 3,
     *      secondaryGroupSize : 0,
     *      fractionGroupSeparator : '\xA0',    // non-breaking space
     *      fractionGroupSize : 0
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFormat = function(dp, rm) {
                            var str = this.toFixed(dp, rm);
                            if (this.c) {
                                var i, arr = str.split("."), g1 = +FORMAT.groupSize, g2 = +FORMAT.secondaryGroupSize, groupSeparator = FORMAT.groupSeparator, intPart = arr[0], fractionPart = arr[1], isNeg = this.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                                if (g1 > 0 && len > 0) {
                                    i = len % g1 || g1;
                                    intPart = intDigits.substr(0, i);
                                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                                    if (isNeg) intPart = "-" + intPart;
                                }
                                str = fractionPart ? intPart + FORMAT.decimalSeparator + ((g2 = +FORMAT.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + FORMAT.fractionGroupSeparator) : fractionPart) : intPart;
                            }
                            return str;
                        };
                        /*
     * Return a string array representing the value of this BigNumber as a simple fraction with
     * an integer numerator and an integer denominator. The denominator will be a positive
     * non-zero value less than or equal to the specified maximum denominator. If a maximum
     * denominator is not specified, the denominator will be the lowest value necessary to
     * represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
                            var arr, d, d0, d1, d2, e, exp, n, n0, n1, q, s, x = this, xc = x.c;
                            if (md != null) {
                                n = new BigNumber(md);
                                // Throw if md is less than one or is not an integer, unless it is Infinity.
                                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + md);
                            }
                            if (!xc) return x.toString();
                            d = new BigNumber(ONE);
                            n1 = d0 = new BigNumber(ONE);
                            d1 = n0 = new BigNumber(ONE);
                            s = coeffToString(xc);
                            // Determine initial denominator.
                            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
                            e = d.e = s.length - x.e - 1;
                            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
                            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
                            exp = MAX_EXP;
                            MAX_EXP = 1 / 0;
                            n = new BigNumber(s);
                            // n0 = d1 = 0
                            n0.c[0] = 0;
                            for(;;){
                                q = div(n, d, 0, 1);
                                d2 = d0.plus(q.times(d1));
                                if (d2.comparedTo(md) == 1) break;
                                d0 = d1;
                                d1 = d2;
                                n1 = n0.plus(q.times(d2 = n1));
                                n0 = d2;
                                d = n.minus(q.times(d2 = d));
                                n = d2;
                            }
                            d2 = div(md.minus(d0), d1, 0, 1);
                            n0 = n0.plus(d2.times(n1));
                            d0 = d0.plus(d2.times(d1));
                            n0.s = n1.s = x.s;
                            e *= 2;
                            // Determine which fraction is closer to x, n0/d0 or n1/d1
                            arr = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                                n1.toString(),
                                d1.toString()
                            ] : [
                                n0.toString(),
                                d0.toString()
                            ];
                            MAX_EXP = exp;
                            return arr;
                        };
                        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
                            return +this;
                        };
                        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
                            if (sd != null) intCheck(sd, 1, MAX);
                            return format(this, sd, rm, 2);
                        };
                        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
                            var str, n = this, s = n.s, e = n.e;
                            // Infinity or NaN?
                            if (e === null) {
                                if (s) {
                                    str = "Infinity";
                                    if (s < 0) str = "-" + str;
                                } else str = "NaN";
                            } else {
                                str = coeffToString(n.c);
                                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                                else {
                                    intCheck(b, 2, ALPHABET.length, "Base");
                                    str = convertBase(toFixedPoint(str, e, "0"), 10, b, s, true);
                                }
                                if (s < 0 && n.c[0]) str = "-" + str;
                            }
                            return str;
                        };
                        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
                            var str, n = this, e = n.e;
                            if (e === null) return n.toString();
                            str = coeffToString(n.c);
                            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
                            return n.s < 0 ? "-" + str : str;
                        };
                        P._isBigNumber = true;
                        if (configObject != null) BigNumber.set(configObject);
                        return BigNumber;
                    }
                    // PRIVATE HELPER FUNCTIONS
                    function bitFloor(n) {
                        var i = n | 0;
                        return n > 0 || n === i ? i : i - 1;
                    }
                    // Return a coefficient array as a string of base 10 digits.
                    function coeffToString(a) {
                        var s, z, i = 1, j = a.length, r = a[0] + "";
                        for(; i < j;){
                            s = a[i++] + "";
                            z = LOG_BASE - s.length;
                            for(; z--; s = "0" + s);
                            r += s;
                        }
                        // Determine trailing zeros.
                        for(j = r.length; r.charCodeAt(--j) === 48;);
                        return r.slice(0, j + 1 || 1);
                    }
                    // Compare the value of BigNumbers x and y.
                    function compare(x, y) {
                        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
                        // Either NaN?
                        if (!i || !j) return null;
                        a = xc && !xc[0];
                        b = yc && !yc[0];
                        // Either zero?
                        if (a || b) return a ? b ? 0 : -j : i;
                        // Signs differ?
                        if (i != j) return i;
                        a = i < 0;
                        b = k == l;
                        // Either Infinity?
                        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
                        // Compare exponents.
                        if (!b) return k > l ^ a ? 1 : -1;
                        j = (k = xc.length) < (l = yc.length) ? k : l;
                        // Compare digit by digit.
                        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
                        // Compare lengths.
                        return k == l ? 0 : k > l ^ a ? 1 : -1;
                    }
                    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name1) {
                        if (n < min || n > max || n !== (n < 0 ? mathceil(n) : mathfloor(n))) throw Error(bignumberError + (name1 || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + n);
                    }
                    function isArray(obj) {
                        return Object.prototype.toString.call(obj) == "[object Array]";
                    }
                    // Assumes finite n.
                    function isOdd(n) {
                        var k = n.c.length - 1;
                        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
                    }
                    function toExponential(str, e) {
                        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
                    }
                    function toFixedPoint(str, e, z) {
                        var len, zs;
                        // Negative exponent?
                        if (e < 0) {
                            // Prepend zeros.
                            for(zs = z + "."; ++e; zs += z);
                            str = zs + str;
                        // Positive exponent
                        } else {
                            len = str.length;
                            // Append zeros.
                            if (++e > len) {
                                for(zs = z, e -= len; --e; zs += z);
                                str += zs;
                            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                        }
                        return str;
                    }
                    // EXPORT
                    BigNumber = clone();
                    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
                    __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return BigNumber;
                    }).call(exports, __webpack_require__, exports, module1), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module1.exports = __WEBPACK_AMD_DEFINE_RESULT__);
                })(this);
            /***/ },
            /***/ 5697: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                /* module decorator */ module1 = __webpack_require__.nmd(module1);
                (function(module1, exports) {
                    "use strict";
                    // Utils
                    function assert(val, msg) {
                        if (!val) throw new Error(msg || "Assertion failed");
                    }
                    // Could use `inherits` module, but don't want to move from single file
                    // architecture yet.
                    function inherits(ctor, superCtor) {
                        ctor.super_ = superCtor;
                        var TempCtor = function() {};
                        TempCtor.prototype = superCtor.prototype;
                        ctor.prototype = new TempCtor();
                        ctor.prototype.constructor = ctor;
                    }
                    // BN
                    function BN(number, base, endian) {
                        if (BN.isBN(number)) return number;
                        this.negative = 0;
                        this.words = null;
                        this.length = 0;
                        // Reduction context
                        this.red = null;
                        if (number !== null) {
                            if (base === "le" || base === "be") {
                                endian = base;
                                base = 10;
                            }
                            this._init(number || 0, base || 10, endian || "be");
                        }
                    }
                    if (typeof module1 === "object") module1.exports = BN;
                    else exports.BN = BN;
                    BN.BN = BN;
                    BN.wordSize = 26;
                    var Buffer;
                    try {
                        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
                        else Buffer = __webpack_require__(2574).Buffer;
                    } catch (e) {}
                    BN.isBN = function isBN(num) {
                        if (num instanceof BN) return true;
                        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
                    };
                    BN.max = function max(left, right) {
                        if (left.cmp(right) > 0) return left;
                        return right;
                    };
                    BN.min = function min(left, right) {
                        if (left.cmp(right) < 0) return left;
                        return right;
                    };
                    BN.prototype._init = function init(number, base, endian) {
                        if (typeof number === "number") return this._initNumber(number, base, endian);
                        if (typeof number === "object") return this._initArray(number, base, endian);
                        if (base === "hex") base = 16;
                        assert(base === (base | 0) && base >= 2 && base <= 36);
                        number = number.toString().replace(/\s+/g, "");
                        var start = 0;
                        if (number[0] === "-") {
                            start++;
                            this.negative = 1;
                        }
                        if (start < number.length) {
                            if (base === 16) this._parseHex(number, start, endian);
                            else {
                                this._parseBase(number, base, start);
                                if (endian === "le") this._initArray(this.toArray(), base, endian);
                            }
                        }
                    };
                    BN.prototype._initNumber = function _initNumber(number, base, endian) {
                        if (number < 0) {
                            this.negative = 1;
                            number = -number;
                        }
                        if (number < 0x4000000) {
                            this.words = [
                                number & 0x3ffffff
                            ];
                            this.length = 1;
                        } else if (number < 0x10000000000000) {
                            this.words = [
                                number & 0x3ffffff,
                                number / 0x4000000 & 0x3ffffff
                            ];
                            this.length = 2;
                        } else {
                            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
                            this.words = [
                                number & 0x3ffffff,
                                number / 0x4000000 & 0x3ffffff,
                                1
                            ];
                            this.length = 3;
                        }
                        if (endian !== "le") return;
                        // Reverse the bytes
                        this._initArray(this.toArray(), base, endian);
                    };
                    BN.prototype._initArray = function _initArray(number, base, endian) {
                        // Perhaps a Uint8Array
                        assert(typeof number.length === "number");
                        if (number.length <= 0) {
                            this.words = [
                                0
                            ];
                            this.length = 1;
                            return this;
                        }
                        this.length = Math.ceil(number.length / 3);
                        this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var j, w;
                        var off = 0;
                        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                            this.words[j] |= w << off & 0x3ffffff;
                            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                            off += 24;
                            if (off >= 26) {
                                off -= 26;
                                j++;
                            }
                        }
                        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
                            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                            this.words[j] |= w << off & 0x3ffffff;
                            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                            off += 24;
                            if (off >= 26) {
                                off -= 26;
                                j++;
                            }
                        }
                        return this.strip();
                    };
                    function parseHex4Bits(string, index) {
                        var c = string.charCodeAt(index);
                        // 'A' - 'F'
                        if (c >= 65 && c <= 70) return c - 55;
                        else if (c >= 97 && c <= 102) return c - 87;
                        else return c - 48 & 0xf;
                    }
                    function parseHexByte(string, lowerBound, index) {
                        var r = parseHex4Bits(string, index);
                        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
                        return r;
                    }
                    BN.prototype._parseHex = function _parseHex(number, start, endian) {
                        // Create possibly bigger array to ensure that it fits the number
                        this.length = Math.ceil((number.length - start) / 6);
                        this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        // 24-bits chunks
                        var off = 0;
                        var j = 0;
                        var w;
                        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
                            w = parseHexByte(number, start, i) << off;
                            this.words[j] |= w & 0x3ffffff;
                            if (off >= 18) {
                                off -= 18;
                                j += 1;
                                this.words[j] |= w >>> 26;
                            } else off += 8;
                        }
                        else {
                            var parseLength = number.length - start;
                            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                                w = parseHexByte(number, start, i) << off;
                                this.words[j] |= w & 0x3ffffff;
                                if (off >= 18) {
                                    off -= 18;
                                    j += 1;
                                    this.words[j] |= w >>> 26;
                                } else off += 8;
                            }
                        }
                        this.strip();
                    };
                    function parseBase(str, start, end, mul) {
                        var r = 0;
                        var len = Math.min(str.length, end);
                        for(var i = start; i < len; i++){
                            var c = str.charCodeAt(i) - 48;
                            r *= mul;
                            // 'a'
                            if (c >= 49) r += c - 49 + 0xa;
                            else if (c >= 17) r += c - 17 + 0xa;
                            else r += c;
                        }
                        return r;
                    }
                    BN.prototype._parseBase = function _parseBase(number, base, start) {
                        // Initialize as zero
                        this.words = [
                            0
                        ];
                        this.length = 1;
                        // Find length of limb in base
                        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
                        limbLen--;
                        limbPow = limbPow / base | 0;
                        var total = number.length - start;
                        var mod = total % limbLen;
                        var end = Math.min(total, total - mod) + start;
                        var word = 0;
                        for(var i = start; i < end; i += limbLen){
                            word = parseBase(number, i, i + limbLen, base);
                            this.imuln(limbPow);
                            if (this.words[0] + word < 0x4000000) this.words[0] += word;
                            else this._iaddn(word);
                        }
                        if (mod !== 0) {
                            var pow = 1;
                            word = parseBase(number, i, number.length, base);
                            for(i = 0; i < mod; i++)pow *= base;
                            this.imuln(pow);
                            if (this.words[0] + word < 0x4000000) this.words[0] += word;
                            else this._iaddn(word);
                        }
                        this.strip();
                    };
                    BN.prototype.copy = function copy(dest) {
                        dest.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
                        dest.length = this.length;
                        dest.negative = this.negative;
                        dest.red = this.red;
                    };
                    BN.prototype.clone = function clone() {
                        var r = new BN(null);
                        this.copy(r);
                        return r;
                    };
                    BN.prototype._expand = function _expand(size) {
                        while(this.length < size)this.words[this.length++] = 0;
                        return this;
                    };
                    // Remove leading `0` from `this`
                    BN.prototype.strip = function strip() {
                        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
                        return this._normSign();
                    };
                    BN.prototype._normSign = function _normSign() {
                        // -0 = 0
                        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
                        return this;
                    };
                    BN.prototype.inspect = function inspect() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ];
                    var groupSizes = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ];
                    var groupBases = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        10000000,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64000000,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        24300000,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    BN.prototype.toString = function toString(base, padding) {
                        base = base || 10;
                        padding = padding | 0 || 1;
                        var out;
                        if (base === 16 || base === "hex") {
                            out = "";
                            var off = 0;
                            var carry = 0;
                            for(var i = 0; i < this.length; i++){
                                var w = this.words[i];
                                var word = ((w << off | carry) & 0xffffff).toString(16);
                                carry = w >>> 24 - off & 0xffffff;
                                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                                else out = word + out;
                                off += 2;
                                if (off >= 26) {
                                    off -= 26;
                                    i--;
                                }
                            }
                            if (carry !== 0) out = carry.toString(16) + out;
                            while(out.length % padding !== 0)out = "0" + out;
                            if (this.negative !== 0) out = "-" + out;
                            return out;
                        }
                        if (base === (base | 0) && base >= 2 && base <= 36) {
                            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
                            var groupSize = groupSizes[base];
                            // var groupBase = Math.pow(base, groupSize);
                            var groupBase = groupBases[base];
                            out = "";
                            var c = this.clone();
                            c.negative = 0;
                            while(!c.isZero()){
                                var r = c.modn(groupBase).toString(base);
                                c = c.idivn(groupBase);
                                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                                else out = r + out;
                            }
                            if (this.isZero()) out = "0" + out;
                            while(out.length % padding !== 0)out = "0" + out;
                            if (this.negative !== 0) out = "-" + out;
                            return out;
                        }
                        assert(false, "Base should be between 2 and 36");
                    };
                    BN.prototype.toNumber = function toNumber() {
                        var ret = this.words[0];
                        if (this.length === 2) ret += this.words[1] * 0x4000000;
                        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
                        ret += 0x10000000000000 + this.words[1] * 0x4000000;
                        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
                        return this.negative !== 0 ? -ret : ret;
                    };
                    BN.prototype.toJSON = function toJSON() {
                        return this.toString(16);
                    };
                    BN.prototype.toBuffer = function toBuffer(endian, length) {
                        assert(typeof Buffer !== "undefined");
                        return this.toArrayLike(Buffer, endian, length);
                    };
                    BN.prototype.toArray = function toArray(endian, length) {
                        return this.toArrayLike(Array, endian, length);
                    };
                    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
                        var byteLength = this.byteLength();
                        var reqLength = length || Math.max(1, byteLength);
                        assert(byteLength <= reqLength, "byte array longer than desired length");
                        assert(reqLength > 0, "Requested array length <= 0");
                        this.strip();
                        var littleEndian = endian === "le";
                        var res = new ArrayType(reqLength);
                        var b, i;
                        var q = this.clone();
                        if (!littleEndian) {
                            // Assume big-endian
                            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
                            for(i = 0; !q.isZero(); i++){
                                b = q.andln(0xff);
                                q.iushrn(8);
                                res[reqLength - i - 1] = b;
                            }
                        } else {
                            for(i = 0; !q.isZero(); i++){
                                b = q.andln(0xff);
                                q.iushrn(8);
                                res[i] = b;
                            }
                            for(; i < reqLength; i++)res[i] = 0;
                        }
                        return res;
                    };
                    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
                        return 32 - Math.clz32(w);
                    };
                    else BN.prototype._countBits = function _countBits(w) {
                        var t = w;
                        var r = 0;
                        if (t >= 0x1000) {
                            r += 13;
                            t >>>= 13;
                        }
                        if (t >= 0x40) {
                            r += 7;
                            t >>>= 7;
                        }
                        if (t >= 0x8) {
                            r += 4;
                            t >>>= 4;
                        }
                        if (t >= 0x02) {
                            r += 2;
                            t >>>= 2;
                        }
                        return r + t;
                    };
                    BN.prototype._zeroBits = function _zeroBits(w) {
                        // Short-cut
                        if (w === 0) return 26;
                        var t = w;
                        var r = 0;
                        if ((t & 0x1fff) === 0) {
                            r += 13;
                            t >>>= 13;
                        }
                        if ((t & 0x7f) === 0) {
                            r += 7;
                            t >>>= 7;
                        }
                        if ((t & 0xf) === 0) {
                            r += 4;
                            t >>>= 4;
                        }
                        if ((t & 0x3) === 0) {
                            r += 2;
                            t >>>= 2;
                        }
                        if ((t & 0x1) === 0) r++;
                        return r;
                    };
                    // Return number of used bits in a BN
                    BN.prototype.bitLength = function bitLength() {
                        var w = this.words[this.length - 1];
                        var hi = this._countBits(w);
                        return (this.length - 1) * 26 + hi;
                    };
                    function toBitArray(num) {
                        var w = new Array(num.bitLength());
                        for(var bit = 0; bit < w.length; bit++){
                            var off = bit / 26 | 0;
                            var wbit = bit % 26;
                            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
                        }
                        return w;
                    }
                    // Number of trailing zero bits
                    BN.prototype.zeroBits = function zeroBits() {
                        if (this.isZero()) return 0;
                        var r = 0;
                        for(var i = 0; i < this.length; i++){
                            var b = this._zeroBits(this.words[i]);
                            r += b;
                            if (b !== 26) break;
                        }
                        return r;
                    };
                    BN.prototype.byteLength = function byteLength() {
                        return Math.ceil(this.bitLength() / 8);
                    };
                    BN.prototype.toTwos = function toTwos(width) {
                        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
                        return this.clone();
                    };
                    BN.prototype.fromTwos = function fromTwos(width) {
                        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
                        return this.clone();
                    };
                    BN.prototype.isNeg = function isNeg() {
                        return this.negative !== 0;
                    };
                    // Return negative clone of `this`
                    BN.prototype.neg = function neg() {
                        return this.clone().ineg();
                    };
                    BN.prototype.ineg = function ineg() {
                        if (!this.isZero()) this.negative ^= 1;
                        return this;
                    };
                    // Or `num` with `this` in-place
                    BN.prototype.iuor = function iuor(num) {
                        while(this.length < num.length)this.words[this.length++] = 0;
                        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
                        return this.strip();
                    };
                    BN.prototype.ior = function ior(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuor(num);
                    };
                    // Or `num` with `this`
                    BN.prototype.or = function or(num) {
                        if (this.length > num.length) return this.clone().ior(num);
                        return num.clone().ior(this);
                    };
                    BN.prototype.uor = function uor(num) {
                        if (this.length > num.length) return this.clone().iuor(num);
                        return num.clone().iuor(this);
                    };
                    // And `num` with `this` in-place
                    BN.prototype.iuand = function iuand(num) {
                        // b = min-length(num, this)
                        var b;
                        if (this.length > num.length) b = num;
                        else b = this;
                        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
                        this.length = b.length;
                        return this.strip();
                    };
                    BN.prototype.iand = function iand(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuand(num);
                    };
                    // And `num` with `this`
                    BN.prototype.and = function and(num) {
                        if (this.length > num.length) return this.clone().iand(num);
                        return num.clone().iand(this);
                    };
                    BN.prototype.uand = function uand(num) {
                        if (this.length > num.length) return this.clone().iuand(num);
                        return num.clone().iuand(this);
                    };
                    // Xor `num` with `this` in-place
                    BN.prototype.iuxor = function iuxor(num) {
                        // a.length > b.length
                        var a;
                        var b;
                        if (this.length > num.length) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
                        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
                        this.length = a.length;
                        return this.strip();
                    };
                    BN.prototype.ixor = function ixor(num) {
                        assert((this.negative | num.negative) === 0);
                        return this.iuxor(num);
                    };
                    // Xor `num` with `this`
                    BN.prototype.xor = function xor(num) {
                        if (this.length > num.length) return this.clone().ixor(num);
                        return num.clone().ixor(this);
                    };
                    BN.prototype.uxor = function uxor(num) {
                        if (this.length > num.length) return this.clone().iuxor(num);
                        return num.clone().iuxor(this);
                    };
                    // Not ``this`` with ``width`` bitwidth
                    BN.prototype.inotn = function inotn(width) {
                        assert(typeof width === "number" && width >= 0);
                        var bytesNeeded = Math.ceil(width / 26) | 0;
                        var bitsLeft = width % 26;
                        // Extend the buffer with leading zeroes
                        this._expand(bytesNeeded);
                        if (bitsLeft > 0) bytesNeeded--;
                        // Handle complete words
                        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
                        // Handle the residue
                        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
                        // And remove leading zeroes
                        return this.strip();
                    };
                    BN.prototype.notn = function notn(width) {
                        return this.clone().inotn(width);
                    };
                    // Set `bit` of `this`
                    BN.prototype.setn = function setn(bit, val) {
                        assert(typeof bit === "number" && bit >= 0);
                        var off = bit / 26 | 0;
                        var wbit = bit % 26;
                        this._expand(off + 1);
                        if (val) this.words[off] = this.words[off] | 1 << wbit;
                        else this.words[off] = this.words[off] & ~(1 << wbit);
                        return this.strip();
                    };
                    // Add `num` to `this` in-place
                    BN.prototype.iadd = function iadd(num) {
                        var r;
                        // negative + positive
                        if (this.negative !== 0 && num.negative === 0) {
                            this.negative = 0;
                            r = this.isub(num);
                            this.negative ^= 1;
                            return this._normSign();
                        // positive + negative
                        } else if (this.negative === 0 && num.negative !== 0) {
                            num.negative = 0;
                            r = this.isub(num);
                            num.negative = 1;
                            return r._normSign();
                        }
                        // a.length > b.length
                        var a, b;
                        if (this.length > num.length) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        var carry = 0;
                        for(var i = 0; i < b.length; i++){
                            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                            this.words[i] = r & 0x3ffffff;
                            carry = r >>> 26;
                        }
                        for(; carry !== 0 && i < a.length; i++){
                            r = (a.words[i] | 0) + carry;
                            this.words[i] = r & 0x3ffffff;
                            carry = r >>> 26;
                        }
                        this.length = a.length;
                        if (carry !== 0) {
                            this.words[this.length] = carry;
                            this.length++;
                        // Copy the rest of the words
                        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                        return this;
                    };
                    // Add `num` to `this`
                    BN.prototype.add = function add(num) {
                        var res;
                        if (num.negative !== 0 && this.negative === 0) {
                            num.negative = 0;
                            res = this.sub(num);
                            num.negative ^= 1;
                            return res;
                        } else if (num.negative === 0 && this.negative !== 0) {
                            this.negative = 0;
                            res = num.sub(this);
                            this.negative = 1;
                            return res;
                        }
                        if (this.length > num.length) return this.clone().iadd(num);
                        return num.clone().iadd(this);
                    };
                    // Subtract `num` from `this` in-place
                    BN.prototype.isub = function isub(num) {
                        // this - (-num) = this + num
                        if (num.negative !== 0) {
                            num.negative = 0;
                            var r = this.iadd(num);
                            num.negative = 1;
                            return r._normSign();
                        // -this - num = -(this + num)
                        } else if (this.negative !== 0) {
                            this.negative = 0;
                            this.iadd(num);
                            this.negative = 1;
                            return this._normSign();
                        }
                        // At this point both numbers are positive
                        var cmp = this.cmp(num);
                        // Optimization - zeroify
                        if (cmp === 0) {
                            this.negative = 0;
                            this.length = 1;
                            this.words[0] = 0;
                            return this;
                        }
                        // a > b
                        var a, b;
                        if (cmp > 0) {
                            a = this;
                            b = num;
                        } else {
                            a = num;
                            b = this;
                        }
                        var carry = 0;
                        for(var i = 0; i < b.length; i++){
                            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                            carry = r >> 26;
                            this.words[i] = r & 0x3ffffff;
                        }
                        for(; carry !== 0 && i < a.length; i++){
                            r = (a.words[i] | 0) + carry;
                            carry = r >> 26;
                            this.words[i] = r & 0x3ffffff;
                        }
                        // Copy rest of the words
                        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                        this.length = Math.max(this.length, i);
                        if (a !== this) this.negative = 1;
                        return this.strip();
                    };
                    // Subtract `num` from `this`
                    BN.prototype.sub = function sub(num) {
                        return this.clone().isub(num);
                    };
                    function smallMulTo(self1, num, out) {
                        out.negative = num.negative ^ self1.negative;
                        var len = self1.length + num.length | 0;
                        out.length = len;
                        len = len - 1 | 0;
                        // Peel one iteration (compiler can't do it, because of code complexity)
                        var a = self1.words[0] | 0;
                        var b = num.words[0] | 0;
                        var r = a * b;
                        var lo = r & 0x3ffffff;
                        var carry = r / 0x4000000 | 0;
                        out.words[0] = lo;
                        for(var k = 1; k < len; k++){
                            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                            // note that ncarry could be >= 0x3ffffff
                            var ncarry = carry >>> 26;
                            var rword = carry & 0x3ffffff;
                            var maxJ = Math.min(k, num.length - 1);
                            for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                                var i = k - j | 0;
                                a = self1.words[i] | 0;
                                b = num.words[j] | 0;
                                r = a * b + rword;
                                ncarry += r / 0x4000000 | 0;
                                rword = r & 0x3ffffff;
                            }
                            out.words[k] = rword | 0;
                            carry = ncarry | 0;
                        }
                        if (carry !== 0) out.words[k] = carry | 0;
                        else out.length--;
                        return out.strip();
                    }
                    // TODO(indutny): it may be reasonable to omit it for users who don't need
                    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
                    // multiplication (like elliptic secp256k1).
                    var comb10MulTo = function comb10MulTo(self1, num, out) {
                        var a = self1.words;
                        var b = num.words;
                        var o = out.words;
                        var c = 0;
                        var lo;
                        var mid;
                        var hi;
                        var a0 = a[0] | 0;
                        var al0 = a0 & 0x1fff;
                        var ah0 = a0 >>> 13;
                        var a1 = a[1] | 0;
                        var al1 = a1 & 0x1fff;
                        var ah1 = a1 >>> 13;
                        var a2 = a[2] | 0;
                        var al2 = a2 & 0x1fff;
                        var ah2 = a2 >>> 13;
                        var a3 = a[3] | 0;
                        var al3 = a3 & 0x1fff;
                        var ah3 = a3 >>> 13;
                        var a4 = a[4] | 0;
                        var al4 = a4 & 0x1fff;
                        var ah4 = a4 >>> 13;
                        var a5 = a[5] | 0;
                        var al5 = a5 & 0x1fff;
                        var ah5 = a5 >>> 13;
                        var a6 = a[6] | 0;
                        var al6 = a6 & 0x1fff;
                        var ah6 = a6 >>> 13;
                        var a7 = a[7] | 0;
                        var al7 = a7 & 0x1fff;
                        var ah7 = a7 >>> 13;
                        var a8 = a[8] | 0;
                        var al8 = a8 & 0x1fff;
                        var ah8 = a8 >>> 13;
                        var a9 = a[9] | 0;
                        var al9 = a9 & 0x1fff;
                        var ah9 = a9 >>> 13;
                        var b0 = b[0] | 0;
                        var bl0 = b0 & 0x1fff;
                        var bh0 = b0 >>> 13;
                        var b1 = b[1] | 0;
                        var bl1 = b1 & 0x1fff;
                        var bh1 = b1 >>> 13;
                        var b2 = b[2] | 0;
                        var bl2 = b2 & 0x1fff;
                        var bh2 = b2 >>> 13;
                        var b3 = b[3] | 0;
                        var bl3 = b3 & 0x1fff;
                        var bh3 = b3 >>> 13;
                        var b4 = b[4] | 0;
                        var bl4 = b4 & 0x1fff;
                        var bh4 = b4 >>> 13;
                        var b5 = b[5] | 0;
                        var bl5 = b5 & 0x1fff;
                        var bh5 = b5 >>> 13;
                        var b6 = b[6] | 0;
                        var bl6 = b6 & 0x1fff;
                        var bh6 = b6 >>> 13;
                        var b7 = b[7] | 0;
                        var bl7 = b7 & 0x1fff;
                        var bh7 = b7 >>> 13;
                        var b8 = b[8] | 0;
                        var bl8 = b8 & 0x1fff;
                        var bh8 = b8 >>> 13;
                        var b9 = b[9] | 0;
                        var bl9 = b9 & 0x1fff;
                        var bh9 = b9 >>> 13;
                        out.negative = self1.negative ^ num.negative;
                        out.length = 19;
                        /* k = 0 */ lo = Math.imul(al0, bl0);
                        mid = Math.imul(al0, bh0);
                        mid = mid + Math.imul(ah0, bl0) | 0;
                        hi = Math.imul(ah0, bh0);
                        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
                        w0 &= 0x3ffffff;
                        /* k = 1 */ lo = Math.imul(al1, bl0);
                        mid = Math.imul(al1, bh0);
                        mid = mid + Math.imul(ah1, bl0) | 0;
                        hi = Math.imul(ah1, bh0);
                        lo = lo + Math.imul(al0, bl1) | 0;
                        mid = mid + Math.imul(al0, bh1) | 0;
                        mid = mid + Math.imul(ah0, bl1) | 0;
                        hi = hi + Math.imul(ah0, bh1) | 0;
                        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
                        w1 &= 0x3ffffff;
                        /* k = 2 */ lo = Math.imul(al2, bl0);
                        mid = Math.imul(al2, bh0);
                        mid = mid + Math.imul(ah2, bl0) | 0;
                        hi = Math.imul(ah2, bh0);
                        lo = lo + Math.imul(al1, bl1) | 0;
                        mid = mid + Math.imul(al1, bh1) | 0;
                        mid = mid + Math.imul(ah1, bl1) | 0;
                        hi = hi + Math.imul(ah1, bh1) | 0;
                        lo = lo + Math.imul(al0, bl2) | 0;
                        mid = mid + Math.imul(al0, bh2) | 0;
                        mid = mid + Math.imul(ah0, bl2) | 0;
                        hi = hi + Math.imul(ah0, bh2) | 0;
                        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
                        w2 &= 0x3ffffff;
                        /* k = 3 */ lo = Math.imul(al3, bl0);
                        mid = Math.imul(al3, bh0);
                        mid = mid + Math.imul(ah3, bl0) | 0;
                        hi = Math.imul(ah3, bh0);
                        lo = lo + Math.imul(al2, bl1) | 0;
                        mid = mid + Math.imul(al2, bh1) | 0;
                        mid = mid + Math.imul(ah2, bl1) | 0;
                        hi = hi + Math.imul(ah2, bh1) | 0;
                        lo = lo + Math.imul(al1, bl2) | 0;
                        mid = mid + Math.imul(al1, bh2) | 0;
                        mid = mid + Math.imul(ah1, bl2) | 0;
                        hi = hi + Math.imul(ah1, bh2) | 0;
                        lo = lo + Math.imul(al0, bl3) | 0;
                        mid = mid + Math.imul(al0, bh3) | 0;
                        mid = mid + Math.imul(ah0, bl3) | 0;
                        hi = hi + Math.imul(ah0, bh3) | 0;
                        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
                        w3 &= 0x3ffffff;
                        /* k = 4 */ lo = Math.imul(al4, bl0);
                        mid = Math.imul(al4, bh0);
                        mid = mid + Math.imul(ah4, bl0) | 0;
                        hi = Math.imul(ah4, bh0);
                        lo = lo + Math.imul(al3, bl1) | 0;
                        mid = mid + Math.imul(al3, bh1) | 0;
                        mid = mid + Math.imul(ah3, bl1) | 0;
                        hi = hi + Math.imul(ah3, bh1) | 0;
                        lo = lo + Math.imul(al2, bl2) | 0;
                        mid = mid + Math.imul(al2, bh2) | 0;
                        mid = mid + Math.imul(ah2, bl2) | 0;
                        hi = hi + Math.imul(ah2, bh2) | 0;
                        lo = lo + Math.imul(al1, bl3) | 0;
                        mid = mid + Math.imul(al1, bh3) | 0;
                        mid = mid + Math.imul(ah1, bl3) | 0;
                        hi = hi + Math.imul(ah1, bh3) | 0;
                        lo = lo + Math.imul(al0, bl4) | 0;
                        mid = mid + Math.imul(al0, bh4) | 0;
                        mid = mid + Math.imul(ah0, bl4) | 0;
                        hi = hi + Math.imul(ah0, bh4) | 0;
                        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
                        w4 &= 0x3ffffff;
                        /* k = 5 */ lo = Math.imul(al5, bl0);
                        mid = Math.imul(al5, bh0);
                        mid = mid + Math.imul(ah5, bl0) | 0;
                        hi = Math.imul(ah5, bh0);
                        lo = lo + Math.imul(al4, bl1) | 0;
                        mid = mid + Math.imul(al4, bh1) | 0;
                        mid = mid + Math.imul(ah4, bl1) | 0;
                        hi = hi + Math.imul(ah4, bh1) | 0;
                        lo = lo + Math.imul(al3, bl2) | 0;
                        mid = mid + Math.imul(al3, bh2) | 0;
                        mid = mid + Math.imul(ah3, bl2) | 0;
                        hi = hi + Math.imul(ah3, bh2) | 0;
                        lo = lo + Math.imul(al2, bl3) | 0;
                        mid = mid + Math.imul(al2, bh3) | 0;
                        mid = mid + Math.imul(ah2, bl3) | 0;
                        hi = hi + Math.imul(ah2, bh3) | 0;
                        lo = lo + Math.imul(al1, bl4) | 0;
                        mid = mid + Math.imul(al1, bh4) | 0;
                        mid = mid + Math.imul(ah1, bl4) | 0;
                        hi = hi + Math.imul(ah1, bh4) | 0;
                        lo = lo + Math.imul(al0, bl5) | 0;
                        mid = mid + Math.imul(al0, bh5) | 0;
                        mid = mid + Math.imul(ah0, bl5) | 0;
                        hi = hi + Math.imul(ah0, bh5) | 0;
                        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
                        w5 &= 0x3ffffff;
                        /* k = 6 */ lo = Math.imul(al6, bl0);
                        mid = Math.imul(al6, bh0);
                        mid = mid + Math.imul(ah6, bl0) | 0;
                        hi = Math.imul(ah6, bh0);
                        lo = lo + Math.imul(al5, bl1) | 0;
                        mid = mid + Math.imul(al5, bh1) | 0;
                        mid = mid + Math.imul(ah5, bl1) | 0;
                        hi = hi + Math.imul(ah5, bh1) | 0;
                        lo = lo + Math.imul(al4, bl2) | 0;
                        mid = mid + Math.imul(al4, bh2) | 0;
                        mid = mid + Math.imul(ah4, bl2) | 0;
                        hi = hi + Math.imul(ah4, bh2) | 0;
                        lo = lo + Math.imul(al3, bl3) | 0;
                        mid = mid + Math.imul(al3, bh3) | 0;
                        mid = mid + Math.imul(ah3, bl3) | 0;
                        hi = hi + Math.imul(ah3, bh3) | 0;
                        lo = lo + Math.imul(al2, bl4) | 0;
                        mid = mid + Math.imul(al2, bh4) | 0;
                        mid = mid + Math.imul(ah2, bl4) | 0;
                        hi = hi + Math.imul(ah2, bh4) | 0;
                        lo = lo + Math.imul(al1, bl5) | 0;
                        mid = mid + Math.imul(al1, bh5) | 0;
                        mid = mid + Math.imul(ah1, bl5) | 0;
                        hi = hi + Math.imul(ah1, bh5) | 0;
                        lo = lo + Math.imul(al0, bl6) | 0;
                        mid = mid + Math.imul(al0, bh6) | 0;
                        mid = mid + Math.imul(ah0, bl6) | 0;
                        hi = hi + Math.imul(ah0, bh6) | 0;
                        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
                        w6 &= 0x3ffffff;
                        /* k = 7 */ lo = Math.imul(al7, bl0);
                        mid = Math.imul(al7, bh0);
                        mid = mid + Math.imul(ah7, bl0) | 0;
                        hi = Math.imul(ah7, bh0);
                        lo = lo + Math.imul(al6, bl1) | 0;
                        mid = mid + Math.imul(al6, bh1) | 0;
                        mid = mid + Math.imul(ah6, bl1) | 0;
                        hi = hi + Math.imul(ah6, bh1) | 0;
                        lo = lo + Math.imul(al5, bl2) | 0;
                        mid = mid + Math.imul(al5, bh2) | 0;
                        mid = mid + Math.imul(ah5, bl2) | 0;
                        hi = hi + Math.imul(ah5, bh2) | 0;
                        lo = lo + Math.imul(al4, bl3) | 0;
                        mid = mid + Math.imul(al4, bh3) | 0;
                        mid = mid + Math.imul(ah4, bl3) | 0;
                        hi = hi + Math.imul(ah4, bh3) | 0;
                        lo = lo + Math.imul(al3, bl4) | 0;
                        mid = mid + Math.imul(al3, bh4) | 0;
                        mid = mid + Math.imul(ah3, bl4) | 0;
                        hi = hi + Math.imul(ah3, bh4) | 0;
                        lo = lo + Math.imul(al2, bl5) | 0;
                        mid = mid + Math.imul(al2, bh5) | 0;
                        mid = mid + Math.imul(ah2, bl5) | 0;
                        hi = hi + Math.imul(ah2, bh5) | 0;
                        lo = lo + Math.imul(al1, bl6) | 0;
                        mid = mid + Math.imul(al1, bh6) | 0;
                        mid = mid + Math.imul(ah1, bl6) | 0;
                        hi = hi + Math.imul(ah1, bh6) | 0;
                        lo = lo + Math.imul(al0, bl7) | 0;
                        mid = mid + Math.imul(al0, bh7) | 0;
                        mid = mid + Math.imul(ah0, bl7) | 0;
                        hi = hi + Math.imul(ah0, bh7) | 0;
                        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
                        w7 &= 0x3ffffff;
                        /* k = 8 */ lo = Math.imul(al8, bl0);
                        mid = Math.imul(al8, bh0);
                        mid = mid + Math.imul(ah8, bl0) | 0;
                        hi = Math.imul(ah8, bh0);
                        lo = lo + Math.imul(al7, bl1) | 0;
                        mid = mid + Math.imul(al7, bh1) | 0;
                        mid = mid + Math.imul(ah7, bl1) | 0;
                        hi = hi + Math.imul(ah7, bh1) | 0;
                        lo = lo + Math.imul(al6, bl2) | 0;
                        mid = mid + Math.imul(al6, bh2) | 0;
                        mid = mid + Math.imul(ah6, bl2) | 0;
                        hi = hi + Math.imul(ah6, bh2) | 0;
                        lo = lo + Math.imul(al5, bl3) | 0;
                        mid = mid + Math.imul(al5, bh3) | 0;
                        mid = mid + Math.imul(ah5, bl3) | 0;
                        hi = hi + Math.imul(ah5, bh3) | 0;
                        lo = lo + Math.imul(al4, bl4) | 0;
                        mid = mid + Math.imul(al4, bh4) | 0;
                        mid = mid + Math.imul(ah4, bl4) | 0;
                        hi = hi + Math.imul(ah4, bh4) | 0;
                        lo = lo + Math.imul(al3, bl5) | 0;
                        mid = mid + Math.imul(al3, bh5) | 0;
                        mid = mid + Math.imul(ah3, bl5) | 0;
                        hi = hi + Math.imul(ah3, bh5) | 0;
                        lo = lo + Math.imul(al2, bl6) | 0;
                        mid = mid + Math.imul(al2, bh6) | 0;
                        mid = mid + Math.imul(ah2, bl6) | 0;
                        hi = hi + Math.imul(ah2, bh6) | 0;
                        lo = lo + Math.imul(al1, bl7) | 0;
                        mid = mid + Math.imul(al1, bh7) | 0;
                        mid = mid + Math.imul(ah1, bl7) | 0;
                        hi = hi + Math.imul(ah1, bh7) | 0;
                        lo = lo + Math.imul(al0, bl8) | 0;
                        mid = mid + Math.imul(al0, bh8) | 0;
                        mid = mid + Math.imul(ah0, bl8) | 0;
                        hi = hi + Math.imul(ah0, bh8) | 0;
                        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
                        w8 &= 0x3ffffff;
                        /* k = 9 */ lo = Math.imul(al9, bl0);
                        mid = Math.imul(al9, bh0);
                        mid = mid + Math.imul(ah9, bl0) | 0;
                        hi = Math.imul(ah9, bh0);
                        lo = lo + Math.imul(al8, bl1) | 0;
                        mid = mid + Math.imul(al8, bh1) | 0;
                        mid = mid + Math.imul(ah8, bl1) | 0;
                        hi = hi + Math.imul(ah8, bh1) | 0;
                        lo = lo + Math.imul(al7, bl2) | 0;
                        mid = mid + Math.imul(al7, bh2) | 0;
                        mid = mid + Math.imul(ah7, bl2) | 0;
                        hi = hi + Math.imul(ah7, bh2) | 0;
                        lo = lo + Math.imul(al6, bl3) | 0;
                        mid = mid + Math.imul(al6, bh3) | 0;
                        mid = mid + Math.imul(ah6, bl3) | 0;
                        hi = hi + Math.imul(ah6, bh3) | 0;
                        lo = lo + Math.imul(al5, bl4) | 0;
                        mid = mid + Math.imul(al5, bh4) | 0;
                        mid = mid + Math.imul(ah5, bl4) | 0;
                        hi = hi + Math.imul(ah5, bh4) | 0;
                        lo = lo + Math.imul(al4, bl5) | 0;
                        mid = mid + Math.imul(al4, bh5) | 0;
                        mid = mid + Math.imul(ah4, bl5) | 0;
                        hi = hi + Math.imul(ah4, bh5) | 0;
                        lo = lo + Math.imul(al3, bl6) | 0;
                        mid = mid + Math.imul(al3, bh6) | 0;
                        mid = mid + Math.imul(ah3, bl6) | 0;
                        hi = hi + Math.imul(ah3, bh6) | 0;
                        lo = lo + Math.imul(al2, bl7) | 0;
                        mid = mid + Math.imul(al2, bh7) | 0;
                        mid = mid + Math.imul(ah2, bl7) | 0;
                        hi = hi + Math.imul(ah2, bh7) | 0;
                        lo = lo + Math.imul(al1, bl8) | 0;
                        mid = mid + Math.imul(al1, bh8) | 0;
                        mid = mid + Math.imul(ah1, bl8) | 0;
                        hi = hi + Math.imul(ah1, bh8) | 0;
                        lo = lo + Math.imul(al0, bl9) | 0;
                        mid = mid + Math.imul(al0, bh9) | 0;
                        mid = mid + Math.imul(ah0, bl9) | 0;
                        hi = hi + Math.imul(ah0, bh9) | 0;
                        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
                        w9 &= 0x3ffffff;
                        /* k = 10 */ lo = Math.imul(al9, bl1);
                        mid = Math.imul(al9, bh1);
                        mid = mid + Math.imul(ah9, bl1) | 0;
                        hi = Math.imul(ah9, bh1);
                        lo = lo + Math.imul(al8, bl2) | 0;
                        mid = mid + Math.imul(al8, bh2) | 0;
                        mid = mid + Math.imul(ah8, bl2) | 0;
                        hi = hi + Math.imul(ah8, bh2) | 0;
                        lo = lo + Math.imul(al7, bl3) | 0;
                        mid = mid + Math.imul(al7, bh3) | 0;
                        mid = mid + Math.imul(ah7, bl3) | 0;
                        hi = hi + Math.imul(ah7, bh3) | 0;
                        lo = lo + Math.imul(al6, bl4) | 0;
                        mid = mid + Math.imul(al6, bh4) | 0;
                        mid = mid + Math.imul(ah6, bl4) | 0;
                        hi = hi + Math.imul(ah6, bh4) | 0;
                        lo = lo + Math.imul(al5, bl5) | 0;
                        mid = mid + Math.imul(al5, bh5) | 0;
                        mid = mid + Math.imul(ah5, bl5) | 0;
                        hi = hi + Math.imul(ah5, bh5) | 0;
                        lo = lo + Math.imul(al4, bl6) | 0;
                        mid = mid + Math.imul(al4, bh6) | 0;
                        mid = mid + Math.imul(ah4, bl6) | 0;
                        hi = hi + Math.imul(ah4, bh6) | 0;
                        lo = lo + Math.imul(al3, bl7) | 0;
                        mid = mid + Math.imul(al3, bh7) | 0;
                        mid = mid + Math.imul(ah3, bl7) | 0;
                        hi = hi + Math.imul(ah3, bh7) | 0;
                        lo = lo + Math.imul(al2, bl8) | 0;
                        mid = mid + Math.imul(al2, bh8) | 0;
                        mid = mid + Math.imul(ah2, bl8) | 0;
                        hi = hi + Math.imul(ah2, bh8) | 0;
                        lo = lo + Math.imul(al1, bl9) | 0;
                        mid = mid + Math.imul(al1, bh9) | 0;
                        mid = mid + Math.imul(ah1, bl9) | 0;
                        hi = hi + Math.imul(ah1, bh9) | 0;
                        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
                        w10 &= 0x3ffffff;
                        /* k = 11 */ lo = Math.imul(al9, bl2);
                        mid = Math.imul(al9, bh2);
                        mid = mid + Math.imul(ah9, bl2) | 0;
                        hi = Math.imul(ah9, bh2);
                        lo = lo + Math.imul(al8, bl3) | 0;
                        mid = mid + Math.imul(al8, bh3) | 0;
                        mid = mid + Math.imul(ah8, bl3) | 0;
                        hi = hi + Math.imul(ah8, bh3) | 0;
                        lo = lo + Math.imul(al7, bl4) | 0;
                        mid = mid + Math.imul(al7, bh4) | 0;
                        mid = mid + Math.imul(ah7, bl4) | 0;
                        hi = hi + Math.imul(ah7, bh4) | 0;
                        lo = lo + Math.imul(al6, bl5) | 0;
                        mid = mid + Math.imul(al6, bh5) | 0;
                        mid = mid + Math.imul(ah6, bl5) | 0;
                        hi = hi + Math.imul(ah6, bh5) | 0;
                        lo = lo + Math.imul(al5, bl6) | 0;
                        mid = mid + Math.imul(al5, bh6) | 0;
                        mid = mid + Math.imul(ah5, bl6) | 0;
                        hi = hi + Math.imul(ah5, bh6) | 0;
                        lo = lo + Math.imul(al4, bl7) | 0;
                        mid = mid + Math.imul(al4, bh7) | 0;
                        mid = mid + Math.imul(ah4, bl7) | 0;
                        hi = hi + Math.imul(ah4, bh7) | 0;
                        lo = lo + Math.imul(al3, bl8) | 0;
                        mid = mid + Math.imul(al3, bh8) | 0;
                        mid = mid + Math.imul(ah3, bl8) | 0;
                        hi = hi + Math.imul(ah3, bh8) | 0;
                        lo = lo + Math.imul(al2, bl9) | 0;
                        mid = mid + Math.imul(al2, bh9) | 0;
                        mid = mid + Math.imul(ah2, bl9) | 0;
                        hi = hi + Math.imul(ah2, bh9) | 0;
                        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
                        w11 &= 0x3ffffff;
                        /* k = 12 */ lo = Math.imul(al9, bl3);
                        mid = Math.imul(al9, bh3);
                        mid = mid + Math.imul(ah9, bl3) | 0;
                        hi = Math.imul(ah9, bh3);
                        lo = lo + Math.imul(al8, bl4) | 0;
                        mid = mid + Math.imul(al8, bh4) | 0;
                        mid = mid + Math.imul(ah8, bl4) | 0;
                        hi = hi + Math.imul(ah8, bh4) | 0;
                        lo = lo + Math.imul(al7, bl5) | 0;
                        mid = mid + Math.imul(al7, bh5) | 0;
                        mid = mid + Math.imul(ah7, bl5) | 0;
                        hi = hi + Math.imul(ah7, bh5) | 0;
                        lo = lo + Math.imul(al6, bl6) | 0;
                        mid = mid + Math.imul(al6, bh6) | 0;
                        mid = mid + Math.imul(ah6, bl6) | 0;
                        hi = hi + Math.imul(ah6, bh6) | 0;
                        lo = lo + Math.imul(al5, bl7) | 0;
                        mid = mid + Math.imul(al5, bh7) | 0;
                        mid = mid + Math.imul(ah5, bl7) | 0;
                        hi = hi + Math.imul(ah5, bh7) | 0;
                        lo = lo + Math.imul(al4, bl8) | 0;
                        mid = mid + Math.imul(al4, bh8) | 0;
                        mid = mid + Math.imul(ah4, bl8) | 0;
                        hi = hi + Math.imul(ah4, bh8) | 0;
                        lo = lo + Math.imul(al3, bl9) | 0;
                        mid = mid + Math.imul(al3, bh9) | 0;
                        mid = mid + Math.imul(ah3, bl9) | 0;
                        hi = hi + Math.imul(ah3, bh9) | 0;
                        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
                        w12 &= 0x3ffffff;
                        /* k = 13 */ lo = Math.imul(al9, bl4);
                        mid = Math.imul(al9, bh4);
                        mid = mid + Math.imul(ah9, bl4) | 0;
                        hi = Math.imul(ah9, bh4);
                        lo = lo + Math.imul(al8, bl5) | 0;
                        mid = mid + Math.imul(al8, bh5) | 0;
                        mid = mid + Math.imul(ah8, bl5) | 0;
                        hi = hi + Math.imul(ah8, bh5) | 0;
                        lo = lo + Math.imul(al7, bl6) | 0;
                        mid = mid + Math.imul(al7, bh6) | 0;
                        mid = mid + Math.imul(ah7, bl6) | 0;
                        hi = hi + Math.imul(ah7, bh6) | 0;
                        lo = lo + Math.imul(al6, bl7) | 0;
                        mid = mid + Math.imul(al6, bh7) | 0;
                        mid = mid + Math.imul(ah6, bl7) | 0;
                        hi = hi + Math.imul(ah6, bh7) | 0;
                        lo = lo + Math.imul(al5, bl8) | 0;
                        mid = mid + Math.imul(al5, bh8) | 0;
                        mid = mid + Math.imul(ah5, bl8) | 0;
                        hi = hi + Math.imul(ah5, bh8) | 0;
                        lo = lo + Math.imul(al4, bl9) | 0;
                        mid = mid + Math.imul(al4, bh9) | 0;
                        mid = mid + Math.imul(ah4, bl9) | 0;
                        hi = hi + Math.imul(ah4, bh9) | 0;
                        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
                        w13 &= 0x3ffffff;
                        /* k = 14 */ lo = Math.imul(al9, bl5);
                        mid = Math.imul(al9, bh5);
                        mid = mid + Math.imul(ah9, bl5) | 0;
                        hi = Math.imul(ah9, bh5);
                        lo = lo + Math.imul(al8, bl6) | 0;
                        mid = mid + Math.imul(al8, bh6) | 0;
                        mid = mid + Math.imul(ah8, bl6) | 0;
                        hi = hi + Math.imul(ah8, bh6) | 0;
                        lo = lo + Math.imul(al7, bl7) | 0;
                        mid = mid + Math.imul(al7, bh7) | 0;
                        mid = mid + Math.imul(ah7, bl7) | 0;
                        hi = hi + Math.imul(ah7, bh7) | 0;
                        lo = lo + Math.imul(al6, bl8) | 0;
                        mid = mid + Math.imul(al6, bh8) | 0;
                        mid = mid + Math.imul(ah6, bl8) | 0;
                        hi = hi + Math.imul(ah6, bh8) | 0;
                        lo = lo + Math.imul(al5, bl9) | 0;
                        mid = mid + Math.imul(al5, bh9) | 0;
                        mid = mid + Math.imul(ah5, bl9) | 0;
                        hi = hi + Math.imul(ah5, bh9) | 0;
                        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
                        w14 &= 0x3ffffff;
                        /* k = 15 */ lo = Math.imul(al9, bl6);
                        mid = Math.imul(al9, bh6);
                        mid = mid + Math.imul(ah9, bl6) | 0;
                        hi = Math.imul(ah9, bh6);
                        lo = lo + Math.imul(al8, bl7) | 0;
                        mid = mid + Math.imul(al8, bh7) | 0;
                        mid = mid + Math.imul(ah8, bl7) | 0;
                        hi = hi + Math.imul(ah8, bh7) | 0;
                        lo = lo + Math.imul(al7, bl8) | 0;
                        mid = mid + Math.imul(al7, bh8) | 0;
                        mid = mid + Math.imul(ah7, bl8) | 0;
                        hi = hi + Math.imul(ah7, bh8) | 0;
                        lo = lo + Math.imul(al6, bl9) | 0;
                        mid = mid + Math.imul(al6, bh9) | 0;
                        mid = mid + Math.imul(ah6, bl9) | 0;
                        hi = hi + Math.imul(ah6, bh9) | 0;
                        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
                        w15 &= 0x3ffffff;
                        /* k = 16 */ lo = Math.imul(al9, bl7);
                        mid = Math.imul(al9, bh7);
                        mid = mid + Math.imul(ah9, bl7) | 0;
                        hi = Math.imul(ah9, bh7);
                        lo = lo + Math.imul(al8, bl8) | 0;
                        mid = mid + Math.imul(al8, bh8) | 0;
                        mid = mid + Math.imul(ah8, bl8) | 0;
                        hi = hi + Math.imul(ah8, bh8) | 0;
                        lo = lo + Math.imul(al7, bl9) | 0;
                        mid = mid + Math.imul(al7, bh9) | 0;
                        mid = mid + Math.imul(ah7, bl9) | 0;
                        hi = hi + Math.imul(ah7, bh9) | 0;
                        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
                        w16 &= 0x3ffffff;
                        /* k = 17 */ lo = Math.imul(al9, bl8);
                        mid = Math.imul(al9, bh8);
                        mid = mid + Math.imul(ah9, bl8) | 0;
                        hi = Math.imul(ah9, bh8);
                        lo = lo + Math.imul(al8, bl9) | 0;
                        mid = mid + Math.imul(al8, bh9) | 0;
                        mid = mid + Math.imul(ah8, bl9) | 0;
                        hi = hi + Math.imul(ah8, bh9) | 0;
                        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
                        w17 &= 0x3ffffff;
                        /* k = 18 */ lo = Math.imul(al9, bl9);
                        mid = Math.imul(al9, bh9);
                        mid = mid + Math.imul(ah9, bl9) | 0;
                        hi = Math.imul(ah9, bh9);
                        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
                        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
                        w18 &= 0x3ffffff;
                        o[0] = w0;
                        o[1] = w1;
                        o[2] = w2;
                        o[3] = w3;
                        o[4] = w4;
                        o[5] = w5;
                        o[6] = w6;
                        o[7] = w7;
                        o[8] = w8;
                        o[9] = w9;
                        o[10] = w10;
                        o[11] = w11;
                        o[12] = w12;
                        o[13] = w13;
                        o[14] = w14;
                        o[15] = w15;
                        o[16] = w16;
                        o[17] = w17;
                        o[18] = w18;
                        if (c !== 0) {
                            o[19] = c;
                            out.length++;
                        }
                        return out;
                    };
                    // Polyfill comb
                    if (!Math.imul) comb10MulTo = smallMulTo;
                    function bigMulTo(self1, num, out) {
                        out.negative = num.negative ^ self1.negative;
                        out.length = self1.length + num.length;
                        var carry = 0;
                        var hncarry = 0;
                        for(var k = 0; k < out.length - 1; k++){
                            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
                            // note that ncarry could be >= 0x3ffffff
                            var ncarry = hncarry;
                            hncarry = 0;
                            var rword = carry & 0x3ffffff;
                            var maxJ = Math.min(k, num.length - 1);
                            for(var j = Math.max(0, k - self1.length + 1); j <= maxJ; j++){
                                var i = k - j;
                                var a = self1.words[i] | 0;
                                var b = num.words[j] | 0;
                                var r = a * b;
                                var lo = r & 0x3ffffff;
                                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                                lo = lo + rword | 0;
                                rword = lo & 0x3ffffff;
                                ncarry = ncarry + (lo >>> 26) | 0;
                                hncarry += ncarry >>> 26;
                                ncarry &= 0x3ffffff;
                            }
                            out.words[k] = rword;
                            carry = ncarry;
                            ncarry = hncarry;
                        }
                        if (carry !== 0) out.words[k] = carry;
                        else out.length--;
                        return out.strip();
                    }
                    function jumboMulTo(self1, num, out) {
                        var fftm = new FFTM();
                        return fftm.mulp(self1, num, out);
                    }
                    BN.prototype.mulTo = function mulTo(num, out) {
                        var res;
                        var len = this.length + num.length;
                        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
                        else if (len < 63) res = smallMulTo(this, num, out);
                        else if (len < 1024) res = bigMulTo(this, num, out);
                        else res = jumboMulTo(this, num, out);
                        return res;
                    };
                    // Cooley-Tukey algorithm for FFT
                    // slightly revisited to rely on looping instead of recursion
                    function FFTM(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    FFTM.prototype.makeRBT = function makeRBT(N) {
                        var t = new Array(N);
                        var l = BN.prototype._countBits(N) - 1;
                        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
                        return t;
                    };
                    // Returns binary-reversed representation of `x`
                    FFTM.prototype.revBin = function revBin(x, l, N) {
                        if (x === 0 || x === N - 1) return x;
                        var rb = 0;
                        for(var i = 0; i < l; i++){
                            rb |= (x & 1) << l - i - 1;
                            x >>= 1;
                        }
                        return rb;
                    };
                    // Performs "tweedling" phase, therefore 'emulating'
                    // behaviour of the recursive algorithm
                    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
                        for(var i = 0; i < N; i++){
                            rtws[i] = rws[rbt[i]];
                            itws[i] = iws[rbt[i]];
                        }
                    };
                    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
                        this.permute(rbt, rws, iws, rtws, itws, N);
                        for(var s = 1; s < N; s <<= 1){
                            var l = s << 1;
                            var rtwdf = Math.cos(2 * Math.PI / l);
                            var itwdf = Math.sin(2 * Math.PI / l);
                            for(var p = 0; p < N; p += l){
                                var rtwdf_ = rtwdf;
                                var itwdf_ = itwdf;
                                for(var j = 0; j < s; j++){
                                    var re = rtws[p + j];
                                    var ie = itws[p + j];
                                    var ro = rtws[p + j + s];
                                    var io = itws[p + j + s];
                                    var rx = rtwdf_ * ro - itwdf_ * io;
                                    io = rtwdf_ * io + itwdf_ * ro;
                                    ro = rx;
                                    rtws[p + j] = re + ro;
                                    itws[p + j] = ie + io;
                                    rtws[p + j + s] = re - ro;
                                    itws[p + j + s] = ie - io;
                                    /* jshint maxdepth : false */ if (j !== l) {
                                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                                        rtwdf_ = rx;
                                    }
                                }
                            }
                        }
                    };
                    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
                        var N = Math.max(m, n) | 1;
                        var odd = N & 1;
                        var i = 0;
                        for(N = N / 2 | 0; N; N = N >>> 1)i++;
                        return 1 << i + 1 + odd;
                    };
                    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
                        if (N <= 1) return;
                        for(var i = 0; i < N / 2; i++){
                            var t = rws[i];
                            rws[i] = rws[N - i - 1];
                            rws[N - i - 1] = t;
                            t = iws[i];
                            iws[i] = -iws[N - i - 1];
                            iws[N - i - 1] = -t;
                        }
                    };
                    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
                        var carry = 0;
                        for(var i = 0; i < N / 2; i++){
                            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                            ws[i] = w & 0x3ffffff;
                            if (w < 0x4000000) carry = 0;
                            else carry = w / 0x4000000 | 0;
                        }
                        return ws;
                    };
                    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
                        var carry = 0;
                        for(var i = 0; i < len; i++){
                            carry = carry + (ws[i] | 0);
                            rws[2 * i] = carry & 0x1fff;
                            carry = carry >>> 13;
                            rws[2 * i + 1] = carry & 0x1fff;
                            carry = carry >>> 13;
                        }
                        // Pad with zeroes
                        for(i = 2 * len; i < N; ++i)rws[i] = 0;
                        assert(carry === 0);
                        assert((carry & -8192) === 0);
                    };
                    FFTM.prototype.stub = function stub(N) {
                        var ph = new Array(N);
                        for(var i = 0; i < N; i++)ph[i] = 0;
                        return ph;
                    };
                    FFTM.prototype.mulp = function mulp(x, y, out) {
                        var N = 2 * this.guessLen13b(x.length, y.length);
                        var rbt = this.makeRBT(N);
                        var _ = this.stub(N);
                        var rws = new Array(N);
                        var rwst = new Array(N);
                        var iwst = new Array(N);
                        var nrws = new Array(N);
                        var nrwst = new Array(N);
                        var niwst = new Array(N);
                        var rmws = out.words;
                        rmws.length = N;
                        this.convert13b(x.words, x.length, rws, N);
                        this.convert13b(y.words, y.length, nrws, N);
                        this.transform(rws, _, rwst, iwst, N, rbt);
                        this.transform(nrws, _, nrwst, niwst, N, rbt);
                        for(var i = 0; i < N; i++){
                            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                            rwst[i] = rx;
                        }
                        this.conjugate(rwst, iwst, N);
                        this.transform(rwst, iwst, rmws, _, N, rbt);
                        this.conjugate(rmws, _, N);
                        this.normalize13b(rmws, N);
                        out.negative = x.negative ^ y.negative;
                        out.length = x.length + y.length;
                        return out.strip();
                    };
                    // Multiply `this` by `num`
                    BN.prototype.mul = function mul(num) {
                        var out = new BN(null);
                        out.words = new Array(this.length + num.length);
                        return this.mulTo(num, out);
                    };
                    // Multiply employing FFT
                    BN.prototype.mulf = function mulf(num) {
                        var out = new BN(null);
                        out.words = new Array(this.length + num.length);
                        return jumboMulTo(this, num, out);
                    };
                    // In-place Multiplication
                    BN.prototype.imul = function imul(num) {
                        return this.clone().mulTo(num, this);
                    };
                    BN.prototype.imuln = function imuln(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        // Carry
                        var carry = 0;
                        for(var i = 0; i < this.length; i++){
                            var w = (this.words[i] | 0) * num;
                            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                            carry >>= 26;
                            carry += w / 0x4000000 | 0;
                            // NOTE: lo is 27bit maximum
                            carry += lo >>> 26;
                            this.words[i] = lo & 0x3ffffff;
                        }
                        if (carry !== 0) {
                            this.words[i] = carry;
                            this.length++;
                        }
                        return this;
                    };
                    BN.prototype.muln = function muln(num) {
                        return this.clone().imuln(num);
                    };
                    // `this` * `this`
                    BN.prototype.sqr = function sqr() {
                        return this.mul(this);
                    };
                    // `this` * `this` in-place
                    BN.prototype.isqr = function isqr() {
                        return this.imul(this.clone());
                    };
                    // Math.pow(`this`, `num`)
                    BN.prototype.pow = function pow(num) {
                        var w = toBitArray(num);
                        if (w.length === 0) return new BN(1);
                        // Skip leading zeroes
                        var res = this;
                        for(var i = 0; i < w.length; i++, res = res.sqr()){
                            if (w[i] !== 0) break;
                        }
                        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                            if (w[i] === 0) continue;
                            res = res.mul(q);
                        }
                        return res;
                    };
                    // Shift-left in-place
                    BN.prototype.iushln = function iushln(bits) {
                        assert(typeof bits === "number" && bits >= 0);
                        var r = bits % 26;
                        var s = (bits - r) / 26;
                        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
                        var i;
                        if (r !== 0) {
                            var carry = 0;
                            for(i = 0; i < this.length; i++){
                                var newCarry = this.words[i] & carryMask;
                                var c = (this.words[i] | 0) - newCarry << r;
                                this.words[i] = c | carry;
                                carry = newCarry >>> 26 - r;
                            }
                            if (carry) {
                                this.words[i] = carry;
                                this.length++;
                            }
                        }
                        if (s !== 0) {
                            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                            for(i = 0; i < s; i++)this.words[i] = 0;
                            this.length += s;
                        }
                        return this.strip();
                    };
                    BN.prototype.ishln = function ishln(bits) {
                        // TODO(indutny): implement me
                        assert(this.negative === 0);
                        return this.iushln(bits);
                    };
                    // Shift-right in-place
                    // NOTE: `hint` is a lowest bit before trailing zeroes
                    // NOTE: if `extended` is present - it will be filled with destroyed bits
                    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
                        assert(typeof bits === "number" && bits >= 0);
                        var h;
                        if (hint) h = (hint - hint % 26) / 26;
                        else h = 0;
                        var r = bits % 26;
                        var s = Math.min((bits - r) / 26, this.length);
                        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                        var maskedWords = extended;
                        h -= s;
                        h = Math.max(0, h);
                        // Extended mode, copy masked part
                        if (maskedWords) {
                            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                            maskedWords.length = s;
                        }
                        if (s === 0) ;
                        else if (this.length > s) {
                            this.length -= s;
                            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
                        } else {
                            this.words[0] = 0;
                            this.length = 1;
                        }
                        var carry = 0;
                        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                            var word = this.words[i] | 0;
                            this.words[i] = carry << 26 - r | word >>> r;
                            carry = word & mask;
                        }
                        // Push carried bits as a mask
                        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
                        if (this.length === 0) {
                            this.words[0] = 0;
                            this.length = 1;
                        }
                        return this.strip();
                    };
                    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
                        // TODO(indutny): implement me
                        assert(this.negative === 0);
                        return this.iushrn(bits, hint, extended);
                    };
                    // Shift-left
                    BN.prototype.shln = function shln(bits) {
                        return this.clone().ishln(bits);
                    };
                    BN.prototype.ushln = function ushln(bits) {
                        return this.clone().iushln(bits);
                    };
                    // Shift-right
                    BN.prototype.shrn = function shrn(bits) {
                        return this.clone().ishrn(bits);
                    };
                    BN.prototype.ushrn = function ushrn(bits) {
                        return this.clone().iushrn(bits);
                    };
                    // Test if n bit is set
                    BN.prototype.testn = function testn(bit) {
                        assert(typeof bit === "number" && bit >= 0);
                        var r = bit % 26;
                        var s = (bit - r) / 26;
                        var q = 1 << r;
                        // Fast case: bit is much higher than all existing words
                        if (this.length <= s) return false;
                        // Check bit and return
                        var w = this.words[s];
                        return !!(w & q);
                    };
                    // Return only lowers bits of number (in-place)
                    BN.prototype.imaskn = function imaskn(bits) {
                        assert(typeof bits === "number" && bits >= 0);
                        var r = bits % 26;
                        var s = (bits - r) / 26;
                        assert(this.negative === 0, "imaskn works only with positive numbers");
                        if (this.length <= s) return this;
                        if (r !== 0) s++;
                        this.length = Math.min(s, this.length);
                        if (r !== 0) {
                            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                            this.words[this.length - 1] &= mask;
                        }
                        return this.strip();
                    };
                    // Return only lowers bits of number
                    BN.prototype.maskn = function maskn(bits) {
                        return this.clone().imaskn(bits);
                    };
                    // Add plain number `num` to `this`
                    BN.prototype.iaddn = function iaddn(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        if (num < 0) return this.isubn(-num);
                        // Possible sign change
                        if (this.negative !== 0) {
                            if (this.length === 1 && (this.words[0] | 0) < num) {
                                this.words[0] = num - (this.words[0] | 0);
                                this.negative = 0;
                                return this;
                            }
                            this.negative = 0;
                            this.isubn(num);
                            this.negative = 1;
                            return this;
                        }
                        // Add without checks
                        return this._iaddn(num);
                    };
                    BN.prototype._iaddn = function _iaddn(num) {
                        this.words[0] += num;
                        // Carry
                        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                            this.words[i] -= 0x4000000;
                            if (i === this.length - 1) this.words[i + 1] = 1;
                            else this.words[i + 1]++;
                        }
                        this.length = Math.max(this.length, i + 1);
                        return this;
                    };
                    // Subtract plain number `num` from `this`
                    BN.prototype.isubn = function isubn(num) {
                        assert(typeof num === "number");
                        assert(num < 0x4000000);
                        if (num < 0) return this.iaddn(-num);
                        if (this.negative !== 0) {
                            this.negative = 0;
                            this.iaddn(num);
                            this.negative = 1;
                            return this;
                        }
                        this.words[0] -= num;
                        if (this.length === 1 && this.words[0] < 0) {
                            this.words[0] = -this.words[0];
                            this.negative = 1;
                        } else // Carry
                        for(var i = 0; i < this.length && this.words[i] < 0; i++){
                            this.words[i] += 0x4000000;
                            this.words[i + 1] -= 1;
                        }
                        return this.strip();
                    };
                    BN.prototype.addn = function addn(num) {
                        return this.clone().iaddn(num);
                    };
                    BN.prototype.subn = function subn(num) {
                        return this.clone().isubn(num);
                    };
                    BN.prototype.iabs = function iabs() {
                        this.negative = 0;
                        return this;
                    };
                    BN.prototype.abs = function abs() {
                        return this.clone().iabs();
                    };
                    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
                        var len = num.length + shift;
                        var i;
                        this._expand(len);
                        var w;
                        var carry = 0;
                        for(i = 0; i < num.length; i++){
                            w = (this.words[i + shift] | 0) + carry;
                            var right = (num.words[i] | 0) * mul;
                            w -= right & 0x3ffffff;
                            carry = (w >> 26) - (right / 0x4000000 | 0);
                            this.words[i + shift] = w & 0x3ffffff;
                        }
                        for(; i < this.length - shift; i++){
                            w = (this.words[i + shift] | 0) + carry;
                            carry = w >> 26;
                            this.words[i + shift] = w & 0x3ffffff;
                        }
                        if (carry === 0) return this.strip();
                        // Subtraction overflow
                        assert(carry === -1);
                        carry = 0;
                        for(i = 0; i < this.length; i++){
                            w = -(this.words[i] | 0) + carry;
                            carry = w >> 26;
                            this.words[i] = w & 0x3ffffff;
                        }
                        this.negative = 1;
                        return this.strip();
                    };
                    BN.prototype._wordDiv = function _wordDiv(num, mode) {
                        var shift = this.length - num.length;
                        var a = this.clone();
                        var b = num;
                        // Normalize
                        var bhi = b.words[b.length - 1] | 0;
                        var bhiBits = this._countBits(bhi);
                        shift = 26 - bhiBits;
                        if (shift !== 0) {
                            b = b.ushln(shift);
                            a.iushln(shift);
                            bhi = b.words[b.length - 1] | 0;
                        }
                        // Initialize quotient
                        var m = a.length - b.length;
                        var q;
                        if (mode !== "mod") {
                            q = new BN(null);
                            q.length = m + 1;
                            q.words = new Array(q.length);
                            for(var i = 0; i < q.length; i++)q.words[i] = 0;
                        }
                        var diff = a.clone()._ishlnsubmul(b, 1, m);
                        if (diff.negative === 0) {
                            a = diff;
                            if (q) q.words[m] = 1;
                        }
                        for(var j = m - 1; j >= 0; j--){
                            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
                            // (0x7ffffff)
                            qj = Math.min(qj / bhi | 0, 0x3ffffff);
                            a._ishlnsubmul(b, qj, j);
                            while(a.negative !== 0){
                                qj--;
                                a.negative = 0;
                                a._ishlnsubmul(b, 1, j);
                                if (!a.isZero()) a.negative ^= 1;
                            }
                            if (q) q.words[j] = qj;
                        }
                        if (q) q.strip();
                        a.strip();
                        // Denormalize
                        if (mode !== "div" && shift !== 0) a.iushrn(shift);
                        return {
                            div: q || null,
                            mod: a
                        };
                    };
                    // NOTE: 1) `mode` can be set to `mod` to request mod only,
                    //       to `div` to request div only, or be absent to
                    //       request both div & mod
                    //       2) `positive` is true if unsigned mod is requested
                    BN.prototype.divmod = function divmod(num, mode, positive) {
                        assert(!num.isZero());
                        if (this.isZero()) return {
                            div: new BN(0),
                            mod: new BN(0)
                        };
                        var div, mod, res;
                        if (this.negative !== 0 && num.negative === 0) {
                            res = this.neg().divmod(num, mode);
                            if (mode !== "mod") div = res.div.neg();
                            if (mode !== "div") {
                                mod = res.mod.neg();
                                if (positive && mod.negative !== 0) mod.iadd(num);
                            }
                            return {
                                div: div,
                                mod: mod
                            };
                        }
                        if (this.negative === 0 && num.negative !== 0) {
                            res = this.divmod(num.neg(), mode);
                            if (mode !== "mod") div = res.div.neg();
                            return {
                                div: div,
                                mod: res.mod
                            };
                        }
                        if ((this.negative & num.negative) !== 0) {
                            res = this.neg().divmod(num.neg(), mode);
                            if (mode !== "div") {
                                mod = res.mod.neg();
                                if (positive && mod.negative !== 0) mod.isub(num);
                            }
                            return {
                                div: res.div,
                                mod: mod
                            };
                        }
                        // Both numbers are positive at this point
                        // Strip both numbers to approximate shift value
                        if (num.length > this.length || this.cmp(num) < 0) return {
                            div: new BN(0),
                            mod: this
                        };
                        // Very short reduction
                        if (num.length === 1) {
                            if (mode === "div") return {
                                div: this.divn(num.words[0]),
                                mod: null
                            };
                            if (mode === "mod") return {
                                div: null,
                                mod: new BN(this.modn(num.words[0]))
                            };
                            return {
                                div: this.divn(num.words[0]),
                                mod: new BN(this.modn(num.words[0]))
                            };
                        }
                        return this._wordDiv(num, mode);
                    };
                    // Find `this` / `num`
                    BN.prototype.div = function div(num) {
                        return this.divmod(num, "div", false).div;
                    };
                    // Find `this` % `num`
                    BN.prototype.mod = function mod(num) {
                        return this.divmod(num, "mod", false).mod;
                    };
                    BN.prototype.umod = function umod(num) {
                        return this.divmod(num, "mod", true).mod;
                    };
                    // Find Round(`this` / `num`)
                    BN.prototype.divRound = function divRound(num) {
                        var dm = this.divmod(num);
                        // Fast case - exact division
                        if (dm.mod.isZero()) return dm.div;
                        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
                        var half = num.ushrn(1);
                        var r2 = num.andln(1);
                        var cmp = mod.cmp(half);
                        // Round down
                        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
                        // Round up
                        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
                    };
                    BN.prototype.modn = function modn(num) {
                        assert(num <= 0x3ffffff);
                        var p = 67108864 % num;
                        var acc = 0;
                        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
                        return acc;
                    };
                    // In-place division by number
                    BN.prototype.idivn = function idivn(num) {
                        assert(num <= 0x3ffffff);
                        var carry = 0;
                        for(var i = this.length - 1; i >= 0; i--){
                            var w = (this.words[i] | 0) + carry * 0x4000000;
                            this.words[i] = w / num | 0;
                            carry = w % num;
                        }
                        return this.strip();
                    };
                    BN.prototype.divn = function divn(num) {
                        return this.clone().idivn(num);
                    };
                    BN.prototype.egcd = function egcd(p) {
                        assert(p.negative === 0);
                        assert(!p.isZero());
                        var x = this;
                        var y = p.clone();
                        if (x.negative !== 0) x = x.umod(p);
                        else x = x.clone();
                        // A * x + B * y = x
                        var A = new BN(1);
                        var B = new BN(0);
                        // C * x + D * y = y
                        var C = new BN(0);
                        var D = new BN(1);
                        var g = 0;
                        while(x.isEven() && y.isEven()){
                            x.iushrn(1);
                            y.iushrn(1);
                            ++g;
                        }
                        var yp = y.clone();
                        var xp = x.clone();
                        while(!x.isZero()){
                            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                            if (i > 0) {
                                x.iushrn(i);
                                while(i-- > 0){
                                    if (A.isOdd() || B.isOdd()) {
                                        A.iadd(yp);
                                        B.isub(xp);
                                    }
                                    A.iushrn(1);
                                    B.iushrn(1);
                                }
                            }
                            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                            if (j > 0) {
                                y.iushrn(j);
                                while(j-- > 0){
                                    if (C.isOdd() || D.isOdd()) {
                                        C.iadd(yp);
                                        D.isub(xp);
                                    }
                                    C.iushrn(1);
                                    D.iushrn(1);
                                }
                            }
                            if (x.cmp(y) >= 0) {
                                x.isub(y);
                                A.isub(C);
                                B.isub(D);
                            } else {
                                y.isub(x);
                                C.isub(A);
                                D.isub(B);
                            }
                        }
                        return {
                            a: C,
                            b: D,
                            gcd: y.iushln(g)
                        };
                    };
                    // This is reduced incarnation of the binary EEA
                    // above, designated to invert members of the
                    // _prime_ fields F(p) at a maximal speed
                    BN.prototype._invmp = function _invmp(p) {
                        assert(p.negative === 0);
                        assert(!p.isZero());
                        var a = this;
                        var b = p.clone();
                        if (a.negative !== 0) a = a.umod(p);
                        else a = a.clone();
                        var x1 = new BN(1);
                        var x2 = new BN(0);
                        var delta = b.clone();
                        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                            if (i > 0) {
                                a.iushrn(i);
                                while(i-- > 0){
                                    if (x1.isOdd()) x1.iadd(delta);
                                    x1.iushrn(1);
                                }
                            }
                            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                            if (j > 0) {
                                b.iushrn(j);
                                while(j-- > 0){
                                    if (x2.isOdd()) x2.iadd(delta);
                                    x2.iushrn(1);
                                }
                            }
                            if (a.cmp(b) >= 0) {
                                a.isub(b);
                                x1.isub(x2);
                            } else {
                                b.isub(a);
                                x2.isub(x1);
                            }
                        }
                        var res;
                        if (a.cmpn(1) === 0) res = x1;
                        else res = x2;
                        if (res.cmpn(0) < 0) res.iadd(p);
                        return res;
                    };
                    BN.prototype.gcd = function gcd(num) {
                        if (this.isZero()) return num.abs();
                        if (num.isZero()) return this.abs();
                        var a = this.clone();
                        var b = num.clone();
                        a.negative = 0;
                        b.negative = 0;
                        // Remove common factor of two
                        for(var shift = 0; a.isEven() && b.isEven(); shift++){
                            a.iushrn(1);
                            b.iushrn(1);
                        }
                        do {
                            while(a.isEven())a.iushrn(1);
                            while(b.isEven())b.iushrn(1);
                            var r = a.cmp(b);
                            if (r < 0) {
                                // Swap `a` and `b` to make `a` always bigger than `b`
                                var t = a;
                                a = b;
                                b = t;
                            } else if (r === 0 || b.cmpn(1) === 0) break;
                            a.isub(b);
                        }while (true);
                        return b.iushln(shift);
                    };
                    // Invert number in the field F(num)
                    BN.prototype.invm = function invm(num) {
                        return this.egcd(num).a.umod(num);
                    };
                    BN.prototype.isEven = function isEven() {
                        return (this.words[0] & 1) === 0;
                    };
                    BN.prototype.isOdd = function isOdd() {
                        return (this.words[0] & 1) === 1;
                    };
                    // And first word and num
                    BN.prototype.andln = function andln(num) {
                        return this.words[0] & num;
                    };
                    // Increment at the bit position in-line
                    BN.prototype.bincn = function bincn(bit) {
                        assert(typeof bit === "number");
                        var r = bit % 26;
                        var s = (bit - r) / 26;
                        var q = 1 << r;
                        // Fast case: bit is much higher than all existing words
                        if (this.length <= s) {
                            this._expand(s + 1);
                            this.words[s] |= q;
                            return this;
                        }
                        // Add bit and propagate, if needed
                        var carry = q;
                        for(var i = s; carry !== 0 && i < this.length; i++){
                            var w = this.words[i] | 0;
                            w += carry;
                            carry = w >>> 26;
                            w &= 0x3ffffff;
                            this.words[i] = w;
                        }
                        if (carry !== 0) {
                            this.words[i] = carry;
                            this.length++;
                        }
                        return this;
                    };
                    BN.prototype.isZero = function isZero() {
                        return this.length === 1 && this.words[0] === 0;
                    };
                    BN.prototype.cmpn = function cmpn(num) {
                        var negative = num < 0;
                        if (this.negative !== 0 && !negative) return -1;
                        if (this.negative === 0 && negative) return 1;
                        this.strip();
                        var res;
                        if (this.length > 1) res = 1;
                        else {
                            if (negative) num = -num;
                            assert(num <= 0x3ffffff, "Number is too big");
                            var w = this.words[0] | 0;
                            res = w === num ? 0 : w < num ? -1 : 1;
                        }
                        if (this.negative !== 0) return -res | 0;
                        return res;
                    };
                    // Compare two numbers and return:
                    // 1 - if `this` > `num`
                    // 0 - if `this` == `num`
                    // -1 - if `this` < `num`
                    BN.prototype.cmp = function cmp(num) {
                        if (this.negative !== 0 && num.negative === 0) return -1;
                        if (this.negative === 0 && num.negative !== 0) return 1;
                        var res = this.ucmp(num);
                        if (this.negative !== 0) return -res | 0;
                        return res;
                    };
                    // Unsigned comparison
                    BN.prototype.ucmp = function ucmp(num) {
                        // At this point both numbers have the same sign
                        if (this.length > num.length) return 1;
                        if (this.length < num.length) return -1;
                        var res = 0;
                        for(var i = this.length - 1; i >= 0; i--){
                            var a = this.words[i] | 0;
                            var b = num.words[i] | 0;
                            if (a === b) continue;
                            if (a < b) res = -1;
                            else if (a > b) res = 1;
                            break;
                        }
                        return res;
                    };
                    BN.prototype.gtn = function gtn(num) {
                        return this.cmpn(num) === 1;
                    };
                    BN.prototype.gt = function gt(num) {
                        return this.cmp(num) === 1;
                    };
                    BN.prototype.gten = function gten(num) {
                        return this.cmpn(num) >= 0;
                    };
                    BN.prototype.gte = function gte(num) {
                        return this.cmp(num) >= 0;
                    };
                    BN.prototype.ltn = function ltn(num) {
                        return this.cmpn(num) === -1;
                    };
                    BN.prototype.lt = function lt(num) {
                        return this.cmp(num) === -1;
                    };
                    BN.prototype.lten = function lten(num) {
                        return this.cmpn(num) <= 0;
                    };
                    BN.prototype.lte = function lte(num) {
                        return this.cmp(num) <= 0;
                    };
                    BN.prototype.eqn = function eqn(num) {
                        return this.cmpn(num) === 0;
                    };
                    BN.prototype.eq = function eq(num) {
                        return this.cmp(num) === 0;
                    };
                    //
                    // A reduce context, could be using montgomery or something better, depending
                    // on the `m` itself.
                    //
                    BN.red = function red(num) {
                        return new Red(num);
                    };
                    BN.prototype.toRed = function toRed(ctx) {
                        assert(!this.red, "Already a number in reduction context");
                        assert(this.negative === 0, "red works only with positives");
                        return ctx.convertTo(this)._forceRed(ctx);
                    };
                    BN.prototype.fromRed = function fromRed() {
                        assert(this.red, "fromRed works only with numbers in reduction context");
                        return this.red.convertFrom(this);
                    };
                    BN.prototype._forceRed = function _forceRed(ctx) {
                        this.red = ctx;
                        return this;
                    };
                    BN.prototype.forceRed = function forceRed(ctx) {
                        assert(!this.red, "Already a number in reduction context");
                        return this._forceRed(ctx);
                    };
                    BN.prototype.redAdd = function redAdd(num) {
                        assert(this.red, "redAdd works only with red numbers");
                        return this.red.add(this, num);
                    };
                    BN.prototype.redIAdd = function redIAdd(num) {
                        assert(this.red, "redIAdd works only with red numbers");
                        return this.red.iadd(this, num);
                    };
                    BN.prototype.redSub = function redSub(num) {
                        assert(this.red, "redSub works only with red numbers");
                        return this.red.sub(this, num);
                    };
                    BN.prototype.redISub = function redISub(num) {
                        assert(this.red, "redISub works only with red numbers");
                        return this.red.isub(this, num);
                    };
                    BN.prototype.redShl = function redShl(num) {
                        assert(this.red, "redShl works only with red numbers");
                        return this.red.shl(this, num);
                    };
                    BN.prototype.redMul = function redMul(num) {
                        assert(this.red, "redMul works only with red numbers");
                        this.red._verify2(this, num);
                        return this.red.mul(this, num);
                    };
                    BN.prototype.redIMul = function redIMul(num) {
                        assert(this.red, "redMul works only with red numbers");
                        this.red._verify2(this, num);
                        return this.red.imul(this, num);
                    };
                    BN.prototype.redSqr = function redSqr() {
                        assert(this.red, "redSqr works only with red numbers");
                        this.red._verify1(this);
                        return this.red.sqr(this);
                    };
                    BN.prototype.redISqr = function redISqr() {
                        assert(this.red, "redISqr works only with red numbers");
                        this.red._verify1(this);
                        return this.red.isqr(this);
                    };
                    // Square root over p
                    BN.prototype.redSqrt = function redSqrt() {
                        assert(this.red, "redSqrt works only with red numbers");
                        this.red._verify1(this);
                        return this.red.sqrt(this);
                    };
                    BN.prototype.redInvm = function redInvm() {
                        assert(this.red, "redInvm works only with red numbers");
                        this.red._verify1(this);
                        return this.red.invm(this);
                    };
                    // Return negative clone of `this` % `red modulo`
                    BN.prototype.redNeg = function redNeg() {
                        assert(this.red, "redNeg works only with red numbers");
                        this.red._verify1(this);
                        return this.red.neg(this);
                    };
                    BN.prototype.redPow = function redPow(num) {
                        assert(this.red && !num.red, "redPow(normalNum)");
                        this.red._verify1(this);
                        return this.red.pow(this, num);
                    };
                    // Prime numbers with efficient reduction
                    var primes = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    // Pseudo-Mersenne prime
                    function MPrime(name1, p) {
                        // P = 2 ^ N - K
                        this.name = name1;
                        this.p = new BN(p, 16);
                        this.n = this.p.bitLength();
                        this.k = new BN(1).iushln(this.n).isub(this.p);
                        this.tmp = this._tmp();
                    }
                    MPrime.prototype._tmp = function _tmp() {
                        var tmp = new BN(null);
                        tmp.words = new Array(Math.ceil(this.n / 13));
                        return tmp;
                    };
                    MPrime.prototype.ireduce = function ireduce(num) {
                        // Assumes that `num` is less than `P^2`
                        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
                        var r = num;
                        var rlen;
                        do {
                            this.split(r, this.tmp);
                            r = this.imulK(r);
                            r = r.iadd(this.tmp);
                            rlen = r.bitLength();
                        }while (rlen > this.n);
                        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
                        if (cmp === 0) {
                            r.words[0] = 0;
                            r.length = 1;
                        } else if (cmp > 0) r.isub(this.p);
                        else if (r.strip !== undefined) // r is BN v4 instance
                        r.strip();
                        else // r is BN v5 instance
                        r._strip();
                        return r;
                    };
                    MPrime.prototype.split = function split(input, out) {
                        input.iushrn(this.n, 0, out);
                    };
                    MPrime.prototype.imulK = function imulK(num) {
                        return num.imul(this.k);
                    };
                    function K256() {
                        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    inherits(K256, MPrime);
                    K256.prototype.split = function split(input, output) {
                        // 256 = 9 * 26 + 22
                        var mask = 0x3fffff;
                        var outLen = Math.min(input.length, 9);
                        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
                        output.length = outLen;
                        if (input.length <= 9) {
                            input.words[0] = 0;
                            input.length = 1;
                            return;
                        }
                        // Shift by 9 limbs
                        var prev = input.words[9];
                        output.words[output.length++] = prev & mask;
                        for(i = 10; i < input.length; i++){
                            var next = input.words[i] | 0;
                            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                            prev = next;
                        }
                        prev >>>= 22;
                        input.words[i - 10] = prev;
                        if (prev === 0 && input.length > 10) input.length -= 10;
                        else input.length -= 9;
                    };
                    K256.prototype.imulK = function imulK(num) {
                        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
                        num.words[num.length] = 0;
                        num.words[num.length + 1] = 0;
                        num.length += 2;
                        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
                        var lo = 0;
                        for(var i = 0; i < num.length; i++){
                            var w = num.words[i] | 0;
                            lo += w * 0x3d1;
                            num.words[i] = lo & 0x3ffffff;
                            lo = w * 0x40 + (lo / 0x4000000 | 0);
                        }
                        // Fast length reduction
                        if (num.words[num.length - 1] === 0) {
                            num.length--;
                            if (num.words[num.length - 1] === 0) num.length--;
                        }
                        return num;
                    };
                    function P224() {
                        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    inherits(P224, MPrime);
                    function P192() {
                        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    inherits(P192, MPrime);
                    function P25519() {
                        // 2 ^ 255 - 19
                        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    inherits(P25519, MPrime);
                    P25519.prototype.imulK = function imulK(num) {
                        // K = 0x13
                        var carry = 0;
                        for(var i = 0; i < num.length; i++){
                            var hi = (num.words[i] | 0) * 0x13 + carry;
                            var lo = hi & 0x3ffffff;
                            hi >>>= 26;
                            num.words[i] = lo;
                            carry = hi;
                        }
                        if (carry !== 0) num.words[num.length++] = carry;
                        return num;
                    };
                    // Exported mostly for testing purposes, use plain name instead
                    BN._prime = function prime(name1) {
                        // Cached version of prime
                        if (primes[name1]) return primes[name1];
                        var prime;
                        if (name1 === "k256") prime = new K256();
                        else if (name1 === "p224") prime = new P224();
                        else if (name1 === "p192") prime = new P192();
                        else if (name1 === "p25519") prime = new P25519();
                        else throw new Error("Unknown prime " + name1);
                        primes[name1] = prime;
                        return prime;
                    };
                    //
                    // Base reduction engine
                    //
                    function Red(m) {
                        if (typeof m === "string") {
                            var prime = BN._prime(m);
                            this.m = prime.p;
                            this.prime = prime;
                        } else {
                            assert(m.gtn(1), "modulus must be greater than 1");
                            this.m = m;
                            this.prime = null;
                        }
                    }
                    Red.prototype._verify1 = function _verify1(a) {
                        assert(a.negative === 0, "red works only with positives");
                        assert(a.red, "red works only with red numbers");
                    };
                    Red.prototype._verify2 = function _verify2(a, b) {
                        assert((a.negative | b.negative) === 0, "red works only with positives");
                        assert(a.red && a.red === b.red, "red works only with red numbers");
                    };
                    Red.prototype.imod = function imod(a) {
                        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
                        return a.umod(this.m)._forceRed(this);
                    };
                    Red.prototype.neg = function neg(a) {
                        if (a.isZero()) return a.clone();
                        return this.m.sub(a)._forceRed(this);
                    };
                    Red.prototype.add = function add(a, b) {
                        this._verify2(a, b);
                        var res = a.add(b);
                        if (res.cmp(this.m) >= 0) res.isub(this.m);
                        return res._forceRed(this);
                    };
                    Red.prototype.iadd = function iadd(a, b) {
                        this._verify2(a, b);
                        var res = a.iadd(b);
                        if (res.cmp(this.m) >= 0) res.isub(this.m);
                        return res;
                    };
                    Red.prototype.sub = function sub(a, b) {
                        this._verify2(a, b);
                        var res = a.sub(b);
                        if (res.cmpn(0) < 0) res.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Red.prototype.isub = function isub(a, b) {
                        this._verify2(a, b);
                        var res = a.isub(b);
                        if (res.cmpn(0) < 0) res.iadd(this.m);
                        return res;
                    };
                    Red.prototype.shl = function shl(a, num) {
                        this._verify1(a);
                        return this.imod(a.ushln(num));
                    };
                    Red.prototype.imul = function imul(a, b) {
                        this._verify2(a, b);
                        return this.imod(a.imul(b));
                    };
                    Red.prototype.mul = function mul(a, b) {
                        this._verify2(a, b);
                        return this.imod(a.mul(b));
                    };
                    Red.prototype.isqr = function isqr(a) {
                        return this.imul(a, a.clone());
                    };
                    Red.prototype.sqr = function sqr(a) {
                        return this.mul(a, a);
                    };
                    Red.prototype.sqrt = function sqrt(a) {
                        if (a.isZero()) return a.clone();
                        var mod3 = this.m.andln(3);
                        assert(mod3 % 2 === 1);
                        // Fast case
                        if (mod3 === 3) {
                            var pow = this.m.add(new BN(1)).iushrn(2);
                            return this.pow(a, pow);
                        }
                        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
                        //
                        // Find Q and S, that Q * 2 ^ S = (P - 1)
                        var q = this.m.subn(1);
                        var s = 0;
                        while(!q.isZero() && q.andln(1) === 0){
                            s++;
                            q.iushrn(1);
                        }
                        assert(!q.isZero());
                        var one = new BN(1).toRed(this);
                        var nOne = one.redNeg();
                        // Find quadratic non-residue
                        // NOTE: Max is such because of generalized Riemann hypothesis.
                        var lpow = this.m.subn(1).iushrn(1);
                        var z = this.m.bitLength();
                        z = new BN(2 * z * z).toRed(this);
                        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
                        var c = this.pow(z, q);
                        var r = this.pow(a, q.addn(1).iushrn(1));
                        var t = this.pow(a, q);
                        var m = s;
                        while(t.cmp(one) !== 0){
                            var tmp = t;
                            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                            assert(i < m);
                            var b = this.pow(c, new BN(1).iushln(m - i - 1));
                            r = r.redMul(b);
                            c = b.redSqr();
                            t = t.redMul(c);
                            m = i;
                        }
                        return r;
                    };
                    Red.prototype.invm = function invm(a) {
                        var inv = a._invmp(this.m);
                        if (inv.negative !== 0) {
                            inv.negative = 0;
                            return this.imod(inv).redNeg();
                        } else return this.imod(inv);
                    };
                    Red.prototype.pow = function pow(a, num) {
                        if (num.isZero()) return new BN(1).toRed(this);
                        if (num.cmpn(1) === 0) return a.clone();
                        var windowSize = 4;
                        var wnd = new Array(1 << windowSize);
                        wnd[0] = new BN(1).toRed(this);
                        wnd[1] = a;
                        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
                        var res = wnd[0];
                        var current = 0;
                        var currentLen = 0;
                        var start = num.bitLength() % 26;
                        if (start === 0) start = 26;
                        for(i = num.length - 1; i >= 0; i--){
                            var word = num.words[i];
                            for(var j = start - 1; j >= 0; j--){
                                var bit = word >> j & 1;
                                if (res !== wnd[0]) res = this.sqr(res);
                                if (bit === 0 && current === 0) {
                                    currentLen = 0;
                                    continue;
                                }
                                current <<= 1;
                                current |= bit;
                                currentLen++;
                                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                                res = this.mul(res, wnd[current]);
                                currentLen = 0;
                                current = 0;
                            }
                            start = 26;
                        }
                        return res;
                    };
                    Red.prototype.convertTo = function convertTo(num) {
                        var r = num.umod(this.m);
                        return r === num ? r.clone() : r;
                    };
                    Red.prototype.convertFrom = function convertFrom(num) {
                        var res = num.clone();
                        res.red = null;
                        return res;
                    };
                    //
                    // Montgomery method engine
                    //
                    BN.mont = function mont(num) {
                        return new Mont(num);
                    };
                    function Mont(m) {
                        Red.call(this, m);
                        this.shift = this.m.bitLength();
                        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
                        this.r = new BN(1).iushln(this.shift);
                        this.r2 = this.imod(this.r.sqr());
                        this.rinv = this.r._invmp(this.m);
                        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
                        this.minv = this.minv.umod(this.r);
                        this.minv = this.r.sub(this.minv);
                    }
                    inherits(Mont, Red);
                    Mont.prototype.convertTo = function convertTo(num) {
                        return this.imod(num.ushln(this.shift));
                    };
                    Mont.prototype.convertFrom = function convertFrom(num) {
                        var r = this.imod(num.mul(this.rinv));
                        r.red = null;
                        return r;
                    };
                    Mont.prototype.imul = function imul(a, b) {
                        if (a.isZero() || b.isZero()) {
                            a.words[0] = 0;
                            a.length = 1;
                            return a;
                        }
                        var t = a.imul(b);
                        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                        var u = t.isub(c).iushrn(this.shift);
                        var res = u;
                        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Mont.prototype.mul = function mul(a, b) {
                        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
                        var t = a.mul(b);
                        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                        var u = t.isub(c).iushrn(this.shift);
                        var res = u;
                        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                        return res._forceRed(this);
                    };
                    Mont.prototype.invm = function invm(a) {
                        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
                        var res = this.imod(a._invmp(this.m).mul(this.r2));
                        return res._forceRed(this);
                    };
                })(module1, this);
            /***/ },
            /***/ 747: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
                /**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
                    "use strict";
                    var root = typeof window === "object" ? window : {};
                    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
                    if (NODE_JS) root = __webpack_require__.g;
                    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module1.exports;
                    var HEX_CHARS = "0123456789abcdef".split("");
                    var SHAKE_PADDING = [
                        31,
                        7936,
                        2031616,
                        520093696
                    ];
                    var KECCAK_PADDING = [
                        1,
                        256,
                        65536,
                        16777216
                    ];
                    var PADDING = [
                        6,
                        1536,
                        393216,
                        100663296
                    ];
                    var SHIFT = [
                        0,
                        8,
                        16,
                        24
                    ];
                    var RC = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ];
                    var BITS = [
                        224,
                        256,
                        384,
                        512
                    ];
                    var SHAKE_BITS = [
                        128,
                        256
                    ];
                    var OUTPUT_TYPES = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array"
                    ];
                    var createOutputMethod = function(bits, padding, outputType) {
                        return function(message) {
                            return new Keccak(bits, padding, bits).update(message)[outputType]();
                        };
                    };
                    var createShakeOutputMethod = function(bits, padding, outputType) {
                        return function(message, outputBits) {
                            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
                        };
                    };
                    var createMethod = function(bits, padding) {
                        var method = createOutputMethod(bits, padding, "hex");
                        method.create = function() {
                            return new Keccak(bits, padding, bits);
                        };
                        method.update = function(message) {
                            return method.create().update(message);
                        };
                        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                            var type = OUTPUT_TYPES[i];
                            method[type] = createOutputMethod(bits, padding, type);
                        }
                        return method;
                    };
                    var createShakeMethod = function(bits, padding) {
                        var method = createShakeOutputMethod(bits, padding, "hex");
                        method.create = function(outputBits) {
                            return new Keccak(bits, padding, outputBits);
                        };
                        method.update = function(message, outputBits) {
                            return method.create(outputBits).update(message);
                        };
                        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                            var type = OUTPUT_TYPES[i];
                            method[type] = createShakeOutputMethod(bits, padding, type);
                        }
                        return method;
                    };
                    var algorithms = [
                        {
                            name: "keccak",
                            padding: KECCAK_PADDING,
                            bits: BITS,
                            createMethod: createMethod
                        },
                        {
                            name: "sha3",
                            padding: PADDING,
                            bits: BITS,
                            createMethod: createMethod
                        },
                        {
                            name: "shake",
                            padding: SHAKE_PADDING,
                            bits: SHAKE_BITS,
                            createMethod: createShakeMethod
                        }
                    ];
                    var methods = {}, methodNames = [];
                    for(var i = 0; i < algorithms.length; ++i){
                        var algorithm = algorithms[i];
                        var bits = algorithm.bits;
                        for(var j = 0; j < bits.length; ++j){
                            var methodName = algorithm.name + "_" + bits[j];
                            methodNames.push(methodName);
                            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
                        }
                    }
                    function Keccak(bits, padding, outputBits) {
                        this.blocks = [];
                        this.s = [];
                        this.padding = padding;
                        this.outputBits = outputBits;
                        this.reset = true;
                        this.block = 0;
                        this.start = 0;
                        this.blockCount = 1600 - (bits << 1) >> 5;
                        this.byteCount = this.blockCount << 2;
                        this.outputBlocks = outputBits >> 5;
                        this.extraBytes = (outputBits & 31) >> 3;
                        for(var i = 0; i < 50; ++i)this.s[i] = 0;
                    }
                    Keccak.prototype.update = function(message) {
                        var notString = typeof message !== "string";
                        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
                        while(index < length){
                            if (this.reset) {
                                this.reset = false;
                                blocks[0] = this.block;
                                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
                            }
                            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
                            else for(i = this.start; index < length && i < byteCount; ++index){
                                code = message.charCodeAt(index);
                                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                                else if (code < 0x800) {
                                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                } else if (code < 0xd800 || code >= 0xe000) {
                                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                } else {
                                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                                }
                            }
                            this.lastByteIndex = i;
                            if (i >= byteCount) {
                                this.start = i - byteCount;
                                this.block = blocks[blockCount];
                                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                                f(s);
                                this.reset = true;
                            } else this.start = i;
                        }
                        return this;
                    };
                    Keccak.prototype.finalize = function() {
                        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
                        blocks[i >> 2] |= this.padding[i & 3];
                        if (this.lastByteIndex === this.byteCount) {
                            blocks[0] = blocks[blockCount];
                            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
                        }
                        blocks[blockCount - 1] |= 0x80000000;
                        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                        f(s);
                    };
                    Keccak.prototype.toString = Keccak.prototype.hex = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var hex = "", block;
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                                block = s[i];
                                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
                            }
                            if (j % blockCount === 0) {
                                f(s);
                                i = 0;
                            }
                        }
                        if (extraBytes) {
                            block = s[i];
                            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
                            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
                            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
                        }
                        return hex;
                    };
                    Keccak.prototype.arrayBuffer = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var bytes = this.outputBits >> 3;
                        var buffer;
                        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
                        else buffer = new ArrayBuffer(bytes);
                        var array = new Uint32Array(buffer);
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
                            if (j % blockCount === 0) f(s);
                        }
                        if (extraBytes) {
                            array[i] = s[i];
                            buffer = buffer.slice(0, bytes);
                        }
                        return buffer;
                    };
                    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
                    Keccak.prototype.digest = Keccak.prototype.array = function() {
                        this.finalize();
                        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
                        var array = [], offset, block;
                        while(j < outputBlocks){
                            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                                offset = j << 2;
                                block = s[i];
                                array[offset] = block & 0xFF;
                                array[offset + 1] = block >> 8 & 0xFF;
                                array[offset + 2] = block >> 16 & 0xFF;
                                array[offset + 3] = block >> 24 & 0xFF;
                            }
                            if (j % blockCount === 0) f(s);
                        }
                        if (extraBytes) {
                            offset = j << 2;
                            block = s[i];
                            if (extraBytes > 0) array[offset] = block & 0xFF;
                            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
                            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
                        }
                        return array;
                    };
                    var f = function(s) {
                        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
                        for(n = 0; n < 48; n += 2){
                            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
                            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
                            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
                            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
                            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
                            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
                            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
                            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
                            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
                            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
                            h = c8 ^ (c2 << 1 | c3 >>> 31);
                            l = c9 ^ (c3 << 1 | c2 >>> 31);
                            s[0] ^= h;
                            s[1] ^= l;
                            s[10] ^= h;
                            s[11] ^= l;
                            s[20] ^= h;
                            s[21] ^= l;
                            s[30] ^= h;
                            s[31] ^= l;
                            s[40] ^= h;
                            s[41] ^= l;
                            h = c0 ^ (c4 << 1 | c5 >>> 31);
                            l = c1 ^ (c5 << 1 | c4 >>> 31);
                            s[2] ^= h;
                            s[3] ^= l;
                            s[12] ^= h;
                            s[13] ^= l;
                            s[22] ^= h;
                            s[23] ^= l;
                            s[32] ^= h;
                            s[33] ^= l;
                            s[42] ^= h;
                            s[43] ^= l;
                            h = c2 ^ (c6 << 1 | c7 >>> 31);
                            l = c3 ^ (c7 << 1 | c6 >>> 31);
                            s[4] ^= h;
                            s[5] ^= l;
                            s[14] ^= h;
                            s[15] ^= l;
                            s[24] ^= h;
                            s[25] ^= l;
                            s[34] ^= h;
                            s[35] ^= l;
                            s[44] ^= h;
                            s[45] ^= l;
                            h = c4 ^ (c8 << 1 | c9 >>> 31);
                            l = c5 ^ (c9 << 1 | c8 >>> 31);
                            s[6] ^= h;
                            s[7] ^= l;
                            s[16] ^= h;
                            s[17] ^= l;
                            s[26] ^= h;
                            s[27] ^= l;
                            s[36] ^= h;
                            s[37] ^= l;
                            s[46] ^= h;
                            s[47] ^= l;
                            h = c6 ^ (c0 << 1 | c1 >>> 31);
                            l = c7 ^ (c1 << 1 | c0 >>> 31);
                            s[8] ^= h;
                            s[9] ^= l;
                            s[18] ^= h;
                            s[19] ^= l;
                            s[28] ^= h;
                            s[29] ^= l;
                            s[38] ^= h;
                            s[39] ^= l;
                            s[48] ^= h;
                            s[49] ^= l;
                            b0 = s[0];
                            b1 = s[1];
                            b32 = s[11] << 4 | s[10] >>> 28;
                            b33 = s[10] << 4 | s[11] >>> 28;
                            b14 = s[20] << 3 | s[21] >>> 29;
                            b15 = s[21] << 3 | s[20] >>> 29;
                            b46 = s[31] << 9 | s[30] >>> 23;
                            b47 = s[30] << 9 | s[31] >>> 23;
                            b28 = s[40] << 18 | s[41] >>> 14;
                            b29 = s[41] << 18 | s[40] >>> 14;
                            b20 = s[2] << 1 | s[3] >>> 31;
                            b21 = s[3] << 1 | s[2] >>> 31;
                            b2 = s[13] << 12 | s[12] >>> 20;
                            b3 = s[12] << 12 | s[13] >>> 20;
                            b34 = s[22] << 10 | s[23] >>> 22;
                            b35 = s[23] << 10 | s[22] >>> 22;
                            b16 = s[33] << 13 | s[32] >>> 19;
                            b17 = s[32] << 13 | s[33] >>> 19;
                            b48 = s[42] << 2 | s[43] >>> 30;
                            b49 = s[43] << 2 | s[42] >>> 30;
                            b40 = s[5] << 30 | s[4] >>> 2;
                            b41 = s[4] << 30 | s[5] >>> 2;
                            b22 = s[14] << 6 | s[15] >>> 26;
                            b23 = s[15] << 6 | s[14] >>> 26;
                            b4 = s[25] << 11 | s[24] >>> 21;
                            b5 = s[24] << 11 | s[25] >>> 21;
                            b36 = s[34] << 15 | s[35] >>> 17;
                            b37 = s[35] << 15 | s[34] >>> 17;
                            b18 = s[45] << 29 | s[44] >>> 3;
                            b19 = s[44] << 29 | s[45] >>> 3;
                            b10 = s[6] << 28 | s[7] >>> 4;
                            b11 = s[7] << 28 | s[6] >>> 4;
                            b42 = s[17] << 23 | s[16] >>> 9;
                            b43 = s[16] << 23 | s[17] >>> 9;
                            b24 = s[26] << 25 | s[27] >>> 7;
                            b25 = s[27] << 25 | s[26] >>> 7;
                            b6 = s[36] << 21 | s[37] >>> 11;
                            b7 = s[37] << 21 | s[36] >>> 11;
                            b38 = s[47] << 24 | s[46] >>> 8;
                            b39 = s[46] << 24 | s[47] >>> 8;
                            b30 = s[8] << 27 | s[9] >>> 5;
                            b31 = s[9] << 27 | s[8] >>> 5;
                            b12 = s[18] << 20 | s[19] >>> 12;
                            b13 = s[19] << 20 | s[18] >>> 12;
                            b44 = s[29] << 7 | s[28] >>> 25;
                            b45 = s[28] << 7 | s[29] >>> 25;
                            b26 = s[38] << 8 | s[39] >>> 24;
                            b27 = s[39] << 8 | s[38] >>> 24;
                            b8 = s[48] << 14 | s[49] >>> 18;
                            b9 = s[49] << 14 | s[48] >>> 18;
                            s[0] = b0 ^ ~b2 & b4;
                            s[1] = b1 ^ ~b3 & b5;
                            s[10] = b10 ^ ~b12 & b14;
                            s[11] = b11 ^ ~b13 & b15;
                            s[20] = b20 ^ ~b22 & b24;
                            s[21] = b21 ^ ~b23 & b25;
                            s[30] = b30 ^ ~b32 & b34;
                            s[31] = b31 ^ ~b33 & b35;
                            s[40] = b40 ^ ~b42 & b44;
                            s[41] = b41 ^ ~b43 & b45;
                            s[2] = b2 ^ ~b4 & b6;
                            s[3] = b3 ^ ~b5 & b7;
                            s[12] = b12 ^ ~b14 & b16;
                            s[13] = b13 ^ ~b15 & b17;
                            s[22] = b22 ^ ~b24 & b26;
                            s[23] = b23 ^ ~b25 & b27;
                            s[32] = b32 ^ ~b34 & b36;
                            s[33] = b33 ^ ~b35 & b37;
                            s[42] = b42 ^ ~b44 & b46;
                            s[43] = b43 ^ ~b45 & b47;
                            s[4] = b4 ^ ~b6 & b8;
                            s[5] = b5 ^ ~b7 & b9;
                            s[14] = b14 ^ ~b16 & b18;
                            s[15] = b15 ^ ~b17 & b19;
                            s[24] = b24 ^ ~b26 & b28;
                            s[25] = b25 ^ ~b27 & b29;
                            s[34] = b34 ^ ~b36 & b38;
                            s[35] = b35 ^ ~b37 & b39;
                            s[44] = b44 ^ ~b46 & b48;
                            s[45] = b45 ^ ~b47 & b49;
                            s[6] = b6 ^ ~b8 & b0;
                            s[7] = b7 ^ ~b9 & b1;
                            s[16] = b16 ^ ~b18 & b10;
                            s[17] = b17 ^ ~b19 & b11;
                            s[26] = b26 ^ ~b28 & b20;
                            s[27] = b27 ^ ~b29 & b21;
                            s[36] = b36 ^ ~b38 & b30;
                            s[37] = b37 ^ ~b39 & b31;
                            s[46] = b46 ^ ~b48 & b40;
                            s[47] = b47 ^ ~b49 & b41;
                            s[8] = b8 ^ ~b0 & b2;
                            s[9] = b9 ^ ~b1 & b3;
                            s[18] = b18 ^ ~b10 & b12;
                            s[19] = b19 ^ ~b11 & b13;
                            s[28] = b28 ^ ~b20 & b22;
                            s[29] = b29 ^ ~b21 & b23;
                            s[38] = b38 ^ ~b30 & b32;
                            s[39] = b39 ^ ~b31 & b33;
                            s[48] = b48 ^ ~b40 & b42;
                            s[49] = b49 ^ ~b41 & b43;
                            s[0] ^= RC[n];
                            s[1] ^= RC[n + 1];
                        }
                    };
                    if (COMMON_JS) module1.exports = methods;
                    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
                })();
            /***/ },
            /***/ 6462: /***/ (__unused_webpack_module, exports)=>{
                "use strict";
                var __webpack_unused_export__;
                __webpack_unused_export__ = {
                    value: true
                };
                /**
 * convert the given Scheme into a Rule that allows undefined value
 * @param scheme the scheme
 */ function optional(scheme) {
                    return (value, context)=>{
                        if (value !== undefined) validate(value, scheme, context);
                        return "";
                    };
                }
                exports.jt = optional;
                /**
 * convert the given Scheme into a Rule that allows null value
 * @param scheme the scheme
 */ function nullable(scheme) {
                    return (value, context)=>{
                        if (value !== null) validate(value, scheme, context);
                        return "";
                    };
                }
                exports.AG = nullable;
                /** Validator class */ class Validator {
                    constructor(scheme){
                        this.scheme = scheme;
                    }
                    test(value, context) {
                        return validate(value, this.scheme, context);
                    }
                }
                __webpack_unused_export__ = Validator;
                /** Error class describes validation error */ class ValidationError extends Error {
                    constructor(rawMessage, context){
                        super(context ? `${context}: ${rawMessage}` : rawMessage);
                        this.rawMessage = rawMessage;
                        this.context = context;
                    }
                }
                exports.p8 = ValidationError;
                ValidationError.prototype.name = "ValidationError";
                /**
 * direct function to validate value without construct Validator object
 * @param value value to be validated
 * @param scheme scheme
 * @param context context string appears in error object
 */ function validate(value, scheme, context) {
                    if (Array.isArray(scheme)) {
                        if (!Array.isArray(value)) throw new ValidationError("expected array", context || "");
                        value.forEach((el, i)=>validate(el, scheme[0], context ? `${context}.#${i}` : `#${i}`));
                    } else if (scheme instanceof Function) {
                        const errMsg = scheme(value, context);
                        if (errMsg) throw new ValidationError(errMsg, context || "");
                    } else {
                        if (!(value instanceof Object)) throw new ValidationError("expected object", context || "");
                        for(const key in scheme)if (scheme.hasOwnProperty(key)) validate(value[key], scheme[key], context ? `${context}.${key}` : key);
                    }
                    return value;
                }
                exports.Gu = validate;
            //# sourceMappingURL=data:application/json;base64,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
            /***/ },
            /***/ 2574: /***/ ()=>{
            /* (ignored) */ /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ id: moduleId,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ (()=>{
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = (module1)=>{
                /******/ var getter = module1 && module1.__esModule ? /******/ ()=>module1["default"] : /******/ ()=>module1;
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/global */ /******/ (()=>{
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === "object") return globalThis;
                /******/ try {
                    /******/ return this || new Function("return this")();
                /******/ } catch (e) {
                    /******/ if (typeof window === "object") return window;
                /******/ }
            /******/ }();
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/node module decorator */ /******/ (()=>{
            /******/ __webpack_require__.nmd = (module1)=>{
                /******/ module1.paths = [];
                /******/ if (!module1.children) module1.children = [];
                /******/ return module1;
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(280);
    /******/ })();
});

},{"6afa0553e9bd9d1f":"5QIF0"}],"h0I6K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENGINE_CONTEXT", ()=>ce);
parcelHelpers.export(exports, "ENGINE_QUEUE_STATES", ()=>I);
parcelHelpers.export(exports, "ENGINE_RPC_OPTS", ()=>V);
parcelHelpers.export(exports, "HISTORY_CONTEXT", ()=>ts);
parcelHelpers.export(exports, "HISTORY_EVENTS", ()=>ss);
parcelHelpers.export(exports, "HISTORY_STORAGE_VERSION", ()=>is);
parcelHelpers.export(exports, "METHODS_TO_VERIFY", ()=>pe);
parcelHelpers.export(exports, "PROPOSAL_CONTEXT", ()=>ne);
parcelHelpers.export(exports, "PROPOSAL_EXPIRY", ()=>rs);
parcelHelpers.export(exports, "PROPOSAL_EXPIRY_MESSAGE", ()=>oe);
parcelHelpers.export(exports, "REQUEST_CONTEXT", ()=>le);
parcelHelpers.export(exports, "SESSION_CONTEXT", ()=>ae);
parcelHelpers.export(exports, "SESSION_EXPIRY", ()=>A);
parcelHelpers.export(exports, "SESSION_REQUEST_EXPIRY_BOUNDARIES", ()=>U);
parcelHelpers.export(exports, "SIGN_CLIENT_CONTEXT", ()=>H);
parcelHelpers.export(exports, "SIGN_CLIENT_DEFAULT", ()=>M);
parcelHelpers.export(exports, "SIGN_CLIENT_EVENTS", ()=>Ze);
parcelHelpers.export(exports, "SIGN_CLIENT_PROTOCOL", ()=>X);
parcelHelpers.export(exports, "SIGN_CLIENT_STORAGE_OPTIONS", ()=>es);
parcelHelpers.export(exports, "SIGN_CLIENT_STORAGE_PREFIX", ()=>G);
parcelHelpers.export(exports, "SIGN_CLIENT_VERSION", ()=>F);
parcelHelpers.export(exports, "SignClient", ()=>gs);
parcelHelpers.export(exports, "WALLETCONNECT_DEEPLINK_CHOICE", ()=>W);
parcelHelpers.export(exports, "default", ()=>Q);
var _core = require("@walletconnect/core");
var _logger = require("@walletconnect/logger");
var _types = require("@walletconnect/types");
var _utils = require("@walletconnect/utils");
var _events = require("events");
var _eventsDefault = parcelHelpers.interopDefault(_events);
var _time = require("@walletconnect/time");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
const X = "wc", F = 2, H = "client", G = `${X}@${F}:${H}:`, M = {
    name: H,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, Ze = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire"
}, es = {
    database: ":memory:"
}, W = "WALLETCONNECT_DEEPLINK_CHOICE", ss = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, ts = "history", is = "0.3", ne = "proposal", rs = (0, _time.THIRTY_DAYS), oe = "Proposal expired", ae = "session", A = (0, _time.SEVEN_DAYS), ce = "engine", V = {
    wc_sessionPropose: {
        req: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, _time.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, _time.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, _time.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, U = {
    min: (0, _time.FIVE_MINUTES),
    max: (0, _time.SEVEN_DAYS)
}, I = {
    idle: "IDLE",
    active: "ACTIVE"
}, le = "request", pe = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var ns = Object.defineProperty, os = Object.defineProperties, as = Object.getOwnPropertyDescriptors, he = Object.getOwnPropertySymbols, cs = Object.prototype.hasOwnProperty, ls = Object.prototype.propertyIsEnumerable, de = (m, r, e)=>r in m ? ns(m, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : m[r] = e, g = (m, r)=>{
    for(var e in r || (r = {}))cs.call(r, e) && de(m, e, r[e]);
    if (he) for (var e of he(r))ls.call(r, e) && de(m, e, r[e]);
    return m;
}, b = (m, r)=>os(m, as(r));
class ps extends (0, _types.IEngine) {
    constructor(r){
        super(r), this.name = ce, this.events = new (0, _eventsDefault.default), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, _utils.TYPE_1)
        ], this.requestQueue = {
            state: I.idle,
            queue: []
        }, this.sessionRequestQueue = {
            state: I.idle,
            queue: []
        }, this.requestQueueDelay = (0, _time.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.registerPairingEvents(), this.client.core.pairing.register({
                methods: Object.keys(V)
            }), this.initialized = !0, setTimeout(()=>{
                this.sessionRequestQueue.queue = this.getPendingSessionRequests(), this.processSessionRequestQueue();
            }, (0, _time.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            await this.isInitialized();
            const s = b(g({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let c = t, p, d = !1;
            if (c && (d = this.client.core.pairing.pairings.get(c).active), !c || !d) {
                const { topic: v, uri: S } = await this.client.core.pairing.create();
                c = v, p = S;
            }
            const h = await this.client.core.crypto.generateKeyPair(), R = g({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, _core.RELAYER_DEFAULT_PROTOCOL)
                    }
                ],
                proposer: {
                    publicKey: h,
                    metadata: this.client.metadata
                }
            }, o && {
                sessionProperties: o
            }), { reject: w, resolve: T, done: K } = (0, _utils.createDelayedPromise)((0, _time.FIVE_MINUTES), oe);
            if (this.events.once((0, _utils.engineEvent)("session_connect"), async ({ error: v, session: S })=>{
                if (v) w(v);
                else if (S) {
                    S.self.publicKey = h;
                    const B = b(g({}, S), {
                        requiredNamespaces: S.requiredNamespaces,
                        optionalNamespaces: S.optionalNamespaces
                    });
                    await this.client.session.set(S.topic, B), await this.setExpiry(S.topic, S.expiry), c && await this.client.core.pairing.updateMetadata({
                        topic: c,
                        metadata: S.peer.metadata
                    }), T(B);
                }
            }), !c) {
                const { message: v } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `connect() pairing topic: ${c}`);
                throw new Error(v);
            }
            const L = await this.sendRequest({
                topic: c,
                method: "wc_sessionPropose",
                params: R
            }), ue = (0, _utils.calcExpiry)((0, _time.FIVE_MINUTES));
            return await this.setProposal(L, g({
                id: L,
                expiry: ue
            }, R)), {
                uri: p,
                approval: K
            };
        }, this.pair = async (e)=>(await this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            await this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: c, requiredNamespaces: p, optionalNamespaces: d } = o;
            a = a || "", (0, _utils.isValidObject)(p) || (p = (0, _utils.getRequiredNamespacesFromNamespaces)(i, "approve()"));
            const h = await this.client.core.crypto.generateKeyPair(), R = c.publicKey, w = await this.client.core.crypto.generateSharedKey(h, R);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: c.metadata
            }), await this.sendResult({
                id: s,
                topic: a,
                result: {
                    relay: {
                        protocol: t ?? "irn"
                    },
                    responderPublicKey: h
                }
            }), await this.client.proposal.delete(s, (0, _utils.getSdkError)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const T = g({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                requiredNamespaces: p,
                optionalNamespaces: d,
                pairingTopic: a,
                controller: {
                    publicKey: h,
                    metadata: this.client.metadata
                },
                expiry: (0, _utils.calcExpiry)(A)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(w), await this.sendRequest({
                topic: w,
                method: "wc_sessionSettle",
                params: T,
                throwOnFailedPublish: !0
            });
            const K = b(g({}, T), {
                topic: w,
                pairingTopic: a,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                },
                controller: h
            });
            return await this.client.session.set(w, K), await this.setExpiry(w, (0, _utils.calcExpiry)(A)), {
                topic: w,
                acknowledged: ()=>new Promise((L)=>setTimeout(()=>L(this.client.session.get(w)), 500))
            };
        }, this.reject = async (e)=>{
            await this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, _utils.getSdkError)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            await this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest({
                topic: s,
                method: "wc_sessionUpdate",
                params: {
                    namespaces: t
                }
            }), { done: n, resolve: o, reject: a } = (0, _utils.createDelayedPromise)();
            return this.events.once((0, _utils.engineEvent)("session_update", i), ({ error: c })=>{
                c ? a(c) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            await this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest({
                topic: s,
                method: "wc_sessionExtend",
                params: {}
            }), { done: i, resolve: n, reject: o } = (0, _utils.createDelayedPromise)();
            return this.events.once((0, _utils.engineEvent)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, _utils.calcExpiry)(A)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            await this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n } = e, o = (0, _jsonrpcUtils.payloadId)(), { done: a, resolve: c, reject: p } = (0, _utils.createDelayedPromise)(n, "Request expired. Please try again.");
            return this.events.once((0, _utils.engineEvent)("session_request", o), ({ error: d, result: h })=>{
                d ? p(d) : c(h);
            }), await Promise.all([
                new Promise(async (d)=>{
                    await this.sendRequest({
                        clientRpcId: o,
                        topic: i,
                        method: "wc_sessionRequest",
                        params: {
                            request: t,
                            chainId: s
                        },
                        expiry: n,
                        throwOnFailedPublish: !0
                    }).catch((h)=>p(h)), this.client.events.emit("session_request_sent", {
                        topic: i,
                        request: t,
                        chainId: s,
                        id: o
                    }), d();
                }),
                new Promise(async (d)=>{
                    const h = await this.client.core.storage.getItem(W);
                    (0, _utils.handleDeeplinkRedirect)({
                        id: o,
                        topic: i,
                        wcDeepLink: h
                    }), d();
                }),
                a()
            ]).then((d)=>d[2]);
        }, this.respond = async (e)=>{
            await this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, _jsonrpcUtils.isJsonRpcResult)(t) ? await this.sendResult({
                id: i,
                topic: s,
                result: t.result,
                throwOnFailedPublish: !0
            }) : (0, _jsonrpcUtils.isJsonRpcError)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            await this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest({
                    topic: s,
                    method: "wc_sessionPing",
                    params: {}
                }), { done: i, resolve: n, reject: o } = (0, _utils.createDelayedPromise)();
                this.events.once((0, _utils.engineEvent)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            await this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest({
                topic: s,
                method: "wc_sessionEvent",
                params: {
                    event: t,
                    chainId: i
                }
            });
        }, this.disconnect = async (e)=>{
            await this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            this.client.session.keys.includes(s) ? (await this.sendRequest({
                topic: s,
                method: "wc_sessionDelete",
                params: (0, _utils.getSdkError)("USER_DISCONNECTED"),
                throwOnFailedPublish: !0
            }), await this.deleteSession(s)) : await this.client.core.pairing.disconnect({
                topic: s
            });
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, _utils.isSessionCompatible)(s, e))), this.getPendingSessionRequests = ()=>(this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e, s)=>{
            const { self: t } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), this.client.session.delete(e, (0, _utils.getSdkError)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(t.publicKey) && await this.client.core.crypto.deleteKeyPair(t.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), s || this.client.core.expirer.del(e), this.client.core.storage.removeItem(W).catch((i)=>this.client.logger.warn(i));
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, _utils.getSdkError)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.sessionRequestQueue.queue = this.sessionRequestQueue.queue.filter((i)=>i.id !== e), t && (this.sessionRequestQueue.state = I.idle);
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, s.expiry);
        }, this.setPendingSessionRequest = async (e)=>{
            const s = V.wc_sessionRequest.req.ttl, { id: t, topic: i, params: n, verifyContext: o } = e;
            await this.client.pendingRequest.set(t, {
                id: t,
                topic: i,
                params: n,
                verifyContext: o
            }), s && this.client.core.expirer.set(t, (0, _utils.calcExpiry)(s));
        }, this.sendRequest = async (e)=>{
            const { topic: s, method: t, params: i, expiry: n, relayRpcId: o, clientRpcId: a, throwOnFailedPublish: c } = e, p = (0, _jsonrpcUtils.formatJsonRpcRequest)(t, i, a);
            if ((0, _utils.isBrowser)() && pe.includes(t)) {
                const R = (0, _utils.hashMessage)(JSON.stringify(p));
                this.client.core.verify.register({
                    attestationId: R
                });
            }
            const d = await this.client.core.crypto.encode(s, p), h = V[t].req;
            return n && (h.ttl = n), o && (h.id = o), this.client.core.history.set(s, p), c ? (h.internal = b(g({}, h.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(s, d, h)) : this.client.core.relayer.publish(s, d, h).catch((R)=>this.client.logger.error(R)), p.id;
        }, this.sendResult = async (e)=>{
            const { id: s, topic: t, result: i, throwOnFailedPublish: n } = e, o = (0, _jsonrpcUtils.formatJsonRpcResult)(s, i), a = await this.client.core.crypto.encode(t, o), c = await this.client.core.history.get(t, s), p = V[c.request.method].res;
            n ? (p.internal = b(g({}, p.internal), {
                throwOnFailedPublish: !0
            }), await this.client.core.relayer.publish(t, a, p)) : this.client.core.relayer.publish(t, a, p).catch((d)=>this.client.logger.error(d)), await this.client.core.history.resolve(o);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, _jsonrpcUtils.formatJsonRpcError)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = V[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                (0, _utils.isExpired)(t.expiry) && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, _utils.isExpired)(t.expiry) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession(t)),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = async (e)=>{
            this.requestQueue.queue.push(e), await this.processRequestsQueue();
        }, this.processRequestsQueue = async ()=>{
            if (this.requestQueue.state === I.active) {
                this.client.logger.info("Request queue already active, skipping...");
                return;
            }
            for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`); this.requestQueue.queue.length > 0;){
                this.requestQueue.state = I.active;
                const e = this.requestQueue.queue.shift();
                if (e) try {
                    this.processRequest(e), await new Promise((s)=>setTimeout(s, 300));
                } catch (s) {
                    this.client.logger.warn(s);
                }
            }
            this.requestQueue.state = I.idle;
        }, this.processRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect(g({}, s.params));
                const n = (0, _utils.calcExpiry)((0, _time.FIVE_MINUTES)), o = g({
                    id: i,
                    pairingTopic: e,
                    expiry: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, _utils.hashMessage)(JSON.stringify(s)), c = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: c
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, _jsonrpcUtils.isJsonRpcResult)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const c = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: c
                });
                const p = await this.client.core.relayer.subscribe(c);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: p
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, _jsonrpcUtils.isJsonRpcError)(s) && (await this.client.proposal.delete(t, (0, _utils.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, _utils.engineEvent)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: c, requiredNamespaces: p, optionalNamespaces: d, sessionProperties: h, pairingTopic: R } = s.params, w = g({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: c,
                    acknowledged: !0,
                    pairingTopic: R,
                    requiredNamespaces: p,
                    optionalNamespaces: d,
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, h && {
                    sessionProperties: h
                });
                await this.sendResult({
                    id: s.id,
                    topic: e,
                    result: !0
                }), this.events.emit((0, _utils.engineEvent)("session_connect"), {
                    session: w
                }), this.cleanupDuplicatePairings(w);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, _jsonrpcUtils.isJsonRpcResult)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, _utils.engineEvent)("session_approve", t), {})) : (0, _jsonrpcUtils.isJsonRpcError)(s) && (await this.client.session.delete(e, (0, _utils.getSdkError)("USER_DISCONNECTED")), this.events.emit((0, _utils.engineEvent)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                const n = `${e}_session_update`, o = (0, _utils.MemoryStore).get(n);
                if (o && this.isRequestOutOfSync(o, i)) {
                    this.client.logger.info(`Discarding out of sync request - ${i}`);
                    return;
                }
                this.isValidUpdate(g({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult({
                    id: i,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                }), (0, _utils.MemoryStore).set(n, i);
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.isRequestOutOfSync = (e, s)=>parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3)), this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, _jsonrpcUtils.isJsonRpcResult)(s) ? this.events.emit((0, _utils.engineEvent)("session_update", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && this.events.emit((0, _utils.engineEvent)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, _utils.calcExpiry)(A)), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, _jsonrpcUtils.isJsonRpcResult)(s) ? this.events.emit((0, _utils.engineEvent)("session_extend", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && this.events.emit((0, _utils.engineEvent)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult({
                    id: t,
                    topic: e,
                    result: !0
                }), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, _jsonrpcUtils.isJsonRpcResult)(s) ? this.events.emit((0, _utils.engineEvent)("session_ping", t), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && this.events.emit((0, _utils.engineEvent)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, _core.RELAYER_EVENTS).publish, async ()=>{
                            i(await this.deleteSession(e));
                        });
                    }),
                    this.sendResult({
                        id: t,
                        topic: e,
                        result: !0
                    })
                ]), this.client.events.emit("session_delete", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest(g({
                    topic: e
                }, i));
                const n = (0, _utils.hashMessage)(JSON.stringify((0, _jsonrpcUtils.formatJsonRpcRequest)("wc_sessionRequest", i, t))), o = this.client.session.get(e), a = await this.getVerifyContext(n, o.peer.metadata), c = {
                    id: t,
                    topic: e,
                    params: i,
                    verifyContext: a
                };
                await this.setPendingSessionRequest(c), this.addSessionRequestToSessionRequestQueue(c), this.processSessionRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, _jsonrpcUtils.isJsonRpcResult)(s) ? this.events.emit((0, _utils.engineEvent)("session_request", t), {
                result: s.result
            }) : (0, _jsonrpcUtils.isJsonRpcError)(s) && this.events.emit((0, _utils.engineEvent)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                const n = `${e}_session_event_${i.event.name}`, o = (0, _utils.MemoryStore).get(n);
                if (o && this.isRequestOutOfSync(o, t)) {
                    this.client.logger.info(`Discarding out of sync request - ${t}`);
                    return;
                }
                this.isValidEmit(g({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                }), (0, _utils.MemoryStore).set(n, t);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addSessionRequestToSessionRequestQueue = (e)=>{
            this.sessionRequestQueue.queue.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.sessionRequestQueue.state = I.idle, this.processSessionRequestQueue();
            }, (0, _time.toMiliseconds)(this.requestQueueDelay));
        }, this.processSessionRequestQueue = ()=>{
            if (this.sessionRequestQueue.state === I.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.sessionRequestQueue.queue[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                this.sessionRequestQueue.state = I.active, this.client.events.emit("session_request", e);
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.onPairingCreated = (e)=>{
            if (e.active) return;
            const s = this.client.proposal.getAll().find((t)=>t.pairingTopic === e.topic);
            s && this.onSessionProposeRequest(e.topic, (0, _jsonrpcUtils.formatJsonRpcRequest)("wc_sessionPropose", {
                requiredNamespaces: s.requiredNamespaces,
                optionalNamespaces: s.optionalNamespaces,
                relays: s.relays,
                proposer: s.proposer
            }, s.id));
        }, this.isValidConnect = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, _utils.isUndefined)(s) || await this.isValidPairingTopic(s), !(0, _utils.isValidRelays)(o, !0)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, _utils.isUndefined)(t) && (0, _utils.isValidObject)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, _utils.isUndefined)(i) && (0, _utils.isValidObject)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, _utils.isUndefined)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, _utils.isValidRequiredNamespaces)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) throw new Error((0, _utils.getInternalError)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, _utils.isValidNamespaces)(t, "approve()");
            if (a) throw new Error(a.message);
            const c = (0, _utils.isConformingNamespaces)(o.requiredNamespaces, t, "approve()");
            if (c) throw new Error(c.message);
            if (!(0, _utils.isValidString)(i, !0)) {
                const { message: p } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(p);
            }
            (0, _utils.isUndefined)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: i } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, _utils.isValidErrorReason)(t)) {
                const { message: i } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: c } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(c);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, _utils.isValidRelay)(s)) {
                const { message: c } = (0, _utils.getInternalError)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(c);
            }
            const o = (0, _utils.isValidController)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, _utils.isValidNamespaces)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, _utils.isExpired)(n)) {
                const { message: c } = (0, _utils.getInternalError)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(c);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, _utils.isValidNamespaces)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, _utils.isConformingNamespaces)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: t } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, _utils.isValidNamespacesChainId)(o, i)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, _utils.isValidRequest)(t)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, _utils.isValidNamespacesRequest)(o, i, t.method)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, _utils.isValidRequestExpiry)(n, U)) {
                const { message: a } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${U.min} and ${U.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: i } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(i);
            }
            const { topic: s, response: t } = e;
            if (await this.isValidSessionTopic(s), !(0, _utils.isValidResponse)(t)) {
                const { message: i } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: t } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: o } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, _utils.isValidNamespacesChainId)(n, i)) {
                const { message: o } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, _utils.isValidEvent)(t)) {
                const { message: o } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, _utils.isValidNamespacesEvent)(n, i, t.name)) {
                const { message: o } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, _utils.isValidParams)(e)) {
                const { message: t } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || (0, _core.VERIFY_SERVER),
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.info(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, _utils.isValidString)(t, !1)) {
                    const { message: i } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    async isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
        await this.client.core.relayer.confirmOnlineStateOrThrow();
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, _core.RELAYER_EVENTS).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, _jsonrpcUtils.isJsonRpcRequest)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, _jsonrpcUtils.isJsonRpcResponse)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, _core.EXPIRER_EVENTS).expired, async (r)=>{
            const { topic: e, id: s } = (0, _utils.parseExpirerTarget)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, _utils.getInternalError)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession(e, !0), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    registerPairingEvents() {
        this.client.core.pairing.events.on((0, _core.PAIRING_EVENTS).create, (r)=>this.onPairingCreated(r));
    }
    isValidPairingTopic(r) {
        if (!(0, _utils.isValidString)(r, !1)) {
            const { message: e } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, _utils.isExpired)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, _utils.getInternalError)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, _utils.isValidString)(r, !1)) {
            const { message: e } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, _utils.isExpired)(this.client.session.get(r).expiry)) {
            await this.deleteSession(r);
            const { message: e } = (0, _utils.getInternalError)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, _utils.isValidString)(r, !1)) {
            const { message: e } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, _utils.isValidId)(r)) {
            const { message: e } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, _utils.isExpired)(this.client.proposal.get(r).expiry)) {
            await this.deleteProposal(r);
            const { message: e } = (0, _utils.getInternalError)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class hs extends (0, _core.Store) {
    constructor(r, e){
        super(r, e, ne, G), this.core = r, this.logger = e;
    }
}
class ds extends (0, _core.Store) {
    constructor(r, e){
        super(r, e, ae, G), this.core = r, this.logger = e;
    }
}
class us extends (0, _core.Store) {
    constructor(r, e){
        super(r, e, le, G, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class Q extends (0, _types.ISignClient) {
    constructor(r){
        super(r), this.protocol = X, this.version = F, this.name = M.name, this.events = new (0, _events.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || M.name, this.metadata = r?.metadata || (0, _utils.getAppMetadata)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
            level: r?.logger || M.logger
        }));
        this.core = r?.core || new (0, _core.Core)(r), this.logger = (0, _logger.generateChildLogger)(e, this.name), this.session = new ds(this.core, this.logger), this.proposal = new hs(this.core, this.logger), this.pendingRequest = new us(this.core, this.logger), this.engine = new ps(this);
    }
    static async init(r) {
        const e = new Q(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const gs = Q;

},{"@walletconnect/core":"kCxsS","@walletconnect/logger":"csu9A","@walletconnect/types":"lizQR","@walletconnect/utils":"jCZRI","events":"fqTtD","@walletconnect/time":"gEfho","@walletconnect/jsonrpc-utils":"dUcPw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kCxsS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CORE_CONTEXT", ()=>X);
parcelHelpers.export(exports, "CORE_DEFAULT", ()=>Xe);
parcelHelpers.export(exports, "CORE_PROTOCOL", ()=>ue);
parcelHelpers.export(exports, "CORE_STORAGE_OPTIONS", ()=>Qe);
parcelHelpers.export(exports, "CORE_STORAGE_PREFIX", ()=>O);
parcelHelpers.export(exports, "CORE_VERSION", ()=>We);
parcelHelpers.export(exports, "CRYPTO_CLIENT_SEED", ()=>le);
parcelHelpers.export(exports, "CRYPTO_CONTEXT", ()=>Ze);
parcelHelpers.export(exports, "CRYPTO_JWT_TTL", ()=>et);
parcelHelpers.export(exports, "Core", ()=>Ar);
parcelHelpers.export(exports, "Crypto", ()=>_t);
parcelHelpers.export(exports, "EXPIRER_CONTEXT", ()=>It);
parcelHelpers.export(exports, "EXPIRER_DEFAULT_TTL", ()=>pr);
parcelHelpers.export(exports, "EXPIRER_EVENTS", ()=>v);
parcelHelpers.export(exports, "EXPIRER_STORAGE_VERSION", ()=>Ct);
parcelHelpers.export(exports, "Expirer", ()=>kt);
parcelHelpers.export(exports, "HISTORY_CONTEXT", ()=>wt);
parcelHelpers.export(exports, "HISTORY_EVENTS", ()=>R);
parcelHelpers.export(exports, "HISTORY_STORAGE_VERSION", ()=>vt);
parcelHelpers.export(exports, "JsonRpcHistory", ()=>Mt);
parcelHelpers.export(exports, "KEYCHAIN_CONTEXT", ()=>tt);
parcelHelpers.export(exports, "KEYCHAIN_STORAGE_VERSION", ()=>it);
parcelHelpers.export(exports, "KeyChain", ()=>Rt);
parcelHelpers.export(exports, "MESSAGES_CONTEXT", ()=>st);
parcelHelpers.export(exports, "MESSAGES_STORAGE_VERSION", ()=>rt);
parcelHelpers.export(exports, "MessageTracker", ()=>St);
parcelHelpers.export(exports, "PAIRING_CONTEXT", ()=>ft);
parcelHelpers.export(exports, "PAIRING_DEFAULT_TTL", ()=>gr);
parcelHelpers.export(exports, "PAIRING_EVENTS", ()=>B);
parcelHelpers.export(exports, "PAIRING_RPC_OPTS", ()=>F);
parcelHelpers.export(exports, "PAIRING_STORAGE_VERSION", ()=>Et);
parcelHelpers.export(exports, "PENDING_SUB_RESOLUTION_TIMEOUT", ()=>bt);
parcelHelpers.export(exports, "PUBLISHER_CONTEXT", ()=>at);
parcelHelpers.export(exports, "PUBLISHER_DEFAULT_TTL", ()=>nt);
parcelHelpers.export(exports, "Pairing", ()=>$t);
parcelHelpers.export(exports, "RELAYER_CONTEXT", ()=>ct);
parcelHelpers.export(exports, "RELAYER_DEFAULT_LOGGER", ()=>ht);
parcelHelpers.export(exports, "RELAYER_DEFAULT_PROTOCOL", ()=>ot);
parcelHelpers.export(exports, "RELAYER_DEFAULT_RELAY_URL", ()=>de);
parcelHelpers.export(exports, "RELAYER_EVENTS", ()=>D);
parcelHelpers.export(exports, "RELAYER_FAILOVER_RELAY_URL", ()=>ge);
parcelHelpers.export(exports, "RELAYER_PROVIDER_EVENTS", ()=>T);
parcelHelpers.export(exports, "RELAYER_RECONNECT_TIMEOUT", ()=>lt);
parcelHelpers.export(exports, "RELAYER_SDK_VERSION", ()=>dt);
parcelHelpers.export(exports, "RELAYER_STORAGE_OPTIONS", ()=>lr);
parcelHelpers.export(exports, "RELAYER_SUBSCRIBER_SUFFIX", ()=>ut);
parcelHelpers.export(exports, "RELAYER_TRANSPORT_CUTOFF", ()=>gt);
parcelHelpers.export(exports, "Relayer", ()=>zt);
parcelHelpers.export(exports, "STORE_STORAGE_VERSION", ()=>pt);
parcelHelpers.export(exports, "SUBSCRIBER_CONTEXT", ()=>yt);
parcelHelpers.export(exports, "SUBSCRIBER_DEFAULT_TTL", ()=>dr);
parcelHelpers.export(exports, "SUBSCRIBER_EVENTS", ()=>w);
parcelHelpers.export(exports, "SUBSCRIBER_STORAGE_VERSION", ()=>mt);
parcelHelpers.export(exports, "Store", ()=>Ft);
parcelHelpers.export(exports, "Subscriber", ()=>xt);
parcelHelpers.export(exports, "VERIFY_CONTEXT", ()=>Q);
parcelHelpers.export(exports, "VERIFY_FALLBACK_SERVER", ()=>pe);
parcelHelpers.export(exports, "VERIFY_SERVER", ()=>Z);
parcelHelpers.export(exports, "Verify", ()=>Kt);
parcelHelpers.export(exports, "WALLETCONNECT_CLIENT_ID", ()=>Dt);
parcelHelpers.export(exports, "default", ()=>ee);
var _events = require("events");
var _eventsDefault = parcelHelpers.interopDefault(_events);
var _keyvaluestorage = require("@walletconnect/keyvaluestorage");
var _keyvaluestorageDefault = parcelHelpers.interopDefault(_keyvaluestorage);
var _heartbeat = require("@walletconnect/heartbeat");
var _logger = require("@walletconnect/logger");
var _types = require("@walletconnect/types");
var _safeJson = require("@walletconnect/safe-json");
var _relayAuth = require("@walletconnect/relay-auth");
var _utils = require("@walletconnect/utils");
var _uint8Arrays = require("uint8arrays");
var _time = require("@walletconnect/time");
var _jsonrpcProvider = require("@walletconnect/jsonrpc-provider");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
var _jsonrpcWsConnection = require("@walletconnect/jsonrpc-ws-connection");
var _jsonrpcWsConnectionDefault = parcelHelpers.interopDefault(_jsonrpcWsConnection);
var _lodashIsequal = require("lodash.isequal");
var _lodashIsequalDefault = parcelHelpers.interopDefault(_lodashIsequal);
function Ki(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), a = n.charCodeAt(0);
        if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
        t[a] = s;
    }
    var o = r.length, h = r.charAt(0), u = Math.log(o) / Math.log(256), d = Math.log(256) / Math.log(o);
    function p(c) {
        if (c instanceof Uint8Array || (ArrayBuffer.isView(c) ? c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength) : Array.isArray(c) && (c = Uint8Array.from(c))), !(c instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (c.length === 0) return "";
        for(var m = 0, z = 0, I = 0, _ = c.length; I !== _ && c[I] === 0;)I++, m++;
        for(var S = (_ - I) * d + 1 >>> 0, b = new Uint8Array(S); I !== _;){
            for(var P = c[I], A = 0, C = S - 1; (P !== 0 || A < z) && C !== -1; C--, A++)P += 256 * b[C] >>> 0, b[C] = P % o >>> 0, P = P / o >>> 0;
            if (P !== 0) throw new Error("Non-zero carry");
            z = A, I++;
        }
        for(var x = S - z; x !== S && b[x] === 0;)x++;
        for(var q = h.repeat(m); x < S; ++x)q += r.charAt(b[x]);
        return q;
    }
    function y(c) {
        if (typeof c != "string") throw new TypeError("Expected String");
        if (c.length === 0) return new Uint8Array;
        var m = 0;
        if (c[m] !== " ") {
            for(var z = 0, I = 0; c[m] === h;)z++, m++;
            for(var _ = (c.length - m) * u + 1 >>> 0, S = new Uint8Array(_); c[m];){
                var b = t[c.charCodeAt(m)];
                if (b === 255) return;
                for(var P = 0, A = _ - 1; (b !== 0 || P < I) && A !== -1; A--, P++)b += o * S[A] >>> 0, S[A] = b % 256 >>> 0, b = b / 256 >>> 0;
                if (b !== 0) throw new Error("Non-zero carry");
                I = P, m++;
            }
            if (c[m] !== " ") {
                for(var C = _ - I; C !== _ && S[C] === 0;)C++;
                for(var x = new Uint8Array(z + (_ - C)), q = z; C !== _;)x[q++] = S[C++];
                return x;
            }
        }
    }
    function $(c) {
        var m = y(c);
        if (m) return m;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: p,
        decodeUnsafe: y,
        decode: $
    };
}
var Bi = Ki, Vi = Bi;
const ze = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, qi = (r)=>new TextEncoder().encode(r), ji = (r)=>new TextDecoder().decode(r);
class Yi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class Gi {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return Ne(this, e);
    }
}
class Hi {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return Ne(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const Ne = (r, e)=>new Hi({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class Ji {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new Yi(e, t, i), this.decoder = new Gi(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const W = ({ name: r, prefix: e, encode: t, decode: i })=>new Ji(r, e, t, i), K = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = Vi(t, e);
    return W({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>ze(s(n))
    });
}, Wi = (r, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const a = new Uint8Array(n * t / 8 | 0);
    let o = 0, h = 0, u = 0;
    for(let d = 0; d < n; ++d){
        const p = s[r[d]];
        if (p === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | p, o += t, o >= 8 && (o -= 8, a[u++] = 255 & h >> o);
    }
    if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
    return a;
}, Xi = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", a = 0, o = 0;
    for(let h = 0; h < r.length; ++h)for(o = o << 8 | r[h], a += 8; a > t;)a -= t, n += e[s & o >> a];
    if (a && (n += e[s & o << t - a]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, g = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>W({
        prefix: e,
        name: r,
        encode (s) {
            return Xi(s, i, t);
        },
        decode (s) {
            return Wi(s, i, t, r);
        }
    }), Qi = W({
    prefix: "\0",
    name: "identity",
    encode: (r)=>ji(r),
    decode: (r)=>qi(r)
});
var Zi = Object.freeze({
    __proto__: null,
    identity: Qi
});
const es = g({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var ts = Object.freeze({
    __proto__: null,
    base2: es
});
const is = g({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var ss = Object.freeze({
    __proto__: null,
    base8: is
});
const rs = K({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var ns = Object.freeze({
    __proto__: null,
    base10: rs
});
const as = g({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), os = g({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var hs = Object.freeze({
    __proto__: null,
    base16: as,
    base16upper: os
});
const cs = g({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), us = g({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), ls = g({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), ds = g({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), gs = g({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), ps = g({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), Ds = g({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), ys = g({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), ms = g({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var bs = Object.freeze({
    __proto__: null,
    base32: cs,
    base32upper: us,
    base32pad: ls,
    base32padupper: ds,
    base32hex: gs,
    base32hexupper: ps,
    base32hexpad: Ds,
    base32hexpadupper: ys,
    base32z: ms
});
const fs = K({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), Es = K({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var ws = Object.freeze({
    __proto__: null,
    base36: fs,
    base36upper: Es
});
const vs = K({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), Is = K({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var Cs = Object.freeze({
    __proto__: null,
    base58btc: vs,
    base58flickr: Is
});
const Rs = g({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), _s = g({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), Ss = g({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), Ps = g({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var Ts = Object.freeze({
    __proto__: null,
    base64: Rs,
    base64pad: _s,
    base64url: Ss,
    base64urlpad: Ps
});
const Le = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), xs = Le.reduce((r, e, t)=>(r[t] = e, r), []), Os = Le.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function As(r) {
    return r.reduce((e, t)=>(e += xs[t], e), "");
}
function zs(r) {
    const e = [];
    for (const t of r){
        const i = Os[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const Ns = W({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: As,
    decode: zs
});
var Ls = Object.freeze({
    __proto__: null,
    base256emoji: Ns
}), Us = Fe, Ue = 128, Fs = 127, $s = ~Fs, Ms = Math.pow(2, 31);
function Fe(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= Ms;)e[t++] = r & 255 | Ue, r /= 128;
    for(; r & $s;)e[t++] = r & 255 | Ue, r >>>= 7;
    return e[t] = r | 0, Fe.bytes = t - i + 1, e;
}
var ks = oe, Ks = 128, $e = 127;
function oe(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, a, o = r.length;
    do {
        if (n >= o) throw oe.bytes = 0, new RangeError("Could not decode varint");
        a = r[n++], t += s < 28 ? (a & $e) << s : (a & $e) * Math.pow(2, s), s += 7;
    }while (a >= Ks);
    return oe.bytes = n - i, t;
}
var Bs = Math.pow(2, 7), Vs = Math.pow(2, 14), qs = Math.pow(2, 21), js = Math.pow(2, 28), Ys = Math.pow(2, 35), Gs = Math.pow(2, 42), Hs = Math.pow(2, 49), Js = Math.pow(2, 56), Ws = Math.pow(2, 63), Xs = function(r) {
    return r < Bs ? 1 : r < Vs ? 2 : r < qs ? 3 : r < js ? 4 : r < Ys ? 5 : r < Gs ? 6 : r < Hs ? 7 : r < Js ? 8 : r < Ws ? 9 : 10;
}, Qs = {
    encode: Us,
    decode: ks,
    encodingLength: Xs
}, Me = Qs;
const ke = (r, e, t = 0)=>(Me.encode(r, e, t), e), Ke = (r)=>Me.encodingLength(r), he = (r, e)=>{
    const t = e.byteLength, i = Ke(r), s = i + Ke(t), n = new Uint8Array(s + t);
    return ke(r, n, 0), ke(t, n, i), n.set(e, s), new Zs(r, t, e, n);
};
class Zs {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const Be = ({ name: r, code: e, encode: t })=>new er(r, e, t);
class er {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? he(this.code, t) : t.then((i)=>he(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const Ve = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), tr = Be({
    name: "sha2-256",
    code: 18,
    encode: Ve("SHA-256")
}), ir = Be({
    name: "sha2-512",
    code: 19,
    encode: Ve("SHA-512")
});
var sr = Object.freeze({
    __proto__: null,
    sha256: tr,
    sha512: ir
});
const qe = 0, rr = "identity", je = ze, nr = (r)=>he(qe, je(r)), ar = {
    code: qe,
    name: rr,
    encode: je,
    digest: nr
};
var or = Object.freeze({
    __proto__: null,
    identity: ar
});
new TextEncoder, new TextDecoder;
const Ye = {
    ...Zi,
    ...ts,
    ...ss,
    ...ns,
    ...hs,
    ...bs,
    ...ws,
    ...Cs,
    ...Ts,
    ...Ls
};
({
    ...sr,
    ...or
});
function Ge(r) {
    return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function hr(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? Ge(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function He(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const Je = He("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), ce = He("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = hr(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), cr = {
    utf8: Je,
    "utf-8": Je,
    hex: Ye.base16,
    latin1: ce,
    ascii: ce,
    binary: ce,
    ...Ye
};
function ur(r, e = "utf8") {
    const t = cr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? Ge(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode(`${t.prefix}${r}`);
}
const ue = "wc", We = 2, X = "core", O = `${ue}@2:${X}:`, Xe = {
    name: X,
    logger: "error"
}, Qe = {
    database: ":memory:"
}, Ze = "crypto", le = "client_ed25519_seed", et = (0, _time.ONE_DAY), tt = "keychain", it = "0.3", st = "messages", rt = "0.3", nt = (0, _time.SIX_HOURS), at = "publisher", ot = "irn", ht = "error", de = "wss://relay.walletconnect.com", ge = "wss://relay.walletconnect.org", ct = "relayer", D = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, ut = "_subscription", T = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, lt = (0, _time.ONE_SECOND), lr = {
    database: ":memory:"
}, dt = "2.10.2", gt = 1e4, pt = "0.3", Dt = "WALLETCONNECT_CLIENT_ID", w = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, dr = (0, _time.THIRTY_DAYS), yt = "subscription", mt = "0.3", bt = (0, _time.FIVE_SECONDS) * 1e3, ft = "pairing", Et = "0.3", gr = (0, _time.THIRTY_DAYS), F = {
    wc_pairingDelete: {
        req: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, _time.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, _time.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, _time.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, B = {
    create: "pairing_create",
    expire: "pairing_expire",
    delete: "pairing_delete",
    ping: "pairing_ping"
}, R = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, wt = "history", vt = "0.3", It = "expirer", v = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, Ct = "0.3", pr = (0, _time.ONE_DAY), Q = "verify-api", Z = "https://verify.walletconnect.com", pe = "https://verify.walletconnect.org";
class Rt {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = tt, this.version = it, this.initialized = !1, this.storagePrefix = O, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, _utils.mapToObj)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, _utils.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class _t {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = Ze, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = _relayAuth.generateKeyPair(s);
            return _relayAuth.encodeIss(n.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, _utils.generateKeyPair)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), a = _relayAuth.generateKeyPair(n), o = (0, _utils.generateRandomBytes32)(), h = et;
            return await _relayAuth.signJWT(o, s, h, a);
        }, this.generateSharedKey = (s, n, a)=>{
            this.isInitialized();
            const o = this.getPrivateKey(s), h = (0, _utils.deriveSymKey)(o, n);
            return this.setSymKey(h, a);
        }, this.setSymKey = async (s, n)=>{
            this.isInitialized();
            const a = n || (0, _utils.hashKey)(s);
            return await this.keychain.set(a, s), a;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, _utils.validateEncoding)(a), h = (0, _safeJson.safeJsonStringify)(n);
            if ((0, _utils.isTypeOneEnvelope)(o)) {
                const y = o.senderPublicKey, $ = o.receiverPublicKey;
                s = await this.generateSharedKey(y, $);
            }
            const u = this.getSymKey(s), { type: d, senderPublicKey: p } = o;
            return (0, _utils.encrypt)({
                type: d,
                symKey: u,
                message: h,
                senderPublicKey: p
            });
        }, this.decode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, _utils.validateDecoding)(n, a);
            if ((0, _utils.isTypeOneEnvelope)(o)) {
                const h = o.receiverPublicKey, u = o.senderPublicKey;
                s = await this.generateSharedKey(h, u);
            }
            try {
                const h = this.getSymKey(s), u = (0, _utils.decrypt)({
                    symKey: h,
                    encoded: n
                });
                return (0, _safeJson.safeJsonParse)(u);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const n = (0, _utils.deserialize)(s);
            return (0, _utils.decodeTypeByte)(n.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const n = (0, _utils.deserialize)(s);
            return n.senderPublicKey ? (0, _uint8Arrays.toString)(n.senderPublicKey, (0, _utils.BASE16)) : void 0;
        }, this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.keychain = i || new Rt(this.core, this.logger);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get(le);
        } catch  {
            e = (0, _utils.generateRandomBytes32)(), await this.keychain.set(le, e);
        }
        return ur(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class St extends (0, _types.IMessageTracker) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = st, this.version = rt, this.initialized = !1, this.storagePrefix = O, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const n = (0, _utils.hashMessage)(s);
            let a = this.messages.get(i);
            return typeof a > "u" && (a = {}), typeof a[n] < "u" || (a[n] = s, this.messages.set(i, a), await this.persist()), n;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const n = this.get(i), a = (0, _utils.hashMessage)(s);
            return typeof n[a] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, _logger.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, _utils.mapToObj)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, _utils.objToMap)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class Dr extends (0, _types.IPublisher) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, _events.EventEmitter), this.name = at, this.queue = new Map, this.publishTimeout = (0, _time.toMiliseconds)((0, _time.TEN_SECONDS)), this.needsTransportRestart = !1, this.publish = async (i, s, n)=>{
            var a;
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            try {
                const o = n?.ttl || nt, h = (0, _utils.getRelayProtocolName)(n), u = n?.prompt || !1, d = n?.tag || 0, p = n?.id || (0, _jsonrpcUtils.getBigIntRpcId)().toString(), y = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: o,
                        relay: h,
                        prompt: u,
                        tag: d,
                        id: p
                    }
                }, $ = setTimeout(()=>this.queue.set(p, y), this.publishTimeout);
                try {
                    await await (0, _utils.createExpiringPromise)(this.rpcPublish(i, s, o, h, u, d, p), this.publishTimeout, "Failed to publish payload, please try again."), this.removeRequestFromQueue(p), this.relayer.events.emit(D.publish, y);
                } catch (c) {
                    if (this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0, (a = n?.internal) != null && a.throwOnFailedPublish) throw this.removeRequestFromQueue(p), c;
                    return;
                } finally{
                    clearTimeout($);
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: n
                    }
                });
            } catch (o) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(o), o;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, n, a, o) {
        var h, u, d, p;
        const y = {
            method: (0, _utils.getRelayProtocolApi)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: n,
                tag: a
            },
            id: o
        };
        return (0, _utils.isUndefined)((h = y.params) == null ? void 0 : h.prompt) && ((u = y.params) == null || delete u.prompt), (0, _utils.isUndefined)((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    removeRequestFromQueue(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, _heartbeat.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit(D.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on(D.message_ack, (e)=>{
            this.removeRequestFromQueue(e.id.toString());
        });
    }
}
class yr {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var mr = Object.defineProperty, br = Object.defineProperties, fr = Object.getOwnPropertyDescriptors, Pt = Object.getOwnPropertySymbols, Er = Object.prototype.hasOwnProperty, wr = Object.prototype.propertyIsEnumerable, Tt = (r, e, t)=>e in r ? mr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, V = (r, e)=>{
    for(var t in e || (e = {}))Er.call(e, t) && Tt(r, t, e[t]);
    if (Pt) for (var t of Pt(e))wr.call(e, t) && Tt(r, t, e[t]);
    return r;
}, De = (r, e)=>br(r, fr(e));
class xt extends (0, _types.ISubscriber) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new yr, this.events = new (0, _events.EventEmitter), this.name = yt, this.version = mt, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = O, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), this.registerEventListeners(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, _utils.getRelayProtocolName)(s), a = {
                    topic: i,
                    relay: n
                };
                this.pending.set(i, a);
                const o = await this.rpcSubscribe(i, n);
                return this.onSubscribe(o, a), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), o;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>this.topics.includes(i) ? !0 : await new Promise((s, n)=>{
                const a = new (0, _time.Watch);
                a.start(this.pendingSubscriptionWatchLabel);
                const o = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(this.pendingSubscriptionWatchLabel) >= bt && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.relayer.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, _utils.getRelayProtocolName)(i);
            await this.rpcUnsubscribe(e, t, s);
            const n = (0, _utils.getSdkError)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, _utils.getRelayProtocolApi)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, _utils.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(D.connection_stalled);
        }
        return (0, _utils.hashMessage)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, _utils.getRelayProtocolApi)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, _utils.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit(D.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, _utils.getRelayProtocolApi)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, De(V({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, V({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, V({}, t)), this.topicMap.set(t.topic, e), this.events.emit(w.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit(w.deleted, De(V({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit(w.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit(w.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, _utils.isValidArray)(t) && this.onBatchSubscribe(t.map((i, s)=>De(V({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (!this.initialized || this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, _heartbeat.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on(D.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on(D.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on(w.created, async (e)=>{
            const t = w.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on(w.deleted, async (e)=>{
            const t = w.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var vr = Object.defineProperty, Ot = Object.getOwnPropertySymbols, Ir = Object.prototype.hasOwnProperty, Cr = Object.prototype.propertyIsEnumerable, At = (r, e, t)=>e in r ? vr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, Rr = (r, e)=>{
    for(var t in e || (e = {}))Ir.call(e, t) && At(r, t, e[t]);
    if (Ot) for (var t of Ot(e))Cr.call(e, t) && At(r, t, e[t]);
    return r;
};
class zt extends (0, _types.IRelayer) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, _events.EventEmitter), this.name = ct, this.transportExplicitlyClosed = !1, this.initialized = !1, this.connectionAttemptInProgress = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.hasExperiencedNetworkDisruption = !1, this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            try {
                return await this.toEstablishConnection(), await this.provider.request(t);
            } catch (i) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(i), i;
            }
        }, this.onPayloadHandler = (t)=>{
            this.onProviderPayload(t);
        }, this.onConnectHandler = ()=>{
            this.events.emit(D.connect);
        }, this.onDisconnectHandler = ()=>{
            this.onProviderDisconnect();
        }, this.onProviderErrorHandler = (t)=>{
            this.logger.error(t), this.events.emit(D.error, t), this.logger.info("Fatal socket error received, closing transport"), this.transportClose();
        }, this.registerProviderListeners = ()=>{
            this.provider.on(T.payload, this.onPayloadHandler), this.provider.on(T.connect, this.onConnectHandler), this.provider.on(T.disconnect, this.onDisconnectHandler), this.provider.on(T.error, this.onProviderErrorHandler);
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, _logger.generateChildLogger)(e.logger, this.name) : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
            level: e.logger || ht
        })), this.messages = new St(this.logger, e.core), this.subscriber = new xt(this, this.logger), this.publisher = new Dr(this, this.logger), this.relayUrl = e?.relayUrl || de, this.projectId = e.projectId, this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), this.registerEventListeners(), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${ge}...`), await this.restartTransport(ge);
        }
        this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, gt);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        if (s) return s;
        let n;
        const a = (o)=>{
            o.topic === e && (this.subscriber.off(w.created, a), n());
        };
        return await Promise.all([
            new Promise((o)=>{
                n = o, this.subscriber.on(w.created, a);
            }),
            new Promise(async (o)=>{
                s = await this.subscriber.subscribe(e, t), o();
            })
        ]), s;
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, this.hasExperiencedNetworkDisruption && this.connected ? await (0, _utils.createExpiringPromise)(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(()=>this.onProviderDisconnect()) : this.connected && await this.provider.disconnect();
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress) {
            e && e !== this.relayUrl && (this.relayUrl = e, await this.transportClose(), await this.createProvider()), this.connectionAttemptInProgress = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        if (!this.initialized) return t();
                        this.subscriber.once(w.resubscribed, ()=>{
                            t();
                        });
                    }),
                    new Promise(async (t, i)=>{
                        try {
                            await (0, _utils.createExpiringPromise)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`);
                        } catch (s) {
                            i(s);
                            return;
                        }
                        t();
                    })
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.provider.events.emit(T.disconnect);
            } finally{
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
            }
        }
    }
    async restartTransport(e) {
        await this.confirmOnlineStateOrThrow(), !this.connectionAttemptInProgress && (this.relayUrl = e || this.relayUrl, await this.transportClose(), await this.createProvider(), await this.transportOpen());
    }
    async confirmOnlineStateOrThrow() {
        if (!await (0, _utils.isOnline)()) throw new Error("No internet connection detected. Please restart your network and try again.");
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    async createProvider() {
        this.provider.connection && this.unregisterProviderListeners();
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, _jsonrpcProvider.JsonRpcProvider)(new (0, _jsonrpcWsConnectionDefault.default)((0, _utils.formatRelayRpcUrl)({
            sdkVersion: dt,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, _jsonrpcUtils.isJsonRpcRequest)(e)) {
            if (!e.method.endsWith(ut)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace(Rr({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, _jsonrpcUtils.isJsonRpcResponse)(e) && this.events.emit(D.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit(D.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, _jsonrpcUtils.formatJsonRpcResult)(e.id, !0);
        await this.provider.connection.send(t);
    }
    unregisterProviderListeners() {
        this.provider.off(T.payload, this.onPayloadHandler), this.provider.off(T.connect, this.onConnectHandler), this.provider.off(T.disconnect, this.onDisconnectHandler), this.provider.off(T.error, this.onProviderErrorHandler);
    }
    async registerEventListeners() {
        this.events.on(D.connection_stalled, ()=>{
            this.restartTransport().catch((t)=>this.logger.error(t));
        });
        let e = await (0, _utils.isOnline)();
        (0, _utils.subscribeToNetworkChange)(async (t)=>{
            this.initialized && e !== t && (e = t, t ? await this.restartTransport().catch((i)=>this.logger.error(i)) : (this.hasExperiencedNetworkDisruption = !0, await this.transportClose().catch((i)=>this.logger.error(i))));
        });
    }
    onProviderDisconnect() {
        this.events.emit(D.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout(async ()=>{
            await this.restartTransport().catch((e)=>this.logger.error(e));
        }, (0, _time.toMiliseconds)(lt)));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (await this.confirmOnlineStateOrThrow(), !this.connected) {
            if (this.connectionAttemptInProgress) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var _r = Object.defineProperty, Nt = Object.getOwnPropertySymbols, Sr = Object.prototype.hasOwnProperty, Pr = Object.prototype.propertyIsEnumerable, Lt = (r, e, t)=>e in r ? _r(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, Ut = (r, e)=>{
    for(var t in e || (e = {}))Sr.call(e, t) && Lt(r, t, e[t]);
    if (Nt) for (var t of Nt(e))Pr.call(e, t) && Lt(r, t, e[t]);
    return r;
};
class Ft extends (0, _types.IStore) {
    constructor(e, t, i, s = O, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = pt, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((a)=>{
                this.getKey && a !== null && !(0, _utils.isUndefined)(a) ? this.map.set(this.getKey(a), a) : (0, _utils.isProposalStruct)(a) ? this.map.set(a.id, a) : (0, _utils.isSessionStruct)(a) && this.map.set(a.topic, a);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (a, o)=>{
            this.isInitialized(), this.map.has(a) ? await this.update(a, o) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: a,
                value: o
            }), this.map.set(a, o), await this.persist());
        }, this.get = (a)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: a
            }), this.getData(a)), this.getAll = (a)=>(this.isInitialized(), a ? this.values.filter((o)=>Object.keys(a).every((h)=>(0, _lodashIsequalDefault.default)(o[h], a[h]))) : this.values), this.update = async (a, o)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: a,
                update: o
            });
            const h = Ut(Ut({}, this.getData(a)), o);
            this.map.set(a, h), await this.persist();
        }, this.delete = async (a, o)=>{
            this.isInitialized(), this.map.has(a) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: a,
                reason: o
            }), this.map.delete(a), await this.persist());
        }, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $t {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = ft, this.version = Et, this.events = new (0, _eventsDefault.default), this.initialized = !1, this.storagePrefix = O, this.ignoredPayloadTypes = [
            (0, _utils.TYPE_1)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, _utils.generateRandomBytes32)(), s = await this.core.crypto.setSymKey(i), n = (0, _utils.calcExpiry)((0, _time.FIVE_MINUTES)), a = {
                protocol: ot
            }, o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
            }, h = (0, _utils.formatUri)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: a
            });
            return await this.pairings.set(s, o), await this.core.relayer.subscribe(s), this.core.expirer.set(s, n), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: n, relay: a } = (0, _utils.parseUri)(i.uri);
            let o;
            if (this.pairings.keys.includes(s) && (o = this.pairings.get(s), o.active)) throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);
            this.core.crypto.keychain.has(s) || (await this.core.crypto.setSymKey(n, s), await this.core.relayer.subscribe(s, {
                relay: a
            }));
            const h = (0, _utils.calcExpiry)((0, _time.FIVE_MINUTES)), u = {
                topic: s,
                relay: a,
                expiry: h,
                active: !1
            };
            return await this.pairings.set(s, u), this.core.expirer.set(s, h), i.activatePairing && await this.activate({
                topic: s
            }), this.events.emit(B.create, u), u;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, _utils.calcExpiry)((0, _time.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: a, resolve: o, reject: h } = (0, _utils.createDelayedPromise)();
                this.events.once((0, _utils.engineEvent)("pairing_ping", n), ({ error: u })=>{
                    u ? h(u) : o();
                }), await a();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, _utils.getSdkError)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, n)=>{
            const a = (0, _jsonrpcUtils.formatJsonRpcRequest)(s, n), o = await this.core.crypto.encode(i, a), h = F[s].req;
            return this.core.history.set(i, a), this.core.relayer.publish(i, o, h), a.id;
        }, this.sendResult = async (i, s, n)=>{
            const a = (0, _jsonrpcUtils.formatJsonRpcResult)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), u = F[h.request.method].res;
            await this.core.relayer.publish(s, o, u), await this.core.history.resolve(a);
        }, this.sendError = async (i, s, n)=>{
            const a = (0, _jsonrpcUtils.formatJsonRpcError)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), u = F[h.request.method] ? F[h.request.method].res : F.unregistered_method.res;
            await this.core.relayer.publish(s, o, u), await this.core.history.resolve(a);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, _utils.getSdkError)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, _utils.isExpired)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, n);
                default:
                    return this.onUnknownRpcMethodRequest(s, n);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: n } = i, a = (await this.core.history.get(s, n.id)).request.method;
            switch(a){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(a);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit(B.ping, {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, _jsonrpcUtils.isJsonRpcResult)(s) ? this.events.emit((0, _utils.engineEvent)("pairing_ping", n), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && this.events.emit((0, _utils.engineEvent)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit(B.delete, {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: n, method: a } = s;
            try {
                if (this.registeredMethods.includes(a)) return;
                const o = (0, _utils.getSdkError)("WC_METHOD_UNSUPPORTED", a);
                await this.sendError(n, i, o), this.logger.error(o);
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, _utils.getSdkError)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            if (!(0, _utils.isValidParams)(i)) {
                const { message: s } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(s);
            }
            if (!(0, _utils.isValidUrl)(i.uri)) {
                const { message: s } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(s);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, _utils.isValidParams)(i)) {
                const { message: n } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, _utils.isValidParams)(i)) {
                const { message: n } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, _utils.isValidString)(i, !1)) {
                const { message: s } = (0, _utils.getInternalError)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, _utils.isExpired)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, _utils.getInternalError)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.pairings = new Ft(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on(D.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, _jsonrpcUtils.isJsonRpcRequest)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, _jsonrpcUtils.isJsonRpcResponse)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on(v.expired, async (e)=>{
            const { topic: t } = (0, _utils.parseExpirerTarget)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit(B.expire, {
                topic: t
            }));
        });
    }
}
class Mt extends (0, _types.IJsonRpcHistory) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, _events.EventEmitter), this.name = wt, this.version = vt, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const a = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, _utils.calcExpiry)((0, _time.THIRTY_DAYS))
            };
            this.records.set(a.id, a), this.events.emit(R.created, a);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, _jsonrpcUtils.isJsonRpcError)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit(R.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit(R.deleted, n);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, _logger.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, _jsonrpcUtils.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit(R.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on(R.created, (e)=>{
            const t = R.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on(R.updated, (e)=>{
            const t = R.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on(R.deleted, (e)=>{
            const t = R.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, _heartbeat.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, _time.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class kt extends (0, _types.IExpirer) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, _events.EventEmitter), this.name = It, this.version = Ct, this.cached = [], this.initialized = !1, this.storagePrefix = O, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), a = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, a), this.checkExpiry(n, a), this.events.emit(v.created, {
                target: n,
                expiration: a
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit(v.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, _logger.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + this.core.customStoragePrefix + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, _utils.formatTopicTarget)(e);
        if (typeof e == "number") return (0, _utils.formatIdTarget)(e);
        const { message: t } = (0, _utils.getInternalError)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit(v.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, _utils.getInternalError)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, _time.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit(v.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, _heartbeat.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on(v.created, (e)=>{
            const t = v.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on(v.expired, (e)=>{
            const t = v.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on(v.deleted, (e)=>{
            const t = v.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class Kt extends (0, _types.IVerify) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = Q, this.initialized = !1, this.queue = [], this.verifyDisabled = !1, this.init = async ()=>{
            if (this.verifyDisabled || (0, _utils.isReactNative)() || !(0, _utils.isBrowser)()) return;
            const i = Z;
            this.verifyUrl !== i && this.removeIframe(), this.verifyUrl = i;
            try {
                await this.createIframe();
            } catch (s) {
                this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(s);
            }
            if (!this.initialized) {
                this.removeIframe(), this.verifyUrl = pe;
                try {
                    await this.createIframe();
                } catch (s) {
                    this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.info(s), this.verifyDisabled = !0;
                }
            }
        }, this.register = async (i)=>{
            this.initialized ? this.sendPost(i.attestationId) : (this.addToQueue(i.attestationId), await this.init());
        }, this.resolve = async (i)=>{
            if (this.isDevEnv) return "";
            const s = i?.verifyUrl || Z;
            let n;
            try {
                n = await this.fetchAttestation(i.attestationId, s);
            } catch (a) {
                this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`), this.logger.info(a), n = await this.fetchAttestation(i.attestationId, pe);
            }
            return n;
        }, this.fetchAttestation = async (i, s)=>{
            this.logger.info(`resolving attestation: ${i} from url: ${s}`);
            const n = this.startAbortTimer((0, _time.ONE_SECOND) * 2), a = await fetch(`${s}/attestation/${i}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? await a.json() : void 0;
        }, this.addToQueue = (i)=>{
            this.queue.push(i);
        }, this.processQueue = ()=>{
            this.queue.length !== 0 && (this.queue.forEach((i)=>this.sendPost(i)), this.queue = []);
        }, this.sendPost = (i)=>{
            var s;
            try {
                if (!this.iframe) return;
                (s = this.iframe.contentWindow) == null || s.postMessage(i, "*"), this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);
            } catch  {}
        }, this.createIframe = async ()=>{
            let i;
            const s = (n)=>{
                n.data === "verify_ready" && (this.initialized = !0, this.processQueue(), window.removeEventListener("message", s), i());
            };
            await Promise.race([
                new Promise((n)=>{
                    if (document.getElementById(Q)) return n();
                    window.addEventListener("message", s);
                    const a = document.createElement("iframe");
                    a.id = Q, a.src = `${this.verifyUrl}/${this.projectId}`, a.style.display = "none", document.body.append(a), this.iframe = a, i = n;
                }),
                new Promise((n, a)=>setTimeout(()=>{
                        window.removeEventListener("message", s), a("verify iframe load timeout");
                    }, (0, _time.toMiliseconds)((0, _time.FIVE_SECONDS))))
            ]);
        }, this.removeIframe = ()=>{
            this.iframe && (this.iframe.remove(), this.iframe = void 0, this.initialized = !1);
        }, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.verifyUrl = Z, this.abortController = new AbortController, this.isDevEnv = (0, _utils.isNode)() && undefined;
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return this.abortController = new AbortController, setTimeout(()=>this.abortController.abort(), (0, _time.toMiliseconds)(e));
    }
}
var Tr = Object.defineProperty, Bt = Object.getOwnPropertySymbols, xr = Object.prototype.hasOwnProperty, Or = Object.prototype.propertyIsEnumerable, Vt = (r, e, t)=>e in r ? Tr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, qt = (r, e)=>{
    for(var t in e || (e = {}))xr.call(e, t) && Vt(r, t, e[t]);
    if (Bt) for (var t of Bt(e))Or.call(e, t) && Vt(r, t, e[t]);
    return r;
};
class ee extends (0, _types.ICore) {
    constructor(e){
        super(e), this.protocol = ue, this.version = We, this.name = X, this.events = new (0, _events.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || de, this.customStoragePrefix = e != null && e.customStoragePrefix ? `:${e.customStoragePrefix}` : "";
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
            level: e?.logger || Xe.logger
        }));
        this.logger = (0, _logger.generateChildLogger)(t, this.name), this.heartbeat = new (0, _heartbeat.HeartBeat), this.crypto = new _t(this, this.logger, e?.keychain), this.history = new Mt(this, this.logger), this.expirer = new kt(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, _keyvaluestorageDefault.default)(qt(qt({}, Qe), e?.storageOptions)), this.relayer = new zt({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $t(this, this.logger), this.verify = new Kt(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new ee(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem(Dt, i), t;
    }
    get context() {
        return (0, _logger.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const Ar = ee;

},{"events":"fqTtD","@walletconnect/keyvaluestorage":"kVUaR","@walletconnect/heartbeat":"ixJ4A","@walletconnect/logger":"csu9A","@walletconnect/types":"bwv1G","@walletconnect/safe-json":"gaejp","@walletconnect/relay-auth":"jug6O","@walletconnect/utils":"jCZRI","uint8arrays":"lR9lT","@walletconnect/time":"gEfho","@walletconnect/jsonrpc-provider":"fbiL9","@walletconnect/jsonrpc-utils":"dUcPw","@walletconnect/jsonrpc-ws-connection":"8ITsi","lodash.isequal":"eOLCt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVUaR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyValueStorage", ()=>h);
parcelHelpers.export(exports, "default", ()=>h);
var _unstorage = require("unstorage");
var _idbKeyval = require("idb-keyval");
var _safeJson = require("@walletconnect/safe-json");
var global = arguments[3];
function C(i) {
    return i;
}
const x = "idb-keyval";
var z = (i = {})=>{
    const t = i.base && i.base.length > 0 ? `${i.base}:` : "", e = (s)=>t + s;
    let n;
    return i.dbName && i.storeName && (n = (0, _idbKeyval.createStore)(i.dbName, i.storeName)), {
        name: x,
        options: i,
        async hasItem (s) {
            return !(typeof await (0, _idbKeyval.get)(e(s), n) > "u");
        },
        async getItem (s) {
            return await (0, _idbKeyval.get)(e(s), n) ?? null;
        },
        setItem (s, a) {
            return (0, _idbKeyval.set)(e(s), a, n);
        },
        removeItem (s) {
            return (0, _idbKeyval.del)(e(s), n);
        },
        getKeys () {
            return (0, _idbKeyval.keys)(n);
        },
        clear () {
            return (0, _idbKeyval.clear)(n);
        }
    };
};
const D = "WALLET_CONNECT_V2_INDEXED_DB", E = "keyvaluestorage";
class _ {
    constructor(){
        this.indexedDb = (0, _unstorage.createStorage)({
            driver: z({
                dbName: D,
                storeName: E
            })
        });
    }
    async getKeys() {
        return this.indexedDb.getKeys();
    }
    async getEntries() {
        return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map((t)=>[
                t.key,
                t.value
            ]);
    }
    async getItem(t) {
        const e = await this.indexedDb.getItem(t);
        if (e !== null) return e;
    }
    async setItem(t, e) {
        await this.indexedDb.setItem(t, (0, _safeJson.safeJsonStringify)(e));
    }
    async removeItem(t) {
        await this.indexedDb.removeItem(t);
    }
}
var l = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, c = {
    exports: {}
};
(function() {
    let i;
    function t() {}
    i = t, i.prototype.getItem = function(e) {
        return this.hasOwnProperty(e) ? String(this[e]) : null;
    }, i.prototype.setItem = function(e, n) {
        this[e] = String(n);
    }, i.prototype.removeItem = function(e) {
        delete this[e];
    }, i.prototype.clear = function() {
        const e = this;
        Object.keys(e).forEach(function(n) {
            e[n] = void 0, delete e[n];
        });
    }, i.prototype.key = function(e) {
        return e = e || 0, Object.keys(this)[e];
    }, i.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    }), typeof l < "u" && l.localStorage ? c.exports = l.localStorage : typeof window < "u" && window.localStorage ? c.exports = window.localStorage : c.exports = new t;
})();
function k(i) {
    var t;
    return [
        i[0],
        (0, _safeJson.safeJsonParse)((t = i[1]) != null ? t : "")
    ];
}
class K {
    constructor(){
        this.localStorage = c.exports;
    }
    async getKeys() {
        return Object.keys(this.localStorage);
    }
    async getEntries() {
        return Object.entries(this.localStorage).map(k);
    }
    async getItem(t) {
        const e = this.localStorage.getItem(t);
        if (e !== null) return (0, _safeJson.safeJsonParse)(e);
    }
    async setItem(t, e) {
        this.localStorage.setItem(t, (0, _safeJson.safeJsonStringify)(e));
    }
    async removeItem(t) {
        this.localStorage.removeItem(t);
    }
}
const N = "wc_storage_version", y = 1, O = async (i, t, e)=>{
    const n = N, s = await t.getItem(n);
    if (s && s >= y) {
        e(t);
        return;
    }
    const a = await i.getKeys();
    if (!a.length) {
        e(t);
        return;
    }
    const m = [];
    for(; a.length;){
        const r = a.shift();
        if (!r) continue;
        const o = r.toLowerCase();
        if (o.includes("wc@") || o.includes("walletconnect") || o.includes("wc_") || o.includes("wallet_connect")) {
            const f = await i.getItem(r);
            await t.setItem(r, f), m.push(r);
        }
    }
    await t.setItem(n, y), e(t), j(i, m);
}, j = async (i, t)=>{
    t.length && t.forEach(async (e)=>{
        await i.removeItem(e);
    });
};
class h {
    constructor(){
        this.initialized = !1, this.setInitialized = (e)=>{
            this.storage = e, this.initialized = !0;
        };
        const t = new K;
        this.storage = t;
        try {
            const e = new _;
            O(t, e, this.setInitialized);
        } catch  {
            this.initialized = !0;
        }
    }
    async getKeys() {
        return await this.initialize(), this.storage.getKeys();
    }
    async getEntries() {
        return await this.initialize(), this.storage.getEntries();
    }
    async getItem(t) {
        return await this.initialize(), this.storage.getItem(t);
    }
    async setItem(t, e) {
        return await this.initialize(), this.storage.setItem(t, e);
    }
    async removeItem(t) {
        return await this.initialize(), this.storage.removeItem(t);
    }
    async initialize() {
        this.initialized || await new Promise((t)=>{
            const e = setInterval(()=>{
                this.initialized && (clearInterval(e), t());
            }, 20);
        });
    }
}

},{"unstorage":"42rYa","idb-keyval":"2Ms2f","@walletconnect/safe-json":"gaejp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42rYa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixStorage", ()=>(0, _unstorage8581F561Mjs.p));
parcelHelpers.export(exports, "builtinDrivers", ()=>builtinDrivers);
parcelHelpers.export(exports, "createStorage", ()=>createStorage);
parcelHelpers.export(exports, "defineDriver", ()=>defineDriver);
parcelHelpers.export(exports, "joinKeys", ()=>(0, _unstorage8581F561Mjs.j));
parcelHelpers.export(exports, "normalizeBaseKey", ()=>(0, _unstorage8581F561Mjs.n));
parcelHelpers.export(exports, "normalizeKey", ()=>(0, _unstorage8581F561Mjs.a));
parcelHelpers.export(exports, "restoreSnapshot", ()=>restoreSnapshot);
parcelHelpers.export(exports, "snapshot", ()=>snapshot);
var _destr = require("destr");
var _destrDefault = parcelHelpers.interopDefault(_destr);
var _unstorage8581F561Mjs = require("./shared/unstorage.8581f561.mjs");
function defineDriver(factory) {
    return factory;
}
const DRIVER_NAME = "memory";
const memory = defineDriver(()=>{
    const data = /* @__PURE__ */ new Map();
    return {
        name: DRIVER_NAME,
        options: {},
        hasItem (key) {
            return data.has(key);
        },
        getItem (key) {
            return data.get(key) ?? null;
        },
        getItemRaw (key) {
            return data.get(key) ?? null;
        },
        setItem (key, value) {
            data.set(key, value);
        },
        setItemRaw (key, value) {
            data.set(key, value);
        },
        removeItem (key) {
            data.delete(key);
        },
        getKeys () {
            return Array.from(data.keys());
        },
        clear () {
            data.clear();
        },
        dispose () {
            data.clear();
        }
    };
});
function createStorage(options = {}) {
    const context = {
        mounts: {
            "": options.driver || memory()
        },
        mountpoints: [
            ""
        ],
        watching: false,
        watchListeners: [],
        unwatch: {}
    };
    const getMount = (key)=>{
        for (const base of context.mountpoints){
            if (key.startsWith(base)) return {
                base,
                relativeKey: key.slice(base.length),
                driver: context.mounts[base]
            };
        }
        return {
            base: "",
            relativeKey: key,
            driver: context.mounts[""]
        };
    };
    const getMounts = (base, includeParent)=>{
        return context.mountpoints.filter((mountpoint)=>mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)).map((mountpoint)=>({
                relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
                mountpoint,
                driver: context.mounts[mountpoint]
            }));
    };
    const onChange = (event, key)=>{
        if (!context.watching) return;
        key = (0, _unstorage8581F561Mjs.a)(key);
        for (const listener of context.watchListeners)listener(event, key);
    };
    const startWatch = async ()=>{
        if (context.watching) return;
        context.watching = true;
        for(const mountpoint in context.mounts)context.unwatch[mountpoint] = await watch(context.mounts[mountpoint], onChange, mountpoint);
    };
    const stopWatch = async ()=>{
        if (!context.watching) return;
        for(const mountpoint in context.unwatch)await context.unwatch[mountpoint]();
        context.unwatch = {};
        context.watching = false;
    };
    const runBatch = (items, commonOptions, cb)=>{
        const batches = /* @__PURE__ */ new Map();
        const getBatch = (mount)=>{
            let batch = batches.get(mount.base);
            if (!batch) {
                batch = {
                    driver: mount.driver,
                    base: mount.base,
                    items: []
                };
                batches.set(mount.base, batch);
            }
            return batch;
        };
        for (const item of items){
            const isStringItem = typeof item === "string";
            const key = (0, _unstorage8581F561Mjs.a)(isStringItem ? item : item.key);
            const value = isStringItem ? void 0 : item.value;
            const options2 = isStringItem || !item.options ? commonOptions : {
                ...commonOptions,
                ...item.options
            };
            const mount = getMount(key);
            getBatch(mount).items.push({
                key,
                value,
                relativeKey: mount.relativeKey,
                options: options2
            });
        }
        return Promise.all([
            ...batches.values()
        ].map((batch)=>cb(batch))).then((r)=>r.flat());
    };
    const storage = {
        // Item
        hasItem (key, opts = {}) {
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            return (0, _unstorage8581F561Mjs.b)(driver.hasItem, relativeKey, opts);
        },
        getItem (key, opts = {}) {
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            return (0, _unstorage8581F561Mjs.b)(driver.getItem, relativeKey, opts).then((value)=>(0, _destrDefault.default)(value));
        },
        getItems (items, commonOptions) {
            return runBatch(items, commonOptions, (batch)=>{
                if (batch.driver.getItems) return (0, _unstorage8581F561Mjs.b)(batch.driver.getItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        options: item.options
                    })), commonOptions).then((r)=>r.map((item)=>({
                            key: (0, _unstorage8581F561Mjs.j)(batch.base, item.key),
                            value: (0, _destrDefault.default)(item.value)
                        })));
                return Promise.all(batch.items.map((item)=>{
                    return (0, _unstorage8581F561Mjs.b)(batch.driver.getItem, item.relativeKey, item.options).then((value)=>({
                            key: item.key,
                            value: (0, _destrDefault.default)(value)
                        }));
                }));
            });
        },
        getItemRaw (key, opts = {}) {
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            if (driver.getItemRaw) return (0, _unstorage8581F561Mjs.b)(driver.getItemRaw, relativeKey, opts);
            return (0, _unstorage8581F561Mjs.b)(driver.getItem, relativeKey, opts).then((value)=>(0, _unstorage8581F561Mjs.d)(value));
        },
        async setItem (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key);
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            if (!driver.setItem) return;
            await (0, _unstorage8581F561Mjs.b)(driver.setItem, relativeKey, (0, _unstorage8581F561Mjs.s)(value), opts);
            if (!driver.watch) onChange("update", key);
        },
        async setItems (items, commonOptions) {
            await runBatch(items, commonOptions, async (batch)=>{
                if (batch.driver.setItems) return (0, _unstorage8581F561Mjs.b)(batch.driver.setItems, batch.items.map((item)=>({
                        key: item.relativeKey,
                        value: (0, _unstorage8581F561Mjs.s)(item.value),
                        options: item.options
                    })), commonOptions);
                if (!batch.driver.setItem) return;
                await Promise.all(batch.items.map((item)=>{
                    return (0, _unstorage8581F561Mjs.b)(batch.driver.setItem, item.relativeKey, (0, _unstorage8581F561Mjs.s)(item.value), item.options);
                }));
            });
        },
        async setItemRaw (key, value, opts = {}) {
            if (value === void 0) return storage.removeItem(key, opts);
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            if (driver.setItemRaw) await (0, _unstorage8581F561Mjs.b)(driver.setItemRaw, relativeKey, value, opts);
            else if (driver.setItem) await (0, _unstorage8581F561Mjs.b)(driver.setItem, relativeKey, (0, _unstorage8581F561Mjs.c)(value), opts);
            else return;
            if (!driver.watch) onChange("update", key);
        },
        async removeItem (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                removeMeta: opts
            };
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            if (!driver.removeItem) return;
            await (0, _unstorage8581F561Mjs.b)(driver.removeItem, relativeKey, opts);
            if (opts.removeMeta || opts.removeMata) await (0, _unstorage8581F561Mjs.b)(driver.removeItem, relativeKey + "$", opts);
            if (!driver.watch) onChange("remove", key);
        },
        // Meta
        async getMeta (key, opts = {}) {
            if (typeof opts === "boolean") opts = {
                nativeOnly: opts
            };
            key = (0, _unstorage8581F561Mjs.a)(key);
            const { relativeKey, driver } = getMount(key);
            const meta = /* @__PURE__ */ Object.create(null);
            if (driver.getMeta) Object.assign(meta, await (0, _unstorage8581F561Mjs.b)(driver.getMeta, relativeKey, opts));
            if (!opts.nativeOnly) {
                const value = await (0, _unstorage8581F561Mjs.b)(driver.getItem, relativeKey + "$", opts).then((value_)=>(0, _destrDefault.default)(value_));
                if (value && typeof value === "object") {
                    if (typeof value.atime === "string") value.atime = new Date(value.atime);
                    if (typeof value.mtime === "string") value.mtime = new Date(value.mtime);
                    Object.assign(meta, value);
                }
            }
            return meta;
        },
        setMeta (key, value, opts = {}) {
            return this.setItem(key + "$", value, opts);
        },
        removeMeta (key, opts = {}) {
            return this.removeItem(key + "$", opts);
        },
        // Keys
        async getKeys (base, opts = {}) {
            base = (0, _unstorage8581F561Mjs.n)(base);
            const mounts = getMounts(base, true);
            let maskedMounts = [];
            const allKeys = [];
            for (const mount of mounts){
                const rawKeys = await (0, _unstorage8581F561Mjs.b)(mount.driver.getKeys, mount.relativeBase, opts);
                const keys = rawKeys.map((key)=>mount.mountpoint + (0, _unstorage8581F561Mjs.a)(key)).filter((key)=>!maskedMounts.some((p)=>key.startsWith(p)));
                allKeys.push(...keys);
                maskedMounts = [
                    mount.mountpoint,
                    ...maskedMounts.filter((p)=>!p.startsWith(mount.mountpoint))
                ];
            }
            return base ? allKeys.filter((key)=>key.startsWith(base) && !key.endsWith("$")) : allKeys.filter((key)=>!key.endsWith("$"));
        },
        // Utils
        async clear (base, opts = {}) {
            base = (0, _unstorage8581F561Mjs.n)(base);
            await Promise.all(getMounts(base, false).map(async (m)=>{
                if (m.driver.clear) return (0, _unstorage8581F561Mjs.b)(m.driver.clear, m.relativeBase, opts);
                if (m.driver.removeItem) {
                    const keys = await m.driver.getKeys(m.relativeBase || "", opts);
                    return Promise.all(keys.map((key)=>m.driver.removeItem(key, opts)));
                }
            }));
        },
        async dispose () {
            await Promise.all(Object.values(context.mounts).map((driver)=>dispose(driver)));
        },
        async watch (callback) {
            await startWatch();
            context.watchListeners.push(callback);
            return async ()=>{
                context.watchListeners = context.watchListeners.filter((listener)=>listener !== callback);
                if (context.watchListeners.length === 0) await stopWatch();
            };
        },
        async unwatch () {
            context.watchListeners = [];
            await stopWatch();
        },
        // Mount
        mount (base, driver) {
            base = (0, _unstorage8581F561Mjs.n)(base);
            if (base && context.mounts[base]) throw new Error(`already mounted at ${base}`);
            if (base) {
                context.mountpoints.push(base);
                context.mountpoints.sort((a, b)=>b.length - a.length);
            }
            context.mounts[base] = driver;
            if (context.watching) Promise.resolve(watch(driver, onChange, base)).then((unwatcher)=>{
                context.unwatch[base] = unwatcher;
            }).catch(console.error);
            return storage;
        },
        async unmount (base, _dispose = true) {
            base = (0, _unstorage8581F561Mjs.n)(base);
            if (!base || !context.mounts[base]) return;
            if (context.watching && base in context.unwatch) {
                context.unwatch[base]();
                delete context.unwatch[base];
            }
            if (_dispose) await dispose(context.mounts[base]);
            context.mountpoints = context.mountpoints.filter((key)=>key !== base);
            delete context.mounts[base];
        },
        getMount (key = "") {
            key = (0, _unstorage8581F561Mjs.a)(key) + ":";
            const m = getMount(key);
            return {
                driver: m.driver,
                base: m.base
            };
        },
        getMounts (base = "", opts = {}) {
            base = (0, _unstorage8581F561Mjs.a)(base);
            const mounts = getMounts(base, opts.parents);
            return mounts.map((m)=>({
                    driver: m.driver,
                    base: m.mountpoint
                }));
        }
    };
    return storage;
}
async function snapshot(storage, base) {
    base = (0, _unstorage8581F561Mjs.n)(base);
    const keys = await storage.getKeys(base);
    const snapshot2 = {};
    await Promise.all(keys.map(async (key)=>{
        snapshot2[key.slice(base.length)] = await storage.getItem(key);
    }));
    return snapshot2;
}
async function restoreSnapshot(driver, snapshot2, base = "") {
    base = (0, _unstorage8581F561Mjs.n)(base);
    await Promise.all(Object.entries(snapshot2).map((e)=>driver.setItem(base + e[0], e[1])));
}
function watch(driver, onChange, base) {
    return driver.watch ? driver.watch((event, key)=>onChange(event, base + key)) : ()=>{};
}
async function dispose(driver) {
    if (typeof driver.dispose === "function") await (0, _unstorage8581F561Mjs.b)(driver.dispose);
}
const builtinDrivers = {
    azureAppConfiguration: "unstorage/drivers/azure-app-configuration",
    azureCosmos: "unstorage/drivers/azure-cosmos",
    azureKeyVault: "unstorage/drivers/azure-key-vault",
    azureStorageBlob: "unstorage/drivers/azure-storage-blob",
    azureStorageTable: "unstorage/drivers/azure-storage-table",
    cloudflareKVBinding: "unstorage/drivers/cloudflare-kv-binding",
    cloudflareKVHTTP: "unstorage/drivers/cloudflare-kv-http",
    cloudflareR2Binding: "unstorage/drivers/cloudflare-r2-binding",
    fs: "unstorage/drivers/fs",
    fsLite: "unstorage/drivers/fs-lite",
    github: "unstorage/drivers/github",
    http: "unstorage/drivers/http",
    indexedb: "unstorage/drivers/indexedb",
    localStorage: "unstorage/drivers/localstorage",
    lruCache: "unstorage/drivers/lru-cache",
    memory: "unstorage/drivers/memory",
    mongodb: "unstorage/drivers/mongodb",
    netlifyBlobs: "unstorage/drivers/netlify-blobs",
    overlay: "unstorage/drivers/overlay",
    planetscale: "unstorage/drivers/planetscale",
    redis: "unstorage/drivers/redis",
    sessionStorage: "unstorage/drivers/session-storage",
    vercelKV: "unstorage/drivers/vercel-kv",
    /** @deprecated */ "cloudflare-kv-binding": "unstorage/drivers/cloudflare-kv-binding",
    /** @deprecated */ "cloudflare-kv-http": "unstorage/drivers/cloudflare-kv-http"
};

},{"destr":"t2d3m","./shared/unstorage.8581f561.mjs":"am5gV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"t2d3m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>destr);
parcelHelpers.export(exports, "destr", ()=>destr);
parcelHelpers.export(exports, "safeDestr", ()=>safeDestr);
const suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function jsonParseTransform(key, value) {
    if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
        warnKeyDropped(key);
        return;
    }
    return value;
}
function warnKeyDropped(key) {
    console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function destr(value, options = {}) {
    if (typeof value !== "string") return value;
    const _value = value.trim();
    if (// eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")) return _value.slice(1, -1);
    if (_value.length <= 9) {
        const _lval = _value.toLowerCase();
        if (_lval === "true") return true;
        if (_lval === "false") return false;
        if (_lval === "undefined") return void 0;
        if (_lval === "null") return null;
        if (_lval === "nan") return Number.NaN;
        if (_lval === "infinity") return Number.POSITIVE_INFINITY;
        if (_lval === "-infinity") return Number.NEGATIVE_INFINITY;
    }
    if (!JsonSigRx.test(value)) {
        if (options.strict) throw new SyntaxError("[destr] Invalid JSON");
        return value;
    }
    try {
        if (suspectProtoRx.test(value) || suspectConstructorRx.test(value)) {
            if (options.strict) throw new Error("[destr] Possible prototype pollution");
            return JSON.parse(value, jsonParseTransform);
        }
        return JSON.parse(value);
    } catch (error) {
        if (options.strict) throw error;
        return value;
    }
}
function safeDestr(value, options = {}) {
    return destr(value, {
        ...options,
        strict: true
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"am5gV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>normalizeKey);
parcelHelpers.export(exports, "b", ()=>asyncCall);
parcelHelpers.export(exports, "c", ()=>serializeRaw);
parcelHelpers.export(exports, "d", ()=>deserializeRaw);
parcelHelpers.export(exports, "j", ()=>joinKeys);
parcelHelpers.export(exports, "n", ()=>normalizeBaseKey);
parcelHelpers.export(exports, "p", ()=>prefixStorage);
parcelHelpers.export(exports, "s", ()=>stringify);
var Buffer = require("d8e26b8d131c6c1e").Buffer;
function wrapToPromise(value) {
    if (!value || typeof value.then !== "function") return Promise.resolve(value);
    return value;
}
function asyncCall(function_, ...arguments_) {
    try {
        return wrapToPromise(function_(...arguments_));
    } catch (error) {
        return Promise.reject(error);
    }
}
function isPrimitive(value) {
    const type = typeof value;
    return value === null || type !== "object" && type !== "function";
}
function isPureObject(value) {
    const proto = Object.getPrototypeOf(value);
    return !proto || proto.isPrototypeOf(Object);
}
function stringify(value) {
    if (isPrimitive(value)) return String(value);
    if (isPureObject(value) || Array.isArray(value)) return JSON.stringify(value);
    if (typeof value.toJSON === "function") return stringify(value.toJSON());
    throw new Error("[unstorage] Cannot stringify value!");
}
function checkBufferSupport() {}
const BASE64_PREFIX = "base64:";
function serializeRaw(value) {
    if (typeof value === "string") return value;
    checkBufferSupport();
    const base64 = Buffer.from(value).toString("base64");
    return BASE64_PREFIX + base64;
}
function deserializeRaw(value) {
    if (typeof value !== "string") return value;
    if (!value.startsWith(BASE64_PREFIX)) return value;
    checkBufferSupport();
    return Buffer.from(value.slice(BASE64_PREFIX.length), "base64");
}
const storageKeyProperties = [
    "hasItem",
    "getItem",
    "getItemRaw",
    "setItem",
    "setItemRaw",
    "removeItem",
    "getMeta",
    "setMeta",
    "removeMeta",
    "getKeys",
    "clear",
    "mount",
    "unmount"
];
function prefixStorage(storage, base) {
    base = normalizeBaseKey(base);
    if (!base) return storage;
    const nsStorage = {
        ...storage
    };
    for (const property of storageKeyProperties)nsStorage[property] = (key = "", ...args)=>// @ts-ignore
        storage[property](base + key, ...args);
    nsStorage.getKeys = (key = "", ...arguments_)=>storage.getKeys(base + key, ...arguments_).then((keys)=>keys.map((key2)=>key2.slice(base.length)));
    return nsStorage;
}
function normalizeKey(key) {
    if (!key) return "";
    return key.split("?")[0].replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "");
}
function joinKeys(...keys) {
    return normalizeKey(keys.join(":"));
}
function normalizeBaseKey(base) {
    base = normalizeKey(base);
    return base ? base + ":" : "";
}

},{"d8e26b8d131c6c1e":"l5Twm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ms2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clear", ()=>clear);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "del", ()=>del);
parcelHelpers.export(exports, "delMany", ()=>delMany);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "getMany", ()=>getMany);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "promisifyRequest", ()=>promisifyRequest);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "setMany", ()=>setMany);
parcelHelpers.export(exports, "update", ()=>update);
parcelHelpers.export(exports, "values", ()=>values);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function createStore(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = promisifyRequest(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var defaultGetStoreFunc;
function defaultGetStore() {
    if (!defaultGetStoreFunc) defaultGetStoreFunc = createStore("keyval-store", "keyval");
    return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function get(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
    return customStore("readonly", function(store) {
        return promisifyRequest(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function set(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function setMany(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return promisifyRequest(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function getMany(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return promisifyRequest(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function update(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve(promisifyRequest(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function del(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function delMany(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return promisifyRequest(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function clear() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return promisifyRequest(store.transaction);
    });
}
function eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return promisifyRequest(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function keys() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return promisifyRequest(store.getAllKeys());
        var items = [];
        return eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function values() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return promisifyRequest(store.getAll());
        var items = [];
        return eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function entries() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            promisifyRequest(store.getAllKeys()),
            promisifyRequest(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaejp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJsonParse", ()=>safeJsonParse);
parcelHelpers.export(exports, "safeJsonStringify", ()=>safeJsonStringify);
const JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function safeJsonStringify(value) {
    return typeof value === "string" ? value : JSONStringify(value) || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ixJ4A":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("4d7c6d075a015636");
tslib_1.__exportStar(require("cb5b472d52d3cf50"), exports);
tslib_1.__exportStar(require("aa82b82d39f043"), exports);
tslib_1.__exportStar(require("ec5895e80e8d0f5f"), exports);

},{"4d7c6d075a015636":"i1ima","cb5b472d52d3cf50":"1xw3e","aa82b82d39f043":"6QZai","ec5895e80e8d0f5f":"PXSeA"}],"i1ima":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xw3e":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeartBeat = void 0;
const tslib_1 = require("fcc1ffd649161ea4");
const events_1 = require("cb5aafd80d34fef8");
const time_1 = require("32850262962ecb3b");
const types_1 = require("6ea39d676cf5a689");
const constants_1 = require("564ba16c950b20da");
class HeartBeat extends types_1.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new events_1.EventEmitter();
        this.interval = constants_1.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || constants_1.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return tslib_1.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), time_1.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit(constants_1.HEARTBEAT_EVENTS.pulse);
    }
}
exports.HeartBeat = HeartBeat;

},{"fcc1ffd649161ea4":"i1ima","cb5aafd80d34fef8":"fqTtD","32850262962ecb3b":"gEfho","6ea39d676cf5a689":"6QZai","564ba16c950b20da":"PXSeA"}],"gEfho":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("8d7ccc892a7089ef");
tslib_1.__exportStar(require("37893644bffdd5dd"), exports);
tslib_1.__exportStar(require("bf4f5982eaec796c"), exports);
tslib_1.__exportStar(require("599d3c63fd46295e"), exports);
tslib_1.__exportStar(require("589a6c864f5c929"), exports);

},{"8d7ccc892a7089ef":"1NmAN","37893644bffdd5dd":"9pp30","bf4f5982eaec796c":"gnUT2","599d3c63fd46295e":"5m9x5","589a6c864f5c929":"dx6AH"}],"1NmAN":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9pp30":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("7f4b0b7c0d74932e");
tslib_1.__exportStar(require("1ec7a14abdc96efe"), exports);
tslib_1.__exportStar(require("616c43863b4df23a"), exports);

},{"7f4b0b7c0d74932e":"1NmAN","1ec7a14abdc96efe":"f8wo3","616c43863b4df23a":"7mL0h"}],"f8wo3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.delay = void 0;
function delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
exports.delay = delay;

},{}],"7mL0h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromMiliseconds = exports.toMiliseconds = void 0;
const constants_1 = require("1bcd6aa3bc332d85");
function toMiliseconds(seconds) {
    return seconds * constants_1.ONE_THOUSAND;
}
exports.toMiliseconds = toMiliseconds;
function fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / constants_1.ONE_THOUSAND);
}
exports.fromMiliseconds = fromMiliseconds;

},{"1bcd6aa3bc332d85":"dx6AH"}],"dx6AH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("327c60ac9bcd2478");
tslib_1.__exportStar(require("89739510288b8b8c"), exports);
tslib_1.__exportStar(require("58d566376ee0f0bb"), exports);

},{"327c60ac9bcd2478":"1NmAN","89739510288b8b8c":"9aJIM","58d566376ee0f0bb":"hmwPs"}],"9aJIM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ONE_THOUSAND = exports.ONE_HUNDRED = void 0;
exports.ONE_HUNDRED = 100;
exports.ONE_THOUSAND = 1000;

},{}],"hmwPs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ONE_YEAR = exports.FOUR_WEEKS = exports.THREE_WEEKS = exports.TWO_WEEKS = exports.ONE_WEEK = exports.THIRTY_DAYS = exports.SEVEN_DAYS = exports.FIVE_DAYS = exports.THREE_DAYS = exports.ONE_DAY = exports.TWENTY_FOUR_HOURS = exports.TWELVE_HOURS = exports.SIX_HOURS = exports.THREE_HOURS = exports.ONE_HOUR = exports.SIXTY_MINUTES = exports.THIRTY_MINUTES = exports.TEN_MINUTES = exports.FIVE_MINUTES = exports.ONE_MINUTE = exports.SIXTY_SECONDS = exports.THIRTY_SECONDS = exports.TEN_SECONDS = exports.FIVE_SECONDS = exports.ONE_SECOND = void 0;
exports.ONE_SECOND = 1;
exports.FIVE_SECONDS = 5;
exports.TEN_SECONDS = 10;
exports.THIRTY_SECONDS = 30;
exports.SIXTY_SECONDS = 60;
exports.ONE_MINUTE = exports.SIXTY_SECONDS;
exports.FIVE_MINUTES = exports.ONE_MINUTE * 5;
exports.TEN_MINUTES = exports.ONE_MINUTE * 10;
exports.THIRTY_MINUTES = exports.ONE_MINUTE * 30;
exports.SIXTY_MINUTES = exports.ONE_MINUTE * 60;
exports.ONE_HOUR = exports.SIXTY_MINUTES;
exports.THREE_HOURS = exports.ONE_HOUR * 3;
exports.SIX_HOURS = exports.ONE_HOUR * 6;
exports.TWELVE_HOURS = exports.ONE_HOUR * 12;
exports.TWENTY_FOUR_HOURS = exports.ONE_HOUR * 24;
exports.ONE_DAY = exports.TWENTY_FOUR_HOURS;
exports.THREE_DAYS = exports.ONE_DAY * 3;
exports.FIVE_DAYS = exports.ONE_DAY * 5;
exports.SEVEN_DAYS = exports.ONE_DAY * 7;
exports.THIRTY_DAYS = exports.ONE_DAY * 30;
exports.ONE_WEEK = exports.SEVEN_DAYS;
exports.TWO_WEEKS = exports.ONE_WEEK * 2;
exports.THREE_WEEKS = exports.ONE_WEEK * 3;
exports.FOUR_WEEKS = exports.ONE_WEEK * 4;
exports.ONE_YEAR = exports.ONE_DAY * 365;

},{}],"gnUT2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Watch = void 0;
class Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
exports.Watch = Watch;
exports.default = Watch;

},{}],"5m9x5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("457184fa7fdc102c");
tslib_1.__exportStar(require("bd221427bf0bd5c3"), exports);

},{"457184fa7fdc102c":"1NmAN","bd221427bf0bd5c3":"7fYbD"}],"7fYbD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IWatch = void 0;
class IWatch {
}
exports.IWatch = IWatch;

},{}],"6QZai":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("5b3dbe629f809bf5");
tslib_1.__exportStar(require("893a5304e35a293d"), exports);

},{"5b3dbe629f809bf5":"i1ima","893a5304e35a293d":"5O8V3"}],"5O8V3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IHeartBeat = void 0;
const events_1 = require("f67179b2d86536f4");
class IHeartBeat extends events_1.IEvents {
    constructor(opts){
        super();
    }
}
exports.IHeartBeat = IHeartBeat;

},{"f67179b2d86536f4":"fHdgn"}],"fHdgn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _events = require("./events");
parcelHelpers.exportAll(_events, exports);

},{"./events":"8aIVr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aIVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IEvents", ()=>IEvents);
class IEvents {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"PXSeA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("9b6f7226e21cdd0c");
tslib_1.__exportStar(require("35cb81f8d1226e8c"), exports);

},{"9b6f7226e21cdd0c":"i1ima","35cb81f8d1226e8c":"jphpe"}],"jphpe":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HEARTBEAT_EVENTS = exports.HEARTBEAT_INTERVAL = void 0;
const time_1 = require("1d1abc30095d3dcd");
exports.HEARTBEAT_INTERVAL = time_1.FIVE_SECONDS;
exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

},{"1d1abc30095d3dcd":"gEfho"}],"csu9A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_LOG_SIZE_IN_BYTES_DEFAULT", ()=>l);
parcelHelpers.export(exports, "PINO_CUSTOM_CONTEXT_KEY", ()=>n);
parcelHelpers.export(exports, "PINO_LOGGER_DEFAULTS", ()=>c);
parcelHelpers.export(exports, "formatChildLoggerContext", ()=>w);
parcelHelpers.export(exports, "generateChildLogger", ()=>E);
parcelHelpers.export(exports, "generateClientLogger", ()=>C);
parcelHelpers.export(exports, "generatePlatformLogger", ()=>A);
parcelHelpers.export(exports, "generateServerLogger", ()=>I);
parcelHelpers.export(exports, "getBrowserLoggerContext", ()=>v);
parcelHelpers.export(exports, "getDefaultLoggerOptions", ()=>k);
parcelHelpers.export(exports, "getLoggerContext", ()=>y);
parcelHelpers.export(exports, "pino", ()=>(0, _pinoDefault.default));
parcelHelpers.export(exports, "setBrowserLoggerContext", ()=>b);
var _pino = require("pino");
var _pinoDefault = parcelHelpers.interopDefault(_pino);
var _safeJson = require("@walletconnect/safe-json");
const c = {
    level: "info"
}, n = "custom_context", l = 1024000;
class O {
    constructor(e){
        this.nodeValue = e, this.sizeInBytes = new TextEncoder().encode(this.nodeValue).length, this.next = null;
    }
    get value() {
        return this.nodeValue;
    }
    get size() {
        return this.sizeInBytes;
    }
}
class d {
    constructor(e){
        this.head = null, this.tail = null, this.lengthInNodes = 0, this.maxSizeInBytes = e, this.sizeInBytes = 0;
    }
    append(e) {
        const t = new O(e);
        if (t.size > this.maxSizeInBytes) throw new Error(`[LinkedList] Value too big to insert into list: ${e} with size ${t.size}`);
        for(; this.size + t.size > this.maxSizeInBytes;)this.shift();
        this.head ? (this.tail && (this.tail.next = t), this.tail = t) : (this.head = t, this.tail = t), this.lengthInNodes++, this.sizeInBytes += t.size;
    }
    shift() {
        if (!this.head) return;
        const e = this.head;
        this.head = this.head.next, this.head || (this.tail = null), this.lengthInNodes--, this.sizeInBytes -= e.size;
    }
    toArray() {
        const e = [];
        let t = this.head;
        for(; t !== null;)e.push(t.value), t = t.next;
        return e;
    }
    get length() {
        return this.lengthInNodes;
    }
    get size() {
        return this.sizeInBytes;
    }
    toOrderedArray() {
        return Array.from(this);
    }
    [Symbol.iterator]() {
        let e = this.head;
        return {
            next: ()=>{
                if (!e) return {
                    done: !0,
                    value: null
                };
                const t = e.value;
                return e = e.next, {
                    done: !1,
                    value: t
                };
            }
        };
    }
}
class L {
    constructor(e, t = l){
        this.level = e ?? "error", this.levelValue = (0, _pino.levels).values[this.level], this.MAX_LOG_SIZE_IN_BYTES = t, this.logs = new d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    forwardToConsole(e, t) {
        t === (0, _pino.levels).values.error ? console.error(e) : t === (0, _pino.levels).values.warn ? console.warn(e) : t === (0, _pino.levels).values.debug ? console.debug(e) : t === (0, _pino.levels).values.trace ? console.trace(e) : console.log(e);
    }
    appendToLogs(e) {
        this.logs.append((0, _safeJson.safeJsonStringify)({
            timestamp: new Date().toISOString(),
            log: e
        }));
        const t = typeof e == "string" ? JSON.parse(e).level : e.level;
        t >= this.levelValue && this.forwardToConsole(e, t);
    }
    getLogs() {
        return this.logs;
    }
    clearLogs() {
        this.logs = new d(this.MAX_LOG_SIZE_IN_BYTES);
    }
    getLogArray() {
        return Array.from(this.logs);
    }
    logsToBlob(e) {
        const t = this.getLogArray();
        return t.push((0, _safeJson.safeJsonStringify)({
            extraMetadata: e
        })), new Blob(t, {
            type: "application/json"
        });
    }
}
class m {
    constructor(e, t = l){
        this.baseChunkLogger = new L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
    downloadLogsBlobInBrowser(e) {
        const t = URL.createObjectURL(this.logsToBlob(e)), o = document.createElement("a");
        o.href = t, o.download = `walletconnect-logs-${new Date().toISOString()}.txt`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(t);
    }
}
class B {
    constructor(e, t = l){
        this.baseChunkLogger = new L(e, t);
    }
    write(e) {
        this.baseChunkLogger.appendToLogs(e);
    }
    getLogs() {
        return this.baseChunkLogger.getLogs();
    }
    clearLogs() {
        this.baseChunkLogger.clearLogs();
    }
    getLogArray() {
        return this.baseChunkLogger.getLogArray();
    }
    logsToBlob(e) {
        return this.baseChunkLogger.logsToBlob(e);
    }
}
var x = Object.defineProperty, S = Object.defineProperties, _ = Object.getOwnPropertyDescriptors, p = Object.getOwnPropertySymbols, T = Object.prototype.hasOwnProperty, z = Object.prototype.propertyIsEnumerable, f = (r, e, t)=>e in r ? x(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, i = (r, e)=>{
    for(var t in e || (e = {}))T.call(e, t) && f(r, t, e[t]);
    if (p) for (var t of p(e))z.call(e, t) && f(r, t, e[t]);
    return r;
}, g = (r, e)=>S(r, _(e));
function k(r) {
    return g(i({}, r), {
        level: r?.level || c.level
    });
}
function v(r, e = n) {
    return r[e] || "";
}
function b(r, e, t = n) {
    return r[t] = e, r;
}
function y(r, e = n) {
    let t = "";
    return typeof r.bindings > "u" ? t = v(r, e) : t = r.bindings().context || "", t;
}
function w(r, e, t = n) {
    const o = y(r, t);
    return o.trim() ? `${o}/${e}` : e;
}
function E(r, e, t = n) {
    const o = w(r, e, t), a = r.child({
        context: o
    });
    return b(a, o, t);
}
function C(r) {
    var e, t;
    const o = new m((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, _pinoDefault.default)(g(i({}, r.opts), {
            level: "trace",
            browser: g(i({}, (t = r.opts) == null ? void 0 : t.browser), {
                write: (a)=>o.write(a)
            })
        })),
        chunkLoggerController: o
    };
}
function I(r) {
    var e;
    const t = new B((e = r.opts) == null ? void 0 : e.level, r.maxSizeInBytes);
    return {
        logger: (0, _pinoDefault.default)(g(i({}, r.opts), {
            level: "trace"
        }), t),
        chunkLoggerController: t
    };
}
function A(r) {
    return typeof r.loggerOverride < "u" && typeof r.loggerOverride != "string" ? {
        logger: r.loggerOverride,
        chunkLoggerController: null
    } : typeof window < "u" ? C(r) : I(r);
}

},{"pino":"jhEET","@walletconnect/safe-json":"gaejp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jhEET":[function(require,module,exports) {
"use strict";
const format = require("a7a441f97f89ff91");
module.exports = pino;
const _console = pfGlobalThisOrFallback().console || {};
const stdSerializers = {
    mapHttpRequest: mock,
    mapHttpResponse: mock,
    wrapRequestSerializer: passthrough,
    wrapResponseSerializer: passthrough,
    wrapErrorSerializer: passthrough,
    req: mock,
    res: mock,
    err: asErrValue
};
function shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || _console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit,
        serialize,
        asObject: opts.browser.asObject,
        levels,
        timestamp: getTimeFunction(opts)
    };
    logger.levels = pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        set(setOpts, logger, "fatal", "error");
        set(setOpts, logger, "warn", "error");
        set(setOpts, logger, "info", "log");
        set(setOpts, logger, "debug", "log");
        set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = bind(parent, bindings, "error");
            this.fatal = bind(parent, bindings, "fatal");
            this.warn = bind(parent, bindings, "warn");
            this.info = bind(parent, bindings, "info");
            this.debug = bind(parent, bindings, "debug");
            this.trace = bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
pino.stdSerializers = stdSerializers;
pino.stdTimeFunctions = Object.assign({}, {
    nullTime,
    epochTime,
    unixTime,
    isoTime
});
function set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? noop : proto[level] ? proto[level] : _console[level] || _console[fallback] || noop;
    wrap(opts, logger, level);
}
function wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === _console ? _console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = pino.levels.values[transmitLevel];
                const methodValue = pino.levels.values[level];
                if (methodValue < transmitValue) return;
                transmit(this, {
                    ts,
                    methodLevel: level,
                    methodValue,
                    transmitLevel,
                    transmitValue: pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function asObject(logger, level, args, ts) {
    if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = format(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = createLogEventShape(bindings);
}
function createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return nullTime;
    return epochTime;
}
function mock() {
    return {};
}
function passthrough(a) {
    return a;
}
function noop() {}
function nullTime() {
    return false;
}
function epochTime() {
    return Date.now();
}
function unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

},{"a7a441f97f89ff91":"5fsqe"}],"5fsqe":[function(require,module,exports) {
"use strict";
function tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = format;
function format(f, args, opts) {
    var ss = opts && opts.stringify || tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

},{}],"bwv1G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICore", ()=>n);
parcelHelpers.export(exports, "ICrypto", ()=>l);
parcelHelpers.export(exports, "IEngine", ()=>S);
parcelHelpers.export(exports, "IEngineEvents", ()=>C);
parcelHelpers.export(exports, "IExpirer", ()=>E);
parcelHelpers.export(exports, "IJsonRpcHistory", ()=>h);
parcelHelpers.export(exports, "IKeyChain", ()=>x);
parcelHelpers.export(exports, "IMessageTracker", ()=>a);
parcelHelpers.export(exports, "IPairing", ()=>m);
parcelHelpers.export(exports, "IPublisher", ()=>u);
parcelHelpers.export(exports, "IRelayer", ()=>g);
parcelHelpers.export(exports, "ISignClient", ()=>b);
parcelHelpers.export(exports, "ISignClientEvents", ()=>v);
parcelHelpers.export(exports, "IStore", ()=>p);
parcelHelpers.export(exports, "ISubscriber", ()=>d);
parcelHelpers.export(exports, "ISubscriberTopicMap", ()=>I);
parcelHelpers.export(exports, "IVerify", ()=>y);
var _events = require("@walletconnect/events");
var _events1 = require("events");
var _eventsDefault = parcelHelpers.interopDefault(_events1);
class n extends (0, _events.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class l {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class h extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class a {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class u extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class g extends (0, _events.IEvents) {
    constructor(s){
        super();
    }
}
class p {
    constructor(s, t, o, w){
        this.core = s, this.logger = t, this.name = o;
    }
}
class I {
    constructor(){
        this.map = new Map;
    }
}
class d extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class x {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class E extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class m {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class y {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class v extends (0, _eventsDefault.default) {
    constructor(){
        super();
    }
}
class b {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class C extends (0, _events1.EventEmitter) {
    constructor(){
        super();
    }
}
class S {
    constructor(s){
        this.client = s;
    }
}

},{"@walletconnect/events":"fHdgn","events":"fqTtD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jug6O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _api = require("./api");
parcelHelpers.exportAll(_api, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./api":"7P0cy","./constants":"3fl8G","./types":"2tpuz","./utils":"9CFIz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7P0cy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateKeyPair", ()=>generateKeyPair);
parcelHelpers.export(exports, "signJWT", ()=>signJWT);
parcelHelpers.export(exports, "verifyJWT", ()=>verifyJWT);
var _ed25519 = require("@stablelib/ed25519");
var _random = require("@stablelib/random");
var _time = require("@walletconnect/time");
var _constants = require("./constants");
var _utils = require("./utils");
function generateKeyPair(seed = (0, _random.randomBytes)((0, _constants.KEY_PAIR_SEED_LENGTH))) {
    return _ed25519.generateKeyPairFromSeed(seed);
}
async function signJWT(sub, aud, ttl, keyPair, iat = (0, _time.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, _constants.JWT_IRIDIUM_ALG),
        typ: (0, _constants.JWT_IRIDIUM_TYP)
    };
    const iss = (0, _utils.encodeIss)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss,
        sub,
        aud,
        iat,
        exp
    };
    const data = (0, _utils.encodeData)({
        header,
        payload
    });
    const signature = _ed25519.sign(keyPair.secretKey, data);
    return (0, _utils.encodeJWT)({
        header,
        payload,
        signature
    });
}
async function verifyJWT(jwt) {
    const { header, payload, data, signature } = (0, _utils.decodeJWT)(jwt);
    if (header.alg !== (0, _constants.JWT_IRIDIUM_ALG) || header.typ !== (0, _constants.JWT_IRIDIUM_TYP)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, _utils.decodeIss)(payload.iss);
    return _ed25519.verify(publicKey, data, signature);
}

},{"@stablelib/ed25519":"5xjuF","@stablelib/random":"fE2oh","@walletconnect/time":"gEfho","./constants":"3fl8G","./utils":"9CFIz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xjuF":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertSecretKeyToX25519 = exports.convertPublicKeyToX25519 = exports.verify = exports.sign = exports.extractPublicKeyFromSecretKey = exports.generateKeyPair = exports.generateKeyPairFromSeed = exports.SEED_LENGTH = exports.SECRET_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = exports.SIGNATURE_LENGTH = void 0;
/**
 * Package ed25519 implements Ed25519 public-key signature algorithm.
 */ const random_1 = require("77255b7d05262a33");
const sha512_1 = require("bb6b80f40d96255");
const wipe_1 = require("17372f190926d190");
exports.SIGNATURE_LENGTH = 64;
exports.PUBLIC_KEY_LENGTH = 32;
exports.SECRET_KEY_LENGTH = 64;
exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const _9 = new Uint8Array(32);
_9[0] = 9;
const gf0 = gf();
const gf1 = gf([
    1
]);
const D = gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const D2 = gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const X = gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const Y = gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const I = gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function pack25519(o, n) {
    const m = gf();
    const t = gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    car25519(t);
    car25519(t);
    car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    pack25519(c, a);
    pack25519(d, b);
    return verify32(c, d);
}
function par25519(a) {
    const d = new Uint8Array(32);
    pack25519(d, a);
    return d[0] & 1;
}
function unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function square(o, a) {
    mul(o, a, a);
}
function inv25519(o, i) {
    const c = gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        square(c, c);
        if (a !== 2 && a !== 4) mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function pow2523(o, i) {
    const c = gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        square(c, c);
        if (a !== 1) mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function edadd(p, q) {
    const a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
    sub(a, p[1], p[0]);
    sub(t, q[1], q[0]);
    mul(a, a, t);
    add(b, p[0], p[1]);
    add(t, q[0], q[1]);
    mul(b, b, t);
    mul(c, p[3], q[3]);
    mul(c, c, D2);
    mul(d, p[2], q[2]);
    add(d, d, d);
    sub(e, b, a);
    sub(f, d, c);
    add(g, d, c);
    add(h, b, a);
    mul(p[0], e, f);
    mul(p[1], h, g);
    mul(p[2], g, f);
    mul(p[3], e, h);
}
function cswap(p, q, b) {
    for(let i = 0; i < 4; i++)sel25519(p[i], q[i], b);
}
function pack(r, p) {
    const tx = gf(), ty = gf(), zi = gf();
    inv25519(zi, p[2]);
    mul(tx, p[0], zi);
    mul(ty, p[1], zi);
    pack25519(r, ty);
    r[31] ^= par25519(tx) << 7;
}
function scalarmult(p, q, s) {
    set25519(p[0], gf0);
    set25519(p[1], gf1);
    set25519(p[2], gf1);
    set25519(p[3], gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        cswap(p, q, b);
        edadd(q, p);
        edadd(p, p);
        cswap(p, q, b);
    }
}
function scalarbase(p, s) {
    const q = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    set25519(q[0], X);
    set25519(q[1], Y);
    set25519(q[2], gf1);
    mul(q[3], X, Y);
    scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function generateKeyPairFromSeed(seed) {
    if (seed.length !== exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${exports.SEED_LENGTH} bytes`);
    const d = (0, sha512_1.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    scalarbase(p, d);
    pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey,
        secretKey
    };
}
exports.generateKeyPairFromSeed = generateKeyPairFromSeed;
function generateKeyPair(prng) {
    const seed = (0, random_1.randomBytes)(32, prng);
    const result = generateKeyPairFromSeed(seed);
    (0, wipe_1.wipe)(seed);
    return result;
}
exports.generateKeyPair = generateKeyPair;
function extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
exports.extractPublicKeyFromSecretKey = extractPublicKeyFromSecretKey;
const L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    const d = (0, sha512_1.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new sha512_1.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    reduce(r);
    scalarbase(p, r);
    pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    modL(signature.subarray(32), x);
    return signature;
}
exports.sign = sign;
function unpackneg(r, p) {
    const t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
    set25519(r[2], gf1);
    unpack25519(r[1], p);
    square(num, r[1]);
    mul(den, num, D);
    sub(num, num, r[2]);
    add(den, r[2], den);
    square(den2, den);
    square(den4, den2);
    mul(den6, den4, den2);
    mul(t, den6, num);
    mul(t, t, den);
    pow2523(t, t);
    mul(t, t, num);
    mul(t, t, den);
    mul(t, t, den);
    mul(r[0], t, den);
    square(chk, r[0]);
    mul(chk, chk, den);
    if (neq25519(chk, num)) mul(r[0], r[0], I);
    square(chk, r[0]);
    mul(chk, chk, den);
    if (neq25519(chk, num)) return -1;
    if (par25519(r[0]) === p[31] >> 7) sub(r[0], gf0, r[0]);
    mul(r[3], r[0], r[1]);
    return 0;
}
function verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    const q = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    if (signature.length !== exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${exports.SIGNATURE_LENGTH} bytes`);
    if (unpackneg(q, publicKey)) return false;
    const hs = new sha512_1.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    reduce(h);
    scalarmult(p, q, h);
    scalarbase(q, signature.subarray(32));
    edadd(p, q);
    pack(t, p);
    if (verify32(signature, t)) return false;
    return true;
}
exports.verify = verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function convertPublicKeyToX25519(publicKey) {
    let q = [
        gf(),
        gf(),
        gf(),
        gf()
    ];
    if (unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = gf();
    let b = gf();
    let y = q[1];
    add(a, gf1, y);
    sub(b, gf1, y);
    inv25519(b, b);
    mul(a, a, b);
    let z = new Uint8Array(32);
    pack25519(z, a);
    return z;
}
exports.convertPublicKeyToX25519 = convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function convertSecretKeyToX25519(secretKey) {
    const d = (0, sha512_1.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, wipe_1.wipe)(d);
    return o;
}
exports.convertSecretKeyToX25519 = convertSecretKeyToX25519;

},{"77255b7d05262a33":"fE2oh","bb6b80f40d96255":"8mNWZ","17372f190926d190":"2ar8l"}],"fE2oh":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomStringForEntropy = exports.randomString = exports.randomUint32 = exports.randomBytes = exports.defaultRandomSource = void 0;
const system_1 = require("95b84bbab8abd28a");
const binary_1 = require("6171ab791b4ad9be");
const wipe_1 = require("a68df3e51a6c727e");
exports.defaultRandomSource = new system_1.SystemRandomSource();
function randomBytes(length, prng = exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
exports.randomBytes = randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function randomUint32(prng = exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, binary_1.readUint32LE)(buf);
    // Clean the buffer.
    (0, wipe_1.wipe)(buf);
    return result;
}
exports.randomUint32 = randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function randomString(length, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, wipe_1.wipe)(buf);
    }
    return out;
}
exports.randomString = randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function randomStringForEntropy(bits, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return randomString(length, charset, prng);
}
exports.randomStringForEntropy = randomStringForEntropy;

},{"95b84bbab8abd28a":"6BtCD","6171ab791b4ad9be":"8KUxR","a68df3e51a6c727e":"2ar8l"}],"6BtCD":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SystemRandomSource = void 0;
const browser_1 = require("52b06b243208607e");
const node_1 = require("49f156a36041812e");
class SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new browser_1.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new node_1.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
exports.SystemRandomSource = SystemRandomSource;

},{"52b06b243208607e":"GqIgH","49f156a36041812e":"h9wq4"}],"GqIgH":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BrowserRandomSource = void 0;
const QUOTA = 65536;
class BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, QUOTA)));
        return out;
    }
}
exports.BrowserRandomSource = BrowserRandomSource;

},{}],"h9wq4":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeRandomSource = void 0;
const wipe_1 = require("89d2f763d16eb5cc");
class NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = require("fb6960c20402a81a");
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, wipe_1.wipe)(buffer);
        return out;
    }
}
exports.NodeRandomSource = NodeRandomSource;

},{"89d2f763d16eb5cc":"2ar8l","fb6960c20402a81a":"13Pcp"}],"2ar8l":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
exports.wipe = wipe;

},{}],"8KUxR":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package binary provides functions for encoding and decoding numbers in byte arrays.
 */ var int_1 = require("1b589c6468d366f4");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
exports.readInt16BE = readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
exports.readUint16BE = readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
exports.readInt16LE = readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
exports.readUint16LE = readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
exports.writeUint16BE = writeUint16BE;
exports.writeInt16BE = writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
exports.writeUint16LE = writeUint16LE;
exports.writeInt16LE = writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
exports.readInt32BE = readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
exports.readUint32BE = readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
exports.readInt32LE = readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
exports.readUint32LE = readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
exports.writeUint32BE = writeUint32BE;
exports.writeInt32BE = writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
exports.writeUint32LE = writeUint32LE;
exports.writeInt32LE = writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = readInt32BE(array, offset);
    var lo = readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
exports.readInt64BE = readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = readUint32BE(array, offset);
    var lo = readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
exports.readUint64BE = readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = readInt32LE(array, offset);
    var hi = readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
exports.readInt64LE = readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = readUint32LE(array, offset);
    var hi = readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
exports.readUint64LE = readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
exports.writeUint64BE = writeUint64BE;
exports.writeInt64BE = writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    writeUint32LE(value >>> 0, out, offset);
    writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
exports.writeUint64LE = writeUint64LE;
exports.writeInt64LE = writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
exports.readUintBE = readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
exports.readUintLE = readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!int_1.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
exports.writeUintBE = writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!int_1.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
exports.writeUintLE = writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
exports.readFloat32BE = readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
exports.readFloat32LE = readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
exports.readFloat64BE = readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
exports.readFloat64LE = readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
exports.writeFloat32BE = writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
exports.writeFloat32LE = writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
exports.writeFloat64BE = writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
exports.writeFloat64LE = writeFloat64LE;

},{"1b589c6468d366f4":"fyzlH"}],"fyzlH":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
exports.mul = Math.imul || imulShim;
/** 32-bit integer addition.  */ function add(a, b) {
    return a + b | 0;
}
exports.add = add;
/**  32-bit integer subtraction.  */ function sub(a, b) {
    return a - b | 0;
}
exports.sub = sub;
/** 32-bit integer left rotation */ function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
exports.rotl = rotl;
/** 32-bit integer left rotation */ function rotr(x, n) {
    return x << 32 - n | x >>> n;
}
exports.rotr = rotr;
function isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ exports.isInteger = Number.isInteger || isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ exports.isSafeInteger = function(n) {
    return exports.isInteger(n) && n >= -exports.MAX_SAFE_INTEGER && n <= exports.MAX_SAFE_INTEGER;
};

},{}],"8mNWZ":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
var binary_1 = require("c810033140540598");
var wipe_1 = require("78bca2fcbb454f02");
exports.DIGEST_LENGTH = 64;
exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        wipe_1.wipe(this._buffer);
        wipe_1.wipe(this._tempHi);
        wipe_1.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            binary_1.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            binary_1.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            binary_1.writeUint32BE(this._stateHi[i], out, i * 8);
            binary_1.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        wipe_1.wipe(savedState.stateHi);
        wipe_1.wipe(savedState.stateLo);
        if (savedState.buffer) wipe_1.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
exports.SHA512 = SHA512;
// Constants
var K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = binary_1.readUint32BE(m, j);
            wl[i] = binary_1.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = K[i * 2];
            l = K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function hash(data) {
    var h = new SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
exports.hash = hash;

},{"c810033140540598":"8KUxR","78bca2fcbb454f02":"2ar8l"}],"3fl8G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JWT_IRIDIUM_ALG", ()=>JWT_IRIDIUM_ALG);
parcelHelpers.export(exports, "JWT_IRIDIUM_TYP", ()=>JWT_IRIDIUM_TYP);
parcelHelpers.export(exports, "JWT_DELIMITER", ()=>JWT_DELIMITER);
parcelHelpers.export(exports, "JWT_ENCODING", ()=>JWT_ENCODING);
parcelHelpers.export(exports, "JSON_ENCODING", ()=>JSON_ENCODING);
parcelHelpers.export(exports, "DATA_ENCODING", ()=>DATA_ENCODING);
parcelHelpers.export(exports, "DID_DELIMITER", ()=>DID_DELIMITER);
parcelHelpers.export(exports, "DID_PREFIX", ()=>DID_PREFIX);
parcelHelpers.export(exports, "DID_METHOD", ()=>DID_METHOD);
parcelHelpers.export(exports, "MULTICODEC_ED25519_ENCODING", ()=>MULTICODEC_ED25519_ENCODING);
parcelHelpers.export(exports, "MULTICODEC_ED25519_BASE", ()=>MULTICODEC_ED25519_BASE);
parcelHelpers.export(exports, "MULTICODEC_ED25519_HEADER", ()=>MULTICODEC_ED25519_HEADER);
parcelHelpers.export(exports, "MULTICODEC_ED25519_LENGTH", ()=>MULTICODEC_ED25519_LENGTH);
parcelHelpers.export(exports, "KEY_PAIR_SEED_LENGTH", ()=>KEY_PAIR_SEED_LENGTH);
const JWT_IRIDIUM_ALG = "EdDSA";
const JWT_IRIDIUM_TYP = "JWT";
const JWT_DELIMITER = ".";
const JWT_ENCODING = "base64url";
const JSON_ENCODING = "utf8";
const DATA_ENCODING = "utf8";
const DID_DELIMITER = ":";
const DID_PREFIX = "did";
const DID_METHOD = "key";
const MULTICODEC_ED25519_ENCODING = "base58btc";
const MULTICODEC_ED25519_BASE = "z";
const MULTICODEC_ED25519_HEADER = "K36";
const MULTICODEC_ED25519_LENGTH = 32;
const KEY_PAIR_SEED_LENGTH = 32;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CFIz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeJSON", ()=>decodeJSON);
parcelHelpers.export(exports, "encodeJSON", ()=>encodeJSON);
parcelHelpers.export(exports, "encodeIss", ()=>encodeIss);
parcelHelpers.export(exports, "decodeIss", ()=>decodeIss);
parcelHelpers.export(exports, "encodeSig", ()=>encodeSig);
parcelHelpers.export(exports, "decodeSig", ()=>decodeSig);
parcelHelpers.export(exports, "encodeData", ()=>encodeData);
parcelHelpers.export(exports, "decodeData", ()=>decodeData);
parcelHelpers.export(exports, "encodeJWT", ()=>encodeJWT);
parcelHelpers.export(exports, "decodeJWT", ()=>decodeJWT);
var _concat = require("uint8arrays/concat");
var _toString = require("uint8arrays/to-string");
var _fromString = require("uint8arrays/from-string");
var _safeJson = require("@walletconnect/safe-json");
var _constants = require("./constants");
function decodeJSON(str) {
    return (0, _safeJson.safeJsonParse)((0, _toString.toString)((0, _fromString.fromString)(str, (0, _constants.JWT_ENCODING)), (0, _constants.JSON_ENCODING)));
}
function encodeJSON(val) {
    return (0, _toString.toString)((0, _fromString.fromString)((0, _safeJson.safeJsonStringify)(val), (0, _constants.JSON_ENCODING)), (0, _constants.JWT_ENCODING));
}
function encodeIss(publicKey) {
    const header = (0, _fromString.fromString)((0, _constants.MULTICODEC_ED25519_HEADER), (0, _constants.MULTICODEC_ED25519_ENCODING));
    const multicodec = (0, _constants.MULTICODEC_ED25519_BASE) + (0, _toString.toString)((0, _concat.concat)([
        header,
        publicKey
    ]), (0, _constants.MULTICODEC_ED25519_ENCODING));
    return [
        (0, _constants.DID_PREFIX),
        (0, _constants.DID_METHOD),
        multicodec
    ].join((0, _constants.DID_DELIMITER));
}
function decodeIss(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, _constants.DID_DELIMITER));
    if (prefix !== (0, _constants.DID_PREFIX) || method !== (0, _constants.DID_METHOD)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, _constants.MULTICODEC_ED25519_BASE)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, _fromString.fromString)(multicodec.slice(1), (0, _constants.MULTICODEC_ED25519_ENCODING));
    const type = (0, _toString.toString)(bytes.slice(0, 2), (0, _constants.MULTICODEC_ED25519_ENCODING));
    if (type !== (0, _constants.MULTICODEC_ED25519_HEADER)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, _constants.MULTICODEC_ED25519_LENGTH)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function encodeSig(bytes) {
    return (0, _toString.toString)(bytes, (0, _constants.JWT_ENCODING));
}
function decodeSig(encoded) {
    return (0, _fromString.fromString)(encoded, (0, _constants.JWT_ENCODING));
}
function encodeData(params) {
    return (0, _fromString.fromString)([
        encodeJSON(params.header),
        encodeJSON(params.payload)
    ].join((0, _constants.JWT_DELIMITER)), (0, _constants.DATA_ENCODING));
}
function decodeData(data) {
    const params = (0, _toString.toString)(data, (0, _constants.DATA_ENCODING)).split((0, _constants.JWT_DELIMITER));
    const header = decodeJSON(params[0]);
    const payload = decodeJSON(params[1]);
    return {
        header,
        payload
    };
}
function encodeJWT(params) {
    return [
        encodeJSON(params.header),
        encodeJSON(params.payload),
        encodeSig(params.signature)
    ].join((0, _constants.JWT_DELIMITER));
}
function decodeJWT(jwt) {
    const params = jwt.split((0, _constants.JWT_DELIMITER));
    const header = decodeJSON(params[0]);
    const payload = decodeJSON(params[1]);
    const signature = decodeSig(params[2]);
    const data = (0, _fromString.fromString)(params.slice(0, 2).join((0, _constants.JWT_DELIMITER)), (0, _constants.DATA_ENCODING));
    return {
        header,
        payload,
        signature,
        data
    };
}

},{"uint8arrays/concat":"e9PFn","uint8arrays/to-string":"ghV7c","uint8arrays/from-string":"1hHKN","@walletconnect/safe-json":"gaejp","./constants":"3fl8G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e9PFn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var alloc = require("e2f6c12d369786de");
var asUint8array = require("60d15feaf9d38a79");
function concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = alloc.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return asUint8array.asUint8Array(output);
}
exports.concat = concat;

},{"e2f6c12d369786de":"fmsfL","60d15feaf9d38a79":"9NWaL"}],"fmsfL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var asUint8array = require("1912689f04eecc12");
function alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return asUint8array.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return asUint8array.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
exports.alloc = alloc;
exports.allocUnsafe = allocUnsafe;

},{"1912689f04eecc12":"9NWaL"}],"9NWaL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
exports.asUint8Array = asUint8Array;

},{}],"ghV7c":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bases = require("e6f7ed57dbbb83e3");
function toString(array, encoding = "utf8") {
    const base = bases[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
exports.toString = toString;

},{"e6f7ed57dbbb83e3":"d8tK4"}],"d8tK4":[function(require,module,exports) {
"use strict";
var basics = require("190b60d88612a55");
var alloc = require("58496cd795266c62");
function createCodec(name, prefix, encode, decode) {
    return {
        name,
        prefix,
        encoder: {
            name,
            prefix,
            encode
        },
        decoder: {
            decode
        }
    };
}
const string = createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const ascii = createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = alloc.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const BASES = {
    utf8: string,
    "utf-8": string,
    hex: basics.bases.base16,
    latin1: ascii,
    ascii: ascii,
    binary: ascii,
    ...basics.bases
};
module.exports = BASES;

},{"190b60d88612a55":"cmWMY","58496cd795266c62":"fmsfL"}],"cmWMY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var identity = require("5661bf79a4a86163");
var base2 = require("92f7de35992ff529");
var base8 = require("99403555646e4b01");
var base10 = require("7bd4c12dbdbfa352");
var base16 = require("5d0a92fef6fb89bf");
var base32 = require("c1a0d10fb67cd525");
var base36 = require("faca89b129a6c1b2");
var base58 = require("3ab4168f23b15924");
var base64 = require("33e7c811597529af");
var base256emoji = require("b5ec1ca7b3019d4");
var sha2 = require("d25d3b6bcb424c86");
var identity$1 = require("460d65c54398a6e4");
var raw = require("addaf882fdf30c51");
var json = require("cd95f9ca9f42ac1e");
require("b09ac10d5fa2ec4b");
var cid = require("79cc7d8ad966fcf");
var hasher = require("d6f49237d20b9c1c");
var digest = require("f6479bf16d9a334c");
var varint = require("6391ff4d314b3214");
var bytes = require("27296f9a39cee6a4");
const bases = {
    ...identity,
    ...base2,
    ...base8,
    ...base10,
    ...base16,
    ...base32,
    ...base36,
    ...base58,
    ...base64,
    ...base256emoji
};
const hashes = {
    ...sha2,
    ...identity$1
};
const codecs = {
    raw,
    json
};
exports.CID = cid.CID;
exports.hasher = hasher;
exports.digest = digest;
exports.varint = varint;
exports.bytes = bytes;
exports.bases = bases;
exports.codecs = codecs;
exports.hashes = hashes;

},{"5661bf79a4a86163":"iGBts","92f7de35992ff529":"cc0nW","99403555646e4b01":"j9j03","7bd4c12dbdbfa352":"87Wbb","5d0a92fef6fb89bf":"aRzZQ","c1a0d10fb67cd525":"bAXJf","faca89b129a6c1b2":"du0Y4","3ab4168f23b15924":"hrNmq","33e7c811597529af":"leCGx","b5ec1ca7b3019d4":"3SJ6t","d25d3b6bcb424c86":"aVTw9","460d65c54398a6e4":"jhLGG","addaf882fdf30c51":"8eqR1","cd95f9ca9f42ac1e":"5yvW8","b09ac10d5fa2ec4b":"nQGzv","79cc7d8ad966fcf":"9uUB7","d6f49237d20b9c1c":"75kFb","f6479bf16d9a334c":"hqnmb","6391ff4d314b3214":"fPATb","27296f9a39cee6a4":"5Qtsr"}],"iGBts":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("bab538411f8ce9c0");
var bytes = require("64f3cab3fd4dd6b");
const identity = base.from({
    prefix: "\0",
    name: "identity",
    encode: (buf)=>bytes.toString(buf),
    decode: (str)=>bytes.fromString(str)
});
exports.identity = identity;

},{"bab538411f8ce9c0":"8Gyqk","64f3cab3fd4dd6b":"5Qtsr"}],"8Gyqk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var baseX$1 = require("e2b0538244b8b4c6");
var bytes = require("e0493e14db98d36e");
class Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return or(this, decoder);
    }
}
class ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const or = (left, right)=>new ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new Encoder(name, prefix, baseEncode);
        this.decoder = new Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const from = ({ name, prefix, encode, decode })=>new Codec(name, prefix, encode, decode);
const baseX = ({ prefix, name, alphabet })=>{
    const { encode, decode } = baseX$1(alphabet, name);
    return from({
        prefix,
        name,
        encode,
        decode: (text)=>bytes.coerce(decode(text))
    });
};
const decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const rfc4648 = ({ name, prefix, bitsPerChar, alphabet })=>{
    return from({
        prefix,
        name,
        encode (input) {
            return encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return decode(input, alphabet, bitsPerChar, name);
        }
    });
};
exports.Codec = Codec;
exports.baseX = baseX;
exports.from = from;
exports.or = or;
exports.rfc4648 = rfc4648;

},{"e2b0538244b8b4c6":"liRL8","e0493e14db98d36e":"5Qtsr"}],"liRL8":[function(require,module,exports) {
"use strict";
function base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var src = base;
var _brrp__multiformats_scope_baseX = src;
module.exports = _brrp__multiformats_scope_baseX;

},{}],"5Qtsr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const empty = new Uint8Array(0);
const toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : empty;
};
const equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const fromString = (str)=>new TextEncoder().encode(str);
const toString = (b)=>new TextDecoder().decode(b);
exports.coerce = coerce;
exports.empty = empty;
exports.equals = equals;
exports.fromHex = fromHex;
exports.fromString = fromString;
exports.isBinary = isBinary;
exports.toHex = toHex;
exports.toString = toString;

},{}],"cc0nW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("d92b1da40210e764");
const base2 = base.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
exports.base2 = base2;

},{"d92b1da40210e764":"8Gyqk"}],"j9j03":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("8f834d7ec49f71ea");
const base8 = base.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
exports.base8 = base8;

},{"8f834d7ec49f71ea":"8Gyqk"}],"87Wbb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("72679f0e6da595d0");
const base10 = base.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
exports.base10 = base10;

},{"72679f0e6da595d0":"8Gyqk"}],"aRzZQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("20fe0ea66660873a");
const base16 = base.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const base16upper = base.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
exports.base16 = base16;
exports.base16upper = base16upper;

},{"20fe0ea66660873a":"8Gyqk"}],"bAXJf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("a71f95f446e3afc0");
const base32 = base.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const base32upper = base.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const base32pad = base.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const base32padupper = base.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const base32hex = base.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const base32hexupper = base.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const base32hexpad = base.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const base32hexpadupper = base.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const base32z = base.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
exports.base32 = base32;
exports.base32hex = base32hex;
exports.base32hexpad = base32hexpad;
exports.base32hexpadupper = base32hexpadupper;
exports.base32hexupper = base32hexupper;
exports.base32pad = base32pad;
exports.base32padupper = base32padupper;
exports.base32upper = base32upper;
exports.base32z = base32z;

},{"a71f95f446e3afc0":"8Gyqk"}],"du0Y4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("f8d89a854fe0304b");
const base36 = base.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const base36upper = base.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
exports.base36 = base36;
exports.base36upper = base36upper;

},{"f8d89a854fe0304b":"8Gyqk"}],"hrNmq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("83679cee3a38c3ed");
const base58btc = base.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const base58flickr = base.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
exports.base58btc = base58btc;
exports.base58flickr = base58flickr;

},{"83679cee3a38c3ed":"8Gyqk"}],"leCGx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("20a9eb25cf44f8a3");
const base64 = base.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const base64pad = base.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const base64url = base.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const base64urlpad = base.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
exports.base64 = base64;
exports.base64pad = base64pad;
exports.base64url = base64url;
exports.base64urlpad = base64urlpad;

},{"20a9eb25cf44f8a3":"8Gyqk"}],"3SJ6t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var base = require("e6238c0263a514ec");
const alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const alphabetBytesToChars = alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const alphabetCharsToBytes = alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function encode(data) {
    return data.reduce((p, c)=>{
        p += alphabetBytesToChars[c];
        return p;
    }, "");
}
function decode(str) {
    const byts = [];
    for (const char of str){
        const byt = alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const base256emoji = base.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode,
    decode
});
exports.base256emoji = base256emoji;

},{"e6238c0263a514ec":"8Gyqk"}],"aVTw9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var hasher = require("87c93fe66805c4b2");
const sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const sha256 = hasher.from({
    name: "sha2-256",
    code: 18,
    encode: sha("SHA-256")
});
const sha512 = hasher.from({
    name: "sha2-512",
    code: 19,
    encode: sha("SHA-512")
});
exports.sha256 = sha256;
exports.sha512 = sha512;

},{"87c93fe66805c4b2":"75kFb"}],"75kFb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var digest = require("c1652a21a595dba0");
const from = ({ name, code, encode })=>new Hasher(name, code, encode);
class Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? digest.create(this.code, result) : result.then((digest$1)=>digest.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
exports.Hasher = Hasher;
exports.from = from;

},{"c1652a21a595dba0":"hqnmb"}],"hqnmb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes = require("2b489620e8a505e");
var varint = require("7f2da23f950d1d6e");
const create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = varint.encodingLength(code);
    const digestOffset = sizeOffset + varint.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    varint.encodeTo(code, bytes, 0);
    varint.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new Digest(code, size, digest, bytes);
};
const decode = (multihash)=>{
    const bytes$1 = bytes.coerce(multihash);
    const [code, sizeOffset] = varint.decode(bytes$1);
    const [size, digestOffset] = varint.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new Digest(code, size, digest, bytes$1);
};
const equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && bytes.equals(a.bytes, b.bytes);
};
class Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
exports.Digest = Digest;
exports.create = create;
exports.decode = decode;
exports.equals = equals;

},{"2b489620e8a505e":"5Qtsr","7f2da23f950d1d6e":"fPATb"}],"fPATb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var varint$1 = require("49ac8faca326d517");
const decode = (data, offset = 0)=>{
    const code = varint$1.decode(data, offset);
    return [
        code,
        varint$1.decode.bytes
    ];
};
const encodeTo = (int, target, offset = 0)=>{
    varint$1.encode(int, target, offset);
    return target;
};
const encodingLength = (int)=>{
    return varint$1.encodingLength(int);
};
exports.decode = decode;
exports.encodeTo = encodeTo;
exports.encodingLength = encodingLength;

},{"49ac8faca326d517":"4j7MY"}],"4j7MY":[function(require,module,exports) {
"use strict";
var encode_1 = encode;
var MSB = 128, REST = 127, MSBALL = ~REST, INT = Math.pow(2, 31);
function encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= INT){
        out[offset++] = num & 255 | MSB;
        num /= 128;
    }
    while(num & MSBALL){
        out[offset++] = num & 255 | MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    encode.bytes = offset - oldOffset + 1;
    return out;
}
var decode = read;
var MSB$1 = 128, REST$1 = 127;
function read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & REST$1) << shift : (b & REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= MSB$1);
    read.bytes = counter - offset;
    return res;
}
var N1 = Math.pow(2, 7);
var N2 = Math.pow(2, 14);
var N3 = Math.pow(2, 21);
var N4 = Math.pow(2, 28);
var N5 = Math.pow(2, 35);
var N6 = Math.pow(2, 42);
var N7 = Math.pow(2, 49);
var N8 = Math.pow(2, 56);
var N9 = Math.pow(2, 63);
var length = function(value) {
    return value < N1 ? 1 : value < N2 ? 2 : value < N3 ? 3 : value < N4 ? 4 : value < N5 ? 5 : value < N6 ? 6 : value < N7 ? 7 : value < N8 ? 8 : value < N9 ? 9 : 10;
};
var varint = {
    encode: encode_1,
    decode: decode,
    encodingLength: length
};
var _brrp_varint = varint;
var varint$1 = _brrp_varint;
module.exports = varint$1;

},{}],"jhLGG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes = require("31f761986cad8f87");
var digest$1 = require("28f7d5b97a7f9531");
const code = 0;
const name = "identity";
const encode = bytes.coerce;
const digest = (input)=>digest$1.create(code, encode(input));
const identity = {
    code,
    name,
    encode,
    digest
};
exports.identity = identity;

},{"31f761986cad8f87":"5Qtsr","28f7d5b97a7f9531":"hqnmb"}],"8eqR1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bytes = require("d6ff41dc2ba68cf7");
const name = "raw";
const code = 85;
const encode = (node)=>bytes.coerce(node);
const decode = (data)=>bytes.coerce(data);
exports.code = code;
exports.decode = decode;
exports.encode = encode;
exports.name = name;

},{"d6ff41dc2ba68cf7":"5Qtsr"}],"5yvW8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const name = "json";
const code = 512;
const encode = (node)=>textEncoder.encode(JSON.stringify(node));
const decode = (data)=>JSON.parse(textDecoder.decode(data));
exports.code = code;
exports.decode = decode;
exports.encode = encode;
exports.name = name;

},{}],"nQGzv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var cid = require("ed6c6fe9a905f417");
var varint = require("e06d36b96b5c2352");
var bytes = require("1d23ed7c351b4be9");
var hasher = require("3a38bf5318adcc6f");
var digest = require("4a8c46149de7f8e2");
exports.CID = cid.CID;
exports.varint = varint;
exports.bytes = bytes;
exports.hasher = hasher;
exports.digest = digest;

},{"ed6c6fe9a905f417":"9uUB7","e06d36b96b5c2352":"fPATb","1d23ed7c351b4be9":"5Qtsr","3a38bf5318adcc6f":"75kFb","4a8c46149de7f8e2":"hqnmb"}],"9uUB7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var varint = require("dda600cb6dfe2c14");
var digest = require("e60e0cbf7a7b4441");
var base58 = require("c43bfafc5e72478d");
var base32 = require("d760cfaeab93deb3");
var bytes = require("64a08ea414b56326");
class CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: hidden,
            byteLength: hidden,
            code: readonly,
            version: readonly,
            multihash: readonly,
            bytes: readonly,
            _baseCache: hidden,
            asCID: hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code, multihash } = this;
                    if (code !== DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code, digest: digest$1 } = this.multihash;
                    const multihash = digest.create(code, digest$1);
                    return CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && digest.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes, version, _baseCache } = this;
        switch(version){
            case 0:
                return toStringV0(bytes, _baseCache, base || base58.base58btc.encoder);
            default:
                return toStringV1(bytes, _baseCache, base || base32.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        deprecate(/^0\.0/, IS_CID_DEPRECATION);
        return !!(value && (value[cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof CID) return value;
        else if (value != null && value.asCID === value) {
            const { version, code, multihash, bytes } = value;
            return new CID(version, code, multihash, bytes || encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[cidSymbol] === true) {
            const { version, multihash, code } = value;
            const digest$1 = digest.decode(multihash);
            return CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${DAG_PB_CODE}) block encoding`);
                else return new CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = encodeCID(version, code, digest.bytes);
                    return new CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return CID.create(0, DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = bytes.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new digest.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? CID.createV0(digest$1) : CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = varint.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version,
            codec,
            multihashCode,
            digestSize,
            multihashSize,
            size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = parseCIDtoBytes(source, base);
        const cid = CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || base58.base58btc;
                return [
                    base58.base58btc.prefix,
                    decoder.decode(`${base58.base58btc.prefix}${source}`)
                ];
            }
        case base58.base58btc.prefix:
            {
                const decoder = base || base58.base58btc;
                return [
                    base58.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case base32.base32.prefix:
            {
                const decoder = base || base32.base32;
                return [
                    base32.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const toStringV0 = (bytes, cache, base)=>{
    const { prefix } = base;
    if (prefix !== base58.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const toStringV1 = (bytes, cache, base)=>{
    const { prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const DAG_PB_CODE = 112;
const SHA_256_CODE = 18;
const encodeCID = (version, code, multihash)=>{
    const codeOffset = varint.encodingLength(version);
    const hashOffset = codeOffset + varint.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    varint.encodeTo(version, bytes, 0);
    varint.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const cidSymbol = Symbol.for("@ipld/js-cid/CID");
const readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const version = "0.0.0-dev";
const deprecate = (range, message)=>{
    if (range.test(version)) console.warn(message);
    else throw new Error(message);
};
const IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
exports.CID = CID;

},{"dda600cb6dfe2c14":"fPATb","e60e0cbf7a7b4441":"hqnmb","c43bfafc5e72478d":"hrNmq","d760cfaeab93deb3":"bAXJf","64a08ea414b56326":"5Qtsr"}],"1hHKN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var bases = require("99480b3736a45df8");
var asUint8array = require("eb5ef55ea61da240");
function fromString(string, encoding = "utf8") {
    const base = bases[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return asUint8array.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
exports.fromString = fromString;

},{"99480b3736a45df8":"d8tK4","eb5ef55ea61da240":"9NWaL"}],"2tpuz":[function(require,module,exports) {

},{}],"jCZRI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE10", ()=>J);
parcelHelpers.export(exports, "BASE16", ()=>p);
parcelHelpers.export(exports, "BASE64", ()=>x);
parcelHelpers.export(exports, "COLON", ()=>Gn);
parcelHelpers.export(exports, "DEFAULT_DEPTH", ()=>ne);
parcelHelpers.export(exports, "EMPTY_SPACE", ()=>H);
parcelHelpers.export(exports, "ENV_MAP", ()=>m);
parcelHelpers.export(exports, "MemoryStore", ()=>er);
parcelHelpers.export(exports, "ONE_THOUSAND", ()=>Wn);
parcelHelpers.export(exports, "REACT_NATIVE_PRODUCT", ()=>Ce);
parcelHelpers.export(exports, "RELAYER_DEFAULT_PROTOCOL", ()=>Fe);
parcelHelpers.export(exports, "SDK_TYPE", ()=>je);
parcelHelpers.export(exports, "SLASH", ()=>$e);
parcelHelpers.export(exports, "TYPE_0", ()=>Q);
parcelHelpers.export(exports, "TYPE_1", ()=>_);
parcelHelpers.export(exports, "UTF8", ()=>F);
parcelHelpers.export(exports, "appendToQueryString", ()=>De);
parcelHelpers.export(exports, "assertType", ()=>Zn);
parcelHelpers.export(exports, "buildApprovedNamespaces", ()=>Ut);
parcelHelpers.export(exports, "calcExpiry", ()=>lt);
parcelHelpers.export(exports, "capitalize", ()=>ot);
parcelHelpers.export(exports, "capitalizeWord", ()=>xe);
parcelHelpers.export(exports, "createDelayedPromise", ()=>st);
parcelHelpers.export(exports, "createExpiringPromise", ()=>it);
parcelHelpers.export(exports, "decodeTypeByte", ()=>$);
parcelHelpers.export(exports, "decrypt", ()=>Ln);
parcelHelpers.export(exports, "deriveSymKey", ()=>kn);
parcelHelpers.export(exports, "deserialize", ()=>ee);
parcelHelpers.export(exports, "encodeTypeByte", ()=>Pe);
parcelHelpers.export(exports, "encrypt", ()=>Kn);
parcelHelpers.export(exports, "engineEvent", ()=>ft);
parcelHelpers.export(exports, "enumify", ()=>rt);
parcelHelpers.export(exports, "formatAccountId", ()=>Ee);
parcelHelpers.export(exports, "formatAccountWithChain", ()=>Pn);
parcelHelpers.export(exports, "formatChainId", ()=>ge);
parcelHelpers.export(exports, "formatExpirerTarget", ()=>re);
parcelHelpers.export(exports, "formatIdTarget", ()=>at);
parcelHelpers.export(exports, "formatMessage", ()=>Cn);
parcelHelpers.export(exports, "formatMessageContext", ()=>Xn);
parcelHelpers.export(exports, "formatRelayParams", ()=>We);
parcelHelpers.export(exports, "formatRelayRpcUrl", ()=>Jn);
parcelHelpers.export(exports, "formatTopicTarget", ()=>ct);
parcelHelpers.export(exports, "formatUA", ()=>Me);
parcelHelpers.export(exports, "formatUri", ()=>Nt);
parcelHelpers.export(exports, "generateKeyPair", ()=>jn);
parcelHelpers.export(exports, "generateRandomBytes32", ()=>Dn);
parcelHelpers.export(exports, "getAccountsChains", ()=>A);
parcelHelpers.export(exports, "getAccountsFromNamespaces", ()=>Rn);
parcelHelpers.export(exports, "getAddressFromAccount", ()=>be);
parcelHelpers.export(exports, "getAddressesFromAccounts", ()=>Tn);
parcelHelpers.export(exports, "getAppMetadata", ()=>zn);
parcelHelpers.export(exports, "getBrowserOnlineStatus", ()=>dn);
parcelHelpers.export(exports, "getChainFromAccount", ()=>Ne);
parcelHelpers.export(exports, "getChainsFromAccounts", ()=>Oe);
parcelHelpers.export(exports, "getChainsFromNamespace", ()=>K);
parcelHelpers.export(exports, "getChainsFromNamespaces", ()=>An);
parcelHelpers.export(exports, "getChainsFromRequiredNamespaces", ()=>Un);
parcelHelpers.export(exports, "getDidAddress", ()=>we);
parcelHelpers.export(exports, "getDidAddressSegments", ()=>L);
parcelHelpers.export(exports, "getDidChainId", ()=>Se);
parcelHelpers.export(exports, "getEnvironment", ()=>R);
parcelHelpers.export(exports, "getHttpUrl", ()=>Qn);
parcelHelpers.export(exports, "getInternalError", ()=>N);
parcelHelpers.export(exports, "getJavascriptID", ()=>Ve);
parcelHelpers.export(exports, "getJavascriptOS", ()=>ke);
parcelHelpers.export(exports, "getLastItems", ()=>Le);
parcelHelpers.export(exports, "getNamespacedDidChainId", ()=>_n);
parcelHelpers.export(exports, "getNamespacesChains", ()=>Je);
parcelHelpers.export(exports, "getNamespacesEventsForChainId", ()=>Ze);
parcelHelpers.export(exports, "getNamespacesMethodsForChainId", ()=>Qe);
parcelHelpers.export(exports, "getNodeOnlineStatus", ()=>pn);
parcelHelpers.export(exports, "getReactNativeOnlineStatus", ()=>fn);
parcelHelpers.export(exports, "getRelayClientMetadata", ()=>Yn);
parcelHelpers.export(exports, "getRelayProtocolApi", ()=>yt);
parcelHelpers.export(exports, "getRelayProtocolName", ()=>mt);
parcelHelpers.export(exports, "getRequiredNamespacesFromNamespaces", ()=>At);
parcelHelpers.export(exports, "getSdkError", ()=>U);
parcelHelpers.export(exports, "getUniqueValues", ()=>Y);
parcelHelpers.export(exports, "handleDeeplinkRedirect", ()=>pt);
parcelHelpers.export(exports, "hasOverlap", ()=>O);
parcelHelpers.export(exports, "hashKey", ()=>Vn);
parcelHelpers.export(exports, "hashMessage", ()=>Mn);
parcelHelpers.export(exports, "isBrowser", ()=>q);
parcelHelpers.export(exports, "isCaipNamespace", ()=>oe);
parcelHelpers.export(exports, "isConformingNamespaces", ()=>un);
parcelHelpers.export(exports, "isExpired", ()=>dt);
parcelHelpers.export(exports, "isNode", ()=>te);
parcelHelpers.export(exports, "isOnline", ()=>Zt);
parcelHelpers.export(exports, "isProposalStruct", ()=>Dt);
parcelHelpers.export(exports, "isReactNative", ()=>j);
parcelHelpers.export(exports, "isSessionCompatible", ()=>$t);
parcelHelpers.export(exports, "isSessionStruct", ()=>kt);
parcelHelpers.export(exports, "isTypeOneEnvelope", ()=>Fn);
parcelHelpers.export(exports, "isUndefined", ()=>w);
parcelHelpers.export(exports, "isValidAccountId", ()=>en);
parcelHelpers.export(exports, "isValidAccounts", ()=>rn);
parcelHelpers.export(exports, "isValidActions", ()=>sn);
parcelHelpers.export(exports, "isValidArray", ()=>D);
parcelHelpers.export(exports, "isValidChainId", ()=>k);
parcelHelpers.export(exports, "isValidChains", ()=>nn);
parcelHelpers.export(exports, "isValidController", ()=>Vt);
parcelHelpers.export(exports, "isValidErrorReason", ()=>Ft);
parcelHelpers.export(exports, "isValidEvent", ()=>Bt);
parcelHelpers.export(exports, "isValidId", ()=>Lt);
parcelHelpers.export(exports, "isValidNamespaceAccounts", ()=>on);
parcelHelpers.export(exports, "isValidNamespaceActions", ()=>ce);
parcelHelpers.export(exports, "isValidNamespaceChains", ()=>tn);
parcelHelpers.export(exports, "isValidNamespaceMethodsOrEvents", ()=>ie);
parcelHelpers.export(exports, "isValidNamespaces", ()=>cn);
parcelHelpers.export(exports, "isValidNamespacesChainId", ()=>Gt);
parcelHelpers.export(exports, "isValidNamespacesEvent", ()=>zt);
parcelHelpers.export(exports, "isValidNamespacesRequest", ()=>Wt);
parcelHelpers.export(exports, "isValidNumber", ()=>G);
parcelHelpers.export(exports, "isValidObject", ()=>B);
parcelHelpers.export(exports, "isValidParams", ()=>xt);
parcelHelpers.export(exports, "isValidRelay", ()=>an);
parcelHelpers.export(exports, "isValidRelays", ()=>Kt);
parcelHelpers.export(exports, "isValidRequest", ()=>Ht);
parcelHelpers.export(exports, "isValidRequestExpiry", ()=>Qt);
parcelHelpers.export(exports, "isValidRequiredNamespaces", ()=>Mt);
parcelHelpers.export(exports, "isValidResponse", ()=>qt);
parcelHelpers.export(exports, "isValidString", ()=>h);
parcelHelpers.export(exports, "isValidUrl", ()=>jt);
parcelHelpers.export(exports, "mapEntries", ()=>tt);
parcelHelpers.export(exports, "mapToObj", ()=>et);
parcelHelpers.export(exports, "mergeArrays", ()=>S);
parcelHelpers.export(exports, "normalizeNamespaces", ()=>se);
parcelHelpers.export(exports, "objToMap", ()=>nt);
parcelHelpers.export(exports, "parseAccountId", ()=>z);
parcelHelpers.export(exports, "parseChainId", ()=>ve);
parcelHelpers.export(exports, "parseContextNames", ()=>Ke);
parcelHelpers.export(exports, "parseExpirerTarget", ()=>ut);
parcelHelpers.export(exports, "parseNamespaceKey", ()=>Xe);
parcelHelpers.export(exports, "parseRelayParams", ()=>Be);
parcelHelpers.export(exports, "parseTopic", ()=>Ge);
parcelHelpers.export(exports, "parseUri", ()=>bt);
parcelHelpers.export(exports, "serialize", ()=>Te);
parcelHelpers.export(exports, "subscribeToBrowserNetworkChange", ()=>mn);
parcelHelpers.export(exports, "subscribeToNetworkChange", ()=>Xt);
parcelHelpers.export(exports, "subscribeToReactNativeNetworkChange", ()=>yn);
parcelHelpers.export(exports, "validateDecoding", ()=>xn);
parcelHelpers.export(exports, "validateEncoding", ()=>Re);
var _chacha20Poly1305 = require("@stablelib/chacha20poly1305");
var _hkdf = require("@stablelib/hkdf");
var _random = require("@stablelib/random");
var _sha256 = require("@stablelib/sha256");
var _x25519 = require("@stablelib/x25519");
var _uint8Arrays = require("uint8arrays");
var _detectBrowser = require("detect-browser");
var _time = require("@walletconnect/time");
var _windowGetters = require("@walletconnect/window-getters");
var _windowMetadata = require("@walletconnect/window-metadata");
var _queryString = require("query-string");
var _relayApi = require("@walletconnect/relay-api");
var process = require("8f49c8c44d164f1a");
var global = arguments[3];
const M = ":";
function ve(e) {
    const [n, t] = e.split(M);
    return {
        namespace: n,
        reference: t
    };
}
function ge(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join(M);
}
function z(e) {
    const [n, t, r] = e.split(M);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function Ee(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join(M);
}
function Y(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function be(e) {
    const { address: n } = z(e);
    return n;
}
function Ne(e) {
    const { namespace: n, reference: t } = z(e);
    return ge({
        namespace: n,
        reference: t
    });
}
function Pn(e, n) {
    const { namespace: t, reference: r } = ve(n);
    return Ee({
        namespace: t,
        reference: r,
        address: e
    });
}
function Tn(e) {
    return Y(e, be);
}
function Oe(e) {
    return Y(e, Ne);
}
function Rn(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function An(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...Oe(o.accounts));
    }), t;
}
function Un(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...K(r, o));
    }), t;
}
function K(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const L = (e)=>e?.split(":"), Se = (e)=>{
    const n = e && L(e);
    if (n) return n[3];
}, _n = (e)=>{
    const n = e && L(e);
    if (n) return n[2] + ":" + n[3];
}, we = (e)=>{
    const n = e && L(e);
    if (n) return n.pop();
}, Cn = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = we(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, l = `Chain ID: ${Se(n)}`, d = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        l,
        d,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, J = "base10", p = "base16", x = "base64pad", F = "utf8", Q = 0, _ = 1, $n = 0, Ie = 1, Z = 12, X = 32;
function jn() {
    const e = _x25519.generateKeyPair();
    return {
        privateKey: (0, _uint8Arrays.toString)(e.secretKey, p),
        publicKey: (0, _uint8Arrays.toString)(e.publicKey, p)
    };
}
function Dn() {
    const e = (0, _random.randomBytes)(X);
    return (0, _uint8Arrays.toString)(e, p);
}
function kn(e, n) {
    const t = _x25519.sharedKey((0, _uint8Arrays.fromString)(e, p), (0, _uint8Arrays.fromString)(n, p), !0), r = new (0, _hkdf.HKDF)((0, _sha256.SHA256), t).expand(X);
    return (0, _uint8Arrays.toString)(r, p);
}
function Vn(e) {
    const n = (0, _sha256.hash)((0, _uint8Arrays.fromString)(e, p));
    return (0, _uint8Arrays.toString)(n, p);
}
function Mn(e) {
    const n = (0, _sha256.hash)((0, _uint8Arrays.fromString)(e, F));
    return (0, _uint8Arrays.toString)(n, p);
}
function Pe(e) {
    return (0, _uint8Arrays.fromString)(`${e}`, J);
}
function $(e) {
    return Number((0, _uint8Arrays.toString)(e, J));
}
function Kn(e) {
    const n = Pe(typeof e.type < "u" ? e.type : Q);
    if ($(n) === _ && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, _uint8Arrays.fromString)(e.senderPublicKey, p) : void 0, r = typeof e.iv < "u" ? (0, _uint8Arrays.fromString)(e.iv, p) : (0, _random.randomBytes)(Z), o = new (0, _chacha20Poly1305.ChaCha20Poly1305)((0, _uint8Arrays.fromString)(e.symKey, p)).seal(r, (0, _uint8Arrays.fromString)(e.message, F));
    return Te({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function Ln(e) {
    const n = new (0, _chacha20Poly1305.ChaCha20Poly1305)((0, _uint8Arrays.fromString)(e.symKey, p)), { sealed: t, iv: r } = ee(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, _uint8Arrays.toString)(o, F);
}
function Te(e) {
    if ($(e.type) === _) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, _uint8Arrays.toString)((0, _uint8Arrays.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), x);
    }
    return (0, _uint8Arrays.toString)((0, _uint8Arrays.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), x);
}
function ee(e) {
    const n = (0, _uint8Arrays.fromString)(e, x), t = n.slice($n, Ie), r = Ie;
    if ($(t) === _) {
        const l = r + X, d = l + Z, c = n.slice(r, l), u = n.slice(l, d), a = n.slice(d);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function xn(e, n) {
    const t = ee(e);
    return Re({
        type: $(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, _uint8Arrays.toString)(t.senderPublicKey, p) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function Re(e) {
    const n = e?.type || Q;
    if (n === _) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function Fn(e) {
    return e.type === _ && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var Hn = Object.defineProperty, Ae = Object.getOwnPropertySymbols, qn = Object.prototype.hasOwnProperty, Bn = Object.prototype.propertyIsEnumerable, Ue = (e, n, t)=>n in e ? Hn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, _e = (e, n)=>{
    for(var t in n || (n = {}))qn.call(n, t) && Ue(e, t, n[t]);
    if (Ae) for (var t of Ae(n))Bn.call(n, t) && Ue(e, t, n[t]);
    return e;
};
const Ce = "ReactNative", m = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, H = " ", Gn = ":", $e = "/", ne = 2, Wn = 1e3, je = "js";
function te() {
    return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function j() {
    return !(0, _windowGetters.getDocument)() && !!(0, _windowGetters.getNavigator)() && navigator.product === Ce;
}
function q() {
    return !te() && !!(0, _windowGetters.getNavigator)();
}
function R() {
    return j() ? m.reactNative : te() ? m.node : q() ? m.browser : m.unknown;
}
function De(e, n) {
    let t = _queryString.parse(e);
    return t = _e(_e({}, t), n), e = _queryString.stringify(t), e;
}
function zn() {
    return (0, _windowMetadata.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function Yn(e, n) {
    var t;
    const r = R(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, _windowGetters.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function ke() {
    if (R() === m.reactNative && typeof global < "u" && typeof (global == null ? void 0 : global.Platform) < "u") {
        const { OS: t, Version: r } = global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, _detectBrowser.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function Ve() {
    var e;
    const n = R();
    return n === m.browser ? [
        n,
        ((e = (0, _windowGetters.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function Me(e, n, t) {
    const r = ke(), o = Ve();
    return [
        [
            e,
            n
        ].join("-"),
        [
            je,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function Jn({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i }) {
    const l = t.split("?"), d = Me(e, n, r), c = {
        auth: o,
        ua: d,
        projectId: s,
        useOnCloseEvent: i || void 0
    }, u = De(l[1] || "", c);
    return l[0] + "?" + u;
}
function Qn(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function Zn(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function Ke(e, n = ne) {
    return Le(e.split($e), n);
}
function Xn(e) {
    return Ke(e).join(H);
}
function O(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function Le(e, n = ne) {
    return e.slice(Math.max(e.length - n, 0));
}
function et(e) {
    return Object.fromEntries(e.entries());
}
function nt(e) {
    return new Map(Object.entries(e));
}
function tt(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const rt = (e)=>e;
function xe(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function ot(e) {
    return e.split(H).map((n)=>xe(n)).join(H);
}
function st(e = (0, _time.FIVE_MINUTES), n) {
    const t = (0, _time.toMiliseconds)(e || (0, _time.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, l)=>{
                s = setTimeout(()=>{
                    l(new Error(n));
                }, t), r = i, o = l;
            })
    };
}
function it(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function re(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function ct(e) {
    return re("topic", e);
}
function at(e) {
    return re("id", e);
}
function ut(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function lt(e, n) {
    return (0, _time.fromMiliseconds)((n || Date.now()) + (0, _time.toMiliseconds)(e));
}
function dt(e) {
    return Date.now() >= (0, _time.toMiliseconds)(e);
}
function ft(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function S(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function pt({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = R();
        i === m.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === m.reactNative && typeof (global == null ? void 0 : global.Linking) < "u" && await global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
const Fe = "irn";
function mt(e) {
    return e?.relay || {
        protocol: Fe
    };
}
function yt(e) {
    const n = (0, _relayApi.RELAY_JSONRPC)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var ht = Object.defineProperty, He = Object.getOwnPropertySymbols, vt = Object.prototype.hasOwnProperty, gt = Object.prototype.propertyIsEnumerable, qe = (e, n, t)=>n in e ? ht(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, Et = (e, n)=>{
    for(var t in n || (n = {}))vt.call(n, t) && qe(e, t, n[t]);
    if (He) for (var t of He(n))gt.call(n, t) && qe(e, t, n[t]);
    return e;
};
function Be(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function bt(e) {
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = _queryString.parse(s);
    return {
        protocol: r,
        topic: Ge(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: Be(i)
    };
}
function Ge(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function We(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function Nt(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + _queryString.stringify(Et({
        symKey: e.symKey
    }, We(e.relay)));
}
var Ot = Object.defineProperty, St = Object.defineProperties, wt = Object.getOwnPropertyDescriptors, ze = Object.getOwnPropertySymbols, It = Object.prototype.hasOwnProperty, Pt = Object.prototype.propertyIsEnumerable, Ye = (e, n, t)=>n in e ? Ot(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, Tt = (e, n)=>{
    for(var t in n || (n = {}))It.call(n, t) && Ye(e, t, n[t]);
    if (ze) for (var t of ze(n))Pt.call(n, t) && Ye(e, t, n[t]);
    return e;
}, Rt = (e, n)=>St(e, wt(n));
function A(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function Je(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...A(t.accounts));
    }), n;
}
function Qe(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        A(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function Ze(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        A(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function At(e, n) {
    const t = cn(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function Ut(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = se(n), s = se(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const l = un(n, i, "approve()");
    if (l) throw new Error(l.message);
    const d = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, v;
            return (v = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : v.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, v;
            return (v = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : v.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, v;
            return (v = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : v.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        d[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const v = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((P)=>r[c].chains.includes(P)), hn = r[c].methods.filter((P)=>{
            var T, C;
            return (C = (T = s[c]) == null ? void 0 : T.methods) == null ? void 0 : C.includes(P);
        }), vn = r[c].events.filter((P)=>{
            var T, C;
            return (C = (T = s[c]) == null ? void 0 : T.events) == null ? void 0 : C.includes(P);
        }), gn = v?.map((P)=>r[c].accounts.filter((T)=>T.includes(`${P}:`))).flat();
        d[c] = {
            chains: S((b = d[c]) == null ? void 0 : b.chains, v),
            methods: S((I = d[c]) == null ? void 0 : I.methods, hn),
            events: S((y = d[c]) == null ? void 0 : y.events, vn),
            accounts: S((f = d[c]) == null ? void 0 : f.accounts, gn)
        };
    }), d);
}
function oe(e) {
    return e.includes(":");
}
function Xe(e) {
    return oe(e) ? e.split(":")[0] : e;
}
function se(e) {
    var n, t, r;
    const o = {};
    if (!B(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const l = oe(s) ? [
            s
        ] : i.chains, d = i.methods || [], c = i.events || [], u = Xe(s);
        o[u] = Rt(Tt({}, o[u]), {
            chains: S(l, (n = o[u]) == null ? void 0 : n.chains),
            methods: S(d, (t = o[u]) == null ? void 0 : t.methods),
            events: S(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const _t = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, Ct = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function N(e, n) {
    const { message: t, code: r } = Ct[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function U(e, n) {
    const { message: t, code: r } = _t[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function D(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function B(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function w(e) {
    return typeof e > "u";
}
function h(e, n) {
    return n && w(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function G(e, n) {
    return n && w(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $t(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return O(o, r) ? (r.forEach((i)=>{
        const { accounts: l, methods: d, events: c } = e.namespaces[i], u = A(l), a = t[i];
        (!O(K(i, a), u) || !O(a.methods, d) || !O(a.events, c)) && (s = !1);
    }), s) : !1;
}
function k(e) {
    return h(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function en(e) {
    if (h(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && k(t);
        }
    }
    return !1;
}
function jt(e) {
    if (h(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function Dt(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function kt(e) {
    return e?.topic;
}
function Vt(e, n) {
    let t = null;
    return h(e?.publicKey, !1) || (t = N("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function ie(e) {
    let n = !0;
    return D(e) ? e.length && (n = e.every((t)=>h(t, !1))) : n = !1, n;
}
function nn(e, n, t) {
    let r = null;
    return D(n) && n.length ? n.forEach((o)=>{
        r || k(o) || (r = U("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : k(e) || (r = U("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function tn(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = nn(o, K(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function rn(e, n) {
    let t = null;
    return D(e) ? e.forEach((r)=>{
        t || en(r) || (t = U("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = U("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function on(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = rn(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function sn(e, n) {
    let t = null;
    return ie(e?.methods) ? ie(e?.events) || (t = U("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = U("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function ce(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = sn(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function Mt(e, n, t) {
    let r = null;
    if (e && B(e)) {
        const o = ce(e, n);
        o && (r = o);
        const s = tn(e, n, t);
        s && (r = s);
    } else r = N("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function cn(e, n) {
    let t = null;
    if (e && B(e)) {
        const r = ce(e, n);
        r && (t = r);
        const o = on(e, n);
        o && (t = o);
    } else t = N("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function an(e) {
    return h(e.protocol, !0);
}
function Kt(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && D(e) && e.length && e.forEach((r)=>{
        t = an(r);
    }), t;
}
function Lt(e) {
    return typeof e == "number";
}
function xt(e) {
    return typeof e < "u" && true;
}
function Ft(e) {
    return !(!e || typeof e != "object" || !e.code || !G(e.code, !1) || !e.message || !h(e.message, !1));
}
function Ht(e) {
    return !(w(e) || !h(e.method, !1));
}
function qt(e) {
    return !(w(e) || w(e.result) && w(e.error) || !G(e.id, !1) || !h(e.jsonrpc, !1));
}
function Bt(e) {
    return !(w(e) || !h(e.name, !1));
}
function Gt(e, n) {
    return !(!k(n) || !Je(e).includes(n));
}
function Wt(e, n, t) {
    return h(t, !1) ? Qe(e, n).includes(t) : !1;
}
function zt(e, n, t) {
    return h(t, !1) ? Ze(e, n).includes(t) : !1;
}
function un(e, n, t) {
    let r = null;
    const o = Yt(e), s = Jt(n), i = Object.keys(o), l = Object.keys(s), d = ln(Object.keys(e)), c = ln(Object.keys(n)), u = d.filter((a)=>!c.includes(a));
    return u.length && (r = N("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), O(i, l) || (r = N("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${l.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = A(n[a].accounts);
        b.includes(a) || (r = N("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || (O(o[a].methods, s[a].methods) ? O(o[a].events, s[a].events) || (r = N("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = N("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function Yt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function ln(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function Jt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = A(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function Qt(e, n) {
    return G(e, !1) && e <= n.max && e >= n.min;
}
function Zt() {
    const e = R();
    return new Promise((n)=>{
        switch(e){
            case m.browser:
                n(dn());
                break;
            case m.reactNative:
                n(fn());
                break;
            case m.node:
                n(pn());
                break;
            default:
                n(!0);
        }
    });
}
function dn() {
    return q() && navigator?.onLine;
}
async function fn() {
    if (j() && typeof global < "u" && global != null && global.NetInfo) {
        const e = await (global == null ? void 0 : global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function pn() {
    return !0;
}
function Xt(e) {
    switch(R()){
        case m.browser:
            mn(e);
            break;
        case m.reactNative:
            yn(e);
            break;
        case m.node:
            break;
    }
}
function mn(e) {
    !j() && q() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function yn(e) {
    j() && typeof global < "u" && global != null && global.NetInfo && global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const ae = {};
class er {
    static get(n) {
        return ae[n];
    }
    static set(n, t) {
        ae[n] = t;
    }
    static delete(n) {
        delete ae[n];
    }
}

},{"8f49c8c44d164f1a":"5QIF0","@stablelib/chacha20poly1305":"fvIje","@stablelib/hkdf":"5e0Kn","@stablelib/random":"fE2oh","@stablelib/sha256":"rfUtC","@stablelib/x25519":"hrpSa","uint8arrays":"lR9lT","detect-browser":"CIp0q","@walletconnect/time":"gEfho","@walletconnect/window-getters":"igbNt","@walletconnect/window-metadata":"5mGkl","query-string":"hj0FI","@walletconnect/relay-api":"ftlSX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fvIje":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
var chacha_1 = require("976b3a8516087e36");
var poly1305_1 = require("57a2241b5ee7deb");
var wipe_1 = require("8b783944859565b4");
var binary_1 = require("24cadc9e6036331e");
var constant_time_1 = require("ee9deaa41a7b3163");
exports.KEY_LENGTH = 32;
exports.NONCE_LENGTH = 12;
exports.TAG_LENGTH = 16;
var ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = exports.NONCE_LENGTH;
        this.tagLength = exports.TAG_LENGTH;
        if (key.length !== exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        chacha_1.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        chacha_1.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        wipe_1.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        chacha_1.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!constant_time_1.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        chacha_1.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        wipe_1.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        wipe_1.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new poly1305_1.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update(ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update(ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) binary_1.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        binary_1.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        wipe_1.wipe(tag);
        wipe_1.wipe(length);
    };
    return ChaCha20Poly1305;
}();
exports.ChaCha20Poly1305 = ChaCha20Poly1305;

},{"976b3a8516087e36":"jvQnB","57a2241b5ee7deb":"jf2Ik","8b783944859565b4":"2ar8l","24cadc9e6036331e":"8KUxR","ee9deaa41a7b3163":"1ffoM"}],"jvQnB":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package chacha implements ChaCha stream cipher.
 */ var binary_1 = require("b4d5bb4e33f3d915");
var wipe_1 = require("490004a374088624");
// Number of ChaCha rounds (ChaCha20).
var ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    binary_1.writeUint32LE(x0 + j0 | 0, out, 0);
    binary_1.writeUint32LE(x1 + j1 | 0, out, 4);
    binary_1.writeUint32LE(x2 + j2 | 0, out, 8);
    binary_1.writeUint32LE(x3 + j3 | 0, out, 12);
    binary_1.writeUint32LE(x4 + j4 | 0, out, 16);
    binary_1.writeUint32LE(x5 + j5 | 0, out, 20);
    binary_1.writeUint32LE(x6 + j6 | 0, out, 24);
    binary_1.writeUint32LE(x7 + j7 | 0, out, 28);
    binary_1.writeUint32LE(x8 + j8 | 0, out, 32);
    binary_1.writeUint32LE(x9 + j9 | 0, out, 36);
    binary_1.writeUint32LE(x10 + j10 | 0, out, 40);
    binary_1.writeUint32LE(x11 + j11 | 0, out, 44);
    binary_1.writeUint32LE(x12 + j12 | 0, out, 48);
    binary_1.writeUint32LE(x13 + j13 | 0, out, 52);
    binary_1.writeUint32LE(x14 + j14 | 0, out, 56);
    binary_1.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    wipe_1.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    wipe_1.wipe(nc);
    return dst;
}
exports.streamXOR = streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    wipe_1.wipe(dst);
    return streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
exports.stream = stream;
function incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

},{"b4d5bb4e33f3d915":"8KUxR","490004a374088624":"2ar8l"}],"jf2Ik":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package poly1305 implements Poly1305 one-time message authentication algorithm.
 */ var constant_time_1 = require("cb036ce5a49ec1dc");
var wipe_1 = require("9bf833f3949af496");
exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        wipe_1.wipe(this._buffer);
        wipe_1.wipe(this._r);
        wipe_1.wipe(this._h);
        wipe_1.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
exports.Poly1305 = Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function oneTimeAuth(key, data) {
    var h = new Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
exports.oneTimeAuth = oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function equal(a, b) {
    if (a.length !== exports.DIGEST_LENGTH || b.length !== exports.DIGEST_LENGTH) return false;
    return constant_time_1.equal(a, b);
}
exports.equal = equal;

},{"cb036ce5a49ec1dc":"1ffoM","9bf833f3949af496":"2ar8l"}],"1ffoM":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
exports.select = select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
exports.lessOrEqual = lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
exports.compare = compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return compare(a, b) !== 0;
}
exports.equal = equal;

},{}],"5e0Kn":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
var hmac_1 = require("22c3fefd76d432c6");
var wipe_1 = require("770fdc9a318be753");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = hmac_1.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new hmac_1.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        wipe_1.wipe(this._buffer);
        wipe_1.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
exports.HKDF = HKDF; // TODO(dchest): maybe implement deriveKey?

},{"22c3fefd76d432c6":"cZdUk","770fdc9a318be753":"2ar8l"}],"cZdUk":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Package hmac implements HMAC algorithm.
 */ var hash_1 = require("a5edd28b38653eb1");
var constant_time_1 = require("e8efa35f4b1e37ac");
var wipe_1 = require("40d3514c50dd920b");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if (hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        wipe_1.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if (hash_1.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if (hash_1.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!hash_1.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!hash_1.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
exports.HMAC = HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function hmac(hash, key, data) {
    var h = new HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
exports.hmac = hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ exports.equal = constant_time_1.equal;

},{"a5edd28b38653eb1":"6JtsL","e8efa35f4b1e37ac":"1ffoM","40d3514c50dd920b":"2ar8l"}],"6JtsL":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
function isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
exports.isSerializableHash = isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

},{}],"rfUtC":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
var binary_1 = require("7becd44fc0145972");
var wipe_1 = require("8812ec0d6d863ba9");
exports.DIGEST_LENGTH = 32;
exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        wipe_1.wipe(this._buffer);
        wipe_1.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            binary_1.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            binary_1.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)binary_1.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        wipe_1.wipe(savedState.state);
        if (savedState.buffer) wipe_1.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
exports.SHA256 = SHA256;
// Constants
var K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = binary_1.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function hash(data) {
    var h = new SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
exports.hash = hash;

},{"7becd44fc0145972":"8KUxR","8812ec0d6d863ba9":"2ar8l"}],"hrpSa":[function(require,module,exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sharedKey = exports.generateKeyPair = exports.generateKeyPairFromSeed = exports.scalarMultBase = exports.scalarMult = exports.SHARED_KEY_LENGTH = exports.SECRET_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = void 0;
/**
 * Package x25519 implements X25519 key agreement.
 */ const random_1 = require("bbd92447c4dc8a5b");
const wipe_1 = require("9037f94747cb188");
exports.PUBLIC_KEY_LENGTH = 32;
exports.SECRET_KEY_LENGTH = 32;
exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const _9 = new Uint8Array(32);
_9[0] = 9;
const _121665 = gf([
    0xdb41,
    1
]);
function car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function pack25519(o, n) {
    const m = gf();
    const t = gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    car25519(t);
    car25519(t);
    car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function square(o, a) {
    mul(o, a, a);
}
function inv25519(o, inp) {
    const c = gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        square(c, c);
        if (i !== 2 && i !== 4) mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        sel25519(a, b, r);
        sel25519(c, d, r);
        add(e, a, c);
        sub(a, a, c);
        add(c, b, d);
        sub(b, b, d);
        square(d, e);
        square(f, a);
        mul(a, c, a);
        mul(c, b, e);
        add(e, a, c);
        sub(a, a, c);
        square(b, a);
        sub(c, d, f);
        mul(a, c, _121665);
        add(a, a, d);
        mul(c, c, a);
        mul(a, d, f);
        mul(d, b, x);
        square(b, e);
        sel25519(a, b, r);
        sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    inv25519(x32, x32);
    mul(x16, x16, x32);
    const q = new Uint8Array(32);
    pack25519(q, x16);
    return q;
}
exports.scalarMult = scalarMult;
function scalarMultBase(n) {
    return scalarMult(n, _9);
}
exports.scalarMultBase = scalarMultBase;
function generateKeyPairFromSeed(seed) {
    if (seed.length !== exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = scalarMultBase(secretKey);
    return {
        publicKey,
        secretKey
    };
}
exports.generateKeyPairFromSeed = generateKeyPairFromSeed;
function generateKeyPair(prng) {
    const seed = (0, random_1.randomBytes)(32, prng);
    const result = generateKeyPairFromSeed(seed);
    (0, wipe_1.wipe)(seed);
    return result;
}
exports.generateKeyPair = generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
exports.sharedKey = sharedKey;

},{"bbd92447c4dc8a5b":"fE2oh","9037f94747cb188":"2ar8l"}],"lR9lT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var compare = require("2723be925479f9b5");
var concat = require("55601d17c951cece");
var equals = require("d6e785ac4c89a0f4");
var fromString = require("6d9691200c10f5ac");
var toString = require("4f7d775db91966d");
var xor = require("6b9ec6020595ff59");
exports.compare = compare.compare;
exports.concat = concat.concat;
exports.equals = equals.equals;
exports.fromString = fromString.fromString;
exports.toString = toString.toString;
exports.xor = xor.xor;

},{"2723be925479f9b5":"hkFht","55601d17c951cece":"e9PFn","d6e785ac4c89a0f4":"5nyaU","6d9691200c10f5ac":"1hHKN","4f7d775db91966d":"ghV7c","6b9ec6020595ff59":"b3kWy"}],"hkFht":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
exports.compare = compare;

},{}],"5nyaU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
exports.equals = equals;

},{}],"b3kWy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var alloc = require("5ecf3f805859c86c");
var asUint8array = require("d29a2106a1bb84dc");
function xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = alloc.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return asUint8array.asUint8Array(result);
}
exports.xor = xor;

},{"5ecf3f805859c86c":"fmsfL","d29a2106a1bb84dc":"9NWaL"}],"CIp0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserInfo", ()=>BrowserInfo);
parcelHelpers.export(exports, "NodeInfo", ()=>NodeInfo);
parcelHelpers.export(exports, "SearchBotDeviceInfo", ()=>SearchBotDeviceInfo);
parcelHelpers.export(exports, "BotInfo", ()=>BotInfo);
parcelHelpers.export(exports, "ReactNativeInfo", ()=>ReactNativeInfo);
parcelHelpers.export(exports, "detect", ()=>detect);
parcelHelpers.export(exports, "browserName", ()=>browserName);
parcelHelpers.export(exports, "parseUserAgent", ()=>parseUserAgent);
parcelHelpers.export(exports, "detectOS", ()=>detectOS);
parcelHelpers.export(exports, "getNodeVersion", ()=>getNodeVersion);
var process = require("333d4e2381a056a9");
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = process.platform;
    }
    return NodeInfo;
}();
var SearchBotDeviceInfo = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var BotInfo = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var ReactNativeInfo = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        SEARCHBOX_UA_REGEX
    ]
];
var operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function detect(userAgent) {
    if (!!userAgent) return parseUserAgent(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new ReactNativeInfo();
    if (typeof navigator !== "undefined") return parseUserAgent(navigator.userAgent);
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new BotInfo();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) versionParts = __spreadArray(__spreadArray([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for(var ii = 0, count = operatingSystemRules.length; ii < count; ii++){
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== "undefined" && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

},{"333d4e2381a056a9":"5QIF0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"igbNt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocalStorage = exports.getLocalStorageOrThrow = exports.getCrypto = exports.getCryptoOrThrow = exports.getLocation = exports.getLocationOrThrow = exports.getNavigator = exports.getNavigatorOrThrow = exports.getDocument = exports.getDocumentOrThrow = exports.getFromWindowOrThrow = exports.getFromWindow = void 0;
function getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
exports.getFromWindow = getFromWindow;
function getFromWindowOrThrow(name) {
    const res = getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
exports.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
    return getFromWindowOrThrow("document");
}
exports.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
    return getFromWindow("document");
}
exports.getDocument = getDocument;
function getNavigatorOrThrow() {
    return getFromWindowOrThrow("navigator");
}
exports.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
    return getFromWindow("navigator");
}
exports.getNavigator = getNavigator;
function getLocationOrThrow() {
    return getFromWindowOrThrow("location");
}
exports.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
    return getFromWindow("location");
}
exports.getLocation = getLocation;
function getCryptoOrThrow() {
    return getFromWindowOrThrow("crypto");
}
exports.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
    return getFromWindow("crypto");
}
exports.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
    return getFromWindowOrThrow("localStorage");
}
exports.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
    return getFromWindow("localStorage");
}
exports.getLocalStorage = getLocalStorage;

},{}],"5mGkl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWindowMetadata = void 0;
const window_getters_1 = require("17ee693c665ef3c1");
function getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = window_getters_1.getDocumentOrThrow();
        loc = window_getters_1.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description,
        url,
        icons,
        name
    };
    return meta;
}
exports.getWindowMetadata = getWindowMetadata;

},{"17ee693c665ef3c1":"igbNt"}],"hj0FI":[function(require,module,exports) {
"use strict";
const strictUriEncode = require("58554573f6177552");
const decodeComponent = require("ba17965db0c7aff3");
const splitOnFirst = require("51b8bc47184070a5");
const filterObject = require("5c22cf306a783d1");
const isNullOrUndefined = (value)=>value === null || value === undefined;
const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            encode(index, options),
                            "]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            ":list=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                encode(key, options),
                                keyValueSep,
                                encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
exports.parseUrl = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = splitOnFirst(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true
    }, options);
    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
exports.pick = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false
    }, options);
    const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
    }, options);
};
exports.exclude = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return exports.pick(input, exclusionFilter, options);
};

},{"58554573f6177552":"kO7zY","ba17965db0c7aff3":"5LMgi","51b8bc47184070a5":"fCebu","5c22cf306a783d1":"fy1Dy"}],"kO7zY":[function(require,module,exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"5LMgi":[function(require,module,exports) {
"use strict";
var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join("");
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"fCebu":[function(require,module,exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"fy1Dy":[function(require,module,exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"ftlSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _parsers = require("./parsers");
parcelHelpers.exportAll(_parsers, exports);
var _jsonrpc = require("./jsonrpc");
parcelHelpers.exportAll(_jsonrpc, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./types":"ftm8D","./parsers":"hGrC8","./jsonrpc":"eMHnk","./validators":"dS7UG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ftm8D":[function(require,module,exports) {

},{}],"hGrC8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseSubscribeRequest", ()=>parseSubscribeRequest);
parcelHelpers.export(exports, "parsePublishRequest", ()=>parsePublishRequest);
parcelHelpers.export(exports, "parseUnsubscribeRequest", ()=>parseUnsubscribeRequest);
parcelHelpers.export(exports, "parseSubscriptionRequest", ()=>parseSubscriptionRequest);
var _misc = require("./misc");
var _validators = require("./validators");
function parseSubscribeRequest(request) {
    if (!(0, _validators.isSubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, _validators.isSubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, _misc.assertType)(params, "topic");
    return params;
}
function parsePublishRequest(request) {
    if (!(0, _validators.isPublishMethod)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, _validators.isPublishParams)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, _misc.assertType)(params, "topic");
    (0, _misc.assertType)(params, "message");
    (0, _misc.assertType)(params, "ttl", "number");
    return params;
}
function parseUnsubscribeRequest(request) {
    if (!(0, _validators.isUnsubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, _validators.isUnsubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, _misc.assertType)(params, "id");
    return params;
}
function parseSubscriptionRequest(request) {
    if (!(0, _validators.isSubscriptionMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, _validators.isSubscriptionParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, _misc.assertType)(params, "id");
    (0, _misc.assertType)(params, "data");
    return params;
}

},{"./misc":"3VMxi","./validators":"dS7UG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3VMxi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertType", ()=>assertType);
parcelHelpers.export(exports, "hasRequiredParams", ()=>hasRequiredParams);
parcelHelpers.export(exports, "hasExactParamsLength", ()=>hasExactParamsLength);
parcelHelpers.export(exports, "hasRequiredParamsLength", ()=>hasRequiredParamsLength);
parcelHelpers.export(exports, "checkParams", ()=>checkParams);
parcelHelpers.export(exports, "methodEndsWith", ()=>methodEndsWith);
function assertType(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function hasRequiredParams(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function hasExactParamsLength(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function hasRequiredParamsLength(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function checkParams(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? hasExactParamsLength(params, required.length) : hasRequiredParamsLength(params, required.length);
    if (!matchesLength) return false;
    return hasRequiredParams(params, required);
}
function methodEndsWith(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dS7UG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSubscribeRequest", ()=>isSubscribeRequest);
parcelHelpers.export(exports, "isSubscribeMethod", ()=>isSubscribeMethod);
parcelHelpers.export(exports, "isSubscribeParams", ()=>isSubscribeParams);
parcelHelpers.export(exports, "isPublishRequest", ()=>isPublishRequest);
parcelHelpers.export(exports, "isPublishMethod", ()=>isPublishMethod);
parcelHelpers.export(exports, "isPublishParams", ()=>isPublishParams);
parcelHelpers.export(exports, "isUnsubscribeRequest", ()=>isUnsubscribeRequest);
parcelHelpers.export(exports, "isUnsubscribeMethod", ()=>isUnsubscribeMethod);
parcelHelpers.export(exports, "isUnsubscribeParams", ()=>isUnsubscribeParams);
parcelHelpers.export(exports, "isSubscriptionRequest", ()=>isSubscriptionRequest);
parcelHelpers.export(exports, "isSubscriptionMethod", ()=>isSubscriptionMethod);
parcelHelpers.export(exports, "isSubscriptionParams", ()=>isSubscriptionParams);
var _misc = require("./misc");
function isSubscribeRequest(request) {
    return isSubscribeMethod(request.method) && isSubscribeParams(request.params);
}
function isSubscribeMethod(method) {
    return (0, _misc.methodEndsWith)(method, "subscribe");
}
function isSubscribeParams(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, _misc.checkParams)(params, required, optional);
}
function isPublishRequest(request) {
    return isPublishMethod(request.method) && isPublishParams(request.params);
}
function isPublishMethod(method) {
    return (0, _misc.methodEndsWith)(method, "publish");
}
function isPublishParams(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, _misc.checkParams)(params, required, optional);
}
function isUnsubscribeRequest(request) {
    return isUnsubscribeMethod(request.method) && isUnsubscribeParams(request.params);
}
function isUnsubscribeMethod(method) {
    return (0, _misc.methodEndsWith)(method, "unsubscribe");
}
function isUnsubscribeParams(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, _misc.checkParams)(params, required, optional);
}
function isSubscriptionRequest(request) {
    return isSubscriptionMethod(request.method) && isSubscriptionParams(request.params);
}
function isSubscriptionMethod(method) {
    return (0, _misc.methodEndsWith)(method, "subscription");
}
function isSubscriptionParams(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, _misc.checkParams)(params, required, optional);
}

},{"./misc":"3VMxi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eMHnk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RELAY_JSONRPC", ()=>RELAY_JSONRPC);
const RELAY_JSONRPC = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fbiL9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _provider = require("./provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
parcelHelpers.exportAll(_provider, exports);
exports.default = (0, _providerDefault.default);

},{"./provider":"kqV2t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kqV2t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonRpcProvider", ()=>JsonRpcProvider);
var _events = require("events");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
class JsonRpcProvider extends (0, _jsonrpcUtils.IJsonRpcProvider) {
    constructor(connection){
        super(connection);
        this.events = new (0, _events.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, _jsonrpcUtils.formatJsonRpcRequest)(request.method, request.params || [], request.id || (0, _jsonrpcUtils.getBigIntRpcId)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, _jsonrpcUtils.isJsonRpcError)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, _jsonrpcUtils.isJsonRpcResponse)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
exports.default = JsonRpcProvider;

},{"events":"fqTtD","@walletconnect/jsonrpc-utils":"dUcPw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUcPw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _format = require("./format");
parcelHelpers.exportAll(_format, exports);
var _routing = require("./routing");
parcelHelpers.exportAll(_routing, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _url = require("./url");
parcelHelpers.exportAll(_url, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./constants":"dic9X","./error":"lpnqm","./env":"3Rucj","./format":"jPgVJ","./routing":"fXfep","./types":"UuYNN","./url":"lT9DQ","./validators":"bqcdC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dic9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARSE_ERROR", ()=>PARSE_ERROR);
parcelHelpers.export(exports, "INVALID_REQUEST", ()=>INVALID_REQUEST);
parcelHelpers.export(exports, "METHOD_NOT_FOUND", ()=>METHOD_NOT_FOUND);
parcelHelpers.export(exports, "INVALID_PARAMS", ()=>INVALID_PARAMS);
parcelHelpers.export(exports, "INTERNAL_ERROR", ()=>INTERNAL_ERROR);
parcelHelpers.export(exports, "SERVER_ERROR", ()=>SERVER_ERROR);
parcelHelpers.export(exports, "RESERVED_ERROR_CODES", ()=>RESERVED_ERROR_CODES);
parcelHelpers.export(exports, "SERVER_ERROR_CODE_RANGE", ()=>SERVER_ERROR_CODE_RANGE);
parcelHelpers.export(exports, "STANDARD_ERROR_MAP", ()=>STANDARD_ERROR_MAP);
parcelHelpers.export(exports, "DEFAULT_ERROR", ()=>DEFAULT_ERROR);
const PARSE_ERROR = "PARSE_ERROR";
const INVALID_REQUEST = "INVALID_REQUEST";
const METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
const INVALID_PARAMS = "INVALID_PARAMS";
const INTERNAL_ERROR = "INTERNAL_ERROR";
const SERVER_ERROR = "SERVER_ERROR";
const RESERVED_ERROR_CODES = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const SERVER_ERROR_CODE_RANGE = [
    -32000,
    -32099
];
const STANDARD_ERROR_MAP = {
    [PARSE_ERROR]: {
        code: -32700,
        message: "Parse error"
    },
    [INVALID_REQUEST]: {
        code: -32600,
        message: "Invalid Request"
    },
    [METHOD_NOT_FOUND]: {
        code: -32601,
        message: "Method not found"
    },
    [INVALID_PARAMS]: {
        code: -32602,
        message: "Invalid params"
    },
    [INTERNAL_ERROR]: {
        code: -32603,
        message: "Internal error"
    },
    [SERVER_ERROR]: {
        code: -32000,
        message: "Server error"
    }
};
const DEFAULT_ERROR = SERVER_ERROR;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpnqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerErrorCode", ()=>isServerErrorCode);
parcelHelpers.export(exports, "isReservedErrorCode", ()=>isReservedErrorCode);
parcelHelpers.export(exports, "isValidErrorCode", ()=>isValidErrorCode);
parcelHelpers.export(exports, "getError", ()=>getError);
parcelHelpers.export(exports, "getErrorByCode", ()=>getErrorByCode);
parcelHelpers.export(exports, "validateJsonRpcError", ()=>validateJsonRpcError);
parcelHelpers.export(exports, "parseConnectionError", ()=>parseConnectionError);
var _constants = require("./constants");
function isServerErrorCode(code) {
    return code <= (0, _constants.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, _constants.SERVER_ERROR_CODE_RANGE)[1];
}
function isReservedErrorCode(code) {
    return (0, _constants.RESERVED_ERROR_CODES).includes(code);
}
function isValidErrorCode(code) {
    return typeof code === "number";
}
function getError(type) {
    if (!Object.keys((0, _constants.STANDARD_ERROR_MAP)).includes(type)) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return (0, _constants.STANDARD_ERROR_MAP)[type];
}
function getErrorByCode(code) {
    const match = Object.values((0, _constants.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return match;
}
function validateJsonRpcError(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!isValidErrorCode(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if (isReservedErrorCode(response.error.code)) {
        const error = getErrorByCode(response.error.code);
        if (error.message !== (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function parseConnectionError(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

},{"./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Rucj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeJs", ()=>isNodeJs);
var _environment = require("@walletconnect/environment");
parcelHelpers.exportAll(_environment, exports);
const isNodeJs = (0, _environment.isNode);

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ljiRg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("7ea7787f9cb444bc");
tslib_1.__exportStar(require("224c4ee8cc5fb5e6"), exports);
tslib_1.__exportStar(require("ca369212861f50d2"), exports);

},{"7ea7787f9cb444bc":"i5Jlw","224c4ee8cc5fb5e6":"9qgYL","ca369212861f50d2":"21TsA"}],"i5Jlw":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qgYL":[function(require,module,exports) {
var global = arguments[3];
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowserCryptoAvailable = exports.getSubtleCrypto = exports.getBrowerCrypto = void 0;
function getBrowerCrypto() {
    return (global === null || global === void 0 ? void 0 : global.crypto) || (global === null || global === void 0 ? void 0 : global.msCrypto) || {};
}
exports.getBrowerCrypto = getBrowerCrypto;
function getSubtleCrypto() {
    const browserCrypto = getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
exports.getSubtleCrypto = getSubtleCrypto;
function isBrowserCryptoAvailable() {
    return !!getBrowerCrypto() && !!getSubtleCrypto();
}
exports.isBrowserCryptoAvailable = isBrowserCryptoAvailable;

},{}],"21TsA":[function(require,module,exports) {
var process = require("6ccfe05cfad71fdb");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowser = exports.isNode = exports.isReactNative = void 0;
function isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
exports.isReactNative = isReactNative;
function isNode() {
    return typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined";
}
exports.isNode = isNode;
function isBrowser() {
    return !isReactNative() && !isNode();
}
exports.isBrowser = isBrowser;

},{"6ccfe05cfad71fdb":"5QIF0"}],"jPgVJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "payloadId", ()=>payloadId);
parcelHelpers.export(exports, "getBigIntRpcId", ()=>getBigIntRpcId);
parcelHelpers.export(exports, "formatJsonRpcRequest", ()=>formatJsonRpcRequest);
parcelHelpers.export(exports, "formatJsonRpcResult", ()=>formatJsonRpcResult);
parcelHelpers.export(exports, "formatJsonRpcError", ()=>formatJsonRpcError);
parcelHelpers.export(exports, "formatErrorMessage", ()=>formatErrorMessage);
var _error = require("./error");
var _constants = require("./constants");
function payloadId(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function getBigIntRpcId(entropy = 6) {
    return BigInt(payloadId(entropy));
}
function formatJsonRpcRequest(method, params, id) {
    return {
        id: id || payloadId(),
        jsonrpc: "2.0",
        method,
        params
    };
}
function formatJsonRpcResult(id, result) {
    return {
        id,
        jsonrpc: "2.0",
        result
    };
}
function formatJsonRpcError(id, error, data) {
    return {
        id,
        jsonrpc: "2.0",
        error: formatErrorMessage(error, data)
    };
}
function formatErrorMessage(error, data) {
    if (typeof error === "undefined") return (0, _error.getError)((0, _constants.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, _error.getError)((0, _constants.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, _error.isReservedErrorCode)(error.code)) error = (0, _error.getErrorByCode)(error.code);
    return error;
}

},{"./error":"lpnqm","./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fXfep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidRoute", ()=>isValidRoute);
parcelHelpers.export(exports, "isValidDefaultRoute", ()=>isValidDefaultRoute);
parcelHelpers.export(exports, "isValidWildcardRoute", ()=>isValidWildcardRoute);
parcelHelpers.export(exports, "isValidLeadingWildcardRoute", ()=>isValidLeadingWildcardRoute);
parcelHelpers.export(exports, "isValidTrailingWildcardRoute", ()=>isValidTrailingWildcardRoute);
function isValidRoute(route) {
    if (route.includes("*")) return isValidWildcardRoute(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function isValidDefaultRoute(route) {
    return route === "*";
}
function isValidWildcardRoute(route) {
    if (isValidDefaultRoute(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function isValidLeadingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[0].trim();
}
function isValidTrailingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[1].trim();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UuYNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrpcTypes = require("@walletconnect/jsonrpc-types");
parcelHelpers.exportAll(_jsonrpcTypes, exports);

},{"@walletconnect/jsonrpc-types":"5PTpM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5PTpM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrpc = require("./jsonrpc");
parcelHelpers.exportAll(_jsonrpc, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _provider = require("./provider");
parcelHelpers.exportAll(_provider, exports);
var _validator = require("./validator");
parcelHelpers.exportAll(_validator, exports);

},{"./jsonrpc":"ak6bw","./misc":"e7Cib","./provider":"9ntku","./validator":"loXJL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ak6bw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e7Cib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IEvents", ()=>IEvents);
class IEvents {
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ntku":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IJsonRpcConnection", ()=>IJsonRpcConnection);
parcelHelpers.export(exports, "IBaseJsonRpcProvider", ()=>IBaseJsonRpcProvider);
parcelHelpers.export(exports, "IJsonRpcProvider", ()=>IJsonRpcProvider);
var _misc = require("./misc");
class IJsonRpcConnection extends (0, _misc.IEvents) {
    constructor(opts){
        super();
    }
}
class IBaseJsonRpcProvider extends (0, _misc.IEvents) {
    constructor(){
        super();
    }
}
class IJsonRpcProvider extends IBaseJsonRpcProvider {
    constructor(connection){
        super();
    }
}

},{"./misc":"e7Cib","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"loXJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lT9DQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHttpUrl", ()=>isHttpUrl);
parcelHelpers.export(exports, "isWsUrl", ()=>isWsUrl);
parcelHelpers.export(exports, "isLocalhostUrl", ()=>isLocalhostUrl);
const HTTP_REGEX = "^https?:";
const WS_REGEX = "^wss?:";
function getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function matchRegexProtocol(url, regex) {
    const protocol = getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
    return matchRegexProtocol(url, HTTP_REGEX);
}
function isWsUrl(url) {
    return matchRegexProtocol(url, WS_REGEX);
}
function isLocalhostUrl(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bqcdC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJsonRpcPayload", ()=>isJsonRpcPayload);
parcelHelpers.export(exports, "isJsonRpcRequest", ()=>isJsonRpcRequest);
parcelHelpers.export(exports, "isJsonRpcResponse", ()=>isJsonRpcResponse);
parcelHelpers.export(exports, "isJsonRpcResult", ()=>isJsonRpcResult);
parcelHelpers.export(exports, "isJsonRpcError", ()=>isJsonRpcError);
parcelHelpers.export(exports, "isJsonRpcValidationInvalid", ()=>isJsonRpcValidationInvalid);
function isJsonRpcPayload(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function isJsonRpcRequest(payload) {
    return isJsonRpcPayload(payload) && "method" in payload;
}
function isJsonRpcResponse(payload) {
    return isJsonRpcPayload(payload) && (isJsonRpcResult(payload) || isJsonRpcError(payload));
}
function isJsonRpcResult(payload) {
    return "result" in payload;
}
function isJsonRpcError(payload) {
    return "error" in payload;
}
function isJsonRpcValidationInvalid(validation) {
    return "error" in validation && validation.valid === false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ITsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ws = require("./ws");
var _wsDefault = parcelHelpers.interopDefault(_ws);
parcelHelpers.exportAll(_ws, exports);
exports.default = (0, _wsDefault.default);

},{"./ws":"b8dV4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8dV4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WsConnection", ()=>WsConnection);
var _events = require("events");
var _safeJson = require("@walletconnect/safe-json");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
var _utils = require("./utils");
const EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
const WS = (0, _utils.resolveWebSocketImplementation)();
class WsConnection {
    constructor(url){
        this.url = url;
        this.events = new (0, _events.EventEmitter)();
        this.registering = false;
        if (!(0, _jsonrpcUtils.isWsUrl)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        this.url = url;
    }
    get connected() {
        return typeof this.socket !== "undefined";
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        return new Promise((resolve, reject)=>{
            if (typeof this.socket === "undefined") {
                reject(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (event)=>{
                this.onClose(event);
                resolve();
            };
            this.socket.close();
        });
    }
    async send(payload, context) {
        if (typeof this.socket === "undefined") this.socket = await this.register();
        try {
            this.socket.send((0, _safeJson.safeJsonStringify)(payload));
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    register(url = this.url) {
        if (!(0, _jsonrpcUtils.isWsUrl)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.socket === "undefined") return reject(new Error("WebSocket connection is missing or invalid"));
                    resolve(this.socket);
                });
            });
        }
        this.url = url;
        this.registering = true;
        return new Promise((resolve, reject)=>{
            const opts = !(0, _jsonrpcUtils.isReactNative)() ? {
                rejectUnauthorized: !(0, _jsonrpcUtils.isLocalhostUrl)(url)
            } : undefined;
            const socket = new WS(url, [], opts);
            if ((0, _utils.hasBuiltInWebSocket)()) socket.onerror = (event)=>{
                const errorEvent = event;
                reject(this.emitError(errorEvent.error));
            };
            else socket.on("error", (errorEvent)=>{
                reject(this.emitError(errorEvent));
            });
            socket.onopen = ()=>{
                this.onOpen(socket);
                resolve(socket);
            };
        });
    }
    onOpen(socket) {
        socket.onmessage = (event)=>this.onPayload(event);
        socket.onclose = (event)=>this.onClose(event);
        this.socket = socket;
        this.registering = false;
        this.events.emit("open");
    }
    onClose(event) {
        this.socket = undefined;
        this.registering = false;
        this.events.emit("close", event);
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, _safeJson.safeJsonParse)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, _jsonrpcUtils.formatJsonRpcError)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, _jsonrpcUtils.parseConnectionError)(e, (0, _utils.truncateQuery)(url), "WS");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners(EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
    emitError(errorEvent) {
        const error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || `WebSocket connection failed for host: ${(0, _utils.truncateQuery)(this.url)}`));
        this.events.emit("register_error", error);
        return error;
    }
}
exports.default = WsConnection;

},{"events":"fqTtD","@walletconnect/safe-json":"gaejp","@walletconnect/jsonrpc-utils":"dUcPw","./utils":"f5w5L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5w5L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveWebSocketImplementation", ()=>resolveWebSocketImplementation);
parcelHelpers.export(exports, "hasBuiltInWebSocket", ()=>hasBuiltInWebSocket);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "truncateQuery", ()=>truncateQuery);
var global = arguments[3];
const resolveWebSocketImplementation = ()=>{
    if (typeof WebSocket !== "undefined") return WebSocket;
    else if (typeof global !== "undefined" && typeof global.WebSocket !== "undefined") return global.WebSocket;
    else if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") return window.WebSocket;
    else if (typeof self !== "undefined" && typeof self.WebSocket !== "undefined") return self.WebSocket;
    return require("86ce241911116a7");
};
const hasBuiltInWebSocket = ()=>typeof WebSocket !== "undefined" || typeof global !== "undefined" && typeof global.WebSocket !== "undefined" || typeof window !== "undefined" && typeof window.WebSocket !== "undefined" || typeof self !== "undefined" && typeof self.WebSocket !== "undefined";
const isBrowser = ()=>typeof window !== "undefined";
const truncateQuery = (wssUrl)=>wssUrl.split("?")[0];

},{"86ce241911116a7":"26vSj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26vSj":[function(require,module,exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

},{}],"eOLCt":[function(require,module,exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var global = arguments[3];
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

},{}],"lizQR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ICore", ()=>n);
parcelHelpers.export(exports, "ICrypto", ()=>l);
parcelHelpers.export(exports, "IEngine", ()=>S);
parcelHelpers.export(exports, "IEngineEvents", ()=>C);
parcelHelpers.export(exports, "IExpirer", ()=>E);
parcelHelpers.export(exports, "IJsonRpcHistory", ()=>h);
parcelHelpers.export(exports, "IKeyChain", ()=>x);
parcelHelpers.export(exports, "IMessageTracker", ()=>a);
parcelHelpers.export(exports, "IPairing", ()=>m);
parcelHelpers.export(exports, "IPublisher", ()=>u);
parcelHelpers.export(exports, "IRelayer", ()=>g);
parcelHelpers.export(exports, "ISignClient", ()=>b);
parcelHelpers.export(exports, "ISignClientEvents", ()=>v);
parcelHelpers.export(exports, "IStore", ()=>p);
parcelHelpers.export(exports, "ISubscriber", ()=>d);
parcelHelpers.export(exports, "ISubscriberTopicMap", ()=>I);
parcelHelpers.export(exports, "IVerify", ()=>y);
var _events = require("@walletconnect/events");
var _events1 = require("events");
var _eventsDefault = parcelHelpers.interopDefault(_events1);
class n extends (0, _events.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class l {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class h extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class a {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class u extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class g extends (0, _events.IEvents) {
    constructor(s){
        super();
    }
}
class p {
    constructor(s, t, o, w){
        this.core = s, this.logger = t, this.name = o;
    }
}
class I {
    constructor(){
        this.map = new Map;
    }
}
class d extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class x {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class E extends (0, _events.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class m {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class y {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class v extends (0, _eventsDefault.default) {
    constructor(){
        super();
    }
}
class b {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class C extends (0, _events1.EventEmitter) {
    constructor(){
        super();
    }
}
class S {
    constructor(s){
        this.client = s;
    }
}

},{"@walletconnect/events":"fHdgn","events":"fqTtD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h8eAN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WalletConnectModal", ()=>d);
var _modalCore = require("@walletconnect/modal-core");
class d {
    constructor(e){
        this.openModal = (0, _modalCore.ModalCtrl).open, this.closeModal = (0, _modalCore.ModalCtrl).close, this.subscribeModal = (0, _modalCore.ModalCtrl).subscribe, this.setTheme = (0, _modalCore.ThemeCtrl).setThemeConfig, (0, _modalCore.ThemeCtrl).setThemeConfig(e), (0, _modalCore.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await require("d9129ae20229e8d2");
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, _modalCore.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}

},{"@walletconnect/modal-core":"4F5XH","d9129ae20229e8d2":"4ieGr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4F5XH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfigCtrl", ()=>y);
parcelHelpers.export(exports, "CoreUtil", ()=>a);
parcelHelpers.export(exports, "EventsCtrl", ()=>R);
parcelHelpers.export(exports, "ExplorerCtrl", ()=>te);
parcelHelpers.export(exports, "ModalCtrl", ()=>se);
parcelHelpers.export(exports, "OptionsCtrl", ()=>p);
parcelHelpers.export(exports, "RouterCtrl", ()=>T);
parcelHelpers.export(exports, "ThemeCtrl", ()=>ne);
parcelHelpers.export(exports, "ToastCtrl", ()=>oe);
var _vanilla = require("valtio/vanilla");
const o = (0, _vanilla.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), T = {
    state: o,
    subscribe (e) {
        return (0, _vanilla.subscribe)(o, ()=>e(o));
    },
    push (e, t) {
        e !== o.view && (o.view = e, t && (o.data = t), o.history.push(e));
    },
    reset (e) {
        o.view = e, o.history = [
            e
        ];
    },
    replace (e) {
        o.history.length > 1 && (o.history[o.history.length - 1] = e, o.view = e);
    },
    goBack () {
        if (o.history.length > 1) {
            o.history.pop();
            const [e] = o.history.slice(-1);
            o.view = e;
        }
    },
    setData (e) {
        o.data = e;
    }
}, a = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return a.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return a.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if (a.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!a.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem(a.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem(a.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem(a.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem(a.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = T.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, _ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), r = (0, _vanilla.proxy)({
    enabled: _,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), R = {
    state: r,
    subscribe (e) {
        return (0, _vanilla.subscribe)(r.events, ()=>e((0, _vanilla.snapshot)(r.events[r.events.length - 1])));
    },
    initialize () {
        r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && (r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        r.connectedWalletId = e;
    },
    click (e) {
        if (r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            r.events.push(t);
        }
    },
    track (e) {
        if (r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            r.events.push(t);
        }
    },
    view (e) {
        if (r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            r.events.push(t);
        }
    }
}, c = (0, _vanilla.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), p = {
    state: c,
    subscribe (e) {
        return (0, _vanilla.subscribe)(c, ()=>e(c));
    },
    setChains (e) {
        c.chains = e;
    },
    setWalletConnectUri (e) {
        c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        c.isUiLoaded = e;
    },
    setIsAuth (e) {
        c.isAuth = e;
    }
}, W = (0, _vanilla.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), y = {
    state: W,
    subscribe (e) {
        return (0, _vanilla.subscribe)(W, ()=>e(W));
    },
    setConfig (e) {
        var t, s;
        R.initialize(), p.setChains(e.chains), p.setIsAuth(Boolean(e.enableAuthMode)), p.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), p.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), a.setModalVersionInStorage(), Object.assign(W, e);
    }
};
var V = Object.defineProperty, D = Object.getOwnPropertySymbols, H = Object.prototype.hasOwnProperty, B = Object.prototype.propertyIsEnumerable, M = (e, t, s)=>t in e ? V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, K = (e, t)=>{
    for(var s in t || (t = {}))H.call(t, s) && M(e, s, t[s]);
    if (D) for (var s of D(t))B.call(t, s) && M(e, s, t[s]);
    return e;
};
const L = "https://explorer-api.walletconnect.com", E = "wcm", O = "js-2.6.2";
async function w(e, t) {
    const s = K({
        sdkType: E,
        sdkVersion: O
    }, t), n = new URL(e, L);
    return n.searchParams.append("projectId", y.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const m = {
    async getDesktopListings (e) {
        return w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${L}/w3m/v1/getWalletImage/${e}?projectId=${y.state.projectId}&sdkType=${E}&sdkVersion=${O}`;
    },
    getAssetImageUrl (e) {
        return `${L}/w3m/v1/getAssetImage/${e}?projectId=${y.state.projectId}&sdkType=${E}&sdkVersion=${O}`;
    }
};
var z = Object.defineProperty, j = Object.getOwnPropertySymbols, J = Object.prototype.hasOwnProperty, q = Object.prototype.propertyIsEnumerable, k = (e, t, s)=>t in e ? z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, F = (e, t)=>{
    for(var s in t || (t = {}))J.call(t, s) && k(e, s, t[s]);
    if (j) for (var s of j(t))q.call(t, s) && k(e, s, t[s]);
    return e;
};
const N = a.isMobile(), d = (0, _vanilla.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), te = {
    state: d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = y.state;
        if (e === "NONE" || t === "ALL" && !e) return d.recomendedWallets;
        if (a.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = p.state, i = s?.join(","), l = a.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: a.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = N ? await m.getMobileListings(v) : await m.getDesktopListings(v);
            d.recomendedWallets = Object.values(b);
        }
        return d.recomendedWallets;
    },
    async getWallets (e) {
        const t = F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = y.state, { recomendedWallets: i } = d;
        if (n === "ALL") return d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : a.isArray(s) && (t.excludedIds = s.join(",")), a.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), p.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = N ? await m.getMobileListings(t) : await m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return d[U] = {
            listings: [
                ...d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return m.getAssetImageUrl(e);
    },
    resetSearch () {
        d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, I = (0, _vanilla.proxy)({
    open: !1
}), se = {
    state: I,
    subscribe (e) {
        return (0, _vanilla.subscribe)(I, ()=>e(I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = p.state;
            if (a.removeWalletConnectDeepLink(), p.setWalletConnectUri(e?.uri), p.setChains(e?.chains), T.reset("ConnectWallet"), s && n) I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = p.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        I.open = !1;
    }
};
var G = Object.defineProperty, $ = Object.getOwnPropertySymbols, Q = Object.prototype.hasOwnProperty, X = Object.prototype.propertyIsEnumerable, S = (e, t, s)=>t in e ? G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, Y = (e, t)=>{
    for(var s in t || (t = {}))Q.call(t, s) && S(e, s, t[s]);
    if ($) for (var s of $(t))X.call(t, s) && S(e, s, t[s]);
    return e;
};
function Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const C = (0, _vanilla.proxy)({
    themeMode: Z() ? "dark" : "light"
}), ne = {
    state: C,
    subscribe (e) {
        return (0, _vanilla.subscribe)(C, ()=>e(C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && (C.themeMode = t), s && (C.themeVariables = Y({}, s));
    }
}, g = (0, _vanilla.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), oe = {
    state: g,
    subscribe (e) {
        return (0, _vanilla.subscribe)(g, ()=>e(g));
    },
    openToast (e, t) {
        g.open = !0, g.message = e, g.variant = t;
    },
    closeToast () {
        g.open = !1;
    }
};

},{"valtio/vanilla":"5XTXh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ieGr":[function(require,module,exports) {
module.exports = require("6801611badb6ceec")(require("3b6d85c43131179a").resolve("49fjZ")).then(()=>module.bundle.root("iAIOg"));

},{"6801611badb6ceec":"hpx0h","3b6d85c43131179a":"fyJL2"}],"hpx0h":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"aCmte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactiveElement = require("@lit/reactive-element");
var _litHtml = require("lit-html");
var _litElementJs = require("lit-element/lit-element.js");
parcelHelpers.exportAll(_litElementJs, exports);
var _isServerJs = require("lit-html/is-server.js");
parcelHelpers.exportAll(_isServerJs, exports);

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","lit-element/lit-element.js":"8BOF1","lit-html/is-server.js":"2Mmwb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUcCl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>(0, _cssTagJs.CSSResult));
parcelHelpers.export(exports, "adoptStyles", ()=>(0, _cssTagJs.adoptStyles));
parcelHelpers.export(exports, "css", ()=>(0, _cssTagJs.css));
parcelHelpers.export(exports, "getCompatibleStyle", ()=>(0, _cssTagJs.getCompatibleStyle));
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>(0, _cssTagJs.supportsAdoptingStyleSheets));
parcelHelpers.export(exports, "unsafeCSS", ()=>(0, _cssTagJs.unsafeCSS));
parcelHelpers.export(exports, "ReactiveElement", ()=>b);
parcelHelpers.export(exports, "defaultConverter", ()=>u);
parcelHelpers.export(exports, "notEqual", ()=>f);
var _cssTagJs = require("./css-tag.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: i, defineProperty: e, getOwnPropertyDescriptor: r, getOwnPropertyNames: h, getOwnPropertySymbols: o, getPrototypeOf: n } = Object, a = globalThis, c = a.trustedTypes, l = c ? c.emptyScript : "", p = a.reactiveElementPolyfillSupport, d = (t, s)=>t, u = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, f = (t, s)=>!i(t, s), y = {
    attribute: !0,
    type: String,
    converter: u,
    reflect: !1,
    hasChanged: f
};
Symbol.metadata ??= Symbol("metadata"), a.litPropertyMetadata ??= new WeakMap;
class b extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? y;
    }
    static _$Ei() {
        if (this.hasOwnProperty(d("elementProperties"))) return;
        const t = n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty(d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
            const t = this.properties, s = [
                ...h(t),
                ...o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, _cssTagJs.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, _cssTagJs.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, _cssTagJs.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : u).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : u;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? f)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
b.elementStyles = [], b.shadowRootOptions = {
    mode: "open"
}, b[d("elementProperties")] = new Map, b[d("finalized")] = new Map, p?.({
    ReactiveElement: b
}), (a.reactiveElementVersions ??= []).push("2.0.4");

},{"./css-tag.js":"gSCbb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSCbb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSResult", ()=>n);
parcelHelpers.export(exports, "adoptStyles", ()=>S);
parcelHelpers.export(exports, "css", ()=>i);
parcelHelpers.export(exports, "getCompatibleStyle", ()=>c);
parcelHelpers.export(exports, "supportsAdoptingStyleSheets", ()=>e);
parcelHelpers.export(exports, "unsafeCSS", ()=>r);
const t = globalThis, e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, s = Symbol(), o = new WeakMap;
class n {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if (e && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const r = (t)=>new n("string" == typeof t ? t : t + "", void 0, s), i = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new n(o, t, s);
}, S = (s, o)=>{
    if (e) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, c = e ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return r(e);
    })(t) : t;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4A25t":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_$LH", ()=>z);
parcelHelpers.export(exports, "html", ()=>x);
parcelHelpers.export(exports, "noChange", ()=>w);
parcelHelpers.export(exports, "nothing", ()=>T);
parcelHelpers.export(exports, "render", ()=>j);
parcelHelpers.export(exports, "svg", ()=>b);
const t = globalThis, i = t.trustedTypes, s = i ? i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, e = "$lit$", h = `lit$${(Math.random() + "").slice(9)}$`, o = "?" + h, n = `<${o}>`, r = document, l = ()=>r.createComment(""), c = (t)=>null === t || "object" != typeof t && "function" != typeof t, a = Array.isArray, u = (t)=>a(t) || "function" == typeof t?.[Symbol.iterator], d = "[ 	\n\f\r]", f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, _ = />/g, m = RegExp(`>|${d}(?:([^\\s"'>=/]+)(${d}*=${d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), p = /'/g, g = /"/g, $ = /^(?:script|style|textarea|title)$/i, y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), x = y(1), b = y(2), w = Symbol.for("lit-noChange"), T = Symbol.for("lit-nothing"), A = new WeakMap, E = r.createTreeWalker(r, 129);
function C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== s ? s.createHTML(i) : i;
}
const P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === f ? "!--" === u[1] ? c = v : void 0 !== u[1] ? c = _ : void 0 !== u[2] ? ($.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = m) : void 0 !== u[3] && (c = m) : c === m ? ">" === u[0] ? (c = r ?? f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? m : '"' === u[3] ? g : p) : c === g || c === p ? c = m : c === v || c === _ ? c = f : (c = m, r = void 0);
        const x = c === m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === f ? s + n : d >= 0 ? (o.push(a), s.slice(0, d) + e + s.slice(d) + h + x) : s + h + (-2 === d ? i : x);
    }
    return [
        C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = P(t, s);
        if (this.el = V.createElement(f, n), E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith(e)) {
                    const i = v[a++], s = r.getAttribute(t).split(h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? k : "?" === e[1] ? H : "@" === e[1] ? I : R
                    }), r.removeAttribute(t);
                } else t.startsWith(h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($.test(r.tagName)) {
                    const t = r.textContent.split(h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = i ? i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], l()), E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf(h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function N(t, i, s = t, e) {
    if (i === w) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = N(t, h._$AS(t, i.values), h, e)), i;
}
class S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? r).importNode(i, !0);
        E.currentNode = e;
        let h = E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = E.nextNode(), o++);
        }
        return E.currentNode = r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = T, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = N(this, t, i), c(t) ? t === T || null == t || "" === t ? (this._$AH !== T && this._$AR(), this._$AH = T) : t !== this._$AH && t !== w && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== T && c(this._$AH) ? this._$AA.nextSibling.data = t : this.T(r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = V.createElement(C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = A.get(t.strings);
        return void 0 === i && A.set(t.strings, i = new V(t)), i;
    }
    k(t) {
        a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new M(this.S(l()), this.S(l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = T, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = T;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = N(this, t, i, 0), o = !c(t) || t !== this._$AH && t !== w, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = N(this, e[s + n], i, n), r === w && (r = this._$AH[n]), o ||= !c(r) || r !== this._$AH[n], r === T ? t = T : t !== T && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === T ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class k extends R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === T ? void 0 : t;
    }
}
class H extends R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== T);
    }
}
class I extends R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = N(this, t, i, 0) ?? T) === w) return;
        const s = this._$AH, e = t === T && s !== T || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== T && (s === T || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        N(this, t);
    }
}
const z = {
    P: e,
    A: h,
    C: o,
    M: 1,
    L: P,
    R: S,
    D: u,
    V: N,
    I: M,
    H: R,
    N: H,
    U: I,
    B: k,
    F: L
}, Z = t.litHtmlPolyfillSupport;
Z?.(V, M), (t.litHtmlVersions ??= []).push("3.1.2");
const j = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new M(i.insertBefore(l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8BOF1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LitElement", ()=>s);
parcelHelpers.export(exports, "_$LE", ()=>o);
var _reactiveElement = require("@lit/reactive-element");
parcelHelpers.exportAll(_reactiveElement, exports);
var _litHtml = require("lit-html");
parcelHelpers.exportAll(_litHtml, exports);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class s extends (0, _reactiveElement.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, _litHtml.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, _litHtml.noChange;
    }
}
s._$litElement$ = !0, s["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: s
});
const r = globalThis.litElementPolyfillSupport;
r?.({
    LitElement: s
});
const o = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.4");

},{"@lit/reactive-element":"hUcCl","lit-html":"4A25t","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Mmwb":[function(require,module,exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>o);
const o = !1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g0s0G":[function(require,module,exports) {
const canPromise = require("da1f68cc1fc16077");
const QRCode = require("8c6cf49ef2287430");
const CanvasRenderer = require("8a60cf7722cc14ce");
const SvgRenderer = require("f6fcc816b915ba37");
function renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !canPromise()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = QRCode.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = QRCode.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
exports.create = QRCode.create;
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
// only svg for now.
exports.toString = renderCanvas.bind(null, function(data, _, opts) {
    return SvgRenderer.render(data, opts);
});

},{"da1f68cc1fc16077":"7NevM","8c6cf49ef2287430":"2Ifk2","8a60cf7722cc14ce":"53FZc","f6fcc816b915ba37":"cM6dr"}],"7NevM":[function(require,module,exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

},{}],"2Ifk2":[function(require,module,exports) {
const Utils = require("4cf6a8173d9f3a2");
const ECLevel = require("2ad62f61c352884c");
const BitBuffer = require("87d5a6270eb1dc26");
const BitMatrix = require("91abc94f777368cc");
const AlignmentPattern = require("9737c3939ab85d95");
const FinderPattern = require("cee3d371e219e45e");
const MaskPattern = require("8700c8c682afabf3");
const ECCode = require("65ad903a6ba3e");
const ReedSolomonEncoder = require("1e8e447afb4d169c");
const Version = require("8a4a19af97836d80");
const FormatInfo = require("26720f9d94c9e268");
const Mode = require("7b6429a248ecc51f");
const Segments = require("1368d0fa14524351");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = FinderPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupAlignmentPattern(matrix, version) {
    const pos = AlignmentPattern.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = Version.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new BitBuffer();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new ReedSolomonEncoder(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = Segments.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = Segments.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = Segments.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = Utils.getSymbolSize(version);
    const modules = new BitMatrix(moduleCount);
    // Add function modules
    setupFinderPattern(modules, version);
    setupTimingPattern(modules);
    setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) setupVersionInfo(modules, version);
    // Add data codewords
    setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules, setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    MaskPattern.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ exports.create = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = ECLevel.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
        version = Version.from(options.version);
        mask = MaskPattern.from(options.maskPattern);
        if (options.toSJISFunc) Utils.setToSJISFunction(options.toSJISFunc);
    }
    return createSymbol(data, version, errorCorrectionLevel, mask);
};

},{"4cf6a8173d9f3a2":"bCvEH","2ad62f61c352884c":"fnt1n","87d5a6270eb1dc26":"2giyh","91abc94f777368cc":"4ozmv","9737c3939ab85d95":"jgRzo","cee3d371e219e45e":"1Qw2I","8700c8c682afabf3":"1BUGW","65ad903a6ba3e":"itXks","1e8e447afb4d169c":"42cTS","8a4a19af97836d80":"2m4It","26720f9d94c9e268":"yj4S4","7b6429a248ecc51f":"epPN6","1368d0fa14524351":"6yArI"}],"bCvEH":[function(require,module,exports) {
let toSJISFunction;
const CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ exports.getSymbolSize = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ exports.getSymbolTotalCodewords = function getSymbolTotalCodewords(version) {
    return CODEWORDS_COUNT[version];
};
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ exports.getBCHDigit = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
exports.setToSJISFunction = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    toSJISFunction = f;
};
exports.isKanjiModeEnabled = function() {
    return typeof toSJISFunction !== "undefined";
};
exports.toSJIS = function toSJIS(kanji) {
    return toSJISFunction(kanji);
};

},{}],"fnt1n":[function(require,module,exports) {
exports.L = {
    bit: 1
};
exports.M = {
    bit: 0
};
exports.Q = {
    bit: 3
};
exports.H = {
    bit: 2
};
function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return exports.L;
        case "m":
        case "medium":
            return exports.M;
        case "q":
        case "quartile":
            return exports.Q;
        case "h":
        case "high":
            return exports.H;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
exports.isValid = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{}],"2giyh":[function(require,module,exports) {
function BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = BitBuffer;

},{}],"4ozmv":[function(require,module,exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = BitMatrix;

},{}],"jgRzo":[function(require,module,exports) {
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ const getSymbolSize = require("3fa093180e62a22a").getSymbolSize;
/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ exports.getRowColCoords = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const coords = [];
    const pos = exports.getRowColCoords(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

},{"3fa093180e62a22a":"bCvEH"}],"1Qw2I":[function(require,module,exports) {
const getSymbolSize = require("6ec9ae5660047293").getSymbolSize;
const FINDER_PATTERN_SIZE = 7;
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    const size = getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - FINDER_PATTERN_SIZE
        ]
    ];
};

},{"6ec9ae5660047293":"bCvEH"}],"1BUGW":[function(require,module,exports) {
/**
 * Data mask pattern reference
 * @type {Object}
 */ exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ exports.isValid = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : undefined;
};
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ exports.getPenaltyN1 = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ exports.getPenaltyN2 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * PenaltyScores.N2;
};
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ exports.getPenaltyN3 = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * PenaltyScores.N3;
};
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ exports.getPenaltyN4 = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case exports.Patterns.PATTERN000:
            return (i + j) % 2 === 0;
        case exports.Patterns.PATTERN001:
            return i % 2 === 0;
        case exports.Patterns.PATTERN010:
            return j % 3 === 0;
        case exports.Patterns.PATTERN011:
            return (i + j) % 3 === 0;
        case exports.Patterns.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case exports.Patterns.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case exports.Patterns.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case exports.Patterns.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ exports.applyMask = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
    }
};
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys(exports.Patterns).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        exports.applyMask(p, data);
        // Calculate penalty
        const penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
        // Undo previously applied mask
        exports.applyMask(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

},{}],"itXks":[function(require,module,exports) {
const ECLevel = require("7baaa530584d1bc4");
const EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ exports.getBlocksCount = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ exports.getTotalCodewordsCount = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

},{"7baaa530584d1bc4":"fnt1n"}],"42cTS":[function(require,module,exports) {
const Polynomial = require("742a7ee6d6a2d145");
function ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = Polynomial.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = ReedSolomonEncoder;

},{"742a7ee6d6a2d145":"gZ2nu"}],"gZ2nu":[function(require,module,exports) {
const GF = require("780c74029318268c");
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ exports.mul = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= GF.mul(p1[i], p2[j]);
    return coeff;
};
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ exports.mod = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= GF.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ exports.generateECPolynomial = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = exports.mul(poly, new Uint8Array([
        1,
        GF.exp(i)
    ]));
    return poly;
};

},{"780c74029318268c":"dLsI5"}],"dLsI5":[function(require,module,exports) {
const EXP_TABLE = new Uint8Array(512);
const LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        EXP_TABLE[i] = x;
        LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)EXP_TABLE[i] = EXP_TABLE[i - 255];
})();
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.log = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return LOG_TABLE[n];
};
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.exp = function exp(n) {
    return EXP_TABLE[n];
};
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ exports.mul = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]];
};

},{}],"2m4It":[function(require,module,exports) {
const Utils = require("f67b02cdf61cb7c6");
const ECCode = require("777da0d92c463f2e");
const ECLevel = require("acd5b4fcd696edf3");
const Mode = require("5303c314c4a688d7");
const VersionCheck = require("663d0e03da8b2897");
// Generator polynomial used to encode version information
const G18 = 7973;
const G18_BCH = Utils.getBCHDigit(G18);
function getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return Mode.getCharCountIndicator(mode, version) + 4;
}
function getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) return currentVersion;
    }
    return undefined;
}
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ exports.getCapacity = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!VersionCheck.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = Mode.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === Mode.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case Mode.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case Mode.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case Mode.KANJI:
            return Math.floor(usableBits / 13);
        case Mode.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ exports.getEncodedBits = function getEncodedBits(version) {
    if (!VersionCheck.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while(Utils.getBCHDigit(d) - G18_BCH >= 0)d ^= G18 << Utils.getBCHDigit(d) - G18_BCH;
    return version << 12 | d;
};

},{"f67b02cdf61cb7c6":"bCvEH","777da0d92c463f2e":"itXks","acd5b4fcd696edf3":"fnt1n","5303c314c4a688d7":"epPN6","663d0e03da8b2897":"i5bYU"}],"epPN6":[function(require,module,exports) {
const VersionCheck = require("488660fac9162579");
const Regex = require("a23fd227d32f3622");
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ exports.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ exports.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ exports.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ exports.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ exports.MIXED = {
    bit: -1
};
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ exports.getCharCountIndicator = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!VersionCheck.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr)) return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr)) return exports.KANJI;
    else return exports.BYTE;
};
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ exports.toString = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ exports.isValid = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return exports.NUMERIC;
        case "alphanumeric":
            return exports.ALPHANUMERIC;
        case "kanji":
            return exports.KANJI;
        case "byte":
            return exports.BYTE;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{"488660fac9162579":"i5bYU","a23fd227d32f3622":"dbM7x"}],"i5bYU":[function(require,module,exports) {
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ exports.isValid = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

},{}],"dbM7x":[function(require,module,exports) {
const numeric = "[0-9]+";
const alphanumeric = "[A-Z $%*+\\-./:]+";
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
const byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
exports.KANJI = new RegExp(kanji, "g");
exports.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
exports.BYTE = new RegExp(byte, "g");
exports.NUMERIC = new RegExp(numeric, "g");
exports.ALPHANUMERIC = new RegExp(alphanumeric, "g");
const TEST_KANJI = new RegExp("^" + kanji + "$");
const TEST_NUMERIC = new RegExp("^" + numeric + "$");
const TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
exports.testKanji = function testKanji(str) {
    return TEST_KANJI.test(str);
};
exports.testNumeric = function testNumeric(str) {
    return TEST_NUMERIC.test(str);
};
exports.testAlphanumeric = function testAlphanumeric(str) {
    return TEST_ALPHANUMERIC.test(str);
};

},{}],"yj4S4":[function(require,module,exports) {
const Utils = require("eeca831a42e85d6c");
const G15 = 1335;
const G15_MASK = 21522;
const G15_BCH = Utils.getBCHDigit(G15);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ exports.getEncodedBits = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while(Utils.getBCHDigit(d) - G15_BCH >= 0)d ^= G15 << Utils.getBCHDigit(d) - G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ G15_MASK;
};

},{"eeca831a42e85d6c":"bCvEH"}],"6yArI":[function(require,module,exports) {
const Mode = require("45f6d4bff9d2fc72");
const NumericData = require("73109cbf4f3c309d");
const AlphanumericData = require("5320016e34c30467");
const ByteData = require("fd16f8f25b581951");
const KanjiData = require("8a7b84039f1cf0d2");
const Regex = require("79379a3a8f3c26bb");
const Utils = require("66903ca51bd2ea1d");
const dijkstra = require("3b9f47d541e7d71f");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function getSegmentsFromString(dataStr) {
    const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
    const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if (Utils.isKanjiModeEnabled()) {
        byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
        kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
    } else {
        byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function getSegmentBitsLength(length, mode) {
    switch(mode){
        case Mode.NUMERIC:
            return NumericData.getBitsLength(length);
        case Mode.ALPHANUMERIC:
            return AlphanumericData.getBitsLength(length);
        case Mode.KANJI:
            return KanjiData.getBitsLength(length);
        case Mode.BYTE:
            return ByteData.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case Mode.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
                break;
            case Mode.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = Mode.getBestModeForData(data);
    mode = Mode.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== Mode.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + Mode.toString(mode) + ".\n Suggested mode is: " + Mode.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) mode = Mode.BYTE;
    switch(mode){
        case Mode.NUMERIC:
            return new NumericData(data);
        case Mode.ALPHANUMERIC:
            return new AlphanumericData(data);
        case Mode.KANJI:
            return new KanjiData(data);
        case Mode.BYTE:
            return new ByteData(data);
    }
}
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push(buildSingleSegment(seg, null));
        else if (seg.data) acc.push(buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ exports.fromString = function fromString(data, version) {
    const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());
    const nodes = buildNodes(segs);
    const graph = buildGraph(nodes, version);
    const path = dijkstra.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return exports.fromArray(mergeSegments(optimizedSegs));
};
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(getSegmentsFromString(data, Utils.isKanjiModeEnabled()));
};

},{"45f6d4bff9d2fc72":"epPN6","73109cbf4f3c309d":"aUlLG","5320016e34c30467":"Ar6x0","fd16f8f25b581951":"hRx4f","8a7b84039f1cf0d2":"1og6T","79379a3a8f3c26bb":"dbM7x","66903ca51bd2ea1d":"bCvEH","3b9f47d541e7d71f":"dhJUA"}],"aUlLG":[function(require,module,exports) {
const Mode = require("29134b0b0820b091");
function NumericData(data) {
    this.mode = Mode.NUMERIC;
    this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength() {
    return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = NumericData;

},{"29134b0b0820b091":"epPN6"}],"Ar6x0":[function(require,module,exports) {
const Mode = require("9c7c9b869570f846");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function AlphanumericData(data) {
    this.mode = Mode.ALPHANUMERIC;
    this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = AlphanumericData;

},{"9c7c9b869570f846":"epPN6"}],"hRx4f":[function(require,module,exports) {
const encodeUtf8 = require("1658cb836325c397");
const Mode = require("a20a51f6cd184253");
function ByteData(data) {
    this.mode = Mode.BYTE;
    if (typeof data === "string") data = encodeUtf8(data);
    this.data = new Uint8Array(data);
}
ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength() {
    return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = ByteData;

},{"1658cb836325c397":"3rBfq","a20a51f6cd184253":"epPN6"}],"3rBfq":[function(require,module,exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

},{}],"1og6T":[function(require,module,exports) {
const Mode = require("b935cfd1cd03a1f6");
const Utils = require("ca4944585cc8d12d");
function KanjiData(data) {
    this.mode = Mode.KANJI;
    this.data = data;
}
KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength() {
    return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = Utils.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = KanjiData;

},{"b935cfd1cd03a1f6":"epPN6","ca4944585cc8d12d":"bCvEH"}],"dhJUA":[function(require,module,exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
        return dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = dijkstra;

},{}],"53FZc":[function(require,module,exports) {
const Utils = require("5b3f7c513802d6c7");
function clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
exports.render = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = getCanvasElement();
    opts = Utils.getOptions(opts);
    const size = Utils.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    Utils.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
exports.renderToDataURL = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = exports.render(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

},{"5b3f7c513802d6c7":"hOTXA"}],"hOTXA":[function(require,module,exports) {
function hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
exports.getOptions = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: hex2rgba(options.color.dark || "#000000ff"),
            light: hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
exports.getImageWidth = function getImageWidth(qrSize, opts) {
    const scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = exports.getScale(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

},{}],"cM6dr":[function(require,module,exports) {
const Utils = require("c36bbcf663291acc");
function getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
exports.render = function render(qrData, options, cb) {
    const opts = Utils.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

},{"c36bbcf663291acc":"hOTXA"}],"1DbR4":[function(require,module,exports) {
// see https://github.com/danfinlay/jazzicon
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "picasso", ()=>picasso);
const MersenneTwister = require("b03b50d04157f3b7");
const defaultColors = [
    "rgb(244, 67, 54)",
    "rgb(233, 30, 99)",
    "rgb(156, 39, 176)",
    "rgb(103, 58, 183)",
    "rgb(63, 81, 181)",
    "rgb(33, 150, 243)",
    "rgb(3, 169, 244)",
    "rgb(0, 188, 212)",
    "rgb(0, 150, 136)",
    "rgb(76, 175, 80)",
    "rgb(139, 195, 74)",
    "rgb(205, 220, 57)",
    "rgb(255, 193, 7)",
    "rgb(255, 152, 0)",
    "rgb(255, 87, 34)"
];
const hash = function(str) {
    if (str.length === 0) return 0;
    let h = 0;
    for(let i = 0; i < str.length; i++){
        h = h * 31 + str.charCodeAt(i);
        h = h % Math.pow(2, 32);
    }
    return h;
};
function picasso(content, colors) {
    colors = colors || defaultColors;
    const seed = hash(content);
    const rand = new MersenneTwister(seed);
    colors = colors.slice();
    const genColor = ()=>{
        const idx = Math.floor(colors.length * rand.random());
        return colors.splice(idx, 1)[0];
    };
    const bgStr = `<rect fill="${genColor()}" width="100" height="100"/>`;
    const style = `<style>.picasso circle{mix-blend-mode:soft-light;}</style>`;
    let shapesStr = "";
    const layers = 3;
    const rs = [
        35,
        40,
        45,
        50,
        55,
        60
    ];
    const cxs = [
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ];
    const cys = [
        30,
        40,
        50,
        60,
        70
    ];
    for(let i = 0; i < layers; i++){
        const r = rs.splice(Math.floor(rs.length * rand.random()), 1)[0];
        const cx = cxs.splice(Math.floor(cxs.length * rand.random()), 1)[0];
        const cy = cys.splice(Math.floor(cys.length * rand.random()), 1)[0];
        const fill = genColor();
        shapesStr += `<circle r="${r}" cx="${cx}" cy="${cy}" fill="${fill}"/>`;
    }
    return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="picasso" width="100" height="100" viewBox="0 0 100 100">${style}${bgStr}${shapesStr}</svg>`;
}
exports.default = picasso;

},{"b03b50d04157f3b7":"2vTNc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2vTNc":[function(require,module,exports) {
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/ /*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/ var MersenneTwister = function(seed) {
    if (seed == undefined) seed = new Date().getTime();
    /* Period parameters */ this.N = 624;
    this.M = 397;
    this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
    this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
    this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
    this.mt = new Array(this.N); /* the array for the state vector */ 
    this.mti = this.N + 1; /* mti==N+1 means mt[N] is not initialized */ 
    if (seed.constructor == Array) this.init_by_array(seed, seed.length);
    else this.init_seed(seed);
};
/* initializes mt[N] with a seed */ /* origin name init_genrand */ MersenneTwister.prototype.init_seed = function(s) {
    this.mt[0] = s >>> 0;
    for(this.mti = 1; this.mti < this.N; this.mti++){
        var s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
        this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
        /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
    /* for >32 bit machines */ }
};
/* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
    var i, j, k;
    this.init_seed(19650218);
    i = 1;
    j = 0;
    k = this.N > key_length ? this.N : key_length;
    for(; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        j++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
        if (j >= key_length) j = 0;
    }
    for(k = this.N - 1; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
    }
    this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
};
/* generates a random number on [0,0xffffffff]-interval */ /* origin name genrand_int32 */ MersenneTwister.prototype.random_int = function() {
    var y;
    var mag01 = new Array(0x0, this.MATRIX_A);
    /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
        var kk;
        if (this.mti == this.N + 1) /* if init_seed() has not been called, */ this.init_seed(5489); /* a default initial seed is used */ 
        for(kk = 0; kk < this.N - this.M; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        for(; kk < this.N - 1; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
        this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
        this.mti = 0;
    }
    y = this.mt[this.mti++];
    /* Tempering */ y ^= y >>> 11;
    y ^= y << 7 & 0x9d2c5680;
    y ^= y << 15 & 0xefc60000;
    y ^= y >>> 18;
    return y >>> 0;
};
/* generates a random number on [0,0x7fffffff]-interval */ /* origin name genrand_int31 */ MersenneTwister.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
};
/* generates a random number on [0,1]-real-interval */ /* origin name genrand_real1 */ MersenneTwister.prototype.random_incl = function() {
    return this.random_int() * (1.0 / 4294967295.0);
/* divided by 2^32-1 */ };
/* generates a random number on [0,1)-real-interval */ MersenneTwister.prototype.random = function() {
    return this.random_int() * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on (0,1)-real-interval */ /* origin name genrand_real3 */ MersenneTwister.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on [0,1) with 53-bit resolution*/ /* origin name genrand_res53 */ MersenneTwister.prototype.random_long = function() {
    var a = this.random_int() >>> 5, b = this.random_int() >>> 6;
    return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
};
/* These real versions are due to Isaku Wada, 2002/01/09 added */ module.exports = MersenneTwister;

},{}],"kQrIl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _customElementJs = require("@lit/reactive-element/decorators/custom-element.js");
parcelHelpers.exportAll(_customElementJs, exports);
var _propertyJs = require("@lit/reactive-element/decorators/property.js");
parcelHelpers.exportAll(_propertyJs, exports);
var _stateJs = require("@lit/reactive-element/decorators/state.js");
parcelHelpers.exportAll(_stateJs, exports);
var _eventOptionsJs = require("@lit/reactive-element/decorators/event-options.js");
parcelHelpers.exportAll(_eventOptionsJs, exports);
var _queryJs = require("@lit/reactive-element/decorators/query.js");
parcelHelpers.exportAll(_queryJs, exports);
var _queryAllJs = require("@lit/reactive-element/decorators/query-all.js");
parcelHelpers.exportAll(_queryAllJs, exports);
var _queryAsyncJs = require("@lit/reactive-element/decorators/query-async.js");
parcelHelpers.exportAll(_queryAsyncJs, exports);
var _queryAssignedElementsJs = require("@lit/reactive-element/decorators/query-assigned-elements.js");
parcelHelpers.exportAll(_queryAssignedElementsJs, exports);
var _queryAssignedNodesJs = require("@lit/reactive-element/decorators/query-assigned-nodes.js");
parcelHelpers.exportAll(_queryAssignedNodesJs, exports);

},{"@lit/reactive-element/decorators/custom-element.js":"dYoHp","@lit/reactive-element/decorators/property.js":"dggVt","@lit/reactive-element/decorators/state.js":"dJKtr","@lit/reactive-element/decorators/event-options.js":"9SENf","@lit/reactive-element/decorators/query.js":"12Pya","@lit/reactive-element/decorators/query-all.js":"gzvjw","@lit/reactive-element/decorators/query-async.js":"kZTrS","@lit/reactive-element/decorators/query-assigned-elements.js":"6ZZSg","@lit/reactive-element/decorators/query-assigned-nodes.js":"l1UPB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dYoHp":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customElement", ()=>t);
const t = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dggVt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "property", ()=>n);
parcelHelpers.export(exports, "standardProperty", ()=>r);
var _reactiveElementJs = require("../reactive-element.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const o = {
    attribute: !0,
    type: String,
    converter: (0, _reactiveElementJs.defaultConverter),
    reflect: !1,
    hasChanged: (0, _reactiveElementJs.notEqual)
}, r = (t = o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function n(t) {
    return (e, o)=>"object" == typeof o ? r(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

},{"../reactive-element.js":"hUcCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJKtr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "state", ()=>r);
var _propertyJs = require("./property.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (0, _propertyJs.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

},{"./property.js":"dggVt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SENf":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventOptions", ()=>t);
function t(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"12Pya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "query", ()=>e);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, _baseJs.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, _baseJs.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4sFH":[function(require,module,exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "desc", ()=>e);
const e = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzvjw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAll", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let e;
function r(r) {
    return (n, o)=>(0, _baseJs.desc)(n, o, {
            get () {
                return (this.renderRoot ?? (e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZTrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAsync", ()=>r);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function r(r) {
    return (n, e)=>(0, _baseJs.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZZSg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedElements", ()=>o);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, _baseJs.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1UPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryAssignedNodes", ()=>n);
var _baseJs = require("./base.js");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function n(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, _baseJs.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

},{"./base.js":"f4sFH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJjIx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createComponent", ()=>(0, _createComponentJs.createComponent));
var _createComponentJs = require("./create-component.js");

},{"./create-component.js":"grZn0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grZn0":[function(require,module,exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createComponent", ()=>o);
const e = new Set([
    "children",
    "localName",
    "ref",
    "style",
    "className"
]), n = new WeakMap, t = (e, t, o, l, a)=>{
    const s = a?.[t];
    void 0 === s ? (e[t] = o, null == o && t in HTMLElement.prototype && e.removeAttribute(t)) : o !== l && ((e, t, o)=>{
        let l = n.get(e);
        void 0 === l && n.set(e, l = new Map);
        let a = l.get(t);
        void 0 !== o ? void 0 === a ? (l.set(t, a = {
            handleEvent: o
        }), e.addEventListener(t, a)) : a.handleEvent = o : void 0 !== a && (l.delete(t), e.removeEventListener(t, a));
    })(e, s, o);
}, o = ({ react: n, tagName: o, elementClass: l, events: a, displayName: s })=>{
    const c = new Set(Object.keys(a ?? {})), r = n.forwardRef((s, r)=>{
        const i = n.useRef(new Map), d = n.useRef(null), f = {}, u = {};
        for (const [n, t] of Object.entries(s))e.has(n) ? f["className" === n ? "class" : n] = t : c.has(n) || n in l.prototype ? u[n] = t : f[n] = t;
        return n.useLayoutEffect(()=>{
            if (null === d.current) return;
            const e = new Map;
            for(const n in u)t(d.current, n, s[n], i.current.get(n), a), i.current.delete(n), e.set(n, s[n]);
            for (const [e, n] of i.current)t(d.current, e, void 0, n, a);
            i.current = e;
        }), n.useLayoutEffect(()=>{
            d.current?.removeAttribute("defer-hydration");
        }, []), f.suppressHydrationWarning = !0, n.createElement(o, {
            ...f,
            ref: n.useCallback((e)=>{
                d.current = e, "function" == typeof r ? r(e) : null !== r && (r.current = e);
            }, [
                r
            ])
        });
    });
    return r.displayName = s ?? l.name, r;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2gEtt":[function(require,module,exports) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HydrationBoundary", ()=>(0, _hydrationBoundaryJs.HydrationBoundary));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringJs.IsRestoringProvider));
parcelHelpers.export(exports, "QueryClientContext", ()=>(0, _queryClientProviderJs.QueryClientContext));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderJs.QueryClientProvider));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "infiniteQueryOptions", ()=>(0, _infiniteQueryOptionsJs.infiniteQueryOptions));
parcelHelpers.export(exports, "queryOptions", ()=>(0, _queryOptionsJs.queryOptions));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryJs.useInfiniteQuery));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useMutationStateJs.useIsMutating));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringJs.useIsRestoring));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationJs.useMutation));
parcelHelpers.export(exports, "useMutationState", ()=>(0, _useMutationStateJs.useMutationState));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryJs.useQuery));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderJs.useQueryClient));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useSuspenseInfiniteQuery", ()=>(0, _useSuspenseInfiniteQueryJs.useSuspenseInfiniteQuery));
parcelHelpers.export(exports, "useSuspenseQueries", ()=>(0, _useSuspenseQueriesJs.useSuspenseQueries));
parcelHelpers.export(exports, "useSuspenseQuery", ()=>(0, _useSuspenseQueryJs.useSuspenseQuery));
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _useQueriesJs = require("./useQueries.js");
var _useQueryJs = require("./useQuery.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useSuspenseInfiniteQueryJs = require("./useSuspenseInfiniteQuery.js");
var _useSuspenseQueriesJs = require("./useSuspenseQueries.js");
var _queryOptionsJs = require("./queryOptions.js");
var _infiniteQueryOptionsJs = require("./infiniteQueryOptions.js");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _hydrationBoundaryJs = require("./HydrationBoundary.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _useIsFetchingJs = require("./useIsFetching.js");
var _useMutationStateJs = require("./useMutationState.js");
var _useMutationJs = require("./useMutation.js");
var _useInfiniteQueryJs = require("./useInfiniteQuery.js");
var _isRestoringJs = require("./isRestoring.js");

},{"@tanstack/query-core":"dON9S","./types.js":"hoyry","./useQueries.js":false,"./useQuery.js":"fLkDJ","./useSuspenseQuery.js":false,"./useSuspenseInfiniteQuery.js":false,"./useSuspenseQueries.js":false,"./queryOptions.js":false,"./infiniteQueryOptions.js":false,"./QueryClientProvider.js":"3YnsP","./HydrationBoundary.js":false,"./QueryErrorResetBoundary.js":false,"./useIsFetching.js":false,"./useMutationState.js":false,"./useMutation.js":false,"./useInfiniteQuery.js":false,"./isRestoring.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dON9S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerJs.CancelledError));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverJs.MutationObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverJs.QueriesObserver));
parcelHelpers.export(exports, "Query", ()=>(0, _queryJs.Query));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverJs.QueryObserver));
parcelHelpers.export(exports, "defaultShouldDehydrateMutation", ()=>(0, _hydrationJs.defaultShouldDehydrateMutation));
parcelHelpers.export(exports, "defaultShouldDehydrateQuery", ()=>(0, _hydrationJs.defaultShouldDehydrateQuery));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationJs.dehydrate));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerJs.focusManager));
parcelHelpers.export(exports, "hashKey", ()=>(0, _utilsJs.hashKey));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationJs.hydrate));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerJs.isCancelledError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsJs.isServer));
parcelHelpers.export(exports, "keepPreviousData", ()=>(0, _utilsJs.keepPreviousData));
parcelHelpers.export(exports, "matchMutation", ()=>(0, _utilsJs.matchMutation));
parcelHelpers.export(exports, "matchQuery", ()=>(0, _utilsJs.matchQuery));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerJs.notifyManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerJs.onlineManager));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsJs.replaceEqualDeep));
parcelHelpers.export(exports, "skipToken", ()=>(0, _utilsJs.skipToken));
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/index.ts
var _retryerJs = require("./retryer.js");
var _queryCacheJs = require("./queryCache.js");
var _queryClientJs = require("./queryClient.js");
var _queryObserverJs = require("./queryObserver.js");
var _queriesObserverJs = require("./queriesObserver.js");
var _infiniteQueryObserverJs = require("./infiniteQueryObserver.js");
var _mutationCacheJs = require("./mutationCache.js");
var _mutationObserverJs = require("./mutationObserver.js");
var _notifyManagerJs = require("./notifyManager.js");
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _utilsJs = require("./utils.js");
var _hydrationJs = require("./hydration.js");
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _queryJs = require("./query.js");

},{"./chunk-2HYBKCYP.js":"aYUR6","./retryer.js":false,"./queryCache.js":false,"./queryClient.js":"cxOQj","./queryObserver.js":"jz2MX","./queriesObserver.js":false,"./infiniteQueryObserver.js":false,"./mutationCache.js":false,"./mutationObserver.js":false,"./notifyManager.js":"gDPaf","./focusManager.js":false,"./onlineManager.js":false,"./utils.js":false,"./hydration.js":false,"./types.js":false,"./query.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aYUR6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__privateGet", ()=>__privateGet);
parcelHelpers.export(exports, "__privateAdd", ()=>__privateAdd);
parcelHelpers.export(exports, "__privateSet", ()=>__privateSet);
parcelHelpers.export(exports, "__privateWrapper", ()=>__privateWrapper);
parcelHelpers.export(exports, "__privateMethod", ()=>__privateMethod);
var __accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter)=>{
    __accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var __privateSet = (obj, member, value1, setter)=>{
    __accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var __privateWrapper = (obj, member, setter, getter)=>({
        set _ (value){
            __privateSet(obj, member, value, setter);
        },
        get _ () {
            return __privateGet(obj, member, getter);
        }
    });
var __privateMethod = (obj, member, method)=>{
    __accessCheck(obj, member, "access private method");
    return method;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9do0x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/retryer.ts
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _utilsJs = require("./utils.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, _onlineManagerJs.onlineManager).isOnline() : true;
}
var CancelledError = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new CancelledError(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, _focusManagerJs.focusManager).isFocused() || config.networkMode !== "always" && !(0, _onlineManagerJs.onlineManager).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, _utilsJs.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, _utilsJs.sleep)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if (canFetch(config.networkMode)) run();
    else pause().then(run);
    return {
        promise,
        cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry,
        continueRetry
    };
}

},{"./chunk-2HYBKCYP.js":"aYUR6","./focusManager.js":"88cOZ","./onlineManager.js":"j9JOC","./utils.js":"3V7Jq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"88cOZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/focusManager.ts
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _focused, _cleanup, _setup;
var FocusManager = class extends (0, _subscribableJs.Subscribable) {
    constructor(){
        super();
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _focused, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _cleanup, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _setup, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _setup, (onFocus)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) this.setEventListener((0, _chunk2HYBKCYPJs.__privateGet)(this, _setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) == null || _a.call(this);
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _setup, setup);
        (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) == null || _a.call(this);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, _chunk2HYBKCYPJs.__privateGet)(this, _focused) !== focused;
        if (changed) {
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, _chunk2HYBKCYPJs.__privateGet)(this, _focused) === "boolean") return (0, _chunk2HYBKCYPJs.__privateGet)(this, _focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
_focused = new WeakMap();
_cleanup = new WeakMap();
_setup = new WeakMap();
var focusManager = new FocusManager();

},{"./chunk-2HYBKCYP.js":"aYUR6","./subscribable.js":"aXRuy","./utils.js":"3V7Jq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aXRuy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/subscribable.ts
var Subscribable = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

},{"./chunk-2HYBKCYP.js":"aYUR6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3V7Jq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToEnd", ()=>addToEnd);
parcelHelpers.export(exports, "addToStart", ()=>addToStart);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "hashKey", ()=>hashKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "keepPreviousData", ()=>keepPreviousData);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/utils.ts
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {
    return void 0;
}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, status, predicate, mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashKey;
    return hashFn(queryKey);
}
function hashKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function partialMatchKey(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!partialMatchKey(a[key], b[key]));
    return false;
}
function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = replaceEqualDeep(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function shallowEqualObjects(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function replaceData(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return replaceEqualDeep(prevData, data);
    return data;
}
function keepPreviousData(previousData) {
    return previousData;
}
function addToEnd(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = Symbol();

},{"./chunk-2HYBKCYP.js":"aYUR6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j9JOC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/onlineManager.ts
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _online, _cleanup, _setup;
var OnlineManager = class extends (0, _subscribableJs.Subscribable) {
    constructor(){
        super();
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _online, true);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _cleanup, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _setup, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _setup, (onOnline)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) this.setEventListener((0, _chunk2HYBKCYPJs.__privateGet)(this, _setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) == null || _a.call(this);
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _setup, setup);
        (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cleanup)) == null || _a.call(this);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, _chunk2HYBKCYPJs.__privateGet)(this, _online) !== online;
        if (changed) {
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _online);
    }
};
_online = new WeakMap();
_cleanup = new WeakMap();
_setup = new WeakMap();
var onlineManager = new OnlineManager();

},{"./chunk-2HYBKCYP.js":"aYUR6","./subscribable.js":"aXRuy","./utils.js":"3V7Jq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkt6t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/queryCache.ts
var _utilsJs = require("./utils.js");
var _queryJs = require("./query.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var _queries;
var QueryCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _queries, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, _utilsJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryJs.Query)({
                cache: this,
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).has(query.queryHash)) {
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, _utilsJs.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, _utilsJs.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
_queries = new WeakMap();

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","./query.js":"fZf5A","./notifyManager.js":"gDPaf","./subscribable.js":"aXRuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fZf5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
parcelHelpers.export(exports, "fetchState", ()=>fetchState);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/query.ts
var _utilsJs = require("./utils.js");
var _notifyManagerJs = require("./notifyManager.js");
var _retryerJs = require("./retryer.js");
var _removableJs = require("./removable.js");
var _initialState, _revertState, _cache, _retryer, _observers, _defaultOptions, _abortSignalConsumed, _dispatch, dispatch_fn;
var Query = class extends (0, _removableJs.Removable) {
    constructor(config){
        super();
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _dispatch);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _initialState, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _revertState, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _cache, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _retryer, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _observers, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _defaultOptions, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _abortSignalConsumed, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _abortSignalConsumed, false);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _observers, []);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _initialState, config.state || getDefaultState(this.options));
        this.state = (0, _chunk2HYBKCYPJs.__privateGet)(this, _initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).length && this.state.fetchStatus === "idle") (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsJs.replaceData)(this.state.data, newData, this.options);
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
            data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) == null ? void 0 : _a.promise;
        (_b = (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, _utilsJs.noop)).catch((0, _utilsJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, _chunk2HYBKCYPJs.__privateGet)(this, _initialState));
    }
    isActive() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, _utilsJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).includes(observer)) {
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).push(observer);
            this.clearGcTimeout();
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).includes(observer)) {
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _observers, (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).filter((x)=>x !== observer));
            if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).length) {
                if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) {
                    if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _abortSignalConsumed)) (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).cancel({
                        revert: true
                    });
                    else (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) {
                (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).continueRetry();
                return (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, _chunk2HYBKCYPJs.__privateSet)(this, _abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn || this.options.queryFn === (0, _utilsJs.skipToken)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, _retryerJs.isCancelledError)(error) && error.silent)) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                type: "error",
                error
            });
            if (!(0, _retryerJs.isCancelledError)(error)) {
                (_b2 = (_a2 = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _retryer, (0, _retryerJs.createRetryer)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError,
            onFail: (failureCount, error)=>{
                (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).promise;
    }
};
_initialState = new WeakMap();
_revertState = new WeakMap();
_cache = new WeakMap();
_retryer = new WeakMap();
_observers = new WeakMap();
_defaultOptions = new WeakMap();
_abortSignalConsumed = new WeakMap();
_dispatch = new WeakSet();
dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...fetchState(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, _retryerJs.isCancelledError)(error) && error.revert && (0, _chunk2HYBKCYPJs.__privateGet)(this, _revertState)) return {
                    ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _cache).notify({
            query: this,
            type: "updated",
            action
        });
    });
};
function fetchState(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, _retryerJs.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","./notifyManager.js":"gDPaf","./retryer.js":"9do0x","./removable.js":"k01LJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gDPaf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/notifyManager.ts
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch,
        batchCalls,
        schedule,
        setNotifyFunction,
        setBatchNotifyFunction,
        setScheduler
    };
}
var notifyManager = createNotifyManager();

},{"./chunk-2HYBKCYP.js":"aYUR6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k01LJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/removable.ts
var _utilsJs = require("./utils.js");
var _gcTimeout;
var Removable = class {
    constructor(){
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsJs.isValidTimeout)(this.gcTime)) (0, _chunk2HYBKCYPJs.__privateSet)(this, _gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, _utilsJs.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _gcTimeout)) {
            clearTimeout((0, _chunk2HYBKCYPJs.__privateGet)(this, _gcTimeout));
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _gcTimeout, void 0);
        }
    }
};
_gcTimeout = new WeakMap();

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxOQj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/queryClient.ts
var _utilsJs = require("./utils.js");
var _queryCacheJs = require("./queryCache.js");
var _mutationCacheJs = require("./mutationCache.js");
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _infiniteQueryBehaviorJs = require("./infiniteQueryBehavior.js");
var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;
var QueryClient = class {
    constructor(config = {}){
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _queryCache, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mutationCache, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _defaultOptions, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _queryDefaults, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mutationDefaults, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mountCount, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _unsubscribeFocus, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _unsubscribeOnline, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _queryCache, config.queryCache || new (0, _queryCacheJs.QueryCache)());
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutationCache, config.mutationCache || new (0, _mutationCacheJs.MutationCache)());
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _defaultOptions, config.defaultOptions || {});
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _queryDefaults, /* @__PURE__ */ new Map());
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutationDefaults, /* @__PURE__ */ new Map());
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mountCount, 0);
    }
    mount() {
        (0, _chunk2HYBKCYPJs.__privateWrapper)(this, _mountCount)._++;
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _mountCount) !== 1) return;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _unsubscribeFocus, (0, _focusManagerJs.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).onFocus();
            }
        }));
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _unsubscribeOnline, (0, _onlineManagerJs.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, _chunk2HYBKCYPJs.__privateWrapper)(this, _mountCount)._--;
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _mountCount) !== 0) return;
        (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _unsubscribeFocus)) == null || _a.call(this);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _unsubscribeFocus, void 0);
        (_b = (0, _chunk2HYBKCYPJs.__privateGet)(this, _unsubscribeOnline)) == null || _b.call(this);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll(filters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey
        });
        const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsJs.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll(filters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache);
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, _utilsJs.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, _utilsJs.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    resumePausedMutations() {
        if ((0, _onlineManagerJs.onlineManager).isOnline()) return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache);
    }
    getMutationCache() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache);
    }
    getDefaultOptions() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _defaultOptions);
    }
    setDefaultOptions(options) {
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryDefaults).set((0, _utilsJs.hashKey)(queryKey), {
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationDefaults).set((0, _utilsJs.hashKey)(mutationKey), {
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, _utilsJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, _utilsJs.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _queryCache).clear();
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).clear();
    }
};
_queryCache = new WeakMap();
_mutationCache = new WeakMap();
_defaultOptions = new WeakMap();
_queryDefaults = new WeakMap();
_mutationDefaults = new WeakMap();
_mountCount = new WeakMap();
_unsubscribeFocus = new WeakMap();
_unsubscribeOnline = new WeakMap();

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","./queryCache.js":"lkt6t","./mutationCache.js":"2fUcV","./focusManager.js":"88cOZ","./onlineManager.js":"j9JOC","./notifyManager.js":"gDPaf","./infiniteQueryBehavior.js":"aWVrJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fUcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/mutationCache.ts
var _notifyManagerJs = require("./notifyManager.js");
var _mutationJs = require("./mutation.js");
var _utilsJs = require("./utils.js");
var _subscribableJs = require("./subscribable.js");
var _mutations, _mutationId, _resuming;
var MutationCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mutations, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mutationId, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _resuming, void 0);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutations, []);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, _mutationJs.Mutation)({
            mutationCache: this,
            mutationId: ++(0, _chunk2HYBKCYPJs.__privateWrapper)(this, _mutationId)._,
            options: client.defaultMutationOptions(options),
            state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).push(mutation);
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutations, (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation
        });
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).find((mutation)=>(0, _utilsJs.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).filter((mutation)=>(0, _utilsJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _resuming, ((0, _chunk2HYBKCYPJs.__privateGet)(this, _resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutations).filter((x)=>x.state.isPaused);
            return (0, _notifyManagerJs.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, _utilsJs.noop))), Promise.resolve()));
        }).then(()=>{
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _resuming, void 0);
        }));
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _resuming);
    }
};
_mutations = new WeakMap();
_mutationId = new WeakMap();
_resuming = new WeakMap();

},{"./chunk-2HYBKCYP.js":"aYUR6","./notifyManager.js":"gDPaf","./mutation.js":"eC3co","./utils.js":"3V7Jq","./subscribable.js":"aXRuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eC3co":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/mutation.ts
var _notifyManagerJs = require("./notifyManager.js");
var _removableJs = require("./removable.js");
var _retryerJs = require("./retryer.js");
var _observers, _defaultOptions, _mutationCache, _retryer, _dispatch, dispatch_fn;
var Mutation = class extends (0, _removableJs.Removable) {
    constructor(config){
        super();
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _dispatch);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _observers, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _defaultOptions, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _mutationCache, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _retryer, void 0);
        this.mutationId = config.mutationId;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _defaultOptions, config.defaultOptions);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _mutationCache, config.mutationCache);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _observers, []);
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, _chunk2HYBKCYPJs.__privateGet)(this, _defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).includes(observer)) {
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).push(observer);
            this.clearGcTimeout();
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _observers, (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _retryer, (0, _retryerJs.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                        type: "failed",
                        failureCount,
                        error
                    });
                },
                onPause: ()=>{
                    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, _chunk2HYBKCYPJs.__privateGet)(this, _retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "pending",
                    variables
                });
                await ((_b = (_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "pending",
                    context,
                    variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, _chunk2HYBKCYPJs.__privateMethod)(this, _dispatch, dispatch_fn).call(this, {
                    type: "error",
                    error
                });
            }
        }
    }
};
_observers = new WeakMap();
_defaultOptions = new WeakMap();
_mutationCache = new WeakMap();
_retryer = new WeakMap();
_dispatch = new WeakSet();
dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, _retryerJs.canFetch)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _mutationCache).notify({
            mutation: this,
            type: "updated",
            action
        });
    });
};
function getDefaultState() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

},{"./chunk-2HYBKCYP.js":"aYUR6","./notifyManager.js":"gDPaf","./removable.js":"k01LJ","./retryer.js":"9do0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aWVrJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/infiniteQueryBehavior.ts
var _utilsJs = require("./utils.js");
function infiniteQueryBehavior(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, _utilsJs.skipToken) ? context.options.queryFn : ()=>{
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages } = context.options;
                    const addTo = previous ? (0, _utilsJs.addToStart) : (0, _utilsJs.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function getNextPageParam(options, { pages, pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function getPreviousPageParam(options, { pages, pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function hasNextPage(options, data) {
    if (!data) return false;
    return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return getPreviousPageParam(options, data) != null;
}

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jz2MX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _chunk2HYBKCYPJs = require("./chunk-2HYBKCYP.js");
// src/queryObserver.ts
var _utilsJs = require("./utils.js");
var _notifyManagerJs = require("./notifyManager.js");
var _focusManagerJs = require("./focusManager.js");
var _subscribableJs = require("./subscribable.js");
var _queryJs = require("./query.js");
var _client, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _selectError, _selectFn, _selectResult, _lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _executeFetch, executeFetch_fn, _updateStaleTimeout, updateStaleTimeout_fn, _computeRefetchInterval, computeRefetchInterval_fn, _updateRefetchInterval, updateRefetchInterval_fn, _updateTimers, updateTimers_fn, _clearStaleTimeout, clearStaleTimeout_fn, _clearRefetchInterval, clearRefetchInterval_fn, _updateQuery, updateQuery_fn, _notify, notify_fn;
var QueryObserver = class extends (0, _subscribableJs.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _executeFetch);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _updateStaleTimeout);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _computeRefetchInterval);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _updateRefetchInterval);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _updateTimers);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _clearStaleTimeout);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _clearRefetchInterval);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _updateQuery);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _notify);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _client, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentQuery, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentQueryInitialState, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentResult, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentResultState, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentResultOptions, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _selectError, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _selectFn, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _lastQueryWithDefinedData, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _staleTimeoutId, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _refetchIntervalId, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _currentRefetchInterval, void 0);
        (0, _chunk2HYBKCYPJs.__privateAdd)(this, _trackedProps, /* @__PURE__ */ new Set());
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _client, client);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).addObserver(this);
            if (shouldFetchOnMount((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery), this.options)) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _executeFetch, executeFetch_fn).call(this);
            else this.updateResult();
            (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateTimers, updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _clearStaleTimeout, clearStaleTimeout_fn).call(this);
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _clearRefetchInterval, clearRefetchInterval_fn).call(this);
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery);
        this.options = (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateQuery, updateQuery_fn).call(this);
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && shouldFetchOptionally((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery), prevQuery, this.options, prevOptions)) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _executeFetch, executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateStaleTimeout, updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, _chunk2HYBKCYPJs.__privateMethod)(this, _computeRefetchInterval, computeRefetchInterval_fn).call(this);
        if (mounted && ((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentRefetchInterval))) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateRefetchInterval, updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).getQueryCache().build((0, _chunk2HYBKCYPJs.__privateGet)(this, _client), options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result)) {
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResult, result);
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResultOptions, this.options);
            (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResultState, (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).defaultQueryOptions(options);
        const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).getQueryCache().build((0, _chunk2HYBKCYPJs.__privateGet)(this, _client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, _chunk2HYBKCYPJs.__privateMethod)(this, _executeFetch, executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult);
        const prevResultState = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResultState);
        const prevResultOptions = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQueryInitialState);
        const { state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, _queryJs.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error, errorUpdatedAt, status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, _chunk2HYBKCYPJs.__privateGet)(this, _selectFn)) data = (0, _chunk2HYBKCYPJs.__privateGet)(this, _selectResult);
            else try {
                (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectFn, options.select);
                data = options.select(newState.data);
                data = (0, _utilsJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectResult, data);
                (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectError, null);
            } catch (selectError) {
                (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, _chunk2HYBKCYPJs.__privateGet)(this, _lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, _chunk2HYBKCYPJs.__privateGet)(this, _lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectError, null);
                } catch (selectError) {
                    (0, _chunk2HYBKCYPJs.__privateSet)(this, _selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, _utilsJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _selectError)) {
            error = (0, _chunk2HYBKCYPJs.__privateGet)(this, _selectError);
            data = (0, _chunk2HYBKCYPJs.__privateGet)(this, _selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status,
            fetchStatus: newState.fetchStatus,
            isPending,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading,
            isLoading,
            data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult);
        const nextResult = this.createResult((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery), this.options);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResultState, (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).state);
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResultOptions, this.options);
        if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResultState).data !== void 0) (0, _chunk2HYBKCYPJs.__privateSet)(this, _lastQueryWithDefinedData, (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery));
        if ((0, _utilsJs.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, _chunk2HYBKCYPJs.__privateGet)(this, _trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, _chunk2HYBKCYPJs.__privateGet)(this, _trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, _chunk2HYBKCYPJs.__privateMethod)(this, _notify, notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateTimers, updateTimers_fn).call(this);
    }
};
_client = new WeakMap();
_currentQuery = new WeakMap();
_currentQueryInitialState = new WeakMap();
_currentResult = new WeakMap();
_currentResultState = new WeakMap();
_currentResultOptions = new WeakMap();
_selectError = new WeakMap();
_selectFn = new WeakMap();
_selectResult = new WeakMap();
_lastQueryWithDefinedData = new WeakMap();
_staleTimeoutId = new WeakMap();
_refetchIntervalId = new WeakMap();
_currentRefetchInterval = new WeakMap();
_trackedProps = new WeakMap();
_executeFetch = new WeakSet();
executeFetch_fn = function(fetchOptions) {
    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateQuery, updateQuery_fn).call(this);
    let promise = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, _utilsJs.noop));
    return promise;
};
_updateStaleTimeout = new WeakSet();
updateStaleTimeout_fn = function() {
    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _clearStaleTimeout, clearStaleTimeout_fn).call(this);
    if ((0, _utilsJs.isServer) || (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult).isStale || !(0, _utilsJs.isValidTimeout)(this.options.staleTime)) return;
    const time = (0, _utilsJs.timeUntilStale)((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, _chunk2HYBKCYPJs.__privateSet)(this, _staleTimeoutId, setTimeout(()=>{
        if (!(0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult).isStale) this.updateResult();
    }, timeout));
};
_computeRefetchInterval = new WeakSet();
computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery)) : this.options.refetchInterval) ?? false;
};
_updateRefetchInterval = new WeakSet();
updateRefetchInterval_fn = function(nextInterval) {
    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _clearRefetchInterval, clearRefetchInterval_fn).call(this);
    (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentRefetchInterval, nextInterval);
    if ((0, _utilsJs.isServer) || this.options.enabled === false || !(0, _utilsJs.isValidTimeout)((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentRefetchInterval)) || (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentRefetchInterval) === 0) return;
    (0, _chunk2HYBKCYPJs.__privateSet)(this, _refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, _focusManagerJs.focusManager).isFocused()) (0, _chunk2HYBKCYPJs.__privateMethod)(this, _executeFetch, executeFetch_fn).call(this);
    }, (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentRefetchInterval)));
};
_updateTimers = new WeakSet();
updateTimers_fn = function() {
    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateStaleTimeout, updateStaleTimeout_fn).call(this);
    (0, _chunk2HYBKCYPJs.__privateMethod)(this, _updateRefetchInterval, updateRefetchInterval_fn).call(this, (0, _chunk2HYBKCYPJs.__privateMethod)(this, _computeRefetchInterval, computeRefetchInterval_fn).call(this));
};
_clearStaleTimeout = new WeakSet();
clearStaleTimeout_fn = function() {
    if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _staleTimeoutId)) {
        clearTimeout((0, _chunk2HYBKCYPJs.__privateGet)(this, _staleTimeoutId));
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _staleTimeoutId, void 0);
    }
};
_clearRefetchInterval = new WeakSet();
clearRefetchInterval_fn = function() {
    if ((0, _chunk2HYBKCYPJs.__privateGet)(this, _refetchIntervalId)) {
        clearInterval((0, _chunk2HYBKCYPJs.__privateGet)(this, _refetchIntervalId));
        (0, _chunk2HYBKCYPJs.__privateSet)(this, _refetchIntervalId, void 0);
    }
};
_updateQuery = new WeakSet();
updateQuery_fn = function() {
    const query = (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).getQueryCache().build((0, _chunk2HYBKCYPJs.__privateGet)(this, _client), this.options);
    if (query === (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery)) return;
    const prevQuery = (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery);
    (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentQuery, query);
    (0, _chunk2HYBKCYPJs.__privateSet)(this, _currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
_notify = new WeakSet();
notify_fn = function(notifyOptions) {
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, _chunk2HYBKCYPJs.__privateGet)(this, _currentResult));
        });
        (0, _chunk2HYBKCYPJs.__privateGet)(this, _client).getQueryCache().notify({
            query: (0, _chunk2HYBKCYPJs.__privateGet)(this, _currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return options.enabled !== false && query.isStaleByTime(options.staleTime);
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, _utilsJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

},{"./chunk-2HYBKCYP.js":"aYUR6","./utils.js":"3V7Jq","./notifyManager.js":"gDPaf","./focusManager.js":"88cOZ","./subscribable.js":"aXRuy","./query.js":"fZf5A","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hoyry":[function(require,module,exports) {

},{}],"fLkDJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
// src/useQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
"use client";
function useQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)(options, (0, _queryCore.QueryObserver), queryClient);
}

},{"@tanstack/query-core":"dON9S","./useBaseQuery.js":"bukak","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bukak":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
// src/useBaseQuery.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _isRestoringJs = require("./isRestoring.js");
var _errorBoundaryUtilsJs = require("./errorBoundaryUtils.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useBaseQuery(options, Observer, queryClient) {
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const isRestoring = (0, _isRestoringJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, _suspenseJs.ensureStaleTime)(defaultedOptions);
    (0, _errorBoundaryUtilsJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, _suspenseJs.shouldSuspend)(defaultedOptions, result)) throw (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, _errorBoundaryUtilsJs.getHasError)({
        result,
        errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"6uln9","@tanstack/query-core":"dON9S","./QueryErrorResetBoundary.js":"d8CYJ","./QueryClientProvider.js":"3YnsP","./isRestoring.js":"hK1NJ","./errorBoundaryUtils.js":"ePB0V","./suspense.js":"8H0cn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8CYJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
// src/QueryErrorResetBoundary.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = _react.createContext(createValue());
var useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext);
var QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryErrorResetBoundaryContext.Provider, {
        value,
        children: typeof children === "function" ? children(value) : children
    });
};

},{"react":"6uln9","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3YnsP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientContext", ()=>QueryClientContext);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
// src/QueryClientProvider.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var QueryClientContext = _react.createContext(void 0);
var useQueryClient = (queryClient)=>{
    const client = _react.useContext(QueryClientContext);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var QueryClientProvider = ({ client, children })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryClientContext.Provider, {
        value: client,
        children
    });
};

},{"react":"6uln9","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hK1NJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
// src/isRestoring.ts
var _react = require("react");
"use client";
var IsRestoringContext = _react.createContext(false);
var useIsRestoring = ()=>_react.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePB0V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
// src/errorBoundaryUtils.ts
var _react = require("react");
var _utilsJs = require("./utils.js");
"use client";
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var getHasError = ({ result, errorResetBoundary, throwOnError, query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, _utilsJs.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]);
};

},{"react":"6uln9","./utils.js":"76ItQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"76ItQ":[function(require,module,exports) {
// src/utils.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8H0cn":[function(require,module,exports) {
// src/suspense.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrowOnError", ()=>defaultThrowOnError);
parcelHelpers.export(exports, "ensureStaleTime", ()=>ensureStaleTime);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
var defaultThrowOnError = (_error, query)=>query.state.data === void 0;
var ensureStaleTime = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"r2Xd0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTRACT_ADDRESS", ()=>CONTRACT_ADDRESS);
parcelHelpers.export(exports, "WALLET_CONNECT_PROJECT_ID", ()=>WALLET_CONNECT_PROJECT_ID);
parcelHelpers.export(exports, "NODE_URL", ()=>NODE_URL);
parcelHelpers.export(exports, "NETWORK", ()=>NETWORK);
parcelHelpers.export(exports, "DELEGATION_URL", ()=>DELEGATION_URL);
parcelHelpers.export(exports, "APP_TITLE", ()=>APP_TITLE);
parcelHelpers.export(exports, "APP_DESCRIPTION", ()=>APP_DESCRIPTION);
parcelHelpers.export(exports, "APP_ICONS", ()=>APP_ICONS);
parcelHelpers.export(exports, "CAPTCHA_SITE_KEY", ()=>CAPTCHA_SITE_KEY);
parcelHelpers.export(exports, "BACKEND_SIGNER_URL", ()=>BACKEND_SIGNER_URL);
const CONTRACT_ADDRESS = "0xfA5738AEeC969684a883362Fb25fEB8cf98A94A2" ?? "";
if (!CONTRACT_ADDRESS) throw new Error("CONTRACT_ADDRESS must be set");
const WALLET_CONNECT_PROJECT_ID = undefined ?? "";
const NODE_URL = "https://testnet.vechain.org" ?? `https://testnet.vechain.org`;
const NETWORK = undefined ?? "test";
const DELEGATION_URL = undefined;
const APP_TITLE = "Captcha + Smart Contract" ?? "Vechain dApp";
const APP_DESCRIPTION = undefined ?? "This is an example dApp showcasing the integration of CAPTCHAs into a smart contract interaction.";
const APP_ICONS = (undefined ?? "").split(",");
const CAPTCHA_SITE_KEY = "0x4AAAAAAAkMIy235NZ3tfaM" ?? "1x00000000000000000000AA";
const BACKEND_SIGNER_URL = "https://captcha-backend-signer.example.vechain.energy" ?? "http://localhost:8787";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cEyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>HelmetExport);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactSideEffect = require("react-side-effect");
var _reactSideEffectDefault = parcelHelpers.interopDefault(_reactSideEffect);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _objectAssign = require("object-assign");
var _objectAssignDefault = parcelHelpers.interopDefault(_objectAssign);
var global = arguments[3];
var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function(name) {
    return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function(obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var SELF_CLOSING_TAGS = [
    TAG_NAMES.NOSCRIPT,
    TAG_NAMES.SCRIPT,
    TAG_NAMES.STYLE
];
var HELMET_ATTRIBUTE = "data-react-helmet";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + _typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssignDefault.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([
            TAG_PROPERTIES.HREF,
            TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [
            TAG_PROPERTIES.REL,
            TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [
            TAG_PROPERTIES.NAME,
            TAG_PROPERTIES.CHARSET,
            TAG_PROPERTIES.HTTPEQUIV,
            TAG_PROPERTIES.PROPERTY,
            TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [
            TAG_PROPERTIES.SRC,
            TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [
            TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            rafPolyfill(callback);
        }, 0);
    };
}();
var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var _helmetCallback = null;
var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(function() {
        commitTagChanges(newState, function() {
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);
    updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes(TAG_NAMES.TITLE, attributes);
};
var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + '="true">' + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement(TAG_NAMES.TITLE, props, title)
    ];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
};
var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompareDefault.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                _extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));
                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });
                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }
            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, _reactDefault.default).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = _extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, _reactDefault.default).createElement(Component, newProps);
        };
        createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, _reactDefault.default).Component), _class.propTypes = {
        base: (0, _propTypesDefault.default).object,
        bodyAttributes: (0, _propTypesDefault.default).object,
        children: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
            (0, _propTypesDefault.default).node
        ]),
        defaultTitle: (0, _propTypesDefault.default).string,
        defer: (0, _propTypesDefault.default).bool,
        encodeSpecialCharacters: (0, _propTypesDefault.default).bool,
        htmlAttributes: (0, _propTypesDefault.default).object,
        link: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        meta: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        noscript: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        onChangeClientState: (0, _propTypesDefault.default).func,
        script: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        style: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
        title: (0, _propTypesDefault.default).string,
        titleAttributes: (0, _propTypesDefault.default).object,
        titleTemplate: (0, _propTypesDefault.default).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var NullComponent = function NullComponent() {
    return null;
};
var HelmetSideEffects = (0, _reactSideEffectDefault.default)(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;
exports.default = HelmetExport;

},{"prop-types":"6FKs7","react-side-effect":"kPK3Q","react-fast-compare":"7oSaD","react":"6uln9","object-assign":"hdgcG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FKs7":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"kPK3Q":[function(require,module,exports) {
"use strict";
function _interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var React = require("85d8b04033ce6109");
var React__default = _interopDefault(React);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            _inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }(React.PureComponent);
        _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        _defineProperty(SideEffect, "canUseDOM", canUseDOM);
        return SideEffect;
    };
}
module.exports = withSideEffect;

},{"85d8b04033ce6109":"6uln9"}],"7oSaD":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"hdgcG":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"dxwDS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Layout);
var _jsxRuntime = require("react/jsx-runtime");
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
function Layout({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-4 p-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex justify-center",
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","./Menu":"3Q2I7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Q2I7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LayoutMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _dappKitReact = require("@vechain/dapp-kit-react");
function LayoutMenu() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappKitReact.WalletButton), {});
}

},{"react/jsx-runtime":"gaGEj","@vechain/dapp-kit-react":"dvX2y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6zMet":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Captcha);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _config = require("~/config");
var _dappKitReact = require("@vechain/dapp-kit-react");
var _transaction = require("./Transaction");
var _transactionDefault = parcelHelpers.interopDefault(_transaction);
var _error = require("~/common/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _sdkCore = require("@vechain/sdk-core");
var _reactTurnstile = require("@marsidev/react-turnstile");
var _decodeEvmError = require("@vechain/sdk-network/src/thor-client/gas/helpers/decode-evm-error");
function Captcha() {
    // get the connected wallet
    const { account } = (0, _dappKitReact.useWallet)();
    // and access to connex for interaction with vechain
    const connex = (0, _dappKitReact.useConnex)();
    // track captcha status for simple UI status display
    const [catpchaStatus, setCaptchaStatus] = (0, _reactDefault.default).useState("loading");
    // track captcha token for backend verification
    const [captchaToken, setCaptchaToken] = (0, _reactDefault.default).useState("");
    const handleCaptchaSuccess = (token)=>{
        setCaptchaStatus("solved");
        setCaptchaToken(token);
    };
    // state for sending status
    const [isLoading, setIsLoading] = (0, _reactDefault.default).useState(false);
    const [txId, setTxId] = (0, _reactDefault.default).useState("");
    const [error, setError] = (0, _reactDefault.default).useState("");
    const handleSend = async ()=>{
        setIsLoading(true);
        try {
            setError("");
            const captchaValidation = await fetch(`${(0, _config.BACKEND_SIGNER_URL)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    token: captchaToken
                })
            }).then((res)=>res.json());
            const clauses = [
                {
                    ...(0, _sdkCore.clauseBuilder).functionInteraction((0, _config.CONTRACT_ADDRESS), "function executeWithAuthorization(bytes32 dataHash,uint256 validAfter,uint256 validBefore,bytes calldata signature)", [
                        captchaValidation.dataHash,
                        captchaValidation.validAfter,
                        captchaValidation.validBefore,
                        captchaValidation.signature
                    ]),
                    value: "0x0"
                }
            ];
            const [simulationResult] = await fetch(`${(0, _config.NODE_URL)}/accounts/*`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    clauses
                })
            }).then((res)=>res.json());
            // prevent transaction if simulation already failed
            if (simulationResult.reverted) {
                // Decode the error message from the simulation result
                const decodedError = (0, _decodeEvmError.decodeRevertReason)(simulationResult.data);
                throw new Error(decodedError);
            }
            // build a transaction for the given clauses
            const tx = connex.vendor.sign("tx", clauses)// requesting a specific signer will prevent the user from changing the signer to another wallet than the signed in one, preventing confusion
            .signer(account);
            // ask the user to sign the transaction
            const { txid } = await tx.request();
            // the resulting transaction id is stored to check for its status later
            setTxId(txid);
        } catch (err) {
            setError(String(err));
        } finally{
            setIsLoading(false);
        }
    };
    if (!account) return "Please connect your wallet to continue.";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "space-y-8 max-w-lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "text-xl font-semibold",
                        children: (0, _config.APP_TITLE)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "font-thin text-sm",
                        children: (0, _config.APP_DESCRIPTION)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "space-y-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTurnstile.Turnstile), {
                        options: {
                            // adjust the size to your needs, invisible will even hide the widget
                            size: "invisible"
                        },
                        siteKey: (0, _config.CAPTCHA_SITE_KEY),
                        onError: ()=>setCaptchaStatus("error"),
                        onExpire: ()=>setCaptchaStatus("expired"),
                        onSuccess: handleCaptchaSuccess
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "font-mono text-xs",
                        children: [
                            "Captcha Status: ",
                            catpchaStatus
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "font-mono text-xs",
                        children: [
                            "Captcha Token: ",
                            captchaToken
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: `w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 ${isLoading || !captchaToken ? "opacity-25" : ""}`,
                    disabled: isLoading || !captchaToken,
                    onClick: handleSend,
                    children: "Transact with Contract"
                })
            }),
            Boolean(error) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionDefault.default), {
                txId: txId
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","~/config":"r2Xd0","@vechain/dapp-kit-react":"dvX2y","./Transaction":"ivZTZ","~/common/Error":"2Ywxn","@vechain/sdk-core":"iZmwY","@marsidev/react-turnstile":"43JJ2","@vechain/sdk-network/src/thor-client/gas/helpers/decode-evm-error":"iYqJ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivZTZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TransactionStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("@headlessui/react");
var _outline = require("@heroicons/react/24/outline");
var _reactQuery = require("@tanstack/react-query");
var _config = require("~/config");
var _useBeats = require("~/hooks/useBeats");
function TransactionStatus({ txId }) {
    // fetch the transaction receipt
    const [open, setOpen] = (0, _reactDefault.default).useState(false);
    const [hasReceipt, setHasReceipt] = (0, _reactDefault.default).useState(false);
    const receipt = (0, _reactQuery.useQuery)({
        queryKey: [
            "transaction",
            txId
        ],
        queryFn: async ()=>fetch(`${(0, _config.NODE_URL)}/transactions/${txId}/receipt`).then((res)=>res.json()),
        refetchInterval: 7000,
        placeholderData: (previousData)=>previousData,
        enabled: Boolean(txId) && !hasReceipt
    });
    const txChange = (0, _useBeats.useBeats)([
        txId
    ], (0, _config.NODE_URL));
    (0, _reactDefault.default).useEffect(()=>{
        if (receipt.data) setHasReceipt(true);
    }, [
        receipt.data
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!txId) return;
        setOpen(true);
        setHasReceipt(false);
    }, [
        txId
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (txId && txChange) receipt.refetch();
    }, [
        txId,
        txChange,
        receipt
    ]);
    const status = !receipt.data ? "pending" : receipt.data?.reverted ? "reverted" : "success";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Root, {
        show: open,
        as: (0, _reactDefault.default).Fragment,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog), {
            as: "div",
            className: "relative z-10",
            onClose: ()=>{},
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                    as: (0, _reactDefault.default).Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "fixed inset-0 z-10 w-screen overflow-y-auto",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Transition).Child, {
                            as: (0, _reactDefault.default).Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react1.Dialog).Panel, {
                                className: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `mx-auto flex h-12 w-12 items-center justify-center rounded-full ${status === "pending" ? "inherit" : status === "reverted" ? "bg-red-100" : "bg-green-100"}`,
                                                children: status === "pending" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outline.ArrowPathIcon), {
                                                    className: "h-8 w-8 text-gray-400 animate-spin",
                                                    "aria-hidden": "true"
                                                }) : status === "reverted" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outline.ExclamationTriangleIcon), {
                                                    className: "h-8 w-8 text-red-600",
                                                    "aria-hidden": "true"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outline.CheckIcon), {
                                                    className: "h-8 w-8 text-green-600",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "mt-3 text-center sm:mt-5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Dialog).Title, {
                                                        as: "h3",
                                                        className: "text-base font-semibold leading-6 text-gray-900",
                                                        children: status === "pending" ? "Transaction pending" : status === "reverted" ? "Transaction reverted" : "Transaction successful"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "text-sm text-gray-500",
                                                            children: status === "pending" ? "Your transaction is being processed." : status === "reverted" ? "Please try again." : "Your transaction has been successfully processed."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "mt-5 sm:mt-6",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "inline-flex w-full h-10 items-center justify-center uppercase rounded-md bg-indigo-600 px-3 py-2 text-sm text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                            onClick: ()=>setOpen(false),
                                            children: "Close"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@headlessui/react":"4at9Y","@heroicons/react/24/outline":"fpWux","@tanstack/react-query":"2gEtt","~/config":"r2Xd0","~/hooks/useBeats":"d6i6L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4at9Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>(0, _portalJs.Portal));
var _clientOnly = require("client-only");
var _comboboxJs = require("./components/combobox/combobox.js");
parcelHelpers.exportAll(_comboboxJs, exports);
var _dialogJs = require("./components/dialog/dialog.js");
parcelHelpers.exportAll(_dialogJs, exports);
var _disclosureJs = require("./components/disclosure/disclosure.js");
parcelHelpers.exportAll(_disclosureJs, exports);
var _focusTrapJs = require("./components/focus-trap/focus-trap.js");
parcelHelpers.exportAll(_focusTrapJs, exports);
var _listboxJs = require("./components/listbox/listbox.js");
parcelHelpers.exportAll(_listboxJs, exports);
var _menuJs = require("./components/menu/menu.js");
parcelHelpers.exportAll(_menuJs, exports);
var _popoverJs = require("./components/popover/popover.js");
parcelHelpers.exportAll(_popoverJs, exports);
var _portalJs = require("./components/portal/portal.js");
var _radioGroupJs = require("./components/radio-group/radio-group.js");
parcelHelpers.exportAll(_radioGroupJs, exports);
var _switchJs = require("./components/switch/switch.js");
parcelHelpers.exportAll(_switchJs, exports);
var _tabsJs = require("./components/tabs/tabs.js");
parcelHelpers.exportAll(_tabsJs, exports);
var _transitionJs = require("./components/transitions/transition.js");
parcelHelpers.exportAll(_transitionJs, exports);

},{"client-only":"16s5h","./components/combobox/combobox.js":false,"./components/dialog/dialog.js":"jERgf","./components/disclosure/disclosure.js":false,"./components/focus-trap/focus-trap.js":false,"./components/listbox/listbox.js":false,"./components/menu/menu.js":false,"./components/popover/popover.js":false,"./components/portal/portal.js":false,"./components/radio-group/radio-group.js":false,"./components/switch/switch.js":false,"./components/tabs/tabs.js":false,"./components/transitions/transition.js":"03gOy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16s5h":[function(require,module,exports) {

},{}],"jERgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>_t);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _focusTrapJs = require("../../components/focus-trap/focus-trap.js");
var _portalJs = require("../../components/portal/portal.js");
var _useDocumentOverflowJs = require("../../hooks/document-overflow/use-document-overflow.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useEventListenerJs = require("../../hooks/use-event-listener.js");
var _useIdJs = require("../../hooks/use-id.js");
var _useInertJs = require("../../hooks/use-inert.js");
var _useOutsideClickJs = require("../../hooks/use-outside-click.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _useRootContainersJs = require("../../hooks/use-root-containers.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _openClosedJs = require("../../internal/open-closed.js");
var _portalForceRootJs = require("../../internal/portal-force-root.js");
var _stackContextJs = require("../../internal/stack-context.js");
var _bugsJs = require("../../utils/bugs.js");
var _matchJs = require("../../utils/match.js");
var _renderJs = require("../../utils/render.js");
var _descriptionJs = require("../description/description.js");
var _keyboardJs = require("../keyboard.js");
var Me = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))(Me || {}), we = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))(we || {});
let He = {
    [0] (o, e) {
        return o.titleId === e.id ? o : {
            ...o,
            titleId: e.id
        };
    }
}, I = (0, _react.createContext)(null);
I.displayName = "DialogContext";
function b(o) {
    let e = (0, _react.useContext)(I);
    if (e === null) {
        let r = new Error(`<${o} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, b), r;
    }
    return e;
}
function Be(o, e, r = ()=>[
        document.body
    ]) {
    (0, _useDocumentOverflowJs.useDocumentOverflowLockedEffect)(o, e, (i)=>{
        var n;
        return {
            containers: [
                ...(n = i.containers) != null ? n : [],
                r
            ]
        };
    });
}
function Ge(o, e) {
    return (0, _matchJs.match)(e.type, He, o, e);
}
let Ne = "div", Ue = (0, _renderJs.Features).RenderStrategy | (0, _renderJs.Features).Static;
function We(o, e) {
    let r = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-${r}`, open: n, onClose: l, initialFocus: s, role: a = "dialog", __demoMode: T = !1, ...m } = o, [M, f] = (0, _react.useState)(0), U = (0, _react.useRef)(!1);
    a = function() {
        return a === "dialog" || a === "alertdialog" ? a : (U.current || (U.current = !0, console.warn(`Invalid role [${a}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let E = (0, _openClosedJs.useOpenClosed)();
    n === void 0 && E !== null && (n = (E & (0, _openClosedJs.State).Open) === (0, _openClosedJs.State).Open);
    let D = (0, _react.useRef)(null), ee = (0, _useSyncRefsJs.useSyncRefs)(D, e), g = (0, _useOwnerJs.useOwnerDocument)(D), W = o.hasOwnProperty("open") || E !== null, $ = o.hasOwnProperty("onClose");
    if (!W && !$) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!$) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let p = n ? 0 : 1, [h, te] = (0, _react.useReducer)(Ge, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, _react.createRef)()
    }), P = (0, _useEventJs.useEvent)(()=>l(!1)), Y = (0, _useEventJs.useEvent)((t)=>te({
            type: 0,
            id: t
        })), S = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)() ? T ? !1 : p === 0 : !1, x = M > 1, j = (0, _react.useContext)(I) !== null, [oe, re] = (0, _portalJs.useNestedPortals)(), ne = {
        get current () {
            var t;
            return (t = h.panelRef.current) != null ? t : D.current;
        }
    }, { resolveContainers: w, mainTreeNodeRef: L, MainTreeNode: le } = (0, _useRootContainersJs.useRootContainers)({
        portals: oe,
        defaultContainers: [
            ne
        ]
    }), ae = x ? "parent" : "leaf", J = E !== null ? (E & (0, _openClosedJs.State).Closing) === (0, _openClosedJs.State).Closing : !1, ie = (()=>j || J ? !1 : S)(), se = (0, _react.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("body > *")) != null ? t : []).find((d)=>d.id === "headlessui-portal-root" ? !1 : d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, _useInertJs.useInert)(se, ie);
    let pe = (()=>x ? !0 : S)(), de = (0, _react.useCallback)(()=>{
        var t, c;
        return (c = Array.from((t = g == null ? void 0 : g.querySelectorAll("[data-headlessui-portal]")) != null ? t : []).find((d)=>d.contains(L.current) && d instanceof HTMLElement)) != null ? c : null;
    }, [
        L
    ]);
    (0, _useInertJs.useInert)(de, pe);
    let ue = (()=>!(!S || x))();
    (0, _useOutsideClickJs.useOutsideClick)(w, (t)=>{
        t.preventDefault(), P();
    }, ue);
    let fe = (()=>!(x || p !== 0))();
    (0, _useEventListenerJs.useEventListener)(g == null ? void 0 : g.defaultView, "keydown", (t)=>{
        fe && (t.defaultPrevented || t.key === (0, _keyboardJs.Keys).Escape && (t.preventDefault(), t.stopPropagation(), P()));
    });
    let ge = (()=>!(J || p !== 0 || j))();
    Be(g, ge, w), (0, _react.useEffect)(()=>{
        if (p !== 0 || !D.current) return;
        let t = new ResizeObserver((c)=>{
            for (let d of c){
                let F = d.target.getBoundingClientRect();
                F.x === 0 && F.y === 0 && F.width === 0 && F.height === 0 && P();
            }
        });
        return t.observe(D.current), ()=>t.disconnect();
    }, [
        p,
        D,
        P
    ]);
    let [Te, ce] = (0, _descriptionJs.useDescriptions)(), De = (0, _react.useMemo)(()=>[
            {
                dialogState: p,
                close: P,
                setTitleId: Y
            },
            h
        ], [
        p,
        h,
        P,
        Y
    ]), X = (0, _react.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), me = {
        ref: ee,
        id: i,
        role: a,
        "aria-modal": p === 0 ? !0 : void 0,
        "aria-labelledby": h.titleId,
        "aria-describedby": Te
    };
    return (0, _reactDefault.default).createElement((0, _stackContextJs.StackProvider), {
        type: "Dialog",
        enabled: p === 0,
        element: D,
        onUpdate: (0, _useEventJs.useEvent)((t, c)=>{
            c === "Dialog" && (0, _matchJs.match)(t, {
                [(0, _stackContextJs.StackMessage).Add]: ()=>f((d)=>d + 1),
                [(0, _stackContextJs.StackMessage).Remove]: ()=>f((d)=>d - 1)
            });
        })
    }, (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !0
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal), null, (0, _reactDefault.default).createElement(I.Provider, {
        value: De
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal).Group, {
        target: D
    }, (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !1
    }, (0, _reactDefault.default).createElement(ce, {
        slot: X,
        name: "Dialog.Description"
    }, (0, _reactDefault.default).createElement((0, _focusTrapJs.FocusTrap), {
        initialFocus: s,
        containers: w,
        features: S ? (0, _matchJs.match)(ae, {
            parent: (0, _focusTrapJs.FocusTrap).features.RestoreFocus,
            leaf: (0, _focusTrapJs.FocusTrap).features.All & ~(0, _focusTrapJs.FocusTrap).features.FocusLock
        }) : (0, _focusTrapJs.FocusTrap).features.None
    }, (0, _reactDefault.default).createElement(re, null, (0, _renderJs.render)({
        ourProps: me,
        theirProps: m,
        slot: X,
        defaultTag: Ne,
        features: Ue,
        visible: p === 0,
        name: "Dialog"
    }))))))))), (0, _reactDefault.default).createElement(le, null));
}
let $e = "div";
function Ye(o, e) {
    let r = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-overlay-${r}`, ...n } = o, [{ dialogState: l, close: s }] = b("Dialog.Overlay"), a = (0, _useSyncRefsJs.useSyncRefs)(e), T = (0, _useEventJs.useEvent)((f)=>{
        if (f.target === f.currentTarget) {
            if ((0, _bugsJs.isDisabledReactIssue7711)(f.currentTarget)) return f.preventDefault();
            f.preventDefault(), f.stopPropagation(), s();
        }
    }), m = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _renderJs.render)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0,
            onClick: T
        },
        theirProps: n,
        slot: m,
        defaultTag: $e,
        name: "Dialog.Overlay"
    });
}
let je = "div";
function Je(o, e) {
    let r = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-backdrop-${r}`, ...n } = o, [{ dialogState: l }, s] = b("Dialog.Backdrop"), a = (0, _useSyncRefsJs.useSyncRefs)(e);
    (0, _react.useEffect)(()=>{
        if (s.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        s.panelRef
    ]);
    let T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _reactDefault.default).createElement((0, _portalForceRootJs.ForcePortalRoot), {
        force: !0
    }, (0, _reactDefault.default).createElement((0, _portalJs.Portal), null, (0, _renderJs.render)({
        ourProps: {
            ref: a,
            id: i,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: T,
        defaultTag: je,
        name: "Dialog.Backdrop"
    })));
}
let Xe = "div";
function Ke(o, e) {
    let r = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-panel-${r}`, ...n } = o, [{ dialogState: l }, s] = b("Dialog.Panel"), a = (0, _useSyncRefsJs.useSyncRefs)(e, s.panelRef), T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), m = (0, _useEventJs.useEvent)((f)=>{
        f.stopPropagation();
    });
    return (0, _renderJs.render)({
        ourProps: {
            ref: a,
            id: i,
            onClick: m
        },
        theirProps: n,
        slot: T,
        defaultTag: Xe,
        name: "Dialog.Panel"
    });
}
let Ve = "h2";
function qe(o, e) {
    let r = (0, _useIdJs.useId)(), { id: i = `headlessui-dialog-title-${r}`, ...n } = o, [{ dialogState: l, setTitleId: s }] = b("Dialog.Title"), a = (0, _useSyncRefsJs.useSyncRefs)(e);
    (0, _react.useEffect)(()=>(s(i), ()=>s(null)), [
        i,
        s
    ]);
    let T = (0, _react.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, _renderJs.render)({
        ourProps: {
            ref: a,
            id: i
        },
        theirProps: n,
        slot: T,
        defaultTag: Ve,
        name: "Dialog.Title"
    });
}
let ze = (0, _renderJs.forwardRefWithAs)(We), Qe = (0, _renderJs.forwardRefWithAs)(Je), Ze = (0, _renderJs.forwardRefWithAs)(Ke), et = (0, _renderJs.forwardRefWithAs)(Ye), tt = (0, _renderJs.forwardRefWithAs)(qe), _t = Object.assign(ze, {
    Backdrop: Qe,
    Panel: Ze,
    Overlay: et,
    Title: tt,
    Description: (0, _descriptionJs.Description)
});

},{"react":"6uln9","../../components/focus-trap/focus-trap.js":"3n335","../../components/portal/portal.js":"52QbR","../../hooks/document-overflow/use-document-overflow.js":"9fKsd","../../hooks/use-event.js":"6LkpW","../../hooks/use-event-listener.js":"jWOo6","../../hooks/use-id.js":"ewTbn","../../hooks/use-inert.js":"kSJbu","../../hooks/use-outside-click.js":"7Xjo6","../../hooks/use-owner.js":"6wF89","../../hooks/use-root-containers.js":"6fnym","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../internal/open-closed.js":"UnZmT","../../internal/portal-force-root.js":"cei7w","../../internal/stack-context.js":"7AirO","../../utils/bugs.js":"8l3GP","../../utils/match.js":"AWHzT","../../utils/render.js":"hFxMl","../description/description.js":"hQSyF","../keyboard.js":"iVXBL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3n335":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>de);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDisposablesJs = require("../../hooks/use-disposables.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useEventListenerJs = require("../../hooks/use-event-listener.js");
var _useIsMountedJs = require("../../hooks/use-is-mounted.js");
var _useOnUnmountJs = require("../../hooks/use-on-unmount.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _useTabDirectionJs = require("../../hooks/use-tab-direction.js");
var _useWatchJs = require("../../hooks/use-watch.js");
var _hiddenJs = require("../../internal/hidden.js");
var _activeElementHistoryJs = require("../../utils/active-element-history.js");
var _focusManagementJs = require("../../utils/focus-management.js");
var _matchJs = require("../../utils/match.js");
var _microTaskJs = require("../../utils/micro-task.js");
var _renderJs = require("../../utils/render.js");
function P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && n.add(e.current);
    return n;
}
let X = "div";
var _ = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))(_ || {});
function z(t, n) {
    let e = (0, _react.useRef)(null), o = (0, _useSyncRefsJs.useSyncRefs)(e, n), { initialFocus: l, containers: c, features: r = 30, ...s } = t;
    (0, _useServerHandoffCompleteJs.useServerHandoffComplete)() || (r = 1);
    let i = (0, _useOwnerJs.useOwnerDocument)(e);
    Y({
        ownerDocument: i
    }, Boolean(r & 16));
    let u = Z({
        ownerDocument: i,
        container: e,
        initialFocus: l
    }, Boolean(r & 2));
    $({
        ownerDocument: i,
        container: e,
        containers: c,
        previousActiveElement: u
    }, Boolean(r & 8));
    let y = (0, _useTabDirectionJs.useTabDirection)(), R = (0, _useEventJs.useEvent)((a)=>{
        let m = e.current;
        if (!m) return;
        ((B)=>B())(()=>{
            (0, _matchJs.match)(y.current, {
                [(0, _useTabDirectionJs.Direction).Forwards]: ()=>{
                    (0, _focusManagementJs.focusIn)(m, (0, _focusManagementJs.Focus).First, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                },
                [(0, _useTabDirectionJs.Direction).Backwards]: ()=>{
                    (0, _focusManagementJs.focusIn)(m, (0, _focusManagementJs.Focus).Last, {
                        skipElements: [
                            a.relatedTarget
                        ]
                    });
                }
            });
        });
    }), h = (0, _useDisposablesJs.useDisposables)(), H = (0, _react.useRef)(!1), j = {
        ref: o,
        onKeyDown (a) {
            a.key == "Tab" && (H.current = !0, h.requestAnimationFrame(()=>{
                H.current = !1;
            }));
        },
        onBlur (a) {
            let m = P(c);
            e.current instanceof HTMLElement && m.add(e.current);
            let T = a.relatedTarget;
            T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && (S(m, T) || (H.current ? (0, _focusManagementJs.focusIn)(e.current, (0, _matchJs.match)(y.current, {
                [(0, _useTabDirectionJs.Direction).Forwards]: ()=>(0, _focusManagementJs.Focus).Next,
                [(0, _useTabDirectionJs.Direction).Backwards]: ()=>(0, _focusManagementJs.Focus).Previous
            }) | (0, _focusManagementJs.Focus).WrapAround, {
                relativeTo: a.target
            }) : a.target instanceof HTMLElement && (0, _focusManagementJs.focusElement)(a.target)));
        }
    };
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, Boolean(r & 4) && (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, _hiddenJs.Features).Focusable
    }), (0, _renderJs.render)({
        ourProps: j,
        theirProps: s,
        defaultTag: X,
        name: "FocusTrap"
    }), Boolean(r & 4) && (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, _hiddenJs.Features).Focusable
    }));
}
let D = (0, _renderJs.forwardRefWithAs)(z), de = Object.assign(D, {
    features: _
});
function Q(t = !0) {
    let n = (0, _react.useRef)((0, _activeElementHistoryJs.history).slice());
    return (0, _useWatchJs.useWatch)(([e], [o])=>{
        o === !0 && e === !1 && (0, _microTaskJs.microTask)(()=>{
            n.current.splice(0);
        }), o === !1 && e === !0 && (n.current = (0, _activeElementHistoryJs.history).slice());
    }, [
        t,
        (0, _activeElementHistoryJs.history),
        n
    ]), (0, _useEventJs.useEvent)(()=>{
        var e;
        return (e = n.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function Y({ ownerDocument: t }, n) {
    let e = Q(n);
    (0, _useWatchJs.useWatch)(()=>{
        n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, _focusManagementJs.focusElement)(e());
    }, [
        n
    ]), (0, _useOnUnmountJs.useOnUnmount)(()=>{
        n && (0, _focusManagementJs.focusElement)(e());
    });
}
function Z({ ownerDocument: t, container: n, initialFocus: e }, o) {
    let l = (0, _react.useRef)(null), c = (0, _useIsMountedJs.useIsMounted)();
    return (0, _useWatchJs.useWatch)(()=>{
        if (!o) return;
        let r = n.current;
        r && (0, _microTaskJs.microTask)(()=>{
            if (!c.current) return;
            let s = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === s) {
                    l.current = s;
                    return;
                }
            } else if (r.contains(s)) {
                l.current = s;
                return;
            }
            e != null && e.current ? (0, _focusManagementJs.focusElement)(e.current) : (0, _focusManagementJs.focusIn)(r, (0, _focusManagementJs.Focus).First) === (0, _focusManagementJs.FocusResult).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), l;
}
function $({ ownerDocument: t, container: n, containers: e, previousActiveElement: o }, l) {
    let c = (0, _useIsMountedJs.useIsMounted)();
    (0, _useEventListenerJs.useEventListener)(t == null ? void 0 : t.defaultView, "focus", (r)=>{
        if (!l || !c.current) return;
        let s = P(e);
        n.current instanceof HTMLElement && s.add(n.current);
        let i = o.current;
        if (!i) return;
        let u = r.target;
        u && u instanceof HTMLElement ? S(s, u) ? (o.current = u, (0, _focusManagementJs.focusElement)(u)) : (r.preventDefault(), r.stopPropagation(), (0, _focusManagementJs.focusElement)(i)) : (0, _focusManagementJs.focusElement)(o.current);
    }, !0);
}
function S(t, n) {
    for (let e of t)if (e.contains(n)) return !0;
    return !1;
}

},{"react":"6uln9","../../hooks/use-disposables.js":"kS4kq","../../hooks/use-event.js":"6LkpW","../../hooks/use-event-listener.js":"jWOo6","../../hooks/use-is-mounted.js":"4Sa1d","../../hooks/use-on-unmount.js":"edKMj","../../hooks/use-owner.js":"6wF89","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../hooks/use-tab-direction.js":"gWy9z","../../hooks/use-watch.js":"4yAr0","../../internal/hidden.js":"kQcB8","../../utils/active-element-history.js":"54Z4x","../../utils/focus-management.js":"f9ZB3","../../utils/match.js":"AWHzT","../../utils/micro-task.js":"73O4s","../../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kS4kq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDisposables", ()=>p);
var _react = require("react");
var _disposablesJs = require("../utils/disposables.js");
function p() {
    let [e] = (0, _react.useState)((0, _disposablesJs.disposables));
    return (0, _react.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

},{"react":"6uln9","../utils/disposables.js":"6bVHS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6bVHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disposables", ()=>o);
var _microTaskJs = require("./micro-task.js");
function o() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, _microTaskJs.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = o();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

},{"./micro-task.js":"73O4s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73O4s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microTask", ()=>t);
function t(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LkpW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEvent", ()=>o);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useLatestValueJs = require("./use-latest-value.js");
let o = function(t) {
    let e = (0, _useLatestValueJs.useLatestValue)(t);
    return (0, _reactDefault.default).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2MN3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLatestValue", ()=>s);
var _react = require("react");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
function s(e) {
    let r = (0, _react.useRef)(e);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

},{"react":"6uln9","./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Aklk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsoMorphicEffect", ()=>l);
var _react = require("react");
var _envJs = require("../utils/env.js");
let l = (e, f)=>{
    (0, _envJs.env).isServer ? (0, _react.useEffect)(e, f) : (0, _react.useLayoutEffect)(e, f);
};

},{"react":"6uln9","../utils/env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VTsa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "env", ()=>s);
var i = Object.defineProperty;
var d = (t, e, n)=>e in t ? i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var r = (t, e, n)=>(d(t, typeof e != "symbol" ? e + "" : e, n), n);
class o {
    constructor(){
        r(this, "current", this.detect());
        r(this, "handoffState", "pending");
        r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let s = new o;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jWOo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventListener", ()=>E);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function E(n, e, a, t) {
    let i = (0, _useLatestValueJs.useLatestValue)(a);
    (0, _react.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Sa1d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMounted", ()=>f);
var _react = require("react");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
function f() {
    let e = (0, _react.useRef)(!1);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

},{"react":"6uln9","./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"edKMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOnUnmount", ()=>c);
var _react = require("react");
var _microTaskJs = require("../utils/micro-task.js");
var _useEventJs = require("./use-event.js");
function c(t) {
    let r = (0, _useEventJs.useEvent)(t), e = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, _microTaskJs.microTask)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}

},{"react":"6uln9","../utils/micro-task.js":"73O4s","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6wF89":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOwnerDocument", ()=>n);
var _react = require("react");
var _ownerJs = require("../utils/owner.js");
function n(...e) {
    return (0, _react.useMemo)(()=>(0, _ownerJs.getOwnerDocument)(...e), [
        ...e
    ]);
}

},{"react":"6uln9","../utils/owner.js":"c71bk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c71bk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOwnerDocument", ()=>o);
var _envJs = require("./env.js");
function o(r) {
    return (0, _envJs.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

},{"./env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bJA23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useServerHandoffComplete", ()=>l);
var _react = require("react");
var _envJs = require("../utils/env.js");
function s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in _react ? ((o)=>o.useSyncExternalStore)(_react)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function l() {
    let r = s(), [e, n] = _react.useState((0, _envJs.env).isHandoffComplete);
    return e && (0, _envJs.env).isHandoffComplete === !1 && n(!1), _react.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), _react.useEffect(()=>(0, _envJs.env).handoff(), []), r ? !1 : e;
}

},{"react":"6uln9","../utils/env.js":"7VTsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"61fW1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optionalRef", ()=>T);
parcelHelpers.export(exports, "useSyncRefs", ()=>y);
var _react = require("react");
var _useEventJs = require("./use-event.js");
let u = Symbol();
function T(t, n = !0) {
    return Object.assign(t, {
        [u]: n
    });
}
function y(...t) {
    let n = (0, _react.useRef)(t);
    (0, _react.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, _useEventJs.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[u])) ? void 0 : c;
}

},{"react":"6uln9","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWy9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Direction", ()=>s);
parcelHelpers.export(exports, "useTabDirection", ()=>n);
var _react = require("react");
var _useWindowEventJs = require("./use-window-event.js");
var s = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))(s || {});
function n() {
    let e = (0, _react.useRef)(0);
    return (0, _useWindowEventJs.useWindowEvent)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}

},{"react":"6uln9","./use-window-event.js":"kI16d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kI16d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowEvent", ()=>s);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function s(e, r, n) {
    let o = (0, _useLatestValueJs.useLatestValue)(r);
    (0, _react.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4yAr0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWatch", ()=>m);
var _react = require("react");
var _useEventJs = require("./use-event.js");
function m(u, t) {
    let e = (0, _react.useRef)([]), r = (0, _useEventJs.useEvent)(u);
    (0, _react.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}

},{"react":"6uln9","./use-event.js":"6LkpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQcB8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Features", ()=>s);
parcelHelpers.export(exports, "Hidden", ()=>u);
var _renderJs = require("../utils/render.js");
let p = "div";
var s = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(s || {});
function l(d, o) {
    var n;
    let { features: t = 1, ...e } = d, r = {
        ref: o,
        "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (t & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(t & 4) === 4 && (t & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, _renderJs.render)({
        ourProps: r,
        theirProps: e,
        slot: {},
        defaultTag: p,
        name: "Hidden"
    });
}
let u = (0, _renderJs.forwardRefWithAs)(l);

},{"../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFxMl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Features", ()=>O);
parcelHelpers.export(exports, "RenderStrategy", ()=>v);
parcelHelpers.export(exports, "compact", ()=>x);
parcelHelpers.export(exports, "forwardRefWithAs", ()=>U);
parcelHelpers.export(exports, "render", ()=>C);
parcelHelpers.export(exports, "useMergeRefsFn", ()=>I);
var _react = require("react");
var _classNamesJs = require("./class-names.js");
var _matchJs = require("./match.js");
var O = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))(O || {}), v = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(v || {});
function C({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : k;
    let s = R(t, r);
    if (a) return m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, _matchJs.match)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return m(s, e, n, f, l);
}
function m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, _react.Fragment) && Object.keys(x(s)).length > 0) {
        if (!(0, _react.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, _classNamesJs.classNames)(i == null ? void 0 : i.className(...p), s.className) : (0, _classNamesJs.classNames)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, _react.cloneElement)(u, Object.assign({}, R(u.props, x(F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, _react.createElement)(a, Object.assign({}, F(s, [
        "ref"
    ]), a !== (0, _react.Fragment) && y, a !== (0, _react.Fragment) && d), u);
}
function I() {
    let r = (0, _react.useRef)([]), t = (0, _react.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function U(r) {
    var t;
    return Object.assign((0, _react.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function x(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}

},{"react":"6uln9","./class-names.js":"9OIM4","./match.js":"AWHzT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9OIM4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "classNames", ()=>t);
function t(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"AWHzT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>u);
function u(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"54Z4x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "history", ()=>t);
var _documentReadyJs = require("./document-ready.js");
let t = [];
(0, _documentReadyJs.onDocumentReady)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && t[0] !== n.target && (t.unshift(n.target), t = t.filter((r)=>r != null && r.isConnected), t.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

},{"./document-ready.js":"f2EEi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f2EEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onDocumentReady", ()=>t);
function t(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9ZB3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Focus", ()=>M);
parcelHelpers.export(exports, "FocusResult", ()=>N);
parcelHelpers.export(exports, "FocusableMode", ()=>T);
parcelHelpers.export(exports, "focusElement", ()=>y);
parcelHelpers.export(exports, "focusFrom", ()=>_);
parcelHelpers.export(exports, "focusIn", ()=>O);
parcelHelpers.export(exports, "getFocusableElements", ()=>f);
parcelHelpers.export(exports, "isFocusableElement", ()=>h);
parcelHelpers.export(exports, "restoreFocusIfNecessary", ()=>D);
parcelHelpers.export(exports, "sortByDomNode", ()=>I);
var _disposablesJs = require("./disposables.js");
var _matchJs = require("./match.js");
var _ownerJs = require("./owner.js");
let c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var M = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))(M || {}), N = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))(N || {}), F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(F || {});
function f(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll(c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var T = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(T || {});
function h(e, r = 0) {
    var t;
    return e === ((t = (0, _ownerJs.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, _matchJs.match)(r, {
        [0] () {
            return e.matches(c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches(c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function D(e) {
    let r = (0, _ownerJs.getOwnerDocument)(e);
    (0, _disposablesJs.disposables)().nextFrame(()=>{
        r && !h(r.activeElement, 0) && y(e);
    });
}
var w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function y(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let S = [
    "textarea",
    "input"
].join(",");
function H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, S)) != null ? t : !1;
}
function I(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function _(e, r) {
    return O(f(), r, {
        relativeTo: e
    });
}
function O(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? I(e) : e : f(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && H(u) && u.select(), 2;
}

},{"./disposables.js":"6bVHS","./match.js":"AWHzT","./owner.js":"c71bk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52QbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>te);
parcelHelpers.export(exports, "useNestedPortals", ()=>ee);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _useEventJs = require("../../hooks/use-event.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _useOnUnmountJs = require("../../hooks/use-on-unmount.js");
var _useOwnerJs = require("../../hooks/use-owner.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _portalForceRootJs = require("../../internal/portal-force-root.js");
var _envJs = require("../../utils/env.js");
var _renderJs = require("../../utils/render.js");
function F(p) {
    let n = (0, _portalForceRootJs.usePortalRoot)(), l = (0, _react.useContext)(_), e = (0, _useOwnerJs.useOwnerDocument)(p), [a, o] = (0, _react.useState)(()=>{
        if (!n && l !== null || (0, _envJs.env).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, _react.useEffect)(()=>{
        a !== null && (e != null && e.body.contains(a) || e == null || e.body.appendChild(a));
    }, [
        a,
        e
    ]), (0, _react.useEffect)(()=>{
        n || l !== null && o(l.current);
    }, [
        l,
        o,
        n
    ]), a;
}
let U = (0, _react.Fragment);
function N(p, n) {
    let l = p, e = (0, _react.useRef)(null), a = (0, _useSyncRefsJs.useSyncRefs)((0, _useSyncRefsJs.optionalRef)((u)=>{
        e.current = u;
    }), n), o = (0, _useOwnerJs.useOwnerDocument)(e), t = F(e), [r] = (0, _react.useState)(()=>{
        var u;
        return (0, _envJs.env).isServer ? null : (u = o == null ? void 0 : o.createElement("div")) != null ? u : null;
    }), i = (0, _react.useContext)(f), v = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        !t || !r || t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r));
    }, [
        t,
        r
    ]), (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        if (r && i) return i.register(r);
    }, [
        i,
        r
    ]), (0, _useOnUnmountJs.useOnUnmount)(()=>{
        var u;
        !t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((u = t.parentElement) == null || u.removeChild(t)));
    }), v ? !t || !r ? null : (0, _reactDom.createPortal)((0, _renderJs.render)({
        ourProps: {
            ref: a
        },
        theirProps: l,
        defaultTag: U,
        name: "Portal"
    }), r) : null;
}
let S = (0, _react.Fragment), _ = (0, _react.createContext)(null);
function j(p, n) {
    let { target: l, ...e } = p, o = {
        ref: (0, _useSyncRefsJs.useSyncRefs)(n)
    };
    return (0, _reactDefault.default).createElement(_.Provider, {
        value: l
    }, (0, _renderJs.render)({
        ourProps: o,
        theirProps: e,
        defaultTag: S,
        name: "Popover.Group"
    }));
}
let f = (0, _react.createContext)(null);
function ee() {
    let p = (0, _react.useContext)(f), n = (0, _react.useRef)([]), l = (0, _useEventJs.useEvent)((o)=>(n.current.push(o), p && p.register(o), ()=>e(o))), e = (0, _useEventJs.useEvent)((o)=>{
        let t = n.current.indexOf(o);
        t !== -1 && n.current.splice(t, 1), p && p.unregister(o);
    }), a = (0, _react.useMemo)(()=>({
            register: l,
            unregister: e,
            portals: n
        }), [
        l,
        e,
        n
    ]);
    return [
        n,
        (0, _react.useMemo)(()=>function({ children: t }) {
                return (0, _reactDefault.default).createElement(f.Provider, {
                    value: a
                }, t);
            }, [
            a
        ])
    ];
}
let D = (0, _renderJs.forwardRefWithAs)(N), I = (0, _renderJs.forwardRefWithAs)(j), te = Object.assign(D, {
    Group: I
});

},{"react":"6uln9","react-dom":"b8T3j","../../hooks/use-event.js":"6LkpW","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../hooks/use-on-unmount.js":"edKMj","../../hooks/use-owner.js":"6wF89","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../internal/portal-force-root.js":"cei7w","../../utils/env.js":"7VTsa","../../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cei7w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForcePortalRoot", ()=>l);
parcelHelpers.export(exports, "usePortalRoot", ()=>a);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let e = (0, _react.createContext)(!1);
function a() {
    return (0, _react.useContext)(e);
}
function l(o) {
    return (0, _reactDefault.default).createElement(e.Provider, {
        value: o.force
    }, o.children);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9fKsd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentOverflowLockedEffect", ()=>p);
var _useStoreJs = require("../../hooks/use-store.js");
var _useIsoMorphicEffectJs = require("../use-iso-morphic-effect.js");
var _overflowStoreJs = require("./overflow-store.js");
function p(e, r, n) {
    let f = (0, _useStoreJs.useStore)((0, _overflowStoreJs.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, _overflowStoreJs.overflows).dispatch("PUSH", e, n), ()=>(0, _overflowStoreJs.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

},{"../../hooks/use-store.js":"8oKBf","../use-iso-morphic-effect.js":"1Aklk","./overflow-store.js":"f5diM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oKBf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStore", ()=>S);
var _indexJs = require("../use-sync-external-store-shim/index.js");
function S(t) {
    return (0, _indexJs.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

},{"../use-sync-external-store-shim/index.js":"2z1qc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2z1qc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>a);
var _react = require("react");
var _useSyncExternalStoreShimClientJs = require("./useSyncExternalStoreShimClient.js");
var _useSyncExternalStoreShimServerJs = require("./useSyncExternalStoreShimServer.js");
const r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", s = !r, c = s ? (0, _useSyncExternalStoreShimServerJs.useSyncExternalStore) : (0, _useSyncExternalStoreShimClientJs.useSyncExternalStore), a = "useSyncExternalStore" in _react ? ((n)=>n.useSyncExternalStore)(_react) : c;

},{"react":"6uln9","./useSyncExternalStoreShimClient.js":"hatp1","./useSyncExternalStoreShimServer.js":"7jkzX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hatp1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>y);
var _react = require("react");
function i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const d = typeof Object.is == "function" ? Object.is : i, { useState: u, useEffect: h, useLayoutEffect: f, useDebugValue: p } = _react;
let S = !1, _ = !1;
function y(e, t, c) {
    const a = t(), [{ inst: n }, o] = u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return f(()=>{
        n.value = a, n.getSnapshot = t, r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), h(()=>(r(n) && o({
            inst: n
        }), e(()=>{
            r(n) && o({
                inst: n
            });
        })), [
        e
    ]), p(a), a;
}
function r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !d(c, a);
    } catch  {
        return !0;
    }
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jkzX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>t);
function t(r, e, n) {
    return e();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5diM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overflows", ()=>a);
var _disposablesJs = require("../../utils/disposables.js");
var _storeJs = require("../../utils/store.js");
var _adjustScrollbarPaddingJs = require("./adjust-scrollbar-padding.js");
var _handleIosLockingJs = require("./handle-ios-locking.js");
var _preventScrollJs = require("./prevent-scroll.js");
function m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let a = (0, _storeJs.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, _disposablesJs.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: m(t)
        }, c = [
            (0, _handleIosLockingJs.handleIOSLocking)(),
            (0, _adjustScrollbarPaddingJs.adjustScrollbarPadding)(),
            (0, _preventScrollJs.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
a.subscribe(()=>{
    let e = a.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && a.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && a.dispatch("TEARDOWN", t);
    }
});

},{"../../utils/disposables.js":"6bVHS","../../utils/store.js":"doxAl","./adjust-scrollbar-padding.js":"lNouo","./handle-ios-locking.js":"9WIM6","./prevent-scroll.js":"hkPEJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"doxAl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>a);
function a(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNouo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjustScrollbarPadding", ()=>c);
function c() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9WIM6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleIOSLocking", ()=>d);
var _disposablesJs = require("../../utils/disposables.js");
var _platformJs = require("../../utils/platform.js");
function d() {
    return (0, _platformJs.isIOS)() ? {
        before ({ doc: r, d: l, meta: c }) {
            function o(a) {
                return c.containers.flatMap((n)=>n()).some((n)=>n.contains(a));
            }
            l.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, _disposablesJs.disposables)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), l.add(()=>l.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, n = null;
                l.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (n = i);
                    } catch  {}
                }, !0), l.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            l.style(e, "overscrollBehavior", "contain");
                        } else l.style(t.target, "touchAction", "none");
                    }
                }), l.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), l.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
                        block: "nearest"
                    }), n = null);
                });
            });
        }
    } : {};
}

},{"../../utils/disposables.js":"6bVHS","../../utils/platform.js":"ikixC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikixC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAndroid", ()=>i);
parcelHelpers.export(exports, "isIOS", ()=>t);
parcelHelpers.export(exports, "isMobile", ()=>n);
function t() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function i() {
    return /Android/gi.test(window.navigator.userAgent);
}
function n() {
    return t() || i();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hkPEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preventScroll", ()=>l);
function l() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ewTbn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>I);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _envJs = require("../utils/env.js");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
var _useServerHandoffCompleteJs = require("./use-server-handoff-complete.js");
var o;
let I = (o = (0, _reactDefault.default).useId) != null ? o : function() {
    let n = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)(), [e, u] = (0, _reactDefault.default).useState(n ? ()=>(0, _envJs.env).nextId() : null);
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        e === null && u((0, _envJs.env).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};

},{"react":"6uln9","../utils/env.js":"7VTsa","./use-iso-morphic-effect.js":"1Aklk","./use-server-handoff-complete.js":"bJA23","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSJbu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInert", ()=>b);
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
let u = new Map, t = new Map;
function b(r, l = !0) {
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = t.get(e)) != null ? d : 1;
            if (i === 1 ? t.delete(e) : t.set(e, i - 1), i !== 1) return;
            let n = u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, u.delete(e));
        }
        let f = (o = t.get(e)) != null ? o : 0;
        return t.set(e, f + 1), f !== 0 || (u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}

},{"./use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Xjo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOutsideClick", ()=>y);
var _react = require("react");
var _focusManagementJs = require("../utils/focus-management.js");
var _platformJs = require("../utils/platform.js");
var _useDocumentEventJs = require("./use-document-event.js");
var _useWindowEventJs = require("./use-window-event.js");
function y(s, m, a = !0) {
    let i = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, _focusManagementJs.isFocusableElement)(t, (0, _focusManagementJs.FocusableMode).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, _react.useRef)(null);
    (0, _useDocumentEventJs.useDocumentEvent)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("click", (e)=>{
        (0, _platformJs.isMobile)() || o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, _useDocumentEventJs.useDocumentEvent)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, _useWindowEventJs.useWindowEvent)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

},{"react":"6uln9","../utils/focus-management.js":"f9ZB3","../utils/platform.js":"ikixC","./use-document-event.js":"g06Br","./use-window-event.js":"kI16d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g06Br":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentEvent", ()=>d);
var _react = require("react");
var _useLatestValueJs = require("./use-latest-value.js");
function d(e, r, n) {
    let o = (0, _useLatestValueJs.useLatestValue)(r);
    (0, _react.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

},{"react":"6uln9","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6fnym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMainTreeNode", ()=>y);
parcelHelpers.export(exports, "useRootContainers", ()=>N);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hiddenJs = require("../internal/hidden.js");
var _useEventJs = require("./use-event.js");
var _useOwnerJs = require("./use-owner.js");
function N({ defaultContainers: o = [], portals: r, mainTreeNodeRef: u } = {}) {
    var f;
    let t = (0, _react.useRef)((f = u == null ? void 0 : u.current) != null ? f : null), l = (0, _useOwnerJs.useOwnerDocument)(t), c = (0, _useEventJs.useEvent)(()=>{
        var i, s, a;
        let n = [];
        for (let e of o)e !== null && (e instanceof HTMLElement ? n.push(e) : "current" in e && e.current instanceof HTMLElement && n.push(e.current));
        if (r != null && r.current) for (let e of r.current)n.push(e);
        for (let e of (i = l == null ? void 0 : l.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (e.contains(t.current) || e.contains((a = (s = t.current) == null ? void 0 : s.getRootNode()) == null ? void 0 : a.host) || n.some((L)=>e.contains(L)) || n.push(e));
        return n;
    });
    return {
        resolveContainers: c,
        contains: (0, _useEventJs.useEvent)((n)=>c().some((i)=>i.contains(n))),
        mainTreeNodeRef: t,
        MainTreeNode: (0, _react.useMemo)(()=>function() {
                return u != null ? null : (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
                    features: (0, _hiddenJs.Features).Hidden,
                    ref: t
                });
            }, [
            t,
            u
        ])
    };
}
function y() {
    let o = (0, _react.useRef)(null);
    return {
        mainTreeNodeRef: o,
        MainTreeNode: (0, _react.useMemo)(()=>function() {
                return (0, _reactDefault.default).createElement((0, _hiddenJs.Hidden), {
                    features: (0, _hiddenJs.Features).Hidden,
                    ref: o
                });
            }, [
            o
        ])
    };
}

},{"react":"6uln9","../internal/hidden.js":"kQcB8","./use-event.js":"6LkpW","./use-owner.js":"6wF89","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UnZmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenClosedProvider", ()=>s);
parcelHelpers.export(exports, "State", ()=>d);
parcelHelpers.export(exports, "useOpenClosed", ()=>u);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let n = (0, _react.createContext)(null);
n.displayName = "OpenClosedContext";
var d = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(d || {});
function u() {
    return (0, _react.useContext)(n);
}
function s({ value: o, children: r }) {
    return (0, _reactDefault.default).createElement(n.Provider, {
        value: o
    }, r);
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7AirO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackMessage", ()=>s);
parcelHelpers.export(exports, "StackProvider", ()=>b);
parcelHelpers.export(exports, "useStackContext", ()=>x);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useEventJs = require("../hooks/use-event.js");
var _useIsoMorphicEffectJs = require("../hooks/use-iso-morphic-effect.js");
let a = (0, _react.createContext)(()=>{});
a.displayName = "StackContext";
var s = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(s || {});
function x() {
    return (0, _react.useContext)(a);
}
function b({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = x(), o = (0, _useEventJs.useEvent)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, _reactDefault.default).createElement(a.Provider, {
        value: o
    }, i);
}

},{"react":"6uln9","../hooks/use-event.js":"6LkpW","../hooks/use-iso-morphic-effect.js":"1Aklk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8l3GP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDisabledReactIssue7711", ()=>r);
function r(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && i(l) ? !1 : t;
}
function i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQSyF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Description", ()=>G);
parcelHelpers.export(exports, "useDescriptions", ()=>w);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useEventJs = require("../../hooks/use-event.js");
var _useIdJs = require("../../hooks/use-id.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _renderJs = require("../../utils/render.js");
let d = (0, _react.createContext)(null);
function f() {
    let r = (0, _react.useContext)(d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, f), t;
    }
    return r;
}
function w() {
    let [r, t] = (0, _react.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, _react.useMemo)(()=>function(e) {
                let i = (0, _useEventJs.useEvent)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, _react.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, _reactDefault.default).createElement(d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let I = "p";
function S(r, t) {
    let a = (0, _useIdJs.useId)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = f(), s = (0, _useSyncRefsJs.useSyncRefs)(t);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, _renderJs.render)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: I,
        name: n.name || "Description"
    });
}
let h = (0, _renderJs.forwardRefWithAs)(S), G = Object.assign(h, {});

},{"react":"6uln9","../../hooks/use-event.js":"6LkpW","../../hooks/use-id.js":"ewTbn","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../hooks/use-sync-refs.js":"61fW1","../../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVXBL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keys", ()=>o);
var o = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))(o || {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03gOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>qe);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useDisposablesJs = require("../../hooks/use-disposables.js");
var _useEventJs = require("../../hooks/use-event.js");
var _useFlagsJs = require("../../hooks/use-flags.js");
var _useIsMountedJs = require("../../hooks/use-is-mounted.js");
var _useIsoMorphicEffectJs = require("../../hooks/use-iso-morphic-effect.js");
var _useLatestValueJs = require("../../hooks/use-latest-value.js");
var _useServerHandoffCompleteJs = require("../../hooks/use-server-handoff-complete.js");
var _useSyncRefsJs = require("../../hooks/use-sync-refs.js");
var _useTransitionJs = require("../../hooks/use-transition.js");
var _openClosedJs = require("../../internal/open-closed.js");
var _classNamesJs = require("../../utils/class-names.js");
var _matchJs = require("../../utils/match.js");
var _renderJs = require("../../utils/render.js");
function S(t = "") {
    return t.split(/\s+/).filter((n)=>n.length > 1);
}
let I = (0, _react.createContext)(null);
I.displayName = "TransitionContext";
var Se = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))(Se || {});
function ye() {
    let t = (0, _react.useContext)(I);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
function xe() {
    let t = (0, _react.useContext)(M);
    if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return t;
}
let M = (0, _react.createContext)(null);
M.displayName = "NestingContext";
function U(t) {
    return "children" in t ? U(t.children) : t.current.filter(({ el: n })=>n.current !== null).filter(({ state: n })=>n === "visible").length > 0;
}
function se(t, n) {
    let r = (0, _useLatestValueJs.useLatestValue)(t), s = (0, _react.useRef)([]), R = (0, _useIsMountedJs.useIsMounted)(), D = (0, _useDisposablesJs.useDisposables)(), p = (0, _useEventJs.useEvent)((i, e = (0, _renderJs.RenderStrategy).Hidden)=>{
        let a = s.current.findIndex(({ el: o })=>o === i);
        a !== -1 && ((0, _matchJs.match)(e, {
            [(0, _renderJs.RenderStrategy).Unmount] () {
                s.current.splice(a, 1);
            },
            [(0, _renderJs.RenderStrategy).Hidden] () {
                s.current[a].state = "hidden";
            }
        }), D.microTask(()=>{
            var o;
            !U(s) && R.current && ((o = r.current) == null || o.call(r));
        }));
    }), x = (0, _useEventJs.useEvent)((i)=>{
        let e = s.current.find(({ el: a })=>a === i);
        return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
            el: i,
            state: "visible"
        }), ()=>p(i, (0, _renderJs.RenderStrategy).Unmount);
    }), h = (0, _react.useRef)([]), v = (0, _react.useRef)(Promise.resolve()), u = (0, _react.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), g = (0, _useEventJs.useEvent)((i, e, a)=>{
        h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(([o])=>o !== i)), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                h.current.push(o);
            })
        ]), n == null || n.chains.current[e].push([
            i,
            new Promise((o)=>{
                Promise.all(u.current[e].map(([f, N])=>N)).then(()=>o());
            })
        ]), e === "enter" ? v.current = v.current.then(()=>n == null ? void 0 : n.wait.current).then(()=>a(e)) : a(e);
    }), d = (0, _useEventJs.useEvent)((i, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = h.current.shift()) == null || o();
        }).then(()=>a(e));
    });
    return (0, _react.useMemo)(()=>({
            children: s,
            register: x,
            unregister: p,
            onStart: g,
            onStop: d,
            wait: v,
            chains: u
        }), [
        x,
        p,
        s,
        g,
        d,
        u,
        v
    ]);
}
function Ne() {}
let Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function ae(t) {
    var r;
    let n = {};
    for (let s of Pe)n[s] = (r = t[s]) != null ? r : Ne;
    return n;
}
function Re(t) {
    let n = (0, _react.useRef)(ae(t));
    return (0, _react.useEffect)(()=>{
        n.current = ae(t);
    }, [
        t
    ]), n;
}
let De = "div", le = (0, _renderJs.Features).RenderStrategy;
function He(t, n) {
    var Q, Y;
    let { beforeEnter: r, afterEnter: s, beforeLeave: R, afterLeave: D, enter: p, enterFrom: x, enterTo: h, entered: v, leave: u, leaveFrom: g, leaveTo: d, ...i } = t, e = (0, _react.useRef)(null), a = (0, _useSyncRefsJs.useSyncRefs)(e, n), o = (Q = i.unmount) == null || Q ? (0, _renderJs.RenderStrategy).Unmount : (0, _renderJs.RenderStrategy).Hidden, { show: f, appear: N, initial: T } = ye(), [l, j] = (0, _react.useState)(f ? "visible" : "hidden"), z = xe(), { register: L, unregister: O } = z;
    (0, _react.useEffect)(()=>L(e), [
        L,
        e
    ]), (0, _react.useEffect)(()=>{
        if (o === (0, _renderJs.RenderStrategy).Hidden && e.current) {
            if (f && l !== "visible") {
                j("visible");
                return;
            }
            return (0, _matchJs.match)(l, {
                ["hidden"]: ()=>O(e),
                ["visible"]: ()=>L(e)
            });
        }
    }, [
        l,
        e,
        L,
        O,
        f,
        o
    ]);
    let k = (0, _useLatestValueJs.useLatestValue)({
        base: S(i.className),
        enter: S(p),
        enterFrom: S(x),
        enterTo: S(h),
        entered: S(v),
        leave: S(u),
        leaveFrom: S(g),
        leaveTo: S(d)
    }), V = Re({
        beforeEnter: r,
        afterEnter: s,
        beforeLeave: R,
        afterLeave: D
    }), G = (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    (0, _react.useEffect)(()=>{
        if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        l,
        G
    ]);
    let Te = T && !N, K = N && f && T, de = (()=>!G || Te ? "idle" : f ? "enter" : "leave")(), H = (0, _useFlagsJs.useFlags)(0), fe = (0, _useEventJs.useEvent)((C)=>(0, _matchJs.match)(C, {
            enter: ()=>{
                H.addFlag((0, _openClosedJs.State).Opening), V.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, _openClosedJs.State).Closing), V.current.beforeLeave();
            },
            idle: ()=>{}
        })), me = (0, _useEventJs.useEvent)((C)=>(0, _matchJs.match)(C, {
            enter: ()=>{
                H.removeFlag((0, _openClosedJs.State).Opening), V.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, _openClosedJs.State).Closing), V.current.afterLeave();
            },
            idle: ()=>{}
        })), w = se(()=>{
        j("hidden"), O(e);
    }, z), B = (0, _react.useRef)(!1);
    (0, _useTransitionJs.useTransition)({
        immediate: K,
        container: e,
        classes: k,
        direction: de,
        onStart: (0, _useLatestValueJs.useLatestValue)((C)=>{
            B.current = !0, w.onStart(e, C, fe);
        }),
        onStop: (0, _useLatestValueJs.useLatestValue)((C)=>{
            B.current = !1, w.onStop(e, C, me), C === "leave" && !U(w) && (j("hidden"), O(e));
        })
    });
    let P = i, ce = {
        ref: a
    };
    return K ? P = {
        ...P,
        className: (0, _classNamesJs.classNames)(i.className, ...k.current.enter, ...k.current.enterFrom)
    } : B.current && (P.className = (0, _classNamesJs.classNames)(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), (0, _reactDefault.default).createElement(M.Provider, {
        value: w
    }, (0, _reactDefault.default).createElement((0, _openClosedJs.OpenClosedProvider), {
        value: (0, _matchJs.match)(l, {
            ["visible"]: (0, _openClosedJs.State).Open,
            ["hidden"]: (0, _openClosedJs.State).Closed
        }) | H.flags
    }, (0, _renderJs.render)({
        ourProps: ce,
        theirProps: P,
        defaultTag: De,
        features: le,
        visible: l === "visible",
        name: "Transition.Child"
    })));
}
function Fe(t, n) {
    let { show: r, appear: s = !1, unmount: R = !0, ...D } = t, p = (0, _react.useRef)(null), x = (0, _useSyncRefsJs.useSyncRefs)(p, n);
    (0, _useServerHandoffCompleteJs.useServerHandoffComplete)();
    let h = (0, _openClosedJs.useOpenClosed)();
    if (r === void 0 && h !== null && (r = (h & (0, _openClosedJs.State).Open) === (0, _openClosedJs.State).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [v, u] = (0, _react.useState)(r ? "visible" : "hidden"), g = se(()=>{
        u("hidden");
    }), [d, i] = (0, _react.useState)(!0), e = (0, _react.useRef)([
        r
    ]);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
    }, [
        e,
        r
    ]);
    let a = (0, _react.useMemo)(()=>({
            show: r,
            appear: s,
            initial: d
        }), [
        r,
        s,
        d
    ]);
    (0, _react.useEffect)(()=>{
        if (r) u("visible");
        else if (!U(g)) u("hidden");
        else {
            let T = p.current;
            if (!T) return;
            let l = T.getBoundingClientRect();
            l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
        }
    }, [
        r,
        g
    ]);
    let o = {
        unmount: R
    }, f = (0, _useEventJs.useEvent)(()=>{
        var T;
        d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }), N = (0, _useEventJs.useEvent)(()=>{
        var T;
        d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
    return (0, _reactDefault.default).createElement(M.Provider, {
        value: g
    }, (0, _reactDefault.default).createElement(I.Provider, {
        value: a
    }, (0, _renderJs.render)({
        ourProps: {
            ...o,
            as: (0, _react.Fragment),
            children: (0, _reactDefault.default).createElement(ue, {
                ref: x,
                ...o,
                ...D,
                beforeEnter: f,
                beforeLeave: N
            })
        },
        theirProps: {},
        defaultTag: (0, _react.Fragment),
        features: le,
        visible: v === "visible",
        name: "Transition"
    })));
}
function _e(t, n) {
    let r = (0, _react.useContext)(I) !== null, s = (0, _openClosedJs.useOpenClosed)() !== null;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !r && s ? (0, _reactDefault.default).createElement(q, {
        ref: n,
        ...t
    }) : (0, _reactDefault.default).createElement(ue, {
        ref: n,
        ...t
    }));
}
let q = (0, _renderJs.forwardRefWithAs)(Fe), ue = (0, _renderJs.forwardRefWithAs)(He), Le = (0, _renderJs.forwardRefWithAs)(_e), qe = Object.assign(q, {
    Child: Le,
    Root: q
});

},{"react":"6uln9","../../hooks/use-disposables.js":"kS4kq","../../hooks/use-event.js":"6LkpW","../../hooks/use-flags.js":"6rKpx","../../hooks/use-is-mounted.js":"4Sa1d","../../hooks/use-iso-morphic-effect.js":"1Aklk","../../hooks/use-latest-value.js":"f2MN3","../../hooks/use-server-handoff-complete.js":"bJA23","../../hooks/use-sync-refs.js":"61fW1","../../hooks/use-transition.js":"lmjjm","../../internal/open-closed.js":"UnZmT","../../utils/class-names.js":"9OIM4","../../utils/match.js":"AWHzT","../../utils/render.js":"hFxMl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rKpx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFlags", ()=>c);
var _react = require("react");
var _useIsMountedJs = require("./use-is-mounted.js");
function c(a = 0) {
    let [l, r] = (0, _react.useState)(a), t = (0, _useIsMountedJs.useIsMounted)(), o = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u | e);
    }, [
        l,
        t
    ]), m = (0, _react.useCallback)((e)=>Boolean(l & e), [
        l
    ]), s = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u & ~e);
    }, [
        r,
        t
    ]), g = (0, _react.useCallback)((e)=>{
        t.current && r((u)=>u ^ e);
    }, [
        r
    ]);
    return {
        flags: l,
        addFlag: o,
        hasFlag: m,
        removeFlag: s,
        toggleFlag: g
    };
}

},{"react":"6uln9","./use-is-mounted.js":"4Sa1d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmjjm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>D);
var _transitionJs = require("../components/transitions/utils/transition.js");
var _disposablesJs = require("../utils/disposables.js");
var _useDisposablesJs = require("./use-disposables.js");
var _useIsMountedJs = require("./use-is-mounted.js");
var _useIsoMorphicEffectJs = require("./use-iso-morphic-effect.js");
var _useLatestValueJs = require("./use-latest-value.js");
function D({ immediate: t, container: s, direction: n, classes: u, onStart: a, onStop: c }) {
    let l = (0, _useIsMountedJs.useIsMounted)(), d = (0, _useDisposablesJs.useDisposables)(), e = (0, _useLatestValueJs.useLatestValue)(n);
    (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        t && (e.current = "enter");
    }, [
        t
    ]), (0, _useIsoMorphicEffectJs.useIsoMorphicEffect)(()=>{
        let r = (0, _disposablesJs.disposables)();
        d.add(r.dispose);
        let i = s.current;
        if (i && e.current !== "idle" && l.current) return r.dispose(), a.current(e.current), r.add((0, _transitionJs.transition)(i, u.current, e.current === "enter", ()=>{
            r.dispose(), c.current(e.current);
        })), r.dispose;
    }, [
        n
    ]);
}

},{"../components/transitions/utils/transition.js":"hsUmI","../utils/disposables.js":"6bVHS","./use-disposables.js":"kS4kq","./use-is-mounted.js":"4Sa1d","./use-iso-morphic-effect.js":"1Aklk","./use-latest-value.js":"f2MN3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hsUmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>M);
var _disposablesJs = require("../../../utils/disposables.js");
var _matchJs = require("../../../utils/match.js");
var _onceJs = require("../../../utils/once.js");
function g(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function b(t, e) {
    let n = (0, _disposablesJs.disposables)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: a } = getComputedStyle(t), [u, p] = [
        m,
        a
    ].map((l)=>{
        let [r = 0] = l.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, T)=>T - i);
        return r;
    }), o = u + p;
    if (o !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, o), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let l = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), l());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function M(t, e, n, m) {
    let a = n ? "enter" : "leave", u = (0, _disposablesJs.disposables)(), p = m !== void 0 ? (0, _onceJs.once)(m) : ()=>{};
    a === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let o = (0, _matchJs.match)(a, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), l = (0, _matchJs.match)(a, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, _matchJs.match)(a, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return v(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), g(t, ...e.base, ...o, ...r), u.nextFrame(()=>{
        v(t, ...e.base, ...o, ...r), g(t, ...e.base, ...o, ...l), b(t, ()=>(v(t, ...e.base, ...o), g(t, ...e.base, ...e.entered), p()));
    }), u.dispose;
}

},{"../../../utils/disposables.js":"6bVHS","../../../utils/match.js":"AWHzT","../../../utils/once.js":"erIss","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"erIss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "once", ()=>l);
function l(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpWux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcademicCapIcon", ()=>(0, _academicCapIconJsDefault.default));
parcelHelpers.export(exports, "AdjustmentsHorizontalIcon", ()=>(0, _adjustmentsHorizontalIconJsDefault.default));
parcelHelpers.export(exports, "AdjustmentsVerticalIcon", ()=>(0, _adjustmentsVerticalIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxArrowDownIcon", ()=>(0, _archiveBoxArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxXMarkIcon", ()=>(0, _archiveBoxXMarkIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxIcon", ()=>(0, _archiveBoxIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircleIcon", ()=>(0, _arrowDownCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftIcon", ()=>(0, _arrowDownLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownOnSquareStackIcon", ()=>(0, _arrowDownOnSquareStackIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownOnSquareIcon", ()=>(0, _arrowDownOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightIcon", ()=>(0, _arrowDownRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownTrayIcon", ()=>(0, _arrowDownTrayIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownIcon", ()=>(0, _arrowDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircleIcon", ()=>(0, _arrowLeftCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftEndOnRectangleIcon", ()=>(0, _arrowLeftEndOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftOnRectangleIcon", ()=>(0, _arrowLeftOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftStartOnRectangleIcon", ()=>(0, _arrowLeftStartOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>(0, _arrowLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongDownIcon", ()=>(0, _arrowLongDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongLeftIcon", ()=>(0, _arrowLongLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongRightIcon", ()=>(0, _arrowLongRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongUpIcon", ()=>(0, _arrowLongUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowPathRoundedSquareIcon", ()=>(0, _arrowPathRoundedSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowPathIcon", ()=>(0, _arrowPathIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircleIcon", ()=>(0, _arrowRightCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightEndOnRectangleIcon", ()=>(0, _arrowRightEndOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightOnRectangleIcon", ()=>(0, _arrowRightOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightStartOnRectangleIcon", ()=>(0, _arrowRightStartOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightIcon", ()=>(0, _arrowRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallDownIcon", ()=>(0, _arrowSmallDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallLeftIcon", ()=>(0, _arrowSmallLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallRightIcon", ()=>(0, _arrowSmallRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallUpIcon", ()=>(0, _arrowSmallUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTopRightOnSquareIcon", ()=>(0, _arrowTopRightOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTrendingDownIcon", ()=>(0, _arrowTrendingDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTrendingUpIcon", ()=>(0, _arrowTrendingUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircleIcon", ()=>(0, _arrowUpCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftIcon", ()=>(0, _arrowUpLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpOnSquareStackIcon", ()=>(0, _arrowUpOnSquareStackIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpOnSquareIcon", ()=>(0, _arrowUpOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightIcon", ()=>(0, _arrowUpRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpTrayIcon", ()=>(0, _arrowUpTrayIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpIcon", ()=>(0, _arrowUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnDownIcon", ()=>(0, _arrowUturnDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnLeftIcon", ()=>(0, _arrowUturnLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnRightIcon", ()=>(0, _arrowUturnRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnUpIcon", ()=>(0, _arrowUturnUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsPointingInIcon", ()=>(0, _arrowsPointingInIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsPointingOutIcon", ()=>(0, _arrowsPointingOutIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsRightLeftIcon", ()=>(0, _arrowsRightLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpDownIcon", ()=>(0, _arrowsUpDownIconJsDefault.default));
parcelHelpers.export(exports, "AtSymbolIcon", ()=>(0, _atSymbolIconJsDefault.default));
parcelHelpers.export(exports, "BackspaceIcon", ()=>(0, _backspaceIconJsDefault.default));
parcelHelpers.export(exports, "BackwardIcon", ()=>(0, _backwardIconJsDefault.default));
parcelHelpers.export(exports, "BanknotesIcon", ()=>(0, _banknotesIconJsDefault.default));
parcelHelpers.export(exports, "Bars2Icon", ()=>(0, _bars2IconJsDefault.default));
parcelHelpers.export(exports, "Bars3BottomLeftIcon", ()=>(0, _bars3BottomLeftIconJsDefault.default));
parcelHelpers.export(exports, "Bars3BottomRightIcon", ()=>(0, _bars3BottomRightIconJsDefault.default));
parcelHelpers.export(exports, "Bars3CenterLeftIcon", ()=>(0, _bars3CenterLeftIconJsDefault.default));
parcelHelpers.export(exports, "Bars3Icon", ()=>(0, _bars3IconJsDefault.default));
parcelHelpers.export(exports, "Bars4Icon", ()=>(0, _bars4IconJsDefault.default));
parcelHelpers.export(exports, "BarsArrowDownIcon", ()=>(0, _barsArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "BarsArrowUpIcon", ()=>(0, _barsArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "Battery0Icon", ()=>(0, _battery0IconJsDefault.default));
parcelHelpers.export(exports, "Battery100Icon", ()=>(0, _battery100IconJsDefault.default));
parcelHelpers.export(exports, "Battery50Icon", ()=>(0, _battery50IconJsDefault.default));
parcelHelpers.export(exports, "BeakerIcon", ()=>(0, _beakerIconJsDefault.default));
parcelHelpers.export(exports, "BellAlertIcon", ()=>(0, _bellAlertIconJsDefault.default));
parcelHelpers.export(exports, "BellSlashIcon", ()=>(0, _bellSlashIconJsDefault.default));
parcelHelpers.export(exports, "BellSnoozeIcon", ()=>(0, _bellSnoozeIconJsDefault.default));
parcelHelpers.export(exports, "BellIcon", ()=>(0, _bellIconJsDefault.default));
parcelHelpers.export(exports, "BoltSlashIcon", ()=>(0, _boltSlashIconJsDefault.default));
parcelHelpers.export(exports, "BoltIcon", ()=>(0, _boltIconJsDefault.default));
parcelHelpers.export(exports, "BookOpenIcon", ()=>(0, _bookOpenIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkSlashIcon", ()=>(0, _bookmarkSlashIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkSquareIcon", ()=>(0, _bookmarkSquareIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkIcon", ()=>(0, _bookmarkIconJsDefault.default));
parcelHelpers.export(exports, "BriefcaseIcon", ()=>(0, _briefcaseIconJsDefault.default));
parcelHelpers.export(exports, "BugAntIcon", ()=>(0, _bugAntIconJsDefault.default));
parcelHelpers.export(exports, "BuildingLibraryIcon", ()=>(0, _buildingLibraryIconJsDefault.default));
parcelHelpers.export(exports, "BuildingOffice2Icon", ()=>(0, _buildingOffice2IconJsDefault.default));
parcelHelpers.export(exports, "BuildingOfficeIcon", ()=>(0, _buildingOfficeIconJsDefault.default));
parcelHelpers.export(exports, "BuildingStorefrontIcon", ()=>(0, _buildingStorefrontIconJsDefault.default));
parcelHelpers.export(exports, "CakeIcon", ()=>(0, _cakeIconJsDefault.default));
parcelHelpers.export(exports, "CalculatorIcon", ()=>(0, _calculatorIconJsDefault.default));
parcelHelpers.export(exports, "CalendarDaysIcon", ()=>(0, _calendarDaysIconJsDefault.default));
parcelHelpers.export(exports, "CalendarIcon", ()=>(0, _calendarIconJsDefault.default));
parcelHelpers.export(exports, "CameraIcon", ()=>(0, _cameraIconJsDefault.default));
parcelHelpers.export(exports, "ChartBarSquareIcon", ()=>(0, _chartBarSquareIconJsDefault.default));
parcelHelpers.export(exports, "ChartBarIcon", ()=>(0, _chartBarIconJsDefault.default));
parcelHelpers.export(exports, "ChartPieIcon", ()=>(0, _chartPieIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleBottomCenterTextIcon", ()=>(0, _chatBubbleBottomCenterTextIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleBottomCenterIcon", ()=>(0, _chatBubbleBottomCenterIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftEllipsisIcon", ()=>(0, _chatBubbleLeftEllipsisIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftRightIcon", ()=>(0, _chatBubbleLeftRightIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftIcon", ()=>(0, _chatBubbleLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleOvalLeftEllipsisIcon", ()=>(0, _chatBubbleOvalLeftEllipsisIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleOvalLeftIcon", ()=>(0, _chatBubbleOvalLeftIconJsDefault.default));
parcelHelpers.export(exports, "CheckBadgeIcon", ()=>(0, _checkBadgeIconJsDefault.default));
parcelHelpers.export(exports, "CheckCircleIcon", ()=>(0, _checkCircleIconJsDefault.default));
parcelHelpers.export(exports, "CheckIcon", ()=>(0, _checkIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleDownIcon", ()=>(0, _chevronDoubleDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleLeftIcon", ()=>(0, _chevronDoubleLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleRightIcon", ()=>(0, _chevronDoubleRightIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleUpIcon", ()=>(0, _chevronDoubleUpIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDownIcon", ()=>(0, _chevronDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftIcon", ()=>(0, _chevronLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChevronRightIcon", ()=>(0, _chevronRightIconJsDefault.default));
parcelHelpers.export(exports, "ChevronUpDownIcon", ()=>(0, _chevronUpDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronUpIcon", ()=>(0, _chevronUpIconJsDefault.default));
parcelHelpers.export(exports, "CircleStackIcon", ()=>(0, _circleStackIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentCheckIcon", ()=>(0, _clipboardDocumentCheckIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentListIcon", ()=>(0, _clipboardDocumentListIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentIcon", ()=>(0, _clipboardDocumentIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardIcon", ()=>(0, _clipboardIconJsDefault.default));
parcelHelpers.export(exports, "ClockIcon", ()=>(0, _clockIconJsDefault.default));
parcelHelpers.export(exports, "CloudArrowDownIcon", ()=>(0, _cloudArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "CloudArrowUpIcon", ()=>(0, _cloudArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "CloudIcon", ()=>(0, _cloudIconJsDefault.default));
parcelHelpers.export(exports, "CodeBracketSquareIcon", ()=>(0, _codeBracketSquareIconJsDefault.default));
parcelHelpers.export(exports, "CodeBracketIcon", ()=>(0, _codeBracketIconJsDefault.default));
parcelHelpers.export(exports, "Cog6ToothIcon", ()=>(0, _cog6ToothIconJsDefault.default));
parcelHelpers.export(exports, "Cog8ToothIcon", ()=>(0, _cog8ToothIconJsDefault.default));
parcelHelpers.export(exports, "CogIcon", ()=>(0, _cogIconJsDefault.default));
parcelHelpers.export(exports, "CommandLineIcon", ()=>(0, _commandLineIconJsDefault.default));
parcelHelpers.export(exports, "ComputerDesktopIcon", ()=>(0, _computerDesktopIconJsDefault.default));
parcelHelpers.export(exports, "CpuChipIcon", ()=>(0, _cpuChipIconJsDefault.default));
parcelHelpers.export(exports, "CreditCardIcon", ()=>(0, _creditCardIconJsDefault.default));
parcelHelpers.export(exports, "CubeTransparentIcon", ()=>(0, _cubeTransparentIconJsDefault.default));
parcelHelpers.export(exports, "CubeIcon", ()=>(0, _cubeIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyBangladeshiIcon", ()=>(0, _currencyBangladeshiIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyDollarIcon", ()=>(0, _currencyDollarIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyEuroIcon", ()=>(0, _currencyEuroIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyPoundIcon", ()=>(0, _currencyPoundIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeIcon", ()=>(0, _currencyRupeeIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyYenIcon", ()=>(0, _currencyYenIconJsDefault.default));
parcelHelpers.export(exports, "CursorArrowRaysIcon", ()=>(0, _cursorArrowRaysIconJsDefault.default));
parcelHelpers.export(exports, "CursorArrowRippleIcon", ()=>(0, _cursorArrowRippleIconJsDefault.default));
parcelHelpers.export(exports, "DevicePhoneMobileIcon", ()=>(0, _devicePhoneMobileIconJsDefault.default));
parcelHelpers.export(exports, "DeviceTabletIcon", ()=>(0, _deviceTabletIconJsDefault.default));
parcelHelpers.export(exports, "DocumentArrowDownIcon", ()=>(0, _documentArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "DocumentArrowUpIcon", ()=>(0, _documentArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "DocumentChartBarIcon", ()=>(0, _documentChartBarIconJsDefault.default));
parcelHelpers.export(exports, "DocumentCheckIcon", ()=>(0, _documentCheckIconJsDefault.default));
parcelHelpers.export(exports, "DocumentDuplicateIcon", ()=>(0, _documentDuplicateIconJsDefault.default));
parcelHelpers.export(exports, "DocumentMagnifyingGlassIcon", ()=>(0, _documentMagnifyingGlassIconJsDefault.default));
parcelHelpers.export(exports, "DocumentMinusIcon", ()=>(0, _documentMinusIconJsDefault.default));
parcelHelpers.export(exports, "DocumentPlusIcon", ()=>(0, _documentPlusIconJsDefault.default));
parcelHelpers.export(exports, "DocumentTextIcon", ()=>(0, _documentTextIconJsDefault.default));
parcelHelpers.export(exports, "DocumentIcon", ()=>(0, _documentIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisHorizontalCircleIcon", ()=>(0, _ellipsisHorizontalCircleIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisHorizontalIcon", ()=>(0, _ellipsisHorizontalIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisVerticalIcon", ()=>(0, _ellipsisVerticalIconJsDefault.default));
parcelHelpers.export(exports, "EnvelopeOpenIcon", ()=>(0, _envelopeOpenIconJsDefault.default));
parcelHelpers.export(exports, "EnvelopeIcon", ()=>(0, _envelopeIconJsDefault.default));
parcelHelpers.export(exports, "ExclamationCircleIcon", ()=>(0, _exclamationCircleIconJsDefault.default));
parcelHelpers.export(exports, "ExclamationTriangleIcon", ()=>(0, _exclamationTriangleIconJsDefault.default));
parcelHelpers.export(exports, "EyeDropperIcon", ()=>(0, _eyeDropperIconJsDefault.default));
parcelHelpers.export(exports, "EyeSlashIcon", ()=>(0, _eyeSlashIconJsDefault.default));
parcelHelpers.export(exports, "EyeIcon", ()=>(0, _eyeIconJsDefault.default));
parcelHelpers.export(exports, "FaceFrownIcon", ()=>(0, _faceFrownIconJsDefault.default));
parcelHelpers.export(exports, "FaceSmileIcon", ()=>(0, _faceSmileIconJsDefault.default));
parcelHelpers.export(exports, "FilmIcon", ()=>(0, _filmIconJsDefault.default));
parcelHelpers.export(exports, "FingerPrintIcon", ()=>(0, _fingerPrintIconJsDefault.default));
parcelHelpers.export(exports, "FireIcon", ()=>(0, _fireIconJsDefault.default));
parcelHelpers.export(exports, "FlagIcon", ()=>(0, _flagIconJsDefault.default));
parcelHelpers.export(exports, "FolderArrowDownIcon", ()=>(0, _folderArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "FolderMinusIcon", ()=>(0, _folderMinusIconJsDefault.default));
parcelHelpers.export(exports, "FolderOpenIcon", ()=>(0, _folderOpenIconJsDefault.default));
parcelHelpers.export(exports, "FolderPlusIcon", ()=>(0, _folderPlusIconJsDefault.default));
parcelHelpers.export(exports, "FolderIcon", ()=>(0, _folderIconJsDefault.default));
parcelHelpers.export(exports, "ForwardIcon", ()=>(0, _forwardIconJsDefault.default));
parcelHelpers.export(exports, "FunnelIcon", ()=>(0, _funnelIconJsDefault.default));
parcelHelpers.export(exports, "GifIcon", ()=>(0, _gifIconJsDefault.default));
parcelHelpers.export(exports, "GiftTopIcon", ()=>(0, _giftTopIconJsDefault.default));
parcelHelpers.export(exports, "GiftIcon", ()=>(0, _giftIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAltIcon", ()=>(0, _globeAltIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAmericasIcon", ()=>(0, _globeAmericasIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAsiaAustraliaIcon", ()=>(0, _globeAsiaAustraliaIconJsDefault.default));
parcelHelpers.export(exports, "GlobeEuropeAfricaIcon", ()=>(0, _globeEuropeAfricaIconJsDefault.default));
parcelHelpers.export(exports, "HandRaisedIcon", ()=>(0, _handRaisedIconJsDefault.default));
parcelHelpers.export(exports, "HandThumbDownIcon", ()=>(0, _handThumbDownIconJsDefault.default));
parcelHelpers.export(exports, "HandThumbUpIcon", ()=>(0, _handThumbUpIconJsDefault.default));
parcelHelpers.export(exports, "HashtagIcon", ()=>(0, _hashtagIconJsDefault.default));
parcelHelpers.export(exports, "HeartIcon", ()=>(0, _heartIconJsDefault.default));
parcelHelpers.export(exports, "HomeModernIcon", ()=>(0, _homeModernIconJsDefault.default));
parcelHelpers.export(exports, "HomeIcon", ()=>(0, _homeIconJsDefault.default));
parcelHelpers.export(exports, "IdentificationIcon", ()=>(0, _identificationIconJsDefault.default));
parcelHelpers.export(exports, "InboxArrowDownIcon", ()=>(0, _inboxArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "InboxStackIcon", ()=>(0, _inboxStackIconJsDefault.default));
parcelHelpers.export(exports, "InboxIcon", ()=>(0, _inboxIconJsDefault.default));
parcelHelpers.export(exports, "InformationCircleIcon", ()=>(0, _informationCircleIconJsDefault.default));
parcelHelpers.export(exports, "KeyIcon", ()=>(0, _keyIconJsDefault.default));
parcelHelpers.export(exports, "LanguageIcon", ()=>(0, _languageIconJsDefault.default));
parcelHelpers.export(exports, "LifebuoyIcon", ()=>(0, _lifebuoyIconJsDefault.default));
parcelHelpers.export(exports, "LightBulbIcon", ()=>(0, _lightBulbIconJsDefault.default));
parcelHelpers.export(exports, "LinkIcon", ()=>(0, _linkIconJsDefault.default));
parcelHelpers.export(exports, "ListBulletIcon", ()=>(0, _listBulletIconJsDefault.default));
parcelHelpers.export(exports, "LockClosedIcon", ()=>(0, _lockClosedIconJsDefault.default));
parcelHelpers.export(exports, "LockOpenIcon", ()=>(0, _lockOpenIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassCircleIcon", ()=>(0, _magnifyingGlassCircleIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassMinusIcon", ()=>(0, _magnifyingGlassMinusIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassPlusIcon", ()=>(0, _magnifyingGlassPlusIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassIcon", ()=>(0, _magnifyingGlassIconJsDefault.default));
parcelHelpers.export(exports, "MapPinIcon", ()=>(0, _mapPinIconJsDefault.default));
parcelHelpers.export(exports, "MapIcon", ()=>(0, _mapIconJsDefault.default));
parcelHelpers.export(exports, "MegaphoneIcon", ()=>(0, _megaphoneIconJsDefault.default));
parcelHelpers.export(exports, "MicrophoneIcon", ()=>(0, _microphoneIconJsDefault.default));
parcelHelpers.export(exports, "MinusCircleIcon", ()=>(0, _minusCircleIconJsDefault.default));
parcelHelpers.export(exports, "MinusSmallIcon", ()=>(0, _minusSmallIconJsDefault.default));
parcelHelpers.export(exports, "MinusIcon", ()=>(0, _minusIconJsDefault.default));
parcelHelpers.export(exports, "MoonIcon", ()=>(0, _moonIconJsDefault.default));
parcelHelpers.export(exports, "MusicalNoteIcon", ()=>(0, _musicalNoteIconJsDefault.default));
parcelHelpers.export(exports, "NewspaperIcon", ()=>(0, _newspaperIconJsDefault.default));
parcelHelpers.export(exports, "NoSymbolIcon", ()=>(0, _noSymbolIconJsDefault.default));
parcelHelpers.export(exports, "PaintBrushIcon", ()=>(0, _paintBrushIconJsDefault.default));
parcelHelpers.export(exports, "PaperAirplaneIcon", ()=>(0, _paperAirplaneIconJsDefault.default));
parcelHelpers.export(exports, "PaperClipIcon", ()=>(0, _paperClipIconJsDefault.default));
parcelHelpers.export(exports, "PauseCircleIcon", ()=>(0, _pauseCircleIconJsDefault.default));
parcelHelpers.export(exports, "PauseIcon", ()=>(0, _pauseIconJsDefault.default));
parcelHelpers.export(exports, "PencilSquareIcon", ()=>(0, _pencilSquareIconJsDefault.default));
parcelHelpers.export(exports, "PencilIcon", ()=>(0, _pencilIconJsDefault.default));
parcelHelpers.export(exports, "PhoneArrowDownLeftIcon", ()=>(0, _phoneArrowDownLeftIconJsDefault.default));
parcelHelpers.export(exports, "PhoneArrowUpRightIcon", ()=>(0, _phoneArrowUpRightIconJsDefault.default));
parcelHelpers.export(exports, "PhoneXMarkIcon", ()=>(0, _phoneXMarkIconJsDefault.default));
parcelHelpers.export(exports, "PhoneIcon", ()=>(0, _phoneIconJsDefault.default));
parcelHelpers.export(exports, "PhotoIcon", ()=>(0, _photoIconJsDefault.default));
parcelHelpers.export(exports, "PlayCircleIcon", ()=>(0, _playCircleIconJsDefault.default));
parcelHelpers.export(exports, "PlayPauseIcon", ()=>(0, _playPauseIconJsDefault.default));
parcelHelpers.export(exports, "PlayIcon", ()=>(0, _playIconJsDefault.default));
parcelHelpers.export(exports, "PlusCircleIcon", ()=>(0, _plusCircleIconJsDefault.default));
parcelHelpers.export(exports, "PlusSmallIcon", ()=>(0, _plusSmallIconJsDefault.default));
parcelHelpers.export(exports, "PlusIcon", ()=>(0, _plusIconJsDefault.default));
parcelHelpers.export(exports, "PowerIcon", ()=>(0, _powerIconJsDefault.default));
parcelHelpers.export(exports, "PresentationChartBarIcon", ()=>(0, _presentationChartBarIconJsDefault.default));
parcelHelpers.export(exports, "PresentationChartLineIcon", ()=>(0, _presentationChartLineIconJsDefault.default));
parcelHelpers.export(exports, "PrinterIcon", ()=>(0, _printerIconJsDefault.default));
parcelHelpers.export(exports, "PuzzlePieceIcon", ()=>(0, _puzzlePieceIconJsDefault.default));
parcelHelpers.export(exports, "QrCodeIcon", ()=>(0, _qrCodeIconJsDefault.default));
parcelHelpers.export(exports, "QuestionMarkCircleIcon", ()=>(0, _questionMarkCircleIconJsDefault.default));
parcelHelpers.export(exports, "QueueListIcon", ()=>(0, _queueListIconJsDefault.default));
parcelHelpers.export(exports, "RadioIcon", ()=>(0, _radioIconJsDefault.default));
parcelHelpers.export(exports, "ReceiptPercentIcon", ()=>(0, _receiptPercentIconJsDefault.default));
parcelHelpers.export(exports, "ReceiptRefundIcon", ()=>(0, _receiptRefundIconJsDefault.default));
parcelHelpers.export(exports, "RectangleGroupIcon", ()=>(0, _rectangleGroupIconJsDefault.default));
parcelHelpers.export(exports, "RectangleStackIcon", ()=>(0, _rectangleStackIconJsDefault.default));
parcelHelpers.export(exports, "RocketLaunchIcon", ()=>(0, _rocketLaunchIconJsDefault.default));
parcelHelpers.export(exports, "RssIcon", ()=>(0, _rssIconJsDefault.default));
parcelHelpers.export(exports, "ScaleIcon", ()=>(0, _scaleIconJsDefault.default));
parcelHelpers.export(exports, "ScissorsIcon", ()=>(0, _scissorsIconJsDefault.default));
parcelHelpers.export(exports, "ServerStackIcon", ()=>(0, _serverStackIconJsDefault.default));
parcelHelpers.export(exports, "ServerIcon", ()=>(0, _serverIconJsDefault.default));
parcelHelpers.export(exports, "ShareIcon", ()=>(0, _shareIconJsDefault.default));
parcelHelpers.export(exports, "ShieldCheckIcon", ()=>(0, _shieldCheckIconJsDefault.default));
parcelHelpers.export(exports, "ShieldExclamationIcon", ()=>(0, _shieldExclamationIconJsDefault.default));
parcelHelpers.export(exports, "ShoppingBagIcon", ()=>(0, _shoppingBagIconJsDefault.default));
parcelHelpers.export(exports, "ShoppingCartIcon", ()=>(0, _shoppingCartIconJsDefault.default));
parcelHelpers.export(exports, "SignalSlashIcon", ()=>(0, _signalSlashIconJsDefault.default));
parcelHelpers.export(exports, "SignalIcon", ()=>(0, _signalIconJsDefault.default));
parcelHelpers.export(exports, "SparklesIcon", ()=>(0, _sparklesIconJsDefault.default));
parcelHelpers.export(exports, "SpeakerWaveIcon", ()=>(0, _speakerWaveIconJsDefault.default));
parcelHelpers.export(exports, "SpeakerXMarkIcon", ()=>(0, _speakerXMarkIconJsDefault.default));
parcelHelpers.export(exports, "Square2StackIcon", ()=>(0, _square2StackIconJsDefault.default));
parcelHelpers.export(exports, "Square3Stack3DIcon", ()=>(0, _square3Stack3DIconJsDefault.default));
parcelHelpers.export(exports, "Squares2X2Icon", ()=>(0, _squares2X2IconJsDefault.default));
parcelHelpers.export(exports, "SquaresPlusIcon", ()=>(0, _squaresPlusIconJsDefault.default));
parcelHelpers.export(exports, "StarIcon", ()=>(0, _starIconJsDefault.default));
parcelHelpers.export(exports, "StopCircleIcon", ()=>(0, _stopCircleIconJsDefault.default));
parcelHelpers.export(exports, "StopIcon", ()=>(0, _stopIconJsDefault.default));
parcelHelpers.export(exports, "SunIcon", ()=>(0, _sunIconJsDefault.default));
parcelHelpers.export(exports, "SwatchIcon", ()=>(0, _swatchIconJsDefault.default));
parcelHelpers.export(exports, "TableCellsIcon", ()=>(0, _tableCellsIconJsDefault.default));
parcelHelpers.export(exports, "TagIcon", ()=>(0, _tagIconJsDefault.default));
parcelHelpers.export(exports, "TicketIcon", ()=>(0, _ticketIconJsDefault.default));
parcelHelpers.export(exports, "TrashIcon", ()=>(0, _trashIconJsDefault.default));
parcelHelpers.export(exports, "TrophyIcon", ()=>(0, _trophyIconJsDefault.default));
parcelHelpers.export(exports, "TruckIcon", ()=>(0, _truckIconJsDefault.default));
parcelHelpers.export(exports, "TvIcon", ()=>(0, _tvIconJsDefault.default));
parcelHelpers.export(exports, "UserCircleIcon", ()=>(0, _userCircleIconJsDefault.default));
parcelHelpers.export(exports, "UserGroupIcon", ()=>(0, _userGroupIconJsDefault.default));
parcelHelpers.export(exports, "UserMinusIcon", ()=>(0, _userMinusIconJsDefault.default));
parcelHelpers.export(exports, "UserPlusIcon", ()=>(0, _userPlusIconJsDefault.default));
parcelHelpers.export(exports, "UserIcon", ()=>(0, _userIconJsDefault.default));
parcelHelpers.export(exports, "UsersIcon", ()=>(0, _usersIconJsDefault.default));
parcelHelpers.export(exports, "VariableIcon", ()=>(0, _variableIconJsDefault.default));
parcelHelpers.export(exports, "VideoCameraSlashIcon", ()=>(0, _videoCameraSlashIconJsDefault.default));
parcelHelpers.export(exports, "VideoCameraIcon", ()=>(0, _videoCameraIconJsDefault.default));
parcelHelpers.export(exports, "ViewColumnsIcon", ()=>(0, _viewColumnsIconJsDefault.default));
parcelHelpers.export(exports, "ViewfinderCircleIcon", ()=>(0, _viewfinderCircleIconJsDefault.default));
parcelHelpers.export(exports, "WalletIcon", ()=>(0, _walletIconJsDefault.default));
parcelHelpers.export(exports, "WifiIcon", ()=>(0, _wifiIconJsDefault.default));
parcelHelpers.export(exports, "WindowIcon", ()=>(0, _windowIconJsDefault.default));
parcelHelpers.export(exports, "WrenchScrewdriverIcon", ()=>(0, _wrenchScrewdriverIconJsDefault.default));
parcelHelpers.export(exports, "WrenchIcon", ()=>(0, _wrenchIconJsDefault.default));
parcelHelpers.export(exports, "XCircleIcon", ()=>(0, _xcircleIconJsDefault.default));
parcelHelpers.export(exports, "XMarkIcon", ()=>(0, _xmarkIconJsDefault.default));
var _academicCapIconJs = require("./AcademicCapIcon.js");
var _academicCapIconJsDefault = parcelHelpers.interopDefault(_academicCapIconJs);
var _adjustmentsHorizontalIconJs = require("./AdjustmentsHorizontalIcon.js");
var _adjustmentsHorizontalIconJsDefault = parcelHelpers.interopDefault(_adjustmentsHorizontalIconJs);
var _adjustmentsVerticalIconJs = require("./AdjustmentsVerticalIcon.js");
var _adjustmentsVerticalIconJsDefault = parcelHelpers.interopDefault(_adjustmentsVerticalIconJs);
var _archiveBoxArrowDownIconJs = require("./ArchiveBoxArrowDownIcon.js");
var _archiveBoxArrowDownIconJsDefault = parcelHelpers.interopDefault(_archiveBoxArrowDownIconJs);
var _archiveBoxXMarkIconJs = require("./ArchiveBoxXMarkIcon.js");
var _archiveBoxXMarkIconJsDefault = parcelHelpers.interopDefault(_archiveBoxXMarkIconJs);
var _archiveBoxIconJs = require("./ArchiveBoxIcon.js");
var _archiveBoxIconJsDefault = parcelHelpers.interopDefault(_archiveBoxIconJs);
var _arrowDownCircleIconJs = require("./ArrowDownCircleIcon.js");
var _arrowDownCircleIconJsDefault = parcelHelpers.interopDefault(_arrowDownCircleIconJs);
var _arrowDownLeftIconJs = require("./ArrowDownLeftIcon.js");
var _arrowDownLeftIconJsDefault = parcelHelpers.interopDefault(_arrowDownLeftIconJs);
var _arrowDownOnSquareStackIconJs = require("./ArrowDownOnSquareStackIcon.js");
var _arrowDownOnSquareStackIconJsDefault = parcelHelpers.interopDefault(_arrowDownOnSquareStackIconJs);
var _arrowDownOnSquareIconJs = require("./ArrowDownOnSquareIcon.js");
var _arrowDownOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowDownOnSquareIconJs);
var _arrowDownRightIconJs = require("./ArrowDownRightIcon.js");
var _arrowDownRightIconJsDefault = parcelHelpers.interopDefault(_arrowDownRightIconJs);
var _arrowDownTrayIconJs = require("./ArrowDownTrayIcon.js");
var _arrowDownTrayIconJsDefault = parcelHelpers.interopDefault(_arrowDownTrayIconJs);
var _arrowDownIconJs = require("./ArrowDownIcon.js");
var _arrowDownIconJsDefault = parcelHelpers.interopDefault(_arrowDownIconJs);
var _arrowLeftCircleIconJs = require("./ArrowLeftCircleIcon.js");
var _arrowLeftCircleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftCircleIconJs);
var _arrowLeftEndOnRectangleIconJs = require("./ArrowLeftEndOnRectangleIcon.js");
var _arrowLeftEndOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftEndOnRectangleIconJs);
var _arrowLeftOnRectangleIconJs = require("./ArrowLeftOnRectangleIcon.js");
var _arrowLeftOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftOnRectangleIconJs);
var _arrowLeftStartOnRectangleIconJs = require("./ArrowLeftStartOnRectangleIcon.js");
var _arrowLeftStartOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftStartOnRectangleIconJs);
var _arrowLeftIconJs = require("./ArrowLeftIcon.js");
var _arrowLeftIconJsDefault = parcelHelpers.interopDefault(_arrowLeftIconJs);
var _arrowLongDownIconJs = require("./ArrowLongDownIcon.js");
var _arrowLongDownIconJsDefault = parcelHelpers.interopDefault(_arrowLongDownIconJs);
var _arrowLongLeftIconJs = require("./ArrowLongLeftIcon.js");
var _arrowLongLeftIconJsDefault = parcelHelpers.interopDefault(_arrowLongLeftIconJs);
var _arrowLongRightIconJs = require("./ArrowLongRightIcon.js");
var _arrowLongRightIconJsDefault = parcelHelpers.interopDefault(_arrowLongRightIconJs);
var _arrowLongUpIconJs = require("./ArrowLongUpIcon.js");
var _arrowLongUpIconJsDefault = parcelHelpers.interopDefault(_arrowLongUpIconJs);
var _arrowPathRoundedSquareIconJs = require("./ArrowPathRoundedSquareIcon.js");
var _arrowPathRoundedSquareIconJsDefault = parcelHelpers.interopDefault(_arrowPathRoundedSquareIconJs);
var _arrowPathIconJs = require("./ArrowPathIcon.js");
var _arrowPathIconJsDefault = parcelHelpers.interopDefault(_arrowPathIconJs);
var _arrowRightCircleIconJs = require("./ArrowRightCircleIcon.js");
var _arrowRightCircleIconJsDefault = parcelHelpers.interopDefault(_arrowRightCircleIconJs);
var _arrowRightEndOnRectangleIconJs = require("./ArrowRightEndOnRectangleIcon.js");
var _arrowRightEndOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightEndOnRectangleIconJs);
var _arrowRightOnRectangleIconJs = require("./ArrowRightOnRectangleIcon.js");
var _arrowRightOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightOnRectangleIconJs);
var _arrowRightStartOnRectangleIconJs = require("./ArrowRightStartOnRectangleIcon.js");
var _arrowRightStartOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightStartOnRectangleIconJs);
var _arrowRightIconJs = require("./ArrowRightIcon.js");
var _arrowRightIconJsDefault = parcelHelpers.interopDefault(_arrowRightIconJs);
var _arrowSmallDownIconJs = require("./ArrowSmallDownIcon.js");
var _arrowSmallDownIconJsDefault = parcelHelpers.interopDefault(_arrowSmallDownIconJs);
var _arrowSmallLeftIconJs = require("./ArrowSmallLeftIcon.js");
var _arrowSmallLeftIconJsDefault = parcelHelpers.interopDefault(_arrowSmallLeftIconJs);
var _arrowSmallRightIconJs = require("./ArrowSmallRightIcon.js");
var _arrowSmallRightIconJsDefault = parcelHelpers.interopDefault(_arrowSmallRightIconJs);
var _arrowSmallUpIconJs = require("./ArrowSmallUpIcon.js");
var _arrowSmallUpIconJsDefault = parcelHelpers.interopDefault(_arrowSmallUpIconJs);
var _arrowTopRightOnSquareIconJs = require("./ArrowTopRightOnSquareIcon.js");
var _arrowTopRightOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowTopRightOnSquareIconJs);
var _arrowTrendingDownIconJs = require("./ArrowTrendingDownIcon.js");
var _arrowTrendingDownIconJsDefault = parcelHelpers.interopDefault(_arrowTrendingDownIconJs);
var _arrowTrendingUpIconJs = require("./ArrowTrendingUpIcon.js");
var _arrowTrendingUpIconJsDefault = parcelHelpers.interopDefault(_arrowTrendingUpIconJs);
var _arrowUpCircleIconJs = require("./ArrowUpCircleIcon.js");
var _arrowUpCircleIconJsDefault = parcelHelpers.interopDefault(_arrowUpCircleIconJs);
var _arrowUpLeftIconJs = require("./ArrowUpLeftIcon.js");
var _arrowUpLeftIconJsDefault = parcelHelpers.interopDefault(_arrowUpLeftIconJs);
var _arrowUpOnSquareStackIconJs = require("./ArrowUpOnSquareStackIcon.js");
var _arrowUpOnSquareStackIconJsDefault = parcelHelpers.interopDefault(_arrowUpOnSquareStackIconJs);
var _arrowUpOnSquareIconJs = require("./ArrowUpOnSquareIcon.js");
var _arrowUpOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowUpOnSquareIconJs);
var _arrowUpRightIconJs = require("./ArrowUpRightIcon.js");
var _arrowUpRightIconJsDefault = parcelHelpers.interopDefault(_arrowUpRightIconJs);
var _arrowUpTrayIconJs = require("./ArrowUpTrayIcon.js");
var _arrowUpTrayIconJsDefault = parcelHelpers.interopDefault(_arrowUpTrayIconJs);
var _arrowUpIconJs = require("./ArrowUpIcon.js");
var _arrowUpIconJsDefault = parcelHelpers.interopDefault(_arrowUpIconJs);
var _arrowUturnDownIconJs = require("./ArrowUturnDownIcon.js");
var _arrowUturnDownIconJsDefault = parcelHelpers.interopDefault(_arrowUturnDownIconJs);
var _arrowUturnLeftIconJs = require("./ArrowUturnLeftIcon.js");
var _arrowUturnLeftIconJsDefault = parcelHelpers.interopDefault(_arrowUturnLeftIconJs);
var _arrowUturnRightIconJs = require("./ArrowUturnRightIcon.js");
var _arrowUturnRightIconJsDefault = parcelHelpers.interopDefault(_arrowUturnRightIconJs);
var _arrowUturnUpIconJs = require("./ArrowUturnUpIcon.js");
var _arrowUturnUpIconJsDefault = parcelHelpers.interopDefault(_arrowUturnUpIconJs);
var _arrowsPointingInIconJs = require("./ArrowsPointingInIcon.js");
var _arrowsPointingInIconJsDefault = parcelHelpers.interopDefault(_arrowsPointingInIconJs);
var _arrowsPointingOutIconJs = require("./ArrowsPointingOutIcon.js");
var _arrowsPointingOutIconJsDefault = parcelHelpers.interopDefault(_arrowsPointingOutIconJs);
var _arrowsRightLeftIconJs = require("./ArrowsRightLeftIcon.js");
var _arrowsRightLeftIconJsDefault = parcelHelpers.interopDefault(_arrowsRightLeftIconJs);
var _arrowsUpDownIconJs = require("./ArrowsUpDownIcon.js");
var _arrowsUpDownIconJsDefault = parcelHelpers.interopDefault(_arrowsUpDownIconJs);
var _atSymbolIconJs = require("./AtSymbolIcon.js");
var _atSymbolIconJsDefault = parcelHelpers.interopDefault(_atSymbolIconJs);
var _backspaceIconJs = require("./BackspaceIcon.js");
var _backspaceIconJsDefault = parcelHelpers.interopDefault(_backspaceIconJs);
var _backwardIconJs = require("./BackwardIcon.js");
var _backwardIconJsDefault = parcelHelpers.interopDefault(_backwardIconJs);
var _banknotesIconJs = require("./BanknotesIcon.js");
var _banknotesIconJsDefault = parcelHelpers.interopDefault(_banknotesIconJs);
var _bars2IconJs = require("./Bars2Icon.js");
var _bars2IconJsDefault = parcelHelpers.interopDefault(_bars2IconJs);
var _bars3BottomLeftIconJs = require("./Bars3BottomLeftIcon.js");
var _bars3BottomLeftIconJsDefault = parcelHelpers.interopDefault(_bars3BottomLeftIconJs);
var _bars3BottomRightIconJs = require("./Bars3BottomRightIcon.js");
var _bars3BottomRightIconJsDefault = parcelHelpers.interopDefault(_bars3BottomRightIconJs);
var _bars3CenterLeftIconJs = require("./Bars3CenterLeftIcon.js");
var _bars3CenterLeftIconJsDefault = parcelHelpers.interopDefault(_bars3CenterLeftIconJs);
var _bars3IconJs = require("./Bars3Icon.js");
var _bars3IconJsDefault = parcelHelpers.interopDefault(_bars3IconJs);
var _bars4IconJs = require("./Bars4Icon.js");
var _bars4IconJsDefault = parcelHelpers.interopDefault(_bars4IconJs);
var _barsArrowDownIconJs = require("./BarsArrowDownIcon.js");
var _barsArrowDownIconJsDefault = parcelHelpers.interopDefault(_barsArrowDownIconJs);
var _barsArrowUpIconJs = require("./BarsArrowUpIcon.js");
var _barsArrowUpIconJsDefault = parcelHelpers.interopDefault(_barsArrowUpIconJs);
var _battery0IconJs = require("./Battery0Icon.js");
var _battery0IconJsDefault = parcelHelpers.interopDefault(_battery0IconJs);
var _battery100IconJs = require("./Battery100Icon.js");
var _battery100IconJsDefault = parcelHelpers.interopDefault(_battery100IconJs);
var _battery50IconJs = require("./Battery50Icon.js");
var _battery50IconJsDefault = parcelHelpers.interopDefault(_battery50IconJs);
var _beakerIconJs = require("./BeakerIcon.js");
var _beakerIconJsDefault = parcelHelpers.interopDefault(_beakerIconJs);
var _bellAlertIconJs = require("./BellAlertIcon.js");
var _bellAlertIconJsDefault = parcelHelpers.interopDefault(_bellAlertIconJs);
var _bellSlashIconJs = require("./BellSlashIcon.js");
var _bellSlashIconJsDefault = parcelHelpers.interopDefault(_bellSlashIconJs);
var _bellSnoozeIconJs = require("./BellSnoozeIcon.js");
var _bellSnoozeIconJsDefault = parcelHelpers.interopDefault(_bellSnoozeIconJs);
var _bellIconJs = require("./BellIcon.js");
var _bellIconJsDefault = parcelHelpers.interopDefault(_bellIconJs);
var _boltSlashIconJs = require("./BoltSlashIcon.js");
var _boltSlashIconJsDefault = parcelHelpers.interopDefault(_boltSlashIconJs);
var _boltIconJs = require("./BoltIcon.js");
var _boltIconJsDefault = parcelHelpers.interopDefault(_boltIconJs);
var _bookOpenIconJs = require("./BookOpenIcon.js");
var _bookOpenIconJsDefault = parcelHelpers.interopDefault(_bookOpenIconJs);
var _bookmarkSlashIconJs = require("./BookmarkSlashIcon.js");
var _bookmarkSlashIconJsDefault = parcelHelpers.interopDefault(_bookmarkSlashIconJs);
var _bookmarkSquareIconJs = require("./BookmarkSquareIcon.js");
var _bookmarkSquareIconJsDefault = parcelHelpers.interopDefault(_bookmarkSquareIconJs);
var _bookmarkIconJs = require("./BookmarkIcon.js");
var _bookmarkIconJsDefault = parcelHelpers.interopDefault(_bookmarkIconJs);
var _briefcaseIconJs = require("./BriefcaseIcon.js");
var _briefcaseIconJsDefault = parcelHelpers.interopDefault(_briefcaseIconJs);
var _bugAntIconJs = require("./BugAntIcon.js");
var _bugAntIconJsDefault = parcelHelpers.interopDefault(_bugAntIconJs);
var _buildingLibraryIconJs = require("./BuildingLibraryIcon.js");
var _buildingLibraryIconJsDefault = parcelHelpers.interopDefault(_buildingLibraryIconJs);
var _buildingOffice2IconJs = require("./BuildingOffice2Icon.js");
var _buildingOffice2IconJsDefault = parcelHelpers.interopDefault(_buildingOffice2IconJs);
var _buildingOfficeIconJs = require("./BuildingOfficeIcon.js");
var _buildingOfficeIconJsDefault = parcelHelpers.interopDefault(_buildingOfficeIconJs);
var _buildingStorefrontIconJs = require("./BuildingStorefrontIcon.js");
var _buildingStorefrontIconJsDefault = parcelHelpers.interopDefault(_buildingStorefrontIconJs);
var _cakeIconJs = require("./CakeIcon.js");
var _cakeIconJsDefault = parcelHelpers.interopDefault(_cakeIconJs);
var _calculatorIconJs = require("./CalculatorIcon.js");
var _calculatorIconJsDefault = parcelHelpers.interopDefault(_calculatorIconJs);
var _calendarDaysIconJs = require("./CalendarDaysIcon.js");
var _calendarDaysIconJsDefault = parcelHelpers.interopDefault(_calendarDaysIconJs);
var _calendarIconJs = require("./CalendarIcon.js");
var _calendarIconJsDefault = parcelHelpers.interopDefault(_calendarIconJs);
var _cameraIconJs = require("./CameraIcon.js");
var _cameraIconJsDefault = parcelHelpers.interopDefault(_cameraIconJs);
var _chartBarSquareIconJs = require("./ChartBarSquareIcon.js");
var _chartBarSquareIconJsDefault = parcelHelpers.interopDefault(_chartBarSquareIconJs);
var _chartBarIconJs = require("./ChartBarIcon.js");
var _chartBarIconJsDefault = parcelHelpers.interopDefault(_chartBarIconJs);
var _chartPieIconJs = require("./ChartPieIcon.js");
var _chartPieIconJsDefault = parcelHelpers.interopDefault(_chartPieIconJs);
var _chatBubbleBottomCenterTextIconJs = require("./ChatBubbleBottomCenterTextIcon.js");
var _chatBubbleBottomCenterTextIconJsDefault = parcelHelpers.interopDefault(_chatBubbleBottomCenterTextIconJs);
var _chatBubbleBottomCenterIconJs = require("./ChatBubbleBottomCenterIcon.js");
var _chatBubbleBottomCenterIconJsDefault = parcelHelpers.interopDefault(_chatBubbleBottomCenterIconJs);
var _chatBubbleLeftEllipsisIconJs = require("./ChatBubbleLeftEllipsisIcon.js");
var _chatBubbleLeftEllipsisIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftEllipsisIconJs);
var _chatBubbleLeftRightIconJs = require("./ChatBubbleLeftRightIcon.js");
var _chatBubbleLeftRightIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftRightIconJs);
var _chatBubbleLeftIconJs = require("./ChatBubbleLeftIcon.js");
var _chatBubbleLeftIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftIconJs);
var _chatBubbleOvalLeftEllipsisIconJs = require("./ChatBubbleOvalLeftEllipsisIcon.js");
var _chatBubbleOvalLeftEllipsisIconJsDefault = parcelHelpers.interopDefault(_chatBubbleOvalLeftEllipsisIconJs);
var _chatBubbleOvalLeftIconJs = require("./ChatBubbleOvalLeftIcon.js");
var _chatBubbleOvalLeftIconJsDefault = parcelHelpers.interopDefault(_chatBubbleOvalLeftIconJs);
var _checkBadgeIconJs = require("./CheckBadgeIcon.js");
var _checkBadgeIconJsDefault = parcelHelpers.interopDefault(_checkBadgeIconJs);
var _checkCircleIconJs = require("./CheckCircleIcon.js");
var _checkCircleIconJsDefault = parcelHelpers.interopDefault(_checkCircleIconJs);
var _checkIconJs = require("./CheckIcon.js");
var _checkIconJsDefault = parcelHelpers.interopDefault(_checkIconJs);
var _chevronDoubleDownIconJs = require("./ChevronDoubleDownIcon.js");
var _chevronDoubleDownIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleDownIconJs);
var _chevronDoubleLeftIconJs = require("./ChevronDoubleLeftIcon.js");
var _chevronDoubleLeftIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleLeftIconJs);
var _chevronDoubleRightIconJs = require("./ChevronDoubleRightIcon.js");
var _chevronDoubleRightIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleRightIconJs);
var _chevronDoubleUpIconJs = require("./ChevronDoubleUpIcon.js");
var _chevronDoubleUpIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleUpIconJs);
var _chevronDownIconJs = require("./ChevronDownIcon.js");
var _chevronDownIconJsDefault = parcelHelpers.interopDefault(_chevronDownIconJs);
var _chevronLeftIconJs = require("./ChevronLeftIcon.js");
var _chevronLeftIconJsDefault = parcelHelpers.interopDefault(_chevronLeftIconJs);
var _chevronRightIconJs = require("./ChevronRightIcon.js");
var _chevronRightIconJsDefault = parcelHelpers.interopDefault(_chevronRightIconJs);
var _chevronUpDownIconJs = require("./ChevronUpDownIcon.js");
var _chevronUpDownIconJsDefault = parcelHelpers.interopDefault(_chevronUpDownIconJs);
var _chevronUpIconJs = require("./ChevronUpIcon.js");
var _chevronUpIconJsDefault = parcelHelpers.interopDefault(_chevronUpIconJs);
var _circleStackIconJs = require("./CircleStackIcon.js");
var _circleStackIconJsDefault = parcelHelpers.interopDefault(_circleStackIconJs);
var _clipboardDocumentCheckIconJs = require("./ClipboardDocumentCheckIcon.js");
var _clipboardDocumentCheckIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentCheckIconJs);
var _clipboardDocumentListIconJs = require("./ClipboardDocumentListIcon.js");
var _clipboardDocumentListIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentListIconJs);
var _clipboardDocumentIconJs = require("./ClipboardDocumentIcon.js");
var _clipboardDocumentIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentIconJs);
var _clipboardIconJs = require("./ClipboardIcon.js");
var _clipboardIconJsDefault = parcelHelpers.interopDefault(_clipboardIconJs);
var _clockIconJs = require("./ClockIcon.js");
var _clockIconJsDefault = parcelHelpers.interopDefault(_clockIconJs);
var _cloudArrowDownIconJs = require("./CloudArrowDownIcon.js");
var _cloudArrowDownIconJsDefault = parcelHelpers.interopDefault(_cloudArrowDownIconJs);
var _cloudArrowUpIconJs = require("./CloudArrowUpIcon.js");
var _cloudArrowUpIconJsDefault = parcelHelpers.interopDefault(_cloudArrowUpIconJs);
var _cloudIconJs = require("./CloudIcon.js");
var _cloudIconJsDefault = parcelHelpers.interopDefault(_cloudIconJs);
var _codeBracketSquareIconJs = require("./CodeBracketSquareIcon.js");
var _codeBracketSquareIconJsDefault = parcelHelpers.interopDefault(_codeBracketSquareIconJs);
var _codeBracketIconJs = require("./CodeBracketIcon.js");
var _codeBracketIconJsDefault = parcelHelpers.interopDefault(_codeBracketIconJs);
var _cog6ToothIconJs = require("./Cog6ToothIcon.js");
var _cog6ToothIconJsDefault = parcelHelpers.interopDefault(_cog6ToothIconJs);
var _cog8ToothIconJs = require("./Cog8ToothIcon.js");
var _cog8ToothIconJsDefault = parcelHelpers.interopDefault(_cog8ToothIconJs);
var _cogIconJs = require("./CogIcon.js");
var _cogIconJsDefault = parcelHelpers.interopDefault(_cogIconJs);
var _commandLineIconJs = require("./CommandLineIcon.js");
var _commandLineIconJsDefault = parcelHelpers.interopDefault(_commandLineIconJs);
var _computerDesktopIconJs = require("./ComputerDesktopIcon.js");
var _computerDesktopIconJsDefault = parcelHelpers.interopDefault(_computerDesktopIconJs);
var _cpuChipIconJs = require("./CpuChipIcon.js");
var _cpuChipIconJsDefault = parcelHelpers.interopDefault(_cpuChipIconJs);
var _creditCardIconJs = require("./CreditCardIcon.js");
var _creditCardIconJsDefault = parcelHelpers.interopDefault(_creditCardIconJs);
var _cubeTransparentIconJs = require("./CubeTransparentIcon.js");
var _cubeTransparentIconJsDefault = parcelHelpers.interopDefault(_cubeTransparentIconJs);
var _cubeIconJs = require("./CubeIcon.js");
var _cubeIconJsDefault = parcelHelpers.interopDefault(_cubeIconJs);
var _currencyBangladeshiIconJs = require("./CurrencyBangladeshiIcon.js");
var _currencyBangladeshiIconJsDefault = parcelHelpers.interopDefault(_currencyBangladeshiIconJs);
var _currencyDollarIconJs = require("./CurrencyDollarIcon.js");
var _currencyDollarIconJsDefault = parcelHelpers.interopDefault(_currencyDollarIconJs);
var _currencyEuroIconJs = require("./CurrencyEuroIcon.js");
var _currencyEuroIconJsDefault = parcelHelpers.interopDefault(_currencyEuroIconJs);
var _currencyPoundIconJs = require("./CurrencyPoundIcon.js");
var _currencyPoundIconJsDefault = parcelHelpers.interopDefault(_currencyPoundIconJs);
var _currencyRupeeIconJs = require("./CurrencyRupeeIcon.js");
var _currencyRupeeIconJsDefault = parcelHelpers.interopDefault(_currencyRupeeIconJs);
var _currencyYenIconJs = require("./CurrencyYenIcon.js");
var _currencyYenIconJsDefault = parcelHelpers.interopDefault(_currencyYenIconJs);
var _cursorArrowRaysIconJs = require("./CursorArrowRaysIcon.js");
var _cursorArrowRaysIconJsDefault = parcelHelpers.interopDefault(_cursorArrowRaysIconJs);
var _cursorArrowRippleIconJs = require("./CursorArrowRippleIcon.js");
var _cursorArrowRippleIconJsDefault = parcelHelpers.interopDefault(_cursorArrowRippleIconJs);
var _devicePhoneMobileIconJs = require("./DevicePhoneMobileIcon.js");
var _devicePhoneMobileIconJsDefault = parcelHelpers.interopDefault(_devicePhoneMobileIconJs);
var _deviceTabletIconJs = require("./DeviceTabletIcon.js");
var _deviceTabletIconJsDefault = parcelHelpers.interopDefault(_deviceTabletIconJs);
var _documentArrowDownIconJs = require("./DocumentArrowDownIcon.js");
var _documentArrowDownIconJsDefault = parcelHelpers.interopDefault(_documentArrowDownIconJs);
var _documentArrowUpIconJs = require("./DocumentArrowUpIcon.js");
var _documentArrowUpIconJsDefault = parcelHelpers.interopDefault(_documentArrowUpIconJs);
var _documentChartBarIconJs = require("./DocumentChartBarIcon.js");
var _documentChartBarIconJsDefault = parcelHelpers.interopDefault(_documentChartBarIconJs);
var _documentCheckIconJs = require("./DocumentCheckIcon.js");
var _documentCheckIconJsDefault = parcelHelpers.interopDefault(_documentCheckIconJs);
var _documentDuplicateIconJs = require("./DocumentDuplicateIcon.js");
var _documentDuplicateIconJsDefault = parcelHelpers.interopDefault(_documentDuplicateIconJs);
var _documentMagnifyingGlassIconJs = require("./DocumentMagnifyingGlassIcon.js");
var _documentMagnifyingGlassIconJsDefault = parcelHelpers.interopDefault(_documentMagnifyingGlassIconJs);
var _documentMinusIconJs = require("./DocumentMinusIcon.js");
var _documentMinusIconJsDefault = parcelHelpers.interopDefault(_documentMinusIconJs);
var _documentPlusIconJs = require("./DocumentPlusIcon.js");
var _documentPlusIconJsDefault = parcelHelpers.interopDefault(_documentPlusIconJs);
var _documentTextIconJs = require("./DocumentTextIcon.js");
var _documentTextIconJsDefault = parcelHelpers.interopDefault(_documentTextIconJs);
var _documentIconJs = require("./DocumentIcon.js");
var _documentIconJsDefault = parcelHelpers.interopDefault(_documentIconJs);
var _ellipsisHorizontalCircleIconJs = require("./EllipsisHorizontalCircleIcon.js");
var _ellipsisHorizontalCircleIconJsDefault = parcelHelpers.interopDefault(_ellipsisHorizontalCircleIconJs);
var _ellipsisHorizontalIconJs = require("./EllipsisHorizontalIcon.js");
var _ellipsisHorizontalIconJsDefault = parcelHelpers.interopDefault(_ellipsisHorizontalIconJs);
var _ellipsisVerticalIconJs = require("./EllipsisVerticalIcon.js");
var _ellipsisVerticalIconJsDefault = parcelHelpers.interopDefault(_ellipsisVerticalIconJs);
var _envelopeOpenIconJs = require("./EnvelopeOpenIcon.js");
var _envelopeOpenIconJsDefault = parcelHelpers.interopDefault(_envelopeOpenIconJs);
var _envelopeIconJs = require("./EnvelopeIcon.js");
var _envelopeIconJsDefault = parcelHelpers.interopDefault(_envelopeIconJs);
var _exclamationCircleIconJs = require("./ExclamationCircleIcon.js");
var _exclamationCircleIconJsDefault = parcelHelpers.interopDefault(_exclamationCircleIconJs);
var _exclamationTriangleIconJs = require("./ExclamationTriangleIcon.js");
var _exclamationTriangleIconJsDefault = parcelHelpers.interopDefault(_exclamationTriangleIconJs);
var _eyeDropperIconJs = require("./EyeDropperIcon.js");
var _eyeDropperIconJsDefault = parcelHelpers.interopDefault(_eyeDropperIconJs);
var _eyeSlashIconJs = require("./EyeSlashIcon.js");
var _eyeSlashIconJsDefault = parcelHelpers.interopDefault(_eyeSlashIconJs);
var _eyeIconJs = require("./EyeIcon.js");
var _eyeIconJsDefault = parcelHelpers.interopDefault(_eyeIconJs);
var _faceFrownIconJs = require("./FaceFrownIcon.js");
var _faceFrownIconJsDefault = parcelHelpers.interopDefault(_faceFrownIconJs);
var _faceSmileIconJs = require("./FaceSmileIcon.js");
var _faceSmileIconJsDefault = parcelHelpers.interopDefault(_faceSmileIconJs);
var _filmIconJs = require("./FilmIcon.js");
var _filmIconJsDefault = parcelHelpers.interopDefault(_filmIconJs);
var _fingerPrintIconJs = require("./FingerPrintIcon.js");
var _fingerPrintIconJsDefault = parcelHelpers.interopDefault(_fingerPrintIconJs);
var _fireIconJs = require("./FireIcon.js");
var _fireIconJsDefault = parcelHelpers.interopDefault(_fireIconJs);
var _flagIconJs = require("./FlagIcon.js");
var _flagIconJsDefault = parcelHelpers.interopDefault(_flagIconJs);
var _folderArrowDownIconJs = require("./FolderArrowDownIcon.js");
var _folderArrowDownIconJsDefault = parcelHelpers.interopDefault(_folderArrowDownIconJs);
var _folderMinusIconJs = require("./FolderMinusIcon.js");
var _folderMinusIconJsDefault = parcelHelpers.interopDefault(_folderMinusIconJs);
var _folderOpenIconJs = require("./FolderOpenIcon.js");
var _folderOpenIconJsDefault = parcelHelpers.interopDefault(_folderOpenIconJs);
var _folderPlusIconJs = require("./FolderPlusIcon.js");
var _folderPlusIconJsDefault = parcelHelpers.interopDefault(_folderPlusIconJs);
var _folderIconJs = require("./FolderIcon.js");
var _folderIconJsDefault = parcelHelpers.interopDefault(_folderIconJs);
var _forwardIconJs = require("./ForwardIcon.js");
var _forwardIconJsDefault = parcelHelpers.interopDefault(_forwardIconJs);
var _funnelIconJs = require("./FunnelIcon.js");
var _funnelIconJsDefault = parcelHelpers.interopDefault(_funnelIconJs);
var _gifIconJs = require("./GifIcon.js");
var _gifIconJsDefault = parcelHelpers.interopDefault(_gifIconJs);
var _giftTopIconJs = require("./GiftTopIcon.js");
var _giftTopIconJsDefault = parcelHelpers.interopDefault(_giftTopIconJs);
var _giftIconJs = require("./GiftIcon.js");
var _giftIconJsDefault = parcelHelpers.interopDefault(_giftIconJs);
var _globeAltIconJs = require("./GlobeAltIcon.js");
var _globeAltIconJsDefault = parcelHelpers.interopDefault(_globeAltIconJs);
var _globeAmericasIconJs = require("./GlobeAmericasIcon.js");
var _globeAmericasIconJsDefault = parcelHelpers.interopDefault(_globeAmericasIconJs);
var _globeAsiaAustraliaIconJs = require("./GlobeAsiaAustraliaIcon.js");
var _globeAsiaAustraliaIconJsDefault = parcelHelpers.interopDefault(_globeAsiaAustraliaIconJs);
var _globeEuropeAfricaIconJs = require("./GlobeEuropeAfricaIcon.js");
var _globeEuropeAfricaIconJsDefault = parcelHelpers.interopDefault(_globeEuropeAfricaIconJs);
var _handRaisedIconJs = require("./HandRaisedIcon.js");
var _handRaisedIconJsDefault = parcelHelpers.interopDefault(_handRaisedIconJs);
var _handThumbDownIconJs = require("./HandThumbDownIcon.js");
var _handThumbDownIconJsDefault = parcelHelpers.interopDefault(_handThumbDownIconJs);
var _handThumbUpIconJs = require("./HandThumbUpIcon.js");
var _handThumbUpIconJsDefault = parcelHelpers.interopDefault(_handThumbUpIconJs);
var _hashtagIconJs = require("./HashtagIcon.js");
var _hashtagIconJsDefault = parcelHelpers.interopDefault(_hashtagIconJs);
var _heartIconJs = require("./HeartIcon.js");
var _heartIconJsDefault = parcelHelpers.interopDefault(_heartIconJs);
var _homeModernIconJs = require("./HomeModernIcon.js");
var _homeModernIconJsDefault = parcelHelpers.interopDefault(_homeModernIconJs);
var _homeIconJs = require("./HomeIcon.js");
var _homeIconJsDefault = parcelHelpers.interopDefault(_homeIconJs);
var _identificationIconJs = require("./IdentificationIcon.js");
var _identificationIconJsDefault = parcelHelpers.interopDefault(_identificationIconJs);
var _inboxArrowDownIconJs = require("./InboxArrowDownIcon.js");
var _inboxArrowDownIconJsDefault = parcelHelpers.interopDefault(_inboxArrowDownIconJs);
var _inboxStackIconJs = require("./InboxStackIcon.js");
var _inboxStackIconJsDefault = parcelHelpers.interopDefault(_inboxStackIconJs);
var _inboxIconJs = require("./InboxIcon.js");
var _inboxIconJsDefault = parcelHelpers.interopDefault(_inboxIconJs);
var _informationCircleIconJs = require("./InformationCircleIcon.js");
var _informationCircleIconJsDefault = parcelHelpers.interopDefault(_informationCircleIconJs);
var _keyIconJs = require("./KeyIcon.js");
var _keyIconJsDefault = parcelHelpers.interopDefault(_keyIconJs);
var _languageIconJs = require("./LanguageIcon.js");
var _languageIconJsDefault = parcelHelpers.interopDefault(_languageIconJs);
var _lifebuoyIconJs = require("./LifebuoyIcon.js");
var _lifebuoyIconJsDefault = parcelHelpers.interopDefault(_lifebuoyIconJs);
var _lightBulbIconJs = require("./LightBulbIcon.js");
var _lightBulbIconJsDefault = parcelHelpers.interopDefault(_lightBulbIconJs);
var _linkIconJs = require("./LinkIcon.js");
var _linkIconJsDefault = parcelHelpers.interopDefault(_linkIconJs);
var _listBulletIconJs = require("./ListBulletIcon.js");
var _listBulletIconJsDefault = parcelHelpers.interopDefault(_listBulletIconJs);
var _lockClosedIconJs = require("./LockClosedIcon.js");
var _lockClosedIconJsDefault = parcelHelpers.interopDefault(_lockClosedIconJs);
var _lockOpenIconJs = require("./LockOpenIcon.js");
var _lockOpenIconJsDefault = parcelHelpers.interopDefault(_lockOpenIconJs);
var _magnifyingGlassCircleIconJs = require("./MagnifyingGlassCircleIcon.js");
var _magnifyingGlassCircleIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassCircleIconJs);
var _magnifyingGlassMinusIconJs = require("./MagnifyingGlassMinusIcon.js");
var _magnifyingGlassMinusIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassMinusIconJs);
var _magnifyingGlassPlusIconJs = require("./MagnifyingGlassPlusIcon.js");
var _magnifyingGlassPlusIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassPlusIconJs);
var _magnifyingGlassIconJs = require("./MagnifyingGlassIcon.js");
var _magnifyingGlassIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassIconJs);
var _mapPinIconJs = require("./MapPinIcon.js");
var _mapPinIconJsDefault = parcelHelpers.interopDefault(_mapPinIconJs);
var _mapIconJs = require("./MapIcon.js");
var _mapIconJsDefault = parcelHelpers.interopDefault(_mapIconJs);
var _megaphoneIconJs = require("./MegaphoneIcon.js");
var _megaphoneIconJsDefault = parcelHelpers.interopDefault(_megaphoneIconJs);
var _microphoneIconJs = require("./MicrophoneIcon.js");
var _microphoneIconJsDefault = parcelHelpers.interopDefault(_microphoneIconJs);
var _minusCircleIconJs = require("./MinusCircleIcon.js");
var _minusCircleIconJsDefault = parcelHelpers.interopDefault(_minusCircleIconJs);
var _minusSmallIconJs = require("./MinusSmallIcon.js");
var _minusSmallIconJsDefault = parcelHelpers.interopDefault(_minusSmallIconJs);
var _minusIconJs = require("./MinusIcon.js");
var _minusIconJsDefault = parcelHelpers.interopDefault(_minusIconJs);
var _moonIconJs = require("./MoonIcon.js");
var _moonIconJsDefault = parcelHelpers.interopDefault(_moonIconJs);
var _musicalNoteIconJs = require("./MusicalNoteIcon.js");
var _musicalNoteIconJsDefault = parcelHelpers.interopDefault(_musicalNoteIconJs);
var _newspaperIconJs = require("./NewspaperIcon.js");
var _newspaperIconJsDefault = parcelHelpers.interopDefault(_newspaperIconJs);
var _noSymbolIconJs = require("./NoSymbolIcon.js");
var _noSymbolIconJsDefault = parcelHelpers.interopDefault(_noSymbolIconJs);
var _paintBrushIconJs = require("./PaintBrushIcon.js");
var _paintBrushIconJsDefault = parcelHelpers.interopDefault(_paintBrushIconJs);
var _paperAirplaneIconJs = require("./PaperAirplaneIcon.js");
var _paperAirplaneIconJsDefault = parcelHelpers.interopDefault(_paperAirplaneIconJs);
var _paperClipIconJs = require("./PaperClipIcon.js");
var _paperClipIconJsDefault = parcelHelpers.interopDefault(_paperClipIconJs);
var _pauseCircleIconJs = require("./PauseCircleIcon.js");
var _pauseCircleIconJsDefault = parcelHelpers.interopDefault(_pauseCircleIconJs);
var _pauseIconJs = require("./PauseIcon.js");
var _pauseIconJsDefault = parcelHelpers.interopDefault(_pauseIconJs);
var _pencilSquareIconJs = require("./PencilSquareIcon.js");
var _pencilSquareIconJsDefault = parcelHelpers.interopDefault(_pencilSquareIconJs);
var _pencilIconJs = require("./PencilIcon.js");
var _pencilIconJsDefault = parcelHelpers.interopDefault(_pencilIconJs);
var _phoneArrowDownLeftIconJs = require("./PhoneArrowDownLeftIcon.js");
var _phoneArrowDownLeftIconJsDefault = parcelHelpers.interopDefault(_phoneArrowDownLeftIconJs);
var _phoneArrowUpRightIconJs = require("./PhoneArrowUpRightIcon.js");
var _phoneArrowUpRightIconJsDefault = parcelHelpers.interopDefault(_phoneArrowUpRightIconJs);
var _phoneXMarkIconJs = require("./PhoneXMarkIcon.js");
var _phoneXMarkIconJsDefault = parcelHelpers.interopDefault(_phoneXMarkIconJs);
var _phoneIconJs = require("./PhoneIcon.js");
var _phoneIconJsDefault = parcelHelpers.interopDefault(_phoneIconJs);
var _photoIconJs = require("./PhotoIcon.js");
var _photoIconJsDefault = parcelHelpers.interopDefault(_photoIconJs);
var _playCircleIconJs = require("./PlayCircleIcon.js");
var _playCircleIconJsDefault = parcelHelpers.interopDefault(_playCircleIconJs);
var _playPauseIconJs = require("./PlayPauseIcon.js");
var _playPauseIconJsDefault = parcelHelpers.interopDefault(_playPauseIconJs);
var _playIconJs = require("./PlayIcon.js");
var _playIconJsDefault = parcelHelpers.interopDefault(_playIconJs);
var _plusCircleIconJs = require("./PlusCircleIcon.js");
var _plusCircleIconJsDefault = parcelHelpers.interopDefault(_plusCircleIconJs);
var _plusSmallIconJs = require("./PlusSmallIcon.js");
var _plusSmallIconJsDefault = parcelHelpers.interopDefault(_plusSmallIconJs);
var _plusIconJs = require("./PlusIcon.js");
var _plusIconJsDefault = parcelHelpers.interopDefault(_plusIconJs);
var _powerIconJs = require("./PowerIcon.js");
var _powerIconJsDefault = parcelHelpers.interopDefault(_powerIconJs);
var _presentationChartBarIconJs = require("./PresentationChartBarIcon.js");
var _presentationChartBarIconJsDefault = parcelHelpers.interopDefault(_presentationChartBarIconJs);
var _presentationChartLineIconJs = require("./PresentationChartLineIcon.js");
var _presentationChartLineIconJsDefault = parcelHelpers.interopDefault(_presentationChartLineIconJs);
var _printerIconJs = require("./PrinterIcon.js");
var _printerIconJsDefault = parcelHelpers.interopDefault(_printerIconJs);
var _puzzlePieceIconJs = require("./PuzzlePieceIcon.js");
var _puzzlePieceIconJsDefault = parcelHelpers.interopDefault(_puzzlePieceIconJs);
var _qrCodeIconJs = require("./QrCodeIcon.js");
var _qrCodeIconJsDefault = parcelHelpers.interopDefault(_qrCodeIconJs);
var _questionMarkCircleIconJs = require("./QuestionMarkCircleIcon.js");
var _questionMarkCircleIconJsDefault = parcelHelpers.interopDefault(_questionMarkCircleIconJs);
var _queueListIconJs = require("./QueueListIcon.js");
var _queueListIconJsDefault = parcelHelpers.interopDefault(_queueListIconJs);
var _radioIconJs = require("./RadioIcon.js");
var _radioIconJsDefault = parcelHelpers.interopDefault(_radioIconJs);
var _receiptPercentIconJs = require("./ReceiptPercentIcon.js");
var _receiptPercentIconJsDefault = parcelHelpers.interopDefault(_receiptPercentIconJs);
var _receiptRefundIconJs = require("./ReceiptRefundIcon.js");
var _receiptRefundIconJsDefault = parcelHelpers.interopDefault(_receiptRefundIconJs);
var _rectangleGroupIconJs = require("./RectangleGroupIcon.js");
var _rectangleGroupIconJsDefault = parcelHelpers.interopDefault(_rectangleGroupIconJs);
var _rectangleStackIconJs = require("./RectangleStackIcon.js");
var _rectangleStackIconJsDefault = parcelHelpers.interopDefault(_rectangleStackIconJs);
var _rocketLaunchIconJs = require("./RocketLaunchIcon.js");
var _rocketLaunchIconJsDefault = parcelHelpers.interopDefault(_rocketLaunchIconJs);
var _rssIconJs = require("./RssIcon.js");
var _rssIconJsDefault = parcelHelpers.interopDefault(_rssIconJs);
var _scaleIconJs = require("./ScaleIcon.js");
var _scaleIconJsDefault = parcelHelpers.interopDefault(_scaleIconJs);
var _scissorsIconJs = require("./ScissorsIcon.js");
var _scissorsIconJsDefault = parcelHelpers.interopDefault(_scissorsIconJs);
var _serverStackIconJs = require("./ServerStackIcon.js");
var _serverStackIconJsDefault = parcelHelpers.interopDefault(_serverStackIconJs);
var _serverIconJs = require("./ServerIcon.js");
var _serverIconJsDefault = parcelHelpers.interopDefault(_serverIconJs);
var _shareIconJs = require("./ShareIcon.js");
var _shareIconJsDefault = parcelHelpers.interopDefault(_shareIconJs);
var _shieldCheckIconJs = require("./ShieldCheckIcon.js");
var _shieldCheckIconJsDefault = parcelHelpers.interopDefault(_shieldCheckIconJs);
var _shieldExclamationIconJs = require("./ShieldExclamationIcon.js");
var _shieldExclamationIconJsDefault = parcelHelpers.interopDefault(_shieldExclamationIconJs);
var _shoppingBagIconJs = require("./ShoppingBagIcon.js");
var _shoppingBagIconJsDefault = parcelHelpers.interopDefault(_shoppingBagIconJs);
var _shoppingCartIconJs = require("./ShoppingCartIcon.js");
var _shoppingCartIconJsDefault = parcelHelpers.interopDefault(_shoppingCartIconJs);
var _signalSlashIconJs = require("./SignalSlashIcon.js");
var _signalSlashIconJsDefault = parcelHelpers.interopDefault(_signalSlashIconJs);
var _signalIconJs = require("./SignalIcon.js");
var _signalIconJsDefault = parcelHelpers.interopDefault(_signalIconJs);
var _sparklesIconJs = require("./SparklesIcon.js");
var _sparklesIconJsDefault = parcelHelpers.interopDefault(_sparklesIconJs);
var _speakerWaveIconJs = require("./SpeakerWaveIcon.js");
var _speakerWaveIconJsDefault = parcelHelpers.interopDefault(_speakerWaveIconJs);
var _speakerXMarkIconJs = require("./SpeakerXMarkIcon.js");
var _speakerXMarkIconJsDefault = parcelHelpers.interopDefault(_speakerXMarkIconJs);
var _square2StackIconJs = require("./Square2StackIcon.js");
var _square2StackIconJsDefault = parcelHelpers.interopDefault(_square2StackIconJs);
var _square3Stack3DIconJs = require("./Square3Stack3DIcon.js");
var _square3Stack3DIconJsDefault = parcelHelpers.interopDefault(_square3Stack3DIconJs);
var _squares2X2IconJs = require("./Squares2X2Icon.js");
var _squares2X2IconJsDefault = parcelHelpers.interopDefault(_squares2X2IconJs);
var _squaresPlusIconJs = require("./SquaresPlusIcon.js");
var _squaresPlusIconJsDefault = parcelHelpers.interopDefault(_squaresPlusIconJs);
var _starIconJs = require("./StarIcon.js");
var _starIconJsDefault = parcelHelpers.interopDefault(_starIconJs);
var _stopCircleIconJs = require("./StopCircleIcon.js");
var _stopCircleIconJsDefault = parcelHelpers.interopDefault(_stopCircleIconJs);
var _stopIconJs = require("./StopIcon.js");
var _stopIconJsDefault = parcelHelpers.interopDefault(_stopIconJs);
var _sunIconJs = require("./SunIcon.js");
var _sunIconJsDefault = parcelHelpers.interopDefault(_sunIconJs);
var _swatchIconJs = require("./SwatchIcon.js");
var _swatchIconJsDefault = parcelHelpers.interopDefault(_swatchIconJs);
var _tableCellsIconJs = require("./TableCellsIcon.js");
var _tableCellsIconJsDefault = parcelHelpers.interopDefault(_tableCellsIconJs);
var _tagIconJs = require("./TagIcon.js");
var _tagIconJsDefault = parcelHelpers.interopDefault(_tagIconJs);
var _ticketIconJs = require("./TicketIcon.js");
var _ticketIconJsDefault = parcelHelpers.interopDefault(_ticketIconJs);
var _trashIconJs = require("./TrashIcon.js");
var _trashIconJsDefault = parcelHelpers.interopDefault(_trashIconJs);
var _trophyIconJs = require("./TrophyIcon.js");
var _trophyIconJsDefault = parcelHelpers.interopDefault(_trophyIconJs);
var _truckIconJs = require("./TruckIcon.js");
var _truckIconJsDefault = parcelHelpers.interopDefault(_truckIconJs);
var _tvIconJs = require("./TvIcon.js");
var _tvIconJsDefault = parcelHelpers.interopDefault(_tvIconJs);
var _userCircleIconJs = require("./UserCircleIcon.js");
var _userCircleIconJsDefault = parcelHelpers.interopDefault(_userCircleIconJs);
var _userGroupIconJs = require("./UserGroupIcon.js");
var _userGroupIconJsDefault = parcelHelpers.interopDefault(_userGroupIconJs);
var _userMinusIconJs = require("./UserMinusIcon.js");
var _userMinusIconJsDefault = parcelHelpers.interopDefault(_userMinusIconJs);
var _userPlusIconJs = require("./UserPlusIcon.js");
var _userPlusIconJsDefault = parcelHelpers.interopDefault(_userPlusIconJs);
var _userIconJs = require("./UserIcon.js");
var _userIconJsDefault = parcelHelpers.interopDefault(_userIconJs);
var _usersIconJs = require("./UsersIcon.js");
var _usersIconJsDefault = parcelHelpers.interopDefault(_usersIconJs);
var _variableIconJs = require("./VariableIcon.js");
var _variableIconJsDefault = parcelHelpers.interopDefault(_variableIconJs);
var _videoCameraSlashIconJs = require("./VideoCameraSlashIcon.js");
var _videoCameraSlashIconJsDefault = parcelHelpers.interopDefault(_videoCameraSlashIconJs);
var _videoCameraIconJs = require("./VideoCameraIcon.js");
var _videoCameraIconJsDefault = parcelHelpers.interopDefault(_videoCameraIconJs);
var _viewColumnsIconJs = require("./ViewColumnsIcon.js");
var _viewColumnsIconJsDefault = parcelHelpers.interopDefault(_viewColumnsIconJs);
var _viewfinderCircleIconJs = require("./ViewfinderCircleIcon.js");
var _viewfinderCircleIconJsDefault = parcelHelpers.interopDefault(_viewfinderCircleIconJs);
var _walletIconJs = require("./WalletIcon.js");
var _walletIconJsDefault = parcelHelpers.interopDefault(_walletIconJs);
var _wifiIconJs = require("./WifiIcon.js");
var _wifiIconJsDefault = parcelHelpers.interopDefault(_wifiIconJs);
var _windowIconJs = require("./WindowIcon.js");
var _windowIconJsDefault = parcelHelpers.interopDefault(_windowIconJs);
var _wrenchScrewdriverIconJs = require("./WrenchScrewdriverIcon.js");
var _wrenchScrewdriverIconJsDefault = parcelHelpers.interopDefault(_wrenchScrewdriverIconJs);
var _wrenchIconJs = require("./WrenchIcon.js");
var _wrenchIconJsDefault = parcelHelpers.interopDefault(_wrenchIconJs);
var _xcircleIconJs = require("./XCircleIcon.js");
var _xcircleIconJsDefault = parcelHelpers.interopDefault(_xcircleIconJs);
var _xmarkIconJs = require("./XMarkIcon.js");
var _xmarkIconJsDefault = parcelHelpers.interopDefault(_xmarkIconJs);

},{"./AcademicCapIcon.js":false,"./AdjustmentsHorizontalIcon.js":false,"./AdjustmentsVerticalIcon.js":false,"./ArchiveBoxArrowDownIcon.js":false,"./ArchiveBoxXMarkIcon.js":false,"./ArchiveBoxIcon.js":false,"./ArrowDownCircleIcon.js":false,"./ArrowDownLeftIcon.js":false,"./ArrowDownOnSquareStackIcon.js":false,"./ArrowDownOnSquareIcon.js":false,"./ArrowDownRightIcon.js":false,"./ArrowDownTrayIcon.js":false,"./ArrowDownIcon.js":false,"./ArrowLeftCircleIcon.js":false,"./ArrowLeftEndOnRectangleIcon.js":false,"./ArrowLeftOnRectangleIcon.js":false,"./ArrowLeftStartOnRectangleIcon.js":false,"./ArrowLeftIcon.js":false,"./ArrowLongDownIcon.js":false,"./ArrowLongLeftIcon.js":false,"./ArrowLongRightIcon.js":false,"./ArrowLongUpIcon.js":false,"./ArrowPathRoundedSquareIcon.js":false,"./ArrowPathIcon.js":"ePXHP","./ArrowRightCircleIcon.js":false,"./ArrowRightEndOnRectangleIcon.js":false,"./ArrowRightOnRectangleIcon.js":false,"./ArrowRightStartOnRectangleIcon.js":false,"./ArrowRightIcon.js":false,"./ArrowSmallDownIcon.js":false,"./ArrowSmallLeftIcon.js":false,"./ArrowSmallRightIcon.js":false,"./ArrowSmallUpIcon.js":false,"./ArrowTopRightOnSquareIcon.js":false,"./ArrowTrendingDownIcon.js":false,"./ArrowTrendingUpIcon.js":false,"./ArrowUpCircleIcon.js":false,"./ArrowUpLeftIcon.js":false,"./ArrowUpOnSquareStackIcon.js":false,"./ArrowUpOnSquareIcon.js":false,"./ArrowUpRightIcon.js":false,"./ArrowUpTrayIcon.js":false,"./ArrowUpIcon.js":false,"./ArrowUturnDownIcon.js":false,"./ArrowUturnLeftIcon.js":false,"./ArrowUturnRightIcon.js":false,"./ArrowUturnUpIcon.js":false,"./ArrowsPointingInIcon.js":false,"./ArrowsPointingOutIcon.js":false,"./ArrowsRightLeftIcon.js":false,"./ArrowsUpDownIcon.js":false,"./AtSymbolIcon.js":false,"./BackspaceIcon.js":false,"./BackwardIcon.js":false,"./BanknotesIcon.js":false,"./Bars2Icon.js":false,"./Bars3BottomLeftIcon.js":false,"./Bars3BottomRightIcon.js":false,"./Bars3CenterLeftIcon.js":false,"./Bars3Icon.js":false,"./Bars4Icon.js":false,"./BarsArrowDownIcon.js":false,"./BarsArrowUpIcon.js":false,"./Battery0Icon.js":false,"./Battery100Icon.js":false,"./Battery50Icon.js":false,"./BeakerIcon.js":false,"./BellAlertIcon.js":false,"./BellSlashIcon.js":false,"./BellSnoozeIcon.js":false,"./BellIcon.js":false,"./BoltSlashIcon.js":false,"./BoltIcon.js":false,"./BookOpenIcon.js":false,"./BookmarkSlashIcon.js":false,"./BookmarkSquareIcon.js":false,"./BookmarkIcon.js":false,"./BriefcaseIcon.js":false,"./BugAntIcon.js":false,"./BuildingLibraryIcon.js":false,"./BuildingOffice2Icon.js":false,"./BuildingOfficeIcon.js":false,"./BuildingStorefrontIcon.js":false,"./CakeIcon.js":false,"./CalculatorIcon.js":false,"./CalendarDaysIcon.js":false,"./CalendarIcon.js":false,"./CameraIcon.js":false,"./ChartBarSquareIcon.js":false,"./ChartBarIcon.js":false,"./ChartPieIcon.js":false,"./ChatBubbleBottomCenterTextIcon.js":false,"./ChatBubbleBottomCenterIcon.js":false,"./ChatBubbleLeftEllipsisIcon.js":false,"./ChatBubbleLeftRightIcon.js":false,"./ChatBubbleLeftIcon.js":false,"./ChatBubbleOvalLeftEllipsisIcon.js":false,"./ChatBubbleOvalLeftIcon.js":false,"./CheckBadgeIcon.js":false,"./CheckCircleIcon.js":false,"./CheckIcon.js":"6kMbN","./ChevronDoubleDownIcon.js":false,"./ChevronDoubleLeftIcon.js":false,"./ChevronDoubleRightIcon.js":false,"./ChevronDoubleUpIcon.js":false,"./ChevronDownIcon.js":false,"./ChevronLeftIcon.js":false,"./ChevronRightIcon.js":false,"./ChevronUpDownIcon.js":false,"./ChevronUpIcon.js":false,"./CircleStackIcon.js":false,"./ClipboardDocumentCheckIcon.js":false,"./ClipboardDocumentListIcon.js":false,"./ClipboardDocumentIcon.js":false,"./ClipboardIcon.js":false,"./ClockIcon.js":false,"./CloudArrowDownIcon.js":false,"./CloudArrowUpIcon.js":false,"./CloudIcon.js":false,"./CodeBracketSquareIcon.js":false,"./CodeBracketIcon.js":false,"./Cog6ToothIcon.js":false,"./Cog8ToothIcon.js":false,"./CogIcon.js":false,"./CommandLineIcon.js":false,"./ComputerDesktopIcon.js":false,"./CpuChipIcon.js":false,"./CreditCardIcon.js":false,"./CubeTransparentIcon.js":false,"./CubeIcon.js":false,"./CurrencyBangladeshiIcon.js":false,"./CurrencyDollarIcon.js":false,"./CurrencyEuroIcon.js":false,"./CurrencyPoundIcon.js":false,"./CurrencyRupeeIcon.js":false,"./CurrencyYenIcon.js":false,"./CursorArrowRaysIcon.js":false,"./CursorArrowRippleIcon.js":false,"./DevicePhoneMobileIcon.js":false,"./DeviceTabletIcon.js":false,"./DocumentArrowDownIcon.js":false,"./DocumentArrowUpIcon.js":false,"./DocumentChartBarIcon.js":false,"./DocumentCheckIcon.js":false,"./DocumentDuplicateIcon.js":false,"./DocumentMagnifyingGlassIcon.js":false,"./DocumentMinusIcon.js":false,"./DocumentPlusIcon.js":false,"./DocumentTextIcon.js":false,"./DocumentIcon.js":false,"./EllipsisHorizontalCircleIcon.js":false,"./EllipsisHorizontalIcon.js":false,"./EllipsisVerticalIcon.js":false,"./EnvelopeOpenIcon.js":false,"./EnvelopeIcon.js":false,"./ExclamationCircleIcon.js":false,"./ExclamationTriangleIcon.js":"lJPYs","./EyeDropperIcon.js":false,"./EyeSlashIcon.js":false,"./EyeIcon.js":false,"./FaceFrownIcon.js":false,"./FaceSmileIcon.js":false,"./FilmIcon.js":false,"./FingerPrintIcon.js":false,"./FireIcon.js":false,"./FlagIcon.js":false,"./FolderArrowDownIcon.js":false,"./FolderMinusIcon.js":false,"./FolderOpenIcon.js":false,"./FolderPlusIcon.js":false,"./FolderIcon.js":false,"./ForwardIcon.js":false,"./FunnelIcon.js":false,"./GifIcon.js":false,"./GiftTopIcon.js":false,"./GiftIcon.js":false,"./GlobeAltIcon.js":false,"./GlobeAmericasIcon.js":false,"./GlobeAsiaAustraliaIcon.js":false,"./GlobeEuropeAfricaIcon.js":false,"./HandRaisedIcon.js":false,"./HandThumbDownIcon.js":false,"./HandThumbUpIcon.js":false,"./HashtagIcon.js":false,"./HeartIcon.js":false,"./HomeModernIcon.js":false,"./HomeIcon.js":false,"./IdentificationIcon.js":false,"./InboxArrowDownIcon.js":false,"./InboxStackIcon.js":false,"./InboxIcon.js":false,"./InformationCircleIcon.js":false,"./KeyIcon.js":false,"./LanguageIcon.js":false,"./LifebuoyIcon.js":false,"./LightBulbIcon.js":false,"./LinkIcon.js":false,"./ListBulletIcon.js":false,"./LockClosedIcon.js":false,"./LockOpenIcon.js":false,"./MagnifyingGlassCircleIcon.js":false,"./MagnifyingGlassMinusIcon.js":false,"./MagnifyingGlassPlusIcon.js":false,"./MagnifyingGlassIcon.js":false,"./MapPinIcon.js":false,"./MapIcon.js":false,"./MegaphoneIcon.js":false,"./MicrophoneIcon.js":false,"./MinusCircleIcon.js":false,"./MinusSmallIcon.js":false,"./MinusIcon.js":false,"./MoonIcon.js":false,"./MusicalNoteIcon.js":false,"./NewspaperIcon.js":false,"./NoSymbolIcon.js":false,"./PaintBrushIcon.js":false,"./PaperAirplaneIcon.js":false,"./PaperClipIcon.js":false,"./PauseCircleIcon.js":false,"./PauseIcon.js":false,"./PencilSquareIcon.js":false,"./PencilIcon.js":false,"./PhoneArrowDownLeftIcon.js":false,"./PhoneArrowUpRightIcon.js":false,"./PhoneXMarkIcon.js":false,"./PhoneIcon.js":false,"./PhotoIcon.js":false,"./PlayCircleIcon.js":false,"./PlayPauseIcon.js":false,"./PlayIcon.js":false,"./PlusCircleIcon.js":false,"./PlusSmallIcon.js":false,"./PlusIcon.js":false,"./PowerIcon.js":false,"./PresentationChartBarIcon.js":false,"./PresentationChartLineIcon.js":false,"./PrinterIcon.js":false,"./PuzzlePieceIcon.js":false,"./QrCodeIcon.js":false,"./QuestionMarkCircleIcon.js":false,"./QueueListIcon.js":false,"./RadioIcon.js":false,"./ReceiptPercentIcon.js":false,"./ReceiptRefundIcon.js":false,"./RectangleGroupIcon.js":false,"./RectangleStackIcon.js":false,"./RocketLaunchIcon.js":false,"./RssIcon.js":false,"./ScaleIcon.js":false,"./ScissorsIcon.js":false,"./ServerStackIcon.js":false,"./ServerIcon.js":false,"./ShareIcon.js":false,"./ShieldCheckIcon.js":false,"./ShieldExclamationIcon.js":false,"./ShoppingBagIcon.js":false,"./ShoppingCartIcon.js":false,"./SignalSlashIcon.js":false,"./SignalIcon.js":false,"./SparklesIcon.js":false,"./SpeakerWaveIcon.js":false,"./SpeakerXMarkIcon.js":false,"./Square2StackIcon.js":false,"./Square3Stack3DIcon.js":false,"./Squares2X2Icon.js":false,"./SquaresPlusIcon.js":false,"./StarIcon.js":false,"./StopCircleIcon.js":false,"./StopIcon.js":false,"./SunIcon.js":false,"./SwatchIcon.js":false,"./TableCellsIcon.js":false,"./TagIcon.js":false,"./TicketIcon.js":false,"./TrashIcon.js":false,"./TrophyIcon.js":false,"./TruckIcon.js":false,"./TvIcon.js":false,"./UserCircleIcon.js":false,"./UserGroupIcon.js":false,"./UserMinusIcon.js":false,"./UserPlusIcon.js":false,"./UserIcon.js":false,"./UsersIcon.js":false,"./VariableIcon.js":false,"./VideoCameraSlashIcon.js":false,"./VideoCameraIcon.js":false,"./ViewColumnsIcon.js":false,"./ViewfinderCircleIcon.js":false,"./WalletIcon.js":false,"./WifiIcon.js":false,"./WindowIcon.js":false,"./WrenchScrewdriverIcon.js":false,"./WrenchIcon.js":false,"./XCircleIcon.js":false,"./XMarkIcon.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ePXHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function ArrowPathIcon({ title, titleId, ...props }, svgRef) {
    return /*#__PURE__*/ _react.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ _react.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ _react.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const ForwardRef = _react.forwardRef(ArrowPathIcon);
exports.default = ForwardRef;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6kMbN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function CheckIcon({ title, titleId, ...props }, svgRef) {
    return /*#__PURE__*/ _react.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ _react.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ _react.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 12.75 6 6 9-13.5"
    }));
}
const ForwardRef = _react.forwardRef(CheckIcon);
exports.default = ForwardRef;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJPYs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function ExclamationTriangleIcon({ title, titleId, ...props }, svgRef) {
    return /*#__PURE__*/ _react.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ _react.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ _react.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    }));
}
const ForwardRef = _react.forwardRef(ExclamationTriangleIcon);
exports.default = ForwardRef;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d6i6L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBeats", ()=>useBeats);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sdkNetwork = require("@vechain/sdk-network");
var _sdkCore = require("@vechain/sdk-core");
var _reactUseWebsocket = require("react-use-websocket");
var _reactUseWebsocketDefault = parcelHelpers.interopDefault(_reactUseWebsocket);
const DELAY = 100;
/**
 * Subscribe to blockchain updates and filter them based on provided addresses, transactions or data.
 *
 * @param {string[]} addressesOrData - An array of addresses, transaction ids or data to filter the incoming beats.
 * @param {string} nodeUrl – Node to connect to
 * @returns {Beat | null} - The latest block that matches the filter criteria or null if no match is found.
 */ const useBeats = (addressesOrData, nodeUrl)=>{
    const [block, setBlock] = (0, _reactDefault.default).useState(null);
    const { lastJsonMessage } = (0, _reactUseWebsocketDefault.default)((0, _sdkNetwork.subscriptions).getBeatSubscriptionUrl(nodeUrl), {
        share: true,
        shouldReconnect: ()=>true
    });
    (0, _reactDefault.default).useEffect(()=>{
        try {
            const block = lastJsonMessage;
            if (addressesOrData.some((addressOrData)=>(0, _sdkCore.addressUtils).isAddress(addressOrData) ? (0, _sdkCore.bloomUtils).isAddressInBloom(block.bloom, block.k, addressOrData) : (0, _sdkCore.bloomUtils).isInBloom(block.bloom, block.k, addressOrData))) setTimeout(()=>setBlock(block), DELAY);
        } catch  {
        /* ignore */ }
    }, [
        lastJsonMessage
    ]);
    return block;
};

},{"react":"6uln9","@vechain/sdk-network":"gOvnG","@vechain/sdk-core":"iZmwY","react-use-websocket":"01YnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOvnG":[function(require,module,exports) {
var Buffer = require("945cf3902c7f9ddc").Buffer;
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var src_exports = {};
__export(src_exports, {
    AccountsModule: ()=>AccountsModule,
    BlocksModule: ()=>BlocksModule,
    Contract: ()=>Contract,
    ContractFactory: ()=>ContractFactory,
    ContractsModule: ()=>ContractsModule,
    DEFAULT_HTTP_TIMEOUT: ()=>DEFAULT_HTTP_TIMEOUT,
    DelegationHandler: ()=>DelegationHandler,
    HTTPS_REGEX: ()=>HTTPS_REGEX,
    HTTP_REGEX: ()=>HTTP_REGEX,
    HttpClient: ()=>HttpClient,
    LogsModule: ()=>LogsModule,
    NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS: ()=>NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS,
    NodesModule: ()=>NodesModule,
    Poll: ()=>Poll,
    ThorClient: ()=>ThorClient,
    TransactionsModule: ()=>TransactionsModule,
    buildQuery: ()=>buildQuery,
    convertError: ()=>convertError,
    network: ()=>network_exports,
    sanitizeWebsocketBaseURL: ()=>sanitizeWebsocketBaseURL,
    subscriptions: ()=>subscriptions,
    thorest: ()=>thorest,
    toQueryString: ()=>toQueryString
});
module.exports = __toCommonJS(src_exports);
// src/network.ts
var network_exports = {};
__export(network_exports, {
    AccountsModule: ()=>AccountsModule,
    BlocksModule: ()=>BlocksModule,
    Contract: ()=>Contract,
    ContractFactory: ()=>ContractFactory,
    ContractsModule: ()=>ContractsModule,
    DEFAULT_HTTP_TIMEOUT: ()=>DEFAULT_HTTP_TIMEOUT,
    DelegationHandler: ()=>DelegationHandler,
    HTTPS_REGEX: ()=>HTTPS_REGEX,
    HTTP_REGEX: ()=>HTTP_REGEX,
    HttpClient: ()=>HttpClient,
    LogsModule: ()=>LogsModule,
    NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS: ()=>NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS,
    NodesModule: ()=>NodesModule,
    Poll: ()=>Poll,
    ThorClient: ()=>ThorClient,
    TransactionsModule: ()=>TransactionsModule,
    buildQuery: ()=>buildQuery,
    convertError: ()=>convertError,
    sanitizeWebsocketBaseURL: ()=>sanitizeWebsocketBaseURL,
    subscriptions: ()=>subscriptions,
    thorest: ()=>thorest,
    toQueryString: ()=>toQueryString
});
// src/thor-client/accounts/accounts-module.ts
var import_sdk_errors7 = require("63526d60e0d88131");
// src/utils/const/client/http-client.ts
var DEFAULT_HTTP_TIMEOUT = 3e4;
var HTTP_REGEX = /^http:\/\//;
var HTTPS_REGEX = /^https:\/\//;
// src/utils/const/client/nodes.ts
var NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS = 30;
// src/utils/helpers/errors.ts
var import_sdk_errors = require("63526d60e0d88131");
var convertError = (error)=>{
    if (error.response != null) {
        const resp = error.response;
        return (0, import_sdk_errors.buildError)("convertError", import_sdk_errors.HTTP_CLIENT.INVALID_HTTP_REQUEST, `An error occurred while performing http request ${error.config?.url}`, {
            status: resp.status,
            method: error.config?.method,
            url: error.config?.url,
            text: (0, import_sdk_errors.stringifyData)(resp.data)
        });
    } else return (0, import_sdk_errors.buildError)("convertError", import_sdk_errors.HTTP_CLIENT.INVALID_HTTP_REQUEST, `An error occurred while performing http request ${error.config?.url}`, {
        method: error.config?.method,
        url: error.config?.url,
        message: error.message
    });
};
// src/utils/helpers/request.ts
var buildQuery = (params)=>{
    const definedParams = {};
    for(const key in params)if (params[key] !== void 0) definedParams[key] = params[key];
    return definedParams;
};
// src/utils/http/http-client.ts
var import_axios = __toESM(require("89dcae773b8495f"));
var import_http = require("a8c4b18217c6ab44");
var import_https = require("9d721ee24bf3b50b");
var import_sdk_errors2 = require("63526d60e0d88131");
var HttpClient = class {
    /**
   * Instantiates an `HttpClient` object with a specified base URL and HTTP request timeout.
   *
   * @param baseURL - The base URL for all network requests.
   * @param options - (Optional) An object containing additional configuration options for the HTTP client, such as a custom Axios instance and a request timeout.
   */ constructor(baseURL, options){
        this.baseURL = baseURL;
        this.axios = options?.axiosInstance ?? import_axios.default.create({
            httpAgent: new import_http.Agent({
                keepAlive: false
            }),
            httpsAgent: new import_https.Agent({
                keepAlive: false
            }),
            baseURL,
            timeout: options?.timeout ?? DEFAULT_HTTP_TIMEOUT
        });
    }
    /**
   * Axios instance to make http requests
   */ axios;
    /**
   * Sends an HTTP request using the Axios library.
   *
   * @param method - The HTTP method to be used ('GET' or 'POST').
   * @param path - The path to access on the server relative to the base URL.
   * @param params - (Optional) Additional request parameters such as query parameters, request body, and custom headers.
   * @returns A promise that resolves to the response data from the HTTP request.
   * @throws {HTTPClientError} Will throw an error if the request fails, with more detailed information if the error is Axios-specific.
   */ async http(method, path, params) {
        const config = {
            method,
            url: path,
            data: params?.body,
            headers: params?.headers,
            params: params?.query
        };
        try {
            const resp = await this.axios(config);
            this.validateResponseHeader(params, resp.headers);
            return resp.data;
        } catch (err) {
            if (import_axios.default.isAxiosError(err)) throw convertError(err);
            throw (0, import_sdk_errors2.buildError)("http", import_sdk_errors2.HTTP_CLIENT.INVALID_HTTP_REQUEST, "HTTP request failed: Check method, path, and parameters for validity.", {
                method,
                path,
                params
            }, err);
        }
    }
    /**
   * Validates the response headers if a validation function is provided.
   *
   * @param params - (Optional) The request parameters.
   * @param headers - The response headers.
   */ validateResponseHeader(params, headers) {
        if (params?.validateResponseHeader != null && headers != null) {
            const responseHeaders = {};
            for(const key in headers){
                const value = headers[key];
                if (typeof value === "string") responseHeaders[key] = value;
            }
            params.validateResponseHeader(responseHeaders);
        }
    }
};
// src/utils/poll/sync.ts
var import_sdk_errors4 = require("63526d60e0d88131");
// src/utils/poll/helpers/assertions.ts
var import_sdk_errors3 = require("63526d60e0d88131");
function assertPositiveIntegerForPollOptions(methodName, field, fieldName) {
    (0, import_sdk_errors3.assert)(`assertPositiveIntegerForPollOptions - ${methodName}`, field === void 0 || field > 0 && Number.isInteger(field), import_sdk_errors3.DATA.INVALID_DATA_TYPE, `Invalid input for field name. ${fieldName} must be a positive number`, {
        field
    });
}
// src/utils/poll/sync.ts
async function sleep(delayInMilliseconds) {
    await new Promise((resolve)=>setTimeout(resolve, delayInMilliseconds));
}
function SyncPoll(pollingFunction, options) {
    assertPositiveIntegerForPollOptions("SyncPoll", options?.requestIntervalInMilliseconds, "options?.requestIntervalInMilliseconds");
    assertPositiveIntegerForPollOptions("SyncPoll", options?.maximumIterations, "options?.maximumIterations");
    assertPositiveIntegerForPollOptions("SyncPoll", options?.maximumWaitingTimeInMilliseconds, "options?.maximumWaitingTimeInMilliseconds");
    let currentIteration = 0;
    let currentResult;
    let pollingCondition = false;
    const startTime = Date.now();
    return {
        /**
     * Poll until the condition is met.
     *
     * @param condition - The condition to be met.
     * @returns The result of the poll after the condition is met.
     */ waitUntil: async (condition)=>{
            try {
                do {
                    currentResult = await pollingFunction();
                    await sleep(options?.requestIntervalInMilliseconds !== void 0 ? options.requestIntervalInMilliseconds : 1e3);
                    currentIteration = currentIteration + 1;
                    const isConditionSatisfied = condition(currentResult);
                    const isMaximumIterationsReached = options?.maximumIterations !== void 0 ? currentIteration >= options.maximumIterations : false;
                    const isTimeLimitReached = options?.maximumWaitingTimeInMilliseconds !== void 0 && Date.now() - startTime >= options.maximumWaitingTimeInMilliseconds;
                    pollingCondition = !(isConditionSatisfied || isMaximumIterationsReached || isTimeLimitReached);
                }while (pollingCondition);
                return currentResult;
            } catch (error) {
                throw (0, import_sdk_errors4.buildError)("SyncPoll - waitUntil", import_sdk_errors4.POLL_ERROR.POLL_EXECUTION_ERROR, "Polling failed: Function execution error encountered during synchronous polling.", {
                    functionName: pollingFunction.name
                }, error);
            }
        }
    };
}
// src/utils/poll/event.ts
var import_events = require("38f82049a7859bb0");
var import_sdk_errors5 = require("63526d60e0d88131");
var EventPoll = class extends import_events.EventEmitter {
    /**
   * The current iteration. It counts how many iterations have been done.
   * This parameter is useful to know how many iterations have been done.
   * For example, it can be used to stop the poll after a certain number of iterations.
   */ currentIteration = 0;
    /**
   * Error thrown during the execution of the poll.
   */ error;
    /**
   * Indicates whether to stop execution on error of the
   * {@link _intervalLoop} function.
   *
   * @type {boolean}
   */ hasToStopOnError;
    /**
   * The interval used to poll.
   */ intervalId;
    /**
   * The function to be called.
   */ pollingFunction;
    /**
   * The interval of time (in milliseconds) between each request.
   */ requestIntervalInMilliseconds;
    /**
   * Constructor for creating an instance of EventPoll.
   *
   * @param {Function} pollingFunction - The function to be executed repeatedly.
   * @param {number} requestIntervalInMilliseconds - The interval in milliseconds between each execution of the polling function.
   * @param {boolean} [hasToStopOnError=true] - Indicates whether to stop polling if an error occurs.
   */ constructor(pollingFunction, requestIntervalInMilliseconds, hasToStopOnError){
        super();
        this.pollingFunction = pollingFunction;
        this.hasToStopOnError = hasToStopOnError;
        assertPositiveIntegerForPollOptions("EventPoll constructor", requestIntervalInMilliseconds, "requestIntervalInMilliseconds");
        this.requestIntervalInMilliseconds = requestIntervalInMilliseconds;
    }
    /**
   * Get how many iterations have been done.
   *
   * @returns The number of iterations.
   */ get getCurrentIteration() {
        return this.currentIteration;
    }
    /**
   * Basic interval loop function.
   * This function must be called into setInterval.
   * It calls the promise and emit the event.
   */ async _intervalLoop() {
        try {
            const data = await this.pollingFunction();
            this.emit("data", {
                data,
                eventPoll: this
            });
        } catch (error) {
            this.error = (0, import_sdk_errors5.buildError)("EventPoll - main interval loop function", import_sdk_errors5.POLL_ERROR.POLL_EXECUTION_ERROR, "Error during the execution of the poll", {
                message: error.message,
                functionName: this.pollingFunction.name
            });
            this.emit("error", {
                error: this.error
            });
            if (this.hasToStopOnError) this.stopListen();
        }
        this.currentIteration = this.currentIteration + 1;
    }
    /**
   * Listen to the 'data' event.
   * This method is the redefinition of the EventEmitter.on method.
   * Because the EventEmitter.on method does not allow to specify the type of the data.
   * And we must be type safe.
   *
   * This is equivalent to:
   *
   * ```typescript
   * eventPoll.on('data', (data) => { ... });
   * ```
   * @param onDataCallback - The callback to be called when the event is emitted.
   */ onData(onDataCallback) {
        this.on("data", (data)=>{
            onDataCallback(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data.data, // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data.eventPoll);
        });
        return this;
    }
    /* --- Overloaded of 'on' event emitter start --- */ /**
   * Listen to the 'error' event.
   * This method is the redefinition of the EventEmitter.on method.
   * Because the EventEmitter.on method does not allow to specify the type of the data.
   * And we must be type safe.
   *
   * This is equivalent to:
   *
   * ```typescript
   * eventPoll.on('error', (data) => { ... });
   * ```
   * @param onErrorCallback - The callback to be called when the event is emitted.
   */ onError(onErrorCallback) {
        this.on("error", (error)=>{
            onErrorCallback(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            error.error);
        });
        return this;
    }
    /**
   * Listen to the 'start' event.
   * This happens when the poll is stopped.
   *
   * @param onStartCallback - The callback to be called when the event is emitted.
   */ onStart(onStartCallback) {
        this.on("start", (data)=>{
            onStartCallback(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data.eventPoll);
        });
        return this;
    }
    /**
   * Listen to the 'stop' event.
   * This happens when the poll is stopped.
   *
   * @param onStopCallback - The callback to be called when the event is emitted.
   */ onStop(onStopCallback) {
        this.on("stop", (data)=>{
            onStopCallback(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            data.eventPoll);
        });
        return this;
    }
    /**
   * Start listening to the event.
   */ startListen() {
        this.emit("start", {
            eventPoll: this
        });
        this._intervalLoop().then(()=>{
            this.intervalId = setInterval(()=>{
                (async ()=>{
                    await this._intervalLoop();
                })();
            }, this.requestIntervalInMilliseconds);
        });
    }
    /**
   * Stop listening to the event.
   */ stopListen() {
        clearInterval(this.intervalId);
        this.emit("stop", {
            eventPoll: this
        });
    }
};
function createEventPoll(callBack, requestIntervalInMilliseconds, hasToStopOnError = true) {
    return new EventPoll(callBack, requestIntervalInMilliseconds, hasToStopOnError);
}
// src/utils/poll/index.ts
var Poll = {
    SyncPoll,
    createEventPoll
};
// src/utils/thorest/helpers.ts
var import_sdk_errors6 = require("63526d60e0d88131");
var toQueryString = (params)=>{
    const queryParts = Object.entries(params).filter(([, value])=>value !== void 0).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
};
var sanitizeWebsocketBaseURL = (url)=>{
    url = url.trim();
    const urlRegex = /^(https?:\/\/)([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(:\d+)?\/?$/;
    if (!urlRegex.test(url)) throw (0, import_sdk_errors6.buildError)("sanitizeWebsocketBaseURL", import_sdk_errors6.DATA.INVALID_DATA_TYPE, `Invalid url: ${url}. Must adhere to the regex: ${urlRegex}.`);
    url = url.replace(/\/$/, "");
    url = HTTP_REGEX.exec(url) !== null ? url.replace(HTTP_REGEX, "ws://") : url.replace(HTTPS_REGEX, "wss://");
    return url;
};
// src/utils/thorest/thorest.ts
var thorest = {
    /**
   * Accounts related endpoints.
   */ accounts: {
        get: {
            ACCOUNT_DETAIL: (address)=>`/accounts/${address}`,
            ACCOUNT_BYTECODE: (address)=>`/accounts/${address}/code`,
            STORAGE_AT: (address, position)=>`/accounts/${address}/storage/${position}`
        },
        post: {
            SIMULATE_TRANSACTION: (revision)=>{
                return revision != null ? `/accounts/*?revision=${revision}` : `/accounts/*`;
            }
        }
    },
    /**
   * Blocks related endpoints.
   */ blocks: {
        get: {
            BLOCK_DETAIL: (revision)=>`/blocks/${revision}`
        }
    },
    /**
   * Nodes related endpoints.
   */ nodes: {
        get: {
            NODES: ()=>"/node/network/peers"
        }
    },
    /**
   * Logs related endpoints.
   */ logs: {
        post: {
            EVENT_LOGS: ()=>"/logs/event",
            TRANSFER_LOGS: ()=>"/logs/transfer"
        }
    },
    /**
   * Transactions related endpoints.
   */ transactions: {
        get: {
            TRANSACTION: (id)=>`/transactions/${id}`,
            TRANSACTION_RECEIPT: (id)=>`/transactions/${id}/receipt`
        },
        post: {
            TRANSACTION: ()=>`/transactions`
        }
    },
    /**
   * Subscriptions related endpoints.
   */ subscriptions: {
        get: {
            /**
       * Subscribe to new blocks.
       *
       * @param baseURL - The URL of the node to request the subscription from.
       * @param position - (optional) The block id to start from, defaults to the best block.
       *
       * @returns The websocket subscription URL.
       */ BLOCK: (baseURL, position)=>{
                const queryParams = toQueryString({
                    pos: position
                });
                return `${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/block${queryParams}`;
            },
            /**
       * Subscribe to new events.
       *
       * @param baseURL - The URL of the node to request the subscription from.
       * @param options - (optional) The options for the subscription.
       *
       * @returns The websocket subscription URL.
       */ EVENT: (baseURL, options)=>{
                const queryParams = toQueryString({
                    pos: options?.position,
                    addr: options?.contractAddress,
                    t0: options?.topic0,
                    t1: options?.topic1,
                    t2: options?.topic2,
                    t3: options?.topic3,
                    t4: options?.topic4
                });
                return `${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/event${queryParams}`;
            },
            /**
       * Subscribe to new VET transfers.
       *
       * @param baseURL - The URL of the node to request the subscription from.
       * @param options - (optional) The options for the subscription.
       *
       * @returns The websocket subscription URL.
       */ VET_TRANSFER: (baseURL, options)=>{
                const queryParams = toQueryString({
                    pos: options?.position,
                    txOrigin: options?.signerAddress,
                    sender: options?.sender,
                    recipient: options?.receiver
                });
                return `${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/transfer${queryParams}`;
            },
            /**
       * Subscribe to new legacy beats.
       * A beat is a notification that a new block has been added to the blockchain with a bloom filter which can be used to check if the block contains any relevant account.
       * @note This subscription has been improved with dynamic size bloom filter with the new `BEAT` subscription.
       *
       * @param baseURL - The URL of the node to request the subscription from.
       * @param position - (optional) The block id to start from, defaults to the best block.
       *
       * @returns The websocket subscription URL.
       */ BEAT_LEGACY: (baseURL, position)=>{
                const queryParams = toQueryString({
                    pos: position
                });
                return `${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/beat${queryParams}`;
            },
            /**
       * Subscribe to new beats.
       * A beat is a notification that a new block has been added to the blockchain with a bloom filter which can be used to check if the block contains any relevant account.
       *
       * @param baseURL - The URL of the node to request the subscription from.
       * @param position - (optional) The block id to start from, defaults to the best block.
       *
       * @returns The websocket subscription URL.
       */ BEAT: (baseURL, position)=>{
                const queryParams = toQueryString({
                    pos: position
                });
                return `${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/beat2${queryParams}`;
            },
            /**
       * Subscribe to new transactions.
       *
       * @returns The websocket subscription URL.
       */ NEW_TRANSACTIONS: (baseURL)=>`${sanitizeWebsocketBaseURL(baseURL)}/subscriptions/txpool`
        }
    },
    /**
   * Debug related endpoints.
   */ debug: {
        post: {
            TRACE_TRANSACTION_CLAUSE: ()=>`/debug/tracers`,
            TRACE_CONTRACT_CALL: ()=>`/debug/tracers/call`,
            RETRIEVE_STORAGE_RANGE: ()=>`/debug/storage-range`
        }
    }
};
// src/utils/subscriptions/beat.ts
var getLegacyBeatSubscriptionUrl = (baseURL, options)=>{
    return thorest.subscriptions.get.BEAT_LEGACY(baseURL, options?.blockID);
};
var getBeatSubscriptionUrl = (baseURL, options)=>{
    return thorest.subscriptions.get.BEAT(baseURL, options?.blockID);
};
// src/utils/subscriptions/block.ts
var getBlockSubscriptionUrl = (baseURL, options)=>{
    return thorest.subscriptions.get.BLOCK(baseURL, options?.blockID);
};
// src/utils/subscriptions/event.ts
var import_sdk_core = require("99ccdce3325a2858");
var getEventSubscriptionUrl = (baseURL, event, indexedValues, options)=>{
    if (import_sdk_core.vechain_sdk_core_ethers.EventFragment.isFragment(event)) event = event.format("full");
    const ev = new import_sdk_core.abi.Event(event);
    const encodedTopics = ev.encodeFilterTopics(indexedValues ?? []);
    return thorest.subscriptions.get.EVENT(baseURL, {
        position: options?.blockID,
        contractAddress: options?.address,
        topic0: encodedTopics[0],
        topic1: encodedTopics[1],
        topic2: encodedTopics[2],
        topic3: encodedTopics[3],
        topic4: encodedTopics[4]
    });
};
// src/utils/subscriptions/transaction.ts
var getNewTransactionsSubscriptionUrl = (baseURL)=>{
    return thorest.subscriptions.get.NEW_TRANSACTIONS(baseURL);
};
// src/utils/subscriptions/transfer.ts
var getVETtransfersSubscriptionUrl = (baseURL, options)=>{
    return thorest.subscriptions.get.VET_TRANSFER(baseURL, {
        position: options?.blockID,
        signerAddress: options?.signerAddress,
        sender: options?.sender,
        receiver: options?.recipient
    });
};
// src/utils/subscriptions/index.ts
var subscriptions = {
    getEventSubscriptionUrl,
    getBlockSubscriptionUrl,
    getNewTransactionsSubscriptionUrl,
    getVETtransfersSubscriptionUrl,
    getLegacyBeatSubscriptionUrl,
    getBeatSubscriptionUrl
};
// src/thor-client/accounts/accounts-module.ts
var import_sdk_core2 = require("99ccdce3325a2858");
var AccountsModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Retrieves account details such as balance of VET, VTHO, and if the address is a smart contract.
   *
   * @param address - The account address to query details for.
   * @param options - (Optional) Other optional parameters for the request.
   * @returns A promise that resolves to an object containing the account details (balance, energy, hasCode).
   *
   * @throws {InvalidDataTypeError} - Will throw an error if the revision is not a valid block number or ID
   *         or if the address is not a valid address.
   */ async getAccount(address, options) {
        (0, import_sdk_core2.assertIsAddress)("getAccount", address);
        (0, import_sdk_core2.assertIsRevisionForAccount)("getAccount", options?.revision);
        return await this.thor.httpClient.http("GET", thorest.accounts.get.ACCOUNT_DETAIL(address), {
            query: buildQuery({
                revision: options?.revision
            })
        });
    }
    /**
   * Fetches the bytecode of a contract at a given address.
   *
   * @param address - The contract address to get the bytecode for.
   * @param options - (Optional) Other optional parameters for the request.
   * @returns A promise that resolves to the contract bytecode as a string.
   *
   * @throws {InvalidDataTypeError} - Will throw an error if the revision is not a valid block number or ID
   *         or if the address is not a valid address.
   */ async getBytecode(address, options) {
        (0, import_sdk_core2.assertIsAddress)("getBytecode", address);
        (0, import_sdk_core2.assertIsRevisionForAccount)("getBytecode", options?.revision);
        const result = await this.thor.httpClient.http("GET", thorest.accounts.get.ACCOUNT_BYTECODE(address), {
            query: buildQuery({
                revision: options?.revision
            })
        });
        return result.code;
    }
    /**
   * Retrieves the value from a smart contract's storage at a given position.
   *
   * @param address - The contract address to query storage from.
   * @param position - The position in the storage to retrieve the value from. Must be a 32 bytes hex string (66 characters including `0x` prefix).
   * @param options - (Optional) Other optional parameters for the request.
   * @returns A promise that resolves to the storage value in hex string format.
   *
   * @throws {InvalidDataTypeError} - Will throw an error if the revision is not a valid block number or ID
   *         or if the position is not a 32 bytes hex string or if the address is not a valid address.
   */ async getStorageAt(address, position, options) {
        (0, import_sdk_core2.assertIsAddress)("getStorageAt", address);
        (0, import_sdk_core2.assertIsRevisionForAccount)("getStorageAt", options?.revision);
        (0, import_sdk_errors7.assert)("getStorageAt", import_sdk_core2.Hex0x.isValid(position) && position.length === 66, import_sdk_errors7.DATA.INVALID_DATA_TYPE, "Invalid `position`. The position must be a hex string of 32 bytes (66 characters including `0x` prefix).", {
            position
        });
        const result = await this.thor.httpClient.http("GET", thorest.accounts.get.STORAGE_AT(address, position), {
            query: buildQuery({
                position,
                revision: options?.revision
            })
        });
        return result.value;
    }
};
// src/thor-client/nodes/nodes-module.ts
var import_sdk_errors8 = require("63526d60e0d88131");
var NodesModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Retrieves connected peers of a node.
   *
   * @returns A promise that resolves to the list of connected peers.
   */ async getNodes() {
        return await this.thor.httpClient.http("GET", thorest.nodes.get.NODES());
    }
    /**
   * Checks the health of a node using the following algorithm:
   * 1. Make an HTTP GET request to retrieve the last block timestamp.
   * 2. Calculates the difference between the current time and the last block timestamp.
   * 3. If the difference is less than the tolerance, the node is healthy.
   * Note, we could also check '/node/network/peers since' but the difficulty with this approach is
   * if you consider a scenario where the node is connected to 20+ peers, which is healthy, and it receives the new blocks as expected.
   * But what if the node's disk is full, and it's not writing the new blocks to its database? In this case the node is off-sync even
   * though it's technically alive and connected
   * @returns A boolean indicating whether the node is healthy.
   * @throws {InvalidDataTypeError} - if the timestamp key does not exist in the response from the API call to the node
   * @throws {InvalidDataTypeError} - if the timestamp key exists in the response from the API call to the node but the value is not a number
   * @throws {InvalidDataTypeError} - if the response from the API call to the node is not an object
   * @throws {InvalidDataTypeError} - if the response from the API call to the node is null or undefined
   */ async isHealthy() {
        const response = await this.thor.blocks.getBestBlockCompressed();
        const lastBlockTimestamp = this.getTimestampFromBlock(response);
        const secondsSinceLastBlock = Math.floor(Date.now() / 1e3) - lastBlockTimestamp;
        return Math.abs(secondsSinceLastBlock) < NODE_HEALTHCHECK_TOLERANCE_IN_SECONDS;
    }
    /**
   * Extracts the timestamp from the block
   * @remarks
   * This function throws an error if the timestamp key does not exist in the response from the API call to the node
   * @param response the response from the API call to the node
   * @returns the timestamp from the block
   * @throws {InvalidDataTypeError} - if the timestamp key does not exist in the response from the API call to the node
   * @throws {InvalidDataTypeError} - if the timestamp key exists in the response from the API call to the node but the value is not a number
   * @throws {InvalidDataTypeError} - if the response from the API call to the node is not an object
   * @throws {InvalidDataTypeError} - if the response from the API call to the node is null or undefined
   */ getTimestampFromBlock = (response)=>{
        (0, import_sdk_errors8.assert)("getTimestampFromBlock", response !== null && response !== void 0 && typeof response === "object" && "timestamp" in response && typeof response.timestamp === "number", import_sdk_errors8.DATA.INVALID_DATA_TYPE, "Invalid block format returned from node. The block must be an object with a timestamp key present of type number", {
            response
        });
        return response?.timestamp;
    };
};
// src/thor-client/transactions/transactions-module.ts
var import_sdk_core5 = require("99ccdce3325a2858");
var import_sdk_errors11 = require("63526d60e0d88131");
// src/thor-client/transactions/helpers/delegation-handler.ts
var import_sdk_core3 = require("99ccdce3325a2858");
var import_sdk_errors9 = require("63526d60e0d88131");
var _getDelegationSignature = async (tx, delegatorUrl, originAddress, httpClient)=>{
    const rawTx = import_sdk_core3.Hex0x.of(tx.encoded);
    const sponsorRequestBody = {
        origin: originAddress,
        raw: rawTx
    };
    try {
        const response = await httpClient.http("POST", delegatorUrl, {
            body: sponsorRequestBody
        });
        return Buffer.from(response.signature.slice(2), "hex");
    } catch (error) {
        throw (0, import_sdk_errors9.buildError)("_getDelegationSignature", import_sdk_errors9.TRANSACTION.INVALID_DELEGATION, "Delegation failed: Cannot get signature from delegator.", {
            delegatorUrl
        }, error);
    }
};
var DelegationHandler = (delegator)=>{
    const delegatorIsUndefined = delegator === void 0 || delegator === null;
    const isDelegatedWithUrl = !delegatorIsUndefined && delegator?.delegatorUrl !== void 0;
    const isDelegatedWithPrivateKey = !delegatorIsUndefined && delegator?.delegatorPrivateKey !== void 0;
    return {
        /**
     * Check if the transaction is delegated.
     *
     * @returns true if the transaction is delegated, false otherwise.
     */ isDelegated: ()=>isDelegatedWithUrl || isDelegatedWithPrivateKey,
        /**
     * Get the delegator options or undefined.
     * (if delegator is undefined or null).
     *
     * @returns The delegator options or undefined.
     */ delegatorOrUndefined: ()=>delegatorIsUndefined ? void 0 : delegator,
        /**
     * Get the delegator options or null.
     * (if delegator is undefined or null).
     *
     * @returns The delegator options or null.
     */ delegatorOrNull: ()=>delegatorIsUndefined ? null : delegator,
        /**
     * Retrieves the signature of a delegation transaction from a delegator given the endpoint
     * from which to retrieve the signature.
     *
     * @param tx - The transaction to delegate.
     * @param originAddress - The address of the origin account.
     * @param httpClient - The HTTP client instance used for making HTTP requests.
     *
     * @returns A promise that resolves to the signature of the delegation transaction.
     *
     * @see [Simple Gas Payer Standard](https://github.com/vechain/VIPs/blob/master/vips/VIP-201.md)
     *
     * @throws an error if the delegation fails.
     */ getDelegationSignatureUsingUrl: async (tx, originAddress, httpClient)=>{
            (0, import_sdk_errors9.assert)("getDelegationSignatureUsingUrl", isDelegatedWithUrl, import_sdk_errors9.TRANSACTION.INVALID_DELEGATION, "Delegation with url failed: delegatorUrl is not defined.", {
                delegator,
                tx,
                originAddress
            });
            return await _getDelegationSignature(tx, delegator?.delegatorUrl, originAddress, httpClient);
        }
    };
};
// src/assertions/transactions/assertions.ts
var import_sdk_core4 = require("99ccdce3325a2858");
var import_sdk_errors10 = require("63526d60e0d88131");
var assertTransactionCanBeSigned = (methodName, originSignature, txBody)=>{
    (0, import_sdk_core4.assertIsValidTransactionSigningPrivateKey)(`assertTransactionCanBeSigned - ${methodName}`, originSignature, import_sdk_core4.secp256k1.isValidPrivateKey, "origin");
    (0, import_sdk_errors10.assert)(`assertTransactionCanBeSigned - ${methodName}`, import_sdk_core4.Transaction.isValidBody(txBody), import_sdk_errors10.TRANSACTION.INVALID_TRANSACTION_BODY, "Invalid transaction body provided, the transaction cannot be signed. Please check the transaction fields.");
};
// src/thor-client/transactions/transactions-module.ts
var TransactionsModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Retrieves the details of a transaction.
   *
   * @param id - Transaction ID of the transaction to retrieve.
   * @param options - (Optional) Other optional parameters for the request.
   * @returns A promise that resolves to the details of the transaction.
   */ async getTransaction(id, options) {
        (0, import_sdk_core5.assertValidTransactionID)("getTransaction", id);
        (0, import_sdk_core5.assertValidTransactionHead)("getTransaction", options?.head);
        return await this.thor.httpClient.http("GET", thorest.transactions.get.TRANSACTION(id), {
            query: buildQuery({
                raw: options?.raw,
                head: options?.head,
                options: options?.pending
            })
        });
    }
    /**
   * Retrieves the receipt of a transaction.
   *
   * @param id - Transaction ID of the transaction to retrieve.
   * @param options - (Optional) Other optional parameters for the request.
   *                  If `head` is not specified, the receipt of the transaction at the best block is returned.
   * @returns A promise that resolves to the receipt of the transaction.
   */ async getTransactionReceipt(id, options) {
        (0, import_sdk_core5.assertValidTransactionID)("getTransactionReceipt", id);
        (0, import_sdk_core5.assertValidTransactionHead)("getTransactionReceipt", options?.head);
        return await this.thor.httpClient.http("GET", thorest.transactions.get.TRANSACTION_RECEIPT(id), {
            query: buildQuery({
                head: options?.head
            })
        });
    }
    /**
   * Retrieves the receipt of a transaction.
   *
   * @param raw - The raw transaction.
   * @returns The transaction id of send transaction.
   */ async sendRawTransaction(raw) {
        (0, import_sdk_errors11.assert)("sendRawTransaction", import_sdk_core5.Hex0x.isValid(raw), import_sdk_errors11.DATA.INVALID_DATA_TYPE, "Sending failed: Input must be a valid raw transaction in hex format.", {
            raw
        });
        try {
            import_sdk_core5.TransactionHandler.decode(Buffer.from(raw.slice(2), "hex"), true);
        } catch (error) {
            throw (0, import_sdk_errors11.buildError)("sendRawTransaction", import_sdk_errors11.DATA.INVALID_DATA_TYPE, "Sending failed: Input must be a valid raw transaction in hex format. Decoding error encountered.", {
                raw
            }, error);
        }
        return await this.thor.httpClient.http("POST", thorest.transactions.post.TRANSACTION(), {
            body: {
                raw
            }
        });
    }
    /**
   * Sends a signed transaction to the network.
   *
   * @param signedTx - the transaction to send. It must be signed.
   *
   * @returns A promise that resolves to the transaction ID of the sent transaction.
   *
   * @throws an error if the transaction is not signed or if the transaction object is invalid.
   */ async sendTransaction(signedTx) {
        (0, import_sdk_core5.assertIsSignedTransaction)("sendTransaction", signedTx);
        const rawTx = import_sdk_core5.Hex0x.of(signedTx.encoded);
        return await this.sendRawTransaction(rawTx);
    }
    /**
   * Waits for a transaction to be included in a block.
   *
   * @param txID - The transaction ID of the transaction to wait for.
   * @param options - Optional parameters for the request. Includes the timeout and interval between requests.
   *                  Both parameters are in milliseconds. If the timeout is not specified, the request will not time out!
   *
   * @returns A promise that resolves to the transaction receipt of the transaction. If the transaction is not included in a block before the timeout,
   *          the promise will resolve to `null`.
   *
   * @throws an error if the transaction ID is invalid.
   */ async waitForTransaction(txID, options) {
        (0, import_sdk_core5.assertValidTransactionID)("waitForTransaction", txID);
        return await Poll.SyncPoll(async ()=>await this.thor.transactions.getTransactionReceipt(txID), {
            requestIntervalInMilliseconds: options?.intervalMs,
            maximumWaitingTimeInMilliseconds: options?.timeoutMs
        }).waitUntil((result)=>{
            return result !== null;
        });
    }
    /**
   * Builds a transaction body with the given clauses without having to
   * specify the chainTag, expiration, gasPriceCoef, gas, dependsOn and reserved fields.
   *
   * @param clauses - The clauses of the transaction.
   * @param gas - The gas to be used to perform the transaction.
   * @param options - Optional parameters for the request. Includes the expiration, gasPriceCoef, dependsOn and isDelegated fields.
   *                  If the `expiration` is not specified, the transaction will expire after 32 blocks.
   *                  If the `gasPriceCoef` is not specified, the transaction will use the default gas price coef of 127.
   *                  If the `dependsOn is` not specified, the transaction will not depend on any other transaction.
   *                  If the `isDelegated` is not specified, the transaction will not be delegated.
   *
   * @returns A promise that resolves to the transaction body.
   *
   * @throws an error if the genesis block or the latest block cannot be retrieved.
   */ async buildTransactionBody(clauses, gas, options) {
        const genesisBlock = await this.thor.blocks.getBlockCompressed(0);
        if (genesisBlock === null) throw (0, import_sdk_errors11.buildError)("buildTransactionBody", import_sdk_errors11.TRANSACTION.INVALID_TRANSACTION_BODY, "Error while building transaction body: Cannot get genesis block.", {
            clauses,
            options
        });
        const constTxBody = {
            nonce: import_sdk_core5.Hex0x.of(import_sdk_core5.secp256k1.randomBytes(8)),
            expiration: options?.expiration ?? 32,
            clauses,
            gasPriceCoef: options?.gasPriceCoef ?? 0,
            gas,
            dependsOn: options?.dependsOn ?? null,
            reserved: options?.isDelegated === true ? {
                features: 1
            } : void 0
        };
        const latestBlockRef = await this.thor.blocks.getBestBlockRef();
        if (latestBlockRef === null) throw (0, import_sdk_errors11.buildError)("buildTransactionBody", import_sdk_errors11.TRANSACTION.INVALID_TRANSACTION_BODY, "Error while building transaction body: Cannot get latest block.", {
            clauses,
            options
        });
        return {
            ...constTxBody,
            chainTag: Number(`0x${genesisBlock.id.slice(64)}`),
            // Last byte of the genesis block ID which is used to identify a network (chainTag)
            blockRef: latestBlockRef
        };
    }
    /**
   * Simulates the execution of a transaction.
   * Allows to estimate the gas cost of a transaction without sending it, as well as to retrieve the return value(s) of the transaction.
   *
   * @param clauses - The clauses of the transaction to simulate.
   * @param options - (Optional) The options for simulating the transaction.
   *
   * @returns A promise that resolves to an array of simulation results.
   *          Each element of the array represents the result of simulating a clause.
   */ async simulateTransaction(clauses, options) {
        const { revision, caller, gasPrice, gasPayer, gas, blockRef, expiration, provedWork } = options ?? {};
        (0, import_sdk_errors11.assert)("simulateTransaction", revision === void 0 || revision === null || import_sdk_core5.revisionUtils.isRevisionAccount(revision), import_sdk_errors11.DATA.INVALID_DATA_TYPE, "Invalid revision given as input. Input must be a valid revision (i.e., a block number or block ID).", {
            revision
        });
        return await this.thor.httpClient.http("POST", thorest.accounts.post.SIMULATE_TRANSACTION(revision), {
            query: buildQuery({
                revision
            }),
            body: {
                clauses: clauses.map((clause)=>{
                    return {
                        ...clause,
                        value: BigInt(clause.value).toString()
                    };
                }),
                gas,
                gasPrice,
                caller,
                provedWork,
                gasPayer,
                expiration,
                blockRef
            }
        });
    }
    /**
   * Signs a transaction with the given private key and handles the delegation if the transaction is delegated.
   * If the transaction is delegated, the signature of the delegator is retrieved from the delegator endpoint or from the delegator private key.
   *
   * @see [Simple Gas Payer Standard](https://docs.vechain.org/core-concepts/transactions/meta-transaction-features/fee-delegation/designated-gas-payer-vip-191) - Designated Gas Payer (VIP-191)
   *
   * @param txBody - The transaction body to sign.
   * @param privateKey - The private key of the origin account.
   * @param delegatorOptions - Optional parameters for the request. Includes the `delegatorUrl` and `delegatorPrivateKey` fields.
   *                  Only one of the following options can be specified: `delegatorUrl`, `delegatorPrivateKey`.
   *
   * @returns A promise that resolves to the signed transaction.
   */ async signTransaction(txBody, privateKey, delegatorOptions) {
        const originPrivateKey = Buffer.from(privateKey, "hex");
        assertTransactionCanBeSigned("signTransaction", originPrivateKey, txBody);
        return DelegationHandler(delegatorOptions).isDelegated() ? await this._signWithDelegator(txBody, originPrivateKey, delegatorOptions?.delegatorPrivateKey, delegatorOptions?.delegatorUrl) : import_sdk_core5.TransactionHandler.sign(txBody, originPrivateKey);
    }
    /**
   * Signs a transaction where the gas fee is paid by a delegator.
   *
   * @param unsignedTransactionBody - The unsigned transaction body to sign.
   * @param originPrivateKey - The private key of the origin account.
   * @param delegatorPrivateKey - (Optional) The private key of the delegator account.
   * @param delegatorUrl - (Optional) The URL of the endpoint of the delegator.
   *
   * @returns A promise that resolves to the signed transaction.
   *
   * @throws an error if the delegation fails.
   */ async _signWithDelegator(unsignedTransactionBody, originPrivateKey, delegatorPrivateKey, delegatorUrl) {
        (0, import_sdk_errors11.assert)("_signWithDelegator", !(delegatorUrl !== void 0 && delegatorPrivateKey !== void 0), import_sdk_errors11.TRANSACTION.INVALID_DELEGATION, "Only one of the following options can be specified: delegatorUrl, delegatorPrivateKey");
        const originAddress = import_sdk_core5.addressUtils.fromPublicKey(import_sdk_core5.secp256k1.derivePublicKey(originPrivateKey));
        const unsignedTx = new import_sdk_core5.Transaction(unsignedTransactionBody);
        if (delegatorPrivateKey !== void 0) return import_sdk_core5.TransactionHandler.signWithDelegator(unsignedTransactionBody, originPrivateKey, Buffer.from(delegatorPrivateKey, "hex"));
        const delegatorSignature = await DelegationHandler({
            delegatorUrl
        }).getDelegationSignatureUsingUrl(unsignedTx, originAddress, this.thor.httpClient);
        const originSignature = import_sdk_core5.secp256k1.sign(unsignedTx.getSignatureHash(), originPrivateKey);
        const signature = Buffer.concat([
            originSignature,
            delegatorSignature
        ]);
        return new import_sdk_core5.Transaction(unsignedTx.body, signature);
    }
};
// src/thor-client/logs/logs-module.ts
var LogsModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Filters event logs based on the provided criteria.
   *
   * @param filterOptions - An object specifying filtering criteria for event logs.
   * @returns A promise that resolves to filtered event logs.
   */ async filterEventLogs(filterOptions) {
        return await this.thor.httpClient.http("POST", thorest.logs.post.EVENT_LOGS(), {
            query: {},
            body: filterOptions,
            headers: {}
        });
    }
    /**
   * Filters transfer logs based on the provided criteria.
   *
   * @param filterOptions - An object specifying filtering criteria for transfer logs.
   * @returns A promise that resolves to filtered transfer logs.
   */ async filterTransferLogs(filterOptions) {
        return await this.thor.httpClient.http("POST", thorest.logs.post.TRANSFER_LOGS(), {
            query: {},
            body: filterOptions,
            headers: {}
        });
    }
};
// src/thor-client/blocks/blocks-module.ts
var import_sdk_errors12 = require("63526d60e0d88131");
var import_sdk_core6 = require("99ccdce3325a2858");
var BlocksModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   * @param options - (Optional) Other optional parameters for polling and error handling.
   */ constructor(thor, options){
        this.thor = thor;
        this.onBlockError = options?.onBlockError;
        if (options?.isPollingEnabled === true) this.setupPolling();
    }
    /**
   * The head block (best block). This is updated by the event poll instance every time a new block is produced.
   * @private
   */ headBlock = null;
    /**
   * Error handler for block-related errors.
   */ onBlockError;
    /**
   * The Poll instance for event polling
   * @private
   */ pollInstance;
    /**
   * Destroys the instance by stopping the event poll.
   */ destroy() {
        if (this.pollInstance != null) this.pollInstance.stopListen();
    }
    /**
   * Sets up the event polling for the best block.
   * @private
   * */ setupPolling() {
        this.pollInstance = Poll.createEventPoll(async ()=>await this.thor.blocks.getBestBlockCompressed(), 1e4).onData((data)=>{
            this.headBlock = data;
        }).onError(this.onBlockError ?? (()=>{}));
        this.pollInstance.startListen();
    }
    /**
   * Retrieves details of a compressed specific block identified by its revision (block number or ID).
   *
   * @param revision - The block number or ID to query details for.
   * @returns A promise that resolves to an object containing the details of the compressed block.
   */ async getBlockCompressed(revision) {
        (0, import_sdk_core6.assertIsRevisionForBlock)("getBlockCompressed", revision);
        return await this.thor.httpClient.http("GET", thorest.blocks.get.BLOCK_DETAIL(revision));
    }
    /**
   * Retrieves details of an expanded specific block identified by its revision (block number or ID).
   *
   * @param revision - The block number or ID to query details for.
   * @returns A promise that resolves to an object containing the details of the expanded block.
   */ async getBlockExpanded(revision) {
        (0, import_sdk_core6.assertIsRevisionForBlock)("getBlockExpanded", revision);
        return await this.thor.httpClient.http("GET", thorest.blocks.get.BLOCK_DETAIL(revision), {
            query: buildQuery({
                expanded: true
            })
        });
    }
    /**
   * Retrieves details of the latest block.
   *
   * @returns A promise that resolves to an object containing the compressed block details.
   */ async getBestBlockCompressed() {
        return await this.getBlockCompressed("best");
    }
    /**
   * Retrieves details of the latest block.
   *
   * @returns A promise that resolves to an object containing the expanded block details.
   */ async getBestBlockExpanded() {
        return await this.getBlockExpanded("best");
    }
    /**
   * Asynchronously retrieves a reference to the best block in the blockchain.
   *
   * This method first calls `getBestBlockCompressed()` to obtain the current best block. If no block is found (i.e., if `getBestBlockCompressed()` returns `null`),
   * the method returns `null` indicating that there's no block to reference. Otherwise, it extracts and returns the first 18 characters of the
   * block's ID, providing the ref to the best block.
   *
   * @returns {Promise<string | null>} A promise that resolves to either a string representing the first 18 characters of the best block's ID,
   * or `null` if no best block is found.
   *
   * @Example:
   * const blockRef = await getBestBlockRef();
   * if (blockRef) {
   *     console.log(`Reference to the best block: ${blockRef}`);
   * } else {
   *     console.log("No best block found.");
   * }
   */ async getBestBlockRef() {
        const bestBlock = await this.getBestBlockCompressed();
        if (bestBlock === null) return null;
        return bestBlock.id.slice(0, 18);
    }
    /**
   * Retrieves the finalized block.
   *
   * @returns A promise that resolves to an object containing the finalized block.
   */ async getFinalBlockCompressed() {
        return await this.getBlockCompressed("finalized");
    }
    /**
   * Retrieves details of the finalized block.
   *
   * @returns A promise that resolves to an object containing the finalized block details.
   */ async getFinalBlockExpanded() {
        return await this.getBlockExpanded("finalized");
    }
    /**
   * Synchronously waits for a specific block revision using polling.
   *
   * @param blockNumber - The block number to wait for.
   * @param expanded - A boolean indicating whether to wait for an expanded block.
   * @param options - (Optional) Allows to specify timeout and interval in milliseconds
   * @returns A promise that resolves to an object containing the compressed block.
   */ async _waitForBlock(blockNumber, expanded, options) {
        (0, import_sdk_errors12.assert)("waitForBlock", blockNumber === void 0 || blockNumber === null || blockNumber >= 0, import_sdk_errors12.DATA.INVALID_DATA_TYPE, "Invalid blockNumber. The blockNumber must be a number representing a block number.", {
            blockNumber
        });
        return await Poll.SyncPoll(async ()=>expanded ? await this.getBestBlockCompressed() : await this.getBestBlockExpanded(), {
            requestIntervalInMilliseconds: options?.intervalMs,
            maximumWaitingTimeInMilliseconds: options?.timeoutMs
        }).waitUntil((result)=>{
            return result != null && result?.number >= blockNumber;
        });
    }
    /**
   * Synchronously waits for a specific block revision using polling.
   *
   * @param blockNumber - The block number to wait for.
   * @param options - (Optional) Allows to specify timeout and interval in milliseconds
   * @returns A promise that resolves to an object containing the compressed block.
   */ async waitForBlockCompressed(blockNumber, options) {
        return await this._waitForBlock(blockNumber, false, options);
    }
    /**
   * Synchronously waits for a specific expanded block revision using polling.
   *
   * @param blockNumber - The block number to wait for.
   * @param options - (Optional) Allows to specify timeout and interval in milliseconds
   * @returns A promise that resolves to an object containing the expanded block details.
   */ async waitForBlockExpanded(blockNumber, options) {
        return await this._waitForBlock(blockNumber, true, options);
    }
    /**
   * Returns the head block (best block).
   * @returns {BlockDetail | null} The head block (best block).
   */ getHeadBlock() {
        return this.headBlock;
    }
    /**
   * Retrieves details of the genesis block.
   *
   * @returns A promise that resolves to an object containing the block details of the genesis block.
   */ async getGenesisBlock() {
        return await this.getBlockCompressed(0);
    }
};
// src/thor-client/contracts/contracts-module.ts
var import_sdk_core10 = require("99ccdce3325a2858");
// src/thor-client/contracts/model/contract-factory.ts
var import_sdk_core9 = require("99ccdce3325a2858");
// src/thor-client/contracts/model/contract.ts
var import_sdk_core8 = require("99ccdce3325a2858");
var import_sdk_errors14 = require("63526d60e0d88131");
// src/thor-client/contracts/model/contract-proxy.ts
var import_sdk_errors13 = require("63526d60e0d88131");
var import_sdk_core7 = require("99ccdce3325a2858");
// src/thor-client/contracts/model/contract-filter.ts
var ContractFilter = class {
    /**
   * The smart contract instance to apply the filter on.
   */ contract;
    /**
   * A set of criteria used to filter events.
   */ criteriaSet;
    /**
   * Constructs an instance of the `ContractFilter` class.
   *
   * @param contract - The smart contract instance to apply the filter on.
   * @param criteriaSet - A set of criteria used to filter events.
   */ constructor(contract, criteriaSet){
        this.contract = contract;
        this.criteriaSet = criteriaSet;
    }
    /**
   * Retrieves event logs based on the specified filter criteria, range, pagination options, and order.
   *
   * @param range - The block range to fetch the events from. Defaults to the entire blockchain history if not provided.
   * @param options - Pagination options for fetching the events.
   * @param order - The order in which to display the events. Defaults to ascending ('asc') if not provided.
   * @returns A promise that resolves to an array of event logs matching the filter criteria.
   */ async get(range, options, order) {
        const filterEventLogsOptions = {
            range: range ?? {
                unit: "block",
                from: 0,
                to: (await this.contract.thor.blocks.getBestBlockCompressed())?.number
            },
            criteriaSet: this.criteriaSet,
            options,
            order: order ?? "asc"
        };
        return await this.contract.thor.logs.filterEventLogs(filterEventLogsOptions);
    }
};
// src/thor-client/contracts/model/contract-proxy.ts
function getReadProxy(contract) {
    return new Proxy(contract.read, {
        get: (_target, prop)=>{
            return async (...args)=>{
                return await contract.thor.contracts.executeContractCall(contract.address, contract.getFunctionFragment(prop), args, {
                    caller: contract.getCallerPrivateKey() !== void 0 ? import_sdk_core7.addressUtils.fromPrivateKey(Buffer.from(contract.getCallerPrivateKey(), "hex")) : void 0,
                    ...contract.getContractReadOptions()
                });
            };
        }
    });
}
function getTransactProxy(contract) {
    return new Proxy(contract.transact, {
        get: (_target, prop)=>{
            return async (...args)=>{
                if (contract.getCallerPrivateKey() === void 0) throw (0, import_sdk_errors13.buildError)("Contract.getTransactProxy", import_sdk_errors13.ERROR_CODES.TRANSACTION.MISSING_PRIVATE_KEY, "Caller private key is required to transact with the contract.", {
                    prop
                });
                const transactionOptions = contract.getContractTransactOptions();
                const transactionValue = getTransactionValue(args);
                if (transactionValue !== void 0) args = args.filter((arg)=>!isTransactionValue(arg));
                return await contract.thor.contracts.executeContractTransaction(contract.getCallerPrivateKey(), contract.address, contract.getFunctionFragment(prop), args, {
                    ...transactionOptions,
                    value: transactionOptions.value ?? transactionValue?.value ?? 0
                });
            };
        }
    });
}
function getFilterProxy(contract) {
    return new Proxy(contract.filters, {
        get: (_target, prop)=>{
            return (...args)=>{
                const eventFragment = new import_sdk_core7.fragment.Event(contract.getEventFragment(prop));
                const topics = new Map(eventFragment.encodeFilterTopics(args).map((topic, index)=>[
                        index,
                        topic
                    ]));
                const criteriaSet = [
                    {
                        address: contract.address,
                        topic0: topics.get(0),
                        // the first topic is always defined since it's the event signature
                        topic1: topics.has(1) ? topics.get(1) : void 0,
                        topic2: topics.has(2) ? topics.get(2) : void 0,
                        topic3: topics.has(3) ? topics.get(3) : void 0,
                        topic4: topics.has(4) ? topics.get(4) : void 0
                    }
                ];
                return new ContractFilter(contract, criteriaSet);
            };
        }
    });
}
function getTransactionValue(args) {
    return args.find((arg)=>isTransactionValue(arg));
}
function isTransactionValue(obj) {
    return obj.value !== void 0;
}
// src/thor-client/contracts/model/contract.ts
var Contract = class {
    thor;
    address;
    abi;
    callerPrivateKey;
    deployTransactionReceipt;
    read = {};
    transact = {};
    filters = {};
    contractCallOptions = {};
    contractTransactionOptions = {};
    /**
   * Initializes a new instance of the `Contract` class.
   * @param address The address of the contract.
   * @param abi The Application Binary Interface (ABI) of the contract, which defines the contract's methods and events.
   * @param thor An instance of ThorClient to interact with the blockchain.
   * @param callerPrivateKey The private key used for signing transactions.
   * @param transactionReceipt (Optional) The transaction receipt of the contract deployment.
   */ constructor(address, abi4, thor, callerPrivateKey, transactionReceipt){
        this.abi = abi4;
        this.thor = thor;
        this.address = address;
        this.deployTransactionReceipt = transactionReceipt;
        this.callerPrivateKey = callerPrivateKey;
        this.read = getReadProxy(this);
        this.transact = getTransactProxy(this);
        this.filters = getFilterProxy(this);
    }
    /**
   * Sets the options for contract calls.
   * @param options - The contract call options to set.
   * @returns The updated contract call options.
   */ setContractReadOptions(options) {
        this.contractCallOptions = options;
        this.read = getReadProxy(this);
        return this.contractCallOptions;
    }
    /**
   * Clears the current contract call options, resetting them to an empty object.
   * @returns The updated contract call options.
   */ getContractReadOptions() {
        return this.contractCallOptions;
    }
    /**
   * Clears the current contract call options, resetting them to an empty object.
   */ clearContractReadOptions() {
        this.contractCallOptions = {};
        this.read = getReadProxy(this);
    }
    /**
   * Sets the options for contract transactions.
   * @param options - The contract transaction options to set.
   * @returns The updated contract transaction options.
   */ setContractTransactOptions(options) {
        this.contractTransactionOptions = options;
        this.transact = getTransactProxy(this);
        return this.contractTransactionOptions;
    }
    getContractTransactOptions() {
        return this.contractTransactionOptions;
    }
    /**
   * Clears the current contract transaction options, resetting them to an empty object.
   */ clearContractTransactOptions() {
        this.contractTransactionOptions = {};
        this.transact = getTransactProxy(this);
    }
    /**
   * Sets the private key of the caller for signing transactions.
   * @param privateKey
   */ setCallerPrivateKey(privateKey) {
        this.callerPrivateKey = privateKey;
        this.transact = getTransactProxy(this);
        this.read = getReadProxy(this);
        return this.callerPrivateKey;
    }
    /**
   * Get the private key of the caller for signing transactions.
   * @returns The private key of the caller.
   */ getCallerPrivateKey() {
        return this.callerPrivateKey;
    }
    /**
   * Retrieves the function fragment for the specified function name.
   * @param prop - The name of the function.
   * @private
   * @throws An error if the specified function name or symbol is not found in the contract's ABI. The error includes
   * the `ERROR_CODES.ABI.INVALID_FUNCTION` code and a message indicating the function is not present in the ABI.
   *
   */ getFunctionFragment(prop) {
        const functionFragment = import_sdk_core8.coder.createInterface(this.abi).getFunction(prop.toString());
        if (functionFragment == null) throw (0, import_sdk_errors14.buildError)("Contract.getFunctionFragment", import_sdk_errors14.ERROR_CODES.ABI.INVALID_FUNCTION, `Function '${prop.toString()}' not found in contract ABI.`, {
            prop
        });
        return functionFragment;
    }
    /**
   * Retrieves the event fragment for the specified event name.
   * @param eventName - The name of the event.
   * @return The event fragment for the specified event name.
   */ getEventFragment(eventName) {
        const eventFragment = import_sdk_core8.coder.createInterface(this.abi).getEvent(eventName.toString());
        if (eventFragment == null) throw (0, import_sdk_errors14.buildError)("Contract.getFunctionFragment", import_sdk_errors14.ERROR_CODES.ABI.INVALID_FUNCTION, `Function '${eventName.toString()}' not found in contract ABI.`, {
            eventName
        });
        return eventFragment;
    }
};
// src/thor-client/contracts/model/contract-factory.ts
var import_sdk_errors15 = require("63526d60e0d88131");
var ContractFactory = class {
    /**
   * The ABI (Application Binary Interface) of the contract.
   */ abi;
    /**
   * The bytecode of the smart contract.
   */ bytecode;
    /**
   * The private key used for signing transactions.
   */ privateKey;
    /**
   * An instance of ThorClient to interact with the blockchain.
   */ thor;
    /**
   * The result of the deployment transaction, undefined until a deployment is started.
   */ deployTransaction;
    /**
   * Initializes a new instance of the `ContractFactory` class.
   * @param abi The Application Binary Interface (ABI) of the contract, which defines the contract's methods and events.
   * @param bytecode The compiled bytecode of the contract, representing the contract's executable code.
   * @param privateKey The private key used for signing transactions during contract deployment, ensuring the deployer's identity.
   * @param thor An instance of ThorClient to interact with the blockchain.
   */ constructor(abi4, bytecode, privateKey, thor){
        this.abi = abi4;
        this.bytecode = bytecode;
        this.privateKey = privateKey;
        this.thor = thor;
    }
    /**
   * Initiates the deployment of a smart contract.
   *
   * This method performs several steps to deploy a smart contract:
   * 1. Builds a transaction clause for deploying the contract.
   * 2. Estimates the gas cost required for the transaction.
   * 3. Constructs the transaction body with the estimated gas cost.
   * 4. Signs the transaction using the provided private key.
   * 5. Sends the signed transaction to the blockchain.
   *
   * @param {DeployParams?} deployParams (Optional) parameters for contract deployment.
   * @param {ContractTransactionOptions?} options (Optional) transaction options, such as gas limit.
   * @returns {Promise<ContractFactory>} A promise that resolves to the instance of `ContractFactory`,
   *          allowing for fluent chaining of further actions or queries.
   * @throws {Error} Throws an error if any step in the deployment process fails.
   */ async startDeployment(deployParams, options) {
        const deployContractClause = import_sdk_core9.clauseBuilder.deployContract(this.bytecode, deployParams);
        const gasResult = await this.thor.gas.estimateGas([
            deployContractClause
        ], import_sdk_core9.addressUtils.fromPrivateKey(Buffer.from(this.privateKey, "hex")));
        const txBody = await this.thor.transactions.buildTransactionBody([
            deployContractClause
        ], gasResult.totalGas, options);
        const signedTx = await this.thor.transactions.signTransaction(txBody, this.privateKey);
        this.deployTransaction = await this.thor.transactions.sendTransaction(signedTx);
        return this;
    }
    /**
   * Waits for the completion of a contract deployment transaction.
   *
   * This method checks for the presence of a deployed transaction result and then
   * waits for the transaction to be processed. Upon successful processing, it
   * constructs and returns a new `Contract` instance based on the transaction receipt.
   *
   * @throws An error if the deployed transaction result is not found or if the
   *         contract deployment fails.
   * @returns {Promise<Contract>} A promise that resolves to a `Contract` instance
   *          once the deployment transaction is completed.
   */ async waitForDeployment() {
        if (this.deployTransaction === void 0) throw (0, import_sdk_errors15.buildError)("ContractFactory.waitForDeployment", import_sdk_errors15.ERROR_CODES.CONTRACT.CONTRACT_DEPLOYMENT_FAILED, "Cannot find a contract deployment transaction.", {
            deployTransaction: this.deployTransaction
        });
        const transactionReceipt = await this.thor.transactions.waitForTransaction(this.deployTransaction.id);
        (0, import_sdk_errors15.assert)("ContractFactory.waitForDeployment", transactionReceipt?.outputs[0]?.contractAddress !== null && transactionReceipt?.outputs[0]?.contractAddress !== void 0, import_sdk_errors15.ERROR_CODES.CONTRACT.CONTRACT_DEPLOYMENT_FAILED, "Contract deployment failed.", {
            deployTransaction: this.deployTransaction
        });
        return new Contract(transactionReceipt?.outputs[0].contractAddress, this.abi, this.thor, this.privateKey, transactionReceipt);
    }
    /**
   * Returns the deploy transaction result, if available.
   */ getDeployTransaction() {
        return this.deployTransaction;
    }
};
// src/thor-client/contracts/contracts-module.ts
var ContractsModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Creates a new instance of `ContractFactory` configured with the specified ABI, bytecode, and private key.
   * This factory is used to deploy new smart contracts to the blockchain network managed by this instance.
   *
   * @param abi - The Application Binary Interface (ABI) of the contract, which defines the contract's methods and events.
   * @param bytecode - The compiled bytecode of the contract, representing the contract's executable code.
   * @param privateKey - The private key used for signing transactions during contract deployment, ensuring the deployer's identity.
   * @returns An instance of `ContractFactory` configured with the provided ABI, bytecode, and private key, ready for deploying contracts.
   */ createContractFactory(abi4, bytecode, privateKey) {
        return new ContractFactory(abi4, bytecode, privateKey, this.thor);
    }
    /**
   * Initializes and returns a new Contract instance with the provided parameters.
   *
   * @param address - The blockchain address of the contract to load.
   * @param abi - The Application Binary Interface (ABI) of the contract, which defines the contract's methods and structures.
   * @param callerPrivateKey - Optional. The private key of the caller, used for signing transactions when interacting with the contract.
   * @returns A new instance of the Contract, initialized with the provided address, ABI, and optionally, a caller private key.
   */ load(address, abi4, callerPrivateKey) {
        return new Contract(address, abi4, this.thor, callerPrivateKey);
    }
    /**
   * Executes a read-only call to a smart contract function, simulating the transaction to obtain the result.
   *
   * @param contractAddress - The address of the smart contract to interact with.
   * @param functionFragment - The function fragment, including the name and types of the function to be called, derived from the contract's ABI.
   * @param functionData - An array of arguments to be passed to the smart contract function, corresponding to the function's parameters.
   * @param contractCallOptions - (Optional) Additional options for the contract call, such as the sender's address, gas limit, and gas price, which can affect the simulation's context.
   * @returns A promise that resolves to the decoded output of the smart contract function call, the format of which depends on the function's return types.
   *
   * The function simulates a transaction using the provided parameters without submitting it to the blockchain, allowing read-only operations to be tested without incurring gas costs or modifying the blockchain state.
   */ async executeContractCall(contractAddress, functionFragment, functionData, contractCallOptions) {
        const response = await this.thor.transactions.simulateTransaction([
            {
                to: contractAddress,
                value: "0",
                data: new import_sdk_core10.abi.Function(functionFragment).encodeInput(functionData)
            }
        ], contractCallOptions);
        return new import_sdk_core10.abi.Function(functionFragment).decodeOutput(response[0].data);
    }
    /**
   * Executes a transaction to interact with a smart contract function.
   *
   * @param privateKey - The private key for signing the transaction.
   * @param contractAddress - The address of the smart contract.
   * @param functionFragment - The function fragment, including the name and types of the function to be called, derived from the contract's ABI.
   * @param functionData - The input data for the function.
   * @param options - (Optional) An object containing options for the transaction body. Includes all options of the `buildTransactionBody` method
   *                  besides `isDelegated`.
   *                  @see {@link TransactionsModule.buildTransactionBody}
   *
   * @returns A promise resolving to a SendTransactionResult object.
   */ async executeContractTransaction(privateKey, contractAddress, functionFragment, functionData, options) {
        const clause = import_sdk_core10.clauseBuilder.functionInteraction(contractAddress, functionFragment, functionData, options?.value ?? 0);
        const gasResult = await this.thor.gas.estimateGas([
            clause
        ], import_sdk_core10.addressUtils.fromPrivateKey(Buffer.from(privateKey, "hex")));
        const txBody = await this.thor.transactions.buildTransactionBody([
            clause
        ], gasResult.totalGas, options);
        const signedTx = await this.thor.transactions.signTransaction(txBody, privateKey);
        const result = await this.thor.transactions.sendTransaction(signedTx);
        result.wait = async ()=>await this.thor.transactions.waitForTransaction(result.id);
        return result;
    }
    /**
   * Gets the base gas price in wei.
   * The base gas price is the minimum gas price that can be used for a transaction.
   * It is used to obtain the VTHO (energy) cost of a transaction.
   *
   * @link [Total Gas Price](https://docs.vechain.org/core-concepts/transactions/transaction-calculation#total-gas-price)
   *
   * @returns The base gas price in wei.
   */ async getBaseGasPrice() {
        return await this.executeContractCall(import_sdk_core10.PARAMS_ADDRESS, import_sdk_core10.coder.createInterface(import_sdk_core10.PARAMS_ABI).getFunction("get"), [
            import_sdk_core10.dataUtils.encodeBytes32String("base-gas-price")
        ]);
    }
};
// src/thor-client/gas/gas-module.ts
var import_sdk_errors16 = require("63526d60e0d88131");
var import_sdk_core13 = require("99ccdce3325a2858");
// src/thor-client/gas/helpers/decode-evm-error.ts
var import_sdk_core12 = require("99ccdce3325a2858");
// src/thor-client/gas/helpers/const.ts
var import_sdk_core11 = require("99ccdce3325a2858");
var SOLIDITY_ERROR_SELECTOR = (0, import_sdk_core11.keccak256)("Error(string)", "hex").slice(0, 10);
var SOLIDITY_PANIC_SELECTOR = (0, import_sdk_core11.keccak256)("Panic(uint256)", "hex").slice(0, 10);
// src/thor-client/gas/helpers/decode-evm-error.ts
function decodeRevertReason(data) {
    if (data.startsWith(SOLIDITY_ERROR_SELECTOR)) return import_sdk_core12.abi.decode("string", "0x" + data.slice(SOLIDITY_ERROR_SELECTOR.length));
    if (data.startsWith(SOLIDITY_PANIC_SELECTOR)) {
        const decoded = import_sdk_core12.abi.decode("uint256", "0x" + data.slice(SOLIDITY_PANIC_SELECTOR.length));
        return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
    }
}
// src/thor-client/gas/gas-module.ts
var GasModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Simulates a transaction and returns an object containing information regarding the gas used and whether the transaction reverted.
   *
   * @param clauses - The clauses of the transaction to simulate.
   * @param caller - The address of the account sending the transaction.
   * @param options - Optional parameters for the request. Includes all options of the `simulateTransaction` method excluding the `caller` option.
   *                  @see {@link TransactionsClient#simulateTransaction}
   *                  Also, includes the `gasPadding` option which is a percentage of gas to add on top of the estimated gas. The value must be between (0, 1].
   *
   * @note The caller option is suggested as estimation without this parameter may not be accurate.
   *
   * @returns An object containing information regarding the gas used and whether the transaction reverted, together with the decoded revert reason and VM errors.
   *
   * @throws an error if the clauses are invalid or if an error occurs during the simulation.
   */ async estimateGas(clauses, caller, options) {
        (0, import_sdk_errors16.assert)("estimateGas", clauses.length > 0, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Invalid clauses. Clauses must be an array of clauses with at least one clause.");
        (0, import_sdk_errors16.assert)("estimateGas", options?.gasPadding === void 0 || options.gasPadding > 0 && options.gasPadding <= 1, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Invalid gasPadding. gasPadding must be a number between (0, 1].");
        const simulations = await this.thor.transactions.simulateTransaction(clauses, {
            caller,
            ...options
        });
        const isReverted = simulations.some((simulation)=>{
            return simulation.reverted;
        });
        const intrinsicGas = import_sdk_core13.TransactionUtils.intrinsicGas(clauses);
        const totalSimulatedGas = simulations.reduce((sum, simulation)=>{
            return sum + simulation.gasUsed;
        }, 0);
        const totalGas = (intrinsicGas + (totalSimulatedGas !== 0 ? totalSimulatedGas + 15e3 : 0)) * (1 + (options?.gasPadding ?? 0));
        return isReverted ? {
            totalGas,
            reverted: true,
            revertReasons: simulations.map((simulation)=>{
                return decodeRevertReason(simulation.data) ?? "";
            }),
            vmErrors: simulations.map((simulation)=>{
                return simulation.vmError;
            })
        } : {
            totalGas,
            reverted: false,
            revertReasons: [],
            vmErrors: []
        };
    }
};
// src/thor-client/debug/debug-module.ts
var import_sdk_errors17 = require("63526d60e0d88131");
var import_sdk_core14 = require("99ccdce3325a2858");
var DebugModule = class {
    /**
   * Initializes a new instance of the `Thor` class.
   * @param thor - The Thor instance used to interact with the vechain blockchain API.
   */ constructor(thor){
        this.thor = thor;
    }
    /**
   * Trace transaction clause.
   *
   * This endpoint allows you to create a tracer for a specific clause.
   * Tracers are instrumental in monitoring and analyzing the execution flow within the EVM.
   * You can customize the tracer using various options to tailor it to your specific debugging needs.
   *
   * @param input - The input for the trace transaction clause. It has:
   * * target - The target of the tracer. It is a combination of blockID, transaction (transaction ID or index into block), and clauseIndex.
   * * config - The configuration of the tracer. It is specific to the name of the tracer.
   * @param name - The name of the tracer to use. It determines Output and Input configuration.
   *
   * @throws{InvalidDataTypeError} - If the input is invalid.
   */ async traceTransactionClause(input, name) {
        this.validateTarget(input.target, "traceTransactionClause");
        const parsedTarget = `${input.target.blockID}/${input.target.transaction}/${input.target.clauseIndex}`;
        return await this.thor.httpClient.http("POST", thorest.debug.post.TRACE_TRANSACTION_CLAUSE(), {
            query: {},
            body: {
                target: parsedTarget,
                name,
                config: input.config
            },
            headers: {}
        });
    }
    /**
   * Trace a contract call.
   *
   * This endpoint enables clients to create a tracer for a specific function call.
   * You can customize the tracer using various options to suit your debugging requirements.
   *
   * @param input - The input for the trace contract call. It has:
   * * contractInput - The contract call information.
   * * config - The configuration of the tracer. It is specific to the name of the tracer.
   * * transactionOptions - The transaction options.
   * @param name - The name of the tracer to use. It determines Output and Input configuration.
   *
   * @throws{InvalidDataTypeError} - If the input is invalid.
   */ async traceContractCall(input, name) {
        if (input.contractInput?.to !== void 0 && input.contractInput.to !== null) (0, import_sdk_errors17.assert)("traceContractCall", import_sdk_core14.addressUtils.isAddress(input.contractInput.to), import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid address '${input.contractInput.to}' given as input for traceContractCall.`, {
            address: input.contractInput.to
        });
        if (input.contractInput?.data !== void 0) (0, import_sdk_errors17.assert)("traceContractCall", import_sdk_core14.Hex0x.isValid(input.contractInput.data, true), import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid data '${input.contractInput?.data}' given as input for traceContractCall.`, {
            data: input.contractInput?.data
        });
        if (input.contractInput?.value !== void 0) (0, import_sdk_errors17.assert)("traceContractCall", import_sdk_core14.Hex0x.isValid(input.contractInput.value), import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid value '${input.contractInput?.value}' given as input for traceContractCall.`, {
            value: input.contractInput?.value
        });
        return await this.thor.httpClient.http("POST", thorest.debug.post.TRACE_CONTRACT_CALL(), {
            query: {},
            body: {
                to: input.contractInput?.to,
                data: input.contractInput?.data,
                value: input.contractInput?.value,
                name,
                gas: input.transactionOptions?.gas,
                gasPrice: input.transactionOptions?.gasPrice,
                caller: input.transactionOptions?.caller,
                provedWork: input.transactionOptions?.provedWork,
                gasPayer: input.transactionOptions?.gasPayer,
                expiration: input.transactionOptions?.expiration,
                blockRef: input.transactionOptions?.blockRef,
                config: input.config
            },
            headers: {}
        });
    }
    /**
   * Retrieve the storage range.
   *
   * This endpoint enables clients to retrieve the storage range for the
   * coordinates specified in the `input` parameter.
   *
   * @param input - the coordinates to retrieve the storage range. It has:
   * * target - {@link TransactionTraceTarget} specifies `blockID`,
   *           `transaction` address and `clauseIndex` number.
   * * options - {@link RetrieveStorageRangeInputOptions} specified the
   *           `address` if the contract or account to retrieve the
   *           storage range for. Nullable.
   */ async retrieveStorageRange(input) {
        this.validateTarget(input.target, "retrieveStorageRange");
        const parsedTarget = `${input.target.blockID}/${input.target.transaction}/${input.target.clauseIndex}`;
        return await this.thor.httpClient.http("POST", thorest.debug.post.RETRIEVE_STORAGE_RANGE(), {
            query: {},
            body: {
                target: parsedTarget,
                address: input.options?.address,
                keyStart: input.options?.keyStart,
                maxResult: input.options?.maxResult
            },
            headers: {}
        });
    }
    /**
   * Validate target of traceTransactionClause and retrieveStorageRange.
   *
   * @param target - Target of traceTransactionClause and retrieveStorageRange to validate.
   * @param functionName - The name of the function.
   *
   * @private
   *
   * @throws{InvalidDataTypeError} - If the input is invalid.
   */ validateTarget(target, functionName) {
        (0, import_sdk_errors17.assert)("validateTarget", import_sdk_core14.Hex0x.isThorId(target.blockID), import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid block ID '${target.blockID}' given as input for ${functionName}.`, {
            blockId: target.blockID
        });
        if (typeof target.transaction === "string") (0, import_sdk_errors17.assert)("validateTarget", import_sdk_core14.Hex0x.isThorId(target.transaction), import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid transaction id '${target.transaction}' given as input for ${functionName}.`, {
            transaction: target.transaction
        });
        else (0, import_sdk_errors17.assert)("validateTarget", target.transaction >= 0, import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid transaction index '${target.transaction}' given as input for ${functionName}.`, {
            transaction: target.transaction
        });
        (0, import_sdk_errors17.assert)("validateTarget", target.clauseIndex >= 0, import_sdk_errors17.DATA.INVALID_DATA_TYPE, `Invalid clause index '${target.clauseIndex}' given as input for ${functionName}.`, {
            clauseIndex: target.clauseIndex
        });
    }
};
// src/thor-client/thor-client.ts
var ThorClient = class _ThorClient {
    /**
   * Constructs a new `ThorClient` instance with a given HTTP client.
   *
   * @param httpClient - The HTTP client instance used for making network requests.
   * @param options - (Optional) Other optional parameters for polling and error handling.
   */ constructor(httpClient, options){
        this.httpClient = httpClient;
        this.accounts = new AccountsModule(this);
        this.nodes = new NodesModule(this);
        this.blocks = new BlocksModule(this, options);
        this.logs = new LogsModule(this);
        this.transactions = new TransactionsModule(this);
        this.contracts = new ContractsModule(this);
        this.gas = new GasModule(this);
        this.debug = new DebugModule(this);
    }
    /**
   * The `AccountsModule` instance
   */ accounts;
    /**
   * The `NodesModule` instance
   */ nodes;
    /**
   * The `BlocksModule` instance
   */ blocks;
    /**
   * The `LogsModule` instance used for interacting with log-related endpoints.
   */ logs;
    /*
   * The `TransactionsModule` instance
   */ transactions;
    /**
   * The 'ContractClient' instance
   */ contracts;
    /**
   * The `GasModule` instance
   */ gas;
    /**
   * The `DebugModule` instance
   */ debug;
    /**
   * Creates a new `ThorClient` instance from a given URL.
   *
   * @param networkUrl - The URL of the network to connect to.
   * @param options - (Optional) Other optional parameters for polling and error handling.
   * @returns A new `ThorClient` instance.
   */ static fromUrl(networkUrl, options) {
        return new _ThorClient(new HttpClient(networkUrl), options);
    }
    /**
   * Destroys the `ThorClient` instance by stopping the event polling
   * and any other cleanup.
   */ destroy() {
        this.blocks.destroy();
    }
};

},{"945cf3902c7f9ddc":"l5Twm","63526d60e0d88131":"lBVu5","89dcae773b8495f":"2uY8v","a8c4b18217c6ab44":"biwe9","9d721ee24bf3b50b":"h9uDr","38f82049a7859bb0":"fqTtD","99ccdce3325a2858":"iZmwY"}],"lBVu5":[function(require,module,exports) {
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var src_exports = {};
__export(src_exports, {
    ABI: ()=>ABI,
    ADDRESS: ()=>ADDRESS,
    BLOOM: ()=>BLOOM,
    CERTIFICATE: ()=>CERTIFICATE,
    CONTRACT: ()=>CONTRACT,
    CertificateInvalidSignatureFormatError: ()=>CertificateInvalidSignatureFormatError,
    CertificateInvalidSignerError: ()=>CertificateInvalidSignerError,
    CertificateNotSignedError: ()=>CertificateNotSignedError,
    ContractDeploymentFailedError: ()=>ContractDeploymentFailedError,
    ContractInterfaceError: ()=>ContractInterfaceError,
    DATA: ()=>DATA,
    EIP1193: ()=>EIP1193,
    EIP1193ChainDisconnected: ()=>EIP1193ChainDisconnected,
    EIP1193Disconnected: ()=>EIP1193Disconnected,
    EIP1193Unauthorized: ()=>EIP1193Unauthorized,
    EIP1193UnsupportedMethod: ()=>EIP1193UnsupportedMethod,
    EIP1193UserRejectedRequest: ()=>EIP1193UserRejectedRequest,
    ERROR_CODES: ()=>ERROR_CODES,
    ErrorBase: ()=>ErrorBase,
    ErrorClassMap: ()=>ErrorClassMap,
    FUNCTION: ()=>FUNCTION,
    HDNODE: ()=>HDNODE,
    HTTPClientError: ()=>HTTPClientError,
    HTTP_CLIENT: ()=>HTTP_CLIENT,
    InvalidAbiDataToDecodeError: ()=>InvalidAbiDataToDecodeError,
    InvalidAbiDataToEncodeError: ()=>InvalidAbiDataToEncodeError,
    InvalidAbiEventError: ()=>InvalidAbiEventError,
    InvalidAbiFormatTypeError: ()=>InvalidAbiFormatTypeError,
    InvalidAbiFunctionError: ()=>InvalidAbiFunctionError,
    InvalidAddressError: ()=>InvalidAddressError,
    InvalidBloomError: ()=>InvalidBloomError,
    InvalidDataReturnTypeError: ()=>InvalidDataReturnTypeError,
    InvalidDataTypeError: ()=>InvalidDataTypeError,
    InvalidHDNodeChaincodeError: ()=>InvalidHDNodeChaincodeError,
    InvalidHDNodeDerivationPathError: ()=>InvalidHDNodeDerivationPathError,
    InvalidHDNodeMnemonicsError: ()=>InvalidHDNodeMnemonicsError,
    InvalidHDNodePrivateKeyError: ()=>InvalidHDNodePrivateKeyError,
    InvalidHDNodePublicKeyError: ()=>InvalidHDNodePublicKeyError,
    InvalidKError: ()=>InvalidKError,
    InvalidKeystoreError: ()=>InvalidKeystoreError,
    InvalidKeystorePasswordError: ()=>InvalidKeystorePasswordError,
    InvalidRLPError: ()=>InvalidRLPError,
    InvalidSecp256k1MessageHashError: ()=>InvalidSecp256k1MessageHashError,
    InvalidSecp256k1PrivateKeyError: ()=>InvalidSecp256k1PrivateKeyError,
    InvalidSecp256k1SignatureError: ()=>InvalidSecp256k1SignatureError,
    InvalidSecp256k1SignatureRecoveryError: ()=>InvalidSecp256k1SignatureRecoveryError,
    JSONRPC: ()=>JSONRPC,
    JSONRPCDefaultError: ()=>JSONRPCDefaultError,
    JSONRPCInternalError: ()=>JSONRPCInternalError,
    JSONRPCInvalidParams: ()=>JSONRPCInvalidParams,
    JSONRPCInvalidRequest: ()=>JSONRPCInvalidRequest,
    KEYSTORE: ()=>KEYSTORE,
    NotImplementedError: ()=>NotImplementedError,
    POLL_ERROR: ()=>POLL_ERROR,
    PollExecutionError: ()=>PollExecutionError,
    ProviderRpcError: ()=>ProviderRpcError,
    RLP: ()=>RLP,
    SECP256K1: ()=>SECP256K1,
    TRANSACTION: ()=>TRANSACTION,
    TransactionAlreadySignedError: ()=>TransactionAlreadySignedError,
    TransactionBodyError: ()=>TransactionBodyError,
    TransactionDelegationError: ()=>TransactionDelegationError,
    TransactionMissingPrivateKeyError: ()=>TransactionMissingPrivateKeyError,
    TransactionNotSignedError: ()=>TransactionNotSignedError,
    assert: ()=>assert,
    assertInnerError: ()=>assertInnerError,
    buildError: ()=>buildError,
    buildErrorMessage: ()=>buildErrorMessage,
    buildProviderError: ()=>buildProviderError,
    errors: ()=>errors_exports,
    getEIP1193ErrorCode: ()=>getEIP1193ErrorCode,
    getJSONRPCErrorCode: ()=>getJSONRPCErrorCode,
    stringifyData: ()=>stringifyData
});
module.exports = __toCommonJS(src_exports);
// src/errors.ts
var errors_exports = {};
__export(errors_exports, {
    ABI: ()=>ABI,
    ADDRESS: ()=>ADDRESS,
    BLOOM: ()=>BLOOM,
    CERTIFICATE: ()=>CERTIFICATE,
    CONTRACT: ()=>CONTRACT,
    CertificateInvalidSignatureFormatError: ()=>CertificateInvalidSignatureFormatError,
    CertificateInvalidSignerError: ()=>CertificateInvalidSignerError,
    CertificateNotSignedError: ()=>CertificateNotSignedError,
    ContractDeploymentFailedError: ()=>ContractDeploymentFailedError,
    ContractInterfaceError: ()=>ContractInterfaceError,
    DATA: ()=>DATA,
    EIP1193: ()=>EIP1193,
    EIP1193ChainDisconnected: ()=>EIP1193ChainDisconnected,
    EIP1193Disconnected: ()=>EIP1193Disconnected,
    EIP1193Unauthorized: ()=>EIP1193Unauthorized,
    EIP1193UnsupportedMethod: ()=>EIP1193UnsupportedMethod,
    EIP1193UserRejectedRequest: ()=>EIP1193UserRejectedRequest,
    ERROR_CODES: ()=>ERROR_CODES,
    ErrorBase: ()=>ErrorBase,
    ErrorClassMap: ()=>ErrorClassMap,
    FUNCTION: ()=>FUNCTION,
    HDNODE: ()=>HDNODE,
    HTTPClientError: ()=>HTTPClientError,
    HTTP_CLIENT: ()=>HTTP_CLIENT,
    InvalidAbiDataToDecodeError: ()=>InvalidAbiDataToDecodeError,
    InvalidAbiDataToEncodeError: ()=>InvalidAbiDataToEncodeError,
    InvalidAbiEventError: ()=>InvalidAbiEventError,
    InvalidAbiFormatTypeError: ()=>InvalidAbiFormatTypeError,
    InvalidAbiFunctionError: ()=>InvalidAbiFunctionError,
    InvalidAddressError: ()=>InvalidAddressError,
    InvalidBloomError: ()=>InvalidBloomError,
    InvalidDataReturnTypeError: ()=>InvalidDataReturnTypeError,
    InvalidDataTypeError: ()=>InvalidDataTypeError,
    InvalidHDNodeChaincodeError: ()=>InvalidHDNodeChaincodeError,
    InvalidHDNodeDerivationPathError: ()=>InvalidHDNodeDerivationPathError,
    InvalidHDNodeMnemonicsError: ()=>InvalidHDNodeMnemonicsError,
    InvalidHDNodePrivateKeyError: ()=>InvalidHDNodePrivateKeyError,
    InvalidHDNodePublicKeyError: ()=>InvalidHDNodePublicKeyError,
    InvalidKError: ()=>InvalidKError,
    InvalidKeystoreError: ()=>InvalidKeystoreError,
    InvalidKeystorePasswordError: ()=>InvalidKeystorePasswordError,
    InvalidRLPError: ()=>InvalidRLPError,
    InvalidSecp256k1MessageHashError: ()=>InvalidSecp256k1MessageHashError,
    InvalidSecp256k1PrivateKeyError: ()=>InvalidSecp256k1PrivateKeyError,
    InvalidSecp256k1SignatureError: ()=>InvalidSecp256k1SignatureError,
    InvalidSecp256k1SignatureRecoveryError: ()=>InvalidSecp256k1SignatureRecoveryError,
    JSONRPC: ()=>JSONRPC,
    JSONRPCDefaultError: ()=>JSONRPCDefaultError,
    JSONRPCInternalError: ()=>JSONRPCInternalError,
    JSONRPCInvalidParams: ()=>JSONRPCInvalidParams,
    JSONRPCInvalidRequest: ()=>JSONRPCInvalidRequest,
    KEYSTORE: ()=>KEYSTORE,
    NotImplementedError: ()=>NotImplementedError,
    POLL_ERROR: ()=>POLL_ERROR,
    PollExecutionError: ()=>PollExecutionError,
    ProviderRpcError: ()=>ProviderRpcError,
    RLP: ()=>RLP,
    SECP256K1: ()=>SECP256K1,
    TRANSACTION: ()=>TRANSACTION,
    TransactionAlreadySignedError: ()=>TransactionAlreadySignedError,
    TransactionBodyError: ()=>TransactionBodyError,
    TransactionDelegationError: ()=>TransactionDelegationError,
    TransactionMissingPrivateKeyError: ()=>TransactionMissingPrivateKeyError,
    TransactionNotSignedError: ()=>TransactionNotSignedError,
    assert: ()=>assert,
    assertInnerError: ()=>assertInnerError,
    buildError: ()=>buildError,
    buildErrorMessage: ()=>buildErrorMessage,
    buildProviderError: ()=>buildProviderError,
    getEIP1193ErrorCode: ()=>getEIP1193ErrorCode,
    getJSONRPCErrorCode: ()=>getJSONRPCErrorCode,
    stringifyData: ()=>stringifyData
});
// src/model/base.ts
var ErrorBase = class extends Error {
    code;
    message;
    data;
    innerError;
    constructor({ code, message, data, innerError }){
        super();
        this.code = code;
        this.message = message;
        this.data = data;
        this.innerError = innerError;
    }
};
// src/model/core/abi.ts
var InvalidAbiDataToDecodeError = class extends ErrorBase {
};
var InvalidAbiDataToEncodeError = class extends ErrorBase {
};
var InvalidAbiEventError = class extends ErrorBase {
};
var InvalidAbiFormatTypeError = class extends ErrorBase {
};
var InvalidAbiFunctionError = class extends ErrorBase {
};
var ContractInterfaceError = class extends ErrorBase {
};
var ABI = /* @__PURE__ */ ((ABI2)=>{
    ABI2["INVALID_FUNCTION"] = "INVALID_FUNCTION";
    ABI2["INVALID_EVENT"] = "INVALID_EVENT";
    ABI2["INVALID_DATA_TO_DECODE"] = "INVALID_DATA_TO_DECODE";
    ABI2["INVALID_DATA_TO_ENCODE"] = "INVALID_DATA_TO_ENCODE";
    ABI2["INVALID_FORMAT_TYPE"] = "INVALID_FORMAT_TYPE";
    ABI2["CONTRACT_INTERFACE_ERROR"] = "CONTRACT_INTERFACE_ERROR";
    return ABI2;
})(ABI || {});
// src/model/core/address.ts
var InvalidAddressError = class extends ErrorBase {
};
var ADDRESS = /* @__PURE__ */ ((ADDRESS2)=>{
    ADDRESS2["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    return ADDRESS2;
})(ADDRESS || {});
// src/model/core/bloom.ts
var InvalidBloomError = class extends ErrorBase {
};
var InvalidKError = class extends ErrorBase {
};
var BLOOM = /* @__PURE__ */ ((BLOOM2)=>{
    BLOOM2["INVALID_BLOOM"] = "INVALID_BLOOM";
    BLOOM2["INVALID_K"] = "INVALID_K";
    return BLOOM2;
})(BLOOM || {});
// src/model/core/certificate.ts
var CertificateNotSignedError = class extends ErrorBase {
};
var CertificateInvalidSignatureFormatError = class extends ErrorBase {
};
var CertificateInvalidSignerError = class extends ErrorBase {
};
var CERTIFICATE = /* @__PURE__ */ ((CERTIFICATE2)=>{
    CERTIFICATE2["CERTIFICATE_NOT_SIGNED"] = "CERTIFICATE_NOT_SIGNED";
    CERTIFICATE2["CERTIFICATE_INVALID_SIGNATURE_FORMAT"] = "CERTIFICATE_INVALID_SIGNATURE_FORMAT";
    CERTIFICATE2["CERTIFICATE_INVALID_SIGNER"] = "CERTIFICATE_INVALID_SIGNER";
    return CERTIFICATE2;
})(CERTIFICATE || {});
// src/model/core/contract.ts
var ContractDeploymentFailedError = class extends ErrorBase {
};
var CONTRACT = /* @__PURE__ */ ((CONTRACT2)=>{
    CONTRACT2["CONTRACT_DEPLOYMENT_FAILED"] = "CONTRACT_DEPLOYMENT_FAILED";
    return CONTRACT2;
})(CONTRACT || {});
// src/model/core/data.ts
var InvalidDataTypeError = class extends ErrorBase {
};
var InvalidDataReturnTypeError = class extends ErrorBase {
};
var DATA = /* @__PURE__ */ ((DATA2)=>{
    DATA2["INVALID_DATA_TYPE"] = "INVALID_DATA_TYPE";
    DATA2["INVALID_DATA_RETURN_TYPE"] = "INVALID_DATA_RETURN_TYPE";
    return DATA2;
})(DATA || {});
// src/model/core/hdnode.ts
var InvalidHDNodeChaincodeError = class extends ErrorBase {
};
var InvalidHDNodeMnemonicsError = class extends ErrorBase {
};
var InvalidHDNodePrivateKeyError = class extends ErrorBase {
};
var InvalidHDNodePublicKeyError = class extends ErrorBase {
};
var InvalidHDNodeDerivationPathError = class extends ErrorBase {
};
var HDNODE = /* @__PURE__ */ ((HDNODE2)=>{
    HDNODE2["INVALID_HDNODE_PUBLIC_KEY"] = "INVALID_HDNODE_PUBLIC_KEY";
    HDNODE2["INVALID_HDNODE_PRIVATE_KEY"] = "INVALID_HDNODE_PRIVATE_KEY";
    HDNODE2["INVALID_HDNODE_CHAIN_CODE"] = "INVALID_HDNODE_CHAIN_CODE";
    HDNODE2["INVALID_HDNODE_MNEMONICS"] = "INVALID_HDNODE_MNEMONICS";
    HDNODE2["INVALID_HDNODE_DERIVATION_PATH"] = "INVALID_HDNODE_DERIVATION_PATH";
    return HDNODE2;
})(HDNODE || {});
// src/model/core/keystore.ts
var InvalidKeystoreError = class extends ErrorBase {
};
var InvalidKeystorePasswordError = class extends ErrorBase {
};
var KEYSTORE = /* @__PURE__ */ ((KEYSTORE2)=>{
    KEYSTORE2["INVALID_KEYSTORE"] = "INVALID_KEYSTORE";
    KEYSTORE2["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    return KEYSTORE2;
})(KEYSTORE || {});
// src/model/core/rlp.ts
var InvalidRLPError = class extends ErrorBase {
};
var RLP = /* @__PURE__ */ ((RLP2)=>{
    RLP2["INVALID_RLP"] = "INVALID_RLP";
    return RLP2;
})(RLP || {});
// src/model/core/secp256k1.ts
var InvalidSecp256k1PrivateKeyError = class extends ErrorBase {
};
var InvalidSecp256k1MessageHashError = class extends ErrorBase {
};
var InvalidSecp256k1SignatureError = class extends ErrorBase {
};
var InvalidSecp256k1SignatureRecoveryError = class extends ErrorBase {
};
var SECP256K1 = /* @__PURE__ */ ((SECP256K12)=>{
    SECP256K12["INVALID_SECP256k1_PRIVATE_KEY"] = "INVALID_SECP256k1_PRIVATE_KEY";
    SECP256K12["INVALID_SECP256k1_MESSAGE_HASH"] = "INVALID_SECP256k1_MESSAGE_HASH";
    SECP256K12["INVALID_SECP256k1_SIGNATURE"] = "INVALID_SECP256k1_SIGNATURE";
    SECP256K12["INVALID_SECP256k1_SIGNATURE_RECOVERY"] = "INVALID_SECP256k1_SIGNATURE_RECOVERY";
    return SECP256K12;
})(SECP256K1 || {});
// src/model/core/transaction.ts
var TransactionAlreadySignedError = class extends ErrorBase {
};
var TransactionNotSignedError = class extends ErrorBase {
};
var TransactionBodyError = class extends ErrorBase {
};
var TransactionDelegationError = class extends ErrorBase {
};
var TransactionMissingPrivateKeyError = class extends ErrorBase {
};
var TRANSACTION = /* @__PURE__ */ ((TRANSACTION2)=>{
    TRANSACTION2["ALREADY_SIGNED"] = "ALREADY_SIGNED";
    TRANSACTION2["NOT_SIGNED"] = "NOT_SIGNED";
    TRANSACTION2["INVALID_TRANSACTION_BODY"] = "INVALID_TRANSACTION_BODY";
    TRANSACTION2["INVALID_DELEGATION"] = "INVALID_DELEGATION";
    TRANSACTION2["MISSING_PRIVATE_KEY"] = "MISSING_PRIVATE_KEY";
    return TRANSACTION2;
})(TRANSACTION || {});
// src/model/network/http-client.ts
var HTTPClientError = class extends ErrorBase {
};
var HTTP_CLIENT = /* @__PURE__ */ ((HTTP_CLIENT2)=>{
    HTTP_CLIENT2["INVALID_HTTP_REQUEST"] = "INVALID_HTTP_REQUEST";
    return HTTP_CLIENT2;
})(HTTP_CLIENT || {});
// src/model/network/poll.ts
var PollExecutionError = class extends ErrorBase {
};
var POLL_ERROR = /* @__PURE__ */ ((POLL_ERROR2)=>{
    POLL_ERROR2["POLL_EXECUTION_ERROR"] = "POLL_EXECUTION_ERROR";
    return POLL_ERROR2;
})(POLL_ERROR || {});
// src/model/generic/function.ts
var NotImplementedError = class extends ErrorBase {
};
var FUNCTION = /* @__PURE__ */ ((FUNCTION2)=>{
    FUNCTION2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    return FUNCTION2;
})(FUNCTION || {});
// src/model/eip1193/eip1193.ts
var EIP1193UserRejectedRequest = class extends ErrorBase {
};
var EIP1193Unauthorized = class extends ErrorBase {
};
var EIP1193UnsupportedMethod = class extends ErrorBase {
};
var EIP1193Disconnected = class extends ErrorBase {
};
var EIP1193ChainDisconnected = class extends ErrorBase {
};
var EIP1193 = /* @__PURE__ */ ((EIP11932)=>{
    EIP11932["USER_REJECTED_REQUEST"] = "USER_REJECTED_REQUEST";
    EIP11932["UNAUTHORIZED"] = "UNAUTHORIZED";
    EIP11932["UNSUPPORTED_METHOD"] = "UNSUPPORTED METHOD";
    EIP11932["DISCONNECTED"] = "DISCONNECTED";
    EIP11932["CHAIN_DISCONNECTED"] = "CHAIN_DISCONNECTED";
    return EIP11932;
})(EIP1193 || {});
var getEIP1193ErrorCode = (error)=>{
    switch(error){
        case "USER_REJECTED_REQUEST" /* USER_REJECTED_REQUEST */ :
            return 4001;
        case "UNAUTHORIZED" /* UNAUTHORIZED */ :
            return 4100;
        case "UNSUPPORTED METHOD" /* UNSUPPORTED_METHOD */ :
            return 4200;
        case "DISCONNECTED" /* DISCONNECTED */ :
            return 4900;
        case "CHAIN_DISCONNECTED" /* CHAIN_DISCONNECTED */ :
            return 4901;
    }
};
// src/model/json-rpc/json-rpc.ts
var JSONRPCInvalidRequest = class extends ErrorBase {
};
var JSONRPCInvalidParams = class extends ErrorBase {
};
var JSONRPCInternalError = class extends ErrorBase {
};
var JSONRPCDefaultError = class extends ErrorBase {
};
var JSONRPC = /* @__PURE__ */ ((JSONRPC2)=>{
    JSONRPC2["INVALID_REQUEST"] = "INVALID_REQUEST";
    JSONRPC2["INVALID_PARAMS"] = "INVALID_PARAMS";
    JSONRPC2["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    JSONRPC2["DEFAULT"] = "DEFAULT";
    return JSONRPC2;
})(JSONRPC || {});
var getJSONRPCErrorCode = (error)=>{
    switch(error){
        case "INVALID_REQUEST" /* INVALID_REQUEST */ :
            return -32600;
        case "INVALID_PARAMS" /* INVALID_PARAMS */ :
            return -32602;
        case "INTERNAL_ERROR" /* INTERNAL_ERROR */ :
            return -32603;
        case "DEFAULT" /* DEFAULT */ :
            return -32000;
    }
};
// src/model/provider-rpc.ts
var ProviderRpcError = class extends Error {
    /**
   * The error code as specified in EIP-1193 or EIP-1474
   *
   * @link [EIP-1474](https://eips.ethereum.org/EIPS/eip-1474#error-codes)
   * @link [EIP-1193](https://eips.ethereum.org/EIPS/eip-1193#provider-errors)
   */ code;
    /**
   * Contains optional extra information about the error
   */ data;
    /**
   *
   * @param code - The error code as specified in EIP-1193 or EIP-1474
   * @param message - The error message
   * @param data - Contains optional extra information about the error
   */ constructor(code, message, data){
        super(message);
        this.code = code;
        this.data = data;
    }
};
// src/types/errorTypes.ts
var ERROR_CODES = {
    SECP256K1,
    ADDRESS,
    KEYSTORE,
    HDNODE,
    BLOOM,
    CERTIFICATE,
    ABI,
    RLP,
    DATA,
    TRANSACTION,
    HTTP_CLIENT,
    POLL_ERROR,
    FUNCTION,
    EIP1193,
    JSONRPC,
    CONTRACT
};
var ErrorClassMap = /* @__PURE__ */ new Map([
    // ADDRESS
    [
        "INVALID_ADDRESS" /* INVALID_ADDRESS */ ,
        InvalidAddressError
    ],
    // SECP256K1
    [
        "INVALID_SECP256k1_PRIVATE_KEY" /* INVALID_SECP256k1_PRIVATE_KEY */ ,
        InvalidSecp256k1PrivateKeyError
    ],
    [
        "INVALID_SECP256k1_MESSAGE_HASH" /* INVALID_SECP256k1_MESSAGE_HASH */ ,
        InvalidSecp256k1MessageHashError
    ],
    [
        "INVALID_SECP256k1_SIGNATURE" /* INVALID_SECP256k1_SIGNATURE */ ,
        InvalidSecp256k1SignatureError
    ],
    [
        "INVALID_SECP256k1_SIGNATURE_RECOVERY" /* INVALID_SECP256k1_SIGNATURE_RECOVERY */ ,
        InvalidSecp256k1SignatureRecoveryError
    ],
    // KEYSTORE
    [
        "INVALID_KEYSTORE" /* INVALID_KEYSTORE */ ,
        InvalidKeystoreError
    ],
    [
        "INVALID_PASSWORD" /* INVALID_PASSWORD */ ,
        InvalidKeystorePasswordError
    ],
    // HDNODE
    [
        "INVALID_HDNODE_CHAIN_CODE" /* INVALID_HDNODE_CHAIN_CODE */ ,
        InvalidHDNodeChaincodeError
    ],
    [
        "INVALID_HDNODE_MNEMONICS" /* INVALID_HDNODE_MNEMONICS */ ,
        InvalidHDNodeMnemonicsError
    ],
    [
        "INVALID_HDNODE_PRIVATE_KEY" /* INVALID_HDNODE_PRIVATE_KEY */ ,
        InvalidHDNodePrivateKeyError
    ],
    [
        "INVALID_HDNODE_PUBLIC_KEY" /* INVALID_HDNODE_PUBLIC_KEY */ ,
        InvalidHDNodePublicKeyError
    ],
    [
        "INVALID_HDNODE_DERIVATION_PATH" /* INVALID_HDNODE_DERIVATION_PATH */ ,
        InvalidHDNodeDerivationPathError
    ],
    [
        "INVALID_BLOOM" /* INVALID_BLOOM */ ,
        InvalidBloomError
    ],
    [
        "INVALID_K" /* INVALID_K */ ,
        InvalidKError
    ],
    // CERTIFICATE
    [
        "CERTIFICATE_NOT_SIGNED" /* CERTIFICATE_NOT_SIGNED */ ,
        CertificateNotSignedError
    ],
    [
        "CERTIFICATE_INVALID_SIGNATURE_FORMAT" /* CERTIFICATE_INVALID_SIGNATURE_FORMAT */ ,
        CertificateInvalidSignatureFormatError
    ],
    [
        "CERTIFICATE_INVALID_SIGNER" /* CERTIFICATE_INVALID_SIGNER */ ,
        CertificateInvalidSignerError
    ],
    // ABI
    [
        "INVALID_EVENT" /* INVALID_EVENT */ ,
        InvalidAbiEventError
    ],
    [
        "INVALID_DATA_TO_DECODE" /* INVALID_DATA_TO_DECODE */ ,
        InvalidAbiDataToDecodeError
    ],
    [
        "INVALID_DATA_TO_ENCODE" /* INVALID_DATA_TO_ENCODE */ ,
        InvalidAbiDataToEncodeError
    ],
    [
        "INVALID_FORMAT_TYPE" /* INVALID_FORMAT_TYPE */ ,
        InvalidAbiFormatTypeError
    ],
    [
        "INVALID_FUNCTION" /* INVALID_FUNCTION */ ,
        InvalidAbiFunctionError
    ],
    [
        "CONTRACT_INTERFACE_ERROR" /* CONTRACT_INTERFACE_ERROR */ ,
        ContractInterfaceError
    ],
    // RLP
    [
        "INVALID_RLP" /* INVALID_RLP */ ,
        InvalidRLPError
    ],
    // DATA
    [
        "INVALID_DATA_TYPE" /* INVALID_DATA_TYPE */ ,
        InvalidDataTypeError
    ],
    [
        "INVALID_DATA_RETURN_TYPE" /* INVALID_DATA_RETURN_TYPE */ ,
        InvalidDataReturnTypeError
    ],
    // TRANSACTION
    [
        "ALREADY_SIGNED" /* ALREADY_SIGNED */ ,
        TransactionAlreadySignedError
    ],
    [
        "NOT_SIGNED" /* NOT_SIGNED */ ,
        TransactionNotSignedError
    ],
    [
        "INVALID_TRANSACTION_BODY" /* INVALID_TRANSACTION_BODY */ ,
        TransactionBodyError
    ],
    [
        "INVALID_DELEGATION" /* INVALID_DELEGATION */ ,
        TransactionDelegationError
    ],
    [
        "MISSING_PRIVATE_KEY" /* MISSING_PRIVATE_KEY */ ,
        TransactionMissingPrivateKeyError
    ],
    // HTTP_CLIENT
    [
        "INVALID_HTTP_REQUEST" /* INVALID_HTTP_REQUEST */ ,
        HTTPClientError
    ],
    // POLL_ERROR
    [
        "POLL_EXECUTION_ERROR" /* POLL_EXECUTION_ERROR */ ,
        PollExecutionError
    ],
    // FUNCTION
    [
        "NOT_IMPLEMENTED" /* NOT_IMPLEMENTED */ ,
        NotImplementedError
    ],
    // EIP1193
    [
        "USER_REJECTED_REQUEST" /* USER_REJECTED_REQUEST */ ,
        EIP1193UserRejectedRequest
    ],
    [
        "UNAUTHORIZED" /* UNAUTHORIZED */ ,
        EIP1193Unauthorized
    ],
    [
        "UNSUPPORTED METHOD" /* UNSUPPORTED_METHOD */ ,
        EIP1193UnsupportedMethod
    ],
    [
        "DISCONNECTED" /* DISCONNECTED */ ,
        EIP1193Disconnected
    ],
    [
        "CHAIN_DISCONNECTED" /* CHAIN_DISCONNECTED */ ,
        EIP1193ChainDisconnected
    ],
    // JSONRPC
    [
        "INVALID_REQUEST" /* INVALID_REQUEST */ ,
        JSONRPCInvalidRequest
    ],
    [
        "INVALID_PARAMS" /* INVALID_PARAMS */ ,
        JSONRPCInvalidParams
    ],
    [
        "INTERNAL_ERROR" /* INTERNAL_ERROR */ ,
        JSONRPCInternalError
    ],
    [
        "DEFAULT" /* DEFAULT */ ,
        JSONRPCDefaultError
    ],
    // CONTRACT
    [
        "CONTRACT_DEPLOYMENT_FAILED" /* CONTRACT_DEPLOYMENT_FAILED */ ,
        ContractDeploymentFailedError
    ]
]);
// src/utils/error-message-builder/error-message-builder.ts
var stringifyData = (data)=>{
    const getCircularReplacer = ()=>{
        const seen = /* @__PURE__ */ new WeakSet();
        return (key, value)=>{
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            return value;
        };
    };
    return JSON.stringify(data, getCircularReplacer());
};
function buildErrorMessage(methodName, errorMessage, inputData, innerError) {
    return `Method '${methodName}' failed.
-Reason: '${errorMessage}'
-Parameters: 
	${stringifyData(inputData)}
-Internal error: 
	${innerError?.message !== void 0 ? innerError.message : "No internal error given"}`;
}
// src/utils/assert/assert.ts
function assert(methodName, condition, code, message, data, innerError) {
    const error = buildError(`Assertion on ${methodName}`, code, message, data, innerError);
    if (!condition && typeof error === "object") throw error;
}
function assertInnerError(error) {
    if (error instanceof Error) return error;
    return new Error(`Inner error is not an instance of Error. Object:
	${stringifyData(error)}`);
}
// src/utils/error-builder/error-builder.ts
function buildError(methodName, code, message, data, innerError) {
    const ErrorClass = ErrorClassMap.get(code);
    if (ErrorClass === void 0 || ErrorClass === null) throw new Error("Invalid error code");
    const errorMessage = buildErrorMessage(methodName, message, data, innerError === void 0 ? void 0 : assertInnerError(innerError));
    const error = new ErrorClass({
        code,
        message: errorMessage,
        data,
        innerError: innerError === void 0 ? void 0 : assertInnerError(innerError)
    });
    return error;
}
// src/utils/error-builder/provider-error-builder.ts
function buildProviderError(code, message, data) {
    const ErrorClass = ErrorClassMap.get(code);
    const _code = isEIP1193Code(code) ? getEIP1193ErrorCode(code) : getJSONRPCErrorCode(code);
    if (ErrorClass === void 0 || ErrorClass === null) throw new Error("Invalid error code");
    return new ProviderRpcError(_code, message, data);
}
function isEIP1193Code(code) {
    return Object.values(EIP1193).includes(code);
}

},{}],"2uY8v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"flaPq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flaPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"3EQvl","./helpers/bind.js":"6gclc","./core/Axios.js":"Khy2a","./core/mergeConfig.js":"kJSuZ","./defaults/index.js":"4j1z9","./helpers/formDataToJSON.js":"buQUY","./cancel/CanceledError.js":"fIigY","./cancel/CancelToken.js":"OUFBl","./cancel/isCancel.js":"ihObN","./env/data.js":"a3Jnu","./helpers/toFormData.js":"i1KRT","./core/AxiosError.js":"3mYqy","./helpers/spread.js":"3iOGk","./helpers/isAxiosError.js":"hghLN","./core/AxiosHeaders.js":"22M5b","./adapters/adapters.js":"1jXah","./helpers/HttpStatusCode.js":"8XcFy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3EQvl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"6gclc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gclc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Khy2a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"3EQvl","../helpers/buildURL.js":"7DpcZ","./InterceptorManager.js":"8y6f6","./dispatchRequest.js":"3tBG5","./mergeConfig.js":"kJSuZ","./buildFullPath.js":"1k0Ql","../helpers/validator.js":"9jha2","./AxiosHeaders.js":"22M5b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DpcZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"3EQvl","../helpers/AxiosURLSearchParams.js":"40Z7Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"40Z7Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"i1KRT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i1KRT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("6852880e0c4f2de1").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"6852880e0c4f2de1":"l5Twm","../utils.js":"3EQvl","../core/AxiosError.js":"3mYqy","../platform/node/classes/FormData.js":"fIMhN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mYqy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIMhN":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8y6f6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3tBG5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"cbzYY","../cancel/isCancel.js":"ihObN","../defaults/index.js":"4j1z9","../cancel/CanceledError.js":"fIigY","../core/AxiosHeaders.js":"22M5b","../adapters/adapters.js":"1jXah","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbzYY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"3EQvl","../defaults/index.js":"4j1z9","../core/AxiosHeaders.js":"22M5b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4j1z9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"3EQvl","../core/AxiosError.js":"3mYqy","./transitional.js":"lst2j","../helpers/toFormData.js":"i1KRT","../helpers/toURLEncodedForm.js":"iPXt6","../platform/index.js":"gw8En","../helpers/formDataToJSON.js":"buQUY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lst2j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iPXt6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"3EQvl","./toFormData.js":"i1KRT","../platform/index.js":"gw8En","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gw8En":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"4g9Qv","./common/utils.js":"5iQy8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4g9Qv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"cS94C","./classes/FormData.js":"3Dutg","./classes/Blob.js":"aBjNS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cS94C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"40Z7Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Dutg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aBjNS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5iQy8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"buQUY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"22M5b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"3EQvl","../helpers/parseHeaders.js":"8TjRt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8TjRt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihObN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fIigY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"3mYqy","../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jXah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"3EQvl","./http.js":"fIMhN","./xhr.js":"l3kxW","../core/AxiosError.js":"3mYqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3kxW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"3EQvl","./../core/settle.js":"9gvFZ","./../helpers/cookies.js":"3J7vf","./../helpers/buildURL.js":"7DpcZ","../core/buildFullPath.js":"1k0Ql","./../helpers/isURLSameOrigin.js":"gbni2","../defaults/transitional.js":"lst2j","../core/AxiosError.js":"3mYqy","../cancel/CanceledError.js":"fIigY","../helpers/parseProtocol.js":"b0hDz","../platform/index.js":"gw8En","../core/AxiosHeaders.js":"22M5b","../helpers/speedometer.js":"8d3g7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9gvFZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"3mYqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3J7vf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"3EQvl","../platform/index.js":"gw8En","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1k0Ql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"dhNqK","../helpers/combineURLs.js":"fNpOy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dhNqK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fNpOy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gbni2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"3EQvl","../platform/index.js":"gw8En","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b0hDz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8d3g7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kJSuZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"3EQvl","./AxiosHeaders.js":"22M5b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9jha2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"a3Jnu","../core/AxiosError.js":"3mYqy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a3Jnu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.8";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"OUFBl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"fIigY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3iOGk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hghLN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"3EQvl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XcFy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iZmwY":[function(require,module,exports) {
var Buffer = require("a94c134a31f0760").Buffer;
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod2)=>function __require() {
        return mod2 || (0, cb[__getOwnPropNames(cb)[0]])((mod2 = {
            exports: {}
        }).exports, mod2), mod2.exports;
    };
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod2, isNodeMode, target)=>(target = mod2 != null ? __create(__getProtoOf(mod2)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod2 || !mod2.__esModule ? __defProp(target, "default", {
        value: mod2,
        enumerable: true
    }) : target, mod2));
var __toCommonJS = (mod2)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod2);
// ../../node_modules/bn.js/lib/bn.js
var require_bn = __commonJS({
    "../../node_modules/bn.js/lib/bn.js" (exports2, module2) {
        "use strict";
        (function(module3, exports3) {
            "use strict";
            function assert29(val, msg) {
                if (!val) throw new Error(msg || "Assertion failed");
            }
            function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function() {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
            }
            function BN2(number2, base, endian) {
                if (BN2.isBN(number2)) return number2;
                this.negative = 0;
                this.words = null;
                this.length = 0;
                this.red = null;
                if (number2 !== null) {
                    if (base === "le" || base === "be") {
                        endian = base;
                        base = 10;
                    }
                    this._init(number2 || 0, base || 10, endian || "be");
                }
            }
            if (typeof module3 === "object") module3.exports = BN2;
            else exports3.BN = BN2;
            BN2.BN = BN2;
            BN2.wordSize = 26;
            var Buffer5;
            try {
                if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer5 = window.Buffer;
                else Buffer5 = require("a94c134a31f0760").Buffer;
            } catch (e) {}
            BN2.isBN = function isBN(num) {
                if (num instanceof BN2) return true;
                return num !== null && typeof num === "object" && num.constructor.wordSize === BN2.wordSize && Array.isArray(num.words);
            };
            BN2.max = function max(left, right) {
                if (left.cmp(right) > 0) return left;
                return right;
            };
            BN2.min = function min(left, right) {
                if (left.cmp(right) < 0) return left;
                return right;
            };
            BN2.prototype._init = function init(number2, base, endian) {
                if (typeof number2 === "number") return this._initNumber(number2, base, endian);
                if (typeof number2 === "object") return this._initArray(number2, base, endian);
                if (base === "hex") base = 16;
                assert29(base === (base | 0) && base >= 2 && base <= 36);
                number2 = number2.toString().replace(/\s+/g, "");
                var start = 0;
                if (number2[0] === "-") {
                    start++;
                    this.negative = 1;
                }
                if (start < number2.length) {
                    if (base === 16) this._parseHex(number2, start, endian);
                    else {
                        this._parseBase(number2, base, start);
                        if (endian === "le") this._initArray(this.toArray(), base, endian);
                    }
                }
            };
            BN2.prototype._initNumber = function _initNumber(number2, base, endian) {
                if (number2 < 0) {
                    this.negative = 1;
                    number2 = -number2;
                }
                if (number2 < 67108864) {
                    this.words = [
                        number2 & 67108863
                    ];
                    this.length = 1;
                } else if (number2 < 4503599627370496) {
                    this.words = [
                        number2 & 67108863,
                        number2 / 67108864 & 67108863
                    ];
                    this.length = 2;
                } else {
                    assert29(number2 < 9007199254740992);
                    this.words = [
                        number2 & 67108863,
                        number2 / 67108864 & 67108863,
                        1
                    ];
                    this.length = 3;
                }
                if (endian !== "le") return;
                this._initArray(this.toArray(), base, endian);
            };
            BN2.prototype._initArray = function _initArray(number2, base, endian) {
                assert29(typeof number2.length === "number");
                if (number2.length <= 0) {
                    this.words = [
                        0
                    ];
                    this.length = 1;
                    return this;
                }
                this.length = Math.ceil(number2.length / 3);
                this.words = new Array(this.length);
                for(var i = 0; i < this.length; i++)this.words[i] = 0;
                var j, w;
                var off = 0;
                if (endian === "be") for(i = number2.length - 1, j = 0; i >= 0; i -= 3){
                    w = number2[i] | number2[i - 1] << 8 | number2[i - 2] << 16;
                    this.words[j] |= w << off & 67108863;
                    this.words[j + 1] = w >>> 26 - off & 67108863;
                    off += 24;
                    if (off >= 26) {
                        off -= 26;
                        j++;
                    }
                }
                else if (endian === "le") for(i = 0, j = 0; i < number2.length; i += 3){
                    w = number2[i] | number2[i + 1] << 8 | number2[i + 2] << 16;
                    this.words[j] |= w << off & 67108863;
                    this.words[j + 1] = w >>> 26 - off & 67108863;
                    off += 24;
                    if (off >= 26) {
                        off -= 26;
                        j++;
                    }
                }
                return this.strip();
            };
            function parseHex4Bits(string, index) {
                var c = string.charCodeAt(index);
                if (c >= 65 && c <= 70) return c - 55;
                else if (c >= 97 && c <= 102) return c - 87;
                else return c - 48 & 15;
            }
            function parseHexByte(string, lowerBound, index) {
                var r = parseHex4Bits(string, index);
                if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
                return r;
            }
            BN2.prototype._parseHex = function _parseHex(number2, start, endian) {
                this.length = Math.ceil((number2.length - start) / 6);
                this.words = new Array(this.length);
                for(var i = 0; i < this.length; i++)this.words[i] = 0;
                var off = 0;
                var j = 0;
                var w;
                if (endian === "be") for(i = number2.length - 1; i >= start; i -= 2){
                    w = parseHexByte(number2, start, i) << off;
                    this.words[j] |= w & 67108863;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
                else {
                    var parseLength = number2.length - start;
                    for(i = parseLength % 2 === 0 ? start + 1 : start; i < number2.length; i += 2){
                        w = parseHexByte(number2, start, i) << off;
                        this.words[j] |= w & 67108863;
                        if (off >= 18) {
                            off -= 18;
                            j += 1;
                            this.words[j] |= w >>> 26;
                        } else off += 8;
                    }
                }
                this.strip();
            };
            function parseBase(str, start, end, mul) {
                var r = 0;
                var len = Math.min(str.length, end);
                for(var i = start; i < len; i++){
                    var c = str.charCodeAt(i) - 48;
                    r *= mul;
                    if (c >= 49) r += c - 49 + 10;
                    else if (c >= 17) r += c - 17 + 10;
                    else r += c;
                }
                return r;
            }
            BN2.prototype._parseBase = function _parseBase(number2, base, start) {
                this.words = [
                    0
                ];
                this.length = 1;
                for(var limbLen = 0, limbPow = 1; limbPow <= 67108863; limbPow *= base)limbLen++;
                limbLen--;
                limbPow = limbPow / base | 0;
                var total = number2.length - start;
                var mod2 = total % limbLen;
                var end = Math.min(total, total - mod2) + start;
                var word = 0;
                for(var i = start; i < end; i += limbLen){
                    word = parseBase(number2, i, i + limbLen, base);
                    this.imuln(limbPow);
                    if (this.words[0] + word < 67108864) this.words[0] += word;
                    else this._iaddn(word);
                }
                if (mod2 !== 0) {
                    var pow3 = 1;
                    word = parseBase(number2, i, number2.length, base);
                    for(i = 0; i < mod2; i++)pow3 *= base;
                    this.imuln(pow3);
                    if (this.words[0] + word < 67108864) this.words[0] += word;
                    else this._iaddn(word);
                }
                this.strip();
            };
            BN2.prototype.copy = function copy(dest) {
                dest.words = new Array(this.length);
                for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
                dest.length = this.length;
                dest.negative = this.negative;
                dest.red = this.red;
            };
            BN2.prototype.clone = function clone() {
                var r = new BN2(null);
                this.copy(r);
                return r;
            };
            BN2.prototype._expand = function _expand(size) {
                while(this.length < size)this.words[this.length++] = 0;
                return this;
            };
            BN2.prototype.strip = function strip() {
                while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
                return this._normSign();
            };
            BN2.prototype._normSign = function _normSign() {
                if (this.length === 1 && this.words[0] === 0) this.negative = 0;
                return this;
            };
            BN2.prototype.inspect = function inspect() {
                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            };
            var zeros = [
                "",
                "0",
                "00",
                "000",
                "0000",
                "00000",
                "000000",
                "0000000",
                "00000000",
                "000000000",
                "0000000000",
                "00000000000",
                "000000000000",
                "0000000000000",
                "00000000000000",
                "000000000000000",
                "0000000000000000",
                "00000000000000000",
                "000000000000000000",
                "0000000000000000000",
                "00000000000000000000",
                "000000000000000000000",
                "0000000000000000000000",
                "00000000000000000000000",
                "000000000000000000000000",
                "0000000000000000000000000"
            ];
            var groupSizes = [
                0,
                0,
                25,
                16,
                12,
                11,
                10,
                9,
                8,
                8,
                7,
                7,
                7,
                7,
                6,
                6,
                6,
                6,
                6,
                6,
                6,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5,
                5
            ];
            var groupBases = [
                0,
                0,
                33554432,
                43046721,
                16777216,
                48828125,
                60466176,
                40353607,
                16777216,
                43046721,
                1e7,
                19487171,
                35831808,
                62748517,
                7529536,
                11390625,
                16777216,
                24137569,
                34012224,
                47045881,
                64e6,
                4084101,
                5153632,
                6436343,
                7962624,
                9765625,
                11881376,
                14348907,
                17210368,
                20511149,
                243e5,
                28629151,
                33554432,
                39135393,
                45435424,
                52521875,
                60466176
            ];
            BN2.prototype.toString = function toString(base, padding) {
                base = base || 10;
                padding = padding | 0 || 1;
                var out;
                if (base === 16 || base === "hex") {
                    out = "";
                    var off = 0;
                    var carry = 0;
                    for(var i = 0; i < this.length; i++){
                        var w = this.words[i];
                        var word = ((w << off | carry) & 16777215).toString(16);
                        carry = w >>> 24 - off & 16777215;
                        if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                        else out = word + out;
                        off += 2;
                        if (off >= 26) {
                            off -= 26;
                            i--;
                        }
                    }
                    if (carry !== 0) out = carry.toString(16) + out;
                    while(out.length % padding !== 0)out = "0" + out;
                    if (this.negative !== 0) out = "-" + out;
                    return out;
                }
                if (base === (base | 0) && base >= 2 && base <= 36) {
                    var groupSize = groupSizes[base];
                    var groupBase = groupBases[base];
                    out = "";
                    var c = this.clone();
                    c.negative = 0;
                    while(!c.isZero()){
                        var r = c.modn(groupBase).toString(base);
                        c = c.idivn(groupBase);
                        if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                        else out = r + out;
                    }
                    if (this.isZero()) out = "0" + out;
                    while(out.length % padding !== 0)out = "0" + out;
                    if (this.negative !== 0) out = "-" + out;
                    return out;
                }
                assert29(false, "Base should be between 2 and 36");
            };
            BN2.prototype.toNumber = function toNumber() {
                var ret = this.words[0];
                if (this.length === 2) ret += this.words[1] * 67108864;
                else if (this.length === 3 && this.words[2] === 1) ret += 4503599627370496 + this.words[1] * 67108864;
                else if (this.length > 2) assert29(false, "Number can only safely store up to 53 bits");
                return this.negative !== 0 ? -ret : ret;
            };
            BN2.prototype.toJSON = function toJSON() {
                return this.toString(16);
            };
            BN2.prototype.toBuffer = function toBuffer(endian, length) {
                assert29(typeof Buffer5 !== "undefined");
                return this.toArrayLike(Buffer5, endian, length);
            };
            BN2.prototype.toArray = function toArray(endian, length) {
                return this.toArrayLike(Array, endian, length);
            };
            BN2.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
                var byteLength = this.byteLength();
                var reqLength = length || Math.max(1, byteLength);
                assert29(byteLength <= reqLength, "byte array longer than desired length");
                assert29(reqLength > 0, "Requested array length <= 0");
                this.strip();
                var littleEndian = endian === "le";
                var res = new ArrayType(reqLength);
                var b, i;
                var q = this.clone();
                if (!littleEndian) {
                    for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
                    for(i = 0; !q.isZero(); i++){
                        b = q.andln(255);
                        q.iushrn(8);
                        res[reqLength - i - 1] = b;
                    }
                } else {
                    for(i = 0; !q.isZero(); i++){
                        b = q.andln(255);
                        q.iushrn(8);
                        res[i] = b;
                    }
                    for(; i < reqLength; i++)res[i] = 0;
                }
                return res;
            };
            if (Math.clz32) BN2.prototype._countBits = function _countBits(w) {
                return 32 - Math.clz32(w);
            };
            else BN2.prototype._countBits = function _countBits(w) {
                var t = w;
                var r = 0;
                if (t >= 4096) {
                    r += 13;
                    t >>>= 13;
                }
                if (t >= 64) {
                    r += 7;
                    t >>>= 7;
                }
                if (t >= 8) {
                    r += 4;
                    t >>>= 4;
                }
                if (t >= 2) {
                    r += 2;
                    t >>>= 2;
                }
                return r + t;
            };
            BN2.prototype._zeroBits = function _zeroBits(w) {
                if (w === 0) return 26;
                var t = w;
                var r = 0;
                if ((t & 8191) === 0) {
                    r += 13;
                    t >>>= 13;
                }
                if ((t & 127) === 0) {
                    r += 7;
                    t >>>= 7;
                }
                if ((t & 15) === 0) {
                    r += 4;
                    t >>>= 4;
                }
                if ((t & 3) === 0) {
                    r += 2;
                    t >>>= 2;
                }
                if ((t & 1) === 0) r++;
                return r;
            };
            BN2.prototype.bitLength = function bitLength() {
                var w = this.words[this.length - 1];
                var hi = this._countBits(w);
                return (this.length - 1) * 26 + hi;
            };
            function toBitArray(num) {
                var w = new Array(num.bitLength());
                for(var bit = 0; bit < w.length; bit++){
                    var off = bit / 26 | 0;
                    var wbit = bit % 26;
                    w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
                }
                return w;
            }
            BN2.prototype.zeroBits = function zeroBits() {
                if (this.isZero()) return 0;
                var r = 0;
                for(var i = 0; i < this.length; i++){
                    var b = this._zeroBits(this.words[i]);
                    r += b;
                    if (b !== 26) break;
                }
                return r;
            };
            BN2.prototype.byteLength = function byteLength() {
                return Math.ceil(this.bitLength() / 8);
            };
            BN2.prototype.toTwos = function toTwos(width) {
                if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
                return this.clone();
            };
            BN2.prototype.fromTwos = function fromTwos(width) {
                if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
                return this.clone();
            };
            BN2.prototype.isNeg = function isNeg() {
                return this.negative !== 0;
            };
            BN2.prototype.neg = function neg() {
                return this.clone().ineg();
            };
            BN2.prototype.ineg = function ineg() {
                if (!this.isZero()) this.negative ^= 1;
                return this;
            };
            BN2.prototype.iuor = function iuor(num) {
                while(this.length < num.length)this.words[this.length++] = 0;
                for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
                return this.strip();
            };
            BN2.prototype.ior = function ior(num) {
                assert29((this.negative | num.negative) === 0);
                return this.iuor(num);
            };
            BN2.prototype.or = function or(num) {
                if (this.length > num.length) return this.clone().ior(num);
                return num.clone().ior(this);
            };
            BN2.prototype.uor = function uor(num) {
                if (this.length > num.length) return this.clone().iuor(num);
                return num.clone().iuor(this);
            };
            BN2.prototype.iuand = function iuand(num) {
                var b;
                if (this.length > num.length) b = num;
                else b = this;
                for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
                this.length = b.length;
                return this.strip();
            };
            BN2.prototype.iand = function iand(num) {
                assert29((this.negative | num.negative) === 0);
                return this.iuand(num);
            };
            BN2.prototype.and = function and(num) {
                if (this.length > num.length) return this.clone().iand(num);
                return num.clone().iand(this);
            };
            BN2.prototype.uand = function uand(num) {
                if (this.length > num.length) return this.clone().iuand(num);
                return num.clone().iuand(this);
            };
            BN2.prototype.iuxor = function iuxor(num) {
                var a;
                var b;
                if (this.length > num.length) {
                    a = this;
                    b = num;
                } else {
                    a = num;
                    b = this;
                }
                for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
                if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
                this.length = a.length;
                return this.strip();
            };
            BN2.prototype.ixor = function ixor(num) {
                assert29((this.negative | num.negative) === 0);
                return this.iuxor(num);
            };
            BN2.prototype.xor = function xor(num) {
                if (this.length > num.length) return this.clone().ixor(num);
                return num.clone().ixor(this);
            };
            BN2.prototype.uxor = function uxor(num) {
                if (this.length > num.length) return this.clone().iuxor(num);
                return num.clone().iuxor(this);
            };
            BN2.prototype.inotn = function inotn(width) {
                assert29(typeof width === "number" && width >= 0);
                var bytesNeeded = Math.ceil(width / 26) | 0;
                var bitsLeft = width % 26;
                this._expand(bytesNeeded);
                if (bitsLeft > 0) bytesNeeded--;
                for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 67108863;
                if (bitsLeft > 0) this.words[i] = ~this.words[i] & 67108863 >> 26 - bitsLeft;
                return this.strip();
            };
            BN2.prototype.notn = function notn(width) {
                return this.clone().inotn(width);
            };
            BN2.prototype.setn = function setn(bit, val) {
                assert29(typeof bit === "number" && bit >= 0);
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                this._expand(off + 1);
                if (val) this.words[off] = this.words[off] | 1 << wbit;
                else this.words[off] = this.words[off] & ~(1 << wbit);
                return this.strip();
            };
            BN2.prototype.iadd = function iadd(num) {
                var r;
                if (this.negative !== 0 && num.negative === 0) {
                    this.negative = 0;
                    r = this.isub(num);
                    this.negative ^= 1;
                    return this._normSign();
                } else if (this.negative === 0 && num.negative !== 0) {
                    num.negative = 0;
                    r = this.isub(num);
                    num.negative = 1;
                    return r._normSign();
                }
                var a, b;
                if (this.length > num.length) {
                    a = this;
                    b = num;
                } else {
                    a = num;
                    b = this;
                }
                var carry = 0;
                for(var i = 0; i < b.length; i++){
                    r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                    this.words[i] = r & 67108863;
                    carry = r >>> 26;
                }
                for(; carry !== 0 && i < a.length; i++){
                    r = (a.words[i] | 0) + carry;
                    this.words[i] = r & 67108863;
                    carry = r >>> 26;
                }
                this.length = a.length;
                if (carry !== 0) {
                    this.words[this.length] = carry;
                    this.length++;
                } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                return this;
            };
            BN2.prototype.add = function add(num) {
                var res;
                if (num.negative !== 0 && this.negative === 0) {
                    num.negative = 0;
                    res = this.sub(num);
                    num.negative ^= 1;
                    return res;
                } else if (num.negative === 0 && this.negative !== 0) {
                    this.negative = 0;
                    res = num.sub(this);
                    this.negative = 1;
                    return res;
                }
                if (this.length > num.length) return this.clone().iadd(num);
                return num.clone().iadd(this);
            };
            BN2.prototype.isub = function isub(num) {
                if (num.negative !== 0) {
                    num.negative = 0;
                    var r = this.iadd(num);
                    num.negative = 1;
                    return r._normSign();
                } else if (this.negative !== 0) {
                    this.negative = 0;
                    this.iadd(num);
                    this.negative = 1;
                    return this._normSign();
                }
                var cmp = this.cmp(num);
                if (cmp === 0) {
                    this.negative = 0;
                    this.length = 1;
                    this.words[0] = 0;
                    return this;
                }
                var a, b;
                if (cmp > 0) {
                    a = this;
                    b = num;
                } else {
                    a = num;
                    b = this;
                }
                var carry = 0;
                for(var i = 0; i < b.length; i++){
                    r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                    carry = r >> 26;
                    this.words[i] = r & 67108863;
                }
                for(; carry !== 0 && i < a.length; i++){
                    r = (a.words[i] | 0) + carry;
                    carry = r >> 26;
                    this.words[i] = r & 67108863;
                }
                if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
                this.length = Math.max(this.length, i);
                if (a !== this) this.negative = 1;
                return this.strip();
            };
            BN2.prototype.sub = function sub(num) {
                return this.clone().isub(num);
            };
            function smallMulTo(self, num, out) {
                out.negative = num.negative ^ self.negative;
                var len = self.length + num.length | 0;
                out.length = len;
                len = len - 1 | 0;
                var a = self.words[0] | 0;
                var b = num.words[0] | 0;
                var r = a * b;
                var lo = r & 67108863;
                var carry = r / 67108864 | 0;
                out.words[0] = lo;
                for(var k = 1; k < len; k++){
                    var ncarry = carry >>> 26;
                    var rword = carry & 67108863;
                    var maxJ = Math.min(k, num.length - 1);
                    for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                        var i = k - j | 0;
                        a = self.words[i] | 0;
                        b = num.words[j] | 0;
                        r = a * b + rword;
                        ncarry += r / 67108864 | 0;
                        rword = r & 67108863;
                    }
                    out.words[k] = rword | 0;
                    carry = ncarry | 0;
                }
                if (carry !== 0) out.words[k] = carry | 0;
                else out.length--;
                return out.strip();
            }
            var comb10MulTo = function comb10MulTo2(self, num, out) {
                var a = self.words;
                var b = num.words;
                var o = out.words;
                var c = 0;
                var lo;
                var mid;
                var hi;
                var a0 = a[0] | 0;
                var al0 = a0 & 8191;
                var ah0 = a0 >>> 13;
                var a1 = a[1] | 0;
                var al1 = a1 & 8191;
                var ah1 = a1 >>> 13;
                var a2 = a[2] | 0;
                var al2 = a2 & 8191;
                var ah2 = a2 >>> 13;
                var a3 = a[3] | 0;
                var al3 = a3 & 8191;
                var ah3 = a3 >>> 13;
                var a4 = a[4] | 0;
                var al4 = a4 & 8191;
                var ah4 = a4 >>> 13;
                var a5 = a[5] | 0;
                var al5 = a5 & 8191;
                var ah5 = a5 >>> 13;
                var a6 = a[6] | 0;
                var al6 = a6 & 8191;
                var ah6 = a6 >>> 13;
                var a7 = a[7] | 0;
                var al7 = a7 & 8191;
                var ah7 = a7 >>> 13;
                var a8 = a[8] | 0;
                var al8 = a8 & 8191;
                var ah8 = a8 >>> 13;
                var a9 = a[9] | 0;
                var al9 = a9 & 8191;
                var ah9 = a9 >>> 13;
                var b0 = b[0] | 0;
                var bl0 = b0 & 8191;
                var bh0 = b0 >>> 13;
                var b1 = b[1] | 0;
                var bl1 = b1 & 8191;
                var bh1 = b1 >>> 13;
                var b2 = b[2] | 0;
                var bl2 = b2 & 8191;
                var bh2 = b2 >>> 13;
                var b3 = b[3] | 0;
                var bl3 = b3 & 8191;
                var bh3 = b3 >>> 13;
                var b4 = b[4] | 0;
                var bl4 = b4 & 8191;
                var bh4 = b4 >>> 13;
                var b5 = b[5] | 0;
                var bl5 = b5 & 8191;
                var bh5 = b5 >>> 13;
                var b6 = b[6] | 0;
                var bl6 = b6 & 8191;
                var bh6 = b6 >>> 13;
                var b7 = b[7] | 0;
                var bl7 = b7 & 8191;
                var bh7 = b7 >>> 13;
                var b8 = b[8] | 0;
                var bl8 = b8 & 8191;
                var bh8 = b8 >>> 13;
                var b9 = b[9] | 0;
                var bl9 = b9 & 8191;
                var bh9 = b9 >>> 13;
                out.negative = self.negative ^ num.negative;
                out.length = 19;
                lo = Math.imul(al0, bl0);
                mid = Math.imul(al0, bh0);
                mid = mid + Math.imul(ah0, bl0) | 0;
                hi = Math.imul(ah0, bh0);
                var w0 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
                w0 &= 67108863;
                lo = Math.imul(al1, bl0);
                mid = Math.imul(al1, bh0);
                mid = mid + Math.imul(ah1, bl0) | 0;
                hi = Math.imul(ah1, bh0);
                lo = lo + Math.imul(al0, bl1) | 0;
                mid = mid + Math.imul(al0, bh1) | 0;
                mid = mid + Math.imul(ah0, bl1) | 0;
                hi = hi + Math.imul(ah0, bh1) | 0;
                var w1 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
                w1 &= 67108863;
                lo = Math.imul(al2, bl0);
                mid = Math.imul(al2, bh0);
                mid = mid + Math.imul(ah2, bl0) | 0;
                hi = Math.imul(ah2, bh0);
                lo = lo + Math.imul(al1, bl1) | 0;
                mid = mid + Math.imul(al1, bh1) | 0;
                mid = mid + Math.imul(ah1, bl1) | 0;
                hi = hi + Math.imul(ah1, bh1) | 0;
                lo = lo + Math.imul(al0, bl2) | 0;
                mid = mid + Math.imul(al0, bh2) | 0;
                mid = mid + Math.imul(ah0, bl2) | 0;
                hi = hi + Math.imul(ah0, bh2) | 0;
                var w2 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
                w2 &= 67108863;
                lo = Math.imul(al3, bl0);
                mid = Math.imul(al3, bh0);
                mid = mid + Math.imul(ah3, bl0) | 0;
                hi = Math.imul(ah3, bh0);
                lo = lo + Math.imul(al2, bl1) | 0;
                mid = mid + Math.imul(al2, bh1) | 0;
                mid = mid + Math.imul(ah2, bl1) | 0;
                hi = hi + Math.imul(ah2, bh1) | 0;
                lo = lo + Math.imul(al1, bl2) | 0;
                mid = mid + Math.imul(al1, bh2) | 0;
                mid = mid + Math.imul(ah1, bl2) | 0;
                hi = hi + Math.imul(ah1, bh2) | 0;
                lo = lo + Math.imul(al0, bl3) | 0;
                mid = mid + Math.imul(al0, bh3) | 0;
                mid = mid + Math.imul(ah0, bl3) | 0;
                hi = hi + Math.imul(ah0, bh3) | 0;
                var w3 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
                w3 &= 67108863;
                lo = Math.imul(al4, bl0);
                mid = Math.imul(al4, bh0);
                mid = mid + Math.imul(ah4, bl0) | 0;
                hi = Math.imul(ah4, bh0);
                lo = lo + Math.imul(al3, bl1) | 0;
                mid = mid + Math.imul(al3, bh1) | 0;
                mid = mid + Math.imul(ah3, bl1) | 0;
                hi = hi + Math.imul(ah3, bh1) | 0;
                lo = lo + Math.imul(al2, bl2) | 0;
                mid = mid + Math.imul(al2, bh2) | 0;
                mid = mid + Math.imul(ah2, bl2) | 0;
                hi = hi + Math.imul(ah2, bh2) | 0;
                lo = lo + Math.imul(al1, bl3) | 0;
                mid = mid + Math.imul(al1, bh3) | 0;
                mid = mid + Math.imul(ah1, bl3) | 0;
                hi = hi + Math.imul(ah1, bh3) | 0;
                lo = lo + Math.imul(al0, bl4) | 0;
                mid = mid + Math.imul(al0, bh4) | 0;
                mid = mid + Math.imul(ah0, bl4) | 0;
                hi = hi + Math.imul(ah0, bh4) | 0;
                var w4 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
                w4 &= 67108863;
                lo = Math.imul(al5, bl0);
                mid = Math.imul(al5, bh0);
                mid = mid + Math.imul(ah5, bl0) | 0;
                hi = Math.imul(ah5, bh0);
                lo = lo + Math.imul(al4, bl1) | 0;
                mid = mid + Math.imul(al4, bh1) | 0;
                mid = mid + Math.imul(ah4, bl1) | 0;
                hi = hi + Math.imul(ah4, bh1) | 0;
                lo = lo + Math.imul(al3, bl2) | 0;
                mid = mid + Math.imul(al3, bh2) | 0;
                mid = mid + Math.imul(ah3, bl2) | 0;
                hi = hi + Math.imul(ah3, bh2) | 0;
                lo = lo + Math.imul(al2, bl3) | 0;
                mid = mid + Math.imul(al2, bh3) | 0;
                mid = mid + Math.imul(ah2, bl3) | 0;
                hi = hi + Math.imul(ah2, bh3) | 0;
                lo = lo + Math.imul(al1, bl4) | 0;
                mid = mid + Math.imul(al1, bh4) | 0;
                mid = mid + Math.imul(ah1, bl4) | 0;
                hi = hi + Math.imul(ah1, bh4) | 0;
                lo = lo + Math.imul(al0, bl5) | 0;
                mid = mid + Math.imul(al0, bh5) | 0;
                mid = mid + Math.imul(ah0, bl5) | 0;
                hi = hi + Math.imul(ah0, bh5) | 0;
                var w5 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
                w5 &= 67108863;
                lo = Math.imul(al6, bl0);
                mid = Math.imul(al6, bh0);
                mid = mid + Math.imul(ah6, bl0) | 0;
                hi = Math.imul(ah6, bh0);
                lo = lo + Math.imul(al5, bl1) | 0;
                mid = mid + Math.imul(al5, bh1) | 0;
                mid = mid + Math.imul(ah5, bl1) | 0;
                hi = hi + Math.imul(ah5, bh1) | 0;
                lo = lo + Math.imul(al4, bl2) | 0;
                mid = mid + Math.imul(al4, bh2) | 0;
                mid = mid + Math.imul(ah4, bl2) | 0;
                hi = hi + Math.imul(ah4, bh2) | 0;
                lo = lo + Math.imul(al3, bl3) | 0;
                mid = mid + Math.imul(al3, bh3) | 0;
                mid = mid + Math.imul(ah3, bl3) | 0;
                hi = hi + Math.imul(ah3, bh3) | 0;
                lo = lo + Math.imul(al2, bl4) | 0;
                mid = mid + Math.imul(al2, bh4) | 0;
                mid = mid + Math.imul(ah2, bl4) | 0;
                hi = hi + Math.imul(ah2, bh4) | 0;
                lo = lo + Math.imul(al1, bl5) | 0;
                mid = mid + Math.imul(al1, bh5) | 0;
                mid = mid + Math.imul(ah1, bl5) | 0;
                hi = hi + Math.imul(ah1, bh5) | 0;
                lo = lo + Math.imul(al0, bl6) | 0;
                mid = mid + Math.imul(al0, bh6) | 0;
                mid = mid + Math.imul(ah0, bl6) | 0;
                hi = hi + Math.imul(ah0, bh6) | 0;
                var w6 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
                w6 &= 67108863;
                lo = Math.imul(al7, bl0);
                mid = Math.imul(al7, bh0);
                mid = mid + Math.imul(ah7, bl0) | 0;
                hi = Math.imul(ah7, bh0);
                lo = lo + Math.imul(al6, bl1) | 0;
                mid = mid + Math.imul(al6, bh1) | 0;
                mid = mid + Math.imul(ah6, bl1) | 0;
                hi = hi + Math.imul(ah6, bh1) | 0;
                lo = lo + Math.imul(al5, bl2) | 0;
                mid = mid + Math.imul(al5, bh2) | 0;
                mid = mid + Math.imul(ah5, bl2) | 0;
                hi = hi + Math.imul(ah5, bh2) | 0;
                lo = lo + Math.imul(al4, bl3) | 0;
                mid = mid + Math.imul(al4, bh3) | 0;
                mid = mid + Math.imul(ah4, bl3) | 0;
                hi = hi + Math.imul(ah4, bh3) | 0;
                lo = lo + Math.imul(al3, bl4) | 0;
                mid = mid + Math.imul(al3, bh4) | 0;
                mid = mid + Math.imul(ah3, bl4) | 0;
                hi = hi + Math.imul(ah3, bh4) | 0;
                lo = lo + Math.imul(al2, bl5) | 0;
                mid = mid + Math.imul(al2, bh5) | 0;
                mid = mid + Math.imul(ah2, bl5) | 0;
                hi = hi + Math.imul(ah2, bh5) | 0;
                lo = lo + Math.imul(al1, bl6) | 0;
                mid = mid + Math.imul(al1, bh6) | 0;
                mid = mid + Math.imul(ah1, bl6) | 0;
                hi = hi + Math.imul(ah1, bh6) | 0;
                lo = lo + Math.imul(al0, bl7) | 0;
                mid = mid + Math.imul(al0, bh7) | 0;
                mid = mid + Math.imul(ah0, bl7) | 0;
                hi = hi + Math.imul(ah0, bh7) | 0;
                var w7 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
                w7 &= 67108863;
                lo = Math.imul(al8, bl0);
                mid = Math.imul(al8, bh0);
                mid = mid + Math.imul(ah8, bl0) | 0;
                hi = Math.imul(ah8, bh0);
                lo = lo + Math.imul(al7, bl1) | 0;
                mid = mid + Math.imul(al7, bh1) | 0;
                mid = mid + Math.imul(ah7, bl1) | 0;
                hi = hi + Math.imul(ah7, bh1) | 0;
                lo = lo + Math.imul(al6, bl2) | 0;
                mid = mid + Math.imul(al6, bh2) | 0;
                mid = mid + Math.imul(ah6, bl2) | 0;
                hi = hi + Math.imul(ah6, bh2) | 0;
                lo = lo + Math.imul(al5, bl3) | 0;
                mid = mid + Math.imul(al5, bh3) | 0;
                mid = mid + Math.imul(ah5, bl3) | 0;
                hi = hi + Math.imul(ah5, bh3) | 0;
                lo = lo + Math.imul(al4, bl4) | 0;
                mid = mid + Math.imul(al4, bh4) | 0;
                mid = mid + Math.imul(ah4, bl4) | 0;
                hi = hi + Math.imul(ah4, bh4) | 0;
                lo = lo + Math.imul(al3, bl5) | 0;
                mid = mid + Math.imul(al3, bh5) | 0;
                mid = mid + Math.imul(ah3, bl5) | 0;
                hi = hi + Math.imul(ah3, bh5) | 0;
                lo = lo + Math.imul(al2, bl6) | 0;
                mid = mid + Math.imul(al2, bh6) | 0;
                mid = mid + Math.imul(ah2, bl6) | 0;
                hi = hi + Math.imul(ah2, bh6) | 0;
                lo = lo + Math.imul(al1, bl7) | 0;
                mid = mid + Math.imul(al1, bh7) | 0;
                mid = mid + Math.imul(ah1, bl7) | 0;
                hi = hi + Math.imul(ah1, bh7) | 0;
                lo = lo + Math.imul(al0, bl8) | 0;
                mid = mid + Math.imul(al0, bh8) | 0;
                mid = mid + Math.imul(ah0, bl8) | 0;
                hi = hi + Math.imul(ah0, bh8) | 0;
                var w8 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
                w8 &= 67108863;
                lo = Math.imul(al9, bl0);
                mid = Math.imul(al9, bh0);
                mid = mid + Math.imul(ah9, bl0) | 0;
                hi = Math.imul(ah9, bh0);
                lo = lo + Math.imul(al8, bl1) | 0;
                mid = mid + Math.imul(al8, bh1) | 0;
                mid = mid + Math.imul(ah8, bl1) | 0;
                hi = hi + Math.imul(ah8, bh1) | 0;
                lo = lo + Math.imul(al7, bl2) | 0;
                mid = mid + Math.imul(al7, bh2) | 0;
                mid = mid + Math.imul(ah7, bl2) | 0;
                hi = hi + Math.imul(ah7, bh2) | 0;
                lo = lo + Math.imul(al6, bl3) | 0;
                mid = mid + Math.imul(al6, bh3) | 0;
                mid = mid + Math.imul(ah6, bl3) | 0;
                hi = hi + Math.imul(ah6, bh3) | 0;
                lo = lo + Math.imul(al5, bl4) | 0;
                mid = mid + Math.imul(al5, bh4) | 0;
                mid = mid + Math.imul(ah5, bl4) | 0;
                hi = hi + Math.imul(ah5, bh4) | 0;
                lo = lo + Math.imul(al4, bl5) | 0;
                mid = mid + Math.imul(al4, bh5) | 0;
                mid = mid + Math.imul(ah4, bl5) | 0;
                hi = hi + Math.imul(ah4, bh5) | 0;
                lo = lo + Math.imul(al3, bl6) | 0;
                mid = mid + Math.imul(al3, bh6) | 0;
                mid = mid + Math.imul(ah3, bl6) | 0;
                hi = hi + Math.imul(ah3, bh6) | 0;
                lo = lo + Math.imul(al2, bl7) | 0;
                mid = mid + Math.imul(al2, bh7) | 0;
                mid = mid + Math.imul(ah2, bl7) | 0;
                hi = hi + Math.imul(ah2, bh7) | 0;
                lo = lo + Math.imul(al1, bl8) | 0;
                mid = mid + Math.imul(al1, bh8) | 0;
                mid = mid + Math.imul(ah1, bl8) | 0;
                hi = hi + Math.imul(ah1, bh8) | 0;
                lo = lo + Math.imul(al0, bl9) | 0;
                mid = mid + Math.imul(al0, bh9) | 0;
                mid = mid + Math.imul(ah0, bl9) | 0;
                hi = hi + Math.imul(ah0, bh9) | 0;
                var w9 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
                w9 &= 67108863;
                lo = Math.imul(al9, bl1);
                mid = Math.imul(al9, bh1);
                mid = mid + Math.imul(ah9, bl1) | 0;
                hi = Math.imul(ah9, bh1);
                lo = lo + Math.imul(al8, bl2) | 0;
                mid = mid + Math.imul(al8, bh2) | 0;
                mid = mid + Math.imul(ah8, bl2) | 0;
                hi = hi + Math.imul(ah8, bh2) | 0;
                lo = lo + Math.imul(al7, bl3) | 0;
                mid = mid + Math.imul(al7, bh3) | 0;
                mid = mid + Math.imul(ah7, bl3) | 0;
                hi = hi + Math.imul(ah7, bh3) | 0;
                lo = lo + Math.imul(al6, bl4) | 0;
                mid = mid + Math.imul(al6, bh4) | 0;
                mid = mid + Math.imul(ah6, bl4) | 0;
                hi = hi + Math.imul(ah6, bh4) | 0;
                lo = lo + Math.imul(al5, bl5) | 0;
                mid = mid + Math.imul(al5, bh5) | 0;
                mid = mid + Math.imul(ah5, bl5) | 0;
                hi = hi + Math.imul(ah5, bh5) | 0;
                lo = lo + Math.imul(al4, bl6) | 0;
                mid = mid + Math.imul(al4, bh6) | 0;
                mid = mid + Math.imul(ah4, bl6) | 0;
                hi = hi + Math.imul(ah4, bh6) | 0;
                lo = lo + Math.imul(al3, bl7) | 0;
                mid = mid + Math.imul(al3, bh7) | 0;
                mid = mid + Math.imul(ah3, bl7) | 0;
                hi = hi + Math.imul(ah3, bh7) | 0;
                lo = lo + Math.imul(al2, bl8) | 0;
                mid = mid + Math.imul(al2, bh8) | 0;
                mid = mid + Math.imul(ah2, bl8) | 0;
                hi = hi + Math.imul(ah2, bh8) | 0;
                lo = lo + Math.imul(al1, bl9) | 0;
                mid = mid + Math.imul(al1, bh9) | 0;
                mid = mid + Math.imul(ah1, bl9) | 0;
                hi = hi + Math.imul(ah1, bh9) | 0;
                var w10 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
                w10 &= 67108863;
                lo = Math.imul(al9, bl2);
                mid = Math.imul(al9, bh2);
                mid = mid + Math.imul(ah9, bl2) | 0;
                hi = Math.imul(ah9, bh2);
                lo = lo + Math.imul(al8, bl3) | 0;
                mid = mid + Math.imul(al8, bh3) | 0;
                mid = mid + Math.imul(ah8, bl3) | 0;
                hi = hi + Math.imul(ah8, bh3) | 0;
                lo = lo + Math.imul(al7, bl4) | 0;
                mid = mid + Math.imul(al7, bh4) | 0;
                mid = mid + Math.imul(ah7, bl4) | 0;
                hi = hi + Math.imul(ah7, bh4) | 0;
                lo = lo + Math.imul(al6, bl5) | 0;
                mid = mid + Math.imul(al6, bh5) | 0;
                mid = mid + Math.imul(ah6, bl5) | 0;
                hi = hi + Math.imul(ah6, bh5) | 0;
                lo = lo + Math.imul(al5, bl6) | 0;
                mid = mid + Math.imul(al5, bh6) | 0;
                mid = mid + Math.imul(ah5, bl6) | 0;
                hi = hi + Math.imul(ah5, bh6) | 0;
                lo = lo + Math.imul(al4, bl7) | 0;
                mid = mid + Math.imul(al4, bh7) | 0;
                mid = mid + Math.imul(ah4, bl7) | 0;
                hi = hi + Math.imul(ah4, bh7) | 0;
                lo = lo + Math.imul(al3, bl8) | 0;
                mid = mid + Math.imul(al3, bh8) | 0;
                mid = mid + Math.imul(ah3, bl8) | 0;
                hi = hi + Math.imul(ah3, bh8) | 0;
                lo = lo + Math.imul(al2, bl9) | 0;
                mid = mid + Math.imul(al2, bh9) | 0;
                mid = mid + Math.imul(ah2, bl9) | 0;
                hi = hi + Math.imul(ah2, bh9) | 0;
                var w11 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
                w11 &= 67108863;
                lo = Math.imul(al9, bl3);
                mid = Math.imul(al9, bh3);
                mid = mid + Math.imul(ah9, bl3) | 0;
                hi = Math.imul(ah9, bh3);
                lo = lo + Math.imul(al8, bl4) | 0;
                mid = mid + Math.imul(al8, bh4) | 0;
                mid = mid + Math.imul(ah8, bl4) | 0;
                hi = hi + Math.imul(ah8, bh4) | 0;
                lo = lo + Math.imul(al7, bl5) | 0;
                mid = mid + Math.imul(al7, bh5) | 0;
                mid = mid + Math.imul(ah7, bl5) | 0;
                hi = hi + Math.imul(ah7, bh5) | 0;
                lo = lo + Math.imul(al6, bl6) | 0;
                mid = mid + Math.imul(al6, bh6) | 0;
                mid = mid + Math.imul(ah6, bl6) | 0;
                hi = hi + Math.imul(ah6, bh6) | 0;
                lo = lo + Math.imul(al5, bl7) | 0;
                mid = mid + Math.imul(al5, bh7) | 0;
                mid = mid + Math.imul(ah5, bl7) | 0;
                hi = hi + Math.imul(ah5, bh7) | 0;
                lo = lo + Math.imul(al4, bl8) | 0;
                mid = mid + Math.imul(al4, bh8) | 0;
                mid = mid + Math.imul(ah4, bl8) | 0;
                hi = hi + Math.imul(ah4, bh8) | 0;
                lo = lo + Math.imul(al3, bl9) | 0;
                mid = mid + Math.imul(al3, bh9) | 0;
                mid = mid + Math.imul(ah3, bl9) | 0;
                hi = hi + Math.imul(ah3, bh9) | 0;
                var w12 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
                w12 &= 67108863;
                lo = Math.imul(al9, bl4);
                mid = Math.imul(al9, bh4);
                mid = mid + Math.imul(ah9, bl4) | 0;
                hi = Math.imul(ah9, bh4);
                lo = lo + Math.imul(al8, bl5) | 0;
                mid = mid + Math.imul(al8, bh5) | 0;
                mid = mid + Math.imul(ah8, bl5) | 0;
                hi = hi + Math.imul(ah8, bh5) | 0;
                lo = lo + Math.imul(al7, bl6) | 0;
                mid = mid + Math.imul(al7, bh6) | 0;
                mid = mid + Math.imul(ah7, bl6) | 0;
                hi = hi + Math.imul(ah7, bh6) | 0;
                lo = lo + Math.imul(al6, bl7) | 0;
                mid = mid + Math.imul(al6, bh7) | 0;
                mid = mid + Math.imul(ah6, bl7) | 0;
                hi = hi + Math.imul(ah6, bh7) | 0;
                lo = lo + Math.imul(al5, bl8) | 0;
                mid = mid + Math.imul(al5, bh8) | 0;
                mid = mid + Math.imul(ah5, bl8) | 0;
                hi = hi + Math.imul(ah5, bh8) | 0;
                lo = lo + Math.imul(al4, bl9) | 0;
                mid = mid + Math.imul(al4, bh9) | 0;
                mid = mid + Math.imul(ah4, bl9) | 0;
                hi = hi + Math.imul(ah4, bh9) | 0;
                var w13 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
                w13 &= 67108863;
                lo = Math.imul(al9, bl5);
                mid = Math.imul(al9, bh5);
                mid = mid + Math.imul(ah9, bl5) | 0;
                hi = Math.imul(ah9, bh5);
                lo = lo + Math.imul(al8, bl6) | 0;
                mid = mid + Math.imul(al8, bh6) | 0;
                mid = mid + Math.imul(ah8, bl6) | 0;
                hi = hi + Math.imul(ah8, bh6) | 0;
                lo = lo + Math.imul(al7, bl7) | 0;
                mid = mid + Math.imul(al7, bh7) | 0;
                mid = mid + Math.imul(ah7, bl7) | 0;
                hi = hi + Math.imul(ah7, bh7) | 0;
                lo = lo + Math.imul(al6, bl8) | 0;
                mid = mid + Math.imul(al6, bh8) | 0;
                mid = mid + Math.imul(ah6, bl8) | 0;
                hi = hi + Math.imul(ah6, bh8) | 0;
                lo = lo + Math.imul(al5, bl9) | 0;
                mid = mid + Math.imul(al5, bh9) | 0;
                mid = mid + Math.imul(ah5, bl9) | 0;
                hi = hi + Math.imul(ah5, bh9) | 0;
                var w14 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
                w14 &= 67108863;
                lo = Math.imul(al9, bl6);
                mid = Math.imul(al9, bh6);
                mid = mid + Math.imul(ah9, bl6) | 0;
                hi = Math.imul(ah9, bh6);
                lo = lo + Math.imul(al8, bl7) | 0;
                mid = mid + Math.imul(al8, bh7) | 0;
                mid = mid + Math.imul(ah8, bl7) | 0;
                hi = hi + Math.imul(ah8, bh7) | 0;
                lo = lo + Math.imul(al7, bl8) | 0;
                mid = mid + Math.imul(al7, bh8) | 0;
                mid = mid + Math.imul(ah7, bl8) | 0;
                hi = hi + Math.imul(ah7, bh8) | 0;
                lo = lo + Math.imul(al6, bl9) | 0;
                mid = mid + Math.imul(al6, bh9) | 0;
                mid = mid + Math.imul(ah6, bl9) | 0;
                hi = hi + Math.imul(ah6, bh9) | 0;
                var w15 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
                w15 &= 67108863;
                lo = Math.imul(al9, bl7);
                mid = Math.imul(al9, bh7);
                mid = mid + Math.imul(ah9, bl7) | 0;
                hi = Math.imul(ah9, bh7);
                lo = lo + Math.imul(al8, bl8) | 0;
                mid = mid + Math.imul(al8, bh8) | 0;
                mid = mid + Math.imul(ah8, bl8) | 0;
                hi = hi + Math.imul(ah8, bh8) | 0;
                lo = lo + Math.imul(al7, bl9) | 0;
                mid = mid + Math.imul(al7, bh9) | 0;
                mid = mid + Math.imul(ah7, bl9) | 0;
                hi = hi + Math.imul(ah7, bh9) | 0;
                var w16 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
                w16 &= 67108863;
                lo = Math.imul(al9, bl8);
                mid = Math.imul(al9, bh8);
                mid = mid + Math.imul(ah9, bl8) | 0;
                hi = Math.imul(ah9, bh8);
                lo = lo + Math.imul(al8, bl9) | 0;
                mid = mid + Math.imul(al8, bh9) | 0;
                mid = mid + Math.imul(ah8, bl9) | 0;
                hi = hi + Math.imul(ah8, bh9) | 0;
                var w17 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
                w17 &= 67108863;
                lo = Math.imul(al9, bl9);
                mid = Math.imul(al9, bh9);
                mid = mid + Math.imul(ah9, bl9) | 0;
                hi = Math.imul(ah9, bh9);
                var w18 = (c + lo | 0) + ((mid & 8191) << 13) | 0;
                c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
                w18 &= 67108863;
                o[0] = w0;
                o[1] = w1;
                o[2] = w2;
                o[3] = w3;
                o[4] = w4;
                o[5] = w5;
                o[6] = w6;
                o[7] = w7;
                o[8] = w8;
                o[9] = w9;
                o[10] = w10;
                o[11] = w11;
                o[12] = w12;
                o[13] = w13;
                o[14] = w14;
                o[15] = w15;
                o[16] = w16;
                o[17] = w17;
                o[18] = w18;
                if (c !== 0) {
                    o[19] = c;
                    out.length++;
                }
                return out;
            };
            if (!Math.imul) comb10MulTo = smallMulTo;
            function bigMulTo(self, num, out) {
                out.negative = num.negative ^ self.negative;
                out.length = self.length + num.length;
                var carry = 0;
                var hncarry = 0;
                for(var k = 0; k < out.length - 1; k++){
                    var ncarry = hncarry;
                    hncarry = 0;
                    var rword = carry & 67108863;
                    var maxJ = Math.min(k, num.length - 1);
                    for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                        var i = k - j;
                        var a = self.words[i] | 0;
                        var b = num.words[j] | 0;
                        var r = a * b;
                        var lo = r & 67108863;
                        ncarry = ncarry + (r / 67108864 | 0) | 0;
                        lo = lo + rword | 0;
                        rword = lo & 67108863;
                        ncarry = ncarry + (lo >>> 26) | 0;
                        hncarry += ncarry >>> 26;
                        ncarry &= 67108863;
                    }
                    out.words[k] = rword;
                    carry = ncarry;
                    ncarry = hncarry;
                }
                if (carry !== 0) out.words[k] = carry;
                else out.length--;
                return out.strip();
            }
            function jumboMulTo(self, num, out) {
                var fftm = new FFTM();
                return fftm.mulp(self, num, out);
            }
            BN2.prototype.mulTo = function mulTo(num, out) {
                var res;
                var len = this.length + num.length;
                if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
                else if (len < 63) res = smallMulTo(this, num, out);
                else if (len < 1024) res = bigMulTo(this, num, out);
                else res = jumboMulTo(this, num, out);
                return res;
            };
            function FFTM(x, y) {
                this.x = x;
                this.y = y;
            }
            FFTM.prototype.makeRBT = function makeRBT(N) {
                var t = new Array(N);
                var l = BN2.prototype._countBits(N) - 1;
                for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
                return t;
            };
            FFTM.prototype.revBin = function revBin(x, l, N) {
                if (x === 0 || x === N - 1) return x;
                var rb = 0;
                for(var i = 0; i < l; i++){
                    rb |= (x & 1) << l - i - 1;
                    x >>= 1;
                }
                return rb;
            };
            FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
                for(var i = 0; i < N; i++){
                    rtws[i] = rws[rbt[i]];
                    itws[i] = iws[rbt[i]];
                }
            };
            FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
                this.permute(rbt, rws, iws, rtws, itws, N);
                for(var s = 1; s < N; s <<= 1){
                    var l = s << 1;
                    var rtwdf = Math.cos(2 * Math.PI / l);
                    var itwdf = Math.sin(2 * Math.PI / l);
                    for(var p = 0; p < N; p += l){
                        var rtwdf_ = rtwdf;
                        var itwdf_ = itwdf;
                        for(var j = 0; j < s; j++){
                            var re = rtws[p + j];
                            var ie = itws[p + j];
                            var ro = rtws[p + j + s];
                            var io = itws[p + j + s];
                            var rx = rtwdf_ * ro - itwdf_ * io;
                            io = rtwdf_ * io + itwdf_ * ro;
                            ro = rx;
                            rtws[p + j] = re + ro;
                            itws[p + j] = ie + io;
                            rtws[p + j + s] = re - ro;
                            itws[p + j + s] = ie - io;
                            if (j !== l) {
                                rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                                itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                                rtwdf_ = rx;
                            }
                        }
                    }
                }
            };
            FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
                var N = Math.max(m, n) | 1;
                var odd = N & 1;
                var i = 0;
                for(N = N / 2 | 0; N; N = N >>> 1)i++;
                return 1 << i + 1 + odd;
            };
            FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
                if (N <= 1) return;
                for(var i = 0; i < N / 2; i++){
                    var t = rws[i];
                    rws[i] = rws[N - i - 1];
                    rws[N - i - 1] = t;
                    t = iws[i];
                    iws[i] = -iws[N - i - 1];
                    iws[N - i - 1] = -t;
                }
            };
            FFTM.prototype.normalize13b = function normalize13b(ws, N) {
                var carry = 0;
                for(var i = 0; i < N / 2; i++){
                    var w = Math.round(ws[2 * i + 1] / N) * 8192 + Math.round(ws[2 * i] / N) + carry;
                    ws[i] = w & 67108863;
                    if (w < 67108864) carry = 0;
                    else carry = w / 67108864 | 0;
                }
                return ws;
            };
            FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
                var carry = 0;
                for(var i = 0; i < len; i++){
                    carry = carry + (ws[i] | 0);
                    rws[2 * i] = carry & 8191;
                    carry = carry >>> 13;
                    rws[2 * i + 1] = carry & 8191;
                    carry = carry >>> 13;
                }
                for(i = 2 * len; i < N; ++i)rws[i] = 0;
                assert29(carry === 0);
                assert29((carry & -8192) === 0);
            };
            FFTM.prototype.stub = function stub(N) {
                var ph = new Array(N);
                for(var i = 0; i < N; i++)ph[i] = 0;
                return ph;
            };
            FFTM.prototype.mulp = function mulp(x, y, out) {
                var N = 2 * this.guessLen13b(x.length, y.length);
                var rbt = this.makeRBT(N);
                var _ = this.stub(N);
                var rws = new Array(N);
                var rwst = new Array(N);
                var iwst = new Array(N);
                var nrws = new Array(N);
                var nrwst = new Array(N);
                var niwst = new Array(N);
                var rmws = out.words;
                rmws.length = N;
                this.convert13b(x.words, x.length, rws, N);
                this.convert13b(y.words, y.length, nrws, N);
                this.transform(rws, _, rwst, iwst, N, rbt);
                this.transform(nrws, _, nrwst, niwst, N, rbt);
                for(var i = 0; i < N; i++){
                    var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                    iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                    rwst[i] = rx;
                }
                this.conjugate(rwst, iwst, N);
                this.transform(rwst, iwst, rmws, _, N, rbt);
                this.conjugate(rmws, _, N);
                this.normalize13b(rmws, N);
                out.negative = x.negative ^ y.negative;
                out.length = x.length + y.length;
                return out.strip();
            };
            BN2.prototype.mul = function mul(num) {
                var out = new BN2(null);
                out.words = new Array(this.length + num.length);
                return this.mulTo(num, out);
            };
            BN2.prototype.mulf = function mulf(num) {
                var out = new BN2(null);
                out.words = new Array(this.length + num.length);
                return jumboMulTo(this, num, out);
            };
            BN2.prototype.imul = function imul(num) {
                return this.clone().mulTo(num, this);
            };
            BN2.prototype.imuln = function imuln(num) {
                assert29(typeof num === "number");
                assert29(num < 67108864);
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = (this.words[i] | 0) * num;
                    var lo = (w & 67108863) + (carry & 67108863);
                    carry >>= 26;
                    carry += w / 67108864 | 0;
                    carry += lo >>> 26;
                    this.words[i] = lo & 67108863;
                }
                if (carry !== 0) {
                    this.words[i] = carry;
                    this.length++;
                }
                return this;
            };
            BN2.prototype.muln = function muln(num) {
                return this.clone().imuln(num);
            };
            BN2.prototype.sqr = function sqr() {
                return this.mul(this);
            };
            BN2.prototype.isqr = function isqr() {
                return this.imul(this.clone());
            };
            BN2.prototype.pow = function pow3(num) {
                var w = toBitArray(num);
                if (w.length === 0) return new BN2(1);
                var res = this;
                for(var i = 0; i < w.length; i++, res = res.sqr()){
                    if (w[i] !== 0) break;
                }
                if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                    if (w[i] === 0) continue;
                    res = res.mul(q);
                }
                return res;
            };
            BN2.prototype.iushln = function iushln(bits) {
                assert29(typeof bits === "number" && bits >= 0);
                var r = bits % 26;
                var s = (bits - r) / 26;
                var carryMask = 67108863 >>> 26 - r << 26 - r;
                var i;
                if (r !== 0) {
                    var carry = 0;
                    for(i = 0; i < this.length; i++){
                        var newCarry = this.words[i] & carryMask;
                        var c = (this.words[i] | 0) - newCarry << r;
                        this.words[i] = c | carry;
                        carry = newCarry >>> 26 - r;
                    }
                    if (carry) {
                        this.words[i] = carry;
                        this.length++;
                    }
                }
                if (s !== 0) {
                    for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                    for(i = 0; i < s; i++)this.words[i] = 0;
                    this.length += s;
                }
                return this.strip();
            };
            BN2.prototype.ishln = function ishln(bits) {
                assert29(this.negative === 0);
                return this.iushln(bits);
            };
            BN2.prototype.iushrn = function iushrn(bits, hint, extended) {
                assert29(typeof bits === "number" && bits >= 0);
                var h;
                if (hint) h = (hint - hint % 26) / 26;
                else h = 0;
                var r = bits % 26;
                var s = Math.min((bits - r) / 26, this.length);
                var mask = 67108863 ^ 67108863 >>> r << r;
                var maskedWords = extended;
                h -= s;
                h = Math.max(0, h);
                if (maskedWords) {
                    for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                    maskedWords.length = s;
                }
                if (s === 0) ;
                else if (this.length > s) {
                    this.length -= s;
                    for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
                } else {
                    this.words[0] = 0;
                    this.length = 1;
                }
                var carry = 0;
                for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                    var word = this.words[i] | 0;
                    this.words[i] = carry << 26 - r | word >>> r;
                    carry = word & mask;
                }
                if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
                if (this.length === 0) {
                    this.words[0] = 0;
                    this.length = 1;
                }
                return this.strip();
            };
            BN2.prototype.ishrn = function ishrn(bits, hint, extended) {
                assert29(this.negative === 0);
                return this.iushrn(bits, hint, extended);
            };
            BN2.prototype.shln = function shln(bits) {
                return this.clone().ishln(bits);
            };
            BN2.prototype.ushln = function ushln(bits) {
                return this.clone().iushln(bits);
            };
            BN2.prototype.shrn = function shrn(bits) {
                return this.clone().ishrn(bits);
            };
            BN2.prototype.ushrn = function ushrn(bits) {
                return this.clone().iushrn(bits);
            };
            BN2.prototype.testn = function testn(bit) {
                assert29(typeof bit === "number" && bit >= 0);
                var r = bit % 26;
                var s = (bit - r) / 26;
                var q = 1 << r;
                if (this.length <= s) return false;
                var w = this.words[s];
                return !!(w & q);
            };
            BN2.prototype.imaskn = function imaskn(bits) {
                assert29(typeof bits === "number" && bits >= 0);
                var r = bits % 26;
                var s = (bits - r) / 26;
                assert29(this.negative === 0, "imaskn works only with positive numbers");
                if (this.length <= s) return this;
                if (r !== 0) s++;
                this.length = Math.min(s, this.length);
                if (r !== 0) {
                    var mask = 67108863 ^ 67108863 >>> r << r;
                    this.words[this.length - 1] &= mask;
                }
                return this.strip();
            };
            BN2.prototype.maskn = function maskn(bits) {
                return this.clone().imaskn(bits);
            };
            BN2.prototype.iaddn = function iaddn(num) {
                assert29(typeof num === "number");
                assert29(num < 67108864);
                if (num < 0) return this.isubn(-num);
                if (this.negative !== 0) {
                    if (this.length === 1 && (this.words[0] | 0) < num) {
                        this.words[0] = num - (this.words[0] | 0);
                        this.negative = 0;
                        return this;
                    }
                    this.negative = 0;
                    this.isubn(num);
                    this.negative = 1;
                    return this;
                }
                return this._iaddn(num);
            };
            BN2.prototype._iaddn = function _iaddn(num) {
                this.words[0] += num;
                for(var i = 0; i < this.length && this.words[i] >= 67108864; i++){
                    this.words[i] -= 67108864;
                    if (i === this.length - 1) this.words[i + 1] = 1;
                    else this.words[i + 1]++;
                }
                this.length = Math.max(this.length, i + 1);
                return this;
            };
            BN2.prototype.isubn = function isubn(num) {
                assert29(typeof num === "number");
                assert29(num < 67108864);
                if (num < 0) return this.iaddn(-num);
                if (this.negative !== 0) {
                    this.negative = 0;
                    this.iaddn(num);
                    this.negative = 1;
                    return this;
                }
                this.words[0] -= num;
                if (this.length === 1 && this.words[0] < 0) {
                    this.words[0] = -this.words[0];
                    this.negative = 1;
                } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                    this.words[i] += 67108864;
                    this.words[i + 1] -= 1;
                }
                return this.strip();
            };
            BN2.prototype.addn = function addn(num) {
                return this.clone().iaddn(num);
            };
            BN2.prototype.subn = function subn(num) {
                return this.clone().isubn(num);
            };
            BN2.prototype.iabs = function iabs() {
                this.negative = 0;
                return this;
            };
            BN2.prototype.abs = function abs() {
                return this.clone().iabs();
            };
            BN2.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
                var len = num.length + shift;
                var i;
                this._expand(len);
                var w;
                var carry = 0;
                for(i = 0; i < num.length; i++){
                    w = (this.words[i + shift] | 0) + carry;
                    var right = (num.words[i] | 0) * mul;
                    w -= right & 67108863;
                    carry = (w >> 26) - (right / 67108864 | 0);
                    this.words[i + shift] = w & 67108863;
                }
                for(; i < this.length - shift; i++){
                    w = (this.words[i + shift] | 0) + carry;
                    carry = w >> 26;
                    this.words[i + shift] = w & 67108863;
                }
                if (carry === 0) return this.strip();
                assert29(carry === -1);
                carry = 0;
                for(i = 0; i < this.length; i++){
                    w = -(this.words[i] | 0) + carry;
                    carry = w >> 26;
                    this.words[i] = w & 67108863;
                }
                this.negative = 1;
                return this.strip();
            };
            BN2.prototype._wordDiv = function _wordDiv(num, mode) {
                var shift = this.length - num.length;
                var a = this.clone();
                var b = num;
                var bhi = b.words[b.length - 1] | 0;
                var bhiBits = this._countBits(bhi);
                shift = 26 - bhiBits;
                if (shift !== 0) {
                    b = b.ushln(shift);
                    a.iushln(shift);
                    bhi = b.words[b.length - 1] | 0;
                }
                var m = a.length - b.length;
                var q;
                if (mode !== "mod") {
                    q = new BN2(null);
                    q.length = m + 1;
                    q.words = new Array(q.length);
                    for(var i = 0; i < q.length; i++)q.words[i] = 0;
                }
                var diff = a.clone()._ishlnsubmul(b, 1, m);
                if (diff.negative === 0) {
                    a = diff;
                    if (q) q.words[m] = 1;
                }
                for(var j = m - 1; j >= 0; j--){
                    var qj = (a.words[b.length + j] | 0) * 67108864 + (a.words[b.length + j - 1] | 0);
                    qj = Math.min(qj / bhi | 0, 67108863);
                    a._ishlnsubmul(b, qj, j);
                    while(a.negative !== 0){
                        qj--;
                        a.negative = 0;
                        a._ishlnsubmul(b, 1, j);
                        if (!a.isZero()) a.negative ^= 1;
                    }
                    if (q) q.words[j] = qj;
                }
                if (q) q.strip();
                a.strip();
                if (mode !== "div" && shift !== 0) a.iushrn(shift);
                return {
                    div: q || null,
                    mod: a
                };
            };
            BN2.prototype.divmod = function divmod(num, mode, positive) {
                assert29(!num.isZero());
                if (this.isZero()) return {
                    div: new BN2(0),
                    mod: new BN2(0)
                };
                var div, mod2, res;
                if (this.negative !== 0 && num.negative === 0) {
                    res = this.neg().divmod(num, mode);
                    if (mode !== "mod") div = res.div.neg();
                    if (mode !== "div") {
                        mod2 = res.mod.neg();
                        if (positive && mod2.negative !== 0) mod2.iadd(num);
                    }
                    return {
                        div,
                        mod: mod2
                    };
                }
                if (this.negative === 0 && num.negative !== 0) {
                    res = this.divmod(num.neg(), mode);
                    if (mode !== "mod") div = res.div.neg();
                    return {
                        div,
                        mod: res.mod
                    };
                }
                if ((this.negative & num.negative) !== 0) {
                    res = this.neg().divmod(num.neg(), mode);
                    if (mode !== "div") {
                        mod2 = res.mod.neg();
                        if (positive && mod2.negative !== 0) mod2.isub(num);
                    }
                    return {
                        div: res.div,
                        mod: mod2
                    };
                }
                if (num.length > this.length || this.cmp(num) < 0) return {
                    div: new BN2(0),
                    mod: this
                };
                if (num.length === 1) {
                    if (mode === "div") return {
                        div: this.divn(num.words[0]),
                        mod: null
                    };
                    if (mode === "mod") return {
                        div: null,
                        mod: new BN2(this.modn(num.words[0]))
                    };
                    return {
                        div: this.divn(num.words[0]),
                        mod: new BN2(this.modn(num.words[0]))
                    };
                }
                return this._wordDiv(num, mode);
            };
            BN2.prototype.div = function div(num) {
                return this.divmod(num, "div", false).div;
            };
            BN2.prototype.mod = function mod2(num) {
                return this.divmod(num, "mod", false).mod;
            };
            BN2.prototype.umod = function umod(num) {
                return this.divmod(num, "mod", true).mod;
            };
            BN2.prototype.divRound = function divRound(num) {
                var dm = this.divmod(num);
                if (dm.mod.isZero()) return dm.div;
                var mod2 = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
                var half = num.ushrn(1);
                var r2 = num.andln(1);
                var cmp = mod2.cmp(half);
                if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
                return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
            };
            BN2.prototype.modn = function modn(num) {
                assert29(num <= 67108863);
                var p = 67108864 % num;
                var acc = 0;
                for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
                return acc;
            };
            BN2.prototype.idivn = function idivn(num) {
                assert29(num <= 67108863);
                var carry = 0;
                for(var i = this.length - 1; i >= 0; i--){
                    var w = (this.words[i] | 0) + carry * 67108864;
                    this.words[i] = w / num | 0;
                    carry = w % num;
                }
                return this.strip();
            };
            BN2.prototype.divn = function divn(num) {
                return this.clone().idivn(num);
            };
            BN2.prototype.egcd = function egcd(p) {
                assert29(p.negative === 0);
                assert29(!p.isZero());
                var x = this;
                var y = p.clone();
                if (x.negative !== 0) x = x.umod(p);
                else x = x.clone();
                var A = new BN2(1);
                var B = new BN2(0);
                var C = new BN2(0);
                var D = new BN2(1);
                var g = 0;
                while(x.isEven() && y.isEven()){
                    x.iushrn(1);
                    y.iushrn(1);
                    ++g;
                }
                var yp = y.clone();
                var xp = x.clone();
                while(!x.isZero()){
                    for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                    if (i > 0) {
                        x.iushrn(i);
                        while(i-- > 0){
                            if (A.isOdd() || B.isOdd()) {
                                A.iadd(yp);
                                B.isub(xp);
                            }
                            A.iushrn(1);
                            B.iushrn(1);
                        }
                    }
                    for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                    if (j > 0) {
                        y.iushrn(j);
                        while(j-- > 0){
                            if (C.isOdd() || D.isOdd()) {
                                C.iadd(yp);
                                D.isub(xp);
                            }
                            C.iushrn(1);
                            D.iushrn(1);
                        }
                    }
                    if (x.cmp(y) >= 0) {
                        x.isub(y);
                        A.isub(C);
                        B.isub(D);
                    } else {
                        y.isub(x);
                        C.isub(A);
                        D.isub(B);
                    }
                }
                return {
                    a: C,
                    b: D,
                    gcd: y.iushln(g)
                };
            };
            BN2.prototype._invmp = function _invmp(p) {
                assert29(p.negative === 0);
                assert29(!p.isZero());
                var a = this;
                var b = p.clone();
                if (a.negative !== 0) a = a.umod(p);
                else a = a.clone();
                var x1 = new BN2(1);
                var x2 = new BN2(0);
                var delta = b.clone();
                while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                    for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                    if (i > 0) {
                        a.iushrn(i);
                        while(i-- > 0){
                            if (x1.isOdd()) x1.iadd(delta);
                            x1.iushrn(1);
                        }
                    }
                    for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                    if (j > 0) {
                        b.iushrn(j);
                        while(j-- > 0){
                            if (x2.isOdd()) x2.iadd(delta);
                            x2.iushrn(1);
                        }
                    }
                    if (a.cmp(b) >= 0) {
                        a.isub(b);
                        x1.isub(x2);
                    } else {
                        b.isub(a);
                        x2.isub(x1);
                    }
                }
                var res;
                if (a.cmpn(1) === 0) res = x1;
                else res = x2;
                if (res.cmpn(0) < 0) res.iadd(p);
                return res;
            };
            BN2.prototype.gcd = function gcd(num) {
                if (this.isZero()) return num.abs();
                if (num.isZero()) return this.abs();
                var a = this.clone();
                var b = num.clone();
                a.negative = 0;
                b.negative = 0;
                for(var shift = 0; a.isEven() && b.isEven(); shift++){
                    a.iushrn(1);
                    b.iushrn(1);
                }
                do {
                    while(a.isEven())a.iushrn(1);
                    while(b.isEven())b.iushrn(1);
                    var r = a.cmp(b);
                    if (r < 0) {
                        var t = a;
                        a = b;
                        b = t;
                    } else if (r === 0 || b.cmpn(1) === 0) break;
                    a.isub(b);
                }while (true);
                return b.iushln(shift);
            };
            BN2.prototype.invm = function invm(num) {
                return this.egcd(num).a.umod(num);
            };
            BN2.prototype.isEven = function isEven() {
                return (this.words[0] & 1) === 0;
            };
            BN2.prototype.isOdd = function isOdd() {
                return (this.words[0] & 1) === 1;
            };
            BN2.prototype.andln = function andln(num) {
                return this.words[0] & num;
            };
            BN2.prototype.bincn = function bincn(bit) {
                assert29(typeof bit === "number");
                var r = bit % 26;
                var s = (bit - r) / 26;
                var q = 1 << r;
                if (this.length <= s) {
                    this._expand(s + 1);
                    this.words[s] |= q;
                    return this;
                }
                var carry = q;
                for(var i = s; carry !== 0 && i < this.length; i++){
                    var w = this.words[i] | 0;
                    w += carry;
                    carry = w >>> 26;
                    w &= 67108863;
                    this.words[i] = w;
                }
                if (carry !== 0) {
                    this.words[i] = carry;
                    this.length++;
                }
                return this;
            };
            BN2.prototype.isZero = function isZero() {
                return this.length === 1 && this.words[0] === 0;
            };
            BN2.prototype.cmpn = function cmpn(num) {
                var negative = num < 0;
                if (this.negative !== 0 && !negative) return -1;
                if (this.negative === 0 && negative) return 1;
                this.strip();
                var res;
                if (this.length > 1) res = 1;
                else {
                    if (negative) num = -num;
                    assert29(num <= 67108863, "Number is too big");
                    var w = this.words[0] | 0;
                    res = w === num ? 0 : w < num ? -1 : 1;
                }
                if (this.negative !== 0) return -res | 0;
                return res;
            };
            BN2.prototype.cmp = function cmp(num) {
                if (this.negative !== 0 && num.negative === 0) return -1;
                if (this.negative === 0 && num.negative !== 0) return 1;
                var res = this.ucmp(num);
                if (this.negative !== 0) return -res | 0;
                return res;
            };
            BN2.prototype.ucmp = function ucmp(num) {
                if (this.length > num.length) return 1;
                if (this.length < num.length) return -1;
                var res = 0;
                for(var i = this.length - 1; i >= 0; i--){
                    var a = this.words[i] | 0;
                    var b = num.words[i] | 0;
                    if (a === b) continue;
                    if (a < b) res = -1;
                    else if (a > b) res = 1;
                    break;
                }
                return res;
            };
            BN2.prototype.gtn = function gtn(num) {
                return this.cmpn(num) === 1;
            };
            BN2.prototype.gt = function gt(num) {
                return this.cmp(num) === 1;
            };
            BN2.prototype.gten = function gten(num) {
                return this.cmpn(num) >= 0;
            };
            BN2.prototype.gte = function gte(num) {
                return this.cmp(num) >= 0;
            };
            BN2.prototype.ltn = function ltn(num) {
                return this.cmpn(num) === -1;
            };
            BN2.prototype.lt = function lt(num) {
                return this.cmp(num) === -1;
            };
            BN2.prototype.lten = function lten(num) {
                return this.cmpn(num) <= 0;
            };
            BN2.prototype.lte = function lte(num) {
                return this.cmp(num) <= 0;
            };
            BN2.prototype.eqn = function eqn(num) {
                return this.cmpn(num) === 0;
            };
            BN2.prototype.eq = function eq(num) {
                return this.cmp(num) === 0;
            };
            BN2.red = function red(num) {
                return new Red(num);
            };
            BN2.prototype.toRed = function toRed(ctx) {
                assert29(!this.red, "Already a number in reduction context");
                assert29(this.negative === 0, "red works only with positives");
                return ctx.convertTo(this)._forceRed(ctx);
            };
            BN2.prototype.fromRed = function fromRed() {
                assert29(this.red, "fromRed works only with numbers in reduction context");
                return this.red.convertFrom(this);
            };
            BN2.prototype._forceRed = function _forceRed(ctx) {
                this.red = ctx;
                return this;
            };
            BN2.prototype.forceRed = function forceRed(ctx) {
                assert29(!this.red, "Already a number in reduction context");
                return this._forceRed(ctx);
            };
            BN2.prototype.redAdd = function redAdd(num) {
                assert29(this.red, "redAdd works only with red numbers");
                return this.red.add(this, num);
            };
            BN2.prototype.redIAdd = function redIAdd(num) {
                assert29(this.red, "redIAdd works only with red numbers");
                return this.red.iadd(this, num);
            };
            BN2.prototype.redSub = function redSub(num) {
                assert29(this.red, "redSub works only with red numbers");
                return this.red.sub(this, num);
            };
            BN2.prototype.redISub = function redISub(num) {
                assert29(this.red, "redISub works only with red numbers");
                return this.red.isub(this, num);
            };
            BN2.prototype.redShl = function redShl(num) {
                assert29(this.red, "redShl works only with red numbers");
                return this.red.shl(this, num);
            };
            BN2.prototype.redMul = function redMul(num) {
                assert29(this.red, "redMul works only with red numbers");
                this.red._verify2(this, num);
                return this.red.mul(this, num);
            };
            BN2.prototype.redIMul = function redIMul(num) {
                assert29(this.red, "redMul works only with red numbers");
                this.red._verify2(this, num);
                return this.red.imul(this, num);
            };
            BN2.prototype.redSqr = function redSqr() {
                assert29(this.red, "redSqr works only with red numbers");
                this.red._verify1(this);
                return this.red.sqr(this);
            };
            BN2.prototype.redISqr = function redISqr() {
                assert29(this.red, "redISqr works only with red numbers");
                this.red._verify1(this);
                return this.red.isqr(this);
            };
            BN2.prototype.redSqrt = function redSqrt() {
                assert29(this.red, "redSqrt works only with red numbers");
                this.red._verify1(this);
                return this.red.sqrt(this);
            };
            BN2.prototype.redInvm = function redInvm() {
                assert29(this.red, "redInvm works only with red numbers");
                this.red._verify1(this);
                return this.red.invm(this);
            };
            BN2.prototype.redNeg = function redNeg() {
                assert29(this.red, "redNeg works only with red numbers");
                this.red._verify1(this);
                return this.red.neg(this);
            };
            BN2.prototype.redPow = function redPow(num) {
                assert29(this.red && !num.red, "redPow(normalNum)");
                this.red._verify1(this);
                return this.red.pow(this, num);
            };
            var primes = {
                k256: null,
                p224: null,
                p192: null,
                p25519: null
            };
            function MPrime(name, p) {
                this.name = name;
                this.p = new BN2(p, 16);
                this.n = this.p.bitLength();
                this.k = new BN2(1).iushln(this.n).isub(this.p);
                this.tmp = this._tmp();
            }
            MPrime.prototype._tmp = function _tmp() {
                var tmp = new BN2(null);
                tmp.words = new Array(Math.ceil(this.n / 13));
                return tmp;
            };
            MPrime.prototype.ireduce = function ireduce(num) {
                var r = num;
                var rlen;
                do {
                    this.split(r, this.tmp);
                    r = this.imulK(r);
                    r = r.iadd(this.tmp);
                    rlen = r.bitLength();
                }while (rlen > this.n);
                var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
                if (cmp === 0) {
                    r.words[0] = 0;
                    r.length = 1;
                } else if (cmp > 0) r.isub(this.p);
                else if (r.strip !== void 0) r.strip();
                else r._strip();
                return r;
            };
            MPrime.prototype.split = function split(input, out) {
                input.iushrn(this.n, 0, out);
            };
            MPrime.prototype.imulK = function imulK(num) {
                return num.imul(this.k);
            };
            function K256() {
                MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
            }
            inherits(K256, MPrime);
            K256.prototype.split = function split(input, output2) {
                var mask = 4194303;
                var outLen = Math.min(input.length, 9);
                for(var i = 0; i < outLen; i++)output2.words[i] = input.words[i];
                output2.length = outLen;
                if (input.length <= 9) {
                    input.words[0] = 0;
                    input.length = 1;
                    return;
                }
                var prev = input.words[9];
                output2.words[output2.length++] = prev & mask;
                for(i = 10; i < input.length; i++){
                    var next = input.words[i] | 0;
                    input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                    prev = next;
                }
                prev >>>= 22;
                input.words[i - 10] = prev;
                if (prev === 0 && input.length > 10) input.length -= 10;
                else input.length -= 9;
            };
            K256.prototype.imulK = function imulK(num) {
                num.words[num.length] = 0;
                num.words[num.length + 1] = 0;
                num.length += 2;
                var lo = 0;
                for(var i = 0; i < num.length; i++){
                    var w = num.words[i] | 0;
                    lo += w * 977;
                    num.words[i] = lo & 67108863;
                    lo = w * 64 + (lo / 67108864 | 0);
                }
                if (num.words[num.length - 1] === 0) {
                    num.length--;
                    if (num.words[num.length - 1] === 0) num.length--;
                }
                return num;
            };
            function P224() {
                MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
            }
            inherits(P224, MPrime);
            function P192() {
                MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
            }
            inherits(P192, MPrime);
            function P25519() {
                MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
            }
            inherits(P25519, MPrime);
            P25519.prototype.imulK = function imulK(num) {
                var carry = 0;
                for(var i = 0; i < num.length; i++){
                    var hi = (num.words[i] | 0) * 19 + carry;
                    var lo = hi & 67108863;
                    hi >>>= 26;
                    num.words[i] = lo;
                    carry = hi;
                }
                if (carry !== 0) num.words[num.length++] = carry;
                return num;
            };
            BN2._prime = function prime(name) {
                if (primes[name]) return primes[name];
                var prime2;
                if (name === "k256") prime2 = new K256();
                else if (name === "p224") prime2 = new P224();
                else if (name === "p192") prime2 = new P192();
                else if (name === "p25519") prime2 = new P25519();
                else throw new Error("Unknown prime " + name);
                primes[name] = prime2;
                return prime2;
            };
            function Red(m) {
                if (typeof m === "string") {
                    var prime = BN2._prime(m);
                    this.m = prime.p;
                    this.prime = prime;
                } else {
                    assert29(m.gtn(1), "modulus must be greater than 1");
                    this.m = m;
                    this.prime = null;
                }
            }
            Red.prototype._verify1 = function _verify1(a) {
                assert29(a.negative === 0, "red works only with positives");
                assert29(a.red, "red works only with red numbers");
            };
            Red.prototype._verify2 = function _verify2(a, b) {
                assert29((a.negative | b.negative) === 0, "red works only with positives");
                assert29(a.red && a.red === b.red, "red works only with red numbers");
            };
            Red.prototype.imod = function imod(a) {
                if (this.prime) return this.prime.ireduce(a)._forceRed(this);
                return a.umod(this.m)._forceRed(this);
            };
            Red.prototype.neg = function neg(a) {
                if (a.isZero()) return a.clone();
                return this.m.sub(a)._forceRed(this);
            };
            Red.prototype.add = function add(a, b) {
                this._verify2(a, b);
                var res = a.add(b);
                if (res.cmp(this.m) >= 0) res.isub(this.m);
                return res._forceRed(this);
            };
            Red.prototype.iadd = function iadd(a, b) {
                this._verify2(a, b);
                var res = a.iadd(b);
                if (res.cmp(this.m) >= 0) res.isub(this.m);
                return res;
            };
            Red.prototype.sub = function sub(a, b) {
                this._verify2(a, b);
                var res = a.sub(b);
                if (res.cmpn(0) < 0) res.iadd(this.m);
                return res._forceRed(this);
            };
            Red.prototype.isub = function isub(a, b) {
                this._verify2(a, b);
                var res = a.isub(b);
                if (res.cmpn(0) < 0) res.iadd(this.m);
                return res;
            };
            Red.prototype.shl = function shl(a, num) {
                this._verify1(a);
                return this.imod(a.ushln(num));
            };
            Red.prototype.imul = function imul(a, b) {
                this._verify2(a, b);
                return this.imod(a.imul(b));
            };
            Red.prototype.mul = function mul(a, b) {
                this._verify2(a, b);
                return this.imod(a.mul(b));
            };
            Red.prototype.isqr = function isqr(a) {
                return this.imul(a, a.clone());
            };
            Red.prototype.sqr = function sqr(a) {
                return this.mul(a, a);
            };
            Red.prototype.sqrt = function sqrt(a) {
                if (a.isZero()) return a.clone();
                var mod3 = this.m.andln(3);
                assert29(mod3 % 2 === 1);
                if (mod3 === 3) {
                    var pow3 = this.m.add(new BN2(1)).iushrn(2);
                    return this.pow(a, pow3);
                }
                var q = this.m.subn(1);
                var s = 0;
                while(!q.isZero() && q.andln(1) === 0){
                    s++;
                    q.iushrn(1);
                }
                assert29(!q.isZero());
                var one = new BN2(1).toRed(this);
                var nOne = one.redNeg();
                var lpow = this.m.subn(1).iushrn(1);
                var z = this.m.bitLength();
                z = new BN2(2 * z * z).toRed(this);
                while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
                var c = this.pow(z, q);
                var r = this.pow(a, q.addn(1).iushrn(1));
                var t = this.pow(a, q);
                var m = s;
                while(t.cmp(one) !== 0){
                    var tmp = t;
                    for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                    assert29(i < m);
                    var b = this.pow(c, new BN2(1).iushln(m - i - 1));
                    r = r.redMul(b);
                    c = b.redSqr();
                    t = t.redMul(c);
                    m = i;
                }
                return r;
            };
            Red.prototype.invm = function invm(a) {
                var inv = a._invmp(this.m);
                if (inv.negative !== 0) {
                    inv.negative = 0;
                    return this.imod(inv).redNeg();
                } else return this.imod(inv);
            };
            Red.prototype.pow = function pow3(a, num) {
                if (num.isZero()) return new BN2(1).toRed(this);
                if (num.cmpn(1) === 0) return a.clone();
                var windowSize = 4;
                var wnd = new Array(1 << windowSize);
                wnd[0] = new BN2(1).toRed(this);
                wnd[1] = a;
                for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
                var res = wnd[0];
                var current = 0;
                var currentLen = 0;
                var start = num.bitLength() % 26;
                if (start === 0) start = 26;
                for(i = num.length - 1; i >= 0; i--){
                    var word = num.words[i];
                    for(var j = start - 1; j >= 0; j--){
                        var bit = word >> j & 1;
                        if (res !== wnd[0]) res = this.sqr(res);
                        if (bit === 0 && current === 0) {
                            currentLen = 0;
                            continue;
                        }
                        current <<= 1;
                        current |= bit;
                        currentLen++;
                        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                        res = this.mul(res, wnd[current]);
                        currentLen = 0;
                        current = 0;
                    }
                    start = 26;
                }
                return res;
            };
            Red.prototype.convertTo = function convertTo(num) {
                var r = num.umod(this.m);
                return r === num ? r.clone() : r;
            };
            Red.prototype.convertFrom = function convertFrom(num) {
                var res = num.clone();
                res.red = null;
                return res;
            };
            BN2.mont = function mont(num) {
                return new Mont(num);
            };
            function Mont(m) {
                Red.call(this, m);
                this.shift = this.m.bitLength();
                if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
                this.r = new BN2(1).iushln(this.shift);
                this.r2 = this.imod(this.r.sqr());
                this.rinv = this.r._invmp(this.m);
                this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
                this.minv = this.minv.umod(this.r);
                this.minv = this.r.sub(this.minv);
            }
            inherits(Mont, Red);
            Mont.prototype.convertTo = function convertTo(num) {
                return this.imod(num.ushln(this.shift));
            };
            Mont.prototype.convertFrom = function convertFrom(num) {
                var r = this.imod(num.mul(this.rinv));
                r.red = null;
                return r;
            };
            Mont.prototype.imul = function imul(a, b) {
                if (a.isZero() || b.isZero()) {
                    a.words[0] = 0;
                    a.length = 1;
                    return a;
                }
                var t = a.imul(b);
                var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                var u = t.isub(c).iushrn(this.shift);
                var res = u;
                if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                return res._forceRed(this);
            };
            Mont.prototype.mul = function mul(a, b) {
                if (a.isZero() || b.isZero()) return new BN2(0)._forceRed(this);
                var t = a.mul(b);
                var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
                var u = t.isub(c).iushrn(this.shift);
                var res = u;
                if (u.cmp(this.m) >= 0) res = u.isub(this.m);
                else if (u.cmpn(0) < 0) res = u.iadd(this.m);
                return res._forceRed(this);
            };
            Mont.prototype.invm = function invm(a) {
                var res = this.imod(a._invmp(this.m).mul(this.r2));
                return res._forceRed(this);
            };
        })(typeof module2 === "undefined" || module2, exports2);
    }
});
// ../../node_modules/fast-json-stable-stringify/index.js
var require_fast_json_stable_stringify = __commonJS({
    "../../node_modules/fast-json-stable-stringify/index.js" (exports2, module2) {
        "use strict";
        module2.exports = function(data, opts) {
            if (!opts) opts = {};
            if (typeof opts === "function") opts = {
                cmp: opts
            };
            var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
            var cmp = opts.cmp && /* @__PURE__ */ function(f) {
                return function(node) {
                    return function(a, b) {
                        var aobj = {
                            key: a,
                            value: node[a]
                        };
                        var bobj = {
                            key: b,
                            value: node[b]
                        };
                        return f(aobj, bobj);
                    };
                };
            }(opts.cmp);
            var seen = [];
            return function stringify(node) {
                if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
                if (node === void 0) return;
                if (typeof node == "number") return isFinite(node) ? "" + node : "null";
                if (typeof node !== "object") return JSON.stringify(node);
                var i, out;
                if (Array.isArray(node)) {
                    out = "[";
                    for(i = 0; i < node.length; i++){
                        if (i) out += ",";
                        out += stringify(node[i]) || "null";
                    }
                    return out + "]";
                }
                if (node === null) return "null";
                if (seen.indexOf(node) !== -1) {
                    if (cycles) return JSON.stringify("__cycle__");
                    throw new TypeError("Converting circular structure to JSON");
                }
                var seenIndex = seen.push(node) - 1;
                var keys = Object.keys(node).sort(cmp && cmp(node));
                out = "";
                for(i = 0; i < keys.length; i++){
                    var key = keys[i];
                    var value = stringify(node[key]);
                    if (!value) continue;
                    if (out) out += ",";
                    out += JSON.stringify(key) + ":" + value;
                }
                seen.splice(seenIndex, 1);
                return "{" + out + "}";
            }(data);
        };
    }
});
// src/index.ts
var src_exports = {};
__export(src_exports, {
    BLOCK_REF_LENGTH: ()=>BLOCK_REF_LENGTH,
    BLOOM_REGEX_LOWERCASE: ()=>BLOOM_REGEX_LOWERCASE,
    BLOOM_REGEX_UPPERCASE: ()=>BLOOM_REGEX_UPPERCASE,
    DECIMAL_INTEGER_REGEX: ()=>DECIMAL_INTEGER_REGEX,
    ERC721_ABI: ()=>ERC721_ABI,
    HDNode: ()=>HDNode,
    HEX_ADDRESS_REGEX: ()=>HEX_ADDRESS_REGEX,
    Hex: ()=>Hex,
    Hex0x: ()=>Hex0x,
    MAINNET_NETWORK: ()=>MAINNET_NETWORK,
    MNEMONIC_WORDLIST_ALLOWED_SIZES: ()=>MNEMONIC_WORDLIST_ALLOWED_SIZES,
    NUMERIC_REGEX: ()=>NUMERIC_REGEX,
    PARAMS_ABI: ()=>PARAMS_ABI,
    PARAMS_ADDRESS: ()=>PARAMS_ADDRESS,
    PRIVATE_KEY_MAX_VALUE: ()=>PRIVATE_KEY_MAX_VALUE,
    Quantity: ()=>Quantity,
    RLP: ()=>RLP2,
    RLPBase: ()=>RLPBase,
    RLPProfiles: ()=>RLPProfiles,
    SCRYPT_PARAMS: ()=>SCRYPT_PARAMS,
    SIGNATURE_LENGTH: ()=>SIGNATURE_LENGTH,
    SIGNED_TRANSACTION_RLP: ()=>SIGNED_TRANSACTION_RLP,
    SOLO_NETWORK: ()=>SOLO_NETWORK,
    TESTNET_NETWORK: ()=>TESTNET_NETWORK,
    TRANSACTIONS_GAS_CONSTANTS: ()=>TRANSACTIONS_GAS_CONSTANTS,
    TRANSACTION_FEATURES_KIND: ()=>TRANSACTION_FEATURES_KIND,
    TRANSACTION_SIGNATURE_KIND: ()=>TRANSACTION_SIGNATURE_KIND,
    Transaction: ()=>Transaction,
    TransactionHandler: ()=>TransactionHandler,
    TransactionUtils: ()=>TransactionUtils,
    UNSIGNED_TRANSACTION_RLP: ()=>UNSIGNED_TRANSACTION_RLP,
    VET_DERIVATION_PATH: ()=>VET_DERIVATION_PATH,
    VIP180_ABI: ()=>VIP180_ABI,
    VTHO_ADDRESS: ()=>VTHO_ADDRESS,
    X_PRIV_PREFIX: ()=>X_PRIV_PREFIX,
    X_PUB_PREFIX: ()=>X_PUB_PREFIX,
    ZERO_ADDRESS: ()=>ZERO_ADDRESS,
    ZERO_BUFFER: ()=>ZERO_BUFFER,
    abi: ()=>abi,
    addressUtils: ()=>addressUtils,
    assertCantGetFieldOnUnsignedTransaction: ()=>assertCantGetFieldOnUnsignedTransaction,
    assertCompactFixedHexBlobBuffer: ()=>assertCompactFixedHexBlobBuffer,
    assertFixedHexBlobKindBuffer: ()=>assertFixedHexBlobKindBuffer,
    assertFixedHexBlobKindData: ()=>assertFixedHexBlobKindData,
    assertIsAddress: ()=>assertIsAddress,
    assertIsArray: ()=>assertIsArray,
    assertIsRevisionForAccount: ()=>assertIsRevisionForAccount,
    assertIsRevisionForBlock: ()=>assertIsRevisionForBlock,
    assertIsSignedTransaction: ()=>assertIsSignedTransaction,
    assertIsValidBuffer: ()=>assertIsValidBuffer,
    assertIsValidHdNodeChainCode: ()=>assertIsValidHdNodeChainCode,
    assertIsValidHdNodeDerivationPath: ()=>assertIsValidHdNodeDerivationPath,
    assertIsValidPrivateKey: ()=>assertIsValidPrivateKey,
    assertIsValidReturnType: ()=>assertIsValidReturnType,
    assertIsValidSecp256k1MessageHash: ()=>assertIsValidSecp256k1MessageHash,
    assertIsValidTransactionSigningPrivateKey: ()=>assertIsValidTransactionSigningPrivateKey,
    assertValidHexBlobKindBuffer: ()=>assertValidHexBlobKindBuffer,
    assertValidHexBlobKindData: ()=>assertValidHexBlobKindData,
    assertValidNumericKindBuffer: ()=>assertValidNumericKindBuffer,
    assertValidTransactionHead: ()=>assertValidTransactionHead,
    assertValidTransactionID: ()=>assertValidTransactionID,
    blake2b256: ()=>blake2b256,
    bloom: ()=>bloom,
    bloomUtils: ()=>bloomUtils,
    certificate: ()=>certificate,
    clauseBuilder: ()=>clauseBuilder,
    coder: ()=>coder,
    core: ()=>core_exports,
    dataUtils: ()=>dataUtils,
    decodeBufferToHexWithLeadingZeros: ()=>decodeBufferToHexWithLeadingZeros,
    decodeBufferToNumberOrHex: ()=>decodeBufferToNumberOrHex,
    encodeBigIntToBuffer: ()=>encodeBigIntToBuffer,
    encodeCompactFixedHexBlob: ()=>encodeCompactFixedHexBlob,
    fragment: ()=>fragment,
    isDerivationPathValid: ()=>isDerivationPathValid,
    keccak256: ()=>keccak256,
    keystore: ()=>keystore,
    mnemonic: ()=>mnemonic,
    networkInfo: ()=>networkInfo,
    revisionUtils: ()=>revisionUtils,
    secp256k1: ()=>secp256k12,
    sha256: ()=>sha256,
    unitsUtils: ()=>unitsUtils,
    validateNumericKindData: ()=>validateNumericKindData,
    vechain_sdk_core_ethers: ()=>import_ethers13.ethers
});
module.exports = __toCommonJS(src_exports);
// src/core.ts
var core_exports = {};
__export(core_exports, {
    BLOCK_REF_LENGTH: ()=>BLOCK_REF_LENGTH,
    BLOOM_REGEX_LOWERCASE: ()=>BLOOM_REGEX_LOWERCASE,
    BLOOM_REGEX_UPPERCASE: ()=>BLOOM_REGEX_UPPERCASE,
    DECIMAL_INTEGER_REGEX: ()=>DECIMAL_INTEGER_REGEX,
    ERC721_ABI: ()=>ERC721_ABI,
    HDNode: ()=>HDNode,
    HEX_ADDRESS_REGEX: ()=>HEX_ADDRESS_REGEX,
    Hex: ()=>Hex,
    Hex0x: ()=>Hex0x,
    MAINNET_NETWORK: ()=>MAINNET_NETWORK,
    MNEMONIC_WORDLIST_ALLOWED_SIZES: ()=>MNEMONIC_WORDLIST_ALLOWED_SIZES,
    NUMERIC_REGEX: ()=>NUMERIC_REGEX,
    PARAMS_ABI: ()=>PARAMS_ABI,
    PARAMS_ADDRESS: ()=>PARAMS_ADDRESS,
    PRIVATE_KEY_MAX_VALUE: ()=>PRIVATE_KEY_MAX_VALUE,
    Quantity: ()=>Quantity,
    RLP: ()=>RLP2,
    RLPBase: ()=>RLPBase,
    RLPProfiles: ()=>RLPProfiles,
    SCRYPT_PARAMS: ()=>SCRYPT_PARAMS,
    SIGNATURE_LENGTH: ()=>SIGNATURE_LENGTH,
    SIGNED_TRANSACTION_RLP: ()=>SIGNED_TRANSACTION_RLP,
    SOLO_NETWORK: ()=>SOLO_NETWORK,
    TESTNET_NETWORK: ()=>TESTNET_NETWORK,
    TRANSACTIONS_GAS_CONSTANTS: ()=>TRANSACTIONS_GAS_CONSTANTS,
    TRANSACTION_FEATURES_KIND: ()=>TRANSACTION_FEATURES_KIND,
    TRANSACTION_SIGNATURE_KIND: ()=>TRANSACTION_SIGNATURE_KIND,
    Transaction: ()=>Transaction,
    TransactionHandler: ()=>TransactionHandler,
    TransactionUtils: ()=>TransactionUtils,
    UNSIGNED_TRANSACTION_RLP: ()=>UNSIGNED_TRANSACTION_RLP,
    VET_DERIVATION_PATH: ()=>VET_DERIVATION_PATH,
    VIP180_ABI: ()=>VIP180_ABI,
    VTHO_ADDRESS: ()=>VTHO_ADDRESS,
    X_PRIV_PREFIX: ()=>X_PRIV_PREFIX,
    X_PUB_PREFIX: ()=>X_PUB_PREFIX,
    ZERO_ADDRESS: ()=>ZERO_ADDRESS,
    ZERO_BUFFER: ()=>ZERO_BUFFER,
    abi: ()=>abi,
    addressUtils: ()=>addressUtils,
    assertCantGetFieldOnUnsignedTransaction: ()=>assertCantGetFieldOnUnsignedTransaction,
    assertCompactFixedHexBlobBuffer: ()=>assertCompactFixedHexBlobBuffer,
    assertFixedHexBlobKindBuffer: ()=>assertFixedHexBlobKindBuffer,
    assertFixedHexBlobKindData: ()=>assertFixedHexBlobKindData,
    assertIsAddress: ()=>assertIsAddress,
    assertIsArray: ()=>assertIsArray,
    assertIsRevisionForAccount: ()=>assertIsRevisionForAccount,
    assertIsRevisionForBlock: ()=>assertIsRevisionForBlock,
    assertIsSignedTransaction: ()=>assertIsSignedTransaction,
    assertIsValidBuffer: ()=>assertIsValidBuffer,
    assertIsValidHdNodeChainCode: ()=>assertIsValidHdNodeChainCode,
    assertIsValidHdNodeDerivationPath: ()=>assertIsValidHdNodeDerivationPath,
    assertIsValidPrivateKey: ()=>assertIsValidPrivateKey,
    assertIsValidReturnType: ()=>assertIsValidReturnType,
    assertIsValidSecp256k1MessageHash: ()=>assertIsValidSecp256k1MessageHash,
    assertIsValidTransactionSigningPrivateKey: ()=>assertIsValidTransactionSigningPrivateKey,
    assertValidHexBlobKindBuffer: ()=>assertValidHexBlobKindBuffer,
    assertValidHexBlobKindData: ()=>assertValidHexBlobKindData,
    assertValidNumericKindBuffer: ()=>assertValidNumericKindBuffer,
    assertValidTransactionHead: ()=>assertValidTransactionHead,
    assertValidTransactionID: ()=>assertValidTransactionID,
    blake2b256: ()=>blake2b256,
    bloom: ()=>bloom,
    bloomUtils: ()=>bloomUtils,
    certificate: ()=>certificate,
    clauseBuilder: ()=>clauseBuilder,
    coder: ()=>coder,
    dataUtils: ()=>dataUtils,
    decodeBufferToHexWithLeadingZeros: ()=>decodeBufferToHexWithLeadingZeros,
    decodeBufferToNumberOrHex: ()=>decodeBufferToNumberOrHex,
    encodeBigIntToBuffer: ()=>encodeBigIntToBuffer,
    encodeCompactFixedHexBlob: ()=>encodeCompactFixedHexBlob,
    fragment: ()=>fragment,
    isDerivationPathValid: ()=>isDerivationPathValid,
    keccak256: ()=>keccak256,
    keystore: ()=>keystore,
    mnemonic: ()=>mnemonic,
    networkInfo: ()=>networkInfo,
    revisionUtils: ()=>revisionUtils,
    secp256k1: ()=>secp256k12,
    sha256: ()=>sha256,
    unitsUtils: ()=>unitsUtils,
    validateNumericKindData: ()=>validateNumericKindData,
    vechain_sdk_core_ethers: ()=>import_ethers13.ethers
});
var import_ethers13 = require("4118e9000a31bc10");
// src/abi/fragment.ts
var import_ethers = require("4118e9000a31bc10");
var import_sdk_errors = require("efe1f1d778f145a2");
// src/abi/helpers/fragment.ts
var sanitizeValuesToEncode = (valuesToEncode, event)=>{
    if (valuesToEncode.length === 0) return [];
    if (valuesToEncode.length > event.inputs.length) return valuesToEncode;
    const sanitizedValuesToEncode = [];
    const eventInputs = event.inputs;
    for (const input of eventInputs)input.indexed === true ? sanitizedValuesToEncode.push(valuesToEncode.shift()) : sanitizedValuesToEncode.push(null);
    return sanitizedValuesToEncode;
};
// src/abi/fragment.ts
var allowedSignatureFormats = [
    "sighash",
    "minimal",
    "full",
    "json"
];
function getSignature(fragment2, formatType) {
    (0, import_sdk_errors.assert)("getSignature", allowedSignatureFormats.includes(formatType), import_sdk_errors.ABI.INVALID_FORMAT_TYPE, `Signature format error: '${formatType}' is invalid. Allowed formats: ${allowedSignatureFormats.join(", ")}`, {
        formatType
    });
    return fragment2.format(formatType);
}
var Function = class {
    /**
   * The main fragment handled by ethers.js.
   *
   */ fragment;
    /**
   * The main interface handled by ethers.js.
   */ iface;
    /**
   * Creates a new Function instance from an ABI fragment.
   *
   * @throws{InvalidAbiFunctionError}
   * @param source - ABI fragment to use.
   */ constructor(source){
        try {
            this.fragment = import_ethers.ethers.FunctionFragment.from(source);
            this.iface = new import_ethers.ethers.Interface([
                this.fragment
            ]);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("Function constructor", import_sdk_errors.ABI.INVALID_FUNCTION, "Initialization failed: Cannot create Function fragment. Function format is invalid.", {
                source
            }, e);
        }
    }
    /**
   * Get the signature hash of the function.
   *
   * @returns The signature hash of the function.
   */ signatureHash() {
        return this.fragment.selector;
    }
    /**
   * Get the signature of the function.
   *
   * @param formatType - The format type of the signature: 'sighash', 'minimal', 'full', or 'json'.
   * @returns The signature of the function.
   */ signature(formatType) {
        return getSignature(this.fragment, formatType);
    }
    /**
   * Decode data using the function's ABI.
   *
   * @throws{InvalidAbiDataToDecodeError} - If the data cannot be decoded.
   * @param data - Data to decode.
   * @returns Decoding results.
   */ decodeInput(data) {
        try {
            return this.iface.decodeFunctionData(this.fragment, data);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("decodeInput", import_sdk_errors.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data
            }, e);
        }
    }
    /**
   * Decodes the output data from a transaction based on ABI (Application Binary Interface) specifications.
   * This method attempts to decode the given byte-like data into a readable format using the contract's interface.
   *
   * @param data - The `BytesLike` data to be decoded, typically representing the output of a contract function call.
   * @returns A `Result` object containing the decoded data.
   *
   * @throws{InvalidAbiDataToDecodeError} - If the data cannot be decoded.
   *
   * @example
   * ```typescript
   *   const decoded = contractInstance.decodeOutput(rawTransactionOutput);
   *   console.log('Decoded Output:', decoded);
   * ```
   */ decodeOutput(data) {
        try {
            return this.iface.decodeFunctionResult(this.fragment, data);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("decodeOutput", import_sdk_errors.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Data must be a valid hex string encoding a compliant ABI type.", {
                data
            }, e);
        }
    }
    /**
   * Encode data using the function's ABI.
   *
   * @throws{InvalidAbiDataToEncodeError}
   * @param dataToEncode - Data to encode.
   * @returns Encoded data.
   */ encodeInput(dataToEncode) {
        try {
            return this.iface.encodeFunctionData(this.fragment, dataToEncode);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("encodeInput", import_sdk_errors.ABI.INVALID_DATA_TO_ENCODE, "Encoding failed: Data format is invalid. Function data does not match the expected format for ABI type encoding.", {
                dataToEncode
            }, e);
        }
    }
};
var Event = class {
    /**
   * The main fragment handled by ethers.js.
   */ fragment;
    /**
   * The main interface handled by ethers.js.
   */ iface;
    /**
   * Creates a new Event instance from an ABI fragment.
   *
   * @throws{InvalidAbiEventError}
   * @param source - ABI fragment to use.
   */ constructor(source){
        try {
            this.fragment = import_ethers.ethers.EventFragment.from(source);
            this.iface = new import_ethers.ethers.Interface([
                this.fragment
            ]);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("Event constructor", import_sdk_errors.ABI.INVALID_EVENT, "Initialization failed: Event fragment creation is not possible due to invalid ABI data format.", {
                source
            }, e);
        }
    }
    /**
   * Get the signature hash of the event.
   *
   * @returns The signature hash of the event.
   */ signatureHash() {
        return this.fragment.topicHash;
    }
    /**
   * Get the signature of the event.
   *
   * @param formatType - The format type of the signature: 'sighash', 'minimal', 'full', or 'json'.
   * @returns The signature of the event.
   */ signature(formatType) {
        return getSignature(this.fragment, formatType);
    }
    /**
   * Decode event log data using the event's ABI.
   *
   * @throws{InvalidAbiDataToDecodeError}
   * @param data - Data to decode.
   * @returns Decoding results.
   */ decodeEventLog(data) {
        try {
            return this.iface.decodeEventLog(this.fragment, data.data, data.topics);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("decodeEventLog", import_sdk_errors.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Data and topics must be correctly formatted for ABI-compliant decoding.", {
                data
            }, e);
        }
    }
    /**
   * Encode event log data using the event's ABI.
   *
   * @throws{InvalidAbiDataToEncodeError}
   * @param dataToEncode - Data to encode.
   * @returns Encoded data along with topics.
   */ encodeEventLog(dataToEncode) {
        try {
            return this.iface.encodeEventLog(this.fragment, dataToEncode);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("encodeEventLog", import_sdk_errors.ABI.INVALID_DATA_TO_ENCODE, "Encoding failed: Event data must be correctly formatted for ABI-compliant encoding.", {
                dataToEncode
            }, e);
        }
    }
    /**
   * Encode event log topics using the event's ABI.
   *
   * @param valuesToEncode - values to encode as topics. Non-indexed values are ignored.
   *                         Only the values of the indexed parameters are needed.
   *
   * @returns Encoded topics array.
   */ encodeFilterTopics(valuesToEncode) {
        try {
            const sanitizedValuesToEncode = sanitizeValuesToEncode(valuesToEncode, this.fragment);
            return this.iface.encodeFilterTopics(this.fragment, sanitizedValuesToEncode).map((topic)=>topic ?? void 0);
        } catch (e) {
            throw (0, import_sdk_errors.buildError)("encodeFilterTopics", import_sdk_errors.ABI.INVALID_DATA_TO_ENCODE, "Encoding topics failed: Event topics values must be correctly formatted for ABI-compliant encoding.", {
                valuesToEncode
            }, e);
        }
    }
};
var fragment = {
    Function,
    Event
};
// src/abi/coder.ts
var import_ethers2 = require("4118e9000a31bc10");
var import_sdk_errors2 = require("efe1f1d778f145a2");
var ethersCoder = new import_ethers2.ethers.AbiCoder();
function encode(type, value) {
    try {
        return ethersCoder.encode([
            type
        ], [
            value
        ]);
    } catch  {
        throw (0, import_sdk_errors2.buildError)("encode", import_sdk_errors2.ABI.INVALID_DATA_TO_ENCODE, "Encoding failed: Data must be a valid ABI type with corresponding valid data.");
    }
}
function encodeParams(types, values) {
    try {
        return ethersCoder.encode(types, values);
    } catch  {
        throw (0, import_sdk_errors2.buildError)("encodeParams", import_sdk_errors2.ABI.INVALID_DATA_TO_ENCODE, "Encoding failed: Data must be a valid ABI type with corresponding valid data.");
    }
}
function decode(types, data) {
    try {
        const decoded = ethersCoder.decode([
            types
        ], data).toArray();
        return decoded[0];
    } catch  {
        throw (0, import_sdk_errors2.buildError)("decode", import_sdk_errors2.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Data must be a valid hex string that encodes a valid ABI type.");
    }
}
var abi = {
    ...fragment,
    encode,
    encodeParams,
    decode
};
// src/contract/coder.ts
var import_ethers3 = require("4118e9000a31bc10");
var import_sdk_errors3 = require("efe1f1d778f145a2");
function createInterface(abi2) {
    return new import_ethers3.Interface(abi2);
}
function encodeFunctionInput(interfaceABI, functionName, functionData) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return new abi.Function(contractInterface.getFunction(functionName)).encodeInput(functionData);
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.encodeFunctionInput", import_sdk_errors3.ERROR_CODES.ABI.INVALID_DATA_TO_ENCODE, `Method 'encodeFunctionInput' failed while encoding input for function '${functionName}'. Input must match ABI specifications and be correctly formatted.
Parameters: ${JSON.stringify(functionData)}.
Ethers' error message: ${e.message}.`, {
            functionName,
            functionData
        }, e);
    }
}
function decodeFunctionInput(interfaceABI, functionName, encodedFunctionInput) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return new abi.Function(contractInterface.getFunction(functionName)).decodeInput(encodedFunctionInput);
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.decodeFunctionInput", import_sdk_errors3.ERROR_CODES.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Function input must be properly encoded per ABI specifications.", {
            functionName
        }, e);
    }
}
function decodeFunctionOutput(interfaceABI, functionName, encodedFunctionOutput) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return new abi.Function(contractInterface.getFunction(functionName)).decodeOutput(encodedFunctionOutput);
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.decodeFunctionOutput", import_sdk_errors3.ERROR_CODES.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Function output must be properly encoded per ABI specifications.", {
            functionName
        }, e);
    }
}
function encodeEventLog(interfaceABI, eventName, dataToEncode) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return new abi.Event(contractInterface.getEvent(eventName)).encodeEventLog(dataToEncode);
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.encodeEventLog", import_sdk_errors3.ERROR_CODES.ABI.INVALID_EVENT, "Encoding failed: Event log data must align with ABI specifications for encoding.", {
            eventName
        }, e);
    }
}
function decodeEventLog(interfaceABI, eventName, dataToDecode) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return new abi.Event(contractInterface.getEvent(eventName)).decodeEventLog(dataToDecode);
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.decodeEventLog", import_sdk_errors3.ERROR_CODES.ABI.INVALID_EVENT, "Decoding failed: Event log data must be correctly encoded per ABI specifications.", {
            eventName
        }, e);
    }
}
function parseLog(interfaceABI, data, topics) {
    try {
        const contractInterface = createInterface(interfaceABI);
        return contractInterface.parseLog({
            topics,
            data
        });
    } catch (e) {
        throw (0, import_sdk_errors3.buildError)("coder.parseLog", import_sdk_errors3.ABI.INVALID_DATA_TO_DECODE, "Decoding failed: Data and topics must be correctly formatted for ABI-compliant decoding.", {
            data
        }, e);
    }
}
var coder = {
    createInterface,
    encodeFunctionInput,
    decodeFunctionInput,
    decodeFunctionOutput,
    encodeEventLog,
    decodeEventLog,
    parseLog
};
// src/address/address.ts
var import_ethers8 = require("4118e9000a31bc10");
// src/utils/const/bloom.ts
var BLOOM_REGEX_UPPERCASE = /^(0x)?[0-9A-F]{16,}$/;
var BLOOM_REGEX_LOWERCASE = /^(0x)?[0-9a-f]{16,}$/;
// src/utils/const/data.ts
var ZERO_BUFFER = (size)=>Buffer.alloc(size, 0);
var HEX_ADDRESS_REGEX = /^0x[0-9a-f]{40}$/i;
var DECIMAL_INTEGER_REGEX = /^\d+$/;
var NUMERIC_REGEX = /(^-?\d+(\.\d+)?)$|(^-?\.\d+)$/;
// src/utils/const/hdnode.ts
var VET_DERIVATION_PATH = "m/44'/818'/0'/0";
var X_PUB_PREFIX = Buffer.from("0488b21e000000000000000000", "hex");
var X_PRIV_PREFIX = Buffer.from("0488ade4000000000000000000", "hex");
// src/utils/const/keystore.ts
var SCRYPT_PARAMS = {
    N: 131072,
    r: 8,
    p: 1
};
// src/utils/const/mnemonic.ts
var MNEMONIC_WORDLIST_ALLOWED_SIZES = [
    12,
    15,
    18,
    21,
    24
];
// src/utils/const/secp256k1.ts
var PRIVATE_KEY_MAX_VALUE = Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
// src/encoding/rlp/rlp.ts
var import_rlp = require("fdfd8d96a65e922d");
var import_sdk_errors11 = require("efe1f1d778f145a2");
// src/assertions/account/account.ts
var import_sdk_errors4 = require("efe1f1d778f145a2");
function assertIsAddress(methodName, address) {
    (0, import_sdk_errors4.assert)(`assertIsAddress - ${methodName}`, addressUtils.isAddress(address), import_sdk_errors4.DATA.INVALID_DATA_TYPE, "Invalid address. The address must be 20 bytes (a 42 characters hex string with a `0x` prefix.)", {
        address
    });
}
// src/assertions/block/block.ts
var import_sdk_errors5 = require("efe1f1d778f145a2");
function assertIsRevisionForBlock(methodName, revision) {
    (0, import_sdk_errors5.assert)(`assertIsRevisionForBlock - ${methodName}`, revision === void 0 || revision === null || revisionUtils.isRevisionBlock(revision), import_sdk_errors5.DATA.INVALID_DATA_TYPE, 'Invalid revision. The revision must be a string representing a block number or block id (also "best" is accepted which represents the best block & "finalized" for the finalized block).', {
        revision
    });
}
function assertIsRevisionForAccount(methodName, revision) {
    (0, import_sdk_errors5.assert)(`assertIsRevisionForAccount - ${methodName}`, revision === void 0 || revision === null || revisionUtils.isRevisionAccount(revision), import_sdk_errors5.DATA.INVALID_DATA_TYPE, 'Invalid revision. The revision must be a string representing a block number or block id (also "best" is accepted which represents the best block).', {
        revision
    });
}
// src/assertions/hash/hash.ts
var import_sdk_errors6 = require("efe1f1d778f145a2");
var isValidReturnType = (value)=>{
    return !(value !== "buffer" && value !== "hex");
};
function assertIsValidReturnType(methodName, returnType) {
    (0, import_sdk_errors6.assert)(`assertIsValidReturnType - ${methodName}`, isValidReturnType(returnType), import_sdk_errors6.DATA.INVALID_DATA_RETURN_TYPE, "Validation error: Invalid Return type. Return type in hash function must be 'buffer' or 'hex'.", {
        returnType
    });
}
// src/assertions/hdnode/hdnode.ts
var import_sdk_errors7 = require("efe1f1d778f145a2");
function assertIsValidHdNodeDerivationPath(methodName, path) {
    (0, import_sdk_errors7.assert)("assertIsValidHdNodeDerivationPath", isDerivationPathValid(path), import_sdk_errors7.HDNODE.INVALID_HDNODE_DERIVATION_PATH, "Invalid derivation path. Ensure the path adheres to the standard format.", {
        path
    });
}
function assertIsValidHdNodeChainCode(methodName, chainCode) {
    (0, import_sdk_errors7.assert)("assertIsValidHdNodeChainCode", chainCode.length === 32, import_sdk_errors7.HDNODE.INVALID_HDNODE_CHAIN_CODE, "Invalid chain code. Length must be exactly 32 bytes.", {
        chainCode
    });
}
// src/assertions/keystore/keystore.ts
var import_sdk_errors8 = require("efe1f1d778f145a2");
function assertIsValidPrivateKey(methodName, privateKey, isValidPrivateKeyFunction) {
    (0, import_sdk_errors8.assert)(`assertIsValidPrivateKey - ${methodName}`, isValidPrivateKeyFunction(privateKey), import_sdk_errors8.SECP256K1.INVALID_SECP256k1_PRIVATE_KEY, "Invalid private key given as input. Ensure it is a valid 32-byte secp256k1 private key.", {
        privateKey
    });
}
function assertIsValidSecp256k1MessageHash(methodName, msgHash, isValidMessageHashFunction) {
    (0, import_sdk_errors8.assert)(`assertIsValidSecp256k1MessageHash - ${methodName}`, isValidMessageHashFunction(msgHash), import_sdk_errors8.SECP256K1.INVALID_SECP256k1_MESSAGE_HASH, "Invalid private key given as input. Ensure it is a valid 32-byte secp256k1 private key.", {
        msgHash
    });
}
// src/assertions/transaction/transaction.ts
var import_sdk_errors9 = require("efe1f1d778f145a2");
function assertValidTransactionID(methodName, transactionId) {
    (0, import_sdk_errors9.assert)(`assertValidTransactionID - ${methodName}`, Hex0x.isThorId(transactionId), import_sdk_errors9.DATA.INVALID_DATA_TYPE, "Invalid transaction ID given as input. Input must be an hex string of length 64.", {
        transactionId
    });
}
function assertValidTransactionHead(methodName, head) {
    (0, import_sdk_errors9.assert)(`assertValidTransactionHead - ${methodName}`, head === void 0 || Hex0x.isThorId(head), import_sdk_errors9.DATA.INVALID_DATA_TYPE, "Invalid head given as input. Input must be an hex string of length 64.", {
        head
    });
}
function assertIsSignedTransaction(methodName, tx) {
    (0, import_sdk_errors9.assert)(`assertIsSignedTransaction - ${methodName}`, tx.isSigned, import_sdk_errors9.TRANSACTION.NOT_SIGNED, "Transaction must be signed.", {
        tx
    });
}
function assertIsValidTransactionSigningPrivateKey(methodName, privateKey, isValidPrivateKeyFunction, role) {
    (0, import_sdk_errors9.assert)(`assertIsValidTransactionSigningPrivateKey - ${methodName}`, isValidPrivateKeyFunction(privateKey), import_sdk_errors9.SECP256K1.INVALID_SECP256k1_PRIVATE_KEY, `Invalid ${role} private key used to sign the transaction. Ensure it's a valid secp256k1 private key.`, {
        privateKey
    });
}
function assertCantGetFieldOnUnsignedTransaction(methodName, transaction, fieldToGet) {
    (0, import_sdk_errors9.assert)(`assertCantGetFieldOnUnsignedTransaction - ${methodName}`, transaction.isSigned, import_sdk_errors9.TRANSACTION.NOT_SIGNED, `Cannot get ${fieldToGet} from unsigned transaction. Sign the transaction first.`);
}
// src/assertions/rlp/rlp.ts
var import_sdk_errors10 = require("efe1f1d778f145a2");
function assertIsValidBuffer(methodName, bufferToCheck, context) {
    (0, import_sdk_errors10.assert)(`assertIsValidBuffer - ${methodName}`, Buffer.isBuffer(bufferToCheck), import_sdk_errors10.RLP.INVALID_RLP, `Validation error: Expected a Buffer type in ${context}.`, {
        bufferToCheck,
        context
    });
}
function assertIsArray(methodName, arrayToCheck, context) {
    (0, import_sdk_errors10.assert)(`assertIsArray - ${methodName}`, Array.isArray(arrayToCheck), import_sdk_errors10.RLP.INVALID_RLP, `Validation error: Expected an array in ${context}.`, {
        context
    });
}
// src/encoding/rlp/rlp.ts
function encode2(data) {
    const encodedData = import_rlp.RLP.encode(data);
    return Buffer.from(encodedData);
}
function decode2(encodedData) {
    return import_rlp.RLP.decode(encodedData);
}
var Profiler = class {
    /**
   * Creates a new Profiler instance.
   * @param profile - RLP profile for encoding/decoding structures.
   */ constructor(profile){
        this.profile = profile;
    }
    /**
   * Encodes an object following the provided RLP profile.
   * @param data - Object to be encoded.
   * @returns - Encoded data as a Buffer.
   */ encodeObject(data) {
        const packedData = _packData(data, this.profile, "");
        return Buffer.from(import_rlp.RLP.encode(packedData));
    }
    /**
   * Decodes an object following the provided RLP profile.
   * @param encodedData - Data to be decoded.
   * @returns - Decoded data as RLPValueType.
   */ decodeObject(encodedData) {
        const packedData = import_rlp.RLP.decode(encodedData);
        return _unpackData(packedData, this.profile, "");
    }
};
var _packData = (obj, profile, context)=>{
    context = context !== "" ? context + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof RLP2.ScalarKind) return kind.data(obj, context).encode();
    if (Array.isArray(kind)) return kind.map((k)=>_packData(obj[k.name], k, context));
    assertIsArray("packData", obj, context);
    if ("item" in kind && Array.isArray(obj)) {
        const item = kind.item;
        return obj.map((part, i)=>_packData(part, {
                name: "#" + i,
                kind: item
            }, context));
    }
};
var _unpackData = (packed, profile, context)=>{
    context = context !== "" ? context + "." + profile.name : profile.name;
    const kind = profile.kind;
    if (kind instanceof RLP2.ScalarKind) {
        (0, import_sdk_errors11.assert)("_unpackData", Buffer.isBuffer(packed) || packed instanceof Uint8Array, import_sdk_errors11.RLP.INVALID_RLP, "Unpacking error: Expected data type is Buffer.", {
            context
        });
        if (packed instanceof Uint8Array) packed = Buffer.from(packed);
        return kind.buffer(packed, context).decode();
    }
    if (Array.isArray(kind) && Array.isArray(packed)) {
        const parts = packed;
        (0, import_sdk_errors11.assert)("_unpackData", parts.length === kind.length, import_sdk_errors11.RLP.INVALID_RLP, `Unpacking error: Expected ${kind.length} items, but got ${parts.length}.`, {
            context
        });
        return kind.reduce((obj, profile2, index)=>{
            obj[profile2.name] = _unpackData(parts[index], profile2, context);
            return obj;
        }, {});
    }
    assertIsArray("_unpackData", packed, context);
    if ("item" in kind && Array.isArray(packed)) {
        const item = kind.item;
        return packed.map((part, index)=>_unpackData(part, {
                name: "#" + index,
                kind: item
            }, context));
    }
};
var RLPBase = {
    encode: encode2,
    decode: decode2,
    Profiler
};
// src/encoding/rlp/kind/scalarkind.abstract.ts
var ScalarKind = class {
};
// src/encoding/rlp/kind/bufferkind.ts
var BufferKind = class extends ScalarKind {
    /**
   * Encodes the input data into buffer format.
   *
   * @throws{InvalidRLPError}
   * @param data - The data to encode, expected to be of buffer type.
   * @param context - Descriptive context for error messages
   * @returns DataOutput object with an encode function.
   */ data(data, context) {
        assertIsValidBuffer("data", data, context);
        return {
            encode: ()=>data
        };
    }
    /**
   * Decodes the input buffer.
   *
   * @throws{InvalidRLPError}
   * @param buffer - The buffer to decode, expected to be of buffer type.
   * @param context - Descriptive context for error messages, usually representing the caller's identity.
   * @returns BufferOutput object with a decode function.
   */ buffer(buffer, context) {
        assertIsValidBuffer("buffer", buffer, context);
        return {
            decode: ()=>buffer
        };
    }
};
// src/encoding/rlp/helpers/numerickind.ts
var import_sdk_errors12 = require("efe1f1d778f145a2");
var validateNumericKindData = (data, context)=>{
    (0, import_sdk_errors12.assert)("validateNumericKindData", typeof data === "number" || typeof data === "string", import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Input in ${context} must be a string or number.`, {
        data,
        context
    });
    if (typeof data === "number") _validateNumericKindNumber(data, context);
    else if (typeof data === "string") _validateNumericKindString(data, context);
    return BigInt(data);
};
var _validateNumericKindNumber = (num, context)=>{
    (0, import_sdk_errors12.assert)("validateNumericKindNumber", Number.isSafeInteger(num) && num >= 0, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Number in ${context} must be a safe and non-negative integer.`, {
        num,
        context
    });
};
var _validateNumericKindString = (str, context)=>{
    const isHex = Hex0x.isValid(str);
    const isDecimal = dataUtils.isDecimalString(str);
    (0, import_sdk_errors12.assert)("_validateNumericKindString", isHex || isDecimal, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: String in ${context} must represent a non-negative integer in hex or decimal format.`, {
        str,
        context
    });
    (0, import_sdk_errors12.assert)("_validateNumericKindString", !isHex || str.length > 2, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Hex string number in ${context} must be of valid length.`, {
        str,
        context
    });
};
var assertValidNumericKindBuffer = (buf, context, maxBytes)=>{
    (0, import_sdk_errors12.assert)("assertValidNumericKindBuffer", maxBytes === void 0 || buf.length <= maxBytes, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Buffer in ${context} must be less than ${maxBytes} bytes.`, {
        maxBytes,
        context
    });
    (0, import_sdk_errors12.assert)("assertValidNumericKindBuffer", buf[0] !== 0, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Buffer in ${context} must represent a canonical integer (no leading zeros).`, {
        buf,
        context
    });
};
var encodeBigIntToBuffer = (bi, maxBytes, context)=>{
    if (bi === 0n) return Buffer.alloc(0);
    const hex = Hex.of(bi);
    (0, import_sdk_errors12.assert)("encodeBigIntToBuffer", maxBytes === void 0 || hex.length <= maxBytes * 2, import_sdk_errors12.RLP.INVALID_RLP, `Validation error: Encoded number in ${context} must fit within ${maxBytes} bytes.`, {
        maxBytes,
        hex,
        context
    });
    return Buffer.from(hex, "hex");
};
var decodeBufferToNumberOrHex = (buffer)=>{
    if (buffer.length === 0) return 0;
    const bi = BigInt(Hex0x.of(buffer));
    const num = Number(bi);
    return Number.isSafeInteger(num) ? num : "0x" + bi.toString(16);
};
// src/encoding/rlp/helpers/hexblobkind.ts
var import_sdk_errors13 = require("efe1f1d778f145a2");
var assertValidHexBlobKindData = (data, context)=>{
    (0, import_sdk_errors13.assert)("assertValidHexBlobKindData", typeof data === "string", import_sdk_errors13.RLP.INVALID_RLP, "Validation error: Input must be a string.", {
        data,
        context
    });
    (0, import_sdk_errors13.assert)("assertValidHexBlobKindData", Hex0x.isValid(data), import_sdk_errors13.RLP.INVALID_RLP, "Validation error: Input must be a valid hex string with a '0x' prefix.", {
        data,
        context
    });
    (0, import_sdk_errors13.assert)("assertValidHexBlobKindData", data.length % 2 === 0, import_sdk_errors13.RLP.INVALID_RLP, "Validation error: Hex string must have an even length.", {
        data,
        context
    });
};
var assertValidHexBlobKindBuffer = (buffer, context)=>{
    (0, import_sdk_errors13.assert)("assertValidHexBlobKindBuffer", Buffer.isBuffer(buffer), import_sdk_errors13.RLP.INVALID_RLP, "Validation error: Input must be a valid buffer.", {
        buffer,
        context
    });
};
// src/encoding/rlp/helpers/fixedhexblobkind.ts
var import_sdk_errors14 = require("efe1f1d778f145a2");
var assertFixedHexBlobKindData = (data, context, bytes2)=>{
    (0, import_sdk_errors14.assert)("assertFixedHexBlobKindData", data.length === bytes2 * 2 + 2, import_sdk_errors14.RLP.INVALID_RLP, `Validation error: Hex string in ${context} must be exactly ${bytes2} bytes in length.`, {
        data,
        context
    });
};
var assertFixedHexBlobKindBuffer = (buffer, context, bytes2)=>{
    (0, import_sdk_errors14.assert)("assertFixedHexBlobKindBuffer", buffer.length === bytes2, import_sdk_errors14.RLP.INVALID_RLP, `Validation error: Buffer in ${context} must be exactly ${bytes2} bytes in length.`, {
        buffer,
        context
    });
};
// src/encoding/rlp/helpers/compactfixedhexblobkind.ts
var import_sdk_errors15 = require("efe1f1d778f145a2");
var assertCompactFixedHexBlobBuffer = (buffer, context, bytes2)=>{
    (0, import_sdk_errors15.assert)("assertCompactFixedHexBlobBuffer", buffer.length <= bytes2, import_sdk_errors15.RLP.INVALID_RLP, `Validation error: Buffer in ${context} must be at most ${bytes2} bytes.`, {
        buffer,
        context
    });
    (0, import_sdk_errors15.assert)("assertCompactFixedHexBlobBuffer", buffer.length === 0 || buffer[0] !== 0, import_sdk_errors15.RLP.INVALID_RLP, `Validation error: Buffer in ${context} should not have leading zero bytes.`, {
        buffer,
        context
    });
};
var encodeCompactFixedHexBlob = (buffer)=>{
    const zeroIndex = buffer.findIndex((byte)=>byte !== 0);
    return zeroIndex !== -1 ? buffer.subarray(zeroIndex) : Buffer.alloc(0);
};
var decodeBufferToHexWithLeadingZeros = (buffer, bytes2)=>{
    return Hex0x.of(buffer, bytes2);
};
// src/encoding/rlp/kind/numerickind.ts
var NumericKind = class extends ScalarKind {
    /**
   * Constructs a new instance of NumericKind.
   *
   * @param maxBytes - Optional parameter that specifies the maximum number of bytes that numeric data can occupy when encoded.
   */ constructor(maxBytes){
        super();
        this.maxBytes = maxBytes;
    }
    /**
   * Encodes the input data into numeric format and ensures it doesn't exceed the maximum bytes, if specified.
   *
   * @param data - The data to encode, expected to be numeric.
   * @param context - Descriptive context for error messages
   * @returns DataOutput object with an encode function.
   * @throws Will throw an error if data validation fails or encoding issues occur.
   */ data(data, context) {
        const dataBI = validateNumericKindData(data, context);
        return {
            encode: ()=>encodeBigIntToBuffer(dataBI, this.maxBytes, context)
        };
    }
    /**
   * Decodes the input buffer into a number or hexadecimal string, ensuring it meets numeric data constraints.
   *
   * @param buffer - The buffer to decode, containing numeric data.
   * @param context - Descriptive context for error messages.
   * @returns BufferOutput object with a decode function.
   * @throws Will throw an error if buffer validation fails.
   */ buffer(buffer, context) {
        assertValidNumericKindBuffer(buffer, context, this.maxBytes);
        return {
            decode: ()=>decodeBufferToNumberOrHex(buffer)
        };
    }
};
// src/encoding/rlp/kind/hexblobkinds/hexblob.ts
var HexBlobKind = class extends ScalarKind {
    /**
   * Encodes the input data into a Buffer.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed even sized hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Buffer.
   */ data(data, context) {
        assertValidHexBlobKindData(data, context);
        return {
            encode: ()=>Buffer.from(data.slice(2), "hex")
        };
    }
    /**
   * Decodes the input buffer into a hex string.
   *
   * @param buffer - The buffer to decode.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string.
   */ buffer(buffer, context) {
        assertValidHexBlobKindBuffer(buffer, context);
        return {
            decode: ()=>Hex0x.of(buffer)
        };
    }
};
// src/encoding/rlp/kind/hexblobkinds/fixedhexblob.ts
var FixedHexBlobKind = class extends HexBlobKind {
    /**
   * Creates a new instance of the {@link FixedHexBlobKind} class.
   * @param bytes - The number of bytes the blob must have.
   */ constructor(bytes2){
        super();
        this.bytes = bytes2;
    }
    /**
   * Encodes the input data into a Buffer with validation against fixed size.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed even sized hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Buffer.
   */ data(data, context) {
        const encoder = super.data(data, context);
        assertFixedHexBlobKindData(data, context, this.bytes);
        return encoder;
    }
    /**
   * Decodes the input buffer into a hex string with validation against fixed size.
   *
   * @param buffer - The buffer to decode.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string.
   */ buffer(buffer, context) {
        const decoder = super.buffer(buffer, context);
        assertFixedHexBlobKindBuffer(buffer, context, this.bytes);
        return decoder;
    }
};
// src/encoding/rlp/kind/hexblobkinds/optionalfixedhexblob.ts
var OptionalFixedHexBlobKind = class extends FixedHexBlobKind {
    /**
   * Encodes the input data (which can be null or undefined) into a Buffer.
   *
   * @param data - The data to encode, can be null or undefined.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Buffer.
   */ data(data, context) {
        return data == null ? {
            encode: ()=>Buffer.alloc(0)
        } : super.data(data, context);
    }
    /**
   * Decodes the input buffer into a hex string or null if the buffer is empty.
   *
   * @param buffer - The buffer to decode, can be empty.
   * @param context - Context string for error handling.
   * @returns An object containing a decode function which returns the decoded hex string or null.
   */ buffer(buffer, context) {
        return buffer.length === 0 ? {
            decode: ()=>null
        } : super.buffer(buffer, context);
    }
};
// src/encoding/rlp/kind/hexblobkinds/compactfixedhexblob.ts
var CompactFixedHexBlobKind = class extends FixedHexBlobKind {
    /**
   * Encodes the input data into a Buffer, trimming leading zeros.
   *
   * @param data - The data to encode, expected to be a '0x' prefixed hex string.
   * @param context - Context string for error handling.
   * @returns An object containing an encode function which returns the encoded Buffer.
   */ data(data, context) {
        const buffer = super.data(data, context).encode();
        return {
            encode: ()=>encodeCompactFixedHexBlob(buffer)
        };
    }
    /**
   * Decodes the input buffer into a number or hexadecimal string, ensuring it meets the fixed size by padding with zeros.
   *
   * @param buffer - The buffer to decode, containing numeric data.
   * @param context - Descriptive context for error messages, usually representing the caller's identity.
   * @returns BufferOutput object with a decode function.
   * @throws Will throw an error if buffer validation fails.
   */ buffer(buffer, context) {
        assertCompactFixedHexBlobBuffer(buffer, context, this.bytes);
        return {
            decode: ()=>Hex0x.of(buffer, this.bytes)
        };
    }
};
// src/encoding/rlp/kind/index.ts
var RLPProfiles = {
    ScalarKind,
    BufferKind,
    NumericKind,
    HexBlobKind,
    FixedHexBlobKind,
    OptionalFixedHexBlobKind,
    CompactFixedHexBlobKind
};
// src/encoding/rlp/index.ts
var RLP2 = {
    ...RLPBase,
    ...RLPProfiles
};
// src/utils/const/transaction.ts
var TRANSACTIONS_GAS_CONSTANTS = {
    /**
   * Default gas for a transaction
   * @internal
   */ TX_GAS: 5e3,
    /**
   * Default gas for a clause
   * @internal
   */ CLAUSE_GAS: 16e3,
    /**
   * Default gas for a contract creation clause
   * @internal
   */ CLAUSE_GAS_CONTRACT_CREATION: 48e3,
    /**
   * Zero gas data
   * @internal
   */ ZERO_GAS_DATA: 4,
    /**
   * Non-zero gas data
   * @internal
   */ NON_ZERO_GAS_DATA: 68
};
var TRANSACTION_FIELDS = [
    /**
   * Chain tag. It represents the id of the chain the transaction is sent to.
   */ {
        name: "chainTag",
        kind: new RLP2.NumericKind(1)
    },
    /**
   * Block reference. It represents the last block of the chain the transaction is sent to.
   */ {
        name: "blockRef",
        kind: new RLP2.CompactFixedHexBlobKind(8)
    },
    /**
   * Expiration. It represents the expiration date of the transaction.
   */ {
        name: "expiration",
        kind: new RLP2.NumericKind(4)
    },
    /**
   * Clauses of the transaction. They represent the actions to be executed by the transaction.
   */ {
        name: "clauses",
        kind: {
            item: [
                {
                    name: "to",
                    kind: new RLP2.OptionalFixedHexBlobKind(20)
                },
                {
                    name: "value",
                    kind: new RLP2.NumericKind(32)
                },
                {
                    name: "data",
                    kind: new RLP2.HexBlobKind()
                }
            ]
        }
    },
    /**
   * Gas price coef. It represents the gas price coefficient of the transaction.
   */ {
        name: "gasPriceCoef",
        kind: new RLP2.NumericKind(1)
    },
    /**
   * Gas. It represents the gas limit of the transaction.
   */ {
        name: "gas",
        kind: new RLP2.NumericKind(8)
    },
    /**
   * Depends on. It represents the hash of the transaction the current transaction depends on.
   */ {
        name: "dependsOn",
        kind: new RLP2.OptionalFixedHexBlobKind(32)
    },
    /**
   * Nonce. It represents the nonce of the transaction.
   */ {
        name: "nonce",
        kind: new RLP2.NumericKind(8)
    },
    /**
   * Reserved. It represents the reserved field of the transaction.
   */ {
        name: "reserved",
        kind: {
            item: new RLP2.BufferKind()
        }
    }
];
var TRANSACTION_FEATURES_KIND = {
    name: "reserved.features",
    kind: new RLP2.NumericKind(4)
};
var TRANSACTION_SIGNATURE_KIND = {
    name: "signature",
    kind: new RLP2.BufferKind()
};
var UNSIGNED_TRANSACTION_RLP = new RLP2.Profiler({
    name: "tx",
    kind: TRANSACTION_FIELDS
});
var SIGNED_TRANSACTION_RLP = new RLP2.Profiler({
    name: "tx",
    // Add signature to the transaction fields
    kind: TRANSACTION_FIELDS.concat([
        TRANSACTION_SIGNATURE_KIND
    ])
});
var SIGNATURE_LENGTH = 65;
var BLOCK_REF_LENGTH = 8;
// src/utils/const/abi.ts
var PARAMS_ABI = JSON.stringify([
    {
        constant: false,
        inputs: [
            {
                name: "_key",
                type: "bytes32"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "set",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_key",
                type: "bytes32"
            }
        ],
        name: "get",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "executor",
        outputs: [
            {
                name: "",
                type: "address"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "key",
                type: "bytes32"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Set",
        type: "event"
    }
]);
var VIP180_ABI = JSON.stringify([
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_spender",
                type: "address"
            },
            {
                name: "_value",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "success",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "success",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                name: "",
                type: "string"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "success",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: false,
        inputs: [
            {
                name: "_from",
                type: "address"
            },
            {
                name: "_to",
                type: "address"
            },
            {
                name: "_amount",
                type: "uint256"
            }
        ],
        name: "move",
        outputs: [
            {
                name: "success",
                type: "bool"
            }
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        constant: true,
        inputs: [],
        name: "totalBurned",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            },
            {
                name: "_spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "remaining",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "_from",
                type: "address"
            },
            {
                indexed: true,
                name: "_to",
                type: "address"
            },
            {
                indexed: false,
                name: "_value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "_owner",
                type: "address"
            },
            {
                indexed: true,
                name: "_spender",
                type: "address"
            },
            {
                indexed: false,
                name: "_value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    }
]);
var ERC721_ABI = JSON.stringify([
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "ERC721IncorrectOwner",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ERC721InsufficientApproval",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address"
            }
        ],
        name: "ERC721InvalidApprover",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "ERC721InvalidOperator",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "ERC721InvalidOwner",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "ERC721InvalidReceiver",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address"
            }
        ],
        name: "ERC721InvalidSender",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ERC721NonexistentToken",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address"
            }
        ],
        name: "mintItem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
]);
// src/hash/blake2b256.ts
var import_blakejs = __toESM(require("e2b027d0a1029668"));
function _blake2b256(...data) {
    const ctx = import_blakejs.default.blake2bInit(32);
    data.forEach((d)=>{
        if (Buffer.isBuffer(d)) import_blakejs.default.blake2bUpdate(ctx, d);
        else import_blakejs.default.blake2bUpdate(ctx, Buffer.from(d, "utf8"));
    });
    return Buffer.from(import_blakejs.default.blake2bFinal(ctx));
}
function blake2b256(data, returnType = "buffer") {
    assertIsValidReturnType("blake2b256", returnType);
    const dataBytesLike = [
        data
    ];
    const hash3 = _blake2b256(...dataBytesLike);
    return returnType === "buffer" ? hash3 : Hex0x.of(hash3);
}
// src/hash/sha256.ts
var import_ethers4 = require("4118e9000a31bc10");
function sha256(data, returnType = "buffer") {
    assertIsValidReturnType("sha256", returnType);
    const hash3 = import_ethers4.ethers.isBytesLike(data) ? import_ethers4.ethers.sha256(data) : import_ethers4.ethers.sha256(import_ethers4.ethers.toUtf8Bytes(data));
    return returnType === "buffer" ? Buffer.from(hash3.slice(2), "hex") : hash3;
}
// src/hash/keccak256.ts
var import_ethers5 = require("4118e9000a31bc10");
function keccak256(data, returnType = "buffer") {
    assertIsValidReturnType("keccak256", returnType);
    const hash3 = import_ethers5.ethers.isBytesLike(data) ? import_ethers5.ethers.keccak256(data) : import_ethers5.ethers.keccak256(import_ethers5.ethers.toUtf8Bytes(data));
    return returnType === "buffer" ? Buffer.from(hash3.slice(2), "hex") : hash3;
}
// src/bloom/bloom.ts
var import_buffer = require("a94c134a31f0760");
var Filter = class {
    bits;
    k;
    /**
   * Constructs a new Filter instance.
   * @param bits - The bit array used in the Bloom filter.
   * @param k - The number of hash functions to be used.
   */ constructor(bits, k){
        this.bits = bits;
        this.k = k;
    }
    /**
   * Checks if the given key might be contained in the set.
   * Note: false positives are possible, but false negatives are not.
   * @param key - The key to be checked.
   * @returns A boolean indicating whether the key might be contained in the set.
   */ contains(key) {
        return distribute(hash(key), this.k, this.bits.byteLength * 8, (index, bit)=>{
            return (this.bits[index] & bit) === bit;
        });
    }
};
function addWithUInt32Wrap(a, b) {
    return (a + b) % 2 ** 32;
}
function hash(key) {
    const uint8ArrayKey = new Uint8Array(key);
    const hash3 = blake2b256(uint8ArrayKey);
    return hash3.readUInt32BE(0);
}
function distribute(hash3, k, nBits, cb) {
    const delta = (hash3 >>> 17 | hash3 << 15) >>> 0;
    for(let i = 0; i < k; i++){
        const bitPos = hash3 % nBits;
        if (!cb(Math.floor(bitPos / 8), 1 << bitPos % 8)) return false;
        hash3 = addWithUInt32Wrap(hash3, delta);
    }
    return true;
}
var Generator = class {
    hashes = /* @__PURE__ */ new Map();
    /**
   * Adds a key to the generator's internal map for later Bloom filter generation.
   * @param key - The key to be added.
   */ add(key) {
        this.hashes.set(hash(key), true);
    }
    /**
   * Generates a variable-length Bloom filter based on the bits per key and count of keys.
   * The generator will be reset after generation.
   *
   * @param bitsPerKey - The number of bits per key.
   * @param k - The number of hash functions to be used (count of keys).
   * @returns A new Filter instance.
   */ generate(bitsPerKey, k) {
        let nBytes = Math.floor((this.hashes.size * bitsPerKey + 7) / 8);
        nBytes = nBytes < 8 ? 8 : nBytes;
        const bits = import_buffer.Buffer.alloc(nBytes);
        const nBits = nBytes * 8;
        for (const hash3 of this.hashes.keys())distribute(hash3, k, nBits, (index, bit)=>{
            bits[index] |= bit;
            return true;
        });
        this.hashes.clear();
        return new Filter(bits, k);
    }
};
function calculateK(bitsPerKey) {
    const k = Math.floor(bitsPerKey * 69 / 100);
    if (k < 1) return 1;
    return k > 30 ? 30 : k;
}
var bloom = {
    Generator,
    Filter,
    calculateK
};
// src/utils/bloom/bloom.ts
var import_sdk_errors17 = require("efe1f1d778f145a2");
// src/utils/hex/hex.ts
var import_sdk_errors16 = require("efe1f1d778f145a2");
var import_buffer2 = require("a94c134a31f0760");
// ../../node_modules/@noble/hashes/esm/crypto.js
var nodeCrypto = __toESM(require("b3b2922e292019e9"), 1);
var crypto = {
    node: nodeCrypto,
    web: void 0
};
// ../../node_modules/@noble/hashes/esm/utils.js
var isLE = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
if (!isLE) throw new Error("Non little-endian hardware is not supported");
var hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
function randomBytes(bytesLength = 32) {
    if (crypto.web) return crypto.web.getRandomValues(new Uint8Array(bytesLength));
    else if (crypto.node) return new Uint8Array(crypto.node.randomBytes(bytesLength).buffer);
    else throw new Error("The environment doesn't have randomBytes function");
}
// src/utils/hex/hex.ts
var ENCODING = "hex";
var PREFIX = "0x";
var RADIX = 16;
var REGEX_FOR_0X_PREFIX_HEX = /^0x[0-9a-f]*$/i;
var REGEX_FOR_OPTIONAL_0X_PREFIX_HEX = /^(0x)?[0-9a-f]*$/i;
var THOR_ID_LENGTH = 64;
function ofBigInt(bi, bytes2) {
    (0, import_sdk_errors16.assert)("ofBigInt", bi >= 0, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'n' not negative." /* NOT_POSITIVE */ , {
        bi: bi.toString()
    });
    return pad(bi.toString(RADIX), bytes2);
}
function ofBuffer(buffer, bytes2) {
    return pad(buffer.toString(ENCODING), bytes2);
}
function ofHexString(n, bytes2) {
    (0, import_sdk_errors16.assert)("ofHexString", Hex0x.isValid(n), import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'n' not an hexadecimal expression" /* NOT_HEX */ , {
        n
    });
    return pad(n.slice(2).toLowerCase(), bytes2);
}
function ofNumber(n, bytes2) {
    (0, import_sdk_errors16.assert)("ofNumber", Number.isInteger(n), import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'n' not an integer." /* NOT_INTEGER */ , {
        n
    });
    (0, import_sdk_errors16.assert)("ofNumber", n >= 0, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'n' not negative." /* NOT_POSITIVE */ , {
        n
    });
    return pad(n.toString(RADIX), bytes2);
}
function ofString(txt, bytes2) {
    return ofBuffer(import_buffer2.Buffer.from(txt), bytes2);
}
function ofUint8Array(uint8Array, bytes2) {
    return ofBuffer(import_buffer2.Buffer.from(uint8Array), bytes2);
}
function pad(exp, bytes2) {
    let result = exp;
    if (result.length % 2 !== 0) result = "0" + result;
    if (bytes2 > 0) {
        const gap = bytes2 - result.length / 2;
        if (gap > 0) return `${"00".repeat(gap)}${result}`;
    }
    return result;
}
function trim(exp) {
    let i = 0;
    while(i < exp.length && exp.at(i) === "0")i++;
    return i === exp.length ? "0" : exp.slice(i);
}
var Hex0x = {
    /**
   * Converts a given string expression to a canonical representation prefixed with `0x`,
   * optionally specifying the number of bytes to include in the canonical form.
   *
   * @param {string} exp - The string expression to convert to canonical form.
   * @param {number} [bytes] - The number of bytes to include in the canonical form.
   * If not specified, all bytes will be included.
   * @returns {string} The canonical representation of the given string expression.
   * @throws {Error} if `exp` is not a valid hexadecimal expression,
   * if `bytes` is not integer and greater or equal to zero.
   */ canon: function(exp, bytes2) {
        return `${PREFIX}${Hex.canon(exp, bytes2)}`;
    },
    /**
   * Checks if the given expression is a valid Thor-based ID.
   * Thor id is a 64 characters long hexadecimal string.
   * It is used to identify a transaction id, a block id, etc.
   *
   * @param {string} exp - The expression to check.
   * @param {boolean} is0xOptional - Do not check if `exp` is `0x` prefixed, `false` by default.
   * @returns {boolean} - Returns true if the expression is a valid Thor ID, otherwise false.
   */ isThorId: function(exp, is0xOptional = false) {
        return this.isValid(exp, is0xOptional) && (is0xOptional ? exp.length === THOR_ID_LENGTH : exp.length === THOR_ID_LENGTH + 2);
    },
    /**
   * Checks if the given expression is a valid hexadecimal expression
   * - prefixed with `0x` (or optionally if `is0xOptional is `true`),
   * - byte aligned if  `isByteAligned` is `true`.
   *
   * @param {string} exp - The expression to be validated.
   * @param {boolean} is0xOptional - Do not check if `exp` is `0x` prefixed, `false` by default.
   * @param {boolean} isByteAliged - Check `exp` represents a full byte or an array of bytes, `false`, by default.
   * @returns {boolean} - Whether the expression is valid or not.
   */ isValid: function(exp, is0xOptional = false, isByteAliged = false) {
        let predicate = is0xOptional ? REGEX_FOR_OPTIONAL_0X_PREFIX_HEX.test(exp) : REGEX_FOR_0X_PREFIX_HEX.test(exp);
        if (isByteAliged && predicate) predicate = exp.length % 2 === 0;
        return predicate;
    },
    /**
   * Returns a hexadecimal representation from the given input data prefixed with `0x`.
   *
   * **Note:** this method calls {@link Hex.of} to generate the hexadecimal representation of n,
   * then it prefixes the result with `0x`.
   *
   * @param {HexRepresentable} n - The input data to be represented.
   * @param {number} [bytes=0] - If not `0` by default, the hexadecimal representation encodes at least {number}  bytes.
   * @returns {Uint8Array} - The resulting hexadecimal representation,
   * it is guaranteed to be even characters long.
   * @see Hex
   * @see HexRepresentable
   */ of: function(n, bytes2 = 0) {
        return `${PREFIX}${Hex.of(n, bytes2)}`;
    }
};
var Hex = {
    /**
   * Converts a given string expression to a canonical representation prefixed with `0x`,
   * optionally specifying the number of bytes to include in the canonical form.
   *
   * @param {string} exp - The string expression to convert to canonical form.
   * @param {number} [bytes] - The number of bytes to include in the canonical form.
   * If not specified, all bytes will be included.
   * @returns {string} The canonical representation of the given string expression.
   * @throws {Error} if `exp` is not a valid hexadecimal expression,
   * if `bytes` is not integer and greater or equal to zero.
   */ canon: function(exp, bytes2) {
        let result = "";
        if (REGEX_FOR_0X_PREFIX_HEX.test(exp)) result = exp.slice(2).toLowerCase();
        else if (REGEX_FOR_OPTIONAL_0X_PREFIX_HEX.test(exp)) result = exp.toLowerCase();
        else throw (0, import_sdk_errors16.buildError)(`Hex.canon`, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'n' not an hexadecimal expression" /* NOT_HEX */ , {
            exp
        });
        if (typeof bytes2 !== "undefined") {
            (0, import_sdk_errors16.assert)("Hex.canon", Number.isInteger(bytes2) && bytes2 >= 0, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'bytes' not a length." /* NOT_LENGTH */ , {
                bytes: bytes2
            });
            result = pad(result, bytes2);
            (0, import_sdk_errors16.assert)("Hex.canon", result.length <= bytes2 * 2, import_sdk_errors16.DATA.INVALID_DATA_TYPE, "Arg 'bytes' not enough to fit 'exp'" /* NOT_FIT */ , {
                bytes: bytes2
            });
        }
        return result;
    },
    /**
   * Returns a hexadecimal representation from the given input data.
   * This method calls
   * * {@link ofBigInt} if `n` type is `bigint`;
   * * {@link ofBuffer} if `n` is an instance of {@link Buffer};
   * * {@link ofHexString} if `n` type is {@link HexString}`;
   * * {@link ofNumber} if `n` type is `number`;
   * * {@link ofString} if `n` type is `string`;
   * * {@link ofUint8Array} if `n` is an instance of {@link Uint8Array}.
   *
   * **Note:** the returned string is not prefixed with `0x`,
   * see {@link Hex0x.of} to make a hexadecimal representation prefixed with `0x`.
   *
   * **Note:** [HexString](https://docs.ethers.org/v6/api/utils/#HexString)
   * definition overlaps `string` TS completely as an alias.
   * This function tests if the given input starts with `0x`
   * and is positive to {@link Hex0x.isValid}
   * processing it as {@link HexString} type,
   * else it considers the string as an array of bytes and
   * returns its hexadecimal representation.
   * To force a string to be considered an array of bytes despite it is
   * a valid `0x` hexadecimal expression, convert it to {@link Buffer}.
   * ```
   * Hex.of(buffer.toString('hex'))
   * ```
   *
   * @param {HexRepresentable} n - The input data to be represented.
   * @param {number} [bytes=0] - If not `0` by default, the hexadecimal representation encodes at least {number}  bytes.
   * @returns {Uint8Array} - The resulting hexadecimal representation,
   * it is guaranteed to be even characters long.
   * @see HexRepresentable
   */ of: function(n, bytes2 = 0) {
        if (n instanceof import_buffer2.Buffer) return ofBuffer(n, bytes2);
        if (n instanceof Uint8Array) return ofUint8Array(n, bytes2);
        if (typeof n === "bigint") return ofBigInt(n, bytes2);
        if (typeof n === `number`) return ofNumber(n, bytes2);
        if (Hex0x.isValid(n)) return ofHexString(n, bytes2);
        return ofString(n, bytes2);
    },
    /**
   * Generates a random hexadecimal string of the specified number of bytes.
   * The length of the string is twice the `bytes`.
   *
   * @param {number} bytes - The number of bytes for the random string.
   * @return {string} - The generated random string.
   */ random: function(bytes2) {
        return ofUint8Array(randomBytes(bytes2), bytes2);
    }
};
var Quantity = {
    /**
   *  Returns a hexadecimal representation for the given input data
   *  - without any not meaningful `0` digit on the left side,
   *  - prefixed with `0x`,
   *  - hence returns `0x0` if `n` is zero.
   *
   * This function is a more efficient drop-in replacement of the function
   * `toQuantity` in [math.ts](https://github.com/ethers-io/ethers.js/blob/main/src.ts/utils/maths.ts)
   * of [The Ethers Project](https://github.com/ethers-io/ethers.js/tree/main) library.
   *
   * @param {HexRepresentable} n - The input data to be represented.
   * @return The resulting hexadecimal representation, nibble aligned.
   * @see HexRepresentable
   */ of (n) {
        return `${PREFIX}${trim(Hex.of(n))}`;
    }
};
// src/utils/bloom/bloom.ts
var isBloom = (bloom2)=>{
    if (typeof bloom2 !== "string") return false;
    return BLOOM_REGEX_LOWERCASE.test(bloom2) || BLOOM_REGEX_UPPERCASE.test(bloom2);
};
var isInBloom = (bloom2, k, data)=>{
    (0, import_sdk_errors17.assert)("isInBloom", isBloom(bloom2), import_sdk_errors17.BLOOM.INVALID_BLOOM, "Invalid bloom filter format. Bloom filters must adhere to the format 0x[0-9a-fA-F]{16,}.", {
        bloom: bloom2
    });
    (0, import_sdk_errors17.assert)("isInBloom", Hex0x.isValid(data, true), import_sdk_errors17.DATA.INVALID_DATA_TYPE, "Invalid data type. Data should be an hexadecimal string", {
        data
    });
    (0, import_sdk_errors17.assert)("isInBloom", Number.isInteger(k) && k > 0, import_sdk_errors17.BLOOM.INVALID_K, "Invalid k. It should be a positive integer.", {
        k
    });
    (0, import_sdk_errors17.assert)("isInBloom", typeof data === "string", import_sdk_errors17.DATA.INVALID_DATA_TYPE, "Invalid data type. Data should be a string", {
        data
    });
    const dataBuffer = Buffer.from(Hex.canon(data), "hex");
    const bloomBuffer = Buffer.from(Hex.canon(bloom2), "hex");
    const bloomFilter = new bloom.Filter(bloomBuffer, k);
    return bloomFilter.contains(dataBuffer);
};
var isAddressInBloom = (bloom2, k, addressToCheck)=>{
    (0, import_sdk_errors17.assert)("isAddressInBloom", addressUtils.isAddress(addressToCheck), import_sdk_errors17.ADDRESS.INVALID_ADDRESS, "Invalid address given as input in Bloom filter. Ensure it is a valid vechain thor address.", {
        addressToCheck
    });
    return isInBloom(bloom2, k, addressToCheck);
};
var bloomUtils = {
    isBloom,
    isInBloom,
    isAddressInBloom
};
// src/utils/data/data.ts
var import_ethers6 = require("4118e9000a31bc10");
var import_sdk_errors18 = require("efe1f1d778f145a2");
var isDecimalString = (data)=>{
    return DECIMAL_INTEGER_REGEX.test(data);
};
var isNumeric = (value)=>{
    return NUMERIC_REGEX.test(value);
};
var encodeBytes32String = (value, zeroPadding = "left")=>{
    try {
        const valueInBytes = import_ethers6.ethers.toUtf8Bytes(value);
        return zeroPadding === "left" ? import_ethers6.ethers.zeroPadValue(valueInBytes, 32) : import_ethers6.ethers.zeroPadBytes(valueInBytes, 32);
    } catch (e) {
        throw (0, import_sdk_errors18.buildError)("encodeBytes32String", import_sdk_errors18.DATA.INVALID_DATA_TYPE, `Encoding to bytes32 failed: Value '${value}' exceeds 32 bytes or is otherwise invalid.`, {
            value,
            zeroPadding
        }, e);
    }
};
var decodeBytes32String = (value)=>{
    (0, import_sdk_errors18.assert)("decodeBytes32String", Hex0x.isValid(value) && Hex.canon(value).length === 64, import_sdk_errors18.DATA.INVALID_DATA_TYPE, `Failed to decode value ${value} to string. Value is not a valid hex string or it is not 64 characters long`, {
        value
    });
    const valueInBytes = Buffer.from(Hex.canon(value), "hex");
    const firstZeroIndex = valueInBytes.findIndex((byte)=>byte === 0);
    if (firstZeroIndex === 0) {
        const nonZeroIndex = valueInBytes.findIndex((byte)=>byte !== 0);
        return import_ethers6.ethers.toUtf8String(valueInBytes.subarray(nonZeroIndex));
    } else if (firstZeroIndex !== -1) return import_ethers6.ethers.toUtf8String(valueInBytes.subarray(0, firstZeroIndex));
    else return import_ethers6.ethers.toUtf8String(valueInBytes);
};
var dataUtils = {
    isDecimalString,
    isNumeric,
    encodeBytes32String,
    decodeBytes32String
};
// src/utils/hdnode/hdnode.ts
function _checkDerivationPathSingleComponentValid(component, index) {
    return(// m
    (index === 0 ? component === "m" : false) || // "number"
    DECIMAL_INTEGER_REGEX.test(component) || // "number'"
    DECIMAL_INTEGER_REGEX.test(component.slice(0, -1)) && component.endsWith("'"));
}
function isDerivationPathValid(derivationPath) {
    const pathComponents = derivationPath.split("/");
    for(let i = 0; i < pathComponents.length; i++){
        if (!_checkDerivationPathSingleComponentValid(pathComponents[i], i)) return false;
    }
    return true;
}
// src/utils/transaction/transaction.ts
var import_sdk_errors19 = require("efe1f1d778f145a2");
function intrinsicGas(clauses) {
    if (clauses.length === 0) return TRANSACTIONS_GAS_CONSTANTS.TX_GAS + TRANSACTIONS_GAS_CONSTANTS.CLAUSE_GAS;
    return clauses.reduce((sum, clause)=>{
        if (clause.to !== null) {
            (0, import_sdk_errors19.assert)("intrinsicGas", addressUtils.isAddress(clause.to), import_sdk_errors19.DATA.INVALID_DATA_TYPE, `Invalid data type in clause. Each 'to' field must be a valid address.`, {
                clause
            });
            sum += TRANSACTIONS_GAS_CONSTANTS.CLAUSE_GAS;
        } else sum += TRANSACTIONS_GAS_CONSTANTS.CLAUSE_GAS_CONTRACT_CREATION;
        sum += _calculateDataUsedGas(clause.data);
        return sum;
    }, TRANSACTIONS_GAS_CONSTANTS.TX_GAS);
}
function _calculateDataUsedGas(data) {
    (0, import_sdk_errors19.assert)("_calculateDataUsedGas", data === "" || Hex0x.isValid(data), import_sdk_errors19.DATA.INVALID_DATA_TYPE, "Invalid data type for gas calculation. Data should be a hexadecimal string.", {
        data
    });
    let sum = 0;
    for(let i = 2; i < data.length; i += 2)if (data.substring(i, i + 2) === "00") sum += TRANSACTIONS_GAS_CONSTANTS.ZERO_GAS_DATA;
    else sum += TRANSACTIONS_GAS_CONSTANTS.NON_ZERO_GAS_DATA;
    return sum;
}
var TransactionUtils = {
    intrinsicGas
};
// src/utils/units/units.ts
var import_ethers7 = require("4118e9000a31bc10");
var import_sdk_errors20 = require("efe1f1d778f145a2");
var parseUnits = (value, decimals)=>{
    (0, import_sdk_errors20.assert)("parseUnits", typeof value !== "string" || dataUtils.isNumeric(value), import_sdk_errors20.DATA.INVALID_DATA_TYPE, `Invalid value format. The value "${value}" must be a numeric string.`, {
        value
    });
    return import_ethers7.ethers.parseUnits(value, decimals);
};
var formatUnits = (value, decimals)=>{
    return import_ethers7.ethers.formatUnits(value, decimals);
};
var parseVET = (value)=>{
    return parseUnits(value, 18);
};
var formatVET = (value)=>{
    return formatUnits(value, 18);
};
var unitsUtils = {
    parseUnits,
    formatUnits,
    parseVET,
    formatVET
};
// src/utils/revision/revision.ts
var isRevisionBlock = (revision)=>{
    return revision === "finalized" || isRevisionAccount(revision);
};
var isRevisionAccount = (revision)=>{
    return revision === "best" || typeof revision === "string" && Hex0x.isValid(revision) || typeof revision === "string" && dataUtils.isDecimalString(revision) || typeof revision === "number" && revision >= 0;
};
var revisionUtils = {
    isRevisionBlock,
    isRevisionAccount
};
// src/address/address.ts
var import_sdk_errors22 = require("efe1f1d778f145a2");
// src/secp256k1/secp256k1.ts
var import_elliptic = require("f76b29320f1f4079");
var import_sdk_errors21 = require("efe1f1d778f145a2");
var import_bn = __toESM(require_bn());
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/_assert.js
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function hash2(hash3) {
    if (typeof hash3 !== "function" || typeof hash3.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(hash3.outputLen);
    number(hash3.blockLen);
}
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/cryptoNode.js
var nc = __toESM(require("b3b2922e292019e9"), 1);
var crypto2 = nc && typeof nc === "object" && "webcrypto" in nc ? nc.webcrypto : void 0;
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/utils.js
var u8a = (a)=>a instanceof Uint8Array;
var createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
var rotr = (word, shift)=>word << 32 - shift | word >>> shift;
var isLE2 = new Uint8Array(new Uint32Array([
    287454020
]).buffer)[0] === 68;
if (!isLE2) throw new Error("Non little-endian hardware is not supported");
function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str));
}
function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    if (!u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad2 = 0;
    arrays.forEach((a)=>{
        if (!u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad2);
        pad2 += a.length;
    });
    return r;
}
var Hash = class {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
};
var toStr = {}.toString;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function randomBytes2(bytesLength = 32) {
    if (crypto2 && typeof crypto2.getRandomValues === "function") return crypto2.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/_sha2.js
function setBigUint64(view, byteOffset, value, isLE3) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE3);
    const _32n = BigInt(32);
    const _u32_max = BigInt(4294967295);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE3 ? 4 : 0;
    const l = isLE3 ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE3);
    view.setUint32(byteOffset + l, wl, isLE3);
}
var SHA2 = class extends Hash {
    constructor(blockLen, outputLen, padOffset, isLE3){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE3;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = createView(this.buffer);
    }
    update(data) {
        exists(this);
        const { view, buffer, blockLen } = this;
        data = toBytes(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            if (take === blockLen) {
                const dataView = createView(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        exists(this);
        output(out, this);
        this.finished = true;
        const { buffer, view, blockLen, isLE: isLE3 } = this;
        let { pos } = this;
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE3);
        this.process(view, 0);
        const oview = createView(out);
        const len = this.outputLen;
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE3);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
};
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/sha256.js
var Chi = (a, b, c)=>a & b ^ ~a & c;
var Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
var SHA256_K = /* @__PURE__ */ new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
]);
var IV = /* @__PURE__ */ new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
]);
var SHA256_W = /* @__PURE__ */ new Uint32Array(64);
var SHA256 = class extends SHA2 {
    constructor(){
        super(64, 32, 8, false);
        this.A = IV[0] | 0;
        this.B = IV[1] | 0;
        this.C = IV[2] | 0;
        this.D = IV[3] | 0;
        this.E = IV[4] | 0;
        this.F = IV[5] | 0;
        this.G = IV[6] | 0;
        this.H = IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ W15 >>> 3;
            const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
            const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
            const T2 = sigma0 + Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
};
var sha2562 = /* @__PURE__ */ wrapConstructor(()=>new SHA256());
// ../../node_modules/@noble/curves/esm/abstract/utils.js
var utils_exports = {};
__export(utils_exports, {
    bitGet: ()=>bitGet,
    bitLen: ()=>bitLen,
    bitMask: ()=>bitMask,
    bitSet: ()=>bitSet,
    bytesToHex: ()=>bytesToHex,
    bytesToNumberBE: ()=>bytesToNumberBE,
    bytesToNumberLE: ()=>bytesToNumberLE,
    concatBytes: ()=>concatBytes2,
    createHmacDrbg: ()=>createHmacDrbg,
    ensureBytes: ()=>ensureBytes,
    equalBytes: ()=>equalBytes,
    hexToBytes: ()=>hexToBytes,
    hexToNumber: ()=>hexToNumber,
    numberToBytesBE: ()=>numberToBytesBE,
    numberToBytesLE: ()=>numberToBytesLE,
    numberToHexUnpadded: ()=>numberToHexUnpadded,
    numberToVarBytesBE: ()=>numberToVarBytesBE,
    utf8ToBytes: ()=>utf8ToBytes2,
    validateObject: ()=>validateObject
});
var _0n = BigInt(0);
var _1n = BigInt(1);
var _2n = BigInt(2);
var u8a2 = (a)=>a instanceof Uint8Array;
var hexes2 = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function bytesToHex(bytes2) {
    if (!u8a2(bytes2)) throw new Error("Uint8Array expected");
    let hex = "";
    for(let i = 0; i < bytes2.length; i++)hex += hexes2[bytes2[i]];
    return hex;
}
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function bytesToNumberBE(bytes2) {
    return hexToNumber(bytesToHex(bytes2));
}
function bytesToNumberLE(bytes2) {
    if (!u8a2(bytes2)) throw new Error("Uint8Array expected");
    return hexToNumber(bytesToHex(Uint8Array.from(bytes2).reverse()));
}
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if (u8a2(hex)) res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function concatBytes2(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad2 = 0;
    arrays.forEach((a)=>{
        if (!u8a2(a)) throw new Error("Uint8Array expected");
        r.set(a, pad2);
        pad2 += a.length;
    });
    return r;
}
function equalBytes(b1, b2) {
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
function utf8ToBytes2(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str));
}
function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
var bitSet = (n, pos, value)=>{
    return n | (value ? _1n : _0n) << BigInt(pos);
};
var bitMask = (n)=>(_2n << BigInt(n - 1)) - _1n;
var u8n = (data)=>new Uint8Array(data);
var u8fr = (arr)=>Uint8Array.from(arr);
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    let v = u8n(hashLen);
    let k = u8n(hashLen);
    let i = 0;
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b);
    const reseed = (seed = u8n())=>{
        k = h(u8fr([
            0
        ]), seed);
        v = h();
        if (seed.length === 0) return;
        k = h(u8fr([
            1
        ]), seed);
        v = h();
    };
    const gen = ()=>{
        if (i++ >= 1e3) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes2(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed);
        let res = void 0;
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
var validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === void 0) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// ../../node_modules/@noble/curves/esm/abstract/modular.js
var _0n2 = BigInt(0);
var _1n2 = BigInt(1);
var _2n2 = BigInt(2);
var _3n = BigInt(3);
var _4n = BigInt(4);
var _5n = BigInt(5);
var _8n = BigInt(8);
var _9n = BigInt(9);
var _16n = BigInt(16);
function mod(a, b) {
    const result = a % b;
    return result >= _0n2 ? result : b + result;
}
function pow(num, power, modulo) {
    if (modulo <= _0n2 || power < _0n2) throw new Error("Expected power/modulo > 0");
    if (modulo === _1n2) return _0n2;
    let res = _1n2;
    while(power > _0n2){
        if (power & _1n2) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n2;
    }
    return res;
}
function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n2){
        res *= res;
        res %= modulo;
    }
    return res;
}
function invert(number2, modulo) {
    if (number2 === _0n2 || modulo <= _0n2) throw new Error(`invert: expected positive integers, got n=${number2} mod=${modulo}`);
    let a = mod(number2, modulo);
    let b = modulo;
    let x = _0n2, y = _1n2, u = _1n2, v = _0n2;
    while(a !== _0n2){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n2) throw new Error("invert: does not exist");
    return mod(x, modulo);
}
function tonelliShanks(P) {
    const legendreC = (P - _1n2) / _2n2;
    let Q, S, Z;
    for(Q = P - _1n2, S = 0; Q % _2n2 === _0n2; Q /= _2n2, S++);
    for(Z = _2n2; Z < P && pow(Z, legendreC, P) !== P - _1n2; Z++);
    if (S === 1) {
        const p1div4 = (P + _1n2) / _4n;
        return function tonelliFast(Fp2, n) {
            const root = Fp2.pow(n, p1div4);
            if (!Fp2.eql(Fp2.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    const Q1div2 = (Q + _1n2) / _2n2;
    return function tonelliSlow(Fp2, n) {
        if (Fp2.pow(n, legendreC) === Fp2.neg(Fp2.ONE)) throw new Error("Cannot find square root");
        let r = S;
        let g = Fp2.pow(Fp2.mul(Fp2.ONE, Z), Q);
        let x = Fp2.pow(n, Q1div2);
        let b = Fp2.pow(n, Q);
        while(!Fp2.eql(b, Fp2.ONE)){
            if (Fp2.eql(b, Fp2.ZERO)) return Fp2.ZERO;
            let m = 1;
            for(let t2 = Fp2.sqr(b); m < r; m++){
                if (Fp2.eql(t2, Fp2.ONE)) break;
                t2 = Fp2.sqr(t2);
            }
            const ge = Fp2.pow(g, _1n2 << BigInt(r - m - 1));
            g = Fp2.sqr(ge);
            x = Fp2.mul(x, ge);
            b = Fp2.mul(b, g);
            r = m;
        }
        return x;
    };
}
function FpSqrt(P) {
    if (P % _4n === _3n) {
        const p1div4 = (P + _1n2) / _4n;
        return function sqrt3mod4(Fp2, n) {
            const root = Fp2.pow(n, p1div4);
            if (!Fp2.eql(Fp2.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp2, n) {
            const n2 = Fp2.mul(n, _2n2);
            const v = Fp2.pow(n2, c1);
            const nv = Fp2.mul(n, v);
            const i = Fp2.mul(Fp2.mul(nv, _2n2), v);
            const root = Fp2.mul(nv, Fp2.sub(i, Fp2.ONE));
            if (!Fp2.eql(Fp2.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    _9n;
    return tonelliShanks(P);
}
var FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return validateObject(field, opts);
}
function FpPow(f, num, power) {
    if (power < _0n2) throw new Error("Expected power > 0");
    if (power === _0n2) return f.ONE;
    if (power === _1n2) return num;
    let p = f.ONE;
    let d = num;
    while(power > _0n2){
        if (power & _1n2) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n2;
    }
    return p;
}
function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    const inverted = f.inv(lastMultiplied);
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function nLength(n, nBitLength) {
    const _nBitLength = nBitLength !== void 0 ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
function Field(ORDER, bitLen2, isLE3 = false, redef = {}) {
    if (ORDER <= _0n2) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen2);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER,
        BITS,
        BYTES,
        MASK: bitMask(BITS),
        ZERO: _0n2,
        ONE: _1n2,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return _0n2 <= num && num < ORDER;
        },
        is0: (num)=>num === _0n2,
        isOdd: (num)=>(num & _1n2) === _1n2,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE3 ? numberToBytesLE(num, BYTES) : numberToBytesBE(num, BYTES),
        fromBytes: (bytes2)=>{
            if (bytes2.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes2.length}`);
            return isLE3 ? bytesToNumberLE(bytes2) : bytesToNumberBE(bytes2);
        }
    });
    return Object.freeze(f);
}
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
function mapHashToField(key, fieldOrder, isLE3 = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE3 ? bytesToNumberBE(key) : bytesToNumberLE(key);
    const reduced = mod(num, fieldOrder - _1n2) + _1n2;
    return isLE3 ? numberToBytesLE(reduced, fieldLen) : numberToBytesBE(reduced, fieldLen);
}
// ../../node_modules/@noble/curves/esm/abstract/curve.js
var _0n3 = BigInt(0);
var _1n3 = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1;
        const windowSize = 2 ** (W - 1);
        return {
            windows,
            windowSize
        };
    };
    return {
        constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n3){
                if (n & _1n3) p = p.add(d);
                d = d.double();
                n >>= _1n3;
            }
            return p;
        },
        /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window2 = 0; window2 < windows; window2++){
                base = p;
                points.push(base);
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */ wNAF (W, precomputes, n) {
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1);
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window2 = 0; window2 < windows; window2++){
                const offset = window2 * windowSize;
                let wbits = Number(n & mask);
                n >>= shiftBy;
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n3;
                }
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1;
                const cond1 = window2 % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            return {
                p,
                f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            const W = P._WINDOW_SIZE || 1;
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve2) {
    validateField(curve2.Fp);
    validateObject(curve2, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    return Object.freeze({
        ...nLength(curve2.n, curve2.nBitLength),
        ...curve2,
        p: curve2.Fp.ORDER
    });
}
// ../../node_modules/@noble/curves/esm/abstract/weierstrass.js
function validatePointOpts(curve2) {
    const opts = validateBasic(curve2);
    validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo, Fp: Fp2, a } = opts;
    if (endo) {
        if (!Fp2.eql(a, Fp2.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
var { bytesToNumberBE: b2n, hexToBytes: h2b } = utils_exports;
var DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = DER;
        if (data.length < 2 || data[0] !== 2) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: b2n(res),
            l: data.subarray(len + 2)
        };
    },
    toSig (hex) {
        const { Err: E } = DER;
        const data = typeof hex === "string" ? h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 48) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r,
            s
        };
    },
    hexFromSig (sig) {
        const slice = (s2)=>Number.parseInt(s2[0], 16) & 8 ? "00" + s2 : s2;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
var _0n4 = BigInt(0);
var _1n4 = BigInt(1);
var _2n3 = BigInt(2);
var _3n2 = BigInt(3);
var _4n2 = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp: Fp2 } = CURVE;
    const toBytes2 = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return concatBytes2(Uint8Array.from([
            4
        ]), Fp2.toBytes(a.x), Fp2.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes2)=>{
        const tail = bytes2.subarray(1);
        const x = Fp2.fromBytes(tail.subarray(0, Fp2.BYTES));
        const y = Fp2.fromBytes(tail.subarray(Fp2.BYTES, 2 * Fp2.BYTES));
        return {
            x,
            y
        };
    });
    function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp2.sqr(x);
        const x3 = Fp2.mul(x2, x);
        return Fp2.add(Fp2.add(x3, Fp2.mul(x, a)), b);
    }
    if (!Fp2.eql(Fp2.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && _0n4 < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = bytesToHex(key);
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : bytesToNumberBE(ensureBytes("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = mod(num, n);
        assertGE(num);
        return num;
    }
    const pointPrecomputes = /* @__PURE__ */ new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point2)) throw new Error("ProjectivePoint expected");
    }
    class Point2 {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp2.isValid(px)) throw new Error("x required");
            if (py == null || !Fp2.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp2.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp2.isValid(x) || !Fp2.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point2) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp2.eql(i, Fp2.ZERO);
            if (is0(x) && is0(y)) return Point2.ZERO;
            return new Point2(x, y, Fp2.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */ static normalizeZ(points) {
            const toInv = Fp2.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point2.fromAffine);
        }
        /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */ static fromHex(hex) {
            const P = Point2.fromAffine(fromBytes(ensureBytes("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point2.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                if (CURVE.allowInfinityPoint && !Fp2.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            const { x, y } = this.toAffine();
            if (!Fp2.isValid(x) || !Fp2.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp2.sqr(y);
            const right = weierstrassEquation(x);
            if (!Fp2.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp2.isOdd) return !Fp2.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
     * Compare one point to another.
     */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp2.eql(Fp2.mul(X1, Z2), Fp2.mul(X2, Z1));
            const U2 = Fp2.eql(Fp2.mul(Y1, Z2), Fp2.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */ negate() {
            return new Point2(this.px, Fp2.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp2.mul(b, _3n2);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp2.ZERO, Y3 = Fp2.ZERO, Z3 = Fp2.ZERO;
            let t0 = Fp2.mul(X1, X1);
            let t1 = Fp2.mul(Y1, Y1);
            let t2 = Fp2.mul(Z1, Z1);
            let t3 = Fp2.mul(X1, Y1);
            t3 = Fp2.add(t3, t3);
            Z3 = Fp2.mul(X1, Z1);
            Z3 = Fp2.add(Z3, Z3);
            X3 = Fp2.mul(a, Z3);
            Y3 = Fp2.mul(b3, t2);
            Y3 = Fp2.add(X3, Y3);
            X3 = Fp2.sub(t1, Y3);
            Y3 = Fp2.add(t1, Y3);
            Y3 = Fp2.mul(X3, Y3);
            X3 = Fp2.mul(t3, X3);
            Z3 = Fp2.mul(b3, Z3);
            t2 = Fp2.mul(a, t2);
            t3 = Fp2.sub(t0, t2);
            t3 = Fp2.mul(a, t3);
            t3 = Fp2.add(t3, Z3);
            Z3 = Fp2.add(t0, t0);
            t0 = Fp2.add(Z3, t0);
            t0 = Fp2.add(t0, t2);
            t0 = Fp2.mul(t0, t3);
            Y3 = Fp2.add(Y3, t0);
            t2 = Fp2.mul(Y1, Z1);
            t2 = Fp2.add(t2, t2);
            t0 = Fp2.mul(t2, t3);
            X3 = Fp2.sub(X3, t0);
            Z3 = Fp2.mul(t2, t1);
            Z3 = Fp2.add(Z3, Z3);
            Z3 = Fp2.add(Z3, Z3);
            return new Point2(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp2.ZERO, Y3 = Fp2.ZERO, Z3 = Fp2.ZERO;
            const a = CURVE.a;
            const b3 = Fp2.mul(CURVE.b, _3n2);
            let t0 = Fp2.mul(X1, X2);
            let t1 = Fp2.mul(Y1, Y2);
            let t2 = Fp2.mul(Z1, Z2);
            let t3 = Fp2.add(X1, Y1);
            let t4 = Fp2.add(X2, Y2);
            t3 = Fp2.mul(t3, t4);
            t4 = Fp2.add(t0, t1);
            t3 = Fp2.sub(t3, t4);
            t4 = Fp2.add(X1, Z1);
            let t5 = Fp2.add(X2, Z2);
            t4 = Fp2.mul(t4, t5);
            t5 = Fp2.add(t0, t2);
            t4 = Fp2.sub(t4, t5);
            t5 = Fp2.add(Y1, Z1);
            X3 = Fp2.add(Y2, Z2);
            t5 = Fp2.mul(t5, X3);
            X3 = Fp2.add(t1, t2);
            t5 = Fp2.sub(t5, X3);
            Z3 = Fp2.mul(a, t4);
            X3 = Fp2.mul(b3, t2);
            Z3 = Fp2.add(X3, Z3);
            X3 = Fp2.sub(t1, Z3);
            Z3 = Fp2.add(t1, Z3);
            Y3 = Fp2.mul(X3, Z3);
            t1 = Fp2.add(t0, t0);
            t1 = Fp2.add(t1, t0);
            t2 = Fp2.mul(a, t2);
            t4 = Fp2.mul(b3, t4);
            t1 = Fp2.add(t1, t2);
            t2 = Fp2.sub(t0, t2);
            t2 = Fp2.mul(a, t2);
            t4 = Fp2.add(t4, t2);
            t0 = Fp2.mul(t1, t4);
            Y3 = Fp2.add(Y3, t0);
            t0 = Fp2.mul(t5, t4);
            X3 = Fp2.mul(t3, X3);
            X3 = Fp2.sub(X3, t0);
            t0 = Fp2.mul(t3, t1);
            Z3 = Fp2.mul(t5, Z3);
            Z3 = Fp2.add(Z3, t0);
            return new Point2(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point2.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp2.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point2.fromAffine);
            });
        }
        /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */ multiplyUnsafe(n) {
            const I = Point2.ZERO;
            if (n === _0n4) return I;
            assertGE(n);
            if (n === _1n4) return this;
            const { endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n4 || k2 > _0n4){
                if (k1 & _1n4) k1p = k1p.add(d);
                if (k2 & _1n4) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n4;
                k2 >>= _1n4;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point2(Fp2.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake;
            const { endo } = CURVE;
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point2(Fp2.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            return Point2.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point2.BASE;
            const mul = (P, a2)=>a2 === _0n4 || a2 === _1n4 || !P.equals(G) ? P.multiplyUnsafe(a2) : P.multiply(a2);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? void 0 : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? Fp2.ONE : Fp2.inv(z);
            const ax = Fp2.mul(x, iz);
            const ay = Fp2.mul(y, iz);
            const zz = Fp2.mul(z, iz);
            if (is0) return {
                x: Fp2.ZERO,
                y: Fp2.ZERO
            };
            if (!Fp2.eql(zz, Fp2.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n4) return true;
            if (isTorsionFree) return isTorsionFree(Point2, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n4) return this;
            if (clearCofactor) return clearCofactor(Point2, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes2(Point2, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point2.BASE = new Point2(CURVE.Gx, CURVE.Gy, Fp2.ONE);
    Point2.ZERO = new Point2(Fp2.ZERO, Fp2.ONE, Fp2.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = wNAF(Point2, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    return {
        CURVE,
        ProjectivePoint: Point2,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
function validateOpts(curve2) {
    const opts = validateBasic(curve2);
    validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp: Fp2, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp2.BYTES + 1;
    const uncompressedLen = 2 * Fp2.BYTES + 1;
    function isValidFieldElement(num) {
        return _0n4 < num && num < Fp2.ORDER;
    }
    function modN(a) {
        return mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point2, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp2.toBytes(a.x);
            const cat = concatBytes2;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 2 : 3
            ]), x);
            else return cat(Uint8Array.from([
                4
            ]), x, Fp2.toBytes(a.y));
        },
        fromBytes (bytes2) {
            const len = bytes2.length;
            const head = bytes2[0];
            const tail = bytes2.subarray(1);
            if (len === compressedLen && (head === 2 || head === 3)) {
                const x = bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x);
                let y = Fp2.sqrt(y2);
                const isYOdd = (y & _1n4) === _1n4;
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp2.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 4) {
                const x = Fp2.fromBytes(tail.subarray(0, Fp2.BYTES));
                const y = Fp2.fromBytes(tail.subarray(Fp2.BYTES, 2 * Fp2.BYTES));
                return {
                    x,
                    y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>bytesToHex(numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number2) {
        const HALF = CURVE_ORDER >> _1n4;
        return number2 > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    const slcNum = (b, from, to)=>bytesToNumberBE(b.slice(from, to));
    class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = ensureBytes("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = DER.toSig(ensureBytes("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN(ensureBytes("msgHash", msgHash));
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp2.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point2.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj);
            const u1 = modN(-h * ir);
            const u2 = modN(s * ir);
            const Q = Point2.BASE.multiplyAndAddUnsafe(R, u1, u2);
            if (!Q) throw new Error("point at infinify");
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar,
        /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ randomPrivateKey: ()=>{
            const length = getMinHashLength(CURVE.n);
            return mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */ precompute (windowSize = 8, point = Point2.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    function getPublicKey(privateKey, isCompressed = true) {
        return Point2.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point2) return true;
        return false;
    }
    function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point2.fromHex(publicB);
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    const bits2int = CURVE.bits2int || function(bytes2) {
        const num = bytesToNumberBE(bytes2);
        const delta = bytes2.length * 8 - CURVE.nBitLength;
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes2) {
        return modN(bits2int(bytes2));
    };
    const ORDER_MASK = bitMask(CURVE.nBitLength);
    function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!(_0n4 <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        return numberToBytesBE(num, CURVE.nByteLength);
    }
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash3, randomBytes: randomBytes4 } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts;
        if (lowS == null) lowS = true;
        msgHash = ensureBytes("msgHash", msgHash);
        if (prehash) msgHash = ensureBytes("prehashed msgHash", hash3(msgHash));
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey);
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        if (ent != null) {
            const e = ent === true ? randomBytes4(Fp2.BYTES) : ent;
            seedArgs.push(ensureBytes("extraEntropy", e));
        }
        const seed = concatBytes2(...seedArgs);
        const m = h1int;
        function k2sig(kBytes) {
            const k = bits2int(kBytes);
            if (!isWithinCurveOrder(k)) return;
            const ik = invN(k);
            const q = Point2.BASE.multiply(k).toAffine();
            const r = modN(q.x);
            if (r === _0n4) return;
            const s = modN(ik * modN(m + r * d));
            if (s === _0n4) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n4);
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s);
                recovery ^= 1;
            }
            return new Signature(r, normS, recovery);
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    function sign3(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts);
        const C = CURVE;
        const drbg = createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig);
    }
    Point2.BASE._setWindowSize(8);
    function verify2(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = ensureBytes("msgHash", msgHash);
        publicKey = ensureBytes("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS, prehash } = opts;
        let _sig = void 0;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r2, s: s2 } = sg;
                _sig = new Signature(r2, s2);
            } else throw new Error("PARSE");
            P = Point2.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash);
        const is = invN(s);
        const u1 = modN(h * is);
        const u2 = modN(r * is);
        const R = Point2.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine();
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign: sign3,
        verify: verify2,
        ProjectivePoint: Point2,
        Signature,
        utils
    };
}
// ../../node_modules/@noble/curves/node_modules/@noble/hashes/esm/hmac.js
var HMAC = class extends Hash {
    constructor(hash3, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        hash2(hash3);
        const key = toBytes(_key);
        this.iHash = hash3.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad2 = new Uint8Array(blockLen);
        pad2.set(key.length > blockLen ? hash3.create().update(key).digest() : key);
        for(let i = 0; i < pad2.length; i++)pad2[i] ^= 54;
        this.iHash.update(pad2);
        this.oHash = hash3.create();
        for(let i = 0; i < pad2.length; i++)pad2[i] ^= 106;
        this.oHash.update(pad2);
        pad2.fill(0);
    }
    update(buf) {
        exists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        exists(this);
        bytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
};
var hmac = (hash3, key, message)=>new HMAC(hash3, key).update(message).digest();
hmac.create = (hash3, key)=>new HMAC(hash3, key);
// ../../node_modules/@noble/curves/esm/_shortw_utils.js
function getHash(hash3) {
    return {
        hash: hash3,
        hmac: (key, ...msgs)=>hmac(hash3, key, concatBytes(...msgs)),
        randomBytes: randomBytes2
    };
}
function createCurve(curveDef, defHash) {
    const create = (hash3)=>weierstrass({
            ...curveDef,
            ...getHash(hash3)
        });
    return Object.freeze({
        ...create(defHash),
        create
    });
}
// ../../node_modules/@noble/curves/esm/secp256k1.js
var secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
var secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
var _1n5 = BigInt(1);
var _2n4 = BigInt(2);
var divNearest = (a, b)=>(a + b / _2n4) / b;
function sqrtMod(y) {
    const P = secp256k1P;
    const _3n3 = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P;
    const b3 = b2 * b2 * y % P;
    const b6 = pow2(b3, _3n3, P) * b3 % P;
    const b9 = pow2(b6, _3n3, P) * b3 % P;
    const b11 = pow2(b9, _2n4, P) * b2 % P;
    const b22 = pow2(b11, _11n, P) * b11 % P;
    const b44 = pow2(b22, _22n, P) * b22 % P;
    const b88 = pow2(b44, _44n, P) * b44 % P;
    const b176 = pow2(b88, _88n, P) * b88 % P;
    const b220 = pow2(b176, _44n, P) * b44 % P;
    const b223 = pow2(b220, _3n3, P) * b3 % P;
    const t1 = pow2(b223, _23n, P) * b22 % P;
    const t2 = pow2(t1, _6n, P) * b2 % P;
    const root = pow2(t2, _2n4, P);
    if (!Fp.eql(Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
var Fp = Field(secp256k1P, void 0, void 0, {
    sqrt: sqrtMod
});
var secp256k1 = createCurve({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -_1n5 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000");
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = mod(k - c1 * a1 - c2 * a2, n);
            let k2 = mod(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha2562);
var _0n5 = BigInt(0);
var Point = secp256k1.ProjectivePoint;
// src/secp256k1/secp256k1.ts
var curve = new import_elliptic.ec("secp256k1");
function isValidMessageHash(hash3) {
    return Buffer.isBuffer(hash3) && hash3.length === 32;
}
function isValidPrivateKey(key) {
    return Buffer.isBuffer(key) && key.length === 32 && !key.equals(ZERO_BUFFER(32)) && key.compare(PRIVATE_KEY_MAX_VALUE) < 0;
}
function generatePrivateKey() {
    return Buffer.from(secp256k1.utils.randomPrivateKey());
}
function derivePublicKey(privateKey) {
    assertIsValidPrivateKey("derivePublicKey", privateKey, isValidPrivateKey);
    const publicKey = secp256k1.getPublicKey(privateKey, false);
    return Buffer.from(publicKey);
}
function sign(messageHash, privateKey) {
    assertIsValidSecp256k1MessageHash("sign", messageHash, isValidMessageHash);
    assertIsValidPrivateKey("sign", privateKey, isValidPrivateKey);
    const sig = secp256k1.sign(messageHash, privateKey);
    const r = Buffer.from(new import_bn.BN(sig.r.toString()).toArray("be", 32));
    const s = Buffer.from(new import_bn.BN(sig.s.toString()).toArray("be", 32));
    return Buffer.concat([
        r,
        s,
        Buffer.from([
            sig.recovery
        ])
    ]);
}
function recover(messageHash, sig) {
    assertIsValidSecp256k1MessageHash("recover", messageHash, isValidMessageHash);
    (0, import_sdk_errors21.assert)("recover", Buffer.isBuffer(sig) && sig.length === SIGNATURE_LENGTH, import_sdk_errors21.SECP256K1.INVALID_SECP256k1_SIGNATURE, "Invalid signature given as input. Length must be exactly 65 bytes.", {
        sig
    });
    const recovery = sig[64];
    (0, import_sdk_errors21.assert)("recover", recovery === 0 || recovery === 1, import_sdk_errors21.SECP256K1.INVALID_SECP256k1_SIGNATURE_RECOVERY, "Invalid signature recovery value. Signature bytes at position 64 must be 0 or 1.", {
        recovery
    });
    return Buffer.from(secp256k1.Signature.fromCompact(Uint8Array.from(sig).slice(0, 64)).addRecoveryBit(recovery).recoverPublicKey(messageHash).toRawBytes(false));
}
function extendedPublicKeyToArray(extendedPublicKey, compact) {
    return curve.keyFromPublic(extendedPublicKey).getPublic(compact, "array");
}
function randomBytes3(bytesLength) {
    return Buffer.from(randomBytes(bytesLength));
}
var secp256k12 = {
    isValidMessageHash,
    isValidPrivateKey,
    generatePrivateKey,
    derivePublicKey,
    sign,
    recover,
    extendedPublicKeyToArray,
    randomBytes: randomBytes3
};
// src/address/address.ts
function fromPublicKey(publicKey) {
    return import_ethers8.ethers.computeAddress(Hex0x.of(publicKey));
}
function fromPrivateKey(privateKey) {
    return addressUtils.fromPublicKey(secp256k12.derivePublicKey(privateKey));
}
function isAddress(addressToVerify) {
    return HEX_ADDRESS_REGEX.test(addressToVerify);
}
function toChecksummed(address) {
    (0, import_sdk_errors22.assert)("toChecksummed", isAddress(address), import_sdk_errors22.ADDRESS.INVALID_ADDRESS, "Checksum failed: Input must be a valid Vechain Thor address.", {
        address
    });
    return import_ethers8.ethers.getAddress(address);
}
var addressUtils = {
    fromPublicKey,
    fromPrivateKey,
    isAddress,
    toChecksummed
};
// src/certificate/certificate.ts
var import_fast_json_stable_stringify = __toESM(require_fast_json_stable_stringify());
var import_buffer3 = require("a94c134a31f0760");
var import_sdk_errors23 = require("efe1f1d778f145a2");
function encode3(cert) {
    return (0, import_fast_json_stable_stringify.default)({
        ...cert,
        signer: cert.signer,
        signature: cert.signature
    });
}
function verify(cert) {
    (0, import_sdk_errors23.assert)("verify", cert.signature !== void 0 && cert.signature !== null, import_sdk_errors23.CERTIFICATE.CERTIFICATE_NOT_SIGNED, "Verification failed: Certificate's signature is missing.", {
        cert
    });
    (0, import_sdk_errors23.assert)("verify", Hex0x.isValid(cert.signature, false, true), import_sdk_errors23.CERTIFICATE.CERTIFICATE_INVALID_SIGNATURE_FORMAT, "Verification failed: Signature format is invalid.", {
        cert
    });
    const encoded = encode3({
        ...cert,
        signature: void 0
    });
    const signingHash = blake2b256(encoded);
    const pubKey = secp256k12.recover(signingHash, import_buffer3.Buffer.from(cert.signature.slice(2), "hex"));
    (0, import_sdk_errors23.assert)("verify", addressUtils.fromPublicKey(pubKey) === cert.signer, import_sdk_errors23.CERTIFICATE.CERTIFICATE_INVALID_SIGNER, "Verification failed: Signature does not correspond to the signer's public key.", {
        pubKey,
        cert
    });
}
var certificate = {
    encode: encode3,
    verify
};
// src/clause/clause.ts
var import_ethers9 = require("4118e9000a31bc10");
var import_sdk_errors24 = require("efe1f1d778f145a2");
function deployContract(contractBytecode, deployParams) {
    let encodedParams = "";
    if (deployParams != null) encodedParams = abi.encodeParams(deployParams.types, deployParams.values).replace("0x", "");
    return {
        to: null,
        value: 0,
        data: contractBytecode + encodedParams
    };
}
function functionInteraction(contractAddress, functionFragment, args, value = 0) {
    return {
        to: contractAddress,
        value,
        data: new abi.Function(functionFragment).encodeInput(args)
    };
}
function transferToken(tokenAddress, recipientAddress, amount) {
    try {
        return functionInteraction(tokenAddress, coder.createInterface(VIP180_ABI).getFunction("transfer"), [
            recipientAddress,
            BigInt(amount)
        ]);
    } catch (error) {
        throw (0, import_sdk_errors24.buildError)("transferToken", import_sdk_errors24.DATA.INVALID_DATA_TYPE, `Invalid 'amount' parameter. Expected an integer but received ${amount}.`);
    }
}
function transferVET(recipientAddress, amount) {
    try {
        const bnAmount = BigInt(amount);
        (0, import_sdk_errors24.assert)("transferVET", bnAmount > 0, import_sdk_errors24.DATA.INVALID_DATA_TYPE, `Invalid 'amount' parameter. Expected a positive amount but received ${amount}.`);
        return {
            to: recipientAddress,
            value: `0x${BigInt(amount).toString(16)}`,
            data: "0x"
        };
    } catch (error) {
        throw (0, import_sdk_errors24.buildError)("transferVET", import_sdk_errors24.DATA.INVALID_DATA_TYPE, `Invalid 'amount' parameter. Expected an integer but received ${amount}.`);
    }
}
function transferNFT(contractAddress, senderAddress, recipientAddress, tokenId) {
    (0, import_sdk_errors24.assert)("transferNFT", tokenId !== "", import_sdk_errors24.DATA.INVALID_DATA_TYPE, `Invalid 'tokenId' parameter. Expected an id but received ${tokenId}.`);
    (0, import_sdk_errors24.assert)("transferNFT", (0, import_ethers9.isAddress)(contractAddress), import_sdk_errors24.DATA.INVALID_DATA_TYPE, `Invalid 'contractAddress' parameter. Expected a contract address but received ${contractAddress}.`);
    return functionInteraction(contractAddress, coder.createInterface(ERC721_ABI).getFunction("transferFrom"), [
        senderAddress,
        recipientAddress,
        tokenId
    ]);
}
var clauseBuilder = {
    deployContract,
    functionInteraction,
    transferToken,
    transferVET,
    transferNFT
};
// src/hdnode/hdnode.ts
var import_ethers10 = require("4118e9000a31bc10");
var import_sdk_errors25 = require("efe1f1d778f145a2");
function fromMnemonic(words, path = VET_DERIVATION_PATH) {
    (0, import_sdk_errors25.assert)("fromMnemonic", MNEMONIC_WORDLIST_ALLOWED_SIZES.includes(words.length), import_sdk_errors25.HDNODE.INVALID_HDNODE_MNEMONICS, "Invalid mnemonic size. Mnemonic must be 12, 15, 18, 21, or 24 words.", {
        words
    });
    assertIsValidHdNodeDerivationPath("fromMnemonic", path);
    const joinedWords = words.join(" ").toLowerCase();
    const node = import_ethers10.ethers.HDNodeWallet.fromMnemonic(import_ethers10.ethers.Mnemonic.fromPhrase(joinedWords), path);
    return ethersNodeToOurHDNode(node);
}
function fromPublicKey2(publicKey, chainCode) {
    (0, import_sdk_errors25.assert)("fromPublicKey", publicKey.length === 65, import_sdk_errors25.HDNODE.INVALID_HDNODE_PUBLIC_KEY, "Invalid public key. Length must be exactly 65 bytes.", {
        publicKey
    });
    assertIsValidHdNodeChainCode("fromPublicKey", chainCode);
    const compressed = secp256k12.extendedPublicKeyToArray(publicKey, true);
    const key = Buffer.concat([
        X_PUB_PREFIX,
        chainCode,
        Buffer.from(compressed)
    ]);
    const checksum = sha256(sha256(key));
    const slicedChecksum = checksum.subarray(0, 4);
    const node = import_ethers10.ethers.HDNodeWallet.fromExtendedKey(import_ethers10.ethers.encodeBase58(Buffer.concat([
        key,
        slicedChecksum
    ])));
    return ethersNodeToOurHDNode(node);
}
function fromPrivateKey2(privateKey, chainCode) {
    (0, import_sdk_errors25.assert)("fromPrivateKey", privateKey.length === 32, import_sdk_errors25.HDNODE.INVALID_HDNODE_PRIVATE_KEY, "Invalid private key. Length must be exactly 32 bytes.", {
        privateKey
    });
    assertIsValidHdNodeChainCode("fromPrivateKey", chainCode);
    const key = Buffer.concat([
        X_PRIV_PREFIX,
        chainCode,
        Buffer.from([
            0
        ]),
        privateKey
    ]);
    const checksum = sha256(sha256(key));
    const slicedChecksum = checksum.subarray(0, 4);
    const node = import_ethers10.ethers.HDNodeWallet.fromExtendedKey(import_ethers10.ethers.encodeBase58(Buffer.concat([
        key,
        slicedChecksum
    ])));
    return ethersNodeToOurHDNode(node);
}
function ethersNodeToOurHDNode(ethersNode) {
    const pub = Buffer.from(secp256k12.extendedPublicKeyToArray(Buffer.from(ethersNode.publicKey.slice(2), "hex"), false));
    const cc = Buffer.from(ethersNode.chainCode.slice(2), "hex");
    const addr = addressUtils.fromPublicKey(pub);
    return {
        get publicKey () {
            return pub;
        },
        get privateKey () {
            if (ethersNode.privateKey !== void 0) return Buffer.from(ethersNode.privateKey.slice(2), "hex");
            return null;
        },
        get chainCode () {
            return cc;
        },
        get address () {
            return addr;
        },
        derive (index) {
            return ethersNodeToOurHDNode(ethersNode.deriveChild(index));
        },
        derivePath (path) {
            assertIsValidHdNodeDerivationPath("ethersNodeToOurHDNode", path);
            return ethersNodeToOurHDNode(ethersNode.derivePath(path));
        }
    };
}
var HDNode = {
    fromMnemonic,
    fromPublicKey: fromPublicKey2,
    fromPrivateKey: fromPrivateKey2
};
// src/keystore/keystore.ts
var import_ethers11 = require("4118e9000a31bc10");
var import_sdk_errors26 = require("efe1f1d778f145a2");
async function encrypt(privateKey, password) {
    const derivePublicKey2 = secp256k12.derivePublicKey(privateKey);
    const deriveAddress2 = addressUtils.fromPublicKey(derivePublicKey2);
    const keystoreAccount = {
        address: deriveAddress2,
        privateKey: Hex0x.of(privateKey)
    };
    const encryptOptions = {
        scrypt: {
            N: SCRYPT_PARAMS.N,
            r: SCRYPT_PARAMS.r,
            p: SCRYPT_PARAMS.p
        }
    };
    const keystoreJsonString = await import_ethers11.ethers.encryptKeystoreJson(keystoreAccount, password, encryptOptions);
    return JSON.parse(keystoreJsonString);
}
async function decrypt(keystore2, password) {
    (0, import_sdk_errors26.assert)("keystore.decrypt", isValid(keystore2), import_sdk_errors26.KEYSTORE.INVALID_KEYSTORE, "Invalid keystore. Ensure the keystore is properly formatted and contains the necessary data.", {
        keystore: keystore2
    });
    try {
        return await import_ethers11.ethers.decryptKeystoreJson(JSON.stringify(keystore2), password);
    } catch (e) {
        throw (0, import_sdk_errors26.buildError)("keystore.decrypt", import_sdk_errors26.KEYSTORE.INVALID_PASSWORD, "Decryption failed: Invalid Password for the given keystore.", {
            keystore: keystore2,
            password
        }, e);
    }
}
function isValid(keystore2) {
    return import_ethers11.ethers.isKeystoreJson(JSON.stringify(keystore2));
}
var keystore = {
    encrypt,
    decrypt,
    isValid
};
// src/mnemonic/mnemonic.ts
var import_ethers12 = require("4118e9000a31bc10");
var import_sdk_errors27 = require("efe1f1d778f145a2");
function generate(wordlistSize, randomGenerator) {
    (0, import_sdk_errors27.assert)("generate", wordlistSize === void 0 || MNEMONIC_WORDLIST_ALLOWED_SIZES.includes(wordlistSize), import_sdk_errors27.HDNODE.INVALID_HDNODE_MNEMONICS, "Invalid wordlist size given as input. Allowed sizes are 12, 15, 18, 21, 24 words.", {
        wordlistSize
    });
    randomGenerator = randomGenerator ?? // Default random generator
    ((numberOfBytes)=>secp256k12.randomBytes(numberOfBytes));
    const wordlistSizeToUse = wordlistSize ?? 12;
    return import_ethers12.ethers.Mnemonic.fromEntropy(randomGenerator(wordlistSizeToUse / 3 * 4)).phrase.split(" ");
}
function validate(words) {
    return import_ethers12.ethers.Mnemonic.isValidMnemonic(words.join(" "));
}
function derivePrivateKey(words, derivationPathFromCurrentNode = "0") {
    return HDNode.fromMnemonic(words).derivePath(derivationPathFromCurrentNode).privateKey;
}
function deriveAddress(words, derivationPathFromCurrentNode = "0") {
    return HDNode.fromMnemonic(words).derivePath(derivationPathFromCurrentNode).address;
}
var mnemonic = {
    generate,
    validate,
    derivePrivateKey,
    deriveAddress
};
// src/transaction/transaction.ts
var import_sdk_errors28 = require("efe1f1d778f145a2");
var Transaction = class _Transaction {
    /**
   * Transaction body. It represents the body of the transaction.
   *
   * @note It is better to take it as a read-only property in order to avoid any external modification.
   */ body;
    /**
   * Transaction signature. It represents the signature of the transaction.
   *
   * @note It is better to take it as a read-only property in order to avoid any external modification.
   */ signature;
    /**
   * Constructor with parameters.
   * This constructor creates a transaction immutable object.
   *
   * @throws{TransactionBodyError, InvalidSecp256k1SignatureError}
   * @param body - Transaction body
   * @param signature - Optional signature for the transaction
   */ constructor(body, signature){
        (0, import_sdk_errors28.assert)("Transaction constructor", _Transaction.isValidBody(body), import_sdk_errors28.TRANSACTION.INVALID_TRANSACTION_BODY, "Invalid transaction body. Ensure all required fields are correctly formatted and present.", {
            body
        });
        this.body = body;
        if (signature !== void 0) {
            (0, import_sdk_errors28.assert)("Transaction constructor", this._isSignatureValid(signature), import_sdk_errors28.SECP256K1.INVALID_SECP256k1_SIGNATURE, "Invalid transaction signature. Ensure it is correctly formatted.", {
                signature
            });
            this.signature = signature;
        }
    }
    // ********** PUBLIC GET ONLY FUNCTIONS **********
    /**
   * Calculate intrinsic gas required for this transaction
   *
   * @returns Intrinsic gas required for this transaction
   */ get intrinsicGas() {
        return TransactionUtils.intrinsicGas(this.body.clauses);
    }
    /**
   * Determines whether the transaction is delegated.
   *
   * @returns If transaction is delegated or not
   */ get isDelegated() {
        return this._isDelegated(this.body);
    }
    /**
   * Get transaction delegator address from signature.
   *
   * @throws{TransactionDelegationError, TransactionNotSignedError}
   * @returns Transaction delegator address
   */ get delegator() {
        (0, import_sdk_errors28.assert)("delegator", this.isDelegated, import_sdk_errors28.TRANSACTION.INVALID_DELEGATION, "Transaction is not delegated. Delegator information is unavailable.");
        assertCantGetFieldOnUnsignedTransaction("delegator", this, "delegator");
        const signatureSliced = this.signature.subarray(65, this.signature?.length);
        const delegatorPublicKey = secp256k12.recover(this.getSignatureHash(this.origin), signatureSliced);
        return addressUtils.fromPublicKey(delegatorPublicKey);
    }
    /**
   * Determines whether the transaction is signed or not.
   *
   * @returns If transaction is signed or not
   */ get isSigned() {
        return this.signature !== void 0;
    }
    /**
   * Computes the signature hash for the transaction. The output is based on
   * the presence of the 'delegateFor' parameter.
   *
   * @param delegateFor - Optional address of the delegator.
   * @returns The computed hash.
   *
   * Mainly:
   *  - No 'delegateFor': return txHash
   * - 'delegateFor' return txHash +  hash('delegateFor' address)
   *
   * @remarks
   * delegateFor is used to sign a transaction on behalf of another account.
   * In fact when the delegator sign the transaction, delegator will add the address
   * of who send the transaction to sign (in this case the 'delegateFor' address parameter)
   *
   * @example
   * A is transaction origin
   * B is the delegator
   * TX is the transaction
   *
   * A sends a TX (signed by A) to B to who add his signature to TX using delegateFor parameter (that is A address)
   * on signing hash of TX computation.
   *
   * Mathematically:
   *
   * ```
   * final_signature = concat_buffer(
   *      sign(TX.signingHash(), A.privateKey),
   *      sign(TX.signingHash(A.address), B.privateKey)
   * )
   * ```
   *
   * Where:
   *
   * ```
   * TX.signatureHash() = blake2b256(TX.encoded)
   * TX.signingHash(A.address) = blake2b256(
   *      concat(
   *              blake2b256(TX.encoded),
   *              A.address
   *             )
   * )
   * ```
   *
   * @throws{InvalidAddressError}
   * @param delegateFor - Address of the delegator
   * @returns Signing hash of the transaction
   */ getSignatureHash(delegateFor) {
        (0, import_sdk_errors28.assert)("getSignatureHash", delegateFor === void 0 || addressUtils.isAddress(delegateFor), import_sdk_errors28.ADDRESS.INVALID_ADDRESS, "Invalid address given as input as delegateFor parameter. Ensure it is a valid address.", {
            delegateFor
        });
        const transactionHash = blake2b256(this._encode(false));
        if (delegateFor !== void 0) return blake2b256(Buffer.concat([
            transactionHash,
            Buffer.from(delegateFor.slice(2), "hex")
        ]));
        return transactionHash;
    }
    /**
   * Encode a transaction
   *
   * @returns The transaction encoded
   */ get encoded() {
        return this._encode(this.isSigned);
    }
    /**
   * Get transaction origin address from signature.
   *
   * @throws{TransactionNotSignedError}
   * @returns Transaction origin
   */ get origin() {
        assertCantGetFieldOnUnsignedTransaction("origin", this, "origin");
        const signatureSliced = this.signature.subarray(0, 65);
        const originPublicKey = secp256k12.recover(this.getSignatureHash(), signatureSliced);
        return addressUtils.fromPublicKey(originPublicKey);
    }
    /**
   * Get transaction ID from signature.
   *
   * @throws{TransactionNotSignedError}
   * @returns Transaction ID
   */ get id() {
        assertCantGetFieldOnUnsignedTransaction("id", this, "id");
        return blake2b256(Buffer.concat([
            this.getSignatureHash(),
            Buffer.from(this.origin.slice(2), "hex")
        ]), "hex");
    }
    // ********** INTERNAL PRIVATE FUNCTIONS **********
    /**
   * Internal function to check if transaction is delegated or not.
   * This function is used to check directly the transaction body.
   * @private
   *
   * @param body Transaction body to check
   * @returns Weather the transaction is delegated or not
   */ _isDelegated(body) {
        const reserved = body.reserved ?? {};
        const features = reserved.features ?? 0;
        return (features & 1) === 1;
    }
    /**
   * Internal function to check if signature is valid or not.
   * This function is used to check directly the signature.
   * @private
   *
   * @param signature Signature to check
   * @returns Weather the signature is valid or not
   */ _isSignatureValid(signature) {
        const expectedSignatureLength = this._isDelegated(this.body) ? SIGNATURE_LENGTH * 2 : SIGNATURE_LENGTH;
        return signature.length === expectedSignatureLength;
    }
    /**
   * Encodes the reserved field to ensure it exists in every encoding.
   *
   * Due to the fact that reserved field is optional in TransactionBody,
   * BUT mandatory in RLPProfiler, we need to have it in every encoding.
   * Fot this reason this function is needed.
   * @private
   *
   * @returns Encoding of reserved field
   */ _encodeReservedField() {
        const reserved = this.body.reserved ?? {};
        const featuresKind = TRANSACTION_FEATURES_KIND.kind;
        const featuresList = [
            featuresKind.data(reserved.features ?? 0, TRANSACTION_FEATURES_KIND.name).encode(),
            ...reserved.unused ?? []
        ];
        while(featuresList.length > 0){
            if (featuresList[featuresList.length - 1].length === 0) featuresList.pop();
            else break;
        }
        return featuresList;
    }
    /**
   * Make the RLP encoding of a transaction body.
   * @private
   *
   * @param body Body to encode
   * @param isSigned If transaction is signed or not
   * @returns RLP encoding of transaction body
   */ _lowLevelEncodeTransactionBodyWithRLP(body, isSigned) {
        if (isSigned) return SIGNED_TRANSACTION_RLP.encodeObject({
            ...body,
            signature: this.signature
        });
        return UNSIGNED_TRANSACTION_RLP.encodeObject(body);
    }
    /**
   * Private utility function to encode a transaction.
   * @private
   *
   * @param isSigned If transaction is signed or not (needed to determine if encoding with SIGNED_TRANSACTION_RLP or UNSIGNED_TRANSACTION_RLP)
   * @returns Encoding of transaction
   */ _encode(isSigned) {
        return this._lowLevelEncodeTransactionBodyWithRLP({
            // Existing body (clauses, gasPrice, gasLimit, nonce, chainTag, blockRef, expiration, ... AND OPTIONALLY reserved field)
            ...this.body,
            /*
         * @note: this.body.clauses is already an array.
         * But TypeScript doesn't know that and for this reason we need to cast it.
         * Otherwise encodeObject will throw an error.
         */ clauses: this.body.clauses,
            // New reserved field
            reserved: this._encodeReservedField()
        }, isSigned);
    }
    /**
   * utility function to check transaction body validity.
   *
   * @param body Transaction body to check
   */ static isValidBody(body) {
        return(// Chain tag
        body.chainTag !== void 0 && body.chainTag >= 0 && body.chainTag <= 255 && // Block reference
        body.blockRef !== void 0 && Hex0x.isValid(body.blockRef) && Buffer.from(body.blockRef.slice(2), "hex").length === BLOCK_REF_LENGTH && // Expiration
        body.expiration !== void 0 && // Clauses
        body.clauses !== void 0 && // Gas price coef
        body.gasPriceCoef !== void 0 && // Gas
        body.gas !== void 0 && // Depends on
        body.dependsOn !== void 0 && // Nonce
        body.nonce !== void 0);
    }
};
// src/transaction/handlers/sign.ts
var import_sdk_errors29 = require("efe1f1d778f145a2");
function sign2(transactionBody, signerPrivateKey) {
    assertIsValidTransactionSigningPrivateKey("sign", signerPrivateKey, secp256k12.isValidPrivateKey);
    const transactionToSign = new Transaction(transactionBody);
    (0, import_sdk_errors29.assert)("sign", !transactionToSign.isDelegated, import_sdk_errors29.TRANSACTION.INVALID_DELEGATION, "Transaction is delegated. Use signWithDelegator method instead.", {
        transactionBody
    });
    const signature = secp256k12.sign(transactionToSign.getSignatureHash(), signerPrivateKey);
    return new Transaction(transactionBody, signature);
}
function signWithDelegator(transactionBody, signerPrivateKey, delegatorPrivateKey) {
    assertIsValidTransactionSigningPrivateKey("signWithDelegator", signerPrivateKey, secp256k12.isValidPrivateKey, "signer");
    assertIsValidTransactionSigningPrivateKey("signWithDelgator", delegatorPrivateKey, secp256k12.isValidPrivateKey, "delegator");
    const transactionToSign = new Transaction(transactionBody);
    (0, import_sdk_errors29.assert)("signWithDelegator", transactionToSign.isDelegated, import_sdk_errors29.TRANSACTION.INVALID_DELEGATION, "Transaction is not delegated. Use sign method instead.", {
        transactionToSign
    });
    const transactionHash = transactionToSign.getSignatureHash();
    const delegatedHash = transactionToSign.getSignatureHash(addressUtils.fromPublicKey(secp256k12.derivePublicKey(signerPrivateKey)));
    const signature = Buffer.concat([
        secp256k12.sign(transactionHash, signerPrivateKey),
        secp256k12.sign(delegatedHash, delegatorPrivateKey)
    ]);
    return new Transaction(transactionBody, signature);
}
// src/transaction/handlers/decode.ts
var import_sdk_errors30 = require("efe1f1d778f145a2");
function decode3(rawTransaction, isSigned) {
    const decoder = isSigned ? SIGNED_TRANSACTION_RLP : UNSIGNED_TRANSACTION_RLP;
    const decodedRLPBody = decoder.decodeObject(rawTransaction);
    const bodyWithoutReservedField = {
        blockRef: decodedRLPBody.blockRef,
        chainTag: decodedRLPBody.chainTag,
        clauses: decodedRLPBody.clauses,
        dependsOn: decodedRLPBody.dependsOn,
        expiration: decodedRLPBody.expiration,
        gas: decodedRLPBody.gas,
        gasPriceCoef: decodedRLPBody.gasPriceCoef,
        nonce: decodedRLPBody.nonce
    };
    const correctTransactionBody = decodedRLPBody.reserved.length > 0 ? {
        ...bodyWithoutReservedField,
        reserved: _decodeReservedField(decodedRLPBody.reserved)
    } : bodyWithoutReservedField;
    return decodedRLPBody.signature !== void 0 ? new Transaction(correctTransactionBody, decodedRLPBody.signature) : new Transaction(correctTransactionBody);
}
function _decodeReservedField(reserved) {
    (0, import_sdk_errors30.assert)("_decodeReservedField", reserved[reserved.length - 1].length !== 0, import_sdk_errors30.TRANSACTION.INVALID_TRANSACTION_BODY, "Invalid reserved field. Fields in the reserved buffer must be properly trimmed.", {
        reserved
    });
    const featuresField = TRANSACTION_FEATURES_KIND.kind.buffer(reserved[0], TRANSACTION_FEATURES_KIND.name).decode();
    return reserved.length > 1 ? {
        features: featuresField,
        unused: reserved.slice(1)
    } : {
        features: featuresField
    };
}
// src/transaction/transaction-handler.ts
var TransactionHandler = {
    // Sign transaction
    sign: sign2,
    signWithDelegator,
    // Decode transaction
    decode: decode3
};
// src/utils/const/network.ts
var VECHAIN_MAINNET_CHAIN_TAG = 74;
var VECHAIN_TESTNET_CHAIN_TAG = 39;
var VECHAIN_SOLO_CHAIN_TAG = 246;
var ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
var VTHO_ADDRESS = "0x0000000000000000000000000000456e65726779";
var PARAMS_ADDRESS = "0x0000000000000000000000000000506172616d73";
var mainnetGenesisBlock = {
    number: 0,
    id: "0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a",
    size: 170,
    parentID: "0xffffffff53616c757465202620526573706563742c20457468657265756d2100",
    timestamp: 1530316800,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var testnetGenesisBlock = {
    number: 0,
    id: "0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127",
    size: 170,
    parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
    timestamp: 1530014400,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var soloGenesisBlock = {
    number: 0,
    id: "0x00000000c05a20fbca2bf6ae3affba6af4a74b800b585bf7a4988aba7aea69f6",
    size: 170,
    parentID: "0xffffffff00000000000000000000000000000000000000000000000000000000",
    timestamp: 15264e5,
    gasLimit: 1e7,
    beneficiary: "0x0000000000000000000000000000000000000000",
    gasUsed: 0,
    totalScore: 0,
    txsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    txsFeatures: 0,
    stateRoot: "0x93de0ffb1f33bc0af053abc2a87c4af44594f5dcb1cb879dd823686a15d68550",
    receiptsRoot: "0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0",
    signer: "0x0000000000000000000000000000000000000000",
    isTrunk: true,
    transactions: []
};
var MAINNET_NETWORK = {
    genesisBlock: mainnetGenesisBlock,
    chainTag: VECHAIN_MAINNET_CHAIN_TAG
};
var TESTNET_NETWORK = {
    genesisBlock: testnetGenesisBlock,
    chainTag: VECHAIN_TESTNET_CHAIN_TAG
};
var SOLO_NETWORK = {
    genesisBlock: soloGenesisBlock,
    chainTag: VECHAIN_SOLO_CHAIN_TAG
};
var networkInfo = {
    mainnet: MAINNET_NETWORK,
    testnet: TESTNET_NETWORK,
    solo: SOLO_NETWORK
};
 /*! Bundled license information:

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/utils.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/modular.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/curve.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/weierstrass.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/_shortw_utils.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/secp256k1.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/ 
},{"a94c134a31f0760":"l5Twm","4118e9000a31bc10":"cudvp","efe1f1d778f145a2":"lBVu5","fdfd8d96a65e922d":"aMgBp","e2b027d0a1029668":"2xufO","b3b2922e292019e9":"9rmFv","f76b29320f1f4079":"dzDrA"}],"cudvp":[function(require,module,exports) {
/**
 *  The Application Programming Interface (API) is the collection of
 *  functions, classes and types offered by the Ethers library.
 *
 *  @_section: api:Application Programming Interface  [about-api]
 *  @_navTitle: API
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ethers", ()=>_ethersJs);
var _ethersJs = require("./ethers.js");
parcelHelpers.exportAll(_ethersJs, exports);

},{"./ethers.js":"a3bpM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a3bpM":[function(require,module,exports) {
/////////////////////////////
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _versionJs.version));
parcelHelpers.export(exports, "decodeBytes32String", ()=>(0, _indexJs.decodeBytes32String));
parcelHelpers.export(exports, "encodeBytes32String", ()=>(0, _indexJs.encodeBytes32String));
parcelHelpers.export(exports, "AbiCoder", ()=>(0, _indexJs.AbiCoder));
parcelHelpers.export(exports, "ConstructorFragment", ()=>(0, _indexJs.ConstructorFragment));
parcelHelpers.export(exports, "ErrorFragment", ()=>(0, _indexJs.ErrorFragment));
parcelHelpers.export(exports, "EventFragment", ()=>(0, _indexJs.EventFragment));
parcelHelpers.export(exports, "Fragment", ()=>(0, _indexJs.Fragment));
parcelHelpers.export(exports, "FallbackFragment", ()=>(0, _indexJs.FallbackFragment));
parcelHelpers.export(exports, "FunctionFragment", ()=>(0, _indexJs.FunctionFragment));
parcelHelpers.export(exports, "NamedFragment", ()=>(0, _indexJs.NamedFragment));
parcelHelpers.export(exports, "ParamType", ()=>(0, _indexJs.ParamType));
parcelHelpers.export(exports, "StructFragment", ()=>(0, _indexJs.StructFragment));
parcelHelpers.export(exports, "checkResultErrors", ()=>(0, _indexJs.checkResultErrors));
parcelHelpers.export(exports, "ErrorDescription", ()=>(0, _indexJs.ErrorDescription));
parcelHelpers.export(exports, "Indexed", ()=>(0, _indexJs.Indexed));
parcelHelpers.export(exports, "Interface", ()=>(0, _indexJs.Interface));
parcelHelpers.export(exports, "LogDescription", ()=>(0, _indexJs.LogDescription));
parcelHelpers.export(exports, "Result", ()=>(0, _indexJs.Result));
parcelHelpers.export(exports, "TransactionDescription", ()=>(0, _indexJs.TransactionDescription));
parcelHelpers.export(exports, "Typed", ()=>(0, _indexJs.Typed));
parcelHelpers.export(exports, "getAddress", ()=>(0, _indexJs1.getAddress));
parcelHelpers.export(exports, "getIcapAddress", ()=>(0, _indexJs1.getIcapAddress));
parcelHelpers.export(exports, "getCreateAddress", ()=>(0, _indexJs1.getCreateAddress));
parcelHelpers.export(exports, "getCreate2Address", ()=>(0, _indexJs1.getCreate2Address));
parcelHelpers.export(exports, "isAddressable", ()=>(0, _indexJs1.isAddressable));
parcelHelpers.export(exports, "isAddress", ()=>(0, _indexJs1.isAddress));
parcelHelpers.export(exports, "resolveAddress", ()=>(0, _indexJs1.resolveAddress));
parcelHelpers.export(exports, "ZeroAddress", ()=>(0, _indexJs2.ZeroAddress));
parcelHelpers.export(exports, "WeiPerEther", ()=>(0, _indexJs2.WeiPerEther));
parcelHelpers.export(exports, "MaxUint256", ()=>(0, _indexJs2.MaxUint256));
parcelHelpers.export(exports, "MinInt256", ()=>(0, _indexJs2.MinInt256));
parcelHelpers.export(exports, "MaxInt256", ()=>(0, _indexJs2.MaxInt256));
parcelHelpers.export(exports, "N", ()=>(0, _indexJs2.N));
parcelHelpers.export(exports, "ZeroHash", ()=>(0, _indexJs2.ZeroHash));
parcelHelpers.export(exports, "EtherSymbol", ()=>(0, _indexJs2.EtherSymbol));
parcelHelpers.export(exports, "MessagePrefix", ()=>(0, _indexJs2.MessagePrefix));
parcelHelpers.export(exports, "BaseContract", ()=>(0, _indexJs3.BaseContract));
parcelHelpers.export(exports, "Contract", ()=>(0, _indexJs3.Contract));
parcelHelpers.export(exports, "ContractFactory", ()=>(0, _indexJs3.ContractFactory));
parcelHelpers.export(exports, "ContractEventPayload", ()=>(0, _indexJs3.ContractEventPayload));
parcelHelpers.export(exports, "ContractTransactionReceipt", ()=>(0, _indexJs3.ContractTransactionReceipt));
parcelHelpers.export(exports, "ContractTransactionResponse", ()=>(0, _indexJs3.ContractTransactionResponse));
parcelHelpers.export(exports, "ContractUnknownEventPayload", ()=>(0, _indexJs3.ContractUnknownEventPayload));
parcelHelpers.export(exports, "EventLog", ()=>(0, _indexJs3.EventLog));
parcelHelpers.export(exports, "UndecodedEventLog", ()=>(0, _indexJs3.UndecodedEventLog));
parcelHelpers.export(exports, "computeHmac", ()=>(0, _indexJs4.computeHmac));
parcelHelpers.export(exports, "randomBytes", ()=>(0, _indexJs4.randomBytes));
parcelHelpers.export(exports, "keccak256", ()=>(0, _indexJs4.keccak256));
parcelHelpers.export(exports, "ripemd160", ()=>(0, _indexJs4.ripemd160));
parcelHelpers.export(exports, "sha256", ()=>(0, _indexJs4.sha256));
parcelHelpers.export(exports, "sha512", ()=>(0, _indexJs4.sha512));
parcelHelpers.export(exports, "pbkdf2", ()=>(0, _indexJs4.pbkdf2));
parcelHelpers.export(exports, "scrypt", ()=>(0, _indexJs4.scrypt));
parcelHelpers.export(exports, "scryptSync", ()=>(0, _indexJs4.scryptSync));
parcelHelpers.export(exports, "lock", ()=>(0, _indexJs4.lock));
parcelHelpers.export(exports, "Signature", ()=>(0, _indexJs4.Signature));
parcelHelpers.export(exports, "SigningKey", ()=>(0, _indexJs4.SigningKey));
parcelHelpers.export(exports, "id", ()=>(0, _indexJs5.id));
parcelHelpers.export(exports, "ensNormalize", ()=>(0, _indexJs5.ensNormalize));
parcelHelpers.export(exports, "isValidName", ()=>(0, _indexJs5.isValidName));
parcelHelpers.export(exports, "namehash", ()=>(0, _indexJs5.namehash));
parcelHelpers.export(exports, "dnsEncode", ()=>(0, _indexJs5.dnsEncode));
parcelHelpers.export(exports, "hashMessage", ()=>(0, _indexJs5.hashMessage));
parcelHelpers.export(exports, "verifyMessage", ()=>(0, _indexJs5.verifyMessage));
parcelHelpers.export(exports, "solidityPacked", ()=>(0, _indexJs5.solidityPacked));
parcelHelpers.export(exports, "solidityPackedKeccak256", ()=>(0, _indexJs5.solidityPackedKeccak256));
parcelHelpers.export(exports, "solidityPackedSha256", ()=>(0, _indexJs5.solidityPackedSha256));
parcelHelpers.export(exports, "TypedDataEncoder", ()=>(0, _indexJs5.TypedDataEncoder));
parcelHelpers.export(exports, "verifyTypedData", ()=>(0, _indexJs5.verifyTypedData));
parcelHelpers.export(exports, "getDefaultProvider", ()=>(0, _indexJs6.getDefaultProvider));
parcelHelpers.export(exports, "Block", ()=>(0, _indexJs6.Block));
parcelHelpers.export(exports, "FeeData", ()=>(0, _indexJs6.FeeData));
parcelHelpers.export(exports, "Log", ()=>(0, _indexJs6.Log));
parcelHelpers.export(exports, "TransactionReceipt", ()=>(0, _indexJs6.TransactionReceipt));
parcelHelpers.export(exports, "TransactionResponse", ()=>(0, _indexJs6.TransactionResponse));
parcelHelpers.export(exports, "AbstractSigner", ()=>(0, _indexJs6.AbstractSigner));
parcelHelpers.export(exports, "NonceManager", ()=>(0, _indexJs6.NonceManager));
parcelHelpers.export(exports, "VoidSigner", ()=>(0, _indexJs6.VoidSigner));
parcelHelpers.export(exports, "AbstractProvider", ()=>(0, _indexJs6.AbstractProvider));
parcelHelpers.export(exports, "FallbackProvider", ()=>(0, _indexJs6.FallbackProvider));
parcelHelpers.export(exports, "JsonRpcApiProvider", ()=>(0, _indexJs6.JsonRpcApiProvider));
parcelHelpers.export(exports, "JsonRpcProvider", ()=>(0, _indexJs6.JsonRpcProvider));
parcelHelpers.export(exports, "JsonRpcSigner", ()=>(0, _indexJs6.JsonRpcSigner));
parcelHelpers.export(exports, "BrowserProvider", ()=>(0, _indexJs6.BrowserProvider));
parcelHelpers.export(exports, "AlchemyProvider", ()=>(0, _indexJs6.AlchemyProvider));
parcelHelpers.export(exports, "AnkrProvider", ()=>(0, _indexJs6.AnkrProvider));
parcelHelpers.export(exports, "CloudflareProvider", ()=>(0, _indexJs6.CloudflareProvider));
parcelHelpers.export(exports, "EtherscanProvider", ()=>(0, _indexJs6.EtherscanProvider));
parcelHelpers.export(exports, "InfuraProvider", ()=>(0, _indexJs6.InfuraProvider));
parcelHelpers.export(exports, "InfuraWebSocketProvider", ()=>(0, _indexJs6.InfuraWebSocketProvider));
parcelHelpers.export(exports, "PocketProvider", ()=>(0, _indexJs6.PocketProvider));
parcelHelpers.export(exports, "QuickNodeProvider", ()=>(0, _indexJs6.QuickNodeProvider));
parcelHelpers.export(exports, "IpcSocketProvider", ()=>(0, _indexJs6.IpcSocketProvider));
parcelHelpers.export(exports, "SocketProvider", ()=>(0, _indexJs6.SocketProvider));
parcelHelpers.export(exports, "WebSocketProvider", ()=>(0, _indexJs6.WebSocketProvider));
parcelHelpers.export(exports, "EnsResolver", ()=>(0, _indexJs6.EnsResolver));
parcelHelpers.export(exports, "Network", ()=>(0, _indexJs6.Network));
parcelHelpers.export(exports, "EnsPlugin", ()=>(0, _indexJs6.EnsPlugin));
parcelHelpers.export(exports, "EtherscanPlugin", ()=>(0, _indexJs6.EtherscanPlugin));
parcelHelpers.export(exports, "FeeDataNetworkPlugin", ()=>(0, _indexJs6.FeeDataNetworkPlugin));
parcelHelpers.export(exports, "FetchUrlFeeDataNetworkPlugin", ()=>(0, _indexJs6.FetchUrlFeeDataNetworkPlugin));
parcelHelpers.export(exports, "GasCostPlugin", ()=>(0, _indexJs6.GasCostPlugin));
parcelHelpers.export(exports, "NetworkPlugin", ()=>(0, _indexJs6.NetworkPlugin));
parcelHelpers.export(exports, "MulticoinProviderPlugin", ()=>(0, _indexJs6.MulticoinProviderPlugin));
parcelHelpers.export(exports, "SocketBlockSubscriber", ()=>(0, _indexJs6.SocketBlockSubscriber));
parcelHelpers.export(exports, "SocketEventSubscriber", ()=>(0, _indexJs6.SocketEventSubscriber));
parcelHelpers.export(exports, "SocketPendingSubscriber", ()=>(0, _indexJs6.SocketPendingSubscriber));
parcelHelpers.export(exports, "SocketSubscriber", ()=>(0, _indexJs6.SocketSubscriber));
parcelHelpers.export(exports, "UnmanagedSubscriber", ()=>(0, _indexJs6.UnmanagedSubscriber));
parcelHelpers.export(exports, "copyRequest", ()=>(0, _indexJs6.copyRequest));
parcelHelpers.export(exports, "showThrottleMessage", ()=>(0, _indexJs6.showThrottleMessage));
parcelHelpers.export(exports, "accessListify", ()=>(0, _indexJs7.accessListify));
parcelHelpers.export(exports, "computeAddress", ()=>(0, _indexJs7.computeAddress));
parcelHelpers.export(exports, "recoverAddress", ()=>(0, _indexJs7.recoverAddress));
parcelHelpers.export(exports, "Transaction", ()=>(0, _indexJs7.Transaction));
parcelHelpers.export(exports, "decodeBase58", ()=>(0, _indexJs8.decodeBase58));
parcelHelpers.export(exports, "encodeBase58", ()=>(0, _indexJs8.encodeBase58));
parcelHelpers.export(exports, "decodeBase64", ()=>(0, _indexJs8.decodeBase64));
parcelHelpers.export(exports, "encodeBase64", ()=>(0, _indexJs8.encodeBase64));
parcelHelpers.export(exports, "concat", ()=>(0, _indexJs8.concat));
parcelHelpers.export(exports, "dataLength", ()=>(0, _indexJs8.dataLength));
parcelHelpers.export(exports, "dataSlice", ()=>(0, _indexJs8.dataSlice));
parcelHelpers.export(exports, "getBytes", ()=>(0, _indexJs8.getBytes));
parcelHelpers.export(exports, "getBytesCopy", ()=>(0, _indexJs8.getBytesCopy));
parcelHelpers.export(exports, "hexlify", ()=>(0, _indexJs8.hexlify));
parcelHelpers.export(exports, "isHexString", ()=>(0, _indexJs8.isHexString));
parcelHelpers.export(exports, "isBytesLike", ()=>(0, _indexJs8.isBytesLike));
parcelHelpers.export(exports, "stripZerosLeft", ()=>(0, _indexJs8.stripZerosLeft));
parcelHelpers.export(exports, "zeroPadBytes", ()=>(0, _indexJs8.zeroPadBytes));
parcelHelpers.export(exports, "zeroPadValue", ()=>(0, _indexJs8.zeroPadValue));
parcelHelpers.export(exports, "defineProperties", ()=>(0, _indexJs8.defineProperties));
parcelHelpers.export(exports, "resolveProperties", ()=>(0, _indexJs8.resolveProperties));
parcelHelpers.export(exports, "assert", ()=>(0, _indexJs8.assert));
parcelHelpers.export(exports, "assertArgument", ()=>(0, _indexJs8.assertArgument));
parcelHelpers.export(exports, "assertArgumentCount", ()=>(0, _indexJs8.assertArgumentCount));
parcelHelpers.export(exports, "assertNormalize", ()=>(0, _indexJs8.assertNormalize));
parcelHelpers.export(exports, "assertPrivate", ()=>(0, _indexJs8.assertPrivate));
parcelHelpers.export(exports, "makeError", ()=>(0, _indexJs8.makeError));
parcelHelpers.export(exports, "isCallException", ()=>(0, _indexJs8.isCallException));
parcelHelpers.export(exports, "isError", ()=>(0, _indexJs8.isError));
parcelHelpers.export(exports, "EventPayload", ()=>(0, _indexJs8.EventPayload));
parcelHelpers.export(exports, "FetchRequest", ()=>(0, _indexJs8.FetchRequest));
parcelHelpers.export(exports, "FetchResponse", ()=>(0, _indexJs8.FetchResponse));
parcelHelpers.export(exports, "FetchCancelSignal", ()=>(0, _indexJs8.FetchCancelSignal));
parcelHelpers.export(exports, "FixedNumber", ()=>(0, _indexJs8.FixedNumber));
parcelHelpers.export(exports, "getBigInt", ()=>(0, _indexJs8.getBigInt));
parcelHelpers.export(exports, "getNumber", ()=>(0, _indexJs8.getNumber));
parcelHelpers.export(exports, "getUint", ()=>(0, _indexJs8.getUint));
parcelHelpers.export(exports, "toBeArray", ()=>(0, _indexJs8.toBeArray));
parcelHelpers.export(exports, "toBigInt", ()=>(0, _indexJs8.toBigInt));
parcelHelpers.export(exports, "toBeHex", ()=>(0, _indexJs8.toBeHex));
parcelHelpers.export(exports, "toNumber", ()=>(0, _indexJs8.toNumber));
parcelHelpers.export(exports, "toQuantity", ()=>(0, _indexJs8.toQuantity));
parcelHelpers.export(exports, "fromTwos", ()=>(0, _indexJs8.fromTwos));
parcelHelpers.export(exports, "toTwos", ()=>(0, _indexJs8.toTwos));
parcelHelpers.export(exports, "mask", ()=>(0, _indexJs8.mask));
parcelHelpers.export(exports, "formatEther", ()=>(0, _indexJs8.formatEther));
parcelHelpers.export(exports, "parseEther", ()=>(0, _indexJs8.parseEther));
parcelHelpers.export(exports, "formatUnits", ()=>(0, _indexJs8.formatUnits));
parcelHelpers.export(exports, "parseUnits", ()=>(0, _indexJs8.parseUnits));
parcelHelpers.export(exports, "toUtf8Bytes", ()=>(0, _indexJs8.toUtf8Bytes));
parcelHelpers.export(exports, "toUtf8CodePoints", ()=>(0, _indexJs8.toUtf8CodePoints));
parcelHelpers.export(exports, "toUtf8String", ()=>(0, _indexJs8.toUtf8String));
parcelHelpers.export(exports, "Utf8ErrorFuncs", ()=>(0, _indexJs8.Utf8ErrorFuncs));
parcelHelpers.export(exports, "decodeRlp", ()=>(0, _indexJs8.decodeRlp));
parcelHelpers.export(exports, "encodeRlp", ()=>(0, _indexJs8.encodeRlp));
parcelHelpers.export(exports, "uuidV4", ()=>(0, _indexJs8.uuidV4));
parcelHelpers.export(exports, "Mnemonic", ()=>(0, _indexJs9.Mnemonic));
parcelHelpers.export(exports, "BaseWallet", ()=>(0, _indexJs9.BaseWallet));
parcelHelpers.export(exports, "HDNodeWallet", ()=>(0, _indexJs9.HDNodeWallet));
parcelHelpers.export(exports, "HDNodeVoidWallet", ()=>(0, _indexJs9.HDNodeVoidWallet));
parcelHelpers.export(exports, "Wallet", ()=>(0, _indexJs9.Wallet));
parcelHelpers.export(exports, "defaultPath", ()=>(0, _indexJs9.defaultPath));
parcelHelpers.export(exports, "getAccountPath", ()=>(0, _indexJs9.getAccountPath));
parcelHelpers.export(exports, "getIndexedAccountPath", ()=>(0, _indexJs9.getIndexedAccountPath));
parcelHelpers.export(exports, "isCrowdsaleJson", ()=>(0, _indexJs9.isCrowdsaleJson));
parcelHelpers.export(exports, "isKeystoreJson", ()=>(0, _indexJs9.isKeystoreJson));
parcelHelpers.export(exports, "decryptCrowdsaleJson", ()=>(0, _indexJs9.decryptCrowdsaleJson));
parcelHelpers.export(exports, "decryptKeystoreJsonSync", ()=>(0, _indexJs9.decryptKeystoreJsonSync));
parcelHelpers.export(exports, "decryptKeystoreJson", ()=>(0, _indexJs9.decryptKeystoreJson));
parcelHelpers.export(exports, "encryptKeystoreJson", ()=>(0, _indexJs9.encryptKeystoreJson));
parcelHelpers.export(exports, "encryptKeystoreJsonSync", ()=>(0, _indexJs9.encryptKeystoreJsonSync));
parcelHelpers.export(exports, "Wordlist", ()=>(0, _indexJs10.Wordlist));
parcelHelpers.export(exports, "LangEn", ()=>(0, _indexJs10.LangEn));
parcelHelpers.export(exports, "WordlistOwl", ()=>(0, _indexJs10.WordlistOwl));
parcelHelpers.export(exports, "WordlistOwlA", ()=>(0, _indexJs10.WordlistOwlA));
parcelHelpers.export(exports, "wordlists", ()=>(0, _indexJs10.wordlists));
var _versionJs = require("./_version.js");
var _indexJs = require("./abi/index.js");
var _indexJs1 = require("./address/index.js");
var _indexJs2 = require("./constants/index.js");
var _indexJs3 = require("./contract/index.js");
var _indexJs4 = require("./crypto/index.js");
var _indexJs5 = require("./hash/index.js");
var _indexJs6 = require("./providers/index.js");
var _indexJs7 = require("./transaction/index.js");
var _indexJs8 = require("./utils/index.js");
var _indexJs9 = require("./wallet/index.js");
var _indexJs10 = require("./wordlists/index.js");

},{"./_version.js":"als7Q","./abi/index.js":"gvX8w","./address/index.js":"3THmk","./constants/index.js":"8Nw3O","./contract/index.js":"fAwEH","./crypto/index.js":"jUsZl","./hash/index.js":"3Gr4x","./providers/index.js":"8NGaI","./transaction/index.js":"iFcfw","./utils/index.js":"4LgPJ","./wallet/index.js":"fT0d5","./wordlists/index.js":"27Mns","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"als7Q":[function(require,module,exports) {
/* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "6.11.1";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gvX8w":[function(require,module,exports) {
/**
 *  The Application Binary Interface (ABI) describes how method input
 *  parameters should be encoded, their results decoded, and how to
 *  decode events and errors.
 *
 *  See [About ABIs](docs-abi) for more details how they are used.
 *
 *  @_section api/abi:Application Binary Interface  [about-abi]
 *  @_navTitle: ABI
 */ //////
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbiCoder", ()=>(0, _abiCoderJs.AbiCoder));
parcelHelpers.export(exports, "decodeBytes32String", ()=>(0, _bytes32Js.decodeBytes32String));
parcelHelpers.export(exports, "encodeBytes32String", ()=>(0, _bytes32Js.encodeBytes32String));
parcelHelpers.export(exports, "ConstructorFragment", ()=>(0, _fragmentsJs.ConstructorFragment));
parcelHelpers.export(exports, "ErrorFragment", ()=>(0, _fragmentsJs.ErrorFragment));
parcelHelpers.export(exports, "EventFragment", ()=>(0, _fragmentsJs.EventFragment));
parcelHelpers.export(exports, "FallbackFragment", ()=>(0, _fragmentsJs.FallbackFragment));
parcelHelpers.export(exports, "Fragment", ()=>(0, _fragmentsJs.Fragment));
parcelHelpers.export(exports, "FunctionFragment", ()=>(0, _fragmentsJs.FunctionFragment));
parcelHelpers.export(exports, "NamedFragment", ()=>(0, _fragmentsJs.NamedFragment));
parcelHelpers.export(exports, "ParamType", ()=>(0, _fragmentsJs.ParamType));
parcelHelpers.export(exports, "StructFragment", ()=>(0, _fragmentsJs.StructFragment));
parcelHelpers.export(exports, "checkResultErrors", ()=>(0, _interfaceJs.checkResultErrors));
parcelHelpers.export(exports, "Indexed", ()=>(0, _interfaceJs.Indexed));
parcelHelpers.export(exports, "Interface", ()=>(0, _interfaceJs.Interface));
parcelHelpers.export(exports, "ErrorDescription", ()=>(0, _interfaceJs.ErrorDescription));
parcelHelpers.export(exports, "LogDescription", ()=>(0, _interfaceJs.LogDescription));
parcelHelpers.export(exports, "TransactionDescription", ()=>(0, _interfaceJs.TransactionDescription));
parcelHelpers.export(exports, "Result", ()=>(0, _interfaceJs.Result));
parcelHelpers.export(exports, "Typed", ()=>(0, _typedJs.Typed));
var _abiCoderJs = require("./abi-coder.js");
var _bytes32Js = require("./bytes32.js");
var _fragmentsJs = require("./fragments.js");
var _interfaceJs = require("./interface.js");
var _typedJs = require("./typed.js");

},{"./abi-coder.js":"cuwf4","./bytes32.js":"k6CBd","./fragments.js":"2OG5v","./interface.js":"801hm","./typed.js":"1X2Hf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuwf4":[function(require,module,exports) {
/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **AbiCoder** is a low-level class responsible for encoding JavaScript
 *  values into binary data and decoding binary data into JavaScript values.
 */ parcelHelpers.export(exports, "AbiCoder", ()=>AbiCoder);
var _indexJs = require("../utils/index.js");
var _abstractCoderJs = require("./coders/abstract-coder.js");
var _addressJs = require("./coders/address.js");
var _arrayJs = require("./coders/array.js");
var _booleanJs = require("./coders/boolean.js");
var _bytesJs = require("./coders/bytes.js");
var _fixedBytesJs = require("./coders/fixed-bytes.js");
var _nullJs = require("./coders/null.js");
var _numberJs = require("./coders/number.js");
var _stringJs = require("./coders/string.js");
var _tupleJs = require("./coders/tuple.js");
var _fragmentsJs = require("./fragments.js");
var _indexJs1 = require("../address/index.js");
// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const PanicReasons = new Map();
PanicReasons.set(0x00, "GENERIC_PANIC");
PanicReasons.set(0x01, "ASSERT_FALSE");
PanicReasons.set(0x11, "OVERFLOW");
PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
PanicReasons.set(0x22, "BAD_STORAGE_DATA");
PanicReasons.set(0x31, "STACK_UNDERFLOW");
PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
PanicReasons.set(0x41, "OUT_OF_MEMORY");
PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let defaultCoder = null;
let defaultMaxInflation = 1024;
function getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, _indexJs.getBytes)(data);
        data = (0, _indexJs.hexlify)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, _indexJs.hexlify)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, _indexJs.hexlify)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, _indexJs1.getAddress)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, _indexJs1.getAddress)(tx.from);
    return (0, _indexJs.makeError)(message, "CALL_EXCEPTION", {
        action,
        data,
        reason,
        transaction,
        invocation,
        revert
    });
}
class AbiCoder {
    #getCoder(param) {
        if (param.isArray()) return new (0, _arrayJs.ArrayCoder)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, _tupleJs.TupleCoder)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, _addressJs.AddressCoder)(param.name);
            case "bool":
                return new (0, _booleanJs.BooleanCoder)(param.name);
            case "string":
                return new (0, _stringJs.StringCoder)(param.name);
            case "bytes":
                return new (0, _bytesJs.BytesCoder)(param.name);
            case "":
                return new (0, _nullJs.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match(paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, _indexJs.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, _numberJs.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match(paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, _indexJs.assertArgument)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, _fixedBytesJs.FixedBytesCoder)(size, param.name);
        }
        (0, _indexJs.assertArgument)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, _fragmentsJs.ParamType).from(type)));
        const coder = new (0, _tupleJs.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, _indexJs.assertArgumentCount)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, _fragmentsJs.ParamType).from(type)));
        const coder = new (0, _tupleJs.TupleCoder)(coders, "_");
        const writer = new (0, _abstractCoderJs.Writer)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, _fragmentsJs.ParamType).from(type)));
        const coder = new (0, _tupleJs.TupleCoder)(coders, "_");
        return coder.decode(new (0, _abstractCoderJs.Reader)(data, loose, defaultMaxInflation));
    }
    static _setDefaultMaxInflation(value) {
        (0, _indexJs.assertArgument)(typeof value === "number" && Number.isInteger(value), "invalid defaultMaxInflation factor", "value", value);
        defaultMaxInflation = value;
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if (defaultCoder == null) defaultCoder = new AbiCoder();
        return defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return getBuiltinCallException(action, tx, data, AbiCoder.defaultAbiCoder());
    }
}

},{"../utils/index.js":"4LgPJ","./coders/abstract-coder.js":"jGfOx","./coders/address.js":"4BgEn","./coders/array.js":"c6PRc","./coders/boolean.js":"ee0Z6","./coders/bytes.js":"huQUS","./coders/fixed-bytes.js":"ka8EM","./coders/null.js":"6T5Nf","./coders/number.js":"8jEGz","./coders/string.js":"eQ2pV","./coders/tuple.js":"jOrdK","./fragments.js":"2OG5v","../address/index.js":"3THmk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4LgPJ":[function(require,module,exports) {
/**
 *  There are many simple utilities required to interact with
 *  Ethereum and to simplify the library, without increasing
 *  the library dependencies for simple functions.
 *
 *  @_section api/utils:Utilities  [about-utils]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeBase58", ()=>(0, _base58Js.decodeBase58));
parcelHelpers.export(exports, "encodeBase58", ()=>(0, _base58Js.encodeBase58));
parcelHelpers.export(exports, "decodeBase64", ()=>(0, _base64Js.decodeBase64));
parcelHelpers.export(exports, "encodeBase64", ()=>(0, _base64Js.encodeBase64));
parcelHelpers.export(exports, "getBytes", ()=>(0, _dataJs.getBytes));
parcelHelpers.export(exports, "getBytesCopy", ()=>(0, _dataJs.getBytesCopy));
parcelHelpers.export(exports, "isHexString", ()=>(0, _dataJs.isHexString));
parcelHelpers.export(exports, "isBytesLike", ()=>(0, _dataJs.isBytesLike));
parcelHelpers.export(exports, "hexlify", ()=>(0, _dataJs.hexlify));
parcelHelpers.export(exports, "concat", ()=>(0, _dataJs.concat));
parcelHelpers.export(exports, "dataLength", ()=>(0, _dataJs.dataLength));
parcelHelpers.export(exports, "dataSlice", ()=>(0, _dataJs.dataSlice));
parcelHelpers.export(exports, "stripZerosLeft", ()=>(0, _dataJs.stripZerosLeft));
parcelHelpers.export(exports, "zeroPadValue", ()=>(0, _dataJs.zeroPadValue));
parcelHelpers.export(exports, "zeroPadBytes", ()=>(0, _dataJs.zeroPadBytes));
parcelHelpers.export(exports, "isCallException", ()=>(0, _errorsJs.isCallException));
parcelHelpers.export(exports, "isError", ()=>(0, _errorsJs.isError));
parcelHelpers.export(exports, "assert", ()=>(0, _errorsJs.assert));
parcelHelpers.export(exports, "assertArgument", ()=>(0, _errorsJs.assertArgument));
parcelHelpers.export(exports, "assertArgumentCount", ()=>(0, _errorsJs.assertArgumentCount));
parcelHelpers.export(exports, "assertPrivate", ()=>(0, _errorsJs.assertPrivate));
parcelHelpers.export(exports, "assertNormalize", ()=>(0, _errorsJs.assertNormalize));
parcelHelpers.export(exports, "makeError", ()=>(0, _errorsJs.makeError));
parcelHelpers.export(exports, "EventPayload", ()=>(0, _eventsJs.EventPayload));
parcelHelpers.export(exports, "FetchRequest", ()=>(0, _fetchJs.FetchRequest));
parcelHelpers.export(exports, "FetchResponse", ()=>(0, _fetchJs.FetchResponse));
parcelHelpers.export(exports, "FetchCancelSignal", ()=>(0, _fetchJs.FetchCancelSignal));
parcelHelpers.export(exports, "FixedNumber", ()=>(0, _fixednumberJs.FixedNumber));
parcelHelpers.export(exports, "fromTwos", ()=>(0, _mathsJs.fromTwos));
parcelHelpers.export(exports, "toTwos", ()=>(0, _mathsJs.toTwos));
parcelHelpers.export(exports, "mask", ()=>(0, _mathsJs.mask));
parcelHelpers.export(exports, "getBigInt", ()=>(0, _mathsJs.getBigInt));
parcelHelpers.export(exports, "getNumber", ()=>(0, _mathsJs.getNumber));
parcelHelpers.export(exports, "getUint", ()=>(0, _mathsJs.getUint));
parcelHelpers.export(exports, "toBigInt", ()=>(0, _mathsJs.toBigInt));
parcelHelpers.export(exports, "toNumber", ()=>(0, _mathsJs.toNumber));
parcelHelpers.export(exports, "toBeHex", ()=>(0, _mathsJs.toBeHex));
parcelHelpers.export(exports, "toBeArray", ()=>(0, _mathsJs.toBeArray));
parcelHelpers.export(exports, "toQuantity", ()=>(0, _mathsJs.toQuantity));
parcelHelpers.export(exports, "resolveProperties", ()=>(0, _propertiesJs.resolveProperties));
parcelHelpers.export(exports, "defineProperties", ()=>(0, _propertiesJs.defineProperties));
parcelHelpers.export(exports, "decodeRlp", ()=>(0, _rlpDecodeJs.decodeRlp));
parcelHelpers.export(exports, "encodeRlp", ()=>(0, _rlpEncodeJs.encodeRlp));
parcelHelpers.export(exports, "formatEther", ()=>(0, _unitsJs.formatEther));
parcelHelpers.export(exports, "parseEther", ()=>(0, _unitsJs.parseEther));
parcelHelpers.export(exports, "formatUnits", ()=>(0, _unitsJs.formatUnits));
parcelHelpers.export(exports, "parseUnits", ()=>(0, _unitsJs.parseUnits));
parcelHelpers.export(exports, "toUtf8Bytes", ()=>(0, _utf8Js.toUtf8Bytes));
parcelHelpers.export(exports, "toUtf8CodePoints", ()=>(0, _utf8Js.toUtf8CodePoints));
parcelHelpers.export(exports, "toUtf8String", ()=>(0, _utf8Js.toUtf8String));
parcelHelpers.export(exports, "Utf8ErrorFuncs", ()=>(0, _utf8Js.Utf8ErrorFuncs));
parcelHelpers.export(exports, "uuidV4", ()=>(0, _uuidJs.uuidV4));
var _base58Js = require("./base58.js");
var _base64Js = require("./base64.js");
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
var _eventsJs = require("./events.js");
var _fetchJs = require("./fetch.js");
var _fixednumberJs = require("./fixednumber.js");
var _mathsJs = require("./maths.js");
var _propertiesJs = require("./properties.js");
var _rlpDecodeJs = require("./rlp-decode.js");
var _rlpEncodeJs = require("./rlp-encode.js");
var _unitsJs = require("./units.js");
var _utf8Js = require("./utf8.js");
var _uuidJs = require("./uuid.js");

},{"./base58.js":"1gT7F","./base64.js":"i0Tiy","./data.js":"7jkig","./errors.js":"dGCHN","./events.js":"0qzK7","./fetch.js":"ktyo1","./fixednumber.js":"iCAWe","./maths.js":"crkKK","./properties.js":"aAzWM","./rlp-decode.js":"6iqnc","./rlp-encode.js":"XmXf7","./units.js":"4OvY2","./utf8.js":"cYEBi","./uuid.js":"85sxU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1gT7F":[function(require,module,exports) {
/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Encode %%value%% as a Base58-encoded string.
 */ parcelHelpers.export(exports, "encodeBase58", ()=>encodeBase58);
/**
 *  Decode the Base58-encoded %%value%%.
 */ parcelHelpers.export(exports, "decodeBase58", ()=>decodeBase58);
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
var _mathsJs = require("./maths.js");
const Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let Lookup = null;
function getAlpha(letter) {
    if (Lookup == null) {
        Lookup = {};
        for(let i = 0; i < Alphabet.length; i++)Lookup[Alphabet[i]] = BigInt(i);
    }
    const result = Lookup[letter];
    (0, _errorsJs.assertArgument)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const BN_0 = BigInt(0);
const BN_58 = BigInt(58);
function encodeBase58(_value) {
    const bytes = (0, _dataJs.getBytes)(_value);
    let value = (0, _mathsJs.toBigInt)(bytes);
    let result = "";
    while(value){
        result = Alphabet[Number(value % BN_58)] + result;
        value /= BN_58;
    }
    // Account for leading padding zeros
    for(let i = 0; i < bytes.length; i++){
        if (bytes[i]) break;
        result = Alphabet[0] + result;
    }
    return result;
}
function decodeBase58(value) {
    let result = BN_0;
    for(let i = 0; i < value.length; i++){
        result *= BN_58;
        result += getAlpha(value[i]);
    }
    return result;
}

},{"./data.js":"7jkig","./errors.js":"dGCHN","./maths.js":"crkKK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jkig":[function(require,module,exports) {
/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Get a typed Uint8Array for %%value%%. If already a Uint8Array
 *  the original %%value%% is returned; if a copy is required use
 *  [[getBytesCopy]].
 *
 *  @see: getBytesCopy
 */ parcelHelpers.export(exports, "getBytes", ()=>getBytes);
/**
 *  Get a typed Uint8Array for %%value%%, creating a copy if necessary
 *  to prevent any modifications of the returned value from being
 *  reflected elsewhere.
 *
 *  @see: getBytes
 */ parcelHelpers.export(exports, "getBytesCopy", ()=>getBytesCopy);
/**
 *  Returns true if %%value%% is a valid [[HexString]].
 *
 *  If %%length%% is ``true`` or a //number//, it also checks that
 *  %%value%% is a valid [[DataHexString]] of %%length%% (if a //number//)
 *  bytes of data (e.g. ``0x1234`` is 2 bytes).
 */ parcelHelpers.export(exports, "isHexString", ()=>isHexString);
/**
 *  Returns true if %%value%% is a valid representation of arbitrary
 *  data (i.e. a valid [[DataHexString]] or a Uint8Array).
 */ parcelHelpers.export(exports, "isBytesLike", ()=>isBytesLike);
/**
 *  Returns a [[DataHexString]] representation of %%data%%.
 */ parcelHelpers.export(exports, "hexlify", ()=>hexlify);
/**
 *  Returns a [[DataHexString]] by concatenating all values
 *  within %%data%%.
 */ parcelHelpers.export(exports, "concat", ()=>concat);
/**
 *  Returns the length of %%data%%, in bytes.
 */ parcelHelpers.export(exports, "dataLength", ()=>dataLength);
/**
 *  Returns a [[DataHexString]] by slicing %%data%% from the %%start%%
 *  offset to the %%end%% offset.
 *
 *  By default %%start%% is 0 and %%end%% is the length of %%data%%.
 */ parcelHelpers.export(exports, "dataSlice", ()=>dataSlice);
/**
 *  Return the [[DataHexString]] result by stripping all **leading**
 ** zero bytes from %%data%%.
 */ parcelHelpers.export(exports, "stripZerosLeft", ()=>stripZerosLeft);
/**
 *  Return the [[DataHexString]] of %%data%% padded on the **left**
 *  to %%length%% bytes.
 *
 *  If %%data%% already exceeds %%length%%, a [[BufferOverrunError]] is
 *  thrown.
 *
 *  This pads data the same as **values** are in Solidity
 *  (e.g. ``uint128``).
 */ parcelHelpers.export(exports, "zeroPadValue", ()=>zeroPadValue);
/**
 *  Return the [[DataHexString]] of %%data%% padded on the **right**
 *  to %%length%% bytes.
 *
 *  If %%data%% already exceeds %%length%%, a [[BufferOverrunError]] is
 *  thrown.
 *
 *  This pads data the same as **bytes** are in Solidity
 *  (e.g. ``bytes16``).
 */ parcelHelpers.export(exports, "zeroPadBytes", ()=>zeroPadBytes);
var _errorsJs = require("./errors.js");
function _getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, _errorsJs.assertArgument)(false, "invalid BytesLike value", name || "value", value);
}
function getBytes(value, name) {
    return _getBytes(value, name, false);
}
function getBytesCopy(value, name) {
    return _getBytes(value, name, true);
}
function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function isBytesLike(value) {
    return isHexString(value, true) || value instanceof Uint8Array;
}
const HexCharacters = "0123456789abcdef";
function hexlify(data) {
    const bytes = getBytes(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
    }
    return result;
}
function concat(datas) {
    return "0x" + datas.map((d)=>hexlify(d).substring(2)).join("");
}
function dataLength(data) {
    if (isHexString(data, true)) return (data.length - 2) / 2;
    return getBytes(data).length;
}
function dataSlice(data, start, end) {
    const bytes = getBytes(data);
    if (end != null && end > bytes.length) (0, _errorsJs.assert)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return hexlify(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function stripZerosLeft(data) {
    let bytes = hexlify(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function zeroPad(data, length, left) {
    const bytes = getBytes(data);
    (0, _errorsJs.assert)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return hexlify(result);
}
function zeroPadValue(data, length) {
    return zeroPad(data, length, true);
}
function zeroPadBytes(data, length) {
    return zeroPad(data, length, false);
}

},{"./errors.js":"dGCHN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dGCHN":[function(require,module,exports) {
/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns true if the %%error%% matches an error thrown by ethers
 *  that matches the error %%code%%.
 *
 *  In TypeScript environments, this can be used to check that %%error%%
 *  matches an EthersError type, which means the expected properties will
 *  be set.
 *
 *  @See [ErrorCodes](api:ErrorCode)
 *  @example
 *    try {
 *      // code....
 *    } catch (e) {
 *      if (isError(e, "CALL_EXCEPTION")) {
 *          // The Type Guard has validated this object
 *          console.log(e.data);
 *      }
 *    }
 */ parcelHelpers.export(exports, "isError", ()=>isError);
/**
 *  Returns true if %%error%% is a [[CallExceptionError].
 */ parcelHelpers.export(exports, "isCallException", ()=>isCallException);
/**
 *  Returns a new Error configured to the format ethers emits errors, with
 *  the %%message%%, [[api:ErrorCode]] %%code%% and additional properties
 *  for the corresponding EthersError.
 *
 *  Each error in ethers includes the version of ethers, a
 *  machine-readable [[ErrorCode]], and depending on %%code%%, additional
 *  required properties. The error message will also include the %%message%%,
 *  ethers version, %%code%% and all additional properties, serialized.
 */ parcelHelpers.export(exports, "makeError", ()=>makeError);
/**
 *  Throws an EthersError with %%message%%, %%code%% and additional error
 *  %%info%% when %%check%% is falsish..
 *
 *  @see [[api:makeError]]
 */ parcelHelpers.export(exports, "assert", ()=>assert);
/**
 *  A simple helper to simply ensuring provided arguments match expected
 *  constraints, throwing if not.
 *
 *  In TypeScript environments, the %%check%% has been asserted true, so
 *  any further code does not need additional compile-time checks.
 */ parcelHelpers.export(exports, "assertArgument", ()=>assertArgument);
parcelHelpers.export(exports, "assertArgumentCount", ()=>assertArgumentCount);
/**
 *  Throws if the normalization %%form%% is not supported.
 */ parcelHelpers.export(exports, "assertNormalize", ()=>assertNormalize);
/**
 *  Many classes use file-scoped values to guard the constructor,
 *  making it effectively private. This facilitates that pattern
 *  by ensuring the %%givenGaurd%% matches the file-scoped %%guard%%,
 *  throwing if not, indicating the %%className%% if provided.
 */ parcelHelpers.export(exports, "assertPrivate", ()=>assertPrivate);
var _versionJs = require("../_version.js");
var _propertiesJs = require("./properties.js");
function stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map(stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${stringify(k)}: ${stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function isError(error, code) {
    return error && error.code === code;
}
function isCallException(error) {
    return isError(error, "CALL_EXCEPTION");
}
function makeError(message, code, info) {
    let shortMessage = message;
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${stringify(info)}`);
            for(const key in info){
                if (key === "shortMessage") continue;
                const value = info[key];
                //                try {
                details.push(key + "=" + stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, _versionJs.version)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, _propertiesJs.defineProperties)(error, {
        code
    });
    if (info) Object.assign(error, info);
    if (error.shortMessage == null) (0, _propertiesJs.defineProperties)(error, {
        shortMessage
    });
    return error;
}
function assert(check, message, code, info) {
    if (!check) throw makeError(message, code, info);
}
function assertArgument(check, message, name, value) {
    assert(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function assertArgumentCount(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    assert(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    assert(count <= expectedCount, "too many arguments" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const _normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function assertNormalize(form) {
    assert(_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form
        }
    });
}
function assertPrivate(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        assert(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation
        });
    }
}

},{"../_version.js":"als7Q","./properties.js":"aAzWM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aAzWM":[function(require,module,exports) {
/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Resolves to a new object that is a copy of %%value%%, but with all
 *  values resolved.
 */ parcelHelpers.export(exports, "resolveProperties", ()=>resolveProperties);
/**
 *  Assigns the %%values%% to %%target%% as read-only values.
 *
 *  It %%types%% is specified, the values are checked.
 */ parcelHelpers.export(exports, "defineProperties", ()=>defineProperties);
function checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function resolveProperties(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function defineProperties(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value,
            writable: false
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"crkKK":[function(require,module,exports) {
/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Convert %%value%% from a twos-compliment representation of %%width%%
 *  bits to its value.
 *
 *  If the highest bit is ``1``, the result will be negative.
 */ parcelHelpers.export(exports, "fromTwos", ()=>fromTwos);
/**
 *  Convert %%value%% to a twos-compliment representation of
 *  %%width%% bits.
 *
 *  The result will always be positive.
 */ parcelHelpers.export(exports, "toTwos", ()=>toTwos);
/**
 *  Mask %%value%% with a bitmask of %%bits%% ones.
 */ parcelHelpers.export(exports, "mask", ()=>mask);
/**
 *  Gets a BigInt from %%value%%. If it is an invalid value for
 *  a BigInt, then an ArgumentError will be thrown for %%name%%.
 */ parcelHelpers.export(exports, "getBigInt", ()=>getBigInt);
/**
 *  Returns %%value%% as a bigint, validating it is valid as a bigint
 *  value and that it is positive.
 */ parcelHelpers.export(exports, "getUint", ()=>getUint);
/*
 * Converts %%value%% to a BigInt. If %%value%% is a Uint8Array, it
 * is treated as Big Endian data.
 */ parcelHelpers.export(exports, "toBigInt", ()=>toBigInt);
/**
 *  Gets a //number// from %%value%%. If it is an invalid value for
 *  a //number//, then an ArgumentError will be thrown for %%name%%.
 */ parcelHelpers.export(exports, "getNumber", ()=>getNumber);
/**
 *  Converts %%value%% to a number. If %%value%% is a Uint8Array, it
 *  is treated as Big Endian data. Throws if the value is not safe.
 */ parcelHelpers.export(exports, "toNumber", ()=>toNumber);
/**
 *  Converts %%value%% to a Big Endian hexstring, optionally padded to
 *  %%width%% bytes.
 */ parcelHelpers.export(exports, "toBeHex", ()=>toBeHex);
/**
 *  Converts %%value%% to a Big Endian Uint8Array.
 */ parcelHelpers.export(exports, "toBeArray", ()=>toBeArray);
/**
 *  Returns a [[HexString]] for %%value%% safe to use as a //Quantity//.
 *
 *  A //Quantity// does not have and leading 0 values unless the value is
 *  the literal value `0x0`. This is most commonly used for JSSON-RPC
 *  numeric values.
 */ parcelHelpers.export(exports, "toQuantity", ()=>toQuantity);
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
const BN_0 = BigInt(0);
const BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const maxValue = 0x1fffffffffffff;
function fromTwos(_value, _width) {
    const value = getUint(_value, "value");
    const width = BigInt(getNumber(_width, "width"));
    (0, _errorsJs.assert)(value >> width === BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - BN_1) {
        const mask = (BN_1 << width) - BN_1;
        return -((~value & mask) + BN_1);
    }
    return value;
}
function toTwos(_value, _width) {
    let value = getBigInt(_value, "value");
    const width = BigInt(getNumber(_width, "width"));
    const limit = BN_1 << width - BN_1;
    if (value < BN_0) {
        value = -value;
        (0, _errorsJs.assert)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = (BN_1 << width) - BN_1;
        return (~value & mask) + BN_1;
    } else (0, _errorsJs.assert)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function mask(_value, _bits) {
    const value = getUint(_value, "value");
    const bits = BigInt(getNumber(_bits, "bits"));
    return value & (BN_1 << bits) - BN_1;
}
function getBigInt(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, _errorsJs.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, _errorsJs.assertArgument)(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, _errorsJs.assertArgument)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, _errorsJs.assertArgument)(false, "invalid BigNumberish value", name || "value", value);
}
function getUint(value, name) {
    const result = getBigInt(value, name);
    (0, _errorsJs.assert)(result >= BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value
    });
    return result;
}
const Nibbles = "0123456789abcdef";
function toBigInt(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += Nibbles[v >> 4];
            result += Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return getBigInt(value);
}
function getNumber(value, name) {
    switch(typeof value){
        case "bigint":
            (0, _errorsJs.assertArgument)(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, _errorsJs.assertArgument)(Number.isInteger(value), "underflow", name || "value", value);
            (0, _errorsJs.assertArgument)(value >= -maxValue && value <= maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return getNumber(BigInt(value), name);
            } catch (e) {
                (0, _errorsJs.assertArgument)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, _errorsJs.assertArgument)(false, "invalid numeric value", name || "value", value);
}
function toNumber(value) {
    return getNumber(toBigInt(value));
}
function toBeHex(_value, _width) {
    const value = getUint(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = getNumber(_width, "width");
        (0, _errorsJs.assert)(width * 2 >= result.length, `value exceeds width (${width} bytes)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function toBeArray(_value) {
    const value = getUint(_value, "value");
    if (value === BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function toQuantity(value) {
    let result = (0, _dataJs.hexlify)((0, _dataJs.isBytesLike)(value) ? value : toBeArray(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}

},{"./data.js":"7jkig","./errors.js":"dGCHN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i0Tiy":[function(require,module,exports) {
// utils/base64-browser
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeBase64", ()=>decodeBase64);
parcelHelpers.export(exports, "encodeBase64", ()=>encodeBase64);
var _dataJs = require("./data.js");
function decodeBase64(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, _dataJs.getBytes)(data);
}
function encodeBase64(_data) {
    const data = (0, _dataJs.getBytes)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

},{"./data.js":"7jkig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0qzK7":[function(require,module,exports) {
/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  When an [[EventEmitterable]] triggers a [[Listener]], the
 *  callback always ahas one additional argument passed, which is
 *  an **EventPayload**.
 */ parcelHelpers.export(exports, "EventPayload", ()=>EventPayload);
var _propertiesJs = require("./properties.js");
class EventPayload {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, _propertiesJs.defineProperties)(this, {
            emitter,
            filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}

},{"./properties.js":"aAzWM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktyo1":[function(require,module,exports) {
/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction that each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retrieve the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentication, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "FetchCancelSignal", ()=>FetchCancelSignal);
/**
 *  Represents a request for a resource using a URI.
 *
 *  By default, the supported schemes are ``HTTP``, ``HTTPS``, ``data:``,
 *  and ``IPFS:``.
 *
 *  Additional schemes can be added globally using [[registerGateway]].
 *
 *  @example:
 *    req = new FetchRequest("https://www.ricmoo.com")
 *    resp = await req.send()
 *    resp.body.length
 *    //_result:
 */ parcelHelpers.export(exports, "FetchRequest", ()=>FetchRequest);
/**
 *  The response for a FetchRequest.
 */ parcelHelpers.export(exports, "FetchResponse", ()=>FetchResponse);
var _base64Js = require("./base64.js");
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
var _propertiesJs = require("./properties.js");
var _utf8Js = require("./utf8.js");
var _geturlJs = require("./geturl.js");
const MAX_ATTEMPTS = 12;
const SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let defaultGetUrlFunc = (0, _geturlJs.createGetUrl)();
const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function dataGatewayFunc(url, signal) {
    try {
        const match = url.match(reData);
        if (!match) throw new Error("invalid data");
        return new FetchResponse(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, _base64Js.decodeBase64)(match[3]) : unpercent(match[3]));
    } catch (error) {
        return new FetchResponse(599, "BAD REQUEST (invalid data: URI)", {}, null, new FetchRequest(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match(reIpfs);
            if (!match) throw new Error("invalid link");
            return new FetchRequest(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new FetchResponse(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new FetchRequest(url));
        }
    }
    return gatewayIpfs;
}
const Gateways = {
    "data": dataGatewayFunc,
    "ipfs": getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const fetchSignals = new WeakMap();
class FetchCancelSignal {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, _errorsJs.assert)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, _errorsJs.assert)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class FetchRequest {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    #getUrlFunc;
    /**
     *  The fetch URL to request.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``).
     *
     *  If %%body%% is a string, the intrinsic ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrinsic ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrinsic ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, _utf8Js.toUtf8Bytes)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, _utf8Js.toUtf8Bytes)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any changes will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, _base64Js.encodeBase64)((0, _utf8Js.toUtf8Bytes)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, _errorsJs.assertArgument)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complete response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, _errorsJs.assertArgument)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  This function is called to fetch content from HTTP and
     *  HTTPS URLs and is platform specific (e.g. nodejs vs
     *  browsers).
     *
     *  This is by default the currently registered global getUrl
     *  function, which can be changed using [[registerGetUrl]].
     *  If this has been set, setting is to ``null`` will cause
     *  this FetchRequest (and any future clones) to revert back to
     *  using the currently registered global getUrl function.
     *
     *  Setting this is generally not necessary, but may be useful
     *  for developers that wish to intercept requests or to
     *  configurege a proxy or other agent.
     */ get getUrlFunc() {
        return this.#getUrlFunc || defaultGetUrlFunc;
    }
    set getUrlFunc(value) {
        this.#getUrlFunc = value;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: SLOT_INTERVAL,
            maxAttempts: MAX_ATTEMPTS
        };
        this.#getUrlFunc = null;
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, _dataJs.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, _errorsJs.assert)(getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in Gateways) {
            const result = await Gateways[scheme](req.url, checkSignal(_request.#signal));
            if (result instanceof FetchResponse) {
                let response = result;
                if (this.processFunc) {
                    checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await this.getUrlFunc(req, checkSignal(_request.#signal));
        let response = new FetchResponse(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, _errorsJs.assert)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new FetchCancelSignal(this);
        return this.#send(0, getTime() + this.timeout, 0, this, new FetchResponse(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, _errorsJs.assert)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locations
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, _errorsJs.assert)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new FetchRequest(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new FetchRequest(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        clone.#getUrlFunc = this.#getUrlFunc;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if (locked) throw new Error("gateways locked");
        Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if (locked) throw new Error("gateways locked");
        defaultGetUrlFunc = getUrl;
    }
    /**
     *  Creates a getUrl function that fetches content from HTTP and
     *  HTTPS URLs.
     *
     *  The available %%options%% are dependent on the platform
     *  implementation of the default getUrl function.
     *
     *  This is not generally something that is needed, but is useful
     *  when trying to customize simple behaviour when fetching HTTP
     *  content.
     */ static createGetUrlFunc(options) {
        return (0, _geturlJs.createGetUrl)(options);
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return getIpfsGatewayFunc(baseUrl);
    }
}
class FetchResponse {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, _dataJs.hexlify)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, _utf8Js.toUtf8String)(this.#body);
        } catch (error) {
            (0, _errorsJs.assert)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, _errorsJs.assert)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new FetchResponse(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message,
            error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, _errorsJs.assertArgument)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, _propertiesJs.defineProperties)(error, {
            stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true if the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message, error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        let requestUrl = null;
        if (this.request) requestUrl = this.request.url;
        let responseBody = null;
        try {
            if (this.#body) responseBody = (0, _utf8Js.toUtf8String)(this.#body);
        } catch (e) {}
        (0, _errorsJs.assert)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error,
            info: {
                requestUrl,
                responseBody,
                responseStatus: `${this.statusCode} ${this.statusMessage}`
            }
        });
    }
}
function getTime() {
    return new Date().getTime();
}
function unpercent(value) {
    return (0, _utf8Js.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}

},{"./base64.js":"i0Tiy","./data.js":"7jkig","./errors.js":"dGCHN","./properties.js":"aAzWM","./utf8.js":"cYEBi","./geturl.js":"9rHEP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cYEBi":[function(require,module,exports) {
/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Utf8ErrorFuncs", ()=>Utf8ErrorFuncs);
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
/**
 *  Returns the UTF-8 byte representation of %%str%%.
 *
 *  If %%form%% is specified, the string is normalized.
 */ parcelHelpers.export(exports, "toUtf8Bytes", ()=>toUtf8Bytes);
/**
 *  Returns the string represented by the UTF-8 data %%bytes%%.
 *
 *  When %%onError%% function is specified, it is called on UTF-8
 *  errors allowing recovery using the [[Utf8ErrorFunc]] API.
 *  (default: [error](Utf8ErrorFuncs))
 */ parcelHelpers.export(exports, "toUtf8String", ()=>toUtf8String);
/**
 *  Returns the UTF-8 code-points for %%str%%.
 *
 *  If %%form%% is specified, the string is normalized.
 */ parcelHelpers.export(exports, "toUtf8CodePoints", ()=>toUtf8CodePoints);
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
function errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, _errorsJs.assertArgument)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, _errorsJs.assertArgument)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const Utf8ErrorFuncs = Object.freeze({
    error: errorFunc,
    ignore: ignoreFunc,
    replace: replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = Utf8ErrorFuncs.error;
    const bytes = (0, _dataJs.getBytes)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function toUtf8Bytes(str, form) {
    (0, _errorsJs.assertArgument)(typeof str === "string", "invalid string value", "str", str);
    if (form != null) {
        (0, _errorsJs.assertNormalize)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, _errorsJs.assertArgument)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function _toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function toUtf8String(bytes, onError) {
    return _toUtf8String(getUtf8CodePoints(bytes, onError));
}
function toUtf8CodePoints(str, form) {
    return getUtf8CodePoints(toUtf8Bytes(str, form));
}

},{"./data.js":"7jkig","./errors.js":"dGCHN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9rHEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @TODO: timeout is completely ignored; start a Promise.any with a reject?
parcelHelpers.export(exports, "createGetUrl", ()=>createGetUrl);
parcelHelpers.export(exports, "getUrl", ()=>getUrl);
var _errorsJs = require("./errors.js");
function createGetUrl(options) {
    async function getUrl(req, _signal) {
        const protocol = req.url.split(":")[0].toLowerCase();
        (0, _errorsJs.assert)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
            info: {
                protocol
            },
            operation: "request"
        });
        (0, _errorsJs.assert)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
            operation: "request"
        });
        let signal = undefined;
        if (_signal) {
            const controller = new AbortController();
            signal = controller.signal;
            _signal.addListener(()=>{
                controller.abort();
            });
        }
        const init = {
            method: req.method,
            headers: new Headers(Array.from(req)),
            body: req.body || undefined,
            signal
        };
        const resp = await fetch(req.url, init);
        const headers = {};
        resp.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        const respBody = await resp.arrayBuffer();
        const body = respBody == null ? null : new Uint8Array(respBody);
        return {
            statusCode: resp.status,
            statusMessage: resp.statusText,
            headers,
            body
        };
    }
    return getUrl;
}
// @TODO: remove in v7; provided for backwards compat
const defaultGetUrl = createGetUrl({});
async function getUrl(req, _signal) {
    return defaultGetUrl(req, _signal);
}

},{"./errors.js":"dGCHN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCAWe":[function(require,module,exports) {
/**
 *  The **FixedNumber** class permits using values with decimal places,
 *  using fixed-pont math.
 *
 *  Fixed-point math is still based on integers under-the-hood, but uses an
 *  internal offset to store fractional components below, and each operation
 *  corrects for this after each operation.
 *
 *  @_section: api/utils/fixed-point-math:Fixed-Point Maths  [about-fixed-point-math]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A FixedNumber represents a value over its [[FixedFormat]]
 *  arithmetic field.
 *
 *  A FixedNumber can be used to perform math, losslessly, on
 *  values which have decmial places.
 *
 *  A FixedNumber has a fixed bit-width to store values in, and stores all
 *  values internally by multiplying the value by 10 raised to the power of
 *  %%decimals%%.
 *
 *  If operations are performed that cause a value to grow too high (close to
 *  positive infinity) or too low (close to negative infinity), the value
 *  is said to //overflow//.
 *
 *  For example, an 8-bit signed value, with 0 decimals may only be within
 *  the range ``-128`` to ``127``; so ``-128 - 1`` will overflow and become
 *  ``127``. Likewise, ``127 + 1`` will overflow and become ``-127``.
 *
 *  Many operation have a normal and //unsafe// variant. The normal variant
 *  will throw a [[NumericFaultError]] on any overflow, while the //unsafe//
 *  variant will silently allow overflow, corrupting its value value.
 *
 *  If operations are performed that cause a value to become too small
 *  (close to zero), the value loses precison and is said to //underflow//.
 *
 *  For example, an value with 1 decimal place may store a number as small
 *  as ``0.1``, but the value of ``0.1 / 2`` is ``0.05``, which cannot fit
 *  into 1 decimal place, so underflow occurs which means precision is lost
 *  and the value becomes ``0``.
 *
 *  Some operations have a normal and //signalling// variant. The normal
 *  variant will silently ignore underflow, while the //signalling// variant
 *  will thow a [[NumericFaultError]] on underflow.
 */ parcelHelpers.export(exports, "FixedNumber", ()=>FixedNumber) //const f1 = FixedNumber.fromString("12.56", "fixed16x2");
 //const f2 = FixedNumber.fromString("0.3", "fixed16x2");
 //console.log(f1.divSignal(f2));
 //const BUMP = FixedNumber.from("0.5");
;
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
var _mathsJs = require("./maths.js");
var _propertiesJs = require("./properties.js");
const BN_N1 = BigInt(-1);
const BN_0 = BigInt(0);
const BN_1 = BigInt(1);
const BN_5 = BigInt(5);
const _guard = {};
// Constant to pull zeros from for multipliers
let Zeros = "0000";
while(Zeros.length < 80)Zeros += Zeros;
// Returns a string "1" followed by decimal "0"s
function getTens(decimals) {
    let result = Zeros;
    while(result.length < decimals)result += result;
    return BigInt("1" + result.substring(0, decimals));
}
function checkValue(val, format, safeOp) {
    const width = BigInt(format.width);
    if (format.signed) {
        const limit = BN_1 << width - BN_1;
        (0, _errorsJs.assert)(safeOp == null || val >= -limit && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        if (val > BN_0) val = (0, _mathsJs.fromTwos)((0, _mathsJs.mask)(val, width), width);
        else val = -(0, _mathsJs.fromTwos)((0, _mathsJs.mask)(-val, width), width);
    } else {
        const limit = BN_1 << width;
        (0, _errorsJs.assert)(safeOp == null || val >= 0 && val < limit, "overflow", "NUMERIC_FAULT", {
            operation: safeOp,
            fault: "overflow",
            value: val
        });
        val = (val % limit + limit) % limit & limit - BN_1;
    }
    return val;
}
function getFormat(value) {
    if (typeof value === "number") value = `fixed128x${value}`;
    let signed = true;
    let width = 128;
    let decimals = 18;
    if (typeof value === "string") {
        // Parse the format string
        if (value === "fixed") ;
        else if (value === "ufixed") signed = false;
        else {
            const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
            (0, _errorsJs.assertArgument)(match, "invalid fixed format", "format", value);
            signed = match[1] !== "u";
            width = parseInt(match[2]);
            decimals = parseInt(match[3]);
        }
    } else if (value) {
        // Extract the values from the object
        const v = value;
        const check = (key, type, defaultValue)=>{
            if (v[key] == null) return defaultValue;
            (0, _errorsJs.assertArgument)(typeof v[key] === type, "invalid fixed format (" + key + " not " + type + ")", "format." + key, v[key]);
            return v[key];
        };
        signed = check("signed", "boolean", signed);
        width = check("width", "number", width);
        decimals = check("decimals", "number", decimals);
    }
    (0, _errorsJs.assertArgument)(width % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", width);
    (0, _errorsJs.assertArgument)(decimals <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", decimals);
    const name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
    return {
        signed,
        width,
        decimals,
        name
    };
}
function toString(val, decimals) {
    let negative = "";
    if (val < BN_0) {
        negative = "-";
        val *= BN_N1;
    }
    let str = val.toString();
    // No decimal point for whole values
    if (decimals === 0) return negative + str;
    // Pad out to the whole component (including a whole digit)
    while(str.length <= decimals)str = Zeros + str;
    // Insert the decimal point
    const index = str.length - decimals;
    str = str.substring(0, index) + "." + str.substring(index);
    // Trim the whole component (leaving at least one 0)
    while(str[0] === "0" && str[1] !== ".")str = str.substring(1);
    // Trim the decimal component (leaving at least one 0)
    while(str[str.length - 1] === "0" && str[str.length - 2] !== ".")str = str.substring(0, str.length - 1);
    return negative + str;
}
class FixedNumber {
    /**
     *  The specific fixed-point arithmetic field for this value.
     */ format;
    #format;
    // The actual value (accounting for decimals)
    #val;
    // A base-10 value to multiple values by to maintain the magnitude
    #tens;
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */ _value;
    // Use this when changing this file to get some typing info,
    // but then switch to any to mask the internal type
    //constructor(guard: any, value: bigint, format: _FixedFormat) {
    /**
     *  @private
     */ constructor(guard, value, format){
        (0, _errorsJs.assertPrivate)(guard, _guard, "FixedNumber");
        this.#val = value;
        this.#format = format;
        const _value = toString(value, format.decimals);
        (0, _propertiesJs.defineProperties)(this, {
            format: format.name,
            _value
        });
        this.#tens = getTens(format.decimals);
    }
    /**
     *  If true, negative values are permitted, otherwise only
     *  positive values and zero are allowed.
     */ get signed() {
        return this.#format.signed;
    }
    /**
     *  The number of bits available to store the value.
     */ get width() {
        return this.#format.width;
    }
    /**
     *  The number of decimal places in the fixed-point arithment field.
     */ get decimals() {
        return this.#format.decimals;
    }
    /**
     *  The value as an integer, based on the smallest unit the
     *  [[decimals]] allow.
     */ get value() {
        return this.#val;
    }
    #checkFormat(other) {
        (0, _errorsJs.assertArgument)(this.format === other.format, "incompatible format; use fixedNumber.toFormat", "other", other);
    }
    #checkValue(val, safeOp) {
        /*
                const width = BigInt(this.width);
                if (this.signed) {
                    const limit = (BN_1 << (width - BN_1));
                    assert(safeOp == null || (val >= -limit  && val < limit), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
        
                    if (val > BN_0) {
                        val = fromTwos(mask(val, width), width);
                    } else {
                        val = -fromTwos(mask(-val, width), width);
                    }
        
                } else {
                    const masked = mask(val, width);
                    assert(safeOp == null || (val >= 0 && val === masked), "overflow", "NUMERIC_FAULT", {
                        operation: <string>safeOp, fault: "overflow", value: val
                    });
                    val = masked;
                }
        */ val = checkValue(val, this.#format, safeOp);
        return new FixedNumber(_guard, val, this.#format);
    }
    #add(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val + o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%, ignoring overflow.
     */ addUnsafe(other) {
        return this.#add(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% added
     *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ add(other) {
        return this.#add(other, "add");
    }
    #sub(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val - o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%, ignoring overflow.
     */ subUnsafe(other) {
        return this.#sub(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
     *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ sub(other) {
        return this.#sub(other, "sub");
    }
    #mul(o, safeOp) {
        this.#checkFormat(o);
        return this.#checkValue(this.#val * o.#val / this.#tens, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%, ignoring overflow and underflow (precision loss).
     */ mulUnsafe(other) {
        return this.#mul(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs.
     */ mul(other) {
        return this.#mul(other, "mul");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
     *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
     *  occurs or if underflow (precision loss) occurs.
     */ mulSignal(other) {
        this.#checkFormat(other);
        const value = this.#val * other.#val;
        (0, _errorsJs.assert)(value % this.#tens === BN_0, "precision lost during signalling mul", "NUMERIC_FAULT", {
            operation: "mulSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / this.#tens, "mulSignal");
    }
    #div(o, safeOp) {
        (0, _errorsJs.assert)(o.#val !== BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(o);
        return this.#checkValue(this.#val * this.#tens / o.#val, safeOp);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ divUnsafe(other) {
        return this.#div(other);
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%, ignoring underflow (precision loss). A
     *  [[NumericFaultError]] is thrown if overflow occurs.
     */ div(other) {
        return this.#div(other, "div");
    }
    /**
     *  Returns a new [[FixedNumber]] with the result of %%this%% divided
     *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
     *  (precision loss) occurs.
     */ divSignal(other) {
        (0, _errorsJs.assert)(other.#val !== BN_0, "division by zero", "NUMERIC_FAULT", {
            operation: "div",
            fault: "divide-by-zero",
            value: this
        });
        this.#checkFormat(other);
        const value = this.#val * this.#tens;
        (0, _errorsJs.assert)(value % other.#val === BN_0, "precision lost during signalling div", "NUMERIC_FAULT", {
            operation: "divSignal",
            fault: "underflow",
            value: this
        });
        return this.#checkValue(value / other.#val, "divSignal");
    }
    /**
     *  Returns a comparison result between %%this%% and %%other%%.
     *
     *  This is suitable for use in sorting, where ``-1`` implies %%this%%
     *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
     *  both are equal.
     */ cmp(other) {
        let a = this.value, b = other.value;
        // Coerce a and b to the same magnitude
        const delta = this.decimals - other.decimals;
        if (delta > 0) b *= getTens(delta);
        else if (delta < 0) a *= getTens(-delta);
        // Comnpare
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    }
    /**
     *  Returns true if %%other%% is equal to %%this%%.
     */ eq(other) {
        return this.cmp(other) === 0;
    }
    /**
     *  Returns true if %%other%% is less than to %%this%%.
     */ lt(other) {
        return this.cmp(other) < 0;
    }
    /**
     *  Returns true if %%other%% is less than or equal to %%this%%.
     */ lte(other) {
        return this.cmp(other) <= 0;
    }
    /**
     *  Returns true if %%other%% is greater than to %%this%%.
     */ gt(other) {
        return this.cmp(other) > 0;
    }
    /**
     *  Returns true if %%other%% is greater than or equal to %%this%%.
     */ gte(other) {
        return this.cmp(other) >= 0;
    }
    /**
     *  Returns a new [[FixedNumber]] which is the largest **integer**
     *  that is less than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ floor() {
        let val = this.#val;
        if (this.#val < BN_0) val -= this.#tens - BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "floor");
    }
    /**
     *  Returns a new [[FixedNumber]] which is the smallest **integer**
     *  that is greater than or equal to %%this%%.
     *
     *  The decimal component of the result will always be ``0``.
     */ ceiling() {
        let val = this.#val;
        if (this.#val > BN_0) val += this.#tens - BN_1;
        val = this.#val / this.#tens * this.#tens;
        return this.#checkValue(val, "ceiling");
    }
    /**
     *  Returns a new [[FixedNumber]] with the decimal component
     *  rounded up on ties at %%decimals%% places.
     */ round(decimals) {
        if (decimals == null) decimals = 0;
        // Not enough precision to not already be rounded
        if (decimals >= this.decimals) return this;
        const delta = this.decimals - decimals;
        const bump = BN_5 * getTens(delta - 1);
        let value = this.value + bump;
        const tens = getTens(delta);
        value = value / tens * tens;
        checkValue(value, this.#format, "round");
        return new FixedNumber(_guard, value, this.#format);
    }
    /**
     *  Returns true if %%this%% is equal to ``0``.
     */ isZero() {
        return this.#val === BN_0;
    }
    /**
     *  Returns true if %%this%% is less than ``0``.
     */ isNegative() {
        return this.#val < BN_0;
    }
    /**
     *  Returns the string representation of %%this%%.
     */ toString() {
        return this._value;
    }
    /**
     *  Returns a float approximation.
     *
     *  Due to IEEE 754 precission (or lack thereof), this function
     *  can only return an approximation and most values will contain
     *  rounding errors.
     */ toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    /**
     *  Return a new [[FixedNumber]] with the same value but has had
     *  its field set to %%format%%.
     *
     *  This will throw if the value cannot fit into %%format%%.
     */ toFormat(format) {
        return FixedNumber.fromString(this.toString(), format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% divided by
     *  %%decimal%% places with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
     *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
     *  or underflow (precision loss).
     */ static fromValue(_value, _decimals, _format) {
        const decimals = _decimals == null ? 0 : (0, _mathsJs.getNumber)(_decimals);
        const format = getFormat(_format);
        let value = (0, _mathsJs.getBigInt)(_value, "value");
        const delta = decimals - format.decimals;
        if (delta > 0) {
            const tens = getTens(delta);
            (0, _errorsJs.assert)(value % tens === BN_0, "value loses precision for format", "NUMERIC_FAULT", {
                operation: "fromValue",
                fault: "underflow",
                value: _value
            });
            value /= tens;
        } else if (delta < 0) value *= getTens(-delta);
        checkValue(value, format, "fromValue");
        return new FixedNumber(_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%%, either due to overflow or underflow (precision loss).
     */ static fromString(_value, _format) {
        const match = _value.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
        (0, _errorsJs.assertArgument)(match && match[2].length + match[3].length > 0, "invalid FixedNumber string value", "value", _value);
        const format = getFormat(_format);
        let whole = match[2] || "0", decimal = match[3] || "";
        // Pad out the decimals
        while(decimal.length < format.decimals)decimal += Zeros;
        // Check precision is safe
        (0, _errorsJs.assert)(decimal.substring(format.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
            operation: "fromString",
            fault: "underflow",
            value: _value
        });
        // Remove extra padding
        decimal = decimal.substring(0, format.decimals);
        const value = BigInt(match[1] + whole + decimal);
        checkValue(value, format, "fromString");
        return new FixedNumber(_guard, value, format);
    }
    /**
     *  Creates a new [[FixedNumber]] with the big-endian representation
     *  %%value%% with %%format%%.
     *
     *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
     *  in %%format%% due to overflow.
     */ static fromBytes(_value, _format) {
        let value = (0, _mathsJs.toBigInt)((0, _dataJs.getBytes)(_value, "value"));
        const format = getFormat(_format);
        if (format.signed) value = (0, _mathsJs.fromTwos)(value, format.width);
        checkValue(value, format, "fromBytes");
        return new FixedNumber(_guard, value, format);
    }
}

},{"./data.js":"7jkig","./errors.js":"dGCHN","./maths.js":"crkKK","./properties.js":"aAzWM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6iqnc":[function(require,module,exports) {
//See: https://github.com/ethereum/wiki/wiki/RLP
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Decodes %%data%% into the structured data it represents.
 */ parcelHelpers.export(exports, "decodeRlp", ()=>decodeRlp);
var _dataJs = require("./data.js");
var _errorsJs = require("./errors.js");
function hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function _decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, _errorsJs.assert)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length,
            offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    (0, _errorsJs.assert)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, _errorsJs.assert)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return _decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, _dataJs.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, _dataJs.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: hexlifyByte(data[offset])
    };
}
function decodeRlp(_data) {
    const data = (0, _dataJs.getBytes)(_data, "data");
    const decoded = _decode(data, 0);
    (0, _errorsJs.assertArgument)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

},{"./data.js":"7jkig","./errors.js":"dGCHN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"XmXf7":[function(require,module,exports) {
//See: https://github.com/ethereum/wiki/wiki/RLP
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Encodes %%object%% as an RLP-encoded [[DataHexString]].
 */ parcelHelpers.export(exports, "encodeRlp", ()=>encodeRlp);
var _dataJs = require("./data.js");
function arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, _dataJs.getBytes)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const nibbles = "0123456789abcdef";
function encodeRlp(object) {
    let result = "0x";
    for (const v of _encode(object)){
        result += nibbles[v >> 4];
        result += nibbles[v & 0xf];
    }
    return result;
}

},{"./data.js":"7jkig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4OvY2":[function(require,module,exports) {
/**
 *  Most interactions with Ethereum requires integer values, which use
 *  the smallest magnitude unit.
 *
 *  For example, imagine dealing with dollars and cents. Since dollars
 *  are divisible, non-integer values are possible, such as ``$10.77``.
 *  By using the smallest indivisible unit (i.e. cents), the value can
 *  be kept as the integer ``1077``.
 *
 *  When receiving decimal input from the user (as a decimal string),
 *  the value should be converted to an integer and when showing a user
 *  a value, the integer value should be converted to a decimal string.
 *
 *  This creates a clear distinction, between values to be used by code
 *  (integers) and values used for display logic to users (decimals).
 *
 *  The native unit in Ethereum, //ether// is divisible to 18 decimal places,
 *  where each individual unit is called a //wei//.
 *
 *  @_subsection api/utils:Unit Conversion  [about-units]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Converts %%value%% into a //decimal string//, assuming %%unit%% decimal
 *  places. The %%unit%% may be the number of decimal places or the name of
 *  a unit (e.g. ``"gwei"`` for 9 decimal places).
 *
 */ parcelHelpers.export(exports, "formatUnits", ()=>formatUnits);
/**
 *  Converts the //decimal string// %%value%% to a BigInt, assuming
 *  %%unit%% decimal places. The %%unit%% may the number of decimal places
 *  or the name of a unit (e.g. ``"gwei"`` for 9 decimal places).
 */ parcelHelpers.export(exports, "parseUnits", ()=>parseUnits);
/**
 *  Converts %%value%% into a //decimal string// using 18 decimal places.
 */ parcelHelpers.export(exports, "formatEther", ()=>formatEther);
/**
 *  Converts the //decimal string// %%ether%% to a BigInt, using 18
 *  decimal places.
 */ parcelHelpers.export(exports, "parseEther", ()=>parseEther);
var _errorsJs = require("./errors.js");
var _fixednumberJs = require("./fixednumber.js");
var _mathsJs = require("./maths.js");
const names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function formatUnits(value, unit) {
    let decimals = 18;
    if (typeof unit === "string") {
        const index = names.indexOf(unit);
        (0, _errorsJs.assertArgument)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, _mathsJs.getNumber)(unit, "unit");
    return (0, _fixednumberJs.FixedNumber).fromValue(value, decimals, {
        decimals,
        width: 512
    }).toString();
}
function parseUnits(value, unit) {
    (0, _errorsJs.assertArgument)(typeof value === "string", "value must be a string", "value", value);
    let decimals = 18;
    if (typeof unit === "string") {
        const index = names.indexOf(unit);
        (0, _errorsJs.assertArgument)(index >= 0, "invalid unit", "unit", unit);
        decimals = 3 * index;
    } else if (unit != null) decimals = (0, _mathsJs.getNumber)(unit, "unit");
    return (0, _fixednumberJs.FixedNumber).fromString(value, {
        decimals,
        width: 512
    }).value;
}
function formatEther(wei) {
    return formatUnits(wei, 18);
}
function parseEther(ether) {
    return parseUnits(ether, 18);
}

},{"./errors.js":"dGCHN","./fixednumber.js":"iCAWe","./maths.js":"crkKK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"85sxU":[function(require,module,exports) {
/**
 *  Explain UUID and link to RFC here.
 *
 *  @_subsection: api/utils:UUID  [about-uuid]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns the version 4 [[link-uuid]] for the %%randomBytes%%.
 *
 *  @see: https://www.ietf.org/rfc/rfc4122.txt (Section 4.4)
 */ parcelHelpers.export(exports, "uuidV4", ()=>uuidV4);
var _dataJs = require("./data.js");
function uuidV4(randomBytes) {
    const bytes = (0, _dataJs.getBytes)(randomBytes, "randomBytes");
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, _dataJs.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

},{"./data.js":"7jkig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGfOx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WordSize", ()=>WordSize);
/**
 *  A [[Result]] is a sub-class of Array, which allows accessing any
 *  of its values either positionally by its index or, if keys are
 *  provided by its name.
 *
 *  @_docloc: api/abi
 */ parcelHelpers.export(exports, "Result", ()=>Result);
/**
 *  Returns all errors found in a [[Result]].
 *
 *  Since certain errors encountered when creating a [[Result]] do
 *  not impact the ability to continue parsing data, they are
 *  deferred until they are actually accessed. Hence a faulty string
 *  in an Event that is never used does not impact the program flow.
 *
 *  However, sometimes it may be useful to access, identify or
 *  validate correctness of a [[Result]].
 *
 *  @_docloc api/abi
 */ parcelHelpers.export(exports, "checkResultErrors", ()=>checkResultErrors);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "Coder", ()=>Coder);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "Writer", ()=>Writer);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "Reader", ()=>Reader);
var _indexJs = require("../../utils/index.js");
const WordSize = 32;
const Padding = new Uint8Array(WordSize);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const passProperties = [
    "then"
];
const _guard = {};
function throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
class Result extends Array {
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== _guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        this.#names = Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        }));
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, _indexJs.getNumber)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if (passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    /**
     *  Returns the Result as a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray() {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) throwError(`index ${index}`, item);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject() {
        return this.#names.reduce((accum, name, index)=>{
            (0, _indexJs.assert)(name != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            // Add values for names that don't conflict
            if (!(name in accum)) accum[name] = this.getValue(name);
            return accum;
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(this.#names[i]);
        }
        return new Result(_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(this.#names[i]);
            }
        }
        return new Result(_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = this.#names.indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new Result(_guard, items, keys);
    }
}
function checkResultErrors(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function getValue(value) {
    let bytes = (0, _indexJs.toBeArray)(value);
    (0, _indexJs.assert)(bytes.length <= WordSize, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: WordSize,
        offset: bytes.length
    });
    if (bytes.length !== WordSize) bytes = (0, _indexJs.getBytesCopy)((0, _indexJs.concat)([
        Padding.slice(bytes.length % WordSize),
        bytes
    ]));
    return bytes;
}
class Coder {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, _indexJs.defineProperties)(this, {
            name,
            type,
            localName,
            dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, _indexJs.assertArgument)(false, message, this.localName, value);
    }
}
class Writer {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, _indexJs.concat)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, _indexJs.getBytesCopy)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, _indexJs.getBytesCopy)(value);
        const paddingOffset = bytes.length % WordSize;
        if (paddingOffset) bytes = (0, _indexJs.getBytesCopy)((0, _indexJs.concat)([
            bytes,
            Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData(getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push(Padding);
        this.#dataLength += WordSize;
        return (value)=>{
            this.#data[offset] = getValue(value);
        };
    }
}
class Reader {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    #bytesRead;
    #parent;
    #maxInflation;
    constructor(data, allowLoose, maxInflation){
        (0, _indexJs.defineProperties)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, _indexJs.getBytesCopy)(data);
        this.#bytesRead = 0;
        this.#parent = null;
        this.#maxInflation = maxInflation != null ? maxInflation : 1024;
        this.#offset = 0;
    }
    get data() {
        return (0, _indexJs.hexlify)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #incrementBytesRead(count) {
        if (this.#parent) return this.#parent.#incrementBytesRead(count);
        this.#bytesRead += count;
        // Check for excessive inflation (see: #4537)
        (0, _indexJs.assert)(this.#maxInflation < 1 || this.#bytesRead <= this.#maxInflation * this.dataLength, `compressed ABI data exceeds inflation ratio of ${this.#maxInflation} ( see: https:/\/github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
            buffer: (0, _indexJs.getBytesCopy)(this.#data),
            offset: this.#offset,
            length: count,
            info: {
                bytesRead: this.#bytesRead,
                dataLength: this.dataLength
            }
        });
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / WordSize) * WordSize;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, _indexJs.assert)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, _indexJs.getBytesCopy)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        const reader = new Reader(this.#data.slice(this.#offset + offset), this.allowLoose, this.#maxInflation);
        reader.#parent = this;
        return reader;
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#incrementBytesRead(length);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, _indexJs.toBigInt)(this.readBytes(WordSize));
    }
    readIndex() {
        return (0, _indexJs.toNumber)(this.readBytes(WordSize));
    }
}

},{"../../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BgEn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "AddressCoder", ()=>AddressCoder);
var _indexJs = require("../../address/index.js");
var _mathsJs = require("../../utils/maths.js");
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
class AddressCoder extends (0, _abstractCoderJs.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, _typedJs.Typed).dereference(_value, "string");
        try {
            value = (0, _indexJs.getAddress)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, _indexJs.getAddress)((0, _mathsJs.toBeHex)(reader.readValue(), 20));
    }
}

},{"../../address/index.js":"3THmk","../../utils/maths.js":"crkKK","../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3THmk":[function(require,module,exports) {
/**
 *  Addresses are a fundamental part of interacting with Ethereum. They
 *  represent the gloabal identity of Externally Owned Accounts (accounts
 *  backed by a private key) and contracts.
 *
 *  The Ethereum Naming Service (ENS) provides an interconnected ecosystem
 *  of contracts, standards and libraries which enable looking up an
 *  address for an ENS name.
 *
 *  These functions help convert between various formats, validate
 *  addresses and safely resolve ENS names.
 *
 *  @_section: api/address:Addresses  [about-addresses]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAddress", ()=>(0, _addressJs.getAddress));
parcelHelpers.export(exports, "getIcapAddress", ()=>(0, _addressJs.getIcapAddress));
parcelHelpers.export(exports, "getCreateAddress", ()=>(0, _contractAddressJs.getCreateAddress));
parcelHelpers.export(exports, "getCreate2Address", ()=>(0, _contractAddressJs.getCreate2Address));
parcelHelpers.export(exports, "isAddressable", ()=>(0, _checksJs.isAddressable));
parcelHelpers.export(exports, "isAddress", ()=>(0, _checksJs.isAddress));
parcelHelpers.export(exports, "resolveAddress", ()=>(0, _checksJs.resolveAddress));
var _addressJs = require("./address.js");
var _contractAddressJs = require("./contract-address.js");
var _checksJs = require("./checks.js");

},{"./address.js":"42Zfe","./contract-address.js":"i98X1","./checks.js":"9cyEY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"42Zfe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns a normalized and checksumed address for %%address%%.
 *  This accepts non-checksum addresses, checksum addresses and
 *  [[getIcapAddress]] formats.
 *
 *  The checksum in Ethereum uses the capitalization (upper-case
 *  vs lower-case) of the characters within an address to encode
 *  its checksum, which offers, on average, a checksum of 15-bits.
 *
 *  If %%address%% contains both upper-case and lower-case, it is
 *  assumed to already be a checksum address and its checksum is
 *  validated, and if the address fails its expected checksum an
 *  error is thrown.
 *
 *  If you wish the checksum of %%address%% to be ignore, it should
 *  be converted to lower-case (i.e. ``.toLowercase()``) before
 *  being passed in. This should be a very rare situation though,
 *  that you wish to bypass the safegaurds in place to protect
 *  against an address that has been incorrectly copied from another
 *  source.
 *
 *  @example:
 *    // Adds the checksum (via upper-casing specific letters)
 *    getAddress("0x8ba1f109551bd432803012645ac136ddd64dba72")
 *    //_result:
 *
 *    // Converts ICAP address and adds checksum
 *    getAddress("XE65GB6LDNXYOFTX0NSV3FUWKOWIXAMJK36");
 *    //_result:
 *
 *    // Throws an error if an address contains mixed case,
 *    // but the checksum fails
 *    getAddress("0x8Ba1f109551bD432803012645Ac136ddd64DBA72")
 *    //_error:
 */ parcelHelpers.export(exports, "getAddress", ()=>getAddress);
/**
 *  The [ICAP Address format](link-icap) format is an early checksum
 *  format which attempts to be compatible with the banking
 *  industry [IBAN format](link-wiki-iban) for bank accounts.
 *
 *  It is no longer common or a recommended format.
 *
 *  @example:
 *    getIcapAddress("0x8ba1f109551bd432803012645ac136ddd64dba72");
 *    //_result:
 *
 *    getIcapAddress("XE65GB6LDNXYOFTX0NSV3FUWKOWIXAMJK36");
 *    //_result:
 *
 *    // Throws an error if the ICAP checksum is wrong
 *    getIcapAddress("XE65GB6LDNXYOFTX0NSV3FUWKOWIXAMJK37");
 *    //_error:
 */ parcelHelpers.export(exports, "getIcapAddress", ()=>getIcapAddress);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
const BN_0 = BigInt(0);
const BN_36 = BigInt(36);
function getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, _indexJs1.getBytes)((0, _indexJs.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup = {};
for(let i = 0; i < 10; i++)ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const safeDigits = 15;
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= safeDigits){
        let block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function fromBase36(value) {
    value = value.toLowerCase();
    let result = BN_0;
    for(let i = 0; i < value.length; i++)result = result * BN_36 + Base36[value[i]];
    return result;
}
function getAddress(address) {
    (0, _indexJs1.assertArgument)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, _indexJs1.assertArgument)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, _indexJs1.assertArgument)(address.substring(2, 4) === ibanChecksum(address), "bad icap checksum", "address", address);
        let result = fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return getChecksumAddress("0x" + result);
    }
    (0, _indexJs1.assertArgument)(false, "invalid address", "address", address);
}
function getIcapAddress(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt(getAddress(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + ibanChecksum("XE00" + base36) + base36;
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jUsZl":[function(require,module,exports) {
/**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SigningKey", ()=>(0, _signingKeyJs.SigningKey));
parcelHelpers.export(exports, "Signature", ()=>(0, _signatureJs.Signature));
parcelHelpers.export(exports, "computeHmac", ()=>(0, _hmacJs.computeHmac));
parcelHelpers.export(exports, "randomBytes", ()=>(0, _randomJs.randomBytes));
parcelHelpers.export(exports, "keccak256", ()=>(0, _keccakJs.keccak256));
parcelHelpers.export(exports, "ripemd160", ()=>(0, _ripemd160Js.ripemd160));
parcelHelpers.export(exports, "sha256", ()=>(0, _sha2Js.sha256));
parcelHelpers.export(exports, "sha512", ()=>(0, _sha2Js.sha512));
parcelHelpers.export(exports, "pbkdf2", ()=>(0, _pbkdf2Js.pbkdf2));
parcelHelpers.export(exports, "scrypt", ()=>(0, _scryptJs.scrypt));
parcelHelpers.export(exports, "scryptSync", ()=>(0, _scryptJs.scryptSync));
parcelHelpers.export(exports, "lock", ()=>lock);
// We import all these so we can export lock()
var _hmacJs = require("./hmac.js");
var _keccakJs = require("./keccak.js");
var _ripemd160Js = require("./ripemd160.js");
var _pbkdf2Js = require("./pbkdf2.js");
var _randomJs = require("./random.js");
var _scryptJs = require("./scrypt.js");
var _sha2Js = require("./sha2.js");
var _signingKeyJs = require("./signing-key.js");
var _signatureJs = require("./signature.js");
/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function lock() {
    (0, _hmacJs.computeHmac).lock();
    (0, _keccakJs.keccak256).lock();
    (0, _pbkdf2Js.pbkdf2).lock();
    (0, _randomJs.randomBytes).lock();
    (0, _ripemd160Js.ripemd160).lock();
    (0, _scryptJs.scrypt).lock();
    (0, _scryptJs.scryptSync).lock();
    (0, _sha2Js.sha256).lock();
    (0, _sha2Js.sha512).lock();
    (0, _randomJs.randomBytes).lock();
}

},{"./hmac.js":"cmWgK","./keccak.js":"bA5rl","./ripemd160.js":"cg1S7","./pbkdf2.js":"i59y9","./random.js":"fvre5","./scrypt.js":"kA6xP","./sha2.js":"ieL3B","./signing-key.js":"6MLlZ","./signature.js":"uHszR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cmWgK":[function(require,module,exports) {
/**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Return the HMAC for %%data%% using the %%key%% key with the underlying
 *  %%algo%% used for compression.
 *
 *  @example:
 *    key = id("some-secret")
 *
 *    // Compute the HMAC
 *    computeHmac("sha256", key, "0x1337")
 *    //_result:
 *
 *    // To compute the HMAC of UTF-8 data, the data must be
 *    // converted to UTF-8 bytes
 *    computeHmac("sha256", key, toUtf8Bytes("Hello World"))
 *    //_result:
 *
 */ parcelHelpers.export(exports, "computeHmac", ()=>computeHmac);
var _cryptoJs = require("./crypto.js");
var _indexJs = require("../utils/index.js");
let locked = false;
const _computeHmac = function(algorithm, key, data) {
    return (0, _cryptoJs.createHmac)(algorithm, key).update(data).digest();
};
let __computeHmac = _computeHmac;
function computeHmac(algorithm, _key, _data) {
    const key = (0, _indexJs.getBytes)(_key, "key");
    const data = (0, _indexJs.getBytes)(_data, "data");
    return (0, _indexJs.hexlify)(__computeHmac(algorithm, key, data));
}
computeHmac._ = _computeHmac;
computeHmac.lock = function() {
    locked = true;
};
computeHmac.register = function(func) {
    if (locked) throw new Error("computeHmac is locked");
    __computeHmac = func;
};
Object.freeze(computeHmac);

},{"./crypto.js":"bs5xP","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bs5xP":[function(require,module,exports) {
/* Browser Crypto Shims */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHash", ()=>createHash);
parcelHelpers.export(exports, "createHmac", ()=>createHmac);
parcelHelpers.export(exports, "pbkdf2Sync", ()=>pbkdf2Sync);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
var _hmac = require("@noble/hashes/hmac");
var _pbkdf2 = require("@noble/hashes/pbkdf2");
var _sha256 = require("@noble/hashes/sha256");
var _sha512 = require("@noble/hashes/sha512");
var _indexJs = require("../utils/index.js");
var global = arguments[3];
function getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    throw new Error("unable to locate global object");
}
const anyGlobal = getGlobal();
const crypto = anyGlobal.crypto || anyGlobal.msCrypto;
function createHash(algo) {
    switch(algo){
        case "sha256":
            return (0, _sha256.sha256).create();
        case "sha512":
            return (0, _sha512.sha512).create();
    }
    (0, _indexJs.assertArgument)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function createHmac(_algo, key) {
    const algo = {
        sha256: (0, _sha256.sha256),
        sha512: (0, _sha512.sha512)
    }[_algo];
    (0, _indexJs.assertArgument)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, _hmac.hmac).create(algo, key);
}
function pbkdf2Sync(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: (0, _sha256.sha256),
        sha512: (0, _sha512.sha512)
    }[_algo];
    (0, _indexJs.assertArgument)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, _pbkdf2.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function randomBytes(length) {
    (0, _indexJs.assert)(crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, _indexJs.assertArgument)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    crypto.getRandomValues(result);
    return result;
}

},{"@noble/hashes/hmac":"gQDJ7","@noble/hashes/pbkdf2":"d5sup","@noble/hashes/sha256":"1DOUQ","@noble/hashes/sha512":"kfGoz","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gQDJ7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
const _assert_js_1 = require("e88bf4701fbf5140");
const utils_js_1 = require("84f9993aa6177ce6");
// HMAC (RFC 2104)
class HMAC extends utils_js_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, _assert_js_1.hash)(hash);
        const key = (0, utils_js_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, _assert_js_1.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"e88bf4701fbf5140":"bU7vJ","84f9993aa6177ce6":"5LiBd"}],"bU7vJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
exports.bool = bool;
function bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(hash.outputLen);
    number(hash.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"5LiBd":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated, we can just drop the import.
const crypto_1 = require("5bc0132fd4454e56");
const u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!exports.isLE) throw new Error("Non little-endian hardware is not supported");
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    if (!u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
exports.randomBytes = randomBytes;

},{"5bc0132fd4454e56":"c2QEs"}],"c2QEs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"d5sup":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pbkdf2Async = exports.pbkdf2 = void 0;
const _assert_js_1 = require("1d3594bdb9a17731");
const hmac_js_1 = require("f7bb4a1f0df44d48");
const utils_js_1 = require("5fdfda8c45efd7a1");
// Common prologue and epilogue for sync/async functions
function pbkdf2Init(hash, _password, _salt, _opts) {
    (0, _assert_js_1.hash)(hash);
    const opts = (0, utils_js_1.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c, dkLen, asyncTick } = opts;
    (0, _assert_js_1.number)(c);
    (0, _assert_js_1.number)(dkLen);
    (0, _assert_js_1.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, utils_js_1.toBytes)(_password);
    const salt = (0, utils_js_1.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = hmac_js_1.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c,
        dkLen,
        asyncTick,
        DK,
        PRF,
        PRFSalt
    };
}
function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function pbkdf2(hash, password, salt, opts) {
    const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2 = pbkdf2;
async function pbkdf2Async(hash, password, salt, opts) {
    const { c, dkLen, asyncTick, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, utils_js_1.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2Async = pbkdf2Async;

},{"1d3594bdb9a17731":"bU7vJ","f7bb4a1f0df44d48":"gQDJ7","5fdfda8c45efd7a1":"5LiBd"}],"1DOUQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha224 = exports.sha256 = void 0;
const _sha2_js_1 = require("27fa1b6fd36bfc5f");
const utils_js_1 = require("5bd8b7e3b913c55e");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _sha2_js_1.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = IV[0] | 0;
        this.B = IV[1] | 0;
        this.C = IV[2] | 0;
        this.D = IV[3] | 0;
        this.E = IV[4] | 0;
        this.F = IV[5] | 0;
        this.G = IV[6] | 0;
        this.H = IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_js_1.rotr)(W15, 7) ^ (0, utils_js_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_js_1.rotr)(W2, 17) ^ (0, utils_js_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_js_1.rotr)(E, 6) ^ (0, utils_js_1.rotr)(E, 11) ^ (0, utils_js_1.rotr)(E, 25);
            const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_js_1.rotr)(A, 2) ^ (0, utils_js_1.rotr)(A, 13) ^ (0, utils_js_1.rotr)(A, 22);
            const T2 = sigma0 + Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class SHA224 extends SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ exports.sha256 = (0, utils_js_1.wrapConstructor)(()=>new SHA256());
exports.sha224 = (0, utils_js_1.wrapConstructor)(()=>new SHA224());

},{"27fa1b6fd36bfc5f":"50xbS","5bd8b7e3b913c55e":"5LiBd"}],"50xbS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA2 = void 0;
const _assert_js_1 = require("3f59950ad26548ed");
const utils_js_1 = require("528d972f8c4e2b3a");
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class SHA2 extends utils_js_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_js_1.createView)(this.buffer);
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { view, buffer, blockLen } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_js_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_js_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
exports.SHA2 = SHA2;

},{"3f59950ad26548ed":"bU7vJ","528d972f8c4e2b3a":"5LiBd"}],"kfGoz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha384 = exports.sha512_256 = exports.sha512_224 = exports.sha512 = exports.SHA512 = void 0;
const _sha2_js_1 = require("7eab39d073d0441b");
const _u64_js_1 = require("ee87e0f542f806dd");
const utils_js_1 = require("e622a6c15814be83");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [SHA512_Kh, SHA512_Kl] = /* @__PURE__ */ (()=>_u64_js_1.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _sha2_js_1.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = _u64_js_1.default.rotrSH(W15h, W15l, 1) ^ _u64_js_1.default.rotrSH(W15h, W15l, 8) ^ _u64_js_1.default.shrSH(W15h, W15l, 7);
            const s0l = _u64_js_1.default.rotrSL(W15h, W15l, 1) ^ _u64_js_1.default.rotrSL(W15h, W15l, 8) ^ _u64_js_1.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = _u64_js_1.default.rotrSH(W2h, W2l, 19) ^ _u64_js_1.default.rotrBH(W2h, W2l, 61) ^ _u64_js_1.default.shrSH(W2h, W2l, 6);
            const s1l = _u64_js_1.default.rotrSL(W2h, W2l, 19) ^ _u64_js_1.default.rotrBL(W2h, W2l, 61) ^ _u64_js_1.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = _u64_js_1.default.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = _u64_js_1.default.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = _u64_js_1.default.rotrSH(Eh, El, 14) ^ _u64_js_1.default.rotrSH(Eh, El, 18) ^ _u64_js_1.default.rotrBH(Eh, El, 41);
            const sigma1l = _u64_js_1.default.rotrSL(Eh, El, 14) ^ _u64_js_1.default.rotrSL(Eh, El, 18) ^ _u64_js_1.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = _u64_js_1.default.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = _u64_js_1.default.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = _u64_js_1.default.rotrSH(Ah, Al, 28) ^ _u64_js_1.default.rotrBH(Ah, Al, 34) ^ _u64_js_1.default.rotrBH(Ah, Al, 39);
            const sigma0l = _u64_js_1.default.rotrSL(Ah, Al, 28) ^ _u64_js_1.default.rotrBL(Ah, Al, 34) ^ _u64_js_1.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = _u64_js_1.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = _u64_js_1.default.add3L(T1l, sigma0l, MAJl);
            Ah = _u64_js_1.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = _u64_js_1.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = _u64_js_1.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = _u64_js_1.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = _u64_js_1.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = _u64_js_1.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = _u64_js_1.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = _u64_js_1.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = _u64_js_1.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        SHA512_W_H.fill(0);
        SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA512_224 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class SHA512_256 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class SHA384 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
exports.sha512 = (0, utils_js_1.wrapConstructor)(()=>new SHA512());
exports.sha512_224 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_224());
exports.sha512_256 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_256());
exports.sha384 = (0, utils_js_1.wrapConstructor)(()=>new SHA384());

},{"7eab39d073d0441b":"50xbS","ee87e0f542f806dd":"5Ut9l","e622a6c15814be83":"5LiBd"}],"5Ut9l":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
exports.fromBig = fromBig;
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
exports.split = split;
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
exports.add = add;
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"bA5rl":[function(require,module,exports) {
/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Compute the cryptographic KECCAK256 hash of %%data%%.
 *
 *  The %%data%% **must** be a data representation, to compute the
 *  hash of UTF-8 data use the [[id]] function.
 *
 *  @returns DataHexstring
 *  @example:
 *    keccak256("0x")
 *    //_result:
 *
 *    keccak256("0x1337")
 *    //_result:
 *
 *    keccak256(new Uint8Array([ 0x13, 0x37 ]))
 *    //_result:
 *
 *    // Strings are assumed to be DataHexString, otherwise it will
 *    // throw. To hash UTF-8 data, see the note above.
 *    keccak256("Hello World")
 *    //_error:
 */ parcelHelpers.export(exports, "keccak256", ()=>keccak256);
var _sha3 = require("@noble/hashes/sha3");
var _indexJs = require("../utils/index.js");
let locked = false;
const _keccak256 = function(data) {
    return (0, _sha3.keccak_256)(data);
};
let __keccak256 = _keccak256;
function keccak256(_data) {
    const data = (0, _indexJs.getBytes)(_data, "data");
    return (0, _indexJs.hexlify)(__keccak256(data));
}
keccak256._ = _keccak256;
keccak256.lock = function() {
    locked = true;
};
keccak256.register = function(func) {
    if (locked) throw new TypeError("keccak256 is locked");
    __keccak256 = func;
};
Object.freeze(keccak256);

},{"@noble/hashes/sha3":"39Lfb","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39Lfb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = exports.keccakP = void 0;
const _assert_js_1 = require("e1b100142ec0c21d");
const _u64_js_1 = require("4bbb2a5ca51e3233");
const utils_js_1 = require("4646b01f87711c64");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [
    [],
    [],
    []
];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"e1b100142ec0c21d":"bU7vJ","4bbb2a5ca51e3233":"5Ut9l","4646b01f87711c64":"5LiBd"}],"cg1S7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Compute the cryptographic RIPEMD-160 hash of %%data%%.
 *
 *  @_docloc: api/crypto:Hash Functions
 *  @returns DataHexstring
 *
 *  @example:
 *    ripemd160("0x")
 *    //_result:
 *
 *    ripemd160("0x1337")
 *    //_result:
 *
 *    ripemd160(new Uint8Array([ 0x13, 0x37 ]))
 *    //_result:
 *
 */ parcelHelpers.export(exports, "ripemd160", ()=>ripemd160);
var _ripemd160 = require("@noble/hashes/ripemd160");
var _indexJs = require("../utils/index.js");
let locked = false;
const _ripemd1601 = function(data) {
    return (0, _ripemd160.ripemd160)(data);
};
let __ripemd160 = _ripemd1601;
function ripemd160(_data) {
    const data = (0, _indexJs.getBytes)(_data, "data");
    return (0, _indexJs.hexlify)(__ripemd160(data));
}
ripemd160._ = _ripemd1601;
ripemd160.lock = function() {
    locked = true;
};
ripemd160.register = function(func) {
    if (locked) throw new TypeError("ripemd160 is locked");
    __ripemd160 = func;
};
Object.freeze(ripemd160);

},{"@noble/hashes/ripemd160":"g1rnI","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g1rnI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ripemd160 = exports.RIPEMD160 = void 0;
const _sha2_js_1 = require("f702bdc9a9956e25");
const utils_js_1 = require("1fc3575b3de518c3");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const Pi = /* @__PURE__ */ Id.map((i)=>(9 * i + 5) % 16);
let idxL = [
    Id
];
let idxR = [
    Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    idxL,
    idxR
])j.push(j[i].map((k)=>Rho[k]));
const shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const shiftsL = /* @__PURE__ */ idxL.map((idx, i)=>idx.map((j)=>shifts[i][j]));
const shiftsR = /* @__PURE__ */ idxR.map((idx, i)=>idx.map((j)=>shifts[i][j]));
const Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const BUF = /* @__PURE__ */ new Uint32Array(16);
class RIPEMD160 extends _sha2_js_1.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0, h1, h2, h3, h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = Kl[group], hbr = Kr[group]; // prettier-ignore
            const rl = idxL[group], rr = idxR[group]; // prettier-ignore
            const sl = shiftsL[group], sr = shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = rotl(al + f(group, bl, cl, dl) + BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = rotl(ar + f(rGroup, br, cr, dr) + BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
exports.RIPEMD160 = RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ exports.ripemd160 = (0, utils_js_1.wrapConstructor)(()=>new RIPEMD160());

},{"f702bdc9a9956e25":"50xbS","1fc3575b3de518c3":"5LiBd"}],"i59y9":[function(require,module,exports) {
/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Return the [[link-pbkdf2]] for %%keylen%% bytes for %%password%% using
 *  the %%salt%% and using %%iterations%% of %%algo%%.
 *
 *  This PBKDF is outdated and should not be used in new projects, but is
 *  required to decrypt older files.
 *
 *  @example:
 *    // The password must be converted to bytes, and it is generally
 *    // best practices to ensure the string has been normalized. Many
 *    // formats explicitly indicate the normalization form to use.
 *    password = "hello"
 *    passwordBytes = toUtf8Bytes(password, "NFKC")
 *
 *    salt = id("some-salt")
 *
 *    // Compute the PBKDF2
 *    pbkdf2(passwordBytes, salt, 1024, 16, "sha256")
 *    //_result:
 */ parcelHelpers.export(exports, "pbkdf2", ()=>pbkdf2);
var _cryptoJs = require("./crypto.js");
var _indexJs = require("../utils/index.js");
let locked = false;
const _pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, _cryptoJs.pbkdf2Sync)(password, salt, iterations, keylen, algo);
};
let __pbkdf2 = _pbkdf2;
function pbkdf2(_password, _salt, iterations, keylen, algo) {
    const password = (0, _indexJs.getBytes)(_password, "password");
    const salt = (0, _indexJs.getBytes)(_salt, "salt");
    return (0, _indexJs.hexlify)(__pbkdf2(password, salt, iterations, keylen, algo));
}
pbkdf2._ = _pbkdf2;
pbkdf2.lock = function() {
    locked = true;
};
pbkdf2.register = function(func) {
    if (locked) throw new Error("pbkdf2 is locked");
    __pbkdf2 = func;
};
Object.freeze(pbkdf2);

},{"./crypto.js":"bs5xP","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fvre5":[function(require,module,exports) {
/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Return %%length%% bytes of cryptographically secure random data.
 *
 *  @example:
 *    randomBytes(8)
 *    //_result:
 */ parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
var _cryptoJs = require("./crypto.js");
let locked = false;
const _randomBytes = function(length) {
    return new Uint8Array((0, _cryptoJs.randomBytes)(length));
};
let __randomBytes = _randomBytes;
function randomBytes(length) {
    return __randomBytes(length);
}
randomBytes._ = _randomBytes;
randomBytes.lock = function() {
    locked = true;
};
randomBytes.register = function(func) {
    if (locked) throw new Error("randomBytes is locked");
    __randomBytes = func;
};
Object.freeze(randomBytes);

},{"./crypto.js":"bs5xP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kA6xP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The [[link-wiki-scrypt]] uses a memory and cpu hard method of
 *  derivation to increase the resource cost to brute-force a password
 *  for a given key.
 *
 *  This means this algorithm is intentionally slow, and can be tuned to
 *  become slower. As computation and memory speed improve over time,
 *  increasing the difficulty maintains the cost of an attacker.
 *
 *  For example, if a target time of 5 seconds is used, a legitimate user
 *  which knows their password requires only 5 seconds to unlock their
 *  account. A 6 character password has 68 billion possibilities, which
 *  would require an attacker to invest over 10,000 years of CPU time. This
 *  is of course a crude example (as password generally aren't random),
 *  but demonstrates to value of imposing large costs to decryption.
 *
 *  For this reason, if building a UI which involved decrypting or
 *  encrypting datsa using scrypt, it is recommended to use a
 *  [[ProgressCallback]] (as event short periods can seem lik an eternity
 *  if the UI freezes). Including the phrase //"decrypting"// in the UI
 *  can also help, assuring the user their waiting is for a good reason.
 *
 *  @_docloc: api/crypto:Passwords
 *
 *  @example:
 *    // The password must be converted to bytes, and it is generally
 *    // best practices to ensure the string has been normalized. Many
 *    // formats explicitly indicate the normalization form to use.
 *    password = "hello"
 *    passwordBytes = toUtf8Bytes(password, "NFKC")
 *
 *    salt = id("some-salt")
 *
 *    // Compute the scrypt
 *    scrypt(passwordBytes, salt, 1024, 8, 1, 16)
 *    //_result:
 */ parcelHelpers.export(exports, "scrypt", ()=>scrypt);
/**
 *  Provides a synchronous variant of [[scrypt]].
 *
 *  This will completely lock up and freeze the UI in a browser and will
 *  prevent any event loop from progressing. For this reason, it is
 *  preferred to use the [async variant](scrypt).
 *
 *  @_docloc: api/crypto:Passwords
 *
 *  @example:
 *    // The password must be converted to bytes, and it is generally
 *    // best practices to ensure the string has been normalized. Many
 *    // formats explicitly indicate the normalization form to use.
 *    password = "hello"
 *    passwordBytes = toUtf8Bytes(password, "NFKC")
 *
 *    salt = id("some-salt")
 *
 *    // Compute the scrypt
 *    scryptSync(passwordBytes, salt, 1024, 8, 1, 16)
 *    //_result:
 */ parcelHelpers.export(exports, "scryptSync", ()=>scryptSync);
var _scrypt = require("@noble/hashes/scrypt");
var _indexJs = require("../utils/index.js");
let lockedSync = false, lockedAsync = false;
const _scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, _scrypt.scryptAsync)(passwd, salt, {
        N,
        r,
        p,
        dkLen,
        onProgress
    });
};
const _scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, _scrypt.scrypt)(passwd, salt, {
        N,
        r,
        p,
        dkLen
    });
};
let __scryptAsync = _scryptAsync;
let __scryptSync = _scryptSync;
async function scrypt(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, _indexJs.getBytes)(_passwd, "passwd");
    const salt = (0, _indexJs.getBytes)(_salt, "salt");
    return (0, _indexJs.hexlify)(await __scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
scrypt._ = _scryptAsync;
scrypt.lock = function() {
    lockedAsync = true;
};
scrypt.register = function(func) {
    if (lockedAsync) throw new Error("scrypt is locked");
    __scryptAsync = func;
};
Object.freeze(scrypt);
function scryptSync(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, _indexJs.getBytes)(_passwd, "passwd");
    const salt = (0, _indexJs.getBytes)(_salt, "salt");
    return (0, _indexJs.hexlify)(__scryptSync(passwd, salt, N, r, p, dkLen));
}
scryptSync._ = _scryptSync;
scryptSync.lock = function() {
    lockedSync = true;
};
scryptSync.register = function(func) {
    if (lockedSync) throw new Error("scryptSync is locked");
    __scryptSync = func;
};
Object.freeze(scryptSync);

},{"@noble/hashes/scrypt":"dir2O","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dir2O":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scryptAsync = exports.scrypt = void 0;
const _assert_js_1 = require("26d07fecad72dba1");
const sha256_js_1 = require("6cf2dc8f4f5ba2ce");
const pbkdf2_js_1 = require("6aba86ac7207e850");
const utils_js_1 = require("4f117216061b1d7c");
// RFC 7914 Scrypt KDF
// Left rotate for uint32
const rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= rotl(x00 + x12 | 0, 7);
        x08 ^= rotl(x04 + x00 | 0, 9);
        x12 ^= rotl(x08 + x04 | 0, 13);
        x00 ^= rotl(x12 + x08 | 0, 18);
        x09 ^= rotl(x05 + x01 | 0, 7);
        x13 ^= rotl(x09 + x05 | 0, 9);
        x01 ^= rotl(x13 + x09 | 0, 13);
        x05 ^= rotl(x01 + x13 | 0, 18);
        x14 ^= rotl(x10 + x06 | 0, 7);
        x02 ^= rotl(x14 + x10 | 0, 9);
        x06 ^= rotl(x02 + x14 | 0, 13);
        x10 ^= rotl(x06 + x02 | 0, 18);
        x03 ^= rotl(x15 + x11 | 0, 7);
        x07 ^= rotl(x03 + x15 | 0, 9);
        x11 ^= rotl(x07 + x03 | 0, 13);
        x15 ^= rotl(x11 + x07 | 0, 18);
        x01 ^= rotl(x00 + x03 | 0, 7);
        x02 ^= rotl(x01 + x00 | 0, 9);
        x03 ^= rotl(x02 + x01 | 0, 13);
        x00 ^= rotl(x03 + x02 | 0, 18);
        x06 ^= rotl(x05 + x04 | 0, 7);
        x07 ^= rotl(x06 + x05 | 0, 9);
        x04 ^= rotl(x07 + x06 | 0, 13);
        x05 ^= rotl(x04 + x07 | 0, 18);
        x11 ^= rotl(x10 + x09 | 0, 7);
        x08 ^= rotl(x11 + x10 | 0, 9);
        x09 ^= rotl(x08 + x11 | 0, 13);
        x10 ^= rotl(x09 + x08 | 0, 18);
        x12 ^= rotl(x15 + x14 | 0, 7);
        x13 ^= rotl(x12 + x15 | 0, 9);
        x14 ^= rotl(x13 + x12 | 0, 13);
        x15 ^= rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, utils_js_1.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N, r, p, dkLen, asyncTick, maxmem, onProgress } = opts;
    (0, _assert_js_1.number)(N);
    (0, _assert_js_1.number)(r);
    (0, _assert_js_1.number)(p);
    (0, _assert_js_1.number)(dkLen);
    (0, _assert_js_1.number)(asyncTick);
    (0, _assert_js_1.number)(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, pbkdf2_js_1.pbkdf2)(sha256_js_1.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, utils_js_1.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, utils_js_1.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, utils_js_1.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N,
        r,
        p,
        dkLen,
        blockSize32,
        V,
        B32,
        B,
        tmp,
        blockMixCb,
        asyncTick
    };
}
function scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, pbkdf2_js_1.pbkdf2)(sha256_js_1.sha256, password, B, {
        c: 1,
        dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function scrypt(password, salt, opts) {
    const { N, r, p, dkLen, blockSize32, V, B32, B, tmp, blockMixCb } = scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return scryptOutput(password, dkLen, B, V, tmp);
}
exports.scrypt = scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function scryptAsync(password, salt, opts) {
    const { N, r, p, dkLen, blockSize32, V, B32, B, tmp, blockMixCb, asyncTick } = scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, utils_js_1.asyncLoop)(N - 1, asyncTick, ()=>{
            BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, utils_js_1.asyncLoop)(N, asyncTick, ()=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return scryptOutput(password, dkLen, B, V, tmp);
}
exports.scryptAsync = scryptAsync;

},{"26d07fecad72dba1":"bU7vJ","6cf2dc8f4f5ba2ce":"1DOUQ","6aba86ac7207e850":"d5sup","4f117216061b1d7c":"5LiBd"}],"ieL3B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Compute the cryptographic SHA2-256 hash of %%data%%.
 *
 *  @_docloc: api/crypto:Hash Functions
 *  @returns DataHexstring
 *
 *  @example:
 *    sha256("0x")
 *    //_result:
 *
 *    sha256("0x1337")
 *    //_result:
 *
 *    sha256(new Uint8Array([ 0x13, 0x37 ]))
 *    //_result:
 *
 */ parcelHelpers.export(exports, "sha256", ()=>sha256);
/**
 *  Compute the cryptographic SHA2-512 hash of %%data%%.
 *
 *  @_docloc: api/crypto:Hash Functions
 *  @returns DataHexstring
 *
 *  @example:
 *    sha512("0x")
 *    //_result:
 *
 *    sha512("0x1337")
 *    //_result:
 *
 *    sha512(new Uint8Array([ 0x13, 0x37 ]))
 *    //_result:
 */ parcelHelpers.export(exports, "sha512", ()=>sha512);
var _cryptoJs = require("./crypto.js");
var _indexJs = require("../utils/index.js");
const _sha256 = function(data) {
    return (0, _cryptoJs.createHash)("sha256").update(data).digest();
};
const _sha512 = function(data) {
    return (0, _cryptoJs.createHash)("sha512").update(data).digest();
};
let __sha256 = _sha256;
let __sha512 = _sha512;
let locked256 = false, locked512 = false;
function sha256(_data) {
    const data = (0, _indexJs.getBytes)(_data, "data");
    return (0, _indexJs.hexlify)(__sha256(data));
}
sha256._ = _sha256;
sha256.lock = function() {
    locked256 = true;
};
sha256.register = function(func) {
    if (locked256) throw new Error("sha256 is locked");
    __sha256 = func;
};
Object.freeze(sha256);
function sha512(_data) {
    const data = (0, _indexJs.getBytes)(_data, "data");
    return (0, _indexJs.hexlify)(__sha512(data));
}
sha512._ = _sha512;
sha512.lock = function() {
    locked512 = true;
};
sha512.register = function(func) {
    if (locked512) throw new Error("sha512 is locked");
    __sha512 = func;
};
Object.freeze(sha256);

},{"./crypto.js":"bs5xP","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MLlZ":[function(require,module,exports) {
/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **SigningKey** provides high-level access to the elliptic curve
 *  cryptography (ECC) operations and key management.
 */ parcelHelpers.export(exports, "SigningKey", ()=>SigningKey);
var _secp256K1 = require("@noble/curves/secp256k1");
var _indexJs = require("../utils/index.js");
var _signatureJs = require("./signature.js");
class SigningKey {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, _indexJs.assertArgument)((0, _indexJs.dataLength)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, _indexJs.hexlify)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return SigningKey.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return SigningKey.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, _indexJs.assertArgument)((0, _indexJs.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, _secp256K1.secp256k1).sign((0, _indexJs.getBytesCopy)(digest), (0, _indexJs.getBytesCopy)(this.#privateKey), {
            lowS: true
        });
        return (0, _signatureJs.Signature).from({
            r: (0, _indexJs.toBeHex)(sig.r, 32),
            s: (0, _indexJs.toBeHex)(sig.s, 32),
            v: sig.recovery ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = SigningKey.computePublicKey(other);
        return (0, _indexJs.hexlify)((0, _secp256K1.secp256k1).getSharedSecret((0, _indexJs.getBytesCopy)(this.#privateKey), (0, _indexJs.getBytes)(pubKey), false));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, _indexJs.getBytes)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = (0, _secp256K1.secp256k1).getPublicKey(bytes, !!compressed);
            return (0, _indexJs.hexlify)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = (0, _secp256K1.secp256k1).ProjectivePoint.fromHex(bytes);
        return (0, _indexJs.hexlify)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, _indexJs.assertArgument)((0, _indexJs.dataLength)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, _signatureJs.Signature).from(signature);
        let secpSig = (0, _secp256K1.secp256k1).Signature.fromCompact((0, _indexJs.getBytesCopy)((0, _indexJs.concat)([
            sig.r,
            sig.s
        ])));
        secpSig = secpSig.addRecoveryBit(sig.yParity);
        const pubKey = secpSig.recoverPublicKey((0, _indexJs.getBytesCopy)(digest));
        (0, _indexJs.assertArgument)(pubKey != null, "invalid signautre for digest", "signature", signature);
        return "0x" + pubKey.toHex(false);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = (0, _secp256K1.secp256k1).ProjectivePoint.fromHex(SigningKey.computePublicKey(p0).substring(2));
        const pub1 = (0, _secp256K1.secp256k1).ProjectivePoint.fromHex(SigningKey.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}

},{"@noble/curves/secp256k1":"eJveS","../utils/index.js":"4LgPJ","./signature.js":"uHszR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJveS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const sha256_1 = require("3c53bd954d845d61");
const utils_1 = require("7a6e65e5bfb7736f");
const modular_js_1 = require("18b0f978761223e3");
const weierstrass_js_1 = require("208a425c8805f366");
const utils_js_1 = require("3ea83df58059487c");
const hash_to_curve_js_1 = require("949206a8da18bd0f");
const _shortw_utils_js_1 = require("8ca4fc7257e92f5a");
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b)=>(a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, modular_js_1.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, modular_js_1.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, modular_js_1.pow2)(b9, _2n, P) * b2 % P;
    const b22 = (0, modular_js_1.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, modular_js_1.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, modular_js_1.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, modular_js_1.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, modular_js_1.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, modular_js_1.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, modular_js_1.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, modular_js_1.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, modular_js_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const Fp = (0, modular_js_1.Field)(secp256k1P, undefined, undefined, {
    sqrt: sqrtMod
});
exports.secp256k1 = (0, _shortw_utils_js_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = (0, modular_js_1.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, modular_js_1.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const _0n = BigInt(0);
const fe = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1P;
const ge = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, utils_js_1.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)((0, utils_js_1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const numTo32b = (n)=>(0, utils_js_1.numberToBytesBE)(n, 32);
const modP = (x)=>(0, modular_js_1.mod)(x, secp256k1P);
const modN = (x)=>(0, modular_js_1.mod)(x, secp256k1N);
const Point = exports.secp256k1.ProjectivePoint;
const GmulAdd = (Q, a, b)=>Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    let d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : modN(-d_);
    return {
        scalar: scalar,
        bytes: pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function lift_x(x) {
    if (!fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = modP(x * x);
    const c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n) y = modP(-y); // Return the unique point P such that x(P) = x and
    const p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function challenge(...args) {
    return modN((0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function schnorrSign(message, privateKey, auxRand = (0, utils_1.randomBytes)(32)) {
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, utils_js_1.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = numTo32b(d ^ (0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = modN((0, utils_js_1.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function schnorrVerify(signature, message, publicKey) {
    const sig = (0, utils_js_1.ensureBytes)("signature", signature, 64);
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const pub = (0, utils_js_1.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = lift_x((0, utils_js_1.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, utils_js_1.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r)) return false;
        const s = (0, utils_js_1.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s)) return false;
        const e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
exports.schnorr = (()=>({
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        utils: {
            randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
            lift_x,
            pointToBytes,
            numberToBytesBE: utils_js_1.numberToBytesBE,
            bytesToNumberBE: utils_js_1.bytesToNumberBE,
            taggedHash,
            mod: modular_js_1.mod
        }
    }))();
const isoMap = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.isogenyMap)(Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const mapSWU = /* @__PURE__ */ (()=>(0, weierstrass_js_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: Fp.create(BigInt("-11"))
    }))();
const htf = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.createHasher)(exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x, y } = mapSWU(Fp.create(scalars[0]));
        return isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: sha256_1.sha256
    }))();
exports.hashToCurve = (()=>htf.hashToCurve)();
exports.encodeToCurve = (()=>htf.encodeToCurve)();

},{"3c53bd954d845d61":"1DOUQ","7a6e65e5bfb7736f":"5LiBd","18b0f978761223e3":"6MubN","208a425c8805f366":"gORRp","3ea83df58059487c":"fDh5I","949206a8da18bd0f":"5wzLc","8ca4fc7257e92f5a":"aN5P6"}],"6MubN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields
const utils_js_1 = require("3ef7bd6bb3669556");
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
const _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
const _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n) throw new Error("Expected power/modulo > 0");
    if (modulo === _1n) return _0n;
    let res = _1n;
    while(power > _0n){
        if (power & _1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while(a !== _0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n) throw new Error("invert: does not exist");
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - _1n) / _2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, _2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, _2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    _9n;
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo)=>(mod(num, modulo) & _1n) === _1n;
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
const FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, utils_js_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n) throw new Error("Expected power > 0");
    if (power === _0n) return f.ONE;
    if (power === _1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > _0n){
        if (power & _1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    const legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER,
        BITS,
        BYTES,
        MASK: (0, utils_js_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === _0n,
        isOdd: (num)=>(num & _1n) === _1n,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, utils_js_1.numberToBytesLE)(num, BYTES) : (0, utils_js_1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, utils_js_1.bytesToNumberLE)(bytes) : (0, utils_js_1.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, utils_js_1.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberLE)(hash) : (0, utils_js_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberBE)(key) : (0, utils_js_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_js_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_js_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;

},{"3ef7bd6bb3669556":"fDh5I"}],"fDh5I":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
const u8a = (a)=>a instanceof Uint8Array;
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
exports.hexToNumber = hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    if (!u8a(bytes)) throw new Error("Uint8Array expected");
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if (u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
exports.concatBytes = concatBytes;
function equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */ const bitSet = (n, pos, value)=>{
    return n | (value ? _1n : _0n) << BigInt(pos);
};
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const bitMask = (n)=>(_2n << BigInt(n - 1)) - _1n;
exports.bitMask = bitMask;
// DRBG
const u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
const validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
exports.validateObject = validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

},{}],"gORRp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapToCurveSimpleSWU = exports.SWUFpSqrtRatio = exports.weierstrass = exports.weierstrassPoints = exports.DER = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b
const mod = require("1fdee92d2c64b42d");
const ut = require("73ba18c5f88dbb0b");
const utils_js_1 = require("73ba18c5f88dbb0b");
const curve_js_1 = require("380ebf28592ccb3d");
function validatePointOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut;
exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = exports.DER;
        const data = typeof hex === "string" ? h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r,
            s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return ut.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x,
            y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : ut.bytesToNumberBE((0, utils_js_1.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, utils_js_1.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x, y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === _0n) return I;
            assertGE(n); // Will throw on 0
            if (n === _1n) return this;
            const { endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n || k2 > _0n){
                if (k1 & _1n) k1p = k1p.add(d);
                if (k2 & _1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo } = CURVE;
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, curve_js_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
exports.weierstrassPoints = weierstrassPoints;
function validateOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = ut.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & _1n) === _1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x,
                    y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>ut.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, utils_js_1.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = exports.DER.toSig((0, utils_js_1.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN((0, utils_js_1.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return ut.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return ut.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = ut.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!(_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, utils_js_1.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_js_1.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = ut.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        publicKey = (0, utils_js_1.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS, prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r, s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils
    };
}
exports.weierstrass = weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = _0n;
    for(let o = q - _1n; o % _2n === _0n; o /= _2n)l += _1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = _2n << c1 - _1n - _1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    const c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > _1n; i--){
            let tv5 = i - _2n; // 18.    tv5 = i - 2
            tv5 = _2n << tv5 - _1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x,
            y
        };
    };
}
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;

},{"1fdee92d2c64b42d":"6MubN","73ba18c5f88dbb0b":"fDh5I","380ebf28592ccb3d":"bFAkY"}],"bFAkY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities
const modular_js_1 = require("4841eb72ec532f63");
const utils_js_1 = require("50ed4dc026960cfa");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows,
            windowSize
        };
    };
    return {
        constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p,
                f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_js_1.validateField)(curve.Fp);
    (0, utils_js_1.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, modular_js_1.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

},{"4841eb72ec532f63":"6MubN","50ed4dc026960cfa":"fDh5I"}],"5wzLc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createHasher = exports.isogenyMap = exports.hash_to_field = exports.expand_message_xof = exports.expand_message_xmd = void 0;
const modular_js_1 = require("1d8cc110c33ba632");
const utils_js_1 = require("95681f37e45b942d");
function validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, utils_js_1.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const os2ip = utils_js_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    isBytes(msg);
    isBytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, utils_js_1.concatBytes)((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, utils_js_1.concatBytes)(DST, i2osp(DST.length, 1));
    const Z_pad = i2osp(0, r_in_bytes);
    const l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, utils_js_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_js_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            strxor(b_0, b[i - 1]),
            i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, utils_js_1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, utils_js_1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
exports.expand_message_xmd = expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    isBytes(msg);
    isBytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen
        }).update((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update(i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update(i2osp(DST.length, 1)).digest();
}
exports.expand_message_xof = expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function hash_to_field(msg, count, options) {
    (0, utils_js_1.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p, k, m, hash, expand, DST: _DST } = options;
    isBytes(msg);
    isNum(count);
    const DST = validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_js_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
exports.hash_to_field = hash_to_field;
function isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x,
            y
        };
    };
}
exports.isogenyMap = isogenyMap;
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
exports.createHasher = createHasher;

},{"1d8cc110c33ba632":"6MubN","95681f37e45b942d":"fDh5I"}],"aN5P6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCurve = exports.getHash = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const hmac_1 = require("53bc54ac3323df37");
const utils_1 = require("3b2fd5f183d41bca");
const weierstrass_js_1 = require("1e643552e47f992d");
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs)=>(0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs)),
        randomBytes: utils_1.randomBytes
    };
}
exports.getHash = getHash;
function createCurve(curveDef, defHash) {
    const create = (hash)=>(0, weierstrass_js_1.weierstrass)({
            ...curveDef,
            ...getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create
    });
}
exports.createCurve = createCurve;

},{"53bc54ac3323df37":"gQDJ7","3b2fd5f183d41bca":"5LiBd","1e643552e47f992d":"gORRp"}],"uHszR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A Signature  @TODO
 *
 *
 *  @_docloc: api/crypto:Signing
 */ parcelHelpers.export(exports, "Signature", ()=>Signature);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../utils/index.js");
// Constants
const BN_0 = BigInt(0);
const BN_1 = BigInt(1);
const BN_2 = BigInt(2);
const BN_27 = BigInt(27);
const BN_28 = BigInt(28);
const BN_35 = BigInt(35);
const _guard = {};
function toUint256(value) {
    return (0, _indexJs1.zeroPadValue)((0, _indexJs1.toBeArray)(value), 32);
}
class Signature {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, _indexJs1.assertArgument)((0, _indexJs1.dataLength)(value) === 32, "invalid r", "value", value);
        this.#r = (0, _indexJs1.hexlify)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, _indexJs1.assertArgument)((0, _indexJs1.dataLength)(_value) === 32, "invalid s", "value", _value);
        const value = (0, _indexJs1.hexlify)(_value);
        (0, _indexJs1.assertArgument)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, _indexJs1.getNumber)(value, "value");
        (0, _indexJs1.assertArgument)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return Signature.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, _indexJs1.getBytes)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, _indexJs1.hexlify)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, _indexJs1.concat)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, _indexJs1.concat)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, _indexJs1.assertPrivate)(guard, _guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new Signature(_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, _indexJs1.getBigInt)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == BN_27 || bv == BN_28) return BN_0;
        // Bad value for an EIP-155 v
        (0, _indexJs1.assertArgument)(bv >= BN_35, "invalid EIP-155 v", "v", v);
        return (bv - BN_35) / BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, _indexJs1.getBigInt)(chainId) * BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, _indexJs1.getBigInt)(v);
        if (bv === BN_0 || bv === BN_27) return 27;
        if (bv === BN_1 || bv === BN_28) return 28;
        (0, _indexJs1.assertArgument)(bv >= BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, _indexJs1.assertArgument)(check, message, "signature", sig);
        }
        if (sig == null) return new Signature(_guard, (0, _indexJs.ZeroHash), (0, _indexJs.ZeroHash), 27);
        if (typeof sig === "string") {
            const bytes = (0, _indexJs1.getBytes)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, _indexJs1.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new Signature(_guard, r, (0, _indexJs1.hexlify)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, _indexJs1.hexlify)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = Signature.getNormalizedV(bytes[64]);
                return new Signature(_guard, r, (0, _indexJs1.hexlify)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof Signature) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return toUint256(s);
            if (yParityAndS != null) {
                assertError((0, _indexJs1.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, _indexJs1.getBytes)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, _indexJs1.hexlify)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, _indexJs1.getBytes)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV, v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, _indexJs1.getBigInt)(_v);
                return {
                    networkV: v >= BN_35 ? v : undefined,
                    v: Signature.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, _indexJs1.isHexString)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, _indexJs1.getBytes)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, _indexJs1.getNumber)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new Signature(_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, _indexJs1.getNumber)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}

},{"../constants/index.js":"8Nw3O","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nw3O":[function(require,module,exports) {
/**
 *  Some common constants useful for Ethereum.
 *
 *  @_section: api/constants: Constants  [about-constants]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZeroAddress", ()=>(0, _addressesJs.ZeroAddress));
parcelHelpers.export(exports, "ZeroHash", ()=>(0, _hashesJs.ZeroHash));
parcelHelpers.export(exports, "N", ()=>(0, _numbersJs.N));
parcelHelpers.export(exports, "WeiPerEther", ()=>(0, _numbersJs.WeiPerEther));
parcelHelpers.export(exports, "MaxUint256", ()=>(0, _numbersJs.MaxUint256));
parcelHelpers.export(exports, "MinInt256", ()=>(0, _numbersJs.MinInt256));
parcelHelpers.export(exports, "MaxInt256", ()=>(0, _numbersJs.MaxInt256));
parcelHelpers.export(exports, "EtherSymbol", ()=>(0, _stringsJs.EtherSymbol));
parcelHelpers.export(exports, "MessagePrefix", ()=>(0, _stringsJs.MessagePrefix));
var _addressesJs = require("./addresses.js");
var _hashesJs = require("./hashes.js");
var _numbersJs = require("./numbers.js");
var _stringsJs = require("./strings.js");

},{"./addresses.js":"drK3N","./hashes.js":"2kMqL","./numbers.js":"7DjBn","./strings.js":"lBBbo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"drK3N":[function(require,module,exports) {
/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZeroAddress", ()=>ZeroAddress);
const ZeroAddress = "0x0000000000000000000000000000000000000000";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kMqL":[function(require,module,exports) {
/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZeroHash", ()=>ZeroHash);
const ZeroHash = "0x0000000000000000000000000000000000000000000000000000000000000000";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DjBn":[function(require,module,exports) {
/**
 *  A constant for the order N for the secp256k1 curve.
 *
 *  (**i.e.** ``0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n``)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "N", ()=>N);
parcelHelpers.export(exports, "WeiPerEther", ()=>WeiPerEther);
parcelHelpers.export(exports, "MaxUint256", ()=>MaxUint256);
parcelHelpers.export(exports, "MinInt256", ()=>MinInt256);
parcelHelpers.export(exports, "MaxInt256", ()=>MaxInt256);
const N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const WeiPerEther = BigInt("1000000000000000000");
const MaxUint256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const MinInt256 = BigInt("0x8000000000000000000000000000000000000000000000000000000000000000") * BigInt(-1);
const MaxInt256 = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBBbo":[function(require,module,exports) {
// NFKC (composed)             // (decomposed)
/**
 *  A constant for the ether symbol (normalized using NFKC).
 *
 *  (**i.e.** ``"\\u039e"``)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EtherSymbol", ()=>EtherSymbol);
parcelHelpers.export(exports, "MessagePrefix", ()=>MessagePrefix);
const EtherSymbol = "\u039E"; // "\uD835\uDF63";
const MessagePrefix = "\x19Ethereum Signed Message:\n";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i98X1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
/**
 *  Returns the address that would result from a ``CREATE`` for %%tx%%.
 *
 *  This can be used to compute the address a contract will be
 *  deployed to by an EOA when sending a deployment transaction (i.e.
 *  when the ``to`` address is ``null``).
 *
 *  This can also be used to compute the address a contract will be
 *  deployed to by a contract, by using the contract's address as the
 *  ``to`` and the contract's nonce.
 *
 *  @example
 *    from = "0x8ba1f109551bD432803012645Ac136ddd64DBA72";
 *    nonce = 5;
 *
 *    getCreateAddress({ from, nonce });
 *    //_result:
 */ parcelHelpers.export(exports, "getCreateAddress", ()=>getCreateAddress);
/**
 *  Returns the address that would result from a ``CREATE2`` operation
 *  with the given %%from%%, %%salt%% and %%initCodeHash%%.
 *
 *  To compute the %%initCodeHash%% from a contract's init code, use
 *  the [[keccak256]] function.
 *
 *  For a quick overview and example of ``CREATE2``, see [[link-ricmoo-wisps]].
 *
 *  @example
 *    // The address of the contract
 *    from = "0x8ba1f109551bD432803012645Ac136ddd64DBA72"
 *
 *    // The salt
 *    salt = id("HelloWorld")
 *
 *    // The hash of the initCode
 *    initCode = "0x6394198df16000526103ff60206004601c335afa6040516060f3";
 *    initCodeHash = keccak256(initCode)
 *
 *    getCreate2Address(from, salt, initCodeHash)
 *    //_result:
 */ parcelHelpers.export(exports, "getCreate2Address", ()=>getCreate2Address);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
var _addressJs = require("./address.js");
function getCreateAddress(tx) {
    const from = (0, _addressJs.getAddress)(tx.from);
    const nonce = (0, _indexJs1.getBigInt)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, _addressJs.getAddress)((0, _indexJs1.dataSlice)((0, _indexJs.keccak256)((0, _indexJs1.encodeRlp)([
        from,
        nonceHex
    ])), 12));
}
function getCreate2Address(_from, _salt, _initCodeHash) {
    const from = (0, _addressJs.getAddress)(_from);
    const salt = (0, _indexJs1.getBytes)(_salt, "salt");
    const initCodeHash = (0, _indexJs1.getBytes)(_initCodeHash, "initCodeHash");
    (0, _indexJs1.assertArgument)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, _indexJs1.assertArgument)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, _addressJs.getAddress)((0, _indexJs1.dataSlice)((0, _indexJs.keccak256)((0, _indexJs1.concat)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","./address.js":"42Zfe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9cyEY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns true if %%value%% is an object which implements the
 *  [[Addressable]] interface.
 *
 *  @example:
 *    // Wallets and AbstractSigner sub-classes
 *    isAddressable(Wallet.createRandom())
 *    //_result:
 *
 *    // Contracts
 *    contract = new Contract("dai.tokens.ethers.eth", [ ], provider)
 *    isAddressable(contract)
 *    //_result:
 */ parcelHelpers.export(exports, "isAddressable", ()=>isAddressable);
/**
 *  Returns true if %%value%% is a valid address.
 *
 *  @example:
 *    // Valid address
 *    isAddress("0x8ba1f109551bD432803012645Ac136ddd64DBA72")
 *    //_result:
 *
 *    // Valid ICAP address
 *    isAddress("XE65GB6LDNXYOFTX0NSV3FUWKOWIXAMJK36")
 *    //_result:
 *
 *    // Invalid checksum
 *    isAddress("0x8Ba1f109551bD432803012645Ac136ddd64DBa72")
 *    //_result:
 *
 *    // Invalid ICAP checksum
 *    isAddress("0x8Ba1f109551bD432803012645Ac136ddd64DBA72")
 *    //_result:
 *
 *    // Not an address (an ENS name requires a provided and an
 *    // asynchronous API to access)
 *    isAddress("ricmoo.eth")
 *    //_result:
 */ parcelHelpers.export(exports, "isAddress", ()=>isAddress);
/**
 *  Resolves to an address for the %%target%%, which may be any
 *  supported address type, an [[Addressable]] or a Promise which
 *  resolves to an address.
 *
 *  If an ENS name is provided, but that name has not been correctly
 *  configured a [[UnconfiguredNameError]] is thrown.
 *
 *  @example:
 *    addr = "0x6B175474E89094C44Da98b954EedeAC495271d0F"
 *
 *    // Addresses are return synchronously
 *    resolveAddress(addr, provider)
 *    //_result:
 *
 *    // Address promises are resolved asynchronously
 *    resolveAddress(Promise.resolve(addr))
 *    //_result:
 *
 *    // ENS names are resolved asynchronously
 *    resolveAddress("dai.tokens.ethers.eth", provider)
 *    //_result:
 *
 *    // Addressable objects are resolved asynchronously
 *    contract = new Contract(addr, [ ])
 *    resolveAddress(contract, provider)
 *    //_result:
 *
 *    // Unconfigured ENS names reject
 *    resolveAddress("nothing-here.ricmoo.eth", provider)
 *    //_error:
 *
 *    // ENS names require a NameResolver object passed in
 *    // (notice the provider was omitted)
 *    resolveAddress("nothing-here.ricmoo.eth")
 *    //_error:
 */ parcelHelpers.export(exports, "resolveAddress", ()=>resolveAddress);
var _indexJs = require("../utils/index.js");
var _addressJs = require("./address.js");
function isAddressable(value) {
    return value && typeof value.getAddress === "function";
}
function isAddress(value) {
    try {
        (0, _addressJs.getAddress)(value);
        return true;
    } catch (error) {}
    return false;
}
async function checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, _indexJs.assert)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, _indexJs.assertArgument)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, _addressJs.getAddress)(result);
}
function resolveAddress(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, _addressJs.getAddress)(target);
        (0, _indexJs.assert)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return checkAddress(target, resolver.resolveName(target));
    } else if (isAddressable(target)) return checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return checkAddress(target, target);
    (0, _indexJs.assertArgument)(false, "unsupported addressable value", "target", target);
}

},{"../utils/index.js":"4LgPJ","./address.js":"42Zfe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1X2Hf":[function(require,module,exports) {
/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **Typed** class to wrap values providing explicit type information.
 */ parcelHelpers.export(exports, "Typed", ()=>Typed);
var _indexJs = require("../utils/index.js");
const _gaurd = {};
function n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new Typed(_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed,
        width
    });
}
function b(value, size) {
    // @TODO: Check range is valid for value
    return new Typed(_gaurd, `bytes${size ? size : ""}`, value, {
        size
    });
}
const _typedSymbol = Symbol.for("_ethers_typed");
class Typed {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, _indexJs.assertPrivate)(_gaurd, gaurd, "Typed");
        (0, _indexJs.defineProperties)(this, {
            _typedSymbol,
            type,
            value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new Typed(_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new Typed(_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new Typed(_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new Typed(_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new Typed(_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new Typed(_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === _typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if (Typed.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c6PRc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "pack", ()=>pack);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "unpack", ()=>unpack);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "ArrayCoder", ()=>ArrayCoder);
var _indexJs = require("../../utils/index.js");
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
var _anonymousJs = require("./anonymous.js");
function pack(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, _indexJs.assert)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder
                },
                value: values
            });
            (0, _indexJs.assert)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, _indexJs.assertArgument)(false, "invalid tuple value", "tuple", values);
    (0, _indexJs.assertArgument)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, _abstractCoderJs.Writer)();
    let dynamicWriter = new (0, _abstractCoderJs.Writer)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function unpack(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, _indexJs.isError)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, _indexJs.isError)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, _abstractCoderJs.Result).fromItems(values, keys);
}
class ArrayCoder extends (0, _abstractCoderJs.Coder) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, _indexJs.defineProperties)(this, {
            coder,
            length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, _typedJs.Typed).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, _indexJs.assertArgumentCount)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return pack(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, _indexJs.assert)(count * (0, _abstractCoderJs.WordSize) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, _abstractCoderJs.WordSize),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, _anonymousJs.AnonymousCoder)(this.coder));
        return unpack(reader, coders);
    }
}

},{"../../utils/index.js":"4LgPJ","../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","./anonymous.js":"6hZqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6hZqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Clones the functionality of an existing Coder, but without a localName
 *
 *  @_ignore
 */ parcelHelpers.export(exports, "AnonymousCoder", ()=>AnonymousCoder);
var _abstractCoderJs = require("./abstract-coder.js");
class AnonymousCoder extends (0, _abstractCoderJs.Coder) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

},{"./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ee0Z6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "BooleanCoder", ()=>BooleanCoder);
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
class BooleanCoder extends (0, _abstractCoderJs.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, _typedJs.Typed).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}

},{"../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huQUS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "DynamicBytesCoder", ()=>DynamicBytesCoder);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "BytesCoder", ()=>BytesCoder);
var _indexJs = require("../../utils/index.js");
var _abstractCoderJs = require("./abstract-coder.js");
class DynamicBytesCoder extends (0, _abstractCoderJs.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, _indexJs.getBytesCopy)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class BytesCoder extends DynamicBytesCoder {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, _indexJs.hexlify)(super.decode(reader));
    }
}

},{"../../utils/index.js":"4LgPJ","./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ka8EM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "FixedBytesCoder", ()=>FixedBytesCoder);
var _indexJs = require("../../utils/index.js");
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
class FixedBytesCoder extends (0, _abstractCoderJs.Coder) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, _indexJs.defineProperties)(this, {
            size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, _indexJs.getBytesCopy)((0, _typedJs.Typed).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, _indexJs.hexlify)(reader.readBytes(this.size));
    }
}

},{"../../utils/index.js":"4LgPJ","../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6T5Nf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "NullCoder", ()=>NullCoder);
var _abstractCoderJs = require("./abstract-coder.js");
const Empty = new Uint8Array([]);
class NullCoder extends (0, _abstractCoderJs.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes(Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}

},{"./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8jEGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "NumberCoder", ()=>NumberCoder);
var _indexJs = require("../../utils/index.js");
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
const BN_0 = BigInt(0);
const BN_1 = BigInt(1);
const BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class NumberCoder extends (0, _abstractCoderJs.Coder) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, _indexJs.defineProperties)(this, {
            size,
            signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, _indexJs.getBigInt)((0, _typedJs.Typed).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, _indexJs.mask)(BN_MAX_UINT256, (0, _abstractCoderJs.WordSize) * 8);
        if (this.signed) {
            let bounds = (0, _indexJs.mask)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, _indexJs.toTwos)(value, 8 * (0, _abstractCoderJs.WordSize));
        } else if (value < BN_0 || value > (0, _indexJs.mask)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, _indexJs.mask)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, _indexJs.fromTwos)(value, this.size * 8);
        return value;
    }
}

},{"../../utils/index.js":"4LgPJ","../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQ2pV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "StringCoder", ()=>StringCoder);
var _utf8Js = require("../../utils/utf8.js");
var _typedJs = require("../typed.js");
var _bytesJs = require("./bytes.js");
class StringCoder extends (0, _bytesJs.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, _utf8Js.toUtf8Bytes)((0, _typedJs.Typed).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, _utf8Js.toUtf8String)(super.decode(reader));
    }
}

},{"../../utils/utf8.js":"cYEBi","../typed.js":"1X2Hf","./bytes.js":"huQUS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOrdK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "TupleCoder", ()=>TupleCoder);
var _propertiesJs = require("../../utils/properties.js");
var _typedJs = require("../typed.js");
var _abstractCoderJs = require("./abstract-coder.js");
var _arrayJs = require("./array.js");
class TupleCoder extends (0, _abstractCoderJs.Coder) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, _propertiesJs.defineProperties)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, _typedJs.Typed).dereference(_value, "tuple");
        return (0, _arrayJs.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, _arrayJs.unpack)(reader, this.coders);
    }
}

},{"../../utils/properties.js":"aAzWM","../typed.js":"1X2Hf","./abstract-coder.js":"jGfOx","./array.js":"c6PRc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2OG5v":[function(require,module,exports) {
/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Each input and output of a [[Fragment]] is an Array of **ParamType**.
 */ parcelHelpers.export(exports, "ParamType", ()=>ParamType);
/**
 *  An abstract class to represent An individual fragment from a parse ABI.
 */ parcelHelpers.export(exports, "Fragment", ()=>Fragment);
/**
 *  An abstract class to represent An individual fragment
 *  which has a name from a parse ABI.
 */ parcelHelpers.export(exports, "NamedFragment", ()=>NamedFragment);
/**
 *  A Fragment which represents a //Custom Error//.
 */ parcelHelpers.export(exports, "ErrorFragment", ()=>ErrorFragment);
/**
 *  A Fragment which represents an Event.
 */ parcelHelpers.export(exports, "EventFragment", ()=>EventFragment);
/**
 *  A Fragment which represents a constructor.
 */ parcelHelpers.export(exports, "ConstructorFragment", ()=>ConstructorFragment);
/**
 *  A Fragment which represents a method.
 */ parcelHelpers.export(exports, "FallbackFragment", ()=>FallbackFragment);
/**
 *  A Fragment which represents a method.
 */ parcelHelpers.export(exports, "FunctionFragment", ()=>FunctionFragment);
/**
 *  A Fragment which represents a structure.
 */ parcelHelpers.export(exports, "StructFragment", ()=>StructFragment);
var _indexJs = require("../utils/index.js");
var _indexJs1 = require("../hash/index.js");
// [ "a", "b" ] => { "a": 1, "b": 1 }
function setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const _kwVisibDeploy = "external public payable override";
const KwVisibDeploy = setify(_kwVisibDeploy.split(" "));
// Visibility Keywords
const _kwVisib = "constant external internal payable private public pure view override";
const KwVisib = setify(_kwVisib.split(" "));
const _kwTypes = "constructor error event fallback function receive struct";
const KwTypes = setify(_kwTypes.split(" "));
const _kwModifiers = "calldata memory storage payable indexed";
const KwModifiers = setify(_kwModifiers.split(" "));
const _kwOther = "tuple returns";
// All Keywords
const _keywords = [
    _kwTypes,
    _kwModifiers,
    _kwOther,
    _kwVisib
].join(" ");
const Keywords = setify(_keywords.split(" "));
// Single character tokens
const SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const regexWhitespacePrefix = new RegExp("^(\\s*)");
const regexNumberPrefix = new RegExp("^([0-9]+)");
const regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) {
            const top = this.peek();
            throw new Error(`expected ${type}; got ${top.type} ${JSON.stringify(top.text)}`);
        }
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match(regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset,
            value: -1
        };
        tokens.push(token);
        let type = SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, _indexJs.getNumber)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match(regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if (Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match(regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match(regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function consumeName(type, tokens) {
    if (tokens.peekKeyword(KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function consumeMutability(tokens) {
    let modifiers = consumeKeywords(tokens, KwVisib);
    // Detect conflicting modifiers
    allowSingle(modifiers, setify("constant payable nonpayable".split(" ")));
    allowSingle(modifiers, setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>ParamType.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, _indexJs.getBigInt)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens at offset ${tokens.offset}: ${tokens.toString()}`);
}
const regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function verifyBasicType(type) {
    const match = type.match(regexType);
    (0, _indexJs.assertArgument)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, _indexJs.assertArgument)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, _indexJs.assertArgument)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const _guard = {};
const internal = Symbol.for("_ethers_internal");
const ParamTypeInternal = "_ParamTypeInternal";
const ErrorFragmentInternal = "_ErrorInternal";
const EventFragmentInternal = "_EventInternal";
const ConstructorFragmentInternal = "_ConstructorInternal";
const FallbackFragmentInternal = "_FallbackInternal";
const FunctionFragmentInternal = "_FunctionInternal";
const StructFragmentInternal = "_StructInternal";
class ParamType {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, _indexJs.assertPrivate)(guard, _guard, "ParamType");
        Object.defineProperty(this, internal, {
            value: ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, _indexJs.defineProperties)(this, {
            name,
            type,
            baseType,
            indexed,
            components,
            arrayLength,
            arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if (ParamType.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return ParamType.from(lex(obj), allowIndexed);
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if (consumeKeywords(obj, setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>ParamType.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new ParamType(_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = consumeKeywords(obj, KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new ParamType(_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, _indexJs.assertArgument)(!name || typeof name === "string" && name.match(regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, _indexJs.assertArgument)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match(regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = ParamType.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new ParamType(_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>ParamType.from(c)) : null;
            const tuple = new ParamType(_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = verifyBasicType(obj.type);
        return new ParamType(_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[internal] === ParamTypeInternal;
    }
}
class Fragment {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, _indexJs.assertPrivate)(guard, _guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, _indexJs.defineProperties)(this, {
            type,
            inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                Fragment.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return Fragment.from(lex(obj));
        }
        if (obj instanceof TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword(KwTypes);
            switch(type){
                case "constructor":
                    return ConstructorFragment.from(obj);
                case "error":
                    return ErrorFragment.from(obj);
                case "event":
                    return EventFragment.from(obj);
                case "fallback":
                case "receive":
                    return FallbackFragment.from(obj);
                case "function":
                    return FunctionFragment.from(obj);
                case "struct":
                    return StructFragment.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return ConstructorFragment.from(obj);
                case "error":
                    return ErrorFragment.from(obj);
                case "event":
                    return EventFragment.from(obj);
                case "fallback":
                case "receive":
                    return FallbackFragment.from(obj);
                case "function":
                    return FunctionFragment.from(obj);
                case "struct":
                    return StructFragment.from(obj);
            }
            (0, _indexJs.assert)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, _indexJs.assertArgument)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return ConstructorFragment.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return ErrorFragment.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return EventFragment.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return FunctionFragment.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return StructFragment.isFragment(value);
    }
}
class NamedFragment extends Fragment {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, _indexJs.assertArgument)(typeof name === "string" && name.match(regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, _indexJs.defineProperties)(this, {
            name
        });
    }
}
function joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class ErrorFragment extends NamedFragment {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, internal, {
            value: ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, _indexJs1.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if (ErrorFragment.isFragment(obj)) return obj;
        if (typeof obj === "string") return ErrorFragment.from(lex(obj));
        else if (obj instanceof TokenString) {
            const name = consumeName("error", obj);
            const inputs = consumeParams(obj);
            consumeEoi(obj);
            return new ErrorFragment(_guard, name, inputs);
        }
        return new ErrorFragment(_guard, obj.name, obj.inputs ? obj.inputs.map(ParamType.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[internal] === ErrorFragmentInternal;
    }
}
class EventFragment extends NamedFragment {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, internal, {
            value: EventFragmentInternal
        });
        (0, _indexJs.defineProperties)(this, {
            anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, _indexJs1.id)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>ParamType.from(p));
        const fragment = new EventFragment(_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if (EventFragment.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return EventFragment.from(lex(obj));
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            const name = consumeName("event", obj);
            const inputs = consumeParams(obj, true);
            const anonymous = !!consumeKeywords(obj, setify([
                "anonymous"
            ])).has("anonymous");
            consumeEoi(obj);
            return new EventFragment(_guard, name, inputs, anonymous);
        }
        return new EventFragment(_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>ParamType.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[internal] === EventFragmentInternal;
    }
}
class ConstructorFragment extends Fragment {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, internal, {
            value: ConstructorFragmentInternal
        });
        (0, _indexJs.defineProperties)(this, {
            payable,
            gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, _indexJs.assert)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${joinParams(format, this.inputs)}`
        ];
        if (this.payable) result.push("payable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if (ConstructorFragment.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return ConstructorFragment.from(lex(obj));
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            consumeKeywords(obj, setify([
                "constructor"
            ]));
            const inputs = consumeParams(obj);
            const payable = !!consumeKeywords(obj, KwVisibDeploy).has("payable");
            const gas = consumeGas(obj);
            consumeEoi(obj);
            return new ConstructorFragment(_guard, "constructor", inputs, payable, gas);
        }
        return new ConstructorFragment(_guard, "constructor", obj.inputs ? obj.inputs.map(ParamType.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[internal] === ConstructorFragmentInternal;
    }
}
class FallbackFragment extends Fragment {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, internal, {
            value: FallbackFragmentInternal
        });
        (0, _indexJs.defineProperties)(this, {
            payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type,
                stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if (FallbackFragment.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return FallbackFragment.from(lex(obj));
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword(setify([
                "fallback",
                "receive"
            ]));
            (0, _indexJs.assertArgument)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword(setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = consumeParams(obj);
                (0, _indexJs.assertArgument)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                consumeKeywords(obj, setify([
                    "payable"
                ]));
                consumeEoi(obj);
                return new FallbackFragment(_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = consumeParams(obj);
            if (inputs.length) (0, _indexJs.assertArgument)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                ParamType.from("bytes")
            ];
            const mutability = consumeMutability(obj);
            (0, _indexJs.assertArgument)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if (consumeKeywords(obj, setify([
                "returns"
            ])).has("returns")) {
                const outputs = consumeParams(obj);
                (0, _indexJs.assertArgument)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            consumeEoi(obj);
            return new FallbackFragment(_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new FallbackFragment(_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                ParamType.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new FallbackFragment(_guard, inputs, payable);
        }
        (0, _indexJs.assertArgument)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[internal] === FallbackFragmentInternal;
    }
}
class FunctionFragment extends NamedFragment {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, internal, {
            value: FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, _indexJs.defineProperties)(this, {
            constant,
            gas,
            outputs,
            payable,
            stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, _indexJs1.id)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push(joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>ParamType.from(p));
        const fragment = new FunctionFragment(_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if (FunctionFragment.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return FunctionFragment.from(lex(obj));
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            const name = consumeName("function", obj);
            const inputs = consumeParams(obj);
            const mutability = consumeMutability(obj);
            let outputs = [];
            if (consumeKeywords(obj, setify([
                "returns"
            ])).has("returns")) outputs = consumeParams(obj);
            const gas = consumeGas(obj);
            consumeEoi(obj);
            return new FunctionFragment(_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new FunctionFragment(_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map(ParamType.from) : [], obj.outputs ? obj.outputs.map(ParamType.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[internal] === FunctionFragmentInternal;
    }
}
class StructFragment extends NamedFragment {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, internal, {
            value: StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return StructFragment.from(lex(obj));
        } catch (error) {
            (0, _indexJs.assertArgument)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof TokenString) {
            const name = consumeName("struct", obj);
            const inputs = consumeParams(obj);
            consumeEoi(obj);
            return new StructFragment(_guard, name, inputs);
        }
        return new StructFragment(_guard, obj.name, obj.inputs ? obj.inputs.map(ParamType.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[internal] === StructFragmentInternal;
    }
}

},{"../utils/index.js":"4LgPJ","../hash/index.js":"3Gr4x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Gr4x":[function(require,module,exports) {
/**
 *  Utilities for common tasks involving hashing. Also see
 *  [cryptographic hashing](about-crypto-hashing).
 *
 *  @_section: api/hashing:Hashing Utilities  [about-hashing]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "id", ()=>(0, _idJs.id));
parcelHelpers.export(exports, "ensNormalize", ()=>(0, _namehashJs.ensNormalize));
parcelHelpers.export(exports, "isValidName", ()=>(0, _namehashJs.isValidName));
parcelHelpers.export(exports, "namehash", ()=>(0, _namehashJs.namehash));
parcelHelpers.export(exports, "dnsEncode", ()=>(0, _namehashJs.dnsEncode));
parcelHelpers.export(exports, "hashMessage", ()=>(0, _messageJs.hashMessage));
parcelHelpers.export(exports, "verifyMessage", ()=>(0, _messageJs.verifyMessage));
parcelHelpers.export(exports, "solidityPacked", ()=>(0, _solidityJs.solidityPacked));
parcelHelpers.export(exports, "solidityPackedKeccak256", ()=>(0, _solidityJs.solidityPackedKeccak256));
parcelHelpers.export(exports, "solidityPackedSha256", ()=>(0, _solidityJs.solidityPackedSha256));
parcelHelpers.export(exports, "TypedDataEncoder", ()=>(0, _typedDataJs.TypedDataEncoder));
parcelHelpers.export(exports, "verifyTypedData", ()=>(0, _typedDataJs.verifyTypedData));
var _idJs = require("./id.js");
var _namehashJs = require("./namehash.js");
var _messageJs = require("./message.js");
var _solidityJs = require("./solidity.js");
var _typedDataJs = require("./typed-data.js");

},{"./id.js":"2CjJy","./namehash.js":"9i02X","./message.js":"29ahs","./solidity.js":"iiclm","./typed-data.js":"jGS74","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2CjJy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A simple hashing function which operates on UTF-8 strings to
 *  compute an 32-byte identifier.
 *
 *  This simply computes the [UTF-8 bytes](toUtf8Bytes) and computes
 *  the [[keccak256]].
 *
 *  @example:
 *    id("hello world")
 *    //_result:
 */ parcelHelpers.export(exports, "id", ()=>id);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
function id(value) {
    return (0, _indexJs.keccak256)((0, _indexJs1.toUtf8Bytes)(value));
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9i02X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns the ENS %%name%% normalized.
 */ parcelHelpers.export(exports, "ensNormalize", ()=>ensNormalize);
/**
 *  Returns ``true`` if %%name%% is a valid ENS name.
 */ parcelHelpers.export(exports, "isValidName", ()=>isValidName);
/**
 *  Returns the [[link-namehash]] for %%name%%.
 */ parcelHelpers.export(exports, "namehash", ()=>namehash);
/**
 *  Returns the DNS encoded %%name%%.
 *
 *  This is used for various parts of ENS name resolution, such
 *  as the wildcard resolution.
 */ parcelHelpers.export(exports, "dnsEncode", ()=>dnsEncode);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
var _ensNormalize = require("@adraffy/ens-normalize");
const Zeros = new Uint8Array(32);
Zeros.fill(0);
function checkComponent(comp) {
    (0, _indexJs1.assertArgument)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function ensNameSplit(name) {
    const bytes = (0, _indexJs1.toUtf8Bytes)(ensNormalize(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push(checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, _indexJs1.assertArgument)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push(checkComponent(bytes.slice(last)));
    return comps;
}
function ensNormalize(name) {
    try {
        if (name.length === 0) throw new Error("empty label");
        return (0, _ensNormalize.ens_normalize)(name);
    } catch (error) {
        (0, _indexJs1.assertArgument)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function isValidName(name) {
    try {
        return ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function namehash(name) {
    (0, _indexJs1.assertArgument)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    (0, _indexJs1.assertArgument)(name.length, `invalid ENS name (empty label)`, "name", name);
    let result = Zeros;
    const comps = ensNameSplit(name);
    while(comps.length)result = (0, _indexJs.keccak256)((0, _indexJs1.concat)([
        result,
        (0, _indexJs.keccak256)(comps.pop())
    ]));
    return (0, _indexJs1.hexlify)(result);
}
function dnsEncode(name, _maxLength) {
    const length = _maxLength != null ? _maxLength : 63;
    (0, _indexJs1.assertArgument)(length <= 255, "DNS encoded label cannot exceed 255", "length", length);
    return (0, _indexJs1.hexlify)((0, _indexJs1.concat)(ensNameSplit(name).map((comp)=>{
        (0, _indexJs1.assertArgument)(comp.length <= length, `label ${JSON.stringify(name)} exceeds ${length} bytes`, "name", name);
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","@adraffy/ens-normalize":"lhfO9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lhfO9":[function(require,module,exports) {
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-ens data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: 0565ed049b9cf1614bb9e11ba7d8ac6a6fb96c893253d890f7e2b2884b9ded32
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ens_beautify", ()=>ens_beautify);
parcelHelpers.export(exports, "ens_emoji", ()=>ens_emoji);
parcelHelpers.export(exports, "ens_normalize", ()=>ens_normalize);
parcelHelpers.export(exports, "ens_normalize_fragment", ()=>ens_normalize_fragment);
parcelHelpers.export(exports, "ens_split", ()=>ens_split);
parcelHelpers.export(exports, "ens_tokenize", ()=>ens_tokenize);
parcelHelpers.export(exports, "is_combining_mark", ()=>is_combining_mark);
parcelHelpers.export(exports, "nfc", ()=>nfc);
parcelHelpers.export(exports, "nfd", ()=>nfd);
parcelHelpers.export(exports, "safe_str_from_cps", ()=>safe_str_from_cps);
parcelHelpers.export(exports, "should_escape", ()=>should_escape);
var COMPRESSED$1 = "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";
const FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const NSM_MAX = 4;
function decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function read_compressed_payload(s) {
    return read_payload(decode_arithmetic(unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
// 20220922: added for https://github.com/adraffy/ens-normalize.js/issues/4
function unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function read_sorted_arrays(next) {
    return read_array_while(()=>{
        let v = read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push(read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push(read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = read_array_while(next);
    let m = read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function read_replacement_table(w, next) {
    let n = 1 + next();
    let m = read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function read_trie(next) {
    let ret = [];
    let sorted = read_sorted(next);
    expand(decode([]), []);
    return ret; // not sorted
    function decode(Q) {
        let S = next(); // state: valid, save, check
        let B = read_array_while(()=>{
            let cps = read_sorted(next).map((i)=>sorted[i]);
            if (cps.length) return decode(cps);
        });
        return {
            S,
            B,
            Q
        };
    }
    function expand({ S, B }, cps, saved) {
        if (S & 4 && saved === cps[cps.length - 1]) return;
        if (S & 2) saved = cps[cps.length - 1];
        if (S & 1) ret.push(cps);
        for (let br of B)for (let cp of br.Q)expand(br, [
            ...cps,
            cp
        ], saved);
    }
}
function hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function quote_cp(cp) {
    return `{${hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-09-25T01:01:55.148Z
// compressed base64-encoded blob for include-nf data
// source: https://github.com/adraffy/ens-normalize.js/blob/main/src/make.js
// see: https://github.com/adraffy/ens-normalize.js#security
// SHA-256: a974b6f8541fc29d919bc85118af0a44015851fab5343f8679cb31be2bdb209e
var COMPRESSED = "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";
// https://unicode.org/reports/tr15/
// for reference implementation
// see: /derive/nf.js
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const S0 = 0xAC00;
const L0 = 0x1100;
const V0 = 0x1161;
const T0 = 0x11A7;
const L_COUNT = 19;
const V_COUNT = 21;
const T_COUNT = 28;
const N_COUNT = V_COUNT * T_COUNT;
const S_COUNT = L_COUNT * N_COUNT;
const S1 = S0 + S_COUNT;
const L1 = L0 + L_COUNT;
const V1 = V0 + V_COUNT;
const T1 = T0 + T_COUNT;
function unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
let SHIFTED_RANK, EXCLUSIONS, DECOMP, RECOMP;
function init$1() {
    //console.time('nf');
    let r = read_compressed_payload(COMPRESSED);
    SHIFTED_RANK = new Map(read_sorted_arrays(r).flatMap((v, i)=>v.map((x)=>[
                x,
                i + 1 << 24
            ]))); // pre-shifted
    EXCLUSIONS = new Set(read_sorted(r));
    DECOMP = new Map();
    RECOMP = new Map();
    for (let [cp, cps] of read_mapped(r)){
        if (!EXCLUSIONS.has(cp) && cps.length == 2) {
            let [a, b] = cps;
            let bucket = RECOMP.get(a);
            if (!bucket) {
                bucket = new Map();
                RECOMP.set(a, bucket);
            }
            bucket.set(b, cp);
        }
        DECOMP.set(cp, cps.reverse()); // stored reversed
    }
//console.timeEnd('nf');
// 20230905: 11ms
}
function is_hangul(cp) {
    return cp >= S0 && cp < S1;
}
function compose_pair(a, b) {
    if (a >= L0 && a < L1 && b >= V0 && b < V1) return S0 + (a - L0) * N_COUNT + (b - V0) * T_COUNT;
    else if (is_hangul(a) && b > T0 && b < T1 && (a - S0) % T_COUNT == 0) return a + (b - T0);
    else {
        let recomp = RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function decomposed(cps) {
    if (!SHIFTED_RANK) init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if (is_hangul(cp)) {
            let s_index = cp - S0;
            let l_index = s_index / N_COUNT | 0;
            let v_index = s_index % N_COUNT / T_COUNT | 0;
            let t_index = s_index % T_COUNT;
            add(L0 + l_index);
            add(V0 + v_index);
            if (t_index > 0) add(T0 + t_index);
        } else {
            let mapped = DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = unpack_cc(ret[i]);
        }
    }
    return ret;
}
function composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = unpack_cc(packed);
        let cp = unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function nfd(cps) {
    return decomposed(cps).map(unpack_cp);
}
function nfc(cps) {
    return composed_from_decomposed(decomposed(cps));
}
const HYPHEN = 0x2D;
const STOP = 0x2E;
const STOP_CH = ".";
const FE0F = 0xFE0F;
const UNIQUE_PH = 1;
// 20230913: replace [...v] with Array_from(v) to avoid large spreads
const Array_from = (x)=>Array.from(x); // Array.from.bind(Array);
function group_has_cp(g, cp) {
    // 20230913: keep primary and secondary distinct instead of creating valid union
    return g.P.has(cp) || g.Q.has(cp);
}
class Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
let MAPPED, IGNORED, CM, NSM, ESCAPE, NFC_CHECK, GROUPS, WHOLE_VALID, WHOLE_MAP, VALID, EMOJI_LIST, EMOJI_ROOT;
function init() {
    if (MAPPED) return;
    let r = read_compressed_payload(COMPRESSED$1);
    const read_sorted_array = ()=>read_sorted(r);
    const read_sorted_set = ()=>new Set(read_sorted_array());
    const set_add_many = (set, v)=>v.forEach((x)=>set.add(x));
    MAPPED = new Map(read_mapped(r));
    IGNORED = read_sorted_set(); // ignored characters are not valid, so just read raw codepoints
    /*
	// direct include from payload is smaller than the decompression code
	const FENCED = new Map(read_array_while(() => {
		let cp = r();
		if (cp) return [cp, read_str(r())];
	}));
	*/ // 20230217: we still need all CM for proper error formatting
    // but norm only needs NSM subset that are potentially-valid
    CM = read_sorted_array();
    NSM = new Set(read_sorted_array().map((i)=>CM[i]));
    CM = new Set(CM);
    ESCAPE = read_sorted_set(); // characters that should not be printed
    NFC_CHECK = read_sorted_set(); // only needed to illustrate ens_tokenize() transformations
    let chunks = read_sorted_arrays(r);
    let unrestricted = r();
    //const read_chunked = () => new Set(read_sorted_array().flatMap(i => chunks[i]).concat(read_sorted_array()));
    const read_chunked = ()=>{
        // 20230921: build set in parts, 2x faster
        let set = new Set();
        read_sorted_array().forEach((i)=>set_add_many(set, chunks[i]));
        set_add_many(set, read_sorted_array());
        return set;
    };
    GROUPS = read_array_while((i)=>{
        // minifier property mangling seems unsafe
        // so these are manually renamed to single chars
        let N = read_array_while(r).map((x)=>x + 0x60);
        if (N.length) {
            let R = i >= unrestricted; // unrestricted then restricted
            N[0] -= 32; // capitalize
            N = str_from_cps(N);
            if (R) N = `Restricted[${N}]`;
            let P = read_chunked(); // primary
            let Q = read_chunked(); // secondary
            let M = !r(); // not-whitelisted, check for NSM
            // *** this code currently isn't needed ***
            /*
			let V = [...P, ...Q].sort((a, b) => a-b); // derive: sorted valid
			let M = r()-1; // number of combining mark
			if (M < 0) { // whitelisted
				M = new Map(read_array_while(() => {
					let i = r();
					if (i) return [V[i-1], read_array_while(() => {
						let v = read_array_while(r);
						if (v.length) return v.map(x => x-1);
					})];
				}));
			}*/ return {
                N,
                P,
                Q,
                M,
                R
            };
        }
    });
    // decode compressed wholes
    WHOLE_VALID = read_sorted_set();
    WHOLE_MAP = new Map();
    let wholes = read_sorted_array().concat(Array_from(WHOLE_VALID)).sort((a, b)=>a - b); // must be sorted
    wholes.forEach((cp, i)=>{
        let d = r();
        let w = wholes[i] = d ? wholes[i - d] : {
            V: [],
            M: new Map()
        };
        w.V.push(cp); // add to member set
        if (!WHOLE_VALID.has(cp)) WHOLE_MAP.set(cp, w); // register with whole map
    });
    // compute confusable-extent complements
    // usage: WHOLE_MAP.get(cp).M.get(cp) = complement set
    for (let { V, M } of new Set(WHOLE_MAP.values())){
        // connect all groups that have each whole character
        let recs = [];
        for (let cp of V){
            let gs = GROUPS.filter((g)=>group_has_cp(g, cp));
            let rec = recs.find(({ G })=>gs.some((g)=>G.has(g)));
            if (!rec) {
                rec = {
                    G: new Set(),
                    V: []
                };
                recs.push(rec);
            }
            rec.V.push(cp);
            set_add_many(rec.G, gs);
        }
        // per character cache groups which are not a member of the extent
        let union = recs.flatMap((x)=>Array_from(x.G)); // all of the groups used by this whole
        for (let { G, V } of recs){
            let complement = new Set(union.filter((g)=>!G.has(g))); // groups not covered by the extent
            for (let cp of V)M.set(cp, complement); // this is the same reference
        }
    }
    // compute valid set
    // 20230924: VALID was union but can be re-used
    VALID = new Set(); // exists in 1+ groups
    let multi = new Set(); // exists in 2+ groups
    const add_to_union = (cp)=>VALID.has(cp) ? multi.add(cp) : VALID.add(cp);
    for (let g of GROUPS){
        for (let cp of g.P)add_to_union(cp);
        for (let cp of g.Q)add_to_union(cp);
    }
    // dual purpose WHOLE_MAP: return placeholder if unique non-confusable
    for (let cp of VALID)if (!WHOLE_MAP.has(cp) && !multi.has(cp)) WHOLE_MAP.set(cp, UNIQUE_PH);
    // add all decomposed parts
    // see derive: "Valid is Closed (via Brute-force)"
    set_add_many(VALID, nfd(VALID));
    // decode emoji
    // 20230719: emoji are now fully-expanded to avoid quirk logic 
    EMOJI_LIST = read_trie(r).map((v)=>Emoji.from(v)).sort(compare_arrays);
    EMOJI_ROOT = new Map(); // this has approx 7K nodes (2+ per emoji)
    for (let cps of EMOJI_LIST){
        // 20230719: change to *slightly* stricter algorithm which disallows 
        // insertion of misplaced FE0F in emoji sequences (matching ENSIP-15)
        // example: beautified [A B] (eg. flag emoji) 
        //  before: allow: [A FE0F B], error: [A FE0F FE0F B] 
        //   after: error: both
        // note: this code now matches ENSNormalize.{cs,java} logic
        let prev = [
            EMOJI_ROOT
        ];
        for (let cp of cps){
            let next = prev.map((node)=>{
                let child = node.get(cp);
                if (!child) {
                    // should this be object? 
                    // (most have 1-2 items, few have many)
                    // 20230719: no, v8 default map is 4?
                    child = new Map();
                    node.set(cp, child);
                }
                return child;
            });
            if (cp === FE0F) prev.push(...next); // less than 20 elements
            else prev = next;
        }
        for (let x of prev)x.V = cps;
    }
}
// if escaped: {HEX}
//       else: "x" {HEX}
function quoted_cp(cp) {
    return (should_escape(cp) ? "" : `${bidi_qq(safe_str_from_cps([
        cp
    ]))} `) + quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == HYPHEN && cps[3] == HYPHEN) throw new Error(`invalid label extension: "${str_from_cps(cps.slice(0, 4))}"`); // this can only be ascii so cant be bidi
}
function check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function check_fenced(cps) {
    let cp = cps[0];
    let prev = FENCED.get(cp);
    if (prev) throw error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw error_placement(`trailing ${prev}`);
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// if cps exceed max, middle truncate with ellipsis
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function safe_str_from_cps(cps, max = Infinity, quoter = quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if (is_combining_mark(cps[0])) buf.push("\u25CC");
    if (cps.length > max) {
        max >>= 1;
        cps = [
            ...cps.slice(0, max),
            0x2026,
            ...cps.slice(-max)
        ];
    }
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if (should_escape(cp)) {
            buf.push(str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push(str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// note: set(s) cannot be exposed because they can be modified
// note: Object.freeze() doesn't work
function is_combining_mark(cp) {
    init();
    return CM.has(cp);
}
function should_escape(cp) {
    init();
    return ESCAPE.has(cp);
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function ens_emoji() {
    init();
    return EMOJI_LIST.map((x)=>x.slice()); // emoji are exposed so copy
}
function ens_normalize_fragment(frag, decompose) {
    init();
    let nf = decompose ? nfd : nfc;
    return frag.split(STOP_CH).map((label)=>str_from_cps(tokens_from_str(explode_cp(label), nf, filter_fe0f).flat())).join(STOP_CH);
}
function ens_normalize(name) {
    return flatten(split(name, nfc, filter_fe0f));
}
function ens_beautify(name) {
    let labels = split(name, nfc, (x)=>x); // emoji not exposed
    for (let { type, output, error } of labels){
        if (error) break; // flatten will throw
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") array_replace(output, 0x3BE, 0x39E);
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    // https://discuss.ens.domains/t/bidi-label-ordering-spoof/15824
    //output.splice(0, 0, 0x200E);
    }
    return flatten(labels);
}
function array_replace(v, a, b) {
    let prev = 0;
    while(true){
        let next = v.indexOf(a, prev);
        if (next < 0) break;
        v[next] = b;
        prev = next + 1;
    }
}
function ens_split(name, preserve_emoji) {
    return split(name, nfc, preserve_emoji ? (x)=>x.slice() : filter_fe0f); // emoji are exposed so copy
}
function split(name, nf, ef) {
    if (!name) return []; // 20230719: empty name allowance
    init();
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split(STOP_CH).map((label)=>{
        let input = explode_cp(label);
        let info = {
            input,
            offset
        };
        offset += input.length + 1; // + stop
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = tokens_from_str(input, nf, ef);
            let token_count = tokens.length;
            let type;
            if (!token_count) //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            throw new Error(`empty label`);
            let norm = info.output = tokens.flat();
            check_leading_underscore(norm);
            let emoji = info.emoji = token_count > 1 || tokens[0].is_emoji; // same as: tokens.some(x => x.is_emoji);
            if (!emoji && norm.every((cp)=>cp < 0x80)) {
                // 20230123: matches matches WHATWG, see note 3.3
                check_label_extension(norm); // only needed for ascii
                // cant have fenced
                // cant have cm
                // cant have wholes
                // see derive: "Fastpath ASCII"
                type = "ASCII";
            } else {
                let chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                if (!chars.length) type = "Emoji";
                else {
                    // 5.) "The label must not begin with a combining mark, that is: General_Category=Mark."
                    if (CM.has(norm[0])) throw error_placement("leading combining mark");
                    for(let i = 1; i < token_count; i++){
                        let cps = tokens[i];
                        if (!cps.is_emoji && CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                        throw error_placement(`emoji + combining mark: "${str_from_cps(tokens[i - 1])} + ${safe_str_from_cps([
                            cps[0]
                        ])}"`);
                    }
                    check_fenced(norm);
                    let unique = Array_from(new Set(chars));
                    let [g] = determine_group(unique); // take the first match
                    // see derive: "Matching Groups have Same CM Style"
                    // alternative: could form a hybrid type: Latin/Japanese/...	
                    check_group(g, chars); // need text in order
                    check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                    type = g.N;
                // 20230121: consider exposing restricted flag
                // it's simpler to just check for 'Restricted'
                // or even better: type.endsWith(']')
                //if (g.R) info.restricted = true;
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        return info;
    });
}
function check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp of unique){
        let whole = WHOLE_MAP.get(cp);
        if (whole === UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : Array_from(set);
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaining groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>group_has_cp(g, cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function determine_group(unique) {
    let groups = GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>group_has_cp(g, cp));
        if (!gs.length) {
            if (!GROUPS.some((g)=>group_has_cp(g, cp))) // the character was composed of valid parts
            // but it's NFC form is invalid
            // 20230716: change to more exact statement, see: ENSNormalize.{cs,java}
            // note: this doesn't have to be a composition
            // 20230720: change to full check
            throw error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function flatten(split) {
    return split.map(({ input, error, output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${bidi_qq(safe_str_from_cps(input, 63))}: ${msg}`);
        }
        return str_from_cps(output);
    }).join(STOP_CH);
}
function error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${quoted_cp(cp)}`);
}
function error_group_member(g, cp) {
    let quoted = quoted_cp(cp);
    let gg = GROUPS.find((g)=>g.P.has(cp)); // only check primary
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function check_group(g, cps) {
    for (let cp of cps){
        if (!group_has_cp(g, cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.P, ...g.Q].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (g.M) {
        let decomposed = nfd(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if (NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`duplicate non-spacing marks: ${quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`excessive non-spacing marks: ${bidi_qq(safe_str_from_cps(decomposed.slice(i - 1, j)))} (${j - i}/${NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
// 20230818: rename for 'process' name collision h/t Javarome
// https://github.com/adraffy/ens-normalize.js/issues/23
function tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(ef(emoji));
        } else {
            let cp = input.pop();
            if (VALID.has(cp)) chars.push(cp);
            else {
                let cps = MAPPED.get(cp);
                if (cps) chars.push(...cps); // less than 10 elements
                else if (!IGNORED.has(cp)) // 20230912: unicode 15.1 changed the order of processing such that
                // disallowed parts are only rejected after NFC
                // https://unicode.org/reports/tr46/#Validity_Criteria
                // this doesn't impact normalization as of today
                // technically, this error can be removed as the group logic will apply similar logic
                // however the error type might be less clear
                throw error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function filter_fe0f(cps) {
    return cps.filter((cp)=>cp != FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function consume_emoji_reversed(cps, eaten) {
    let node = EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while(pos){
        node = node.get(cps[--pos]);
        if (!node) break;
        let { V } = node;
        if (V) {
            emoji = V;
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // (optional) copy input, used for ens_tokenize()
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
// ************************************************************
// tokenizer 
const TY_VALID = "valid";
const TY_MAPPED = "mapped";
const TY_IGNORED = "ignored";
const TY_DISALLOWED = "disallowed";
const TY_EMOJI = "emoji";
const TY_NFC = "nfc";
const TY_STOP = "stop";
function ens_tokenize(name, { nf = true } = {}) {
    init();
    let input = explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = consume_emoji_reversed(input, eaten);
        if (emoji) {
            tokens.push({
                type: TY_EMOJI,
                emoji: emoji.slice(),
                input: eaten,
                cps: filter_fe0f(emoji)
            });
            eaten = []; // reset buffer
        } else {
            let cp = input.pop();
            if (cp == STOP) tokens.push({
                type: TY_STOP,
                cp
            });
            else if (VALID.has(cp)) tokens.push({
                type: TY_VALID,
                cps: [
                    cp
                ]
            });
            else if (IGNORED.has(cp)) tokens.push({
                type: TY_IGNORED,
                cp
            });
            else {
                let cps = MAPPED.get(cp);
                if (cps) tokens.push({
                    type: TY_MAPPED,
                    cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: TY_DISALLOWED,
                    cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if (is_valid_or_mapped(token.type)) {
            if (requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type, cps } = tokens[pos];
                    if (is_valid_or_mapped(type)) {
                        if (!requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = nfc(cps0);
                if (compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: TY_NFC,
                        input: cps0,
                        cps,
                        tokens0: collapse_valid_tokens(slice),
                        tokens: ens_tokenize(str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== TY_IGNORED) start = -1; // reset
    }
    return collapse_valid_tokens(tokens);
}
function is_valid_or_mapped(type) {
    return type == TY_VALID || type == TY_MAPPED;
}
function requires_check(cps) {
    return cps.some((cp)=>NFC_CHECK.has(cp));
}
function collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29ahs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Computes the [[link-eip-191]] personal-sign message digest to sign.
 *
 *  This prefixes the message with [[MessagePrefix]] and the decimal length
 *  of %%message%% and computes the [[keccak256]] digest.
 *
 *  If %%message%% is a string, it is converted to its UTF-8 bytes
 *  first. To compute the digest of a [[DataHexString]], it must be converted
 *  to [bytes](getBytes).
 *
 *  @example:
 *    hashMessage("Hello World")
 *    //_result:
 *
 *    // Hashes the SIX (6) string characters, i.e.
 *    // [ "0", "x", "4", "2", "4", "3" ]
 *    hashMessage("0x4243")
 *    //_result:
 *
 *    // Hashes the TWO (2) bytes [ 0x42, 0x43 ]...
 *    hashMessage(getBytes("0x4243"))
 *    //_result:
 *
 *    // ...which is equal to using data
 *    hashMessage(new Uint8Array([ 0x42, 0x43 ]))
 *    //_result:
 *
 */ parcelHelpers.export(exports, "hashMessage", ()=>hashMessage);
/**
 *  Return the address of the private key that produced
 *  the signature %%sig%% during signing for %%message%%.
 */ parcelHelpers.export(exports, "verifyMessage", ()=>verifyMessage);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../constants/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
function hashMessage(message) {
    if (typeof message === "string") message = (0, _indexJs3.toUtf8Bytes)(message);
    return (0, _indexJs.keccak256)((0, _indexJs3.concat)([
        (0, _indexJs3.toUtf8Bytes)((0, _indexJs1.MessagePrefix)),
        (0, _indexJs3.toUtf8Bytes)(String(message.length)),
        message
    ]));
}
function verifyMessage(message, sig) {
    const digest = hashMessage(message);
    return (0, _indexJs2.recoverAddress)(digest, sig);
}

},{"../crypto/index.js":"jUsZl","../constants/index.js":"8Nw3O","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iFcfw":[function(require,module,exports) {
/**
 *  Each state-changing operation on Ethereum requires a transaction.
 *
 *  @_section api/transaction:Transactions  [about-transactions]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accessListify", ()=>(0, _accesslistJs.accessListify));
parcelHelpers.export(exports, "computeAddress", ()=>(0, _addressJs.computeAddress));
parcelHelpers.export(exports, "recoverAddress", ()=>(0, _addressJs.recoverAddress));
parcelHelpers.export(exports, "Transaction", ()=>(0, _transactionJs.Transaction));
var _accesslistJs = require("./accesslist.js");
var _addressJs = require("./address.js");
var _transactionJs = require("./transaction.js");

},{"./accesslist.js":"8vgfS","./address.js":"17Xld","./transaction.js":"6tdts","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vgfS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns a [[AccessList]] from any ethers-supported access-list structure.
 */ parcelHelpers.export(exports, "accessListify", ()=>accessListify);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../utils/index.js");
function accessSetify(addr, storageKeys) {
    return {
        address: (0, _indexJs.getAddress)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, _indexJs1.assertArgument)((0, _indexJs1.isHexString)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function accessListify(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, _indexJs1.assertArgument)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return accessSetify(set[0], set[1]);
        }
        (0, _indexJs1.assertArgument)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return accessSetify(set.address, set.storageKeys);
    });
    (0, _indexJs1.assertArgument)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}

},{"../address/index.js":"3THmk","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17Xld":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns the address for the %%key%%.
 *
 *  The key may be any standard form of public key or a private key.
 */ parcelHelpers.export(exports, "computeAddress", ()=>computeAddress);
/**
 *  Returns the recovered address for the private key that was
 *  used to sign %%digest%% that resulted in %%signature%%.
 */ parcelHelpers.export(exports, "recoverAddress", ()=>recoverAddress);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
function computeAddress(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, _indexJs1.SigningKey).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, _indexJs.getAddress)((0, _indexJs1.keccak256)("0x" + pubkey.substring(4)).substring(26));
}
function recoverAddress(digest, signature) {
    return computeAddress((0, _indexJs1.SigningKey).recoverPublicKey(digest, signature));
}

},{"../address/index.js":"3THmk","../crypto/index.js":"jUsZl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tdts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **Transaction** describes an operation to be executed on
 *  Ethereum by an Externally Owned Account (EOA). It includes
 *  who (the [[to]] address), what (the [[data]]) and how much (the
 *  [[value]] in ether) the operation should entail.
 *
 *  @example:
 *    tx = new Transaction()
 *    //_result:
 *
 *    tx.data = "0x1234";
 *    //_result:
 */ parcelHelpers.export(exports, "Transaction", ()=>Transaction);
var _indexJs = require("../address/index.js");
var _addressesJs = require("../constants/addresses.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../utils/index.js");
var _accesslistJs = require("./accesslist.js");
var _addressJs = require("./address.js");
const BN_0 = BigInt(0);
const BN_2 = BigInt(2);
const BN_27 = BigInt(27);
const BN_28 = BigInt(28);
const BN_35 = BigInt(35);
const BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function handleAddress(value) {
    if (value === "0x") return null;
    return (0, _indexJs.getAddress)(value);
}
function handleAccessList(value, param) {
    try {
        return (0, _accesslistJs.accessListify)(value);
    } catch (error) {
        (0, _indexJs2.assertArgument)(false, error.message, param, value);
    }
}
function handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, _indexJs2.getNumber)(_value, param);
}
function handleUint(_value, param) {
    if (_value === "0x") return BN_0;
    const value = (0, _indexJs2.getBigInt)(_value, param);
    (0, _indexJs2.assertArgument)(value <= BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function formatNumber(_value, name) {
    const value = (0, _indexJs2.getBigInt)(_value, "value");
    const result = (0, _indexJs2.toBeArray)(value);
    (0, _indexJs2.assertArgument)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function formatAccessList(value) {
    return (0, _accesslistJs.accessListify)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function formatHashes(value, param) {
    (0, _indexJs2.assertArgument)(Array.isArray(value), `invalid ${param}`, "value", value);
    for(let i = 0; i < value.length; i++)(0, _indexJs2.assertArgument)((0, _indexJs2.isHexString)(value[i], 32), "invalid ${ param } hash", `value[${i}]`, value[i]);
    return value;
}
function _parseLegacy(data) {
    const fields = (0, _indexJs2.decodeRlp)(data);
    (0, _indexJs2.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: handleNumber(fields[0], "nonce"),
        gasPrice: handleUint(fields[1], "gasPrice"),
        gasLimit: handleUint(fields[2], "gasLimit"),
        to: handleAddress(fields[3]),
        value: handleUint(fields[4], "value"),
        data: (0, _indexJs2.hexlify)(fields[5]),
        chainId: BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = handleUint(fields[6], "v");
    const r = handleUint(fields[7], "r");
    const s = handleUint(fields[8], "s");
    if (r === BN_0 && s === BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - BN_35) / BN_2;
        if (chainId < BN_0) chainId = BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, _indexJs2.assertArgument)(chainId !== BN_0 || v === BN_27 || v === BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, _indexJs1.Signature).from({
            r: (0, _indexJs2.zeroPadValue)(fields[7], 32),
            s: (0, _indexJs2.zeroPadValue)(fields[8], 32),
            v
        });
        tx.hash = (0, _indexJs1.keccak256)(data);
    }
    return tx;
}
function _serializeLegacy(tx, sig) {
    const fields = [
        formatNumber(tx.nonce, "nonce"),
        formatNumber(tx.gasPrice || 0, "gasPrice"),
        formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        formatNumber(tx.value, "value"),
        tx.data
    ];
    let chainId = BN_0;
    if (tx.chainId != BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, _indexJs2.getBigInt)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, _indexJs2.assertArgument)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== BN_0) {
            fields.push((0, _indexJs2.toBeArray)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, _indexJs2.encodeRlp)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== BN_0) v = (0, _indexJs1.Signature).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, _indexJs2.assertArgument)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, _indexJs2.toBeArray)(v));
    fields.push((0, _indexJs2.toBeArray)(sig.r));
    fields.push((0, _indexJs2.toBeArray)(sig.s));
    return (0, _indexJs2.encodeRlp)(fields);
}
function _parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, _indexJs2.assertArgument)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, _indexJs2.zeroPadValue)(fields[1], 32);
    const s = (0, _indexJs2.zeroPadValue)(fields[2], 32);
    const signature = (0, _indexJs1.Signature).from({
        r,
        s,
        yParity
    });
    tx.signature = signature;
}
function _parseEip1559(data) {
    const fields = (0, _indexJs2.decodeRlp)((0, _indexJs2.getBytes)(data).slice(1));
    (0, _indexJs2.assertArgument)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, _indexJs2.hexlify)(data));
    const tx = {
        type: 2,
        chainId: handleUint(fields[0], "chainId"),
        nonce: handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: handleUint(fields[4], "gasLimit"),
        to: handleAddress(fields[5]),
        value: handleUint(fields[6], "value"),
        data: (0, _indexJs2.hexlify)(fields[7]),
        accessList: handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    tx.hash = (0, _indexJs1.keccak256)(data);
    _parseEipSignature(tx, fields.slice(9));
    return tx;
}
function _serializeEip1559(tx, sig) {
    const fields = [
        formatNumber(tx.chainId, "chainId"),
        formatNumber(tx.nonce, "nonce"),
        formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        formatNumber(tx.value, "value"),
        tx.data,
        formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push(formatNumber(sig.yParity, "yParity"));
        fields.push((0, _indexJs2.toBeArray)(sig.r));
        fields.push((0, _indexJs2.toBeArray)(sig.s));
    }
    return (0, _indexJs2.concat)([
        "0x02",
        (0, _indexJs2.encodeRlp)(fields)
    ]);
}
function _parseEip2930(data) {
    const fields = (0, _indexJs2.decodeRlp)((0, _indexJs2.getBytes)(data).slice(1));
    (0, _indexJs2.assertArgument)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, _indexJs2.hexlify)(data));
    const tx = {
        type: 1,
        chainId: handleUint(fields[0], "chainId"),
        nonce: handleNumber(fields[1], "nonce"),
        gasPrice: handleUint(fields[2], "gasPrice"),
        gasLimit: handleUint(fields[3], "gasLimit"),
        to: handleAddress(fields[4]),
        value: handleUint(fields[5], "value"),
        data: (0, _indexJs2.hexlify)(fields[6]),
        accessList: handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    tx.hash = (0, _indexJs1.keccak256)(data);
    _parseEipSignature(tx, fields.slice(8));
    return tx;
}
function _serializeEip2930(tx, sig) {
    const fields = [
        formatNumber(tx.chainId, "chainId"),
        formatNumber(tx.nonce, "nonce"),
        formatNumber(tx.gasPrice || 0, "gasPrice"),
        formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || "0x",
        formatNumber(tx.value, "value"),
        tx.data,
        formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push(formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, _indexJs2.toBeArray)(sig.r));
        fields.push((0, _indexJs2.toBeArray)(sig.s));
    }
    return (0, _indexJs2.concat)([
        "0x01",
        (0, _indexJs2.encodeRlp)(fields)
    ]);
}
function _parseEip4844(data) {
    const fields = (0, _indexJs2.decodeRlp)((0, _indexJs2.getBytes)(data).slice(1));
    (0, _indexJs2.assertArgument)(Array.isArray(fields) && (fields.length === 11 || fields.length === 14), "invalid field count for transaction type: 3", "data", (0, _indexJs2.hexlify)(data));
    const tx = {
        type: 3,
        chainId: handleUint(fields[0], "chainId"),
        nonce: handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: handleUint(fields[2], "maxPriorityFeePerGas"),
        maxFeePerGas: handleUint(fields[3], "maxFeePerGas"),
        gasPrice: null,
        gasLimit: handleUint(fields[4], "gasLimit"),
        to: handleAddress(fields[5]),
        value: handleUint(fields[6], "value"),
        data: (0, _indexJs2.hexlify)(fields[7]),
        accessList: handleAccessList(fields[8], "accessList"),
        maxFeePerBlobGas: handleUint(fields[9], "maxFeePerBlobGas"),
        blobVersionedHashes: fields[10]
    };
    (0, _indexJs2.assertArgument)(tx.to != null, "invalid address for transaction type: 3", "data", data);
    (0, _indexJs2.assertArgument)(Array.isArray(tx.blobVersionedHashes), "invalid blobVersionedHashes: must be an array", "data", data);
    for(let i = 0; i < tx.blobVersionedHashes.length; i++)(0, _indexJs2.assertArgument)((0, _indexJs2.isHexString)(tx.blobVersionedHashes[i], 32), `invalid blobVersionedHash at index ${i}: must be length 32`, "data", data);
    // Unsigned EIP-4844 Transaction
    if (fields.length === 11) return tx;
    tx.hash = (0, _indexJs1.keccak256)(data);
    _parseEipSignature(tx, fields.slice(11));
    return tx;
}
function _serializeEip4844(tx, sig) {
    const fields = [
        formatNumber(tx.chainId, "chainId"),
        formatNumber(tx.nonce, "nonce"),
        formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(tx.gasLimit, "gasLimit"),
        tx.to || (0, _addressesJs.ZeroAddress),
        formatNumber(tx.value, "value"),
        tx.data,
        formatAccessList(tx.accessList || []),
        formatNumber(tx.maxFeePerBlobGas || 0, "maxFeePerBlobGas"),
        formatHashes(tx.blobVersionedHashes || [], "blobVersionedHashes")
    ];
    if (sig) {
        fields.push(formatNumber(sig.yParity, "yParity"));
        fields.push((0, _indexJs2.toBeArray)(sig.r));
        fields.push((0, _indexJs2.toBeArray)(sig.s));
    }
    return (0, _indexJs2.concat)([
        "0x03",
        (0, _indexJs2.encodeRlp)(fields)
    ]);
}
class Transaction {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    #maxFeePerBlobGas;
    #blobVersionedHashes;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            case 3:
            case "cancun":
            case "eip-4844":
                this.#type = 3;
                break;
            default:
                (0, _indexJs2.assertArgument)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
            case 3:
                return "eip-4844";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        const value = this.#to;
        if (value == null && this.type === 3) return 0, _addressesJs.ZeroAddress;
        return value;
    }
    set to(value) {
        this.#to = value == null ? null : (0, _indexJs.getAddress)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, _indexJs2.getNumber)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, _indexJs2.getBigInt)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, _indexJs2.getBigInt)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, _indexJs2.getBigInt)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2 || this.type === 3) return BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, _indexJs2.getBigInt)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, _indexJs2.hexlify)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, _indexJs2.getBigInt)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, _indexJs2.getBigInt)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, _indexJs1.Signature).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2 || this.type === 3) // @TODO: in v7, this should assign the value or become
            // a live object itself, otherwise mutation is inconsistent
            return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, _accesslistJs.accessListify)(value);
    }
    /**
     *  The max fee per blob gas for Cancun transactions.
     */ get maxFeePerBlobGas() {
        const value = this.#maxFeePerBlobGas;
        if (value == null && this.type === 3) return BN_0;
        return value;
    }
    set maxFeePerBlobGas(value) {
        this.#maxFeePerBlobGas = value == null ? null : (0, _indexJs2.getBigInt)(value, "maxFeePerBlobGas");
    }
    /**
     *  The BLOB versioned hashes for Cancun transactions.
     */ get blobVersionedHashes() {
        // @TODO: Mutation is inconsistent; if unset, the returned value
        // cannot mutate the object, if set it can
        let value = this.#blobVersionedHashes;
        if (value == null && this.type === 3) return [];
        return value;
    }
    set blobVersionedHashes(value) {
        if (value != null) {
            (0, _indexJs2.assertArgument)(Array.isArray(value), "blobVersionedHashes must be an Array", "value", value);
            value = value.slice();
            for(let i = 0; i < value.length; i++)(0, _indexJs2.assertArgument)((0, _indexJs2.isHexString)(value[i], 32), "invalid blobVersionedHash", `value[${i}]`, value[i]);
        }
        this.#blobVersionedHashes = value;
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = BN_0;
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = BN_0;
        this.#chainId = BN_0;
        this.#sig = null;
        this.#accessList = null;
        this.#maxFeePerBlobGas = null;
        this.#blobVersionedHashes = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, _indexJs1.keccak256)(this.serialized);
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, _indexJs1.keccak256)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, _addressJs.recoverAddress)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, _indexJs1.SigningKey).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        (0, _indexJs2.assert)(this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        switch(this.inferType()){
            case 0:
                return _serializeLegacy(this, this.signature);
            case 1:
                return _serializeEip2930(this, this.signature);
            case 2:
                return _serializeEip1559(this, this.signature);
            case 3:
                return _serializeEip4844(this, this.signature);
        }
        (0, _indexJs2.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        switch(this.inferType()){
            case 0:
                return _serializeLegacy(this);
            case 1:
                return _serializeEip2930(this);
            case 2:
                return _serializeEip1559(this);
            case 3:
                return _serializeEip4844(this);
        }
        (0, _indexJs2.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".unsignedSerialized"
        });
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        const types = this.inferTypes();
        // Prefer London (EIP-1559) over Cancun (BLOb)
        if (types.indexOf(2) >= 0) return 2;
        // Return the highest inferred type
        return types.pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        const hasBlob = this.#maxFeePerBlobGas != null || this.#blobVersionedHashes;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, _indexJs2.assert)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, _indexJs2.assert)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, _indexJs2.assert)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else if (hasBlob && this.to) types.push(3);
            else {
                types.push(0);
                types.push(1);
                types.push(2);
                types.push(3);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if this transaction is an [[link-eip-4844]] BLOB
     *  transaction.
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return Transaction.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new Transaction();
        if (typeof tx === "string") {
            const payload = (0, _indexJs2.getBytes)(tx);
            if (payload[0] >= 0x7f) return Transaction.from(_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return Transaction.from(_parseEip2930(payload));
                case 2:
                    return Transaction.from(_parseEip1559(payload));
                case 3:
                    return Transaction.from(_parseEip4844(payload));
            }
            (0, _indexJs2.assert)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new Transaction();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.maxFeePerBlobGas != null) result.maxFeePerBlobGas = tx.maxFeePerBlobGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, _indexJs1.Signature).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        if (tx.blobVersionedHashes != null) result.blobVersionedHashes = tx.blobVersionedHashes;
        if (tx.hash != null) {
            (0, _indexJs2.assertArgument)(result.isSigned(), "unsigned transaction cannot define hash", "tx", tx);
            (0, _indexJs2.assertArgument)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, _indexJs2.assertArgument)(result.isSigned(), "unsigned transaction cannot define from", "tx", tx);
            (0, _indexJs2.assertArgument)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}

},{"../address/index.js":"3THmk","../constants/addresses.js":"drK3N","../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","./accesslist.js":"8vgfS","./address.js":"17Xld","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iiclm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @TODO: Array Enum
/**
 *   Computes the [[link-solc-packed]] representation of %%values%%
 *   respectively to their %%types%%.
 *
 *   @example:
 *       addr = "0x8ba1f109551bd432803012645ac136ddd64dba72"
 *       solidityPacked([ "address", "uint" ], [ addr, 45 ]);
 *       //_result:
 */ parcelHelpers.export(exports, "solidityPacked", ()=>solidityPacked);
/**
 *   Computes the [[link-solc-packed]] [[keccak256]] hash of %%values%%
 *   respectively to their %%types%%.
 *
 *   @example:
 *       addr = "0x8ba1f109551bd432803012645ac136ddd64dba72"
 *       solidityPackedKeccak256([ "address", "uint" ], [ addr, 45 ]);
 *       //_result:
 */ parcelHelpers.export(exports, "solidityPackedKeccak256", ()=>solidityPackedKeccak256);
/**
 *   Computes the [[link-solc-packed]] [[sha256]] hash of %%values%%
 *   respectively to their %%types%%.
 *
 *   @example:
 *       addr = "0x8ba1f109551bd432803012645ac136ddd64dba72"
 *       solidityPackedSha256([ "address", "uint" ], [ addr, 45 ]);
 *       //_result:
 */ parcelHelpers.export(exports, "solidityPackedSha256", ()=>solidityPackedSha256);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../utils/index.js");
const regexBytes = new RegExp("^bytes([0-9]+)$");
const regexNumber = new RegExp("^(u?int)([0-9]*)$");
const regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
function _pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, _indexJs2.getBytes)((0, _indexJs2.zeroPadValue)(value, 32));
            return (0, _indexJs2.getBytes)((0, _indexJs.getAddress)(value));
        case "string":
            return (0, _indexJs2.toUtf8Bytes)(value);
        case "bytes":
            return (0, _indexJs2.getBytes)(value);
        case "bool":
            value = !!value ? "0x01" : "0x00";
            if (isArray) return (0, _indexJs2.getBytes)((0, _indexJs2.zeroPadValue)(value, 32));
            return (0, _indexJs2.getBytes)(value);
    }
    let match = type.match(regexNumber);
    if (match) {
        let signed = match[1] === "int";
        let size = parseInt(match[2] || "256");
        (0, _indexJs2.assertArgument)((!match[2] || match[2] === String(size)) && size % 8 === 0 && size !== 0 && size <= 256, "invalid number type", "type", type);
        if (isArray) size = 256;
        if (signed) value = (0, _indexJs2.toTwos)(value, size);
        return (0, _indexJs2.getBytes)((0, _indexJs2.zeroPadValue)((0, _indexJs2.toBeArray)(value), size / 8));
    }
    match = type.match(regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        (0, _indexJs2.assertArgument)(String(size) === match[1] && size !== 0 && size <= 32, "invalid bytes type", "type", type);
        (0, _indexJs2.assertArgument)((0, _indexJs2.dataLength)(value) === size, `invalid value for ${type}`, "value", value);
        if (isArray) return (0, _indexJs2.getBytes)((0, _indexJs2.zeroPadBytes)(value, 32));
        return value;
    }
    match = type.match(regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        (0, _indexJs2.assertArgument)(count === value.length, `invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push(_pack(baseType, value, true));
        });
        return (0, _indexJs2.getBytes)((0, _indexJs2.concat)(result));
    }
    (0, _indexJs2.assertArgument)(false, "invalid type", "type", type);
}
function solidityPacked(types, values) {
    (0, _indexJs2.assertArgument)(types.length === values.length, "wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push(_pack(type, values[index]));
    });
    return (0, _indexJs2.hexlify)((0, _indexJs2.concat)(tight));
}
function solidityPackedKeccak256(types, values) {
    return (0, _indexJs1.keccak256)(solidityPacked(types, values));
}
function solidityPackedSha256(types, values) {
    return (0, _indexJs1.sha256)(solidityPacked(types, values));
}

},{"../address/index.js":"3THmk","../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGS74":[function(require,module,exports) {
//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **TypedDataEncode** prepares and encodes [[link-eip-712]] payloads
 *  for signed typed data.
 *
 *  This is useful for those that wish to compute various components of a
 *  typed data hash, primary types, or sub-components, but generally the
 *  higher level [[Signer-signTypedData]] is more useful.
 */ parcelHelpers.export(exports, "TypedDataEncoder", ()=>TypedDataEncoder);
/**
 *  Compute the address used to sign the typed data for the %%signature%%.
 */ parcelHelpers.export(exports, "verifyTypedData", ()=>verifyTypedData);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
var _idJs = require("./id.js");
const padding = new Uint8Array(32);
padding.fill(0);
const BN__1 = BigInt(-1);
const BN_0 = BigInt(0);
const BN_1 = BigInt(1);
const BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(value) {
    const bytes = (0, _indexJs3.getBytes)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, _indexJs3.concat)([
        bytes,
        padding.slice(padOffset)
    ]);
    return (0, _indexJs3.hexlify)(bytes);
}
const hexTrue = (0, _indexJs3.toBeHex)(BN_1, 32);
const hexFalse = (0, _indexJs3.toBeHex)(BN_0, 32);
const domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function checkString(key) {
    return function(value) {
        (0, _indexJs3.assertArgument)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const domainChecks = {
    name: checkString("name"),
    version: checkString("version"),
    chainId: function(_value) {
        const value = (0, _indexJs3.getBigInt)(_value, "domain.chainId");
        (0, _indexJs3.assertArgument)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, _indexJs3.toQuantity)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, _indexJs.getAddress)(value).toLowerCase();
        } catch (error) {}
        (0, _indexJs3.assertArgument)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, _indexJs3.getBytes)(value, "domain.salt");
        (0, _indexJs3.assertArgument)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, _indexJs3.hexlify)(bytes);
    }
};
function getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d+)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2]);
            (0, _indexJs3.assertArgument)(width % 8 === 0 && width !== 0 && width <= 256 && match[2] === String(width), "invalid numeric width", "type", type);
            const boundsUpper = (0, _indexJs3.mask)(BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + BN_1) * BN__1 : BN_0;
            return function(_value) {
                const value = (0, _indexJs3.getBigInt)(_value, "value");
                (0, _indexJs3.assertArgument)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, _indexJs3.toBeHex)(signed ? (0, _indexJs3.toTwos)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, _indexJs3.assertArgument)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, _indexJs3.getBytes)(value);
                (0, _indexJs3.assertArgument)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, _indexJs3.zeroPadValue)((0, _indexJs.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? hexFalse : hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, _indexJs1.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, _idJs.id)(value);
            };
    }
    return null;
}
function encodeType(name, fields) {
    return `${name}(${fields.map(({ name, type })=>type + " " + name).join(",")})`;
}
// foo[][3] => { base: "foo", index: "[][3]", array: {
//     base: "foo", prefix: "foo[]", count: 3 } }
function splitArray(type) {
    const match = type.match(/^([^\x5b]*)((\x5b\d*\x5d)*)(\x5b(\d*)\x5d)$/);
    if (match) return {
        base: match[1],
        index: match[2] + match[4],
        array: {
            base: match[1],
            prefix: match[1] + match[2],
            count: match[5] ? parseInt(match[5]) : -1
        }
    };
    return {
        base: type
    };
}
class TypedDataEncoder {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(_types){
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        const types = {};
        Object.keys(_types).forEach((type)=>{
            types[type] = _types[type].map(({ name, type })=>{
                // Normalize the base type (unless name conflict)
                let { base, index } = splitArray(type);
                if (base === "int" && !_types["int"]) base = "int256";
                if (base === "uint" && !_types["uint"]) base = "uint256";
                return {
                    name,
                    type: base + (index || "")
                };
            });
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        this.#types = JSON.stringify(types);
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, _indexJs3.assertArgument)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", _types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = splitArray(field.type).base;
                (0, _indexJs3.assertArgument)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", _types);
                // Is this a base encoding type?
                const encoder = getBaseEncoder(baseType);
                if (encoder) continue;
                (0, _indexJs3.assertArgument)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", _types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, _indexJs3.assertArgument)(primaryTypes.length !== 0, "missing primary type", "types", _types);
        (0, _indexJs3.assertArgument)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", _types);
        (0, _indexJs3.defineProperties)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, _indexJs3.assertArgument)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", _types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, encodeType(name, types[name]) + st.map((t)=>encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const array = splitArray(type).array;
        if (array) {
            const subtype = array.prefix;
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, _indexJs3.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, _indexJs1.keccak256));
                return (0, _indexJs1.keccak256)((0, _indexJs3.concat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, _idJs.id)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name, type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, _indexJs1.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, _indexJs3.concat)(values);
            };
        }
        (0, _indexJs3.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, _indexJs3.assertArgument)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, _indexJs1.keccak256)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const array = splitArray(type).array;
        if (array) {
            (0, _indexJs3.assertArgument)(array.count === -1 || array.count === value.length, `array length mismatch; expected length ${array.count}`, "value", value);
            return value.map((v)=>this._visit(array.prefix, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name, type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, _indexJs3.assertArgument)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new TypedDataEncoder(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return TypedDataEncoder.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return TypedDataEncoder.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = domainFieldTypes[name];
            (0, _indexJs3.assertArgument)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name,
                type
            });
        }
        domainFields.sort((a, b)=>{
            return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
        });
        return TypedDataEncoder.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, _indexJs3.concat)([
            "0x1901",
            TypedDataEncoder.hashDomain(domain),
            TypedDataEncoder.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, _indexJs1.keccak256)(TypedDataEncoder.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, _indexJs3.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = TypedDataEncoder.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, _indexJs3.isHexString)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain,
            value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        TypedDataEncoder.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = domainChecks[name](value);
            domainTypes.push({
                name,
                type: domainFieldTypes[name]
            });
        });
        const encoder = TypedDataEncoder.from(types);
        // Get the normalized types
        types = encoder.types;
        const typesWithDomain = Object.assign({}, types);
        (0, _indexJs3.assertArgument)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, _indexJs3.hexlify)((0, _indexJs3.getBytes)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, _indexJs3.getBigInt)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, _indexJs3.assertArgument)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, _indexJs3.assertArgument)(false, "unsupported type", "type", type);
            })
        };
    }
}
function verifyTypedData(domain, types, value, signature) {
    return (0, _indexJs2.recoverAddress)(TypedDataEncoder.hash(domain, types, value), signature);
}

},{"../address/index.js":"3THmk","../crypto/index.js":"jUsZl","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./id.js":"2CjJy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6CBd":[function(require,module,exports) {
/**
 *  About bytes32 strings...
 *
 *  @_docloc: api/utils:Bytes32 Strings
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Encodes %%text%% as a Bytes32 string.
 */ parcelHelpers.export(exports, "encodeBytes32String", ()=>encodeBytes32String);
/**
 *  Encodes the Bytes32-encoded %%bytes%% into a string.
 */ parcelHelpers.export(exports, "decodeBytes32String", ()=>decodeBytes32String);
var _indexJs = require("../utils/index.js");
function encodeBytes32String(text) {
    // Get the bytes
    const bytes = (0, _indexJs.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, _indexJs.zeroPadBytes)(bytes, 32);
}
function decodeBytes32String(_bytes) {
    const data = (0, _indexJs.getBytes)(_bytes, "bytes");
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, _indexJs.toUtf8String)(data.slice(0, length));
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"801hm":[function(require,module,exports) {
/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkResultErrors", ()=>(0, _abstractCoderJs.checkResultErrors));
parcelHelpers.export(exports, "Result", ()=>(0, _abstractCoderJs.Result));
/**
 *  When using the [[Interface-parseLog]] to automatically match a Log to its event
 *  for parsing, a **LogDescription** is returned.
 */ parcelHelpers.export(exports, "LogDescription", ()=>LogDescription);
/**
 *  When using the [[Interface-parseTransaction]] to automatically match
 *  a transaction data to its function for parsing,
 *  a **TransactionDescription** is returned.
 */ parcelHelpers.export(exports, "TransactionDescription", ()=>TransactionDescription);
/**
 *  When using the [[Interface-parseError]] to automatically match an
 *  error for a call result for parsing, an **ErrorDescription** is returned.
 */ parcelHelpers.export(exports, "ErrorDescription", ()=>ErrorDescription);
/**
 *  An **Indexed** is used as a value when a value that does not
 *  fit within a topic (i.e. not a fixed-length, 32-byte type). It
 *  is the ``keccak256`` of the value, and used for types such as
 *  arrays, tuples, bytes and strings.
 */ parcelHelpers.export(exports, "Indexed", ()=>Indexed);
/**
 *  An Interface abstracts many of the low-level details for
 *  encoding and decoding the data on the blockchain.
 *
 *  An ABI provides information on how to encode data to send to
 *  a Contract, how to decode the results and events and how to
 *  interpret revert errors.
 *
 *  The ABI can be specified by [any supported format](InterfaceAbi).
 */ parcelHelpers.export(exports, "Interface", ()=>Interface);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../hash/index.js");
var _indexJs2 = require("../utils/index.js");
var _abiCoderJs = require("./abi-coder.js");
var _abstractCoderJs = require("./coders/abstract-coder.js");
var _fragmentsJs = require("./fragments.js");
var _typedJs = require("./typed.js");
class LogDescription {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, _indexJs2.defineProperties)(this, {
            fragment,
            name,
            signature,
            topic,
            args
        });
    }
}
class TransactionDescription {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, _indexJs2.defineProperties)(this, {
            fragment,
            name,
            args,
            signature,
            selector,
            value
        });
    }
}
class ErrorDescription {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, _indexJs2.defineProperties)(this, {
            fragment,
            name,
            args,
            signature,
            selector
        });
    }
}
class Indexed {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, _indexJs2.defineProperties)(this, {
            hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && PanicReasons[code.toString()]) reason = PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class Interface {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, _fragmentsJs.Fragment).from(a));
        } catch (error) {
            console.log(`[Warning] Invalid Fragment ${JSON.stringify(a)}:`, error.message);
        }
        (0, _indexJs2.defineProperties)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, _indexJs2.defineProperties)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, _indexJs2.assertArgument)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, _indexJs2.defineProperties)(this, {
            deploy: (0, _fragmentsJs.ConstructorFragment).from("constructor()")
        });
        (0, _indexJs2.defineProperties)(this, {
            fallback,
            receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, _abiCoderJs.AbiCoder).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, _indexJs2.isHexString)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, _typedJs.Typed).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, _typedJs.Typed).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, _indexJs2.assertArgument)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, _fragmentsJs.FunctionFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, _indexJs2.assertArgument)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, _indexJs2.isHexString)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, _typedJs.Typed).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, _indexJs2.assertArgument)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, _fragmentsJs.EventFragment).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, _indexJs2.assertArgument)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, _indexJs2.isHexString)(key)) {
            const selector = key.toLowerCase();
            if (BuiltinErrors[selector]) return (0, _fragmentsJs.ErrorFragment).from(BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, _fragmentsJs.ErrorFragment).from("error Error(string)");
                if (key === "Panic") return (0, _fragmentsJs.ErrorFragment).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, _indexJs2.assertArgument)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, _fragmentsJs.ErrorFragment).from(key).format();
        if (key === "Error(string)") return (0, _fragmentsJs.ErrorFragment).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, _fragmentsJs.ErrorFragment).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, _indexJs2.assertArgument)((0, _indexJs2.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, _indexJs2.dataSlice)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, _indexJs2.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, _indexJs2.assertArgument)((0, _indexJs2.dataSlice)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, _indexJs2.dataSlice)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, _indexJs2.concat)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, _indexJs2.getBytesCopy)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, _indexJs2.assert)(false, message, "BAD_DATA", {
            value: (0, _indexJs2.hexlify)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, _indexJs2.getBytes)(_data, "data");
        const error = (0, _abiCoderJs.AbiCoder).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, _indexJs2.hexlify)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, _indexJs2.hexlify)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, _indexJs2.assert)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, _indexJs1.id)(value);
            else if (param.type === "bytes") return (0, _indexJs.keccak256)((0, _indexJs2.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, _indexJs2.toBeHex)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, _indexJs2.zeroPadBytes)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, _indexJs2.zeroPadValue)((0, _indexJs2.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, _indexJs2.assertArgument)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, _indexJs2.assertArgument)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, _indexJs2.assertArgument)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, _indexJs1.id)(value));
                else if (param.type === "bytes") topics.push((0, _indexJs.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, _indexJs2.assertArgument)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, _indexJs2.assertArgument)((0, _indexJs2.isHexString)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, _fragmentsJs.ParamType).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, _indexJs2.concat)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new Indexed(null);
                else if (dynamic[index]) value = new Indexed(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, _abstractCoderJs.Result).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, _indexJs2.getBytes)(tx.data, "tx.data");
        const value = (0, _indexJs2.getBigInt)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, _indexJs2.hexlify)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new TransactionDescription(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new LogDescription(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, _indexJs2.hexlify)(data);
        const fragment = this.getError((0, _indexJs2.dataSlice)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, _indexJs2.dataSlice)(hexData, 4));
        return new ErrorDescription(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof Interface) return value;
        // JSON
        if (typeof value === "string") return new Interface(JSON.parse(value));
        // Maybe an interface from an older version, or from a symlinked copy
        if (typeof value.format === "function") return new Interface(value.format("json"));
        // Array of fragments
        return new Interface(value);
    }
}

},{"../crypto/index.js":"jUsZl","../hash/index.js":"3Gr4x","../utils/index.js":"4LgPJ","./abi-coder.js":"cuwf4","./coders/abstract-coder.js":"jGfOx","./fragments.js":"2OG5v","./typed.js":"1X2Hf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAwEH":[function(require,module,exports) {
/**
 *  A **Contract** object is a meta-class (a class whose definition is
 *  defined at runtime), which communicates with a deployed smart contract
 *  on the blockchain and provides a simple JavaScript interface to call
 *  methods, send transaction, query historic logs and listen for its events.
 *
 *  @_section: api/contract:Contracts  [about-contracts]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseContract", ()=>(0, _contractJs.BaseContract));
parcelHelpers.export(exports, "Contract", ()=>(0, _contractJs.Contract));
parcelHelpers.export(exports, "ContractFactory", ()=>(0, _factoryJs.ContractFactory));
parcelHelpers.export(exports, "ContractEventPayload", ()=>(0, _wrappersJs.ContractEventPayload));
parcelHelpers.export(exports, "ContractUnknownEventPayload", ()=>(0, _wrappersJs.ContractUnknownEventPayload));
parcelHelpers.export(exports, "ContractTransactionReceipt", ()=>(0, _wrappersJs.ContractTransactionReceipt));
parcelHelpers.export(exports, "ContractTransactionResponse", ()=>(0, _wrappersJs.ContractTransactionResponse));
parcelHelpers.export(exports, "EventLog", ()=>(0, _wrappersJs.EventLog));
parcelHelpers.export(exports, "UndecodedEventLog", ()=>(0, _wrappersJs.UndecodedEventLog));
var _contractJs = require("./contract.js");
var _factoryJs = require("./factory.js");
var _wrappersJs = require("./wrappers.js");

},{"./contract.js":"ktge2","./factory.js":"fQ5ht","./wrappers.js":"d7AXn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktge2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore:
 */ parcelHelpers.export(exports, "copyOverrides", ()=>copyOverrides);
/**
 *  @_ignore:
 */ parcelHelpers.export(exports, "resolveArgs", ()=>resolveArgs);
parcelHelpers.export(exports, "BaseContract", ()=>BaseContract);
/**
 *  A [[BaseContract]] with no type guards on its methods or events.
 */ parcelHelpers.export(exports, "Contract", ()=>Contract);
var _indexJs = require("../abi/index.js");
var _indexJs1 = require("../address/index.js");
// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider
var _providerJs = require("../providers/provider.js");
var _indexJs2 = require("../utils/index.js");
var _wrappersJs = require("./wrappers.js");
const BN_0 = BigInt(0);
function canCall(value) {
    return value && typeof value.call === "function";
}
function canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
function getResolver(value) {
    if (value != null) {
        if (canResolve(value)) return value;
        if (value.provider) return value.provider;
    }
    return undefined;
}
class PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, _indexJs2.defineProperties)(this, {
            fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = getRunner(contract.runner, "resolveName");
        const resolver = canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, _indexJs1.resolveAddress)(v, resolver)));
                        return (0, _indexJs1.resolveAddress)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function copyOverrides(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, _indexJs.Typed).dereference(arg, "overrides");
    (0, _indexJs2.assertArgument)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, _providerJs.copyRequest)(_overrides);
    (0, _indexJs2.assertArgument)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, _indexJs2.assertArgument)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = overrides.from;
    return overrides;
}
async function resolveArgs(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = getRunner(_runner, "resolveName");
    const resolver = canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, _indexJs.Typed).dereference(value, type);
            if (type === "address") return (0, _indexJs1.resolveAddress)(value, resolver);
            return value;
        });
    }));
}
function buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await copyOverrides(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        if (tx.from) tx.from = await (0, _indexJs1.resolveAddress)(tx.from, getResolver(contract.runner));
        const iface = contract.interface;
        const noValue = (0, _indexJs2.getBigInt)(tx.value || BN_0, "overrides.value") === BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, _indexJs2.assertArgument)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, _indexJs2.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, _indexJs2.assertArgument)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, _indexJs2.assertArgument)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = getRunner(contract.runner, "call");
        (0, _indexJs2.assert)(canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, _indexJs2.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, _indexJs2.assert)(canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, _wrappersJs.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = getRunner(contract.runner, "estimateGas");
        (0, _indexJs2.assert)(canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, _indexJs2.defineProperties)(method, {
        _contract: contract,
        estimateGas,
        populateTransaction,
        send,
        staticCall
    });
    return method;
}
function buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, _indexJs2.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key,
                args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) {
            overrides = await copyOverrides(args.pop());
            if (overrides.from) overrides.from = await (0, _indexJs1.resolveAddress)(overrides.from, getResolver(contract.runner));
        }
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await resolveArgs(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, _indexJs2.resolveProperties)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, _indexJs2.assert)(canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, _wrappersJs.ContractTransactionResponse)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = getRunner(contract.runner, "estimateGas");
        (0, _indexJs2.assert)(canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = getRunner(contract.runner, "call");
        (0, _indexJs2.assert)(canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, _indexJs2.isCallException)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, _indexJs2.defineProperties)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment,
        estimateGas,
        populateTransaction,
        send,
        staticCall,
        staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, _indexJs2.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key
                }
            });
            return fragment;
        }
    });
    return method;
}
function buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, _indexJs2.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key,
                args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, _indexJs2.defineProperties)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, _indexJs2.assert)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const internal = Symbol.for("_ethersInternal_contract");
const internalValues = new WeakMap();
function setInternal(contract, values) {
    internalValues.set(contract[internal], values);
}
function getInternal(contract) {
    return internalValues.get(contract[internal]);
}
function isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, _indexJs2.isHexString)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, _indexJs2.assertArgument)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, _indexJs2.isHexString)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, _indexJs2.assertArgument)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if (isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, _indexJs2.assertArgument)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment,
        tag,
        topics
    };
}
async function hasSub(contract, event) {
    const { subs } = getInternal(contract);
    return subs.get((await getSubInfo(contract, event)).tag) || null;
}
async function getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = getProvider(contract.runner);
    (0, _indexJs2.assert)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation
    });
    const { fragment, tag, topics } = await getSubInfo(contract, event);
    const { addr, subs } = getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address,
            topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                emit(contract, event, args, (listener)=>{
                    return new (0, _wrappersJs.ContractEventPayload)(contract, listener, event, _foundFragment, log);
                });
            } else emit(contract, event, [], (listener)=>{
                return new (0, _wrappersJs.ContractUnknownEventPayload)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag,
            listeners: [],
            start,
            stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let lastEmit = Promise.resolve();
async function _emit(contract, event, args, payloadFunc) {
    await lastEmit;
    const sub = await hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener, once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function emit(contract, event, args, payloadFunc) {
    try {
        await lastEmit;
    } catch (error) {}
    const resultPromise = _emit(contract, event, args, payloadFunc);
    lastEmit = resultPromise;
    return await resultPromise;
}
const passProperties = [
    "then"
];
class BaseContract {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, _indexJs2.assertArgument)(typeof target === "string" || (0, _indexJs1.isAddressable)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, _indexJs.Interface).from(abi);
        (0, _indexJs2.defineProperties)(this, {
            target,
            runner,
            interface: iface
        });
        Object.defineProperty(this, internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, _wrappersJs.ContractTransactionResponse)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, _indexJs2.isHexString)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = getRunner(runner, "resolveName");
                if (!canResolve(resolver)) throw (0, _indexJs2.makeError)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, _indexJs2.makeError)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        setInternal(this, {
            addrPromise,
            addr,
            deployTx,
            subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, _indexJs2.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if (passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, _indexJs2.defineProperties)(this, {
            filters
        });
        (0, _indexJs2.defineProperties)(this, {
            fallback: iface.receive || iface.fallback ? buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, _indexJs2.isError)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new BaseContract(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new BaseContract(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = getProvider(this.runner);
        (0, _indexJs2.assert)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = getProvider(this.runner);
        (0, _indexJs2.assert)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr, addrPromise } = getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment, topics } = await getSubInfo(this, event);
        const filter = {
            address,
            topics,
            fromBlock,
            toBlock
        };
        const provider = getProvider(this.runner);
        (0, _indexJs2.assert)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, _wrappersJs.EventLog)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, _wrappersJs.UndecodedEventLog)(log, error);
            }
            return new (0, _providerJs.Log)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await getSub(this, "on", event);
        sub.listeners.push({
            listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await getSub(this, "once", event);
        sub.listeners.push({
            listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs } = getInternal(this);
        let total = 0;
        for (const { listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener })=>listener);
        }
        const { subs } = getInternal(this);
        let result = [];
        for (const { listeners } of subs.values())result = result.concat(listeners.map(({ listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs } = getInternal(this);
            for (const { tag, stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends BaseContract {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function _ContractBase() {
    return BaseContract;
}
class Contract extends _ContractBase() {
}

},{"../abi/index.js":"gvX8w","../address/index.js":"3THmk","../providers/provider.js":"gKSYo","../utils/index.js":"4LgPJ","./wrappers.js":"d7AXn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKSYo":[function(require,module,exports) {
//import { resolveAddress } from "@ethersproject/address";
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @TODO? <T extends FeeData = { }> implements Required<T>
/**
 *  A **FeeData** wraps all the fee-related values associated with
 *  the network.
 */ parcelHelpers.export(exports, "FeeData", ()=>FeeData);
/**
 *  Returns a copy of %%req%% with all properties coerced to their strict
 *  types.
 */ parcelHelpers.export(exports, "copyRequest", ()=>copyRequest);
/**
 *  A **Block** represents the data associated with a full block on
 *  Ethereum.
 */ parcelHelpers.export(exports, "Block", ()=>Block);
//////////////////////
// Log
/**
 *  A **Log** in Ethereum represents an event that has been included in a
 *  transaction using the ``LOG*`` opcodes, which are most commonly used by
 *  Solidity's emit for announcing events.
 */ parcelHelpers.export(exports, "Log", ()=>Log);
//////////////////////
// Transaction Receipt
/*
export interface LegacyTransactionReceipt {
    byzantium: false;
    status: null;
    root: string;
}

export interface ByzantiumTransactionReceipt {
    byzantium: true;
    status: number;
    root: null;
}
*/ /**
 *  A **TransactionReceipt** includes additional information about a
 *  transaction that is only available after it has been mined.
 */ parcelHelpers.export(exports, "TransactionReceipt", ()=>TransactionReceipt);
/**
 *  A **TransactionResponse** includes all properties about a transaction
 *  that was sent to the network, which may or may not be included in a
 *  block.
 *
 *  The [[TransactionResponse-isMined]] can be used to check if the
 *  transaction has been mined as well as type guard that the otherwise
 *  possibly ``null`` properties are defined.
 */ parcelHelpers.export(exports, "TransactionResponse", ()=>TransactionResponse);
var _indexJs = require("../utils/index.js");
var _indexJs1 = require("../transaction/index.js");
const BN_0 = BigInt(0);
// -----------------------
function getValue(value) {
    if (value == null) return null;
    return value;
}
function toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class FeeData {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, _indexJs.defineProperties)(this, {
            gasPrice: getValue(gasPrice),
            maxFeePerGas: getValue(maxFeePerGas),
            maxPriorityFeePerGas: getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: toJson(gasPrice),
            maxFeePerGas: toJson(maxFeePerGas),
            maxPriorityFeePerGas: toJson(maxPriorityFeePerGas)
        };
    }
}
function copyRequest(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, _indexJs.hexlify)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, _indexJs.getBigInt)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, _indexJs.getNumber)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, _indexJs1.accessListify)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    return result;
}
class Block {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The hash tree root of the parent beacon block for the given
     *  execution block. See [[link-eip-4788]].
     */ parentBeaconBlockRoot;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The root hash for the global state after applying changes
     *  in this block.
     */ stateRoot;
    /**
     *  The hash of the transaction receipts trie.
     */ receiptsRoot;
    /**
     *  The total amount of blob gas consumed by the transactions
     *  within the block. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The running total of blob gas consumed in excess of the
     *  target, prior to the block. See [[link-eip-4844]].
     */ excessBlobGas;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new TransactionResponse(tx, provider);
            return tx;
        });
        (0, _indexJs.defineProperties)(this, {
            provider,
            hash: getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            parentBeaconBlockRoot: block.parentBeaconBlockRoot,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            blobGasUsed: block.blobGasUsed,
            excessBlobGas: block.excessBlobGas,
            miner: block.miner,
            extraData: block.extraData,
            baseFeePerGas: getValue(block.baseFeePerGas),
            stateRoot: block.stateRoot,
            receiptsRoot: block.receiptsRoot
        });
    }
    /**
     *  Returns the list of transaction hashes, in the order
     *  they were executed within the block.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions, in the order they
     *  were executed within the block.
     *
     *  This is only available for blocks which prefetched
     *  transactions, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, _indexJs.assert)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas, difficulty, extraData, gasLimit, gasUsed, hash, miner, nonce, number, parentHash, parentBeaconBlockRoot, stateRoot, receiptsRoot, timestamp, transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: toJson(baseFeePerGas),
            difficulty: toJson(difficulty),
            extraData,
            gasLimit: toJson(gasLimit),
            gasUsed: toJson(gasUsed),
            blobGasUsed: toJson(this.blobGasUsed),
            excessBlobGas: toJson(this.excessBlobGas),
            hash,
            miner,
            nonce,
            number,
            parentHash,
            timestamp,
            parentBeaconBlockRoot,
            stateRoot,
            receiptsRoot,
            transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, _indexJs.assertArgument)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return createOrphanedBlockFilter(this);
    }
}
class Log {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, _indexJs.defineProperties)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address, blockHash, blockNumber, data, index, removed, topics, transactionHash, transactionIndex } = this;
        return {
            _type: "log",
            address,
            blockHash,
            blockNumber,
            data,
            index,
            removed,
            topics,
            transactionHash,
            transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, _indexJs.assert)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, _indexJs.assert)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, _indexJs.assert)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return createRemovedLogFilter(this);
    }
}
class TransactionReceipt {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was sent to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */ blobGasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */ blobGasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new Log(log, provider);
        }));
        let gasPrice = BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, _indexJs.defineProperties)(this, {
            provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            blobGasUsed: tx.blobGasUsed,
            gasPrice,
            blobGasPrice: tx.blobGasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to, from, contractAddress, hash, index, blockHash, blockNumber, logsBloom, logs, status, root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash,
            blockNumber,
            //byzantium, 
            contractAddress,
            cumulativeGasUsed: toJson(this.cumulativeGasUsed),
            from,
            gasPrice: toJson(this.gasPrice),
            blobGasUsed: toJson(this.blobGasUsed),
            blobGasPrice: toJson(this.blobGasPrice),
            gasUsed: toJson(this.gasUsed),
            hash,
            index,
            logs,
            logsBloom,
            root,
            status,
            to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, _indexJs.assert)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return createReorderedTransactionFilter(this, other);
    }
}
class TransactionResponse {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */ maxFeePerBlobGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */ blobVersionedHashes;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.maxFeePerBlobGas = tx.maxFeePerBlobGas != null ? tx.maxFeePerBlobGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.blobVersionedHashes = tx.blobVersionedHashes != null ? tx.blobVersionedHashes : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber, blockHash, index, hash, type, to, from, nonce, data, signature, accessList, blobVersionedHashes } = this;
        return {
            _type: "TransactionResponse",
            accessList,
            blockNumber,
            blockHash,
            blobVersionedHashes,
            chainId: toJson(this.chainId),
            data,
            from,
            gasLimit: toJson(this.gasLimit),
            gasPrice: toJson(this.gasPrice),
            hash,
            maxFeePerGas: toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: toJson(this.maxPriorityFeePerGas),
            maxFeePerBlobGas: toJson(this.maxFeePerBlobGas),
            nonce,
            signature,
            to,
            index,
            type,
            value: toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx, blockNumber } = await (0, _indexJs.resolveProperties)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber, nonce } = await (0, _indexJs.resolveProperties)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === BN_0) reason = "cancelled";
                        (0, _indexJs.assert)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, _indexJs.assert)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, _indexJs.makeError)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, _indexJs.isError)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */ isCancun() {
        return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, _indexJs.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, _indexJs.assert)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, _indexJs.assert)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, _indexJs.assertArgument)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new TransactionResponse(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx,
        other
    };
}
function createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx
    };
}
function createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}

},{"../utils/index.js":"4LgPJ","../transaction/index.js":"iFcfw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7AXn":[function(require,module,exports) {
// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  An **EventLog** contains additional properties parsed from the [[Log]].
 */ parcelHelpers.export(exports, "EventLog", ()=>EventLog);
/**
 *  An **EventLog** contains additional properties parsed from the [[Log]].
 */ parcelHelpers.export(exports, "UndecodedEventLog", ()=>UndecodedEventLog);
/**
 *  A **ContractTransactionReceipt** includes the parsed logs from a
 *  [[TransactionReceipt]].
 */ parcelHelpers.export(exports, "ContractTransactionReceipt", ()=>ContractTransactionReceipt);
/**
 *  A **ContractTransactionResponse** will return a
 *  [[ContractTransactionReceipt]] when waited on.
 */ parcelHelpers.export(exports, "ContractTransactionResponse", ()=>ContractTransactionResponse);
/**
 *  A **ContractUnknownEventPayload** is included as the last parameter to
 *  Contract Events when the event does not match any events in the ABI.
 */ parcelHelpers.export(exports, "ContractUnknownEventPayload", ()=>ContractUnknownEventPayload);
/**
 *  A **ContractEventPayload** is included as the last parameter to
 *  Contract Events when the event is known.
 */ parcelHelpers.export(exports, "ContractEventPayload", ()=>ContractEventPayload);
var _providerJs = require("../providers/provider.js");
var _indexJs = require("../utils/index.js");
class EventLog extends (0, _providerJs.Log) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, _indexJs.defineProperties)(this, {
            args,
            fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class UndecodedEventLog extends (0, _providerJs.Log) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, _indexJs.defineProperties)(this, {
            error
        });
    }
}
class ContractTransactionReceipt extends (0, _providerJs.TransactionReceipt) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new EventLog(log, this.#iface, fragment);
            } catch (error) {
                return new UndecodedEventLog(log, error);
            }
            return log;
        });
    }
}
class ContractTransactionResponse extends (0, _providerJs.TransactionResponse) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms, timeout) {
        const receipt = await super.wait(confirms, timeout);
        if (receipt == null) return null;
        return new ContractTransactionReceipt(this.#iface, this.provider, receipt);
    }
}
class ContractUnknownEventPayload extends (0, _indexJs.EventPayload) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, _indexJs.defineProperties)(this, {
            log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class ContractEventPayload extends ContractUnknownEventPayload {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new EventLog(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, _indexJs.defineProperties)(this, {
            args,
            fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}

},{"../providers/provider.js":"gKSYo","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQ5ht":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A = Arguments to the constructor
// I = Interface of deployed contracts
/**
 *  A **ContractFactory** is used to deploy a Contract to the blockchain.
 */ parcelHelpers.export(exports, "ContractFactory", ()=>ContractFactory);
var _indexJs = require("../abi/index.js");
var _indexJs1 = require("../address/index.js");
var _indexJs2 = require("../utils/index.js");
var _contractJs = require("./contract.js");
class ContractFactory {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The Contract deployment bytecode. Often called the initcode.
     */ bytecode;
    /**
     *  The ContractRunner to deploy the Contract as.
     */ runner;
    /**
     *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
     *  optionally connected to %%runner%%.
     *
     *  The %%bytecode%% may be the ``bytecode`` property within the
     *  standard Solidity JSON output.
     */ constructor(abi, bytecode, runner){
        const iface = (0, _indexJs.Interface).from(abi);
        // Dereference Solidity bytecode objects and allow a missing `0x`-prefix
        if (bytecode instanceof Uint8Array) bytecode = (0, _indexJs2.hexlify)((0, _indexJs2.getBytes)(bytecode));
        else {
            if (typeof bytecode === "object") bytecode = bytecode.object;
            if (!bytecode.startsWith("0x")) bytecode = "0x" + bytecode;
            bytecode = (0, _indexJs2.hexlify)((0, _indexJs2.getBytes)(bytecode));
        }
        (0, _indexJs2.defineProperties)(this, {
            bytecode,
            interface: iface,
            runner: runner || null
        });
    }
    attach(target) {
        return new (0, _contractJs.BaseContract)(target, this.interface, this.runner);
    }
    /**
     *  Resolves to the transaction to deploy the contract, passing %%args%%
     *  into the constructor.
     */ async getDeployTransaction(...args) {
        let overrides = {};
        const fragment = this.interface.deploy;
        if (fragment.inputs.length + 1 === args.length) overrides = await (0, _contractJs.copyOverrides)(args.pop());
        if (fragment.inputs.length !== args.length) throw new Error("incorrect number of arguments to constructor");
        const resolvedArgs = await (0, _contractJs.resolveArgs)(this.runner, fragment.inputs, args);
        const data = (0, _indexJs2.concat)([
            this.bytecode,
            this.interface.encodeDeploy(resolvedArgs)
        ]);
        return Object.assign({}, overrides, {
            data
        });
    }
    /**
     *  Resolves to the Contract deployed by passing %%args%% into the
     *  constructor.
     *
     *  This will resolve to the Contract before it has been deployed to the
     *  network, so the [[BaseContract-waitForDeployment]] should be used before
     *  sending any transactions to it.
     */ async deploy(...args) {
        const tx = await this.getDeployTransaction(...args);
        (0, _indexJs2.assert)(this.runner && typeof this.runner.sendTransaction === "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const sentTx = await this.runner.sendTransaction(tx);
        const address = (0, _indexJs1.getCreateAddress)(sentTx);
        return new (0, _contractJs.BaseContract)(address, this.interface, this.runner, sentTx);
    }
    /**
     *  Return a new **ContractFactory** with the same ABI and bytecode,
     *  but connected to %%runner%%.
     */ connect(runner) {
        return new ContractFactory(this.interface, this.bytecode, runner);
    }
    /**
     *  Create a new **ContractFactory** from the standard Solidity JSON output.
     */ static fromSolidity(output, runner) {
        (0, _indexJs2.assertArgument)(output != null, "bad compiler output", "output", output);
        if (typeof output === "string") output = JSON.parse(output);
        const abi = output.abi;
        let bytecode = "";
        if (output.bytecode) bytecode = output.bytecode;
        else if (output.evm && output.evm.bytecode) bytecode = output.evm.bytecode;
        return new this(abi, bytecode, runner);
    }
}

},{"../abi/index.js":"gvX8w","../address/index.js":"3THmk","../utils/index.js":"4LgPJ","./contract.js":"ktge2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NGaI":[function(require,module,exports) {
/**
 *  A **Provider** provides a connection to the blockchain, whch can be
 *  used to query its current state, simulate execution and send transactions
 *  to update the state.
 *
 *  It is one of the most fundamental components of interacting with a
 *  blockchain application, and there are many ways to connect, such as over
 *  HTTP, WebSockets or injected providers such as [MetaMask](link-metamask).
 *
 *  @_section: api/providers:Providers  [about-providers]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractProvider", ()=>(0, _abstractProviderJs.AbstractProvider));
parcelHelpers.export(exports, "UnmanagedSubscriber", ()=>(0, _abstractProviderJs.UnmanagedSubscriber));
parcelHelpers.export(exports, "AbstractSigner", ()=>(0, _abstractSignerJs.AbstractSigner));
parcelHelpers.export(exports, "VoidSigner", ()=>(0, _abstractSignerJs.VoidSigner));
parcelHelpers.export(exports, "showThrottleMessage", ()=>(0, _communityJs.showThrottleMessage));
parcelHelpers.export(exports, "getDefaultProvider", ()=>(0, _defaultProviderJs.getDefaultProvider));
parcelHelpers.export(exports, "EnsResolver", ()=>(0, _ensResolverJs.EnsResolver));
parcelHelpers.export(exports, "MulticoinProviderPlugin", ()=>(0, _ensResolverJs.MulticoinProviderPlugin));
parcelHelpers.export(exports, "Network", ()=>(0, _networkJs.Network));
parcelHelpers.export(exports, "NonceManager", ()=>(0, _signerNoncemanagerJs.NonceManager));
parcelHelpers.export(exports, "NetworkPlugin", ()=>(0, _pluginsNetworkJs.NetworkPlugin));
parcelHelpers.export(exports, "GasCostPlugin", ()=>(0, _pluginsNetworkJs.GasCostPlugin));
parcelHelpers.export(exports, "EnsPlugin", ()=>(0, _pluginsNetworkJs.EnsPlugin));
parcelHelpers.export(exports, "FeeDataNetworkPlugin", ()=>(0, _pluginsNetworkJs.FeeDataNetworkPlugin));
parcelHelpers.export(exports, "FetchUrlFeeDataNetworkPlugin", ()=>(0, _pluginsNetworkJs.FetchUrlFeeDataNetworkPlugin));
parcelHelpers.export(exports, "Block", ()=>(0, _providerJs.Block));
parcelHelpers.export(exports, "FeeData", ()=>(0, _providerJs.FeeData));
parcelHelpers.export(exports, "Log", ()=>(0, _providerJs.Log));
parcelHelpers.export(exports, "TransactionReceipt", ()=>(0, _providerJs.TransactionReceipt));
parcelHelpers.export(exports, "TransactionResponse", ()=>(0, _providerJs.TransactionResponse));
parcelHelpers.export(exports, "copyRequest", ()=>(0, _providerJs.copyRequest));
parcelHelpers.export(exports, "FallbackProvider", ()=>(0, _providerFallbackJs.FallbackProvider));
parcelHelpers.export(exports, "JsonRpcApiProvider", ()=>(0, _providerJsonrpcJs.JsonRpcApiProvider));
parcelHelpers.export(exports, "JsonRpcProvider", ()=>(0, _providerJsonrpcJs.JsonRpcProvider));
parcelHelpers.export(exports, "JsonRpcSigner", ()=>(0, _providerJsonrpcJs.JsonRpcSigner));
parcelHelpers.export(exports, "BrowserProvider", ()=>(0, _providerBrowserJs.BrowserProvider));
parcelHelpers.export(exports, "AlchemyProvider", ()=>(0, _providerAlchemyJs.AlchemyProvider));
parcelHelpers.export(exports, "AnkrProvider", ()=>(0, _providerAnkrJs.AnkrProvider));
parcelHelpers.export(exports, "CloudflareProvider", ()=>(0, _providerCloudflareJs.CloudflareProvider));
parcelHelpers.export(exports, "EtherscanProvider", ()=>(0, _providerEtherscanJs.EtherscanProvider));
parcelHelpers.export(exports, "EtherscanPlugin", ()=>(0, _providerEtherscanJs.EtherscanPlugin));
parcelHelpers.export(exports, "InfuraProvider", ()=>(0, _providerInfuraJs.InfuraProvider));
parcelHelpers.export(exports, "InfuraWebSocketProvider", ()=>(0, _providerInfuraJs.InfuraWebSocketProvider));
parcelHelpers.export(exports, "PocketProvider", ()=>(0, _providerPocketJs.PocketProvider));
parcelHelpers.export(exports, "QuickNodeProvider", ()=>(0, _providerQuicknodeJs.QuickNodeProvider));
parcelHelpers.export(exports, "SocketProvider", ()=>(0, _providerSocketJs.SocketProvider));
parcelHelpers.export(exports, "WebSocketProvider", ()=>(0, _providerWebsocketJs.WebSocketProvider));
parcelHelpers.export(exports, "SocketSubscriber", ()=>(0, _providerSocketJs.SocketSubscriber));
parcelHelpers.export(exports, "SocketBlockSubscriber", ()=>(0, _providerSocketJs.SocketBlockSubscriber));
parcelHelpers.export(exports, "SocketPendingSubscriber", ()=>(0, _providerSocketJs.SocketPendingSubscriber));
parcelHelpers.export(exports, "SocketEventSubscriber", ()=>(0, _providerSocketJs.SocketEventSubscriber));
parcelHelpers.export(exports, "IpcSocketProvider", ()=>(0, _providerIpcsocketJs.IpcSocketProvider));
var _abstractProviderJs = require("./abstract-provider.js");
var _abstractSignerJs = require("./abstract-signer.js");
var _communityJs = require("./community.js");
var _defaultProviderJs = require("./default-provider.js");
var _ensResolverJs = require("./ens-resolver.js");
var _networkJs = require("./network.js");
var _signerNoncemanagerJs = require("./signer-noncemanager.js");
var _pluginsNetworkJs = require("./plugins-network.js");
var _providerJs = require("./provider.js");
var _providerFallbackJs = require("./provider-fallback.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
var _providerBrowserJs = require("./provider-browser.js");
var _providerAlchemyJs = require("./provider-alchemy.js");
var _providerAnkrJs = require("./provider-ankr.js");
var _providerCloudflareJs = require("./provider-cloudflare.js");
var _providerEtherscanJs = require("./provider-etherscan.js");
var _providerInfuraJs = require("./provider-infura.js");
var _providerPocketJs = require("./provider-pocket.js");
var _providerQuicknodeJs = require("./provider-quicknode.js");
var _providerIpcsocketJs = require("./provider-ipcsocket.js"); /*-browser*/ 
var _providerSocketJs = require("./provider-socket.js");
var _providerWebsocketJs = require("./provider-websocket.js");

},{"./abstract-provider.js":"jQbel","./abstract-signer.js":"gFBgG","./community.js":"dJBY6","./default-provider.js":"d78Ge","./ens-resolver.js":"3YcOG","./network.js":"7ojLV","./signer-noncemanager.js":"eNVTd","./plugins-network.js":"4LHg9","./provider.js":"gKSYo","./provider-fallback.js":"6GEA5","./provider-jsonrpc.js":"iaEcB","./provider-browser.js":"75VQh","./provider-alchemy.js":"csjf9","./provider-ankr.js":"4h21q","./provider-cloudflare.js":"93E3h","./provider-etherscan.js":"3hPhQ","./provider-infura.js":"3KegO","./provider-pocket.js":"7ngzD","./provider-quicknode.js":"58OKO","./provider-ipcsocket.js":"9Tw5J","./provider-socket.js":"a8HA9","./provider-websocket.js":"1L5gj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQbel":[function(require,module,exports) {
/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  An **UnmanagedSubscriber** is useful for events which do not require
 *  any additional management, such as ``"debug"`` which only requires
 *  emit in synchronous event loop triggered calls.
 */ parcelHelpers.export(exports, "UnmanagedSubscriber", ()=>UnmanagedSubscriber);
/**
 *  An **AbstractProvider** provides a base class for other sub-classes to
 *  implement the [[Provider]] API by normalizing input arguments and
 *  formatting output results as well as tracking events for consistent
 *  behaviour on an eventually-consistent network.
 */ parcelHelpers.export(exports, "AbstractProvider", ()=>AbstractProvider);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../constants/index.js");
var _indexJs2 = require("../contract/index.js");
var _indexJs3 = require("../hash/index.js");
var _indexJs4 = require("../transaction/index.js");
var _indexJs5 = require("../utils/index.js");
var _ensResolverJs = require("./ens-resolver.js");
var _formatJs = require("./format.js");
var _networkJs = require("./network.js");
var _providerJs = require("./provider.js");
var _subscriberPollingJs = require("./subscriber-polling.js");
// Constants
const BN_2 = BigInt(2);
const MAX_CCIP_REDIRECTS = 10;
function isPromise(value) {
    return value && typeof value.then === "function";
}
function getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class UnmanagedSubscriber {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, _indexJs5.defineProperties)(this, {
            name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "debug":
        case "error":
        case "finalized":
        case "network":
        case "pending":
        case "safe":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, _indexJs5.isHexString)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: getTag("tx", {
                hash
            }),
            hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: getTag("orphan", event),
            filter: copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, _indexJs5.isHexString)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, _indexJs.resolveAddress)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter,
            tag: getTag("event", filter),
            type: "event"
        };
    }
    (0, _indexJs5.assertArgument)(false, "unknown ProviderEvent", "event", _event);
}
function getTime() {
    return new Date().getTime();
}
const defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class AbstractProvider {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, _networkJs.Network).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, _indexJs5.FetchRequest)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data,
                sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request,
                index: i,
                urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request,
                        result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request,
                    result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, _indexJs5.assert)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url,
                    errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, _indexJs5.assert)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls,
                errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, _providerJs.Block)((0, _formatJs.formatBlock)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, _providerJs.Log)((0, _formatJs.formatLog)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, _providerJs.TransactionReceipt)((0, _formatJs.formatTransactionReceipt)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, _providerJs.TransactionResponse)((0, _formatJs.formatTransactionResponse)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, _indexJs5.assert)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, _indexJs5.assert)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, _indexJs5.getNumber)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, _indexJs.resolveAddress)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "finalized":
            case "latest":
            case "pending":
            case "safe":
                return blockTag;
        }
        if ((0, _indexJs5.isHexString)(blockTag)) {
            if ((0, _indexJs5.isHexString)(blockTag, 32)) return blockTag;
            return (0, _indexJs5.toQuantity)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, _indexJs5.getNumber)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, _indexJs5.toQuantity)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, _indexJs5.toQuantity)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, _indexJs5.toQuantity)(b + blockTag));
        }
        (0, _indexJs5.assertArgument)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resovles to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, _providerJs.copyRequest)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, _indexJs.resolveAddress)(request[key], this);
            if (isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if (isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = (async ()=>{
                try {
                    const network = await this._detectNetwork();
                    this.emit("network", network, null);
                    return network;
                } catch (error) {
                    if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                    throw error;
                }
            })();
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, _indexJs5.assert)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block, gasPrice, priorityFee } = await (0, _indexJs5.resolveProperties)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, _indexJs5.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })(),
                priorityFee: (async ()=>{
                    try {
                        const value = await this.#perform({
                            method: "getPriorityFee"
                        });
                        return (0, _indexJs5.getBigInt)(value, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = priorityFee != null ? priorityFee : BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * BN_2 + maxPriorityFeePerGas;
            }
            return new (0, _providerJs.FeeData)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, _indexJs5.FetchRequest)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, _providerJs.FeeData)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if (isPromise(tx)) tx = await tx;
        return (0, _indexJs5.getBigInt)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, _indexJs5.assert)(attempt < MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, _providerJs.copyRequest)(tx);
        try {
            return (0, _indexJs5.hexlify)(await this._perform({
                method: "call",
                transaction,
                blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, _indexJs5.isCallException)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, _indexJs5.dataSlice)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, _indexJs.resolveAddress)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = parseOffchainLookup((0, _indexJs5.dataSlice)(error.data, 4));
                } catch (error) {
                    (0, _indexJs5.assert)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction,
                        info: {
                            data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, _indexJs5.assert)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, _indexJs5.assert)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, _indexJs5.concat)([
                        ccipArgs.selector,
                        encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx, blockTag } = await (0, _indexJs5.resolveProperties)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address,
            blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, _indexJs5.getBigInt)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, _indexJs5.getNumber)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, _indexJs5.hexlify)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, _indexJs5.getBigInt)(_position, "position");
        return (0, _indexJs5.hexlify)(await this.#getAccountValue({
            method: "getStorage",
            position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber, hash, network } = await (0, _indexJs5.resolveProperties)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, _indexJs4.Transaction).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, _indexJs5.isHexString)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag,
            includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network, params } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network, params } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network, params } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash
            })
        });
        if (result == null) return null;
        return (0, _indexJs5.hexlify)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if (isPromise(filter)) filter = await filter;
        const { network, params } = await (0, _indexJs5.resolveProperties)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, _indexJs5.assert)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, _ensResolverJs.EnsResolver).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, _indexJs.getAddress)(address);
        const node = (0, _indexJs3.namehash)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, _ensResolverJs.EnsResolver).getEnsAddress(this);
            const ensContract = new (0, _indexJs2.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, _indexJs1.ZeroAddress)) return null;
            const resolverContract = new (0, _indexJs2.Contract)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, _indexJs5.isError)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, _indexJs5.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, _indexJs5.makeError)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, _indexJs5.assert)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer,
                func,
                time: getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new UnmanagedSubscriber(sub.type);
            case "block":
                {
                    const subscriber = new (0, _subscriberPollingJs.PollingBlockSubscriber)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "safe":
            case "finalized":
                return new (0, _subscriberPollingJs.PollingBlockTagSubscriber)(this, sub.type);
            case "event":
                return new (0, _subscriberPollingJs.PollingEventSubscriber)(this, sub.filter);
            case "transaction":
                return new (0, _subscriberPollingJs.PollingTransactionSubscriber)(this, sub.hash);
            case "orphan":
                return new (0, _subscriberPollingJs.PollingOrphanSubscriber)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber,
                tag,
                addressableMap,
                nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener, once })=>{
            const payload = new (0, _indexJs5.EventPayload)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener })=>listener);
        }
        let result = [];
        for (const { listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag, started, subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started, subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, _indexJs5.assert)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function _parseString(result, start) {
    try {
        const bytes = _parseBytes(result, start);
        if (bytes) return (0, _indexJs5.toUtf8String)(bytes);
    } catch (error) {}
    return null;
}
function _parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, _indexJs5.getNumber)((0, _indexJs5.dataSlice)(result, start, start + 32));
        const length = (0, _indexJs5.getNumber)((0, _indexJs5.dataSlice)(result, offset, offset + 32));
        return (0, _indexJs5.dataSlice)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function numPad(value) {
    const result = (0, _indexJs5.toBeArray)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, _indexJs5.getBytes)(datas[i]);
        // Update the bytes offset
        result[i] = numPad(byteCount);
        // The length and padded value of data
        result.push(numPad(data.length));
        result.push(bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, _indexJs5.concat)(result);
}
const zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, _indexJs5.assert)((0, _indexJs5.dataLength)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, _indexJs5.dataSlice)(data, 0, 32);
    (0, _indexJs5.assert)((0, _indexJs5.dataSlice)(sender, 0, 12) === (0, _indexJs5.dataSlice)(zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, _indexJs5.dataSlice)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, _indexJs5.getNumber)((0, _indexJs5.dataSlice)(data, 32, 64));
        const urlsLength = (0, _indexJs5.getNumber)((0, _indexJs5.dataSlice)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, _indexJs5.dataSlice)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = _parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, _indexJs5.assert)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = _parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, _indexJs5.assert)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, _indexJs5.assert)((0, _indexJs5.dataSlice)(data, 100, 128) === (0, _indexJs5.dataSlice)(zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, _indexJs5.dataSlice)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = _parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, _indexJs5.assert)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}

},{"../address/index.js":"3THmk","../constants/index.js":"8Nw3O","../contract/index.js":"fAwEH","../hash/index.js":"3Gr4x","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./ens-resolver.js":"3YcOG","./format.js":"gGshW","./network.js":"7ojLV","./provider.js":"gKSYo","./subscriber-polling.js":"ezHm2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3YcOG":[function(require,module,exports) {
/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A provider plugin super-class for processing multicoin address types.
 */ parcelHelpers.export(exports, "MulticoinProviderPlugin", ()=>MulticoinProviderPlugin);
/**
 *  A **BasicMulticoinProviderPlugin** provides service for common
 *  coin types, which do not require additional libraries to encode or
 *  decode.
 */ parcelHelpers.export(exports, "BasicMulticoinProviderPlugin", ()=>BasicMulticoinProviderPlugin);
/**
 *  A connected object to a resolved ENS name resolver, which can be
 *  used to query additional details.
 */ parcelHelpers.export(exports, "EnsResolver", ()=>EnsResolver);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../constants/index.js");
var _indexJs2 = require("../contract/index.js");
var _indexJs3 = require("../hash/index.js");
var _indexJs4 = require("../utils/index.js");
// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, _indexJs4.assertArgument)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class MulticoinProviderPlugin {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, _indexJs4.defineProperties)(this, {
            name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resovles to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resovles to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class BasicMulticoinProviderPlugin extends MulticoinProviderPlugin {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super(BasicMulticoinPluginId);
    }
}
const matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class EnsResolver {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, _indexJs4.defineProperties)(this, {
            provider,
            address,
            name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, _indexJs2.Contract)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, _indexJs4.isError)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, _indexJs3.namehash)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, _indexJs4.assert)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName
                }
            });
            params = [
                (0, _indexJs3.dnsEncode)(this.name, 255),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, _indexJs4.isError)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, _indexJs1.ZeroAddress)) return null;
            return result;
        } catch (error) {
            if ((0, _indexJs4.isError)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, _indexJs4.isHexString)(data, 20)) return (0, _indexJs.getAddress)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof MulticoinProviderPlugin)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, _indexJs4.assert)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType,
                data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, _indexJs4.encodeBase58)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, _indexJs4.assert)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < matchers.length; i++){
                const match = avatar.match(matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage,
                                url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, _indexJs2.Contract)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, _indexJs4.toBeHex)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, _indexJs4.FetchRequest)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, _indexJs4.hexlify)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match(matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, _indexJs4.assert)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await EnsResolver.getEnsAddress(provider);
        try {
            const contract = new (0, _indexJs2.Contract)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, _indexJs3.namehash)(name), {
                enableCcipRead: true
            });
            if (addr === (0, _indexJs1.ZeroAddress)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await EnsResolver.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new EnsResolver(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}

},{"../address/index.js":"3THmk","../constants/index.js":"8Nw3O","../contract/index.js":"fAwEH","../hash/index.js":"3Gr4x","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGshW":[function(require,module,exports) {
/**
 *  @_ignore
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allowNull", ()=>allowNull);
parcelHelpers.export(exports, "arrayOf", ()=>arrayOf);
// Requires an object which matches a fleet of other formatters
// Any FormatFunc may return `undefined` to have the value omitted
// from the result object. Calls preserve `this`.
parcelHelpers.export(exports, "object", ()=>object);
parcelHelpers.export(exports, "formatBoolean", ()=>formatBoolean);
parcelHelpers.export(exports, "formatData", ()=>formatData);
parcelHelpers.export(exports, "formatHash", ()=>formatHash);
parcelHelpers.export(exports, "formatUint256", ()=>formatUint256);
parcelHelpers.export(exports, "formatLog", ()=>formatLog);
parcelHelpers.export(exports, "formatBlock", ()=>formatBlock);
parcelHelpers.export(exports, "formatReceiptLog", ()=>formatReceiptLog);
parcelHelpers.export(exports, "formatTransactionReceipt", ()=>formatTransactionReceipt);
parcelHelpers.export(exports, "formatTransactionResponse", ()=>formatTransactionResponse);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
const BN_0 = BigInt(0);
function allowNull(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function arrayOf(format, allowNull) {
    return (array)=>{
        if (allowNull && array == null) return null;
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function object(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, _indexJs3.assert)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value
                });
            }
        }
        return result;
    };
}
function formatBoolean(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, _indexJs3.assertArgument)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function formatData(value) {
    (0, _indexJs3.assertArgument)((0, _indexJs3.isHexString)(value, true), "invalid data", "value", value);
    return value;
}
function formatHash(value) {
    (0, _indexJs3.assertArgument)((0, _indexJs3.isHexString)(value, 32), "invalid hash", "value", value);
    return value;
}
function formatUint256(value) {
    if (!(0, _indexJs3.isHexString)(value)) throw new Error("invalid uint256");
    return (0, _indexJs3.zeroPadValue)(value, 32);
}
const _formatLog = object({
    address: (0, _indexJs.getAddress),
    blockHash: formatHash,
    blockNumber: (0, _indexJs3.getNumber),
    data: formatData,
    index: (0, _indexJs3.getNumber),
    removed: allowNull(formatBoolean, false),
    topics: arrayOf(formatHash),
    transactionHash: formatHash,
    transactionIndex: (0, _indexJs3.getNumber)
}, {
    index: [
        "logIndex"
    ]
});
function formatLog(value) {
    return _formatLog(value);
}
const _formatBlock = object({
    hash: allowNull(formatHash),
    parentHash: formatHash,
    parentBeaconBlockRoot: allowNull(formatHash, null),
    number: (0, _indexJs3.getNumber),
    timestamp: (0, _indexJs3.getNumber),
    nonce: allowNull(formatData),
    difficulty: (0, _indexJs3.getBigInt),
    gasLimit: (0, _indexJs3.getBigInt),
    gasUsed: (0, _indexJs3.getBigInt),
    stateRoot: allowNull(formatHash, null),
    receiptsRoot: allowNull(formatHash, null),
    blobGasUsed: allowNull((0, _indexJs3.getBigInt), null),
    excessBlobGas: allowNull((0, _indexJs3.getBigInt), null),
    miner: allowNull((0, _indexJs.getAddress)),
    extraData: formatData,
    baseFeePerGas: allowNull((0, _indexJs3.getBigInt))
});
function formatBlock(value) {
    const result = _formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return formatTransactionResponse(tx);
    });
    return result;
}
const _formatReceiptLog = object({
    transactionIndex: (0, _indexJs3.getNumber),
    blockNumber: (0, _indexJs3.getNumber),
    transactionHash: formatHash,
    address: (0, _indexJs.getAddress),
    topics: arrayOf(formatHash),
    data: formatData,
    index: (0, _indexJs3.getNumber),
    blockHash: formatHash
}, {
    index: [
        "logIndex"
    ]
});
function formatReceiptLog(value) {
    return _formatReceiptLog(value);
}
const _formatTransactionReceipt = object({
    to: allowNull((0, _indexJs.getAddress), null),
    from: allowNull((0, _indexJs.getAddress), null),
    contractAddress: allowNull((0, _indexJs.getAddress), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, _indexJs3.getNumber),
    root: allowNull((0, _indexJs3.hexlify)),
    gasUsed: (0, _indexJs3.getBigInt),
    blobGasUsed: allowNull((0, _indexJs3.getBigInt), null),
    logsBloom: allowNull(formatData),
    blockHash: formatHash,
    hash: formatHash,
    logs: arrayOf(formatReceiptLog),
    blockNumber: (0, _indexJs3.getNumber),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, _indexJs3.getBigInt),
    effectiveGasPrice: allowNull((0, _indexJs3.getBigInt)),
    blobGasPrice: allowNull((0, _indexJs3.getBigInt), null),
    status: allowNull((0, _indexJs3.getNumber)),
    type: allowNull((0, _indexJs3.getNumber), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function formatTransactionReceipt(value) {
    return _formatTransactionReceipt(value);
}
function formatTransactionResponse(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, _indexJs3.getBigInt)(value.to) === BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = object({
        hash: formatHash,
        // Some nodes do not return this, usually test nodes (like Ganache)
        index: allowNull((0, _indexJs3.getNumber), undefined),
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, _indexJs3.getNumber)(value);
        },
        accessList: allowNull((0, _indexJs2.accessListify), null),
        blobVersionedHashes: allowNull(arrayOf(formatHash, true), null),
        blockHash: allowNull(formatHash, null),
        blockNumber: allowNull((0, _indexJs3.getNumber), null),
        transactionIndex: allowNull((0, _indexJs3.getNumber), null),
        from: (0, _indexJs.getAddress),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: allowNull((0, _indexJs3.getBigInt)),
        maxPriorityFeePerGas: allowNull((0, _indexJs3.getBigInt)),
        maxFeePerGas: allowNull((0, _indexJs3.getBigInt)),
        maxFeePerBlobGas: allowNull((0, _indexJs3.getBigInt), null),
        gasLimit: (0, _indexJs3.getBigInt),
        to: allowNull((0, _indexJs.getAddress), null),
        value: (0, _indexJs3.getBigInt),
        nonce: (0, _indexJs3.getNumber),
        data: formatData,
        creates: allowNull((0, _indexJs.getAddress), null),
        chainId: allowNull((0, _indexJs3.getBigInt), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ],
        index: [
            "transactionIndex"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, _indexJs.getCreateAddress)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, _indexJs1.Signature).from(value.signature);
    else result.signature = (0, _indexJs1.Signature).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, _indexJs3.getBigInt)(result.blockHash) === BN_0) result.blockHash = null;
    return result;
}

},{"../address/index.js":"3THmk","../crypto/index.js":"jUsZl","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ojLV":[function(require,module,exports) {
/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **Network** provides access to a chain's properties and allows
 *  for plug-ins to extend functionality.
 */ parcelHelpers.export(exports, "Network", ()=>Network);
var _indexJs = require("../transaction/index.js");
var _indexJs1 = require("../utils/index.js");
var _pluginsNetworkJs = require("./plugins-network.js");
/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const Networks = new Map();
class Network {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, _indexJs1.getBigInt)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, _indexJs1.getBigInt)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, _indexJs1.getBigInt)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, _indexJs1.getBigInt)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, _indexJs1.getBigInt)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new Network(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, _pluginsNetworkJs.GasCostPlugin)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, _indexJs.accessListify)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        injectCommonNetworks();
        // Default network
        if (network == null) return Network.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new Network("unknown", network);
            (0, _indexJs1.assertArgument)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, _indexJs1.assertArgument)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new Network(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, _pluginsNetworkJs.EnsPlugin)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, _indexJs1.assertArgument)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = Networks.get(nameOrChainId);
        if (existing) (0, _indexJs1.assertArgument)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function getGasStationPlugin(url) {
    return new (0, _pluginsNetworkJs.FetchUrlFeeDataNetworkPlugin)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, _indexJs1.assert)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request,
                response,
                error
            });
        }
    });
}
// See: https://chainlist.org
let injected = false;
function injectCommonNetworks() {
    if (injected) return;
    injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new Network(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, _pluginsNetworkJs.EnsPlugin)(null, options.ensNetwork));
            network.attachPlugin(new (0, _pluginsNetworkJs.GasCostPlugin)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        Network.register(name, func);
        Network.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            Network.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {
        ensNetwork: 11155111
    });
    registerEth("holesky", 17000, {
        ensNetwork: 17000
    });
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("arbitrum-sepolia", 421614, {});
    registerEth("base", 8453, {
        ensNetwork: 1
    });
    registerEth("base-goerli", 84531, {});
    registerEth("base-sepolia", 84532, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: []
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("optimism-sepolia", 11155420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}

},{"../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./plugins-network.js":"4LHg9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4LHg9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **NetworkPlugin** provides additional functionality on a [[Network]].
 */ parcelHelpers.export(exports, "NetworkPlugin", ()=>NetworkPlugin);
/**
 *  A **GasCostPlugin** allows a network to provide alternative values when
 *  computing the intrinsic gas required for a transaction.
 */ parcelHelpers.export(exports, "GasCostPlugin", ()=>GasCostPlugin);
/**
 *  An **EnsPlugin** allows a [[Network]] to specify the ENS Registry
 *  Contract address and the target network to use when using that
 *  contract.
 *
 *  Various testnets have their own instance of the contract to use, but
 *  in general, the mainnet instance supports multi-chain addresses and
 *  should be used.
 */ parcelHelpers.export(exports, "EnsPlugin", ()=>EnsPlugin);
/**
 *  A **FeeDataNetworkPlugin** allows a network to provide and alternate
 *  means to specify its fee data.
 *
 *  For example, a network which does not support [[link-eip-1559]] may
 *  choose to use a Gas Station site to approximate the gas price.
 */ parcelHelpers.export(exports, "FeeDataNetworkPlugin", ()=>FeeDataNetworkPlugin);
parcelHelpers.export(exports, "FetchUrlFeeDataNetworkPlugin", ()=>FetchUrlFeeDataNetworkPlugin) /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ ;
var _propertiesJs = require("../utils/properties.js");
var _indexJs = require("../utils/index.js");
const EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class NetworkPlugin {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, _propertiesJs.defineProperties)(this, {
            name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new NetworkPlugin(this.name);
    }
}
class GasCostPlugin extends NetworkPlugin {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, _indexJs.assertArgument)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, _propertiesJs.defineProperties)(this, props);
    }
    clone() {
        return new GasCostPlugin(this.effectiveBlock, this);
    }
}
class EnsPlugin extends NetworkPlugin {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, _propertiesJs.defineProperties)(this, {
            address: address || EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new EnsPlugin(this.address, this.targetNetwork);
    }
}
class FeeDataNetworkPlugin extends NetworkPlugin {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new FeeDataNetworkPlugin(this.#feeDataFunc);
    }
}
class FetchUrlFeeDataNetworkPlugin extends NetworkPlugin {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
}

},{"../utils/properties.js":"aAzWM","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezHm2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Return the polling subscriber for common events.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "getPollingSubscriber", ()=>getPollingSubscriber);
// @TODO: refactor this
/**
 *  A **PollingBlockSubscriber** polls at a regular interval for a change
 *  in the block number.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "PollingBlockSubscriber", ()=>PollingBlockSubscriber);
/**
 *  An **OnBlockSubscriber** can be sub-classed, with a [[_poll]]
 *  implmentation which will be called on every new block.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "OnBlockSubscriber", ()=>OnBlockSubscriber);
parcelHelpers.export(exports, "PollingBlockTagSubscriber", ()=>PollingBlockTagSubscriber);
/**
 *  @_ignore:
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "PollingOrphanSubscriber", ()=>PollingOrphanSubscriber);
/**
 *  A **PollingTransactionSubscriber** will poll for a given transaction
 *  hash for its receipt.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "PollingTransactionSubscriber", ()=>PollingTransactionSubscriber);
/**
 *  A **PollingEventSubscriber** will poll for a given filter for its logs.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "PollingEventSubscriber", ()=>PollingEventSubscriber);
var _indexJs = require("../utils/index.js");
function copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function getPollingSubscriber(provider, event) {
    if (event === "block") return new PollingBlockSubscriber(provider);
    if ((0, _indexJs.isHexString)(event, 32)) return new PollingTransactionSubscriber(provider, event);
    (0, _indexJs.assert)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event
        }
    });
}
class PollingBlockSubscriber {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class OnBlockSubscriber {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class PollingBlockTagSubscriber extends OnBlockSubscriber {
    #tag;
    #lastBlock;
    constructor(provider, tag){
        super(provider);
        this.#tag = tag;
        this.#lastBlock = -2;
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#lastBlock = -2;
        super.pause(dropWhilePaused);
    }
    async _poll(blockNumber, provider) {
        const block = await provider.getBlock(this.#tag);
        if (block == null) return;
        if (this.#lastBlock === -2) this.#lastBlock = block.number;
        else if (block.number > this.#lastBlock) {
            provider.emit(this.#tag, block.number);
            this.#lastBlock = block.number;
        }
    }
}
class PollingOrphanSubscriber extends OnBlockSubscriber {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class PollingTransactionSubscriber extends OnBlockSubscriber {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class PollingEventSubscriber {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFBgG":[function(require,module,exports) {
/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  An **AbstractSigner** includes most of teh functionality required
 *  to get a [[Signer]] working as expected, but requires a few
 *  Signer-specific methods be overridden.
 *
 */ parcelHelpers.export(exports, "AbstractSigner", ()=>AbstractSigner);
/**
 *  A **VoidSigner** is a class deisgned to allow an address to be used
 *  in any API which accepts a Signer, but for which there are no
 *  credentials available to perform any actual signing.
 *
 *  This for example allow impersonating an account for the purpose of
 *  static calls or estimating gas, but does not allow sending transactions.
 */ parcelHelpers.export(exports, "VoidSigner", ()=>VoidSigner);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../transaction/index.js");
var _indexJs2 = require("../utils/index.js");
var _providerJs = require("./provider.js");
function checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, _indexJs2.assert)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation
    });
}
async function populate(signer, tx) {
    let pop = (0, _providerJs.copyRequest)(tx);
    if (pop.to != null) pop.to = (0, _indexJs.resolveAddress)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, _indexJs.resolveAddress)(from, signer)
        ]).then(([address, from])=>{
            (0, _indexJs2.assertArgument)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, _indexJs2.resolveProperties)(pop);
}
class AbstractSigner {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, _indexJs2.defineProperties)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = checkProvider(this, "populateTransaction");
        const pop = await populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, _indexJs2.getBigInt)(pop.chainId);
            (0, _indexJs2.assertArgument)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, _indexJs2.assertArgument)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, _indexJs2.assertArgument)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, _indexJs2.assert)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, _indexJs2.assert)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, _indexJs2.assert)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2) {
                // Explicitly using EIP-1559
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, _indexJs2.resolveProperties)(pop);
    }
    async estimateGas(tx) {
        return checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, _indexJs1.Transaction).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class VoidSigner extends AbstractSigner {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, _indexJs2.defineProperties)(this, {
            address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new VoidSigner(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, _indexJs2.assert)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}

},{"../address/index.js":"3THmk","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./provider.js":"gKSYo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJBY6":[function(require,module,exports) {
/**
 *  There are many awesome community services that provide Ethereum
 *  nodes both for developers just starting out and for large-scale
 *  communities.
 *
 *  @_section: api/providers/thirdparty: Community Providers  [thirdparty]
 */ // Show the throttle message only once per service
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Displays a warning in tht console when the community resource is
 *  being used too heavily by the app, recommending the developer
 *  acquire their own credentials instead of using the community
 *  credentials.
 *
 *  The notification will only occur once per service.
 */ parcelHelpers.export(exports, "showThrottleMessage", ()=>showThrottleMessage);
const shown = new Set();
function showThrottleMessage(service) {
    if (shown.has(service)) return;
    shown.add(service);
    console.log("========= NOTICE =========");
    console.log(`Request-Rate Exceeded for ${service} (this message will not be repeated)`);
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.org/api-keys/");
    console.log("==========================");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d78Ge":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns a default provider for %%network%%.
 *
 *  If %%network%% is a [[WebSocketLike]] or string that begins with
 *  ``"ws:"`` or ``"wss:"``, a [[WebSocketProvider]] is returned backed
 *  by that WebSocket or URL.
 *
 *  If %%network%% is a string that begins with ``"HTTP:"`` or ``"HTTPS:"``,
 *  a [[JsonRpcProvider]] is returned connected to that URL.
 *
 *  Otherwise, a default provider is created backed by well-known public
 *  Web3 backends (such as [[link-infura]]) using community-provided API
 *  keys.
 *
 *  The %%options%% allows specifying custom API keys per backend (setting
 *  an API key to ``"-"`` will omit that provider) and ``options.exclusive``
 *  can be set to either a backend name or and array of backend names, which
 *  will whitelist **only** those backends.
 *
 *  Current backend strings supported are:
 *  - ``"alchemy"``
 *  - ``"ankr"``
 *  - ``"cloudflare"``
 *  - ``"etherscan"``
 *  - ``"infura"``
 *  - ``"publicPolygon"``
 *  - ``"quicknode"``
 *
 *  @example:
 *    // Connect to a local Geth node
 *    provider = getDefaultProvider("http://localhost:8545/");
 *
 *    // Connect to Ethereum mainnet with any current and future
 *    // third-party services available
 *    provider = getDefaultProvider("mainnet");
 *
 *    // Connect to Polygon, but only allow Etherscan and
 *    // INFURA and use "MY_API_KEY" in calls to Etherscan.
 *    provider = getDefaultProvider("matic", {
 *      etherscan: "MY_API_KEY",
 *      exclusive: [ "etherscan", "infura" ]
 *    });
 */ parcelHelpers.export(exports, "getDefaultProvider", ()=>getDefaultProvider);
var _indexJs = require("../utils/index.js");
var _providerAnkrJs = require("./provider-ankr.js");
var _providerAlchemyJs = require("./provider-alchemy.js");
var _providerCloudflareJs = require("./provider-cloudflare.js");
var _providerEtherscanJs = require("./provider-etherscan.js");
var _providerInfuraJs = require("./provider-infura.js");
//import { PocketProvider } from "./provider-pocket.js";
var _providerQuicknodeJs = require("./provider-quicknode.js");
var _providerFallbackJs = require("./provider-fallback.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
var _networkJs = require("./network.js");
var _providerWebsocketJs = require("./provider-websocket.js");
function isWebSocketLike(value) {
    return value && typeof value.send === "function" && typeof value.close === "function";
}
const Testnets = "goerli kovan sepolia classicKotti optimism-goerli arbitrum-goerli matic-mumbai bnbt".split(" ");
function getDefaultProvider(network, options) {
    if (options == null) options = {};
    const allowService = (name)=>{
        if (options[name] === "-") return false;
        if (typeof options.exclusive === "string") return name === options.exclusive;
        if (Array.isArray(options.exclusive)) return options.exclusive.indexOf(name) !== -1;
        return true;
    };
    if (typeof network === "string" && network.match(/^https?:/)) return new (0, _providerJsonrpcJs.JsonRpcProvider)(network);
    if (typeof network === "string" && network.match(/^wss?:/) || isWebSocketLike(network)) return new (0, _providerWebsocketJs.WebSocketProvider)(network);
    // Get the network and name, if possible
    let staticNetwork = null;
    try {
        staticNetwork = (0, _networkJs.Network).from(network);
    } catch (error) {}
    const providers = [];
    if (allowService("publicPolygon") && staticNetwork) {
        if (staticNetwork.name === "matic") providers.push(new (0, _providerJsonrpcJs.JsonRpcProvider)("https://polygon-rpc.com/", staticNetwork, {
            staticNetwork
        }));
    }
    if (allowService("alchemy")) try {
        providers.push(new (0, _providerAlchemyJs.AlchemyProvider)(network, options.alchemy));
    } catch (error) {}
    if (allowService("ankr") && options.ankr != null) try {
        providers.push(new (0, _providerAnkrJs.AnkrProvider)(network, options.ankr));
    } catch (error) {}
    if (allowService("cloudflare")) try {
        providers.push(new (0, _providerCloudflareJs.CloudflareProvider)(network));
    } catch (error) {}
    if (allowService("etherscan")) try {
        providers.push(new (0, _providerEtherscanJs.EtherscanProvider)(network, options.etherscan));
    } catch (error) {}
    if (allowService("infura")) try {
        let projectId = options.infura;
        let projectSecret = undefined;
        if (typeof projectId === "object") {
            projectSecret = projectId.projectSecret;
            projectId = projectId.projectId;
        }
        providers.push(new (0, _providerInfuraJs.InfuraProvider)(network, projectId, projectSecret));
    } catch (error) {}
    /*
        if (options.pocket !== "-") {
            try {
                let appId = options.pocket;
                let secretKey: undefined | string = undefined;
                let loadBalancer: undefined | boolean = undefined;
                if (typeof(appId) === "object") {
                    loadBalancer = !!appId.loadBalancer;
                    secretKey = appId.secretKey;
                    appId = appId.appId;
                }
                providers.push(new PocketProvider(network, appId, secretKey, loadBalancer));
            } catch (error) { console.log(error); }
        }
    */ if (allowService("quicknode")) try {
        let token = options.quicknode;
        providers.push(new (0, _providerQuicknodeJs.QuickNodeProvider)(network, token));
    } catch (error) {}
    (0, _indexJs.assert)(providers.length, "unsupported default network", "UNSUPPORTED_OPERATION", {
        operation: "getDefaultProvider"
    });
    // No need for a FallbackProvider
    if (providers.length === 1) return providers[0];
    // We use the floor because public third-party providers can be unreliable,
    // so a low number of providers with a large quorum will fail too often
    let quorum = Math.floor(providers.length / 2);
    if (quorum > 2) quorum = 2;
    // Testnets don't need as strong a security gaurantee and speed is
    // more useful during testing
    if (staticNetwork && Testnets.indexOf(staticNetwork.name) !== -1) quorum = 1;
    // Provided override qorum takes priority
    if (options && options.quorum) quorum = options.quorum;
    return new (0, _providerFallbackJs.FallbackProvider)(providers, undefined, {
        quorum
    });
}

},{"../utils/index.js":"4LgPJ","./provider-ankr.js":"4h21q","./provider-alchemy.js":"csjf9","./provider-cloudflare.js":"93E3h","./provider-etherscan.js":"3hPhQ","./provider-infura.js":"3KegO","./provider-quicknode.js":"58OKO","./provider-fallback.js":"6GEA5","./provider-jsonrpc.js":"iaEcB","./network.js":"7ojLV","./provider-websocket.js":"1L5gj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4h21q":[function(require,module,exports) {
/**
 *  [[link-ankr]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - BNB (``bnb``)
 *  - BNB Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:Ankr  [providers-ankr]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **AnkrProvider** connects to the [[link-ankr]]
 *  JSON-RPC end-points.
 *
 *  By default, a highly-throttled API key is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-ankr-signup).
 */ parcelHelpers.export(exports, "AnkrProvider", ()=>AnkrProvider);
var _indexJs = require("../utils/index.js");
var _communityJs = require("./community.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
const defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function getHost(name) {
    switch(name){
        case "mainnet":
            return "rpc.ankr.com/eth";
        case "goerli":
            return "rpc.ankr.com/eth_goerli";
        case "sepolia":
            return "rpc.ankr.com/eth_sepolia";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum";
        case "base":
            return "rpc.ankr.com/base";
        case "base-goerli":
            return "rpc.ankr.com/base_goerli";
        case "base-sepolia":
            return "rpc.ankr.com/base_sepolia";
        case "bnb":
            return "rpc.ankr.com/bsc";
        case "bnbt":
            return "rpc.ankr.com/bsc_testnet_chapel";
        case "matic":
            return "rpc.ankr.com/polygon";
        case "matic-mumbai":
            return "rpc.ankr.com/polygon_mumbai";
        case "optimism":
            return "rpc.ankr.com/optimism";
        case "optimism-goerli":
            return "rpc.ankr.com/optimism_testnet";
        case "optimism-sepolia":
            return "rpc.ankr.com/optimism_sepolia";
    }
    (0, _indexJs.assertArgument)(false, "unsupported network", "network", name);
}
class AnkrProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    /**
     *  The API key for the Ankr connection.
     */ apiKey;
    /**
     *  Create a new **AnkrProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */ constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        if (apiKey == null) apiKey = defaultApiKey;
        // Ankr does not support filterId, so we force polling
        const options = {
            polling: true,
            staticNetwork: network
        };
        const request = AnkrProvider.getRequest(network, apiKey);
        super(request, network, options);
        (0, _indexJs.defineProperties)(this, {
            apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new AnkrProvider(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%apiKey%%.
     */ static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = defaultApiKey;
        const request = new (0, _indexJs.FetchRequest)(`https:/\/${getHost(network.name)}/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === defaultApiKey) request.retryFunc = async (request, response, attempt)=>{
            (0, _communityJs.showThrottleMessage)("AnkrProvider");
            return true;
        };
        return request;
    }
    getRpcError(payload, error) {
        if (payload.method === "eth_sendRawTransaction") {
            if (error && error.error && error.error.message === "INTERNAL_ERROR: could not replace existing tx") error.error.message = "replacement transaction underpriced";
        }
        return super.getRpcError(payload, error);
    }
    isCommunityResource() {
        return this.apiKey === defaultApiKey;
    }
}

},{"../utils/index.js":"4LgPJ","./community.js":"dJBY6","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iaEcB":[function(require,module,exports) {
/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @TODO: Unchecked Signers
parcelHelpers.export(exports, "JsonRpcSigner", ()=>JsonRpcSigner);
/**
 *  The JsonRpcApiProvider is an abstract class and **MUST** be
 *  sub-classed.
 *
 *  It provides the base for all JSON-RPC-based Provider interaction.
 *
 *  Sub-classing Notes:
 *  - a sub-class MUST override _send
 *  - a sub-class MUST call the `_start()` method once connected
 */ parcelHelpers.export(exports, "JsonRpcApiProvider", ()=>JsonRpcApiProvider);
// @TODO: remove this in v7, it is not exported because this functionality
// is exposed in the JsonRpcApiProvider by setting polling to true. It should
// be safe to remove regardless, because it isn't reachable, but just in case.
/**
 *  @_ignore:
 */ parcelHelpers.export(exports, "JsonRpcApiPollingProvider", ()=>JsonRpcApiPollingProvider);
/**
 *  The JsonRpcProvider is one of the most common Providers,
 *  which performs all operations over HTTP (or HTTPS) requests.
 *
 *  Events are processed by polling the backend for the current block
 *  number; when it advances, all block-base events are then checked
 *  for updates.
 */ parcelHelpers.export(exports, "JsonRpcProvider", ()=>JsonRpcProvider);
var _indexJs = require("../abi/index.js");
var _indexJs1 = require("../address/index.js");
var _indexJs2 = require("../hash/index.js");
var _indexJs3 = require("../transaction/index.js");
var _indexJs4 = require("../utils/index.js");
var _abstractProviderJs = require("./abstract-provider.js");
var _abstractSignerJs = require("./abstract-signer.js");
var _networkJs = require("./network.js");
var _subscriberFilteridJs = require("./subscriber-filterid.js");
var _subscriberPollingJs = require("./subscriber-polling.js");
const Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function deepCopy(value) {
    if (value == null || Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map(deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class JsonRpcSigner extends (0, _abstractSignerJs.AbstractSigner) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, _indexJs1.getAddress)(address);
        (0, _indexJs4.defineProperties)(this, {
            address
        });
    }
    connect(provider) {
        (0, _indexJs4.assert)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, _indexJs1.resolveAddress)(_from, this.provider);
                (0, _indexJs4.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, _indexJs1.resolveAddress)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            let invalids = 0;
            const checkTx = async ()=>{
                try {
                    // Try getting the transaction
                    const tx = await this.provider.getTransaction(hash);
                    if (tx != null) {
                        resolve(tx.replaceableTransaction(blockNumber));
                        return;
                    }
                } catch (error) {
                    // If we were cancelled: stop polling.
                    // If the data is bad: the node returns bad transactions
                    // If the network changed: calling again will also fail
                    // If unsupported: likely destroyed
                    if ((0, _indexJs4.isError)(error, "CANCELLED") || (0, _indexJs4.isError)(error, "BAD_DATA") || (0, _indexJs4.isError)(error, "NETWORK_ERROR")) {
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        reject(error);
                        return;
                    }
                    // Stop-gap for misbehaving backends; see #4513
                    if ((0, _indexJs4.isError)(error, "INVALID_ARGUMENT")) {
                        invalids++;
                        if (error.info == null) error.info = {};
                        error.info.sendTransactionHash = hash;
                        if (invalids > 10) {
                            reject(error);
                            return;
                        }
                    }
                    // Notify anyone that cares; but we will try again, since
                    // it is likely an intermittent service error
                    this.provider.emit("error", (0, _indexJs4.makeError)("failed to fetch transation after sending (will try again)", "UNKNOWN_ERROR", {
                        error
                    }));
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, _indexJs1.resolveAddress)(tx.from, this.provider);
            (0, _indexJs4.assertArgument)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, _indexJs4.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, _indexJs4.hexlify)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, _indexJs2.TypedDataEncoder).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, _indexJs1.resolveAddress)(value);
            (0, _indexJs4.assertArgument)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, _indexJs2.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, _indexJs4.toUtf8Bytes)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, _indexJs4.hexlify)(message)
        ]);
    }
}
class JsonRpcApiProvider extends (0, _abstractProviderJs.AbstractProvider) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #pendingDetectNetwork;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no harm in sending it immediately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result
                        });
                        // Process results in batch order
                        for (const { resolve, reject, payload } of batch){
                            if (this.destroyed) {
                                reject((0, _indexJs4.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, _indexJs4.makeError)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error
                        });
                        for (const { reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        this.#pendingDetectNetwork = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise,
                resolve
            };
        }
        const staticNetwork = this._getOption("staticNetwork");
        if (typeof staticNetwork === "boolean") {
            (0, _indexJs4.assertArgument)(!staticNetwork || network !== "any", "staticNetwork cannot be used on special network 'any'", "options", options);
            if (staticNetwork && network != null) this.#network = (0, _networkJs.Network).from(network);
        } else if (staticNetwork) {
            // Make sure any static network is compatbile with the provided netwrok
            (0, _indexJs4.assertArgument)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, _indexJs4.assert)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, _indexJs4.getBigInt)(tx.type)) // If there are no EIP-1559 properties, it might be non-EIP-a559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) {
            if (network === true) {
                if (this.#network) return this.#network;
            } else return network;
        }
        if (this.#pendingDetectNetwork) return await this.#pendingDetectNetwork;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) {
            this.#pendingDetectNetwork = (async ()=>{
                try {
                    const result = (0, _networkJs.Network).from((0, _indexJs4.getBigInt)(await this.send("eth_chainId", [])));
                    this.#pendingDetectNetwork = null;
                    return result;
                } catch (error) {
                    this.#pendingDetectNetwork = null;
                    throw error;
                }
            })();
            return await this.#pendingDetectNetwork;
        }
        // We are not ready yet; use the primitive _send
        this.#pendingDetectNetwork = (async ()=>{
            const payload = {
                id: this.#nextId++,
                method: "eth_chainId",
                params: [],
                jsonrpc: "2.0"
            };
            this.emit("debug", {
                action: "sendRpcPayload",
                payload
            });
            let result;
            try {
                result = (await this._send(payload))[0];
                this.#pendingDetectNetwork = null;
            } catch (error) {
                this.#pendingDetectNetwork = null;
                this.emit("debug", {
                    action: "receiveRpcError",
                    error
                });
                throw error;
            }
            this.emit("debug", {
                action: "receiveRpcResult",
                result
            });
            if ("result" in result) return (0, _networkJs.Network).from((0, _indexJs4.getBigInt)(result.result));
            throw this.getRpcError(payload, result);
        })();
        return await this.#pendingDetectNetwork;
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, _indexJs4.makeError)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error
                    }
                }));
                await stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, _subscriberFilteridJs.FilterIdPendingSubscriber)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, _subscriberPollingJs.PollingEventSubscriber)(this, sub.filter);
            return new (0, _subscriberFilteridJs.FilterIdEventSubscriber)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, _abstractProviderJs.UnmanagedSubscriber)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, _indexJs4.toQuantity)((0, _indexJs4.getBigInt)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, _indexJs4.hexlify)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, _indexJs3.accessListify)(tx.accessList);
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getPriorityFee":
                return {
                    method: "eth_maxPriorityFeePerGas",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map(getLowerCase);
                    else req.filter.address = getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method } = payload;
        const { error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, _indexJs4.makeError)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload,
                    error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = spelunkData(error);
            const e = (0, _indexJs.AbiCoder).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error,
                payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify(spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, _indexJs4.makeError)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload,
                    error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, _indexJs4.makeError)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction,
                info: {
                    error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, _indexJs4.makeError)("nonce has already been used", "NONCE_EXPIRED", {
                transaction,
                info: {
                    error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, _indexJs4.makeError)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction,
                info: {
                    error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, _indexJs4.makeError)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction,
                    info: {
                        error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, _indexJs4.makeError)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error,
                payload
            }
        });
        return (0, _indexJs4.makeError)("could not coalesce error", "UNKNOWN_ERROR", {
            error,
            payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, _indexJs4.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve,
                reject,
                payload: {
                    method,
                    params,
                    id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new JsonRpcSigner(this, accounts[address]);
        }
        const { accounts } = await (0, _indexJs4.resolveProperties)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, _indexJs1.getAddress)(address);
        for (const account of accounts){
            if ((0, _indexJs1.getAddress)(account) === address) return new JsonRpcSigner(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new JsonRpcSigner(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload, reject } of this.#payloads)reject((0, _indexJs4.makeError)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class JsonRpcApiPollingProvider extends JsonRpcApiProvider {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        this.#pollingInterval = 4000;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if (isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if (isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class JsonRpcProvider extends JsonRpcApiPollingProvider {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, _indexJs4.FetchRequest)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, _indexJs4.isHexString)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function _spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return _spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function spelunkMessage(value) {
    const result = [];
    _spelunkMessage(value, result);
    return result;
}

},{"../abi/index.js":"gvX8w","../address/index.js":"3THmk","../hash/index.js":"3Gr4x","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./abstract-provider.js":"jQbel","./abstract-signer.js":"gFBgG","./network.js":"7ojLV","./subscriber-filterid.js":"kvbg8","./subscriber-polling.js":"ezHm2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kvbg8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Some backends support subscribing to events using a Filter ID.
 *
 *  When subscribing with this technique, the node issues a unique
 *  //Filter ID//. At this point the node dedicates resources to
 *  the filter, so that periodic calls to follow up on the //Filter ID//
 *  will receive any events since the last call.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "FilterIdSubscriber", ()=>FilterIdSubscriber);
/**
 *  A **FilterIdSubscriber** for receiving contract events.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "FilterIdEventSubscriber", ()=>FilterIdEventSubscriber);
/**
 *  A **FilterIdSubscriber** for receiving pending transactions events.
 *
 *  @_docloc: api/providers/abstract-provider
 */ parcelHelpers.export(exports, "FilterIdPendingSubscriber", ()=>FilterIdPendingSubscriber);
var _indexJs = require("../utils/index.js");
var _subscriberPollingJs = require("./subscriber-polling.js");
function copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class FilterIdSubscriber {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, _indexJs.isError)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class FilterIdEventSubscriber extends FilterIdSubscriber {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = copy(filter);
    }
    _recover(provider) {
        return new (0, _subscriberPollingJs.PollingEventSubscriber)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class FilterIdPendingSubscriber extends FilterIdSubscriber {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}

},{"../utils/index.js":"4LgPJ","./subscriber-polling.js":"ezHm2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"csjf9":[function(require,module,exports) {
/**
 *  [[link-alchemy]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:Alchemy  [providers-alchemy]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **AlchemyProvider** connects to the [[link-alchemy]]
 *  JSON-RPC end-points.
 *
 *  By default, a highly-throttled API key is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-alchemy-signup).
 *
 *  @_docloc: api/providers/thirdparty
 */ parcelHelpers.export(exports, "AlchemyProvider", ()=>AlchemyProvider);
var _indexJs = require("../utils/index.js");
var _communityJs = require("./community.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
const defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
function getHost(name) {
    switch(name){
        case "mainnet":
            return "eth-mainnet.alchemyapi.io";
        case "goerli":
            return "eth-goerli.g.alchemy.com";
        case "sepolia":
            return "eth-sepolia.g.alchemy.com";
        case "arbitrum":
            return "arb-mainnet.g.alchemy.com";
        case "arbitrum-goerli":
            return "arb-goerli.g.alchemy.com";
        case "arbitrum-sepolia":
            return "arb-sepolia.g.alchemy.com";
        case "base":
            return "base-mainnet.g.alchemy.com";
        case "base-goerli":
            return "base-goerli.g.alchemy.com";
        case "base-sepolia":
            return "base-sepolia.g.alchemy.com";
        case "matic":
            return "polygon-mainnet.g.alchemy.com";
        case "matic-mumbai":
            return "polygon-mumbai.g.alchemy.com";
        case "optimism":
            return "opt-mainnet.g.alchemy.com";
        case "optimism-goerli":
            return "opt-goerli.g.alchemy.com";
        case "optimism-sepolia":
            return "opt-sepolia.g.alchemy.com";
    }
    (0, _indexJs.assertArgument)(false, "unsupported network", "network", name);
}
class AlchemyProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    apiKey;
    constructor(_network, apiKey){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        if (apiKey == null) apiKey = defaultApiKey;
        const request = AlchemyProvider.getRequest(network, apiKey);
        super(request, network, {
            staticNetwork: network
        });
        (0, _indexJs.defineProperties)(this, {
            apiKey
        });
    }
    _getProvider(chainId) {
        try {
            return new AlchemyProvider(chainId, this.apiKey);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    async _perform(req) {
        // https://docs.alchemy.com/reference/trace-transaction
        if (req.method === "getTransactionResult") {
            const { trace, tx } = await (0, _indexJs.resolveProperties)({
                trace: this.send("trace_transaction", [
                    req.hash
                ]),
                tx: this.getTransaction(req.hash)
            });
            if (trace == null || tx == null) return null;
            let data;
            let error = false;
            try {
                data = trace[0].result.output;
                error = trace[0].error === "Reverted";
            } catch (error) {}
            if (data) {
                (0, _indexJs.assert)(!error, "an error occurred during transaction executions", "CALL_EXCEPTION", {
                    action: "getTransactionResult",
                    data,
                    reason: null,
                    transaction: tx,
                    invocation: null,
                    revert: null // @TODO
                });
                return data;
            }
            (0, _indexJs.assert)(false, "could not parse trace result", "BAD_DATA", {
                value: trace
            });
        }
        return await super._perform(req);
    }
    isCommunityResource() {
        return this.apiKey === defaultApiKey;
    }
    static getRequest(network, apiKey) {
        if (apiKey == null) apiKey = defaultApiKey;
        const request = new (0, _indexJs.FetchRequest)(`https:/\/${getHost(network.name)}/v2/${apiKey}`);
        request.allowGzip = true;
        if (apiKey === defaultApiKey) request.retryFunc = async (request, response, attempt)=>{
            (0, _communityJs.showThrottleMessage)("alchemy");
            return true;
        };
        return request;
    }
}

},{"../utils/index.js":"4LgPJ","./community.js":"dJBY6","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93E3h":[function(require,module,exports) {
/**
 *  About Cloudflare
 *
 *  @_subsection: api/providers/thirdparty:Cloudflare  [providers-cloudflare]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  About Cloudflare...
 */ parcelHelpers.export(exports, "CloudflareProvider", ()=>CloudflareProvider);
var _indexJs = require("../utils/index.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
class CloudflareProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    constructor(_network){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        (0, _indexJs.assertArgument)(network.name === "mainnet", "unsupported network", "network", _network);
        super("https://cloudflare-eth.com/", network, {
            staticNetwork: network
        });
    }
}

},{"../utils/index.js":"4LgPJ","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3hPhQ":[function(require,module,exports) {
/**
 *  [[link-etherscan]] provides a third-party service for connecting to
 *  various blockchains over a combination of JSON-RPC and custom API
 *  endpoints.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Sepolia Testnet (``holesky``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection api/providers/thirdparty:Etherscan  [providers-etherscan]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A Network can include an **EtherscanPlugin** to provide
 *  a custom base URL.
 *
 *  @_docloc: api/providers/thirdparty:Etherscan
 */ parcelHelpers.export(exports, "EtherscanPlugin", ()=>EtherscanPlugin);
/**
 *  The **EtherscanBaseProvider** is the super-class of
 *  [[EtherscanProvider]], which should generally be used instead.
 *
 *  Since the **EtherscanProvider** includes additional code for
 *  [[Contract]] access, in //rare cases// that contracts are not
 *  used, this class can reduce code size.
 *
 *  @_docloc: api/providers/thirdparty:Etherscan
 */ parcelHelpers.export(exports, "EtherscanProvider", ()=>EtherscanProvider);
var _indexJs = require("../abi/index.js");
var _indexJs1 = require("../contract/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
var _abstractProviderJs = require("./abstract-provider.js");
var _networkJs = require("./network.js");
var _pluginsNetworkJs = require("./plugins-network.js");
var _communityJs = require("./community.js");
const THROTTLE = 2000;
function isPromise(value) {
    return value && typeof value.then === "function";
}
const EtherscanPluginId = "org.ethers.plugins.provider.Etherscan";
class EtherscanPlugin extends (0, _pluginsNetworkJs.NetworkPlugin) {
    /**
     *  The Etherscan API base URL.
     */ baseUrl;
    /**
     *  Creates a new **EtherscanProvider** which will use
     *  %%baseUrl%%.
     */ constructor(baseUrl){
        super(EtherscanPluginId);
        (0, _indexJs3.defineProperties)(this, {
            baseUrl
        });
    }
    clone() {
        return new EtherscanPlugin(this.baseUrl);
    }
}
const skipKeys = [
    "enableCcipRead"
];
let nextId = 1;
class EtherscanProvider extends (0, _abstractProviderJs.AbstractProvider) {
    /**
     *  The connected network.
     */ network;
    /**
     *  The API key or null if using the community provided bandwidth.
     */ apiKey;
    #plugin;
    /**
     *  Creates a new **EtherscanBaseProvider**.
     */ constructor(_network, _apiKey){
        const apiKey = _apiKey != null ? _apiKey : null;
        super();
        const network = (0, _networkJs.Network).from(_network);
        this.#plugin = network.getPlugin(EtherscanPluginId);
        (0, _indexJs3.defineProperties)(this, {
            apiKey,
            network
        });
        // Test that the network is supported by Etherscan
        this.getBaseUrl();
    }
    /**
     *  Returns the base URL.
     *
     *  If an [[EtherscanPlugin]] is configured on the
     *  [[EtherscanBaseProvider_network]], returns the plugin's
     *  baseUrl.
     */ getBaseUrl() {
        if (this.#plugin) return this.#plugin.baseUrl;
        switch(this.network.name){
            case "mainnet":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "holesky":
                return "https://api-holesky.etherscan.io";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "bnb":
                return "https://api.bscscan.com";
            case "bnbt":
                return "https://api-testnet.bscscan.com";
            case "matic":
                return "https://api.polygonscan.com";
            case "matic-mumbai":
                return "https://api-testnet.polygonscan.com";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        (0, _indexJs3.assertArgument)(false, "unsupported network", "network", this.network);
    }
    /**
     *  Returns the URL for the %%module%% and %%params%%.
     */ getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.getBaseUrl()}/api?module=${module}${query}${apiKey}`;
    }
    /**
     *  Returns the URL for using POST requests.
     */ getPostUrl() {
        return `${this.getBaseUrl()}/api`;
    }
    /**
     *  Returns the parameters for using POST requests.
     */ getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    async detectNetwork() {
        return this.network;
    }
    /**
     *  Resolves to the result of calling %%module%% with %%params%%.
     *
     *  If %%post%%, the request is made as a POST request.
     */ async fetch(module, params, post) {
        const id = nextId++;
        const url = post ? this.getPostUrl() : this.getUrl(module, params);
        const payload = post ? this.getPostData(module, params) : null;
        this.emit("debug", {
            action: "sendRequest",
            id,
            url,
            payload: payload
        });
        const request = new (0, _indexJs3.FetchRequest)(url);
        request.setThrottleParams({
            slotInterval: 1000
        });
        request.retryFunc = (req, resp, attempt)=>{
            if (this.isCommunityResource()) (0, _communityJs.showThrottleMessage)("Etherscan");
            return Promise.resolve(true);
        };
        request.processFunc = async (request, response)=>{
            const result = response.hasBody() ? JSON.parse((0, _indexJs3.toUtf8String)(response.body)) : {};
            const throttle = (typeof result.result === "string" ? result.result : "").toLowerCase().indexOf("rate limit") >= 0;
            if (module === "proxy") // This JSON response indicates we are being throttled
            {
                if (result && result.status == 0 && result.message == "NOTOK" && throttle) {
                    this.emit("debug", {
                        action: "receiveError",
                        id,
                        reason: "proxy-NOTOK",
                        error: result
                    });
                    response.throwThrottleError(result.result, THROTTLE);
                }
            } else if (throttle) {
                this.emit("debug", {
                    action: "receiveError",
                    id,
                    reason: "null result",
                    error: result.result
                });
                response.throwThrottleError(result.result, THROTTLE);
            }
            return response;
        };
        if (payload) {
            request.setHeader("content-type", "application/x-www-form-urlencoded; charset=UTF-8");
            request.body = Object.keys(payload).map((k)=>`${k}=${payload[k]}`).join("&");
        }
        const response = await request.send();
        try {
            response.assertOk();
        } catch (error) {
            this.emit("debug", {
                action: "receiveError",
                id,
                error,
                reason: "assertOk"
            });
            (0, _indexJs3.assert)(false, "response error", "SERVER_ERROR", {
                request,
                response
            });
        }
        if (!response.hasBody()) {
            this.emit("debug", {
                action: "receiveError",
                id,
                error: "missing body",
                reason: "null body"
            });
            (0, _indexJs3.assert)(false, "missing response", "SERVER_ERROR", {
                request,
                response
            });
        }
        const result = JSON.parse((0, _indexJs3.toUtf8String)(response.body));
        if (module === "proxy") {
            if (result.jsonrpc != "2.0") {
                this.emit("debug", {
                    action: "receiveError",
                    id,
                    result,
                    reason: "invalid JSON-RPC"
                });
                (0, _indexJs3.assert)(false, "invalid JSON-RPC response (missing jsonrpc='2.0')", "SERVER_ERROR", {
                    request,
                    response,
                    info: {
                        result
                    }
                });
            }
            if (result.error) {
                this.emit("debug", {
                    action: "receiveError",
                    id,
                    result,
                    reason: "JSON-RPC error"
                });
                (0, _indexJs3.assert)(false, "error response", "SERVER_ERROR", {
                    request,
                    response,
                    info: {
                        result
                    }
                });
            }
            this.emit("debug", {
                action: "receiveRequest",
                id,
                result
            });
            return result.result;
        } else {
            // getLogs, getHistory have weird success responses
            if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) {
                this.emit("debug", {
                    action: "receiveRequest",
                    id,
                    result
                });
                return result.result;
            }
            if (result.status != 1 || typeof result.message === "string" && !result.message.match(/^OK/)) {
                this.emit("debug", {
                    action: "receiveError",
                    id,
                    result
                });
                (0, _indexJs3.assert)(false, "error response", "SERVER_ERROR", {
                    request,
                    response,
                    info: {
                        result
                    }
                });
            }
            this.emit("debug", {
                action: "receiveRequest",
                id,
                result
            });
            return result.result;
        }
    }
    /**
     *  Returns %%transaction%% normalized for the Etherscan API.
     */ _getTransactionPostData(transaction) {
        const result = {};
        for(let key in transaction){
            if (skipKeys.indexOf(key) >= 0) continue;
            if (transaction[key] == null) continue;
            let value = transaction[key];
            if (key === "type" && value === 0) continue;
            if (key === "blockTag" && value === "latest") continue;
            // Quantity-types require no leading zero, unless 0
            if (({
                type: true,
                gasLimit: true,
                gasPrice: true,
                maxFeePerGs: true,
                maxPriorityFeePerGas: true,
                nonce: true,
                value: true
            })[key]) value = (0, _indexJs3.toQuantity)(value);
            else if (key === "accessList") value = "[" + (0, _indexJs2.accessListify)(value).map((set)=>{
                return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
            }).join(",") + "]";
            else value = (0, _indexJs3.hexlify)(value);
            result[key] = value;
        }
        return result;
    }
    /**
     *  Throws the normalized Etherscan error.
     */ _checkError(req, error, transaction) {
        // Pull any message out if, possible
        let message = "";
        if ((0, _indexJs3.isError)(error, "SERVER_ERROR")) {
            // Check for an error emitted by a proxy call
            try {
                message = error.info.result.error.message;
            } catch (e) {}
            if (!message) try {
                message = error.info.message;
            } catch (e) {}
        }
        if (req.method === "estimateGas") {
            if (!message.match(/revert/i) && message.match(/insufficient funds/i)) (0, _indexJs3.assert)(false, "insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: req.transaction
            });
        }
        if (req.method === "call" || req.method === "estimateGas") {
            if (message.match(/execution reverted/i)) {
                let data = "";
                try {
                    data = error.info.result.error.data;
                } catch (error) {}
                const e = (0, _indexJs.AbiCoder).getBuiltinCallException(req.method, req.transaction, data);
                e.info = {
                    request: req,
                    error
                };
                throw e;
            }
        }
        if (message) {
            if (req.method === "broadcastTransaction") {
                const transaction = (0, _indexJs2.Transaction).from(req.signedTransaction);
                if (message.match(/replacement/i) && message.match(/underpriced/i)) (0, _indexJs3.assert)(false, "replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                    transaction
                });
                if (message.match(/insufficient funds/)) (0, _indexJs3.assert)(false, "insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                    transaction
                });
                if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) (0, _indexJs3.assert)(false, "nonce has already been used", "NONCE_EXPIRED", {
                    transaction
                });
            }
        }
        // Something we could not process
        throw error;
    }
    async _detectNetwork() {
        return this.network;
    }
    async _perform(req) {
        switch(req.method){
            case "chainId":
                return this.network.chainId;
            case "getBlockNumber":
                return this.fetch("proxy", {
                    action: "eth_blockNumber"
                });
            case "getGasPrice":
                return this.fetch("proxy", {
                    action: "eth_gasPrice"
                });
            case "getPriorityFee":
                // This is temporary until Etherscan completes support
                if (this.network.name === "mainnet") return "1000000000";
                else if (this.network.name === "optimism") return "1000000";
                else throw new Error("fallback onto the AbstractProvider default");
            /* Working with Etherscan to get this added:
            try {
                const test = await this.fetch("proxy", {
                    action: "eth_maxPriorityFeePerGas"
                });
                console.log(test);
                return test;
            } catch (e) {
                console.log("DEBUG", e);
                throw e;
            }
            */ /* This might be safe; but due to rounding neither myself
               or Etherscan are necessarily comfortable with this. :)
            try {
                const result = await this.fetch("gastracker", { action: "gasoracle" });
                console.log(result);
                const gasPrice = parseUnits(result.SafeGasPrice, "gwei");
                const baseFee = parseUnits(result.suggestBaseFee, "gwei");
                const priorityFee = gasPrice - baseFee;
                if (priorityFee < 0) { throw new Error("negative priority fee; defer to abstract provider default"); }
                return priorityFee;
            } catch (error) {
                console.log("DEBUG", error);
                throw error;
            }
            */ case "getBalance":
                // Returns base-10 result
                return this.fetch("account", {
                    action: "balance",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getTransactionCount":
                return this.fetch("proxy", {
                    action: "eth_getTransactionCount",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getCode":
                return this.fetch("proxy", {
                    action: "eth_getCode",
                    address: req.address,
                    tag: req.blockTag
                });
            case "getStorage":
                return this.fetch("proxy", {
                    action: "eth_getStorageAt",
                    address: req.address,
                    position: req.position,
                    tag: req.blockTag
                });
            case "broadcastTransaction":
                return this.fetch("proxy", {
                    action: "eth_sendRawTransaction",
                    hex: req.signedTransaction
                }, true).catch((error)=>{
                    return this._checkError(req, error, req.signedTransaction);
                });
            case "getBlock":
                if ("blockTag" in req) return this.fetch("proxy", {
                    action: "eth_getBlockByNumber",
                    tag: req.blockTag,
                    boolean: req.includeTransactions ? "true" : "false"
                });
                (0, _indexJs3.assert)(false, "getBlock by blockHash not supported by Etherscan", "UNSUPPORTED_OPERATION", {
                    operation: "getBlock(blockHash)"
                });
            case "getTransaction":
                return this.fetch("proxy", {
                    action: "eth_getTransactionByHash",
                    txhash: req.hash
                });
            case "getTransactionReceipt":
                return this.fetch("proxy", {
                    action: "eth_getTransactionReceipt",
                    txhash: req.hash
                });
            case "call":
                {
                    if (req.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                    const postData = this._getTransactionPostData(req.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_call";
                    try {
                        return await this.fetch("proxy", postData, true);
                    } catch (error) {
                        return this._checkError(req, error, req.transaction);
                    }
                }
            case "estimateGas":
                {
                    const postData = this._getTransactionPostData(req.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_estimateGas";
                    try {
                        return await this.fetch("proxy", postData, true);
                    } catch (error) {
                        return this._checkError(req, error, req.transaction);
                    }
                }
            /*
                        case "getLogs": {
                            // Needs to complain if more than one address is passed in
                            const args: Record<string, any> = { action: "getLogs" }
            
                            if (params.filter.fromBlock) {
                                args.fromBlock = checkLogTag(params.filter.fromBlock);
                            }
            
                            if (params.filter.toBlock) {
                                args.toBlock = checkLogTag(params.filter.toBlock);
                            }
            
                            if (params.filter.address) {
                                args.address = params.filter.address;
                            }
            
                            // @TODO: We can handle slightly more complicated logs using the logs API
                            if (params.filter.topics && params.filter.topics.length > 0) {
                                if (params.filter.topics.length > 1) {
                                    logger.throwError("unsupported topic count", Logger.Errors.UNSUPPORTED_OPERATION, { topics: params.filter.topics });
                                }
                                if (params.filter.topics.length === 1) {
                                    const topic0 = params.filter.topics[0];
                                    if (typeof(topic0) !== "string" || topic0.length !== 66) {
                                        logger.throwError("unsupported topic format", Logger.Errors.UNSUPPORTED_OPERATION, { topic0: topic0 });
                                    }
                                    args.topic0 = topic0;
                                }
                            }
            
                            const logs: Array<any> = await this.fetch("logs", args);
            
                            // Cache txHash => blockHash
                            let blocks: { [tag: string]: string } = {};
            
                            // Add any missing blockHash to the logs
                            for (let i = 0; i < logs.length; i++) {
                                const log = logs[i];
                                if (log.blockHash != null) { continue; }
                                if (blocks[log.blockNumber] == null) {
                                    const block = await this.getBlock(log.blockNumber);
                                    if (block) {
                                        blocks[log.blockNumber] = block.hash;
                                    }
                                }
            
                                log.blockHash = blocks[log.blockNumber];
                            }
            
                            return logs;
                        }
            */ default:
                break;
        }
        return super._perform(req);
    }
    async getNetwork() {
        return this.network;
    }
    /**
     *  Resolves to the current price of ether.
     *
     *  This returns ``0`` on any network other than ``mainnet``.
     */ async getEtherPrice() {
        if (this.network.name !== "mainnet") return 0.0;
        return parseFloat((await this.fetch("stats", {
            action: "ethprice"
        })).ethusd);
    }
    /**
     *  Resolves to a [Contract]] for %%address%%, using the
     *  Etherscan API to retreive the Contract ABI.
     */ async getContract(_address) {
        let address = this._getAddress(_address);
        if (isPromise(address)) address = await address;
        try {
            const resp = await this.fetch("contract", {
                action: "getabi",
                address
            });
            const abi = JSON.parse(resp);
            return new (0, _indexJs1.Contract)(address, abi, this);
        } catch (error) {
            return null;
        }
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}

},{"../abi/index.js":"gvX8w","../contract/index.js":"fAwEH","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./abstract-provider.js":"jQbel","./network.js":"7ojLV","./plugins-network.js":"4LHg9","./community.js":"dJBY6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3KegO":[function(require,module,exports) {
/**
 *  [[link-infura]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base (``base``)
 *  - Base Goerlia Testnet (``base-goerli``)
 *  - Base Sepolia Testnet (``base-sepolia``)
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Linea (``linea``)
 *  - Linea Goerlia Testnet (``linea-goerli``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:INFURA  [providers-infura]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **InfuraWebSocketProvider** connects to the [[link-infura]]
 *  WebSocket end-points.
 *
 *  By default, a highly-throttled API key is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-infura-signup).
 */ parcelHelpers.export(exports, "InfuraWebSocketProvider", ()=>InfuraWebSocketProvider);
/**
 *  The **InfuraProvider** connects to the [[link-infura]]
 *  JSON-RPC end-points.
 *
 *  By default, a highly-throttled API key is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-infura-signup).
 */ parcelHelpers.export(exports, "InfuraProvider", ()=>InfuraProvider);
var _indexJs = require("../utils/index.js");
var _communityJs = require("./community.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
var _providerWebsocketJs = require("./provider-websocket.js");
const defaultProjectId = "84842078b09946638c03157f83405213";
function getHost(name) {
    switch(name){
        case "mainnet":
            return "mainnet.infura.io";
        case "goerli":
            return "goerli.infura.io";
        case "sepolia":
            return "sepolia.infura.io";
        case "arbitrum":
            return "arbitrum-mainnet.infura.io";
        case "arbitrum-goerli":
            return "arbitrum-goerli.infura.io";
        case "arbitrum-sepolia":
            return "arbitrum-sepolia.infura.io";
        case "base":
            return "base-mainnet.infura.io";
        case "base-goerlia":
            return "base-goerli.infura.io";
        case "base-sepolia":
            return "base-sepolia.infura.io";
        case "bnb":
            return "bnbsmartchain-mainnet.infura.io";
        case "bnbt":
            return "bnbsmartchain-testnet.infura.io";
        case "linea":
            return "linea-mainnet.infura.io";
        case "linea-goerli":
            return "linea-goerli.infura.io";
        case "matic":
            return "polygon-mainnet.infura.io";
        case "matic-mumbai":
            return "polygon-mumbai.infura.io";
        case "optimism":
            return "optimism-mainnet.infura.io";
        case "optimism-goerli":
            return "optimism-goerli.infura.io";
        case "optimism-sepolia":
            return "optimism-sepolia.infura.io";
    }
    (0, _indexJs.assertArgument)(false, "unsupported network", "network", name);
}
class InfuraWebSocketProvider extends (0, _providerWebsocketJs.WebSocketProvider) {
    /**
     *  The Project ID for the INFURA connection.
     */ projectId;
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */ projectSecret;
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */ constructor(network, projectId){
        const provider = new InfuraProvider(network, projectId);
        const req = provider._getConnection();
        (0, _indexJs.assert)(!req.credentials, "INFURA WebSocket project secrets unsupported", "UNSUPPORTED_OPERATION", {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = req.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, _indexJs.defineProperties)(this, {
            projectId: provider.projectId,
            projectSecret: provider.projectSecret
        });
    }
    isCommunityResource() {
        return this.projectId === defaultProjectId;
    }
}
class InfuraProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    /**
     *  The Project ID for the INFURA connection.
     */ projectId;
    /**
     *  The Project Secret.
     *
     *  If null, no authenticated requests are made. This should not
     *  be used outside of private contexts.
     */ projectSecret;
    /**
     *  Creates a new **InfuraProvider**.
     */ constructor(_network, projectId, projectSecret){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        if (projectId == null) projectId = defaultProjectId;
        if (projectSecret == null) projectSecret = null;
        const request = InfuraProvider.getRequest(network, projectId, projectSecret);
        super(request, network, {
            staticNetwork: network
        });
        (0, _indexJs.defineProperties)(this, {
            projectId,
            projectSecret
        });
    }
    _getProvider(chainId) {
        try {
            return new InfuraProvider(chainId, this.projectId, this.projectSecret);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    isCommunityResource() {
        return this.projectId === defaultProjectId;
    }
    /**
     *  Creates a new **InfuraWebSocketProvider**.
     */ static getWebSocketProvider(network, projectId) {
        return new InfuraWebSocketProvider(network, projectId);
    }
    /**
     *  Returns a prepared request for connecting to %%network%%
     *  with %%projectId%% and %%projectSecret%%.
     */ static getRequest(network, projectId, projectSecret) {
        if (projectId == null) projectId = defaultProjectId;
        if (projectSecret == null) projectSecret = null;
        const request = new (0, _indexJs.FetchRequest)(`https:/\/${getHost(network.name)}/v3/${projectId}`);
        request.allowGzip = true;
        if (projectSecret) request.setCredentials("", projectSecret);
        if (projectId === defaultProjectId) request.retryFunc = async (request, response, attempt)=>{
            (0, _communityJs.showThrottleMessage)("InfuraProvider");
            return true;
        };
        return request;
    }
}

},{"../utils/index.js":"4LgPJ","./community.js":"dJBY6","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","./provider-websocket.js":"1L5gj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1L5gj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A JSON-RPC provider which is backed by a WebSocket.
 *
 *  WebSockets are often preferred because they retain a live connection
 *  to a server, which permits more instant access to events.
 *
 *  However, this incurs higher server infrasturture costs, so additional
 *  resources may be required to host your own WebSocket nodes and many
 *  third-party services charge additional fees for WebSocket endpoints.
 */ parcelHelpers.export(exports, "WebSocketProvider", ()=>WebSocketProvider);
var _wsJs = require("./ws.js"); /*-browser*/ 
var _providerSocketJs = require("./provider-socket.js");
class WebSocketProvider extends (0, _providerSocketJs.SocketProvider) {
    #connect;
    #websocket;
    get websocket() {
        if (this.#websocket == null) throw new Error("websocket closed");
        return this.#websocket;
    }
    constructor(url, network, options){
        super(network, options);
        if (typeof url === "string") {
            this.#connect = ()=>{
                return new (0, _wsJs.WebSocket)(url);
            };
            this.#websocket = this.#connect();
        } else if (typeof url === "function") {
            this.#connect = url;
            this.#websocket = url();
        } else {
            this.#connect = null;
            this.#websocket = url;
        }
        this.websocket.onopen = async ()=>{
            try {
                await this._start();
                this.resume();
            } catch (error) {
                console.log("failed to start WebsocketProvider", error);
            // @TODO: now what? Attempt reconnect?
            }
        };
        this.websocket.onmessage = (message)=>{
            this._processMessage(message.data);
        };
    /*
                this.websocket.onclose = (event) => {
                    // @TODO: What event.code should we reconnect on?
                    const reconnect = false;
                    if (reconnect) {
                        this.pause(true);
                        if (this.#connect) {
                            this.#websocket = this.#connect();
                            this.#websocket.onopen = ...
                            // @TODO: this requires the super class to rebroadcast; move it there
                        }
                        this._reconnect();
                    }
                };
        */ }
    async _write(message) {
        this.websocket.send(message);
    }
    async destroy() {
        if (this.#websocket != null) {
            this.#websocket.close();
            this.#websocket = null;
        }
        super.destroy();
    }
}

},{"./ws.js":"l6uGz","./provider-socket.js":"a8HA9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6uGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebSocket", ()=>_WebSocket);
var global = arguments[3];
function getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    throw new Error("unable to locate global object");
}
const _WebSocket = getGlobal().WebSocket;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a8HA9":[function(require,module,exports) {
/**
 *  Generic long-lived socket provider.
 *
 *  Sub-classing notes
 *  - a sub-class MUST call the `_start()` method once connected
 *  - a sub-class MUST override the `_write(string)` method
 *  - a sub-class MUST call `_processMessage(string)` for each message
 *
 *  @_subsection: api/providers/abstract-provider:Socket Providers  [about-socketProvider]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **SocketSubscriber** uses a socket transport to handle events and
 *  should use [[_emit]] to manage the events.
 */ parcelHelpers.export(exports, "SocketSubscriber", ()=>SocketSubscriber);
/**
 *  A **SocketBlockSubscriber** listens for ``newHeads`` events and emits
 *  ``"block"`` events.
 */ parcelHelpers.export(exports, "SocketBlockSubscriber", ()=>SocketBlockSubscriber);
/**
 *  A **SocketPendingSubscriber** listens for pending transacitons and emits
 *  ``"pending"`` events.
 */ parcelHelpers.export(exports, "SocketPendingSubscriber", ()=>SocketPendingSubscriber);
/**
 *  A **SocketEventSubscriber** listens for event logs.
 */ parcelHelpers.export(exports, "SocketEventSubscriber", ()=>SocketEventSubscriber);
/**
 *  A **SocketProvider** is backed by a long-lived connection over a
 *  socket, which can subscribe and receive real-time messages over
 *  its communication channel.
 */ parcelHelpers.export(exports, "SocketProvider", ()=>SocketProvider);
var _abstractProviderJs = require("./abstract-provider.js");
var _indexJs = require("../utils/index.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
class SocketSubscriber {
    #provider;
    #filter;
    /**
     *  The filter.
     */ get filter() {
        return JSON.parse(this.#filter);
    }
    #filterId;
    #paused;
    #emitPromise;
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = JSON.stringify(filter);
        this.#filterId = null;
        this.#paused = null;
        this.#emitPromise = null;
    }
    start() {
        this.#filterId = this.#provider.send("eth_subscribe", this.filter).then((filterId)=>{
            this.#provider._register(filterId, this);
            return filterId;
        });
    }
    stop() {
        this.#filterId.then((filterId)=>{
            this.#provider.send("eth_unsubscribe", [
                filterId
            ]);
        });
        this.#filterId = null;
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(dropWhilePaused) {
        (0, _indexJs.assert)(dropWhilePaused, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", {
            operation: "pause(false)"
        });
        this.#paused = !!dropWhilePaused;
    }
    resume() {
        this.#paused = null;
    }
    /**
     *  @_ignore:
     */ _handleMessage(message) {
        if (this.#filterId == null) return;
        if (this.#paused === null) {
            let emitPromise = this.#emitPromise;
            if (emitPromise == null) emitPromise = this._emit(this.#provider, message);
            else emitPromise = emitPromise.then(async ()=>{
                await this._emit(this.#provider, message);
            });
            this.#emitPromise = emitPromise.then(()=>{
                if (this.#emitPromise === emitPromise) this.#emitPromise = null;
            });
        }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */ async _emit(provider, message) {
        throw new Error("sub-classes must implemente this; _emit");
    }
}
class SocketBlockSubscriber extends SocketSubscriber {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newHeads"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("block", parseInt(message.number));
    }
}
class SocketPendingSubscriber extends SocketSubscriber {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newPendingTransactions"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("pending", message);
    }
}
class SocketEventSubscriber extends SocketSubscriber {
    #logFilter;
    /**
     *  The filter.
     */ get logFilter() {
        return JSON.parse(this.#logFilter);
    }
    /**
     *  @_ignore:
     */ constructor(provider, filter){
        super(provider, [
            "logs",
            filter
        ]);
        this.#logFilter = JSON.stringify(filter);
    }
    async _emit(provider, message) {
        provider.emit(this.logFilter, provider._wrapLog(message, provider._network));
    }
}
class SocketProvider extends (0, _providerJsonrpcJs.JsonRpcApiProvider) {
    #callbacks;
    // Maps each filterId to its subscriber
    #subs;
    // If any events come in before a subscriber has finished
    // registering, queue them
    #pending;
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */ constructor(network, _options){
        // Copy the options
        const options = Object.assign({}, _options != null ? _options : {});
        // Support for batches is generally not supported for
        // connection-base providers; if this changes in the future
        // the _send should be updated to reflect this
        (0, _indexJs.assertArgument)(options.batchMaxCount == null || options.batchMaxCount === 1, "sockets-based providers do not support batches", "options.batchMaxCount", _options);
        options.batchMaxCount = 1;
        // Socket-based Providers (generally) cannot change their network,
        // since they have a long-lived connection; but let people override
        // this if they have just cause.
        if (options.staticNetwork == null) options.staticNetwork = true;
        super(network, options);
        this.#callbacks = new Map();
        this.#subs = new Map();
        this.#pending = new Map();
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */ _getSubscriber(sub) {
        switch(sub.type){
            case "close":
                return new (0, _abstractProviderJs.UnmanagedSubscriber)("close");
            case "block":
                return new SocketBlockSubscriber(this);
            case "pending":
                return new SocketPendingSubscriber(this);
            case "event":
                return new SocketEventSubscriber(this, sub.filter);
            case "orphan":
                // Handled auto-matically within AbstractProvider
                // when the log.removed = true
                if (sub.filter.orphan === "drop-log") return new (0, _abstractProviderJs.UnmanagedSubscriber)("drop-log");
        }
        return super._getSubscriber(sub);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */ _register(filterId, subscriber) {
        this.#subs.set(filterId, subscriber);
        const pending = this.#pending.get(filterId);
        if (pending) {
            for (const message of pending)subscriber._handleMessage(message);
            this.#pending.delete(filterId);
        }
    }
    async _send(payload) {
        // WebSocket provider doesn't accept batches
        (0, _indexJs.assertArgument)(!Array.isArray(payload), "WebSocket does not support batch send", "payload", payload);
        // @TODO: stringify payloads here and store to prevent mutations
        // Prepare a promise to respond to
        const promise = new Promise((resolve, reject)=>{
            this.#callbacks.set(payload.id, {
                payload,
                resolve,
                reject
            });
        });
        // Wait until the socket is connected before writing to it
        await this._waitUntilReady();
        // Write the request to the socket
        await this._write(JSON.stringify(payload));
        return [
            await promise
        ];
    }
    // Sub-classes must call this once they are connected
    /*
    async _start(): Promise<void> {
        if (this.#ready) { return; }

        for (const { payload } of this.#callbacks.values()) {
            await this._write(JSON.stringify(payload));
        }

        this.#ready = (async function() {
            await super._start();
        })();
    }
    */ /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */ async _processMessage(message) {
        const result = JSON.parse(message);
        if (result && typeof result === "object" && "id" in result) {
            const callback = this.#callbacks.get(result.id);
            if (callback == null) {
                this.emit("error", (0, _indexJs.makeError)("received result for unknown id", "UNKNOWN_ERROR", {
                    reasonCode: "UNKNOWN_ID",
                    result
                }));
                return;
            }
            this.#callbacks.delete(result.id);
            callback.resolve(result);
        } else if (result && result.method === "eth_subscription") {
            const filterId = result.params.subscription;
            const subscriber = this.#subs.get(filterId);
            if (subscriber) subscriber._handleMessage(result.params.result);
            else {
                let pending = this.#pending.get(filterId);
                if (pending == null) {
                    pending = [];
                    this.#pending.set(filterId, pending);
                }
                pending.push(result.params.result);
            }
        } else {
            this.emit("error", (0, _indexJs.makeError)("received unexpected message", "UNKNOWN_ERROR", {
                reasonCode: "UNEXPECTED_MESSAGE",
                result
            }));
            return;
        }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */ async _write(message) {
        throw new Error("sub-classes must override this");
    }
}

},{"./abstract-provider.js":"jQbel","../utils/index.js":"4LgPJ","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58OKO":[function(require,module,exports) {
/**
 *  [[link-quicknode]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Sepolia Testnet (``sepolia``)
 *  - Holesky Testnet (``holesky``)
 *  - Arbitrum (``arbitrum``)
 *  - Arbitrum Goerli Testnet (``arbitrum-goerli``)
 *  - Arbitrum Sepolia Testnet (``arbitrum-sepolia``)
 *  - Base Mainnet (``base``);
 *  - Base Goerli Testnet (``base-goerli``);
 *  - Base Sepolia Testnet (``base-sepolia``);
 *  - BNB Smart Chain Mainnet (``bnb``)
 *  - BNB Smart Chain Testnet (``bnbt``)
 *  - Optimism (``optimism``)
 *  - Optimism Goerli Testnet (``optimism-goerli``)
 *  - Optimism Sepolia Testnet (``optimism-sepolia``)
 *  - Polygon (``matic``)
 *  - Polygon Mumbai Testnet (``matic-mumbai``)
 *
 *  @_subsection: api/providers/thirdparty:QuickNode  [providers-quicknode]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
@TODO:
  These networks are not currently present in the Network
  default included networks. Research them and ensure they
  are EVM compatible and work with ethers

  http://ethers.matic-amoy.quiknode.pro

  http://ethers.avalanche-mainnet.quiknode.pro
  http://ethers.avalanche-testnet.quiknode.pro
  http://ethers.blast-sepolia.quiknode.pro
  http://ethers.celo-mainnet.quiknode.pro
  http://ethers.fantom.quiknode.pro
  http://ethers.imx-demo.quiknode.pro
  http://ethers.imx-mainnet.quiknode.pro
  http://ethers.imx-testnet.quiknode.pro
  http://ethers.near-mainnet.quiknode.pro
  http://ethers.near-testnet.quiknode.pro
  http://ethers.nova-mainnet.quiknode.pro
  http://ethers.scroll-mainnet.quiknode.pro
  http://ethers.scroll-testnet.quiknode.pro
  http://ethers.tron-mainnet.quiknode.pro
  http://ethers.zkevm-mainnet.quiknode.pro
  http://ethers.zkevm-testnet.quiknode.pro
  http://ethers.zksync-mainnet.quiknode.pro
  http://ethers.zksync-testnet.quiknode.pro
*/ /**
 *  The **QuickNodeProvider** connects to the [[link-quicknode]]
 *  JSON-RPC end-points.
 *
 *  By default, a highly-throttled API token is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-quicknode).
 */ parcelHelpers.export(exports, "QuickNodeProvider", ()=>QuickNodeProvider);
var _indexJs = require("../utils/index.js");
var _communityJs = require("./community.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
const defaultToken = "919b412a057b5e9c9b6dce193c5a60242d6efadb";
function getHost(name) {
    switch(name){
        case "mainnet":
            return "ethers.quiknode.pro";
        case "goerli":
            return "ethers.ethereum-goerli.quiknode.pro";
        case "sepolia":
            return "ethers.ethereum-sepolia.quiknode.pro";
        case "holesky":
            return "ethers.ethereum-holesky.quiknode.pro";
        case "arbitrum":
            return "ethers.arbitrum-mainnet.quiknode.pro";
        case "arbitrum-goerli":
            return "ethers.arbitrum-goerli.quiknode.pro";
        case "arbitrum-sepolia":
            return "ethers.arbitrum-sepolia.quiknode.pro";
        case "base":
            return "ethers.base-mainnet.quiknode.pro";
        case "base-goerli":
            return "ethers.base-goerli.quiknode.pro";
        case "base-spolia":
            return "ethers.base-sepolia.quiknode.pro";
        case "bnb":
            return "ethers.bsc.quiknode.pro";
        case "bnbt":
            return "ethers.bsc-testnet.quiknode.pro";
        case "matic":
            return "ethers.matic.quiknode.pro";
        case "matic-mumbai":
            return "ethers.matic-testnet.quiknode.pro";
        case "optimism":
            return "ethers.optimism.quiknode.pro";
        case "optimism-goerli":
            return "ethers.optimism-goerli.quiknode.pro";
        case "optimism-sepolia":
            return "ethers.optimism-sepolia.quiknode.pro";
        case "xdai":
            return "ethers.xdai.quiknode.pro";
    }
    (0, _indexJs.assertArgument)(false, "unsupported network", "network", name);
}
class QuickNodeProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    /**
     *  The API token.
     */ token;
    /**
     *  Creates a new **QuickNodeProvider**.
     */ constructor(_network, token){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        if (token == null) token = defaultToken;
        const request = QuickNodeProvider.getRequest(network, token);
        super(request, network, {
            staticNetwork: network
        });
        (0, _indexJs.defineProperties)(this, {
            token
        });
    }
    _getProvider(chainId) {
        try {
            return new QuickNodeProvider(chainId, this.token);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    isCommunityResource() {
        return this.token === defaultToken;
    }
    /**
     *  Returns a new request prepared for %%network%% and the
     *  %%token%%.
     */ static getRequest(network, token) {
        if (token == null) token = defaultToken;
        const request = new (0, _indexJs.FetchRequest)(`https:/\/${getHost(network.name)}/${token}`);
        request.allowGzip = true;
        //if (projectSecret) { request.setCredentials("", projectSecret); }
        if (token === defaultToken) request.retryFunc = async (request, response, attempt)=>{
            (0, _communityJs.showThrottleMessage)("QuickNodeProvider");
            return true;
        };
        return request;
    }
}

},{"../utils/index.js":"4LgPJ","./community.js":"dJBY6","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GEA5":[function(require,module,exports) {
/**
 *  A **FallbackProvider** provides resilience, security and performance
 *  in a way that is customizable and configurable.
 *
 *  @_section: api/providers/fallback-provider:Fallback Provider [about-fallback-provider]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **FallbackProvider** manages several [[Providers]] providing
 *  resilience by switching between slow or misbehaving nodes, security
 *  by requiring multiple backends to aggree and performance by allowing
 *  faster backends to respond earlier.
 *
 */ parcelHelpers.export(exports, "FallbackProvider", ()=>FallbackProvider);
var _indexJs = require("../utils/index.js");
var _abstractProviderJs = require("./abstract-provider.js");
var _networkJs = require("./network.js");
const BN_1 = BigInt("1");
const BN_2 = BigInt("2");
function shuffle(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
}
function stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function getTime() {
    return new Date().getTime();
}
function stringify(value) {
    return JSON.stringify(value, (key, value)=>{
        if (typeof value === "bigint") return {
            type: "bigint",
            value: value.toString()
        };
        return value;
    });
}
const defaultConfig = {
    stallTimeout: 400,
    priority: 1,
    weight: 1
};
const defaultState = {
    blockNumber: -2,
    requests: 0,
    lateResponses: 0,
    errorResponses: 0,
    outOfSync: -1,
    unsupportedEvents: 0,
    rollingDuration: 0,
    score: 0,
    _network: null,
    _updateNumber: null,
    _totalTime: 0,
    _lastFatalError: null,
    _lastFatalErrorTimestamp: 0
};
async function waitForSync(config, blockNumber) {
    while(config.blockNumber < 0 || config.blockNumber < blockNumber){
        if (!config._updateNumber) config._updateNumber = (async ()=>{
            try {
                const blockNumber = await config.provider.getBlockNumber();
                if (blockNumber > config.blockNumber) config.blockNumber = blockNumber;
            } catch (error) {
                config.blockNumber = -2;
                config._lastFatalError = error;
                config._lastFatalErrorTimestamp = getTime();
            }
            config._updateNumber = null;
        })();
        await config._updateNumber;
        config.outOfSync++;
        if (config._lastFatalError) break;
    }
}
function _normalize(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[" + value.map(_normalize).join(",") + "]";
    if (typeof value === "object" && typeof value.toJSON === "function") return _normalize(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
        case "number":
            return BigInt(value).toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{" + keys.map((k)=>`${JSON.stringify(k)}:${_normalize(value[k])}`).join(",") + "}";
            }
    }
    console.log("Could not serialize", value);
    throw new Error("Hmm...");
}
function normalizeResult(value) {
    if ("error" in value) {
        const error = value.error;
        return {
            tag: _normalize(error),
            value: error
        };
    }
    const result = value.result;
    return {
        tag: _normalize(result),
        value: result
    };
}
// This strategy picks the highest weight result, as long as the weight is
// equal to or greater than quorum
function checkQuorum(quorum, results) {
    const tally = new Map();
    for (const { value, tag, weight } of results){
        const t = tally.get(tag) || {
            value,
            weight: 0
        };
        t.weight += weight;
        tally.set(tag, t);
    }
    let best = null;
    for (const r of tally.values())if (r.weight >= quorum && (!best || r.weight > best.weight)) best = r;
    if (best) return best.value;
    return undefined;
}
function getMedian(quorum, results) {
    let resultWeight = 0;
    const errorMap = new Map();
    let bestError = null;
    const values = [];
    for (const { value, tag, weight } of results)if (value instanceof Error) {
        const e = errorMap.get(tag) || {
            value,
            weight: 0
        };
        e.weight += weight;
        errorMap.set(tag, e);
        if (bestError == null || e.weight > bestError.weight) bestError = e;
    } else {
        values.push(BigInt(value));
        resultWeight += weight;
    }
    if (resultWeight < quorum) {
        // We have quorum for an error
        if (bestError && bestError.weight >= quorum) return bestError.value;
        // We do not have quorum for a result
        return undefined;
    }
    // Get the sorted values
    values.sort((a, b)=>a < b ? -1 : b > a ? 1 : 0);
    const mid = Math.floor(values.length / 2);
    // Odd-length; take the middle value
    if (values.length % 2) return values[mid];
    // Even length; take the ceiling of the mean of the center two values
    return (values[mid - 1] + values[mid] + BN_1) / BN_2;
}
function getAnyResult(quorum, results) {
    // If any value or error meets quorum, that is our preferred result
    const result = checkQuorum(quorum, results);
    if (result !== undefined) return result;
    // Otherwise, do we have any result?
    for (const r of results){
        if (r.value) return r.value;
    }
    // Nope!
    return undefined;
}
function getFuzzyMode(quorum, results) {
    if (quorum === 1) return (0, _indexJs.getNumber)(getMedian(quorum, results), "%internal");
    const tally = new Map();
    const add = (result, weight)=>{
        const t = tally.get(result) || {
            result,
            weight: 0
        };
        t.weight += weight;
        tally.set(result, t);
    };
    for (const { weight, value } of results){
        const r = (0, _indexJs.getNumber)(value);
        add(r - 1, weight);
        add(r, weight);
        add(r + 1, weight);
    }
    let bestWeight = 0;
    let bestResult = undefined;
    for (const { weight, result } of tally.values())// Use this result, if this result meets quorum and has either:
    // - a better weight
    // - or equal weight, but the result is larger
    if (weight >= quorum && (weight > bestWeight || bestResult != null && weight === bestWeight && result > bestResult)) {
        bestWeight = weight;
        bestResult = result;
    }
    return bestResult;
}
class FallbackProvider extends (0, _abstractProviderJs.AbstractProvider) {
    /**
     *  The number of backends that must agree on a value before it is
     *  accpeted.
     */ quorum;
    /**
     *  @_ignore:
     */ eventQuorum;
    /**
     *  @_ignore:
     */ eventWorkers;
    #configs;
    #height;
    #initialSyncPromise;
    /**
     *  Creates a new **FallbackProvider** with %%providers%% connected to
     *  %%network%%.
     *
     *  If a [[Provider]] is included in %%providers%%, defaults are used
     *  for the configuration.
     */ constructor(providers, network, options){
        super(network, options);
        this.#configs = providers.map((p)=>{
            if (p instanceof (0, _abstractProviderJs.AbstractProvider)) return Object.assign({
                provider: p
            }, defaultConfig, defaultState);
            else return Object.assign({}, defaultConfig, p, defaultState);
        });
        this.#height = -2;
        this.#initialSyncPromise = null;
        if (options && options.quorum != null) this.quorum = options.quorum;
        else this.quorum = Math.ceil(this.#configs.reduce((accum, config)=>{
            accum += config.weight;
            return accum;
        }, 0) / 2);
        this.eventQuorum = 1;
        this.eventWorkers = 1;
        (0, _indexJs.assertArgument)(this.quorum <= this.#configs.reduce((a, c)=>a + c.weight, 0), "quorum exceed provider wieght", "quorum", this.quorum);
    }
    get providerConfigs() {
        return this.#configs.map((c)=>{
            const result = Object.assign({}, c);
            for(const key in result)if (key[0] === "_") delete result[key];
            return result;
        });
    }
    async _detectNetwork() {
        return (0, _networkJs.Network).from((0, _indexJs.getBigInt)(await this._perform({
            method: "chainId"
        })));
    }
    // @TODO: Add support to select providers to be the event subscriber
    //_getSubscriber(sub: Subscription): Subscriber {
    //    throw new Error("@TODO");
    //}
    /**
     *  Transforms a %%req%% into the correct method call on %%provider%%.
     */ async _translatePerform(provider, req) {
        switch(req.method){
            case "broadcastTransaction":
                return await provider.broadcastTransaction(req.signedTransaction);
            case "call":
                return await provider.call(Object.assign({}, req.transaction, {
                    blockTag: req.blockTag
                }));
            case "chainId":
                return (await provider.getNetwork()).chainId;
            case "estimateGas":
                return await provider.estimateGas(req.transaction);
            case "getBalance":
                return await provider.getBalance(req.address, req.blockTag);
            case "getBlock":
                {
                    const block = "blockHash" in req ? req.blockHash : req.blockTag;
                    return await provider.getBlock(block, req.includeTransactions);
                }
            case "getBlockNumber":
                return await provider.getBlockNumber();
            case "getCode":
                return await provider.getCode(req.address, req.blockTag);
            case "getGasPrice":
                return (await provider.getFeeData()).gasPrice;
            case "getPriorityFee":
                return (await provider.getFeeData()).maxPriorityFeePerGas;
            case "getLogs":
                return await provider.getLogs(req.filter);
            case "getStorage":
                return await provider.getStorage(req.address, req.position, req.blockTag);
            case "getTransaction":
                return await provider.getTransaction(req.hash);
            case "getTransactionCount":
                return await provider.getTransactionCount(req.address, req.blockTag);
            case "getTransactionReceipt":
                return await provider.getTransactionReceipt(req.hash);
            case "getTransactionResult":
                return await provider.getTransactionResult(req.hash);
        }
    }
    // Grab the next (random) config that is not already part of
    // the running set
    #getNextConfig(running) {
        // @TODO: Maybe do a check here to favour (heavily) providers that
        //        do not require waitForSync and disfavour providers that
        //        seem down-ish or are behaving slowly
        const configs = Array.from(running).map((r)=>r.config);
        // Shuffle the states, sorted by priority
        const allConfigs = this.#configs.slice();
        shuffle(allConfigs);
        allConfigs.sort((a, b)=>a.priority - b.priority);
        for (const config of allConfigs){
            if (config._lastFatalError) continue;
            if (configs.indexOf(config) === -1) return config;
        }
        return null;
    }
    // Adds a new runner (if available) to running.
    #addRunner(running, req) {
        const config = this.#getNextConfig(running);
        // No runners available
        if (config == null) return null;
        // Create a new runner
        const runner = {
            config,
            result: null,
            didBump: false,
            perform: null,
            staller: null
        };
        const now = getTime();
        // Start performing this operation
        runner.perform = (async ()=>{
            try {
                config.requests++;
                const result = await this._translatePerform(config.provider, req);
                runner.result = {
                    result
                };
            } catch (error) {
                config.errorResponses++;
                runner.result = {
                    error
                };
            }
            const dt = getTime() - now;
            config._totalTime += dt;
            config.rollingDuration = 0.95 * config.rollingDuration + 0.05 * dt;
            runner.perform = null;
        })();
        // Start a staller; when this times out, it's time to force
        // kicking off another runner because we are taking too long
        runner.staller = (async ()=>{
            await stall(config.stallTimeout);
            runner.staller = null;
        })();
        running.add(runner);
        return runner;
    }
    // Initializes the blockNumber and network for each runner and
    // blocks until initialized
    async #initialSync() {
        let initialSync = this.#initialSyncPromise;
        if (!initialSync) {
            const promises = [];
            this.#configs.forEach((config)=>{
                promises.push((async ()=>{
                    await waitForSync(config, 0);
                    if (!config._lastFatalError) config._network = await config.provider.getNetwork();
                })());
            });
            this.#initialSyncPromise = initialSync = (async ()=>{
                // Wait for all providers to have a block number and network
                await Promise.all(promises);
                // Check all the networks match
                let chainId = null;
                for (const config of this.#configs){
                    if (config._lastFatalError) continue;
                    const network = config._network;
                    if (chainId == null) chainId = network.chainId;
                    else if (network.chainId !== chainId) (0, _indexJs.assert)(false, "cannot mix providers on different networks", "UNSUPPORTED_OPERATION", {
                        operation: "new FallbackProvider"
                    });
                }
            })();
        }
        await initialSync;
    }
    async #checkQuorum(running, req) {
        // Get all the result objects
        const results = [];
        for (const runner of running)if (runner.result != null) {
            const { tag, value } = normalizeResult(runner.result);
            results.push({
                tag,
                value,
                weight: runner.config.weight
            });
        }
        // Are there enough results to event meet quorum?
        if (results.reduce((a, r)=>a + r.weight, 0) < this.quorum) return undefined;
        switch(req.method){
            case "getBlockNumber":
                {
                    // We need to get the bootstrap block height
                    if (this.#height === -2) this.#height = Math.ceil((0, _indexJs.getNumber)(getMedian(this.quorum, this.#configs.filter((c)=>!c._lastFatalError).map((c)=>({
                            value: c.blockNumber,
                            tag: (0, _indexJs.getNumber)(c.blockNumber).toString(),
                            weight: c.weight
                        })))));
                    // Find the mode across all the providers, allowing for
                    // a little drift between block heights
                    const mode = getFuzzyMode(this.quorum, results);
                    if (mode === undefined) return undefined;
                    if (mode > this.#height) this.#height = mode;
                    return this.#height;
                }
            case "getGasPrice":
            case "getPriorityFee":
            case "estimateGas":
                return getMedian(this.quorum, results);
            case "getBlock":
                // Pending blocks are in the mempool and already
                // quite untrustworthy; just grab anything
                if ("blockTag" in req && req.blockTag === "pending") return getAnyResult(this.quorum, results);
                return checkQuorum(this.quorum, results);
            case "call":
            case "chainId":
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
            case "getStorage":
            case "getTransaction":
            case "getTransactionReceipt":
            case "getLogs":
                return checkQuorum(this.quorum, results);
            case "broadcastTransaction":
                return getAnyResult(this.quorum, results);
        }
        (0, _indexJs.assert)(false, "unsupported method", "UNSUPPORTED_OPERATION", {
            operation: `_perform(${stringify(req.method)})`
        });
    }
    async #waitForQuorum(running, req) {
        if (running.size === 0) throw new Error("no runners?!");
        // Any promises that are interesting to watch for; an expired stall
        // or a successful perform
        const interesting = [];
        let newRunners = 0;
        for (const runner of running){
            // No responses, yet; keep an eye on it
            if (runner.perform) interesting.push(runner.perform);
            // Still stalling...
            if (runner.staller) {
                interesting.push(runner.staller);
                continue;
            }
            // This runner has already triggered another runner
            if (runner.didBump) continue;
            // Got a response (result or error) or stalled; kick off another runner
            runner.didBump = true;
            newRunners++;
        }
        // Check if we have reached quorum on a result (or error)
        const value = await this.#checkQuorum(running, req);
        if (value !== undefined) {
            if (value instanceof Error) throw value;
            return value;
        }
        // Add any new runners, because a staller timed out or a result
        // or error response came in.
        for(let i = 0; i < newRunners; i++)this.#addRunner(running, req);
        // All providers have returned, and we have no result
        (0, _indexJs.assert)(interesting.length > 0, "quorum not met", "SERVER_ERROR", {
            request: "%sub-requests",
            info: {
                request: req,
                results: Array.from(running).map((r)=>stringify(r.result))
            }
        });
        // Wait for someone to either complete its perform or stall out
        await Promise.race(interesting);
        // This is recursive, but at worst case the depth is 2x the
        // number of providers (each has a perform and a staller)
        return await this.#waitForQuorum(running, req);
    }
    async _perform(req) {
        // Broadcasting a transaction is rare (ish) and already incurs
        // a cost on the user, so spamming is safe-ish. Just send it to
        // every backend.
        if (req.method === "broadcastTransaction") {
            // Once any broadcast provides a positive result, use it. No
            // need to wait for anyone else
            const results = this.#configs.map((c)=>null);
            const broadcasts = this.#configs.map(async ({ provider, weight }, index)=>{
                try {
                    const result = await provider._perform(req);
                    results[index] = Object.assign(normalizeResult({
                        result
                    }), {
                        weight
                    });
                } catch (error) {
                    results[index] = Object.assign(normalizeResult({
                        error
                    }), {
                        weight
                    });
                }
            });
            // As each promise finishes...
            while(true){
                // Check for a valid broadcast result
                const done = results.filter((r)=>r != null);
                for (const { value } of done){
                    if (!(value instanceof Error)) return value;
                }
                // Check for a legit broadcast error (one which we cannot
                // recover from; some nodes may return the following red
                // herring events:
                // - alredy seend (UNKNOWN_ERROR)
                // - NONCE_EXPIRED
                // - REPLACEMENT_UNDERPRICED
                const result = checkQuorum(this.quorum, results.filter((r)=>r != null));
                if ((0, _indexJs.isError)(result, "INSUFFICIENT_FUNDS")) throw result;
                // Kick off the next provider (if any)
                const waiting = broadcasts.filter((b, i)=>results[i] == null);
                if (waiting.length === 0) break;
                await Promise.race(waiting);
            }
            // Use standard quorum results; any result was returned above,
            // so this will find any error that met quorum if any
            const result = getAnyResult(this.quorum, results);
            (0, _indexJs.assert)(result !== undefined, "problem multi-broadcasting", "SERVER_ERROR", {
                request: "%sub-requests",
                info: {
                    request: req,
                    results: results.map(stringify)
                }
            });
            if (result instanceof Error) throw result;
            return result;
        }
        await this.#initialSync();
        // Bootstrap enough runners to meet quorum
        const running = new Set();
        let inflightQuorum = 0;
        while(true){
            const runner = this.#addRunner(running, req);
            if (runner == null) break;
            inflightQuorum += runner.config.weight;
            if (inflightQuorum >= this.quorum) break;
        }
        const result = await this.#waitForQuorum(running, req);
        // Track requests sent to a provider that are still
        // outstanding after quorum has been otherwise found
        for (const runner of running)if (runner.perform && runner.result == null) runner.config.lateResponses++;
        return result;
    }
    async destroy() {
        for (const { provider } of this.#configs)provider.destroy();
        super.destroy();
    }
}

},{"../utils/index.js":"4LgPJ","./abstract-provider.js":"jQbel","./network.js":"7ojLV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNVTd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **NonceManager** wraps another [[Signer]] and automatically manages
 *  the nonce, ensuring serialized and sequential nonces are used during
 *  transaction.
 */ parcelHelpers.export(exports, "NonceManager", ()=>NonceManager);
var _indexJs = require("../utils/index.js");
var _abstractSignerJs = require("./abstract-signer.js");
class NonceManager extends (0, _abstractSignerJs.AbstractSigner) {
    /**
     *  The Signer being managed.
     */ signer;
    #noncePromise;
    #delta;
    /**
     *  Creates a new **NonceManager** to manage %%signer%%.
     */ constructor(signer){
        super(signer.provider);
        (0, _indexJs.defineProperties)(this, {
            signer
        });
        this.#noncePromise = null;
        this.#delta = 0;
    }
    async getAddress() {
        return this.signer.getAddress();
    }
    connect(provider) {
        return new NonceManager(this.signer.connect(provider));
    }
    async getNonce(blockTag) {
        if (blockTag === "pending") {
            if (this.#noncePromise == null) this.#noncePromise = super.getNonce("pending");
            const delta = this.#delta;
            return await this.#noncePromise + delta;
        }
        return super.getNonce(blockTag);
    }
    /**
     *  Manually increment the nonce. This may be useful when managng
     *  offline transactions.
     */ increment() {
        this.#delta++;
    }
    /**
     *  Resets the nonce, causing the **NonceManager** to reload the current
     *  nonce from the blockchain on the next transaction.
     */ reset() {
        this.#delta = 0;
        this.#noncePromise = null;
    }
    async sendTransaction(tx) {
        const noncePromise = this.getNonce("pending");
        this.increment();
        tx = await this.signer.populateTransaction(tx);
        tx.nonce = await noncePromise;
        // @TODO: Maybe handle interesting/recoverable errors?
        // Like don't increment if the tx was certainly not sent
        return await this.signer.sendTransaction(tx);
    }
    signTransaction(tx) {
        return this.signer.signTransaction(tx);
    }
    signMessage(message) {
        return this.signer.signMessage(message);
    }
    signTypedData(domain, types, value) {
        return this.signer.signTypedData(domain, types, value);
    }
}

},{"../utils/index.js":"4LgPJ","./abstract-signer.js":"gFBgG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"75VQh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **BrowserProvider** is intended to wrap an injected provider which
 *  adheres to the [[link-eip-1193]] standard, which most (if not all)
 *  currently do.
 */ parcelHelpers.export(exports, "BrowserProvider", ()=>BrowserProvider);
var _indexJs = require("../utils/index.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
class BrowserProvider extends (0, _providerJsonrpcJs.JsonRpcApiPollingProvider) {
    #request;
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network){
        (0, _indexJs.assertArgument)(ethereum && ethereum.request, "invalid EIP-1193 provider", "ethereum", ethereum);
        super(network, {
            batchMaxCount: 1
        });
        this.#request = async (method, params)=>{
            const payload = {
                method,
                params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error
                });
                throw error;
            }
        };
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, _indexJs.assertArgument)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into 
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            //const resp = 
            await this.#request("eth_requestAccounts", []);
        //console.log("RESP", resp);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error
            });
        }
        return await super.getSigner(address);
    }
}

},{"../utils/index.js":"4LgPJ","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ngzD":[function(require,module,exports) {
/**
 *  [[link-pocket]] provides a third-party service for connecting to
 *  various blockchains over JSON-RPC.
 *
 *  **Supported Networks**
 *
 *  - Ethereum Mainnet (``mainnet``)
 *  - Goerli Testnet (``goerli``)
 *  - Polygon (``matic``)
 *  - Arbitrum (``arbitrum``)
 *
 *  @_subsection: api/providers/thirdparty:Pocket  [providers-pocket]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **PocketProvider** connects to the [[link-pocket]]
 *  JSON-RPC end-points.
 *
 *  By default, a highly-throttled API key is used, which is
 *  appropriate for quick prototypes and simple scripts. To
 *  gain access to an increased rate-limit, it is highly
 *  recommended to [sign up here](link-pocket-signup).
 */ parcelHelpers.export(exports, "PocketProvider", ()=>PocketProvider);
var _indexJs = require("../utils/index.js");
var _communityJs = require("./community.js");
var _networkJs = require("./network.js");
var _providerJsonrpcJs = require("./provider-jsonrpc.js");
const defaultApplicationId = "62e1ad51b37b8e00394bda3b";
function getHost(name) {
    switch(name){
        case "mainnet":
            return "eth-mainnet.gateway.pokt.network";
        case "goerli":
            return "eth-goerli.gateway.pokt.network";
        case "matic":
            return "poly-mainnet.gateway.pokt.network";
        case "matic-mumbai":
            return "polygon-mumbai-rpc.gateway.pokt.network";
    }
    (0, _indexJs.assertArgument)(false, "unsupported network", "network", name);
}
class PocketProvider extends (0, _providerJsonrpcJs.JsonRpcProvider) {
    /**
     *  The Application ID for the Pocket connection.
     */ applicationId;
    /**
     *  The Application Secret for making authenticated requests
     *  to the Pocket connection.
     */ applicationSecret;
    /**
     *  Create a new **PocketProvider**.
     *
     *  By default connecting to ``mainnet`` with a highly throttled
     *  API key.
     */ constructor(_network, applicationId, applicationSecret){
        if (_network == null) _network = "mainnet";
        const network = (0, _networkJs.Network).from(_network);
        if (applicationId == null) applicationId = defaultApplicationId;
        if (applicationSecret == null) applicationSecret = null;
        const options = {
            staticNetwork: network
        };
        const request = PocketProvider.getRequest(network, applicationId, applicationSecret);
        super(request, network, options);
        (0, _indexJs.defineProperties)(this, {
            applicationId,
            applicationSecret
        });
    }
    _getProvider(chainId) {
        try {
            return new PocketProvider(chainId, this.applicationId, this.applicationSecret);
        } catch (error) {}
        return super._getProvider(chainId);
    }
    /**
     *  Returns a prepared request for connecting to %%network%% with
     *  %%applicationId%%.
     */ static getRequest(network, applicationId, applicationSecret) {
        if (applicationId == null) applicationId = defaultApplicationId;
        const request = new (0, _indexJs.FetchRequest)(`https:/\/${getHost(network.name)}/v1/lb/${applicationId}`);
        request.allowGzip = true;
        if (applicationSecret) request.setCredentials("", applicationSecret);
        if (applicationId === defaultApplicationId) request.retryFunc = async (request, response, attempt)=>{
            (0, _communityJs.showThrottleMessage)("PocketProvider");
            return true;
        };
        return request;
    }
    isCommunityResource() {
        return this.applicationId === defaultApplicationId;
    }
}

},{"../utils/index.js":"4LgPJ","./community.js":"dJBY6","./network.js":"7ojLV","./provider-jsonrpc.js":"iaEcB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Tw5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IpcSocketProvider", ()=>IpcSocketProvider);
const IpcSocketProvider = undefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fT0d5":[function(require,module,exports) {
/**
 *  When interacting with Ethereum, it is necessary to use a private
 *  key authenticate actions by signing a payload.
 *
 *  Wallets are the simplest way to expose the concept of an
 *  //Externally Owner Account// (EOA) as it wraps a private key
 *  and supports high-level methods to sign common types of interaction
 *  and send transactions.
 *
 *  The class most developers will want to use is [[Wallet]], which
 *  can load a private key directly or from any common wallet format.
 *
 *  The [[HDNodeWallet]] can be used when it is necessary to access
 *  low-level details of how an HD wallets are derived, exported
 *  or imported.
 *
 *  @_section: api/wallet:Wallets  [about-wallets]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseWallet", ()=>(0, _baseWalletJs.BaseWallet));
parcelHelpers.export(exports, "defaultPath", ()=>(0, _hdwalletJs.defaultPath));
parcelHelpers.export(exports, "getAccountPath", ()=>(0, _hdwalletJs.getAccountPath));
parcelHelpers.export(exports, "getIndexedAccountPath", ()=>(0, _hdwalletJs.getIndexedAccountPath));
parcelHelpers.export(exports, "HDNodeWallet", ()=>(0, _hdwalletJs.HDNodeWallet));
parcelHelpers.export(exports, "HDNodeVoidWallet", ()=>(0, _hdwalletJs.HDNodeVoidWallet));
parcelHelpers.export(exports, "isCrowdsaleJson", ()=>(0, _jsonCrowdsaleJs.isCrowdsaleJson));
parcelHelpers.export(exports, "decryptCrowdsaleJson", ()=>(0, _jsonCrowdsaleJs.decryptCrowdsaleJson));
parcelHelpers.export(exports, "isKeystoreJson", ()=>(0, _jsonKeystoreJs.isKeystoreJson));
parcelHelpers.export(exports, "decryptKeystoreJsonSync", ()=>(0, _jsonKeystoreJs.decryptKeystoreJsonSync));
parcelHelpers.export(exports, "decryptKeystoreJson", ()=>(0, _jsonKeystoreJs.decryptKeystoreJson));
parcelHelpers.export(exports, "encryptKeystoreJson", ()=>(0, _jsonKeystoreJs.encryptKeystoreJson));
parcelHelpers.export(exports, "encryptKeystoreJsonSync", ()=>(0, _jsonKeystoreJs.encryptKeystoreJsonSync));
parcelHelpers.export(exports, "Mnemonic", ()=>(0, _mnemonicJs.Mnemonic));
parcelHelpers.export(exports, "Wallet", ()=>(0, _walletJs.Wallet));
var _baseWalletJs = require("./base-wallet.js");
var _hdwalletJs = require("./hdwallet.js");
var _jsonCrowdsaleJs = require("./json-crowdsale.js");
var _jsonKeystoreJs = require("./json-keystore.js");
var _mnemonicJs = require("./mnemonic.js");
var _walletJs = require("./wallet.js");

},{"./base-wallet.js":"6QsJK","./hdwallet.js":"1TAim","./json-crowdsale.js":"dbG4O","./json-keystore.js":"htQBf","./mnemonic.js":"kWQMV","./wallet.js":"ge8e2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QsJK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The **BaseWallet** is a stream-lined implementation of a
 *  [[Signer]] that operates with a private key.
 *
 *  It is preferred to use the [[Wallet]] class, as it offers
 *  additional functionality and simplifies loading a variety
 *  of JSON formats, Mnemonic Phrases, etc.
 *
 *  This class may be of use for those attempting to implement
 *  a minimal Signer.
 */ parcelHelpers.export(exports, "BaseWallet", ()=>BaseWallet);
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../hash/index.js");
var _indexJs2 = require("../providers/index.js");
var _indexJs3 = require("../transaction/index.js");
var _indexJs4 = require("../utils/index.js");
class BaseWallet extends (0, _indexJs2.AbstractSigner) {
    /**
     *  The wallet address.
     */ address;
    #signingKey;
    /**
     *  Creates a new BaseWallet for %%privateKey%%, optionally
     *  connected to %%provider%%.
     *
     *  If %%provider%% is not specified, only offline methods can
     *  be used.
     */ constructor(privateKey, provider){
        super(provider);
        (0, _indexJs4.assertArgument)(privateKey && typeof privateKey.sign === "function", "invalid private key", "privateKey", "[ REDACTED ]");
        this.#signingKey = privateKey;
        const address = (0, _indexJs3.computeAddress)(this.signingKey.publicKey);
        (0, _indexJs4.defineProperties)(this, {
            address
        });
    }
    // Store private values behind getters to reduce visibility
    // in console.log
    /**
     *  The [[SigningKey]] used for signing payloads.
     */ get signingKey() {
        return this.#signingKey;
    }
    /**
     *  The private key for this wallet.
     */ get privateKey() {
        return this.signingKey.privateKey;
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new BaseWallet(this.#signingKey, provider);
    }
    async signTransaction(tx) {
        // Replace any Addressable or ENS name with an address
        const { to, from } = await (0, _indexJs4.resolveProperties)({
            to: tx.to ? (0, _indexJs.resolveAddress)(tx.to, this.provider) : undefined,
            from: tx.from ? (0, _indexJs.resolveAddress)(tx.from, this.provider) : undefined
        });
        if (to != null) tx.to = to;
        if (from != null) tx.from = from;
        if (tx.from != null) {
            (0, _indexJs4.assertArgument)((0, _indexJs.getAddress)(tx.from) === this.address, "transaction from address mismatch", "tx.from", tx.from);
            delete tx.from;
        }
        // Build the transaction
        const btx = (0, _indexJs3.Transaction).from(tx);
        btx.signature = this.signingKey.sign(btx.unsignedHash);
        return btx.serialized;
    }
    async signMessage(message) {
        return this.signMessageSync(message);
    }
    // @TODO: Add a secialized signTx and signTyped sync that enforces
    // all parameters are known?
    /**
     *  Returns the signature for %%message%% signed with this wallet.
     */ signMessageSync(message) {
        return this.signingKey.sign((0, _indexJs1.hashMessage)(message)).serialized;
    }
    async signTypedData(domain, types, value) {
        // Populate any ENS names
        const populated = await (0, _indexJs1.TypedDataEncoder).resolveNames(domain, types, value, async (name)=>{
            // @TODO: this should use resolveName; addresses don't
            //        need a provider
            (0, _indexJs4.assert)(this.provider != null, "cannot resolve ENS names without a provider", "UNSUPPORTED_OPERATION", {
                operation: "resolveName",
                info: {
                    name
                }
            });
            const address = await this.provider.resolveName(name);
            (0, _indexJs4.assert)(address != null, "unconfigured ENS name", "UNCONFIGURED_NAME", {
                value: name
            });
            return address;
        });
        return this.signingKey.sign((0, _indexJs1.TypedDataEncoder).hash(populated.domain, types, populated.value)).serialized;
    }
}

},{"../address/index.js":"3THmk","../hash/index.js":"3Gr4x","../providers/index.js":"8NGaI","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1TAim":[function(require,module,exports) {
/**
 *  Explain HD Wallets..
 *
 *  @_subsection: api/wallet:HD Wallets  [hd-wallets]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPath", ()=>defaultPath);
/**
 *  An **HDNodeWallet** is a [[Signer]] backed by the private key derived
 *  from an HD Node using the [[link-bip-32]] stantard.
 *
 *  An HD Node forms a hierarchal structure with each HD Node having a
 *  private key and the ability to derive child HD Nodes, defined by
 *  a path indicating the index of each child.
 */ parcelHelpers.export(exports, "HDNodeWallet", ()=>HDNodeWallet);
/**
 *  A **HDNodeVoidWallet** cannot sign, but provides access to
 *  the children nodes of a [[link-bip-32]] HD wallet addresses.
 *
 *  The can be created by using an extended ``xpub`` key to
 *  [[HDNodeWallet_fromExtendedKey]] or by
 *  [nuetering](HDNodeWallet-neuter) a [[HDNodeWallet]].
 */ parcelHelpers.export(exports, "HDNodeVoidWallet", ()=>HDNodeVoidWallet);
/*
export class HDNodeWalletManager {
    #root: HDNodeWallet;

    constructor(phrase: string, password?: null | string, path?: null | string, locale?: null | Wordlist) {
        if (password == null) { password = ""; }
        if (path == null) { path = "m/44'/60'/0'/0"; }
        if (locale == null) { locale = LangEn.wordlist(); }
        this.#root = HDNodeWallet.fromPhrase(phrase, password, path, locale);
    }

    getSigner(index?: number): HDNodeWallet {
        return this.#root.deriveChild((index == null) ? 0: index);
    }
}
*/ /**
 *  Returns the [[link-bip-32]] path for the account at %%index%%.
 *
 *  This is the pattern used by wallets like Ledger.
 *
 *  There is also an [alternate pattern](getIndexedAccountPath) used by
 *  some software.
 */ parcelHelpers.export(exports, "getAccountPath", ()=>getAccountPath);
/**
 *  Returns the path using an alternative pattern for deriving accounts,
 *  at %%index%%.
 *
 *  This derivation path uses the //index// component rather than the
 *  //account// component to derive sequential accounts.
 *
 *  This is the pattern used by wallets like MetaMask.
 */ parcelHelpers.export(exports, "getIndexedAccountPath", ()=>getIndexedAccountPath);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../providers/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
var _langEnJs = require("../wordlists/lang-en.js");
var _baseWalletJs = require("./base-wallet.js");
var _mnemonicJs = require("./mnemonic.js");
var _jsonKeystoreJs = require("./json-keystore.js");
const defaultPath = "m/44'/60'/0'/0/0";
// "Bitcoin seed"
const MasterSecret = new Uint8Array([
    66,
    105,
    116,
    99,
    111,
    105,
    110,
    32,
    115,
    101,
    101,
    100
]);
const HardenedBit = 0x80000000;
const N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const Nibbles = "0123456789abcdef";
function zpad(value, length) {
    let result = "";
    while(value){
        result = Nibbles[value % 16] + result;
        value = Math.trunc(value / 16);
    }
    while(result.length < length * 2)result = "0" + result;
    return "0x" + result;
}
function encodeBase58Check(_value) {
    const value = (0, _indexJs3.getBytes)(_value);
    const check = (0, _indexJs3.dataSlice)((0, _indexJs.sha256)((0, _indexJs.sha256)(value)), 0, 4);
    const bytes = (0, _indexJs3.concat)([
        value,
        check
    ]);
    return (0, _indexJs3.encodeBase58)(bytes);
}
const _guard = {};
function ser_I(index, chainCode, publicKey, privateKey) {
    const data = new Uint8Array(37);
    if (index & HardenedBit) {
        (0, _indexJs3.assert)(privateKey != null, "cannot derive child of neutered node", "UNSUPPORTED_OPERATION", {
            operation: "deriveChild"
        });
        // Data = 0x00 || ser_256(k_par)
        data.set((0, _indexJs3.getBytes)(privateKey), 1);
    } else // Data = ser_p(point(k_par))
    data.set((0, _indexJs3.getBytes)(publicKey));
    // Data += ser_32(i)
    for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
    const I = (0, _indexJs3.getBytes)((0, _indexJs.computeHmac)("sha512", chainCode, data));
    return {
        IL: I.slice(0, 32),
        IR: I.slice(32)
    };
}
function derivePath(node, path) {
    const components = path.split("/");
    (0, _indexJs3.assertArgument)(components.length > 0, "invalid path", "path", path);
    if (components[0] === "m") {
        (0, _indexJs3.assertArgument)(node.depth === 0, `cannot derive root path (i.e. path starting with "m/") for a node at non-zero depth ${node.depth}`, "path", path);
        components.shift();
    }
    let result = node;
    for(let i = 0; i < components.length; i++){
        const component = components[i];
        if (component.match(/^[0-9]+'$/)) {
            const index = parseInt(component.substring(0, component.length - 1));
            (0, _indexJs3.assertArgument)(index < HardenedBit, "invalid path index", `path[${i}]`, component);
            result = result.deriveChild(HardenedBit + index);
        } else if (component.match(/^[0-9]+$/)) {
            const index = parseInt(component);
            (0, _indexJs3.assertArgument)(index < HardenedBit, "invalid path index", `path[${i}]`, component);
            result = result.deriveChild(index);
        } else (0, _indexJs3.assertArgument)(false, "invalid path component", `path[${i}]`, component);
    }
    return result;
}
class HDNodeWallet extends (0, _baseWalletJs.BaseWallet) {
    /**
     *  The compressed public key.
     */ publicKey;
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */ fingerprint;
    /**
     *  The parent fingerprint.
     */ parentFingerprint;
    /**
     *  The mnemonic used to create this HD Node, if available.
     *
     *  Sources such as extended keys do not encode the mnemonic, in
     *  which case this will be ``null``.
     */ mnemonic;
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */ chainCode;
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provider full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  enocde it.
     */ path;
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */ index;
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */ depth;
    /**
     *  @private
     */ constructor(guard, signingKey, parentFingerprint, chainCode, path, index, depth, mnemonic, provider){
        super(signingKey, provider);
        (0, _indexJs3.assertPrivate)(guard, _guard, "HDNodeWallet");
        (0, _indexJs3.defineProperties)(this, {
            publicKey: signingKey.compressedPublicKey
        });
        const fingerprint = (0, _indexJs3.dataSlice)((0, _indexJs.ripemd160)((0, _indexJs.sha256)(this.publicKey)), 0, 4);
        (0, _indexJs3.defineProperties)(this, {
            parentFingerprint,
            fingerprint,
            chainCode,
            path,
            index,
            depth
        });
        (0, _indexJs3.defineProperties)(this, {
            mnemonic
        });
    }
    connect(provider) {
        return new HDNodeWallet(_guard, this.signingKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.mnemonic, provider);
    }
    #account() {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        const m = this.mnemonic;
        if (this.path && m && m.wordlist.locale === "en" && m.password === "") account.mnemonic = {
            path: this.path,
            locale: "en",
            entropy: m.entropy
        };
        return account;
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */ async encrypt(password, progressCallback) {
        return await (0, _jsonKeystoreJs.encryptKeystoreJson)(this.#account(), password, {
            progressCallback
        });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */ encryptSync(password) {
        return (0, _jsonKeystoreJs.encryptKeystoreJsonSync)(this.#account(), password);
    }
    /**
     *  The extended key.
     *
     *  This key will begin with the prefix ``xpriv`` and can be used to
     *  reconstruct this HD Node to derive its children.
     */ get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        (0, _indexJs3.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", {
            operation: "extendedKey"
        });
        return encodeBase58Check((0, _indexJs3.concat)([
            "0x0488ADE4",
            zpad(this.depth, 1),
            this.parentFingerprint,
            zpad(this.index, 4),
            this.chainCode,
            (0, _indexJs3.concat)([
                "0x00",
                this.privateKey
            ])
        ]));
    }
    /**
     *  Returns true if this wallet has a path, providing a Type Guard
     *  that the path is non-null.
     */ hasPath() {
        return this.path != null;
    }
    /**
     *  Returns a neutered HD Node, which removes the private details
     *  of an HD Node.
     *
     *  A neutered node has no private key, but can be used to derive
     *  child addresses and other public data about the HD Node.
     */ neuter() {
        return new HDNodeVoidWallet(_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, this.provider);
    }
    /**
     *  Return the child for %%index%%.
     */ deriveChild(_index) {
        const index = (0, _indexJs3.getNumber)(_index, "index");
        (0, _indexJs3.assertArgument)(index <= 0xffffffff, "invalid index", "index", index);
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~HardenedBit);
            if (index & HardenedBit) path += "'";
        }
        const { IR, IL } = ser_I(index, this.chainCode, this.publicKey, this.privateKey);
        const ki = new (0, _indexJs.SigningKey)((0, _indexJs3.toBeHex)(((0, _indexJs3.toBigInt)(IL) + BigInt(this.privateKey)) % N, 32));
        return new HDNodeWallet(_guard, ki, this.fingerprint, (0, _indexJs3.hexlify)(IR), path, index, this.depth + 1, this.mnemonic, this.provider);
    }
    /**
     *  Return the HDNode for %%path%% from this node.
     */ derivePath(path) {
        return derivePath(this, path);
    }
    static #fromSeed(_seed, mnemonic) {
        (0, _indexJs3.assertArgument)((0, _indexJs3.isBytesLike)(_seed), "invalid seed", "seed", "[REDACTED]");
        const seed = (0, _indexJs3.getBytes)(_seed, "seed");
        (0, _indexJs3.assertArgument)(seed.length >= 16 && seed.length <= 64, "invalid seed", "seed", "[REDACTED]");
        const I = (0, _indexJs3.getBytes)((0, _indexJs.computeHmac)("sha512", MasterSecret, seed));
        const signingKey = new (0, _indexJs.SigningKey)((0, _indexJs3.hexlify)(I.slice(0, 32)));
        return new HDNodeWallet(_guard, signingKey, "0x00000000", (0, _indexJs3.hexlify)(I.slice(32)), "m", 0, 0, mnemonic, null);
    }
    /**
     *  Creates a new HD Node from %%extendedKey%%.
     *
     *  If the %%extendedKey%% will either have a prefix or ``xpub`` or
     *  ``xpriv``, returning a neutered HD Node ([[HDNodeVoidWallet]])
     *  or full HD Node ([[HDNodeWallet) respectively.
     */ static fromExtendedKey(extendedKey) {
        const bytes = (0, _indexJs3.toBeArray)((0, _indexJs3.decodeBase58)(extendedKey)); // @TODO: redact
        (0, _indexJs3.assertArgument)(bytes.length === 82 || encodeBase58Check(bytes.slice(0, 78)) === extendedKey, "invalid extended key", "extendedKey", "[ REDACTED ]");
        const depth = bytes[4];
        const parentFingerprint = (0, _indexJs3.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, _indexJs3.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, _indexJs3.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, _indexJs3.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                {
                    const publicKey = (0, _indexJs3.hexlify)(key);
                    return new HDNodeVoidWallet(_guard, (0, _indexJs2.computeAddress)(publicKey), publicKey, parentFingerprint, chainCode, null, index, depth, null);
                }
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new HDNodeWallet(_guard, new (0, _indexJs.SigningKey)(key.slice(1)), parentFingerprint, chainCode, null, index, depth, null, null);
        }
        (0, _indexJs3.assertArgument)(false, "invalid extended key prefix", "extendedKey", "[ REDACTED ]");
    }
    /**
     *  Creates a new random HDNode.
     */ static createRandom(password, path, wordlist) {
        if (password == null) password = "";
        if (path == null) path = defaultPath;
        if (wordlist == null) wordlist = (0, _langEnJs.LangEn).wordlist();
        const mnemonic = (0, _mnemonicJs.Mnemonic).fromEntropy((0, _indexJs.randomBytes)(16), password, wordlist);
        return HDNodeWallet.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Create an HD Node from %%mnemonic%%.
     */ static fromMnemonic(mnemonic, path) {
        if (!path) path = defaultPath;
        return HDNodeWallet.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Creates an HD Node from a mnemonic %%phrase%%.
     */ static fromPhrase(phrase, password, path, wordlist) {
        if (password == null) password = "";
        if (path == null) path = defaultPath;
        if (wordlist == null) wordlist = (0, _langEnJs.LangEn).wordlist();
        const mnemonic = (0, _mnemonicJs.Mnemonic).fromPhrase(phrase, password, wordlist);
        return HDNodeWallet.#fromSeed(mnemonic.computeSeed(), mnemonic).derivePath(path);
    }
    /**
     *  Creates an HD Node from a %%seed%%.
     */ static fromSeed(seed) {
        return HDNodeWallet.#fromSeed(seed, null);
    }
}
class HDNodeVoidWallet extends (0, _indexJs1.VoidSigner) {
    /**
     *  The compressed public key.
     */ publicKey;
    /**
     *  The fingerprint.
     *
     *  A fingerprint allows quick qay to detect parent and child nodes,
     *  but developers should be prepared to deal with collisions as it
     *  is only 4 bytes.
     */ fingerprint;
    /**
     *  The parent node fingerprint.
     */ parentFingerprint;
    /**
     *  The chaincode, which is effectively a public key used
     *  to derive children.
     */ chainCode;
    /**
     *  The derivation path of this wallet.
     *
     *  Since extended keys do not provider full path details, this
     *  may be ``null``, if instantiated from a source that does not
     *  enocde it.
     */ path;
    /**
     *  The child index of this wallet. Values over ``2 *\* 31`` indicate
     *  the node is hardened.
     */ index;
    /**
     *  The depth of this wallet, which is the number of components
     *  in its path.
     */ depth;
    /**
     *  @private
     */ constructor(guard, address, publicKey, parentFingerprint, chainCode, path, index, depth, provider){
        super(address, provider);
        (0, _indexJs3.assertPrivate)(guard, _guard, "HDNodeVoidWallet");
        (0, _indexJs3.defineProperties)(this, {
            publicKey
        });
        const fingerprint = (0, _indexJs3.dataSlice)((0, _indexJs.ripemd160)((0, _indexJs.sha256)(publicKey)), 0, 4);
        (0, _indexJs3.defineProperties)(this, {
            publicKey,
            fingerprint,
            parentFingerprint,
            chainCode,
            path,
            index,
            depth
        });
    }
    connect(provider) {
        return new HDNodeVoidWallet(_guard, this.address, this.publicKey, this.parentFingerprint, this.chainCode, this.path, this.index, this.depth, provider);
    }
    /**
     *  The extended key.
     *
     *  This key will begin with the prefix ``xpub`` and can be used to
     *  reconstruct this neutered key to derive its children addresses.
     */ get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        (0, _indexJs3.assert)(this.depth < 256, "Depth too deep", "UNSUPPORTED_OPERATION", {
            operation: "extendedKey"
        });
        return encodeBase58Check((0, _indexJs3.concat)([
            "0x0488B21E",
            zpad(this.depth, 1),
            this.parentFingerprint,
            zpad(this.index, 4),
            this.chainCode,
            this.publicKey
        ]));
    }
    /**
     *  Returns true if this wallet has a path, providing a Type Guard
     *  that the path is non-null.
     */ hasPath() {
        return this.path != null;
    }
    /**
     *  Return the child for %%index%%.
     */ deriveChild(_index) {
        const index = (0, _indexJs3.getNumber)(_index, "index");
        (0, _indexJs3.assertArgument)(index <= 0xffffffff, "invalid index", "index", index);
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~HardenedBit);
            if (index & HardenedBit) path += "'";
        }
        const { IR, IL } = ser_I(index, this.chainCode, this.publicKey, null);
        const Ki = (0, _indexJs.SigningKey).addPoints(IL, this.publicKey, true);
        const address = (0, _indexJs2.computeAddress)(Ki);
        return new HDNodeVoidWallet(_guard, address, Ki, this.fingerprint, (0, _indexJs3.hexlify)(IR), path, index, this.depth + 1, this.provider);
    }
    /**
     *  Return the signer for %%path%% from this node.
     */ derivePath(path) {
        return derivePath(this, path);
    }
}
function getAccountPath(_index) {
    const index = (0, _indexJs3.getNumber)(_index, "index");
    (0, _indexJs3.assertArgument)(index >= 0 && index < HardenedBit, "invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}
function getIndexedAccountPath(_index) {
    const index = (0, _indexJs3.getNumber)(_index, "index");
    (0, _indexJs3.assertArgument)(index >= 0 && index < HardenedBit, "invalid account index", "index", index);
    return `m/44'/60'/0'/0/${index}`;
}

},{"../crypto/index.js":"jUsZl","../providers/index.js":"8NGaI","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","../wordlists/lang-en.js":"lae98","./base-wallet.js":"6QsJK","./mnemonic.js":"kWQMV","./json-keystore.js":"htQBf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lae98":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  The [[link-bip39-en]] for [mnemonic phrases](link-bip-39).
 *
 *  @_docloc: api/wordlists
 */ parcelHelpers.export(exports, "LangEn", ()=>LangEn);
var _wordlistOwlJs = require("./wordlist-owl.js");
const words = "0erleonalorenseinceregesticitStanvetearctssi#ch2Athck&tneLl0And#Il.yLeOutO=S|S%b/ra@SurdU'0Ce[Cid|CountCu'Hie=IdOu,-Qui*Ro[TT]T%T*[Tu$0AptDD-tD*[Ju,M.UltV<)Vi)0Rob-0FairF%dRaid0A(EEntRee0Ead0MRRp%tS!_rmBumCoholErtI&LLeyLowMo,O}PhaReadySoT Ways0A>urAz(gOngOuntU'd0Aly,Ch%Ci|G G!GryIm$K!Noun)Nu$O` Sw T&naTiqueXietyY1ArtOlogyPe?P!Pro=Ril1ChCt-EaEnaGueMMedM%MyOundR<+Re,Ri=RowTTefa@Ti,Tw%k0KPe@SaultSetSi,SumeThma0H!>OmTa{T&dT.udeTra@0Ct]D.Gu,NtTh%ToTumn0Era+OcadoOid0AkeA*AyEsomeFulKw?d0Is:ByChel%C#D+GL<)Lc#y~MbooN<aNn RRelyRga(R*lSeS-SketTt!3A^AnAutyCau'ComeEfF%eG(Ha=H(dLie=LowLtN^Nef./TrayTt Twe&Y#d3Cyc!DKeNdOlogyRdR`Tt _{AdeAmeAnketA,EakE[IndOodO[omOu'UeUrUsh_rdAtDyIlMbNeNusOkO,Rd R(gRrowSsTtomUn)XY_{etA(AndA[A=EadEezeI{Id+IefIghtIngIskOccoliOk&OnzeOomO` OwnUsh2Bb!DdyD+tFf$oIldLbLkL!tNd!Nk Rd&Rg R,SS(e[SyTt Y Zz:Bba+B(B!CtusGeKe~LmM aMpNN$N)lNdyNn#NoeNvasNy#Pab!P.$Pta(RRb#RdRgoRpetRryRtSeShS(o/!Su$TT$ogT^Teg%yTt!UghtU'Ut]Ve3Il(gL yM|NsusNturyRe$Rta(_irAlkAmp]An+AosApt Ar+A'AtEapE{Ee'EfErryE,I{&IefIldIm}yOi)Oo'R#-U{!UnkUrn0G?Nnam#Rc!Tiz&TyVil_imApArifyAwAyE<ErkEv I{I|IffImbIn-IpO{OgO'O`OudOwnUbUmpU, Ut^_^A,C#utDeFfeeIlInL!@L%LumnMb(eMeMf%tM-Mm#Mp<yNc tNdu@NfirmNg*[N}@Nsid NtrolNv()OkOlPp PyR$ReRnR*@/Tt#U^UntryUp!Ur'Us(V Yo>_{Ad!AftAmA}AshAt AwlAzyEamEd.EekEwI{etImeIspIt-OpO[Ou^OwdUci$UelUi'Umb!Un^UshYY,$2BeLtu*PPbo?dRiousRr|Rta(R=Sh]/omTe3C!:DMa+MpN)Ng R(gShUght WnY3AlBa>BrisCadeCemb CideCl(eC%a>C*a'ErF&'F(eFyG*eLayLiv M<dMi'Ni$Nti,NyP?tP&dPos.P`PutyRi=ScribeS tSignSkSpair/royTailTe@VelopVi)Vo>3AgramAlAm#dAryCeE'lEtFf G.$Gn.yLemmaNn NosaurRe@RtSag*eScov Sea'ShSmi[S%d Splay/<)V tVideV%)Zzy5Ct%Cum|G~Lph(Ma(Na>NkeyN%OrSeUb!Ve_ftAg#AmaA,-AwEamE[IftIllInkIpI=OpUmY2CkMbNeR(g/T^Ty1Arf1Nam-:G G!RlyRnR`Sily/Sy1HoOlogyOnomy0GeItUca>1F%t0G1GhtTh 2BowD E@r-Eg<tEm|Eph<tEvat%I>Se0B?kBodyBra)Er+Ot]PloyPow Pty0Ab!A@DD![D%'EmyErgyF%)Ga+G(eH<)JoyLi,OughR-hRollSu*T Ti*TryVelope1Isode0U$Uip0AA'OdeOs]R%Upt0CapeSayS&)Ta>0Ern$H-s1Id&)IlOkeOl=1A@Amp!Ce[Ch<+C.eCludeCu'Ecu>Erci'Hau,Hib.I!I,ItOt-P<dPe@Pi*Pla(Po'P*[T&dTra0EEbrow:Br-CeCultyDeIntI`~L'MeMilyMousNNcyNtasyRmSh]TT$Th TigueUltV%.e3Atu*Bru?yD $EEdElMa!N)/iv$T^V W3B Ct]EldGu*LeLmLt N$NdNeNg NishReRmR,Sc$ShTT}[X_gAmeAshAtAv%EeIghtIpOatO{O%Ow UidUshY_mCusGIlLd~owOdOtR)Re,R+tRkRtu}RumRw?dSsil/ UndX_gi!AmeEqu|EshI&dIn+OgOntO,OwnOz&U.2ElNNnyRna)RyTu*:D+tInLaxy~ yMePRa+Rba+Rd&Rl-Rm|SSpTeTh U+Ze3N $NiusN*Nt!Nu(e/u*2O,0AntFtGg!Ng RaffeRlVe_dAn)A*A[IdeImp'ObeOomOryO=OwUe_tDde[LdOdO'RillaSpelSsipV nWn_bA)A(AntApeA[Av.yEatE&IdIefItOc yOupOwUnt_rdE[IdeIltIt?N3M:B.IrLfMm M, NdPpyRb%RdRshR=,TVeWkZ?d3AdAl`ArtAvyD+hogIght~oLmetLpNRo3Dd&Gh~NtPRe/%y5BbyCkeyLdLeLiday~owMeNeyOdPeRnRr%R'Sp.$/TelUrV 5BGeM<Mb!M%Nd*dNgryNtRd!RryRtSb<d3Brid:1EOn0EaEntifyLe2N%e4LLeg$L}[0A+Ita>M&'Mu}Pa@Po'Pro=Pul'0ChCludeComeC*a'DexD-a>Do%Du,ryF<tFl-tF%mHa!H .Iti$Je@JuryMa>N Noc|PutQuiryS<eSe@SideSpi*/$lTa@T e,ToVe,V.eVol=3On0L<dOla>Sue0Em1Ory:CketGu?RZz3AlousAns~yWel9BInKeUr}yY5D+I)MpNg!Ni%Nk/:Ng?oo3EnEpT^upY3CkDD}yNdNgdomSsTT^&TeTt&Wi4EeIfeO{Ow:BBelB%Dd DyKeMpNgua+PtopR+T T(UghUndryVaWWnWsu.Y Zy3Ad AfArnA=Ctu*FtGG$G&dIsu*M#NdNg`NsOp?dSs#Tt Vel3ArB tyBr?yC&'FeFtGhtKeMbM.NkOnQuid/Tt!VeZ?d5AdAnB, C$CkG-NelyNgOpTt yUdUn+VeY$5CkyGga+Mb N?N^Xury3R-s:Ch(eDG-G}tIdIlInJ%KeMm$NNa+Nda>NgoNs]Nu$P!Rb!R^Rg(R(eRketRria+SkSs/ T^T i$ThTrixTt XimumZe3AdowAnAsu*AtCh<-D$DiaLodyLtMb M%yNt]NuRcyR+R.RryShSsa+T$Thod3Dd!DnightLk~]M-NdNimumN%Nu>Rac!Rr%S ySs/akeXXedXtu*5Bi!DelDifyMM|N.%NkeyN, N`OnR$ReRn(gSqu.oTh T]T%Unta(U'VeVie5ChFf(LeLtiplySc!SeumShroomS-/Tu$3Self/ yTh:I=MePk(Rrow/yT]Tu*3ArCkEdGati=G!@I` PhewR=/TTw%kUtr$V WsXt3CeGht5B!I'M(eeOd!Rm$R`SeTab!TeTh(gTi)VelW5C!?Mb R'T:K0EyJe@Li+Scu*S =Ta(Vious0CurE<Tob 0Or1FF Fi)T&2L1Ay0DI=Ymp-0It0CeEI#L(eLy1EnEraIn]Po'T]1An+B.Ch?dD D(?yG<I|Ig($Ph<0Tr-h0H 0Tdo%T TputTside0AlEnEr0NN 0Yg&0/ 0O}:CtDd!GeIrLa)LmNdaNelN-N` P RadeR|RkRrotRtySsT^ThTi|TrolTt nU'VeYm|3A)AnutArAs<tL-<NN$tyNcilOp!Pp Rfe@Rm.Rs#T2O}OtoRa'Ys-$0AnoCn-Ctu*E)GGe#~LotNkO} Pe/olT^Zza_)A}tA,-A>AyEa'Ed+U{UgUn+2EmEtIntL?LeLi)NdNyOlPul?Rt]S.]Ssib!/TatoTt yV tyWd W _@i)Ai'Ed-tEf Epa*Es|EttyEv|I)IdeIm?yIntI%.yIs#Iva>IzeOb!mO)[Odu)Of.OgramOje@Omo>OofOp tyOsp O>@OudOvide2Bl-Dd(g~LpL'Mpk(N^PilPpyR^a'R.yRpo'R'ShTZz!3Ramid:99Al.yAntumArt E,]I{ItIzO>:Bb.Cco#CeCkD?DioIlInI'~yMpN^NdomN+PidReTeTh V&WZ%3AdyAlAs#BelBuildC$lCei=CipeC%dCyc!Du)F!@F%mFu'G]G*tGul?Je@LaxLea'LiefLyMa(Memb M(dMo=Nd NewNtOp&PairPeatPla)P%tQui*ScueSemb!Si,Sour)Sp#'SultTi*T*atTurnUn]Ve$ViewW?d2Y`m0BBb#CeChDeD+F!GhtGidNgOtPp!SkTu$V$V 5AdA,BotBu,CketM<)OfOkieOmSeTa>UghUndU>Y$5Bb DeGLeNNwayR$:DDd!D}[FeIlLadLm#L#LtLu>MeMp!NdTisfyToshiU)Usa+VeY1A!AnA*Att E}HemeHoolI&)I[%sOrp]OutRapRe&RiptRub1AAr^As#AtC#dC*tCt]Cur.yEdEkGm|Le@~M(?Ni%N'Nt&)RiesRvi)Ss]Tt!TupV&_dowAftAllowA*EdEllEriffIeldIftI}IpIv O{OeOotOpOrtOuld O=RimpRugUff!Y0Bl(gCkDeE+GhtGnL|Lk~yLv Mil?Mp!N)NgR&/ Tua>XZe1A>Et^IIllInIrtUll0AbAmEepEnd I)IdeIghtImOg<OtOwUsh0AllArtI!OkeOo`0A{AkeApIffOw0ApCc Ci$CkDaFtL?Ldi LidLut]L=Me#eNgOnRryRtUlUndUpUr)U`0A)A*Ati$AwnEakEci$EedEllEndH eI)Id IkeInIr.L.OilOns%O#OrtOtRayReadR(gY0Ua*UeezeUir*l_b!AdiumAffA+AirsAmpAndArtA>AyEakEelEmEpE*oI{IllIngO{Oma^O}OolOryO=Ra>gyReetRikeR#gRugg!Ud|UffUmb!Y!0Bje@Bm.BwayC)[ChDd&Ff G?G+,ItMm NNnyN'tP PplyP*meReRfa)R+Rpri'RroundR=ySpe@/a(1AllowAmpApArmE?EetIftImIngIt^Ord1MbolMptomRup/em:B!Ck!GIlL|LkNkPeR+tSk/eTtooXi3A^Am~NN<tNnisNtRm/Xt_nkAtEmeEnE%yE*EyIngIsOughtReeRi=RowUmbUnd 0CketDeG LtMb MeNyPRedSsueT!5A,BaccoDayDdl EGe` I!tK&MatoM%rowNeNgueNightOlO`PP-Pp!R^RnadoRtoi'SsT$Uri,W?dW WnY_{AdeAff-Ag-A(Ansf ApAshA=lAyEatEeEndI$IbeI{Igg ImIpOphyOub!U{UeUlyUmpetU,U`Y2BeIt]Mb!NaN}lRkeyRnRt!1El=EntyI)InI,O1PeP-$:5Ly5B*lla0Ab!Awa*C!Cov D DoFairFoldHappyIf%mIqueItIv 'KnownLo{TilUsu$Veil1Da>GradeHoldOnP Set1B<Ge0A+EEdEfulE![U$0Il.y:C<tCuumGueLidL!yL=NNishP%Rious/Ult3H-!L=tNd%Ntu*NueRbRifyRs]RyS'lT <3Ab!Br<tCiousCt%yDeoEw~a+Nta+Ol(Rtu$RusSaS.Su$T$Vid5C$I)IdLc<oLumeTeYa+:GeG#ItLk~LnutNtRfa*RmRri%ShSp/eT VeY3Al`Ap#ArA'lA` BDd(gEk&dIrdLcome/T_!AtEatEelEnE*IpIsp 0DeD`FeLd~NNdowNeNgNkNn Nt ReSdomSeShT}[5LfM<Nd OdOlRdRkRldRryR`_pE{E,!I,I>Ong::Rd3Ar~ow9UUngU`:3BraRo9NeO";
const checksum = "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60";
let wordlist = null;
class LangEn extends (0, _wordlistOwlJs.WordlistOwl) {
    /**
     *  Creates a new instance of the English language Wordlist.
     *
     *  This should be unnecessary most of the time as the exported
     *  [[langEn]] should suffice.
     *
     *  @_ignore:
     */ constructor(){
        super("en", words, checksum);
    }
    /**
     *  Returns a singleton instance of a ``LangEn``, creating it
     *  if this is the first time being called.
     */ static wordlist() {
        if (wordlist == null) wordlist = new LangEn();
        return wordlist;
    }
}

},{"./wordlist-owl.js":"8y30J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8y30J":[function(require,module,exports) {
// Use the encode-latin.js script to create the necessary
// data files to be consumed by this class
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  An OWL format Wordlist is an encoding method that exploits
 *  the general locality of alphabetically sorted words to
 *  achieve a simple but effective means of compression.
 *
 *  This class is generally not useful to most developers as
 *  it is used mainly internally to keep Wordlists for languages
 *  based on ASCII-7 small.
 *
 *  If necessary, there are tools within the ``generation/`` folder
 *  to create the necessary data.
 */ parcelHelpers.export(exports, "WordlistOwl", ()=>WordlistOwl);
var _indexJs = require("../hash/index.js");
var _indexJs1 = require("../utils/index.js");
var _decodeOwlJs = require("./decode-owl.js");
var _wordlistJs = require("./wordlist.js");
class WordlistOwl extends (0, _wordlistJs.Wordlist) {
    #data;
    #checksum;
    /**
     *  Creates a new Wordlist for %%locale%% using the OWL %%data%%
     *  and validated against the %%checksum%%.
     */ constructor(locale, data, checksum){
        super(locale);
        this.#data = data;
        this.#checksum = checksum;
        this.#words = null;
    }
    /**
     *  The OWL-encoded data.
     */ get _data() {
        return this.#data;
    }
    /**
     *  Decode all the words for the wordlist.
     */ _decodeWords() {
        return (0, _decodeOwlJs.decodeOwl)(this.#data);
    }
    #words;
    #loadWords() {
        if (this.#words == null) {
            const words = this._decodeWords();
            // Verify the computed list matches the official list
            const checksum = (0, _indexJs.id)(words.join("\n") + "\n");
            /* c8 ignore start */ if (checksum !== this.#checksum) throw new Error(`BIP39 Wordlist for ${this.locale} FAILED`);
            /* c8 ignore stop */ this.#words = words;
        }
        return this.#words;
    }
    getWord(index) {
        const words = this.#loadWords();
        (0, _indexJs1.assertArgument)(index >= 0 && index < words.length, `invalid word index: ${index}`, "index", index);
        return words[index];
    }
    getWordIndex(word) {
        return this.#loadWords().indexOf(word);
    }
}

},{"../hash/index.js":"3Gr4x","../utils/index.js":"4LgPJ","./decode-owl.js":"9KQ9j","./wordlist.js":"kq9Li","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9KQ9j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "decode", ()=>decode);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "decodeOwl", ()=>decodeOwl);
var _indexJs = require("../utils/index.js");
const subsChrs = " !#$%&'()*+,-./<=>?@[]^_`{|}~";
const Word = /^[a-z]*$/i;
function unfold(words, sep) {
    let initial = 97;
    return words.reduce((accum, word)=>{
        if (word === sep) initial++;
        else if (word.match(Word)) accum.push(String.fromCharCode(initial) + word);
        else {
            initial = 97;
            accum.push(word);
        }
        return accum;
    }, []);
}
function decode(data, subs) {
    // Replace all the substitutions with their expanded form
    for(let i = subsChrs.length - 1; i >= 0; i--)data = data.split(subsChrs[i]).join(subs.substring(2 * i, 2 * i + 2));
    // Get all tle clumps; each suffix, first-increment and second-increment
    const clumps = [];
    const leftover = data.replace(/(:|([0-9])|([A-Z][a-z]*))/g, (all, item, semi, word)=>{
        if (semi) for(let i = parseInt(semi); i >= 0; i--)clumps.push(";");
        else clumps.push(item.toLowerCase());
        return "";
    });
    /* c8 ignore start */ if (leftover) throw new Error(`leftovers: ${JSON.stringify(leftover)}`);
    /* c8 ignore stop */ return unfold(unfold(clumps, ";"), ":");
}
function decodeOwl(data) {
    (0, _indexJs.assertArgument)(data[0] === "0", "unsupported auwl data", "data", data);
    return decode(data.substring(1 + 2 * subsChrs.length), data.substring(1, 1 + 2 * subsChrs.length));
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kq9Li":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A Wordlist represents a collection of language-specific
 *  words used to encode and devoce [[link-bip-39]] encoded data
 *  by mapping words to 11-bit values and vice versa.
 */ parcelHelpers.export(exports, "Wordlist", ()=>Wordlist);
var _indexJs = require("../utils/index.js");
class Wordlist {
    locale;
    /**
     *  Creates a new Wordlist instance.
     *
     *  Sub-classes MUST call this if they provide their own constructor,
     *  passing in the locale string of the language.
     *
     *  Generally there is no need to create instances of a Wordlist,
     *  since each language-specific Wordlist creates an instance and
     *  there is no state kept internally, so they are safe to share.
     */ constructor(locale){
        (0, _indexJs.defineProperties)(this, {
            locale
        });
    }
    /**
     *  Sub-classes may override this to provide a language-specific
     *  method for spliting %%phrase%% into individual words.
     *
     *  By default, %%phrase%% is split using any sequences of
     *  white-space as defined by regular expressions (i.e. ``/\s+/``).
     */ split(phrase) {
        return phrase.toLowerCase().split(/\s+/g);
    }
    /**
     *  Sub-classes may override this to provider a language-specific
     *  method for joining %%words%% into a phrase.
     *
     *  By default, %%words%% are joined by a single space.
     */ join(words) {
        return words.join(" ");
    }
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kWQMV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **Mnemonic** wraps all properties required to compute [[link-bip-39]]
 *  seeds and convert between phrases and entropy.
 */ parcelHelpers.export(exports, "Mnemonic", ()=>Mnemonic);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
var _langEnJs = require("../wordlists/lang-en.js");
// Returns a byte with the MSB bits set
function getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits & 0xff;
}
// Returns a byte with the LSB bits set
function getLowerMask(bits) {
    return (1 << bits) - 1 & 0xff;
}
function mnemonicToEntropy(mnemonic, wordlist) {
    (0, _indexJs1.assertNormalize)("NFKD");
    if (wordlist == null) wordlist = (0, _langEnJs.LangEn).wordlist();
    const words = wordlist.split(mnemonic);
    (0, _indexJs1.assertArgument)(words.length % 3 === 0 && words.length >= 12 && words.length <= 24, "invalid mnemonic length", "mnemonic", "[ REDACTED ]");
    const entropy = new Uint8Array(Math.ceil(11 * words.length / 8));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        (0, _indexJs1.assertArgument)(index >= 0, `invalid mnemonic word at index ${i}`, "mnemonic", "[ REDACTED ]");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = getUpperMask(checksumBits);
    const checksum = (0, _indexJs1.getBytes)((0, _indexJs.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    (0, _indexJs1.assertArgument)(checksum === (entropy[entropy.length - 1] & checksumMask), "invalid mnemonic checksum", "mnemonic", "[ REDACTED ]");
    return (0, _indexJs1.hexlify)(entropy.slice(0, entropyBits / 8));
}
function entropyToMnemonic(entropy, wordlist) {
    (0, _indexJs1.assertArgument)(entropy.length % 4 === 0 && entropy.length >= 16 && entropy.length <= 32, "invalid entropy size", "entropy", "[ REDACTED ]");
    if (wordlist == null) wordlist = (0, _langEnJs.LangEn).wordlist();
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = parseInt((0, _indexJs.sha256)(entropy).substring(2, 4), 16) & getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
const _guard = {};
class Mnemonic {
    /**
     *  The mnemonic phrase of 12, 15, 18, 21 or 24 words.
     *
     *  Use the [[wordlist]] ``split`` method to get the individual words.
     */ phrase;
    /**
     *  The password used for this mnemonic. If no password is used this
     *  is the empty string (i.e. ``""``) as per the specification.
     */ password;
    /**
     *  The wordlist for this mnemonic.
     */ wordlist;
    /**
     *  The underlying entropy which the mnemonic encodes.
     */ entropy;
    /**
     *  @private
     */ constructor(guard, entropy, phrase, password, wordlist){
        if (password == null) password = "";
        if (wordlist == null) wordlist = (0, _langEnJs.LangEn).wordlist();
        (0, _indexJs1.assertPrivate)(guard, _guard, "Mnemonic");
        (0, _indexJs1.defineProperties)(this, {
            phrase,
            password,
            wordlist,
            entropy
        });
    }
    /**
     *  Returns the seed for the mnemonic.
     */ computeSeed() {
        const salt = (0, _indexJs1.toUtf8Bytes)("mnemonic" + this.password, "NFKD");
        return (0, _indexJs.pbkdf2)((0, _indexJs1.toUtf8Bytes)(this.phrase, "NFKD"), salt, 2048, 64, "sha512");
    }
    /**
     *  Creates a new Mnemonic for the %%phrase%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */ static fromPhrase(phrase, password, wordlist) {
        // Normalize the case and space; throws if invalid
        const entropy = mnemonicToEntropy(phrase, wordlist);
        phrase = entropyToMnemonic((0, _indexJs1.getBytes)(entropy), wordlist);
        return new Mnemonic(_guard, entropy, phrase, password, wordlist);
    }
    /**
     *  Create a new **Mnemonic** from the %%entropy%%.
     *
     *  The default %%password%% is the empty string and the default
     *  wordlist is the [English wordlists](LangEn).
     */ static fromEntropy(_entropy, password, wordlist) {
        const entropy = (0, _indexJs1.getBytes)(_entropy, "entropy");
        const phrase = entropyToMnemonic(entropy, wordlist);
        return new Mnemonic(_guard, (0, _indexJs1.hexlify)(entropy), phrase, password, wordlist);
    }
    /**
     *  Returns the phrase for %%mnemonic%%.
     */ static entropyToPhrase(_entropy, wordlist) {
        const entropy = (0, _indexJs1.getBytes)(_entropy, "entropy");
        return entropyToMnemonic(entropy, wordlist);
    }
    /**
     *  Returns the entropy for %%phrase%%.
     */ static phraseToEntropy(phrase, wordlist) {
        return mnemonicToEntropy(phrase, wordlist);
    }
    /**
     *  Returns true if %%phrase%% is a valid [[link-bip-39]] phrase.
     *
     *  This checks all the provided words belong to the %%wordlist%%,
     *  that the length is valid and the checksum is correct.
     */ static isValidMnemonic(phrase, wordlist) {
        try {
            mnemonicToEntropy(phrase, wordlist);
            return true;
        } catch (error) {}
        return false;
    }
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","../wordlists/lang-en.js":"lae98","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"htQBf":[function(require,module,exports) {
/**
 *  The JSON Wallet formats allow a simple way to store the private
 *  keys needed in Ethereum along with related information and allows
 *  for extensible forms of encryption.
 *
 *  These utilities facilitate decrypting and encrypting the most common
 *  JSON Wallet formats.
 *
 *  @_subsection: api/wallet:JSON Wallets  [json-wallets]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns true if %%json%% is a valid JSON Keystore Wallet.
 */ parcelHelpers.export(exports, "isKeystoreJson", ()=>isKeystoreJson);
/**
 *  Returns the account details for the JSON Keystore Wallet %%json%%
 *  using %%password%%.
 *
 *  It is preferred to use the [async version](decryptKeystoreJson)
 *  instead, which allows a [[ProgressCallback]] to keep the user informed
 *  as to the decryption status.
 *
 *  This method will block the event loop (freezing all UI) until decryption
 *  is complete, which can take quite some time, depending on the wallet
 *  paramters and platform.
 */ parcelHelpers.export(exports, "decryptKeystoreJsonSync", ()=>decryptKeystoreJsonSync);
/**
 *  Resolves to the decrypted JSON Keystore Wallet %%json%% using the
 *  %%password%%.
 *
 *  If provided, %%progress%% will be called periodically during the
 *  decrpytion to provide feedback, and if the function returns
 *  ``false`` will halt decryption.
 *
 *  The %%progressCallback%% will **always** receive ``0`` before
 *  decryption begins and ``1`` when complete.
 */ parcelHelpers.export(exports, "decryptKeystoreJson", ()=>decryptKeystoreJson);
/**
 *  Return the JSON Keystore Wallet for %%account%% encrypted with
 *  %%password%%.
 *
 *  The %%options%% can be used to tune the password-based key
 *  derivation function parameters, explicitly set the random values
 *  used. Any provided [[ProgressCallback]] is ignord.
 */ parcelHelpers.export(exports, "encryptKeystoreJsonSync", ()=>encryptKeystoreJsonSync);
/**
 *  Resolved to the JSON Keystore Wallet for %%account%% encrypted
 *  with %%password%%.
 *
 *  The %%options%% can be used to tune the password-based key
 *  derivation function parameters, explicitly set the random values
 *  used and provide a [[ProgressCallback]] to receive periodic updates
 *  on the completion status..
 */ parcelHelpers.export(exports, "encryptKeystoreJson", ()=>encryptKeystoreJson);
var _aesJs = require("aes-js");
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../transaction/index.js");
var _indexJs3 = require("../utils/index.js");
var _utilsJs = require("./utils.js");
var _versionJs = require("../_version.js");
const defaultPath = "m/44'/60'/0'/0/0";
function isKeystoreJson(json) {
    try {
        const data = JSON.parse(json);
        const version = data.version != null ? parseInt(data.version) : 0;
        if (version === 3) return true;
    } catch (error) {}
    return false;
}
function decrypt(data, key, ciphertext) {
    const cipher = (0, _utilsJs.spelunk)(data, "crypto.cipher:string");
    if (cipher === "aes-128-ctr") {
        const iv = (0, _utilsJs.spelunk)(data, "crypto.cipherparams.iv:data!");
        const aesCtr = new (0, _aesJs.CTR)(key, iv);
        return (0, _indexJs3.hexlify)(aesCtr.decrypt(ciphertext));
    }
    (0, _indexJs3.assert)(false, "unsupported cipher", "UNSUPPORTED_OPERATION", {
        operation: "decrypt"
    });
}
function getAccount(data, _key) {
    const key = (0, _indexJs3.getBytes)(_key);
    const ciphertext = (0, _utilsJs.spelunk)(data, "crypto.ciphertext:data!");
    const computedMAC = (0, _indexJs3.hexlify)((0, _indexJs1.keccak256)((0, _indexJs3.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    (0, _indexJs3.assertArgument)(computedMAC === (0, _utilsJs.spelunk)(data, "crypto.mac:string!").toLowerCase(), "incorrect password", "password", "[ REDACTED ]");
    const privateKey = decrypt(data, key.slice(0, 16), ciphertext);
    const address = (0, _indexJs2.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (!check.startsWith("0x")) check = "0x" + check;
        (0, _indexJs3.assertArgument)((0, _indexJs.getAddress)(check) === address, "keystore address/privateKey mismatch", "address", data.address);
    }
    const account = {
        address,
        privateKey
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    const version = (0, _utilsJs.spelunk)(data, "x-ethers.version:string");
    if (version === "0.1") {
        const mnemonicKey = key.slice(32, 64);
        const mnemonicCiphertext = (0, _utilsJs.spelunk)(data, "x-ethers.mnemonicCiphertext:data!");
        const mnemonicIv = (0, _utilsJs.spelunk)(data, "x-ethers.mnemonicCounter:data!");
        const mnemonicAesCtr = new (0, _aesJs.CTR)(mnemonicKey, mnemonicIv);
        account.mnemonic = {
            path: (0, _utilsJs.spelunk)(data, "x-ethers.path:string") || defaultPath,
            locale: (0, _utilsJs.spelunk)(data, "x-ethers.locale:string") || "en",
            entropy: (0, _indexJs3.hexlify)((0, _indexJs3.getBytes)(mnemonicAesCtr.decrypt(mnemonicCiphertext)))
        };
    }
    return account;
}
function getDecryptKdfParams(data) {
    const kdf = (0, _utilsJs.spelunk)(data, "crypto.kdf:string");
    if (kdf && typeof kdf === "string") {
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.salt:data!");
            const N = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.n:int!");
            const r = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.r:int!");
            const p = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.p:int!");
            // Make sure N is a power of 2
            (0, _indexJs3.assertArgument)(N > 0 && (N & N - 1) === 0, "invalid kdf.N", "kdf.N", N);
            (0, _indexJs3.assertArgument)(r > 0 && p > 0, "invalid kdf", "kdf", kdf);
            const dkLen = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.dklen:int!");
            (0, _indexJs3.assertArgument)(dkLen === 32, "invalid kdf.dklen", "kdf.dflen", dkLen);
            return {
                name: "scrypt",
                salt,
                N,
                r,
                p,
                dkLen: 64
            };
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.salt:data!");
            const prf = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.prf:string!");
            const algorithm = prf.split("-").pop();
            (0, _indexJs3.assertArgument)(algorithm === "sha256" || algorithm === "sha512", "invalid kdf.pdf", "kdf.pdf", prf);
            const count = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.c:int!");
            const dkLen = (0, _utilsJs.spelunk)(data, "crypto.kdfparams.dklen:int!");
            (0, _indexJs3.assertArgument)(dkLen === 32, "invalid kdf.dklen", "kdf.dklen", dkLen);
            return {
                name: "pbkdf2",
                salt,
                count,
                dkLen,
                algorithm
            };
        }
    }
    (0, _indexJs3.assertArgument)(false, "unsupported key-derivation function", "kdf", kdf);
}
function decryptKeystoreJsonSync(json, _password) {
    const data = JSON.parse(json);
    const password = (0, _utilsJs.getPassword)(_password);
    const params = getDecryptKdfParams(data);
    if (params.name === "pbkdf2") {
        const { salt, count, dkLen, algorithm } = params;
        const key = (0, _indexJs1.pbkdf2)(password, salt, count, dkLen, algorithm);
        return getAccount(data, key);
    }
    (0, _indexJs3.assert)(params.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", {
        params
    });
    const { salt, N, r, p, dkLen } = params;
    const key = (0, _indexJs1.scryptSync)(password, salt, N, r, p, dkLen);
    return getAccount(data, key);
}
function stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
}
async function decryptKeystoreJson(json, _password, progress) {
    const data = JSON.parse(json);
    const password = (0, _utilsJs.getPassword)(_password);
    const params = getDecryptKdfParams(data);
    if (params.name === "pbkdf2") {
        if (progress) {
            progress(0);
            await stall(0);
        }
        const { salt, count, dkLen, algorithm } = params;
        const key = (0, _indexJs1.pbkdf2)(password, salt, count, dkLen, algorithm);
        if (progress) {
            progress(1);
            await stall(0);
        }
        return getAccount(data, key);
    }
    (0, _indexJs3.assert)(params.name === "scrypt", "cannot be reached", "UNKNOWN_ERROR", {
        params
    });
    const { salt, N, r, p, dkLen } = params;
    const key = await (0, _indexJs1.scrypt)(password, salt, N, r, p, dkLen, progress);
    return getAccount(data, key);
}
function getEncryptKdfParams(options) {
    // Check/generate the salt
    const salt = options.salt != null ? (0, _indexJs3.getBytes)(options.salt, "options.salt") : (0, _indexJs1.randomBytes)(32);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    (0, _indexJs3.assertArgument)(typeof N === "number" && N > 0 && Number.isSafeInteger(N) && (BigInt(N) & BigInt(N - 1)) === BigInt(0), "invalid scrypt N parameter", "options.N", N);
    (0, _indexJs3.assertArgument)(typeof r === "number" && r > 0 && Number.isSafeInteger(r), "invalid scrypt r parameter", "options.r", r);
    (0, _indexJs3.assertArgument)(typeof p === "number" && p > 0 && Number.isSafeInteger(p), "invalid scrypt p parameter", "options.p", p);
    return {
        name: "scrypt",
        dkLen: 32,
        salt,
        N,
        r,
        p
    };
}
function _encryptKeystore(key, kdf, account, options) {
    const privateKey = (0, _indexJs3.getBytes)(account.privateKey, "privateKey");
    // Override initialization vector
    const iv = options.iv != null ? (0, _indexJs3.getBytes)(options.iv, "options.iv") : (0, _indexJs1.randomBytes)(16);
    (0, _indexJs3.assertArgument)(iv.length === 16, "invalid options.iv length", "options.iv", options.iv);
    // Override the uuid
    const uuidRandom = options.uuid != null ? (0, _indexJs3.getBytes)(options.uuid, "options.uuid") : (0, _indexJs1.randomBytes)(16);
    (0, _indexJs3.assertArgument)(uuidRandom.length === 16, "invalid options.uuid length", "options.uuid", options.iv);
    // This will be used to encrypt the wallet (as per Web3 secret storage)
    // - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    // - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    const derivedKey = key.slice(0, 16);
    const macPrefix = key.slice(16, 32);
    // Encrypt the private key
    const aesCtr = new (0, _aesJs.CTR)(derivedKey, iv);
    const ciphertext = (0, _indexJs3.getBytes)(aesCtr.encrypt(privateKey));
    // Compute the message authentication code, used to check the password
    const mac = (0, _indexJs1.keccak256)((0, _indexJs3.concat)([
        macPrefix,
        ciphertext
    ]));
    // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
    const data = {
        address: account.address.substring(2).toLowerCase(),
        id: (0, _indexJs3.uuidV4)(uuidRandom),
        version: 3,
        Crypto: {
            cipher: "aes-128-ctr",
            cipherparams: {
                iv: (0, _indexJs3.hexlify)(iv).substring(2)
            },
            ciphertext: (0, _indexJs3.hexlify)(ciphertext).substring(2),
            kdf: "scrypt",
            kdfparams: {
                salt: (0, _indexJs3.hexlify)(kdf.salt).substring(2),
                n: kdf.N,
                dklen: 32,
                p: kdf.p,
                r: kdf.r
            },
            mac: mac.substring(2)
        }
    };
    // If we have a mnemonic, encrypt it into the JSON wallet
    if (account.mnemonic) {
        const client = options.client != null ? options.client : `ethers/${0, _versionJs.version}`;
        const path = account.mnemonic.path || defaultPath;
        const locale = account.mnemonic.locale || "en";
        const mnemonicKey = key.slice(32, 64);
        const entropy = (0, _indexJs3.getBytes)(account.mnemonic.entropy, "account.mnemonic.entropy");
        const mnemonicIv = (0, _indexJs1.randomBytes)(16);
        const mnemonicAesCtr = new (0, _aesJs.CTR)(mnemonicKey, mnemonicIv);
        const mnemonicCiphertext = (0, _indexJs3.getBytes)(mnemonicAesCtr.encrypt(entropy));
        const now = new Date();
        const timestamp = now.getUTCFullYear() + "-" + (0, _utilsJs.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, _utilsJs.zpad)(now.getUTCDate(), 2) + "T" + (0, _utilsJs.zpad)(now.getUTCHours(), 2) + "-" + (0, _utilsJs.zpad)(now.getUTCMinutes(), 2) + "-" + (0, _utilsJs.zpad)(now.getUTCSeconds(), 2) + ".0Z";
        const gethFilename = "UTC--" + timestamp + "--" + data.address;
        data["x-ethers"] = {
            client,
            gethFilename,
            path,
            locale,
            mnemonicCounter: (0, _indexJs3.hexlify)(mnemonicIv).substring(2),
            mnemonicCiphertext: (0, _indexJs3.hexlify)(mnemonicCiphertext).substring(2),
            version: "0.1"
        };
    }
    return JSON.stringify(data);
}
function encryptKeystoreJsonSync(account, password, options) {
    if (options == null) options = {};
    const passwordBytes = (0, _utilsJs.getPassword)(password);
    const kdf = getEncryptKdfParams(options);
    const key = (0, _indexJs1.scryptSync)(passwordBytes, kdf.salt, kdf.N, kdf.r, kdf.p, 64);
    return _encryptKeystore((0, _indexJs3.getBytes)(key), kdf, account, options);
}
async function encryptKeystoreJson(account, password, options) {
    if (options == null) options = {};
    const passwordBytes = (0, _utilsJs.getPassword)(password);
    const kdf = getEncryptKdfParams(options);
    const key = await (0, _indexJs1.scrypt)(passwordBytes, kdf.salt, kdf.N, kdf.r, kdf.p, 64, options.progressCallback);
    return _encryptKeystore((0, _indexJs3.getBytes)(key), kdf, account, options);
}

},{"aes-js":"jfWHv","../address/index.js":"3THmk","../crypto/index.js":"jUsZl","../transaction/index.js":"iFcfw","../utils/index.js":"4LgPJ","./utils.js":"cscUt","../_version.js":"als7Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfWHv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AES", ()=>(0, _aesJs.AES));
parcelHelpers.export(exports, "ModeOfOperation", ()=>(0, _modeJs.ModeOfOperation));
parcelHelpers.export(exports, "CBC", ()=>(0, _modeCbcJs.CBC));
parcelHelpers.export(exports, "CFB", ()=>(0, _modeCfbJs.CFB));
parcelHelpers.export(exports, "CTR", ()=>(0, _modeCtrJs.CTR));
parcelHelpers.export(exports, "ECB", ()=>(0, _modeEcbJs.ECB));
parcelHelpers.export(exports, "OFB", ()=>(0, _modeOfbJs.OFB));
parcelHelpers.export(exports, "pkcs7Pad", ()=>(0, _paddingJs.pkcs7Pad));
parcelHelpers.export(exports, "pkcs7Strip", ()=>(0, _paddingJs.pkcs7Strip));
var _aesJs = require("./aes.js");
var _modeJs = require("./mode.js");
var _modeCbcJs = require("./mode-cbc.js");
var _modeCfbJs = require("./mode-cfb.js");
var _modeCtrJs = require("./mode-ctr.js");
var _modeEcbJs = require("./mode-ecb.js");
var _modeOfbJs = require("./mode-ofb.js");
var _paddingJs = require("./padding.js");

},{"./aes.js":"iOCyT","./mode.js":"8xDjI","./mode-cbc.js":"5zST0","./mode-cfb.js":"8nBeS","./mode-ctr.js":"eGizN","./mode-ecb.js":"8GOin","./mode-ofb.js":"c7x9S","./padding.js":"fzP4m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOCyT":[function(require,module,exports) {
/*! MIT License. Copyright 2015-2022 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AES", ()=>AES);
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _AES_key, _AES_Kd, _AES_Ke;
// Number of rounds by keysize
const numberOfRounds = {
    16: 10,
    24: 12,
    32: 14
};
// Round constant words
const rcon = [
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36,
    0x6c,
    0xd8,
    0xab,
    0x4d,
    0x9a,
    0x2f,
    0x5e,
    0xbc,
    0x63,
    0xc6,
    0x97,
    0x35,
    0x6a,
    0xd4,
    0xb3,
    0x7d,
    0xfa,
    0xef,
    0xc5,
    0x91
];
// S-box and Inverse S-box (S is for Substitution)
const S = [
    0x63,
    0x7c,
    0x77,
    0x7b,
    0xf2,
    0x6b,
    0x6f,
    0xc5,
    0x30,
    0x01,
    0x67,
    0x2b,
    0xfe,
    0xd7,
    0xab,
    0x76,
    0xca,
    0x82,
    0xc9,
    0x7d,
    0xfa,
    0x59,
    0x47,
    0xf0,
    0xad,
    0xd4,
    0xa2,
    0xaf,
    0x9c,
    0xa4,
    0x72,
    0xc0,
    0xb7,
    0xfd,
    0x93,
    0x26,
    0x36,
    0x3f,
    0xf7,
    0xcc,
    0x34,
    0xa5,
    0xe5,
    0xf1,
    0x71,
    0xd8,
    0x31,
    0x15,
    0x04,
    0xc7,
    0x23,
    0xc3,
    0x18,
    0x96,
    0x05,
    0x9a,
    0x07,
    0x12,
    0x80,
    0xe2,
    0xeb,
    0x27,
    0xb2,
    0x75,
    0x09,
    0x83,
    0x2c,
    0x1a,
    0x1b,
    0x6e,
    0x5a,
    0xa0,
    0x52,
    0x3b,
    0xd6,
    0xb3,
    0x29,
    0xe3,
    0x2f,
    0x84,
    0x53,
    0xd1,
    0x00,
    0xed,
    0x20,
    0xfc,
    0xb1,
    0x5b,
    0x6a,
    0xcb,
    0xbe,
    0x39,
    0x4a,
    0x4c,
    0x58,
    0xcf,
    0xd0,
    0xef,
    0xaa,
    0xfb,
    0x43,
    0x4d,
    0x33,
    0x85,
    0x45,
    0xf9,
    0x02,
    0x7f,
    0x50,
    0x3c,
    0x9f,
    0xa8,
    0x51,
    0xa3,
    0x40,
    0x8f,
    0x92,
    0x9d,
    0x38,
    0xf5,
    0xbc,
    0xb6,
    0xda,
    0x21,
    0x10,
    0xff,
    0xf3,
    0xd2,
    0xcd,
    0x0c,
    0x13,
    0xec,
    0x5f,
    0x97,
    0x44,
    0x17,
    0xc4,
    0xa7,
    0x7e,
    0x3d,
    0x64,
    0x5d,
    0x19,
    0x73,
    0x60,
    0x81,
    0x4f,
    0xdc,
    0x22,
    0x2a,
    0x90,
    0x88,
    0x46,
    0xee,
    0xb8,
    0x14,
    0xde,
    0x5e,
    0x0b,
    0xdb,
    0xe0,
    0x32,
    0x3a,
    0x0a,
    0x49,
    0x06,
    0x24,
    0x5c,
    0xc2,
    0xd3,
    0xac,
    0x62,
    0x91,
    0x95,
    0xe4,
    0x79,
    0xe7,
    0xc8,
    0x37,
    0x6d,
    0x8d,
    0xd5,
    0x4e,
    0xa9,
    0x6c,
    0x56,
    0xf4,
    0xea,
    0x65,
    0x7a,
    0xae,
    0x08,
    0xba,
    0x78,
    0x25,
    0x2e,
    0x1c,
    0xa6,
    0xb4,
    0xc6,
    0xe8,
    0xdd,
    0x74,
    0x1f,
    0x4b,
    0xbd,
    0x8b,
    0x8a,
    0x70,
    0x3e,
    0xb5,
    0x66,
    0x48,
    0x03,
    0xf6,
    0x0e,
    0x61,
    0x35,
    0x57,
    0xb9,
    0x86,
    0xc1,
    0x1d,
    0x9e,
    0xe1,
    0xf8,
    0x98,
    0x11,
    0x69,
    0xd9,
    0x8e,
    0x94,
    0x9b,
    0x1e,
    0x87,
    0xe9,
    0xce,
    0x55,
    0x28,
    0xdf,
    0x8c,
    0xa1,
    0x89,
    0x0d,
    0xbf,
    0xe6,
    0x42,
    0x68,
    0x41,
    0x99,
    0x2d,
    0x0f,
    0xb0,
    0x54,
    0xbb,
    0x16
];
const Si = [
    0x52,
    0x09,
    0x6a,
    0xd5,
    0x30,
    0x36,
    0xa5,
    0x38,
    0xbf,
    0x40,
    0xa3,
    0x9e,
    0x81,
    0xf3,
    0xd7,
    0xfb,
    0x7c,
    0xe3,
    0x39,
    0x82,
    0x9b,
    0x2f,
    0xff,
    0x87,
    0x34,
    0x8e,
    0x43,
    0x44,
    0xc4,
    0xde,
    0xe9,
    0xcb,
    0x54,
    0x7b,
    0x94,
    0x32,
    0xa6,
    0xc2,
    0x23,
    0x3d,
    0xee,
    0x4c,
    0x95,
    0x0b,
    0x42,
    0xfa,
    0xc3,
    0x4e,
    0x08,
    0x2e,
    0xa1,
    0x66,
    0x28,
    0xd9,
    0x24,
    0xb2,
    0x76,
    0x5b,
    0xa2,
    0x49,
    0x6d,
    0x8b,
    0xd1,
    0x25,
    0x72,
    0xf8,
    0xf6,
    0x64,
    0x86,
    0x68,
    0x98,
    0x16,
    0xd4,
    0xa4,
    0x5c,
    0xcc,
    0x5d,
    0x65,
    0xb6,
    0x92,
    0x6c,
    0x70,
    0x48,
    0x50,
    0xfd,
    0xed,
    0xb9,
    0xda,
    0x5e,
    0x15,
    0x46,
    0x57,
    0xa7,
    0x8d,
    0x9d,
    0x84,
    0x90,
    0xd8,
    0xab,
    0x00,
    0x8c,
    0xbc,
    0xd3,
    0x0a,
    0xf7,
    0xe4,
    0x58,
    0x05,
    0xb8,
    0xb3,
    0x45,
    0x06,
    0xd0,
    0x2c,
    0x1e,
    0x8f,
    0xca,
    0x3f,
    0x0f,
    0x02,
    0xc1,
    0xaf,
    0xbd,
    0x03,
    0x01,
    0x13,
    0x8a,
    0x6b,
    0x3a,
    0x91,
    0x11,
    0x41,
    0x4f,
    0x67,
    0xdc,
    0xea,
    0x97,
    0xf2,
    0xcf,
    0xce,
    0xf0,
    0xb4,
    0xe6,
    0x73,
    0x96,
    0xac,
    0x74,
    0x22,
    0xe7,
    0xad,
    0x35,
    0x85,
    0xe2,
    0xf9,
    0x37,
    0xe8,
    0x1c,
    0x75,
    0xdf,
    0x6e,
    0x47,
    0xf1,
    0x1a,
    0x71,
    0x1d,
    0x29,
    0xc5,
    0x89,
    0x6f,
    0xb7,
    0x62,
    0x0e,
    0xaa,
    0x18,
    0xbe,
    0x1b,
    0xfc,
    0x56,
    0x3e,
    0x4b,
    0xc6,
    0xd2,
    0x79,
    0x20,
    0x9a,
    0xdb,
    0xc0,
    0xfe,
    0x78,
    0xcd,
    0x5a,
    0xf4,
    0x1f,
    0xdd,
    0xa8,
    0x33,
    0x88,
    0x07,
    0xc7,
    0x31,
    0xb1,
    0x12,
    0x10,
    0x59,
    0x27,
    0x80,
    0xec,
    0x5f,
    0x60,
    0x51,
    0x7f,
    0xa9,
    0x19,
    0xb5,
    0x4a,
    0x0d,
    0x2d,
    0xe5,
    0x7a,
    0x9f,
    0x93,
    0xc9,
    0x9c,
    0xef,
    0xa0,
    0xe0,
    0x3b,
    0x4d,
    0xae,
    0x2a,
    0xf5,
    0xb0,
    0xc8,
    0xeb,
    0xbb,
    0x3c,
    0x83,
    0x53,
    0x99,
    0x61,
    0x17,
    0x2b,
    0x04,
    0x7e,
    0xba,
    0x77,
    0xd6,
    0x26,
    0xe1,
    0x69,
    0x14,
    0x63,
    0x55,
    0x21,
    0x0c,
    0x7d
];
// Transformations for encryption
const T1 = [
    0xc66363a5,
    0xf87c7c84,
    0xee777799,
    0xf67b7b8d,
    0xfff2f20d,
    0xd66b6bbd,
    0xde6f6fb1,
    0x91c5c554,
    0x60303050,
    0x02010103,
    0xce6767a9,
    0x562b2b7d,
    0xe7fefe19,
    0xb5d7d762,
    0x4dababe6,
    0xec76769a,
    0x8fcaca45,
    0x1f82829d,
    0x89c9c940,
    0xfa7d7d87,
    0xeffafa15,
    0xb25959eb,
    0x8e4747c9,
    0xfbf0f00b,
    0x41adadec,
    0xb3d4d467,
    0x5fa2a2fd,
    0x45afafea,
    0x239c9cbf,
    0x53a4a4f7,
    0xe4727296,
    0x9bc0c05b,
    0x75b7b7c2,
    0xe1fdfd1c,
    0x3d9393ae,
    0x4c26266a,
    0x6c36365a,
    0x7e3f3f41,
    0xf5f7f702,
    0x83cccc4f,
    0x6834345c,
    0x51a5a5f4,
    0xd1e5e534,
    0xf9f1f108,
    0xe2717193,
    0xabd8d873,
    0x62313153,
    0x2a15153f,
    0x0804040c,
    0x95c7c752,
    0x46232365,
    0x9dc3c35e,
    0x30181828,
    0x379696a1,
    0x0a05050f,
    0x2f9a9ab5,
    0x0e070709,
    0x24121236,
    0x1b80809b,
    0xdfe2e23d,
    0xcdebeb26,
    0x4e272769,
    0x7fb2b2cd,
    0xea75759f,
    0x1209091b,
    0x1d83839e,
    0x582c2c74,
    0x341a1a2e,
    0x361b1b2d,
    0xdc6e6eb2,
    0xb45a5aee,
    0x5ba0a0fb,
    0xa45252f6,
    0x763b3b4d,
    0xb7d6d661,
    0x7db3b3ce,
    0x5229297b,
    0xdde3e33e,
    0x5e2f2f71,
    0x13848497,
    0xa65353f5,
    0xb9d1d168,
    0x00000000,
    0xc1eded2c,
    0x40202060,
    0xe3fcfc1f,
    0x79b1b1c8,
    0xb65b5bed,
    0xd46a6abe,
    0x8dcbcb46,
    0x67bebed9,
    0x7239394b,
    0x944a4ade,
    0x984c4cd4,
    0xb05858e8,
    0x85cfcf4a,
    0xbbd0d06b,
    0xc5efef2a,
    0x4faaaae5,
    0xedfbfb16,
    0x864343c5,
    0x9a4d4dd7,
    0x66333355,
    0x11858594,
    0x8a4545cf,
    0xe9f9f910,
    0x04020206,
    0xfe7f7f81,
    0xa05050f0,
    0x783c3c44,
    0x259f9fba,
    0x4ba8a8e3,
    0xa25151f3,
    0x5da3a3fe,
    0x804040c0,
    0x058f8f8a,
    0x3f9292ad,
    0x219d9dbc,
    0x70383848,
    0xf1f5f504,
    0x63bcbcdf,
    0x77b6b6c1,
    0xafdada75,
    0x42212163,
    0x20101030,
    0xe5ffff1a,
    0xfdf3f30e,
    0xbfd2d26d,
    0x81cdcd4c,
    0x180c0c14,
    0x26131335,
    0xc3ecec2f,
    0xbe5f5fe1,
    0x359797a2,
    0x884444cc,
    0x2e171739,
    0x93c4c457,
    0x55a7a7f2,
    0xfc7e7e82,
    0x7a3d3d47,
    0xc86464ac,
    0xba5d5de7,
    0x3219192b,
    0xe6737395,
    0xc06060a0,
    0x19818198,
    0x9e4f4fd1,
    0xa3dcdc7f,
    0x44222266,
    0x542a2a7e,
    0x3b9090ab,
    0x0b888883,
    0x8c4646ca,
    0xc7eeee29,
    0x6bb8b8d3,
    0x2814143c,
    0xa7dede79,
    0xbc5e5ee2,
    0x160b0b1d,
    0xaddbdb76,
    0xdbe0e03b,
    0x64323256,
    0x743a3a4e,
    0x140a0a1e,
    0x924949db,
    0x0c06060a,
    0x4824246c,
    0xb85c5ce4,
    0x9fc2c25d,
    0xbdd3d36e,
    0x43acacef,
    0xc46262a6,
    0x399191a8,
    0x319595a4,
    0xd3e4e437,
    0xf279798b,
    0xd5e7e732,
    0x8bc8c843,
    0x6e373759,
    0xda6d6db7,
    0x018d8d8c,
    0xb1d5d564,
    0x9c4e4ed2,
    0x49a9a9e0,
    0xd86c6cb4,
    0xac5656fa,
    0xf3f4f407,
    0xcfeaea25,
    0xca6565af,
    0xf47a7a8e,
    0x47aeaee9,
    0x10080818,
    0x6fbabad5,
    0xf0787888,
    0x4a25256f,
    0x5c2e2e72,
    0x381c1c24,
    0x57a6a6f1,
    0x73b4b4c7,
    0x97c6c651,
    0xcbe8e823,
    0xa1dddd7c,
    0xe874749c,
    0x3e1f1f21,
    0x964b4bdd,
    0x61bdbddc,
    0x0d8b8b86,
    0x0f8a8a85,
    0xe0707090,
    0x7c3e3e42,
    0x71b5b5c4,
    0xcc6666aa,
    0x904848d8,
    0x06030305,
    0xf7f6f601,
    0x1c0e0e12,
    0xc26161a3,
    0x6a35355f,
    0xae5757f9,
    0x69b9b9d0,
    0x17868691,
    0x99c1c158,
    0x3a1d1d27,
    0x279e9eb9,
    0xd9e1e138,
    0xebf8f813,
    0x2b9898b3,
    0x22111133,
    0xd26969bb,
    0xa9d9d970,
    0x078e8e89,
    0x339494a7,
    0x2d9b9bb6,
    0x3c1e1e22,
    0x15878792,
    0xc9e9e920,
    0x87cece49,
    0xaa5555ff,
    0x50282878,
    0xa5dfdf7a,
    0x038c8c8f,
    0x59a1a1f8,
    0x09898980,
    0x1a0d0d17,
    0x65bfbfda,
    0xd7e6e631,
    0x844242c6,
    0xd06868b8,
    0x824141c3,
    0x299999b0,
    0x5a2d2d77,
    0x1e0f0f11,
    0x7bb0b0cb,
    0xa85454fc,
    0x6dbbbbd6,
    0x2c16163a
];
const T2 = [
    0xa5c66363,
    0x84f87c7c,
    0x99ee7777,
    0x8df67b7b,
    0x0dfff2f2,
    0xbdd66b6b,
    0xb1de6f6f,
    0x5491c5c5,
    0x50603030,
    0x03020101,
    0xa9ce6767,
    0x7d562b2b,
    0x19e7fefe,
    0x62b5d7d7,
    0xe64dabab,
    0x9aec7676,
    0x458fcaca,
    0x9d1f8282,
    0x4089c9c9,
    0x87fa7d7d,
    0x15effafa,
    0xebb25959,
    0xc98e4747,
    0x0bfbf0f0,
    0xec41adad,
    0x67b3d4d4,
    0xfd5fa2a2,
    0xea45afaf,
    0xbf239c9c,
    0xf753a4a4,
    0x96e47272,
    0x5b9bc0c0,
    0xc275b7b7,
    0x1ce1fdfd,
    0xae3d9393,
    0x6a4c2626,
    0x5a6c3636,
    0x417e3f3f,
    0x02f5f7f7,
    0x4f83cccc,
    0x5c683434,
    0xf451a5a5,
    0x34d1e5e5,
    0x08f9f1f1,
    0x93e27171,
    0x73abd8d8,
    0x53623131,
    0x3f2a1515,
    0x0c080404,
    0x5295c7c7,
    0x65462323,
    0x5e9dc3c3,
    0x28301818,
    0xa1379696,
    0x0f0a0505,
    0xb52f9a9a,
    0x090e0707,
    0x36241212,
    0x9b1b8080,
    0x3ddfe2e2,
    0x26cdebeb,
    0x694e2727,
    0xcd7fb2b2,
    0x9fea7575,
    0x1b120909,
    0x9e1d8383,
    0x74582c2c,
    0x2e341a1a,
    0x2d361b1b,
    0xb2dc6e6e,
    0xeeb45a5a,
    0xfb5ba0a0,
    0xf6a45252,
    0x4d763b3b,
    0x61b7d6d6,
    0xce7db3b3,
    0x7b522929,
    0x3edde3e3,
    0x715e2f2f,
    0x97138484,
    0xf5a65353,
    0x68b9d1d1,
    0x00000000,
    0x2cc1eded,
    0x60402020,
    0x1fe3fcfc,
    0xc879b1b1,
    0xedb65b5b,
    0xbed46a6a,
    0x468dcbcb,
    0xd967bebe,
    0x4b723939,
    0xde944a4a,
    0xd4984c4c,
    0xe8b05858,
    0x4a85cfcf,
    0x6bbbd0d0,
    0x2ac5efef,
    0xe54faaaa,
    0x16edfbfb,
    0xc5864343,
    0xd79a4d4d,
    0x55663333,
    0x94118585,
    0xcf8a4545,
    0x10e9f9f9,
    0x06040202,
    0x81fe7f7f,
    0xf0a05050,
    0x44783c3c,
    0xba259f9f,
    0xe34ba8a8,
    0xf3a25151,
    0xfe5da3a3,
    0xc0804040,
    0x8a058f8f,
    0xad3f9292,
    0xbc219d9d,
    0x48703838,
    0x04f1f5f5,
    0xdf63bcbc,
    0xc177b6b6,
    0x75afdada,
    0x63422121,
    0x30201010,
    0x1ae5ffff,
    0x0efdf3f3,
    0x6dbfd2d2,
    0x4c81cdcd,
    0x14180c0c,
    0x35261313,
    0x2fc3ecec,
    0xe1be5f5f,
    0xa2359797,
    0xcc884444,
    0x392e1717,
    0x5793c4c4,
    0xf255a7a7,
    0x82fc7e7e,
    0x477a3d3d,
    0xacc86464,
    0xe7ba5d5d,
    0x2b321919,
    0x95e67373,
    0xa0c06060,
    0x98198181,
    0xd19e4f4f,
    0x7fa3dcdc,
    0x66442222,
    0x7e542a2a,
    0xab3b9090,
    0x830b8888,
    0xca8c4646,
    0x29c7eeee,
    0xd36bb8b8,
    0x3c281414,
    0x79a7dede,
    0xe2bc5e5e,
    0x1d160b0b,
    0x76addbdb,
    0x3bdbe0e0,
    0x56643232,
    0x4e743a3a,
    0x1e140a0a,
    0xdb924949,
    0x0a0c0606,
    0x6c482424,
    0xe4b85c5c,
    0x5d9fc2c2,
    0x6ebdd3d3,
    0xef43acac,
    0xa6c46262,
    0xa8399191,
    0xa4319595,
    0x37d3e4e4,
    0x8bf27979,
    0x32d5e7e7,
    0x438bc8c8,
    0x596e3737,
    0xb7da6d6d,
    0x8c018d8d,
    0x64b1d5d5,
    0xd29c4e4e,
    0xe049a9a9,
    0xb4d86c6c,
    0xfaac5656,
    0x07f3f4f4,
    0x25cfeaea,
    0xafca6565,
    0x8ef47a7a,
    0xe947aeae,
    0x18100808,
    0xd56fbaba,
    0x88f07878,
    0x6f4a2525,
    0x725c2e2e,
    0x24381c1c,
    0xf157a6a6,
    0xc773b4b4,
    0x5197c6c6,
    0x23cbe8e8,
    0x7ca1dddd,
    0x9ce87474,
    0x213e1f1f,
    0xdd964b4b,
    0xdc61bdbd,
    0x860d8b8b,
    0x850f8a8a,
    0x90e07070,
    0x427c3e3e,
    0xc471b5b5,
    0xaacc6666,
    0xd8904848,
    0x05060303,
    0x01f7f6f6,
    0x121c0e0e,
    0xa3c26161,
    0x5f6a3535,
    0xf9ae5757,
    0xd069b9b9,
    0x91178686,
    0x5899c1c1,
    0x273a1d1d,
    0xb9279e9e,
    0x38d9e1e1,
    0x13ebf8f8,
    0xb32b9898,
    0x33221111,
    0xbbd26969,
    0x70a9d9d9,
    0x89078e8e,
    0xa7339494,
    0xb62d9b9b,
    0x223c1e1e,
    0x92158787,
    0x20c9e9e9,
    0x4987cece,
    0xffaa5555,
    0x78502828,
    0x7aa5dfdf,
    0x8f038c8c,
    0xf859a1a1,
    0x80098989,
    0x171a0d0d,
    0xda65bfbf,
    0x31d7e6e6,
    0xc6844242,
    0xb8d06868,
    0xc3824141,
    0xb0299999,
    0x775a2d2d,
    0x111e0f0f,
    0xcb7bb0b0,
    0xfca85454,
    0xd66dbbbb,
    0x3a2c1616
];
const T3 = [
    0x63a5c663,
    0x7c84f87c,
    0x7799ee77,
    0x7b8df67b,
    0xf20dfff2,
    0x6bbdd66b,
    0x6fb1de6f,
    0xc55491c5,
    0x30506030,
    0x01030201,
    0x67a9ce67,
    0x2b7d562b,
    0xfe19e7fe,
    0xd762b5d7,
    0xabe64dab,
    0x769aec76,
    0xca458fca,
    0x829d1f82,
    0xc94089c9,
    0x7d87fa7d,
    0xfa15effa,
    0x59ebb259,
    0x47c98e47,
    0xf00bfbf0,
    0xadec41ad,
    0xd467b3d4,
    0xa2fd5fa2,
    0xafea45af,
    0x9cbf239c,
    0xa4f753a4,
    0x7296e472,
    0xc05b9bc0,
    0xb7c275b7,
    0xfd1ce1fd,
    0x93ae3d93,
    0x266a4c26,
    0x365a6c36,
    0x3f417e3f,
    0xf702f5f7,
    0xcc4f83cc,
    0x345c6834,
    0xa5f451a5,
    0xe534d1e5,
    0xf108f9f1,
    0x7193e271,
    0xd873abd8,
    0x31536231,
    0x153f2a15,
    0x040c0804,
    0xc75295c7,
    0x23654623,
    0xc35e9dc3,
    0x18283018,
    0x96a13796,
    0x050f0a05,
    0x9ab52f9a,
    0x07090e07,
    0x12362412,
    0x809b1b80,
    0xe23ddfe2,
    0xeb26cdeb,
    0x27694e27,
    0xb2cd7fb2,
    0x759fea75,
    0x091b1209,
    0x839e1d83,
    0x2c74582c,
    0x1a2e341a,
    0x1b2d361b,
    0x6eb2dc6e,
    0x5aeeb45a,
    0xa0fb5ba0,
    0x52f6a452,
    0x3b4d763b,
    0xd661b7d6,
    0xb3ce7db3,
    0x297b5229,
    0xe33edde3,
    0x2f715e2f,
    0x84971384,
    0x53f5a653,
    0xd168b9d1,
    0x00000000,
    0xed2cc1ed,
    0x20604020,
    0xfc1fe3fc,
    0xb1c879b1,
    0x5bedb65b,
    0x6abed46a,
    0xcb468dcb,
    0xbed967be,
    0x394b7239,
    0x4ade944a,
    0x4cd4984c,
    0x58e8b058,
    0xcf4a85cf,
    0xd06bbbd0,
    0xef2ac5ef,
    0xaae54faa,
    0xfb16edfb,
    0x43c58643,
    0x4dd79a4d,
    0x33556633,
    0x85941185,
    0x45cf8a45,
    0xf910e9f9,
    0x02060402,
    0x7f81fe7f,
    0x50f0a050,
    0x3c44783c,
    0x9fba259f,
    0xa8e34ba8,
    0x51f3a251,
    0xa3fe5da3,
    0x40c08040,
    0x8f8a058f,
    0x92ad3f92,
    0x9dbc219d,
    0x38487038,
    0xf504f1f5,
    0xbcdf63bc,
    0xb6c177b6,
    0xda75afda,
    0x21634221,
    0x10302010,
    0xff1ae5ff,
    0xf30efdf3,
    0xd26dbfd2,
    0xcd4c81cd,
    0x0c14180c,
    0x13352613,
    0xec2fc3ec,
    0x5fe1be5f,
    0x97a23597,
    0x44cc8844,
    0x17392e17,
    0xc45793c4,
    0xa7f255a7,
    0x7e82fc7e,
    0x3d477a3d,
    0x64acc864,
    0x5de7ba5d,
    0x192b3219,
    0x7395e673,
    0x60a0c060,
    0x81981981,
    0x4fd19e4f,
    0xdc7fa3dc,
    0x22664422,
    0x2a7e542a,
    0x90ab3b90,
    0x88830b88,
    0x46ca8c46,
    0xee29c7ee,
    0xb8d36bb8,
    0x143c2814,
    0xde79a7de,
    0x5ee2bc5e,
    0x0b1d160b,
    0xdb76addb,
    0xe03bdbe0,
    0x32566432,
    0x3a4e743a,
    0x0a1e140a,
    0x49db9249,
    0x060a0c06,
    0x246c4824,
    0x5ce4b85c,
    0xc25d9fc2,
    0xd36ebdd3,
    0xacef43ac,
    0x62a6c462,
    0x91a83991,
    0x95a43195,
    0xe437d3e4,
    0x798bf279,
    0xe732d5e7,
    0xc8438bc8,
    0x37596e37,
    0x6db7da6d,
    0x8d8c018d,
    0xd564b1d5,
    0x4ed29c4e,
    0xa9e049a9,
    0x6cb4d86c,
    0x56faac56,
    0xf407f3f4,
    0xea25cfea,
    0x65afca65,
    0x7a8ef47a,
    0xaee947ae,
    0x08181008,
    0xbad56fba,
    0x7888f078,
    0x256f4a25,
    0x2e725c2e,
    0x1c24381c,
    0xa6f157a6,
    0xb4c773b4,
    0xc65197c6,
    0xe823cbe8,
    0xdd7ca1dd,
    0x749ce874,
    0x1f213e1f,
    0x4bdd964b,
    0xbddc61bd,
    0x8b860d8b,
    0x8a850f8a,
    0x7090e070,
    0x3e427c3e,
    0xb5c471b5,
    0x66aacc66,
    0x48d89048,
    0x03050603,
    0xf601f7f6,
    0x0e121c0e,
    0x61a3c261,
    0x355f6a35,
    0x57f9ae57,
    0xb9d069b9,
    0x86911786,
    0xc15899c1,
    0x1d273a1d,
    0x9eb9279e,
    0xe138d9e1,
    0xf813ebf8,
    0x98b32b98,
    0x11332211,
    0x69bbd269,
    0xd970a9d9,
    0x8e89078e,
    0x94a73394,
    0x9bb62d9b,
    0x1e223c1e,
    0x87921587,
    0xe920c9e9,
    0xce4987ce,
    0x55ffaa55,
    0x28785028,
    0xdf7aa5df,
    0x8c8f038c,
    0xa1f859a1,
    0x89800989,
    0x0d171a0d,
    0xbfda65bf,
    0xe631d7e6,
    0x42c68442,
    0x68b8d068,
    0x41c38241,
    0x99b02999,
    0x2d775a2d,
    0x0f111e0f,
    0xb0cb7bb0,
    0x54fca854,
    0xbbd66dbb,
    0x163a2c16
];
const T4 = [
    0x6363a5c6,
    0x7c7c84f8,
    0x777799ee,
    0x7b7b8df6,
    0xf2f20dff,
    0x6b6bbdd6,
    0x6f6fb1de,
    0xc5c55491,
    0x30305060,
    0x01010302,
    0x6767a9ce,
    0x2b2b7d56,
    0xfefe19e7,
    0xd7d762b5,
    0xababe64d,
    0x76769aec,
    0xcaca458f,
    0x82829d1f,
    0xc9c94089,
    0x7d7d87fa,
    0xfafa15ef,
    0x5959ebb2,
    0x4747c98e,
    0xf0f00bfb,
    0xadadec41,
    0xd4d467b3,
    0xa2a2fd5f,
    0xafafea45,
    0x9c9cbf23,
    0xa4a4f753,
    0x727296e4,
    0xc0c05b9b,
    0xb7b7c275,
    0xfdfd1ce1,
    0x9393ae3d,
    0x26266a4c,
    0x36365a6c,
    0x3f3f417e,
    0xf7f702f5,
    0xcccc4f83,
    0x34345c68,
    0xa5a5f451,
    0xe5e534d1,
    0xf1f108f9,
    0x717193e2,
    0xd8d873ab,
    0x31315362,
    0x15153f2a,
    0x04040c08,
    0xc7c75295,
    0x23236546,
    0xc3c35e9d,
    0x18182830,
    0x9696a137,
    0x05050f0a,
    0x9a9ab52f,
    0x0707090e,
    0x12123624,
    0x80809b1b,
    0xe2e23ddf,
    0xebeb26cd,
    0x2727694e,
    0xb2b2cd7f,
    0x75759fea,
    0x09091b12,
    0x83839e1d,
    0x2c2c7458,
    0x1a1a2e34,
    0x1b1b2d36,
    0x6e6eb2dc,
    0x5a5aeeb4,
    0xa0a0fb5b,
    0x5252f6a4,
    0x3b3b4d76,
    0xd6d661b7,
    0xb3b3ce7d,
    0x29297b52,
    0xe3e33edd,
    0x2f2f715e,
    0x84849713,
    0x5353f5a6,
    0xd1d168b9,
    0x00000000,
    0xeded2cc1,
    0x20206040,
    0xfcfc1fe3,
    0xb1b1c879,
    0x5b5bedb6,
    0x6a6abed4,
    0xcbcb468d,
    0xbebed967,
    0x39394b72,
    0x4a4ade94,
    0x4c4cd498,
    0x5858e8b0,
    0xcfcf4a85,
    0xd0d06bbb,
    0xefef2ac5,
    0xaaaae54f,
    0xfbfb16ed,
    0x4343c586,
    0x4d4dd79a,
    0x33335566,
    0x85859411,
    0x4545cf8a,
    0xf9f910e9,
    0x02020604,
    0x7f7f81fe,
    0x5050f0a0,
    0x3c3c4478,
    0x9f9fba25,
    0xa8a8e34b,
    0x5151f3a2,
    0xa3a3fe5d,
    0x4040c080,
    0x8f8f8a05,
    0x9292ad3f,
    0x9d9dbc21,
    0x38384870,
    0xf5f504f1,
    0xbcbcdf63,
    0xb6b6c177,
    0xdada75af,
    0x21216342,
    0x10103020,
    0xffff1ae5,
    0xf3f30efd,
    0xd2d26dbf,
    0xcdcd4c81,
    0x0c0c1418,
    0x13133526,
    0xecec2fc3,
    0x5f5fe1be,
    0x9797a235,
    0x4444cc88,
    0x1717392e,
    0xc4c45793,
    0xa7a7f255,
    0x7e7e82fc,
    0x3d3d477a,
    0x6464acc8,
    0x5d5de7ba,
    0x19192b32,
    0x737395e6,
    0x6060a0c0,
    0x81819819,
    0x4f4fd19e,
    0xdcdc7fa3,
    0x22226644,
    0x2a2a7e54,
    0x9090ab3b,
    0x8888830b,
    0x4646ca8c,
    0xeeee29c7,
    0xb8b8d36b,
    0x14143c28,
    0xdede79a7,
    0x5e5ee2bc,
    0x0b0b1d16,
    0xdbdb76ad,
    0xe0e03bdb,
    0x32325664,
    0x3a3a4e74,
    0x0a0a1e14,
    0x4949db92,
    0x06060a0c,
    0x24246c48,
    0x5c5ce4b8,
    0xc2c25d9f,
    0xd3d36ebd,
    0xacacef43,
    0x6262a6c4,
    0x9191a839,
    0x9595a431,
    0xe4e437d3,
    0x79798bf2,
    0xe7e732d5,
    0xc8c8438b,
    0x3737596e,
    0x6d6db7da,
    0x8d8d8c01,
    0xd5d564b1,
    0x4e4ed29c,
    0xa9a9e049,
    0x6c6cb4d8,
    0x5656faac,
    0xf4f407f3,
    0xeaea25cf,
    0x6565afca,
    0x7a7a8ef4,
    0xaeaee947,
    0x08081810,
    0xbabad56f,
    0x787888f0,
    0x25256f4a,
    0x2e2e725c,
    0x1c1c2438,
    0xa6a6f157,
    0xb4b4c773,
    0xc6c65197,
    0xe8e823cb,
    0xdddd7ca1,
    0x74749ce8,
    0x1f1f213e,
    0x4b4bdd96,
    0xbdbddc61,
    0x8b8b860d,
    0x8a8a850f,
    0x707090e0,
    0x3e3e427c,
    0xb5b5c471,
    0x6666aacc,
    0x4848d890,
    0x03030506,
    0xf6f601f7,
    0x0e0e121c,
    0x6161a3c2,
    0x35355f6a,
    0x5757f9ae,
    0xb9b9d069,
    0x86869117,
    0xc1c15899,
    0x1d1d273a,
    0x9e9eb927,
    0xe1e138d9,
    0xf8f813eb,
    0x9898b32b,
    0x11113322,
    0x6969bbd2,
    0xd9d970a9,
    0x8e8e8907,
    0x9494a733,
    0x9b9bb62d,
    0x1e1e223c,
    0x87879215,
    0xe9e920c9,
    0xcece4987,
    0x5555ffaa,
    0x28287850,
    0xdfdf7aa5,
    0x8c8c8f03,
    0xa1a1f859,
    0x89898009,
    0x0d0d171a,
    0xbfbfda65,
    0xe6e631d7,
    0x4242c684,
    0x6868b8d0,
    0x4141c382,
    0x9999b029,
    0x2d2d775a,
    0x0f0f111e,
    0xb0b0cb7b,
    0x5454fca8,
    0xbbbbd66d,
    0x16163a2c
];
// Transformations for decryption
const T5 = [
    0x51f4a750,
    0x7e416553,
    0x1a17a4c3,
    0x3a275e96,
    0x3bab6bcb,
    0x1f9d45f1,
    0xacfa58ab,
    0x4be30393,
    0x2030fa55,
    0xad766df6,
    0x88cc7691,
    0xf5024c25,
    0x4fe5d7fc,
    0xc52acbd7,
    0x26354480,
    0xb562a38f,
    0xdeb15a49,
    0x25ba1b67,
    0x45ea0e98,
    0x5dfec0e1,
    0xc32f7502,
    0x814cf012,
    0x8d4697a3,
    0x6bd3f9c6,
    0x038f5fe7,
    0x15929c95,
    0xbf6d7aeb,
    0x955259da,
    0xd4be832d,
    0x587421d3,
    0x49e06929,
    0x8ec9c844,
    0x75c2896a,
    0xf48e7978,
    0x99583e6b,
    0x27b971dd,
    0xbee14fb6,
    0xf088ad17,
    0xc920ac66,
    0x7dce3ab4,
    0x63df4a18,
    0xe51a3182,
    0x97513360,
    0x62537f45,
    0xb16477e0,
    0xbb6bae84,
    0xfe81a01c,
    0xf9082b94,
    0x70486858,
    0x8f45fd19,
    0x94de6c87,
    0x527bf8b7,
    0xab73d323,
    0x724b02e2,
    0xe31f8f57,
    0x6655ab2a,
    0xb2eb2807,
    0x2fb5c203,
    0x86c57b9a,
    0xd33708a5,
    0x302887f2,
    0x23bfa5b2,
    0x02036aba,
    0xed16825c,
    0x8acf1c2b,
    0xa779b492,
    0xf307f2f0,
    0x4e69e2a1,
    0x65daf4cd,
    0x0605bed5,
    0xd134621f,
    0xc4a6fe8a,
    0x342e539d,
    0xa2f355a0,
    0x058ae132,
    0xa4f6eb75,
    0x0b83ec39,
    0x4060efaa,
    0x5e719f06,
    0xbd6e1051,
    0x3e218af9,
    0x96dd063d,
    0xdd3e05ae,
    0x4de6bd46,
    0x91548db5,
    0x71c45d05,
    0x0406d46f,
    0x605015ff,
    0x1998fb24,
    0xd6bde997,
    0x894043cc,
    0x67d99e77,
    0xb0e842bd,
    0x07898b88,
    0xe7195b38,
    0x79c8eedb,
    0xa17c0a47,
    0x7c420fe9,
    0xf8841ec9,
    0x00000000,
    0x09808683,
    0x322bed48,
    0x1e1170ac,
    0x6c5a724e,
    0xfd0efffb,
    0x0f853856,
    0x3daed51e,
    0x362d3927,
    0x0a0fd964,
    0x685ca621,
    0x9b5b54d1,
    0x24362e3a,
    0x0c0a67b1,
    0x9357e70f,
    0xb4ee96d2,
    0x1b9b919e,
    0x80c0c54f,
    0x61dc20a2,
    0x5a774b69,
    0x1c121a16,
    0xe293ba0a,
    0xc0a02ae5,
    0x3c22e043,
    0x121b171d,
    0x0e090d0b,
    0xf28bc7ad,
    0x2db6a8b9,
    0x141ea9c8,
    0x57f11985,
    0xaf75074c,
    0xee99ddbb,
    0xa37f60fd,
    0xf701269f,
    0x5c72f5bc,
    0x44663bc5,
    0x5bfb7e34,
    0x8b432976,
    0xcb23c6dc,
    0xb6edfc68,
    0xb8e4f163,
    0xd731dcca,
    0x42638510,
    0x13972240,
    0x84c61120,
    0x854a247d,
    0xd2bb3df8,
    0xaef93211,
    0xc729a16d,
    0x1d9e2f4b,
    0xdcb230f3,
    0x0d8652ec,
    0x77c1e3d0,
    0x2bb3166c,
    0xa970b999,
    0x119448fa,
    0x47e96422,
    0xa8fc8cc4,
    0xa0f03f1a,
    0x567d2cd8,
    0x223390ef,
    0x87494ec7,
    0xd938d1c1,
    0x8ccaa2fe,
    0x98d40b36,
    0xa6f581cf,
    0xa57ade28,
    0xdab78e26,
    0x3fadbfa4,
    0x2c3a9de4,
    0x5078920d,
    0x6a5fcc9b,
    0x547e4662,
    0xf68d13c2,
    0x90d8b8e8,
    0x2e39f75e,
    0x82c3aff5,
    0x9f5d80be,
    0x69d0937c,
    0x6fd52da9,
    0xcf2512b3,
    0xc8ac993b,
    0x10187da7,
    0xe89c636e,
    0xdb3bbb7b,
    0xcd267809,
    0x6e5918f4,
    0xec9ab701,
    0x834f9aa8,
    0xe6956e65,
    0xaaffe67e,
    0x21bccf08,
    0xef15e8e6,
    0xbae79bd9,
    0x4a6f36ce,
    0xea9f09d4,
    0x29b07cd6,
    0x31a4b2af,
    0x2a3f2331,
    0xc6a59430,
    0x35a266c0,
    0x744ebc37,
    0xfc82caa6,
    0xe090d0b0,
    0x33a7d815,
    0xf104984a,
    0x41ecdaf7,
    0x7fcd500e,
    0x1791f62f,
    0x764dd68d,
    0x43efb04d,
    0xccaa4d54,
    0xe49604df,
    0x9ed1b5e3,
    0x4c6a881b,
    0xc12c1fb8,
    0x4665517f,
    0x9d5eea04,
    0x018c355d,
    0xfa877473,
    0xfb0b412e,
    0xb3671d5a,
    0x92dbd252,
    0xe9105633,
    0x6dd64713,
    0x9ad7618c,
    0x37a10c7a,
    0x59f8148e,
    0xeb133c89,
    0xcea927ee,
    0xb761c935,
    0xe11ce5ed,
    0x7a47b13c,
    0x9cd2df59,
    0x55f2733f,
    0x1814ce79,
    0x73c737bf,
    0x53f7cdea,
    0x5ffdaa5b,
    0xdf3d6f14,
    0x7844db86,
    0xcaaff381,
    0xb968c43e,
    0x3824342c,
    0xc2a3405f,
    0x161dc372,
    0xbce2250c,
    0x283c498b,
    0xff0d9541,
    0x39a80171,
    0x080cb3de,
    0xd8b4e49c,
    0x6456c190,
    0x7bcb8461,
    0xd532b670,
    0x486c5c74,
    0xd0b85742
];
const T6 = [
    0x5051f4a7,
    0x537e4165,
    0xc31a17a4,
    0x963a275e,
    0xcb3bab6b,
    0xf11f9d45,
    0xabacfa58,
    0x934be303,
    0x552030fa,
    0xf6ad766d,
    0x9188cc76,
    0x25f5024c,
    0xfc4fe5d7,
    0xd7c52acb,
    0x80263544,
    0x8fb562a3,
    0x49deb15a,
    0x6725ba1b,
    0x9845ea0e,
    0xe15dfec0,
    0x02c32f75,
    0x12814cf0,
    0xa38d4697,
    0xc66bd3f9,
    0xe7038f5f,
    0x9515929c,
    0xebbf6d7a,
    0xda955259,
    0x2dd4be83,
    0xd3587421,
    0x2949e069,
    0x448ec9c8,
    0x6a75c289,
    0x78f48e79,
    0x6b99583e,
    0xdd27b971,
    0xb6bee14f,
    0x17f088ad,
    0x66c920ac,
    0xb47dce3a,
    0x1863df4a,
    0x82e51a31,
    0x60975133,
    0x4562537f,
    0xe0b16477,
    0x84bb6bae,
    0x1cfe81a0,
    0x94f9082b,
    0x58704868,
    0x198f45fd,
    0x8794de6c,
    0xb7527bf8,
    0x23ab73d3,
    0xe2724b02,
    0x57e31f8f,
    0x2a6655ab,
    0x07b2eb28,
    0x032fb5c2,
    0x9a86c57b,
    0xa5d33708,
    0xf2302887,
    0xb223bfa5,
    0xba02036a,
    0x5ced1682,
    0x2b8acf1c,
    0x92a779b4,
    0xf0f307f2,
    0xa14e69e2,
    0xcd65daf4,
    0xd50605be,
    0x1fd13462,
    0x8ac4a6fe,
    0x9d342e53,
    0xa0a2f355,
    0x32058ae1,
    0x75a4f6eb,
    0x390b83ec,
    0xaa4060ef,
    0x065e719f,
    0x51bd6e10,
    0xf93e218a,
    0x3d96dd06,
    0xaedd3e05,
    0x464de6bd,
    0xb591548d,
    0x0571c45d,
    0x6f0406d4,
    0xff605015,
    0x241998fb,
    0x97d6bde9,
    0xcc894043,
    0x7767d99e,
    0xbdb0e842,
    0x8807898b,
    0x38e7195b,
    0xdb79c8ee,
    0x47a17c0a,
    0xe97c420f,
    0xc9f8841e,
    0x00000000,
    0x83098086,
    0x48322bed,
    0xac1e1170,
    0x4e6c5a72,
    0xfbfd0eff,
    0x560f8538,
    0x1e3daed5,
    0x27362d39,
    0x640a0fd9,
    0x21685ca6,
    0xd19b5b54,
    0x3a24362e,
    0xb10c0a67,
    0x0f9357e7,
    0xd2b4ee96,
    0x9e1b9b91,
    0x4f80c0c5,
    0xa261dc20,
    0x695a774b,
    0x161c121a,
    0x0ae293ba,
    0xe5c0a02a,
    0x433c22e0,
    0x1d121b17,
    0x0b0e090d,
    0xadf28bc7,
    0xb92db6a8,
    0xc8141ea9,
    0x8557f119,
    0x4caf7507,
    0xbbee99dd,
    0xfda37f60,
    0x9ff70126,
    0xbc5c72f5,
    0xc544663b,
    0x345bfb7e,
    0x768b4329,
    0xdccb23c6,
    0x68b6edfc,
    0x63b8e4f1,
    0xcad731dc,
    0x10426385,
    0x40139722,
    0x2084c611,
    0x7d854a24,
    0xf8d2bb3d,
    0x11aef932,
    0x6dc729a1,
    0x4b1d9e2f,
    0xf3dcb230,
    0xec0d8652,
    0xd077c1e3,
    0x6c2bb316,
    0x99a970b9,
    0xfa119448,
    0x2247e964,
    0xc4a8fc8c,
    0x1aa0f03f,
    0xd8567d2c,
    0xef223390,
    0xc787494e,
    0xc1d938d1,
    0xfe8ccaa2,
    0x3698d40b,
    0xcfa6f581,
    0x28a57ade,
    0x26dab78e,
    0xa43fadbf,
    0xe42c3a9d,
    0x0d507892,
    0x9b6a5fcc,
    0x62547e46,
    0xc2f68d13,
    0xe890d8b8,
    0x5e2e39f7,
    0xf582c3af,
    0xbe9f5d80,
    0x7c69d093,
    0xa96fd52d,
    0xb3cf2512,
    0x3bc8ac99,
    0xa710187d,
    0x6ee89c63,
    0x7bdb3bbb,
    0x09cd2678,
    0xf46e5918,
    0x01ec9ab7,
    0xa8834f9a,
    0x65e6956e,
    0x7eaaffe6,
    0x0821bccf,
    0xe6ef15e8,
    0xd9bae79b,
    0xce4a6f36,
    0xd4ea9f09,
    0xd629b07c,
    0xaf31a4b2,
    0x312a3f23,
    0x30c6a594,
    0xc035a266,
    0x37744ebc,
    0xa6fc82ca,
    0xb0e090d0,
    0x1533a7d8,
    0x4af10498,
    0xf741ecda,
    0x0e7fcd50,
    0x2f1791f6,
    0x8d764dd6,
    0x4d43efb0,
    0x54ccaa4d,
    0xdfe49604,
    0xe39ed1b5,
    0x1b4c6a88,
    0xb8c12c1f,
    0x7f466551,
    0x049d5eea,
    0x5d018c35,
    0x73fa8774,
    0x2efb0b41,
    0x5ab3671d,
    0x5292dbd2,
    0x33e91056,
    0x136dd647,
    0x8c9ad761,
    0x7a37a10c,
    0x8e59f814,
    0x89eb133c,
    0xeecea927,
    0x35b761c9,
    0xede11ce5,
    0x3c7a47b1,
    0x599cd2df,
    0x3f55f273,
    0x791814ce,
    0xbf73c737,
    0xea53f7cd,
    0x5b5ffdaa,
    0x14df3d6f,
    0x867844db,
    0x81caaff3,
    0x3eb968c4,
    0x2c382434,
    0x5fc2a340,
    0x72161dc3,
    0x0cbce225,
    0x8b283c49,
    0x41ff0d95,
    0x7139a801,
    0xde080cb3,
    0x9cd8b4e4,
    0x906456c1,
    0x617bcb84,
    0x70d532b6,
    0x74486c5c,
    0x42d0b857
];
const T7 = [
    0xa75051f4,
    0x65537e41,
    0xa4c31a17,
    0x5e963a27,
    0x6bcb3bab,
    0x45f11f9d,
    0x58abacfa,
    0x03934be3,
    0xfa552030,
    0x6df6ad76,
    0x769188cc,
    0x4c25f502,
    0xd7fc4fe5,
    0xcbd7c52a,
    0x44802635,
    0xa38fb562,
    0x5a49deb1,
    0x1b6725ba,
    0x0e9845ea,
    0xc0e15dfe,
    0x7502c32f,
    0xf012814c,
    0x97a38d46,
    0xf9c66bd3,
    0x5fe7038f,
    0x9c951592,
    0x7aebbf6d,
    0x59da9552,
    0x832dd4be,
    0x21d35874,
    0x692949e0,
    0xc8448ec9,
    0x896a75c2,
    0x7978f48e,
    0x3e6b9958,
    0x71dd27b9,
    0x4fb6bee1,
    0xad17f088,
    0xac66c920,
    0x3ab47dce,
    0x4a1863df,
    0x3182e51a,
    0x33609751,
    0x7f456253,
    0x77e0b164,
    0xae84bb6b,
    0xa01cfe81,
    0x2b94f908,
    0x68587048,
    0xfd198f45,
    0x6c8794de,
    0xf8b7527b,
    0xd323ab73,
    0x02e2724b,
    0x8f57e31f,
    0xab2a6655,
    0x2807b2eb,
    0xc2032fb5,
    0x7b9a86c5,
    0x08a5d337,
    0x87f23028,
    0xa5b223bf,
    0x6aba0203,
    0x825ced16,
    0x1c2b8acf,
    0xb492a779,
    0xf2f0f307,
    0xe2a14e69,
    0xf4cd65da,
    0xbed50605,
    0x621fd134,
    0xfe8ac4a6,
    0x539d342e,
    0x55a0a2f3,
    0xe132058a,
    0xeb75a4f6,
    0xec390b83,
    0xefaa4060,
    0x9f065e71,
    0x1051bd6e,
    0x8af93e21,
    0x063d96dd,
    0x05aedd3e,
    0xbd464de6,
    0x8db59154,
    0x5d0571c4,
    0xd46f0406,
    0x15ff6050,
    0xfb241998,
    0xe997d6bd,
    0x43cc8940,
    0x9e7767d9,
    0x42bdb0e8,
    0x8b880789,
    0x5b38e719,
    0xeedb79c8,
    0x0a47a17c,
    0x0fe97c42,
    0x1ec9f884,
    0x00000000,
    0x86830980,
    0xed48322b,
    0x70ac1e11,
    0x724e6c5a,
    0xfffbfd0e,
    0x38560f85,
    0xd51e3dae,
    0x3927362d,
    0xd9640a0f,
    0xa621685c,
    0x54d19b5b,
    0x2e3a2436,
    0x67b10c0a,
    0xe70f9357,
    0x96d2b4ee,
    0x919e1b9b,
    0xc54f80c0,
    0x20a261dc,
    0x4b695a77,
    0x1a161c12,
    0xba0ae293,
    0x2ae5c0a0,
    0xe0433c22,
    0x171d121b,
    0x0d0b0e09,
    0xc7adf28b,
    0xa8b92db6,
    0xa9c8141e,
    0x198557f1,
    0x074caf75,
    0xddbbee99,
    0x60fda37f,
    0x269ff701,
    0xf5bc5c72,
    0x3bc54466,
    0x7e345bfb,
    0x29768b43,
    0xc6dccb23,
    0xfc68b6ed,
    0xf163b8e4,
    0xdccad731,
    0x85104263,
    0x22401397,
    0x112084c6,
    0x247d854a,
    0x3df8d2bb,
    0x3211aef9,
    0xa16dc729,
    0x2f4b1d9e,
    0x30f3dcb2,
    0x52ec0d86,
    0xe3d077c1,
    0x166c2bb3,
    0xb999a970,
    0x48fa1194,
    0x642247e9,
    0x8cc4a8fc,
    0x3f1aa0f0,
    0x2cd8567d,
    0x90ef2233,
    0x4ec78749,
    0xd1c1d938,
    0xa2fe8cca,
    0x0b3698d4,
    0x81cfa6f5,
    0xde28a57a,
    0x8e26dab7,
    0xbfa43fad,
    0x9de42c3a,
    0x920d5078,
    0xcc9b6a5f,
    0x4662547e,
    0x13c2f68d,
    0xb8e890d8,
    0xf75e2e39,
    0xaff582c3,
    0x80be9f5d,
    0x937c69d0,
    0x2da96fd5,
    0x12b3cf25,
    0x993bc8ac,
    0x7da71018,
    0x636ee89c,
    0xbb7bdb3b,
    0x7809cd26,
    0x18f46e59,
    0xb701ec9a,
    0x9aa8834f,
    0x6e65e695,
    0xe67eaaff,
    0xcf0821bc,
    0xe8e6ef15,
    0x9bd9bae7,
    0x36ce4a6f,
    0x09d4ea9f,
    0x7cd629b0,
    0xb2af31a4,
    0x23312a3f,
    0x9430c6a5,
    0x66c035a2,
    0xbc37744e,
    0xcaa6fc82,
    0xd0b0e090,
    0xd81533a7,
    0x984af104,
    0xdaf741ec,
    0x500e7fcd,
    0xf62f1791,
    0xd68d764d,
    0xb04d43ef,
    0x4d54ccaa,
    0x04dfe496,
    0xb5e39ed1,
    0x881b4c6a,
    0x1fb8c12c,
    0x517f4665,
    0xea049d5e,
    0x355d018c,
    0x7473fa87,
    0x412efb0b,
    0x1d5ab367,
    0xd25292db,
    0x5633e910,
    0x47136dd6,
    0x618c9ad7,
    0x0c7a37a1,
    0x148e59f8,
    0x3c89eb13,
    0x27eecea9,
    0xc935b761,
    0xe5ede11c,
    0xb13c7a47,
    0xdf599cd2,
    0x733f55f2,
    0xce791814,
    0x37bf73c7,
    0xcdea53f7,
    0xaa5b5ffd,
    0x6f14df3d,
    0xdb867844,
    0xf381caaf,
    0xc43eb968,
    0x342c3824,
    0x405fc2a3,
    0xc372161d,
    0x250cbce2,
    0x498b283c,
    0x9541ff0d,
    0x017139a8,
    0xb3de080c,
    0xe49cd8b4,
    0xc1906456,
    0x84617bcb,
    0xb670d532,
    0x5c74486c,
    0x5742d0b8
];
const T8 = [
    0xf4a75051,
    0x4165537e,
    0x17a4c31a,
    0x275e963a,
    0xab6bcb3b,
    0x9d45f11f,
    0xfa58abac,
    0xe303934b,
    0x30fa5520,
    0x766df6ad,
    0xcc769188,
    0x024c25f5,
    0xe5d7fc4f,
    0x2acbd7c5,
    0x35448026,
    0x62a38fb5,
    0xb15a49de,
    0xba1b6725,
    0xea0e9845,
    0xfec0e15d,
    0x2f7502c3,
    0x4cf01281,
    0x4697a38d,
    0xd3f9c66b,
    0x8f5fe703,
    0x929c9515,
    0x6d7aebbf,
    0x5259da95,
    0xbe832dd4,
    0x7421d358,
    0xe0692949,
    0xc9c8448e,
    0xc2896a75,
    0x8e7978f4,
    0x583e6b99,
    0xb971dd27,
    0xe14fb6be,
    0x88ad17f0,
    0x20ac66c9,
    0xce3ab47d,
    0xdf4a1863,
    0x1a3182e5,
    0x51336097,
    0x537f4562,
    0x6477e0b1,
    0x6bae84bb,
    0x81a01cfe,
    0x082b94f9,
    0x48685870,
    0x45fd198f,
    0xde6c8794,
    0x7bf8b752,
    0x73d323ab,
    0x4b02e272,
    0x1f8f57e3,
    0x55ab2a66,
    0xeb2807b2,
    0xb5c2032f,
    0xc57b9a86,
    0x3708a5d3,
    0x2887f230,
    0xbfa5b223,
    0x036aba02,
    0x16825ced,
    0xcf1c2b8a,
    0x79b492a7,
    0x07f2f0f3,
    0x69e2a14e,
    0xdaf4cd65,
    0x05bed506,
    0x34621fd1,
    0xa6fe8ac4,
    0x2e539d34,
    0xf355a0a2,
    0x8ae13205,
    0xf6eb75a4,
    0x83ec390b,
    0x60efaa40,
    0x719f065e,
    0x6e1051bd,
    0x218af93e,
    0xdd063d96,
    0x3e05aedd,
    0xe6bd464d,
    0x548db591,
    0xc45d0571,
    0x06d46f04,
    0x5015ff60,
    0x98fb2419,
    0xbde997d6,
    0x4043cc89,
    0xd99e7767,
    0xe842bdb0,
    0x898b8807,
    0x195b38e7,
    0xc8eedb79,
    0x7c0a47a1,
    0x420fe97c,
    0x841ec9f8,
    0x00000000,
    0x80868309,
    0x2bed4832,
    0x1170ac1e,
    0x5a724e6c,
    0x0efffbfd,
    0x8538560f,
    0xaed51e3d,
    0x2d392736,
    0x0fd9640a,
    0x5ca62168,
    0x5b54d19b,
    0x362e3a24,
    0x0a67b10c,
    0x57e70f93,
    0xee96d2b4,
    0x9b919e1b,
    0xc0c54f80,
    0xdc20a261,
    0x774b695a,
    0x121a161c,
    0x93ba0ae2,
    0xa02ae5c0,
    0x22e0433c,
    0x1b171d12,
    0x090d0b0e,
    0x8bc7adf2,
    0xb6a8b92d,
    0x1ea9c814,
    0xf1198557,
    0x75074caf,
    0x99ddbbee,
    0x7f60fda3,
    0x01269ff7,
    0x72f5bc5c,
    0x663bc544,
    0xfb7e345b,
    0x4329768b,
    0x23c6dccb,
    0xedfc68b6,
    0xe4f163b8,
    0x31dccad7,
    0x63851042,
    0x97224013,
    0xc6112084,
    0x4a247d85,
    0xbb3df8d2,
    0xf93211ae,
    0x29a16dc7,
    0x9e2f4b1d,
    0xb230f3dc,
    0x8652ec0d,
    0xc1e3d077,
    0xb3166c2b,
    0x70b999a9,
    0x9448fa11,
    0xe9642247,
    0xfc8cc4a8,
    0xf03f1aa0,
    0x7d2cd856,
    0x3390ef22,
    0x494ec787,
    0x38d1c1d9,
    0xcaa2fe8c,
    0xd40b3698,
    0xf581cfa6,
    0x7ade28a5,
    0xb78e26da,
    0xadbfa43f,
    0x3a9de42c,
    0x78920d50,
    0x5fcc9b6a,
    0x7e466254,
    0x8d13c2f6,
    0xd8b8e890,
    0x39f75e2e,
    0xc3aff582,
    0x5d80be9f,
    0xd0937c69,
    0xd52da96f,
    0x2512b3cf,
    0xac993bc8,
    0x187da710,
    0x9c636ee8,
    0x3bbb7bdb,
    0x267809cd,
    0x5918f46e,
    0x9ab701ec,
    0x4f9aa883,
    0x956e65e6,
    0xffe67eaa,
    0xbccf0821,
    0x15e8e6ef,
    0xe79bd9ba,
    0x6f36ce4a,
    0x9f09d4ea,
    0xb07cd629,
    0xa4b2af31,
    0x3f23312a,
    0xa59430c6,
    0xa266c035,
    0x4ebc3774,
    0x82caa6fc,
    0x90d0b0e0,
    0xa7d81533,
    0x04984af1,
    0xecdaf741,
    0xcd500e7f,
    0x91f62f17,
    0x4dd68d76,
    0xefb04d43,
    0xaa4d54cc,
    0x9604dfe4,
    0xd1b5e39e,
    0x6a881b4c,
    0x2c1fb8c1,
    0x65517f46,
    0x5eea049d,
    0x8c355d01,
    0x877473fa,
    0x0b412efb,
    0x671d5ab3,
    0xdbd25292,
    0x105633e9,
    0xd647136d,
    0xd7618c9a,
    0xa10c7a37,
    0xf8148e59,
    0x133c89eb,
    0xa927eece,
    0x61c935b7,
    0x1ce5ede1,
    0x47b13c7a,
    0xd2df599c,
    0xf2733f55,
    0x14ce7918,
    0xc737bf73,
    0xf7cdea53,
    0xfdaa5b5f,
    0x3d6f14df,
    0x44db8678,
    0xaff381ca,
    0x68c43eb9,
    0x24342c38,
    0xa3405fc2,
    0x1dc37216,
    0xe2250cbc,
    0x3c498b28,
    0x0d9541ff,
    0xa8017139,
    0x0cb3de08,
    0xb4e49cd8,
    0x56c19064,
    0xcb84617b,
    0x32b670d5,
    0x6c5c7448,
    0xb85742d0
];
// Transformations for decryption key expansion
const U1 = [
    0x00000000,
    0x0e090d0b,
    0x1c121a16,
    0x121b171d,
    0x3824342c,
    0x362d3927,
    0x24362e3a,
    0x2a3f2331,
    0x70486858,
    0x7e416553,
    0x6c5a724e,
    0x62537f45,
    0x486c5c74,
    0x4665517f,
    0x547e4662,
    0x5a774b69,
    0xe090d0b0,
    0xee99ddbb,
    0xfc82caa6,
    0xf28bc7ad,
    0xd8b4e49c,
    0xd6bde997,
    0xc4a6fe8a,
    0xcaaff381,
    0x90d8b8e8,
    0x9ed1b5e3,
    0x8ccaa2fe,
    0x82c3aff5,
    0xa8fc8cc4,
    0xa6f581cf,
    0xb4ee96d2,
    0xbae79bd9,
    0xdb3bbb7b,
    0xd532b670,
    0xc729a16d,
    0xc920ac66,
    0xe31f8f57,
    0xed16825c,
    0xff0d9541,
    0xf104984a,
    0xab73d323,
    0xa57ade28,
    0xb761c935,
    0xb968c43e,
    0x9357e70f,
    0x9d5eea04,
    0x8f45fd19,
    0x814cf012,
    0x3bab6bcb,
    0x35a266c0,
    0x27b971dd,
    0x29b07cd6,
    0x038f5fe7,
    0x0d8652ec,
    0x1f9d45f1,
    0x119448fa,
    0x4be30393,
    0x45ea0e98,
    0x57f11985,
    0x59f8148e,
    0x73c737bf,
    0x7dce3ab4,
    0x6fd52da9,
    0x61dc20a2,
    0xad766df6,
    0xa37f60fd,
    0xb16477e0,
    0xbf6d7aeb,
    0x955259da,
    0x9b5b54d1,
    0x894043cc,
    0x87494ec7,
    0xdd3e05ae,
    0xd33708a5,
    0xc12c1fb8,
    0xcf2512b3,
    0xe51a3182,
    0xeb133c89,
    0xf9082b94,
    0xf701269f,
    0x4de6bd46,
    0x43efb04d,
    0x51f4a750,
    0x5ffdaa5b,
    0x75c2896a,
    0x7bcb8461,
    0x69d0937c,
    0x67d99e77,
    0x3daed51e,
    0x33a7d815,
    0x21bccf08,
    0x2fb5c203,
    0x058ae132,
    0x0b83ec39,
    0x1998fb24,
    0x1791f62f,
    0x764dd68d,
    0x7844db86,
    0x6a5fcc9b,
    0x6456c190,
    0x4e69e2a1,
    0x4060efaa,
    0x527bf8b7,
    0x5c72f5bc,
    0x0605bed5,
    0x080cb3de,
    0x1a17a4c3,
    0x141ea9c8,
    0x3e218af9,
    0x302887f2,
    0x223390ef,
    0x2c3a9de4,
    0x96dd063d,
    0x98d40b36,
    0x8acf1c2b,
    0x84c61120,
    0xaef93211,
    0xa0f03f1a,
    0xb2eb2807,
    0xbce2250c,
    0xe6956e65,
    0xe89c636e,
    0xfa877473,
    0xf48e7978,
    0xdeb15a49,
    0xd0b85742,
    0xc2a3405f,
    0xccaa4d54,
    0x41ecdaf7,
    0x4fe5d7fc,
    0x5dfec0e1,
    0x53f7cdea,
    0x79c8eedb,
    0x77c1e3d0,
    0x65daf4cd,
    0x6bd3f9c6,
    0x31a4b2af,
    0x3fadbfa4,
    0x2db6a8b9,
    0x23bfa5b2,
    0x09808683,
    0x07898b88,
    0x15929c95,
    0x1b9b919e,
    0xa17c0a47,
    0xaf75074c,
    0xbd6e1051,
    0xb3671d5a,
    0x99583e6b,
    0x97513360,
    0x854a247d,
    0x8b432976,
    0xd134621f,
    0xdf3d6f14,
    0xcd267809,
    0xc32f7502,
    0xe9105633,
    0xe7195b38,
    0xf5024c25,
    0xfb0b412e,
    0x9ad7618c,
    0x94de6c87,
    0x86c57b9a,
    0x88cc7691,
    0xa2f355a0,
    0xacfa58ab,
    0xbee14fb6,
    0xb0e842bd,
    0xea9f09d4,
    0xe49604df,
    0xf68d13c2,
    0xf8841ec9,
    0xd2bb3df8,
    0xdcb230f3,
    0xcea927ee,
    0xc0a02ae5,
    0x7a47b13c,
    0x744ebc37,
    0x6655ab2a,
    0x685ca621,
    0x42638510,
    0x4c6a881b,
    0x5e719f06,
    0x5078920d,
    0x0a0fd964,
    0x0406d46f,
    0x161dc372,
    0x1814ce79,
    0x322bed48,
    0x3c22e043,
    0x2e39f75e,
    0x2030fa55,
    0xec9ab701,
    0xe293ba0a,
    0xf088ad17,
    0xfe81a01c,
    0xd4be832d,
    0xdab78e26,
    0xc8ac993b,
    0xc6a59430,
    0x9cd2df59,
    0x92dbd252,
    0x80c0c54f,
    0x8ec9c844,
    0xa4f6eb75,
    0xaaffe67e,
    0xb8e4f163,
    0xb6edfc68,
    0x0c0a67b1,
    0x02036aba,
    0x10187da7,
    0x1e1170ac,
    0x342e539d,
    0x3a275e96,
    0x283c498b,
    0x26354480,
    0x7c420fe9,
    0x724b02e2,
    0x605015ff,
    0x6e5918f4,
    0x44663bc5,
    0x4a6f36ce,
    0x587421d3,
    0x567d2cd8,
    0x37a10c7a,
    0x39a80171,
    0x2bb3166c,
    0x25ba1b67,
    0x0f853856,
    0x018c355d,
    0x13972240,
    0x1d9e2f4b,
    0x47e96422,
    0x49e06929,
    0x5bfb7e34,
    0x55f2733f,
    0x7fcd500e,
    0x71c45d05,
    0x63df4a18,
    0x6dd64713,
    0xd731dcca,
    0xd938d1c1,
    0xcb23c6dc,
    0xc52acbd7,
    0xef15e8e6,
    0xe11ce5ed,
    0xf307f2f0,
    0xfd0efffb,
    0xa779b492,
    0xa970b999,
    0xbb6bae84,
    0xb562a38f,
    0x9f5d80be,
    0x91548db5,
    0x834f9aa8,
    0x8d4697a3
];
const U2 = [
    0x00000000,
    0x0b0e090d,
    0x161c121a,
    0x1d121b17,
    0x2c382434,
    0x27362d39,
    0x3a24362e,
    0x312a3f23,
    0x58704868,
    0x537e4165,
    0x4e6c5a72,
    0x4562537f,
    0x74486c5c,
    0x7f466551,
    0x62547e46,
    0x695a774b,
    0xb0e090d0,
    0xbbee99dd,
    0xa6fc82ca,
    0xadf28bc7,
    0x9cd8b4e4,
    0x97d6bde9,
    0x8ac4a6fe,
    0x81caaff3,
    0xe890d8b8,
    0xe39ed1b5,
    0xfe8ccaa2,
    0xf582c3af,
    0xc4a8fc8c,
    0xcfa6f581,
    0xd2b4ee96,
    0xd9bae79b,
    0x7bdb3bbb,
    0x70d532b6,
    0x6dc729a1,
    0x66c920ac,
    0x57e31f8f,
    0x5ced1682,
    0x41ff0d95,
    0x4af10498,
    0x23ab73d3,
    0x28a57ade,
    0x35b761c9,
    0x3eb968c4,
    0x0f9357e7,
    0x049d5eea,
    0x198f45fd,
    0x12814cf0,
    0xcb3bab6b,
    0xc035a266,
    0xdd27b971,
    0xd629b07c,
    0xe7038f5f,
    0xec0d8652,
    0xf11f9d45,
    0xfa119448,
    0x934be303,
    0x9845ea0e,
    0x8557f119,
    0x8e59f814,
    0xbf73c737,
    0xb47dce3a,
    0xa96fd52d,
    0xa261dc20,
    0xf6ad766d,
    0xfda37f60,
    0xe0b16477,
    0xebbf6d7a,
    0xda955259,
    0xd19b5b54,
    0xcc894043,
    0xc787494e,
    0xaedd3e05,
    0xa5d33708,
    0xb8c12c1f,
    0xb3cf2512,
    0x82e51a31,
    0x89eb133c,
    0x94f9082b,
    0x9ff70126,
    0x464de6bd,
    0x4d43efb0,
    0x5051f4a7,
    0x5b5ffdaa,
    0x6a75c289,
    0x617bcb84,
    0x7c69d093,
    0x7767d99e,
    0x1e3daed5,
    0x1533a7d8,
    0x0821bccf,
    0x032fb5c2,
    0x32058ae1,
    0x390b83ec,
    0x241998fb,
    0x2f1791f6,
    0x8d764dd6,
    0x867844db,
    0x9b6a5fcc,
    0x906456c1,
    0xa14e69e2,
    0xaa4060ef,
    0xb7527bf8,
    0xbc5c72f5,
    0xd50605be,
    0xde080cb3,
    0xc31a17a4,
    0xc8141ea9,
    0xf93e218a,
    0xf2302887,
    0xef223390,
    0xe42c3a9d,
    0x3d96dd06,
    0x3698d40b,
    0x2b8acf1c,
    0x2084c611,
    0x11aef932,
    0x1aa0f03f,
    0x07b2eb28,
    0x0cbce225,
    0x65e6956e,
    0x6ee89c63,
    0x73fa8774,
    0x78f48e79,
    0x49deb15a,
    0x42d0b857,
    0x5fc2a340,
    0x54ccaa4d,
    0xf741ecda,
    0xfc4fe5d7,
    0xe15dfec0,
    0xea53f7cd,
    0xdb79c8ee,
    0xd077c1e3,
    0xcd65daf4,
    0xc66bd3f9,
    0xaf31a4b2,
    0xa43fadbf,
    0xb92db6a8,
    0xb223bfa5,
    0x83098086,
    0x8807898b,
    0x9515929c,
    0x9e1b9b91,
    0x47a17c0a,
    0x4caf7507,
    0x51bd6e10,
    0x5ab3671d,
    0x6b99583e,
    0x60975133,
    0x7d854a24,
    0x768b4329,
    0x1fd13462,
    0x14df3d6f,
    0x09cd2678,
    0x02c32f75,
    0x33e91056,
    0x38e7195b,
    0x25f5024c,
    0x2efb0b41,
    0x8c9ad761,
    0x8794de6c,
    0x9a86c57b,
    0x9188cc76,
    0xa0a2f355,
    0xabacfa58,
    0xb6bee14f,
    0xbdb0e842,
    0xd4ea9f09,
    0xdfe49604,
    0xc2f68d13,
    0xc9f8841e,
    0xf8d2bb3d,
    0xf3dcb230,
    0xeecea927,
    0xe5c0a02a,
    0x3c7a47b1,
    0x37744ebc,
    0x2a6655ab,
    0x21685ca6,
    0x10426385,
    0x1b4c6a88,
    0x065e719f,
    0x0d507892,
    0x640a0fd9,
    0x6f0406d4,
    0x72161dc3,
    0x791814ce,
    0x48322bed,
    0x433c22e0,
    0x5e2e39f7,
    0x552030fa,
    0x01ec9ab7,
    0x0ae293ba,
    0x17f088ad,
    0x1cfe81a0,
    0x2dd4be83,
    0x26dab78e,
    0x3bc8ac99,
    0x30c6a594,
    0x599cd2df,
    0x5292dbd2,
    0x4f80c0c5,
    0x448ec9c8,
    0x75a4f6eb,
    0x7eaaffe6,
    0x63b8e4f1,
    0x68b6edfc,
    0xb10c0a67,
    0xba02036a,
    0xa710187d,
    0xac1e1170,
    0x9d342e53,
    0x963a275e,
    0x8b283c49,
    0x80263544,
    0xe97c420f,
    0xe2724b02,
    0xff605015,
    0xf46e5918,
    0xc544663b,
    0xce4a6f36,
    0xd3587421,
    0xd8567d2c,
    0x7a37a10c,
    0x7139a801,
    0x6c2bb316,
    0x6725ba1b,
    0x560f8538,
    0x5d018c35,
    0x40139722,
    0x4b1d9e2f,
    0x2247e964,
    0x2949e069,
    0x345bfb7e,
    0x3f55f273,
    0x0e7fcd50,
    0x0571c45d,
    0x1863df4a,
    0x136dd647,
    0xcad731dc,
    0xc1d938d1,
    0xdccb23c6,
    0xd7c52acb,
    0xe6ef15e8,
    0xede11ce5,
    0xf0f307f2,
    0xfbfd0eff,
    0x92a779b4,
    0x99a970b9,
    0x84bb6bae,
    0x8fb562a3,
    0xbe9f5d80,
    0xb591548d,
    0xa8834f9a,
    0xa38d4697
];
const U3 = [
    0x00000000,
    0x0d0b0e09,
    0x1a161c12,
    0x171d121b,
    0x342c3824,
    0x3927362d,
    0x2e3a2436,
    0x23312a3f,
    0x68587048,
    0x65537e41,
    0x724e6c5a,
    0x7f456253,
    0x5c74486c,
    0x517f4665,
    0x4662547e,
    0x4b695a77,
    0xd0b0e090,
    0xddbbee99,
    0xcaa6fc82,
    0xc7adf28b,
    0xe49cd8b4,
    0xe997d6bd,
    0xfe8ac4a6,
    0xf381caaf,
    0xb8e890d8,
    0xb5e39ed1,
    0xa2fe8cca,
    0xaff582c3,
    0x8cc4a8fc,
    0x81cfa6f5,
    0x96d2b4ee,
    0x9bd9bae7,
    0xbb7bdb3b,
    0xb670d532,
    0xa16dc729,
    0xac66c920,
    0x8f57e31f,
    0x825ced16,
    0x9541ff0d,
    0x984af104,
    0xd323ab73,
    0xde28a57a,
    0xc935b761,
    0xc43eb968,
    0xe70f9357,
    0xea049d5e,
    0xfd198f45,
    0xf012814c,
    0x6bcb3bab,
    0x66c035a2,
    0x71dd27b9,
    0x7cd629b0,
    0x5fe7038f,
    0x52ec0d86,
    0x45f11f9d,
    0x48fa1194,
    0x03934be3,
    0x0e9845ea,
    0x198557f1,
    0x148e59f8,
    0x37bf73c7,
    0x3ab47dce,
    0x2da96fd5,
    0x20a261dc,
    0x6df6ad76,
    0x60fda37f,
    0x77e0b164,
    0x7aebbf6d,
    0x59da9552,
    0x54d19b5b,
    0x43cc8940,
    0x4ec78749,
    0x05aedd3e,
    0x08a5d337,
    0x1fb8c12c,
    0x12b3cf25,
    0x3182e51a,
    0x3c89eb13,
    0x2b94f908,
    0x269ff701,
    0xbd464de6,
    0xb04d43ef,
    0xa75051f4,
    0xaa5b5ffd,
    0x896a75c2,
    0x84617bcb,
    0x937c69d0,
    0x9e7767d9,
    0xd51e3dae,
    0xd81533a7,
    0xcf0821bc,
    0xc2032fb5,
    0xe132058a,
    0xec390b83,
    0xfb241998,
    0xf62f1791,
    0xd68d764d,
    0xdb867844,
    0xcc9b6a5f,
    0xc1906456,
    0xe2a14e69,
    0xefaa4060,
    0xf8b7527b,
    0xf5bc5c72,
    0xbed50605,
    0xb3de080c,
    0xa4c31a17,
    0xa9c8141e,
    0x8af93e21,
    0x87f23028,
    0x90ef2233,
    0x9de42c3a,
    0x063d96dd,
    0x0b3698d4,
    0x1c2b8acf,
    0x112084c6,
    0x3211aef9,
    0x3f1aa0f0,
    0x2807b2eb,
    0x250cbce2,
    0x6e65e695,
    0x636ee89c,
    0x7473fa87,
    0x7978f48e,
    0x5a49deb1,
    0x5742d0b8,
    0x405fc2a3,
    0x4d54ccaa,
    0xdaf741ec,
    0xd7fc4fe5,
    0xc0e15dfe,
    0xcdea53f7,
    0xeedb79c8,
    0xe3d077c1,
    0xf4cd65da,
    0xf9c66bd3,
    0xb2af31a4,
    0xbfa43fad,
    0xa8b92db6,
    0xa5b223bf,
    0x86830980,
    0x8b880789,
    0x9c951592,
    0x919e1b9b,
    0x0a47a17c,
    0x074caf75,
    0x1051bd6e,
    0x1d5ab367,
    0x3e6b9958,
    0x33609751,
    0x247d854a,
    0x29768b43,
    0x621fd134,
    0x6f14df3d,
    0x7809cd26,
    0x7502c32f,
    0x5633e910,
    0x5b38e719,
    0x4c25f502,
    0x412efb0b,
    0x618c9ad7,
    0x6c8794de,
    0x7b9a86c5,
    0x769188cc,
    0x55a0a2f3,
    0x58abacfa,
    0x4fb6bee1,
    0x42bdb0e8,
    0x09d4ea9f,
    0x04dfe496,
    0x13c2f68d,
    0x1ec9f884,
    0x3df8d2bb,
    0x30f3dcb2,
    0x27eecea9,
    0x2ae5c0a0,
    0xb13c7a47,
    0xbc37744e,
    0xab2a6655,
    0xa621685c,
    0x85104263,
    0x881b4c6a,
    0x9f065e71,
    0x920d5078,
    0xd9640a0f,
    0xd46f0406,
    0xc372161d,
    0xce791814,
    0xed48322b,
    0xe0433c22,
    0xf75e2e39,
    0xfa552030,
    0xb701ec9a,
    0xba0ae293,
    0xad17f088,
    0xa01cfe81,
    0x832dd4be,
    0x8e26dab7,
    0x993bc8ac,
    0x9430c6a5,
    0xdf599cd2,
    0xd25292db,
    0xc54f80c0,
    0xc8448ec9,
    0xeb75a4f6,
    0xe67eaaff,
    0xf163b8e4,
    0xfc68b6ed,
    0x67b10c0a,
    0x6aba0203,
    0x7da71018,
    0x70ac1e11,
    0x539d342e,
    0x5e963a27,
    0x498b283c,
    0x44802635,
    0x0fe97c42,
    0x02e2724b,
    0x15ff6050,
    0x18f46e59,
    0x3bc54466,
    0x36ce4a6f,
    0x21d35874,
    0x2cd8567d,
    0x0c7a37a1,
    0x017139a8,
    0x166c2bb3,
    0x1b6725ba,
    0x38560f85,
    0x355d018c,
    0x22401397,
    0x2f4b1d9e,
    0x642247e9,
    0x692949e0,
    0x7e345bfb,
    0x733f55f2,
    0x500e7fcd,
    0x5d0571c4,
    0x4a1863df,
    0x47136dd6,
    0xdccad731,
    0xd1c1d938,
    0xc6dccb23,
    0xcbd7c52a,
    0xe8e6ef15,
    0xe5ede11c,
    0xf2f0f307,
    0xfffbfd0e,
    0xb492a779,
    0xb999a970,
    0xae84bb6b,
    0xa38fb562,
    0x80be9f5d,
    0x8db59154,
    0x9aa8834f,
    0x97a38d46
];
const U4 = [
    0x00000000,
    0x090d0b0e,
    0x121a161c,
    0x1b171d12,
    0x24342c38,
    0x2d392736,
    0x362e3a24,
    0x3f23312a,
    0x48685870,
    0x4165537e,
    0x5a724e6c,
    0x537f4562,
    0x6c5c7448,
    0x65517f46,
    0x7e466254,
    0x774b695a,
    0x90d0b0e0,
    0x99ddbbee,
    0x82caa6fc,
    0x8bc7adf2,
    0xb4e49cd8,
    0xbde997d6,
    0xa6fe8ac4,
    0xaff381ca,
    0xd8b8e890,
    0xd1b5e39e,
    0xcaa2fe8c,
    0xc3aff582,
    0xfc8cc4a8,
    0xf581cfa6,
    0xee96d2b4,
    0xe79bd9ba,
    0x3bbb7bdb,
    0x32b670d5,
    0x29a16dc7,
    0x20ac66c9,
    0x1f8f57e3,
    0x16825ced,
    0x0d9541ff,
    0x04984af1,
    0x73d323ab,
    0x7ade28a5,
    0x61c935b7,
    0x68c43eb9,
    0x57e70f93,
    0x5eea049d,
    0x45fd198f,
    0x4cf01281,
    0xab6bcb3b,
    0xa266c035,
    0xb971dd27,
    0xb07cd629,
    0x8f5fe703,
    0x8652ec0d,
    0x9d45f11f,
    0x9448fa11,
    0xe303934b,
    0xea0e9845,
    0xf1198557,
    0xf8148e59,
    0xc737bf73,
    0xce3ab47d,
    0xd52da96f,
    0xdc20a261,
    0x766df6ad,
    0x7f60fda3,
    0x6477e0b1,
    0x6d7aebbf,
    0x5259da95,
    0x5b54d19b,
    0x4043cc89,
    0x494ec787,
    0x3e05aedd,
    0x3708a5d3,
    0x2c1fb8c1,
    0x2512b3cf,
    0x1a3182e5,
    0x133c89eb,
    0x082b94f9,
    0x01269ff7,
    0xe6bd464d,
    0xefb04d43,
    0xf4a75051,
    0xfdaa5b5f,
    0xc2896a75,
    0xcb84617b,
    0xd0937c69,
    0xd99e7767,
    0xaed51e3d,
    0xa7d81533,
    0xbccf0821,
    0xb5c2032f,
    0x8ae13205,
    0x83ec390b,
    0x98fb2419,
    0x91f62f17,
    0x4dd68d76,
    0x44db8678,
    0x5fcc9b6a,
    0x56c19064,
    0x69e2a14e,
    0x60efaa40,
    0x7bf8b752,
    0x72f5bc5c,
    0x05bed506,
    0x0cb3de08,
    0x17a4c31a,
    0x1ea9c814,
    0x218af93e,
    0x2887f230,
    0x3390ef22,
    0x3a9de42c,
    0xdd063d96,
    0xd40b3698,
    0xcf1c2b8a,
    0xc6112084,
    0xf93211ae,
    0xf03f1aa0,
    0xeb2807b2,
    0xe2250cbc,
    0x956e65e6,
    0x9c636ee8,
    0x877473fa,
    0x8e7978f4,
    0xb15a49de,
    0xb85742d0,
    0xa3405fc2,
    0xaa4d54cc,
    0xecdaf741,
    0xe5d7fc4f,
    0xfec0e15d,
    0xf7cdea53,
    0xc8eedb79,
    0xc1e3d077,
    0xdaf4cd65,
    0xd3f9c66b,
    0xa4b2af31,
    0xadbfa43f,
    0xb6a8b92d,
    0xbfa5b223,
    0x80868309,
    0x898b8807,
    0x929c9515,
    0x9b919e1b,
    0x7c0a47a1,
    0x75074caf,
    0x6e1051bd,
    0x671d5ab3,
    0x583e6b99,
    0x51336097,
    0x4a247d85,
    0x4329768b,
    0x34621fd1,
    0x3d6f14df,
    0x267809cd,
    0x2f7502c3,
    0x105633e9,
    0x195b38e7,
    0x024c25f5,
    0x0b412efb,
    0xd7618c9a,
    0xde6c8794,
    0xc57b9a86,
    0xcc769188,
    0xf355a0a2,
    0xfa58abac,
    0xe14fb6be,
    0xe842bdb0,
    0x9f09d4ea,
    0x9604dfe4,
    0x8d13c2f6,
    0x841ec9f8,
    0xbb3df8d2,
    0xb230f3dc,
    0xa927eece,
    0xa02ae5c0,
    0x47b13c7a,
    0x4ebc3774,
    0x55ab2a66,
    0x5ca62168,
    0x63851042,
    0x6a881b4c,
    0x719f065e,
    0x78920d50,
    0x0fd9640a,
    0x06d46f04,
    0x1dc37216,
    0x14ce7918,
    0x2bed4832,
    0x22e0433c,
    0x39f75e2e,
    0x30fa5520,
    0x9ab701ec,
    0x93ba0ae2,
    0x88ad17f0,
    0x81a01cfe,
    0xbe832dd4,
    0xb78e26da,
    0xac993bc8,
    0xa59430c6,
    0xd2df599c,
    0xdbd25292,
    0xc0c54f80,
    0xc9c8448e,
    0xf6eb75a4,
    0xffe67eaa,
    0xe4f163b8,
    0xedfc68b6,
    0x0a67b10c,
    0x036aba02,
    0x187da710,
    0x1170ac1e,
    0x2e539d34,
    0x275e963a,
    0x3c498b28,
    0x35448026,
    0x420fe97c,
    0x4b02e272,
    0x5015ff60,
    0x5918f46e,
    0x663bc544,
    0x6f36ce4a,
    0x7421d358,
    0x7d2cd856,
    0xa10c7a37,
    0xa8017139,
    0xb3166c2b,
    0xba1b6725,
    0x8538560f,
    0x8c355d01,
    0x97224013,
    0x9e2f4b1d,
    0xe9642247,
    0xe0692949,
    0xfb7e345b,
    0xf2733f55,
    0xcd500e7f,
    0xc45d0571,
    0xdf4a1863,
    0xd647136d,
    0x31dccad7,
    0x38d1c1d9,
    0x23c6dccb,
    0x2acbd7c5,
    0x15e8e6ef,
    0x1ce5ede1,
    0x07f2f0f3,
    0x0efffbfd,
    0x79b492a7,
    0x70b999a9,
    0x6bae84bb,
    0x62a38fb5,
    0x5d80be9f,
    0x548db591,
    0x4f9aa883,
    0x4697a38d
];
function convertToInt32(bytes) {
    const result = [];
    for(let i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
    return result;
}
class AES {
    get key() {
        return __classPrivateFieldGet(this, _AES_key, "f").slice();
    }
    constructor(key){
        _AES_key.set(this, void 0);
        _AES_Kd.set(this, void 0);
        _AES_Ke.set(this, void 0);
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        __classPrivateFieldSet(this, _AES_key, new Uint8Array(key), "f");
        const rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new TypeError("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        __classPrivateFieldSet(this, _AES_Ke, [], "f");
        // decryption round keys
        __classPrivateFieldSet(this, _AES_Kd, [], "f");
        for(let i = 0; i <= rounds; i++){
            __classPrivateFieldGet(this, _AES_Ke, "f").push([
                0,
                0,
                0,
                0
            ]);
            __classPrivateFieldGet(this, _AES_Kd, "f").push([
                0,
                0,
                0,
                0
            ]);
        }
        const roundKeyCount = (rounds + 1) * 4;
        const KC = this.key.length / 4;
        // convert the key into ints
        const tk = convertToInt32(this.key);
        // copy values into round key arrays
        let index;
        for(let i = 0; i < KC; i++){
            index = i >> 2;
            __classPrivateFieldGet(this, _AES_Ke, "f")[index][i % 4] = tk[i];
            __classPrivateFieldGet(this, _AES_Kd, "f")[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        let rconpointer = 0;
        let t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(let i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(let i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(let i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            let i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                __classPrivateFieldGet(this, _AES_Ke, "f")[r][c] = tk[i];
                __classPrivateFieldGet(this, _AES_Kd, "f")[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(let r = 1; r < rounds; r++)for(let c = 0; c < 4; c++){
            tt = __classPrivateFieldGet(this, _AES_Kd, "f")[r][c];
            __classPrivateFieldGet(this, _AES_Kd, "f")[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    }
    encrypt(plaintext) {
        if (plaintext.length != 16) throw new TypeError("invalid plaintext size (must be 16 bytes)");
        const rounds = __classPrivateFieldGet(this, _AES_Ke, "f").length - 1;
        const a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        let t = convertToInt32(plaintext);
        for(let i = 0; i < 4; i++)t[i] ^= __classPrivateFieldGet(this, _AES_Ke, "f")[0][i];
        // apply round transforms
        for(let r = 1; r < rounds; r++){
            for(let i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ __classPrivateFieldGet(this, _AES_Ke, "f")[r][i];
            t = a.slice();
        }
        // the last round is special
        const result = new Uint8Array(16);
        let tt = 0;
        for(let i = 0; i < 4; i++){
            tt = __classPrivateFieldGet(this, _AES_Ke, "f")[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    }
    decrypt(ciphertext) {
        if (ciphertext.length != 16) throw new TypeError("invalid ciphertext size (must be 16 bytes)");
        const rounds = __classPrivateFieldGet(this, _AES_Kd, "f").length - 1;
        const a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        let t = convertToInt32(ciphertext);
        for(let i = 0; i < 4; i++)t[i] ^= __classPrivateFieldGet(this, _AES_Kd, "f")[0][i];
        // apply round transforms
        for(let r = 1; r < rounds; r++){
            for(let i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ __classPrivateFieldGet(this, _AES_Kd, "f")[r][i];
            t = a.slice();
        }
        // the last round is special
        const result = new Uint8Array(16);
        let tt = 0;
        for(let i = 0; i < 4; i++){
            tt = __classPrivateFieldGet(this, _AES_Kd, "f")[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    }
}
_AES_key = new WeakMap(), _AES_Kd = new WeakMap(), _AES_Ke = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8xDjI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModeOfOperation", ()=>ModeOfOperation);
var _aesJs = require("./aes.js");
class ModeOfOperation {
    constructor(name, key, cls){
        if (cls && !(this instanceof cls)) throw new Error(`${name} must be instantiated with "new"`);
        Object.defineProperties(this, {
            aes: {
                enumerable: true,
                value: new (0, _aesJs.AES)(key)
            },
            name: {
                enumerable: true,
                value: name
            }
        });
    }
}

},{"./aes.js":"iOCyT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5zST0":[function(require,module,exports) {
// Cipher Block Chaining
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CBC", ()=>CBC);
var _modeJs = require("./mode.js");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CBC_iv, _CBC_lastBlock;
class CBC extends (0, _modeJs.ModeOfOperation) {
    constructor(key, iv){
        super("ECC", key, CBC);
        _CBC_iv.set(this, void 0);
        _CBC_lastBlock.set(this, void 0);
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            __classPrivateFieldSet(this, _CBC_iv, new Uint8Array(iv), "f");
        } else __classPrivateFieldSet(this, _CBC_iv, new Uint8Array(16), "f");
        __classPrivateFieldSet(this, _CBC_lastBlock, this.iv, "f");
    }
    get iv() {
        return new Uint8Array(__classPrivateFieldGet(this, _CBC_iv, "f"));
    }
    encrypt(plaintext) {
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const ciphertext = new Uint8Array(plaintext.length);
        for(let i = 0; i < plaintext.length; i += 16){
            for(let j = 0; j < 16; j++)__classPrivateFieldGet(this, _CBC_lastBlock, "f")[j] ^= plaintext[i + j];
            __classPrivateFieldSet(this, _CBC_lastBlock, this.aes.encrypt(__classPrivateFieldGet(this, _CBC_lastBlock, "f")), "f");
            ciphertext.set(__classPrivateFieldGet(this, _CBC_lastBlock, "f"), i);
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (ciphertext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        const plaintext = new Uint8Array(ciphertext.length);
        for(let i = 0; i < ciphertext.length; i += 16){
            const block = this.aes.decrypt(ciphertext.subarray(i, i + 16));
            for(let j = 0; j < 16; j++){
                plaintext[i + j] = block[j] ^ __classPrivateFieldGet(this, _CBC_lastBlock, "f")[j];
                __classPrivateFieldGet(this, _CBC_lastBlock, "f")[j] = ciphertext[i + j];
            }
        }
        return plaintext;
    }
}
_CBC_iv = new WeakMap(), _CBC_lastBlock = new WeakMap();

},{"./mode.js":"8xDjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nBeS":[function(require,module,exports) {
// Cipher Feedback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CFB", ()=>CFB);
var _modeJs = require("./mode.js");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CFB_instances, _CFB_iv, _CFB_shiftRegister, _CFB_shift;
class CFB extends (0, _modeJs.ModeOfOperation) {
    constructor(key, iv, segmentSize = 8){
        super("CFB", key, CFB);
        _CFB_instances.add(this);
        _CFB_iv.set(this, void 0);
        _CFB_shiftRegister.set(this, void 0);
        // This library currently only handles byte-aligned segmentSize
        if (!Number.isInteger(segmentSize) || segmentSize % 8) throw new TypeError("invalid segmentSize");
        Object.defineProperties(this, {
            segmentSize: {
                enumerable: true,
                value: segmentSize
            }
        });
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            __classPrivateFieldSet(this, _CFB_iv, new Uint8Array(iv), "f");
        } else __classPrivateFieldSet(this, _CFB_iv, new Uint8Array(16), "f");
        __classPrivateFieldSet(this, _CFB_shiftRegister, this.iv, "f");
    }
    get iv() {
        return new Uint8Array(__classPrivateFieldGet(this, _CFB_iv, "f"));
    }
    encrypt(plaintext) {
        if (8 * plaintext.length % this.segmentSize) throw new TypeError("invalid plaintext size (must be multiple of segmentSize bytes)");
        const segmentSize = this.segmentSize / 8;
        const ciphertext = new Uint8Array(plaintext);
        for(let i = 0; i < ciphertext.length; i += segmentSize){
            const xorSegment = this.aes.encrypt(__classPrivateFieldGet(this, _CFB_shiftRegister, "f"));
            for(let j = 0; j < segmentSize; j++)ciphertext[i + j] ^= xorSegment[j];
            __classPrivateFieldGet(this, _CFB_instances, "m", _CFB_shift).call(this, ciphertext.subarray(i));
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (8 * ciphertext.length % this.segmentSize) throw new TypeError("invalid ciphertext size (must be multiple of segmentSize bytes)");
        const segmentSize = this.segmentSize / 8;
        const plaintext = new Uint8Array(ciphertext);
        for(let i = 0; i < plaintext.length; i += segmentSize){
            const xorSegment = this.aes.encrypt(__classPrivateFieldGet(this, _CFB_shiftRegister, "f"));
            for(let j = 0; j < segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            __classPrivateFieldGet(this, _CFB_instances, "m", _CFB_shift).call(this, ciphertext.subarray(i));
        }
        return plaintext;
    }
}
_CFB_iv = new WeakMap(), _CFB_shiftRegister = new WeakMap(), _CFB_instances = new WeakSet(), _CFB_shift = function _CFB_shift(data) {
    const segmentSize = this.segmentSize / 8;
    // Shift the register
    __classPrivateFieldGet(this, _CFB_shiftRegister, "f").set(__classPrivateFieldGet(this, _CFB_shiftRegister, "f").subarray(segmentSize));
    __classPrivateFieldGet(this, _CFB_shiftRegister, "f").set(data.subarray(0, segmentSize), 16 - segmentSize);
};

},{"./mode.js":"8xDjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eGizN":[function(require,module,exports) {
// Counter Mode
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CTR", ()=>CTR);
var _modeJs = require("./mode.js");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CTR_remaining, _CTR_remainingIndex, _CTR_counter;
class CTR extends (0, _modeJs.ModeOfOperation) {
    constructor(key, initialValue){
        super("CTR", key, CTR);
        // Remaining bytes for the one-time pad
        _CTR_remaining.set(this, void 0);
        _CTR_remainingIndex.set(this, void 0);
        // The current counter
        _CTR_counter.set(this, void 0);
        __classPrivateFieldSet(this, _CTR_counter, new Uint8Array(16), "f");
        __classPrivateFieldGet(this, _CTR_counter, "f").fill(0);
        __classPrivateFieldSet(this, _CTR_remaining, __classPrivateFieldGet(this, _CTR_counter, "f"), "f"); // This will be discarded immediately
        __classPrivateFieldSet(this, _CTR_remainingIndex, 16, "f");
        if (initialValue == null) initialValue = 1;
        if (typeof initialValue === "number") this.setCounterValue(initialValue);
        else this.setCounterBytes(initialValue);
    }
    get counter() {
        return new Uint8Array(__classPrivateFieldGet(this, _CTR_counter, "f"));
    }
    setCounterValue(value) {
        if (!Number.isInteger(value) || value < 0 || value > Number.MAX_SAFE_INTEGER) throw new TypeError("invalid counter initial integer value");
        for(let index = 15; index >= 0; --index){
            __classPrivateFieldGet(this, _CTR_counter, "f")[index] = value % 256;
            value = Math.floor(value / 256);
        }
    }
    setCounterBytes(value) {
        if (value.length !== 16) throw new TypeError("invalid counter initial Uint8Array value length");
        __classPrivateFieldGet(this, _CTR_counter, "f").set(value);
    }
    increment() {
        for(let i = 15; i >= 0; i--)if (__classPrivateFieldGet(this, _CTR_counter, "f")[i] === 255) __classPrivateFieldGet(this, _CTR_counter, "f")[i] = 0;
        else {
            __classPrivateFieldGet(this, _CTR_counter, "f")[i]++;
            break;
        }
    }
    encrypt(plaintext) {
        var _a, _b;
        const crypttext = new Uint8Array(plaintext);
        for(let i = 0; i < crypttext.length; i++){
            if (__classPrivateFieldGet(this, _CTR_remainingIndex, "f") === 16) {
                __classPrivateFieldSet(this, _CTR_remaining, this.aes.encrypt(__classPrivateFieldGet(this, _CTR_counter, "f")), "f");
                __classPrivateFieldSet(this, _CTR_remainingIndex, 0, "f");
                this.increment();
            }
            crypttext[i] ^= __classPrivateFieldGet(this, _CTR_remaining, "f")[__classPrivateFieldSet(this, _CTR_remainingIndex, (_b = __classPrivateFieldGet(this, _CTR_remainingIndex, "f"), _a = _b++, _b), "f"), _a];
        }
        return crypttext;
    }
    decrypt(ciphertext) {
        return this.encrypt(ciphertext);
    }
}
_CTR_remaining = new WeakMap(), _CTR_remainingIndex = new WeakMap(), _CTR_counter = new WeakMap();

},{"./mode.js":"8xDjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8GOin":[function(require,module,exports) {
// Electronic Code Book
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ECB", ()=>ECB);
var _modeJs = require("./mode.js");
class ECB extends (0, _modeJs.ModeOfOperation) {
    constructor(key){
        super("ECB", key, ECB);
    }
    encrypt(plaintext) {
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const crypttext = new Uint8Array(plaintext.length);
        for(let i = 0; i < plaintext.length; i += 16)crypttext.set(this.aes.encrypt(plaintext.subarray(i, i + 16)), i);
        return crypttext;
    }
    decrypt(crypttext) {
        if (crypttext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        const plaintext = new Uint8Array(crypttext.length);
        for(let i = 0; i < crypttext.length; i += 16)plaintext.set(this.aes.decrypt(crypttext.subarray(i, i + 16)), i);
        return plaintext;
    }
}

},{"./mode.js":"8xDjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7x9S":[function(require,module,exports) {
// Output Feedback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OFB", ()=>OFB);
var _modeJs = require("./mode.js");
var __classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _OFB_iv, _OFB_lastPrecipher, _OFB_lastPrecipherIndex;
class OFB extends (0, _modeJs.ModeOfOperation) {
    constructor(key, iv){
        super("OFB", key, OFB);
        _OFB_iv.set(this, void 0);
        _OFB_lastPrecipher.set(this, void 0);
        _OFB_lastPrecipherIndex.set(this, void 0);
        if (iv) {
            if (iv.length % 16) throw new TypeError("invalid iv size (must be 16 bytes)");
            __classPrivateFieldSet(this, _OFB_iv, new Uint8Array(iv), "f");
        } else __classPrivateFieldSet(this, _OFB_iv, new Uint8Array(16), "f");
        __classPrivateFieldSet(this, _OFB_lastPrecipher, this.iv, "f");
        __classPrivateFieldSet(this, _OFB_lastPrecipherIndex, 16, "f");
    }
    get iv() {
        return new Uint8Array(__classPrivateFieldGet(this, _OFB_iv, "f"));
    }
    encrypt(plaintext) {
        var _a, _b;
        if (plaintext.length % 16) throw new TypeError("invalid plaintext size (must be multiple of 16 bytes)");
        const ciphertext = new Uint8Array(plaintext);
        for(let i = 0; i < ciphertext.length; i++){
            if (__classPrivateFieldGet(this, _OFB_lastPrecipherIndex, "f") === 16) {
                __classPrivateFieldSet(this, _OFB_lastPrecipher, this.aes.encrypt(__classPrivateFieldGet(this, _OFB_lastPrecipher, "f")), "f");
                __classPrivateFieldSet(this, _OFB_lastPrecipherIndex, 0, "f");
            }
            ciphertext[i] ^= __classPrivateFieldGet(this, _OFB_lastPrecipher, "f")[__classPrivateFieldSet(this, _OFB_lastPrecipherIndex, (_b = __classPrivateFieldGet(this, _OFB_lastPrecipherIndex, "f"), _a = _b++, _b), "f"), _a];
        }
        return ciphertext;
    }
    decrypt(ciphertext) {
        if (ciphertext.length % 16) throw new TypeError("invalid ciphertext size (must be multiple of 16 bytes)");
        return this.encrypt(ciphertext);
    }
}
_OFB_iv = new WeakMap(), _OFB_lastPrecipher = new WeakMap(), _OFB_lastPrecipherIndex = new WeakMap();

},{"./mode.js":"8xDjI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fzP4m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pkcs7Pad", ()=>pkcs7Pad);
parcelHelpers.export(exports, "pkcs7Strip", ()=>pkcs7Strip);
function pkcs7Pad(data) {
    const padder = 16 - data.length % 16;
    const result = new Uint8Array(data.length + padder);
    result.set(data);
    for(let i = data.length; i < result.length; i++)result[i] = padder;
    return result;
}
function pkcs7Strip(data) {
    if (data.length < 16) throw new TypeError("PKCS#7 invalid length");
    const padder = data[data.length - 1];
    if (padder > 16) throw new TypeError("PKCS#7 padding byte out of range");
    const length = data.length - padder;
    for(let i = 0; i < padder; i++){
        if (data[length + i] !== padder) throw new TypeError("PKCS#7 invalid padding byte");
    }
    return new Uint8Array(data.subarray(0, length));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cscUt":[function(require,module,exports) {
/**
 *  @_ignore
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "looseArrayify", ()=>looseArrayify);
parcelHelpers.export(exports, "zpad", ()=>zpad);
parcelHelpers.export(exports, "getPassword", ()=>getPassword);
parcelHelpers.export(exports, "spelunk", ()=>spelunk) /*
export function follow(object: any, path: string): null | string {
    let currentChild = object;

    for (const comp of path.toLowerCase().split('/')) {

        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for (const key in currentChild) {
             if (key.toLowerCase() === comp) {
                 matchingChild = currentChild[key];
                 break;
             }
        }

        if (matchingChild === null) { return null; }

        currentChild = matchingChild;
    }

    return currentChild;
}

// "path/to/something:type!"
export function followRequired(data: any, path: string): string {
    const value = follow(data, path);
    if (value != null) { return value; }
    return logger.throwArgumentError("invalid value", `data:${ path }`,
    JSON.stringify(data));
}
*/  // See: https://www.ietf.org/rfc/rfc4122.txt (Section 4.4)
 /*
export function uuidV4(randomBytes: BytesLike): string {
    const bytes = getBytes(randomBytes, "randomBytes");

    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = (bytes[6] & 0x0f) | 0x40;

    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const value = hexlify(bytes);

    return [
       value.substring(2, 10),
       value.substring(10, 14),
       value.substring(14, 18),
       value.substring(18, 22),
       value.substring(22, 34),
    ].join("-");
}
*/ ;
var _indexJs = require("../utils/index.js");
function looseArrayify(hexString) {
    if (typeof hexString === "string" && !hexString.startsWith("0x")) hexString = "0x" + hexString;
    return (0, _indexJs.getBytesCopy)(hexString);
}
function zpad(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function getPassword(password) {
    if (typeof password === "string") return (0, _indexJs.toUtf8Bytes)(password, "NFKC");
    return (0, _indexJs.getBytesCopy)(password);
}
function spelunk(object, _path) {
    const match = _path.match(/^([a-z0-9$_.-]*)(:([a-z]+))?(!)?$/i);
    (0, _indexJs.assertArgument)(match != null, "invalid path", "path", _path);
    const path = match[1];
    const type = match[3];
    const reqd = match[4] === "!";
    let cur = object;
    for (const comp of path.toLowerCase().split(".")){
        // Search for a child object with a case-insensitive matching key
        if (Array.isArray(cur)) {
            if (!comp.match(/^[0-9]+$/)) break;
            cur = cur[parseInt(comp)];
        } else if (typeof cur === "object") {
            let found = null;
            for(const key in cur)if (key.toLowerCase() === comp) {
                found = cur[key];
                break;
            }
            cur = found;
        } else cur = null;
        if (cur == null) break;
    }
    (0, _indexJs.assertArgument)(!reqd || cur != null, "missing required value", "path", path);
    if (type && cur != null) {
        if (type === "int") {
            if (typeof cur === "string" && cur.match(/^-?[0-9]+$/)) return parseInt(cur);
            else if (Number.isSafeInteger(cur)) return cur;
        }
        if (type === "number") {
            if (typeof cur === "string" && cur.match(/^-?[0-9.]*$/)) return parseFloat(cur);
        }
        if (type === "data") {
            if (typeof cur === "string") return looseArrayify(cur);
        }
        if (type === "array" && Array.isArray(cur)) return cur;
        if (type === typeof cur) return cur;
        (0, _indexJs.assertArgument)(false, `wrong type found for ${type} `, "path", path);
    }
    return cur;
}

},{"../utils/index.js":"4LgPJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbG4O":[function(require,module,exports) {
/**
 *  @_subsection: api/wallet:JSON Wallets  [json-wallets]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  Returns true if %%json%% is a valid JSON Crowdsale wallet.
 */ parcelHelpers.export(exports, "isCrowdsaleJson", ()=>isCrowdsaleJson);
// See: https://github.com/ethereum/pyethsaletool
/**
 *  Before Ethereum launched, it was necessary to create a wallet
 *  format for backers to use, which would be used to receive ether
 *  as a reward for contributing to the project.
 *
 *  The [[link-crowdsale]] format is now obsolete, but it is still
 *  useful to support and the additional code is fairly trivial as
 *  all the primitives required are used through core portions of
 *  the library.
 */ parcelHelpers.export(exports, "decryptCrowdsaleJson", ()=>decryptCrowdsaleJson);
var _aesJs = require("aes-js");
var _indexJs = require("../address/index.js");
var _indexJs1 = require("../crypto/index.js");
var _indexJs2 = require("../hash/index.js");
var _indexJs3 = require("../utils/index.js");
var _utilsJs = require("./utils.js");
function isCrowdsaleJson(json) {
    try {
        const data = JSON.parse(json);
        if (data.encseed) return true;
    } catch (error) {}
    return false;
}
function decryptCrowdsaleJson(json, _password) {
    const data = JSON.parse(json);
    const password = (0, _utilsJs.getPassword)(_password);
    // Ethereum Address
    const address = (0, _indexJs.getAddress)((0, _utilsJs.spelunk)(data, "ethaddr:string!"));
    // Encrypted Seed
    const encseed = (0, _utilsJs.looseArrayify)((0, _utilsJs.spelunk)(data, "encseed:string!"));
    (0, _indexJs3.assertArgument)(encseed && encseed.length % 16 === 0, "invalid encseed", "json", json);
    const key = (0, _indexJs3.getBytes)((0, _indexJs1.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, _aesJs.CBC)(key, iv);
    const seed = (0, _aesJs.pkcs7Strip)((0, _indexJs3.getBytes)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    return {
        address,
        privateKey: (0, _indexJs2.id)(seedHex)
    };
}

},{"aes-js":"jfWHv","../address/index.js":"3THmk","../crypto/index.js":"jUsZl","../hash/index.js":"3Gr4x","../utils/index.js":"4LgPJ","./utils.js":"cscUt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ge8e2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  A **Wallet** manages a single private key which is used to sign
 *  transactions, messages and other common payloads.
 *
 *  This class is generally the main entry point for developers
 *  that wish to use a private key directly, as it can create
 *  instances from a large variety of common sources, including
 *  raw private key, [[link-bip-39]] mnemonics and encrypte JSON
 *  wallets.
 */ parcelHelpers.export(exports, "Wallet", ()=>Wallet);
var _indexJs = require("../crypto/index.js");
var _indexJs1 = require("../utils/index.js");
var _baseWalletJs = require("./base-wallet.js");
var _hdwalletJs = require("./hdwallet.js");
var _jsonCrowdsaleJs = require("./json-crowdsale.js");
var _jsonKeystoreJs = require("./json-keystore.js");
var _mnemonicJs = require("./mnemonic.js");
function stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
}
class Wallet extends (0, _baseWalletJs.BaseWallet) {
    /**
     *  Create a new wallet for the private %%key%%, optionally connected
     *  to %%provider%%.
     */ constructor(key, provider){
        if (typeof key === "string" && !key.startsWith("0x")) key = "0x" + key;
        let signingKey = typeof key === "string" ? new (0, _indexJs.SigningKey)(key) : key;
        super(signingKey, provider);
    }
    connect(provider) {
        return new Wallet(this.signingKey, provider);
    }
    /**
     *  Resolves to a [JSON Keystore Wallet](json-wallets) encrypted with
     *  %%password%%.
     *
     *  If %%progressCallback%% is specified, it will receive periodic
     *  updates as the encryption process progreses.
     */ async encrypt(password, progressCallback) {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        return await (0, _jsonKeystoreJs.encryptKeystoreJson)(account, password, {
            progressCallback
        });
    }
    /**
     *  Returns a [JSON Keystore Wallet](json-wallets) encryped with
     *  %%password%%.
     *
     *  It is preferred to use the [async version](encrypt) instead,
     *  which allows a [[ProgressCallback]] to keep the user informed.
     *
     *  This method will block the event loop (freezing all UI) until
     *  it is complete, which may be a non-trivial duration.
     */ encryptSync(password) {
        const account = {
            address: this.address,
            privateKey: this.privateKey
        };
        return (0, _jsonKeystoreJs.encryptKeystoreJsonSync)(account, password);
    }
    static #fromAccount(account) {
        (0, _indexJs1.assertArgument)(account, "invalid JSON wallet", "json", "[ REDACTED ]");
        if ("mnemonic" in account && account.mnemonic && account.mnemonic.locale === "en") {
            const mnemonic = (0, _mnemonicJs.Mnemonic).fromEntropy(account.mnemonic.entropy);
            const wallet = (0, _hdwalletJs.HDNodeWallet).fromMnemonic(mnemonic, account.mnemonic.path);
            if (wallet.address === account.address && wallet.privateKey === account.privateKey) return wallet;
            console.log("WARNING: JSON mismatch address/privateKey != mnemonic; fallback onto private key");
        }
        const wallet = new Wallet(account.privateKey);
        (0, _indexJs1.assertArgument)(wallet.address === account.address, "address/privateKey mismatch", "json", "[ REDACTED ]");
        return wallet;
    }
    /**
     *  Creates (asynchronously) a **Wallet** by decrypting the %%json%%
     *  with %%password%%.
     *
     *  If %%progress%% is provided, it is called periodically during
     *  decryption so that any UI can be updated.
     */ static async fromEncryptedJson(json, password, progress) {
        let account = null;
        if ((0, _jsonKeystoreJs.isKeystoreJson)(json)) account = await (0, _jsonKeystoreJs.decryptKeystoreJson)(json, password, progress);
        else if ((0, _jsonCrowdsaleJs.isCrowdsaleJson)(json)) {
            if (progress) {
                progress(0);
                await stall(0);
            }
            account = (0, _jsonCrowdsaleJs.decryptCrowdsaleJson)(json, password);
            if (progress) {
                progress(1);
                await stall(0);
            }
        }
        return Wallet.#fromAccount(account);
    }
    /**
     *  Creates a **Wallet** by decrypting the %%json%% with %%password%%.
     *
     *  The [[fromEncryptedJson]] method is preferred, as this method
     *  will lock up and freeze the UI during decryption, which may take
     *  some time.
     */ static fromEncryptedJsonSync(json, password) {
        let account = null;
        if ((0, _jsonKeystoreJs.isKeystoreJson)(json)) account = (0, _jsonKeystoreJs.decryptKeystoreJsonSync)(json, password);
        else if ((0, _jsonCrowdsaleJs.isCrowdsaleJson)(json)) account = (0, _jsonCrowdsaleJs.decryptCrowdsaleJson)(json, password);
        else (0, _indexJs1.assertArgument)(false, "invalid JSON wallet", "json", "[ REDACTED ]");
        return Wallet.#fromAccount(account);
    }
    /**
     *  Creates a new random [[HDNodeWallet]] using the available
     *  [cryptographic random source](randomBytes).
     *
     *  If there is no crytographic random source, this will throw.
     */ static createRandom(provider) {
        const wallet = (0, _hdwalletJs.HDNodeWallet).createRandom();
        if (provider) return wallet.connect(provider);
        return wallet;
    }
    /**
     *  Creates a [[HDNodeWallet]] for %%phrase%%.
     */ static fromPhrase(phrase, provider) {
        const wallet = (0, _hdwalletJs.HDNodeWallet).fromPhrase(phrase);
        if (provider) return wallet.connect(provider);
        return wallet;
    }
}

},{"../crypto/index.js":"jUsZl","../utils/index.js":"4LgPJ","./base-wallet.js":"6QsJK","./hdwallet.js":"1TAim","./json-crowdsale.js":"dbG4O","./json-keystore.js":"htQBf","./mnemonic.js":"kWQMV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"27Mns":[function(require,module,exports) {
/**
 *  A Wordlist is a set of 2048 words used to encode private keys
 *  (or other binary data) that is easier for humans to write down,
 *  transcribe and dictate.
 *
 *  The [[link-bip-39]] standard includes several checksum bits,
 *  depending on the size of the mnemonic phrase.
 *
 *  A mnemonic phrase may be 12, 15, 18, 21 or 24 words long. For
 *  most purposes 12 word mnemonics should be used, as including
 *  additional words increases the difficulty and potential for
 *  mistakes and does not offer any effective improvement on security.
 *
 *  There are a variety of [[link-bip39-wordlists]] for different
 *  languages, but for maximal compatibility, the
 *  [English Wordlist](LangEn) is recommended.
 *
 *  @_section: api/wordlists:Wordlists [about-wordlists]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wordlist", ()=>(0, _wordlistJs.Wordlist));
parcelHelpers.export(exports, "LangEn", ()=>(0, _langEnJs.LangEn));
parcelHelpers.export(exports, "WordlistOwl", ()=>(0, _wordlistOwlJs.WordlistOwl));
parcelHelpers.export(exports, "WordlistOwlA", ()=>(0, _wordlistOwlaJs.WordlistOwlA));
parcelHelpers.export(exports, "wordlists", ()=>(0, _wordlistsJs.wordlists));
var _wordlistJs = require("./wordlist.js");
var _langEnJs = require("./lang-en.js");
var _wordlistOwlJs = require("./wordlist-owl.js");
var _wordlistOwlaJs = require("./wordlist-owla.js");
var _wordlistsJs = require("./wordlists.js");

},{"./wordlist.js":"kq9Li","./lang-en.js":"lae98","./wordlist-owl.js":"8y30J","./wordlist-owla.js":"enHcC","./wordlists.js":"d2cuU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"enHcC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  An OWL-A format Wordlist extends the OWL format to add an
 *  overlay onto an OWL format Wordlist to support diacritic
 *  marks.
 *
 *  This class is generally not useful to most developers as
 *  it is used mainly internally to keep Wordlists for languages
 *  based on latin-1 small.
 *
 *  If necessary, there are tools within the ``generation/`` folder
 *  to create the necessary data.
 */ parcelHelpers.export(exports, "WordlistOwlA", ()=>WordlistOwlA);
var _wordlistOwlJs = require("./wordlist-owl.js");
var _decodeOwlaJs = require("./decode-owla.js");
class WordlistOwlA extends (0, _wordlistOwlJs.WordlistOwl) {
    #accent;
    /**
     *  Creates a new Wordlist for %%locale%% using the OWLA %%data%%
     *  and %%accent%% data and validated against the %%checksum%%.
     */ constructor(locale, data, accent, checksum){
        super(locale, data, checksum);
        this.#accent = accent;
    }
    /**
     *  The OWLA-encoded accent data.
     */ get _accent() {
        return this.#accent;
    }
    /**
     *  Decode all the words for the wordlist.
     */ _decodeWords() {
        return (0, _decodeOwlaJs.decodeOwlA)(this._data, this._accent);
    }
}

},{"./wordlist-owl.js":"8y30J","./decode-owla.js":"lWv7G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lWv7G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "decodeOwlA", ()=>decodeOwlA);
var _indexJs = require("../utils/index.js");
var _bitReaderJs = require("./bit-reader.js");
var _decodeOwlJs = require("./decode-owl.js");
function decodeOwlA(data, accents) {
    let words = (0, _decodeOwlJs.decodeOwl)(data).join(",");
    // Inject the accents
    accents.split(/,/g).forEach((accent)=>{
        const match = accent.match(/^([a-z]*)([0-9]+)([0-9])(.*)$/);
        (0, _indexJs.assertArgument)(match !== null, "internal error parsing accents", "accents", accents);
        let posOffset = 0;
        const positions = (0, _bitReaderJs.decodeBits)(parseInt(match[3]), match[4]);
        const charCode = parseInt(match[2]);
        const regex = new RegExp(`([${match[1]}])`, "g");
        words = words.replace(regex, (all, letter)=>{
            const rem = --positions[posOffset];
            if (rem === 0) {
                letter = String.fromCharCode(letter.charCodeAt(0), charCode);
                posOffset++;
            }
            return letter;
        });
    });
    return words.split(",");
}

},{"../utils/index.js":"4LgPJ","./bit-reader.js":"6y5Vw","./decode-owl.js":"9KQ9j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6y5Vw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *  @_ignore
 */ parcelHelpers.export(exports, "decodeBits", ()=>decodeBits);
const Base64 = ")!@#$%^&*(ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
function decodeBits(width, data) {
    const maxValue = (1 << width) - 1;
    const result = [];
    let accum = 0, bits = 0, flood = 0;
    for(let i = 0; i < data.length; i++){
        // Accumulate 6 bits of data
        accum = accum << 6 | Base64.indexOf(data[i]);
        bits += 6;
        // While we have enough for a word...
        while(bits >= width){
            // ...read the word
            const value = accum >> bits - width;
            accum &= (1 << bits - width) - 1;
            bits -= width;
            // A value of 0 indicates we exceeded maxValue, it
            // floods over into the next value
            if (value === 0) flood += maxValue;
            else {
                result.push(value + flood);
                flood = 0;
            }
        }
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d2cuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wordlists", ()=>wordlists);
var _langEnJs = require("./lang-en.js");
const wordlists = {
    en: (0, _langEnJs.LangEn).wordlist()
};

},{"./lang-en.js":"lae98","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMgBp":[function(require,module,exports) {
/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "utils", ()=>utils);
parcelHelpers.export(exports, "RLP", ()=>RLP);
function encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = encode(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return concatBytes(encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return concatBytes(encodeLength(inputBuf.length, 128), inputBuf);
}
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return parseHexByte(bytesToHex(v));
}
function encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = numberToHex(offset + 55 + lLength);
    return Uint8Array.from(hexToBytes(firstByte + hexLength));
}
function decode(input, stream = false) {
    if (typeof input === "undefined" || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = toBytes(input);
    const decoded = _decode(inputBytes);
    if (stream) return {
        data: decoded.data,
        remainder: decoded.remainder.slice()
    };
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
/** Decode an input with RLP */ function _decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.subarray(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data,
            remainder: input.subarray(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = decodeLength(safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = safeSlice(input, llength, length + llength);
        return {
            data,
            remainder: input.subarray(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = decodeLength(safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(totalLength)
        };
    }
}
const cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += cachedHexes[uint8a[i]];
    return hex;
}
function parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if (isHexPrefixed(v)) return hexToBytes(padToEven(stripHexPrefix(v)));
        return utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return hexToBytes(numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
const utils = {
    bytesToHex,
    concatBytes,
    hexToBytes,
    utf8ToBytes
};
const RLP = {
    encode,
    decode
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dzDrA":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("2f0a75c64426eefd").version;
elliptic.utils = require("b5994f78671d1fe4");
elliptic.rand = require("98f3821176ee3c07");
elliptic.curve = require("5f81a237f307e031");
elliptic.curves = require("46a907f14f6e60d6");
// Protocols
elliptic.ec = require("fc0c0617aa87aca");
elliptic.eddsa = require("ec9f03e0b8cf9e3a");

},{"2f0a75c64426eefd":"4YUZB","b5994f78671d1fe4":"eAOIv","98f3821176ee3c07":"dzcfb","5f81a237f307e031":"fwM0A","46a907f14f6e60d6":"cxBSL","fc0c0617aa87aca":"qWnfF","ec9f03e0b8cf9e3a":"2oqcQ"}],"4YUZB":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"eAOIv":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("c6d6f3deb385ea03");
var minAssert = require("4389c823cab2e0b0");
var minUtils = require("26e4f0e4afedad15");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"c6d6f3deb385ea03":"lMk0z","4389c823cab2e0b0":"cKbUa","26e4f0e4afedad15":"1KIes"}],"lMk0z":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("f8915a0fb3dd55ee").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"f8915a0fb3dd55ee":"13Pcp"}],"fwM0A":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("55a0eb6b9ec6f7b3");
curve.short = require("2940cc0ac507d3f2");
curve.mont = require("abc24b325eac3062");
curve.edwards = require("bb0b2405011f6b69");

},{"55a0eb6b9ec6f7b3":"3xTBB","2940cc0ac507d3f2":"Kn3JP","abc24b325eac3062":"ew5CC","bb0b2405011f6b69":"eZIsF"}],"3xTBB":[function(require,module,exports) {
"use strict";
var BN = require("ddf9f376b35c1766");
var utils = require("a6c9d99571aa6338");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"ddf9f376b35c1766":"lMk0z","a6c9d99571aa6338":"eAOIv"}],"Kn3JP":[function(require,module,exports) {
"use strict";
var utils = require("6ecf697d7b1829e1");
var BN = require("b308e86bdaa92bc3");
var inherits = require("ab8f5c1c71167964");
var Base = require("94bdfcec84125818");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"6ecf697d7b1829e1":"eAOIv","b308e86bdaa92bc3":"lMk0z","ab8f5c1c71167964":"8LxVj","94bdfcec84125818":"3xTBB"}],"ew5CC":[function(require,module,exports) {
"use strict";
var BN = require("8fe42c72f6a79f2f");
var inherits = require("d68cc2515c7d7576");
var Base = require("f906667b2e71d5f7");
var utils = require("42d2b63edce55a24");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"8fe42c72f6a79f2f":"lMk0z","d68cc2515c7d7576":"8LxVj","f906667b2e71d5f7":"3xTBB","42d2b63edce55a24":"eAOIv"}],"eZIsF":[function(require,module,exports) {
"use strict";
var utils = require("c9ea586b31af5ac9");
var BN = require("cd2618a987cb7faa");
var inherits = require("d8ba8575128794d");
var Base = require("32d0f8ab544dfb91");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"c9ea586b31af5ac9":"eAOIv","cd2618a987cb7faa":"lMk0z","d8ba8575128794d":"8LxVj","32d0f8ab544dfb91":"3xTBB"}],"cxBSL":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("40045bdc0eaddc9a");
var curve = require("27f89c67574799e1");
var utils = require("38fd53b6ac743f56");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("810fd62c51cddc08");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"40045bdc0eaddc9a":"dElqS","27f89c67574799e1":"fwM0A","38fd53b6ac743f56":"eAOIv","810fd62c51cddc08":"34dHH"}],"34dHH":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"qWnfF":[function(require,module,exports) {
"use strict";
var BN = require("d84c303ea26ea431");
var HmacDRBG = require("ae8819e8cfbe7df2");
var utils = require("d969e4e8d613854c");
var curves = require("163442bf2a546461");
var rand = require("48b498ff237115f6");
var assert = utils.assert;
var KeyPair = require("336d15a02c32627");
var Signature = require("5cf386ca0471b079");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"d84c303ea26ea431":"lMk0z","ae8819e8cfbe7df2":"alGiF","d969e4e8d613854c":"eAOIv","163442bf2a546461":"cxBSL","48b498ff237115f6":"dzcfb","336d15a02c32627":"lgXEs","5cf386ca0471b079":"2YS7L"}],"lgXEs":[function(require,module,exports) {
"use strict";
var BN = require("153aa742f4bd5061");
var utils = require("7e7a3a89053eea86");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"153aa742f4bd5061":"lMk0z","7e7a3a89053eea86":"eAOIv"}],"2YS7L":[function(require,module,exports) {
"use strict";
var BN = require("3327a81574715de5");
var utils = require("bdab001d1e6cf6cb");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"3327a81574715de5":"lMk0z","bdab001d1e6cf6cb":"eAOIv"}],"2oqcQ":[function(require,module,exports) {
"use strict";
var hash = require("624855c9296037c");
var curves = require("2b81988e080f43ba");
var utils = require("94d5c649a41d2d8");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("b2d7204d828b0292");
var Signature = require("20244b540064d219");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"624855c9296037c":"dElqS","2b81988e080f43ba":"cxBSL","94d5c649a41d2d8":"eAOIv","b2d7204d828b0292":"9yziJ","20244b540064d219":"hDZpk"}],"9yziJ":[function(require,module,exports) {
"use strict";
var utils = require("929d48cc254e7113");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"929d48cc254e7113":"eAOIv"}],"hDZpk":[function(require,module,exports) {
"use strict";
var BN = require("f25760d59535fef6");
var utils = require("3b6f2255d836ca");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"f25760d59535fef6":"lMk0z","3b6f2255d836ca":"eAOIv"}],"01YnU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetGlobalState = exports.useEventSource = exports.ReadyState = exports.useSocketIO = exports.default = void 0;
var use_websocket_1 = require("f00fb6dc03460a64");
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return use_websocket_1.useWebSocket;
    }
});
var use_socket_io_1 = require("8ac29534a9d1516e");
Object.defineProperty(exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return use_socket_io_1.useSocketIO;
    }
});
var constants_1 = require("62bf0ad1d3a6788f");
Object.defineProperty(exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return constants_1.ReadyState;
    }
});
var use_event_source_1 = require("2eb9c2413566c19c");
Object.defineProperty(exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return use_event_source_1.useEventSource;
    }
});
var util_1 = require("408f744950de5e53");
Object.defineProperty(exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return util_1.resetGlobalState;
    }
});

},{"f00fb6dc03460a64":"jDW4u","8ac29534a9d1516e":"gLnVv","62bf0ad1d3a6788f":"irOOR","2eb9c2413566c19c":"8SKuN","408f744950de5e53":"6Etpg"}],"jDW4u":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useWebSocket = void 0;
var react_1 = require("e250885887842d2e");
var react_dom_1 = require("e71cea6a67895f6");
var constants_1 = require("98e19833e256c9c5");
var create_or_join_1 = require("f34c96379ea5e08");
var get_url_1 = require("c5c603ed07b713a4");
var proxy_1 = __importDefault(require("747d19339b4d0463"));
var util_1 = require("4ea9ba5e37b67d0a");
var useWebSocket = function(url, options, connect) {
    if (options === void 0) options = constants_1.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = (0, react_1.useState)(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = (0, react_1.useState)({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = (0, react_1.useMemo)(function() {
        if (lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return constants_1.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage
    ]);
    var convertedUrl = (0, react_1.useRef)(null);
    var webSocketRef = (0, react_1.useRef)(null);
    var startRef = (0, react_1.useRef)(function() {
        return void 0;
    });
    var reconnectCount = (0, react_1.useRef)(0);
    var messageQueue = (0, react_1.useRef)([]);
    var webSocketProxy = (0, react_1.useRef)(null);
    var optionsCache = (0, react_1.useRef)(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? constants_1.ReadyState.CONNECTING : constants_1.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = (0, react_1.useCallback)(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if (constants_1.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn("Unable to send a message from an eventSource");
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === constants_1.ReadyState.OPEN) {
            (0, util_1.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = (0, react_1.useCallback)(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = (0, react_1.useCallback)(function() {
        if (optionsCache.current.share !== true || constants_1.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            (0, util_1.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketProxy.current = (0, proxy_1.default)(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    (0, react_1.useEffect)(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var createOrJoin_1 = true;
            var start_1 = function() {
                return __awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return __generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    (0, get_url_1.getUrl)(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                if (convertedUrl.current === null) {
                                    console.error("Failed to get a valid URL. WebSocket connection aborted.");
                                    convertedUrl.current = "ABORTED";
                                    (0, react_dom_1.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            return __assign(__assign({}, prev), {
                                                ABORTED: constants_1.ReadyState.CLOSED
                                            });
                                        });
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) (0, react_dom_1.flushSync)(function() {
                                        return setLastMessage(message);
                                    });
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) (0, react_dom_1.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            var _a;
                                            return __assign(__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                        });
                                    });
                                };
                                if (createOrJoin_1) removeListeners_1 = (0, create_or_join_1.createOrJoinSocket)(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                createOrJoin_1 = false;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return __assign(__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = constants_1.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    (0, react_1.useEffect)(function() {
        if (readyStateFromUrl === constants_1.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};
exports.useWebSocket = useWebSocket;

},{"e250885887842d2e":"6uln9","e71cea6a67895f6":"b8T3j","98e19833e256c9c5":"irOOR","f34c96379ea5e08":"ks44Q","c5c603ed07b713a4":"3tYAn","747d19339b4d0463":"cpAlB","4ea9ba5e37b67d0a":"6Etpg"}],"irOOR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEventSourceSupported = exports.isReactNative = exports.ReadyState = exports.DEFAULT_HEARTBEAT = exports.UNPARSABLE_JSON_OBJECT = exports.DEFAULT_RECONNECT_INTERVAL_MS = exports.DEFAULT_RECONNECT_LIMIT = exports.SOCKET_IO_PING_CODE = exports.SOCKET_IO_PATH = exports.SOCKET_IO_PING_INTERVAL = exports.DEFAULT_EVENT_SOURCE_OPTIONS = exports.EMPTY_EVENT_HANDLERS = exports.DEFAULT_OPTIONS = void 0;
var MILLISECONDS = 1;
var SECONDS = 1000 * MILLISECONDS;
exports.DEFAULT_OPTIONS = {};
exports.EMPTY_EVENT_HANDLERS = {};
exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: exports.EMPTY_EVENT_HANDLERS
};
exports.SOCKET_IO_PING_INTERVAL = 25 * SECONDS;
exports.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket";
exports.SOCKET_IO_PING_CODE = "2";
exports.DEFAULT_RECONNECT_LIMIT = 20;
exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
exports.UNPARSABLE_JSON_OBJECT = {};
exports.DEFAULT_HEARTBEAT = {
    message: "ping",
    timeout: 60000,
    interval: 25000
};
var ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})(ReadyState = exports.ReadyState || (exports.ReadyState = {}));
var eventSourceSupported = function() {
    try {
        return "EventSource" in globalThis;
    } catch (e) {
        return false;
    }
};
exports.isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
exports.isEventSourceSupported = !exports.isReactNative && eventSourceSupported();

},{}],"ks44Q":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createOrJoinSocket = void 0;
var globals_1 = require("5ab94d6ee985f071");
var constants_1 = require("7c13c4f76b199b0d");
var attach_listener_1 = require("61c06f8dc5d87572");
var attach_shared_listeners_1 = require("355f45549233fc5f");
var manage_subscribers_1 = require("930dfe43ec98720");
//TODO ensure that all onClose callbacks are called
var cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        (0, manage_subscribers_1.removeSubscriber)(url, subscriber);
        if (!(0, manage_subscribers_1.hasSubscribers)(url)) {
            try {
                var socketLike = globals_1.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState(constants_1.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete globals_1.sharedWebSockets[url];
        }
    };
};
var createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, sendMessage) {
    if (!constants_1.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if (constants_1.isReactNative) throw new Error("EventSource is not supported in ReactNative");
        else throw new Error("EventSource is not supported");
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if (globals_1.sharedWebSockets[url] === undefined) {
            globals_1.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = globals_1.sharedWebSockets[url];
            setReadyState(constants_1.ReadyState.CONNECTING);
            clearSocketIoPingInterval = (0, attach_shared_listeners_1.attachSharedListeners)(globals_1.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = globals_1.sharedWebSockets[url];
            setReadyState(globals_1.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef
        };
        (0, manage_subscribers_1.addSubscriber)(url, subscriber);
        return cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState(constants_1.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error("WebSocket failed to be created");
        return (0, attach_listener_1.attachListeners)(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, sendMessage);
    }
};
exports.createOrJoinSocket = createOrJoinSocket;

},{"5ab94d6ee985f071":"l5cHZ","7c13c4f76b199b0d":"irOOR","61c06f8dc5d87572":"bvS1M","355f45549233fc5f":"aX4hz","930dfe43ec98720":"JIGzW"}],"l5cHZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetWebSockets = exports.sharedWebSockets = void 0;
exports.sharedWebSockets = {};
var resetWebSockets = function(url) {
    if (url && exports.sharedWebSockets.hasOwnProperty(url)) delete exports.sharedWebSockets[url];
    else {
        for(var url_1 in exports.sharedWebSockets)if (exports.sharedWebSockets.hasOwnProperty(url_1)) delete exports.sharedWebSockets[url_1];
    }
};
exports.resetWebSockets = resetWebSockets;

},{}],"bvS1M":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.attachListeners = void 0;
var socket_io_1 = require("24b1865333b52250");
var heartbeat_1 = require("460890fb88f22e0e");
var constants_1 = require("a482a8018486d938");
var util_1 = require("a77647fcd6d44775");
var bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage) {
    var heartbeatCb;
    if (optionsRef.current.heartbeat && webSocketInstance instanceof WebSocket) {
        var heartbeatOptions = typeof optionsRef.current.heartbeat === "boolean" ? undefined : optionsRef.current.heartbeat;
        heartbeatCb = (0, heartbeat_1.heartbeat)(webSocketInstance, heartbeatOptions);
    }
    webSocketInstance.onmessage = function(message) {
        var _a;
        heartbeatCb === null || heartbeatCb === void 0 || heartbeatCb();
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === "function" && optionsRef.current.filter(message) !== true) return;
        if (optionsRef.current.heartbeat && typeof optionsRef.current.heartbeat !== "boolean" && ((_a = optionsRef.current.heartbeat) === null || _a === void 0 ? void 0 : _a.returnMessage) === message.data) return;
        setLastMessage(message);
    };
};
var bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState(constants_1.ReadyState.OPEN);
    };
};
var bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if (constants_1.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    (0, util_1.assertIsWebSocket)(webSocketInstance, optionsRef.current.skipAssert);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState(constants_1.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : constants_1.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if (constants_1.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose(__assign(__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: ".concat(error),
                wasClean: false
            }));
            setReadyState(constants_1.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT)) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : constants_1.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(optionsRef.current.reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = (0, socket_io_1.setUpSocketIOPing)(sendMessage);
    bindMessageHandler(webSocketInstance, optionsRef, setLastMessage);
    bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount);
    cancelReconnectOnClose = bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState(constants_1.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};
exports.attachListeners = attachListeners;

},{"24b1865333b52250":"eP9eE","460890fb88f22e0e":"b1JCb","a482a8018486d938":"irOOR","a77647fcd6d44775":"6Etpg"}],"eP9eE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setUpSocketIOPing = exports.appendQueryParams = exports.parseSocketIOUrl = void 0;
var constants_1 = require("5ecd5ba9ae6b0064");
var parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, "");
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, "");
        var protocol = isSecure ? "wss" : "ws";
        return "".concat(protocol, "://").concat(removedFinalBackSlack).concat(constants_1.SOCKET_IO_PATH);
    } else if (url === "") {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? "wss" : "ws";
        var port = window.location.port ? ":".concat(window.location.port) : "";
        return "".concat(protocol, "://").concat(window.location.hostname).concat(port).concat(constants_1.SOCKET_IO_PATH);
    }
    return url;
};
exports.parseSocketIOUrl = parseSocketIOUrl;
var appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "".concat(Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + "".concat(key, "=").concat(value, "&");
    }, "").slice(0, -1));
    return "".concat(url).concat(alreadyHasParams ? "&" : "?").concat(stringified);
};
exports.appendQueryParams = appendQueryParams;
var setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = constants_1.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage(constants_1.SOCKET_IO_PING_CODE);
    };
    return window.setInterval(ping, interval);
};
exports.setUpSocketIOPing = setUpSocketIOPing;

},{"5ecd5ba9ae6b0064":"irOOR"}],"b1JCb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.heartbeat = void 0;
var constants_1 = require("7e09194d8fe2ce63");
function heartbeat(ws, options) {
    var _a = options || {}, _b = _a.interval, interval = _b === void 0 ? constants_1.DEFAULT_HEARTBEAT.interval : _b, _c = _a.timeout, timeout = _c === void 0 ? constants_1.DEFAULT_HEARTBEAT.timeout : _c, _d = _a.message, message = _d === void 0 ? constants_1.DEFAULT_HEARTBEAT.message : _d;
    var messageAccepted = false;
    var pingTimer = setInterval(function() {
        try {
            if (typeof message === "function") ws.send(message());
            else ws.send(message);
        } catch (error) {
        // do nothing
        }
    }, interval);
    var timeoutTimer = setInterval(function() {
        if (!messageAccepted) ws.close();
        else messageAccepted = false;
    }, timeout);
    ws.addEventListener("close", function() {
        clearInterval(pingTimer);
        clearInterval(timeoutTimer);
    });
    return function() {
        messageAccepted = true;
    };
}
exports.heartbeat = heartbeat;

},{"7e09194d8fe2ce63":"irOOR"}],"6Etpg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetGlobalState = exports.assertIsWebSocket = void 0;
var globals_1 = require("ec560538d5ba11fc");
var manage_subscribers_1 = require("e0372be3fae40109");
function assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false) throw new Error("");
}
exports.assertIsWebSocket = assertIsWebSocket;
function resetGlobalState(url) {
    (0, manage_subscribers_1.resetSubscribers)(url);
    (0, globals_1.resetWebSockets)(url);
}
exports.resetGlobalState = resetGlobalState;

},{"ec560538d5ba11fc":"l5cHZ","e0372be3fae40109":"JIGzW"}],"JIGzW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetSubscribers = exports.removeSubscriber = exports.addSubscriber = exports.hasSubscribers = exports.getSubscribers = void 0;
var subscribers = {};
var EMPTY_LIST = [];
var getSubscribers = function(url) {
    if ((0, exports.hasSubscribers)(url)) return Array.from(subscribers[url]);
    return EMPTY_LIST;
};
exports.getSubscribers = getSubscribers;
var hasSubscribers = function(url) {
    var _a;
    return ((_a = subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
exports.hasSubscribers = hasSubscribers;
var addSubscriber = function(url, subscriber) {
    subscribers[url] = subscribers[url] || new Set();
    subscribers[url].add(subscriber);
};
exports.addSubscriber = addSubscriber;
var removeSubscriber = function(url, subscriber) {
    subscribers[url].delete(subscriber);
};
exports.removeSubscriber = removeSubscriber;
var resetSubscribers = function(url) {
    if (url && subscribers.hasOwnProperty(url)) delete subscribers[url];
    else {
        for(var url_1 in subscribers)if (subscribers.hasOwnProperty(url_1)) delete subscribers[url_1];
    }
};
exports.resetSubscribers = resetSubscribers;

},{}],"aX4hz":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.attachSharedListeners = void 0;
var globals_1 = require("84dce7866492f036");
var constants_1 = require("4ed520fbcc356161");
var manage_subscribers_1 = require("5e7f022a1358ff00");
var socket_io_1 = require("e92ab2c3413a343a");
var heartbeat_1 = require("394109615c022354");
var bindMessageHandler = function(webSocketInstance, url, heartbeatOptions) {
    var onMessageCb;
    if (heartbeatOptions && webSocketInstance instanceof WebSocket) onMessageCb = (0, heartbeat_1.heartbeat)(webSocketInstance, typeof heartbeatOptions === "boolean" ? undefined : heartbeatOptions);
    webSocketInstance.onmessage = function(message) {
        onMessageCb === null || onMessageCb === void 0 || onMessageCb();
        (0, manage_subscribers_1.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof subscriber.optionsRef.current.filter === "function" && subscriber.optionsRef.current.filter(message) !== true) return;
            if (heartbeatOptions && typeof heartbeatOptions !== "boolean" && (heartbeatOptions === null || heartbeatOptions === void 0 ? void 0 : heartbeatOptions.returnMessage) === message.data) return;
            subscriber.setLastMessage(message);
        });
    };
};
var bindOpenHandler = function(webSocketInstance, url) {
    webSocketInstance.onopen = function(event) {
        (0, manage_subscribers_1.getSubscribers)(url).forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState(constants_1.ReadyState.OPEN);
        });
    };
};
var bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        (0, manage_subscribers_1.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState(constants_1.ReadyState.CLOSED);
        });
        delete globals_1.sharedWebSockets[url];
        (0, manage_subscribers_1.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    var nextReconnectInterval = typeof subscriber.optionsRef.current.reconnectInterval === "function" ? subscriber.optionsRef.current.reconnectInterval(subscriber.reconnectCount.current) : subscriber.optionsRef.current.reconnectInterval;
                    setTimeout(function() {
                        subscriber.reconnectCount.current++;
                        subscriber.reconnect.current();
                    }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : constants_1.DEFAULT_RECONNECT_INTERVAL_MS);
                } else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
                }
            }
        });
    };
};
var bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        (0, manage_subscribers_1.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if (constants_1.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose(__assign(__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: ".concat(error),
                    wasClean: false
                }));
                subscriber.setReadyState(constants_1.ReadyState.CLOSED);
            }
        });
        if (constants_1.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
var attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = (0, socket_io_1.setUpSocketIOPing)(sendMessage);
    bindMessageHandler(webSocketInstance, url, optionsRef.current.heartbeat);
    bindCloseHandler(webSocketInstance, url);
    bindOpenHandler(webSocketInstance, url);
    bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};
exports.attachSharedListeners = attachSharedListeners;

},{"84dce7866492f036":"l5cHZ","4ed520fbcc356161":"irOOR","5e7f022a1358ff00":"JIGzW","e92ab2c3413a343a":"eP9eE","394109615c022354":"b1JCb"}],"3tYAn":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUrl = void 0;
var socket_io_1 = require("63aa923d2b6cfe17");
var constants_1 = require("28863276a4d0d05d");
var waitFor = function(duration) {
    return new Promise(function(resolve) {
        return window.setTimeout(resolve, duration);
    });
};
var getUrl = function(url, optionsRef, retriedAttempts) {
    if (retriedAttempts === void 0) retriedAttempts = 0;
    return __awaiter(void 0, void 0, void 0, function() {
        var convertedUrl, e_1, reconnectLimit, nextReconnectInterval, parsedUrl, parsedWithQueryParams;
        var _a, _b, _c;
        return __generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    if (!(typeof url === "function")) return [
                        3 /*break*/ ,
                        10
                    ];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        3,
                        ,
                        9
                    ]);
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 2:
                    convertedUrl = _d.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 3:
                    e_1 = _d.sent();
                    if (!optionsRef.current.retryOnError) return [
                        3 /*break*/ ,
                        7
                    ];
                    reconnectLimit = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_RECONNECT_LIMIT;
                    if (!(retriedAttempts < reconnectLimit)) return [
                        3 /*break*/ ,
                        5
                    ];
                    nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(retriedAttempts) : optionsRef.current.reconnectInterval;
                    return [
                        4 /*yield*/ ,
                        waitFor(nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : constants_1.DEFAULT_RECONNECT_INTERVAL_MS)
                    ];
                case 4:
                    _d.sent();
                    return [
                        2 /*return*/ ,
                        (0, exports.getUrl)(url, optionsRef, retriedAttempts + 1)
                    ];
                case 5:
                    (_c = (_b = optionsRef.current).onReconnectStop) === null || _c === void 0 || _c.call(_b, retriedAttempts);
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 9:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    convertedUrl = url;
                    _d.label = 11;
                case 11:
                    parsedUrl = optionsRef.current.fromSocketIO ? (0, socket_io_1.parseSocketIOUrl)(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? (0, socket_io_1.appendQueryParams)(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};
exports.getUrl = getUrl;

},{"63aa923d2b6cfe17":"eP9eE","28863276a4d0d05d":"irOOR"}],"cpAlB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.websocketWrapper = void 0;
var websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === "reconnect") return start;
            if (typeof val === "function") {
                console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.");
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket.");
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
exports.websocketWrapper = websocketWrapper;
exports.default = exports.websocketWrapper;

},{}],"gLnVv":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSocketIO = void 0;
var react_1 = require("f6d47a6c0f4703a1");
var use_websocket_1 = require("6ba0a83015c1f0c7");
var constants_1 = require("6b2cbfbb56f3202e");
var emptyEvent = {
    type: "empty",
    payload: null
};
var getSocketData = function(event) {
    if (!event || !event.data) return emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
var useSocketIO = function(url, options, connect) {
    if (options === void 0) options = constants_1.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = (0, react_1.useMemo)(function() {
        return __assign(__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = (0, use_websocket_1.useWebSocket)(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = (0, react_1.useMemo)(function() {
        return getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};
exports.useSocketIO = useSocketIO;

},{"f6d47a6c0f4703a1":"6uln9","6ba0a83015c1f0c7":"jDW4u","6b2cbfbb56f3202e":"irOOR"}],"8SKuN":[function(require,module,exports) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useEventSource = void 0;
var react_1 = require("1b93b1ab979e767b");
var use_websocket_1 = require("225f273a6b8bf956");
var constants_1 = require("7fd8d268d32bab6b");
var useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = constants_1.DEFAULT_EVENT_SOURCE_OPTIONS;
    var withCredentials = _a.withCredentials, events = _a.events, options = __rest(_a, [
        "withCredentials",
        "events"
    ]);
    if (connect === void 0) connect = true;
    var optionsWithEventSource = __assign(__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = (0, react_1.useRef)(constants_1.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = (0, use_websocket_1.useWebSocket)(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    (0, react_1.useEffect)(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};
exports.useEventSource = useEventSource;

},{"1b93b1ab979e767b":"6uln9","225f273a6b8bf956":"jDW4u","7fd8d268d32bab6b":"irOOR"}],"2Ywxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Error);
var _jsxRuntime = require("react/jsx-runtime");
var _solid = require("@heroicons/react/20/solid");
function Error({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "border-l-4 border-red-400 bg-red-50 p-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-shrink-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _solid.ExclamationTriangleIcon), {
                        className: "h-5 w-5 text-red-400",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ml-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-sm text-red-700",
                        children: children
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@heroicons/react/20/solid":"dg1lj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dg1lj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcademicCapIcon", ()=>(0, _academicCapIconJsDefault.default));
parcelHelpers.export(exports, "AdjustmentsHorizontalIcon", ()=>(0, _adjustmentsHorizontalIconJsDefault.default));
parcelHelpers.export(exports, "AdjustmentsVerticalIcon", ()=>(0, _adjustmentsVerticalIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxArrowDownIcon", ()=>(0, _archiveBoxArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxXMarkIcon", ()=>(0, _archiveBoxXMarkIconJsDefault.default));
parcelHelpers.export(exports, "ArchiveBoxIcon", ()=>(0, _archiveBoxIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownCircleIcon", ()=>(0, _arrowDownCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownLeftIcon", ()=>(0, _arrowDownLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownOnSquareStackIcon", ()=>(0, _arrowDownOnSquareStackIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownOnSquareIcon", ()=>(0, _arrowDownOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownRightIcon", ()=>(0, _arrowDownRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownTrayIcon", ()=>(0, _arrowDownTrayIconJsDefault.default));
parcelHelpers.export(exports, "ArrowDownIcon", ()=>(0, _arrowDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftCircleIcon", ()=>(0, _arrowLeftCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftEndOnRectangleIcon", ()=>(0, _arrowLeftEndOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftOnRectangleIcon", ()=>(0, _arrowLeftOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftStartOnRectangleIcon", ()=>(0, _arrowLeftStartOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>(0, _arrowLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongDownIcon", ()=>(0, _arrowLongDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongLeftIcon", ()=>(0, _arrowLongLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongRightIcon", ()=>(0, _arrowLongRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowLongUpIcon", ()=>(0, _arrowLongUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowPathRoundedSquareIcon", ()=>(0, _arrowPathRoundedSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowPathIcon", ()=>(0, _arrowPathIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightCircleIcon", ()=>(0, _arrowRightCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightEndOnRectangleIcon", ()=>(0, _arrowRightEndOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightOnRectangleIcon", ()=>(0, _arrowRightOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightStartOnRectangleIcon", ()=>(0, _arrowRightStartOnRectangleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowRightIcon", ()=>(0, _arrowRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallDownIcon", ()=>(0, _arrowSmallDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallLeftIcon", ()=>(0, _arrowSmallLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallRightIcon", ()=>(0, _arrowSmallRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowSmallUpIcon", ()=>(0, _arrowSmallUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTopRightOnSquareIcon", ()=>(0, _arrowTopRightOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTrendingDownIcon", ()=>(0, _arrowTrendingDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowTrendingUpIcon", ()=>(0, _arrowTrendingUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpCircleIcon", ()=>(0, _arrowUpCircleIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpLeftIcon", ()=>(0, _arrowUpLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpOnSquareStackIcon", ()=>(0, _arrowUpOnSquareStackIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpOnSquareIcon", ()=>(0, _arrowUpOnSquareIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpRightIcon", ()=>(0, _arrowUpRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpTrayIcon", ()=>(0, _arrowUpTrayIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUpIcon", ()=>(0, _arrowUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnDownIcon", ()=>(0, _arrowUturnDownIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnLeftIcon", ()=>(0, _arrowUturnLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnRightIcon", ()=>(0, _arrowUturnRightIconJsDefault.default));
parcelHelpers.export(exports, "ArrowUturnUpIcon", ()=>(0, _arrowUturnUpIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsPointingInIcon", ()=>(0, _arrowsPointingInIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsPointingOutIcon", ()=>(0, _arrowsPointingOutIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsRightLeftIcon", ()=>(0, _arrowsRightLeftIconJsDefault.default));
parcelHelpers.export(exports, "ArrowsUpDownIcon", ()=>(0, _arrowsUpDownIconJsDefault.default));
parcelHelpers.export(exports, "AtSymbolIcon", ()=>(0, _atSymbolIconJsDefault.default));
parcelHelpers.export(exports, "BackspaceIcon", ()=>(0, _backspaceIconJsDefault.default));
parcelHelpers.export(exports, "BackwardIcon", ()=>(0, _backwardIconJsDefault.default));
parcelHelpers.export(exports, "BanknotesIcon", ()=>(0, _banknotesIconJsDefault.default));
parcelHelpers.export(exports, "Bars2Icon", ()=>(0, _bars2IconJsDefault.default));
parcelHelpers.export(exports, "Bars3BottomLeftIcon", ()=>(0, _bars3BottomLeftIconJsDefault.default));
parcelHelpers.export(exports, "Bars3BottomRightIcon", ()=>(0, _bars3BottomRightIconJsDefault.default));
parcelHelpers.export(exports, "Bars3CenterLeftIcon", ()=>(0, _bars3CenterLeftIconJsDefault.default));
parcelHelpers.export(exports, "Bars3Icon", ()=>(0, _bars3IconJsDefault.default));
parcelHelpers.export(exports, "Bars4Icon", ()=>(0, _bars4IconJsDefault.default));
parcelHelpers.export(exports, "BarsArrowDownIcon", ()=>(0, _barsArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "BarsArrowUpIcon", ()=>(0, _barsArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "Battery0Icon", ()=>(0, _battery0IconJsDefault.default));
parcelHelpers.export(exports, "Battery100Icon", ()=>(0, _battery100IconJsDefault.default));
parcelHelpers.export(exports, "Battery50Icon", ()=>(0, _battery50IconJsDefault.default));
parcelHelpers.export(exports, "BeakerIcon", ()=>(0, _beakerIconJsDefault.default));
parcelHelpers.export(exports, "BellAlertIcon", ()=>(0, _bellAlertIconJsDefault.default));
parcelHelpers.export(exports, "BellSlashIcon", ()=>(0, _bellSlashIconJsDefault.default));
parcelHelpers.export(exports, "BellSnoozeIcon", ()=>(0, _bellSnoozeIconJsDefault.default));
parcelHelpers.export(exports, "BellIcon", ()=>(0, _bellIconJsDefault.default));
parcelHelpers.export(exports, "BoltSlashIcon", ()=>(0, _boltSlashIconJsDefault.default));
parcelHelpers.export(exports, "BoltIcon", ()=>(0, _boltIconJsDefault.default));
parcelHelpers.export(exports, "BookOpenIcon", ()=>(0, _bookOpenIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkSlashIcon", ()=>(0, _bookmarkSlashIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkSquareIcon", ()=>(0, _bookmarkSquareIconJsDefault.default));
parcelHelpers.export(exports, "BookmarkIcon", ()=>(0, _bookmarkIconJsDefault.default));
parcelHelpers.export(exports, "BriefcaseIcon", ()=>(0, _briefcaseIconJsDefault.default));
parcelHelpers.export(exports, "BugAntIcon", ()=>(0, _bugAntIconJsDefault.default));
parcelHelpers.export(exports, "BuildingLibraryIcon", ()=>(0, _buildingLibraryIconJsDefault.default));
parcelHelpers.export(exports, "BuildingOffice2Icon", ()=>(0, _buildingOffice2IconJsDefault.default));
parcelHelpers.export(exports, "BuildingOfficeIcon", ()=>(0, _buildingOfficeIconJsDefault.default));
parcelHelpers.export(exports, "BuildingStorefrontIcon", ()=>(0, _buildingStorefrontIconJsDefault.default));
parcelHelpers.export(exports, "CakeIcon", ()=>(0, _cakeIconJsDefault.default));
parcelHelpers.export(exports, "CalculatorIcon", ()=>(0, _calculatorIconJsDefault.default));
parcelHelpers.export(exports, "CalendarDaysIcon", ()=>(0, _calendarDaysIconJsDefault.default));
parcelHelpers.export(exports, "CalendarIcon", ()=>(0, _calendarIconJsDefault.default));
parcelHelpers.export(exports, "CameraIcon", ()=>(0, _cameraIconJsDefault.default));
parcelHelpers.export(exports, "ChartBarSquareIcon", ()=>(0, _chartBarSquareIconJsDefault.default));
parcelHelpers.export(exports, "ChartBarIcon", ()=>(0, _chartBarIconJsDefault.default));
parcelHelpers.export(exports, "ChartPieIcon", ()=>(0, _chartPieIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleBottomCenterTextIcon", ()=>(0, _chatBubbleBottomCenterTextIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleBottomCenterIcon", ()=>(0, _chatBubbleBottomCenterIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftEllipsisIcon", ()=>(0, _chatBubbleLeftEllipsisIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftRightIcon", ()=>(0, _chatBubbleLeftRightIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleLeftIcon", ()=>(0, _chatBubbleLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleOvalLeftEllipsisIcon", ()=>(0, _chatBubbleOvalLeftEllipsisIconJsDefault.default));
parcelHelpers.export(exports, "ChatBubbleOvalLeftIcon", ()=>(0, _chatBubbleOvalLeftIconJsDefault.default));
parcelHelpers.export(exports, "CheckBadgeIcon", ()=>(0, _checkBadgeIconJsDefault.default));
parcelHelpers.export(exports, "CheckCircleIcon", ()=>(0, _checkCircleIconJsDefault.default));
parcelHelpers.export(exports, "CheckIcon", ()=>(0, _checkIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleDownIcon", ()=>(0, _chevronDoubleDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleLeftIcon", ()=>(0, _chevronDoubleLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleRightIcon", ()=>(0, _chevronDoubleRightIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDoubleUpIcon", ()=>(0, _chevronDoubleUpIconJsDefault.default));
parcelHelpers.export(exports, "ChevronDownIcon", ()=>(0, _chevronDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronLeftIcon", ()=>(0, _chevronLeftIconJsDefault.default));
parcelHelpers.export(exports, "ChevronRightIcon", ()=>(0, _chevronRightIconJsDefault.default));
parcelHelpers.export(exports, "ChevronUpDownIcon", ()=>(0, _chevronUpDownIconJsDefault.default));
parcelHelpers.export(exports, "ChevronUpIcon", ()=>(0, _chevronUpIconJsDefault.default));
parcelHelpers.export(exports, "CircleStackIcon", ()=>(0, _circleStackIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentCheckIcon", ()=>(0, _clipboardDocumentCheckIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentListIcon", ()=>(0, _clipboardDocumentListIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardDocumentIcon", ()=>(0, _clipboardDocumentIconJsDefault.default));
parcelHelpers.export(exports, "ClipboardIcon", ()=>(0, _clipboardIconJsDefault.default));
parcelHelpers.export(exports, "ClockIcon", ()=>(0, _clockIconJsDefault.default));
parcelHelpers.export(exports, "CloudArrowDownIcon", ()=>(0, _cloudArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "CloudArrowUpIcon", ()=>(0, _cloudArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "CloudIcon", ()=>(0, _cloudIconJsDefault.default));
parcelHelpers.export(exports, "CodeBracketSquareIcon", ()=>(0, _codeBracketSquareIconJsDefault.default));
parcelHelpers.export(exports, "CodeBracketIcon", ()=>(0, _codeBracketIconJsDefault.default));
parcelHelpers.export(exports, "Cog6ToothIcon", ()=>(0, _cog6ToothIconJsDefault.default));
parcelHelpers.export(exports, "Cog8ToothIcon", ()=>(0, _cog8ToothIconJsDefault.default));
parcelHelpers.export(exports, "CogIcon", ()=>(0, _cogIconJsDefault.default));
parcelHelpers.export(exports, "CommandLineIcon", ()=>(0, _commandLineIconJsDefault.default));
parcelHelpers.export(exports, "ComputerDesktopIcon", ()=>(0, _computerDesktopIconJsDefault.default));
parcelHelpers.export(exports, "CpuChipIcon", ()=>(0, _cpuChipIconJsDefault.default));
parcelHelpers.export(exports, "CreditCardIcon", ()=>(0, _creditCardIconJsDefault.default));
parcelHelpers.export(exports, "CubeTransparentIcon", ()=>(0, _cubeTransparentIconJsDefault.default));
parcelHelpers.export(exports, "CubeIcon", ()=>(0, _cubeIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyBangladeshiIcon", ()=>(0, _currencyBangladeshiIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyDollarIcon", ()=>(0, _currencyDollarIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyEuroIcon", ()=>(0, _currencyEuroIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyPoundIcon", ()=>(0, _currencyPoundIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyRupeeIcon", ()=>(0, _currencyRupeeIconJsDefault.default));
parcelHelpers.export(exports, "CurrencyYenIcon", ()=>(0, _currencyYenIconJsDefault.default));
parcelHelpers.export(exports, "CursorArrowRaysIcon", ()=>(0, _cursorArrowRaysIconJsDefault.default));
parcelHelpers.export(exports, "CursorArrowRippleIcon", ()=>(0, _cursorArrowRippleIconJsDefault.default));
parcelHelpers.export(exports, "DevicePhoneMobileIcon", ()=>(0, _devicePhoneMobileIconJsDefault.default));
parcelHelpers.export(exports, "DeviceTabletIcon", ()=>(0, _deviceTabletIconJsDefault.default));
parcelHelpers.export(exports, "DocumentArrowDownIcon", ()=>(0, _documentArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "DocumentArrowUpIcon", ()=>(0, _documentArrowUpIconJsDefault.default));
parcelHelpers.export(exports, "DocumentChartBarIcon", ()=>(0, _documentChartBarIconJsDefault.default));
parcelHelpers.export(exports, "DocumentCheckIcon", ()=>(0, _documentCheckIconJsDefault.default));
parcelHelpers.export(exports, "DocumentDuplicateIcon", ()=>(0, _documentDuplicateIconJsDefault.default));
parcelHelpers.export(exports, "DocumentMagnifyingGlassIcon", ()=>(0, _documentMagnifyingGlassIconJsDefault.default));
parcelHelpers.export(exports, "DocumentMinusIcon", ()=>(0, _documentMinusIconJsDefault.default));
parcelHelpers.export(exports, "DocumentPlusIcon", ()=>(0, _documentPlusIconJsDefault.default));
parcelHelpers.export(exports, "DocumentTextIcon", ()=>(0, _documentTextIconJsDefault.default));
parcelHelpers.export(exports, "DocumentIcon", ()=>(0, _documentIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisHorizontalCircleIcon", ()=>(0, _ellipsisHorizontalCircleIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisHorizontalIcon", ()=>(0, _ellipsisHorizontalIconJsDefault.default));
parcelHelpers.export(exports, "EllipsisVerticalIcon", ()=>(0, _ellipsisVerticalIconJsDefault.default));
parcelHelpers.export(exports, "EnvelopeOpenIcon", ()=>(0, _envelopeOpenIconJsDefault.default));
parcelHelpers.export(exports, "EnvelopeIcon", ()=>(0, _envelopeIconJsDefault.default));
parcelHelpers.export(exports, "ExclamationCircleIcon", ()=>(0, _exclamationCircleIconJsDefault.default));
parcelHelpers.export(exports, "ExclamationTriangleIcon", ()=>(0, _exclamationTriangleIconJsDefault.default));
parcelHelpers.export(exports, "EyeDropperIcon", ()=>(0, _eyeDropperIconJsDefault.default));
parcelHelpers.export(exports, "EyeSlashIcon", ()=>(0, _eyeSlashIconJsDefault.default));
parcelHelpers.export(exports, "EyeIcon", ()=>(0, _eyeIconJsDefault.default));
parcelHelpers.export(exports, "FaceFrownIcon", ()=>(0, _faceFrownIconJsDefault.default));
parcelHelpers.export(exports, "FaceSmileIcon", ()=>(0, _faceSmileIconJsDefault.default));
parcelHelpers.export(exports, "FilmIcon", ()=>(0, _filmIconJsDefault.default));
parcelHelpers.export(exports, "FingerPrintIcon", ()=>(0, _fingerPrintIconJsDefault.default));
parcelHelpers.export(exports, "FireIcon", ()=>(0, _fireIconJsDefault.default));
parcelHelpers.export(exports, "FlagIcon", ()=>(0, _flagIconJsDefault.default));
parcelHelpers.export(exports, "FolderArrowDownIcon", ()=>(0, _folderArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "FolderMinusIcon", ()=>(0, _folderMinusIconJsDefault.default));
parcelHelpers.export(exports, "FolderOpenIcon", ()=>(0, _folderOpenIconJsDefault.default));
parcelHelpers.export(exports, "FolderPlusIcon", ()=>(0, _folderPlusIconJsDefault.default));
parcelHelpers.export(exports, "FolderIcon", ()=>(0, _folderIconJsDefault.default));
parcelHelpers.export(exports, "ForwardIcon", ()=>(0, _forwardIconJsDefault.default));
parcelHelpers.export(exports, "FunnelIcon", ()=>(0, _funnelIconJsDefault.default));
parcelHelpers.export(exports, "GifIcon", ()=>(0, _gifIconJsDefault.default));
parcelHelpers.export(exports, "GiftTopIcon", ()=>(0, _giftTopIconJsDefault.default));
parcelHelpers.export(exports, "GiftIcon", ()=>(0, _giftIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAltIcon", ()=>(0, _globeAltIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAmericasIcon", ()=>(0, _globeAmericasIconJsDefault.default));
parcelHelpers.export(exports, "GlobeAsiaAustraliaIcon", ()=>(0, _globeAsiaAustraliaIconJsDefault.default));
parcelHelpers.export(exports, "GlobeEuropeAfricaIcon", ()=>(0, _globeEuropeAfricaIconJsDefault.default));
parcelHelpers.export(exports, "HandRaisedIcon", ()=>(0, _handRaisedIconJsDefault.default));
parcelHelpers.export(exports, "HandThumbDownIcon", ()=>(0, _handThumbDownIconJsDefault.default));
parcelHelpers.export(exports, "HandThumbUpIcon", ()=>(0, _handThumbUpIconJsDefault.default));
parcelHelpers.export(exports, "HashtagIcon", ()=>(0, _hashtagIconJsDefault.default));
parcelHelpers.export(exports, "HeartIcon", ()=>(0, _heartIconJsDefault.default));
parcelHelpers.export(exports, "HomeModernIcon", ()=>(0, _homeModernIconJsDefault.default));
parcelHelpers.export(exports, "HomeIcon", ()=>(0, _homeIconJsDefault.default));
parcelHelpers.export(exports, "IdentificationIcon", ()=>(0, _identificationIconJsDefault.default));
parcelHelpers.export(exports, "InboxArrowDownIcon", ()=>(0, _inboxArrowDownIconJsDefault.default));
parcelHelpers.export(exports, "InboxStackIcon", ()=>(0, _inboxStackIconJsDefault.default));
parcelHelpers.export(exports, "InboxIcon", ()=>(0, _inboxIconJsDefault.default));
parcelHelpers.export(exports, "InformationCircleIcon", ()=>(0, _informationCircleIconJsDefault.default));
parcelHelpers.export(exports, "KeyIcon", ()=>(0, _keyIconJsDefault.default));
parcelHelpers.export(exports, "LanguageIcon", ()=>(0, _languageIconJsDefault.default));
parcelHelpers.export(exports, "LifebuoyIcon", ()=>(0, _lifebuoyIconJsDefault.default));
parcelHelpers.export(exports, "LightBulbIcon", ()=>(0, _lightBulbIconJsDefault.default));
parcelHelpers.export(exports, "LinkIcon", ()=>(0, _linkIconJsDefault.default));
parcelHelpers.export(exports, "ListBulletIcon", ()=>(0, _listBulletIconJsDefault.default));
parcelHelpers.export(exports, "LockClosedIcon", ()=>(0, _lockClosedIconJsDefault.default));
parcelHelpers.export(exports, "LockOpenIcon", ()=>(0, _lockOpenIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassCircleIcon", ()=>(0, _magnifyingGlassCircleIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassMinusIcon", ()=>(0, _magnifyingGlassMinusIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassPlusIcon", ()=>(0, _magnifyingGlassPlusIconJsDefault.default));
parcelHelpers.export(exports, "MagnifyingGlassIcon", ()=>(0, _magnifyingGlassIconJsDefault.default));
parcelHelpers.export(exports, "MapPinIcon", ()=>(0, _mapPinIconJsDefault.default));
parcelHelpers.export(exports, "MapIcon", ()=>(0, _mapIconJsDefault.default));
parcelHelpers.export(exports, "MegaphoneIcon", ()=>(0, _megaphoneIconJsDefault.default));
parcelHelpers.export(exports, "MicrophoneIcon", ()=>(0, _microphoneIconJsDefault.default));
parcelHelpers.export(exports, "MinusCircleIcon", ()=>(0, _minusCircleIconJsDefault.default));
parcelHelpers.export(exports, "MinusSmallIcon", ()=>(0, _minusSmallIconJsDefault.default));
parcelHelpers.export(exports, "MinusIcon", ()=>(0, _minusIconJsDefault.default));
parcelHelpers.export(exports, "MoonIcon", ()=>(0, _moonIconJsDefault.default));
parcelHelpers.export(exports, "MusicalNoteIcon", ()=>(0, _musicalNoteIconJsDefault.default));
parcelHelpers.export(exports, "NewspaperIcon", ()=>(0, _newspaperIconJsDefault.default));
parcelHelpers.export(exports, "NoSymbolIcon", ()=>(0, _noSymbolIconJsDefault.default));
parcelHelpers.export(exports, "PaintBrushIcon", ()=>(0, _paintBrushIconJsDefault.default));
parcelHelpers.export(exports, "PaperAirplaneIcon", ()=>(0, _paperAirplaneIconJsDefault.default));
parcelHelpers.export(exports, "PaperClipIcon", ()=>(0, _paperClipIconJsDefault.default));
parcelHelpers.export(exports, "PauseCircleIcon", ()=>(0, _pauseCircleIconJsDefault.default));
parcelHelpers.export(exports, "PauseIcon", ()=>(0, _pauseIconJsDefault.default));
parcelHelpers.export(exports, "PencilSquareIcon", ()=>(0, _pencilSquareIconJsDefault.default));
parcelHelpers.export(exports, "PencilIcon", ()=>(0, _pencilIconJsDefault.default));
parcelHelpers.export(exports, "PhoneArrowDownLeftIcon", ()=>(0, _phoneArrowDownLeftIconJsDefault.default));
parcelHelpers.export(exports, "PhoneArrowUpRightIcon", ()=>(0, _phoneArrowUpRightIconJsDefault.default));
parcelHelpers.export(exports, "PhoneXMarkIcon", ()=>(0, _phoneXMarkIconJsDefault.default));
parcelHelpers.export(exports, "PhoneIcon", ()=>(0, _phoneIconJsDefault.default));
parcelHelpers.export(exports, "PhotoIcon", ()=>(0, _photoIconJsDefault.default));
parcelHelpers.export(exports, "PlayCircleIcon", ()=>(0, _playCircleIconJsDefault.default));
parcelHelpers.export(exports, "PlayPauseIcon", ()=>(0, _playPauseIconJsDefault.default));
parcelHelpers.export(exports, "PlayIcon", ()=>(0, _playIconJsDefault.default));
parcelHelpers.export(exports, "PlusCircleIcon", ()=>(0, _plusCircleIconJsDefault.default));
parcelHelpers.export(exports, "PlusSmallIcon", ()=>(0, _plusSmallIconJsDefault.default));
parcelHelpers.export(exports, "PlusIcon", ()=>(0, _plusIconJsDefault.default));
parcelHelpers.export(exports, "PowerIcon", ()=>(0, _powerIconJsDefault.default));
parcelHelpers.export(exports, "PresentationChartBarIcon", ()=>(0, _presentationChartBarIconJsDefault.default));
parcelHelpers.export(exports, "PresentationChartLineIcon", ()=>(0, _presentationChartLineIconJsDefault.default));
parcelHelpers.export(exports, "PrinterIcon", ()=>(0, _printerIconJsDefault.default));
parcelHelpers.export(exports, "PuzzlePieceIcon", ()=>(0, _puzzlePieceIconJsDefault.default));
parcelHelpers.export(exports, "QrCodeIcon", ()=>(0, _qrCodeIconJsDefault.default));
parcelHelpers.export(exports, "QuestionMarkCircleIcon", ()=>(0, _questionMarkCircleIconJsDefault.default));
parcelHelpers.export(exports, "QueueListIcon", ()=>(0, _queueListIconJsDefault.default));
parcelHelpers.export(exports, "RadioIcon", ()=>(0, _radioIconJsDefault.default));
parcelHelpers.export(exports, "ReceiptPercentIcon", ()=>(0, _receiptPercentIconJsDefault.default));
parcelHelpers.export(exports, "ReceiptRefundIcon", ()=>(0, _receiptRefundIconJsDefault.default));
parcelHelpers.export(exports, "RectangleGroupIcon", ()=>(0, _rectangleGroupIconJsDefault.default));
parcelHelpers.export(exports, "RectangleStackIcon", ()=>(0, _rectangleStackIconJsDefault.default));
parcelHelpers.export(exports, "RocketLaunchIcon", ()=>(0, _rocketLaunchIconJsDefault.default));
parcelHelpers.export(exports, "RssIcon", ()=>(0, _rssIconJsDefault.default));
parcelHelpers.export(exports, "ScaleIcon", ()=>(0, _scaleIconJsDefault.default));
parcelHelpers.export(exports, "ScissorsIcon", ()=>(0, _scissorsIconJsDefault.default));
parcelHelpers.export(exports, "ServerStackIcon", ()=>(0, _serverStackIconJsDefault.default));
parcelHelpers.export(exports, "ServerIcon", ()=>(0, _serverIconJsDefault.default));
parcelHelpers.export(exports, "ShareIcon", ()=>(0, _shareIconJsDefault.default));
parcelHelpers.export(exports, "ShieldCheckIcon", ()=>(0, _shieldCheckIconJsDefault.default));
parcelHelpers.export(exports, "ShieldExclamationIcon", ()=>(0, _shieldExclamationIconJsDefault.default));
parcelHelpers.export(exports, "ShoppingBagIcon", ()=>(0, _shoppingBagIconJsDefault.default));
parcelHelpers.export(exports, "ShoppingCartIcon", ()=>(0, _shoppingCartIconJsDefault.default));
parcelHelpers.export(exports, "SignalSlashIcon", ()=>(0, _signalSlashIconJsDefault.default));
parcelHelpers.export(exports, "SignalIcon", ()=>(0, _signalIconJsDefault.default));
parcelHelpers.export(exports, "SparklesIcon", ()=>(0, _sparklesIconJsDefault.default));
parcelHelpers.export(exports, "SpeakerWaveIcon", ()=>(0, _speakerWaveIconJsDefault.default));
parcelHelpers.export(exports, "SpeakerXMarkIcon", ()=>(0, _speakerXMarkIconJsDefault.default));
parcelHelpers.export(exports, "Square2StackIcon", ()=>(0, _square2StackIconJsDefault.default));
parcelHelpers.export(exports, "Square3Stack3DIcon", ()=>(0, _square3Stack3DIconJsDefault.default));
parcelHelpers.export(exports, "Squares2X2Icon", ()=>(0, _squares2X2IconJsDefault.default));
parcelHelpers.export(exports, "SquaresPlusIcon", ()=>(0, _squaresPlusIconJsDefault.default));
parcelHelpers.export(exports, "StarIcon", ()=>(0, _starIconJsDefault.default));
parcelHelpers.export(exports, "StopCircleIcon", ()=>(0, _stopCircleIconJsDefault.default));
parcelHelpers.export(exports, "StopIcon", ()=>(0, _stopIconJsDefault.default));
parcelHelpers.export(exports, "SunIcon", ()=>(0, _sunIconJsDefault.default));
parcelHelpers.export(exports, "SwatchIcon", ()=>(0, _swatchIconJsDefault.default));
parcelHelpers.export(exports, "TableCellsIcon", ()=>(0, _tableCellsIconJsDefault.default));
parcelHelpers.export(exports, "TagIcon", ()=>(0, _tagIconJsDefault.default));
parcelHelpers.export(exports, "TicketIcon", ()=>(0, _ticketIconJsDefault.default));
parcelHelpers.export(exports, "TrashIcon", ()=>(0, _trashIconJsDefault.default));
parcelHelpers.export(exports, "TrophyIcon", ()=>(0, _trophyIconJsDefault.default));
parcelHelpers.export(exports, "TruckIcon", ()=>(0, _truckIconJsDefault.default));
parcelHelpers.export(exports, "TvIcon", ()=>(0, _tvIconJsDefault.default));
parcelHelpers.export(exports, "UserCircleIcon", ()=>(0, _userCircleIconJsDefault.default));
parcelHelpers.export(exports, "UserGroupIcon", ()=>(0, _userGroupIconJsDefault.default));
parcelHelpers.export(exports, "UserMinusIcon", ()=>(0, _userMinusIconJsDefault.default));
parcelHelpers.export(exports, "UserPlusIcon", ()=>(0, _userPlusIconJsDefault.default));
parcelHelpers.export(exports, "UserIcon", ()=>(0, _userIconJsDefault.default));
parcelHelpers.export(exports, "UsersIcon", ()=>(0, _usersIconJsDefault.default));
parcelHelpers.export(exports, "VariableIcon", ()=>(0, _variableIconJsDefault.default));
parcelHelpers.export(exports, "VideoCameraSlashIcon", ()=>(0, _videoCameraSlashIconJsDefault.default));
parcelHelpers.export(exports, "VideoCameraIcon", ()=>(0, _videoCameraIconJsDefault.default));
parcelHelpers.export(exports, "ViewColumnsIcon", ()=>(0, _viewColumnsIconJsDefault.default));
parcelHelpers.export(exports, "ViewfinderCircleIcon", ()=>(0, _viewfinderCircleIconJsDefault.default));
parcelHelpers.export(exports, "WalletIcon", ()=>(0, _walletIconJsDefault.default));
parcelHelpers.export(exports, "WifiIcon", ()=>(0, _wifiIconJsDefault.default));
parcelHelpers.export(exports, "WindowIcon", ()=>(0, _windowIconJsDefault.default));
parcelHelpers.export(exports, "WrenchScrewdriverIcon", ()=>(0, _wrenchScrewdriverIconJsDefault.default));
parcelHelpers.export(exports, "WrenchIcon", ()=>(0, _wrenchIconJsDefault.default));
parcelHelpers.export(exports, "XCircleIcon", ()=>(0, _xcircleIconJsDefault.default));
parcelHelpers.export(exports, "XMarkIcon", ()=>(0, _xmarkIconJsDefault.default));
var _academicCapIconJs = require("./AcademicCapIcon.js");
var _academicCapIconJsDefault = parcelHelpers.interopDefault(_academicCapIconJs);
var _adjustmentsHorizontalIconJs = require("./AdjustmentsHorizontalIcon.js");
var _adjustmentsHorizontalIconJsDefault = parcelHelpers.interopDefault(_adjustmentsHorizontalIconJs);
var _adjustmentsVerticalIconJs = require("./AdjustmentsVerticalIcon.js");
var _adjustmentsVerticalIconJsDefault = parcelHelpers.interopDefault(_adjustmentsVerticalIconJs);
var _archiveBoxArrowDownIconJs = require("./ArchiveBoxArrowDownIcon.js");
var _archiveBoxArrowDownIconJsDefault = parcelHelpers.interopDefault(_archiveBoxArrowDownIconJs);
var _archiveBoxXMarkIconJs = require("./ArchiveBoxXMarkIcon.js");
var _archiveBoxXMarkIconJsDefault = parcelHelpers.interopDefault(_archiveBoxXMarkIconJs);
var _archiveBoxIconJs = require("./ArchiveBoxIcon.js");
var _archiveBoxIconJsDefault = parcelHelpers.interopDefault(_archiveBoxIconJs);
var _arrowDownCircleIconJs = require("./ArrowDownCircleIcon.js");
var _arrowDownCircleIconJsDefault = parcelHelpers.interopDefault(_arrowDownCircleIconJs);
var _arrowDownLeftIconJs = require("./ArrowDownLeftIcon.js");
var _arrowDownLeftIconJsDefault = parcelHelpers.interopDefault(_arrowDownLeftIconJs);
var _arrowDownOnSquareStackIconJs = require("./ArrowDownOnSquareStackIcon.js");
var _arrowDownOnSquareStackIconJsDefault = parcelHelpers.interopDefault(_arrowDownOnSquareStackIconJs);
var _arrowDownOnSquareIconJs = require("./ArrowDownOnSquareIcon.js");
var _arrowDownOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowDownOnSquareIconJs);
var _arrowDownRightIconJs = require("./ArrowDownRightIcon.js");
var _arrowDownRightIconJsDefault = parcelHelpers.interopDefault(_arrowDownRightIconJs);
var _arrowDownTrayIconJs = require("./ArrowDownTrayIcon.js");
var _arrowDownTrayIconJsDefault = parcelHelpers.interopDefault(_arrowDownTrayIconJs);
var _arrowDownIconJs = require("./ArrowDownIcon.js");
var _arrowDownIconJsDefault = parcelHelpers.interopDefault(_arrowDownIconJs);
var _arrowLeftCircleIconJs = require("./ArrowLeftCircleIcon.js");
var _arrowLeftCircleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftCircleIconJs);
var _arrowLeftEndOnRectangleIconJs = require("./ArrowLeftEndOnRectangleIcon.js");
var _arrowLeftEndOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftEndOnRectangleIconJs);
var _arrowLeftOnRectangleIconJs = require("./ArrowLeftOnRectangleIcon.js");
var _arrowLeftOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftOnRectangleIconJs);
var _arrowLeftStartOnRectangleIconJs = require("./ArrowLeftStartOnRectangleIcon.js");
var _arrowLeftStartOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowLeftStartOnRectangleIconJs);
var _arrowLeftIconJs = require("./ArrowLeftIcon.js");
var _arrowLeftIconJsDefault = parcelHelpers.interopDefault(_arrowLeftIconJs);
var _arrowLongDownIconJs = require("./ArrowLongDownIcon.js");
var _arrowLongDownIconJsDefault = parcelHelpers.interopDefault(_arrowLongDownIconJs);
var _arrowLongLeftIconJs = require("./ArrowLongLeftIcon.js");
var _arrowLongLeftIconJsDefault = parcelHelpers.interopDefault(_arrowLongLeftIconJs);
var _arrowLongRightIconJs = require("./ArrowLongRightIcon.js");
var _arrowLongRightIconJsDefault = parcelHelpers.interopDefault(_arrowLongRightIconJs);
var _arrowLongUpIconJs = require("./ArrowLongUpIcon.js");
var _arrowLongUpIconJsDefault = parcelHelpers.interopDefault(_arrowLongUpIconJs);
var _arrowPathRoundedSquareIconJs = require("./ArrowPathRoundedSquareIcon.js");
var _arrowPathRoundedSquareIconJsDefault = parcelHelpers.interopDefault(_arrowPathRoundedSquareIconJs);
var _arrowPathIconJs = require("./ArrowPathIcon.js");
var _arrowPathIconJsDefault = parcelHelpers.interopDefault(_arrowPathIconJs);
var _arrowRightCircleIconJs = require("./ArrowRightCircleIcon.js");
var _arrowRightCircleIconJsDefault = parcelHelpers.interopDefault(_arrowRightCircleIconJs);
var _arrowRightEndOnRectangleIconJs = require("./ArrowRightEndOnRectangleIcon.js");
var _arrowRightEndOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightEndOnRectangleIconJs);
var _arrowRightOnRectangleIconJs = require("./ArrowRightOnRectangleIcon.js");
var _arrowRightOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightOnRectangleIconJs);
var _arrowRightStartOnRectangleIconJs = require("./ArrowRightStartOnRectangleIcon.js");
var _arrowRightStartOnRectangleIconJsDefault = parcelHelpers.interopDefault(_arrowRightStartOnRectangleIconJs);
var _arrowRightIconJs = require("./ArrowRightIcon.js");
var _arrowRightIconJsDefault = parcelHelpers.interopDefault(_arrowRightIconJs);
var _arrowSmallDownIconJs = require("./ArrowSmallDownIcon.js");
var _arrowSmallDownIconJsDefault = parcelHelpers.interopDefault(_arrowSmallDownIconJs);
var _arrowSmallLeftIconJs = require("./ArrowSmallLeftIcon.js");
var _arrowSmallLeftIconJsDefault = parcelHelpers.interopDefault(_arrowSmallLeftIconJs);
var _arrowSmallRightIconJs = require("./ArrowSmallRightIcon.js");
var _arrowSmallRightIconJsDefault = parcelHelpers.interopDefault(_arrowSmallRightIconJs);
var _arrowSmallUpIconJs = require("./ArrowSmallUpIcon.js");
var _arrowSmallUpIconJsDefault = parcelHelpers.interopDefault(_arrowSmallUpIconJs);
var _arrowTopRightOnSquareIconJs = require("./ArrowTopRightOnSquareIcon.js");
var _arrowTopRightOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowTopRightOnSquareIconJs);
var _arrowTrendingDownIconJs = require("./ArrowTrendingDownIcon.js");
var _arrowTrendingDownIconJsDefault = parcelHelpers.interopDefault(_arrowTrendingDownIconJs);
var _arrowTrendingUpIconJs = require("./ArrowTrendingUpIcon.js");
var _arrowTrendingUpIconJsDefault = parcelHelpers.interopDefault(_arrowTrendingUpIconJs);
var _arrowUpCircleIconJs = require("./ArrowUpCircleIcon.js");
var _arrowUpCircleIconJsDefault = parcelHelpers.interopDefault(_arrowUpCircleIconJs);
var _arrowUpLeftIconJs = require("./ArrowUpLeftIcon.js");
var _arrowUpLeftIconJsDefault = parcelHelpers.interopDefault(_arrowUpLeftIconJs);
var _arrowUpOnSquareStackIconJs = require("./ArrowUpOnSquareStackIcon.js");
var _arrowUpOnSquareStackIconJsDefault = parcelHelpers.interopDefault(_arrowUpOnSquareStackIconJs);
var _arrowUpOnSquareIconJs = require("./ArrowUpOnSquareIcon.js");
var _arrowUpOnSquareIconJsDefault = parcelHelpers.interopDefault(_arrowUpOnSquareIconJs);
var _arrowUpRightIconJs = require("./ArrowUpRightIcon.js");
var _arrowUpRightIconJsDefault = parcelHelpers.interopDefault(_arrowUpRightIconJs);
var _arrowUpTrayIconJs = require("./ArrowUpTrayIcon.js");
var _arrowUpTrayIconJsDefault = parcelHelpers.interopDefault(_arrowUpTrayIconJs);
var _arrowUpIconJs = require("./ArrowUpIcon.js");
var _arrowUpIconJsDefault = parcelHelpers.interopDefault(_arrowUpIconJs);
var _arrowUturnDownIconJs = require("./ArrowUturnDownIcon.js");
var _arrowUturnDownIconJsDefault = parcelHelpers.interopDefault(_arrowUturnDownIconJs);
var _arrowUturnLeftIconJs = require("./ArrowUturnLeftIcon.js");
var _arrowUturnLeftIconJsDefault = parcelHelpers.interopDefault(_arrowUturnLeftIconJs);
var _arrowUturnRightIconJs = require("./ArrowUturnRightIcon.js");
var _arrowUturnRightIconJsDefault = parcelHelpers.interopDefault(_arrowUturnRightIconJs);
var _arrowUturnUpIconJs = require("./ArrowUturnUpIcon.js");
var _arrowUturnUpIconJsDefault = parcelHelpers.interopDefault(_arrowUturnUpIconJs);
var _arrowsPointingInIconJs = require("./ArrowsPointingInIcon.js");
var _arrowsPointingInIconJsDefault = parcelHelpers.interopDefault(_arrowsPointingInIconJs);
var _arrowsPointingOutIconJs = require("./ArrowsPointingOutIcon.js");
var _arrowsPointingOutIconJsDefault = parcelHelpers.interopDefault(_arrowsPointingOutIconJs);
var _arrowsRightLeftIconJs = require("./ArrowsRightLeftIcon.js");
var _arrowsRightLeftIconJsDefault = parcelHelpers.interopDefault(_arrowsRightLeftIconJs);
var _arrowsUpDownIconJs = require("./ArrowsUpDownIcon.js");
var _arrowsUpDownIconJsDefault = parcelHelpers.interopDefault(_arrowsUpDownIconJs);
var _atSymbolIconJs = require("./AtSymbolIcon.js");
var _atSymbolIconJsDefault = parcelHelpers.interopDefault(_atSymbolIconJs);
var _backspaceIconJs = require("./BackspaceIcon.js");
var _backspaceIconJsDefault = parcelHelpers.interopDefault(_backspaceIconJs);
var _backwardIconJs = require("./BackwardIcon.js");
var _backwardIconJsDefault = parcelHelpers.interopDefault(_backwardIconJs);
var _banknotesIconJs = require("./BanknotesIcon.js");
var _banknotesIconJsDefault = parcelHelpers.interopDefault(_banknotesIconJs);
var _bars2IconJs = require("./Bars2Icon.js");
var _bars2IconJsDefault = parcelHelpers.interopDefault(_bars2IconJs);
var _bars3BottomLeftIconJs = require("./Bars3BottomLeftIcon.js");
var _bars3BottomLeftIconJsDefault = parcelHelpers.interopDefault(_bars3BottomLeftIconJs);
var _bars3BottomRightIconJs = require("./Bars3BottomRightIcon.js");
var _bars3BottomRightIconJsDefault = parcelHelpers.interopDefault(_bars3BottomRightIconJs);
var _bars3CenterLeftIconJs = require("./Bars3CenterLeftIcon.js");
var _bars3CenterLeftIconJsDefault = parcelHelpers.interopDefault(_bars3CenterLeftIconJs);
var _bars3IconJs = require("./Bars3Icon.js");
var _bars3IconJsDefault = parcelHelpers.interopDefault(_bars3IconJs);
var _bars4IconJs = require("./Bars4Icon.js");
var _bars4IconJsDefault = parcelHelpers.interopDefault(_bars4IconJs);
var _barsArrowDownIconJs = require("./BarsArrowDownIcon.js");
var _barsArrowDownIconJsDefault = parcelHelpers.interopDefault(_barsArrowDownIconJs);
var _barsArrowUpIconJs = require("./BarsArrowUpIcon.js");
var _barsArrowUpIconJsDefault = parcelHelpers.interopDefault(_barsArrowUpIconJs);
var _battery0IconJs = require("./Battery0Icon.js");
var _battery0IconJsDefault = parcelHelpers.interopDefault(_battery0IconJs);
var _battery100IconJs = require("./Battery100Icon.js");
var _battery100IconJsDefault = parcelHelpers.interopDefault(_battery100IconJs);
var _battery50IconJs = require("./Battery50Icon.js");
var _battery50IconJsDefault = parcelHelpers.interopDefault(_battery50IconJs);
var _beakerIconJs = require("./BeakerIcon.js");
var _beakerIconJsDefault = parcelHelpers.interopDefault(_beakerIconJs);
var _bellAlertIconJs = require("./BellAlertIcon.js");
var _bellAlertIconJsDefault = parcelHelpers.interopDefault(_bellAlertIconJs);
var _bellSlashIconJs = require("./BellSlashIcon.js");
var _bellSlashIconJsDefault = parcelHelpers.interopDefault(_bellSlashIconJs);
var _bellSnoozeIconJs = require("./BellSnoozeIcon.js");
var _bellSnoozeIconJsDefault = parcelHelpers.interopDefault(_bellSnoozeIconJs);
var _bellIconJs = require("./BellIcon.js");
var _bellIconJsDefault = parcelHelpers.interopDefault(_bellIconJs);
var _boltSlashIconJs = require("./BoltSlashIcon.js");
var _boltSlashIconJsDefault = parcelHelpers.interopDefault(_boltSlashIconJs);
var _boltIconJs = require("./BoltIcon.js");
var _boltIconJsDefault = parcelHelpers.interopDefault(_boltIconJs);
var _bookOpenIconJs = require("./BookOpenIcon.js");
var _bookOpenIconJsDefault = parcelHelpers.interopDefault(_bookOpenIconJs);
var _bookmarkSlashIconJs = require("./BookmarkSlashIcon.js");
var _bookmarkSlashIconJsDefault = parcelHelpers.interopDefault(_bookmarkSlashIconJs);
var _bookmarkSquareIconJs = require("./BookmarkSquareIcon.js");
var _bookmarkSquareIconJsDefault = parcelHelpers.interopDefault(_bookmarkSquareIconJs);
var _bookmarkIconJs = require("./BookmarkIcon.js");
var _bookmarkIconJsDefault = parcelHelpers.interopDefault(_bookmarkIconJs);
var _briefcaseIconJs = require("./BriefcaseIcon.js");
var _briefcaseIconJsDefault = parcelHelpers.interopDefault(_briefcaseIconJs);
var _bugAntIconJs = require("./BugAntIcon.js");
var _bugAntIconJsDefault = parcelHelpers.interopDefault(_bugAntIconJs);
var _buildingLibraryIconJs = require("./BuildingLibraryIcon.js");
var _buildingLibraryIconJsDefault = parcelHelpers.interopDefault(_buildingLibraryIconJs);
var _buildingOffice2IconJs = require("./BuildingOffice2Icon.js");
var _buildingOffice2IconJsDefault = parcelHelpers.interopDefault(_buildingOffice2IconJs);
var _buildingOfficeIconJs = require("./BuildingOfficeIcon.js");
var _buildingOfficeIconJsDefault = parcelHelpers.interopDefault(_buildingOfficeIconJs);
var _buildingStorefrontIconJs = require("./BuildingStorefrontIcon.js");
var _buildingStorefrontIconJsDefault = parcelHelpers.interopDefault(_buildingStorefrontIconJs);
var _cakeIconJs = require("./CakeIcon.js");
var _cakeIconJsDefault = parcelHelpers.interopDefault(_cakeIconJs);
var _calculatorIconJs = require("./CalculatorIcon.js");
var _calculatorIconJsDefault = parcelHelpers.interopDefault(_calculatorIconJs);
var _calendarDaysIconJs = require("./CalendarDaysIcon.js");
var _calendarDaysIconJsDefault = parcelHelpers.interopDefault(_calendarDaysIconJs);
var _calendarIconJs = require("./CalendarIcon.js");
var _calendarIconJsDefault = parcelHelpers.interopDefault(_calendarIconJs);
var _cameraIconJs = require("./CameraIcon.js");
var _cameraIconJsDefault = parcelHelpers.interopDefault(_cameraIconJs);
var _chartBarSquareIconJs = require("./ChartBarSquareIcon.js");
var _chartBarSquareIconJsDefault = parcelHelpers.interopDefault(_chartBarSquareIconJs);
var _chartBarIconJs = require("./ChartBarIcon.js");
var _chartBarIconJsDefault = parcelHelpers.interopDefault(_chartBarIconJs);
var _chartPieIconJs = require("./ChartPieIcon.js");
var _chartPieIconJsDefault = parcelHelpers.interopDefault(_chartPieIconJs);
var _chatBubbleBottomCenterTextIconJs = require("./ChatBubbleBottomCenterTextIcon.js");
var _chatBubbleBottomCenterTextIconJsDefault = parcelHelpers.interopDefault(_chatBubbleBottomCenterTextIconJs);
var _chatBubbleBottomCenterIconJs = require("./ChatBubbleBottomCenterIcon.js");
var _chatBubbleBottomCenterIconJsDefault = parcelHelpers.interopDefault(_chatBubbleBottomCenterIconJs);
var _chatBubbleLeftEllipsisIconJs = require("./ChatBubbleLeftEllipsisIcon.js");
var _chatBubbleLeftEllipsisIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftEllipsisIconJs);
var _chatBubbleLeftRightIconJs = require("./ChatBubbleLeftRightIcon.js");
var _chatBubbleLeftRightIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftRightIconJs);
var _chatBubbleLeftIconJs = require("./ChatBubbleLeftIcon.js");
var _chatBubbleLeftIconJsDefault = parcelHelpers.interopDefault(_chatBubbleLeftIconJs);
var _chatBubbleOvalLeftEllipsisIconJs = require("./ChatBubbleOvalLeftEllipsisIcon.js");
var _chatBubbleOvalLeftEllipsisIconJsDefault = parcelHelpers.interopDefault(_chatBubbleOvalLeftEllipsisIconJs);
var _chatBubbleOvalLeftIconJs = require("./ChatBubbleOvalLeftIcon.js");
var _chatBubbleOvalLeftIconJsDefault = parcelHelpers.interopDefault(_chatBubbleOvalLeftIconJs);
var _checkBadgeIconJs = require("./CheckBadgeIcon.js");
var _checkBadgeIconJsDefault = parcelHelpers.interopDefault(_checkBadgeIconJs);
var _checkCircleIconJs = require("./CheckCircleIcon.js");
var _checkCircleIconJsDefault = parcelHelpers.interopDefault(_checkCircleIconJs);
var _checkIconJs = require("./CheckIcon.js");
var _checkIconJsDefault = parcelHelpers.interopDefault(_checkIconJs);
var _chevronDoubleDownIconJs = require("./ChevronDoubleDownIcon.js");
var _chevronDoubleDownIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleDownIconJs);
var _chevronDoubleLeftIconJs = require("./ChevronDoubleLeftIcon.js");
var _chevronDoubleLeftIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleLeftIconJs);
var _chevronDoubleRightIconJs = require("./ChevronDoubleRightIcon.js");
var _chevronDoubleRightIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleRightIconJs);
var _chevronDoubleUpIconJs = require("./ChevronDoubleUpIcon.js");
var _chevronDoubleUpIconJsDefault = parcelHelpers.interopDefault(_chevronDoubleUpIconJs);
var _chevronDownIconJs = require("./ChevronDownIcon.js");
var _chevronDownIconJsDefault = parcelHelpers.interopDefault(_chevronDownIconJs);
var _chevronLeftIconJs = require("./ChevronLeftIcon.js");
var _chevronLeftIconJsDefault = parcelHelpers.interopDefault(_chevronLeftIconJs);
var _chevronRightIconJs = require("./ChevronRightIcon.js");
var _chevronRightIconJsDefault = parcelHelpers.interopDefault(_chevronRightIconJs);
var _chevronUpDownIconJs = require("./ChevronUpDownIcon.js");
var _chevronUpDownIconJsDefault = parcelHelpers.interopDefault(_chevronUpDownIconJs);
var _chevronUpIconJs = require("./ChevronUpIcon.js");
var _chevronUpIconJsDefault = parcelHelpers.interopDefault(_chevronUpIconJs);
var _circleStackIconJs = require("./CircleStackIcon.js");
var _circleStackIconJsDefault = parcelHelpers.interopDefault(_circleStackIconJs);
var _clipboardDocumentCheckIconJs = require("./ClipboardDocumentCheckIcon.js");
var _clipboardDocumentCheckIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentCheckIconJs);
var _clipboardDocumentListIconJs = require("./ClipboardDocumentListIcon.js");
var _clipboardDocumentListIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentListIconJs);
var _clipboardDocumentIconJs = require("./ClipboardDocumentIcon.js");
var _clipboardDocumentIconJsDefault = parcelHelpers.interopDefault(_clipboardDocumentIconJs);
var _clipboardIconJs = require("./ClipboardIcon.js");
var _clipboardIconJsDefault = parcelHelpers.interopDefault(_clipboardIconJs);
var _clockIconJs = require("./ClockIcon.js");
var _clockIconJsDefault = parcelHelpers.interopDefault(_clockIconJs);
var _cloudArrowDownIconJs = require("./CloudArrowDownIcon.js");
var _cloudArrowDownIconJsDefault = parcelHelpers.interopDefault(_cloudArrowDownIconJs);
var _cloudArrowUpIconJs = require("./CloudArrowUpIcon.js");
var _cloudArrowUpIconJsDefault = parcelHelpers.interopDefault(_cloudArrowUpIconJs);
var _cloudIconJs = require("./CloudIcon.js");
var _cloudIconJsDefault = parcelHelpers.interopDefault(_cloudIconJs);
var _codeBracketSquareIconJs = require("./CodeBracketSquareIcon.js");
var _codeBracketSquareIconJsDefault = parcelHelpers.interopDefault(_codeBracketSquareIconJs);
var _codeBracketIconJs = require("./CodeBracketIcon.js");
var _codeBracketIconJsDefault = parcelHelpers.interopDefault(_codeBracketIconJs);
var _cog6ToothIconJs = require("./Cog6ToothIcon.js");
var _cog6ToothIconJsDefault = parcelHelpers.interopDefault(_cog6ToothIconJs);
var _cog8ToothIconJs = require("./Cog8ToothIcon.js");
var _cog8ToothIconJsDefault = parcelHelpers.interopDefault(_cog8ToothIconJs);
var _cogIconJs = require("./CogIcon.js");
var _cogIconJsDefault = parcelHelpers.interopDefault(_cogIconJs);
var _commandLineIconJs = require("./CommandLineIcon.js");
var _commandLineIconJsDefault = parcelHelpers.interopDefault(_commandLineIconJs);
var _computerDesktopIconJs = require("./ComputerDesktopIcon.js");
var _computerDesktopIconJsDefault = parcelHelpers.interopDefault(_computerDesktopIconJs);
var _cpuChipIconJs = require("./CpuChipIcon.js");
var _cpuChipIconJsDefault = parcelHelpers.interopDefault(_cpuChipIconJs);
var _creditCardIconJs = require("./CreditCardIcon.js");
var _creditCardIconJsDefault = parcelHelpers.interopDefault(_creditCardIconJs);
var _cubeTransparentIconJs = require("./CubeTransparentIcon.js");
var _cubeTransparentIconJsDefault = parcelHelpers.interopDefault(_cubeTransparentIconJs);
var _cubeIconJs = require("./CubeIcon.js");
var _cubeIconJsDefault = parcelHelpers.interopDefault(_cubeIconJs);
var _currencyBangladeshiIconJs = require("./CurrencyBangladeshiIcon.js");
var _currencyBangladeshiIconJsDefault = parcelHelpers.interopDefault(_currencyBangladeshiIconJs);
var _currencyDollarIconJs = require("./CurrencyDollarIcon.js");
var _currencyDollarIconJsDefault = parcelHelpers.interopDefault(_currencyDollarIconJs);
var _currencyEuroIconJs = require("./CurrencyEuroIcon.js");
var _currencyEuroIconJsDefault = parcelHelpers.interopDefault(_currencyEuroIconJs);
var _currencyPoundIconJs = require("./CurrencyPoundIcon.js");
var _currencyPoundIconJsDefault = parcelHelpers.interopDefault(_currencyPoundIconJs);
var _currencyRupeeIconJs = require("./CurrencyRupeeIcon.js");
var _currencyRupeeIconJsDefault = parcelHelpers.interopDefault(_currencyRupeeIconJs);
var _currencyYenIconJs = require("./CurrencyYenIcon.js");
var _currencyYenIconJsDefault = parcelHelpers.interopDefault(_currencyYenIconJs);
var _cursorArrowRaysIconJs = require("./CursorArrowRaysIcon.js");
var _cursorArrowRaysIconJsDefault = parcelHelpers.interopDefault(_cursorArrowRaysIconJs);
var _cursorArrowRippleIconJs = require("./CursorArrowRippleIcon.js");
var _cursorArrowRippleIconJsDefault = parcelHelpers.interopDefault(_cursorArrowRippleIconJs);
var _devicePhoneMobileIconJs = require("./DevicePhoneMobileIcon.js");
var _devicePhoneMobileIconJsDefault = parcelHelpers.interopDefault(_devicePhoneMobileIconJs);
var _deviceTabletIconJs = require("./DeviceTabletIcon.js");
var _deviceTabletIconJsDefault = parcelHelpers.interopDefault(_deviceTabletIconJs);
var _documentArrowDownIconJs = require("./DocumentArrowDownIcon.js");
var _documentArrowDownIconJsDefault = parcelHelpers.interopDefault(_documentArrowDownIconJs);
var _documentArrowUpIconJs = require("./DocumentArrowUpIcon.js");
var _documentArrowUpIconJsDefault = parcelHelpers.interopDefault(_documentArrowUpIconJs);
var _documentChartBarIconJs = require("./DocumentChartBarIcon.js");
var _documentChartBarIconJsDefault = parcelHelpers.interopDefault(_documentChartBarIconJs);
var _documentCheckIconJs = require("./DocumentCheckIcon.js");
var _documentCheckIconJsDefault = parcelHelpers.interopDefault(_documentCheckIconJs);
var _documentDuplicateIconJs = require("./DocumentDuplicateIcon.js");
var _documentDuplicateIconJsDefault = parcelHelpers.interopDefault(_documentDuplicateIconJs);
var _documentMagnifyingGlassIconJs = require("./DocumentMagnifyingGlassIcon.js");
var _documentMagnifyingGlassIconJsDefault = parcelHelpers.interopDefault(_documentMagnifyingGlassIconJs);
var _documentMinusIconJs = require("./DocumentMinusIcon.js");
var _documentMinusIconJsDefault = parcelHelpers.interopDefault(_documentMinusIconJs);
var _documentPlusIconJs = require("./DocumentPlusIcon.js");
var _documentPlusIconJsDefault = parcelHelpers.interopDefault(_documentPlusIconJs);
var _documentTextIconJs = require("./DocumentTextIcon.js");
var _documentTextIconJsDefault = parcelHelpers.interopDefault(_documentTextIconJs);
var _documentIconJs = require("./DocumentIcon.js");
var _documentIconJsDefault = parcelHelpers.interopDefault(_documentIconJs);
var _ellipsisHorizontalCircleIconJs = require("./EllipsisHorizontalCircleIcon.js");
var _ellipsisHorizontalCircleIconJsDefault = parcelHelpers.interopDefault(_ellipsisHorizontalCircleIconJs);
var _ellipsisHorizontalIconJs = require("./EllipsisHorizontalIcon.js");
var _ellipsisHorizontalIconJsDefault = parcelHelpers.interopDefault(_ellipsisHorizontalIconJs);
var _ellipsisVerticalIconJs = require("./EllipsisVerticalIcon.js");
var _ellipsisVerticalIconJsDefault = parcelHelpers.interopDefault(_ellipsisVerticalIconJs);
var _envelopeOpenIconJs = require("./EnvelopeOpenIcon.js");
var _envelopeOpenIconJsDefault = parcelHelpers.interopDefault(_envelopeOpenIconJs);
var _envelopeIconJs = require("./EnvelopeIcon.js");
var _envelopeIconJsDefault = parcelHelpers.interopDefault(_envelopeIconJs);
var _exclamationCircleIconJs = require("./ExclamationCircleIcon.js");
var _exclamationCircleIconJsDefault = parcelHelpers.interopDefault(_exclamationCircleIconJs);
var _exclamationTriangleIconJs = require("./ExclamationTriangleIcon.js");
var _exclamationTriangleIconJsDefault = parcelHelpers.interopDefault(_exclamationTriangleIconJs);
var _eyeDropperIconJs = require("./EyeDropperIcon.js");
var _eyeDropperIconJsDefault = parcelHelpers.interopDefault(_eyeDropperIconJs);
var _eyeSlashIconJs = require("./EyeSlashIcon.js");
var _eyeSlashIconJsDefault = parcelHelpers.interopDefault(_eyeSlashIconJs);
var _eyeIconJs = require("./EyeIcon.js");
var _eyeIconJsDefault = parcelHelpers.interopDefault(_eyeIconJs);
var _faceFrownIconJs = require("./FaceFrownIcon.js");
var _faceFrownIconJsDefault = parcelHelpers.interopDefault(_faceFrownIconJs);
var _faceSmileIconJs = require("./FaceSmileIcon.js");
var _faceSmileIconJsDefault = parcelHelpers.interopDefault(_faceSmileIconJs);
var _filmIconJs = require("./FilmIcon.js");
var _filmIconJsDefault = parcelHelpers.interopDefault(_filmIconJs);
var _fingerPrintIconJs = require("./FingerPrintIcon.js");
var _fingerPrintIconJsDefault = parcelHelpers.interopDefault(_fingerPrintIconJs);
var _fireIconJs = require("./FireIcon.js");
var _fireIconJsDefault = parcelHelpers.interopDefault(_fireIconJs);
var _flagIconJs = require("./FlagIcon.js");
var _flagIconJsDefault = parcelHelpers.interopDefault(_flagIconJs);
var _folderArrowDownIconJs = require("./FolderArrowDownIcon.js");
var _folderArrowDownIconJsDefault = parcelHelpers.interopDefault(_folderArrowDownIconJs);
var _folderMinusIconJs = require("./FolderMinusIcon.js");
var _folderMinusIconJsDefault = parcelHelpers.interopDefault(_folderMinusIconJs);
var _folderOpenIconJs = require("./FolderOpenIcon.js");
var _folderOpenIconJsDefault = parcelHelpers.interopDefault(_folderOpenIconJs);
var _folderPlusIconJs = require("./FolderPlusIcon.js");
var _folderPlusIconJsDefault = parcelHelpers.interopDefault(_folderPlusIconJs);
var _folderIconJs = require("./FolderIcon.js");
var _folderIconJsDefault = parcelHelpers.interopDefault(_folderIconJs);
var _forwardIconJs = require("./ForwardIcon.js");
var _forwardIconJsDefault = parcelHelpers.interopDefault(_forwardIconJs);
var _funnelIconJs = require("./FunnelIcon.js");
var _funnelIconJsDefault = parcelHelpers.interopDefault(_funnelIconJs);
var _gifIconJs = require("./GifIcon.js");
var _gifIconJsDefault = parcelHelpers.interopDefault(_gifIconJs);
var _giftTopIconJs = require("./GiftTopIcon.js");
var _giftTopIconJsDefault = parcelHelpers.interopDefault(_giftTopIconJs);
var _giftIconJs = require("./GiftIcon.js");
var _giftIconJsDefault = parcelHelpers.interopDefault(_giftIconJs);
var _globeAltIconJs = require("./GlobeAltIcon.js");
var _globeAltIconJsDefault = parcelHelpers.interopDefault(_globeAltIconJs);
var _globeAmericasIconJs = require("./GlobeAmericasIcon.js");
var _globeAmericasIconJsDefault = parcelHelpers.interopDefault(_globeAmericasIconJs);
var _globeAsiaAustraliaIconJs = require("./GlobeAsiaAustraliaIcon.js");
var _globeAsiaAustraliaIconJsDefault = parcelHelpers.interopDefault(_globeAsiaAustraliaIconJs);
var _globeEuropeAfricaIconJs = require("./GlobeEuropeAfricaIcon.js");
var _globeEuropeAfricaIconJsDefault = parcelHelpers.interopDefault(_globeEuropeAfricaIconJs);
var _handRaisedIconJs = require("./HandRaisedIcon.js");
var _handRaisedIconJsDefault = parcelHelpers.interopDefault(_handRaisedIconJs);
var _handThumbDownIconJs = require("./HandThumbDownIcon.js");
var _handThumbDownIconJsDefault = parcelHelpers.interopDefault(_handThumbDownIconJs);
var _handThumbUpIconJs = require("./HandThumbUpIcon.js");
var _handThumbUpIconJsDefault = parcelHelpers.interopDefault(_handThumbUpIconJs);
var _hashtagIconJs = require("./HashtagIcon.js");
var _hashtagIconJsDefault = parcelHelpers.interopDefault(_hashtagIconJs);
var _heartIconJs = require("./HeartIcon.js");
var _heartIconJsDefault = parcelHelpers.interopDefault(_heartIconJs);
var _homeModernIconJs = require("./HomeModernIcon.js");
var _homeModernIconJsDefault = parcelHelpers.interopDefault(_homeModernIconJs);
var _homeIconJs = require("./HomeIcon.js");
var _homeIconJsDefault = parcelHelpers.interopDefault(_homeIconJs);
var _identificationIconJs = require("./IdentificationIcon.js");
var _identificationIconJsDefault = parcelHelpers.interopDefault(_identificationIconJs);
var _inboxArrowDownIconJs = require("./InboxArrowDownIcon.js");
var _inboxArrowDownIconJsDefault = parcelHelpers.interopDefault(_inboxArrowDownIconJs);
var _inboxStackIconJs = require("./InboxStackIcon.js");
var _inboxStackIconJsDefault = parcelHelpers.interopDefault(_inboxStackIconJs);
var _inboxIconJs = require("./InboxIcon.js");
var _inboxIconJsDefault = parcelHelpers.interopDefault(_inboxIconJs);
var _informationCircleIconJs = require("./InformationCircleIcon.js");
var _informationCircleIconJsDefault = parcelHelpers.interopDefault(_informationCircleIconJs);
var _keyIconJs = require("./KeyIcon.js");
var _keyIconJsDefault = parcelHelpers.interopDefault(_keyIconJs);
var _languageIconJs = require("./LanguageIcon.js");
var _languageIconJsDefault = parcelHelpers.interopDefault(_languageIconJs);
var _lifebuoyIconJs = require("./LifebuoyIcon.js");
var _lifebuoyIconJsDefault = parcelHelpers.interopDefault(_lifebuoyIconJs);
var _lightBulbIconJs = require("./LightBulbIcon.js");
var _lightBulbIconJsDefault = parcelHelpers.interopDefault(_lightBulbIconJs);
var _linkIconJs = require("./LinkIcon.js");
var _linkIconJsDefault = parcelHelpers.interopDefault(_linkIconJs);
var _listBulletIconJs = require("./ListBulletIcon.js");
var _listBulletIconJsDefault = parcelHelpers.interopDefault(_listBulletIconJs);
var _lockClosedIconJs = require("./LockClosedIcon.js");
var _lockClosedIconJsDefault = parcelHelpers.interopDefault(_lockClosedIconJs);
var _lockOpenIconJs = require("./LockOpenIcon.js");
var _lockOpenIconJsDefault = parcelHelpers.interopDefault(_lockOpenIconJs);
var _magnifyingGlassCircleIconJs = require("./MagnifyingGlassCircleIcon.js");
var _magnifyingGlassCircleIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassCircleIconJs);
var _magnifyingGlassMinusIconJs = require("./MagnifyingGlassMinusIcon.js");
var _magnifyingGlassMinusIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassMinusIconJs);
var _magnifyingGlassPlusIconJs = require("./MagnifyingGlassPlusIcon.js");
var _magnifyingGlassPlusIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassPlusIconJs);
var _magnifyingGlassIconJs = require("./MagnifyingGlassIcon.js");
var _magnifyingGlassIconJsDefault = parcelHelpers.interopDefault(_magnifyingGlassIconJs);
var _mapPinIconJs = require("./MapPinIcon.js");
var _mapPinIconJsDefault = parcelHelpers.interopDefault(_mapPinIconJs);
var _mapIconJs = require("./MapIcon.js");
var _mapIconJsDefault = parcelHelpers.interopDefault(_mapIconJs);
var _megaphoneIconJs = require("./MegaphoneIcon.js");
var _megaphoneIconJsDefault = parcelHelpers.interopDefault(_megaphoneIconJs);
var _microphoneIconJs = require("./MicrophoneIcon.js");
var _microphoneIconJsDefault = parcelHelpers.interopDefault(_microphoneIconJs);
var _minusCircleIconJs = require("./MinusCircleIcon.js");
var _minusCircleIconJsDefault = parcelHelpers.interopDefault(_minusCircleIconJs);
var _minusSmallIconJs = require("./MinusSmallIcon.js");
var _minusSmallIconJsDefault = parcelHelpers.interopDefault(_minusSmallIconJs);
var _minusIconJs = require("./MinusIcon.js");
var _minusIconJsDefault = parcelHelpers.interopDefault(_minusIconJs);
var _moonIconJs = require("./MoonIcon.js");
var _moonIconJsDefault = parcelHelpers.interopDefault(_moonIconJs);
var _musicalNoteIconJs = require("./MusicalNoteIcon.js");
var _musicalNoteIconJsDefault = parcelHelpers.interopDefault(_musicalNoteIconJs);
var _newspaperIconJs = require("./NewspaperIcon.js");
var _newspaperIconJsDefault = parcelHelpers.interopDefault(_newspaperIconJs);
var _noSymbolIconJs = require("./NoSymbolIcon.js");
var _noSymbolIconJsDefault = parcelHelpers.interopDefault(_noSymbolIconJs);
var _paintBrushIconJs = require("./PaintBrushIcon.js");
var _paintBrushIconJsDefault = parcelHelpers.interopDefault(_paintBrushIconJs);
var _paperAirplaneIconJs = require("./PaperAirplaneIcon.js");
var _paperAirplaneIconJsDefault = parcelHelpers.interopDefault(_paperAirplaneIconJs);
var _paperClipIconJs = require("./PaperClipIcon.js");
var _paperClipIconJsDefault = parcelHelpers.interopDefault(_paperClipIconJs);
var _pauseCircleIconJs = require("./PauseCircleIcon.js");
var _pauseCircleIconJsDefault = parcelHelpers.interopDefault(_pauseCircleIconJs);
var _pauseIconJs = require("./PauseIcon.js");
var _pauseIconJsDefault = parcelHelpers.interopDefault(_pauseIconJs);
var _pencilSquareIconJs = require("./PencilSquareIcon.js");
var _pencilSquareIconJsDefault = parcelHelpers.interopDefault(_pencilSquareIconJs);
var _pencilIconJs = require("./PencilIcon.js");
var _pencilIconJsDefault = parcelHelpers.interopDefault(_pencilIconJs);
var _phoneArrowDownLeftIconJs = require("./PhoneArrowDownLeftIcon.js");
var _phoneArrowDownLeftIconJsDefault = parcelHelpers.interopDefault(_phoneArrowDownLeftIconJs);
var _phoneArrowUpRightIconJs = require("./PhoneArrowUpRightIcon.js");
var _phoneArrowUpRightIconJsDefault = parcelHelpers.interopDefault(_phoneArrowUpRightIconJs);
var _phoneXMarkIconJs = require("./PhoneXMarkIcon.js");
var _phoneXMarkIconJsDefault = parcelHelpers.interopDefault(_phoneXMarkIconJs);
var _phoneIconJs = require("./PhoneIcon.js");
var _phoneIconJsDefault = parcelHelpers.interopDefault(_phoneIconJs);
var _photoIconJs = require("./PhotoIcon.js");
var _photoIconJsDefault = parcelHelpers.interopDefault(_photoIconJs);
var _playCircleIconJs = require("./PlayCircleIcon.js");
var _playCircleIconJsDefault = parcelHelpers.interopDefault(_playCircleIconJs);
var _playPauseIconJs = require("./PlayPauseIcon.js");
var _playPauseIconJsDefault = parcelHelpers.interopDefault(_playPauseIconJs);
var _playIconJs = require("./PlayIcon.js");
var _playIconJsDefault = parcelHelpers.interopDefault(_playIconJs);
var _plusCircleIconJs = require("./PlusCircleIcon.js");
var _plusCircleIconJsDefault = parcelHelpers.interopDefault(_plusCircleIconJs);
var _plusSmallIconJs = require("./PlusSmallIcon.js");
var _plusSmallIconJsDefault = parcelHelpers.interopDefault(_plusSmallIconJs);
var _plusIconJs = require("./PlusIcon.js");
var _plusIconJsDefault = parcelHelpers.interopDefault(_plusIconJs);
var _powerIconJs = require("./PowerIcon.js");
var _powerIconJsDefault = parcelHelpers.interopDefault(_powerIconJs);
var _presentationChartBarIconJs = require("./PresentationChartBarIcon.js");
var _presentationChartBarIconJsDefault = parcelHelpers.interopDefault(_presentationChartBarIconJs);
var _presentationChartLineIconJs = require("./PresentationChartLineIcon.js");
var _presentationChartLineIconJsDefault = parcelHelpers.interopDefault(_presentationChartLineIconJs);
var _printerIconJs = require("./PrinterIcon.js");
var _printerIconJsDefault = parcelHelpers.interopDefault(_printerIconJs);
var _puzzlePieceIconJs = require("./PuzzlePieceIcon.js");
var _puzzlePieceIconJsDefault = parcelHelpers.interopDefault(_puzzlePieceIconJs);
var _qrCodeIconJs = require("./QrCodeIcon.js");
var _qrCodeIconJsDefault = parcelHelpers.interopDefault(_qrCodeIconJs);
var _questionMarkCircleIconJs = require("./QuestionMarkCircleIcon.js");
var _questionMarkCircleIconJsDefault = parcelHelpers.interopDefault(_questionMarkCircleIconJs);
var _queueListIconJs = require("./QueueListIcon.js");
var _queueListIconJsDefault = parcelHelpers.interopDefault(_queueListIconJs);
var _radioIconJs = require("./RadioIcon.js");
var _radioIconJsDefault = parcelHelpers.interopDefault(_radioIconJs);
var _receiptPercentIconJs = require("./ReceiptPercentIcon.js");
var _receiptPercentIconJsDefault = parcelHelpers.interopDefault(_receiptPercentIconJs);
var _receiptRefundIconJs = require("./ReceiptRefundIcon.js");
var _receiptRefundIconJsDefault = parcelHelpers.interopDefault(_receiptRefundIconJs);
var _rectangleGroupIconJs = require("./RectangleGroupIcon.js");
var _rectangleGroupIconJsDefault = parcelHelpers.interopDefault(_rectangleGroupIconJs);
var _rectangleStackIconJs = require("./RectangleStackIcon.js");
var _rectangleStackIconJsDefault = parcelHelpers.interopDefault(_rectangleStackIconJs);
var _rocketLaunchIconJs = require("./RocketLaunchIcon.js");
var _rocketLaunchIconJsDefault = parcelHelpers.interopDefault(_rocketLaunchIconJs);
var _rssIconJs = require("./RssIcon.js");
var _rssIconJsDefault = parcelHelpers.interopDefault(_rssIconJs);
var _scaleIconJs = require("./ScaleIcon.js");
var _scaleIconJsDefault = parcelHelpers.interopDefault(_scaleIconJs);
var _scissorsIconJs = require("./ScissorsIcon.js");
var _scissorsIconJsDefault = parcelHelpers.interopDefault(_scissorsIconJs);
var _serverStackIconJs = require("./ServerStackIcon.js");
var _serverStackIconJsDefault = parcelHelpers.interopDefault(_serverStackIconJs);
var _serverIconJs = require("./ServerIcon.js");
var _serverIconJsDefault = parcelHelpers.interopDefault(_serverIconJs);
var _shareIconJs = require("./ShareIcon.js");
var _shareIconJsDefault = parcelHelpers.interopDefault(_shareIconJs);
var _shieldCheckIconJs = require("./ShieldCheckIcon.js");
var _shieldCheckIconJsDefault = parcelHelpers.interopDefault(_shieldCheckIconJs);
var _shieldExclamationIconJs = require("./ShieldExclamationIcon.js");
var _shieldExclamationIconJsDefault = parcelHelpers.interopDefault(_shieldExclamationIconJs);
var _shoppingBagIconJs = require("./ShoppingBagIcon.js");
var _shoppingBagIconJsDefault = parcelHelpers.interopDefault(_shoppingBagIconJs);
var _shoppingCartIconJs = require("./ShoppingCartIcon.js");
var _shoppingCartIconJsDefault = parcelHelpers.interopDefault(_shoppingCartIconJs);
var _signalSlashIconJs = require("./SignalSlashIcon.js");
var _signalSlashIconJsDefault = parcelHelpers.interopDefault(_signalSlashIconJs);
var _signalIconJs = require("./SignalIcon.js");
var _signalIconJsDefault = parcelHelpers.interopDefault(_signalIconJs);
var _sparklesIconJs = require("./SparklesIcon.js");
var _sparklesIconJsDefault = parcelHelpers.interopDefault(_sparklesIconJs);
var _speakerWaveIconJs = require("./SpeakerWaveIcon.js");
var _speakerWaveIconJsDefault = parcelHelpers.interopDefault(_speakerWaveIconJs);
var _speakerXMarkIconJs = require("./SpeakerXMarkIcon.js");
var _speakerXMarkIconJsDefault = parcelHelpers.interopDefault(_speakerXMarkIconJs);
var _square2StackIconJs = require("./Square2StackIcon.js");
var _square2StackIconJsDefault = parcelHelpers.interopDefault(_square2StackIconJs);
var _square3Stack3DIconJs = require("./Square3Stack3DIcon.js");
var _square3Stack3DIconJsDefault = parcelHelpers.interopDefault(_square3Stack3DIconJs);
var _squares2X2IconJs = require("./Squares2X2Icon.js");
var _squares2X2IconJsDefault = parcelHelpers.interopDefault(_squares2X2IconJs);
var _squaresPlusIconJs = require("./SquaresPlusIcon.js");
var _squaresPlusIconJsDefault = parcelHelpers.interopDefault(_squaresPlusIconJs);
var _starIconJs = require("./StarIcon.js");
var _starIconJsDefault = parcelHelpers.interopDefault(_starIconJs);
var _stopCircleIconJs = require("./StopCircleIcon.js");
var _stopCircleIconJsDefault = parcelHelpers.interopDefault(_stopCircleIconJs);
var _stopIconJs = require("./StopIcon.js");
var _stopIconJsDefault = parcelHelpers.interopDefault(_stopIconJs);
var _sunIconJs = require("./SunIcon.js");
var _sunIconJsDefault = parcelHelpers.interopDefault(_sunIconJs);
var _swatchIconJs = require("./SwatchIcon.js");
var _swatchIconJsDefault = parcelHelpers.interopDefault(_swatchIconJs);
var _tableCellsIconJs = require("./TableCellsIcon.js");
var _tableCellsIconJsDefault = parcelHelpers.interopDefault(_tableCellsIconJs);
var _tagIconJs = require("./TagIcon.js");
var _tagIconJsDefault = parcelHelpers.interopDefault(_tagIconJs);
var _ticketIconJs = require("./TicketIcon.js");
var _ticketIconJsDefault = parcelHelpers.interopDefault(_ticketIconJs);
var _trashIconJs = require("./TrashIcon.js");
var _trashIconJsDefault = parcelHelpers.interopDefault(_trashIconJs);
var _trophyIconJs = require("./TrophyIcon.js");
var _trophyIconJsDefault = parcelHelpers.interopDefault(_trophyIconJs);
var _truckIconJs = require("./TruckIcon.js");
var _truckIconJsDefault = parcelHelpers.interopDefault(_truckIconJs);
var _tvIconJs = require("./TvIcon.js");
var _tvIconJsDefault = parcelHelpers.interopDefault(_tvIconJs);
var _userCircleIconJs = require("./UserCircleIcon.js");
var _userCircleIconJsDefault = parcelHelpers.interopDefault(_userCircleIconJs);
var _userGroupIconJs = require("./UserGroupIcon.js");
var _userGroupIconJsDefault = parcelHelpers.interopDefault(_userGroupIconJs);
var _userMinusIconJs = require("./UserMinusIcon.js");
var _userMinusIconJsDefault = parcelHelpers.interopDefault(_userMinusIconJs);
var _userPlusIconJs = require("./UserPlusIcon.js");
var _userPlusIconJsDefault = parcelHelpers.interopDefault(_userPlusIconJs);
var _userIconJs = require("./UserIcon.js");
var _userIconJsDefault = parcelHelpers.interopDefault(_userIconJs);
var _usersIconJs = require("./UsersIcon.js");
var _usersIconJsDefault = parcelHelpers.interopDefault(_usersIconJs);
var _variableIconJs = require("./VariableIcon.js");
var _variableIconJsDefault = parcelHelpers.interopDefault(_variableIconJs);
var _videoCameraSlashIconJs = require("./VideoCameraSlashIcon.js");
var _videoCameraSlashIconJsDefault = parcelHelpers.interopDefault(_videoCameraSlashIconJs);
var _videoCameraIconJs = require("./VideoCameraIcon.js");
var _videoCameraIconJsDefault = parcelHelpers.interopDefault(_videoCameraIconJs);
var _viewColumnsIconJs = require("./ViewColumnsIcon.js");
var _viewColumnsIconJsDefault = parcelHelpers.interopDefault(_viewColumnsIconJs);
var _viewfinderCircleIconJs = require("./ViewfinderCircleIcon.js");
var _viewfinderCircleIconJsDefault = parcelHelpers.interopDefault(_viewfinderCircleIconJs);
var _walletIconJs = require("./WalletIcon.js");
var _walletIconJsDefault = parcelHelpers.interopDefault(_walletIconJs);
var _wifiIconJs = require("./WifiIcon.js");
var _wifiIconJsDefault = parcelHelpers.interopDefault(_wifiIconJs);
var _windowIconJs = require("./WindowIcon.js");
var _windowIconJsDefault = parcelHelpers.interopDefault(_windowIconJs);
var _wrenchScrewdriverIconJs = require("./WrenchScrewdriverIcon.js");
var _wrenchScrewdriverIconJsDefault = parcelHelpers.interopDefault(_wrenchScrewdriverIconJs);
var _wrenchIconJs = require("./WrenchIcon.js");
var _wrenchIconJsDefault = parcelHelpers.interopDefault(_wrenchIconJs);
var _xcircleIconJs = require("./XCircleIcon.js");
var _xcircleIconJsDefault = parcelHelpers.interopDefault(_xcircleIconJs);
var _xmarkIconJs = require("./XMarkIcon.js");
var _xmarkIconJsDefault = parcelHelpers.interopDefault(_xmarkIconJs);

},{"./AcademicCapIcon.js":false,"./AdjustmentsHorizontalIcon.js":false,"./AdjustmentsVerticalIcon.js":false,"./ArchiveBoxArrowDownIcon.js":false,"./ArchiveBoxXMarkIcon.js":false,"./ArchiveBoxIcon.js":false,"./ArrowDownCircleIcon.js":false,"./ArrowDownLeftIcon.js":false,"./ArrowDownOnSquareStackIcon.js":false,"./ArrowDownOnSquareIcon.js":false,"./ArrowDownRightIcon.js":false,"./ArrowDownTrayIcon.js":false,"./ArrowDownIcon.js":false,"./ArrowLeftCircleIcon.js":false,"./ArrowLeftEndOnRectangleIcon.js":false,"./ArrowLeftOnRectangleIcon.js":false,"./ArrowLeftStartOnRectangleIcon.js":false,"./ArrowLeftIcon.js":false,"./ArrowLongDownIcon.js":false,"./ArrowLongLeftIcon.js":false,"./ArrowLongRightIcon.js":false,"./ArrowLongUpIcon.js":false,"./ArrowPathRoundedSquareIcon.js":false,"./ArrowPathIcon.js":false,"./ArrowRightCircleIcon.js":false,"./ArrowRightEndOnRectangleIcon.js":false,"./ArrowRightOnRectangleIcon.js":false,"./ArrowRightStartOnRectangleIcon.js":false,"./ArrowRightIcon.js":false,"./ArrowSmallDownIcon.js":false,"./ArrowSmallLeftIcon.js":false,"./ArrowSmallRightIcon.js":false,"./ArrowSmallUpIcon.js":false,"./ArrowTopRightOnSquareIcon.js":false,"./ArrowTrendingDownIcon.js":false,"./ArrowTrendingUpIcon.js":false,"./ArrowUpCircleIcon.js":false,"./ArrowUpLeftIcon.js":false,"./ArrowUpOnSquareStackIcon.js":false,"./ArrowUpOnSquareIcon.js":false,"./ArrowUpRightIcon.js":false,"./ArrowUpTrayIcon.js":false,"./ArrowUpIcon.js":false,"./ArrowUturnDownIcon.js":false,"./ArrowUturnLeftIcon.js":false,"./ArrowUturnRightIcon.js":false,"./ArrowUturnUpIcon.js":false,"./ArrowsPointingInIcon.js":false,"./ArrowsPointingOutIcon.js":false,"./ArrowsRightLeftIcon.js":false,"./ArrowsUpDownIcon.js":false,"./AtSymbolIcon.js":false,"./BackspaceIcon.js":false,"./BackwardIcon.js":false,"./BanknotesIcon.js":false,"./Bars2Icon.js":false,"./Bars3BottomLeftIcon.js":false,"./Bars3BottomRightIcon.js":false,"./Bars3CenterLeftIcon.js":false,"./Bars3Icon.js":false,"./Bars4Icon.js":false,"./BarsArrowDownIcon.js":false,"./BarsArrowUpIcon.js":false,"./Battery0Icon.js":false,"./Battery100Icon.js":false,"./Battery50Icon.js":false,"./BeakerIcon.js":false,"./BellAlertIcon.js":false,"./BellSlashIcon.js":false,"./BellSnoozeIcon.js":false,"./BellIcon.js":false,"./BoltSlashIcon.js":false,"./BoltIcon.js":false,"./BookOpenIcon.js":false,"./BookmarkSlashIcon.js":false,"./BookmarkSquareIcon.js":false,"./BookmarkIcon.js":false,"./BriefcaseIcon.js":false,"./BugAntIcon.js":false,"./BuildingLibraryIcon.js":false,"./BuildingOffice2Icon.js":false,"./BuildingOfficeIcon.js":false,"./BuildingStorefrontIcon.js":false,"./CakeIcon.js":false,"./CalculatorIcon.js":false,"./CalendarDaysIcon.js":false,"./CalendarIcon.js":false,"./CameraIcon.js":false,"./ChartBarSquareIcon.js":false,"./ChartBarIcon.js":false,"./ChartPieIcon.js":false,"./ChatBubbleBottomCenterTextIcon.js":false,"./ChatBubbleBottomCenterIcon.js":false,"./ChatBubbleLeftEllipsisIcon.js":false,"./ChatBubbleLeftRightIcon.js":false,"./ChatBubbleLeftIcon.js":false,"./ChatBubbleOvalLeftEllipsisIcon.js":false,"./ChatBubbleOvalLeftIcon.js":false,"./CheckBadgeIcon.js":false,"./CheckCircleIcon.js":false,"./CheckIcon.js":false,"./ChevronDoubleDownIcon.js":false,"./ChevronDoubleLeftIcon.js":false,"./ChevronDoubleRightIcon.js":false,"./ChevronDoubleUpIcon.js":false,"./ChevronDownIcon.js":false,"./ChevronLeftIcon.js":false,"./ChevronRightIcon.js":false,"./ChevronUpDownIcon.js":false,"./ChevronUpIcon.js":false,"./CircleStackIcon.js":false,"./ClipboardDocumentCheckIcon.js":false,"./ClipboardDocumentListIcon.js":false,"./ClipboardDocumentIcon.js":false,"./ClipboardIcon.js":false,"./ClockIcon.js":false,"./CloudArrowDownIcon.js":false,"./CloudArrowUpIcon.js":false,"./CloudIcon.js":false,"./CodeBracketSquareIcon.js":false,"./CodeBracketIcon.js":false,"./Cog6ToothIcon.js":false,"./Cog8ToothIcon.js":false,"./CogIcon.js":false,"./CommandLineIcon.js":false,"./ComputerDesktopIcon.js":false,"./CpuChipIcon.js":false,"./CreditCardIcon.js":false,"./CubeTransparentIcon.js":false,"./CubeIcon.js":false,"./CurrencyBangladeshiIcon.js":false,"./CurrencyDollarIcon.js":false,"./CurrencyEuroIcon.js":false,"./CurrencyPoundIcon.js":false,"./CurrencyRupeeIcon.js":false,"./CurrencyYenIcon.js":false,"./CursorArrowRaysIcon.js":false,"./CursorArrowRippleIcon.js":false,"./DevicePhoneMobileIcon.js":false,"./DeviceTabletIcon.js":false,"./DocumentArrowDownIcon.js":false,"./DocumentArrowUpIcon.js":false,"./DocumentChartBarIcon.js":false,"./DocumentCheckIcon.js":false,"./DocumentDuplicateIcon.js":false,"./DocumentMagnifyingGlassIcon.js":false,"./DocumentMinusIcon.js":false,"./DocumentPlusIcon.js":false,"./DocumentTextIcon.js":false,"./DocumentIcon.js":false,"./EllipsisHorizontalCircleIcon.js":false,"./EllipsisHorizontalIcon.js":false,"./EllipsisVerticalIcon.js":false,"./EnvelopeOpenIcon.js":false,"./EnvelopeIcon.js":false,"./ExclamationCircleIcon.js":false,"./ExclamationTriangleIcon.js":"gcSIT","./EyeDropperIcon.js":false,"./EyeSlashIcon.js":false,"./EyeIcon.js":false,"./FaceFrownIcon.js":false,"./FaceSmileIcon.js":false,"./FilmIcon.js":false,"./FingerPrintIcon.js":false,"./FireIcon.js":false,"./FlagIcon.js":false,"./FolderArrowDownIcon.js":false,"./FolderMinusIcon.js":false,"./FolderOpenIcon.js":false,"./FolderPlusIcon.js":false,"./FolderIcon.js":false,"./ForwardIcon.js":false,"./FunnelIcon.js":false,"./GifIcon.js":false,"./GiftTopIcon.js":false,"./GiftIcon.js":false,"./GlobeAltIcon.js":false,"./GlobeAmericasIcon.js":false,"./GlobeAsiaAustraliaIcon.js":false,"./GlobeEuropeAfricaIcon.js":false,"./HandRaisedIcon.js":false,"./HandThumbDownIcon.js":false,"./HandThumbUpIcon.js":false,"./HashtagIcon.js":false,"./HeartIcon.js":false,"./HomeModernIcon.js":false,"./HomeIcon.js":false,"./IdentificationIcon.js":false,"./InboxArrowDownIcon.js":false,"./InboxStackIcon.js":false,"./InboxIcon.js":false,"./InformationCircleIcon.js":false,"./KeyIcon.js":false,"./LanguageIcon.js":false,"./LifebuoyIcon.js":false,"./LightBulbIcon.js":false,"./LinkIcon.js":false,"./ListBulletIcon.js":false,"./LockClosedIcon.js":false,"./LockOpenIcon.js":false,"./MagnifyingGlassCircleIcon.js":false,"./MagnifyingGlassMinusIcon.js":false,"./MagnifyingGlassPlusIcon.js":false,"./MagnifyingGlassIcon.js":false,"./MapPinIcon.js":false,"./MapIcon.js":false,"./MegaphoneIcon.js":false,"./MicrophoneIcon.js":false,"./MinusCircleIcon.js":false,"./MinusSmallIcon.js":false,"./MinusIcon.js":false,"./MoonIcon.js":false,"./MusicalNoteIcon.js":false,"./NewspaperIcon.js":false,"./NoSymbolIcon.js":false,"./PaintBrushIcon.js":false,"./PaperAirplaneIcon.js":false,"./PaperClipIcon.js":false,"./PauseCircleIcon.js":false,"./PauseIcon.js":false,"./PencilSquareIcon.js":false,"./PencilIcon.js":false,"./PhoneArrowDownLeftIcon.js":false,"./PhoneArrowUpRightIcon.js":false,"./PhoneXMarkIcon.js":false,"./PhoneIcon.js":false,"./PhotoIcon.js":false,"./PlayCircleIcon.js":false,"./PlayPauseIcon.js":false,"./PlayIcon.js":false,"./PlusCircleIcon.js":false,"./PlusSmallIcon.js":false,"./PlusIcon.js":false,"./PowerIcon.js":false,"./PresentationChartBarIcon.js":false,"./PresentationChartLineIcon.js":false,"./PrinterIcon.js":false,"./PuzzlePieceIcon.js":false,"./QrCodeIcon.js":false,"./QuestionMarkCircleIcon.js":false,"./QueueListIcon.js":false,"./RadioIcon.js":false,"./ReceiptPercentIcon.js":false,"./ReceiptRefundIcon.js":false,"./RectangleGroupIcon.js":false,"./RectangleStackIcon.js":false,"./RocketLaunchIcon.js":false,"./RssIcon.js":false,"./ScaleIcon.js":false,"./ScissorsIcon.js":false,"./ServerStackIcon.js":false,"./ServerIcon.js":false,"./ShareIcon.js":false,"./ShieldCheckIcon.js":false,"./ShieldExclamationIcon.js":false,"./ShoppingBagIcon.js":false,"./ShoppingCartIcon.js":false,"./SignalSlashIcon.js":false,"./SignalIcon.js":false,"./SparklesIcon.js":false,"./SpeakerWaveIcon.js":false,"./SpeakerXMarkIcon.js":false,"./Square2StackIcon.js":false,"./Square3Stack3DIcon.js":false,"./Squares2X2Icon.js":false,"./SquaresPlusIcon.js":false,"./StarIcon.js":false,"./StopCircleIcon.js":false,"./StopIcon.js":false,"./SunIcon.js":false,"./SwatchIcon.js":false,"./TableCellsIcon.js":false,"./TagIcon.js":false,"./TicketIcon.js":false,"./TrashIcon.js":false,"./TrophyIcon.js":false,"./TruckIcon.js":false,"./TvIcon.js":false,"./UserCircleIcon.js":false,"./UserGroupIcon.js":false,"./UserMinusIcon.js":false,"./UserPlusIcon.js":false,"./UserIcon.js":false,"./UsersIcon.js":false,"./VariableIcon.js":false,"./VideoCameraSlashIcon.js":false,"./VideoCameraIcon.js":false,"./ViewColumnsIcon.js":false,"./ViewfinderCircleIcon.js":false,"./WalletIcon.js":false,"./WifiIcon.js":false,"./WindowIcon.js":false,"./WrenchScrewdriverIcon.js":false,"./WrenchIcon.js":false,"./XCircleIcon.js":false,"./XMarkIcon.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gcSIT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function ExclamationTriangleIcon({ title, titleId, ...props }, svgRef) {
    return /*#__PURE__*/ _react.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ _react.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const ForwardRef = _react.forwardRef(ExclamationTriangleIcon);
exports.default = ForwardRef;

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"43JJ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CONTAINER_ID", ()=>A);
parcelHelpers.export(exports, "DEFAULT_ONLOAD_NAME", ()=>S);
parcelHelpers.export(exports, "DEFAULT_SCRIPT_ID", ()=>w);
parcelHelpers.export(exports, "SCRIPT_URL", ()=>Y);
parcelHelpers.export(exports, "Turnstile", ()=>Te);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var se = ({ as: r = "div", ...c }, o)=>(0, _jsxRuntime.jsx)(r, {
        ...c,
        ref: o
    }), V = (0, _react.forwardRef)(se);
var Y = "https://challenges.cloudflare.com/turnstile/v0/api.js", w = "cf-turnstile-script", A = "cf-turnstile", S = "onloadTurnstileCallback", D = (r)=>!!document.getElementById(r), q = ({ render: r = "explicit", onLoadCallbackName: c = S, scriptOptions: { nonce: o = "", defer: e = !0, async: p = !0, id: x = "", appendTo: C, onError: v, crossOrigin: I = "" } = {} })=>{
    let R = x || w;
    if (D(R)) return;
    let i = document.createElement("script");
    if (i.id = R, i.src = `${Y}?onload=${c}&render=${r}`, document.querySelector(`script[src="${i.src}"]`)) return;
    i.defer = !!e, i.async = !!p, o && (i.nonce = o), I && (i.crossOrigin = I), v && (i.onerror = v, delete window[c]), (C === "body" ? document.body : document.getElementsByTagName("head")[0]).appendChild(i);
}, l = {
    normal: {
        width: 300,
        height: 65
    },
    compact: {
        width: 150,
        height: 140
    },
    invisible: {
        width: 0,
        height: 0,
        overflow: "hidden"
    },
    flexible: {
        minWidth: 300,
        width: "100%",
        height: 65
    },
    interactionOnly: {
        width: "fit-content",
        height: "auto",
        display: "flex"
    }
};
function J(r) {
    if (r !== "invisible" && r !== "interactionOnly") return r;
}
function O(r = w) {
    let [c, o] = (0, _react.useState)(!1);
    return (0, _react.useEffect)(()=>{
        let e = ()=>{
            D(r) && o(!0);
        }, p = new MutationObserver(e);
        return p.observe(document, {
            childList: !0,
            subtree: !0
        }), e(), ()=>{
            p.disconnect();
        };
    }, [
        r
    ]), c;
}
var b = "unloaded", G, fe = new Promise((r, c)=>{
    G = {
        resolve: r,
        reject: c
    }, b === "ready" && r(void 0);
}), me = (r = S)=>(b === "unloaded" && (b = "loading", window[r] = ()=>{
        G.resolve(), b = "ready", delete window[r];
    }), fe), Te = (0, _react.forwardRef)((r, c)=>{
    let { scriptOptions: o, options: e = {}, siteKey: p, onWidgetLoad: x, onSuccess: C, onExpire: v, onError: I, onBeforeInteractive: R, onAfterInteractive: i, onUnsupported: N, onTimeout: Q, onLoadScript: U, id: Z, style: ee, as: te = "div", injectScript: M = !0, ...re } = r, s = e.size, z = (0, _react.useCallback)(()=>typeof s > "u" ? {} : e.execution === "execute" ? l.invisible : e.appearance === "interaction-only" ? l.interactionOnly : l[s], [
        e.execution,
        s,
        e.appearance
    ]), [ne, y] = (0, _react.useState)(z()), a = (0, _react.useRef)(null), [f, W] = (0, _react.useState)(!1), t = (0, _react.useRef)(), h = (0, _react.useRef)(!1), $ = Z || A, P = o?.id || w, L = O(P), j = o?.onLoadCallbackName || S, oe = e.appearance || "always", g = (0, _react.useMemo)(()=>({
            sitekey: p,
            action: e.action,
            cData: e.cData,
            callback: (n)=>{
                h.current = !0, C?.(n);
            },
            "error-callback": I,
            "expired-callback": v,
            "before-interactive-callback": R,
            "after-interactive-callback": i,
            "unsupported-callback": N,
            theme: e.theme || "auto",
            language: e.language || "auto",
            tabindex: e.tabIndex,
            "response-field": e.responseField,
            "response-field-name": e.responseFieldName,
            size: J(s),
            retry: e.retry || "auto",
            "retry-interval": e.retryInterval || 8e3,
            "refresh-expired": e.refreshExpired || "auto",
            "refresh-timeout": e.refreshTimeout || "auto",
            execution: e.execution || "render",
            appearance: e.appearance || "always",
            "feedback-enabled": e.feedbackEnabled || !0,
            "timeout-callback": Q
        }), [
        e.action,
        e.appearance,
        e.cData,
        e.execution,
        e.language,
        e.refreshExpired,
        e.responseField,
        e.responseFieldName,
        e.retry,
        e.retryInterval,
        e.tabIndex,
        e.theme,
        e.feedbackEnabled,
        e.refreshTimeout,
        p,
        s
    ]), m = (0, _react.useCallback)(()=>typeof window < "u" && !!window.turnstile, []);
    return (0, _react.useEffect)(function() {
        M && !f && q({
            onLoadCallbackName: j,
            scriptOptions: {
                ...o,
                id: P
            }
        });
    }, [
        M,
        f,
        o,
        P
    ]), (0, _react.useEffect)(function() {
        b !== "ready" && me(j).then(()=>W(!0)).catch(console.error);
    }, []), (0, _react.useEffect)(function() {
        if (!a.current || !f) return;
        let u = !1;
        return (async ()=>{
            if (u || !a.current) return;
            let _ = window.turnstile.render(a.current, g);
            t.current = _, t.current && x?.(t.current);
        })(), ()=>{
            u = !0, t.current && (window.turnstile.remove(t.current), h.current = !1);
        };
    }, [
        $,
        f,
        g
    ]), (0, _react.useImperativeHandle)(c, ()=>{
        let { turnstile: n } = window;
        return {
            getResponse () {
                if (!n?.getResponse || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                return n.getResponse(t.current);
            },
            async getResponsePromise (u = 3e4, B = 100) {
                return new Promise((_, k)=>{
                    let d, H = async ()=>{
                        if (h.current && window.turnstile && t.current) try {
                            let T = window.turnstile.getResponse(t.current);
                            return d && clearTimeout(d), T ? _(T) : k(new Error("No response received"));
                        } catch (T) {
                            return d && clearTimeout(d), console.warn("Failed to get response", T), k(new Error("Failed to get response"));
                        }
                        d || (d = setTimeout(()=>{
                            d && clearTimeout(d), k(new Error("Timeout"));
                        }, u)), await new Promise((T)=>setTimeout(T, B)), await H();
                    };
                    H();
                });
            },
            reset () {
                if (!n?.reset || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                e.execution === "execute" && y(l.invisible);
                try {
                    h.current = !1, n.reset(t.current);
                } catch (u) {
                    console.warn(`Failed to reset Turnstile widget ${t}`, u);
                }
            },
            remove () {
                if (!n?.remove || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded");
                    return;
                }
                y(l.invisible), h.current = !1, n.remove(t.current), t.current = null;
            },
            render () {
                if (!n?.render || !a.current || !m() || t.current) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                let u = n.render(a.current, g);
                return t.current = u, t.current && x?.(t.current), e.execution !== "execute" && y(s ? l[s] : {}), u;
            },
            execute () {
                if (e.execution !== "execute") {
                    console.warn('Execution mode is not set to "execute"');
                    return;
                }
                if (!n?.execute || !a.current || !t.current || !m()) {
                    console.warn("Turnstile has not been loaded or container not found");
                    return;
                }
                n.execute(a.current, g), y(s ? l[s] : {});
            },
            isExpired () {
                return !n?.isExpired || !t.current || !m() ? (console.warn("Turnstile has not been loaded"), !1) : n.isExpired(t.current);
            }
        };
    }, [
        t,
        e.execution,
        s,
        g,
        a,
        m,
        f,
        x
    ]), (0, _react.useEffect)(()=>{
        L && !f && window.turnstile && W(!0);
    }, [
        f,
        L
    ]), (0, _react.useEffect)(()=>{
        y(z());
    }, [
        e.execution,
        s,
        oe
    ]), (0, _react.useEffect)(()=>{
        !L || typeof U != "function" || U();
    }, [
        L
    ]), (0, _jsxRuntime.jsx)(V, {
        ref: a,
        as: te,
        id: $,
        style: {
            ...ne,
            ...ee
        },
        ...re
    });
});
Te.displayName = "Turnstile";

},{"react":"6uln9","react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYqJ5":[function(require,module,exports) {
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#error-handling-assert-require-revert-and-exceptions
// builtin errors in solidity, Error(string) and Panic(uint256)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeRevertReason", ()=>decodeRevertReason);
var _sdkCore = require("@vechain/sdk-core");
var _const = require("./const");
/**
 * Decodes revert reasons from a given hex-encoded data string, identifying whether the revert is due to an "Error(string)" or a "Panic(uint256)".
 *
 * @param data - Hex-encoded data containing revert information.
 * @returns Decoded revert reason or an error message if decoding fails.
 *
 * @example
 * ```typescript
 * const revertReason = decodeRevertReason('0x0123456789abcdef0123456789abcdef');
 * console.log(revertReason); // 'Decoded Revert Reason'
 * ```
 */ function decodeRevertReason(data) {
    // Check if the revert reason starts with the error selector
    if (data.startsWith((0, _const.SOLIDITY_ERROR_SELECTOR))) // Decode the error message from the remaining data
    return (0, _sdkCore.abi).decode("string", "0x" + data.slice((0, _const.SOLIDITY_ERROR_SELECTOR).length));
    if (data.startsWith((0, _const.SOLIDITY_PANIC_SELECTOR))) {
        // Decode the panic code and format it as a string
        const decoded = (0, _sdkCore.abi).decode("uint256", "0x" + data.slice((0, _const.SOLIDITY_PANIC_SELECTOR).length));
        return `Panic(0x${parseInt(decoded).toString(16).padStart(2, "0")})`;
    }
}

},{"@vechain/sdk-core":"iZmwY","./const":"gKEvb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKEvb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SOLIDITY_ERROR_SELECTOR", ()=>SOLIDITY_ERROR_SELECTOR);
parcelHelpers.export(exports, "SOLIDITY_PANIC_SELECTOR", ()=>SOLIDITY_PANIC_SELECTOR);
var _sdkCore = require("@vechain/sdk-core");
/**
 * The selector of the `Error(string)` function in Solidity.
 */ const SOLIDITY_ERROR_SELECTOR = (0, _sdkCore.keccak256)("Error(string)", "hex").slice(0, 10);
/**
 * The selector of the `Panic(uint256)` function in Solidity.
 */ const SOLIDITY_PANIC_SELECTOR = (0, _sdkCore.keccak256)("Panic(uint256)", "hex").slice(0, 10);

},{"@vechain/sdk-core":"iZmwY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["4zTVb"], "4zTVb", "parcelRequire60ee")

//# sourceMappingURL=index.1249563a.js.map
